// src/ar-SA.ts
var arSA = {
  locale: "ar-SA",
  backButton: "\u0627\u0644\u0631\u062C\u0648\u0639",
  badge__default: "\u0627\u0644\u0623\u0641\u062A\u0631\u0627\u0636\u064A",
  badge__otherImpersonatorDevice: "\u062C\u0647\u0627\u0632 \u0645\u0646\u062A\u062D\u0644 \u0622\u062E\u0631",
  badge__primary: "\u0627\u0644\u0631\u0626\u064A\u0633\u064A",
  badge__requiresAction: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0645\u0637\u0644\u0648\u0628",
  badge__thisDevice: "\u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
  badge__unverified: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647",
  badge__userDevice: "\u062C\u0647\u0627\u0632 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  badge__you: "\u0623\u0646\u062A",
  createOrganization: {
    formButtonSubmit: "\u0623\u0646\u0634\u0627\u0621 \u0645\u0646\u0638\u0645\u0629",
    invitePage: {
      formButtonReset: "\u062A\u062E\u0637\u064A"
    },
    title: "\u0623\u0646\u0634\u0627\u0621 \u0645\u0646\u0638\u0645\u0629"
  },
  dates: {
    lastDay: "\u0627\u0644\u0623\u0645\u0633 \u0641\u064A {{ date | timeString('en-US') }}",
    next6Days: "{{ date | weekday('en-US','long') }} \u0641\u064A {{ date | timeString('en-US') }}",
    nextDay: "\u063A\u062F\u0627 \u0641\u064A {{ date | timeString('en-US') }}",
    numeric: "{{ date | numeric('en-US') }}",
    previous6Days: "\u0623\u062E\u0631 {{ date | weekday('en-US','long') }} \u0641\u064A {{ date | timeString('en-US') }}",
    sameDay: "\u0627\u0644\u064A\u0648\u0645 \u0641\u064A {{ date | timeString('en-US') }}"
  },
  dividerText: "\u0623\u0648",
  footerActionLink__useAnotherMethod: "\u0623\u062E\u062A\u0631 \u0637\u0631\u064A\u0642\u0629 \u0623\u062E\u0631\u0649",
  footerPageLink__help: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629",
  footerPageLink__privacy: "\u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
  footerPageLink__terms: "\u0627\u0644\u0634\u0631\u0648\u0637",
  formButtonPrimary: "\u0645\u062A\u0627\u0628\u0639\u0629",
  formButtonPrimary__verify: "\u062A\u062D\u0642\u0642",
  formFieldAction__forgotPassword: "\u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061F",
  formFieldError__matchingPasswords: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0645\u0637\u0627\u0628\u0642\u0629",
  formFieldError__notMatchingPasswords: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u0627 \u062A\u062A\u0637\u0627\u0628\u0642",
  formFieldError__verificationLinkExpired: "\u0635\u0644\u0627\u062D\u064A\u0629 \u0631\u0645\u0632 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0623\u0646\u062A\u0647\u062A. \u064A\u0631\u062C\u0649 \u0637\u0644\u0628 \u0631\u0627\u0628\u0637 \u062C\u062F\u064A\u062F",
  formFieldHintText__optional: "\u0625\u062E\u062A\u064A\u0627\u0631\u064A",
  formFieldHintText__slug: "(slug) \u0647\u0648 \u0645\u0639\u0631\u0641 \u064A\u0645\u0643\u0646 \u0642\u0631\u0627\u0621\u062A\u0647 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u0625\u0646\u0633\u0627\u0646 \u0648\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u0631\u064A\u062F\u064B\u0627. \u063A\u0627\u0644\u0628\u064B\u0627 \u0645\u0627 \u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0641\u064A \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "\u0623\u062F\u062E\u0644 \u0623\u0648 \u0644\u0635\u0642 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u062D\u062F \u0623\u0648 \u0623\u0643\u062B\u0631 \u060C \u0645\u0641\u0635\u0648\u0644\u0629 \u0628\u0645\u0633\u0627\u0641\u0627\u062A \u0623\u0648 \u0641\u0648\u0627\u0635\u0644",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "\u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u062F\u0639\u0648\u0629 \u0627\u0644\u0623\u0648\u062A\u0645\u0627\u062A\u0643\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642",
  formFieldLabel__backupCode: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A",
  formFieldLabel__confirmDeletion: "\u062A\u0623\u0643\u064A\u062F",
  formFieldLabel__confirmPassword: "\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  formFieldLabel__currentPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  formFieldLabel__emailAddress: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  formFieldLabel__emailAddress_username: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  formFieldLabel__emailAddresses: "\u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
  formFieldLabel__firstName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",
  formFieldLabel__lastName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631",
  formFieldLabel__newPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
  formFieldLabel__organizationDomain: "\u0627\u0644\u0646\u0637\u0627\u0642",
  formFieldLabel__organizationDomainDeletePending: "\u062D\u0630\u0641 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0648\u0627\u0644\u0623\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0642\u0629",
  formFieldLabel__organizationDomainEmailAddress: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062A\u062D\u0642\u0642",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0646\u0637\u0627\u0642 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649  \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0646\u0637\u0627\u0642",
  formFieldLabel__organizationName: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
  formFieldLabel__organizationSlug: "\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
  formFieldLabel__passkeyName: "\u0627\u0633\u0645 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 (Passkey)",
  formFieldLabel__password: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  formFieldLabel__phoneNumber: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
  formFieldLabel__role: "\u062F\u0648\u0631",
  formFieldLabel__signOutOfOtherSessions: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u062C\u0647\u0632\u0629",
  formFieldLabel__username: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  impersonationFab: {
    action__signOut: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    title: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0623\u0633\u0645 {{identifier}}"
  },
  maintenanceMode: "\u0646\u062D\u0646 \u0646\u0642\u0648\u0645 \u0628\u0639\u0645\u0644 \u0628\u0639\u0636 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A. \u0633\u0648\u0641 \u0646\u0639\u0648\u062F \u0641\u064A \u063A\u0636\u0648\u0646 \u062F\u0642\u0627\u0626\u0642 \u0642\u0644\u064A\u0644\u0629",
  membershipRole__admin: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  membershipRole__basicMember: "\u0639\u0636\u0648",
  membershipRole__guestMember: "\u0636\u064A\u0641",
  organizationList: {
    action__createOrganization: "\u0623\u0646\u0634\u0627\u0621 \u0645\u0646\u0638\u0645\u0629",
    action__invitationAccept: "\u0623\u0646\u0636\u0645\u0627\u0645",
    action__suggestionsAccept: "\u0637\u0644\u0628 \u0623\u0646\u0636\u0645\u0627\u0645",
    createOrganization: "\u0623\u0646\u0634\u0627\u0621 \u0645\u0646\u0638\u0645\u0629",
    invitationAcceptedLabel: "\u0623\u0646\u0636\u0645\u064A\u062A",
    subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
    suggestionsAcceptedLabel: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0639\u0644\u0642\u0629",
    title: "\u0623\u062E\u062A\u0631 \u062D\u0633\u0627\u0628",
    titleWithoutPersonal: "\u0623\u062E\u062A\u0631 \u0645\u0646\u0638\u0645\u0629"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u062F\u0639\u0648\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629",
    badge__automaticSuggestion: "\u0623\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629",
    badge__manualInvitation: "\u0644\u064A\u0633 \u0647\u0646\u0627\u0643 \u062A\u0633\u062C\u064A\u0644 \u062A\u0644\u0642\u0627\u0626\u064A",
    badge__unverified: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627",
    createDomainPage: {
      subtitle: "\u0623\u0636\u0641 \u0627\u0644\u0646\u0637\u0627\u0642 \u0644\u0644\u062A\u062D\u0642\u0642. \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u0644\u062F\u064A\u0647\u0645 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u064A\u0645\u0643\u0646\u0647\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0646\u0638\u0645\u0629 \u0628\u0634\u0643\u0644 \u062A\u0644\u0642\u0627\u0626\u064A \u0623\u0648 \u0637\u0644\u0628 \u0627\u0644\u0623\u0646\u0636\u0645\u0627\u0645.",
      title: "\u0625\u0636\u0627\u0641\u0629 \u0646\u0637\u0627\u0642"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A. \u0627\u0646\u0638\u0631 \u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0648\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649:",
      formButtonPrimary__continue: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A",
      selectDropdown__role: "\u0625\u062E\u062A\u0631 \u062F\u0648\u0631",
      subtitle: "\u062F\u0639\u0648\u0629 \u0623\u0639\u0636\u0627\u0621 \u062C\u062F\u062F \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
      successMessage: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0628\u0646\u062C\u0627\u062D",
      title: "\u062F\u0639\u0648\u0629 \u0623\u0639\u0636\u0627\u0621"
    },
    membersPage: {
      action__invite: "\u062F\u0639\u0648\u0629",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u0625\u0632\u0627\u0644\u0629 \u0639\u0636\u0648",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u0627\u0646\u0636\u0645",
        tableHeader__role: "\u062F\u0648\u0631",
        tableHeader__user: "\u0645\u0633\u062A\u062E\u062F\u0645"
      },
      detailsTitle__emptyRow: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0639\u0636\u0627\u0621 \u0644\u0644\u0639\u0631\u0636",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0639\u0646 \u0637\u0631\u064A\u0642 \u062A\u0648\u0635\u064A\u0644 \u0646\u0637\u0627\u0642 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0628\u0645\u0646\u0638\u0645\u062A\u0643. \u0633\u064A\u062A\u0645\u0643\u0646 \u0623\u064A \u0634\u062E\u0635 \u064A\u0642\u0648\u0645 \u0628\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0641\u064A \u0645\u062C\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0637\u0627\u0628\u0642 \u0645\u0646 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0646\u0638\u0645\u0629 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.",
          headerTitle: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A\u0629",
          primaryButton: "\u0623\u062F\u0627\u0631\u0629 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0648\u062B\u0648\u0642\u0629"
        },
        table__emptyRow: "\u0644\u0627 \u062F\u0639\u0648\u0627\u062A \u0644\u0644\u0639\u0631\u0636"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u0633\u062D\u0628 \u0627\u0644\u062F\u0639\u0648\u0629",
        tableHeader__invited: "\u0645\u062F\u0639\u0648"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u0633\u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0627\u0644\u0630\u064A\u0646 \u064A\u0634\u062A\u0631\u0643\u0648\u0646 \u0641\u064A \u0645\u062C\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0637\u0627\u0628\u0642 \u0645\u0646 \u0631\u0624\u064A\u0629 \u0627\u0642\u062A\u0631\u0627\u062D \u0644\u0637\u0644\u0628 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0646\u0638\u0645\u0629.",
          headerTitle: "\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629",
          primaryButton: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627"
        },
        menuAction__approve: "\u0642\u0628\u0648\u0644",
        menuAction__reject: "\u0631\u0641\u0636",
        tableHeader__requested: "\u0637\u0644\u0628 \u0627\u0644\u0623\u0646\u0636\u0645\u0627\u0645",
        table__emptyRow: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0644\u0644\u0639\u0631\u0636"
      },
      start: {
        headerTitle__invitations: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A",
        headerTitle__members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
        headerTitle__requests: "\u0627\u0644\u0637\u0644\u0628\u0627\u062A"
      }
    },
    navbar: {
      description: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u0638\u0645\u062A\u0643.",
      general: "\u0639\u0627\u0645",
      members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      title: "\u0627\u0644\u0645\u0646\u0638\u0645\u0629"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "\u0623\u0643\u062A\u0628 {{organizationName}} \u0628\u0627\u0644\u0623\u0633\u0641\u0644 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
          messageLine1: "\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0646\u0643 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
          messageLine2: "\u0647\u0630\u0627 \u0627\u0644\u0642\u0631\u0627\u0631 \u0646\u0647\u0627\u0626\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647.",
          successMessage: "\u0644\u0642\u062F \u062D\u0630\u0641\u062A \u0647\u0630\u0647 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
          title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0646\u0638\u0645\u0629"
        },
        leaveOrganization: {
          actionDescription: "\u0623\u0643\u062A\u0628 {{organizationName}} \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
          messageLine1: "\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0627\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0627\u0644\u0645\u0646\u0638\u0645\u0629\u061F \u0633\u0648\u0641 \u062A\u0641\u0642\u062F \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0646\u0638\u0645\u0629 \u0648\u062C\u0645\u064A\u0639 \u062A\u0637\u0628\u064A\u0642\u0627\u062A\u0647\u0627",
          messageLine2: "\u0647\u0630\u0627 \u0627\u0644\u0642\u0631\u0627\u0631 \u0646\u0647\u0627\u0626\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647.",
          successMessage: "\u0644\u0642\u062F \u063A\u0627\u062F\u0631\u062A \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
          title: "\u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0627\u0644\u0645\u0646\u0638\u0645\u0629"
        },
        title: "\u062E\u0637\u0631"
      },
      domainSection: {
        menuAction__manage: "\u0625\u062F\u0627\u0631\u0629",
        menuAction__remove: "\u062D\u0630\u0641",
        menuAction__verify: "\u062A\u062D\u0642\u0642",
        primaryButton: "\u0623\u0636\u0627\u0641\u0629 \u0646\u0637\u0627\u0642",
        subtitle: "\u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0644\u0644\u0623\u0646\u0636\u0645\u0627\u0645 \u0644\u0644\u0645\u0646\u0638\u0645\u0629 \u0628\u0634\u0643\u0644 \u062A\u0644\u0642\u0627\u0626\u064A \u0623\u0648 \u0639\u0646 \u0637\u0631\u064A\u0642 \u062F\u0639\u0648\u0629 \u0644\u0644\u0623\u0646\u0636\u0645\u0627\u0645 \u0639\u0644\u0649 \u0646\u0637\u0627\u0642 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647",
        title: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627"
      },
      successMessage: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
      title: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A \u0644\u0644\u0645\u0646\u0638\u0645\u0629"
    },
    removeDomainPage: {
      messageLine1: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0646\u0637\u0627\u0642 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627{{domain}}.",
      messageLine2: "\u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0645\u0646 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0628\u0639\u062F \u0630\u0644\u0643.",
      successMessage: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 {{domain}}.",
      title: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0637\u0627\u0642"
    },
    start: {
      headerTitle__general: "\u0639\u0627\u0645",
      headerTitle__members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      profileSection: {
        primaryButton: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
        title: "\u0645\u0644\u0641 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
        uploadAction__title: "\u0634\u0639\u0627\u0631"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u0633\u064A\u0624\u062B\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0645\u062F\u0639\u0648\u064A\u0646",
        removeDomainActionLabel__remove: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0637\u0627\u0642",
        removeDomainSubtitle: "\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u0645\u0646 \u0645\u0646 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0639\u062A\u0645\u062F\u0629",
        removeDomainTitle: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0637\u0627\u0642"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u062A\u062A\u0645 \u062F\u0639\u0648\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0639\u0646\u062F \u062A\u0633\u062C\u064A\u0644 \u062D\u0633\u0627\u0628 \u062C\u062F\u064A\u062F \u0648\u064A\u0645\u0643\u0646\u0647\u0645 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.",
        automaticInvitationOption__label: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A\u0629",
        automaticSuggestionOption__description: "\u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0627\u0642\u062A\u0631\u0627\u062D\u064B\u0627 \u0644\u0637\u0644\u0628 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u060C \u0648\u0644\u0643\u0646 \u064A\u062C\u0628 \u0623\u0646 \u064A\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647 \u0627\u0644\u0645\u0634\u0631\u0641 \u0642\u0628\u0644 \u0623\u0646 \u064A\u062A\u0645\u0643\u0646\u0648\u0627 \u0645\u0646 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0646\u0638\u0645\u0629.",
        automaticSuggestionOption__label: "\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629",
        calloutInfoLabel: "\u0625\u0646 \u062A\u063A\u064A\u064A\u0631 \u0648\u0636\u0639 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0633\u064A\u0624\u062B\u0631 \u0641\u0642\u0637 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u062C\u062F\u062F.",
        calloutInvitationCountLabel: "\u0647\u0646\u0627\u0643 {{count}} \u062F\u0639\u0648\u0629 \u0645\u0639\u0644\u0642\u0629 \u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646",
        calloutSuggestionCountLabel: "\u0647\u0646\u0627\u0643 {{count}} \u0623\u0642\u062A\u0631\u0627\u062D \u0645\u0639\u0644\u0642 \u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646",
        manualInvitationOption__description: "\u064A\u0645\u0643\u0646 \u062F\u0639\u0648\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u064A\u062F\u0648\u064A\u064B\u0627 \u0641\u0642\u0637 \u0644\u0644\u0645\u0624\u0633\u0633\u0629.",
        manualInvitationOption__label: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0633\u062C\u064A\u0644 \u062A\u0644\u0642\u0627\u0626\u064A",
        subtitle: "\u0623\u062E\u062A\u0631 \u0643\u064A\u0641 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0646\u0638\u0645\u0629"
      },
      start: {
        headerTitle__danger: "\u062E\u0637\u0631",
        headerTitle__enrollment: "\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0633\u062C\u064A\u0644"
      },
      subtitle: "\u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 {{domain}} \u0645\u0648\u062B\u0648\u0642 \u0627\u0644\u0622\u0646. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0648\u0623\u062E\u062A\u064A\u0627\u0631 \u0648\u0636\u0639 \u0627\u0644\u062A\u0633\u062C\u064A\u0644.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u064A\u062C\u0628 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 {{domainName}} \u0639\u0646 \u0637\u0631\u064A\u0642 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0648\u062B\u0648\u0642",
      subtitleVerificationCodeScreen: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0645\u0632 \u062A\u062D\u0642\u0642 \u0625\u0644\u0649 {{emailAddress}}. \u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
      title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0646\u0637\u0627\u0642"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0623\u0646\u0634\u0627\u0621 \u0645\u0646\u0638\u0645\u0629",
    action__invitationAccept: "\u0623\u0646\u0636\u0645\u0627\u0645",
    action__manageOrganization: "\u0623\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
    action__suggestionsAccept: "\u0637\u0644\u0628 \u0623\u0646\u0636\u0645\u0627\u0645",
    notSelected: "\u0644\u0645 \u064A\u062A\u0645 \u0623\u062E\u062A\u064A\u0627\u0631 \u0645\u0646\u0638\u0645\u0629",
    personalWorkspace: "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0634\u062E\u0635\u064A",
    suggestionsAcceptedLabel: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0639\u0644\u0642\u0629"
  },
  paginationButton__next: "\u0627\u0644\u062A\u0627\u0644\u064A",
  paginationButton__previous: "\u0627\u0644\u0633\u0627\u0628\u0642",
  paginationRowText__displaying: "\u0639\u0631\u0636",
  paginationRowText__of: "\u0645\u0646",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u0625\u0636\u0627\u0641\u0629 \u062D\u0633\u0627\u0628",
      action__signOutAll: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
      subtitle: "\u0642\u0645 \u0628\u0625\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0630\u064A \u062A\u0631\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0628\u0647",
      title: "\u0625\u062E\u062A\u0631 \u062D\u0633\u0627\u0628"
    },
    alternativeMethods: {
      actionLink: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629",
      actionText: "\u0644\u0627 \u062A\u0645\u0644\u0643 \u0627\u064A \u0645\u0646 \u0647\u0624\u0644\u0627\u0621?",
      blockButton__backupCode: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0631\u0645\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A",
      blockButton__emailCode: "\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644  {{identifier}}",
      blockButton__emailLink: "\u0631\u0627\u0628\u0637 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644 {{identifier}}",
      blockButton__passkey: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      blockButton__password: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
      blockButton__phoneCode: "\u0623\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629 \u0646\u0635\u064A\u0629 \u0644{{identifier}}",
      blockButton__totp: "\u0627\u0633\u062A\u062E\u062F\u0645 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      getHelp: {
        blockButton__emailSupport: "\u0628\u0631\u064A\u062F \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u0641\u0646\u064A",
        content: "\u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0648\u0627\u062C\u0647 \u0635\u0639\u0648\u0628\u0629 \u0641\u064A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643 \u060C \u0631\u0627\u0633\u0644\u0646\u0627 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0633\u0646\u0639\u0645\u0644 \u0645\u0639\u0643 \u0644\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0641\u064A \u0623\u0642\u0631\u0628 \u0648\u0642\u062A \u0645\u0645\u0643\u0646.",
        title: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629"
      },
      subtitle: "\u062A\u0648\u0627\u062C\u0647 \u0645\u0634\u0643\u0644\u0629\u061F \u062A\u0633\u062A\u0637\u064A\u0639 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0623\u064A \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0637\u0631\u0642 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      title: "\u0623\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0623\u062E\u0631\u0649"
    },
    backupCodeMfa: {
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A"
    },
    emailCode: {
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u064A \u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629, \u0642\u0645 \u0628\u0641\u062A\u062D \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0639\u0628\u0631 \u0646\u0641\u0633 \u0627\u0644\u062C\u0647\u0627\u0632 \u0648\u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0630\u064A \u0627\u0646\u0634\u0623\u062A \u0645\u062D\u0627\u0648\u0644\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646\u0647",
        title: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632"
      },
      expired: {
        subtitle: "\u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
        title: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0627."
      },
      failed: {
        subtitle: "\u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
        title: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0627 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
      },
      formSubtitle: "\u0623\u0633\u062A\u0639\u0645\u0644 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      formTitle: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642",
      loading: {
        subtitle: "\u0633\u062A\u062A\u0645 \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647\u0643 \u0642\u0631\u064A\u0628\u064B\u0627",
        title: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644..."
      },
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0627\u0628\u0637\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      unusedTab: {
        title: "\u064A\u0645\u0643\u0646\u0643 \u0623\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629"
      },
      verified: {
        subtitle: "\u0633\u064A\u062A\u0645 \u0623\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647\u0643 \u0641\u064A \u0644\u062D\u0638\u0627\u062A",
        title: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0646\u062C\u0627\u062D"
      },
      verifiedSwitchTab: {
        subtitle: "\u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
        subtitleNewTab: "\u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u062D\u062F\u064A\u062B\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
        titleNewTab: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0641\u064A \u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u0623\u062E\u0631\u0649"
      }
    },
    forgotPassword: {
      formTitle: "\u0631\u0645\u0632 \u062A\u062D\u0642\u0642 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0623\u064A \u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      subtitle: "\u0644\u0623\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      subtitle_email: "\u0623\u0648\u0644\u0627\u064B, \u0642\u0645 \u0628\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u0627\u064A\u0645\u064A\u0644 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      subtitle_phone: "\u0623\u0648\u0644\u0627\u064B, \u0642\u0645 \u0628\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      title: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      label__alternativeMethods: "\u0623\u0648 \u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0637\u0631\u064A\u0642\u0629 \u0623\u062E\u0631\u0649",
      title: "\u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061F"
    },
    noAvailableMethods: {
      message: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0645\u062A\u0627\u0628\u0639\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. \u0644\u0627 \u064A\u0648\u062C\u062F \u0648\u0633\u064A\u0644\u0629 \u0645\u0635\u0627\u062F\u0642\u0629 \u0645\u062A\u0627\u062D\u0629.",
      subtitle: "\u062D\u062F\u062B \u062E\u0637\u0623",
      title: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644"
    },
    passkey: {
      subtitle: "\u064A\u0624\u062F\u064A \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0625\u0644\u0649 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643. \u062C\u0647\u0627\u0632\u0643 \u0627\u0644\u062E\u0627\u0635 \u0642\u062F \u064A\u0642\u0648\u0645 \u0628\u0633\u0624\u0627\u0644\u0643 \u0639\u0646 \u0628\u0635\u0645\u0629 \u0627\u0644\u0625\u0635\u0628\u0639, \u0627\u0648 \u0645\u0639\u0631\u0641 \u0627\u0644\u0648\u062C\u0629 \u0627\u0648 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0642\u0641\u0644 \u0627\u0644\u0634\u0627\u0634\u0629",
      title: "\u0625\u0633\u062A\u062E\u062F\u0645 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    password: {
      actionLink: "\u0623\u0633\u062A\u0639\u0645\u0644 \u0637\u0631\u064A\u0642\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u0627\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    passwordPwned: {
      title: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0622\u0645\u0646\u0629"
    },
    phoneCode: {
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0627\u062A\u0641\u0643"
    },
    phoneCodeMfa: {
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0647\u0627\u062A\u0641\u0643",
      title: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0627\u062A\u0641\u0643"
    },
    resetPassword: {
      formButtonPrimary: "\u0623\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      requiredMessage: "\u064A\u0648\u062C\u062F \u062D\u0633\u0627\u0628 \u0628\u0627\u0644\u0641\u0639\u0644 \u0628\u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647. \u0627\u0644\u0631\u062C\u0627\u0621 \u0623\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u062A\u0623\u0645\u064A\u0646 \u062D\u0633\u0627\u0628\u0643",
      successMessage: "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0628\u0646\u062C\u0627\u062D. \u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u0623\u0646\u062A\u0638\u0627\u0631 \u0642\u0644\u064A\u0644\u0627.",
      title: "\u0623\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    resetPasswordMfa: {
      detailsLabel: "\u0646\u0631\u064A\u062F \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u0623\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    start: {
      actionLink: "\u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u062C\u062F\u064A\u062F",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      actionLink__use_email_username: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
      actionLink__use_passkey: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0628\u062F\u0644\u0627\u064B \u0645\u0646 \u0630\u0644\u0643",
      actionLink__use_phone: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
      actionLink__use_username: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
      actionText: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628\u061F",
      actionText__join_waitlist: void 0,
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      subtitleCombined: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0630\u064A \u062A\u0645 \u0625\u0646\u0634\u0627\u0624\u0647 \u0628\u0648\u0627\u0633\u0637\u0629 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      title: "\u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646"
    }
  },
  signInEnterPasswordTitle: "\u0625\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  signUp: {
    continue: {
      actionLink: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      actionText: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628\u061F",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u0627\u0645\u0644\u0623 \u0627\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0645\u0641\u0642\u0648\u062F\u0629"
    },
    emailCode: {
      formSubtitle: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u0627\u0641\u062A\u062D \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0639\u0644\u0649 \u0627\u0644\u062C\u0647\u0627\u0632 \u0648\u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0630\u064A \u0623\u0646\u0634\u0623\u062A \u0645\u062D\u0627\u0648\u0644\u0629 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0646\u0647",
        title: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632"
      },
      formSubtitle: "\u0623\u0633\u062A\u0639\u0645\u0644 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      formTitle: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642",
      loading: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628..."
      },
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0627\u0628\u0637\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      verified: {
        title: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0646\u062C\u0627\u062D"
      },
      verifiedSwitchTab: {
        subtitle: "\u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u062D\u062F\u064A\u062B\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
        subtitleNewTab: "\u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0633\u0627\u0628\u0642\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
        title: "\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u0646\u062C\u0627\u062D \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0647\u0627\u062A\u0641\u0643",
      formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
      resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      title: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0627\u062A\u0641\u0643"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0627\u0644\u0641\u0639\u0644\u061F",
      subtitle: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 {{applicationName}}",
      subtitleCombined: void 0,
      title: "\u0623\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u062C\u062F\u064A\u062F",
      titleCombined: "\u0623\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u062C\u062F\u064A\u062F"
    }
  },
  socialButtonsBlockButton: "\u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0639 {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0633\u0628\u0628 \u0645\u0634\u0627\u0643\u0644 \u062A\u062D\u0642\u0642 \u0623\u0645\u0646\u064A\u0629. \u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627 \u0644\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629",
    captcha_unavailable: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u063A\u064A\u0631 \u0646\u0627\u062C\u062D \u0628\u0633\u0628\u0628 \u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629 \u0627\u0644\u0631\u0648\u0628\u0648\u062A. \u064A\u064F\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0641\u0631\u064A\u0642 \u0627\u0644\u062F\u0639\u0645 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "\u062A\u0645 \u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
    form_identifier_exists__phone_number: "\u062A\u0645 \u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0647\u0630\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
    form_identifier_exists__username: "\u062A\u0645 \u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u062F \u0647\u0630\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u064A\u062C\u0628 \u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0635\u0627\u0644\u062D",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "\u0627\u0644\u0623\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u064A\u062C\u0628 \u0627\u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 256 \u062D\u0631\u0641",
    form_param_max_length_exceeded__last_name: "\u0627\u0644\u0623\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631 \u064A\u062C\u0628 \u0627\u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 256 \u062D\u0631\u0641",
    form_param_max_length_exceeded__name: "\u0627\u0644\u0623\u0633\u0645 \u064A\u062C\u0628 \u0627\u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 256 \u062D\u0631\u0641",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u064A\u0633\u062A \u0642\u0648\u064A\u0629",
    form_password_pwned: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0647\u0630\u0647 \u0644\u0627\u0646\u0647\u0627 \u063A\u064A\u0631 \u0623\u0645\u0646\u0629, \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0623\u062E\u0631\u0649",
    form_password_pwned__sign_in: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0647\u0630\u0647 \u0644\u0627\u0646\u0647\u0627 \u063A\u064A\u0631 \u0623\u0645\u0646\u0629, \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0623\u062E\u0631\u0649",
    form_password_size_in_bytes_exceeded: "\u062A\u062C\u0627\u0648\u0632\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u0645\u062F\u062E\u0644\u0629, \u0627\u0644\u0631\u062C\u0627\u0621 \u0623\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0623\u0642\u0635\u0631 \u0623\u0648 \u062D\u0630\u0641 \u0628\u0639\u0636 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u062E\u0627\u0635\u0629",
    form_password_validation_failed: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0647\u0648\u064A\u062A\u0643 \u0627\u0644\u0622\u062E\u064A\u0631\u0629 ",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0645\u0633\u0628\u0642\u0627\u064B \u0645\u0639 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
    passkey_not_supported: "\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
    passkey_pa_not_supported: "\u064A\u062A\u0637\u0644\u0628 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0623\u062F\u0627\u0629 \u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0648\u0644\u0643\u0646 \u0627\u0644\u062C\u0647\u0627\u0632 \u0644\u0627 \u064A\u062F\u0639\u0645\u0647\u0627",
    passkey_registration_cancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u062A\u0633\u062C\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u062A\u0647",
    passkey_retrieval_cancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u062A\u0633\u062C\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u062A\u0647",
    passwordComplexity: {
      maximumLength: "\u0623\u0642\u0644 \u0645\u0646 {{length}} \u062D\u0631\u0648\u0641",
      minimumLength: "{{length}} \u062D\u0631\u0648\u0641 \u0623\u0648 \u0623\u0643\u062B\u0631",
      requireLowercase: "\u062D\u0631\u0641 \u0635\u063A\u064A\u0631",
      requireNumbers: "\u0631\u0642\u0645",
      requireSpecialCharacter: "\u062D\u0631\u0641 \u062E\u0627\u0635",
      requireUppercase: "\u062D\u0631\u0641 \u0643\u0628\u064A\u0631",
      sentencePrefix: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u064A\u062C\u0628 \u0623\u0646 \u062A\u062D\u062A\u0648\u064A \u0639\u0644\u0649"
    },
    phone_number_exists: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645 \u0645\u0623\u062E\u0648\u0630 \u0627\u0644\u0631\u062C\u0627\u0621 \u0623\u062E\u062A\u064A\u0627\u0631 \u0631\u0642\u0645 \u0622\u062E\u0631",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631\u0643 \u0633\u0644\u064A\u0645\u0629 \u0645\u0646 \u0627\u0644\u0623\u0641\u0636\u0644 \u0627\u0646 \u062A\u0643\u0648\u0646 \u0627\u0642\u0648\u0649. \u0627\u0644\u0631\u062C\u0627\u0621 \u0623\u0636\u0627\u0641\u0629 \u062D\u0631\u0648\u0641 \u0623\u0643\u062B\u0631",
      goodPassword: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631\u0643 \u0637\u0627\u0628\u0642\u062A \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u062A\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0627\u0632\u0645\u0629",
      notEnough: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u064A\u0633\u062A \u0642\u0648\u064A\u0629",
      suggestions: {
        allUppercase: "\u0623\u0633\u062A\u0639\u0645\u0644 \u062D\u0631\u0648\u0641 \u0643\u0628\u064A\u0631\u0629 \u0644\u0628\u0639\u0636 \u0627\u0644\u062D\u0631\u0648\u0641 \u0648\u0644\u064A\u0633 \u0643\u0644\u0647\u0627.",
        anotherWord: "\u0623\u0636\u0641 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0623\u0642\u0644 \u0634\u064A\u0648\u0639\u064B\u0627.",
        associatedYears: "\u062A\u062C\u0646\u0628 \u0627\u0644\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0643.",
        capitalization: "\u0623\u0633\u062A\u0639\u0645\u0644 \u062D\u0631\u0648\u0641 \u0643\u0628\u064A\u0631\u0629 \u0644\u0623\u0643\u062B\u0631 \u0645\u0646 \u062D\u0631\u0641 \u063A\u064A\u0631 \u0627\u0644\u062D\u0631\u0641 \u0627\u0644\u0623\u0648\u0644",
        dates: "\u062A\u062C\u0646\u0628 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0643.",
        l33t: '\u062A\u062C\u0646\u0628 \u0628\u062F\u0627\u0626\u0644 \u0627\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0646\u0628\u0624 \u0628\u0647\u0627 \u0645\u062B\u0644 "a" \u0644 "@" ',
        longerKeyboardPattern: "\u0623\u0633\u062A\u062E\u062F\u0645 \u0623\u0646\u0645\u0627\u0637 \u0623\u0643\u062B\u0631 \u0648\u0642\u0645 \u0628\u062A\u063A\u064A\u064A\u0631 \u0623\u062A\u062C\u0627\u0647 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0639\u062F\u0629 \u0645\u0631\u0627\u062A",
        noNeed: "\u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0627\u062A \u0645\u0631\u0648\u0631 \u0642\u0648\u064A\u0629 \u062F\u0648\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0631\u0645\u0648\u0632 \u0623\u0648 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0623\u0648 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0643\u0628\u064A\u0631\u0629.",
        pwned: "\u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0633\u062A\u062E\u062F\u0645 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0647\u0630\u0647 \u0641\u064A \u0645\u0643\u0627\u0646 \u0622\u062E\u0631 \u060C \u0641\u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u062A\u063A\u064A\u064A\u0631\u0647\u0627.",
        recentYears: "\u062A\u062C\u0646\u0628 \u0627\u0644\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u0623\u062E\u064A\u0631\u0629.",
        repeated: "\u062A\u062C\u0646\u0628 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0648\u0627\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u0645\u062A\u0643\u0631\u0631\u0629.",
        reverseWords: "\u062A\u062C\u0646\u0628 \u0627\u0644\u062A\u0647\u062C\u0626\u0627\u062A \u0627\u0644\u0639\u0643\u0633\u064A\u0629 \u0644\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0634\u0627\u0626\u0639\u0629.",
        sequences: "\u062A\u062C\u0646\u0628 \u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0634\u0627\u0626\u0639\u0629.",
        useWords: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0643\u0644\u0645\u0627\u062A \u0645\u062A\u0639\u062F\u062F\u0629 \u060C \u0648\u0644\u0643\u0646 \u062A\u062C\u0646\u0628 \u0627\u0644\u0639\u0628\u0627\u0631\u0627\u062A \u0627\u0644\u0634\u0627\u0626\u0639\u0629."
      },
      warnings: {
        common: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0647\u0630\u0647 \u0634\u0627\u0626\u0639\u0629 \u0641\u064A \u0627\u0644\u0623\u0633\u062A\u062E\u062F\u0627\u0645",
        commonNames: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0627\u0644\u0623\u0633\u0645\u0627\u0621 \u0648\u0627\u0644\u0623\u0644\u0642\u0627\u0628 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
        dates: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
        extendedRepeat: '\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0623\u0646\u0645\u0627\u0637 \u0627\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u0645\u062A\u0643\u0631\u0631\u0629 \u0645\u062B\u0644 "abcabcabc"',
        keyPattern: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0623\u0646\u0645\u0627\u0637 \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0635\u063A\u064A\u0631\u0629",
        namesByThemselves: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0627\u0644\u0623\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0623\u0648 \u0627\u0644\u0644\u0642\u0628",
        pwned: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u062A\u0645 \u0623\u062E\u062A\u0631\u0627\u0642\u0647\u0627 \u0648\u0627\u0644\u0643\u0634\u0641 \u0639\u0646\u0647\u0627 \u0641\u064A \u0627\u0644\u0623\u0646\u062A\u0631\u0646\u062A",
        recentYears: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0627\u0644\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u062D\u062F\u064A\u062B\u0629",
        sequences: '\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0623\u0646\u0645\u0627\u0637 \u0627\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u0639\u0627\u0645\u0629 \u0623\u0648 \u0627\u0644\u0647\u062C\u0627\u0626\u064A\u0629 \u0645\u062B\u0644 "abc" ',
        similarToCommon: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0647\u0630\u0647 \u0645\u0634\u0627\u0628\u0647\u0629 \u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0633\u0631 \u0627\u0644\u0634\u0627\u0626\u0639\u0629 \u0641\u064A \u0627\u0644\u0623\u0633\u062A\u062E\u062F\u0627\u0645",
        simpleRepeat: '\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0627\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u0645\u0643\u0631\u0631\u0629 \u0645\u062B\u0644 "aaa"',
        straightRow: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0646 \u0627\u0644\u062D\u0631\u0648\u0641 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0639\u0644\u0649 \u0646\u0641\u0633 \u0627\u0644\u0633\u0637\u0631 \u0641\u064A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
        topHundred: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0647\u0630\u0647 \u0645\u0633\u062A\u062E\u062F\u0645\u0629 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631\u0629",
        topTen: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631 \u0647\u0630\u0647 \u0645\u0633\u062A\u062E\u062F\u0645\u0629 \u0628\u0643\u062B\u0631\u0629",
        userInputs: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0623\u064A \u0628\u064A\u0627\u0646\u0627\u062A \u0634\u062E\u0635\u064A\u0629 \u0623\u0648 \u0628\u064A\u0627\u0646\u0627\u062A \u0630\u0627\u062A \u0635\u0644\u0629 \u0628\u0627\u0644\u0635\u0641\u062D\u0629.",
        wordByItself: "\u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u062A\u062E\u0645\u064A\u0644 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0646\u0641\u0631\u062F\u0629"
      }
    }
  },
  userButton: {
    action__addAccount: "\u0625\u0636\u0627\u0641\u0629 \u062D\u0633\u0627\u0628",
    action__manageAccount: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062D\u0633\u0627\u0628",
    action__signOut: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    action__signOutAll: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E",
      actionLabel__copy: "\u0646\u0633\u062E \u0627\u0644\u0643\u0644",
      actionLabel__download: "\u062A\u062D\u0645\u064A\u0644 \u0645\u0644\u0641 .txt",
      actionLabel__print: "\u0637\u0628\u0627\u0639\u0629",
      infoText1: "\u0633\u064A\u062A\u0645 \u062A\u0641\u0639\u064A\u0644 \u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628",
      infoText2: "\u0642\u0645 \u0628\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0631\u0645\u0648\u0632 \u0641\u064A \u0645\u0643\u0627\u0646 \u0622\u0645\u0646 \u0648\u062D\u0627\u0641\u0638 \u0639\u0644\u0649 \u0633\u0631\u064A\u062A\u0647\u0627. \u064A\u0645\u0643\u0646\u0643 \u062A\u062C\u062F\u064A\u062F \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0627\u0630\u0627 \u0643\u0646\u062A \u062A\u0634\u0643 \u0623\u0646 \u062D\u0633\u0627\u0628\u0643 \u0645\u0639\u0631\u0636 \u0644\u0644\u062E\u0637\u0631",
      subtitle__codelist: "\u0642\u0645 \u0628\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0631\u0645\u0648\u0632 \u0641\u064A \u0645\u0643\u0627\u0646 \u0622\u0645\u0646 \u0648\u0627\u0628\u0642\u064A\u0647\u0627 \u0633\u0631\u0627.",
      successMessage: "\u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A \u0645\u0641\u0639\u0644\u0629 \u0627\u0644\u0622\u0646. \u064A\u0645\u0643\u0646\u0643 \u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0648\u0627\u062D\u062F\u0629 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0631\u0645\u0648\u0632 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643, \u0627\u0630\u0627 \u0641\u0642\u062F\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062C\u0647\u0627\u0632 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643. \u0643\u0644 \u0631\u0645\u0632 \u064A\u0645\u0643\u0646 \u0623\u0633\u062A\u0639\u0645\u0627\u0644\u0647 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637.",
      successSubtitle: "\u064A\u0645\u0643\u0646\u0643 \u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0648\u0627\u062D\u062F\u0629 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0631\u0645\u0648\u0632 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643, \u0627\u0630\u0627 \u0641\u0642\u062F\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062C\u0647\u0627\u0632 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      title: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A\u0629",
      title__codelist: "\u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0623\u062D\u062A\u064A\u0627\u0637\u064A"
    },
    connectedAccountPage: {
      formHint: "\u0623\u062E\u062A\u0631 \u0645\u0648\u0641\u0631 \u062E\u062F\u0645\u0629 \u0644\u062A\u0648\u0635\u064A\u0644 \u062D\u0633\u0627\u0628\u0643",
      formHint__noAccounts: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0648\u0641\u0631\u064A\u0646 \u062E\u062F\u0645\u0629 \u0644\u062A\u0648\u0635\u064A\u0644 \u062D\u0633\u0627\u0628\u0643",
      removeResource: {
        messageLine1: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0641\u0631 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 {{identifier}}",
        messageLine2: "\u0644\u0646 \u062A\u062A\u0645\u0643\u0646 \u0628\u0639\u062F \u0627\u0644\u0622\u0646 \u0645\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u062A\u0635\u0644 \u0648\u0644\u0646 \u062A\u0639\u0645\u0644 \u0623\u064A \u0645\u064A\u0632\u0627\u062A \u062A\u0627\u0628\u0639\u0629.",
        successMessage: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 {{connectedAccount}}",
        title: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u062A\u0635\u0644"
      },
      socialButtonsBlockButton: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0648\u0641\u0631 {{provider|titleize}} \u0644\u062D\u0633\u0627\u0628\u0643",
      successMessage: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0641\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \u0627\u0644\u0649 \u062D\u0633\u0627\u0628\u0643",
      title: "\u0623\u0636\u0641 \u062D\u0633\u0627\u0628 \u0645\u062A\u0635\u0644"
    },
    deletePage: {
      actionDescription: "\u0623\u0643\u062A\u0628 \u062D\u0630\u0641 \u062D\u0633\u0627\u0628 \u0628\u0627\u0644\u0623\u0633\u0641\u0644 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
      confirm: "\u062D\u0630\u0641 \u062D\u0633\u0627\u0628",
      messageLine1: "\u0647\u0644 \u0623\u0646\u062A \u0645\u0646 \u0627\u0646\u0643 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628\u061F",
      messageLine2: "\u0647\u0630\u0627 \u0627\u0644\u0642\u0631\u0627\u0631 \u0646\u0647\u0627\u0626\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647.",
      title: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u0633\u064A\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0644\u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        formSubtitle: "\u0623\u0631\u0633\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 {{identifier}}",
        formTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
        resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0645\u0632\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
        successMessage: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A {{identifier}} \u062A\u0645\u062A \u0625\u0636\u0627\u0641\u062A\u0647 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643"
      },
      emailLink: {
        formHint: "\u0633\u064A\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0644\u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        formSubtitle: "\u0623\u0646\u0642\u0631 \u0639\u0644\u0649 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0623\u0644\u0643\u062A\u0631\u0648\u0646\u064A {{identifier}}",
        formTitle: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642",
        resendButton: "\u0644\u0645 \u064A\u0635\u0644\u0643 \u0627\u0644\u0631\u0627\u0628\u0637\u061F \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
        successMessage: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A {{identifier}} \u062A\u0645\u062A \u0625\u0636\u0627\u0641\u062A\u0647 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643"
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0625\u064A\u0645\u064A\u0644 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 {{identifier}}",
        messageLine2: "\u0644\u0646 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627.",
        successMessage: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 {{emailAddress}}",
        title: "\u062D\u0630\u0641 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627"
      },
      title: "\u0623\u0636\u0627\u0641\u0629 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "\u0625\u0636\u0627\u0641\u0629",
    formButtonPrimary__continue: "\u0645\u062A\u0627\u0628\u0639\u0629",
    formButtonPrimary__finish: "\u0627\u0646\u0647\u0627\u0621",
    formButtonPrimary__remove: "\u0625\u0632\u0627\u0644\u0629",
    formButtonPrimary__save: "\u062D\u0641\u0638",
    formButtonReset: "\u0627\u0644\u063A\u0627\u0621",
    mfaPage: {
      formHint: "\u0623\u062E\u062A\u0631 \u0637\u0631\u064A\u0642\u0629 \u0644\u0644\u0623\u0636\u0627\u0641\u0629",
      title: "\u0623\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646"
    },
    mfaPhoneCodePage: {
      backButton: "\u0625\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u0648\u062C\u0648\u062F",
      primaryButton__addPhoneNumber: "\u0625\u0636\u0627\u0641\u0629 \u0631\u0642\u0645 \u062C\u0648\u0627\u0644",
      removeResource: {
        messageLine1: "\u0644\u0646 \u064A\u062A\u0645 \u0625\u0633\u062A\u0644\u0627\u0645 \u0627\u064A \u0631\u0645\u0648\u0632 \u062A\u062D\u0642\u0642 \u0639\u0644\u0649 {{identifier}} \u0639\u0646\u062F \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        messageLine2: "\u0642\u062F \u0644\u0627 \u064A\u0643\u0648\u0646 \u062D\u0633\u0627\u0628\u0643 \u0622\u0645\u0646\u0627. \u0647\u0644 \u0623\u0646\u0643 \u0645\u062A\u0623\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u061F",
        successMessage: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0635\u064A\u0629 \u0644\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u0647\u0630\u0627 {{mfaPhoneCode}}",
        title: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646"
      },
      subtitle__availablePhoneNumbers: "\u0623\u062E\u062A\u0631 \u0631\u0642\u0645 \u062C\u0648\u0627\u0644 \u0644\u0623\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0635\u064A\u0629",
      subtitle__unavailablePhoneNumbers: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0631\u0642\u0645 \u062C\u0648\u0627\u0644 \u0644\u0623\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0635\u064A\u0629",
      successMessage1: "\u0639\u0646\u062F \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\u060C \u0633\u0648\u0641 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u062F\u062E\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0630\u064A \u062A\u0645 \u0625\u0631\u0633\u0627\u0644\u0647 \u0625\u0644\u0649 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0647\u0630\u0627 \u0643\u062E\u0637\u0648\u0629 \u0625\u0636\u0627\u0641\u064A\u0629.",
      successMessage2: '\u0627\u062D\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0648\u0642\u0645 \u0628\u062A\u062E\u0632\u064A\u0646\u0647\u0627 \u0641\u064A \u0645\u0643\u0627\u0646 \u0622\u0645\u0646." \u0625\u0630\u0627 \u0641\u0642\u062F\u062A \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062C\u0647\u0627\u0632 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643\u060C \u0641\u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.',
      successTitle: "\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0631\u0645\u0632 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0642\u0635\u064A\u0631\u0629",
      title: "\u0623\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0631\u0645\u0632 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0635\u064A\u0629"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644QR \u0628\u062F\u0644\u0627 \u0645\u0646 \u0630\u0644\u0643",
        buttonUnableToScan__nonPrimary: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644QR?",
        infoText__ableToScan: "\u0642\u0645 \u0628\u0625\u0639\u062F\u0627\u062F \u0637\u0631\u064A\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u062C\u062F\u064A\u062F\u0629 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0648 \u0642\u0645 \u0628\u0645\u0633\u062D \u0643\u0648\u062F \u0627\u0644QR \u0644\u0631\u0628\u0637\u0647 \u0628\u062D\u0633\u0627\u0628\u0643",
        infoText__unableToScan: "\u0642\u0645 \u0628\u0625\u0639\u062F\u0627\u062F \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u062C\u062F\u064A\u062F\u0629 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0648\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0642\u062F\u0645 \u0623\u062F\u0646\u0627\u0647",
        inputLabel__unableToScan1: "\u062A\u0623\u0643\u062F \u0645\u0646 \u062A\u0641\u0639\u064A\u0644 \u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0648\u0642\u062A \u0623\u0648 \u0627\u0644\u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0644\u0648\u0627\u062D\u062F, \u062B\u0645 \u0623\u0643\u0645\u0644 \u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643",
        inputLabel__unableToScan2: "\u0628\u062F\u0644\u0627 \u0645\u0646 \u0630\u0644\u0643, \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0645\u0635\u062F\u0642 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u064A\u062F\u0639\u0645 \u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629 \u0645\u0646 \u0637\u0631\u0642 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0648\u0642\u062A \u0623\u0648 \u0627\u0644\u0623\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0644\u0648\u0627\u062D\u062F, \u064A\u0645\u0643\u0646\u0643 \u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637 \u0643\u0644\u0647"
      },
      removeResource: {
        messageLine1: "\u0631\u0645\u0648\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0647\u0630\u0627 \u0633\u062A\u0643\u0648\u0646 \u063A\u064A\u0631 \u0636\u0631\u0648\u064A\u0629 \u0639\u0646\u062F \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        messageLine2: "\u0642\u062F \u0644\u0627 \u064A\u0643\u0648\u0646 \u062D\u0633\u0627\u0628\u0643 \u0622\u0645\u0646\u0627. \u0647\u0644 \u0623\u0646\u0643 \u0645\u062A\u0623\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u061F",
        successMessage: "\u062A\u0645 \u0623\u0632\u0627\u0644\u0629 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0645\u0646 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
        title: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646"
      },
      successMessage: "\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0627\u0644\u0644\u0622\u0646. \u0639\u0646\u062F \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0633\u0648\u0641 \u064A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0623\u062F\u062E\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      title: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629",
      verifySubtitle: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0646\u0634\u0626 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
      verifyTitle: "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642"
    },
    mobileButton__menu: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    navbar: {
      account: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
      description: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062E\u0635\u064A.",
      security: "\u062D\u0645\u0627\u064A\u0629",
      title: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} \u0633\u0648\u0641 \u064A\u062A\u0645 \u062D\u0630\u0641\u0647 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628.",
        title: "\u0625\u0632\u0627\u0644\u0629 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631"
      },
      subtitle__rename: "\u064A\u0645\u0643\u0646\u0643 \u062A\u063A\u064A\u064A\u0631 \u0627\u0633\u0645 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u062A\u0633\u0647\u064A\u0644 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u064A\u0647",
      title__rename: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u064A\u0648\u0635\u0649 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u0631\u0628\u0645\u0627 \u0642\u062F \u0627\u0633\u062A\u062E\u062F\u0645\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.",
      readonly: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u0623\u0646\u0647 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0639\u0646 \u0637\u0631\u064A\u0642 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      successMessage__set: "\u062A\u0645 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631.",
      successMessage__signOutOfOtherSessions: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u062C\u0647\u0632\u0629.",
      successMessage__update: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631",
      title__set: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      title__update: "\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    phoneNumberPage: {
      infoText: "\u0633\u064A\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629 \u0646\u0635\u064A\u0629 \u062A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0642\u0642 \u0625\u0644\u0649 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0647\u0630\u0627.",
      removeResource: {
        messageLine1: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0625\u064A\u0645\u064A\u0644 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 {{identifier}}",
        messageLine2: "\u0644\u0646 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u0647\u0630\u0627",
        successMessage: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 {{phoneNumber}}",
        title: "\u062D\u0630\u0641 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644"
      },
      successMessage: "\u062A\u0645 \u0625\u0636\u0627\u0641\u0629 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u0647\u0630\u0627 {{identifier}}",
      title: "\u0625\u0636\u0627\u0641\u0629 \u0631\u0642\u0645 \u062C\u0648\u0627\u0644",
      verifySubtitle: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 {{identifier}}",
      verifyTitle: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641"
    },
    profilePage: {
      fileDropAreaHint: "\u0623\u0631\u0641\u0639 \u0635\u0648\u0631\u0629 \u0628\u0635\u064A\u063A\u0629 JPG, PNG, GIF \u0623\u0648 WEBP \u0623\u0642\u0644 \u0645\u0646 10 \u0645\u064A\u063A\u0627\u0628\u0627\u064A\u062A",
      imageFormDestructiveActionSubtitle: "\u062D\u0630\u0641 \u0635\u0648\u0631\u0629 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
      imageFormSubtitle: "\u0631\u0641\u0639 \u0635\u0648\u0631\u0629 \u0644\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
      imageFormTitle: "\u0635\u0648\u0631\u0629 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
      readonly: "\u062A\u0645 \u062A\u0648\u0641\u064A\u0631 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0633\u0627\u0628\u0643 \u0639\u0646 \u0637\u0631\u064A\u0642 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627",
      successMessage: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0633\u0627\u0628\u0643 \u0627\u0644\u0634\u062E\u0635\u064A \u062A\u0645 \u062A\u062D\u062F\u064A\u062B\u0647\u0627",
      title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0642\u0645 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0627\u0644\u062C\u0647\u0627\u0632",
        title: "\u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0646\u0634\u0637\u0629"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
        actionLabel__reauthorize: "\u0623\u0639\u0637\u0649 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0622\u0646",
        destructiveActionTitle: "\u062D\u0630\u0641",
        primaryButton: "\u0631\u0628\u0637 \u062D\u0633\u0627\u0628",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629. \u0647\u0630\u0627 \u0627\u0644\u062A\u062D\u062F\u064A\u062B \u0642\u062F \u064A\u062D\u062F \u0645\u0646 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0648\u0638\u064A\u0641\u064A\u0629. \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u062A\u0631\u062E\u064A\u0635 \u0647\u0630\u0627 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0644\u062A\u062C\u0646\u0628 \u0623\u064A \u0645\u0634\u0627\u0643\u0644",
        title: "\u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0644\u0629"
      },
      dangerSection: {
        deleteAccountButton: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
        title: "\u062E\u0637\u0631"
      },
      emailAddressesSection: {
        destructiveAction: "\u0623\u062D\u0630\u0641 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        detailsAction__nonPrimary: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0628\u0631\u064A\u062F \u0631\u0626\u064A\u0633\u064A",
        detailsAction__primary: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0643\u0627\u0645\u0644",
        detailsAction__unverified: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        primaryButton: "\u0623\u0636\u0627\u0641\u0629 \u0639\u0646\u0648\u0627\u0646 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
      },
      enterpriseAccountsSection: {
        title: "\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A"
      },
      headerTitle__account: "\u0627\u0644\u062D\u0633\u0627\u0628",
      headerTitle__security: "\u0627\u0644\u0623\u0645\u0627\u0646",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u062A\u062C\u062F\u064A\u062F \u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A",
          headerTitle: "\u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A",
          subtitle__regenerate: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u062C\u0645\u0648\u0639\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0627\u0644\u0622\u0645\u0646\u0629. \u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0627\u0644\u0633\u0627\u0628\u0642\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627.",
          title__regenerate: "\u062A\u062C\u062F\u064A\u062F \u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A"
        },
        phoneCode: {
          actionLabel__setDefault: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0623\u0641\u062A\u0631\u0627\u0636\u064A",
          destructiveActionLabel: "\u062D\u0630\u0641 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644"
        },
        primaryButton: "\u0625\u0636\u0627\u0641\u0629\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
        title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
        totp: {
          destructiveActionTitle: "\u062D\u0630\u0641",
          headerTitle: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629"
        }
      },
      passkeysSection: {
        menuAction__destructive: "\u0625\u0632\u0627\u0644\u0629",
        menuAction__rename: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629",
        primaryButton: void 0,
        title: "\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0645\u0631\u0648\u0631"
      },
      passwordSection: {
        primaryButton__setPassword: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
        primaryButton__updatePassword: "\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
        title: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
      },
      phoneNumbersSection: {
        destructiveAction: "\u062D\u0630\u0641 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
        detailsAction__nonPrimary: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0631\u0626\u064A\u0633\u064A",
        detailsAction__primary: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0643\u0627\u0645\u0644",
        detailsAction__unverified: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
        primaryButton: "\u0625\u0636\u0627\u0641\u0629 \u0631\u0642\u0645 \u062C\u0648\u0627\u0644",
        title: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644"
      },
      profileSection: {
        primaryButton: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
        title: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A"
      },
      usernameSection: {
        primaryButton__setUsername: "\u062A\u0639\u064A\u064A\u0646 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
        primaryButton__updateUsername: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
        title: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645"
      },
      web3WalletsSection: {
        destructiveAction: "\u062D\u0630\u0641 \u0627\u0644\u0645\u062D\u0641\u0638\u0629",
        primaryButton: "\u0645\u062D\u0627\u0641\u0638 Web3",
        title: "\u0645\u062D\u0627\u0641\u0638 Web3"
      }
    },
    usernamePage: {
      successMessage: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
      title__set: "\u062A\u062D\u062F\u064A\u062B \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
      title__update: "\u062A\u062D\u062F\u064A\u062B \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643{{identifier}}",
        messageLine2: "\u0644\u0646 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u062D\u0641\u0638\u0629 web3 \u0647\u0630\u0647",
        successMessage: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643{{web3Wallet}}",
        title: "\u062D\u0630\u0641 \u0645\u062D\u0641\u0638\u0629 web3"
      },
      subtitle__availableWallets: "\u0623\u062E\u062A\u0631 \u0645\u062D\u0641\u0638\u0629 web3 \u0644\u062A\u0648\u0635\u064A\u0644\u0647\u0627 \u0628\u062D\u0633\u0627\u0628\u0643",
      subtitle__unavailableWallets: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0627\u064A \u0645\u062D\u0641\u0638\u0629 web3 \u0645\u062A\u0627\u062D\u0629",
      successMessage: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0627\u0644\u0649 \u062D\u0633\u0627\u0628\u0643.",
      title: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062D\u0641\u0638\u0629 web3",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/be-BY.ts
var beBY = {
  locale: "be-BY",
  backButton: "\u041D\u0430\u0437\u0430\u0434",
  badge__default: "\u041F\u0430-\u0437\u043C\u0430\u045E\u0447\u0430\u043D\u043D\u0456",
  badge__otherImpersonatorDevice: "\u0406\u043D\u0448\u0430\u044F \u043F\u0440\u044B\u043B\u0430\u0434\u0430",
  badge__primary: "\u0410\u0441\u043D\u043E\u045E\u043D\u0430\u044F",
  badge__requiresAction: "\u041F\u0430\u0442\u0440\u0430\u0431\u0443\u0435\u0446\u0446\u0430 \u0434\u0437\u0435\u044F\u043D\u043D\u0435",
  badge__thisDevice: "\u0413\u044D\u0442\u0430 \u043F\u0440\u044B\u043B\u0430\u0434\u0430",
  badge__unverified: "\u041D\u0435 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0432\u0430\u043D\u0430",
  badge__userDevice: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u0446\u043A\u0430\u044F \u043F\u0440\u044B\u043B\u0430\u0434\u0430",
  badge__you: "\u0412\u044B",
  createOrganization: {
    formButtonSubmit: "\u0421\u0442\u0432\u0430\u0440\u044B\u0446\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E",
    invitePage: {
      formButtonReset: "\u041F\u0440\u0430\u043F\u0443\u0441\u0446\u0456\u0446\u044C"
    },
    title: "\u0421\u0442\u0432\u0430\u0440\u044B\u0446\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E"
  },
  dates: {
    lastDay: "\u0423\u0447\u043E\u0440\u0430 \u045E {{ date | timeString('be-BY') }}",
    next6Days: "{{ date | weekday('be-BY','long') }} \u045E {{ date | timeString('be-BY') }}",
    nextDay: "\u0417\u0430\u045E\u0442\u0440\u0430 \u045E {{ date | timeString('be-BY') }}",
    numeric: "{{ date | numeric('be-BY') }}",
    previous6Days: "\u0410\u043F\u043E\u0448\u043D\u0456 {{ date | weekday('be-BY','long') }} \u045E {{ date | timeString('be-BY') }}",
    sameDay: "\u0421\u0451\u043D\u043D\u044F \u045E {{ date | timeString('be-BY') }}"
  },
  dividerText: "\u0446\u0456",
  footerActionLink__useAnotherMethod: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u0456\u043D\u0448\u044B \u043C\u0435\u0442\u0430\u0434",
  footerPageLink__help: "\u0414\u0430\u043F\u0430\u043C\u043E\u0433\u0430",
  footerPageLink__privacy: "\u041F\u0440\u0438\u0432\u0430\u0442\u043D\u0430\u0441\u0446\u044C",
  footerPageLink__terms: "\u0423\u043C\u043E\u0432\u044B",
  formButtonPrimary: "\u041F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C",
  formButtonPrimary__verify: "\u041F\u0440\u0430\u0432\u0435\u0440\u044B\u0446\u044C",
  formFieldAction__forgotPassword: "\u0417\u0430\u0431\u044B\u043B\u0456 \u043F\u0430\u0440\u043E\u043B\u044C?",
  formFieldError__matchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0456 \u0441\u0443\u043F\u0430\u0434\u0430\u044E\u0446\u044C.",
  formFieldError__notMatchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0456 \u043D\u0435 \u0441\u0443\u043F\u0430\u0434\u0430\u044E\u0446\u044C.",
  formFieldError__verificationLinkExpired: "\u0421\u043F\u0430\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044E \u0441\u043F\u0430\u043C\u043F\u0430\u0432\u0430\u043B\u0430. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u044B\u0442\u0430\u0439\u0446\u0435 \u043D\u043E\u0432\u0443\u044E \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443.",
  formFieldHintText__optional: "\u041D\u0435\u0430\u0431\u0430\u0432\u044F\u0437\u043A\u043E\u0432\u0430",
  formFieldHintText__slug: "Slug \u2014 \u0433\u044D\u0442\u0430 \u0447\u044B\u0442\u0430\u043B\u044C\u043D\u044B \u0456\u0434\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0442\u0430\u0440, \u044F\u043A\u0456 \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0431\u044B\u0446\u044C \u0443\u043D\u0456\u043A\u0430\u043B\u044C\u043D\u044B\u043C. \u0427\u0430\u0441\u0442\u043E \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0435\u0446\u0446\u0430 \u045E URL-\u0430\u0445.",
  formFieldInputPlaceholder__backupCode: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B \u043A\u043E\u0434",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u041F\u0430\u0446\u0432\u0435\u0440\u0434\u0437\u0456\u0446\u044C \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u043D\u0435 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443",
  formFieldInputPlaceholder__emailAddress: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0430\u0448 \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B",
  formFieldInputPlaceholder__emailAddress_username: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u0430\u0431\u043E \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
  formFieldInputPlaceholder__emailAddresses: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0430\u0431\u043E \u045E\u0441\u0442\u0430\u045E\u0446\u0435 \u0430\u0434\u0437\u0456\u043D \u0446\u0456 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u0430\u0434\u0440\u0430\u0441\u043E\u045E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B, \u0440\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u044E\u0447\u044B \u0456\u0445 \u043F\u0440\u0430\u0431\u0435\u043B\u0430\u043C\u0456 \u0430\u0431\u043E \u043A\u043E\u0441\u043A\u0430\u043C\u0456",
  formFieldInputPlaceholder__firstName: "\u0406\u043C\u044F",
  formFieldInputPlaceholder__lastName: "\u041F\u0440\u043E\u0437\u0432\u0456\u0448\u0447\u0430",
  formFieldInputPlaceholder__organizationDomain: "\u0414\u0430\u043C\u0435\u043D \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 (\u043D\u0430\u043F\u0440\u044B\u043A\u043B\u0430\u0434, example.com)",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0448\u0442\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456",
  formFieldInputPlaceholder__organizationName: "\u041D\u0430\u0437\u0432\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456",
  formFieldInputPlaceholder__organizationSlug: "slug \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 (\u043D\u0430\u043F\u0440\u044B\u043A\u043B\u0430\u0434, my-org)",
  formFieldInputPlaceholder__password: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldInputPlaceholder__phoneNumber: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0430\u0448 \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
  formFieldInputPlaceholder__username: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
  formFieldLabel__automaticInvitations: "\u0423\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u044B\u044F \u0437\u0430\u043F\u0440\u0430\u0448\u044D\u043D\u043D\u0456 \u0434\u043B\u044F \u0433\u044D\u0442\u0430\u0433\u0430 \u0434\u0430\u043C\u0435\u043D\u0430",
  formFieldLabel__backupCode: "\u041A\u043E\u0434 \u0430\u0434\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u044F",
  formFieldLabel__confirmDeletion: "\u041F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u0435",
  formFieldLabel__confirmPassword: "\u041F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
  formFieldLabel__currentPassword: "\u0426\u044F\u043F\u0435\u0440\u0430\u0448\u043D\u0456 \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__emailAddress: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0448\u0442\u0430",
  formFieldLabel__emailAddress_username: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0448\u0442\u0430 \u0430\u0431\u043E \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
  formFieldLabel__emailAddresses: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u044F \u0430\u0434\u0440\u0430\u0441\u044B",
  formFieldLabel__firstName: "\u0406\u043C\u044F",
  formFieldLabel__lastName: "\u041F\u0440\u043E\u0437\u0432\u0456\u0448\u0447\u0430",
  formFieldLabel__newPassword: "\u041D\u043E\u0432\u044B \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__organizationDomain: "\u0414\u0430\u043C\u0435\u043D",
  formFieldLabel__organizationDomainDeletePending: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0447\u0430\u043A\u0430\u043D\u044B\u044F \u0437\u0430\u043F\u0440\u0430\u0448\u044D\u043D\u043D\u0456 \u0456 \u043F\u0440\u0430\u043F\u0430\u043D\u043E\u0432\u044B",
  formFieldLabel__organizationDomainEmailAddress: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B \u0430\u0434\u0440\u0430\u0441 \u0434\u043B\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u043F\u0430\u0434 \u0433\u044D\u0442\u044B\u043C \u0434\u0430\u043C\u0435\u043D\u0430\u043C, \u043A\u0430\u0431 \u0430\u0442\u0440\u044B\u043C\u0430\u0446\u044C \u043A\u043E\u0434 \u0456 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0432\u0430\u0446\u044C \u0433\u044D\u0442\u044B \u0434\u0430\u043C\u0435\u043D.",
  formFieldLabel__organizationName: "\u041D\u0430\u0437\u0432\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u041F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__phoneNumber: "\u041D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
  formFieldLabel__role: "\u0420\u043E\u043B\u044F",
  formFieldLabel__signOutOfOtherSessions: "\u0412\u044B\u0439\u0441\u0446\u0456 \u0437 \u0443\u0441\u0456\u0445 \u0456\u043D\u0448\u044B\u0445 \u0441\u0435\u0441\u0456\u0439",
  formFieldLabel__username: "\u0406\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
  impersonationFab: {
    action__signOut: "\u0412\u044B\u0439\u0441\u0446\u0456",
    title: "\u0412\u044B \u045E\u0432\u0430\u0439\u0448\u043B\u0456 \u044F\u043A {{identifier}}"
  },
  maintenanceMode: "\u0420\u044D\u0436\u044B\u043C \u0442\u044D\u0445\u043D\u0456\u0447\u043D\u0430\u0433\u0430 \u0430\u0431\u0441\u043B\u0443\u0433\u043E\u045E\u0432\u0430\u043D\u043D\u044F",
  membershipRole__admin: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0430\u0440",
  membershipRole__basicMember: "\u0423\u0434\u0437\u0435\u043B\u044C\u043D\u0456\u043A",
  membershipRole__guestMember: "\u0413\u043E\u0441\u0446\u044C",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u045E\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
    titleWithoutPersonal: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0434\u043E\u043C\u0435\u043D. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438, \u0447\u044C\u044F \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u0434\u043E\u043C\u0435\u043D\u0435, \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0438\u043B\u0438 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C. \u0418\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443:",
      formButtonPrimary__continue: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
      selectDropdown__role: "Select role",
      subtitle: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0432 \u044D\u0442\u0443 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E",
      successMessage: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B",
      title: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432"
    },
    membersPage: {
      action__invite: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0434\u0437\u0435\u043B\u044C\u043D\u0456\u043A\u0430",
        tableHeader__actions: "\u0414\u0437\u0435\u044F\u043D\u043D\u0456",
        tableHeader__joined: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F",
        tableHeader__role: "\u0420\u043E\u043B\u044F",
        tableHeader__user: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A"
      },
      detailsTitle__emptyRow: "\u041D\u0435\u0442 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u041E\u0442\u043E\u0437\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435",
        tableHeader__invited: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043D\u044B\u0435"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
        headerTitle__members: "\u0423\u0434\u0437\u0435\u043B\u044C\u043D\u0456\u043A\u0456",
        headerTitle__requests: "\u0417\u0430\u044F\u0432\u043A\u0456"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "\u041D\u0430\u043F\u0456\u0448\u044B\u0446\u0435 {{organizationName}} \u045E \u043F\u043E\u043B\u0456 \u043D\u0456\u0436\u044D\u0439, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.",
          messageLine1: "\u0412\u044B \u045E\u043F\u044D\u045E\u043D\u0435\u043D\u044B, \u0448\u0442\u043E \u0445\u043E\u0447\u0430\u0446\u0435 \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u0443\u044E \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E?",
          messageLine2: "\u0413\u044D\u0442\u0430 \u0434\u0437\u0435\u044F\u043D\u043D\u0435 \u043D\u0435\u043B\u044C\u0433\u0430 \u0430\u0434\u043C\u044F\u043D\u0456\u0446\u044C.",
          successMessage: "\u0412\u044B \u0432\u044B\u0434\u0430\u043B\u0456\u043B\u0456 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E.",
          title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E"
        },
        leaveOrganization: {
          actionDescription: '\u041D\u0430\u043F\u0456\u0448\u044B\u0446\u0435 "{{organizationName}}" \u043D\u0456\u0436\u044D\u0439, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.',
          messageLine1: "\u0412\u044B \u045E\u043F\u044D\u045E\u043D\u0435\u043D\u044B, \u0448\u0442\u043E \u0445\u043E\u0447\u0430\u0446\u0435 \u043F\u0430\u043A\u0456\u043D\u0443\u0446\u044C \u0433\u044D\u0442\u0443\u044E \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E? \u0412\u044B \u0441\u0442\u0440\u0430\u0446\u0456\u0446\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u0430 \u0433\u044D\u0442\u0430\u0439 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u0456 \u044F\u0435 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F\u043C.",
          messageLine2: "\u0413\u044D\u0442\u0430 \u0434\u0437\u0435\u044F\u043D\u043D\u0435 \u043D\u0435\u043B\u044C\u0433\u0430 \u0430\u0434\u043C\u044F\u043D\u0456\u0446\u044C.",
          successMessage: "\u0412\u044B \u043F\u0430\u043A\u0456\u043D\u0443\u043B\u0456 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E.",
          title: "\u041F\u0430\u043A\u0456\u043D\u0443\u0446\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E"
        },
        title: "\u041D\u0435\u0431\u044F\u0441\u043F\u0435\u043A\u0430"
      },
      domainSection: {
        menuAction__manage: "\u041A\u0456\u0440\u0430\u0432\u0430\u0446\u044C",
        menuAction__remove: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C",
        menuAction__verify: "\u041F\u0440\u0430\u0432\u0435\u0440\u044B\u0446\u044C",
        primaryButton: "\u0414\u0430\u0434\u0430\u0446\u044C \u0434\u043E\u043C\u0435\u043D",
        subtitle: "\u0414\u0430\u0437\u0432\u043E\u043B\u044C\u0446\u0435 \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u043C \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0430 \u0434\u0430\u043B\u0443\u0447\u0430\u0446\u0446\u0430 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u0430\u0431\u043E \u043F\u0430 \u0437\u0430\u043F\u044B\u0446\u0435, \u043A\u0430\u043B\u0456 \u0434\u0430\u043C\u0435\u043D \u0456\u0445 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u043F\u0440\u0430\u0432\u0435\u0440\u0430\u043D\u044B.",
        title: "\u041F\u0440\u0430\u0432\u0435\u0440\u0430\u043D\u044B\u044F \u0434\u0430\u043C\u0435\u043D\u044B"
      },
      successMessage: "\u0410\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044F \u0431\u044B\u043B\u0430 \u0430\u0431\u043D\u043E\u045E\u043B\u0435\u043D\u0430.",
      title: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456"
    },
    removeDomainPage: {
      messageLine1: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B \u0434\u0430\u043C\u0435\u043D {{domain}} \u0431\u0443\u0434\u0437\u0435 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B.",
      messageLine2: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0456 \u043D\u0435 \u0437\u043C\u043E\u0433\u0443\u0446\u044C \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0430 \u0434\u0430\u043B\u0443\u0447\u0430\u0446\u0446\u0430 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u043F\u0430\u0441\u043B\u044F \u0433\u044D\u0442\u0430\u0433\u0430.",
      successMessage: "{{domain}} \u0431\u044B\u045E \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B.",
      title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0434\u0430\u043C\u0435\u043D"
    },
    start: {
      headerTitle__general: "\u0410\u0433\u0443\u043B\u044C\u043D\u044B",
      headerTitle__members: "\u0423\u0434\u0437\u0435\u043B\u044C\u043D\u0456\u043A\u0456",
      profileSection: {
        primaryButton: void 0,
        title: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456",
        uploadAction__title: "\u041B\u0430\u0433\u0430\u0442\u044B\u043F"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u0412\u044B\u0434\u0430\u043B\u0435\u043D\u043D\u0435 \u0434\u0430\u043C\u0435\u043D\u0430 \u043F\u0430\u045E\u043F\u043B\u044B\u0432\u0430\u0435 \u043D\u0430 \u0437\u0430\u043F\u0440\u043E\u0448\u0430\u043D\u044B\u0445 \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u045E.",
        removeDomainActionLabel__remove: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0434\u0430\u043C\u0435\u043D",
        removeDomainSubtitle: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u044B \u0434\u0430\u043C\u0435\u043D \u0437 \u043B\u0456\u043A\u0443 \u043F\u0440\u0430\u0432\u0435\u0440\u0430\u043D\u044B\u0445",
        removeDomainTitle: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0434\u0430\u043C\u0435\u043D"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0456 \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0430 \u0430\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u044E\u0446\u044C \u0437\u0430\u043F\u0440\u0430\u0448\u044D\u043D\u043D\u0435 \u0434\u0430\u043B\u0443\u0447\u044B\u0446\u0446\u0430 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u043F\u0430\u0441\u043B\u044F \u0440\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u0456 \u0456 \u043C\u043E\u0433\u0443\u0446\u044C \u043F\u0440\u044B\u043D\u044F\u0446\u044C \u044F\u0433\u043E \u045E \u043B\u044E\u0431\u044B \u0447\u0430\u0441 \u0431\u0435\u0437 \u0430\u0434\u0430\u0431\u0440\u044D\u043D\u043D\u044F \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0430\u0440\u0430",
        automaticInvitationOption__label: "\u0410\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u044B\u044F \u0437\u0430\u043F\u0440\u0430\u0448\u044D\u043D\u043D\u0456",
        automaticSuggestionOption__description: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0456 \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0430 \u0430\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u044E\u0446\u044C \u0437\u0430\u043F\u0440\u0430\u0448\u044D\u043D\u043D\u0435 \u043F\u0430\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u045E\u043A\u0443 \u043D\u0430 \u0434\u0430\u043B\u0443\u0447\u044D\u043D\u043D\u0435 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456. \u041A\u0430\u0431 \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A \u043C\u043E\u0433 \u0434\u0430\u043B\u0443\u0447\u044B\u0446\u0446\u0430 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456, \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0430\u0440 \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0430\u0434\u0430\u0431\u0440\u0430\u0446\u044C \u0437\u0430\u044F\u045E\u043A\u0443.",
        automaticSuggestionOption__label: "\u0410\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u044B\u044F \u0440\u044D\u043A\u0430\u043C\u0435\u043D\u0434\u0430\u0446\u044B\u0456",
        calloutInfoLabel: "\u0417\u043C\u0435\u043D\u0430 \u0441\u043F\u043E\u0441\u0430\u0431\u0443 \u0434\u0430\u043B\u0443\u0447\u044D\u043D\u043D\u044F \u043F\u0430\u045E\u043F\u043B\u044B\u0432\u0430\u0435 \u0442\u043E\u043B\u044C\u043A\u0456 \u043D\u0430 \u043D\u043E\u0432\u044B\u0445 \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u045E.",
        calloutInvitationCountLabel: "\u0417\u0430\u043F\u0440\u0430\u0448\u044D\u043D\u043D\u044F\u045E \u0430\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430: {{count}}",
        calloutSuggestionCountLabel: "\u0420\u044D\u043A\u0430\u043C\u0435\u043D\u0434\u0430\u0446\u044B\u0439 \u0430\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430: {{count}}",
        manualInvitationOption__description: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0456 \u043D\u0435 \u0437\u043C\u043E\u0433\u0443\u0446\u044C \u0434\u0430\u043B\u0443\u0447\u0430\u0446\u0446\u0430 \u0441\u0430\u043C\u0430\u0441\u0442\u043E\u0439\u043D\u0430, \u043C\u043E\u0436\u043D\u0430 \u0434\u0430\u0434\u0430\u0432\u0430\u0446\u044C \u0456\u0445 \u0442\u043E\u043B\u044C\u043A\u0456 \u045E\u0440\u0443\u0447\u043D\u0443\u044E.",
        manualInvitationOption__label: "\u0422\u043E\u043B\u044C\u043A\u0456 \u0440\u0443\u0447\u043D\u043E\u0435 \u0434\u0430\u0434\u0430\u0432\u0430\u043D\u043D\u0435",
        subtitle: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435, \u044F\u043A\u0456\u043C \u0447\u044B\u043D\u0430\u043C \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0456 \u0437 \u0433\u044D\u0442\u044B\u043C \u0434\u0430\u043C\u0435\u043D\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u0431\u0443\u0434\u0443\u0446\u044C \u0434\u0430\u043B\u0443\u0447\u0430\u0446\u0446\u0430 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456."
      },
      start: {
        headerTitle__danger: "\u041D\u0435\u0431\u044F\u0441\u043F\u0435\u043A\u0430",
        headerTitle__enrollment: "\u0421\u043F\u043E\u0441\u0430\u0431\u044B \u0434\u0430\u043B\u0443\u0447\u044D\u043D\u043D\u044F"
      },
      subtitle: "\u0414\u0430\u043C\u0435\u043D {{domain}} \u043F\u0440\u0430\u0432\u0435\u0440\u0430\u043D\u044B. \u0426\u044F\u043F\u0435\u0440 \u0432\u044B\u0431\u0435\u0440\u044B\u0446\u0435, \u044F\u043A \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0456 \u0437 \u0433\u044D\u0442\u044B\u043C \u0434\u0430\u043C\u0435\u043D\u0430\u043C \u0431\u0443\u0434\u0443\u0446\u044C \u0434\u0430\u043B\u0443\u0447\u0430\u0446\u0446\u0430 \u0434\u0430 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456.",
      title: "\u0410\u0431\u043D\u0430\u0432\u0456\u0446\u044C {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u045E\u043A\u0430\u0437\u0430\u043D\u0443\u044E \u043F\u043E\u0448\u0442\u0443",
      formTitle: "\u041A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F",
      resendButton: "\u041D\u0435 \u0430\u0442\u0440\u044B\u043C\u0430\u043B\u0456 \u043A\u043E\u0434? \u0410\u0434\u043F\u0440\u0430\u045E\u0446\u0435 \u044F\u0448\u0447\u044D \u0440\u0430\u0437",
      subtitle: "\u0414\u043E\u043C\u0435\u043D {{domainName}} \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0431\u044B\u0446\u044C \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0432\u0430\u043D\u044B \u043F\u0440\u0430\u0437 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0448\u0442\u0443.",
      subtitleVerificationCodeScreen: "\u041A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0448\u0442\u0443 {{emailAddress}}. \u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u044F\u0433\u043E \u0441\u044E\u0434\u044B, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.",
      title: "\u0412\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044F \u0434\u0430\u043C\u0435\u043D\u0430"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0421\u0442\u0432\u0430\u0440\u044B\u0446\u044C \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E",
    action__invitationAccept: "Join",
    action__manageOrganization: "\u041A\u0456\u0440\u0430\u0432\u0430\u043D\u043D\u0435 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044F\u0439",
    action__suggestionsAccept: "Request to join",
    notSelected: "\u0410\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044F \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430",
    personalWorkspace: "\u0410\u0441\u0430\u0431\u0456\u0441\u0442\u0430\u0435 \u043F\u0440\u0430\u0446\u043E\u045E\u043D\u0430\u0435 \u043F\u0440\u0430\u0441\u0442\u043E\u0440\u0430",
    suggestionsAcceptedLabel: "\u0423 \u0447\u0430\u043A\u0430\u043D\u043D\u0456 \u0430\u0434\u0430\u0431\u0440\u044D\u043D\u043D\u044F"
  },
  paginationButton__next: "\u041D\u0430\u043F\u0435\u0440\u0430\u0434",
  paginationButton__previous: "\u041D\u0430\u0437\u0430\u0434",
  paginationRowText__displaying: "\u0410\u0434\u043B\u044E\u0441\u0442\u0440\u0430\u0432\u0430\u043D\u043D\u0435",
  paginationRowText__of: "\u0437",
  reverification: {
    alternativeMethods: {
      actionLink: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u0430\u043B\u044C\u0442\u044D\u0440\u043D\u0430\u0442\u044B\u045E\u043D\u044B \u043C\u0435\u0442\u0430\u0434",
      actionText: "\u041F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u0456\u043D\u0448\u044B \u043C\u0435\u0442\u0430\u0434 \u0434\u043B\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456.",
      blockButton__backupCode: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 \u0437 \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u0433\u0430 \u043A\u043E\u0434\u0430",
      blockButton__emailCode: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0448\u0442\u0443",
      blockButton__password: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043F\u0430\u0440\u043E\u043B\u044C",
      blockButton__phoneCode: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u0442\u044D\u043B\u0435\u0444\u043E\u043D",
      blockButton__totp: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0439\u0446\u0435 TOTP",
      getHelp: {
        blockButton__emailSupport: "\u0417\u0432\u044F\u0437\u0430\u0446\u0446\u0430 \u0437 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0430\u0439 \u043F\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0446\u0435",
        content: "\u041A\u0430\u043B\u0456 \u045E \u0432\u0430\u0441 \u0451\u0441\u0446\u044C \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B, \u0437\u0432\u044F\u0436\u044B\u0446\u0435\u0441\u044F \u0437 \u043D\u0430\u0448\u0430\u0439 \u0441\u043B\u0443\u0436\u0431\u0430\u0439 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456.",
        title: "\u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0437\u0432\u044F\u0436\u044B\u0446\u0435\u0441\u044F \u0437 \u043D\u0430\u043C\u0456 \u0434\u043B\u044F \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0456."
      },
      subtitle: "\u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0430\u0432\u0430\u0446\u044C \u0430\u0434\u0437\u0456\u043D \u0437 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u0434\u0430\u045E \u0434\u043B\u044F \u0437\u0430\u0432\u044F\u0440\u0448\u044D\u043D\u043D\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456.",
      title: "\u0410\u043B\u044C\u0442\u044D\u0440\u043D\u0430\u0442\u044B\u045E\u043D\u044B\u044F \u043C\u0435\u0442\u0430\u0434\u044B \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456"
    },
    backupCodeMfa: {
      subtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B \u043A\u043E\u0434 \u0434\u043B\u044F \u0437\u0430\u0432\u044F\u0440\u0448\u044D\u043D\u043D\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456.",
      title: "\u0420\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B \u043A\u043E\u0434 MFA"
    },
    emailCode: {
      formTitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u044F\u043A\u0456 \u043C\u044B \u0430\u0434\u043F\u0440\u0430\u0432\u0456\u043B\u0456 \u0432\u0430\u043C \u043D\u0430 email.",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 \u043D\u0430 email",
      subtitle: "\u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0432\u0430\u0448\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0448\u0442\u0443 \u0434\u043B\u044F \u043A\u043E\u0434\u0430.",
      title: "\u041A\u043E\u0434 \u0437 email"
    },
    noAvailableMethods: {
      message: "\u041D\u044F\u043C\u0430 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u0434\u0430\u045E \u0434\u043B\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456.",
      subtitle: "\u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0432\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u0456\u043D\u0448\u044B \u043C\u0435\u0442\u0430\u0434 \u0430\u0431\u043E \u0437\u0432\u044F\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u045E \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456.",
      title: "\u041D\u044F\u043C\u0430 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u0434\u0430\u045E \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456"
    },
    password: {
      actionLink: "\u0412\u044F\u0440\u043D\u0443\u0446\u0446\u0430 \u0434\u0430 \u045E\u0432\u043E\u0434\u0443 \u043F\u0430\u0440\u043E\u043B\u044F",
      subtitle: "\u041A\u0430\u043B\u0456 \u0432\u044B \u043F\u0430\u043C\u044F\u0442\u0430\u0435\u0446\u0435 \u0441\u0432\u043E\u0439 \u043F\u0430\u0440\u043E\u043B\u044C, \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u045E\u0432\u0435\u0441\u0446\u0456 \u044F\u0433\u043E \u0434\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u044D\u043D\u043D\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456.",
      title: "\u041F\u0430\u0434\u0446\u0432\u0435\u0440\u0434\u0437\u0456\u0446\u044C \u043F\u0440\u0430\u0437 \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    phoneCode: {
      formTitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u044F\u043A\u0456 \u0431\u044B\u045E \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D.",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 \u043D\u0430 \u0442\u044D\u043B\u0435\u0444\u043E\u043D",
      subtitle: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0441\u043C\u0441-\u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u0434\u043B\u044F \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u044F \u043A\u043E\u0434\u0430.",
      title: "\u041A\u043E\u0434 \u0437 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430"
    },
    phoneCodeMfa: {
      formTitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 MFA, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D.",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 MFA",
      subtitle: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0441\u043C\u0441-\u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u0434\u043B\u044F \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u044F \u043A\u043E\u0434\u0430 MFA.",
      title: "\u041A\u043E\u0434 MFA \u0437 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430"
    },
    totpMfa: {
      formTitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 TOTP \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F.",
      subtitle: "\u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u0435 \u0434\u043B\u044F \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u044F \u0430\u0434\u043D\u0430\u0440\u0430\u0437\u043E\u0432\u0430\u0433\u0430 \u043A\u043E\u0434\u0430.",
      title: "\u041A\u043E\u0434 TOTP"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u0414\u0430\u0434\u0430\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
      action__signOutAll: "\u0412\u044B\u0439\u0441\u0446\u0456 \u0437 \u0443\u0441\u0456\u0445 \u0443\u043B\u0456\u043A\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0456\u0441\u0430\u045E",
      subtitle: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u045E\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441, \u0437 \u044F\u043A\u0456\u043C \u0432\u044B \u0436\u0430\u0434\u0430\u0435\u0446\u0435 \u043F\u0440\u0430\u0446\u044F\u0433\u0432\u0430\u0446\u044C.",
      title: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u045E\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441"
    },
    alternativeMethods: {
      actionLink: "\u0414\u0430\u043F\u0430\u043C\u043E\u0433\u0430",
      actionText: "\u041D\u0435 \u043C\u0430\u0435\u0446\u0435 \u043D\u0456\u0447\u043E\u0433\u0430 \u0437 \u0433\u044D\u0442\u0430\u0433\u0430?",
      blockButton__backupCode: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0439\u0446\u0435 \u043A\u043E\u0434 \u0430\u0434\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u044F",
      blockButton__emailCode: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__emailLink: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 {{identifier}}",
      blockButton__passkey: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C passkey",
      blockButton__password: "\u0423\u0432\u0430\u0439\u0441\u0446\u0456 \u0437 \u043F\u0430\u0440\u043E\u043B\u0435\u043C",
      blockButton__phoneCode: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__totp: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0439\u0446\u0435 \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0442\u0430\u0440",
      getHelp: {
        blockButton__emailSupport: "\u041D\u0430\u043F\u0456\u0441\u0430\u0446\u044C \u0443 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0443",
        content: "\u041A\u0430\u043B\u0456 \u0432\u044B \u0441\u0443\u0442\u044B\u043A\u043D\u0443\u043B\u0456\u0441\u044F \u0437 \u0446\u044F\u0436\u043A\u0430\u0441\u0446\u044F\u043C\u0456 \u0437 \u0443\u0432\u0430\u0445\u043E\u0434\u0430\u043C \u0443 \u0432\u0430\u0448 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441, \u043D\u0430\u043F\u0456\u0448\u044B\u0446\u0435 \u043D\u0430\u043C, \u0456 \u043C\u044B \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0435\u043C \u0430\u0434\u043D\u0430\u0432\u0456\u0446\u044C \u0432\u0430\u0448 \u0434\u043E\u0441\u0442\u0443\u043F \u0443 \u043D\u0430\u0439\u043A\u0430\u0440\u0430\u0446\u0435\u0439\u0448\u044B\u044F \u0442\u044D\u0440\u043C\u0456\u043D\u044B.",
        title: "\u0414\u0430\u043F\u0430\u043C\u043E\u0433\u0430"
      },
      subtitle: "\u0421\u0443\u0441\u0442\u0440\u044D\u043B\u0456 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B? \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u043B\u044E\u0431\u044B \u0437 \u0433\u044D\u0442\u044B\u0445 \u043C\u0435\u0442\u0430\u0434\u0430\u045E \u0434\u043B\u044F \u045E\u0432\u0430\u0445\u043E\u0434\u0443.",
      title: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u0456\u043D\u0448\u044B \u043C\u0435\u0442\u0430\u0434"
    },
    backupCodeMfa: {
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 \u0430\u0434\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u044F"
    },
    emailCode: {
      formTitle: "\u041A\u043E\u0434 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0432\u0430\u0448\u0443 \u043F\u043E\u0448\u0442\u0443"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0413\u044D\u0442\u0430\u044F \u0441\u0435\u0441\u0456\u044F \u043D\u0435 \u0430\u0434\u043F\u0430\u0432\u044F\u0434\u0430\u0435 \u0432\u0430\u0448\u0430\u043C\u0443 \u043A\u043B\u0456\u0435\u043D\u0442\u0443 \u0430\u0431\u043E \u043F\u0440\u044B\u043B\u0430\u0434\u0437\u0435. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0430\u043A\u0430\u043D\u0430\u0439\u0446\u0435\u0441\u044F, \u0448\u0442\u043E \u0432\u044B \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0435\u0446\u0435 \u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u0437\u0430\u043F\u0456\u0441.",
        title: "\u041D\u0435\u0441\u0443\u043C\u044F\u0448\u0447\u0430\u043B\u044C\u043D\u0430\u0441\u0446\u044C \u0437 \u043A\u043B\u0456\u0435\u043D\u0442\u0430\u043C"
      },
      expired: {
        subtitle: "\u0412\u0435\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u043D\u0430 \u043F\u0430\u0447\u0430\u0442\u043A\u043E\u0432\u0443\u044E \u045E\u043A\u043B\u0430\u0434\u043A\u0443, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.",
        title: "\u0413\u044D\u0442\u0430\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u044F \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043D\u0447\u044B\u043B\u0430\u0441\u044F"
      },
      failed: {
        subtitle: "\u0412\u0435\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u043D\u0430 \u043F\u0430\u0447\u0430\u0442\u043A\u043E\u0432\u0443\u044E \u045E\u043A\u043B\u0430\u0434\u043A\u0443, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.",
        title: "\u0413\u044D\u0442\u0430\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u044F \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430 \u043D\u0435\u0430\u0434\u044D\u043A\u0432\u0430\u0442\u043D\u0430\u044F."
      },
      formSubtitle: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0443\u044E \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0443\u044E \u043D\u0430 \u0432\u0430\u0448\u0443 \u043F\u043E\u0448\u0442\u0443",
      formTitle: "\u0412\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u044F \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430",
      loading: {
        subtitle: "\u0412\u044B \u0445\u0443\u0442\u043A\u0430 \u0431\u0443\u0434\u0437\u0435\u0446\u0435 \u043F\u0435\u0440\u0430\u043D\u0430\u043A\u0456\u0440\u0430\u0432\u0430\u043D\u044B",
        title: "\u0423\u0432\u0430\u0445\u043E\u0434\u0437\u0456\u043C..."
      },
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0432\u0430\u0448\u0443 \u043F\u043E\u0448\u0442\u0443",
      unusedTab: {
        title: "\u0423\u043A\u043B\u0430\u0434\u043A\u0443 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u0447\u044B\u043D\u0456\u0446\u044C"
      },
      verified: {
        subtitle: "\u0412\u044B \u0445\u0443\u0442\u043A\u0430 \u0431\u0443\u0434\u0437\u0435\u0446\u0435 \u043F\u0435\u0440\u0430\u043D\u0430\u043A\u0456\u0440\u0430\u0432\u0430\u043D\u044B",
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B \u045E\u0432\u0430\u0445\u043E\u0434"
      },
      verifiedSwitchTab: {
        subtitle: "\u0412\u0435\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u043D\u0430 \u043F\u0430\u0447\u0430\u0442\u043A\u043E\u0432\u0443\u044E \u045E\u043A\u043B\u0430\u0434\u043A\u0443, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C",
        subtitleNewTab: "\u0412\u0435\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u0456 \u0448\u0442\u043E \u0430\u0434\u0447\u044B\u043D\u0435\u043D\u0443\u044E \u045E\u043A\u043B\u0430\u0434\u043A\u0443, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C",
        titleNewTab: "\u0417\u0430\u043B\u043E\u0433\u0456\u043D\u044C\u0446\u0435\u0441\u044F \u043D\u0430 \u0456\u043D\u0448\u0430\u0439 \u0443\u043A\u043B\u0430\u0434\u0446\u044B"
      }
    },
    forgotPassword: {
      formTitle: "\u041A\u043E\u0434 \u0430\u0434\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
      resendButton: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 \u044F\u0448\u0447\u044D \u0440\u0430\u0437",
      subtitle: "\u043A\u0430\u0431 \u0441\u043A\u0456\u0434\u0430\u0446\u044C \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
      subtitle_email: "\u0421\u043F\u0430\u0447\u0430\u0442\u043A\u0443 \u0443\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B",
      subtitle_phone: "\u0421\u043F\u0430\u0447\u0430\u0442\u043A\u0443 \u0443\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D",
      title: "\u0421\u043A\u0456\u0434 \u043F\u0430\u0440\u043E\u043B\u044F"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0410\u0434\u043D\u0430\u0432\u0456\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      label__alternativeMethods: "\u0410\u0431\u043E \u045E\u0432\u0430\u0439\u0434\u0437\u0456\u0446\u0435 \u0456\u043D\u0448\u044B\u043C \u0441\u043F\u043E\u0441\u0430\u0431\u0430\u043C",
      title: "\u0417\u0430\u0431\u044B\u045E\u0441\u044F \u043F\u0430\u0440\u043E\u043B\u044C?"
    },
    noAvailableMethods: {
      message: "\u041D\u0435\u043C\u0430\u0433\u0447\u044B\u043C\u0430 \u045E\u0432\u0430\u0439\u0441\u0446\u0456. \u041D\u044F\u043C\u0430 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0444\u0430\u043A\u0442\u0430\u0440\u0430\u045E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456.",
      subtitle: "\u0410\u0434\u0431\u044B\u043B\u0430\u0441\u044F \u043F\u0430\u043C\u044B\u043B\u043A\u0430",
      title: "\u041D\u0435\u043C\u0430\u0433\u0447\u044B\u043C\u0430 \u045E\u0432\u0430\u0439\u0441\u0446\u0456"
    },
    passkey: {
      subtitle: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u043F\u0430\u0441\u043A\u0435\u0439 \u0434\u043B\u044F \u0431\u044F\u0441\u043F\u0435\u0447\u043D\u0430\u0433\u0430 \u045E\u0432\u0430\u0445\u043E\u0434\u0443.",
      title: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043F\u0430\u0441\u043A\u0435\u0439"
    },
    password: {
      actionLink: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u0456\u043D\u0448\u044B \u043C\u0435\u0442\u0430\u0434",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    passwordPwned: {
      title: "\u041F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u045E \u0443\u0437\u043B\u0430\u043C\u0430\u043D\u044B"
    },
    phoneCode: {
      formTitle: "\u041A\u043E\u0434 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0432\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D"
    },
    phoneCodeMfa: {
      formTitle: "\u041A\u043E\u0434 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434",
      subtitle: "\u041A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C, \u0443\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D.",
      title: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0432\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D"
    },
    resetPassword: {
      formButtonPrimary: "\u0421\u043A\u0456\u0434\u0430\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      requiredMessage: "\u041F\u0430 \u043C\u0435\u0440\u043A\u0430\u0432\u0430\u043D\u043D\u044E \u0431\u044F\u0441\u043F\u0435\u043A\u0456 \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430 \u0441\u043A\u0456\u0434\u0430\u0446\u044C \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C.",
      successMessage: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0430\u0441\u043F\u044F\u0445\u043E\u0432\u0430 \u0437\u043C\u0435\u043D\u0435\u043D\u044B. \u0412\u044B\u043A\u043E\u043D\u0432\u0430\u0435\u0446\u0446\u0430 \u045E\u0432\u0430\u0445\u043E\u0434, \u043F\u0430\u0447\u0430\u043A\u0430\u0439\u0446\u0435.",
      title: "\u0421\u043A\u0456\u0434\u0430\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    resetPasswordMfa: {
      detailsLabel: "\u041D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0432\u0430\u0446\u044C \u0432\u0430\u0448\u0443 \u0430\u0441\u043E\u0431\u0443 \u043F\u0435\u0440\u0430\u0434 \u0430\u0434\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u0435\u043C \u043F\u0430\u0440\u043E\u043B\u044F"
    },
    start: {
      actionLink: "\u0417\u0430\u0440\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0432\u0430\u0446\u0446\u0430",
      actionLink__join_waitlist: "\u0414\u0430\u043B\u0443\u0447\u044B\u0446\u0446\u0430 \u0434\u0430 \u0447\u0430\u0440\u0433\u0456",
      actionLink__use_email: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u043F\u043E\u0448\u0442\u0443",
      actionLink__use_email_username: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u043F\u043E\u0448\u0442\u0443 \u0430\u0431\u043E \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
      actionLink__use_passkey: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u043F\u0430\u0441\u043A\u0435\u0439",
      actionLink__use_phone: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
      actionLink__use_username: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
      actionText: "\u041D\u044F\u043C\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443?",
      actionText__join_waitlist: "\u0414\u0430\u043B\u0443\u0447\u044B\u0446\u0435\u0441\u044F \u0434\u0430 \u0447\u0430\u043A\u0430\u043D\u043D\u044F",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      subtitleCombined: void 0,
      title: "\u0423\u0432\u0430\u0439\u0441\u0446\u0456",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u041A\u043E\u0434 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      subtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434, \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u044B \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 TOTP-\u0433\u0435\u043D\u0435\u0440\u0430\u0442\u0430\u0440\u0430.",
      title: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u044F \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044F"
    }
  },
  signInEnterPasswordTitle: void 0,
  signUp: {
    continue: {
      actionLink: "\u0423\u0432\u0430\u0439\u0441\u0446\u0456",
      actionText: "\u0423\u0436\u043E \u0451\u0441\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441?",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u0417\u0430\u043F\u043E\u045E\u043D\u0456\u0446\u0435 \u045E\u0441\u0435 \u043F\u0430\u043B\u0456"
    },
    emailCode: {
      formSubtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u0432\u0430\u043C \u043D\u0430 \u043F\u043E\u0448\u0442\u0443",
      formTitle: "\u041A\u043E\u0434 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u0412\u0435\u0440\u044B\u0444\u0456\u043A\u0443\u0439\u0446\u0435 \u0432\u0430\u0448\u0443 \u043F\u043E\u0448\u0442\u0443"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u041A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C, \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 passkey \u0434\u043B\u044F \u045E\u0432\u0430\u0445\u043E\u0434\u0443 \u0430\u0431\u043E \u0440\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u0456.",
        title: "\u041F\u0430\u0434\u043A\u043B\u044E\u0447\u044D\u043D\u043D\u0435 passkey"
      },
      formSubtitle: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0443\u044E \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0443\u044E \u0432\u0430\u043C \u043D\u0430 \u043F\u043E\u0448\u0442\u0443",
      formTitle: "\u0412\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u044F \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430",
      loading: {
        title: "\u0423\u0432\u0430\u0445\u043E\u0434\u0437\u0456\u043C..."
      },
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u041F\u0440\u0430\u0432\u0435\u0440\u0446\u0435 \u0432\u0430\u0448\u0443 \u043F\u043E\u0448\u0442\u0443",
      verified: {
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B \u045E\u0432\u0430\u0445\u043E\u0434"
      },
      verifiedSwitchTab: {
        subtitle: "\u0412\u044F\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u043D\u0430 \u043D\u043E\u0432\u0443\u044E \u0430\u0434\u043A\u0440\u044B\u0442\u0443\u044E \u045E\u043A\u043B\u0430\u0434\u043A\u0443, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C",
        subtitleNewTab: "\u0412\u044F\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u043D\u0430 \u043F\u0430\u043F\u044F\u0440\u044D\u0434\u043D\u044E\u044E \u045E\u043A\u043B\u0430\u0434\u043A\u0443, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C",
        title: "\u041F\u043E\u0448\u0442\u0430 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0432\u0430\u043D\u0430"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "\u042F \u0437\u0433\u0430\u0434\u0436\u0430\u044E\u0441\u044F \u0437 \u043F\u0430\u043B\u0456\u0442\u044B\u043A\u0430\u0439 \u043A\u0430\u043D\u0444\u0456\u0434\u044D\u043D\u0446\u044B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456",
        label__onlyTermsOfService: "\u042F \u0437\u0433\u0430\u0434\u0436\u0430\u044E\u0441\u044F \u0437 \u0443\u043C\u043E\u0432\u0430\u043C\u0456 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u043D\u044F",
        label__termsOfServiceAndPrivacyPolicy: "\u042F \u0437\u0433\u0430\u0434\u0436\u0430\u044E\u0441\u044F \u0437 \u0443\u043C\u043E\u0432\u0430\u043C\u0456 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u043D\u044F \u0456 \u043F\u0430\u043B\u0456\u0442\u044B\u043A\u0430\u0439 \u043A\u0430\u043D\u0444\u0456\u0434\u044D\u043D\u0446\u044B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456"
      },
      continue: {
        subtitle: "\u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0433\u0430\u0434\u0437\u0456\u0446\u0435\u0441\u044F \u0437 \u0443\u043C\u043E\u0432\u0430\u043C\u0456, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.",
        title: "\u041F\u0430\u0433\u0430\u0434\u0437\u0456\u0446\u0446\u0430 \u0437 \u0443\u043C\u043E\u0432\u0430\u043C\u0456 \u0456 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C"
      }
    },
    phoneCode: {
      formSubtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u044B \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u0412\u0430\u0448 \u0442\u044D\u043B\u0435\u0444\u043E\u043D",
      formTitle: "\u0412\u0435\u0440\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u044B \u043A\u043E\u0434",
      resendButton: "\u041F\u0435\u0440\u0430\u0430\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u0412\u0435\u0440\u044B\u0444\u0456\u043A\u0443\u0439\u0446\u0435 \u0412\u0430\u0448 \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430"
    },
    restrictedAccess: {
      actionLink: "\u0417\u0432\u044F\u0436\u044B\u0446\u0435\u0441\u044F \u0437 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0430\u0439",
      actionText: "\u041A\u0430\u043B\u0456 \u045E \u0432\u0430\u0441 \u0451\u0441\u0446\u044C \u043F\u044B\u0442\u0430\u043D\u043D\u0456, \u0437\u0432\u044F\u0440\u0442\u0430\u0439\u0446\u0435\u0441\u044F \u045E \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456.",
      blockButton__emailSupport: "\u0417\u0432\u044F\u0440\u043D\u0443\u0446\u0446\u0430 \u045E \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456 \u043F\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0446\u0435",
      blockButton__joinWaitlist: "\u0414\u0430\u043B\u0443\u0447\u044B\u0446\u0446\u0430 \u0434\u0430 \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u0430\u0433\u0430 \u0441\u043F\u0456\u0441\u0443",
      subtitle: "\u0414\u043E\u0441\u0442\u0443\u043F \u0434\u0430 \u0433\u044D\u0442\u0430\u0433\u0430 \u0440\u0430\u0437\u0434\u0437\u0435\u043B\u0430 \u0430\u0431\u043C\u0435\u0436\u0430\u0432\u0430\u043D\u044B. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0437\u0432\u044F\u0440\u043D\u0456\u0446\u0435\u0441\u044F \u045E \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456 \u0434\u043B\u044F \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u044F \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0456.",
      subtitleWaitlist: "\u0412\u044B \u0437\u043D\u0430\u0445\u043E\u0434\u0437\u0456\u0446\u0435\u0441\u044F \u045E \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u044B\u043C \u0441\u043F\u0456\u0441\u0435. \u041C\u044B \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u0456\u043C \u0432\u0430\u043C, \u043A\u0430\u043B\u0456 \u0441\u0442\u0430\u043D\u0435 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u0430.",
      title: "\u0410\u0431\u043C\u0435\u0436\u0430\u0432\u0430\u043D\u044B \u0434\u043E\u0441\u0442\u0443\u043F"
    },
    start: {
      actionLink: "\u0423\u0432\u0430\u0439\u0441\u0446\u0456",
      actionLink__use_email: "\u0423\u0432\u0430\u0439\u0441\u0446\u0456 \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B",
      actionLink__use_phone: "\u0423\u0432\u0430\u0439\u0441\u0446\u0456 \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
      actionText: "\u0423\u0436\u043E \u0451\u0441\u0446\u044C \u0430\u043A\u0430\u045E\u043D\u0442?",
      subtitle: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      subtitleCombined: '\u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0443 \u045E "{{applicationName}}"',
      title: "\u0421\u0442\u0432\u0430\u0440\u044B\u0446\u0435 \u0412\u0430\u0448 \u0430\u043A\u0430\u045E\u043D\u0442",
      titleCombined: "\u0421\u0442\u0432\u0430\u0440\u044B\u0446\u0435 \u0412\u0430\u0448 \u0430\u043A\u0430\u045E\u043D\u0442"
    }
  },
  socialButtonsBlockButton: "\u041F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "\u0412\u044B \u045E\u0436\u043E \u0437\u2019\u044F\u045E\u043B\u044F\u0435\u0446\u0435\u0441\u044F \u0447\u043B\u0435\u043D\u0430\u043C \u0433\u044D\u0442\u0430\u0439 \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456.",
    captcha_invalid: "\u0420\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u044F \u043D\u0435 \u045E\u0434\u0430\u043B\u0430\u0441\u044F \u0437-\u0437\u0430 \u043F\u0430\u043C\u044B\u043B\u0430\u043A \u0431\u044F\u0441\u043F\u0435\u043A\u0456. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0430\u0431\u043D\u0430\u0432\u0456\u0446\u0435 \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443, \u043A\u0430\u0431 \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0430\u0432\u0430\u0446\u044C \u044F\u0448\u0447\u044D \u0440\u0430\u0437, \u0430\u0431\u043E \u0437\u0432\u044F\u0436\u044B\u0446\u0435\u0441\u044F \u0441\u0430 \u0441\u043B\u0443\u0436\u0431\u0430\u0439 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456 \u0434\u043B\u044F \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u044F \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0456.",
    captcha_unavailable: "\u0420\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u044F \u043D\u0435 \u045E\u0434\u0430\u043B\u0430\u0441\u044F \u0437-\u0437\u0430 \u043F\u0430\u043C\u044B\u043B\u0430\u043A \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0456 \u0431\u043E\u0442\u0430\u045E. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0430\u0431\u043D\u0430\u0432\u0456\u0446\u0435 \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443, \u043A\u0430\u0431 \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0430\u0432\u0430\u0446\u044C \u044F\u0448\u0447\u044D \u0440\u0430\u0437 \u0430\u0431\u043E \u0437\u0432\u044F\u0436\u044B\u0446\u0435\u0441\u044F \u0441\u0430 \u0441\u043B\u0443\u0436\u0431\u0430\u0439 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043A\u0456 \u0434\u043B\u044F \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u044F \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0456.",
    form_code_incorrect: "\u041D\u0435\u0432\u044F\u0434\u043E\u043C\u044B \u043A\u043E\u0434. \u041F\u0435\u0440\u0430\u043A\u0430\u043D\u0430\u0439\u0446\u0435\u0441\u044F, \u0448\u0442\u043E \u0432\u044B \u045E\u0432\u044F\u043B\u0456 \u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u043A\u043E\u0434.",
    form_identifier_exists__email_address: "\u0413\u044D\u0442\u044B \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u045E\u0436\u043E \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0435\u0446\u0446\u0430.",
    form_identifier_exists__phone_number: "\u0413\u044D\u0442\u044B \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430 \u045E\u0436\u043E \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0435\u0446\u0446\u0430.",
    form_identifier_exists__username: "\u0413\u044D\u0442\u0430 \u0456\u043C\u044F \u045E\u0436\u043E \u0437\u0430\u043D\u044F\u0442\u0430.",
    form_identifier_not_found: "\u0406\u0434\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0442\u0430\u0440 \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u044B.",
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u0410\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0431\u044B\u0446\u044C \u0441\u0430\u043F\u0440\u0430\u045E\u0434\u043D\u044B\u043C \u0430\u0434\u0440\u0430\u0441\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B.",
    form_param_format_invalid__phone_number: "\u041D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430 \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0431\u044B\u0446\u044C \u0443 \u0441\u0430\u043F\u0440\u0430\u045E\u0434\u043D\u044B\u043C \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C \u0444\u0430\u0440\u043C\u0430\u0446\u0435",
    form_param_max_length_exceeded__first_name: "\u0406\u043C\u044F \u043D\u0435 \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u043F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u0446\u044C 256 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
    form_param_max_length_exceeded__last_name: "\u041F\u0440\u043E\u0437\u0432\u0456\u0448\u0447\u0430 \u043D\u0435 \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u043F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u0446\u044C 256 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
    form_param_max_length_exceeded__name: "\u0406\u043C\u044F \u043D\u0435 \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u043F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u0446\u044C 256 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
    form_param_nil: "\u0413\u044D\u0442\u0430 \u043F\u043E\u043B\u0435 \u0430\u0431\u0430\u0432\u044F\u0437\u043A\u043E\u0432\u0430\u0435.",
    form_param_value_invalid: "\u041D\u0435\u0432\u044F\u0434\u043E\u043C\u044B \u0430\u0431\u043E \u043D\u0435\u0434\u0430\u043F\u0443\u0448\u0447\u0430\u043B\u044C\u043D\u044B \u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435.",
    form_password_incorrect: "\u041D\u0435\u0432\u0456\u0440\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
    form_password_length_too_short: "\u041F\u0430\u0440\u043E\u043B\u044C \u0437\u0430\u043D\u0430\u0434\u0442\u0430 \u043A\u0430\u0440\u043E\u0442\u043A\u0456.",
    form_password_not_strong_enough: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u0434\u0430\u0441\u0442\u0430\u0442\u043A\u043E\u0432\u0430 \u043D\u0430\u0434\u0437\u0435\u0439\u043D\u044B.",
    form_password_pwned: "\u0413\u044D\u0442\u044B \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u045E \u0443\u0437\u043B\u0430\u043C\u0430\u043D\u044B \u0456 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u044B, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u0456\u043D\u0448\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
    form_password_pwned__sign_in: "\u0413\u044D\u0442\u044B \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u045E \u0443\u0437\u043B\u0430\u043C\u0430\u043D\u044B, \u043A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0430\u0431\u044F\u0440\u044B\u0446\u0435 \u0456\u043D\u0448\u044B.",
    form_password_size_in_bytes_exceeded: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u0435 \u043C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u0430\u043F\u0443\u0448\u0447\u0430\u043B\u044C\u043D\u0430\u0435 \u043A\u043E\u043B\u044C\u043A\u0430\u0441\u0446\u044C \u0431\u0430\u0439\u0442\u0430\u045E, \u0441\u043A\u0430\u0440\u0430\u0446\u0456\u0446\u0435 \u044F\u0433\u043E \u0430\u0431\u043E \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u0435 \u043D\u0435\u043A\u0430\u0442\u043E\u0440\u044B\u044F \u0441\u043F\u0435\u0446\u044B\u044F\u043B\u044C\u043D\u044B\u044F \u0441\u0456\u043C\u0432\u0430\u043B\u044B.",
    form_password_validation_failed: "\u041D\u0435\u0432\u0435\u0440\u0430\u0433\u043E\u0434\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C",
    form_username_invalid_character: "\u0406\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430 \u0437\u043C\u044F\u0448\u0447\u0430\u0435 \u043D\u0435\u0434\u0430\u043F\u0443\u0448\u0447\u0430\u043B\u044C\u043D\u044B\u044F \u0441\u0456\u043C\u0432\u0430\u043B\u044B.",
    form_username_invalid_length: "\u0406\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430 \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u0431\u044B\u0446\u044C \u0430\u0434 3 \u0434\u0430 50 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
    identification_deletion_failed: "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0432\u0430\u0448\u0443 \u0430\u043F\u043E\u0448\u043D\u044E\u044E \u0456\u0434\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044E.",
    not_allowed_access: "\u0412\u044B \u043D\u0435 \u043C\u0430\u0435\u0446\u0435 \u043F\u0440\u0430\u0432\u043E\u045E \u0434\u043E\u0441\u0442\u0443\u043F\u0443.",
    organization_domain_blocked: "\u0414\u0430\u043C\u0435\u043D \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u0437\u0430\u0431\u043B\u0430\u043A\u0430\u0432\u0430\u043D.",
    organization_domain_common: "\u0414\u0430\u043C\u0435\u043D \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u0437\u0432\u044B\u0447\u0430\u0439\u043D\u044B \u0456 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u044B.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "\u041A\u0432\u043E\u0442\u0430 \u045E\u0434\u0437\u0435\u043B\u044C\u043D\u0456\u043A\u0430\u045E \u0430\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u0456 \u043F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u043D\u0430.",
    organization_minimum_permissions_needed: "\u041F\u0430\u0442\u0440\u0430\u0431\u0443\u044E\u0446\u0446\u0430 \u043C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u044B\u044F \u043F\u0440\u0430\u0432\u044B \u0434\u043E\u0441\u0442\u0443\u043F\u0443.",
    passkey_already_exists: "Passkey \u0443\u0436\u043E \u0456\u0441\u043D\u0443\u0435. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0456\u043D\u0448\u044B.",
    passkey_not_supported: "Passkey \u043D\u0435 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0435\u0446\u0446\u0430 \u043D\u0430 \u0433\u044D\u0442\u0430\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435.",
    passkey_pa_not_supported: "Passkey \u0434\u043B\u044F \u0433\u044D\u0442\u0430\u0433\u0430 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u043D\u0435 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0435\u0446\u0446\u0430.",
    passkey_registration_cancelled: "\u0420\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u044F passkey \u0431\u044B\u043B\u0430 \u0430\u0434\u043C\u043E\u045E\u043B\u0435\u043D\u0430.",
    passkey_retrieval_cancelled: "\u0410\u0442\u0440\u044B\u043C\u0430\u043D\u043D\u0435 passkey \u0431\u044B\u043B\u043E \u0430\u0434\u043C\u043E\u045E\u043B\u0435\u043D\u0430.",
    passwordComplexity: {
      maximumLength: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{length}} \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E",
      minimumLength: "{{length}} \u0430\u0431\u043E \u0431\u043E\u043B\u044C\u0448 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E",
      requireLowercase: "\u043B\u0456\u0442\u0430\u0440\u0443 \u045E \u043D\u0456\u0436\u043D\u0456\u043C \u0440\u044D\u0433\u0456\u0441\u0442\u0440\u044B",
      requireNumbers: "\u043B\u0456\u0447\u0431\u0443",
      requireSpecialCharacter: "\u0441\u043F\u0435\u0446\u044B\u044F\u043B\u044C\u043D\u044B \u0441\u0456\u043C\u0432\u0430\u043B",
      requireUppercase: "\u043B\u0456\u0442\u0430\u0440\u0443 \u045E \u0432\u0435\u0440\u0445\u043D\u0456\u043C \u0440\u044D\u0433\u0456\u0441\u0442\u0440\u044B",
      sentencePrefix: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0443\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0446\u044C"
    },
    phone_number_exists: "\u0413\u044D\u0442\u044B \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430 \u045E\u0436\u043E \u0437\u0430\u043D\u044F\u0442\u044B. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u0456\u043D\u0448\u044B.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0430\u0434\u044B\u0445\u043E\u0434\u0437\u0456\u0446\u044C, \u0430\u043B\u0435 \u043C\u043E\u0433 \u0431\u044B \u0431\u044B\u0446\u044C \u043D\u0430\u0434\u0437\u0435\u0439\u043D\u0435\u0439\u0448\u044B\u043C. \u041F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044C \u0431\u043E\u043B\u044C\u0448 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
      goodPassword: "\u0414\u043E\u0431\u0440\u0430\u044F \u043F\u0440\u0430\u0446\u0430. \u0413\u044D\u0442\u0430 \u0432\u044B\u0434\u0430\u0442\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
      notEnough: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u0434\u0430\u0441\u0442\u0430\u0442\u043A\u043E\u0432\u0430 \u043D\u0430\u0434\u0437\u0435\u0439\u043D\u044B.",
      suggestions: {
        allUppercase: "\u0417\u0440\u0430\u0431\u0456\u0446\u0435 \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u043C\u0456 \u043D\u0435\u043A\u0430\u0442\u043E\u0440\u044B\u044F, \u0430\u043B\u0435 \u043D\u0435 \u045E\u0441\u0435 \u043B\u0456\u0442\u0430\u0440\u044B.",
        anotherWord: "\u0414\u0430\u0434\u0430\u0439\u0446\u0435 \u0431\u043E\u043B\u044C\u0448 \u0441\u043B\u043E\u045E, \u044F\u043A\u0456\u044F \u043C\u0435\u043D\u0448 \u0440\u0430\u0441\u043F\u0430\u045E\u0441\u044E\u0434\u0436\u0430\u043D\u044B.",
        associatedYears: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u0433\u0430\u0434\u043E\u045E, \u044F\u043A\u0456\u044F \u0437\u0432\u044F\u0437\u0430\u043D\u044B \u0437 \u0432\u0430\u043C\u0456.",
        capitalization: "\u0417\u0440\u0430\u0431\u0456\u0446\u0435 \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u043C\u0456 \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u0456 \u043F\u0435\u0440\u0448\u0443\u044E \u043B\u0456\u0442\u0430\u0440\u0443",
        dates: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u0434\u0430\u0442 \u0456 \u0433\u0430\u0434\u043E\u045E, \u044F\u043A\u0456\u044F \u0437\u0432\u044F\u0437\u0430\u043D\u044B \u0437 \u0432\u0430\u043C\u0456.",
        l33t: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u043F\u0440\u0430\u0434\u043A\u0430\u0437\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u043C\u0435\u043D \u043B\u0456\u0442\u0430\u0440, \u0442\u0430\u043A\u0456\u0445 \u044F\u043A \xAB@\xBB \u0437\u0430\u043C\u0435\u0441\u0442 \xABa\xBB.",
        longerKeyboardPattern: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0431\u043E\u043B\u044C\u0448 \u0434\u043E\u045E\u0433\u0456\u044F \u0441\u043F\u0430\u043B\u0443\u0447\u044D\u043D\u043D\u0456 \u043A\u043B\u0430\u0432\u0456\u0448 \u0456 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u0440\u0430\u0437\u043E\u045E \u0437\u043C\u044F\u043D\u044F\u0439\u0446\u0435 \u043D\u0430\u043F\u0440\u0430\u043C\u0430\u043A \u0443\u0432\u043E\u0434\u0443.",
        noNeed: "\u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0441\u0442\u0432\u0430\u0440\u0430\u0446\u044C \u043D\u0430\u0434\u0437\u0435\u0439\u043D\u044B\u044F \u043F\u0430\u0440\u043E\u043B\u0456 \u0431\u0435\u0437 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u043D\u044F \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E, \u043B\u0456\u043A\u0430\u045E \u0430\u0431\u043E \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u0445 \u043B\u0456\u0442\u0430\u0440.",
        pwned: "\u041A\u0430\u043B\u0456 \u0432\u044B \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0435\u0446\u0435 \u0433\u044D\u0442\u044B \u043F\u0430\u0440\u043E\u043B\u044C \u0443 \u0456\u043D\u0448\u044B\u043C \u043C\u0435\u0441\u0446\u044B, \u0432\u0430\u043C \u0432\u0430\u0440\u0442\u0430 \u0437\u043C\u044F\u043D\u0456\u0446\u044C \u044F\u0433\u043E.",
        recentYears: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u0430\u043F\u043E\u0448\u043D\u0456\u0445 \u0433\u0430\u0434\u043E\u045E.",
        repeated: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u043F\u0430\u045E\u0442\u0430\u0440\u0430\u043B\u044C\u043D\u044B\u0445 \u0441\u043B\u043E\u045E \u0456 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
        reverseWords: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u0430\u0434\u0432\u0430\u0440\u043E\u0442\u043D\u0430\u0433\u0430 \u043D\u0430\u043F\u0456\u0441\u0430\u043D\u043D\u044F \u0447\u0430\u0441\u0442\u0430 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u043D\u044B\u0445 \u0441\u043B\u043E\u045E.",
        sequences: "\u041F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u0447\u0430\u0441\u0442\u044B\u0445 \u043F\u0430\u0441\u043B\u044F\u0434\u043E\u045E\u043D\u0430\u0441\u0446\u044F\u045E \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
        useWords: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u0441\u043B\u043E\u045E, \u0430\u043B\u0435 \u043F\u0430\u0437\u0431\u044F\u0433\u0430\u0439\u0446\u0435 \u0440\u0430\u0441\u043F\u0430\u045E\u0441\u044E\u0434\u0436\u0430\u043D\u044B\u0445 \u0444\u0440\u0430\u0437."
      },
      warnings: {
        common: "\u0413\u044D\u0442\u0430 \u0440\u0430\u0441\u043F\u0430\u045E\u0441\u044E\u0434\u0436\u0430\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
        commonNames: "\u0420\u0430\u0441\u043F\u0430\u045E\u0441\u044E\u0434\u0436\u0430\u043D\u044B\u044F \u0456\u043C\u0451\u043D\u044B \u0456 \u043F\u0440\u043E\u0437\u0432\u0456\u0448\u0447\u044B \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        dates: "\u0414\u0430\u0442\u044B \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        extendedRepeat: "\u041F\u0430\u045E\u0442\u0430\u0440\u0430\u043B\u044C\u043D\u044B\u044F \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E, \u0442\u0430\u043A\u0456\u044F \u044F\u043A 'abcabcabc', \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        keyPattern: "\u041A\u0430\u0440\u043E\u0442\u043A\u0456\u044F \u0441\u043F\u0430\u043B\u0443\u0447\u044D\u043D\u043D\u0456 \u043A\u043B\u0430\u0432\u0456\u0448 \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        namesByThemselves: "\u0410\u0434\u0437\u0456\u043D\u043A\u0456 \u0456\u043C\u0451\u043D\u044B \u0430\u0431\u043E \u043F\u0440\u043E\u0437\u0432\u0456\u0448\u0447\u044B \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        pwned: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u045E \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u044B \u045E \u0432\u044B\u043D\u0456\u043A\u0443 \u045E\u0446\u0435\u0447\u043A\u0456 \u0434\u0430\u043D\u044B\u0445 \u0443 \u0406\u043D\u0442\u044D\u0440\u043D\u044D\u0446\u0435.",
        recentYears: "\u0410\u043F\u043E\u0448\u043D\u0456\u044F \u0433\u0430\u0434\u044B \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        sequences: "\u0427\u0430\u0441\u0442\u044B\u044F \u043F\u0430\u0441\u043B\u044F\u0434\u043E\u045E\u043D\u0430\u0441\u0446\u0456 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E, \u0442\u0430\u043A\u0456\u0445 \u044F\u043A 'abc', \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        similarToCommon: "\u0413\u044D\u0442\u044B \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0430\u0434\u043E\u0431\u043D\u044B \u043D\u0430 \u0447\u0430\u0441\u0442\u0430 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
        simpleRepeat: "\u041F\u0430\u045E\u0442\u0430\u0440\u0430\u043B\u044C\u043D\u044B\u044F \u0441\u0456\u043C\u0432\u0430\u043B\u044B, \u0442\u0430\u043A\u0456\u044F \u044F\u043A 'aaa', \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        straightRow: "\u041F\u0440\u043E\u0441\u0442\u044B\u044F \u0448\u044D\u0440\u0430\u0433\u0456 \u043A\u043B\u0430\u0432\u0456\u0448 \u043D\u0430 \u043A\u043B\u0430\u0432\u0456\u044F\u0442\u0443\u0440\u044B \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C.",
        topHundred: "\u0413\u044D\u0442\u0430 \u0447\u0430\u0441\u0442\u0430 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
        topTen: "\u0413\u044D\u0442\u0430 \u0432\u0435\u043B\u044C\u043C\u0456 \u0447\u0430\u0441\u0442\u0430 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
        userInputs: "\u041D\u0435 \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u0431\u044B\u0446\u044C \u043D\u0456\u044F\u043A\u0456\u0445 \u0430\u0441\u0430\u0431\u0456\u0441\u0442\u044B\u0445 \u0434\u0430\u0434\u0437\u0435\u043D\u044B\u0445 \u0430\u0431\u043E \u0434\u0430\u0434\u0437\u0435\u043D\u044B\u0445, \u0437\u0432\u044F\u0437\u0430\u043D\u044B\u0445 \u0441\u0430 \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0430\u0439.",
        wordByItself: "\u0410\u0434\u043D\u0430\u043A\u0430\u0432\u044B\u044F \u0441\u043B\u043E\u0432\u044B \u043B\u0451\u0433\u043A\u0430 \u0430\u0434\u0433\u0430\u0434\u0430\u0446\u044C."
      }
    }
  },
  userButton: {
    action__addAccount: "\u0414\u0430\u0434\u0430\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
    action__manageAccount: "\u041A\u0456\u0440\u0430\u0432\u0430\u043D\u043D\u0435 \u045E\u043B\u0456\u043A\u043E\u0432\u044B\u043C \u0437\u0430\u043F\u0456\u0441\u0430\u043C",
    action__signOut: "\u0412\u044B\u0439\u0441\u0446\u0456",
    action__signOutAll: "\u0412\u044B\u0439\u0441\u0446\u0456 \u0437 \u0443\u0441\u0456\u0445 \u0443\u043B\u0456\u043A\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0456\u0441\u0430\u045E"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u0421\u043A\u0430\u043F\u0456\u0440\u0430\u0432\u0430\u043D\u0430!",
      actionLabel__copy: "\u0421\u043A\u0430\u043F\u0456\u0440\u0430\u0432\u0430\u0446\u044C \u0443\u0441\u0451",
      actionLabel__download: "\u0421\u043F\u0430\u043C\u043F\u0430\u0432\u0430\u0446\u044C .txt",
      actionLabel__print: "\u0414\u0440\u0443\u043A\u0430\u0432\u0430\u0446\u044C",
      infoText1: "\u0420\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B \u0431\u0443\u0434\u0443\u0446\u044C \u0443\u043A\u043B\u044E\u0447\u0430\u043D\u044B \u0434\u043B\u044F \u0433\u044D\u0442\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
      infoText2: "\u0417\u0430\u0445\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B \u045E \u0442\u0430\u0439\u043D\u0435 \u0456 \u0437\u0430\u0445\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0456\u0445 \u0443 \u0431\u044F\u0441\u043F\u0435\u0446\u044B. \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0441\u0442\u0432\u0430\u0440\u044B\u0446\u044C \u043D\u043E\u0432\u044B\u044F \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B, \u043A\u0430\u043B\u0456 \u043F\u0430\u0434\u0430\u0437\u0440\u0430\u0435\u0446\u0435, \u0448\u0442\u043E \u044F\u043D\u044B \u0431\u044B\u043B\u0456 \u0441\u043A\u0430\u043C\u043F\u0440\u0430\u043C\u0435\u0442\u0430\u0432\u0430\u043D\u044B\u044F.",
      subtitle__codelist: "\u0417\u0430\u0445\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0456\u0445 \u0443 \u0431\u044F\u0441\u043F\u0435\u0446\u044B \u0456 \u043D\u0435 \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u044F\u0439\u0446\u0435 \u043D\u0456\u043A\u043E\u043C\u0443.",
      successMessage: "\u0420\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B \u045E\u043A\u043B\u044E\u0447\u0430\u043D\u044B. \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u0430\u0434\u0437\u0456\u043D \u0437 \u0433\u044D\u0442\u044B\u0445 \u043A\u043E\u0434\u043E\u045E \u0434\u043B\u044F \u045E\u0432\u0430\u0445\u043E\u0434\u0443 \u045E \u0441\u0432\u043E\u0439 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441, \u043A\u0430\u043B\u0456 \u0432\u044B \u0441\u0442\u0440\u0430\u0446\u0456\u0446\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u0430 \u0441\u0432\u0430\u0439\u0433\u043E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u0433\u0430 \u043F\u0440\u044B\u043B\u0430\u0434\u044B. \u041A\u043E\u0436\u043D\u044B \u043A\u043E\u0434 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u0456 \u0430\u0434\u043D\u043E\u0439\u0447\u044B.",
      successSubtitle: "\u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u0430\u0434\u0437\u0456\u043D \u0437 \u0433\u044D\u0442\u044B\u0445 \u043A\u043E\u0434\u043E\u045E \u0434\u043B\u044F \u045E\u0432\u0430\u0445\u043E\u0434\u0443 \u045E \u0441\u0432\u043E\u0439 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441, \u043A\u0430\u043B\u0456 \u0432\u044B \u0441\u0442\u0440\u0430\u0446\u0456\u0446\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u0430 \u0441\u0432\u0430\u0439\u0433\u043E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u0433\u0430 \u043F\u0440\u044B\u043B\u0430\u0434\u044B.",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B \u043A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F",
      title__codelist: "\u0420\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B \u043A\u043E\u0434\u044B"
    },
    connectedAccountPage: {
      formHint: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043F\u0440\u0430\u0432\u0430\u0439\u0434\u0430\u0440\u0430 \u0434\u043B\u044F \u043F\u0430\u0434\u043A\u043B\u044E\u0447\u044D\u043D\u043D\u044F \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
      formHint__noAccounts: "\u041D\u044F\u043C\u0430 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043F\u0440\u0430\u0432\u0430\u0439\u0434\u0430\u0440\u0430\u045E \u0437\u043D\u0435\u0448\u043D\u0456\u0445 \u0443\u043B\u0456\u043A\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0456\u0441\u0430\u045E.",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0437\u0435 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0437\u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u0433\u044D\u0442\u044B \u043F\u0430\u0434\u043A\u043B\u044E\u0447\u0430\u043D\u044B \u045E\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441, \u0456 \u043B\u044E\u0431\u044B\u044F \u0437\u0430\u043B\u0435\u0436\u043D\u044B\u044F \u0444\u0443\u043D\u043A\u0446\u044B\u0456 \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0431\u0443\u0434\u0443\u0446\u044C \u043F\u0440\u0430\u0446\u0430\u0432\u0430\u0446\u044C.",
        successMessage: "{{connectedAccount}} \u0431\u044B\u045E \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u043F\u0430\u0434\u043A\u043B\u044E\u0447\u0430\u043D\u044B \u045E\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441"
      },
      socialButtonsBlockButton: "\u041F\u0430\u0434\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441 {{provider|titleize}}",
      successMessage: "\u041F\u0440\u0430\u0432\u0430\u0439\u0434\u0430\u0440 \u0431\u044B\u045E \u0434\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u044B \u045E \u0432\u0430\u0448 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u043F\u0430\u0434\u043A\u043B\u044E\u0447\u0430\u043D\u044B \u045E\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441"
    },
    deletePage: {
      actionDescription: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 '\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441' \u043D\u0456\u0436\u044D\u0439, \u043A\u0430\u0431 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C.",
      confirm: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
      messageLine1: "\u0412\u044B \u045E\u043F\u044D\u045E\u043D\u0435\u043D\u044B, \u0448\u0442\u043E \u0445\u043E\u0447\u0430\u0446\u0435 \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0441\u0432\u043E\u0439 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441?",
      messageLine2: "\u0413\u044D\u0442\u0430 \u0434\u0437\u0435\u044F\u043D\u043D\u0435 \u0437'\u044F\u045E\u043B\u044F\u0435\u0446\u0446\u0430 \u0431\u0435\u0441\u0441\u0440\u043E\u0447\u043D\u044B\u043C \u0456 \u043D\u0435\u0430\u0431\u0440\u0430\u0442\u043D\u044B\u043C.",
      title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u041D\u0430 \u0433\u044D\u0442\u044B \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u0431\u0443\u0434\u0437\u0435 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430 \u043B\u0456\u0441\u0442\u0430 \u0437 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u044B\u0439\u043D\u044B\u043C \u043A\u043E\u0434\u0430\u043C.",
        formSubtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u044B\u0439\u043D\u044B \u043A\u043E\u0434, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 {{identifier}}",
        formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u044B\u0439\u043D\u044B \u043A\u043E\u0434",
        resendButton: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u043A\u043E\u0434 \u043F\u0430\u045E\u0442\u043E\u0440\u043D\u0430",
        successMessage: "\u0410\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B {{identifier}} \u0431\u044B\u045E \u0434\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u044B \u045E \u0432\u0430\u0448 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441."
      },
      emailLink: {
        formHint: "\u041D\u0430 \u0433\u044D\u0442\u044B \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B \u0431\u0443\u0434\u0437\u0435 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u044F \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430.",
        formSubtitle: "\u041D\u0430\u0446\u0456\u0441\u043D\u0456\u0446\u0435 \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0443\u044E \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443 \u045E \u043B\u0456\u0441\u044C\u0446\u0435, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B\u043C \u043D\u0430 {{identifier}}",
        formTitle: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u044F \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430",
        resendButton: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0443 \u043F\u0430\u045E\u0442\u043E\u0440\u043D\u0430",
        successMessage: "\u0410\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B {{identifier}} \u0431\u044B\u045E \u0434\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u044B \u045E \u0432\u0430\u0448 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0437\u0435 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0433\u044D\u0442\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0437\u043C\u043E\u0436\u0430\u0446\u0435 \u045E\u0432\u0430\u0445\u043E\u0434\u0437\u0456\u0446\u044C, \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u044E\u0447\u044B \u0433\u044D\u0442\u044B \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B.",
        successMessage: "{{emailAddress}} \u0431\u044B\u045E \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B"
      },
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B",
      verifyTitle: "\u041F\u0440\u0430\u0432\u0435\u0440\u044B\u0446\u044C \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "\u041F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C",
    formButtonPrimary__finish: "\u0413\u0430\u0442\u043E\u0432\u0430",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "\u0417\u0430\u0445\u0430\u0432\u0430\u0446\u044C",
    formButtonReset: "\u0421\u043A\u0430\u0441\u0430\u0432\u0430\u043D\u043D\u0435",
    mfaPage: {
      formHint: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043C\u0435\u0442\u0430\u0434 \u0434\u043B\u044F \u0434\u0430\u0434\u0430\u0432\u0430\u043D\u043D\u044F.",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0443\u044E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044E"
    },
    mfaPhoneCodePage: {
      backButton: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u0446\u044C \u0456\u0441\u043D\u0443\u044E\u0447\u044B \u043D\u0443\u043C\u0430\u0440",
      primaryButton__addPhoneNumber: "\u0414\u0430\u0434\u0430\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0431\u0443\u0434\u0437\u0435 \u0430\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0446\u044C \u043A\u043E\u0434\u044B \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F \u043F\u0440\u044B \u045E\u0432\u0430\u0445\u043E\u0434\u0437\u0435 \u045E \u0441\u0456\u0441\u0442\u044D\u043C\u0443.",
        messageLine2: "\u0412\u0430\u0448\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u044F \u0437\u0430\u043F\u0456\u0441 \u0431\u0443\u0434\u0437\u0435 \u043C\u0435\u043D\u0448 \u0430\u0431\u0430\u0440\u043E\u043D\u0435\u043D\u0430\u0439. \u0412\u044B \u045E\u043F\u044D\u045E\u043D\u0435\u043D\u044B, \u0448\u0442\u043E \u0445\u043E\u0447\u0430\u0446\u0435 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C?",
        successMessage: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u044F \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0430 \u0437 \u043A\u043E\u0434\u0430\u043C \u0437 SMS \u0431\u044B\u043B\u0430 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u0430 \u0434\u043B\u044F {{mfaPhoneCode}}",
        title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0443\u044E \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0443"
      },
      subtitle__availablePhoneNumbers: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0440\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u0456 \u045E \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u0439 \u043F\u0440\u0430\u0432\u0435\u0440\u0446\u044B \u0437 \u043A\u043E\u0434\u0430\u043C \u0437 SMS.",
      subtitle__unavailablePhoneNumbers: "\u041D\u044F\u043C\u0430 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043D\u0443\u043C\u0430\u0440\u043E\u045E \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0440\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0446\u044B\u0456 \u045E \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u0439 \u043F\u0440\u0430\u0432\u0435\u0440\u0446\u044B \u0437 \u043A\u043E\u0434\u0430\u043C \u0437 SMS.",
      successMessage1: "\u041F\u0440\u044B \u045E\u0432\u0430\u0445\u043E\u0434\u0437\u0435 \u0432\u0430\u043C \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430 \u0431\u0443\u0434\u0437\u0435 \u045E\u0432\u0435\u0441\u0446\u0456 \u043A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 \u0433\u044D\u0442\u044B \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430, \u044F\u043A \u0434\u0430\u0434\u0430\u0442\u043A\u043E\u0432\u044B \u043A\u0440\u043E\u043A.",
      successMessage2: "\u0417\u0430\u0445\u0430\u0432\u0430\u0439\u0446\u0435 \u0433\u044D\u0442\u044B\u044F \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B \u0456 \u0437\u0430\u0445\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0456\u0445 \u0443 \u0431\u044F\u0441\u043F\u0435\u0446\u044B. \u041A\u0430\u043B\u0456 \u0432\u044B \u0441\u0442\u0440\u0430\u0446\u0456\u0446\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u0430 \u0441\u0432\u0430\u0439\u0433\u043E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u0433\u0430 \u043F\u0440\u044B\u043B\u0430\u0434\u044B, \u0432\u044B \u0437\u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B \u0434\u043B\u044F \u045E\u0432\u0430\u0445\u043E\u0434\u0443.",
      successTitle: "\u041F\u0440\u0430\u0432\u0435\u0440\u043A\u0430 \u043A\u043E\u0434\u0430 SMS \u0443\u043A\u043B\u044E\u0447\u0430\u043D\u0430",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0443 \u043A\u043E\u0434\u0430\u043C \u0437 SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u0417\u0430\u043C\u0435\u0441\u0442 \u0433\u044D\u0442\u0430\u0433\u0430 \u0430\u0434\u0441\u043A\u0430\u043D\u0456\u0440\u0443\u0439\u0446\u0435 QR-\u043A\u043E\u0434",
        buttonUnableToScan__nonPrimary: "\u041D\u0435 \u045E\u0434\u0430\u0435\u0446\u0446\u0430 \u0430\u0434\u0441\u043A\u0430\u043D\u0430\u0432\u0430\u0446\u044C QR-\u043A\u043E\u0434?",
        infoText__ableToScan: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0446\u0435 \u043D\u043E\u0432\u044B \u043C\u0435\u0442\u0430\u0434 \u0443\u0432\u0430\u0445\u043E\u0434\u0443 \u045E \u0432\u0430\u0448\u044B\u043C \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u043D\u044B\u043C \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0442\u0430\u0440\u044B \u0456 \u0430\u0434\u0441\u043A\u0430\u043D\u0456\u0440\u0443\u0439\u0446\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B QR-\u043A\u043E\u0434, \u043A\u0430\u0431 \u0437\u0432\u044F\u0437\u0430\u0446\u044C \u044F\u0433\u043E \u0437 \u0432\u0430\u0448\u0430\u0439 \u0443\u043B\u0456\u043A\u043E\u0432\u0430\u0439 \u0437\u0430\u043F\u0456\u0441\u044E.",
        infoText__unableToScan: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0446\u0435 \u043D\u043E\u0432\u044B \u043C\u0435\u0442\u0430\u0434 \u0443\u0432\u0430\u0445\u043E\u0434\u0443 \u045E \u0432\u0430\u0448\u044B\u043C \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u043D\u044B\u043C \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0442\u0430\u0440\u044B \u0456 \u0443\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043D\u0456\u0436\u044D\u0439 \u043F\u0440\u0430\u0434\u0441\u0442\u0430\u045E\u043B\u0435\u043D\u044B \u043A\u043B\u044E\u0447.",
        inputLabel__unableToScan1: "\u0423\u043F\u044D\u045E\u043D\u0456\u0446\u0435\u0441\u044F, \u0448\u0442\u043E \u045E\u043A\u043B\u044E\u0447\u0430\u043D\u044B\u044F \u0430\u0434\u0437\u0456\u043D\u043E\u0447\u043D\u044B\u044F \u043F\u0430\u0440\u043E\u043B\u0456 \u043D\u0430 \u0430\u0441\u043D\u043E\u0432\u0435 \u0447\u0430\u0441\u0443, \u0437\u0430\u0442\u044B\u043C \u0437\u0430\u0432\u044F\u0440\u0448\u044B\u0446\u0435 \u0437\u0432\u044F\u0437\u0432\u0430\u043D\u043D\u0435 \u0441\u0432\u0430\u0451\u0439 \u0443\u043B\u0456\u043A\u043E\u0432\u0430\u0439 \u0437\u0430\u043F\u0456\u0441\u044E.",
        inputLabel__unableToScan2: "\u0410\u043A\u0440\u0430\u043C\u044F \u0442\u0430\u0433\u043E, \u043A\u0430\u043B\u0456 \u0432\u0430\u0448\u0430 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u0435 \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0435 URI TOTP, \u0432\u044B \u0442\u0430\u043A\u0441\u0430\u043C\u0430 \u043C\u043E\u0436\u0430\u0446\u0435 \u0441\u043A\u0430\u043F\u0456\u0440\u0430\u0432\u0430\u0446\u044C \u043F\u043E\u045E\u043D\u044B URI."
      },
      removeResource: {
        messageLine1: "\u041A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F \u0437 \u0433\u044D\u0442\u0430\u0433\u0430 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456 \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0441\u043F\u0430\u0442\u0440\u044D\u0431\u0456\u0446\u0446\u0430 \u043F\u0440\u044B \u045E\u0432\u0430\u0445\u043E\u0434\u0437\u0435 \u045E \u0441\u0456\u0441\u0442\u044D\u043C\u0443.",
        messageLine2: "\u0412\u0430\u0448 \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441 \u0431\u0443\u0434\u0437\u0435 \u043C\u0435\u043D\u0448 \u0430\u0431\u0430\u0440\u043E\u043D\u0435\u043D\u044B\u043C. \u0412\u044B \u045E\u043F\u044D\u045E\u043D\u0435\u043D\u044B, \u0448\u0442\u043E \u0445\u043E\u0447\u0430\u0446\u0435 \u043F\u0440\u0430\u0446\u044F\u0433\u043D\u0443\u0446\u044C?",
        successMessage: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u044F \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044F \u043F\u0440\u0430\u0437 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u0435 \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456 \u0431\u044B\u043B\u0430 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u0430.",
        title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0443\u044E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044E"
      },
      successMessage: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u044F \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0430 \u045E \u0446\u044F\u043F\u0435\u0440\u0430\u0448\u043D\u0456 \u0447\u0430\u0441 \u0443\u043A\u043B\u044E\u0447\u0430\u043D\u0430. \u041F\u0440\u044B \u045E\u0432\u0430\u0445\u043E\u0434\u0437\u0435 \u045E \u0441\u0456\u0441\u0442\u044D\u043C\u0443 \u0432\u0430\u043C \u0442\u0440\u044D\u0431\u0430 \u0431\u0443\u0434\u0437\u0435 \u045E\u0432\u0435\u0441\u0446\u0456 \u043A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F \u0437 \u0433\u044D\u0442\u0430\u0433\u0430 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u044F\u043A \u0434\u0430\u0434\u0430\u0442\u043A\u043E\u0432\u044B \u043A\u0440\u043E\u043A.",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u0435 \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      verifySubtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F, \u0441\u0442\u0432\u043E\u0440\u0430\u043D\u044B \u0432\u0430\u0448\u044B\u043C \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u0435\u043C \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456",
      verifyTitle: "\u041A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F"
    },
    mobileButton__menu: "\u041C\u0435\u043D\u044E",
    navbar: {
      account: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C",
      description: "\u041A\u0456\u0440\u0443\u0439\u0446\u0435 \u0456\u043D\u0444\u0430\u0440\u043C\u0430\u0446\u044B\u044F\u0439 \u0430\u0431 \u0432\u0430\u0448\u044B\u043C \u0443\u043B\u0456\u043A\u043E\u0432\u044B\u043C \u0437\u0430\u043F\u0456\u0441\u0435.",
      security: "\u0411\u044F\u0441\u043F\u0435\u043A\u0430",
      title: "\u0423\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "\u0412\u044B \u045E\u043F\u044D\u045E\u043D\u0435\u043D\u044B, \u0448\u0442\u043E \u0445\u043E\u0447\u0430\u0446\u0435 \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u044B passkey?",
        title: "\u0412\u044B\u0434\u0430\u043B\u0435\u043D\u043D\u0435 passkey"
      },
      subtitle__rename: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043D\u043E\u0432\u0430\u0435 \u0456\u043C\u044F \u0434\u043B\u044F passkey.",
      title__rename: "\u041F\u0435\u0440\u0430\u0439\u043C\u0435\u043D\u0430\u0432\u0430\u0446\u044C passkey"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u0420\u044D\u043A\u0430\u043C\u0435\u043D\u0434\u0443\u0435\u0446\u0446\u0430 \u0432\u044B\u0439\u0441\u0446\u0456 \u0437 \u0443\u0441\u0456\u0445 \u0456\u043D\u0448\u044B\u0445 \u043F\u0440\u044B\u043B\u0430\u0434, \u044F\u043A\u0456\u044F \u043C\u0430\u0433\u043B\u0456 \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0446\u044C \u0432\u0430\u0448 \u0441\u0442\u0430\u0440\u044B \u043F\u0430\u0440\u043E\u043B\u044C.",
      readonly: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0430\u043A\u0443\u043B\u044C \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0430\u0434\u0440\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u043D\u044B, \u0431\u043E \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u045E\u0432\u0430\u0439\u0441\u0446\u0456 \u0442\u043E\u043B\u044C\u043A\u0456 \u043F\u0440\u0430\u0437 \u043F\u0440\u0430\u0434\u043F\u0440\u044B\u0435\u043C\u0441\u0442\u0432\u0430\u045E \u0437\u043B\u0443\u0447\u044D\u043D\u043D\u044F.",
      successMessage__set: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0443\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u043D\u044B.",
      successMessage__signOutOfOtherSessions: "\u0423\u0441\u0435 \u0456\u043D\u0448\u044B\u044F \u043F\u0440\u044B\u043B\u0430\u0434\u044B \u0431\u044B\u043B\u0456 \u0432\u044B\u0432\u0435\u0434\u0437\u0435\u043D\u044B \u0437 \u0441\u0456\u0441\u0442\u044D\u043C\u044B.",
      successMessage__update: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u045E \u0430\u0431\u043D\u043E\u045E\u043B\u0435\u043D\u044B.",
      title__set: "\u0423\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      title__update: "\u0417\u043C\u044F\u043D\u0456\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    phoneNumberPage: {
      infoText: "\u041D\u0430 \u0433\u044D\u0442\u044B \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430 \u0431\u0443\u0434\u0437\u0435 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430 \u0442\u044D\u043A\u0441\u0442\u0430\u0432\u0430\u0435 \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u0437 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u044B\u0439\u043D\u0430\u0439 \u0441\u043F\u0430\u0441\u044B\u043B\u043A\u0430\u0439.",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0437\u0435 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0433\u044D\u0442\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0437\u043C\u043E\u0436\u0430\u0446\u0435 \u045E\u0432\u0430\u0439\u0441\u0446\u0456, \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u044E\u0447\u044B \u0433\u044D\u0442\u044B \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430.",
        successMessage: "{{phoneNumber}} \u0431\u044B\u045E \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430"
      },
      successMessage: "{{identifier}} \u0431\u044B\u045E \u0434\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u044B \u0434\u0430 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
      verifySubtitle: "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u043A\u043E\u0434 \u043F\u0430\u0446\u0432\u0435\u0440\u0434\u0436\u0430\u043D\u043D\u044F, \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u044B \u043D\u0430 {{identifier}}",
      verifyTitle: "\u041F\u0440\u0430\u0432\u0435\u0440\u044B\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430"
    },
    profilePage: {
      fileDropAreaHint: "\u0417\u0430\u0433\u0440\u0443\u0437\u0456\u0446\u0435 \u043C\u0430\u043B\u044E\u043D\u0430\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0442\u0430\u0445 JPG, PNG, GIF \u0430\u0431\u043E WEBP \u043F\u0430\u043C\u0435\u0440\u0430\u043C \u043C\u0435\u043D\u0448 \u0437\u0430 10 \u041C\u0411",
      imageFormDestructiveActionSubtitle: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u043C\u0430\u043B\u044E\u043D\u0430\u043A",
      imageFormSubtitle: "\u0417\u0430\u0433\u0440\u0443\u0437\u0456\u0446\u044C \u043C\u0430\u043B\u044E\u043D\u0430\u043A",
      imageFormTitle: "\u041C\u0430\u043B\u044E\u043D\u0430\u043A \u043F\u0440\u043E\u0444\u0456\u043B\u044E",
      readonly: "\u0412\u0430\u0448\u0430 \u0456\u043D\u0444\u0430\u0440\u043C\u0430\u0446\u044B\u044F \u043F\u0440\u043E\u0444\u0456\u043B\u044E \u0431\u044B\u043B\u0430 \u043F\u0440\u0430\u0434\u0441\u0442\u0430\u045E\u043B\u0435\u043D\u0430 \u043F\u0440\u0430\u0434\u043F\u0440\u044B\u0435\u043C\u0441\u0442\u0432\u0430\u043C \u0437\u043B\u0443\u0447\u044D\u043D\u043D\u044F \u0456 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0430\u0434\u0440\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u043D\u0430.",
      successMessage: "\u0412\u0430\u0448 \u043F\u0440\u043E\u0444\u0456\u043B\u044C \u0431\u044B\u045E \u0430\u0431\u043D\u043E\u045E\u043B\u0435\u043D\u044B.",
      title: "\u0410\u0431\u043D\u0430\u0432\u0456\u0446\u044C \u043F\u0440\u043E\u0444\u0456\u043B\u044C"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0412\u044B\u0439\u0441\u0446\u0456 \u0437 \u043F\u0440\u044B\u043B\u0430\u0434\u044B",
        title: "\u0410\u043A\u0442\u044B\u045E\u043D\u044B\u044F \u043F\u0440\u044B\u043B\u0430\u0434\u044B"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u041F\u0430\u0441\u043F\u0440\u0430\u0431\u0430\u0432\u0430\u0446\u044C \u0437\u043D\u043E\u045E",
        actionLabel__reauthorize: "\u0410\u045E\u0442\u0430\u0440\u044B\u0437\u0430\u0432\u0430\u0446\u044C \u0437\u0430\u0440\u0430\u0437",
        destructiveActionTitle: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C",
        primaryButton: "\u041F\u0430\u0434\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
        subtitle__disconnected: "\u0417\u043B\u0443\u0447\u044D\u043D\u043D\u0435 \u0441\u0442\u0440\u0430\u0447\u0430\u043D\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0434\u043A\u043B\u044E\u0447\u044B\u0446\u0446\u0430 \u0437\u043D\u043E\u045E.",
        subtitle__reauthorize: "\u0410\u0431\u043D\u043E\u045E\u043B\u0435\u043D\u044B \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u044B\u044F \u0441\u043A\u043E\u043F\u044B, \u0456 \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0430\u0434\u0447\u0443\u0432\u0430\u0446\u044C \u0430\u0431\u043C\u0435\u0436\u0430\u0432\u0430\u043D\u0443\u044E \u0444\u0443\u043D\u043A\u0446\u044B\u044F\u043D\u0430\u043B\u044C\u043D\u0430\u0441\u0446\u044C. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0430\u0430\u045E\u0442\u0430\u0440\u044B\u0437\u0443\u0439\u0446\u0435 \u0433\u044D\u0442\u0430 \u043F\u0440\u044B\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u0435, \u043A\u0430\u0431 \u043F\u0430\u0437\u0431\u0435\u0433\u043D\u0443\u0446\u044C \u043B\u044E\u0431\u044B\u0445 \u043F\u0440\u0430\u0431\u043B\u0435\u043C.",
        title: "\u041F\u0430\u0434\u043A\u043B\u044E\u0447\u0430\u043D\u044B\u044F \u045E\u043B\u0456\u043A\u043E\u0432\u044B\u044F \u0437\u0430\u043F\u0456\u0441\u044B"
      },
      dangerSection: {
        deleteAccountButton: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0443\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
        title: "\u0412\u044B\u0434\u0430\u043B\u0435\u043D\u043D\u0435 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443"
      },
      emailAddressesSection: {
        destructiveAction: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B",
        detailsAction__nonPrimary: "\u0423\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u0446\u044C \u0443 \u044F\u043A\u0430\u0441\u0446\u0456 \u0430\u0441\u043D\u043E\u045E\u043D\u0430\u0433\u0430",
        detailsAction__primary: "\u0417\u0430\u0432\u044F\u0440\u0448\u044B\u0446\u044C \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0443",
        detailsAction__unverified: "\u0417\u0430\u0432\u044F\u0440\u0448\u044B\u0446\u044C \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0443",
        primaryButton: "\u0414\u0430\u0434\u0430\u0446\u044C \u0430\u0434\u0440\u0430\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B",
        title: "\u0410\u0434\u0440\u0430\u0441\u044B \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u0439 \u043F\u043E\u0448\u0442\u044B"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "\u0423\u043B\u0456\u043A\u043E\u0432\u044B \u0437\u0430\u043F\u0456\u0441",
      headerTitle__security: "\u0411\u044F\u0441\u043F\u0435\u043A\u0430",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u0421\u0433\u0435\u043D\u0435\u0440\u0430\u0432\u0430\u0446\u044C \u043A\u043E\u0434\u044B",
          headerTitle: "\u0420\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B",
          subtitle__regenerate: "\u0410\u0442\u0440\u044B\u043C\u0430\u0435\u0446\u0435 \u043D\u043E\u0432\u044B \u043D\u0430\u0431\u043E\u0440 \u0431\u044F\u0441\u043F\u0435\u0447\u043D\u044B\u0445 \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u0445 \u043A\u043E\u0434\u0430\u045E. \u041F\u0430\u043F\u044F\u0440\u044D\u0434\u043D\u0456\u044F \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B \u0431\u0443\u0434\u0443\u0446\u044C \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0456 \u043D\u0435 \u043C\u043E\u0433\u0443\u0446\u044C \u0431\u044B\u0446\u044C \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u044B.",
          title__regenerate: "\u0421\u0433\u0435\u043D\u0435\u0440\u0430\u0432\u0430\u0446\u044C \u043D\u043E\u0432\u044B\u044F \u0440\u044D\u0437\u0435\u0440\u0432\u043E\u0432\u044B\u044F \u043A\u043E\u0434\u044B"
        },
        phoneCode: {
          actionLabel__setDefault: "\u0423\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u0446\u044C \u043F\u0430 \u0437\u043C\u0430\u045E\u0447\u0430\u043D\u043D\u0456",
          destructiveActionLabel: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430"
        },
        primaryButton: "\u0414\u0430\u0434\u0430\u0446\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0443\u044E \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044E",
        title: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u0430\u0440\u043D\u0430\u044F \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u044F",
        totp: {
          destructiveActionTitle: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C",
          headerTitle: "\u041F\u0440\u044B\u043A\u043B\u0430\u0434\u043D\u043E\u0435 \u0430\u045E\u0442\u044D\u043D\u0442\u044B\u0444\u0456\u043A\u0430\u0446\u044B\u0456"
        }
      },
      passkeysSection: {
        menuAction__destructive: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C passkey",
        menuAction__rename: "\u041F\u0435\u0440\u0430\u0439\u043C\u0435\u043D\u0430\u0432\u0430\u0446\u044C passkey",
        primaryButton: void 0,
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "\u0423\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
        primaryButton__updatePassword: "\u0417\u043C\u044F\u043D\u0456\u0446\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
        title: "\u041F\u0430\u0440\u043E\u043B\u044C"
      },
      phoneNumbersSection: {
        destructiveAction: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
        detailsAction__nonPrimary: "\u0423\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u0446\u044C \u044F\u043A \u0430\u0441\u043D\u043E\u045E\u043D\u044B",
        detailsAction__primary: "\u0417\u0430\u0432\u044F\u0440\u0448\u044B\u0446\u044C \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0443",
        detailsAction__unverified: "\u0417\u0430\u0432\u044F\u0440\u0448\u044B\u0446\u044C \u043F\u0440\u0430\u0432\u0435\u0440\u043A\u0443",
        primaryButton: "\u0414\u0430\u0434\u0430\u0446\u044C \u043D\u0443\u043C\u0430\u0440 \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430",
        title: "\u041D\u0443\u043C\u0430\u0440\u044B \u0442\u044D\u043B\u0435\u0444\u043E\u043D\u0430\u045E"
      },
      profileSection: {
        primaryButton: "\u0410\u0431\u043D\u0430\u0432\u0456\u0446\u044C \u043F\u0440\u043E\u0444\u0456\u043B\u044C",
        title: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C"
      },
      usernameSection: {
        primaryButton__setUsername: "\u0423\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
        primaryButton__updateUsername: "\u0417\u043C\u044F\u043D\u0456\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
        title: "\u0406\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430"
      },
      web3WalletsSection: {
        destructiveAction: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u043A\u0430\u0448\u0430\u043B\u0451\u043A",
        primaryButton: "Web3 \u043A\u0430\u0448\u0430\u043B\u044C\u043A\u0456",
        title: "Web3 \u043A\u0430\u0448\u0430\u043B\u044C\u043A\u0456"
      }
    },
    usernamePage: {
      successMessage: "\u0406\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430 \u0431\u044B\u043B\u043E \u0430\u0431\u043D\u043E\u045E\u043B\u0435\u043D\u0430.",
      title__set: "\u0410\u0431\u043D\u0430\u0432\u0456\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
      title__update: "\u0410\u0431\u043D\u0430\u0432\u0456\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0437\u0435 \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0433\u044D\u0442\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448 \u043D\u0435 \u0437\u043C\u043E\u0436\u0430\u0446\u0435 \u045E\u0432\u0430\u0439\u0441\u0446\u0456, \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u044E\u0447\u044B \u0433\u044D\u0442\u044B web3 \u043A\u0430\u0448\u0430\u043B\u0451\u043A.",
        successMessage: "{{web3Wallet}} \u0431\u044B\u045E \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
        title: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C web3 \u043A\u0430\u0448\u0430\u043B\u0451\u043A"
      },
      subtitle__availableWallets: "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 web3 \u043A\u0430\u0448\u0430\u043B\u0451\u043A \u0434\u043B\u044F \u043F\u0430\u0434\u043A\u043B\u044E\u0447\u044D\u043D\u043D\u044F \u0434\u0430 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
      subtitle__unavailableWallets: "\u041D\u044F\u043C\u0430 \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u0445 web3 \u043A\u0430\u0448\u0430\u043B\u044C\u043A\u043E\u045E.",
      successMessage: "\u041A\u0430\u0448\u0430\u043B\u0451\u043A \u0431\u044B\u045E \u0434\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u044B \u0434\u0430 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443.",
      title: "\u0414\u0430\u0434\u0430\u0446\u044C web3 \u043A\u0430\u0448\u0430\u043B\u0451\u043A",
      web3WalletButtonsBlockButton: "\u041F\u0430\u0434\u043A\u043B\u044E\u0447\u044B\u0446\u044C web3 \u043A\u0430\u0448\u0430\u043B\u0451\u043A"
    }
  },
  waitlist: {
    start: {
      actionLink: "\u0417\u0430\u0440\u044D\u0433\u0456\u0441\u0442\u0440\u0430\u0432\u0430\u0446\u0446\u0430 \u045E \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u044B\u043C \u0441\u043F\u0456\u0441\u0435",
      actionText: "\u0416\u0430\u0434\u0430\u0435\u0446\u0435 \u043F\u0440\u044B\u0454\u0434\u043D\u0430\u0446\u0446\u0430 \u0434\u0430 \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u0430\u0433\u0430 \u0441\u043F\u0456\u0441\u0443?",
      formButton: "\u0414\u0430\u043B\u0443\u0447\u044B\u0446\u0446\u0430 \u0434\u0430 \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u0430\u0433\u0430 \u0441\u043F\u0456\u0441\u0443",
      subtitle: "\u041C\u044B \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u0456\u043C \u0432\u0430\u043C, \u043A\u0430\u043B\u0456 \u043C\u0435\u0441\u0446\u0430 \u0431\u0443\u0434\u0443\u0446\u044C \u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B\u044F.",
      title: "\u0427\u0430\u043A\u0430\u043B\u044C\u043D\u044B \u0441\u043F\u0456\u0441"
    },
    success: {
      message: "\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0431\u044B\u043B\u0430 \u043F\u0430\u0441\u043F\u044F\u0445\u043E\u0432\u0430 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430 \u045E \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u044B \u0441\u043F\u0456\u0441.",
      subtitle: "\u0414\u0437\u044F\u043A\u0443\u0439 \u0437\u0430 \u0432\u0430\u0448\u0430\u0435 \u0442\u0435\u0440\u043F\u043B\u0456\u0432\u0430\u043D\u043D\u0435, \u043C\u044B \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u0456\u043C \u0432\u0430\u043C, \u043A\u0430\u043B\u0456 \u0437\u2019\u044F\u0432\u044F\u0446\u0446\u0430 \u043C\u0435\u0441\u0446\u044B.",
      title: "\u0412\u044B \u045E \u0447\u0430\u043A\u0430\u043B\u044C\u043D\u044B\u043C \u0441\u043F\u0456\u0441\u0435"
    }
  }
};

// src/en-US.ts
var enUS = {
  locale: "en-US",
  backButton: "Back",
  badge__default: "Default",
  badge__otherImpersonatorDevice: "Other impersonator device",
  badge__primary: "Primary",
  badge__requiresAction: "Requires action",
  badge__thisDevice: "This device",
  badge__unverified: "Unverified",
  badge__userDevice: "User device",
  badge__you: "You",
  createOrganization: {
    formButtonSubmit: "Create organization",
    invitePage: {
      formButtonReset: "Skip"
    },
    title: "Create organization"
  },
  dates: {
    lastDay: "Yesterday at {{ date | timeString('en-US') }}",
    next6Days: "{{ date | weekday('en-US','long') }} at {{ date | timeString('en-US') }}",
    nextDay: "Tomorrow at {{ date | timeString('en-US') }}",
    numeric: "{{ date | numeric('en-US') }}",
    previous6Days: "Last {{ date | weekday('en-US','long') }} at {{ date | timeString('en-US') }}",
    sameDay: "Today at {{ date | timeString('en-US') }}"
  },
  dividerText: "or",
  footerActionLink__useAnotherMethod: "Use another method",
  footerPageLink__help: "Help",
  footerPageLink__privacy: "Privacy",
  footerPageLink__terms: "Terms",
  formButtonPrimary: "Continue",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Forgot password?",
  formFieldError__matchingPasswords: "Passwords match.",
  formFieldError__notMatchingPasswords: "Passwords don't match.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "Optional",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: "Enter backup code",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: "Enter your email address",
  formFieldInputPlaceholder__emailAddress_username: "Enter email or username",
  formFieldInputPlaceholder__emailAddresses: "example@email.com, example2@email.com",
  formFieldInputPlaceholder__firstName: "First name",
  formFieldInputPlaceholder__lastName: "Last name",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "you@example.com",
  formFieldInputPlaceholder__organizationName: "Organization name",
  formFieldInputPlaceholder__organizationSlug: "my-org",
  formFieldInputPlaceholder__password: "Enter your password",
  formFieldInputPlaceholder__phoneNumber: "Enter your phone number",
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "Backup code",
  formFieldLabel__confirmDeletion: "Confirmation",
  formFieldLabel__confirmPassword: "Confirm password",
  formFieldLabel__currentPassword: "Current password",
  formFieldLabel__emailAddress: "Email address",
  formFieldLabel__emailAddress_username: "Email address or username",
  formFieldLabel__emailAddresses: "Email addresses",
  formFieldLabel__firstName: "First name",
  formFieldLabel__lastName: "Last name",
  formFieldLabel__newPassword: "New password",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "Name",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Name of passkey",
  formFieldLabel__password: "Password",
  formFieldLabel__phoneNumber: "Phone number",
  formFieldLabel__role: "Role",
  formFieldLabel__signOutOfOtherSessions: "Sign out of all other devices",
  formFieldLabel__username: "Username",
  impersonationFab: {
    action__signOut: "Sign out",
    title: "Signed in as {{identifier}}"
  },
  maintenanceMode: "We are currently undergoing maintenance, but don't worry, it shouldn't take more than a few minutes.",
  membershipRole__admin: "Admin",
  membershipRole__basicMember: "Member",
  membershipRole__guestMember: "Guest",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "The invitations could not be sent. There are already pending invitations for the following email addresses: {{email_addresses}}.",
      formButtonPrimary__continue: "Send invitations",
      selectDropdown__role: "Select role",
      subtitle: "Enter or paste one or more email addresses, separated by spaces or commas.",
      successMessage: "Invitations successfully sent",
      title: "Invite new members"
    },
    membersPage: {
      action__invite: "Invite",
      action__search: "Search",
      activeMembersTab: {
        menuAction__remove: "Remove member",
        tableHeader__actions: "Actions",
        tableHeader__joined: "Joined",
        tableHeader__role: "Role",
        tableHeader__user: "User"
      },
      detailsTitle__emptyRow: "No members to display",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revoke invitation",
        tableHeader__invited: "Invited"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to delete this organization?",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have deleted the organization.",
          title: "Delete organization"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to leave this organization? You will lose access to this organization and its applications.",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have left the organization.",
          title: "Leave organization"
        },
        title: "Danger"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "The organization has been updated.",
      title: "Update profile"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Members",
      profileSection: {
        primaryButton: "Update profile",
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__manageOrganization: "Manage",
    action__suggestionsAccept: "Request to join",
    notSelected: "No organization selected",
    personalWorkspace: "Personal account",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "Next",
  paginationButton__previous: "Previous",
  paginationRowText__displaying: "Displaying",
  paginationRowText__of: "of",
  reverification: {
    alternativeMethods: {
      actionLink: "Get help",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Use a backup code",
      blockButton__passkey: "Use your passkey",
      blockButton__emailCode: "Email code to {{identifier}}",
      blockButton__password: "Continue with your password",
      blockButton__phoneCode: "Send SMS code to {{identifier}}",
      blockButton__totp: "Use your authenticator app",
      getHelp: {
        blockButton__emailSupport: "Email support",
        content: "If you have trouble verifying your account, email us and we will work with you to restore access as soon as possible.",
        title: "Get help"
      },
      subtitle: "Facing issues? You can use any of these methods for verification.",
      title: "Use another method"
    },
    backupCodeMfa: {
      subtitle: "Enter the backup code you received when setting up two-step authentication",
      title: "Enter a backup code"
    },
    passkey: {
      subtitle: "Using your passkey confirms your identity. Your device may ask for your fingerprint, face, or screen lock.",
      title: "Use your passkey",
      blockButton__passkey: "Use your passkey"
    },
    emailCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the code sent to your email to continue",
      title: "Verification required"
    },
    noAvailableMethods: {
      message: "Cannot proceed with verification. No suitable authentication factor is configured",
      subtitle: "An error occurred",
      title: "Cannot verify your account"
    },
    password: {
      actionLink: "Use another method",
      subtitle: "Enter your password to continue",
      title: "Verification required"
    },
    phoneCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the code sent to your phone to continue",
      title: "Verification required"
    },
    phoneCodeMfa: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the code sent to your phone to continue",
      title: "Verification required"
    },
    totpMfa: {
      formTitle: "Verification code",
      subtitle: "Enter the code generated by your authenticator app to continue",
      title: "Verification required"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Get help",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Use a backup code",
      blockButton__emailCode: "Email code to {{identifier}}",
      blockButton__emailLink: "Email link to {{identifier}}",
      blockButton__passkey: "Sign in with your passkey",
      blockButton__password: "Sign in with your password",
      blockButton__phoneCode: "Send SMS code to {{identifier}}",
      blockButton__totp: "Use your authenticator app",
      getHelp: {
        blockButton__emailSupport: "Email support",
        content: "If you have trouble signing into your account, email us and we will work with you to restore access as soon as possible.",
        title: "Get help"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "Use another method"
    },
    backupCodeMfa: {
      subtitle: "Your backup code is the one you got when setting up two-step authentication.",
      title: "Enter a backup code"
    },
    emailCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Check your email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "To continue, open the verification link on the device and browser from which you initiated the sign-in",
        title: "Verification link is invalid for this device"
      },
      expired: {
        subtitle: "Return to the original tab to continue.",
        title: "This verification link has expired"
      },
      failed: {
        subtitle: "Return to the original tab to continue.",
        title: "This verification link is invalid"
      },
      formSubtitle: "Use the verification link sent to your email",
      formTitle: "Verification link",
      loading: {
        subtitle: "You will be redirected soon",
        title: "Signing in..."
      },
      resendButton: "Didn't receive a link? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Check your email",
      unusedTab: {
        title: "You may close this tab"
      },
      verified: {
        subtitle: "You will be redirected soon",
        title: "Successfully signed in"
      },
      verifiedSwitchTab: {
        subtitle: "Return to original tab to continue",
        subtitleNewTab: "Return to the newly opened tab to continue",
        titleNewTab: "Signed in on other tab"
      }
    },
    forgotPassword: {
      formTitle: "Reset password code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email address",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Reset your password",
      label__alternativeMethods: "Or, sign in with another method",
      title: "Forgot Password?"
    },
    noAvailableMethods: {
      message: "Cannot proceed with sign in. There's no available authentication factor.",
      subtitle: "An error occurred",
      title: "Cannot sign in"
    },
    passkey: {
      subtitle: "Using your passkey confirms it's you. Your device may ask for your fingerprint, face or screen lock.",
      title: "Use your passkey"
    },
    password: {
      actionLink: "Use another method",
      subtitle: "Enter the password associated with your account",
      title: "Enter your password"
    },
    passwordPwned: {
      title: "Password compromised"
    },
    phoneCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Check your phone"
    },
    phoneCodeMfa: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "To continue, please enter the verification code sent to your phone",
      title: "Check your phone"
    },
    resetPassword: {
      formButtonPrimary: "Reset Password",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "Your password was successfully changed. Signing you in, please wait a moment.",
      title: "Set new password"
    },
    resetPasswordMfa: {
      detailsLabel: "We need to verify your identity before resetting your password."
    },
    start: {
      actionLink: "Sign up",
      actionLink__join_waitlist: "Join waitlist",
      actionLink__use_email: "Use email",
      actionLink__use_email_username: "Use email or username",
      actionLink__use_passkey: "Use passkey instead",
      actionLink__use_phone: "Use phone",
      actionLink__use_username: "Use username",
      actionText: "Don\u2019t have an account?",
      actionText__join_waitlist: "Want early access?",
      subtitle: "Welcome back! Please sign in to continue",
      subtitleCombined: void 0,
      title: "Sign in to {{applicationName}}",
      titleCombined: "Continue to {{applicationName}}"
    },
    totpMfa: {
      formTitle: "Verification code",
      subtitle: "To continue, please enter the verification code generated by your authenticator app",
      title: "Two-step verification"
    }
  },
  signInEnterPasswordTitle: "Enter your password",
  signUp: {
    continue: {
      actionLink: "Sign in",
      actionText: "Already have an account?",
      subtitle: "Please fill in the remaining details to continue.",
      title: "Fill in missing fields"
    },
    emailCode: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the verification code sent to your email",
      title: "Verify your email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "To continue, open the verification link on the device and browser from which you initiated the sign-up",
        title: "Verification link is invalid for this device"
      },
      formSubtitle: "Use the verification link sent to your email address",
      formTitle: "Verification link",
      loading: {
        title: "Signing up..."
      },
      resendButton: "Didn't receive a link? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Verify your email",
      verified: {
        title: "Successfully signed up"
      },
      verifiedSwitchTab: {
        subtitle: "Return to the newly opened tab to continue",
        subtitleNewTab: "Return to previous tab to continue",
        title: "Successfully verified email"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'I agree to the {{ privacyPolicyLink || link("Privacy Policy") }}',
        label__onlyTermsOfService: 'I agree to the {{ termsOfServiceLink || link("Terms of Service") }}',
        label__termsOfServiceAndPrivacyPolicy: 'I agree to the {{ termsOfServiceLink || link("Terms of Service") }} and {{ privacyPolicyLink || link("Privacy Policy") }}'
      },
      continue: {
        subtitle: "Please read and accept the terms to continue",
        title: "Legal consent"
      }
    },
    phoneCode: {
      formSubtitle: "Enter the verification code sent to your phone number",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the verification code sent to your phone",
      title: "Verify your phone"
    },
    restrictedAccess: {
      actionLink: "Sign in",
      actionText: "Already have an account?",
      blockButton__emailSupport: "Email support",
      blockButton__joinWaitlist: "Join waitlist",
      subtitle: "Sign ups are currently disabled. If you believe you should have access, please contact support.",
      subtitleWaitlist: "Sign ups are currently disabled. To be the first to know when we launch, join the waitlist.",
      title: "Access restricted"
    },
    start: {
      actionLink: "Sign in",
      actionLink__use_email: "Use email instead",
      actionLink__use_phone: "Use phone instead",
      actionText: "Already have an account?",
      subtitle: "Welcome! Please fill in the details to get started.",
      subtitleCombined: "Welcome! Please fill in the details to get started.",
      title: "Create your account",
      titleCombined: "Create your account"
    }
  },
  socialButtonsBlockButton: "Continue with {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} is already a member of the organization.",
    captcha_invalid: "Sign up unsuccessful due to failed security validations. Please refresh the page to try again or reach out to support for more assistance.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "This email address is taken. Please try another.",
    form_identifier_exists__phone_number: "This phone number is taken. Please try another.",
    form_identifier_exists__username: "This username is taken. Please try another.",
    form_identifier_not_found: "No account found with this identifier. Please check and try again.",
    form_param_format_invalid: "The value entered is in an invalid format. Please check and correct it.",
    form_param_format_invalid__email_address: "Email address must be a valid email address.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format.",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: "This field is required and cannot be empty.",
    form_param_value_invalid: "The value entered is invalid. Please correct it.",
    form_password_incorrect: "The password you entered is incorrect. Please try again.",
    form_password_length_too_short: "Your password is too short. It must be at least 8 characters long.",
    form_password_not_strong_enough: "Your password is not strong enough.",
    form_password_pwned: "This password has been found as part of a breach and can not be used, please try another password instead.",
    form_password_pwned__sign_in: "This password has been found as part of a breach and can not be used, please reset your password.",
    form_password_size_in_bytes_exceeded: "Your password has exceeded the maximum number of bytes allowed, please shorten it or remove some special characters.",
    form_password_validation_failed: "Incorrect Password",
    form_username_invalid_character: "Your username contains invalid characters. Please use only letters, numbers, and underscores.",
    form_username_invalid_length: "Your username must be between {{min_length}} and {{max_length}} characters long.",
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: "You do not have permission to access this page. Please contact support if you believe this is an error.",
    organization_domain_blocked: "This is a blocked email provider domain. Please use a different one.",
    organization_domain_common: "This is a common email provider domain. Please use a different one.",
    organization_domain_exists_for_enterprise_connection: "This domain is already used for your organization\u2019s SSO",
    organization_membership_quota_exceeded: "You have reached your limit of organization memberships, including outstanding invitations.",
    organization_minimum_permissions_needed: "There has to be at least one organization member with the minimum required permissions.",
    passkey_already_exists: "A passkey is already registered with this device.",
    passkey_not_supported: "Passkeys are not supported on this device.",
    passkey_pa_not_supported: "Registration requires a platform authenticator but the device does not support it.",
    passkey_registration_cancelled: "Passkey registration was cancelled or timed out.",
    passkey_retrieval_cancelled: "Passkey verification was cancelled or timed out.",
    passwordComplexity: {
      maximumLength: "less than {{length}} characters",
      minimumLength: "{{length}} or more characters",
      requireLowercase: "a lowercase letter",
      requireNumbers: "a number",
      requireSpecialCharacter: "a special character",
      requireUppercase: "an uppercase letter",
      sentencePrefix: "Your password must contain"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: "A Web3 Wallet extension cannot be found. Please install one to continue.",
    zxcvbn: {
      couldBeStronger: "Your password works, but could be stronger. Try adding more characters.",
      goodPassword: "Your password meets all the necessary requirements.",
      notEnough: "Your password is not strong enough.",
      suggestions: {
        allUppercase: "Capitalize some, but not all letters.",
        anotherWord: "Add more words that are less common.",
        associatedYears: "Avoid years that are associated with you.",
        capitalization: "Capitalize more than the first letter.",
        dates: "Avoid dates and years that are associated with you.",
        l33t: "Avoid predictable letter substitutions like '@' for 'a'.",
        longerKeyboardPattern: "Use longer keyboard patterns and change typing direction multiple times.",
        noNeed: "You can create strong passwords without using symbols, numbers, or uppercase letters.",
        pwned: "If you use this password elsewhere, you should change it.",
        recentYears: "Avoid recent years.",
        repeated: "Avoid repeated words and characters.",
        reverseWords: "Avoid reversed spellings of common words.",
        sequences: "Avoid common character sequences.",
        useWords: "Use multiple words, but avoid common phrases."
      },
      warnings: {
        common: "This is a commonly used password.",
        commonNames: "Common names and surnames are easy to guess.",
        dates: "Dates are easy to guess.",
        extendedRepeat: 'Repeated character patterns like "abcabcabc" are easy to guess.',
        keyPattern: "Short keyboard patterns are easy to guess.",
        namesByThemselves: "Single names or surnames are easy to guess.",
        pwned: "Your password was exposed by a data breach on the Internet.",
        recentYears: "Recent years are easy to guess.",
        sequences: 'Common character sequences like "abc" are easy to guess.',
        similarToCommon: "This is similar to a commonly used password.",
        simpleRepeat: 'Repeated characters like "aaa" are easy to guess.',
        straightRow: "Straight rows of keys on your keyboard are easy to guess.",
        topHundred: "This is a frequently used password.",
        topTen: "This is a heavily used password.",
        userInputs: "There should not be any personal or page related data.",
        wordByItself: "Single words are easy to guess."
      }
    }
  },
  userButton: {
    action__addAccount: "Add account",
    action__manageAccount: "Manage account",
    action__signOut: "Sign out",
    action__signOutAll: "Sign out of all accounts"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copied!",
      actionLabel__copy: "Copy all",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Print",
      infoText1: "Backup codes will be enabled for this account.",
      infoText2: "Keep the backup codes secret and store them securely. You may regenerate backup codes if you suspect they have been compromised.",
      subtitle__codelist: "Store them securely and keep them secret.",
      successMessage: "Backup codes are now enabled. You can use one of these to sign in to your account, if you lose access to your authentication device. Each code can only be used once.",
      successSubtitle: "You can use one of these to sign in to your account, if you lose access to your authentication device.",
      title: "Add backup code verification",
      title__codelist: "Backup codes"
    },
    connectedAccountPage: {
      formHint: "Select a provider to connect your account.",
      formHint__noAccounts: "There are no available external account providers.",
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to use this connected account and any dependent features will no longer work.",
        successMessage: "{{connectedAccount}} has been removed from your account.",
        title: "Remove connected account"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "The provider has been added to your account",
      title: "Add connected account"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "Delete account",
      messageLine1: "Are you sure you want to delete your account?",
      messageLine2: "This action is permanent and irreversible.",
      title: "Delete account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "An email containing a verification code will be sent to this email address.",
        formSubtitle: "Enter the verification code sent to {{identifier}}",
        formTitle: "Verification code",
        resendButton: "Didn't receive a code? Resend",
        successMessage: "The email {{identifier}} has been added to your account."
      },
      emailLink: {
        formHint: "An email containing a verification link will be sent to this email address.",
        formSubtitle: "Click on the verification link in the email sent to {{identifier}}",
        formTitle: "Verification link",
        resendButton: "Didn't receive a link? Resend",
        successMessage: "The email {{identifier}} has been added to your account."
      },
      enterpriseSSOLink: {
        formButton: "Click to sign-in",
        formSubtitle: "Complete the sign-in with {{identifier}}"
      },
      formHint: "You'll need to verify this email address before it can be added to your account.",
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to sign in using this email address.",
        successMessage: "{{emailAddress}} has been removed from your account.",
        title: "Remove email address"
      },
      title: "Add email address",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Continue",
    formButtonPrimary__finish: "Finish",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "Cancel",
    mfaPage: {
      formHint: "Select a method to add.",
      title: "Add two-step verification"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "Add phone number",
      removeResource: {
        messageLine1: "{{identifier}} will be no longer receiving verification codes when signing in.",
        messageLine2: "Your account may not be as secure. Are you sure you want to continue?",
        successMessage: "SMS code two-step verification has been removed for {{mfaPhoneCode}}",
        title: "Remove two-step verification"
      },
      subtitle__availablePhoneNumbers: "Select an existing phone number to register for SMS code two-step verification or add a new one.",
      subtitle__unavailablePhoneNumbers: "There are no available phone numbers to register for SMS code two-step verification, please add a new one.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "Add SMS code verification"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scan QR code instead",
        buttonUnableToScan__nonPrimary: "Can\u2019t scan QR code?",
        infoText__ableToScan: "Set up a new sign-in method in your authenticator app and scan the following QR code to link it to your account.",
        infoText__unableToScan: "Set up a new sign-in method in your authenticator and enter the Key provided below.",
        inputLabel__unableToScan1: "Make sure Time-based or One-time passwords is enabled, then finish linking your account.",
        inputLabel__unableToScan2: "Alternatively, if your authenticator supports TOTP URIs, you can also copy the full URI."
      },
      removeResource: {
        messageLine1: "Verification codes from this authenticator will no longer be required when signing in.",
        messageLine2: "Your account may not be as secure. Are you sure you want to continue?",
        successMessage: "Two-step verification via authenticator application has been removed.",
        title: "Remove two-step verification"
      },
      successMessage: "Two-step verification is now enabled. When signing in, you will need to enter a verification code from this authenticator as an additional step.",
      title: "Add authenticator application",
      verifySubtitle: "Enter verification code generated by your authenticator",
      verifyTitle: "Verification code"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} will be removed from this account.",
        title: "Remove passkey"
      },
      subtitle__rename: "You can change the passkey name to make it easier to find.",
      title__rename: "Rename Passkey"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "Your password has been set.",
      successMessage__signOutOfOtherSessions: "All other devices have been signed out.",
      successMessage__update: "Your password has been updated.",
      title__set: "Set password",
      title__update: "Update password"
    },
    phoneNumberPage: {
      infoText: "A text message containing a verification code will be sent to this phone number. Message and data rates may apply.",
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to sign in using this phone number.",
        successMessage: "{{phoneNumber}} has been removed from your account.",
        title: "Remove phone number"
      },
      successMessage: "{{identifier}} has been added to your account.",
      title: "Add phone number",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "Recommended size 1:1, up to 10MB.",
      imageFormDestructiveActionSubtitle: "Remove",
      imageFormSubtitle: "Upload",
      imageFormTitle: "Profile image",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "Your profile has been updated.",
      title: "Update profile"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Sign out of device",
        title: "Active devices"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Reconnect",
        actionLabel__reauthorize: "Authorize now",
        destructiveActionTitle: "Remove",
        primaryButton: "Connect account",
        subtitle__disconnected: "This account has been disconnected.",
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "Connected accounts"
      },
      dangerSection: {
        deleteAccountButton: "Delete account",
        title: "Delete account"
      },
      emailAddressesSection: {
        destructiveAction: "Remove email",
        detailsAction__nonPrimary: "Set as primary",
        detailsAction__primary: "Complete verification",
        detailsAction__unverified: "Verify",
        primaryButton: "Add email address",
        title: "Email addresses"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "Profile details",
      headerTitle__security: "Security",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenerate",
          headerTitle: "Backup codes",
          subtitle__regenerate: "Get a fresh set of secure backup codes. Prior backup codes will be deleted and cannot be used.",
          title__regenerate: "Regenerate backup codes"
        },
        phoneCode: {
          actionLabel__setDefault: "Set as default",
          destructiveActionLabel: "Remove"
        },
        primaryButton: "Add two-step verification",
        title: "Two-step verification",
        totp: {
          destructiveActionTitle: "Remove",
          headerTitle: "Authenticator application"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Remove",
        menuAction__rename: "Rename",
        primaryButton: "Add a passkey",
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "Set password",
        primaryButton__updatePassword: "Update password",
        title: "Password"
      },
      phoneNumbersSection: {
        destructiveAction: "Remove phone number",
        detailsAction__nonPrimary: "Set as primary",
        detailsAction__primary: "Complete verification",
        detailsAction__unverified: "Verify phone number",
        primaryButton: "Add phone number",
        title: "Phone numbers"
      },
      profileSection: {
        primaryButton: "Update profile",
        title: "Profile"
      },
      usernameSection: {
        primaryButton__setUsername: "Set username",
        primaryButton__updateUsername: "Update username",
        title: "Username"
      },
      web3WalletsSection: {
        destructiveAction: "Remove wallet",
        primaryButton: "Connect wallet",
        title: "Web3 wallets"
      }
    },
    usernamePage: {
      successMessage: "Your username has been updated.",
      title__set: "Set username",
      title__update: "Update username"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to sign in using this web3 wallet.",
        successMessage: "{{web3Wallet}} has been removed from your account.",
        title: "Remove web3 wallet"
      },
      subtitle__availableWallets: "Select a web3 wallet to connect to your account.",
      subtitle__unavailableWallets: "There are no available web3 wallets.",
      successMessage: "The wallet has been added to your account.",
      title: "Add web3 wallet",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: "Sign in",
      actionText: "Already have access?",
      formButton: "Join the waitlist",
      subtitle: "Enter your email address and we\u2019ll let you know when your spot is ready",
      title: "Join the waitlist"
    },
    success: {
      message: "You will be redirected soon...",
      subtitle: "We\u2019ll be in touch when your spot is ready",
      title: "Thanks for joining the waitlist!"
    }
  }
};

// src/en-GB.ts
var enGB = {
  locale: "en-GB",
  backButton: "Back",
  badge__default: "Default",
  badge__otherImpersonatorDevice: "Other impersonator device",
  badge__primary: "Primary",
  badge__requiresAction: "Requires action",
  badge__thisDevice: "This device",
  badge__unverified: "Unverified",
  badge__userDevice: "User device",
  badge__you: "You",
  createOrganization: {
    formButtonSubmit: "Create organisation",
    invitePage: {
      formButtonReset: "Skip"
    },
    title: "Create organisation"
  },
  dates: {
    lastDay: "Yesterday at {{ date | timeString('en-GB') }}",
    next6Days: "{{ date | weekday('en-GB','long') }} at {{ date | timeString('en-GB') }}",
    nextDay: "Tomorrow at {{ date | timeString('en-GB') }}",
    numeric: "{{ date | numeric('en-GB') }}",
    previous6Days: "Last {{ date | weekday('en-GB','long') }} at {{ date | timeString('en-GB') }}",
    sameDay: "Today at {{ date | timeString('en-GB') }}"
  },
  dividerText: "or",
  footerActionLink__useAnotherMethod: "Use another method",
  footerPageLink__help: "Help",
  footerPageLink__privacy: "Privacy",
  footerPageLink__terms: "Terms",
  formButtonPrimary: "Continue",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Forgot password?",
  formFieldError__matchingPasswords: "Passwords match.",
  formFieldError__notMatchingPasswords: "Passwords don't match.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "Optional",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: "Enter backup code",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Confirm account deletion",
  formFieldInputPlaceholder__emailAddress: "Enter your email address",
  formFieldInputPlaceholder__emailAddress_username: "Enter email or username",
  formFieldInputPlaceholder__emailAddresses: "example@email.com, example2@email.com",
  formFieldInputPlaceholder__firstName: "First name",
  formFieldInputPlaceholder__lastName: "Last name",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "you@example.com",
  formFieldInputPlaceholder__organizationName: "Organisation name",
  formFieldInputPlaceholder__organizationSlug: "my-org",
  formFieldInputPlaceholder__password: "Enter your password",
  formFieldInputPlaceholder__phoneNumber: "Enter your phone number",
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "Backup code",
  formFieldLabel__confirmDeletion: "Confirmation",
  formFieldLabel__confirmPassword: "Confirm password",
  formFieldLabel__currentPassword: "Current password",
  formFieldLabel__emailAddress: "Email address",
  formFieldLabel__emailAddress_username: "Email address or username",
  formFieldLabel__emailAddresses: "Email addresses",
  formFieldLabel__firstName: "First name",
  formFieldLabel__lastName: "Last name",
  formFieldLabel__newPassword: "New password",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "Name",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Name of passkey",
  formFieldLabel__password: "Password",
  formFieldLabel__phoneNumber: "Phone number",
  formFieldLabel__role: "Role",
  formFieldLabel__signOutOfOtherSessions: "Sign out of all other devices",
  formFieldLabel__username: "Username",
  impersonationFab: {
    action__signOut: "Sign out",
    title: "Signed in as {{identifier}}"
  },
  maintenanceMode: "We are currently undergoing maintenance, but don't worry, it shouldn't take more than a few minutes.",
  membershipRole__admin: "Admin",
  membershipRole__basicMember: "Member",
  membershipRole__guestMember: "Guest",
  organizationList: {
    action__createOrganization: "Create organisation",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organisation",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organisation"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organisation automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "The invitations could not be sent. There are already pending invitations for the following email addresses: {{email_addresses}}.",
      formButtonPrimary__continue: "Send invitations",
      selectDropdown__role: "Select role",
      subtitle: "Enter or paste one or more email addresses, separated by spaces or commas.",
      successMessage: "Invitations successfully sent",
      title: "Invite new members"
    },
    membersPage: {
      action__invite: "Invite",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Remove member",
        tableHeader__actions: "Actions",
        tableHeader__joined: "Joined",
        tableHeader__role: "Role",
        tableHeader__user: "User"
      },
      detailsTitle__emptyRow: "No members to display",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organisation. Anyone who signs up with a matching email domain will be able to join the organisation anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revoke invitation",
        tableHeader__invited: "Invited"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organisation.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organisation.",
      general: "General",
      members: "Members",
      title: "Organisation"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to delete this organisation?",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have deleted the organisation.",
          title: "Delete organisation"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to leave this organisation? You will lose access to this organisation and its applications.",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have left the organisation.",
          title: "Leave organisation"
        },
        title: "Danger"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organisation automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "The organisation has been updated.",
      title: "Update profile"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organisation automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Members",
      profileSection: {
        primaryButton: "Update profile",
        title: "Organisation Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organisation when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organisation.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organisation.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organisation."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Create organisation",
    action__invitationAccept: "Join",
    action__manageOrganization: "Manage",
    action__suggestionsAccept: "Request to join",
    notSelected: "No organisation selected",
    personalWorkspace: "Personal account",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "Next",
  paginationButton__previous: "Previous",
  paginationRowText__displaying: "Displaying",
  paginationRowText__of: "of",
  reverification: {
    alternativeMethods: {
      actionLink: "Get help",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Use a backup code",
      blockButton__emailCode: "Email code to {{identifier}}",
      blockButton__password: "Continue with your password",
      blockButton__phoneCode: "Send SMS code to {{identifier}}",
      blockButton__totp: "Use your authenticator app",
      getHelp: {
        blockButton__emailSupport: "Email support",
        content: "If you have trouble verifying your account, email us and we will work with you to restore access as soon as possible.",
        title: "Get help"
      },
      subtitle: "Facing issues? You can use any of these methods for verification.",
      title: "Use another method"
    },
    backupCodeMfa: {
      subtitle: "Enter the backup code you received when setting up two-step authentication",
      title: "Enter a backup code"
    },
    emailCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the code sent to your email to continue",
      title: "Verification required"
    },
    noAvailableMethods: {
      message: "Cannot proceed with verification. No suitable authentication factor is configured",
      subtitle: "An error occurred",
      title: "Cannot verify your account"
    },
    password: {
      actionLink: "Use another method",
      subtitle: "Enter your password to continue",
      title: "Verification required"
    },
    phoneCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the code sent to your phone to continue",
      title: "Verification required"
    },
    phoneCodeMfa: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the code sent to your phone to continue",
      title: "Verification required"
    },
    totpMfa: {
      formTitle: "Verification code",
      subtitle: "Enter the code generated by your authenticator app to continue",
      title: "Verification required"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Get help",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Use a backup code",
      blockButton__emailCode: "Email code to {{identifier}}",
      blockButton__emailLink: "Email link to {{identifier}}",
      blockButton__passkey: "Sign in with your passkey",
      blockButton__password: "Sign in with your password",
      blockButton__phoneCode: "Send SMS code to {{identifier}}",
      blockButton__totp: "Use your authenticator app",
      getHelp: {
        blockButton__emailSupport: "Email support",
        content: "If you have trouble signing into your account, email us and we will work with you to restore access as soon as possible.",
        title: "Get help"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "Use another method"
    },
    backupCodeMfa: {
      subtitle: "Your backup code is the one you got when setting up two-step authentication.",
      title: "Enter a backup code"
    },
    emailCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Check your email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "To continue, open the verification link on the device and browser from which you initiated the sign-in",
        title: "Verification link is invalid for this device"
      },
      expired: {
        subtitle: "Return to the original tab to continue.",
        title: "This verification link has expired"
      },
      failed: {
        subtitle: "Return to the original tab to continue.",
        title: "This verification link is invalid"
      },
      formSubtitle: "Use the verification link sent to your email",
      formTitle: "Verification link",
      loading: {
        subtitle: "You will be redirected soon",
        title: "Signing in..."
      },
      resendButton: "Didn't receive a link? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Check your email",
      unusedTab: {
        title: "You may close this tab"
      },
      verified: {
        subtitle: "You will be redirected soon",
        title: "Successfully signed in"
      },
      verifiedSwitchTab: {
        subtitle: "Return to original tab to continue",
        subtitleNewTab: "Return to the newly opened tab to continue",
        titleNewTab: "Signed in on other tab"
      }
    },
    forgotPassword: {
      formTitle: "Reset password code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email address",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Reset your password",
      label__alternativeMethods: "Or, sign in with another method",
      title: "Forgot Password?"
    },
    noAvailableMethods: {
      message: "Cannot proceed with sign in. There's no available authentication factor.",
      subtitle: "An error occurred",
      title: "Cannot sign in"
    },
    passkey: {
      subtitle: "Using your passkey confirms it's you. Your device may ask for your fingerprint, face or screen lock.",
      title: "Use your passkey"
    },
    password: {
      actionLink: "Use another method",
      subtitle: "Enter the password associated with your account",
      title: "Enter your password"
    },
    passwordPwned: {
      title: "Password compromised"
    },
    phoneCode: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Check your phone"
    },
    phoneCodeMfa: {
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "To continue, please enter the verification code sent to your phone",
      title: "Check your phone"
    },
    resetPassword: {
      formButtonPrimary: "Reset Password",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "Your password was successfully changed. Signing you in, please wait a moment.",
      title: "Set new password"
    },
    resetPasswordMfa: {
      detailsLabel: "We need to verify your identity before resetting your password."
    },
    start: {
      actionLink: "Sign up",
      actionLink__join_waitlist: "Join waitlist",
      actionLink__use_email: "Use email",
      actionLink__use_email_username: "Use email or username",
      actionLink__use_passkey: "Use passkey instead",
      actionLink__use_phone: "Use phone",
      actionLink__use_username: "Use username",
      actionText: "Don\u2019t have an account?",
      actionText__join_waitlist: "Want early access?",
      subtitle: "Welcome back! Please sign in to continue",
      subtitleCombined: void 0,
      title: "Sign in to {{applicationName}}",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Verification code",
      subtitle: "To continue, please enter the verification code generated by your authenticator app",
      title: "Two-step verification"
    }
  },
  signInEnterPasswordTitle: "Enter your password",
  signUp: {
    continue: {
      actionLink: "Sign in",
      actionText: "Already have an account?",
      subtitle: "Please fill in the remaining details to continue.",
      title: "Fill in missing fields"
    },
    emailCode: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the verification code sent to your email",
      title: "Verify your email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "To continue, open the verification link on the device and browser from which you initiated the sign-up",
        title: "Verification link is invalid for this device"
      },
      formSubtitle: "Use the verification link sent to your email address",
      formTitle: "Verification link",
      loading: {
        title: "Signing up..."
      },
      resendButton: "Didn't receive a link? Resend",
      subtitle: "to continue to {{applicationName}}",
      title: "Verify your email",
      verified: {
        title: "Successfully signed up"
      },
      verifiedSwitchTab: {
        subtitle: "Return to the newly opened tab to continue",
        subtitleNewTab: "Return to previous tab to continue",
        title: "Successfully verified email"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'I agree to the {{ privacyPolicyLink || link("Privacy Policy") }}',
        label__onlyTermsOfService: 'I agree to the {{ termsOfServiceLink || link("Terms of Service") }}',
        label__termsOfServiceAndPrivacyPolicy: 'I agree to the {{ termsOfServiceLink || link("Terms of Service") }} and {{ privacyPolicyLink || link("Privacy Policy") }}'
      },
      continue: {
        subtitle: "Please read and accept the terms to continue",
        title: "Legal consent"
      }
    },
    phoneCode: {
      formSubtitle: "Enter the verification code sent to your phone number",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "Enter the verification code sent to your phone",
      title: "Verify your phone"
    },
    restrictedAccess: {
      actionLink: "Sign in",
      actionText: "Already have an account?",
      blockButton__emailSupport: "Email support",
      blockButton__joinWaitlist: "Join waitlist",
      subtitle: "Sign ups are currently disabled. If you believe you should have access, please contact support.",
      subtitleWaitlist: "Sign ups are currently disabled. To be the first to know when we launch, join the waitlist.",
      title: "Access restricted"
    },
    start: {
      actionLink: "Sign in",
      actionLink__use_email: "Use email instead",
      actionLink__use_phone: "Use phone instead",
      actionText: "Already have an account?",
      subtitle: "Welcome! Please fill in the details to get started.",
      subtitleCombined: "Welcome! Please fill in the details to get started.",
      title: "Create your account",
      titleCombined: "Create your account"
    }
  },
  socialButtonsBlockButton: "Continue with {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} is already a member of the organisation.",
    captcha_invalid: "Sign up unsuccessful due to failed security validations. Please refresh the page to try again or reach out to support for more assistance.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "This email address is taken. Please try another.",
    form_identifier_exists__phone_number: "This phone number is taken. Please try another.",
    form_identifier_exists__username: "This username is taken. Please try another.",
    form_identifier_not_found: "No account found with this identifier. Please check and try again.",
    form_param_format_invalid: "The value entered is in an invalid format. Please check and correct it.",
    form_param_format_invalid__email_address: "Email address must be a valid email address.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format.",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: "This field is required and cannot be empty.",
    form_param_value_invalid: "The value entered is invalid. Please correct it.",
    form_password_incorrect: "The password you entered is incorrect. Please try again.",
    form_password_length_too_short: "Your password is too short. It must be at least 8 characters long.",
    form_password_not_strong_enough: "Your password is not strong enough.",
    form_password_pwned: "This password has been found as part of a breach and can not be used, please try another password instead.",
    form_password_pwned__sign_in: "This password has been found as part of a breach and can not be used, please reset your password.",
    form_password_size_in_bytes_exceeded: "Your password has exceeded the maximum number of bytes allowed, please shorten it or remove some special characters.",
    form_password_validation_failed: "Incorrect Password",
    form_username_invalid_character: "Your username contains invalid characters. Please use only letters, numbers, and underscores.",
    form_username_invalid_length: "Your username must be between 3 and 20 characters long.",
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: "You do not have permission to access this page. Please contact support if you believe this is an error.",
    organization_domain_blocked: "This is a blocked email provider domain. Please use a different one.",
    organization_domain_common: "This is a common email provider domain. Please use a different one.",
    organization_domain_exists_for_enterprise_connection: "This domain is already used for your organisation\u2019s SSO",
    organization_membership_quota_exceeded: "You have reached your limit of organisation memberships, including outstanding invitations.",
    organization_minimum_permissions_needed: "There has to be at least one organisation member with the minimum required permissions.",
    passkey_already_exists: "A passkey is already registered with this device.",
    passkey_not_supported: "Passkeys are not supported on this device.",
    passkey_pa_not_supported: "Registration requires a platform authenticator but the device does not support it.",
    passkey_registration_cancelled: "Passkey registration was cancelled or timed out.",
    passkey_retrieval_cancelled: "Passkey verification was cancelled or timed out.",
    passwordComplexity: {
      maximumLength: "less than {{length}} characters",
      minimumLength: "{{length}} or more characters",
      requireLowercase: "a lowercase letter",
      requireNumbers: "a number",
      requireSpecialCharacter: "a special character",
      requireUppercase: "an uppercase letter",
      sentencePrefix: "Your password must contain"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Your password works, but could be stronger. Try adding more characters.",
      goodPassword: "Your password meets all the necessary requirements.",
      notEnough: "Your password is not strong enough.",
      suggestions: {
        allUppercase: "Capitalize some, but not all letters.",
        anotherWord: "Add more words that are less common.",
        associatedYears: "Avoid years that are associated with you.",
        capitalization: "Capitalize more than the first letter.",
        dates: "Avoid dates and years that are associated with you.",
        l33t: "Avoid predictable letter substitutions like '@' for 'a'.",
        longerKeyboardPattern: "Use longer keyboard patterns and change typing direction multiple times.",
        noNeed: "You can create strong passwords without using symbols, numbers, or uppercase letters.",
        pwned: "If you use this password elsewhere, you should change it.",
        recentYears: "Avoid recent years.",
        repeated: "Avoid repeated words and characters.",
        reverseWords: "Avoid reversed spellings of common words.",
        sequences: "Avoid common character sequences.",
        useWords: "Use multiple words, but avoid common phrases."
      },
      warnings: {
        common: "This is a commonly used password.",
        commonNames: "Common names and surnames are easy to guess.",
        dates: "Dates are easy to guess.",
        extendedRepeat: 'Repeated character patterns like "abcabcabc" are easy to guess.',
        keyPattern: "Short keyboard patterns are easy to guess.",
        namesByThemselves: "Single names or surnames are easy to guess.",
        pwned: "Your password was exposed by a data breach on the Internet.",
        recentYears: "Recent years are easy to guess.",
        sequences: 'Common character sequences like "abc" are easy to guess.',
        similarToCommon: "This is similar to a commonly used password.",
        simpleRepeat: 'Repeated characters like "aaa" are easy to guess.',
        straightRow: "Straight rows of keys on your keyboard are easy to guess.",
        topHundred: "This is a frequently used password.",
        topTen: "This is a heavily used password.",
        userInputs: "There should not be any personal or page related data.",
        wordByItself: "Single words are easy to guess."
      }
    }
  },
  userButton: {
    action__addAccount: "Add account",
    action__manageAccount: "Manage account",
    action__signOut: "Sign out",
    action__signOutAll: "Sign out of all accounts"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copied!",
      actionLabel__copy: "Copy all",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Print",
      infoText1: "Backup codes will be enabled for this account.",
      infoText2: "Keep the backup codes secret and store them securely. You may regenerate backup codes if you suspect they have been compromised.",
      subtitle__codelist: "Store them securely and keep them secret.",
      successMessage: "Backup codes are now enabled. You can use one of these to sign in to your account, if you lose access to your authentication device. Each code can only be used once.",
      successSubtitle: "You can use one of these to sign in to your account, if you lose access to your authentication device.",
      title: "Add backup code verification",
      title__codelist: "Backup codes"
    },
    connectedAccountPage: {
      formHint: "Select a provider to connect your account.",
      formHint__noAccounts: "There are no available external account providers.",
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to use this connected account and any dependent features will no longer work.",
        successMessage: "{{connectedAccount}} has been removed from your account.",
        title: "Remove connected account"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "The provider has been added to your account",
      title: "Add connected account"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "Delete account",
      messageLine1: "Are you sure you want to delete your account?",
      messageLine2: "This action is permanent and irreversible.",
      title: "Delete account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "An email containing a verification code will be sent to this email address.",
        formSubtitle: "Enter the verification code sent to {{identifier}}",
        formTitle: "Verification code",
        resendButton: "Didn't receive a code? Resend",
        successMessage: "The email {{identifier}} has been added to your account."
      },
      emailLink: {
        formHint: "An email containing a verification link will be sent to this email address.",
        formSubtitle: "Click on the verification link in the email sent to {{identifier}}",
        formTitle: "Verification link",
        resendButton: "Didn't receive a link? Resend",
        successMessage: "The email {{identifier}} has been added to your account."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to sign in using this email address.",
        successMessage: "{{emailAddress}} has been removed from your account.",
        title: "Remove email address"
      },
      title: "Add email address",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Continue",
    formButtonPrimary__finish: "Finish",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "Cancel",
    mfaPage: {
      formHint: "Select a method to add.",
      title: "Add two-step verification"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "Add phone number",
      removeResource: {
        messageLine1: "{{identifier}} will be no longer receiving verification codes when signing in.",
        messageLine2: "Your account may not be as secure. Are you sure you want to continue?",
        successMessage: "SMS code two-step verification has been removed for {{mfaPhoneCode}}",
        title: "Remove two-step verification"
      },
      subtitle__availablePhoneNumbers: "Select an existing phone number to register for SMS code two-step verification or add a new one.",
      subtitle__unavailablePhoneNumbers: "There are no available phone numbers to register for SMS code two-step verification, please add a new one.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "Add SMS code verification"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scan QR code instead",
        buttonUnableToScan__nonPrimary: "Can\u2019t scan QR code?",
        infoText__ableToScan: "Set up a new sign-in method in your authenticator app and scan the following QR code to link it to your account.",
        infoText__unableToScan: "Set up a new sign-in method in your authenticator and enter the Key provided below.",
        inputLabel__unableToScan1: "Make sure Time-based or One-time passwords is enabled, then finish linking your account.",
        inputLabel__unableToScan2: "Alternatively, if your authenticator supports TOTP URIs, you can also copy the full URI."
      },
      removeResource: {
        messageLine1: "Verification codes from this authenticator will no longer be required when signing in.",
        messageLine2: "Your account may not be as secure. Are you sure you want to continue?",
        successMessage: "Two-step verification via authenticator application has been removed.",
        title: "Remove two-step verification"
      },
      successMessage: "Two-step verification is now enabled. When signing in, you will need to enter a verification code from this authenticator as an additional step.",
      title: "Add authenticator application",
      verifySubtitle: "Enter verification code generated by your authenticator",
      verifyTitle: "Verification code"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} will be removed from this account.",
        title: "Remove passkey"
      },
      subtitle__rename: "You can change the passkey name to make it easier to find.",
      title__rename: "Rename Passkey"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "Your password has been set.",
      successMessage__signOutOfOtherSessions: "All other devices have been signed out.",
      successMessage__update: "Your password has been updated.",
      title__set: "Set password",
      title__update: "Update password"
    },
    phoneNumberPage: {
      infoText: "A text message containing a verification code will be sent to this phone number. Message and data rates may apply.",
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to sign in using this phone number.",
        successMessage: "{{phoneNumber}} has been removed from your account.",
        title: "Remove phone number"
      },
      successMessage: "{{identifier}} has been added to your account.",
      title: "Add phone number",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "Recommended size 1:1, up to 10MB.",
      imageFormDestructiveActionSubtitle: "Remove",
      imageFormSubtitle: "Upload",
      imageFormTitle: "Profile image",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "Your profile has been updated.",
      title: "Update profile"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Sign out of device",
        title: "Active devices"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Reconnect",
        actionLabel__reauthorize: "Authorise now",
        destructiveActionTitle: "Remove",
        primaryButton: "Connect account",
        subtitle__disconnected: "This account has been disconnected.",
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorise this application to avoid any issues",
        title: "Connected accounts"
      },
      dangerSection: {
        deleteAccountButton: "Delete account",
        title: "Delete account"
      },
      emailAddressesSection: {
        destructiveAction: "Remove email",
        detailsAction__nonPrimary: "Set as primary",
        detailsAction__primary: "Complete verification",
        detailsAction__unverified: "Verify",
        primaryButton: "Add email address",
        title: "Email addresses"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "Profile details",
      headerTitle__security: "Security",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenerate",
          headerTitle: "Backup codes",
          subtitle__regenerate: "Get a fresh set of secure backup codes. Prior backup codes will be deleted and cannot be used.",
          title__regenerate: "Regenerate backup codes"
        },
        phoneCode: {
          actionLabel__setDefault: "Set as default",
          destructiveActionLabel: "Remove"
        },
        primaryButton: "Add two-step verification",
        title: "Two-step verification",
        totp: {
          destructiveActionTitle: "Remove",
          headerTitle: "Authenticator application"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Remove",
        menuAction__rename: "Rename",
        primaryButton: void 0,
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "Set password",
        primaryButton__updatePassword: "Update password",
        title: "Password"
      },
      phoneNumbersSection: {
        destructiveAction: "Remove phone number",
        detailsAction__nonPrimary: "Set as primary",
        detailsAction__primary: "Complete verification",
        detailsAction__unverified: "Verify phone number",
        primaryButton: "Add phone number",
        title: "Phone numbers"
      },
      profileSection: {
        primaryButton: "Update profile",
        title: "Profile"
      },
      usernameSection: {
        primaryButton__setUsername: "Set username",
        primaryButton__updateUsername: "Update username",
        title: "Username"
      },
      web3WalletsSection: {
        destructiveAction: "Remove wallet",
        primaryButton: "Connect wallet",
        title: "Web3 wallets"
      }
    },
    usernamePage: {
      successMessage: "Your username has been updated.",
      title__set: "Set username",
      title__update: "Update username"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} will be removed from this account.",
        messageLine2: "You will no longer be able to sign in using this web3 wallet.",
        successMessage: "{{web3Wallet}} has been removed from your account.",
        title: "Remove web3 wallet"
      },
      subtitle__availableWallets: "Select a web3 wallet to connect to your account.",
      subtitle__unavailableWallets: "There are no available web3 wallets.",
      successMessage: "The wallet has been added to your account.",
      title: "Add web3 wallet",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: "Sign in",
      actionText: "Already have access?",
      formButton: "Join the waitlist",
      subtitle: "Enter your email address and we\u2019ll let you know when your spot is ready",
      title: "Join the waitlist"
    },
    success: {
      message: "You will be redirected soon...",
      subtitle: "We\u2019ll be in touch when your spot is ready",
      title: "Thanks for joining the waitlist!"
    }
  }
};

// src/fr-FR.ts
var frFR = {
  locale: "fr-FR",
  backButton: "Retour",
  badge__default: "D\xE9faut",
  badge__otherImpersonatorDevice: "Autre dispositif d'imitation",
  badge__primary: "Principal",
  badge__requiresAction: "N\xE9cessite une action",
  badge__thisDevice: "Cet appareil",
  badge__unverified: "Non v\xE9rifi\xE9",
  badge__userDevice: "Appareil utilisateur",
  badge__you: "Vous",
  createOrganization: {
    formButtonSubmit: "Cr\xE9er l\u2019organisation",
    invitePage: {
      formButtonReset: "Passer"
    },
    title: "Cr\xE9er une organisation"
  },
  dates: {
    lastDay: "Hier \xE0 {{ date | timeString('fr-FR') }}",
    next6Days: "{{ date | weekday('fr-FR','long') }} \xE0 {{ date | timeString('fr-FR') }}",
    nextDay: "Demain \xE0 {{ date | timeString('fr-FR') }}",
    numeric: "{{ date | numeric('fr-FR') }}",
    previous6Days: "{{ date | weekday('fr-FR','long') }} dernier \xE0 {{ date | timeString('fr-FR') }}",
    sameDay: "Aujourd'hui \xE0 {{ date | timeString('fr-FR') }}"
  },
  dividerText: "ou",
  footerActionLink__useAnotherMethod: "Utiliser une autre m\xE9thode",
  footerPageLink__help: "Aide",
  footerPageLink__privacy: "Vie priv\xE9e",
  footerPageLink__terms: "Conditions",
  formButtonPrimary: "Continuer",
  formButtonPrimary__verify: "V\xE9rifier",
  formFieldAction__forgotPassword: "Mot de passe oubli\xE9 ?",
  formFieldError__matchingPasswords: "Les mots de passe correspondent.",
  formFieldError__notMatchingPasswords: "Les mots de passe ne correspondent pas.",
  formFieldError__verificationLinkExpired: "Le lien de v\xE9rification a expir\xE9. Merci de demander un nouveau lien.",
  formFieldHintText__optional: "Optionnel",
  formFieldHintText__slug: "Un slug est un identifiant lisible qui doit \xEAtre unique. Il est souvent utilis\xE9 dans les URL.",
  formFieldInputPlaceholder__backupCode: "Code de sauvegarde",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Supprimer le compte",
  formFieldInputPlaceholder__emailAddress: "Adresse e-mail",
  formFieldInputPlaceholder__emailAddress_username: "Nom d'utilisateur ou adresse e-mail",
  formFieldInputPlaceholder__emailAddresses: "Saisissez ou collez une ou plusieurs adresses e-mail, s\xE9par\xE9es par des espaces ou des virgules",
  formFieldInputPlaceholder__firstName: "Pr\xE9nom",
  formFieldInputPlaceholder__lastName: "Nom de famille",
  formFieldInputPlaceholder__organizationDomain: "Domaine de l'organisation",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Adresse e-mail de l'organisation",
  formFieldInputPlaceholder__organizationName: "Nom de l'organisation",
  formFieldInputPlaceholder__organizationSlug: "Identifiant de l'organisation",
  formFieldInputPlaceholder__password: "Mot de passe",
  formFieldInputPlaceholder__phoneNumber: "Num\xE9ro de t\xE9l\xE9phone",
  formFieldInputPlaceholder__username: "Nom d'utilisateur",
  formFieldLabel__automaticInvitations: "Autoriser les invitations automatiques pour ce domaine",
  formFieldLabel__backupCode: "Code de r\xE9cup\xE9ration",
  formFieldLabel__confirmDeletion: "Confirmation",
  formFieldLabel__confirmPassword: "Confirmer le mot de passe",
  formFieldLabel__currentPassword: "Mot de passe actuel",
  formFieldLabel__emailAddress: "Adresse e-mail",
  formFieldLabel__emailAddress_username: "Adresse e-mail ou nom d'utilisateur",
  formFieldLabel__emailAddresses: "Adresses e-mail",
  formFieldLabel__firstName: "Pr\xE9nom",
  formFieldLabel__lastName: "Nom de famille",
  formFieldLabel__newPassword: "Nouveau mot de passe",
  formFieldLabel__organizationDomain: "Domaine",
  formFieldLabel__organizationDomainDeletePending: "Supprimer les invitations et suggestions en attente",
  formFieldLabel__organizationDomainEmailAddress: "E-mail de v\xE9rification",
  formFieldLabel__organizationDomainEmailAddressDescription: "Entrer une adresse e-mail appartenant \xE0 ce domaine pour recevoir un code et v\xE9rifier ce domaine.",
  formFieldLabel__organizationName: "Nom de l'organisation",
  formFieldLabel__organizationSlug: "Slug URL",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "Mot de passe",
  formFieldLabel__phoneNumber: "Num\xE9ro de t\xE9l\xE9phone",
  formFieldLabel__role: "R\xF4le",
  formFieldLabel__signOutOfOtherSessions: "Se d\xE9connecter de tous les autres appareils",
  formFieldLabel__username: "Nom d'utilisateur",
  impersonationFab: {
    action__signOut: "D\xE9connexion",
    title: "Connect\xE9 en tant que {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "Administrateur",
  membershipRole__basicMember: "Membre",
  membershipRole__guestMember: "Invit\xE9",
  organizationList: {
    action__createOrganization: "Cr\xE9er une organisation",
    action__invitationAccept: "Rejoindre",
    action__suggestionsAccept: "Demande d'adh\xE9sion",
    createOrganization: "Cr\xE9er une Organisation",
    invitationAcceptedLabel: "Accept\xE9e",
    subtitle: "pour continuer vers {{applicationName}}",
    suggestionsAcceptedLabel: "En attente d\u2019approbation",
    title: "Choisissez un compte",
    titleWithoutPersonal: "Choisissez une organisation"
  },
  organizationProfile: {
    badge__automaticInvitation: "Invitations automatiques",
    badge__automaticSuggestion: "Suggestions automatiques",
    badge__manualInvitation: "Pas d'inscription automatique",
    badge__unverified: "Non v\xE9rifi\xE9",
    createDomainPage: {
      subtitle: "Ajoutez le domaine pour le v\xE9rifier. Les utilisateurs poss\xE9dant une adresses e-mail sur ce domaine peuvent rejoindre l'organisation automatiquement ou faire une demande pour y adh\xE9rer.",
      title: "Ajouter un domaine"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Les invitations suivantes n\u2019ont pas pu \xEAtre envoy\xE9es. Veuillez r\xE9gler ce probl\xE8me et r\xE9essayer:",
      formButtonPrimary__continue: "Envoyer des invitations",
      selectDropdown__role: "S\xE9lectionner un r\xF4le",
      subtitle: "Inviter des membres \xE0 rejoindre l\u2019organisation",
      successMessage: "Les invitations ont \xE9t\xE9 envoy\xE9es.",
      title: "Inviter des membres"
    },
    membersPage: {
      action__invite: "Inviter",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Supprimer",
        tableHeader__actions: "Actions",
        tableHeader__joined: "Rejoint",
        tableHeader__role: "R\xF4le",
        tableHeader__user: "Utilisateur"
      },
      detailsTitle__emptyRow: "Aucun membre",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invitez des utilisateurs en connectant un domaine de messagerie \xE0 votre organisation. Toute personne s'inscrivant avec une adresses e-mail sur ce domaine pourra rejoindre l'organisation.",
          headerTitle: "Invitations automatiques",
          primaryButton: "G\xE9rer les domaines valid\xE9s"
        },
        table__emptyRow: "Pas d'invitations \xE0 afficher"
      },
      invitedMembersTab: {
        menuAction__revoke: "R\xE9voquer l'invitation",
        tableHeader__invited: "Invit\xE9"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Les utilisateurs qui s'inscrivent avec un domaine de messagerie identique verront une suggestion pour demander \xE0 rejoindre votre organisation.",
          headerTitle: "Suggestions automatiques",
          primaryButton: "G\xE9rer les domaines valid\xE9s"
        },
        menuAction__approve: "Approuver",
        menuAction__reject: "Rejeter",
        tableHeader__requested: "Acc\xE8s demand\xE9",
        table__emptyRow: "Pas de demandes \xE0 afficher"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Membres",
        headerTitle__requests: "Demandes"
      }
    },
    navbar: {
      description: "G\xE9rer votre organisation.",
      general: "G\xE9n\xE9ral",
      members: "Membres",
      title: "Organisation"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "Saisissez {{organizationName}} ci-dessous pour continuer.",
          messageLine1: "\xCAtes-vous s\xFBr(e) de vouloir supprimer cette organisation ?",
          messageLine2: "Cette action est d\xE9finitive et irr\xE9versible.",
          successMessage: "Vous avez supprim\xE9 l'organisation.",
          title: "Supprimer l'organisation"
        },
        leaveOrganization: {
          actionDescription: "Saisissez {{organizationName}} ci-dessous pour continuer.",
          messageLine1: "\xCAtes-vous s\xFBr de vouloir quitter cette organisation ? Vous perdrez l'acc\xE8s \xE0 cette organisation et \xE0 ses applications.",
          messageLine2: "Cette action est permanente et irr\xE9versible.",
          successMessage: "Vous avez quitt\xE9 l'organisation.",
          title: "Quitter l'organisation"
        },
        title: "Danger"
      },
      domainSection: {
        menuAction__manage: "G\xE9rer",
        menuAction__remove: "Supprimer",
        menuAction__verify: "Valider",
        primaryButton: "Ajouter un domaine",
        subtitle: "Permettre aux utilisateurs de rejoindre l'organisation automatiquement ou de faire une demande d'adh\xE9sion si leur domaine de messagerie est v\xE9rifi\xE9.",
        title: "Domaines v\xE9rifi\xE9s"
      },
      successMessage: "L'organisation a \xE9t\xE9 mise \xE0 jour.",
      title: "Profil de l\u2019organisation"
    },
    removeDomainPage: {
      messageLine1: "Le domaine de messagerie {{domain}} sera supprim\xE9.",
      messageLine2: "Les utilisateurs ne pourront plus rejoindre l'organisation automatiquement apr\xE8s cela.",
      successMessage: "{{domain}} a \xE9t\xE9 supprim\xE9.",
      title: "Supprimer un domaine"
    },
    start: {
      headerTitle__general: "G\xE9n\xE9ral",
      headerTitle__members: "Membres",
      profileSection: {
        primaryButton: "Mettre \xE0 jour le profil",
        title: "Profil de l'organisation",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Supprimer ce domaine affectera les utilisateurs invit\xE9s.",
        removeDomainActionLabel__remove: "Supprimer ce domaine",
        removeDomainSubtitle: "Supprimer ce domaine de vos domaines v\xE9rifi\xE9s",
        removeDomainTitle: "Supprimer un domaine"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Les utilisateurs sont automatiquement invit\xE9s \xE0 rejoindre l'organisation lors de leur inscription et peuvent la rejoindre \xE0 tout moment.",
        automaticInvitationOption__label: "Invitations automatiques",
        automaticSuggestionOption__description: "Les utilisateurs re\xE7oivent une suggestion d'adh\xE9sion \xE0 l'organisation, mais doivent \xEAtre approuv\xE9s par un administrateur avant de pouvoir y adh\xE9rer.",
        automaticSuggestionOption__label: "Suggestions automatiques",
        calloutInfoLabel: "Changer le mode d'inscription n'affectera que les nouveaux utilisateurs.",
        calloutInvitationCountLabel: "Invitations en attente envoy\xE9es aux utilisateurs : {{count}}",
        calloutSuggestionCountLabel: "Suggestions en attente envoy\xE9es aux utilisateurs : {{count}}",
        manualInvitationOption__description: "Les utilisateurs ne peuvent \xEAtre invit\xE9s \xE0 l'organisation que manuellement.",
        manualInvitationOption__label: "Pas d'inscription automatique",
        subtitle: "Choisissez comment les utilisateurs de ce domaine peuvent rejoindre l'organisation."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Option d'inscription"
      },
      subtitle: "Le domaine {{domain}} est maintenant v\xE9rifi\xE9. Poursuivez en s\xE9lectionnant le mode d'inscription.",
      title: "Mettre \xE0 jour {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Saisissez le code de v\xE9rification envoy\xE9 \xE0 votre adresse e-mail",
      formTitle: "Code de v\xE9rification",
      resendButton: "Vous n'avez pas re\xE7u de code ? Renvoyer",
      subtitle: "Le domaine {{domainName}} doit \xEAtre v\xE9rifi\xE9 par e-mail.",
      subtitleVerificationCodeScreen: "Un code de v\xE9rification a \xE9t\xE9 envoy\xE9 \xE0 {{emailAddress}}. Saisissez le code pour continuer.",
      title: "V\xE9rifier un domaine"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Cr\xE9er une organisation",
    action__invitationAccept: "Rejoindre",
    action__manageOrganization: "G\xE9rer l'organisation",
    action__suggestionsAccept: "Demander \xE0 rejoindre",
    notSelected: "Aucune organisation s\xE9lectionn\xE9e",
    personalWorkspace: "Espace de travail personnel",
    suggestionsAcceptedLabel: "En attente d'acceptation"
  },
  paginationButton__next: "Prochain",
  paginationButton__previous: "Pr\xE9c\xE9dent",
  paginationRowText__displaying: "Affichage",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: "Utiliser une autre m\xE9thode",
      actionText: "Vous ne pouvez pas acc\xE9der \xE0 votre compte ?",
      blockButton__backupCode: "Utiliser un code de r\xE9cup\xE9ration",
      blockButton__emailCode: "Recevoir un code par e-mail",
      blockButton__password: "Utiliser le mot de passe",
      blockButton__phoneCode: "Recevoir un code par t\xE9l\xE9phone",
      blockButton__totp: "Utiliser un code d\u2019application d\u2019authentification",
      getHelp: {
        blockButton__emailSupport: "Contacter le support par e-mail",
        content: "Si vous ne pouvez pas acc\xE9der \xE0 votre compte, contactez notre \xE9quipe de support pour obtenir de l'aide.",
        title: "Obtenir de l'aide"
      },
      subtitle: "Choisissez une m\xE9thode alternative pour v\xE9rifier votre identit\xE9.",
      title: "V\xE9rification alternative"
    },
    backupCodeMfa: {
      subtitle: "Entrez l'un de vos codes de r\xE9cup\xE9ration pour v\xE9rifier votre compte.",
      title: "V\xE9rification par code de r\xE9cup\xE9ration"
    },
    emailCode: {
      formTitle: "Entrez le code de v\xE9rification",
      resendButton: "Renvoyer le code",
      subtitle: "Un code a \xE9t\xE9 envoy\xE9 \xE0 votre adresse e-mail.",
      title: "V\xE9rification par e-mail"
    },
    noAvailableMethods: {
      message: "Aucune m\xE9thode de v\xE9rification n'est disponible.",
      subtitle: "Impossible de proc\xE9der \xE0 la v\xE9rification.",
      title: "Aucune m\xE9thode disponible"
    },
    password: {
      actionLink: "R\xE9initialiser le mot de passe",
      subtitle: "Entrez votre mot de passe pour continuer.",
      title: "V\xE9rification par mot de passe"
    },
    phoneCode: {
      formTitle: "Entrez le code de v\xE9rification",
      resendButton: "Renvoyer le code",
      subtitle: "Un code a \xE9t\xE9 envoy\xE9 \xE0 votre t\xE9l\xE9phone.",
      title: "V\xE9rification par t\xE9l\xE9phone"
    },
    phoneCodeMfa: {
      formTitle: "Entrez le code de v\xE9rification",
      resendButton: "Renvoyer le code",
      subtitle: "Un code a \xE9t\xE9 envoy\xE9 \xE0 votre t\xE9l\xE9phone pour v\xE9rification.",
      title: "V\xE9rification par t\xE9l\xE9phone"
    },
    totpMfa: {
      formTitle: "Entrez le code de v\xE9rification",
      subtitle: "Entrez le code g\xE9n\xE9r\xE9 par votre application d'authentification.",
      title: "V\xE9rification par application d\u2019authentification"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Ajouter un compte",
      action__signOutAll: "Se d\xE9connecter de tous les comptes",
      subtitle: "S\xE9lectionnez le compte avec lequel vous souhaitez continuer.",
      title: "Choisissez un compte"
    },
    alternativeMethods: {
      actionLink: "Obtenir de l'aide",
      actionText: "Aucune de ces m\xE9thode d'authentification ?",
      blockButton__backupCode: "Utiliser un code de r\xE9cup\xE9ration",
      blockButton__emailCode: "Envoyer le code \xE0 {{identifier}}",
      blockButton__emailLink: "Envoyer le lien \xE0 {{identifier}}",
      blockButton__passkey: "Utiliser une cl\xE9 de s\xE9curit\xE9",
      blockButton__password: "Connectez-vous avec votre mot de passe",
      blockButton__phoneCode: "Envoyer le code \xE0 {{identifier}}",
      blockButton__totp: "Utilisez votre application d'authentification",
      getHelp: {
        blockButton__emailSupport: "Assistance par e-mail",
        content: "Si vous rencontrez des difficult\xE9s pour vous connecter \xE0 votre compte, envoyez-nous un e-mail et nous travaillerons avec vous pour r\xE9tablir l'acc\xE8s d\xE8s que possible.",
        title: "Obtenir de l'aide"
      },
      subtitle: "Vous rencontrez des probl\xE8mes ? Vous pouvez utiliser l'une de ces m\xE9thodes pour vous connecter.",
      title: "Utiliser une autre m\xE9thode"
    },
    backupCodeMfa: {
      subtitle: "pour continuer vers {{applicationName}}",
      title: "Entrez un code de r\xE9cup\xE9ration"
    },
    emailCode: {
      formTitle: "Le code de v\xE9rification",
      resendButton: "Renvoyer le code",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "V\xE9rifiez votre messagerie"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Ce lien ne correspond pas \xE0 la demande en cours.",
        title: "Erreur de correspondance du client"
      },
      expired: {
        subtitle: "Retournez \xE0 l'onglet d'origine pour continuer",
        title: "Ce lien de v\xE9rification a expir\xE9"
      },
      failed: {
        subtitle: "Retourner \xE0 l'onglet original pour continuer",
        title: "Ce lien de v\xE9rification n'est pas valide"
      },
      formSubtitle: "Utilisez le lien de v\xE9rification envoy\xE9 par e-mail",
      formTitle: "lien de v\xE9rification",
      loading: {
        subtitle: "Vous allez bient\xF4t \xEAtre redirig\xE9",
        title: "Signing in..."
      },
      resendButton: "Renvoyer le lien",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "V\xE9rifiez votre messagerie",
      unusedTab: {
        title: "Vous pouvez fermer cet onglet"
      },
      verified: {
        subtitle: "Vous serez bient\xF4t redirig\xE9",
        title: "Connexion r\xE9ussie"
      },
      verifiedSwitchTab: {
        subtitle: "Revenir \xE0 l'onglet d'origine pour continuer",
        subtitleNewTab: "Revenez \xE0 l'onglet nouvellement ouvert pour continuer",
        titleNewTab: "Connect\xE9 sur un autre onglet"
      }
    },
    forgotPassword: {
      formTitle: "Code de r\xE9initialisation du mot de passe",
      resendButton: "Vous n'avez pas re\xE7u de code ? Renvoyer",
      subtitle: "pour r\xE9initialiser votre mot de passe",
      subtitle_email: "Tout d'abord, saisissez le code envoy\xE9 \xE0 votre adresse e-mail.",
      subtitle_phone: "Tout d'abord, saisissez le code envoy\xE9 \xE0 votre t\xE9l\xE9phone.",
      title: "R\xE9initialiser le mot de passe"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "R\xE9initialiser votre mot de passe",
      label__alternativeMethods: "Ou connectez-vous avec une autre m\xE9thode.",
      title: "Mot de passe oubli\xE9 ?"
    },
    noAvailableMethods: {
      message: "Impossible de poursuivre la connexion. Aucun facteur d'authentification n'est disponible.",
      subtitle: "Une erreur s'est produite",
      title: "Impossible de se connecter"
    },
    passkey: {
      subtitle: "Utilisez une cl\xE9 de s\xE9curit\xE9 pour continuer.",
      title: "Cl\xE9 de s\xE9curit\xE9"
    },
    password: {
      actionLink: "Utiliser une autre m\xE9thode",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "Tapez votre mot de passe"
    },
    passwordPwned: {
      title: "Mot de passe compromis"
    },
    phoneCode: {
      formTitle: "Code de v\xE9rification",
      resendButton: "Vous n'avez pas re\xE7u de code ? Renvoyer",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "V\xE9rifiez votre t\xE9l\xE9phone"
    },
    phoneCodeMfa: {
      formTitle: "Code de v\xE9rification",
      resendButton: "Vous n'avez pas re\xE7u de code ? Renvoyer",
      subtitle: "Entrez le code envoy\xE9 \xE0 votre t\xE9l\xE9phone pour continuer.",
      title: "V\xE9rifiez votre t\xE9l\xE9phone"
    },
    resetPassword: {
      formButtonPrimary: "R\xE9initialiser",
      requiredMessage: "Pour des raisons de s\xE9curit\xE9, il est n\xE9cessaire de r\xE9initialiser votre mot de passe.",
      successMessage: "Votre mot de passe a \xE9t\xE9 modifi\xE9 avec succ\xE8s. Nous vous reconnectons, veuillez patienter un instant.",
      title: "R\xE9initialiser le mot de passe"
    },
    resetPasswordMfa: {
      detailsLabel: "Nous devons v\xE9rifier votre identit\xE9 avant de r\xE9initialiser votre mot de passe."
    },
    start: {
      actionLink: "S'inscrire",
      actionLink__join_waitlist: "Rejoindre la liste d'attente",
      actionLink__use_email: "Utiliser e-mail",
      actionLink__use_email_username: "Utiliser l'e-mail ou le nom d'utilisateur",
      actionLink__use_passkey: "Utiliser une cl\xE9 de s\xE9curit\xE9",
      actionLink__use_phone: "Utiliser t\xE9l\xE9phone",
      actionLink__use_username: "Utiliser le nom d'utilisateur",
      actionText: "Vous n'avez pas encore de compte ?",
      actionText__join_waitlist: "Inscrivez-vous sur la liste d'attente",
      subtitle: "pour continuer vers {{applicationName}}",
      subtitleCombined: void 0,
      title: "S'identifier",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Le code de v\xE9rification",
      subtitle: "Entrez le code de l'application d'authentification.",
      title: "V\xE9rification en deux \xE9tapes"
    }
  },
  signInEnterPasswordTitle: "Tapez votre mot de passe",
  signUp: {
    continue: {
      actionLink: "S'identifier",
      actionText: "Vous avez d\xE9j\xE0 un compte ?",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "Remplir les champs manquants"
    },
    emailCode: {
      formSubtitle: "Entrez le code de v\xE9rification envoy\xE9 \xE0 votre adresse e-mail",
      formTitle: "Le code de v\xE9rification",
      resendButton: "Renvoyer le code",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "V\xE9rifiez votre e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Ce lien ne correspond pas \xE0 la demande en cours.",
        title: "Erreur de correspondance du client"
      },
      formSubtitle: "Utilisez le lien de v\xE9rification envoy\xE9 \xE0 votre adresse e-mail",
      formTitle: "lien de v\xE9rification",
      loading: {
        title: "Cr\xE9ation de votre compte..."
      },
      resendButton: "Renvoyer le lien",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "V\xE9rifiez votre e-mail",
      verified: {
        title: "Compte cr\xE9\xE9"
      },
      verifiedSwitchTab: {
        subtitle: "Revenez \xE0 l'onglet nouvellement ouvert pour continuer",
        subtitleNewTab: "Revenir \xE0 l'onglet pr\xE9c\xE9dent pour continuer",
        title: "Courriel v\xE9rifi\xE9 avec succ\xE8s"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "J'accepte la Politique de confidentialit\xE9.",
        label__onlyTermsOfService: "J'accepte les Conditions d'utilisation.",
        label__termsOfServiceAndPrivacyPolicy: "J'accepte les Conditions d'utilisation et la Politique de confidentialit\xE9."
      },
      continue: {
        subtitle: "Lisez et acceptez les conditions pour continuer.",
        title: "Consentement l\xE9gal"
      }
    },
    phoneCode: {
      formSubtitle: "Entrez le code de v\xE9rification envoy\xE9 \xE0 votre num\xE9ro de t\xE9l\xE9phone",
      formTitle: "Le code de v\xE9rification",
      resendButton: "Renvoyer le code",
      subtitle: "pour continuer vers {{applicationName}}",
      title: "V\xE9rifiez votre t\xE9l\xE9phone"
    },
    restrictedAccess: {
      actionLink: "Contacter le support",
      actionText: "Acc\xE8s restreint.",
      blockButton__emailSupport: "Contacter le support par e-mail",
      blockButton__joinWaitlist: "Rejoindre la liste d'attente",
      subtitle: "Vous n'avez pas la permission d'acc\xE9der \xE0 cette page.",
      subtitleWaitlist: "Inscrivez-vous pour demander l'acc\xE8s.",
      title: "Acc\xE8s restreint"
    },
    start: {
      actionLink: "S'identifier",
      actionLink__use_email: "Utiliser votre adresse e-mail",
      actionLink__use_phone: "Utiliser votre t\xE9l\xE9phone",
      actionText: "Vous avez d\xE9j\xE0 un compte ?",
      subtitle: "pour continuer vers {{applicationName}}",
      subtitleCombined: "pour continuer vers {{applicationName}}",
      title: "Cr\xE9ez votre compte",
      titleCombined: "Cr\xE9ez votre compte"
    }
  },
  socialButtonsBlockButton: "Continuer avec {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "Vous \xEAtes d\xE9j\xE0 membre de cette organisation.",
    captcha_invalid: "Inscription \xE9chou\xE9e en raison de validations de s\xE9curit\xE9 incorrectes. Veuillez rafra\xEEchir la page pour r\xE9essayer ou contacter le support pour obtenir de l'aide.",
    captcha_unavailable: "Inscription \xE9chou\xE9e en raison d'une validation de captcha non r\xE9ussie. Veuillez actualiser la page pour r\xE9essayer ou contacter le support pour obtenir de l'aide.",
    form_code_incorrect: "Code incorrect",
    form_identifier_exists__email_address: "Cette adresse e-mail existe d\xE9j\xE0.",
    form_identifier_exists__phone_number: "Ce num\xE9ro de t\xE9l\xE9phone existe d\xE9j\xE0.",
    form_identifier_exists__username: "Ce nom d'utilisateur existe d\xE9j\xE0.",
    form_identifier_not_found: "Identifiant introuvable",
    form_param_format_invalid: "Le format est invalide",
    form_param_format_invalid__email_address: "L'adresse e-mail doit \xEAtre une adresse e-mail valide.",
    form_param_format_invalid__phone_number: "Le num\xE9ro de t\xE9l\xE9phone doit \xEAtre au format international.",
    form_param_max_length_exceeded__first_name: "Le pr\xE9nom ne doit pas d\xE9passer 256 caract\xE8res.",
    form_param_max_length_exceeded__last_name: "Le nom ne doit pas d\xE9passer 256 caract\xE8res.",
    form_param_max_length_exceeded__name: "Le nom ne doit pas d\xE9passer 256 caract\xE8res.",
    form_param_nil: "Ce champ est requis.",
    form_param_value_invalid: "La valeur fournie est invalide.",
    form_password_incorrect: "Mot de passe incorrect",
    form_password_length_too_short: "Votre mot de passe est trop court.",
    form_password_not_strong_enough: "Votre mot de passe n'est pas assez fort.",
    form_password_pwned: "Ce mot de passe a \xE9t\xE9 compromis et ne peut pas \xEAtre utilis\xE9. Veuillez essayer un autre mot de passe \xE0 la place.",
    form_password_pwned__sign_in: "Mot de passe compromis. Veuillez le r\xE9initialiser.",
    form_password_size_in_bytes_exceeded: "Votre mot de passe a d\xE9pass\xE9 le nombre maximum d'octets autoris\xE9s. Veuillez le raccourcir ou supprimer certains caract\xE8res sp\xE9ciaux.",
    form_password_validation_failed: "Mot de passe incorrect",
    form_username_invalid_character: "L'identifiant contient des caract\xE8res invalides.",
    form_username_invalid_length: "Le nombre de caract\xE8res de l'identifiant est invalide.",
    identification_deletion_failed: "Vous ne pouvez pas supprimer votre derni\xE8re identification.",
    not_allowed_access: "Acc\xE8s non autoris\xE9",
    organization_domain_blocked: "Ce domaine d'organisation est bloqu\xE9.",
    organization_domain_common: "Ce domaine est trop courant pour une organisation.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Le quota de membres de l'organisation a \xE9t\xE9 d\xE9pass\xE9.",
    organization_minimum_permissions_needed: "Permissions minimales n\xE9cessaires pour acc\xE9der \xE0 cette organisation.",
    passkey_already_exists: "Cette cl\xE9 de s\xE9curit\xE9 existe d\xE9j\xE0.",
    passkey_not_supported: "Les cl\xE9s de s\xE9curit\xE9 ne sont pas prises en charge sur cet appareil.",
    passkey_pa_not_supported: "Les cl\xE9s de s\xE9curit\xE9 ne sont pas prises en charge dans cet environnement.",
    passkey_registration_cancelled: "Enregistrement de la cl\xE9 de s\xE9curit\xE9 annul\xE9.",
    passkey_retrieval_cancelled: "R\xE9cup\xE9ration de la cl\xE9 de s\xE9curit\xE9 annul\xE9e.",
    passwordComplexity: {
      maximumLength: "moins de {{length}} caract\xE8res",
      minimumLength: "{{length}} caract\xE8res ou plus",
      requireLowercase: "une lettre minuscule",
      requireNumbers: "un chiffre",
      requireSpecialCharacter: "un caract\xE8re sp\xE9cial",
      requireUppercase: "une lettre majuscule",
      sentencePrefix: "Votre mot de passe doit contenir"
    },
    phone_number_exists: "Ce num\xE9ro de t\xE9l\xE9phone est d\xE9j\xE0 utilis\xE9. Veuillez essayer un autre.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Votre mot de passe fonctionne mais pourrait \xEAtre plus s\xFBr. Essayez d'ajouter des caract\xE8res.",
      goodPassword: "Bien jou\xE9. C'est un excellent mot de passe.",
      notEnough: "Votre mot de passe n'est pas assez fort.",
      suggestions: {
        allUppercase: "Mettez quelques lettres en majuscules, mais pas toutes.",
        anotherWord: "Ajoutez des mots moins courants.",
        associatedYears: "\xC9vitez les ann\xE9es qui vous sont associ\xE9es. (ex: date de naissance)",
        capitalization: "Capitalisez mais pas seulement la premi\xE8re lettre.",
        dates: "\xC9vitez les dates et les ann\xE9es qui vous sont associ\xE9es. (ex: date ou ann\xE9e de naissance)",
        l33t: "\xC9vitez les substitutions de lettres pr\xE9visibles comme '@' pour 'a'.",
        longerKeyboardPattern: "Utilisez des motifs de clavier plus longs et changez de sens de frappe plusieurs fois.",
        noNeed: "Vous pouvez cr\xE9er des mots de passe forts sans utiliser de symboles, de chiffres ou de lettres majuscules.",
        pwned: "Si vous utilisez ce mot de passe ailleurs, vous devriez le modifier.",
        recentYears: "\xC9vitez les derni\xE8res ann\xE9es.",
        repeated: "\xC9vitez les mots et les caract\xE8res r\xE9p\xE9t\xE9s.",
        reverseWords: "\xC9vitez les orthographes invers\xE9es des mots courants",
        sequences: "\xC9vitez les s\xE9quences de caract\xE8res courantes.",
        useWords: "Utilisez plusieurs mots, mais \xE9vitez les phrases courantes."
      },
      warnings: {
        common: "Ce mot de passe est couramment utilis\xE9.",
        commonNames: "Les noms communs et les noms de famille sont faciles \xE0 deviner.",
        dates: "Les dates sont faciles \xE0 deviner.",
        extendedRepeat: "Les caract\xE8res r\xE9p\xE9t\xE9s comme 'abcabcabc' sont faciles \xE0 deviner.",
        keyPattern: "Des motifs de clavier courts sont faciles \xE0 deviner.",
        namesByThemselves: "Des noms ou des pr\xE9noms simples sont faciles \xE0 deviner.",
        pwned: "Votre mot de passe a \xE9t\xE9 divulgu\xE9 suite \xE0 une violation de donn\xE9es sur Internet.",
        recentYears: "Les ann\xE9es r\xE9centes sont faciles \xE0 deviner.",
        sequences: "Des s\xE9quences de caract\xE8res communs comme 'abc' sont faciles \xE0 deviner.",
        similarToCommon: "Ce mot de passe est similaire \xE0 un mot de passe couramment utilis\xE9.",
        simpleRepeat: "Les caract\xE8res r\xE9p\xE9t\xE9s comme 'aaa' sont faciles \xE0 deviner.",
        straightRow: "Les lignes droites de touches de votre clavier sont faciles \xE0 deviner.",
        topHundred: "Ce mot de passe est fr\xE9quemment utilis\xE9.",
        topTen: "Ce mot de passe est tr\xE8s utilis\xE9.",
        userInputs: "Le mot de passe ne doit pas comporter de donn\xE9es personnelles ou li\xE9es au site.",
        wordByItself: "Les mots simples sont faciles \xE0 deviner."
      }
    }
  },
  userButton: {
    action__addAccount: "Ajouter un compte",
    action__manageAccount: "G\xE9rer son compte",
    action__signOut: "D\xE9connexion",
    action__signOutAll: "Se d\xE9connecter de tous les comptes"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copi\xE9 !",
      actionLabel__copy: "Copier tous les codes",
      actionLabel__download: "T\xE9l\xE9charger en .txt",
      actionLabel__print: "Imprimer",
      infoText1: "Les codes de r\xE9cup\xE9ration seront activ\xE9s pour ce compte.",
      infoText2: "Gardez les codes de r\xE9cup\xE9ration secrets et stockez-les en toute s\xE9curit\xE9. Vous pouvez r\xE9g\xE9n\xE9rer les codes de r\xE9cup\xE9ration si vous pensez qu'ils ont \xE9t\xE9 compromis.",
      subtitle__codelist: "Conservez-les en toute s\xE9curit\xE9 et gardez-les secrets.",
      successMessage: "Les codes de r\xE9cup\xE9ration sont maintenant activ\xE9s. Vous pouvez utiliser l'un d'entre eux pour vous connecter \xE0 votre compte, si vous perdez l'acc\xE8s \xE0 votre dispositif d'authentification. Chaque code ne peut \xEAtre utilis\xE9 qu'une seule fois.",
      successSubtitle: "Vous pouvez utiliser l'un d'entre eux pour vous connecter \xE0 votre compte, si vous perdez l'acc\xE8s \xE0 votre dispositif d'authentification.",
      title: "Ajouter la v\xE9rification du code de r\xE9cup\xE9ration",
      title__codelist: "Codes de r\xE9cup\xE9ration"
    },
    connectedAccountPage: {
      formHint: "S\xE9lectionnez un fournisseur pour connecter votre compte.",
      formHint__noAccounts: "Aucun fournisseur de compte externe n'est disponible.",
      removeResource: {
        messageLine1: "{{identifier}} sera supprim\xE9 de ce compte.",
        messageLine2: "Vous ne pourrez plus utiliser ce compte connect\xE9 et toutes les fonctionnalit\xE9s d\xE9pendantes ne fonctionneront plus.",
        successMessage: "{{connectedAccount}} a \xE9t\xE9 supprim\xE9 de votre compte.",
        title: "Supprimer le compte connect\xE9"
      },
      socialButtonsBlockButton: "Connecter {{provider|titleize}} compte",
      successMessage: "Le fournisseur a \xE9t\xE9 ajout\xE9 \xE0 votre compte",
      title: "Ajouter un compte connect\xE9"
    },
    deletePage: {
      actionDescription: 'Saisissez "Supprimer le compte" ci-dessous pour continuer.',
      confirm: "Supprimer le compte",
      messageLine1: "\xCAtes-vous s\xFBr(e) de vouloir supprimer votre compte ?",
      messageLine2: "Cette action est d\xE9finitive et irr\xE9versible.",
      title: "Supprimer le compte"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Un e-mail contenant un code de v\xE9rification sera envoy\xE9 \xE0 cette adresse e-mail.",
        formSubtitle: "Saisissez le code de v\xE9rification envoy\xE9 \xE0 {{identifier}}",
        formTitle: "Le code de v\xE9rification",
        resendButton: "Renvoyer le lien",
        successMessage: "L'e-mail {{identifier}} a \xE9t\xE9 v\xE9rifi\xE9 et ajout\xE9 \xE0 votre compte."
      },
      emailLink: {
        formHint: "Un e-mail contenant un lien de v\xE9rification sera envoy\xE9 \xE0 cette adresse e-mail.",
        formSubtitle: "Cliquez sur le lien de v\xE9rification dans l'e-mail envoy\xE9 \xE0 {{identifier}}",
        formTitle: "lien de v\xE9rification",
        resendButton: "Renvoyer le lien",
        successMessage: "L'e-mail {{identifier}} a \xE9t\xE9 v\xE9rifi\xE9 et ajout\xE9 \xE0 votre compte."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} sera supprim\xE9 de ce compte.",
        messageLine2: "Vous ne pourrez plus vous connecter avec cette adresse e-mail.",
        successMessage: "{{emailAddress}} a \xE9t\xE9 supprim\xE9 de votre compte.",
        title: "Supprimer l'adresse e-mail"
      },
      title: "Ajouter une adresse e-mail",
      verifyTitle: "Verifier un e-mail"
    },
    formButtonPrimary__add: "Ajouter",
    formButtonPrimary__continue: "Continuer",
    formButtonPrimary__finish: "Retour",
    formButtonPrimary__remove: "Supprimer",
    formButtonPrimary__save: "Sauvegarder",
    formButtonReset: "Annuler",
    mfaPage: {
      formHint: "S\xE9lectionnez une m\xE9thode \xE0 ajouter.",
      title: "Ajouter la v\xE9rification en deux \xE9tapes"
    },
    mfaPhoneCodePage: {
      backButton: "Utiliser un num\xE9ro existant",
      primaryButton__addPhoneNumber: "Ajouter un num\xE9ro de t\xE9l\xE9phone",
      removeResource: {
        messageLine1: "{{identifier}} ne recevra plus de codes de validation lors de la connexion.",
        messageLine2: "Votre compte sera moins s\xE9curis\xE9. Souhaitez-vous continuer ?",
        successMessage: "La v\xE9rification en deux \xE9tapes du code SMS a \xE9t\xE9 supprim\xE9e pour {{mfaPhoneCode}}",
        title: "Supprimer la v\xE9rification en deux \xE9tapes"
      },
      subtitle__availablePhoneNumbers: "S\xE9lectionnez un num\xE9ro de t\xE9l\xE9phone pour vous inscrire \xE0 la v\xE9rification en deux \xE9tapes du code SMS.",
      subtitle__unavailablePhoneNumbers: "Il n'y a pas de num\xE9ros de t\xE9l\xE9phone disponibles pour s'inscrire \xE0 la v\xE9rification en deux \xE9tapes du code SMS.",
      successMessage1: "Lors de la connexion, vous devrez entrer un code de v\xE9rification envoy\xE9 \xE0 ce num\xE9ro de t\xE9l\xE9phone comme \xE9tape suppl\xE9mentaire.",
      successMessage2: "Enregistrez ces codes de r\xE9cup\xE9rations et conservez-les en lieu s\xFBr. Si vous perdez l'acc\xE8s \xE0 votre appareil d'authentification, vous pourrez utiliser les codes de r\xE9cup\xE9rations pour vous connecter.",
      successTitle: "V\xE9rification par SMS activ\xE9e",
      title: "Ajouter la v\xE9rification du code SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scannez le QR code \xE0 la place",
        buttonUnableToScan__nonPrimary: "Vous ne pouvez pas scanner le QR code ?",
        infoText__ableToScan: "Configurez une nouvelle m\xE9thode de connexion dans votre application d'authentification et scannez le QR code suivant pour le lier \xE0 votre compte.",
        infoText__unableToScan: "Configurez une nouvelle m\xE9thode de connexion dans votre authentificateur et entrez la cl\xE9 fournie ci-dessous.",
        inputLabel__unableToScan1: "Assurez-vous que les mots de passe bas\xE9s sur le temps ou \xE0 usage unique sont activ\xE9s, puis terminez la liaison de votre compte.",
        inputLabel__unableToScan2: "Alternativement, si votre authentificateur prend en charge les URI TOTP, vous pouvez \xE9galement copier l'URI complet."
      },
      removeResource: {
        messageLine1: "Les codes de v\xE9rification de cet authentificateur ne seront plus requis lors de la connexion.",
        messageLine2: "Votre compte sera moins s\xE9curis\xE9. Souhaitez-vous continuer ?",
        successMessage: "La v\xE9rification en deux \xE9tapes via l'application d'authentification a \xE9t\xE9 supprim\xE9e.",
        title: "Supprimer la v\xE9rification en deux \xE9tapes"
      },
      successMessage: "La v\xE9rification en deux \xE9tapes est maintenant activ\xE9e. Lors de la connexion, vous devrez saisir un code de v\xE9rification de cet authentificateur comme \xE9tape suppl\xE9mentaire.",
      title: "Ajouter une application d'authentification",
      verifySubtitle: "Entrez le code de v\xE9rification g\xE9n\xE9r\xE9 par votre application d'authentification",
      verifyTitle: "Le code de v\xE9rification"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Compte",
      description: "G\xE9rer votre compte.",
      security: "S\xE9curit\xE9",
      title: "Profil"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "\xCAtes-vous s\xFBr de vouloir supprimer cette cl\xE9 de s\xE9curit\xE9 ?",
        title: "Supprimer la cl\xE9 de s\xE9curit\xE9"
      },
      subtitle__rename: "Renommez votre cl\xE9 de s\xE9curit\xE9 pour une identification facile.",
      title__rename: "Renommer la cl\xE9 de s\xE9curit\xE9"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Il est recommand\xE9 de se d\xE9connecter de tous les autres appareils qui pourraient avoir utilis\xE9 votre ancien mot de passe.",
      readonly: "Votre mot de passe ne peut pas \xEAtre modifi\xE9 pour l'instant car vous ne pouvez vous connecter qu'\xE0 l'aide de la connexion entreprise.",
      successMessage__set: "Votre mot de passe a \xE9t\xE9 mis \xE0 jour.",
      successMessage__signOutOfOtherSessions: "Tous les autres appareils ont \xE9t\xE9 d\xE9connect\xE9s.",
      successMessage__update: "Votre mot de passe a \xE9t\xE9 mis \xE0 jour.",
      title__set: "Mettre \xE0 jour le mot de passe",
      title__update: "Changer le mot de passe"
    },
    phoneNumberPage: {
      infoText: "Un SMS contenant un lien de v\xE9rification sera envoy\xE9 \xE0 ce num\xE9ro de t\xE9l\xE9phone.",
      removeResource: {
        messageLine1: "{{identifier}} sera supprim\xE9 de ce compte.",
        messageLine2: "Vous ne pourrez plus vous connecter avec ce num\xE9ro de t\xE9l\xE9phone.",
        successMessage: "{{phoneNumber}} a \xE9t\xE9 supprim\xE9 de votre compte.",
        title: "Supprimer le num\xE9ro de t\xE9l\xE9phone"
      },
      successMessage: "{{identifier}} a \xE9t\xE9 v\xE9rifi\xE9 et ajout\xE9 \xE0 votre compte.",
      title: "Ajouter un num\xE9ro de t\xE9l\xE9phone",
      verifySubtitle: "Saisissez le code de v\xE9rification envoy\xE9 \xE0 {{identifier}}",
      verifyTitle: "V\xE9rification du num\xE9ro de t\xE9l\xE9phone"
    },
    profilePage: {
      fileDropAreaHint: "T\xE9l\xE9chargez une image JPG, PNG, GIF ou WEBP inf\xE9rieure \xE0 10 Mo",
      imageFormDestructiveActionSubtitle: "Supprimer l'image",
      imageFormSubtitle: "T\xE9l\xE9charger une image",
      imageFormTitle: "Photo de profil",
      readonly: "Les informations de votre profil ont \xE9t\xE9 fournies par la connexion d'entreprise et ne peuvent pas \xEAtre modifi\xE9es.",
      successMessage: "Votre profil a \xE9t\xE9 mis a jour.",
      title: "Mettre \xE0 jour le profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Se d\xE9connecter de l'appareil",
        title: "Appareils actifs"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "R\xE9essayer",
        actionLabel__reauthorize: "Autoriser maintenant",
        destructiveActionTitle: "Retirer",
        primaryButton: "Connecter le compte",
        subtitle__disconnected: "Compte d\xE9connect\xE9. Connectez-vous \xE0 nouveau pour acc\xE9der aux fonctionnalit\xE9s.",
        subtitle__reauthorize: "Les autorisations requises ont \xE9t\xE9 mises \xE0 jour, ce qui peut entra\xEEner des fonctionnalit\xE9s limit\xE9es. Veuillez r\xE9-autoriser cette application pour \xE9viter tout probl\xE8me.",
        title: "Comptes connect\xE9s"
      },
      dangerSection: {
        deleteAccountButton: "Supprimer le compte",
        title: "Danger"
      },
      emailAddressesSection: {
        destructiveAction: "Supprimer l'adresse e-mail",
        detailsAction__nonPrimary: "D\xE9finir comme principale",
        detailsAction__primary: "Compl\xE9ter la v\xE9rification",
        detailsAction__unverified: "Compl\xE9ter la v\xE9rification",
        primaryButton: "Ajouter une adresse e-mail",
        title: "Adresses e-mail"
      },
      enterpriseAccountsSection: {
        title: "Comptes entreprises"
      },
      headerTitle__account: "Compte",
      headerTitle__security: "S\xE9curit\xE9",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "R\xE9g\xE9n\xE9rer les codes",
          headerTitle: "Codes de r\xE9cup\xE9ration",
          subtitle__regenerate: "Obtenez de nouveaux codes de r\xE9cup\xE9ration s\xE9curis\xE9s. Les codes de r\xE9cup\xE9ration ant\xE9rieurs seront supprim\xE9s et ne pourront pas \xEAtre utilis\xE9s.",
          title__regenerate: "R\xE9g\xE9n\xE9rer les codes de r\xE9cup\xE9ration"
        },
        phoneCode: {
          actionLabel__setDefault: "D\xE9finir par d\xE9faut",
          destructiveActionLabel: "Supprimer le num\xE9ro de t\xE9l\xE9phone"
        },
        primaryButton: "Ajouter la v\xE9rification en deux \xE9tapes",
        title: "V\xE9rification en deux \xE9tapes",
        totp: {
          destructiveActionTitle: "D\xE9sactiver",
          headerTitle: "Application d'authentification"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Supprimer",
        menuAction__rename: "Renommer",
        primaryButton: void 0,
        title: "Cl\xE9s de s\xE9curit\xE9"
      },
      passwordSection: {
        primaryButton__setPassword: "D\xE9finir le mot de passe",
        primaryButton__updatePassword: "Changer le mot de passe",
        title: "Mot de passe"
      },
      phoneNumbersSection: {
        destructiveAction: "Supprimer le num\xE9ro de t\xE9l\xE9phone",
        detailsAction__nonPrimary: "D\xE9finir comme principale",
        detailsAction__primary: "Compl\xE9ter la v\xE9rification",
        detailsAction__unverified: "Compl\xE9ter la v\xE9rification",
        primaryButton: "Ajouter un num\xE9ro de t\xE9l\xE9phone",
        title: "Num\xE9ros de t\xE9l\xE9phone"
      },
      profileSection: {
        primaryButton: "Mettre \xE0 jour le profil",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "D\xE9finir le nom d'utilisateur",
        primaryButton__updateUsername: "Changer le nom d'utilisateur",
        title: "Nom d'utilisateur"
      },
      web3WalletsSection: {
        destructiveAction: "Supprimer le portefeuille",
        primaryButton: "Portefeuilles Web3",
        title: "Portefeuilles Web3"
      }
    },
    usernamePage: {
      successMessage: "Votre nom d'utilisateur a \xE9t\xE9 mis \xE0 jour.",
      title__set: "Mettre \xE0 jour le nom d'utilisateur",
      title__update: "Mettre \xE0 jour le nom d'utilisateur"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} sera supprim\xE9 de ce compte.",
        messageLine2: "Vous ne pourrez plus vous connecter avec ce portefeuille web3.",
        successMessage: "{{web3Wallet}} a \xE9t\xE9 supprim\xE9 de votre compte.",
        title: "Supprimer le portefeuille Web3"
      },
      subtitle__availableWallets: "S\xE9lectionnez un portefeuille Web3 pour vous connecter \xE0 votre compte.",
      subtitle__unavailableWallets: "Il n'y a pas de portefeuilles Web3 disponibles.",
      successMessage: "Le portefeuille a \xE9t\xE9 ajout\xE9 \xE0 votre compte.",
      title: "Ajouter un portefeuille Web3",
      web3WalletButtonsBlockButton: "Utiliser un portefeuille Web3"
    }
  },
  waitlist: {
    start: {
      actionLink: "Rejoindre la liste d'attente",
      actionText: "Int\xE9ress\xE9 ? Rejoignez-nous !",
      formButton: "S'inscrire",
      subtitle: "Soyez parmi les premiers \xE0 d\xE9couvrir notre nouveau service.",
      title: "Rejoindre la liste d'attente"
    },
    success: {
      message: "Merci ! Vous avez \xE9t\xE9 ajout\xE9 \xE0 la liste d'attente.",
      subtitle: "Nous vous contacterons bient\xF4t avec plus de d\xE9tails.",
      title: "Inscription r\xE9ussie"
    }
  }
};

// src/da-DK.ts
var daDK = {
  locale: "da-DK",
  backButton: "Tilbage",
  badge__default: "Standard",
  badge__otherImpersonatorDevice: "Anden enhed som efterligner",
  badge__primary: "Prim\xE6r",
  badge__requiresAction: "Kr\xE6ver handling",
  badge__thisDevice: "Denne enhed",
  badge__unverified: "Ikke verificeret",
  badge__userDevice: "Brugerenhed",
  badge__you: "Dig",
  createOrganization: {
    formButtonSubmit: "Opret organisation",
    invitePage: {
      formButtonReset: "Spring over"
    },
    title: "Opret organisation"
  },
  dates: {
    lastDay: "I g\xE5r: {{ date | timeString('en-US') }}",
    next6Days: "{{ date | weekday('en-US','long') }} kl. {{ date | timeString('en-US') }}",
    nextDay: "I morgen: {{ date | timeString('en-US') }}",
    numeric: "{{ date | numeric('en-US') }}",
    previous6Days: "Sidste {{ date | weekday('en-US','long') }} kl. {{ date | timeString('en-US') }}",
    sameDay: "I dag: {{ date | timeString('en-US') }}"
  },
  dividerText: "eller",
  footerActionLink__useAnotherMethod: "Brug en anden metode",
  footerPageLink__help: "Hj\xE6lp",
  footerPageLink__privacy: "Privatliv",
  footerPageLink__terms: "Vilk\xE5r",
  formButtonPrimary: "Forts\xE6t",
  formButtonPrimary__verify: "Verificer",
  formFieldAction__forgotPassword: "Glemt adgangskode?",
  formFieldError__matchingPasswords: "Adgangskoderne matcher.",
  formFieldError__notMatchingPasswords: "Adgangskoderne matcher ikke.",
  formFieldError__verificationLinkExpired: "Bekr\xE6ftelseslinket er udl\xF8bet. Venligst anmod om et nyt link.",
  formFieldHintText__optional: "Valgfri",
  formFieldHintText__slug: "En slug er en menneskelig l\xE6sbar ID, der skal v\xE6re unik. Det bruges ofte i URL\u2019er.",
  formFieldInputPlaceholder__backupCode: "Indtast sikkerhedskode",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Slet konto",
  formFieldInputPlaceholder__emailAddress: "Indtast e-mailadresse",
  formFieldInputPlaceholder__emailAddress_username: "Indtast e-mailadresse eller brugernavn",
  formFieldInputPlaceholder__emailAddresses: "Indtast eller inds\xE6t en eller flere e-mailadresser, adskilt af mellemrum eller kommaer",
  formFieldInputPlaceholder__firstName: "Indtast fornavn",
  formFieldInputPlaceholder__lastName: "Indtast efternavn",
  formFieldInputPlaceholder__organizationDomain: "Indtast dom\xE6ne",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Indtast e-mailadresse til verifikation",
  formFieldInputPlaceholder__organizationName: "Indtast organisationens navn",
  formFieldInputPlaceholder__organizationSlug: "Indtast slug URL",
  formFieldInputPlaceholder__password: "Indtast adgangskode",
  formFieldInputPlaceholder__phoneNumber: "Indtast telefonnummer",
  formFieldInputPlaceholder__username: "Indtast brugernavn",
  formFieldLabel__automaticInvitations: "Aktiver automatiske invitationer for dette dom\xE6ne",
  formFieldLabel__backupCode: "Sikkerhedskode",
  formFieldLabel__confirmDeletion: "Bekr\xE6ftelse",
  formFieldLabel__confirmPassword: "Bekr\xE6ft adgangskode",
  formFieldLabel__currentPassword: "Nuv\xE6rende adgangskode",
  formFieldLabel__emailAddress: "E-mailadresse",
  formFieldLabel__emailAddress_username: "E-mailadresse eller brugernavn",
  formFieldLabel__emailAddresses: "E-mailadresser",
  formFieldLabel__firstName: "Fornavn",
  formFieldLabel__lastName: "Efternavn",
  formFieldLabel__newPassword: "Ny adgangskode",
  formFieldLabel__organizationDomain: "Dom\xE6ne",
  formFieldLabel__organizationDomainDeletePending: "Slet ventende invitationer og forslag",
  formFieldLabel__organizationDomainEmailAddress: "Verifikation e-mailadresse",
  formFieldLabel__organizationDomainEmailAddressDescription: "Indtast en e-mailadresse under dette dom\xE6ne for at modtage en kode og verificere dette dom\xE6ne.",
  formFieldLabel__organizationName: "Organisationens navn",
  formFieldLabel__organizationSlug: "Slug URL",
  formFieldLabel__passkeyName: "Navn p\xE5 adgangsn\xF8gle",
  formFieldLabel__password: "Adgangskode",
  formFieldLabel__phoneNumber: "Telefonnummer",
  formFieldLabel__role: "Rolle",
  formFieldLabel__signOutOfOtherSessions: "Log ud af alle andre enheder",
  formFieldLabel__username: "Brugernavn",
  impersonationFab: {
    action__signOut: "Log ud",
    title: "Logget ind som {{identifier}}"
  },
  maintenanceMode: "Vedligeholdelsestilstand",
  membershipRole__admin: "Administrator",
  membershipRole__basicMember: "Medlem",
  membershipRole__guestMember: "G\xE6st",
  organizationList: {
    action__createOrganization: "Opret organisation",
    action__invitationAccept: "Deltag",
    action__suggestionsAccept: "Anmod om at deltage",
    createOrganization: "Opret Organisation",
    invitationAcceptedLabel: "Deltaget",
    subtitle: "for at forts\xE6tte til {{applicationName}}",
    suggestionsAcceptedLabel: "Afventer godkendelse",
    title: "V\xE6lg en konto",
    titleWithoutPersonal: "V\xE6lg en organisation"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatiske invitationer",
    badge__automaticSuggestion: "Automatiske forslag",
    badge__manualInvitation: "Ingen automatisk tilmelding",
    badge__unverified: "Ikke verificeret",
    createDomainPage: {
      subtitle: "Tilf\xF8j dom\xE6net for at verificere. Brugere med e-mailadresser under dette dom\xE6ne kan automatisk deltage i organisationen eller anmode om at deltage.",
      title: "Tilf\xF8j dom\xE6ne"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Invitationerne kunne ikke sendes. Ret f\xF8lgende, og pr\xF8v igen:",
      formButtonPrimary__continue: "Send invitationer",
      selectDropdown__role: "V\xE6lg rolle",
      subtitle: "Inviter nye medlemmer til denne organisation",
      successMessage: "Invitationer blev sendt",
      title: "Inviter medlemmer"
    },
    membersPage: {
      action__invite: "Inviter",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Fjern medlem",
        tableHeader__actions: "Handlinger",
        tableHeader__joined: "Deltaget",
        tableHeader__role: "Rolle",
        tableHeader__user: "Bruger"
      },
      detailsTitle__emptyRow: "Ingen medlemmer at vise",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Inviter brugere ved at forbinde et e-maildom\xE6ne med din organisation. Alle, der tilmelder sig med en matchende e-maildom\xE6ne, vil kunne deltage i organisationen n\xE5r som helst.",
          headerTitle: "Automatiske invitationer",
          primaryButton: "Administrer verificerede dom\xE6ner"
        },
        table__emptyRow: "Ingen invitationer at vise"
      },
      invitedMembersTab: {
        menuAction__revoke: "Tilbagekald invitation",
        tableHeader__invited: "Inviteret"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Brugere, der tilmelder sig med en matchende e-maildom\xE6ne, vil kunne se et forslag om at anmode om at deltage i din organisation.",
          headerTitle: "Automatiske forslag",
          primaryButton: "Administrer verificerede dom\xE6ner"
        },
        menuAction__approve: "Godkend",
        menuAction__reject: "Afvis",
        tableHeader__requested: "Anmodet adgang",
        table__emptyRow: "Ingen anmodninger at vise"
      },
      start: {
        headerTitle__invitations: "Invitationer",
        headerTitle__members: "Medlemmer",
        headerTitle__requests: "Anmodninger"
      }
    },
    navbar: {
      description: "Administrer din organisation.",
      general: "Generelt",
      members: "Medlemmer",
      title: "Organisation"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Skriv "{{organizationName}}" nedenfor for at forts\xE6tte.',
          messageLine1: "Er du sikker p\xE5, at du vil slette denne organisation?",
          messageLine2: "Denne handling er permanent og kan ikke fortrydes.",
          successMessage: "Du har slettet organisationen.",
          title: "Slet organisation"
        },
        leaveOrganization: {
          actionDescription: 'Skriv "{{organizationName}}" nedenfor for at forts\xE6tte.',
          messageLine1: "Er du sikker p\xE5, at du vil forlade denne organisation? Du mister adgang til denne organisation og dens applikationer.",
          messageLine2: "Denne handling er permanent og kan ikke fortrydes.",
          successMessage: "Du har forladt organisationen.",
          title: "Forlad organisationen"
        },
        title: "Fare"
      },
      domainSection: {
        menuAction__manage: "Administrer",
        menuAction__remove: "Slet",
        menuAction__verify: "Verificer",
        primaryButton: "Tilf\xF8j dom\xE6ne",
        subtitle: "Tillad brugere at deltage i organisationen automatisk eller anmode om at deltage baseret p\xE5 et verificeret e-maildom\xE6ne.",
        title: "Verificerede dom\xE6ner"
      },
      successMessage: "Organisationen er blevet opdateret.",
      title: "Organisationsprofil"
    },
    removeDomainPage: {
      messageLine1: "E-maildom\xE6net {{domain}} vil blive fjernet.",
      messageLine2: "Brugere vil ikke l\xE6ngere kunne deltage i organisationen automatisk efter dette.",
      successMessage: "{{domain}} er blevet fjernet.",
      title: "Fjern dom\xE6ne"
    },
    start: {
      headerTitle__general: "Generelt",
      headerTitle__members: "Medlemmer",
      profileSection: {
        primaryButton: "Opdater profil",
        title: "Organisationsprofil",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Fjernelse af dette dom\xE6ne vil p\xE5virke inviterede brugere.",
        removeDomainActionLabel__remove: "Fjern dom\xE6ne",
        removeDomainSubtitle: "Fjern dette dom\xE6ne fra dine verificerede dom\xE6ner",
        removeDomainTitle: "Fjern dom\xE6ne"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Brugere bliver automatisk inviteret til at deltage i organisationen, n\xE5r de tilmelder sig og kan deltage n\xE5r som helst.",
        automaticInvitationOption__label: "Automatiske invitationer",
        automaticSuggestionOption__description: "Brugere modtager et forslag om at anmode om at deltage, men skal godkendes af en administrator, f\xF8r de kan deltage i organisationen.",
        automaticSuggestionOption__label: "Automatiske forslag",
        calloutInfoLabel: "\xC6ndring af tilmeldingsindstilling vil kun p\xE5virke nye brugere.",
        calloutInvitationCountLabel: "Ventende invitationer sendt til brugere: {{count}}",
        calloutSuggestionCountLabel: "Ventende forslag sendt til brugere: {{count}}",
        manualInvitationOption__description: "Brugere kan kun inviteres manuelt til organisationen.",
        manualInvitationOption__label: "Ingen automatisk tilmelding",
        subtitle: "V\xE6lg hvordan brugere fra dette dom\xE6ne kan deltage i organisationen."
      },
      start: {
        headerTitle__danger: "Fare",
        headerTitle__enrollment: "Tilmeldingsindstillinger"
      },
      subtitle: "Dom\xE6net {{domain}} er nu verificeret. Forts\xE6t ved at v\xE6lge tilmeldingsmetode.",
      title: "Opdater {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Indtast den bekr\xE6ftelseskode, der blev sendt til din e-mailadresse",
      formTitle: "Bekr\xE6ftelseskode",
      resendButton: "Modtog du ikke en kode? Send igen",
      subtitle: "Dom\xE6net {{domainName}} skal verificeres via e-mail.",
      subtitleVerificationCodeScreen: "En bekr\xE6ftelseskode blev sendt til {{emailAddress}}. Indtast koden for at forts\xE6tte.",
      title: "Verificer dom\xE6ne"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Opret organisation",
    action__invitationAccept: "Deltag",
    action__manageOrganization: "Administrer organisation",
    action__suggestionsAccept: "Anmod om at deltage",
    notSelected: "Ingen organisation valgt",
    personalWorkspace: "Personligt arbejdsomr\xE5de",
    suggestionsAcceptedLabel: "Afventer godkendelse"
  },
  paginationButton__next: "N\xE6ste",
  paginationButton__previous: "Forrige",
  paginationRowText__displaying: "Viser",
  paginationRowText__of: "af",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Tilf\xF8j konto",
      action__signOutAll: "Log ud af alle konti",
      subtitle: "V\xE6lg den konto, du \xF8nsker at forts\xE6tte med.",
      title: "V\xE6lg en konto"
    },
    alternativeMethods: {
      actionLink: "F\xE5 hj\xE6lp",
      actionText: "Har du ingen af disse?",
      blockButton__backupCode: "Brug en backup-kode",
      blockButton__emailCode: "Send kode til {{identifier}}",
      blockButton__emailLink: "Send link til {{identifier}}",
      blockButton__passkey: "Brug en adgangsn\xF8gle",
      blockButton__password: "Log ind med adgangskode",
      blockButton__phoneCode: "Send kode til {{identifier}}",
      blockButton__totp: "Brug din godkendelsesapp",
      getHelp: {
        blockButton__emailSupport: "E-mail support",
        content: "Hvis du har problemer med at logge ind p\xE5 din konto, skal du sende en e-mail til os, og vi vil samarbejde med dig om at genoprette adgang s\xE5 hurtigt som muligt.",
        title: "F\xE5 hj\xE6lp"
      },
      subtitle: "Oplever du problemer? Du kan bruge en af disse metoder til at logge ind.",
      title: "Brug en anden metode"
    },
    backupCodeMfa: {
      subtitle: "Forts\xE6t til {{applicationName}}",
      title: "Indtast en backup-kode"
    },
    emailCode: {
      formTitle: "Bekr\xE6ftelseskode",
      resendButton: "Send kode igen",
      subtitle: "Forts\xE6t til {{applicationName}}",
      title: "Tjek din email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Klient uoverensstemmelse. Pr\xF8v igen.",
        title: "Klient fejl"
      },
      expired: {
        subtitle: "Vend tilbage til den oprindelige fane for at forts\xE6tte.",
        title: "Dette bekr\xE6ftelseslink er udl\xF8bet"
      },
      failed: {
        subtitle: "Vend tilbage til den oprindelige fane for at forts\xE6tte.",
        title: "Dette bekr\xE6ftelseslink er ugyldigt"
      },
      formSubtitle: "Brug bekr\xE6ftelseslinket sendt til din e-mail",
      formTitle: "Bekr\xE6ftelseslink",
      loading: {
        subtitle: "Du vil snart blive viderestillet",
        title: "Logger ind..."
      },
      resendButton: "Send link igen",
      subtitle: "Forts\xE6t til {{applicationName}}",
      title: "Tjek din email",
      unusedTab: {
        title: "Du kan lukke denne fane"
      },
      verified: {
        subtitle: "Du vil snart blive viderestillet",
        title: "Vellykket log ind"
      },
      verifiedSwitchTab: {
        subtitle: "Vend tilbage til den oprindelige fane for at forts\xE6tte",
        subtitleNewTab: "Vend tilbage til den nyligt \xE5bnede fane for at forts\xE6tte",
        titleNewTab: "Logget ind p\xE5 anden fane"
      }
    },
    forgotPassword: {
      formTitle: "Nulstil adgangskode",
      resendButton: "Modtog du ikke en kode? Send igen",
      subtitle: "for at nulstille din adgangskode",
      subtitle_email: "Indtast f\xF8rst koden sendt til din e-mailadresse",
      subtitle_phone: "Indtast f\xF8rst koden sendt til din telefon",
      title: "Nulstil adgangskode"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Nulstil din adgangskode",
      label__alternativeMethods: "Eller, log ind med en anden metode",
      title: "Glemt Adgangskode?"
    },
    noAvailableMethods: {
      message: "Kan ikke forts\xE6tte med login. Der er ingen tilg\xE6ngelige godkendelsesfaktorer.",
      subtitle: "En fejl opstod",
      title: "Kan ikke logge ind"
    },
    passkey: {
      subtitle: "Brug adgangsn\xF8gle til at logge ind.",
      title: "Adgangsn\xF8gle"
    },
    password: {
      actionLink: "Brug en anden metode",
      subtitle: "Forts\xE6t til {{applicationName}}",
      title: "Indtast din adgangskode"
    },
    passwordPwned: {
      title: "Sikkerhedsadvarsel"
    },
    phoneCode: {
      formTitle: "Bekr\xE6ftelseskode",
      resendButton: "Send kode igen",
      subtitle: "g\xE5 videre til {{applicationName}}",
      title: "Tjek din telefon"
    },
    phoneCodeMfa: {
      formTitle: "Bekr\xE6ftelseskode",
      resendButton: "Send kode igen",
      subtitle: void 0,
      title: "Tjek din telefon"
    },
    resetPassword: {
      formButtonPrimary: "Nulstil Adgangskode",
      requiredMessage: "Af sikkerhedsm\xE6ssige \xE5rsager er det n\xF8dvendigt at nulstille din adgangskode.",
      successMessage: "Din adgangskode blev \xE6ndret med succes. Logger dig ind, vent venligst et \xF8jeblik.",
      title: "Indstil ny adgangskode"
    },
    resetPasswordMfa: {
      detailsLabel: "Vi skal bekr\xE6fte din identitet, f\xF8r du nulstiller din adgangskode."
    },
    start: {
      actionLink: "Tilmeld dig",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Brug email",
      actionLink__use_email_username: "Brug email eller brugernavn",
      actionLink__use_passkey: "Brug adgangsn\xF8gle",
      actionLink__use_phone: "Brug telefon",
      actionLink__use_username: "Brug brugernavn",
      actionText: "Ingen konto?",
      actionText__join_waitlist: void 0,
      subtitle: "Fors\xE6t til {{applicationName}}",
      subtitleCombined: void 0,
      title: "Log ind",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Bekr\xE6ftelseskode",
      subtitle: void 0,
      title: "Totrinsbekr\xE6ftelse"
    }
  },
  signInEnterPasswordTitle: "Indtast din adgangskode",
  signUp: {
    continue: {
      actionLink: "Log ind",
      actionText: "Har du en konto?",
      subtitle: "Fors\xE6t til {{applicationName}}",
      title: "Udfyld manglende felter"
    },
    emailCode: {
      formSubtitle: "Indtast bekr\xE6ftelseskoden sendt til din e-mailadresse",
      formTitle: "Bekr\xE6ftelseskode",
      resendButton: "Send kode igen",
      subtitle: "Forts\xE6t til {{applicationName}}",
      title: "Bekr\xE6ft din email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Klient uoverensstemmelse. Pr\xF8v igen.",
        title: "Klient fejl"
      },
      formSubtitle: "Brug bekr\xE6ftelseslinket sendt til din e-mailadresse",
      formTitle: "Bekr\xE6ftelseslink",
      loading: {
        title: "Tilmelding..."
      },
      resendButton: "Send link igen",
      subtitle: "Fors\xE6t til {{applicationName}}",
      title: "Bekr\xE6ft din email",
      verified: {
        title: "Vellykket tilmelding"
      },
      verifiedSwitchTab: {
        subtitle: "Vend tilbage til den nyligt \xE5bnede fane for at forts\xE6tte",
        subtitleNewTab: "Vend tilbage til forrige fane for at forts\xE6tte",
        title: "E-mail er bekr\xE6ftet"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Indtast bekr\xE6ftelseskoden sendt til dit telefonnummer",
      formTitle: "Bekr\xE6ftelseskode",
      resendButton: "Send kode igen",
      subtitle: "Forts\xE6t til {{applicationName}}",
      title: "Bekr\xE6ft din telefon"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Log ind",
      actionLink__use_email: "Brug email",
      actionLink__use_phone: "Brug telefon",
      actionText: "Har du en konto?",
      subtitle: "Fors\xE6t til {{applicationName}}",
      subtitleCombined: "Fors\xE6t til {{applicationName}}",
      title: "Opret din konto",
      titleCombined: "Opret din konto"
    }
  },
  socialButtonsBlockButton: "Fors\xE6t med {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Tilmelding mislykkedes p\xE5 grund af fejlede sikkerhedsvalideringer. Opdater siden for at pr\xF8ve igen, eller kontakt support for yderligere assistance.",
    captcha_unavailable: "Tilmelding mislykkedes p\xE5 grund af fejlet botvalidering. Opdater siden for at pr\xF8ve igen, eller kontakt support for yderligere assistance.",
    form_code_incorrect: "Koden er forkert.",
    form_identifier_exists__email_address: "E-mailadressen er allerede i brug.",
    form_identifier_exists__phone_number: "Telefonnummeret er allerede i brug.",
    form_identifier_exists__username: "Brugernavnet er allerede i brug.",
    form_identifier_not_found: "Identifikatoren blev ikke fundet.",
    form_param_format_invalid: "Formatet er ugyldigt.",
    form_param_format_invalid__email_address: "E-mailadressen skal v\xE6re en gyldig e-mailadresse.",
    form_param_format_invalid__phone_number: "Telefonnummeret skal v\xE6re i et gyldigt internationalt format.",
    form_param_max_length_exceeded__first_name: "Fornavnet m\xE5 ikke overstige 256 tegn.",
    form_param_max_length_exceeded__last_name: "Efternavnet m\xE5 ikke overstige 256 tegn.",
    form_param_max_length_exceeded__name: "Navnet m\xE5 ikke overstige 256 tegn.",
    form_param_nil: "Dette felt kan ikke v\xE6re tomt.",
    form_param_value_invalid: void 0,
    form_password_incorrect: "Adgangskoden er forkert.",
    form_password_length_too_short: "Adgangskoden er for kort.",
    form_password_not_strong_enough: "Adgangskoden er ikke st\xE6rk nok.",
    form_password_pwned: "Adgangskoden er blevet kompromitteret.",
    form_password_pwned__sign_in: "Din adgangskode er blevet kompromitteret, v\xE6lg en ny.",
    form_password_size_in_bytes_exceeded: "Din adgangskode har overskredet det maksimalt tilladte antal bytes, forkort den eller fjern nogle specialtegn.",
    form_password_validation_failed: "Forkert adgangskode.",
    form_username_invalid_character: "Brugernavnet indeholder ugyldige tegn.",
    form_username_invalid_length: "Brugernavnet har en ugyldig l\xE6ngde.",
    identification_deletion_failed: "Du kan ikke slette din sidste identifikation.",
    not_allowed_access: "Adgang ikke tilladt.",
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "Adgangsn\xF8gle findes allerede.",
    passkey_not_supported: "Adgangsn\xF8gler underst\xF8ttes ikke p\xE5 denne enhed.",
    passkey_pa_not_supported: "Adgangsn\xF8gler underst\xF8ttes ikke p\xE5 dette styresystem.",
    passkey_registration_cancelled: "Registrering af adgangsn\xF8gle blev annulleret.",
    passkey_retrieval_cancelled: "Hentning af adgangsn\xF8gle blev annulleret.",
    passwordComplexity: {
      maximumLength: "mindre end {{length}} tegn",
      minimumLength: "{{length}} eller flere tegn",
      requireLowercase: "et lille bogstav",
      requireNumbers: "et tal",
      requireSpecialCharacter: "et specialtegn",
      requireUppercase: "et stort bogstav",
      sentencePrefix: "Din adgangskode skal indeholde"
    },
    phone_number_exists: "Dette telefonnummer er allerede taget. Pr\xF8v et andet.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Din adgangskode virker, men kunne v\xE6re st\xE6rkere. Pr\xF8v at tilf\xF8je flere tegn.",
      goodPassword: "Din adgangskode opfylder alle n\xF8dvendige krav.",
      notEnough: "Din adgangskode er ikke st\xE6rk nok.",
      suggestions: {
        allUppercase: "Brug store bogstaver p\xE5 nogle, men ikke alle bogstaver.",
        anotherWord: "Tilf\xF8j flere ord, der er mindre almindelige.",
        associatedYears: "Undg\xE5 \xE5r, der er forbundet med dig.",
        capitalization: "Brug store bogstaver p\xE5 mere end det f\xF8rste bogstav.",
        dates: "Undg\xE5 datoer og \xE5r, der er forbundet med dig.",
        l33t: "Undg\xE5 forudsigelige bogstavsubstitutioner som '@' for 'a'.",
        longerKeyboardPattern: "Brug l\xE6ngere tastaturm\xF8nstre og skift retning flere gange.",
        noNeed: "Du kan oprette st\xE6rke adgangskoder uden at bruge symboler, tal eller store bogstaver.",
        pwned: "Hvis du bruger denne adgangskode andre steder, b\xF8r du \xE6ndre den.",
        recentYears: "Undg\xE5 nylige \xE5rstal.",
        repeated: "Undg\xE5 gentagne ord og tegn.",
        reverseWords: "Undg\xE5 omvendte stavem\xE5der af almindelige ord.",
        sequences: "Undg\xE5 almindelige tegnsekvenser.",
        useWords: "Brug flere ord, men undg\xE5 almindelige s\xE6tninger."
      },
      warnings: {
        common: "Dette er en almindeligt brugt adgangskode.",
        commonNames: "Almindelige navne og efternavne er nemme at g\xE6tte.",
        dates: "Datoer er nemme at g\xE6tte.",
        extendedRepeat: 'Gentagne tegnm\xF8nstre som "abcabcabc" er nemme at g\xE6tte.',
        keyPattern: "Korte tastaturm\xF8nstre er nemme at g\xE6tte.",
        namesByThemselves: "Enkeltst\xE5ende navne eller efternavne er nemme at g\xE6tte.",
        pwned: "Din adgangskode er blevet eksponeret af et databrud p\xE5 internettet.",
        recentYears: "Nylige \xE5rstal er nemme at g\xE6tte.",
        sequences: 'Almindelige tegnsekvenser som "abc" er nemme at g\xE6tte.',
        similarToCommon: "Dette ligner en almindeligt brugt adgangskode.",
        simpleRepeat: 'Gentagne tegn som "aaa" er nemme at g\xE6tte.',
        straightRow: "Lige r\xE6kker af taster p\xE5 dit tastatur er nemme at g\xE6tte.",
        topHundred: "Dette er en ofte brugt adgangskode.",
        topTen: "Dette er en meget brugt adgangskode.",
        userInputs: "Der b\xF8r ikke v\xE6re nogen personlige eller sidespecifikke data.",
        wordByItself: "Enkeltst\xE5ende ord er nemme at g\xE6tte."
      }
    }
  },
  userButton: {
    action__addAccount: "Tilf\xF8j konto",
    action__manageAccount: "Administrer konto",
    action__signOut: "Log ud",
    action__signOutAll: "Log ud af alle konti"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopieret!",
      actionLabel__copy: "Kopier alle",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Print",
      infoText1: "Backup-koder vil blive aktiveret for denne konto.",
      infoText2: "Hold backup-koderne hemmelige og gem dem sikkert. Du kan genskabe backup-koder, hvis du har mistanke om, at de er blevet kompromitteret.",
      subtitle__codelist: "Opbevar dem sikkert og hold dem hemmelige.",
      successMessage: "Backup-koder er nu aktiveret. Du kan bruge en af disse til at logge ind p\xE5 din konto, hvis du mister adgangen til din totrinsbekr\xE6ftelse. Hver kode kan kun bruges \xE9n gang.",
      successSubtitle: "Du kan bruge en af disse til at logge ind p\xE5 din konto, hvis du mister adgangen til din totrinsbekr\xE6ftelse.",
      title: "Tilf\xF8j bekr\xE6ftelse af backup-kode",
      title__codelist: "Backup-koder"
    },
    connectedAccountPage: {
      formHint: "V\xE6lg en udbyder for at forbinde din konto.",
      formHint__noAccounts: "Der er ingen tilg\xE6ngelige eksterne kontoudbydere.",
      removeResource: {
        messageLine1: "{{identifier}} vil blive fjernet fra denne konto.",
        messageLine2: "Du vil ikke l\xE6ngere v\xE6re i stand til at bruge denne tilsluttede konto, og eventuelle afh\xE6ngige funktioner vil ikke l\xE6ngere virke.",
        successMessage: "{{connectedAccount}} er blevet fjernet fra din konto.",
        title: "Fjern tilsluttet konto"
      },
      socialButtonsBlockButton: "Forbind {{provider|titleize}} konto",
      successMessage: "Udbyderen er blevet tilf\xF8jet til din konto",
      title: "Tilf\xF8j tilsluttet konto"
    },
    deletePage: {
      actionDescription: 'Skriv "Slet konto" nedenfor for at forts\xE6tte.',
      confirm: "Slet konto",
      messageLine1: "Er du sikker p\xE5, at du vil slette din konto?",
      messageLine2: "Denne handling er permanent og kan ikke fortrydes.",
      title: "Slet konto"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "En e-mail indeholdende en bekr\xE6ftelseskode vil blive sendt til denne e-mailadresse.",
        formSubtitle: "Indtast bekr\xE6ftelseskoden sendt til {{identifier}}",
        formTitle: "Bekr\xE6ftelseskode",
        resendButton: "Send kode igen",
        successMessage: "E-mailen {{identifier}} er blevet tilf\xF8jet til din konto."
      },
      emailLink: {
        formHint: "En e-mail indeholdende et bekr\xE6ftelseslink vil blive sendt til denne e-mailadresse.",
        formSubtitle: "Klik p\xE5 bekr\xE6ftelseslinket i e-mailen sendt til {{identifier}}",
        formTitle: "Bekr\xE6ftelseslink",
        resendButton: "Send link igen",
        successMessage: "E-mailen {{identifier}} er blevet tilf\xF8jet til din konto."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} vil blive fjernet fra denne konto.",
        messageLine2: "Du vil ikke l\xE6ngere kunne logge ind med denne e-mailadresse.",
        successMessage: "{{emailAddress}} er blevet fjernet fra din konto.",
        title: "Fjern e-mailadresse"
      },
      title: "Tilf\xF8j e-mailadresse",
      verifyTitle: "Verificer e-mailadresse"
    },
    formButtonPrimary__add: "Tilf\xF8j",
    formButtonPrimary__continue: "Forts\xE6t",
    formButtonPrimary__finish: "Afslut",
    formButtonPrimary__remove: "Fjern",
    formButtonPrimary__save: "Gem",
    formButtonReset: "Annuller",
    mfaPage: {
      formHint: "V\xE6lg en metode, der skal tilf\xF8jes.",
      title: "Tilf\xF8j totrinsbekr\xE6ftelse"
    },
    mfaPhoneCodePage: {
      backButton: "Brug eksisterende nummer",
      primaryButton__addPhoneNumber: "Tilf\xF8j et telefonnummer",
      removeResource: {
        messageLine1: "{{identifier}} vil ikke l\xE6ngere modtage bekr\xE6ftelseskoder, n\xE5r du logger ind.",
        messageLine2: "Din konto er muligvis ikke s\xE5 sikker. Er du sikker p\xE5, at du vil forts\xE6tte?",
        successMessage: "SMS-bekr\xE6ftelse er blevet fjernet for {{mfaPhoneCode}}",
        title: "Fjern SMS-bekr\xE6ftelse"
      },
      subtitle__availablePhoneNumbers: "V\xE6lg et telefonnummer for at registrere SMS-bekr\xE6ftelse til totrinsbekr\xE6ftelse.",
      subtitle__unavailablePhoneNumbers: "Der er ingen tilg\xE6ngelige telefonnumre til at registrere til SMS-bekr\xE6ftelse til totrinsbekr\xE6ftelse.",
      successMessage1: "N\xE5r du logger ind, skal du indtaste en bekr\xE6ftelseskode sendt til dette telefonnummer som et ekstra trin.",
      successMessage2: "Gem disse backup-koder og opbevar dem et sikkert sted. Hvis du mister adgangen til din godkendelsesenhed, kan du bruge backup-koder til at logge ind.",
      successTitle: "SMS-bekr\xE6ftelse aktiveret",
      title: "Tilf\xF8j SMS-bekr\xE6ftelse"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scan QR-koden i stedet",
        buttonUnableToScan__nonPrimary: "Kan du ikke scanne QR-koden?",
        infoText__ableToScan: "Konfigurer en ny login-metode i din autentificeringsapp, og scan f\xF8lgende QR-kode for at linke den til din konto.",
        infoText__unableToScan: "Konfigurer en ny login-metode i din autentificeringsapp, og indtast n\xF8glen nedenfor.",
        inputLabel__unableToScan1: "S\xF8rg for, at tidsbaserede eller engangsadgangskoder er aktiveret, og afslut derefter tilknytningen af din konto.",
        inputLabel__unableToScan2: "Alternativt, hvis din autentificeringsapp underst\xF8tter TOTP URI'er, kan du ogs\xE5 kopiere hele URI'en."
      },
      removeResource: {
        messageLine1: "Bekr\xE6ftelseskoder fra denne autentificeringsapp kr\xE6ves ikke l\xE6ngere, n\xE5r du logger ind.",
        messageLine2: "Din konto er muligvis ikke s\xE5 sikker. Er du sikker p\xE5, at du vil forts\xE6tte?",
        successMessage: "Totrinsbekr\xE6ftelse via autentificeringsapp er blevet fjernet.",
        title: "Fjern totrinsbekr\xE6ftelse"
      },
      successMessage: "N\xE5r du logger ind, skal du indtaste en bekr\xE6ftelseskode fra denne autentificeringsapp som et ekstra trin.",
      title: "Tilf\xF8j autentificeringsapp",
      verifySubtitle: "Indtast bekr\xE6ftelseskode, der er genereret af din autentificeringsapp",
      verifyTitle: "Bekr\xE6ftelseskode"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profil",
      description: "Administrer dine kontooplysninger.",
      security: "Sikkerhed",
      title: "Konto"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "Adgangsn\xF8glen fjernes fra din konto.",
        title: "Fjern adgangsn\xF8gle"
      },
      subtitle__rename: "Omd\xF8b adgangsn\xF8gle",
      title__rename: "Omd\xF8b adgangsn\xF8gle"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Det anbefales at logge ud af alle andre enheder, der kan have brugt din gamle adgangskode.",
      readonly: "Din adgangskode kan i \xF8jeblikket ikke redigeres, fordi du kun kan logge ind via virksomhedens forbindelse.",
      successMessage__set: "Din adgangskode er blevet indstillet.",
      successMessage__signOutOfOtherSessions: "Alle andre enheder er blevet logget ud.",
      successMessage__update: "Din adgangskode er blevet opdateret.",
      title__set: "Indstil adgangskode",
      title__update: "Skift adgangskode"
    },
    phoneNumberPage: {
      infoText: "En SMS, der indeholder et bekr\xE6ftelseslink, sendes til dette telefonnummer.",
      removeResource: {
        messageLine1: "{{identifier}} vil blive fjernet fra denne konto.",
        messageLine2: "Du vil ikke l\xE6ngere kunne logge ind med dette telefonnummer.",
        successMessage: "{{phoneNumber}} er blevet fjernet fra din konto.",
        title: "Fjern telefonnummer"
      },
      successMessage: "{{identifier}} er blevet tilf\xF8jet til din konto.",
      title: "Tilf\xF8j telefonnummer",
      verifySubtitle: "Indtast bekr\xE6ftelseskoden sendt til {{identifier}}",
      verifyTitle: "Verificer telefonnummer"
    },
    profilePage: {
      fileDropAreaHint: "Upload et JPG, PNG, GIF, eller WEBP-billede mindre end 10 MB",
      imageFormDestructiveActionSubtitle: "Fjern billede",
      imageFormSubtitle: "Upload billede",
      imageFormTitle: "Profilbillede",
      readonly: "Dine profiloplysninger er leveret af virksomhedens forbindelse og kan ikke redigeres.",
      successMessage: "Din profil er blevet opdateret.",
      title: "Profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Log ud af enhed",
        title: "Aktive enheder"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Pr\xF8v igen",
        actionLabel__reauthorize: "Godkend nu",
        destructiveActionTitle: "Fjern",
        primaryButton: "Tilknyt konto",
        subtitle__disconnected: "Ingen tilknyttede konti",
        subtitle__reauthorize: "De kr\xE6vede tilladelser er blevet opdateret, og du kan opleve begr\xE6nset funktionalitet. Godkend venligst denne applikation igen for at undg\xE5 eventuelle problemer",
        title: "Tilknyttede konti"
      },
      dangerSection: {
        deleteAccountButton: "Slet Konto",
        title: "Konto afslutning"
      },
      emailAddressesSection: {
        destructiveAction: "Fjern e-mailadresse",
        detailsAction__nonPrimary: "S\xE6t som prim\xE6r",
        detailsAction__primary: "Fuldf\xF8r bekr\xE6ftelse",
        detailsAction__unverified: "Fuldf\xF8r bekr\xE6ftelse",
        primaryButton: "Tilf\xF8j en e-mailadresse",
        title: "E-mailadresser"
      },
      enterpriseAccountsSection: {
        title: "Virksomhedskonti"
      },
      headerTitle__account: "Konto",
      headerTitle__security: "Sikkerhed",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Generer koder",
          headerTitle: "Backup-koder",
          subtitle__regenerate: "F\xE5 et nyt s\xE6t sikre backup-koder. Tidligere backup-koder vil blive slettet og kan ikke bruges.",
          title__regenerate: "Generer backup-koder"
        },
        phoneCode: {
          actionLabel__setDefault: "Indstil som standard",
          destructiveActionLabel: "Fjern telefonnummer"
        },
        primaryButton: "Tilf\xF8j totrinsbekr\xE6ftelse",
        title: "Totrinsbekr\xE6ftelse",
        totp: {
          destructiveActionTitle: "Fjern",
          headerTitle: "Autentificeringsapp"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Fjern adgangsn\xF8gle",
        menuAction__rename: "Omd\xF8b adgangsn\xF8gle",
        primaryButton: void 0,
        title: "Adgangsn\xF8gler"
      },
      passwordSection: {
        primaryButton__setPassword: "Indtast adgangskode",
        primaryButton__updatePassword: "Skift adgangskode",
        title: "Adgangskode"
      },
      phoneNumbersSection: {
        destructiveAction: "Fjern telefonnummer",
        detailsAction__nonPrimary: "S\xE6t som prim\xE6r",
        detailsAction__primary: "Fuldf\xF8r bekr\xE6ftelse",
        detailsAction__unverified: "Fuldf\xF8r bekr\xE6ftelse",
        primaryButton: "Tilf\xF8j et telefonnummer",
        title: "Telefonnumre"
      },
      profileSection: {
        primaryButton: "Opdater profil",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "S\xE6t brugernavn",
        primaryButton__updateUsername: "Skift brugernavn",
        title: "Brugernavn"
      },
      web3WalletsSection: {
        destructiveAction: "Fjern tegnebog",
        primaryButton: "Tilf\xF8j Web3 tegneb\xF8ger",
        title: "Web3 tegneb\xF8ger"
      }
    },
    usernamePage: {
      successMessage: "Dit brugernavn er blevet opdateret.",
      title__set: "Indstil brugernavn",
      title__update: "Opdater brugernavn"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} vil blive fjernet fra denne konto.",
        messageLine2: "Du vil ikke l\xE6ngere v\xE6re i stand til at logge ind med denne web3-tegnebog.",
        successMessage: "{{web3Wallet}} er blevet fjernet fra din konto.",
        title: "Fjern web3-tegnebog"
      },
      subtitle__availableWallets: "V\xE6lg en web3-tegnebog for at oprette forbindelse til din konto.",
      subtitle__unavailableWallets: "Der er ingen tilg\xE6ngelige web3-tegneb\xF8ger.",
      successMessage: "Tegnebogen er blevet tilf\xF8jet til din konto.",
      title: "Tilf\xF8j web3-tegnebog",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/de-DE.ts
var deDE = {
  locale: "de-DE",
  backButton: "Zur\xFCck",
  badge__default: "Standard",
  badge__otherImpersonatorDevice: "Anderes Imitationsger\xE4t",
  badge__primary: "Prim\xE4r",
  badge__requiresAction: "Erfordert Handeln",
  badge__thisDevice: "Dieses Ger\xE4t",
  badge__unverified: "Unbest\xE4tigt",
  badge__userDevice: "Benutzerger\xE4t",
  badge__you: "Du",
  createOrganization: {
    formButtonSubmit: "Organisation erstellen",
    invitePage: {
      formButtonReset: "\xDCberspringen"
    },
    title: "Organisation erstellen"
  },
  dates: {
    lastDay: "Gestern um {{ date | timeString('de-DE') }}",
    next6Days: "{{ date | weekday('de-DE','long') }} bei {{ date | timeString('de-DE') }}",
    nextDay: "Morgen um {{ date | timeString('de-DE') }}",
    numeric: "{{ date | numeric('de-DE') }}",
    previous6Days: "Letzte {{ date | weekday('de-DE','long') }} um {{ date | timeString('de-DE') }}",
    sameDay: "Heute um {{ date | timeString('de-DE') }}"
  },
  dividerText: "oder",
  footerActionLink__useAnotherMethod: "Verwenden Sie eine andere Methode",
  footerPageLink__help: "Hilfe",
  footerPageLink__privacy: "Privatsph\xE4re",
  footerPageLink__terms: "Bedingungen",
  formButtonPrimary: "Fortsetzen",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Passwort vergessen?",
  formFieldError__matchingPasswords: "Passw\xF6rter stimmen \xFCberein.",
  formFieldError__notMatchingPasswords: "Passw\xF6rter stimmen nicht \xFCberein.",
  formFieldError__verificationLinkExpired: "Der Best\xE4tigungslink ist abgelaufen. Bitte fordern Sie einen neuen Link an.",
  formFieldHintText__optional: "Optional",
  formFieldHintText__slug: "Der Slug ist eine f\xFCr Menschen lesbare ID. Sie muss einzigartig sein und wird oft in URLs verwendet.",
  formFieldInputPlaceholder__backupCode: "Sicherheitscode eingeben",
  formFieldInputPlaceholder__confirmDeletionUserAccount: void 0,
  formFieldInputPlaceholder__emailAddress: "E-Mail-Adresse eingeben",
  formFieldInputPlaceholder__emailAddress_username: "E-Mail-Adresse oder Benutzername eingeben",
  formFieldInputPlaceholder__emailAddresses: void 0,
  formFieldInputPlaceholder__firstName: "Vorname eingeben",
  formFieldInputPlaceholder__lastName: "Nachname eingeben",
  formFieldInputPlaceholder__organizationDomain: "Organisations-Domain eingeben",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "E-Mail-Adresse der Organisations-Domain eingeben",
  formFieldInputPlaceholder__organizationName: "Name der Organisation eingeben",
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: "Passwort eingeben",
  formFieldInputPlaceholder__phoneNumber: "Telefonnummer eingeben",
  formFieldInputPlaceholder__username: "Benutzername eingeben",
  formFieldLabel__automaticInvitations: "Aktivieren Sie automatische Einladungen f\xFCr diese Domain",
  formFieldLabel__backupCode: "Sicherungscode",
  formFieldLabel__confirmDeletion: "Best\xE4tigung",
  formFieldLabel__confirmPassword: "Passwort best\xE4tigen",
  formFieldLabel__currentPassword: "Aktuelles Passwort",
  formFieldLabel__emailAddress: "E-Mail-Adresse",
  formFieldLabel__emailAddress_username: "E-Mail-Adresse oder Benutzername",
  formFieldLabel__emailAddresses: "E-Mail-Adressen",
  formFieldLabel__firstName: "Vorname",
  formFieldLabel__lastName: "Nachname",
  formFieldLabel__newPassword: "Neues Passwort",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Ausstehende Einladungen und Vorschl\xE4ge l\xF6schen",
  formFieldLabel__organizationDomainEmailAddress: "E-Mail-Adresse f\xFCr die Verifizierung",
  formFieldLabel__organizationDomainEmailAddressDescription: "Geben Sie eine E-Mail-Adresse dieser Domain ein, um einen Code zu erhalten und diese Domain zu verifizieren.",
  formFieldLabel__organizationName: "Organisationsname",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Name des Passkeys",
  formFieldLabel__password: "Passwort",
  formFieldLabel__phoneNumber: "Telefonnummer",
  formFieldLabel__role: "Rolle",
  formFieldLabel__signOutOfOtherSessions: "Alle anderen Ger\xE4te abmelden",
  formFieldLabel__username: "Nutzername",
  impersonationFab: {
    action__signOut: "Ausloggen",
    title: "Angemeldet als {{identifier}}"
  },
  maintenanceMode: "Wir f\xFChren derzeit Wartungsarbeiten durch, aber keine Sorge, es sollte nicht l\xE4nger als ein paar Minuten dauern.",
  membershipRole__admin: "Administrator",
  membershipRole__basicMember: "Mitglied",
  membershipRole__guestMember: "Gast",
  organizationList: {
    action__createOrganization: "Organisation erstellen",
    action__invitationAccept: "Beitreten",
    action__suggestionsAccept: "Beitritt anfragen",
    createOrganization: "Organisation erstellen",
    invitationAcceptedLabel: "Beitreten",
    subtitle: "um fortzufahren zu {{applicationName}}",
    suggestionsAcceptedLabel: "Genehmigung ausstehend",
    title: "Konto ausw\xE4hlen",
    titleWithoutPersonal: "Organisation ausw\xE4hlen"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatische Einladungen",
    badge__automaticSuggestion: "Automatische Vorschl\xE4ge",
    badge__manualInvitation: "Keine automatische Aufnahme",
    badge__unverified: "Nicht verifiziert",
    createDomainPage: {
      subtitle: "F\xFCgen Sie die zu \xFCberpr\xFCfende Domain hinzu. Benutzer mit E-Mail-Adressen von dieser Domain k\xF6nnen der Organisation automatisch beitreten oder einen Antrag auf Beitritt stellen.",
      title: "Domain hinzuf\xFCgen"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Die Einladungen konnten nicht versendet werden. Beheben Sie Folgendes und versuchen Sie es erneut:",
      formButtonPrimary__continue: "Einladungen verschicken",
      selectDropdown__role: "Rolle w\xE4hlen",
      subtitle: "Laden Sie neue Mitglieder zu dieser Organisation ein",
      successMessage: "Einladungen erfolgreich versendet",
      title: "Mitglieder einladen"
    },
    membersPage: {
      action__invite: "Einladen",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Mitglied entfernen",
        tableHeader__actions: "Aktionen",
        tableHeader__joined: "Trat bei",
        tableHeader__role: "Rolle",
        tableHeader__user: "Benutzer"
      },
      detailsTitle__emptyRow: "Keine Mitglieder zum Anzeigen",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Laden Sie Benutzer ein, indem Sie eine E-Mail-Domain mit Ihrer Organisation verbinden. Jeder, der sich mit dieser passenden E-Mail-Domain anmeldet, kann der Organisation jederzeit beitreten.",
          headerTitle: "Automatische Einladungen",
          primaryButton: "Verwalten Sie verifizierte Domains"
        },
        table__emptyRow: "Keine Einladungen verf\xFCgbar"
      },
      invitedMembersTab: {
        menuAction__revoke: "Einladung widerrufen",
        tableHeader__invited: "Eingeladen"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Benutzer, die sich mit einer passenden E-Mail-Domain anmelden, k\xF6nnen einen Vorschlag f\xFCr eine Beitrittsanfrage zu Ihrer Organisation sehen.",
          headerTitle: "Automatische Vorschl\xE4ge",
          primaryButton: "Verifizierte Domains verwalten"
        },
        menuAction__approve: "Best\xE4tigen",
        menuAction__reject: "Ablehnen",
        tableHeader__requested: "Angefragte Zug\xE4nge",
        table__emptyRow: "Keine Anfragen verf\xFCgbar"
      },
      start: {
        headerTitle__invitations: "Einladungen",
        headerTitle__members: "Mitglieder",
        headerTitle__requests: "Anfragen"
      }
    },
    navbar: {
      description: "Verwalten Sie ihre Organisation.",
      general: "Allgemein",
      members: "Mitglieder",
      title: "Organisation"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Geben Sie "{{organizationName}}" unten ein, um fortzufahren.',
          messageLine1: "Sind Sie sicher, dass Sie diese Organisation l\xF6schen wollen?",
          messageLine2: "Diese Aktion ist dauerhaft und irreversibel.",
          successMessage: "Sie haben die Organisation gel\xF6scht.",
          title: "Organisation l\xF6schen"
        },
        leaveOrganization: {
          actionDescription: 'Geben Sie "{{organizationName}}" unten ein, um fortzufahren.',
          messageLine1: "M\xF6chten Sie diese Organisation wirklich verlassen? Sie verlieren den Zugriff auf diese Organisation und Ihre Anwendungen.",
          messageLine2: "Diese Aktion ist dauerhaft und irreversibel.",
          successMessage: "Sie haben die Organisation verlassen.",
          title: "Organisation verlassen"
        },
        title: "Achtung"
      },
      domainSection: {
        menuAction__manage: "Verwalten",
        menuAction__remove: "L\xF6schen",
        menuAction__verify: "Verifizieren",
        primaryButton: "Domain hinzuf\xFCgen",
        subtitle: "Erlauben Sie Benutzern, der Organisation automatisch beizutreten oder den Beitritt auf der Grundlage einer verifizierten E-Mail-Domain anzufragen.",
        title: "Verifizierte Domains"
      },
      successMessage: "Die Organisation wurde aktualisiert.",
      title: "Organisationsprofil"
    },
    removeDomainPage: {
      messageLine1: "Die E-mail-Domain {{domain}} wird entfernt.",
      messageLine2: "Benutzer k\xF6nnen der Organisation danach nicht mehr automatisch beitreten.",
      successMessage: "{{domain}} wurde entfernt.",
      title: "Domain entfernen"
    },
    start: {
      headerTitle__general: "Allgemein",
      headerTitle__members: "Mitglieder",
      profileSection: {
        primaryButton: "Profil bearbeiten",
        title: "Organisationsprofil",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Das Entfernen dieser Domain betrifft die eingeladenen Benutzer.",
        removeDomainActionLabel__remove: "Domain entfernen",
        removeDomainSubtitle: "Sie k\xF6nnen diese Domain von den verifizierten Domains entfernen",
        removeDomainTitle: "Domain entfernen"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Benutzer werden bei der Anmeldung automatisch eingeladen, der Organisation beizutreten, und k\xF6nnen jederzeit beitreten.",
        automaticInvitationOption__label: "Automatische Einladungen",
        automaticSuggestionOption__description: "Benutzer erhalten einen Vorschlag f\xFCr eine Beitrittsanfrage, m\xFCssen aber von einem Administrator genehmigt werden, bevor sie der Organisation beitreten k\xF6nnen.",
        automaticSuggestionOption__label: "Automatische Vorschl\xE4ge",
        calloutInfoLabel: "\xC4nderungen des Anmeldemodus wirkt sich nur auf neue Benutzer aus.",
        calloutInvitationCountLabel: "Ausstehende Einladungen gesendet an Benutzer: {{count}}",
        calloutSuggestionCountLabel: "Ausstehende Vorschl\xE4ge gesendet an Benutzer: {{count}}",
        manualInvitationOption__description: "Benutzer k\xF6nnen nur manuell in die Organisation eingeladen werden.",
        manualInvitationOption__label: "Keine automatische Aufnahme",
        subtitle: "W\xE4hlen Sie, wie Benutzer mit dieser Domain der Organisation beitreten k\xF6nnen."
      },
      start: {
        headerTitle__danger: "Gefahr",
        headerTitle__enrollment: "Optionen f\xFCr die Aufnahme"
      },
      subtitle: "Die Domain {{domain}} ist nun verifiziert. Bitte w\xE4hlen Sie einen Aufnahmemodus aus.",
      title: "{{domain}} aktualisieren"
    },
    verifyDomainPage: {
      formSubtitle: "Geben Sie den an Ihre E-Mail-Adresse gesendeten Verifizierungscode ein",
      formTitle: "Verifizierungscode",
      resendButton: "Sie haben keinen Code erhalten? Erneut senden",
      subtitle: "Die Domain {{domainName}} muss per E-mail verifiziert werden.",
      subtitleVerificationCodeScreen: "Ein Verifizierungscode wurde an {{emailAddress}} gesendet. Geben Sie den Code ein, um fortzufahren.",
      title: "Domain verifizieren"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Organisation erstellen",
    action__invitationAccept: "Beitreten",
    action__manageOrganization: "Organisation verwalten",
    action__suggestionsAccept: "Beitritt anfragen",
    notSelected: "Keine Organisation ausgew\xE4hlt",
    personalWorkspace: "Pers\xF6nlicher Arbeitsbereich",
    suggestionsAcceptedLabel: "Annahme ausstehend"
  },
  paginationButton__next: "N\xE4chste",
  paginationButton__previous: "Vorherige",
  paginationRowText__displaying: "Anzeigen",
  paginationRowText__of: "von",
  reverification: {
    alternativeMethods: {
      actionLink: "Klicken Sie hier, um eine alternative Methode zu verwenden",
      actionText: "Verwenden Sie eine alternative Verifizierungsmethode",
      blockButton__backupCode: "Mit Backup-Code verifizieren",
      blockButton__emailCode: "Mit E-Mail-Code verifizieren",
      blockButton__password: "Mit Passwort verifizieren",
      blockButton__phoneCode: "Mit SMS-Code verifizieren",
      blockButton__totp: "Mit TOTP verifizieren",
      getHelp: {
        blockButton__emailSupport: "E-Mail-Support kontaktieren",
        content: "Wenn Sie Hilfe ben\xF6tigen, wenden Sie sich bitte an unseren Support.",
        title: "Hilfe erhalten"
      },
      subtitle: "W\xE4hlen Sie eine Methode, um sich zu verifizieren",
      title: "Verifizierung erforderlich"
    },
    backupCodeMfa: {
      subtitle: "Verwenden Sie den Backup-Code, der Ihnen bei der Registrierung zur Verf\xFCgung gestellt wurde.",
      title: "Backup-Code Verifizierung"
    },
    emailCode: {
      formTitle: "Geben Sie den Code ein, den wir an Ihre E-Mail-Adresse gesendet haben.",
      resendButton: "Code erneut senden",
      subtitle: "\xDCberpr\xFCfen Sie Ihre E-Mail auf den Verifizierungscode.",
      title: "E-Mail-Code Verifizierung"
    },
    noAvailableMethods: {
      message: "Es sind keine Verifizierungsmethoden mehr verf\xFCgbar.",
      subtitle: "Bitte kontaktieren Sie den Support, um Hilfe zu erhalten.",
      title: "Keine verf\xFCgbaren Methoden"
    },
    password: {
      actionLink: "Passwort zur\xFCcksetzen",
      subtitle: "Geben Sie Ihr Passwort ein, um fortzufahren.",
      title: "Passwort-Verifizierung"
    },
    phoneCode: {
      formTitle: "Geben Sie den Code ein, den wir an Ihre Telefonnummer gesendet haben.",
      resendButton: "Code erneut senden",
      subtitle: "\xDCberpr\xFCfen Sie Ihre SMS-Nachricht auf den Verifizierungscode.",
      title: "SMS-Code Verifizierung"
    },
    phoneCodeMfa: {
      formTitle: "Geben Sie den Code ein, den wir Ihnen per SMS gesendet haben.",
      resendButton: "Code erneut senden",
      subtitle: "\xDCberpr\xFCfen Sie Ihre SMS auf den Verifizierungscode.",
      title: "SMS-Code (MFA) Verifizierung"
    },
    totpMfa: {
      formTitle: "Geben Sie den Code aus Ihrer Authentifikator-App ein.",
      subtitle: "Verwenden Sie die Authentifikator-App, die Sie eingerichtet haben.",
      title: "TOTP-Verifizierung (MFA)"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Konto hinzuf\xFCgen",
      action__signOutAll: "Von allen Konten abmelden",
      subtitle: "W\xE4hlen Sie das Konto, mit dem Sie fortfahren m\xF6chten.",
      title: "W\xE4hlen Sie ein Konto"
    },
    alternativeMethods: {
      actionLink: "Hilfe",
      actionText: "Haben Sie keine davon?",
      blockButton__backupCode: "Verwenden Sie einen Backup-Code",
      blockButton__emailCode: "Code an {{identifier}} senden",
      blockButton__emailLink: "Link senden an {{identifier}}",
      blockButton__passkey: "Melden Sie sich mit Ihrem Passkey an",
      blockButton__password: "Melden Sie sich mit Ihrem Passwort an",
      blockButton__phoneCode: "Code an {{identifier}} senden",
      blockButton__totp: "Verwenden Sie Ihre Authentifizierungs-App",
      getHelp: {
        blockButton__emailSupport: "Unterst\xFCtzung per E-Mail",
        content: "Wenn Sie Schwierigkeiten haben, sich mit Ihrem Konto anzumelden, senden Sie uns eine E-Mail und wir werden mit Ihnen zusammenarbeiten, um den Zugriff so schnell wie m\xF6glich wiederherzustellen.",
        title: "Hilfe"
      },
      subtitle: "Haben Sie Probleme? Sie k\xF6nnen eine der folgenden Methoden zur Anmeldung verwenden.",
      title: "Verwenden Sie eine andere Methode"
    },
    backupCodeMfa: {
      subtitle: "weiter zu {{applicationName}}",
      title: "Geben Sie einen Backup-Code ein"
    },
    emailCode: {
      formTitle: "Best\xE4tigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "\xDCberpr\xFCfen Sie Ihren Posteingang"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Die Anfrage stammt von einem nicht kompatiblen Client.",
        title: "Client-Kompatibilit\xE4tsfehler"
      },
      expired: {
        subtitle: "Kehren Sie zum urspr\xFCnglichen Tab zur\xFCck, um fortzufahren.",
        title: "Dieser Best\xE4tigungslink ist abgelaufen"
      },
      failed: {
        subtitle: "Kehren Sie zum urspr\xFCnglichen Tab zur\xFCck, um fortzufahren.",
        title: "Dieser Best\xE4tigungslink ist ung\xFCltig"
      },
      formSubtitle: "Verwenden Sie den an Ihre E-Mail gesendeten Best\xE4tigungslink",
      formTitle: "Best\xE4tigungslink",
      loading: {
        subtitle: "Sie werden in K\xFCrze weitergeleitet",
        title: "Einloggen..."
      },
      resendButton: "Link erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "\xDCberpr\xFCfen Sie Ihren Posteingang",
      unusedTab: {
        title: "Sie k\xF6nnen diesen Tab schlie\xDFen"
      },
      verified: {
        subtitle: "Sie werden in K\xFCrze weitergeleitet",
        title: "Erfolgreich angemeldet"
      },
      verifiedSwitchTab: {
        subtitle: "Kehren Sie zum urspr\xFCnglichem Tab zur\xFCck, um fortzufahren",
        subtitleNewTab: "Kehren Sie zum neu ge\xF6ffneten Tab zur\xFCck, um fortzufahren",
        titleNewTab: "In einem anderen Tab angemeldet"
      }
    },
    forgotPassword: {
      formTitle: "Passwort-Code zur\xFCcksetzen",
      resendButton: "Sie haben keinen Code erhalten? Erneut senden",
      subtitle: "um Passwort zur\xFCckzusetzen",
      subtitle_email: "Geben Sie zun\xE4chst den an Ihre E-Mail gesendeten Code ein",
      subtitle_phone: "Geben Sie zun\xE4chst den auf Ihr Mobiltelefon geschickten Code ein",
      title: "Passwort zur\xFCcksetzen"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Passwort zur\xFCcksetzen",
      label__alternativeMethods: "Oder melden Sie sich mit einer anderen Methode an",
      title: "Passwort vergessen?"
    },
    noAvailableMethods: {
      message: "Die Anmeldung kann nicht fortgesetzt werden. Es ist kein Authentifizierungsfaktor verf\xFCgbar.",
      subtitle: "Ein Fehler ist aufgetreten",
      title: "Anmeldung nicht m\xF6glich"
    },
    passkey: {
      subtitle: "Die Verwendung Ihres Passkeys best\xE4tigt, dass Sie es sind. Ihr Ger\xE4t kann nach Ihrem Fingerabdruck, Ihrem Gesicht oder der Bildschirmsperre fragen.",
      title: "Verwenden Sie Ihren Passkey"
    },
    password: {
      actionLink: "Verwenden Sie eine andere Methode",
      subtitle: "weiter zu {{applicationName}}",
      title: "Geben Sie Ihr Passwort ein"
    },
    passwordPwned: {
      title: "Passwort kompromittiert"
    },
    phoneCode: {
      formTitle: "Best\xE4tigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Schau auf dein Telefon"
    },
    phoneCodeMfa: {
      formTitle: "Best\xE4tigungscode",
      resendButton: "Code erneut senden",
      subtitle: "Um fortzufahren, geben Sie bitte den Best\xE4tigungscode ein, der an Ihre Telefonnummer gesendet wurde",
      title: "Schau auf dein Telefon"
    },
    resetPassword: {
      formButtonPrimary: "Passwort zur\xFCcksetzen",
      requiredMessage: "Es existiert bereits ein Konto mit einer nicht verifizierten E-Mail Adresse. Bitte setzen Sie Ihr Passwort zur Sicherheit zur\xFCck.",
      successMessage: "Ihr Passwort wurde erfolgreich ge\xE4ndert. Bitte warten Sie einen Moment, um Sie anzumelden.",
      title: "Neues Passwort setzen"
    },
    resetPasswordMfa: {
      detailsLabel: "Bevor wir Ihr Passwort zur\xFCcksetzen k\xF6nnen, m\xFCssen wir Ihre Identit\xE4t \xFCberpr\xFCfen."
    },
    start: {
      actionLink: "Anmelden",
      actionLink__join_waitlist: "Warteliste beitreten",
      actionLink__use_email: "E-mail nutzen",
      actionLink__use_email_username: "E-mail oder Benutzernamen nutzen",
      actionLink__use_passkey: "Passkey nutzen",
      actionLink__use_phone: "Mobiltelefon nutzen",
      actionLink__use_username: "Benutzername nutzen",
      actionText: "Kein Account?",
      actionText__join_waitlist: "Warteliste beitreten",
      subtitle: "weiter zu {{applicationName}}",
      subtitleCombined: void 0,
      title: "Einloggen",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Best\xE4tigungscode",
      subtitle: "Um fortzufahren, geben Sie bitte den Verifizierungscode ein, der von Ihrer Authenticator-App generiert wurde.",
      title: "Best\xE4tigung in zwei Schritten"
    }
  },
  signInEnterPasswordTitle: "Geben Sie Ihr Passwort ein",
  signUp: {
    continue: {
      actionLink: "Einloggen",
      actionText: "Haben Sie ein Konto?",
      subtitle: "weiter zu {{applicationName}}",
      title: "F\xFCllen Sie fehlende Felder aus"
    },
    emailCode: {
      formSubtitle: "Geben Sie den Best\xE4tigungscode ein, der an Ihre E-Mail-Adresse gesendet wurde",
      formTitle: "Best\xE4tigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Best\xE4tigen Sie Ihre E-Mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Die Anfrage konnte nicht verarbeitet werden, da der Client nicht kompatibel ist.",
        title: "Fehler: Inkompatibler Client"
      },
      formSubtitle: "Verwenden Sie den an Ihre E-Mail-Adresse gesendeten Best\xE4tigungslink",
      formTitle: "Best\xE4tigungslink",
      loading: {
        title: "Anmeldung..."
      },
      resendButton: "Link erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Best\xE4tigen Sie Ihre E-Mail",
      verified: {
        title: "Erfolgreich angemeldet"
      },
      verifiedSwitchTab: {
        subtitle: "Kehren Sie zum neu ge\xF6ffneten Tab zur\xFCck, um fortzufahren",
        subtitleNewTab: "Kehren Sie zum vorherigen Tab zur\xFCck, um fortzufahren",
        title: "E-Mail erfolgreich verifiziert"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Ich stimme der {{ privacyPolicyLink || link("Datenschutzerkl\xE4rung") }} zu',
        label__onlyTermsOfService: 'Ich stimme den {{ termsOfServiceLink || link("Nutzungsbedingungen") }} zu',
        label__termsOfServiceAndPrivacyPolicy: 'Ich stimme den {{ termsOfServiceLink || link("Nutzungsbedingungen") }} und der {{ privacyPolicyLink || link("Datenschutzerkl\xE4rung") }} zu'
      },
      continue: {
        subtitle: "Bitte lesen und akzeptieren Sie die Bedingungen, um fortzufahren",
        title: "Rechtliche Einwilligung"
      }
    },
    phoneCode: {
      formSubtitle: "Geben Sie den Best\xE4tigungscode ein, der an Ihre Telefonnummer gesendet wurde",
      formTitle: "Best\xE4tigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Verifizieren Sie Ihre Telefonnummer"
    },
    restrictedAccess: {
      actionLink: "Mehr erfahren",
      actionText: "Zugang verweigert?",
      blockButton__emailSupport: "E-Mail-Support kontaktieren",
      blockButton__joinWaitlist: "Warteliste beitreten",
      subtitle: "Ihr Zugang ist momentan eingeschr\xE4nkt.",
      subtitleWaitlist: "Treten Sie der Warteliste bei, um Benachrichtigungen zu erhalten.",
      title: "Zugang verweigert"
    },
    start: {
      actionLink: "Einloggen",
      actionLink__use_email: "Mit E-Mail einloggen",
      actionLink__use_phone: "Mit Telefonnummer einloggen",
      actionText: "Haben Sie ein Konto?",
      subtitle: "weiter zu {{applicationName}}",
      subtitleCombined: "weiter zu {{applicationName}}",
      title: "Erstelle deinen Account",
      titleCombined: "Erstelle deinen Account"
    }
  },
  socialButtonsBlockButton: "Weiter mit {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "Sie sind bereits Mitglied in dieser Organisation.",
    captcha_invalid: "Anmeldung aufgrund fehlgeschlagener Sicherheits\xFCberpr\xFCfung nicht erfolgreich. Bitte versuchen Sie es erneut oder kontaktieren Sie uns f\xFCr weitere Unterst\xFCtzung.",
    captcha_unavailable: "Die Anmeldung ist aufgrund einer fehlgeschlagenen Bot-Validierung fehlgeschlagen. Bitte aktualisieren Sie die Seite, um es erneut zu versuchen, oder wenden Sie sich an den Support, um weitere Unterst\xFCtzung zu erhalten.",
    form_code_incorrect: "Der eingegebene Code ist falsch. Bitte \xFCberpr\xFCfen Sie ihn und versuchen Sie es erneut.",
    form_identifier_exists__email_address: "Diese E-Mail-Adresse ist bereits vergeben. Bitte w\xE4hlen Sie eine andere.",
    form_identifier_exists__phone_number: "Diese Telefonnummer ist bereits vergeben. Bitte w\xE4hlen Sie eine andere.",
    form_identifier_exists__username: "Dieser Benutzername ist bereits vergeben. Bitte w\xE4hlen Sie einen anderen.",
    form_identifier_not_found: "Die eingegebene Kennung wurde nicht gefunden. Bitte \xFCberpr\xFCfen Sie Ihre Eingabe.",
    form_param_format_invalid: "Das Format des eingegebenen Parameters ist ung\xFCltig.",
    form_param_format_invalid__email_address: "Bitte geben Sie eine g\xFCltige E-Mail-Adresse ein.",
    form_param_format_invalid__phone_number: "Die Telefonnummer muss ein g\xFCltiges internationales Format haben.",
    form_param_max_length_exceeded__first_name: "Der Vorname sollte nicht mehr als 256 Zeichen umfassen.",
    form_param_max_length_exceeded__last_name: "Der Nachname sollte nicht mehr als 256 Zeichen umfassen.",
    form_param_max_length_exceeded__name: "Der Name sollte nicht l\xE4nger als 256 Zeichen sein.",
    form_param_nil: "Ein erforderliches Feld wurde nicht ausgef\xFCllt. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben.",
    form_param_value_invalid: "Der eingegebene Wert ist ung\xFCltig.",
    form_password_incorrect: "Das eingegebene Passwort ist falsch.",
    form_password_length_too_short: "Das Passwort ist zu kurz. Es muss mindestens 8 Zeichen lang sein.",
    form_password_not_strong_enough: "Passwort nicht stark genug.",
    form_password_pwned: "Das gew\xE4hlte Passwort wurde bei einem Datenleck im Internet gefunden. W\xE4hlen Sie aus Sicherheitsgr\xFCnden bitte ein anderes Passwort.",
    form_password_pwned__sign_in: "Dieses Passwort wurde in einem Datenleck gefunden und kann nicht verwendet werden. Bitte setzen Sie Ihr Passwort zur\xFCck.",
    form_password_size_in_bytes_exceeded: "Das Passwort hat die maximale Anzahl an Bytes \xFCberschritten. Bitte k\xFCrzen oder Sonderzeichen entfernen.",
    form_password_validation_failed: "Falsches Passwort.",
    form_username_invalid_character: "Der Benutzername enth\xE4lt ung\xFCltige Zeichen. Bitte verwenden Sie nur alphanumerische Zeichen und Unterstriche.",
    form_username_invalid_length: "Der Benutzername muss zwischen 3 und 30 Zeichen lang sein.",
    identification_deletion_failed: "Sie k\xF6nnen Ihre letzte Kennung nicht l\xF6schen.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "Auf diesem Ger\xE4t ist bereits ein Passkey registriert.",
    passkey_not_supported: "Passkeys werden auf diesem Ger\xE4t nicht unterst\xFCtzt.",
    passkey_pa_not_supported: "Die Registrierung erfordert einen Plattformauthentifikator, der vom Ger\xE4t nicht unterst\xFCtzt wird.",
    passkey_registration_cancelled: "Die Passkey-Registrierung wurde abgebrochen oder das Zeitlimit wurde \xFCberschritten.",
    passkey_retrieval_cancelled: "Die Passkey-Registrierung wurde abgebrochen oder das Zeitlimit wurde \xFCberschritten.",
    passwordComplexity: {
      maximumLength: "weniger als {{length}} Zeichen lang sein",
      minimumLength: "mindestens {{length}} Zeichen lang sein",
      requireLowercase: "einen Kleinbuchstaben enthalten",
      requireNumbers: "eine Zahl enthalten",
      requireSpecialCharacter: "ein Sonderzeichen enthalten",
      requireUppercase: "einen Gro\xDFbuchstaben enthalten",
      sentencePrefix: "Das Passwort muss"
    },
    phone_number_exists: "Diese Telefonnummer ist bereits vergeben. Bitte w\xE4hlen Sie eine Andere.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Ihr Passwort funktioniert, k\xF6nnte aber besser sein. Versuchen Sie, mehr Zeichen hinzuzuf\xFCgen.",
      goodPassword: "Ihr Passwort erf\xFCllt alle notwendigen Anforderungen.",
      notEnough: "Ihr Passwort ist nicht stark genug.",
      suggestions: {
        allUppercase: "Einige, aber nicht alle Buchstaben gro\xDF schreiben.",
        anotherWord: "Weitere W\xF6rter, die weniger h\xE4ufig vorkommen, hinzuf\xFCgen.",
        associatedYears: "Jahre, die mit pers\xF6nlichen Daten in Verbindung gebracht werden k\xF6nnen, vermeiden.",
        capitalization: "Nicht nur den ersten Buchstaben gro\xDF schreiben.",
        dates: "Daten, die mit pers\xF6nlichen Daten in Verbindung gebracht werden k\xF6nnen, vermeiden.",
        l33t: "Vorhersehbare Buchstabenersetzungen wie '@' f\xFCr 'a' vermeiden.",
        longerKeyboardPattern: "L\xE4ngere Tastaturmuster in unterschiedlicher Tipprichtung verwenden.",
        noNeed: "Es ist m\xF6glich, starke Passw\xF6rter zu erstellen, ohne Symbole, Zahlen oder Gro\xDFbuchstaben zu verwenden.",
        pwned: "Wenn Sie dieses Passwort an anderer Stelle verwenden, sollten Sie es \xE4ndern.",
        recentYears: "Die j\xFCngsten Jahreszahlen vermeiden.",
        repeated: "Wort- und Zeichenwiederholungen vermeiden.",
        reverseWords: "Umgekehrte Schreibweise von gebr\xE4uchlichen W\xF6rtern vermeiden.",
        sequences: "H\xE4ufige Zeichenfolgen vermeiden.",
        useWords: "Mehrere W\xF6rter verwenden, aber allgemeine Phrasen vermeiden."
      },
      warnings: {
        common: "Dies ist ein oft verwendetes Passwort.",
        commonNames: "Vornamen und Nachnamen sind leicht zu erraten.",
        dates: "Ein Datum ist leicht zu erraten.",
        extendedRepeat: 'Sich wiederholende Zeichenmuster wie "abcabcabc" sind leicht zu erraten.',
        keyPattern: "Kurze Tastaturmuster sind leicht zu erraten.",
        namesByThemselves: "Einzelne Namen oder Nachnamen sind leicht zu erraten.",
        pwned: "Ihr Passwort wurde durch eine Datenpanne im Internet offengelegt.",
        recentYears: "Die j\xFCngsten Jahreszahlen sind leicht zu erraten.",
        sequences: 'H\xE4ufige Zeichenfolgen wie "abc" sind leicht zu erraten.',
        similarToCommon: "Dies weist \xC4hnlichkeit zu anderen oft verwendeten Passw\xF6rtern auf.",
        simpleRepeat: 'Sich wiederholende Zeichen wie "aaa" sind leicht zu erraten.',
        straightRow: "Gerade Linien von Tasten auf der Tastatur sind leicht zu erraten.",
        topHundred: "Dies ist ein h\xE4ufig verwendetes Passwort.",
        topTen: "Dies ist ein sehr h\xE4ufig verwendetes Passwort.",
        userInputs: "Es sollten keine pers\xF6nlichen oder Seiten relevanten Daten vorkommen.",
        wordByItself: "Einzelne W\xF6rter sind leicht zu erraten."
      }
    }
  },
  userButton: {
    action__addAccount: "Konto hinzuf\xFCgen",
    action__manageAccount: "Konto verwalten",
    action__signOut: "Ausloggen",
    action__signOutAll: "Melden Sie sich von allen Konten ab"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopiert!",
      actionLabel__copy: "Kopiere alle",
      actionLabel__download: "Laden Sie .txt herunter",
      actionLabel__print: "Drucken",
      infoText1: "Backup-Codes werden f\xFCr dieses Konto aktiviert.",
      infoText2: "Halten Sie die Backup-Codes geheim und bewahren Sie sie sicher auf. Sie k\xF6nnen Sicherungscodes neu generieren, wenn Sie vermuten, dass sie kompromittiert wurden.",
      subtitle__codelist: "Bewahren Sie die Codes sicher auf und halten Sie sie geheim.",
      successMessage: "Sicherungscodes sind jetzt aktiviert. Sie k\xF6nnen eines davon verwenden, um sich bei Ihrem Konto anzumelden, wenn Sie den Zugriff auf Ihr Authentifizierungsger\xE4t verlieren. Jeder Code kann nur einmal verwendet werden.",
      successSubtitle: "Sie k\xF6nnen diese Codes verwenden, um sich bei Ihrem Konto anzumelden, wenn Sie den Zugriff auf Ihr Authentifizierungsger\xE4t verlieren.",
      title: "Backup-Code-Verifizierung hinzuf\xFCgen",
      title__codelist: "Sicherungscodes"
    },
    connectedAccountPage: {
      formHint: "W\xE4hlen Sie einen Anbieter aus, um Ihr Konto zu verbinden.",
      formHint__noAccounts: "Es sind keine externen Kontoanbieter verf\xFCgbar.",
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2: "Sie k\xF6nnen dieses verbundene Konto nicht mehr verwenden und alle abh\xE4ngigen Funktionen funktionieren nicht mehr.",
        successMessage: "{{connectedAccount}} wurde aus Ihrem Konto entfernt.",
        title: "Verbundenes Konto entfernen"
      },
      socialButtonsBlockButton: "{{provider|titleize}}-Konto verbinden",
      successMessage: "Der Anbieter wurde Ihrem Konto hinzugef\xFCgt",
      title: "Verbundenes Konto hinzuf\xFCgen"
    },
    deletePage: {
      actionDescription: 'Geben Sie "Konto l\xF6schen" ein, um fortzufahren.',
      confirm: "Konto l\xF6schen",
      messageLine1: "Sind Sie sicher, dass Sie ihr Konto l\xF6schen m\xF6chten?",
      messageLine2: "Diese Aktion ist endg\xFCltig und kann nicht r\xFCckg\xE4ngig gemacht werden.",
      title: "Konto l\xF6schen"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "An diese E-Mail-Adresse wird eine E-Mail mit einem Best\xE4tigungscode gesendet.",
        formSubtitle: "Geben Sie den Best\xE4tigungscode ein, der an {{identifier}} gesendet wird",
        formTitle: "Verifizierungs-Schl\xFCssel",
        resendButton: "Code erneut senden",
        successMessage: "Die E-Mail-Adresse {{identifier}} wurde Ihrem Konto hinzugef\xFCgt."
      },
      emailLink: {
        formHint: "An diese E-Mail-Adresse wird eine E-Mail mit einem Best\xE4tigungslink gesendet.",
        formSubtitle: "Klicken Sie auf den Best\xE4tigungslink in der an {{identifier}} gesendeten E-Mail",
        formTitle: "Best\xE4tigungslink",
        resendButton: "Link erneut senden",
        successMessage: "Die E-Mail-Adresse {{identifier}} wurde Ihrem Konto hinzugef\xFCgt."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2: "Sie k\xF6nnen sich nicht mehr mit dieser E-Mail-Adresse anmelden.",
        successMessage: "{{emailAddress}} wurde aus Ihrem Konto entfernt.",
        title: "E-Mail-Adresse entfernen"
      },
      title: "E-Mail-Adresse hinzuf\xFCgen",
      verifyTitle: "E-Mail Adresse verifizieren"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Fortsetzen",
    formButtonPrimary__finish: "Fertig",
    formButtonPrimary__remove: "Entfernen",
    formButtonPrimary__save: "Speichern",
    formButtonReset: "Zur\xFCcksetzen",
    mfaPage: {
      formHint: "W\xE4hlen Sie eine Methode aus.",
      title: "Aktivieren Sie Zweifaktor-Authentifizierung"
    },
    mfaPhoneCodePage: {
      backButton: "Vorhandene Nummer verwenden",
      primaryButton__addPhoneNumber: "F\xFCgen Sie eine Telefonnummer hinzu",
      removeResource: {
        messageLine1: "{{identifier}} erh\xE4lt bei der Anmeldung keine Best\xE4tigungscodes mehr.",
        messageLine2: "Ihr Konto ist m\xF6glicherweise nicht so sicher. Bist du dir sicher, dass du weitermachen willst?",
        successMessage: "SMS-Code-Best\xE4tigung in zwei Schritten wurde f\xFCr {{mfaPhoneCode}} entfernt",
        title: "Entfernen Sie die Best\xE4tigung in zwei Schritten"
      },
      subtitle__availablePhoneNumbers: "W\xE4hlen Sie eine Telefonnummer aus, um sich f\xFCr die Best\xE4tigung in zwei Schritten per SMS-Code zu registrieren.",
      subtitle__unavailablePhoneNumbers: "Es sind keine Telefonnummern verf\xFCgbar, um sich f\xFCr die SMS-Code-Best\xE4tigung in zwei Schritten zu registrieren.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "SMS-Code-Best\xE4tigung hinzuf\xFCgen"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scannen Sie stattdessen den QR-Code",
        buttonUnableToScan__nonPrimary: "QR-Code kann nicht gescannt werden?",
        infoText__ableToScan: "Richten Sie eine neue Anmeldemethode in Ihrer Authentifizierungs-App ein und scannen Sie den folgenden QR-Code, um ihn mit Ihrem Konto zu verkn\xFCpfen.",
        infoText__unableToScan: "Richten Sie eine neue Anmeldemethode in Ihrem Authentifikator ein und geben Sie den unten angegebenen Schl\xFCssel ein.",
        inputLabel__unableToScan1: "Stellen Sie sicher, dass zeitbasierte oder einmalige Passw\xF6rter aktiviert sind, und schlie\xDFen Sie dann die Verkn\xFCpfung Ihres Kontos ab.",
        inputLabel__unableToScan2: "Wenn Ihr Authentifikator TOTP-URIs unterst\xFCtzt, k\xF6nnen Sie alternativ auch die vollst\xE4ndige URI kopieren."
      },
      removeResource: {
        messageLine1: "Bei der Anmeldung sind keine Best\xE4tigungscodes von diesem Authentifikator mehr erforderlich.",
        messageLine2: "Ihr Konto ist m\xF6glicherweise nicht mehr so sicher. Sind Sie sich sicher, dass Sie fortfahren wollen?",
        successMessage: "Die zweistufige Verifizierung \xFCber die Authentifizierungs-App wurde entfernt.",
        title: "Entfernen Sie die Best\xE4tigung in zwei Schritten"
      },
      successMessage: "Die Best\xE4tigung in zwei Schritten ist jetzt aktiviert. Bei der Anmeldung m\xFCssen Sie als zus\xE4tzlichen Schritt einen Best\xE4tigungscode von diesem Authentifikator eingeben.",
      title: "Authentifizierungs-App hinzuf\xFCgen",
      verifySubtitle: "Geben Sie den von Ihrem Authentifikator generierten Best\xE4tigungscode ein",
      verifyTitle: "Verifizierungs-Schl\xFCssel"
    },
    mobileButton__menu: "Men\xFC",
    navbar: {
      account: "Profil",
      description: "Verwalten Sie Ihre Kontoinformationen.",
      security: "Sicherheit",
      title: "Benutzerkonto"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} wird von diesem Konto entfernt.",
        title: "Passkey entfernen"
      },
      subtitle__rename: "Sie k\xF6nnen den Namen des Passkeys \xE4ndern, um ihn leichter zu finden.",
      title__rename: "Passkey umbenennen"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Es wird empfohlen, sich von allen anderen Ger\xE4ten abzumelden, die m\xF6glicherweise Ihr altes Passwort verwendet haben.",
      readonly: "Ihr Passwort kann derzeit nicht ge\xE4ndert werden, da Sie sich nur \xFCber die Enterprise-Verbindung anmelden k\xF6nnen.",
      successMessage__set: "Ihr Passwort wurde festgelegt.",
      successMessage__signOutOfOtherSessions: "Alle anderen Ger\xE4te wurden abgemeldet.",
      successMessage__update: "Dein Passwort wurde aktualisiert.",
      title__set: "Passwort festlegen",
      title__update: "Passwort \xE4ndern"
    },
    phoneNumberPage: {
      infoText: "An diese Telefonnummer wird eine SMS mit einem Best\xE4tigungslink gesendet.",
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2: "Sie k\xF6nnen sich nicht mehr mit dieser Telefonnummer anmelden.",
        successMessage: "{{phoneNumber}} wurde aus Ihrem Konto entfernt.",
        title: "Telefonnummer entfernen"
      },
      successMessage: "{{identifier}} wurde Ihrem Konto hinzugef\xFCgt.",
      title: "Telefonnummer hinzuf\xFCgen",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "Laden Sie ein JPG-, PNG-, GIF- oder WEBP-Bild hoch, welches kleiner als 10 MB ist",
      imageFormDestructiveActionSubtitle: "Bild entfernen",
      imageFormSubtitle: "Bild hochladen",
      imageFormTitle: "Profilbild",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "Ihr Profil wurde aktualisiert.",
      title: "Profil aktualisieren"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Vom Ger\xE4t abmelden",
        title: "Aktive Ger\xE4te"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Versuchen Sie es nochmal",
        actionLabel__reauthorize: "Jetzt autorisieren",
        destructiveActionTitle: "Entfernen",
        primaryButton: "Konto verbinden",
        subtitle__disconnected: "Ihr Konto ist derzeit getrennt. Bitte verbinden Sie es erneut.",
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "Verbundene Konten"
      },
      dangerSection: {
        deleteAccountButton: "Konto l\xF6schen",
        title: "Achtung"
      },
      emailAddressesSection: {
        destructiveAction: "E-Mail-Adresse entfernen",
        detailsAction__nonPrimary: "Als prim\xE4r festlegen",
        detailsAction__primary: "Verifizierung abschlie\xDFen",
        detailsAction__unverified: "Verifizierung abschlie\xDFen",
        primaryButton: "F\xFCgen Sie eine E-Mail-Adresse hinzu",
        title: "E-Mail-Adressen"
      },
      enterpriseAccountsSection: {
        title: "Unternehmens-Konten"
      },
      headerTitle__account: "Konto",
      headerTitle__security: "Sicherheit",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Codes neu generieren",
          headerTitle: "Backup-Codes",
          subtitle__regenerate: "Generieren Sie einen neuen Satz sicherer Backup-Codes. Alte Backup-Code werden gel\xF6scht und k\xF6nnen nicht mehr verwendet werden.",
          title__regenerate: "Backup-Codes neu generieren"
        },
        phoneCode: {
          actionLabel__setDefault: "Als Standard einstellen",
          destructiveActionLabel: "Telefonnummer entfernen"
        },
        primaryButton: "Aktivieren Sie die Zweifaktor-Authentifizierung",
        title: "Zweifaktor-Authentifizierung",
        totp: {
          destructiveActionTitle: "Entfernen",
          headerTitle: "Authentifizierungs-App"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Entfernen",
        menuAction__rename: "Umbenennen",
        primaryButton: void 0,
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "Passwort festlegen",
        primaryButton__updatePassword: "Passwort \xE4ndern",
        title: "Passwort"
      },
      phoneNumbersSection: {
        destructiveAction: "Telefonnummer entfernen",
        detailsAction__nonPrimary: "Als prim\xE4r festlegen",
        detailsAction__primary: "Verifizierung abschlie\xDFen",
        detailsAction__unverified: "Verifizierung abschlie\xDFen",
        primaryButton: "F\xFCgen Sie eine Telefonnummer hinzu",
        title: "Telefonnummern"
      },
      profileSection: {
        primaryButton: "Profil bearbeiten",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Benutzernamen festlegen",
        primaryButton__updateUsername: "Benutzernamen \xE4ndern",
        title: "Nutzername"
      },
      web3WalletsSection: {
        destructiveAction: "Wallet entfernen",
        primaryButton: "Web3-Wallets",
        title: "Web3-Wallets"
      }
    },
    usernamePage: {
      successMessage: "Ihr Benutzername wurde aktualisiert.",
      title__set: "Benutzernamen aktualisieren",
      title__update: "Benutzernamen aktualisieren"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2: "Sie k\xF6nnen sich nicht mehr mit diesem Web3-Wallet anmelden.",
        successMessage: "{{web3Wallet}} wurde aus Ihrem Konto entfernt.",
        title: "Entfernen Sie das Web3-Wallet"
      },
      subtitle__availableWallets: "W\xE4hlen Sie ein Web3-Wallet aus, um sich mit Ihrem Konto zu verbinden.",
      subtitle__unavailableWallets: "Es sind keine Web3-Wallets verf\xFCgbar.",
      successMessage: "Die Brieftasche wurde Ihrem Konto hinzugef\xFCgt.",
      title: "Web3-Wallet hinzuf\xFCgen",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: "Jetzt anmelden",
      actionText: "Kein Zugang? Auf die Warteliste setzen!",
      formButton: "Zur Warteliste hinzuf\xFCgen",
      subtitle: "Es tut uns leid, aber derzeit sind keine Pl\xE4tze verf\xFCgbar.",
      title: "Warteliste beitreten"
    },
    success: {
      message: "Sie wurden erfolgreich auf die Warteliste gesetzt. Wir benachrichtigen Sie, sobald Pl\xE4tze verf\xFCgbar sind.",
      subtitle: "Vielen Dank f\xFCr Ihre Geduld. Sie erhalten eine Benachrichtigung, sobald der Zugang freigegeben wird.",
      title: "Erfolgreich auf die Warteliste gesetzt"
    }
  }
};

// src/it-IT.ts
var itIT = {
  locale: "it-IT",
  backButton: "Indietro",
  badge__default: "Predefinito",
  badge__otherImpersonatorDevice: "Altro dispositivo impersonato",
  badge__primary: "Primario",
  badge__requiresAction: "Richiede azione",
  badge__thisDevice: "Questo dispositivo",
  badge__unverified: "Non verificato",
  badge__userDevice: "Dispositivo utente",
  badge__you: "Tu",
  createOrganization: {
    formButtonSubmit: "Crea organizzazione",
    invitePage: {
      formButtonReset: "Salta"
    },
    title: "Crea organizzazione"
  },
  dates: {
    lastDay: "Ieri alle {{ date | timeString('it-IT') }}",
    next6Days: "{{ date | weekday('it-IT','long') }} alle {{ date | timeString('it-IT') }}",
    nextDay: "Domani alle {{ date | timeString('it-IT') }}",
    numeric: "{{ date | numeric('it-IT') }}",
    previous6Days: "{{ date | weekday('it-IT','long') }} alle {{ date | timeString('it-IT') }}",
    sameDay: "Oggi alle {{ date | timeString('it-IT') }}"
  },
  dividerText: "oppure",
  footerActionLink__useAnotherMethod: "Utilizzo un altro metodo",
  footerPageLink__help: "Aiuto",
  footerPageLink__privacy: "Privacy",
  footerPageLink__terms: "Termini",
  formButtonPrimary: "Continua",
  formButtonPrimary__verify: "Verifica",
  formFieldAction__forgotPassword: "Password dimenticata?",
  formFieldError__matchingPasswords: "Le password coincidono.",
  formFieldError__notMatchingPasswords: "Le password non coincidono.",
  formFieldError__verificationLinkExpired: "Il link di verifica \xE8 scaduto. Per favore richiedi un nuovo link.",
  formFieldHintText__optional: "Opzionale",
  formFieldHintText__slug: "Uno slug \xE8 un identificativo leggibile dall\u2019uomo che deve essere univoco. Spesso viene usato negli URL.",
  formFieldInputPlaceholder__backupCode: "Inserisci il codice di backup",
  formFieldInputPlaceholder__confirmDeletionUserAccount: void 0,
  formFieldInputPlaceholder__emailAddress: "Inserisci l'indirizzo email",
  formFieldInputPlaceholder__emailAddress_username: "Inserisci l'indirizzo email o il nome utente",
  formFieldInputPlaceholder__emailAddresses: void 0,
  formFieldInputPlaceholder__firstName: "Inserisci il tuo nome",
  formFieldInputPlaceholder__lastName: "Inserisci il tuo cognome",
  formFieldInputPlaceholder__organizationDomain: "Inserisci il dominio dell'organizzazione",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Inserisci l'indirizzo email del dominio dell'organizzazione",
  formFieldInputPlaceholder__organizationName: "Inserisci il nome dell'organizzazione",
  formFieldInputPlaceholder__organizationSlug: "Inserisci lo slug dell'organizzazione",
  formFieldInputPlaceholder__password: "Inserisci la tua password",
  formFieldInputPlaceholder__phoneNumber: "Inserisci il numero di telefono",
  formFieldInputPlaceholder__username: "Inserisci il nome utente",
  formFieldLabel__automaticInvitations: "Abilita inviti automatici per questo dominio",
  formFieldLabel__backupCode: "Codice di backup",
  formFieldLabel__confirmDeletion: "Conferma",
  formFieldLabel__confirmPassword: "Conferma password",
  formFieldLabel__currentPassword: "Password corrente",
  formFieldLabel__emailAddress: "Indirizzo email",
  formFieldLabel__emailAddress_username: "Indirizzo email o nome utente",
  formFieldLabel__emailAddresses: "Indirizzi email",
  formFieldLabel__firstName: "Nome",
  formFieldLabel__lastName: "Cognome",
  formFieldLabel__newPassword: "Nuova password",
  formFieldLabel__organizationDomain: "Dominio",
  formFieldLabel__organizationDomainDeletePending: "Elimina inviti e suggerimenti pendenti",
  formFieldLabel__organizationDomainEmailAddress: "Indirizzo email di verifica",
  formFieldLabel__organizationDomainEmailAddressDescription: "Inserisci un indirizzo email sotto questo dominio per ricevere un codice e verificare questo dominio.",
  formFieldLabel__organizationName: "Nome organizzazione",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Nome della passkey",
  formFieldLabel__password: "Password",
  formFieldLabel__phoneNumber: "Numero di telefono",
  formFieldLabel__role: "Ruolo",
  formFieldLabel__signOutOfOtherSessions: "Disconnetti tutti gli altri dispositivi",
  formFieldLabel__username: "Nome utente",
  impersonationFab: {
    action__signOut: "Disconnetti",
    title: "Accesso tramite {{identifier}}"
  },
  maintenanceMode: "Modalit\xE0 di manutenzione",
  membershipRole__admin: "Amministratore",
  membershipRole__basicMember: "Utente",
  membershipRole__guestMember: "Ospite",
  organizationList: {
    action__createOrganization: "Crea organizzazione",
    action__invitationAccept: "Unisciti",
    action__suggestionsAccept: "Richiedi di unirti",
    createOrganization: "Crea organizzazione",
    invitationAcceptedLabel: "Unito",
    subtitle: "per continuare a {{applicationName}}",
    suggestionsAcceptedLabel: "In attesa di approvazione",
    title: "Scegli un account",
    titleWithoutPersonal: "Scegli un\u2019organizzazione"
  },
  organizationProfile: {
    badge__automaticInvitation: "Inviti automatici",
    badge__automaticSuggestion: "Suggerimenti automatici",
    badge__manualInvitation: "Nessuna iscrizione automatica",
    badge__unverified: "Non verificato",
    createDomainPage: {
      subtitle: "Aggiungi il dominio da verificare. Gli utenti con indirizzi email in questo dominio possono unirsi all\u2019organizzazione automaticamente o richiedere di unirsi.",
      title: "Aggiungi dominio"
    },
    invitePage: {
      detailsTitle__inviteFailed: "L'invito non pu\xF3 essere inviato. Correggi i seguenti e riprova:",
      formButtonPrimary__continue: "Invia inviti",
      selectDropdown__role: "Seleziona ruolo",
      subtitle: "Invita un nuovo membro in questa organizzazione",
      successMessage: "Invito inviato con successo",
      title: "Invita membri"
    },
    membersPage: {
      action__invite: "Invita",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Rimuovi membro",
        tableHeader__actions: "Azioni",
        tableHeader__joined: "Iscritto",
        tableHeader__role: "Ruolo",
        tableHeader__user: "Utente"
      },
      detailsTitle__emptyRow: "Nessun membro da visualizzare",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invita utenti collegando un dominio email con la tua organizzazione. Chiunque si iscriva con un dominio email corrispondente potr\xE0 unirsi all\u2019organizzazione in qualsiasi momento.",
          headerTitle: "Inviti automatici",
          primaryButton: "Gestisci domini verificati"
        },
        table__emptyRow: "Nessun invito da visualizzare"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revoca invito",
        tableHeader__invited: "Invitato"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Gli utenti che si iscrivono con un dominio email corrispondente, potranno vedere un suggerimento di richiesta di unirsi alla tua organizzazione.",
          headerTitle: "Suggerimenti automatici",
          primaryButton: "Gestisci domini verificati"
        },
        menuAction__approve: "Approva",
        menuAction__reject: "Rifiuta",
        tableHeader__requested: "Richiesta accesso",
        table__emptyRow: "Nessuna richiesta da visualizzare"
      },
      start: {
        headerTitle__invitations: "Inviti",
        headerTitle__members: "Membri",
        headerTitle__requests: "Richieste"
      }
    },
    navbar: {
      description: "Gestisci la tua organizzazione.",
      general: "Generale",
      members: "Membri",
      title: "Organizzazione"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Scrivi "{{organizationName}}" qui sotto per continuare.',
          messageLine1: "Sei sicuro di voler eliminare questa organizzazione?",
          messageLine2: "Questa azione \xE8 permanente e irreversibile.",
          successMessage: "Hai eliminato l\u2019organizzazione.",
          title: "Elimina organizzazione"
        },
        leaveOrganization: {
          actionDescription: 'Scrivi "{{organizationName}}" qui sotto per continuare.',
          messageLine1: "Sei sicuro di voler lasciare questa organizzazione? Perderai accesso a questa organizzazione e le sue applicazioni.",
          messageLine2: "Questa azione \xE8 permanente ed irreversibile.",
          successMessage: "Hai lasciato l'organizzazione.",
          title: "Lascia organizzazione"
        },
        title: "Pericolo"
      },
      domainSection: {
        menuAction__manage: "Gestisci",
        menuAction__remove: "Elimina",
        menuAction__verify: "Verifica",
        primaryButton: "Aggiungi dominio",
        subtitle: "Consenti agli utenti di unirsi automaticamente all'organizzazione oppure di richiedere di unirsi in base a un dominio email verificato.",
        title: "Domini verificati"
      },
      successMessage: "L'organizzazione \xE8 stata aggiornata.",
      title: "Profilo dell'organizzazione"
    },
    removeDomainPage: {
      messageLine1: "Il dominio email {{domain}} verr\xE0 rimosso.",
      messageLine2: "Gli utenti non potranno pi\xF9 unirsi automaticamente all'organizzazione dopo questo.",
      successMessage: "{{domain}} \xE8 stato rimosso.",
      title: "Rimuovi dominio"
    },
    start: {
      headerTitle__general: "Generale",
      headerTitle__members: "Membri",
      profileSection: {
        primaryButton: "Modifica profilo",
        title: "Profilo dell'organizzazione",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Rimuovere questo dominio influir\xE0 sugli utenti invitati.",
        removeDomainActionLabel__remove: "Rimuovi dominio",
        removeDomainSubtitle: "Rimuovi questo dominio dai tuoi domini verificati",
        removeDomainTitle: "Rimuovi dominio"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Gli utenti sono automaticamente invitati a unirsi all'organizzazione quando si registrano e possono unirsi in qualsiasi momento.",
        automaticInvitationOption__label: "Inviti automatici",
        automaticSuggestionOption__description: "Gli utenti ricevono un suggerimento per richiedere di unirsi, ma devono essere approvati da un amministratore prima di poter accedere all'organizzazione.",
        automaticSuggestionOption__label: "Suggerimenti automatici",
        calloutInfoLabel: "La modifica della modalit\xE0 di iscrizione influenzer\xE0 solo i nuovi utenti.",
        calloutInvitationCountLabel: "Inviti in sospeso inviati agli utenti: {{count}}",
        calloutSuggestionCountLabel: "Suggerimenti in sospeso inviati agli utenti: {{count}}",
        manualInvitationOption__description: "Gli utenti possono essere invitati manualmente solo all'organizzazione.",
        manualInvitationOption__label: "Nessuna iscrizione automatica",
        subtitle: "Scegli come gli utenti di questo dominio possono unirsi all'organizzazione."
      },
      start: {
        headerTitle__danger: "Pericolo",
        headerTitle__enrollment: "Opzioni di iscrizione"
      },
      subtitle: "Il dominio {{domain}} \xE8 ora verificato. Continua selezionando la modalit\xE0 di iscrizione.",
      title: "Aggiorna {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Inserisci il codice di verifica inviato al tuo indirizzo email",
      formTitle: "Codice di verifica",
      resendButton: "Non hai ricevuto un codice? Reinvia",
      subtitle: "Il dominio {{domainName}} deve essere verificato tramite email.",
      subtitleVerificationCodeScreen: "\xC8 stato inviato un codice di verifica a {{emailAddress}}. Inserisci il codice per continuare.",
      title: "Verifica dominio"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Crea Organizzazione",
    action__invitationAccept: "Unisciti",
    action__manageOrganization: "Gestisci Organizzazione",
    action__suggestionsAccept: "Richiedi di unirti",
    notSelected: "Nessuna organizzazione selezionata",
    personalWorkspace: "Spazio di lavoro personale",
    suggestionsAcceptedLabel: "In attesa di approvazione"
  },
  paginationButton__next: "Prossimo",
  paginationButton__previous: "Precedente",
  paginationRowText__displaying: "Visualizzando",
  paginationRowText__of: "di",
  reverification: {
    alternativeMethods: {
      actionLink: "Clicca qui per utilizzare un metodo alternativo",
      actionText: "Usa un metodo di verifica alternativo",
      blockButton__backupCode: "Verifica con il codice di backup",
      blockButton__emailCode: "Verifica con il codice via email",
      blockButton__password: "Verifica con la password",
      blockButton__phoneCode: "Verifica con il codice SMS",
      blockButton__totp: "Verifica con il TOTP",
      getHelp: {
        blockButton__emailSupport: "Contatta il supporto via email",
        content: "Se hai bisogno di assistenza, contatta il nostro supporto.",
        title: "Ottieni aiuto"
      },
      subtitle: "Scegli un metodo per verificarti",
      title: "Verifica necessaria"
    },
    backupCodeMfa: {
      subtitle: "Usa il codice di backup che ti \xE8 stato fornito al momento della registrazione.",
      title: "Verifica con il codice di backup"
    },
    emailCode: {
      formTitle: "Inserisci il codice che ti \xE8 stato inviato via email.",
      resendButton: "Invia di nuovo il codice",
      subtitle: "Controlla la tua email per il codice di verifica.",
      title: "Verifica con il codice email"
    },
    noAvailableMethods: {
      message: "Non sono disponibili metodi di verifica.",
      subtitle: "Contatta il supporto per assistenza.",
      title: "Nessun metodo disponibile"
    },
    password: {
      actionLink: "Reimposta la password",
      subtitle: "Inserisci la tua password per continuare.",
      title: "Verifica con la password"
    },
    phoneCode: {
      formTitle: "Inserisci il codice che ti \xE8 stato inviato via SMS.",
      resendButton: "Invia di nuovo il codice",
      subtitle: "Controlla il tuo SMS per il codice di verifica.",
      title: "Verifica con il codice SMS"
    },
    phoneCodeMfa: {
      formTitle: "Inserisci il codice che ti abbiamo inviato via SMS.",
      resendButton: "Invia di nuovo il codice",
      subtitle: "Controlla il tuo SMS per il codice di verifica.",
      title: "Verifica SMS (MFA)"
    },
    totpMfa: {
      formTitle: "Inserisci il codice dalla tua app di autenticazione.",
      subtitle: "Usa l\u2019app di autenticazione che hai configurato.",
      title: "Verifica TOTP (MFA)"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Aggiungi account",
      action__signOutAll: "Disconnettiti da tutti gli account",
      subtitle: "Seleziona l'account con cui desideri continuare.",
      title: "Scegli un account"
    },
    alternativeMethods: {
      actionLink: "Richiedi aiuto",
      actionText: "Non ne possiedi nessuno?",
      blockButton__backupCode: "Usa un codice di backup",
      blockButton__emailCode: "Invia codice a {{identifier}}",
      blockButton__emailLink: "Invia link a {{identifier}}",
      blockButton__passkey: "Usa una passkey",
      blockButton__password: "Accedi con la tua password",
      blockButton__phoneCode: "Invia codice a {{identifier}}",
      blockButton__totp: "Usa la tua app di autenticazione",
      getHelp: {
        blockButton__emailSupport: "Supporto email",
        content: "Se stai incontrando delle difficolt\xE0 ad accedere al tuo account, inviaci una email e ti aiuteremo a ripristinare il tuo account il prima possibile.",
        title: "Richiedi aiuto"
      },
      subtitle: "Problemi di accesso? Puoi usare uno di questi metodi per accedere.",
      title: "Usa un altro metodo"
    },
    backupCodeMfa: {
      subtitle: "per continuare su {{applicationName}}",
      title: "Inserisci un codice di backup"
    },
    emailCode: {
      formTitle: "Codice di verifica",
      resendButton: "Rinvia codice",
      subtitle: "per continuare su {{applicationName}}",
      title: "Controlla la tua email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Il client utilizzato non corrisponde al tipo di account associato.",
        title: "Errore di mismatch del client"
      },
      expired: {
        subtitle: "Ritorna alla scheda originaria per continuare",
        title: "Questo link di verifica \xE8 scaduto"
      },
      failed: {
        subtitle: "Ritorna alla scheda originaria per continuare",
        title: "Questo link di verifica non \xE8 valido"
      },
      formSubtitle: "Usa il link di verifica inviato al tuo indirizzo email",
      formTitle: "Link di verifica",
      loading: {
        subtitle: "Verrai presto reindirizzato",
        title: "Accesso in corso..."
      },
      resendButton: "Rinvia link",
      subtitle: "per continuare su {{applicationName}}",
      title: "Controlla la tua email",
      unusedTab: {
        title: "Puoi chiudere questa scheda"
      },
      verified: {
        subtitle: "Verrai presto reindirizzato",
        title: "Accesso avvenuto con successo"
      },
      verifiedSwitchTab: {
        subtitle: "Ritorna alla scheda originaria per continuare",
        subtitleNewTab: "Ritorna sulla nuova scheda aperta per continuare",
        titleNewTab: "Accedi da un'altra scheda"
      }
    },
    forgotPassword: {
      formTitle: "Codice di reset della password",
      resendButton: "Non hai ricevuto un codice? Reinvia",
      subtitle: "per resettare la tua password",
      subtitle_email: "Per prima cosa, inserisci il codice inviato al tuo ID email",
      subtitle_phone: "Per prima cosa, inserisci il codice inviato al tuo telefono",
      title: "Resetta la password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Resetta la tua password",
      label__alternativeMethods: "Oppure, accedi con un altro metodo",
      title: "Hai dimenticato la password?"
    },
    noAvailableMethods: {
      message: "Impossibile procedere con l'accesso. Non ci sono strumenti di autenticazione disponibili.",
      subtitle: "Si \xE8 verificato un errore",
      title: "Impossibile accedere"
    },
    passkey: {
      subtitle: "Usa una passkey per un accesso pi\xF9 sicuro e rapido.",
      title: "Autenticazione tramite passkey"
    },
    password: {
      actionLink: "Usa un altro metodo",
      subtitle: "per continuare su {{applicationName}}",
      title: "Inserisci la tua password"
    },
    passwordPwned: {
      title: "La tua password \xE8 stata trovata in un data breach."
    },
    phoneCode: {
      formTitle: "Codice di verifica",
      resendButton: "Rinvia il codice",
      subtitle: "per accedere a {{applicationName}}",
      title: "Controlla il tuo telefono"
    },
    phoneCodeMfa: {
      formTitle: "Codice di verifica",
      resendButton: "Rinvia il codice",
      subtitle: "per accedere a {{applicationName}}",
      title: "Controlla il tuo telefono"
    },
    resetPassword: {
      formButtonPrimary: "Resetta la password",
      requiredMessage: "Per motivi di sicurezza, \xE8 richiesto di resettare la tua password.",
      successMessage: "La tua password \xE8 stata cambiata con successo. Ti stiamo collegando, attendi un momento.",
      title: "Imposta nuova password"
    },
    resetPasswordMfa: {
      detailsLabel: "Dobbiamo verificare la tua identit\xE0 prima di resettare la tua password."
    },
    start: {
      actionLink: "Registrati",
      actionLink__join_waitlist: "Unisciti alla lista d'attesa",
      actionLink__use_email: "Usa email",
      actionLink__use_email_username: "Usa email o username",
      actionLink__use_passkey: "Usa passkey",
      actionLink__use_phone: "Usa telefono",
      actionLink__use_username: "Usa username",
      actionText: "Non hai un account?",
      actionText__join_waitlist: "Unisciti alla lista d'attesa",
      subtitle: "per continuare su {{applicationName}}",
      subtitleCombined: void 0,
      title: "Accedi",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Codice di verifica",
      subtitle: "Inserisci il codice di verifica dalla tua app di autenticazione.",
      title: "Verifica in due passaggi"
    }
  },
  signInEnterPasswordTitle: "Inserisci la tua password",
  signUp: {
    continue: {
      actionLink: "Accedi",
      actionText: "Hai un account?",
      subtitle: "per continuare su {{applicationName}}",
      title: "Compila i campi mancanti"
    },
    emailCode: {
      formSubtitle: "Inserisci il codice di verifica inviato alla tua email",
      formTitle: "Codice di verifica",
      resendButton: "Rinvia codice",
      subtitle: "per continuare su {{applicationName}}",
      title: "Verifica la tua email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Il client che stai utilizzando non corrisponde a quello previsto per il tuo account.",
        title: "Errore di incompatibilit\xE0 del client"
      },
      formSubtitle: "Usa il link di verifica inviato al tuo indirizzo email",
      formTitle: "Link di verifica",
      loading: {
        title: "Registrando..."
      },
      resendButton: "Rinvia link",
      subtitle: "per continuare su {{applicationName}}",
      title: "Verifica la tua email",
      verified: {
        title: "Registrato con successo"
      },
      verifiedSwitchTab: {
        subtitle: "Ritorna alla nuova tab aperta per continuare",
        subtitleNewTab: "Ritorna alla tab precedente per continuare",
        title: "Email verificata con successo"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "Accetto la Politica sulla Privacy",
        label__onlyTermsOfService: "Accetto i Termini di Servizio",
        label__termsOfServiceAndPrivacyPolicy: "Accetto i Termini di Servizio e la Politica sulla Privacy"
      },
      continue: {
        subtitle: "Per completare la registrazione, accetta i termini e la privacy policy.",
        title: "Continua"
      }
    },
    phoneCode: {
      formSubtitle: "Inserisci il codice di verifica inviato al tuo numero di telefono",
      formTitle: "Codice di verifica",
      resendButton: "Rinvia codice",
      subtitle: "per continuare su {{applicationName}}",
      title: "Verifica il tuo numero di telefono"
    },
    restrictedAccess: {
      actionLink: "Contatta il supporto",
      actionText: "Hai bisogno di aiuto?",
      blockButton__emailSupport: "Email al supporto",
      blockButton__joinWaitlist: "Unisciti alla lista d'attesa",
      subtitle: "L'accesso \xE8 limitato per il momento. Ti invitiamo a contattare il supporto per ulteriori informazioni.",
      subtitleWaitlist: "Puoi unirti alla lista d'attesa e ti avviseremo quando l'accesso sar\xE0 disponibile.",
      title: "Accesso limitato"
    },
    start: {
      actionLink: "Accedi",
      actionLink__use_email: "Usa email",
      actionLink__use_phone: "Usa telefono",
      actionText: "Hai gi\xE0 un account?",
      subtitle: "per continuare su {{applicationName}}",
      subtitleCombined: "per continuare su {{applicationName}}",
      title: "Crea il tuo account",
      titleCombined: "Crea il tuo account"
    }
  },
  socialButtonsBlockButton: "Continua con {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "Sei gi\xE0 un membro di questa organizzazione.",
    captcha_invalid: "Registrazione non riuscita a causa di fallite convalide di sicurezza. Per favore, ricarica la pagina e riprova o contatta il supporto per ulteriore assistenza.",
    captcha_unavailable: "Registrazione non riuscita a causa della convalida del bot non riuscita. Per favore, ricarica la pagina e riprova o contatta il supporto per ulteriore assistenza.",
    form_code_incorrect: "Il codice inserito non \xE8 corretto. Riprova.",
    form_identifier_exists__email_address: "Questa email \xE8 gi\xE0 registrata.",
    form_identifier_exists__phone_number: "Questo numero di telefono \xE8 gi\xE0 registrato.",
    form_identifier_exists__username: "Questo username \xE8 gi\xE0 in uso.",
    form_identifier_not_found: "Non abbiamo trovato nessun account con queste informazioni.",
    form_param_format_invalid: "Formato non valido.",
    form_param_format_invalid__email_address: "L'indirizzo email deve essere un indirizzo email valido.",
    form_param_format_invalid__phone_number: "Il numero di telefono deve essere in un formato internazionale valido.",
    form_param_max_length_exceeded__first_name: "Il nome non deve superare i 256 caratteri.",
    form_param_max_length_exceeded__last_name: "Il cognome non deve superare i 256 caratteri.",
    form_param_max_length_exceeded__name: "Il nome non deve superare i 256 caratteri.",
    form_param_nil: "Questo campo \xE8 obbligatorio.",
    form_param_value_invalid: "Valore non valido.",
    form_password_incorrect: "Password errata.",
    form_password_length_too_short: "La password deve avere almeno 8 caratteri.",
    form_password_not_strong_enough: "La tua password non \xE8 abbastanza forte.",
    form_password_pwned: "Questa password \xE8 stata trovata in una violazione dei dati. Scegli una password diversa.",
    form_password_pwned__sign_in: "Questa password \xE8 stata trovata in una violazione dei dati. Non pu\xF2 essere utilizzata. Reimposta la tua password.",
    form_password_size_in_bytes_exceeded: "La tua password ha superato il numero massimo di byte consentiti, per favore accorciala o rimuovi alcuni caratteri speciali.",
    form_password_validation_failed: "Password errata.",
    form_username_invalid_character: "Il nome utente contiene caratteri non validi.",
    form_username_invalid_length: "Il nome utente deve avere una lunghezza compresa tra 3 e 32 caratteri.",
    identification_deletion_failed: "Non puoi eliminare la tua ultima identificazione.",
    not_allowed_access: "Non hai accesso a questa risorsa.",
    organization_domain_blocked: "Il dominio dell'organizzazione \xE8 stato bloccato.",
    organization_domain_common: "Questo dominio \xE8 troppo comune per essere utilizzato.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Hai raggiunto il limite massimo di membri nell'organizzazione.",
    organization_minimum_permissions_needed: "Non hai i permessi minimi necessari per completare questa operazione.",
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: void 0,
      minimumLength: void 0,
      requireLowercase: void 0,
      requireNumbers: void 0,
      requireSpecialCharacter: void 0,
      requireUppercase: void 0,
      sentencePrefix: void 0
    },
    phone_number_exists: void 0,
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: void 0,
      goodPassword: void 0,
      notEnough: void 0,
      suggestions: {
        allUppercase: void 0,
        anotherWord: void 0,
        associatedYears: void 0,
        capitalization: void 0,
        dates: void 0,
        l33t: void 0,
        longerKeyboardPattern: void 0,
        noNeed: void 0,
        pwned: void 0,
        recentYears: void 0,
        repeated: void 0,
        reverseWords: void 0,
        sequences: void 0,
        useWords: void 0
      },
      warnings: {
        common: void 0,
        commonNames: void 0,
        dates: void 0,
        extendedRepeat: void 0,
        keyPattern: void 0,
        namesByThemselves: void 0,
        pwned: void 0,
        recentYears: void 0,
        sequences: void 0,
        similarToCommon: void 0,
        simpleRepeat: void 0,
        straightRow: void 0,
        topHundred: void 0,
        topTen: void 0,
        userInputs: void 0,
        wordByItself: void 0
      }
    }
  },
  userButton: {
    action__addAccount: "Aggiungi account",
    action__manageAccount: "Gestisci account",
    action__signOut: "Disconnetti",
    action__signOutAll: "Disconnetti da tutti gli accounts"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copiati!",
      actionLabel__copy: "Copia tutti",
      actionLabel__download: "Scarica .txt",
      actionLabel__print: "Stampa",
      infoText1: "I codici di backup saranno abilitati per questo account.",
      infoText2: "Tieni segreti i codici di backup e salvali in maniera sicura. Potrai generare altri codici di backup se pensi che possano essere compromessi.",
      subtitle__codelist: "Salvali in maniera sicura e tienili segreti.",
      successMessage: "I codici di backup sono ora abilitati. Puoi ora utilizzare questi codici di backup per accedere al tuo account, nel caso di perdita del proprio strumento di autenticazione. Ogni codice potr\xE0 essere utilizzato una sola volta.",
      successSubtitle: "Puoi ora utilizzare questi codici di backup per accedere al tuo account, nel caso di perdita del proprio strumento di autenticazione.",
      title: "Aggiungi verifica codici backup",
      title__codelist: "Codici di backup"
    },
    connectedAccountPage: {
      formHint: "Seleziona un provider per collegare il tuo account.",
      formHint__noAccounts: "Non ci sono provider esterni disponibili.",
      removeResource: {
        messageLine1: "{{identifier}} sar\xE0 rimosso dal tuo account.",
        messageLine2: "Non sarai pi\xFA in grado di accedere utilizzando questo account e le funzionalit\xE0 collegate smetteranno di funzionare.",
        successMessage: "{{connectedAccount}} \xE8 stato rimosso dal tuo account.",
        title: "Rimuovi account collegato"
      },
      socialButtonsBlockButton: "Collega {{provider|titleize}} account",
      successMessage: "Il provider \xE8 stato aggiunto al tuo account",
      title: "Aggiungi account collegato"
    },
    deletePage: {
      actionDescription: 'Digita "Elimina account" qui sotto per continuare.',
      confirm: "Elimina account",
      messageLine1: "Sei sicuro di voler eliminare il tuo account?",
      messageLine2: "Questa azione \xE8 permanente e irreversibile.",
      title: "Elimina account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Una email contenente un codice di verifica \xE8 stata inviata a questo indirizzo email.",
        formSubtitle: "Inserisci il codice di verifica inviato a {{identifier}}",
        formTitle: "Codice di verifica",
        resendButton: "Rinvia codice",
        successMessage: "L'indirizzo email {{identifier}} \xE8 stato aggiunto al tuo account."
      },
      emailLink: {
        formHint: "Una email contenente un link di verifica sar\xE0 inviata a questo indirizzo email.",
        formSubtitle: "Clicca sul link di verifica nella email inviata a {{identifier}}",
        formTitle: "Link di verifica",
        resendButton: "Rinvia link",
        successMessage: "L'indirizzo email {{identifier}} \xE8 stato aggiunto al tuo account."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} sar\xE0 rimosso dal tuo account.",
        messageLine2: "Non sarai pi\xFA in grado di accedere utilizzando questo indirizzo email.",
        successMessage: "{{emailAddress}} \xE8 stato rimosso dal tuo account.",
        title: "Rimuovi indirizzo email"
      },
      title: "Aggiungi un indirizzo email",
      verifyTitle: "Verifica indirizzo email"
    },
    formButtonPrimary__add: "Aggiungi",
    formButtonPrimary__continue: "Continua",
    formButtonPrimary__finish: "Concludi",
    formButtonPrimary__remove: "Rimuovi",
    formButtonPrimary__save: "Salva",
    formButtonReset: "Cancella",
    mfaPage: {
      formHint: "Seleziona un metodo da aggiungere.",
      title: "Aggiungi verifica in 2 passaggi"
    },
    mfaPhoneCodePage: {
      backButton: "Usa numero esistente",
      primaryButton__addPhoneNumber: "Aggiungi un numero di telefono",
      removeResource: {
        messageLine1: "{{identifier}} non ricever\xE0 pi\xFA i codici di verifica all'accesso.",
        messageLine2: "Il tuo account potrebbe essere non sicuro. Sei sicuro di voler continuare?",
        successMessage: "La verifica in 2 passaggi tramite SMS \xE8 stata rimossa per {{mfaPhoneCode}}",
        title: "Rimuovi verifica in 2 passaggi"
      },
      subtitle__availablePhoneNumbers: "Seleziona un numero di telefono da registrare per la verifica in 2 passaggi tramite SMS.",
      subtitle__unavailablePhoneNumbers: "Non ci sono numeri di telefono da registrare per la verifica in 2 passaggi tramite SMS.",
      successMessage1: "Quando accedi, dovrai inserire un codice di verifica inviato a questo numero di telefono come passaggio aggiuntivo.",
      successMessage2: "Salva questi codici di backup e conservali in un luogo sicuro. Se perdi l'accesso al tuo dispositivo di autenticazione, puoi utilizzare i codici di backup per accedere.",
      successTitle: "Verifica codice SMS abilitata",
      title: "Aggiungi verifica tramite SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scansiona il codice QR",
        buttonUnableToScan__nonPrimary: "Non \xE8 possibile scansionare il codice QR?",
        infoText__ableToScan: "Aggiungi un nuovo metodo di accesso nella tua app di autenticazione e scansione il seguente codice QR per associarla a questo account.",
        infoText__unableToScan: "Aggiungi un nuovo metodo di accesso nella tua app di autenticazione ed aggiungi la chiave di sicurezza generata sotto.",
        inputLabel__unableToScan1: "Assicurarsi che le password Time-based oppure One-time siano abilitate, poi continua il collegamento al tuo account.",
        inputLabel__unableToScan2: "Alternativamente, se il tuo autenticatore supporta TOTP URIs, puoi anche copiare l'intera URI."
      },
      removeResource: {
        messageLine1: "I codici di verifica di questo autenticatore non saranno pi\xFA richiesti all'accesso.",
        messageLine2: "Il tuo account potrebbe essere non sicuro. Sei sicuro di voler continuare?",
        successMessage: "La verifica in 2 passaggi tramite autenticatore \xE8 stata rimossa.",
        title: "Rimuovi verifica in 2 passaggi"
      },
      successMessage: "Verifica in 2 passaggi attivata. All'accesso sar\xE0 richiesto di inserire un codice di verifica generato dall'app di autenticazione come ulteriore passaggio.",
      title: "Aggiungi app di autenticazione",
      verifySubtitle: "Inserisci il codice di verifica generato dalla tua app di autenticazione",
      verifyTitle: "Codice di verifica"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profilo",
      description: "Gestisci il tuo account.",
      security: "Sicurezza",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "Sei sicuro di voler rimuovere questa chiave di accesso dal tuo account?",
        title: "Rimuovi chiave di accesso"
      },
      subtitle__rename: "Modifica il nome della tua chiave di accesso",
      title__rename: "Rinomina chiave di accesso"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\xC8 consigliabile disconnettersi da tutti gli altri dispositivi che potrebbero aver utilizzato la tua vecchia password.",
      readonly: "La tua password corrente non pu\xF2 essere modificata perch\xE9 puoi accedere solo tramite la connessione aziendale.",
      successMessage__set: "La tua password \xE8 stata impostata.",
      successMessage__signOutOfOtherSessions: "Tutti gli altri dispositivi sono stati disconnessi.",
      successMessage__update: "La tua password \xE8 stata aggiornata.",
      title__set: "Imposta password",
      title__update: "Cambia password"
    },
    phoneNumberPage: {
      infoText: "Un SMS contenente un link di verifica \xE8 stato inviato a questo numero di telefono.",
      removeResource: {
        messageLine1: "{{identifier}} sar\xE0 rimosso dal tuo account.",
        messageLine2: "Non sarai pi\xFA in grado di accedere utilizzando questo numero di telefono.",
        successMessage: "{{phoneNumber}} \xE8 stato rimosso dal tuo account.",
        title: "Rimuovi numero di telefono"
      },
      successMessage: "{{identifier}} \xE8 stato aggiunto al tuo account.",
      title: "Aggiungi numero di telefono",
      verifySubtitle: "Inserisci il codice di verifica inviato a {{identifier}}",
      verifyTitle: "Verifica numero di telefono"
    },
    profilePage: {
      fileDropAreaHint: "Carica una immagine pi\xFA piccola di 10MB di tipo JPG, PNG, GIF, oppure WEBP",
      imageFormDestructiveActionSubtitle: "Rimuovi immagine",
      imageFormSubtitle: "Carica immagine",
      imageFormTitle: "Immagine di profilo",
      readonly: "Le informazioni del tuo profilo sono state fornite dalla connessione aziendale e non possono essere modificate.",
      successMessage: "Il tuo profile \xE8 stato aggiornato.",
      title: "Aggiorna profilo"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Disconnetti dal dispositivo",
        title: "Dispositivi attivi"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Riprova",
        actionLabel__reauthorize: "Autorizza ora",
        destructiveActionTitle: "Rimuovi",
        primaryButton: "Collega account",
        subtitle__disconnected: "Il tuo account \xE8 disconnesso. Per favore, riconnetti il tuo account per continuare.",
        subtitle__reauthorize: "Gli ambiti richiesti sono stati aggiornati e potresti riscontrare funzionalit\xE0 limitate. Per favore, ri-autorizza questa applicazione per evitare problemi.",
        title: "Account collegati"
      },
      dangerSection: {
        deleteAccountButton: "Elimina account",
        title: "Terminazione account"
      },
      emailAddressesSection: {
        destructiveAction: "Rimuovi indirizzo email",
        detailsAction__nonPrimary: "Imposta come principale",
        detailsAction__primary: "Completa la verifica",
        detailsAction__unverified: "Completa la verifica",
        primaryButton: "Aggiungi un indirizzo email",
        title: "Indirizzi email"
      },
      enterpriseAccountsSection: {
        title: "Account aziendali"
      },
      headerTitle__account: "Dettagli profilo",
      headerTitle__security: "Sicurezza",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Rigenera codici",
          headerTitle: "Codice di backup",
          subtitle__regenerate: "Ottieni una nuova lista di codici di sicurezza di backup. I codici di sicurezza di backup precedentemente generati saranno eliminati e non saranno utilizzabili.",
          title__regenerate: "Rigenera codici di backup"
        },
        phoneCode: {
          actionLabel__setDefault: "Imposta come predefinito",
          destructiveActionLabel: "Rimuovi numero di telefono"
        },
        primaryButton: "Aggiungi verifica in 2 passaggi",
        title: "Verifica in 2 passaggi",
        totp: {
          destructiveActionTitle: "Rimuovi",
          headerTitle: "Applicazione di autenticazione"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Rimuovi chiave di accesso",
        menuAction__rename: "Rinomina chiave di accesso",
        primaryButton: void 0,
        title: "Gestisci le tue chiavi di accesso"
      },
      passwordSection: {
        primaryButton__setPassword: "Imposta password",
        primaryButton__updatePassword: "Cambia password",
        title: "Password"
      },
      phoneNumbersSection: {
        destructiveAction: "Rimuovi numero di telefono",
        detailsAction__nonPrimary: "Imposta come principale",
        detailsAction__primary: "Completa la verifica",
        detailsAction__unverified: "Completa la verifica",
        primaryButton: "Aggiungi un numero di telefono",
        title: "Numeri di telefono"
      },
      profileSection: {
        primaryButton: "Salva modifiche",
        title: "Profilo"
      },
      usernameSection: {
        primaryButton__setUsername: "Imposta username",
        primaryButton__updateUsername: "Cambia username",
        title: "Username"
      },
      web3WalletsSection: {
        destructiveAction: "Rimuovi wallet",
        primaryButton: "Web3 wallets",
        title: "Web3 wallets"
      }
    },
    usernamePage: {
      successMessage: "Il tuo username \xE8 stato aggiornato.",
      title__set: "Aggiorna username",
      title__update: "Aggiorna username"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} sar\xE0 rimosso dal tuo account.",
        messageLine2: "Non sarai pi\xFA in grado di accedere utilizzando questo web3 wallet.",
        successMessage: "{{web3Wallet}} \xE8 stato rimosso dal tuo account.",
        title: "Rimuovi web3 wallet"
      },
      subtitle__availableWallets: "Seleziona un web3 wallet da collegare al tuo account.",
      subtitle__unavailableWallets: "Non ci sono web3 wallets disponibili.",
      successMessage: "Il wallet \xE8 stato aggiunto al tuo account.",
      title: "Aggiungi web3 wallet",
      web3WalletButtonsBlockButton: "Continua con il tuo portafoglio Web3"
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/pt-BR.ts
var ptBR = {
  locale: "pt-BR",
  backButton: "Voltar",
  badge__default: "Padr\xE3o",
  badge__otherImpersonatorDevice: "Personificar outro dispositivo",
  badge__primary: "Principal",
  badge__requiresAction: "Requer a\xE7\xE3o",
  badge__thisDevice: "Este dispositivo",
  badge__unverified: "N\xE3o verificado",
  badge__userDevice: "Dispositivo do usu\xE1rio",
  badge__you: "Voc\xEA",
  createOrganization: {
    formButtonSubmit: "Criar organiza\xE7\xE3o",
    invitePage: {
      formButtonReset: "Pular"
    },
    title: "Criar organiza\xE7\xE3o"
  },
  dates: {
    lastDay: "Ontem \xE0s {{ date | timeString('pt-BR') }}",
    next6Days: "{{ date | weekday('pt-BR','long') }} \xE0s {{ date | timeString('pt-BR') }}",
    nextDay: "Amanh\xE3 \xE0s {{ date | timeString('pt-BR') }}",
    numeric: "{{ date | numeric('pt-BR') }}",
    previous6Days: "\xDAltimo {{ date | weekday('pt-BR','long') }} \xE0s {{ date | timeString('pt-BR') }}",
    sameDay: "Hoje \xE0s {{ date | timeString('pt-BR') }}"
  },
  dividerText: "ou",
  footerActionLink__useAnotherMethod: "Utilize outro m\xE9todo",
  footerPageLink__help: "Ajuda",
  footerPageLink__privacy: "Privacidade",
  footerPageLink__terms: "Termos de uso",
  formButtonPrimary: "Continuar",
  formButtonPrimary__verify: "Verificar",
  formFieldAction__forgotPassword: "Esqueceu a senha?",
  formFieldError__matchingPasswords: "Senhas conferem.",
  formFieldError__notMatchingPasswords: "Senhas n\xE3o conferem.",
  formFieldError__verificationLinkExpired: "O link de verifica\xE7\xE3o expirou. Por favor solicite um novo link.",
  formFieldHintText__optional: "Opcional",
  formFieldHintText__slug: "Um r\xF3tulo \xE9 um identificador leg\xEDvel por humanos que deve ser \xFAnico. \xC9 comumente usado em URLs.",
  formFieldInputPlaceholder__backupCode: "Insira o c\xF3digo de backup",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Excluir conta",
  formFieldInputPlaceholder__emailAddress: "Digite o endere\xE7o de e-mail",
  formFieldInputPlaceholder__emailAddress_username: "Digite seu e-mail ou nome de usu\xE1rio",
  formFieldInputPlaceholder__emailAddresses: "Insira um ou mais endere\xE7os de e-mail separados por espa\xE7os ou v\xEDrgulas",
  formFieldInputPlaceholder__firstName: "Digite seu primeiro nome",
  formFieldInputPlaceholder__lastName: "Digite seu sobrenome",
  formFieldInputPlaceholder__organizationDomain: "Digite o dom\xEDnio da organiza\xE7\xE3o",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Digite o e-mail associado ao dom\xEDnio da organiza\xE7\xE3o",
  formFieldInputPlaceholder__organizationName: "Digite o nome da organiza\xE7\xE3o",
  formFieldInputPlaceholder__organizationSlug: "minha-org",
  formFieldInputPlaceholder__password: "Digite sua senha",
  formFieldInputPlaceholder__phoneNumber: "Digite seu n\xFAmero de telefone",
  formFieldInputPlaceholder__username: "Digite seu nome de usu\xE1rio",
  formFieldLabel__automaticInvitations: "Ativar convites autom\xE1ticos para este dom\xEDnio",
  formFieldLabel__backupCode: "C\xF3digo de backup",
  formFieldLabel__confirmDeletion: "Confirmar exclus\xE3o",
  formFieldLabel__confirmPassword: "Confirmar senha",
  formFieldLabel__currentPassword: "Senha atual",
  formFieldLabel__emailAddress: "Seu e-mail",
  formFieldLabel__emailAddress_username: "E-mail ou nome de usu\xE1rio",
  formFieldLabel__emailAddresses: "Endere\xE7os de e-mail",
  formFieldLabel__firstName: "Nome",
  formFieldLabel__lastName: "Sobrenome",
  formFieldLabel__newPassword: "Nova senha",
  formFieldLabel__organizationDomain: "Dom\xEDnio",
  formFieldLabel__organizationDomainDeletePending: "Excluir convites e sugest\xF5es pendentes",
  formFieldLabel__organizationDomainEmailAddress: "Endere\xE7o de e-mail de verifica\xE7\xE3o",
  formFieldLabel__organizationDomainEmailAddressDescription: "Endere\xE7o de e-mail para receber um c\xF3digo e verificar este dom\xEDnio",
  formFieldLabel__organizationName: "Nome da organiza\xE7\xE3o",
  formFieldLabel__organizationSlug: "R\xF3tulo do URL",
  formFieldLabel__passkeyName: "Nome da chave de acesso",
  formFieldLabel__password: "Senha",
  formFieldLabel__phoneNumber: "Telefone",
  formFieldLabel__role: "Fun\xE7\xE3o",
  formFieldLabel__signOutOfOtherSessions: "Desconectar de todos os outros dispositivos",
  formFieldLabel__username: "Nome de usu\xE1rio",
  impersonationFab: {
    action__signOut: "Sair",
    title: "Logado como {{identifier}}"
  },
  maintenanceMode: "Estamos em manuten\xE7\xE3o, mas n\xE3o se preocupe, n\xE3o deve levar mais do que alguns minutos",
  membershipRole__admin: "Administrador",
  membershipRole__basicMember: "Membro",
  membershipRole__guestMember: "Convidado",
  organizationList: {
    action__createOrganization: "Criar organiza\xE7\xE3o",
    action__invitationAccept: "Participar",
    action__suggestionsAccept: "Solicitar participa\xE7\xE3o",
    createOrganization: "Criar organiza\xE7\xE3o",
    invitationAcceptedLabel: "Participando",
    subtitle: "para continuar no {{applicationName}}",
    suggestionsAcceptedLabel: "Aprova\xE7\xE3o pendente",
    title: "Selecione uma conta",
    titleWithoutPersonal: "Selecione uma organiza\xE7\xE3o"
  },
  organizationProfile: {
    badge__automaticInvitation: "Convites autom\xE1ticos",
    badge__automaticSuggestion: "Sugest\xF5es autom\xE1ticas",
    badge__manualInvitation: "Sem inscri\xE7\xE3o autom\xE1tica",
    badge__unverified: "N\xE3o verificado",
    createDomainPage: {
      subtitle: "Adicione o dom\xEDnio para verificar. Usu\xE1rios com endere\xE7os de e-mail neste dom\xEDnio podem se juntar \xE0 organiza\xE7\xE3o automaticamente ou solicitar participa\xE7\xE3o.",
      title: "Adicionar dom\xEDnio"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Os convites n\xE3o puderam ser enviados. Corrija o seguinte e tente novamente:",
      formButtonPrimary__continue: "Enviar convites",
      selectDropdown__role: "Select role",
      subtitle: "Convidar novos membros para esta organiza\xE7\xE3o",
      successMessage: "Convites enviados com sucesso",
      title: "Convidar membros"
    },
    membersPage: {
      action__invite: "Convidar",
      action__search: "Pesquisar",
      activeMembersTab: {
        menuAction__remove: "Remover membro",
        tableHeader__actions: "A\xE7\xF5es",
        tableHeader__joined: "Entrou",
        tableHeader__role: "Fun\xE7\xE3o",
        tableHeader__user: "Usu\xE1rio"
      },
      detailsTitle__emptyRow: "Nenhum membro para exibir",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Convide usu\xE1rios conectando um dom\xEDnio de e-mail com sua organiza\xE7\xE3o. Qualquer pessoa que se inscrever com um dom\xEDnio de e-mail correspondente poder\xE1 se juntar \xE0 organiza\xE7\xE3o a qualquer momento.",
          headerTitle: "Convites autom\xE1ticos",
          primaryButton: "Gerenciar dom\xEDnios verificados"
        },
        table__emptyRow: "Nenhum convite para exibir"
      },
      invitedMembersTab: {
        menuAction__revoke: "Cancelar convite",
        tableHeader__invited: "Convidado"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Usu\xE1rios que se inscrevem com um dom\xEDnio de e-mail correspondente podem ver uma sugest\xE3o para solicitar participa\xE7\xE3o em sua organiza\xE7\xE3o.",
          headerTitle: "Sugest\xF5es autom\xE1ticas",
          primaryButton: "Gerenciar dom\xEDnios verificados"
        },
        menuAction__approve: "Aprovar",
        menuAction__reject: "Rejeitar",
        tableHeader__requested: "Acesso solicitado",
        table__emptyRow: "Nenhuma solicita\xE7\xE3o para exibir"
      },
      start: {
        headerTitle__invitations: "Convites",
        headerTitle__members: "Membros",
        headerTitle__requests: "Solicita\xE7\xF5es"
      }
    },
    navbar: {
      description: "Gerencie sua organiza\xE7\xE3o.",
      general: "Geral",
      members: "Membros",
      title: "Organiza\xE7\xE3o"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "Digite {{organizationName}} abaixo para continuar.",
          messageLine1: "Tem certeza de que deseja excluir esta organiza\xE7\xE3o?",
          messageLine2: "Esta a\xE7\xE3o \xE9 permanente e irrevers\xEDvel.",
          successMessage: "Voc\xEA excluiu a organiza\xE7\xE3o.",
          title: "Excluir organiza\xE7\xE3o"
        },
        leaveOrganization: {
          actionDescription: "Digite {{organizationName}} abaixo para continuar.",
          messageLine1: "Tem certeza de que deseja sair desta organiza\xE7\xE3o? Voc\xEA perder\xE1 o acesso a esta organiza\xE7\xE3o e suas aplica\xE7\xF5es.",
          messageLine2: "Esta a\xE7\xE3o \xE9 permanente e n\xE3o pode ser desfeita.",
          successMessage: "Voc\xEA saiu da organiza\xE7\xE3o.",
          title: "Sair da organiza\xE7\xE3o"
        },
        title: "Perigo"
      },
      domainSection: {
        menuAction__manage: "Gerenciar",
        menuAction__remove: "Excluir",
        menuAction__verify: "Verificar",
        primaryButton: "Adicionar dom\xEDnio",
        subtitle: "Permita que os usu\xE1rios se juntem \xE0 organiza\xE7\xE3o automaticamente ou solicitem participa\xE7\xE3o com base em um dom\xEDnio de e-mail verificado.",
        title: "Dom\xEDnios verificados"
      },
      successMessage: "A organiza\xE7\xE3o foi atualizada.",
      title: "Perfil da organiza\xE7\xE3o"
    },
    removeDomainPage: {
      messageLine1: "O dom\xEDnio de e-mail {{domain}} ser\xE1 removido.",
      messageLine2: "Os usu\xE1rios n\xE3o poder\xE3o mais se juntar \xE0 organiza\xE7\xE3o automaticamente ap\xF3s isso.",
      successMessage: "{{domain}} foi removido.",
      title: "Excluir dom\xEDnio"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Membros",
      profileSection: {
        primaryButton: "Atualizar perfil",
        title: "Perfil da Organiza\xE7\xE3o",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "A exclus\xE3o deste dom\xEDnio afetar\xE1 os usu\xE1rios convidados.",
        removeDomainActionLabel__remove: "Excluir dom\xEDnio",
        removeDomainSubtitle: "Remova este dom\xEDnio de seus dom\xEDnios verificados",
        removeDomainTitle: "Excluir dom\xEDnio"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Os usu\xE1rios s\xE3o convidados automaticamente a se juntar \xE0 organiza\xE7\xE3o quando se inscrevem e podem se juntar a qualquer momento.",
        automaticInvitationOption__label: "Convites autom\xE1ticos",
        automaticSuggestionOption__description: "Os usu\xE1rios recebem uma sugest\xE3o para solicitar participa\xE7\xE3o, mas devem ser aprovados por um administrador antes de poderem se juntar \xE0 organiza\xE7\xE3o.",
        automaticSuggestionOption__label: "Sugest\xF5es autom\xE1ticas",
        calloutInfoLabel: "Alterar o modo de inscri\xE7\xE3o afetar\xE1 apenas os novos usu\xE1rios.",
        calloutInvitationCountLabel: "Convites pendentes enviados aos usu\xE1rios: {{count}}",
        calloutSuggestionCountLabel: "Sugest\xF5es pendentes enviadas aos usu\xE1rios: {{count}}",
        manualInvitationOption__description: "Os usu\xE1rios s\xF3 podem ser convidados manualmente para a organiza\xE7\xE3o.",
        manualInvitationOption__label: "Sem inscri\xE7\xE3o autom\xE1tica",
        subtitle: "Escolha como os usu\xE1rios deste dom\xEDnio podem se juntar \xE0 organiza\xE7\xE3o."
      },
      start: {
        headerTitle__danger: "Perigo",
        headerTitle__enrollment: "Op\xE7\xF5es de inscri\xE7\xE3o"
      },
      subtitle: "O dom\xEDnio {{domain}} agora est\xE1 verificado. Continue selecionando o modo de inscri\xE7\xE3o.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o enviado para o seu endere\xE7o de e-mail",
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
      subtitle: "O dom\xEDnio {{domainName}} precisa ser verificado por e-mail.",
      subtitleVerificationCodeScreen: "Um c\xF3digo de verifica\xE7\xE3o foi enviado para {{emailAddress}}. Insira o c\xF3digo para continuar.",
      title: "Verificar dom\xEDnio"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Criar organiza\xE7\xE3o",
    action__invitationAccept: "Participar",
    action__manageOrganization: "Gerenciar organiza\xE7\xE3o",
    action__suggestionsAccept: "Solicitar participa\xE7\xE3o",
    notSelected: "Nenhuma organiza\xE7\xE3o selecionada",
    personalWorkspace: "Conta pessoal",
    suggestionsAcceptedLabel: "Aprova\xE7\xE3o pendente"
  },
  paginationButton__next: "Pr\xF3ximo",
  paginationButton__previous: "Anterior",
  paginationRowText__displaying: "Exibindo",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: "Solicitar ajuda",
      actionText: "N\xE3o tem nenhum dos m\xE9todos? Tente outra forma.",
      blockButton__backupCode: "Usar c\xF3digo de backup",
      blockButton__emailCode: "Enviar c\xF3digo para {{identifier}}",
      blockButton__password: "Usar senha",
      blockButton__phoneCode: "Enviar c\xF3digo de telefone",
      blockButton__totp: "Usar autentica\xE7\xE3o TOTP",
      getHelp: {
        blockButton__emailSupport: "Entrar em contato com o suporte",
        content: "Se voc\xEA n\xE3o tem nenhum dos m\xE9todos listados, entre em contato com nosso suporte.",
        title: void 0
      },
      subtitle: "Escolha um dos m\xE9todos alternativos para verificar sua identidade.",
      title: "M\xE9todos alternativos de verifica\xE7\xE3o"
    },
    backupCodeMfa: {
      subtitle: "Digite seu c\xF3digo de backup para continuar.",
      title: "Verifica\xE7\xE3o com c\xF3digo de backup"
    },
    emailCode: {
      formTitle: "C\xF3digo enviado para seu e-mail",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Verifique seu e-mail e insira o c\xF3digo para continuar.",
      title: "Verifique seu e-mail"
    },
    noAvailableMethods: {
      message: "Nenhum m\xE9todo de verifica\xE7\xE3o dispon\xEDvel. Entre em contato com o suporte.",
      subtitle: "N\xE3o h\xE1 m\xE9todos de verifica\xE7\xE3o dispon\xEDveis no momento.",
      title: "M\xE9todos de verifica\xE7\xE3o indispon\xEDveis"
    },
    password: {
      actionLink: "Usar outro m\xE9todo",
      subtitle: "Digite sua senha para continuar.",
      title: "Digite sua senha"
    },
    phoneCode: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Verifique seu celular para o c\xF3digo de verifica\xE7\xE3o.",
      title: "Verifique seu celular"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Verifique seu celular para o c\xF3digo de verifica\xE7\xE3o.",
      title: "Verifique seu celular"
    },
    totpMfa: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o TOTP",
      subtitle: "Digite o c\xF3digo de verifica\xE7\xE3o gerado pelo seu aplicativo de autentica\xE7\xE3o.",
      title: "Autentica\xE7\xE3o TOTP"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Adicionar conta",
      action__signOutAll: "Sair de todas as contas",
      subtitle: "Selecione a conta com a qual gostaria de continuar.",
      title: "Escolha uma conta."
    },
    alternativeMethods: {
      actionLink: "Ajuda",
      actionText: "N\xE3o tem nenhum destes?",
      blockButton__backupCode: "Utilize um c\xF3digo de backup",
      blockButton__emailCode: "Enviar c\xF3digo para {{identifier}}",
      blockButton__emailLink: "Enviar link para {{identifier}}",
      blockButton__passkey: "Acessar com sua chave de acesso",
      blockButton__password: "Acessar com sua senha",
      blockButton__phoneCode: "Enviar c\xF3digo para {{identifier}}",
      blockButton__totp: "Utilize seu aplicativo autenticador",
      getHelp: {
        blockButton__emailSupport: "E-mail de suporte",
        content: "Se estiver com dificuldades para entrar em sua conta, envie um e-mail para n\xF3s que iremos te ajudar a restaurar seu acesso o mais r\xE1pido poss\xEDvel.",
        title: "Ajuda"
      },
      subtitle: "Encontrando dificuldades? Voc\xEA pode utilizar qualquer um destes m\xE9todos para acessar.",
      title: "Utilize outro m\xE9todo"
    },
    backupCodeMfa: {
      subtitle: "para continuar em {{applicationName}}",
      title: "Insira um c\xF3digo de backup"
    },
    emailCode: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Para continuar, abra o link de verifica\xE7\xE3o no mesmo dispositivo e navegador em que iniciou o login",
        title: "Link de verifica\xE7\xE3o \xE9 inv\xE1lido para este dispositivo"
      },
      expired: {
        subtitle: "Retorne para a aba original para continuar",
        title: "Este link de verifica\xE7\xE3o expirou"
      },
      failed: {
        subtitle: "Retorne para a aba original para continuar",
        title: "Este link de verifica\xE7\xE3o \xE9 inv\xE1lido"
      },
      formSubtitle: "Utilize o link enviado no seu e-mail",
      formTitle: "Link de verifica\xE7\xE3o",
      loading: {
        subtitle: "Voc\xEA ser\xE1 redirecionado em breve",
        title: "Conectando..."
      },
      resendButton: "N\xE3o recebeu um link? Reenviar",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu e-mail",
      unusedTab: {
        title: "Voc\xEA pode fechar esta aba"
      },
      verified: {
        subtitle: "Voc\xEA ser\xE1 redirecionado em breve",
        title: "Login realizado com sucesso"
      },
      verifiedSwitchTab: {
        subtitle: "Retorne para a aba original para continuar",
        subtitleNewTab: "Retorne para a nova aba que foi aberta para continuar",
        titleNewTab: "Conectado em outra aba"
      }
    },
    forgotPassword: {
      formTitle: "C\xF3digo de redefini\xE7\xE3o de senha",
      resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
      subtitle: "para redefinir sua senha",
      subtitle_email: "Primeiro, digite o c\xF3digo enviado para seu e-mail",
      subtitle_phone: "Primeiro, digite o c\xF3digo enviado para seu telefone",
      title: "Redefinir senha"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Redefinir sua senha",
      label__alternativeMethods: "Ou, fa\xE7a login com outro m\xE9todo.",
      title: "Esqueceu a senha?"
    },
    noAvailableMethods: {
      message: "N\xE3o foi poss\xEDvel fazer login. N\xE3o h\xE1 nenhum m\xE9todo de autentica\xE7\xE3o dispon\xEDvel.",
      subtitle: "Aconteceu um erro",
      title: "N\xE3o foi poss\xEDvel fazer login"
    },
    passkey: {
      subtitle: "Usar sua chave de acesso confirma a sua identidade. Seu dispositivo pode solicitar sua impress\xE3o digital, reconhecimento facial ou PIN.",
      title: "Use sua chave de acesso."
    },
    password: {
      actionLink: "Utilize outro m\xE9todo",
      subtitle: "para continuar em {{applicationName}}",
      title: "Insira sua senha"
    },
    passwordPwned: {
      title: "Senha comprometida"
    },
    phoneCode: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu telefone"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Para continuar, insira o c\xF3digo enviado para o seu telefone.",
      title: "Verifique seu telefone"
    },
    resetPassword: {
      formButtonPrimary: "Redefinir Senha",
      requiredMessage: "Por raz\xF5es de seguran\xE7a, \xE9 necess\xE1rio redefinir sua senha.",
      successMessage: "Sua senha foi alterada com sucesso. Entrando, por favor aguarde um momento.",
      title: "Redefinir Senha"
    },
    resetPasswordMfa: {
      detailsLabel: "Precisamos verificar sua identidade antes de redefinir sua senha."
    },
    start: {
      actionLink: "Registre-se",
      actionLink__join_waitlist: "Entrar na lista de espera",
      actionLink__use_email: "Usar e-mail",
      actionLink__use_email_username: "Usar e-mail ou nome de usu\xE1rio",
      actionLink__use_passkey: "Ou use sua chave de acesso",
      actionLink__use_phone: "Usar telefone",
      actionLink__use_username: "Usar nome de usu\xE1rio",
      actionText: "N\xE3o possui uma conta?",
      actionText__join_waitlist: "Quer ser notificado quando estivermos prontos?",
      subtitle: "para continuar em {{applicationName}}",
      subtitleCombined: void 0,
      title: "Entrar",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      subtitle: "Para continuar, insira o c\xF3digo gerado pelo seu aplicativo autenticador.",
      title: "Verifica\xE7\xE3o em duas etapas"
    }
  },
  signInEnterPasswordTitle: "Insira sua senha",
  signUp: {
    continue: {
      actionLink: "Entrar",
      actionText: "Possui uma conta?",
      subtitle: "para continuar em {{applicationName}}",
      title: "Preencha os campos ausentes"
    },
    emailCode: {
      formSubtitle: "Insira o c\xF3digo enviado para seu e-mail",
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "N\xE3o recebeu o c\xF3digo? Reenviar",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Para continuar, abra o link de verifica\xE7\xE3o no mesmo dispositivo e navegador em que iniciou o cadastro",
        title: "Link de verifica\xE7\xE3o \xE9 inv\xE1lido para este dispositivo"
      },
      formSubtitle: "Utilize o link enviado no seu e-mail",
      formTitle: "Link de verifica\xE7\xE3o",
      loading: {
        title: "Conectando..."
      },
      resendButton: "Reenviar link",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu e-mail",
      verified: {
        title: "Cadastro realizado com sucesso"
      },
      verifiedSwitchTab: {
        subtitle: "Retorne para a nova aba que foi aberta para continuar",
        subtitleNewTab: "Retorne para a aba anterior para continuar",
        title: "E-mail verificado com sucesso"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Eu concordo com a {{privacyPolicyLink || link("Pol\xEDtica de Privacidade")}}',
        label__onlyTermsOfService: 'Eu concordo com os {{termsOfServiceLink || link("Termos de Uso")}}',
        label__termsOfServiceAndPrivacyPolicy: 'Eu concordo com os {{termsOfServiceLink || link("Termos de Uso")}} e com a {{ privacyPolicyLink || link("Pol\xEDtica de Privacidade") }}'
      },
      continue: {
        subtitle: "Por favor leia e aceite os termos para continuar",
        title: "Continuar"
      }
    },
    phoneCode: {
      formSubtitle: "Insira o c\xF3digo enviado para seu telefone",
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "N\xE3o recebeu o c\xF3digo? Reenviar",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu telefone"
    },
    restrictedAccess: {
      actionLink: "Entrar",
      actionText: "J\xE1 possui uma conta?",
      blockButton__emailSupport: "Suporte por e-mail",
      blockButton__joinWaitlist: "Entre na lista de espera",
      subtitle: "Cadastros est\xE3o desabilitados no momento. Se voc\xEA deveria ter acesso, por favor entre em contato com o suporte.",
      subtitleWaitlist: "Cadastros est\xE3o desabilitados no momento. Para ser um dos primeiros a saber quando lan\xE7aremos, entre na lista de espera.",
      title: "Acesso restrito"
    },
    start: {
      actionLink: "Entrar",
      actionLink__use_email: "Ou use e-mail",
      actionLink__use_phone: "Ou use telefone",
      actionText: "Possui uma conta?",
      subtitle: "para continuar em {{applicationName}}",
      subtitleCombined: "para continuar em {{applicationName}}",
      title: "Criar sua conta",
      titleCombined: "Criar sua conta"
    }
  },
  socialButtonsBlockButton: "Continuar com {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "{{email}} j\xE1 \xE9 membro da organiza\xE7\xE3o.",
    captcha_invalid: "N\xE3o foi poss\xEDvel se inscrever devido a falhas nas valida\xE7\xF5es de seguran\xE7a. Por favor, atualize a p\xE1gina para tentar novamente ou entre em contato com o suporte para obter mais ajuda.",
    captcha_unavailable: "N\xE3o foi poss\xEDvel se inscrever devido \xE0 indisponibilidade do captcha. Por favor atualize a p\xE1gina para tentar novamente ou entre em contato com o suporte para obter mais ajuda.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "E-mail j\xE1 est\xE1 em uso. Por favor, tente outro.",
    form_identifier_exists__phone_number: "Telefone j\xE1 est\xE1 em uso. Por favor, tente outro.",
    form_identifier_exists__username: "Nome de usu\xE1rio j\xE1 est\xE1 em uso. Por favor, tente outro.",
    form_identifier_not_found: "N\xE3o foi poss\xEDvel encontrar o usu\xE1rio.",
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "O endere\xE7o de e-mail deve ser um endere\xE7o de e-mail v\xE1lido.",
    form_param_format_invalid__phone_number: "N\xFAmero de telefone precisa estar num formato internacional v\xE1lido.",
    form_param_max_length_exceeded__first_name: "O primeiro nome n\xE3o deve exceder 256 caracteres.",
    form_param_max_length_exceeded__last_name: "O sobrenome n\xE3o deve exceder 256 caracteres.",
    form_param_max_length_exceeded__name: "O nome n\xE3o deve exceder 256 caracteres.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: "Senha incorreta.",
    form_password_length_too_short: "Sua senha \xE9 muito curta. Por favor, tente novamente.",
    form_password_not_strong_enough: "Sua senha n\xE3o \xE9 forte o suficiente.",
    form_password_pwned: "Esta senha foi comprometida e n\xE3o pode ser usada, por favor, tente outra senha.",
    form_password_pwned__sign_in: "Esta senha foi comprometida, por favor redefina sua senha.",
    form_password_size_in_bytes_exceeded: "Sua senha excedeu o n\xFAmero m\xE1ximo de bytes permitidos, por favor, encurte-a ou remova alguns caracteres especiais.",
    form_password_validation_failed: "Senha incorreta",
    form_username_invalid_character: "Nome de usu\xE1rio cont\xE9m caracteres inv\xE1lidos. Por favor, tente outro.",
    form_username_invalid_length: "Nome de usu\xE1rio deve ter entre 3 e 256 caracteres.",
    identification_deletion_failed: "Voc\xEA n\xE3o pode excluir sua \xFAltima identifica\xE7\xE3o.",
    not_allowed_access: "Acesso n\xE3o permitido.",
    organization_domain_blocked: "Este \xE9 um provedor de dom\xEDnio de e-mail bloqueado. Por favor, use um diferente.",
    organization_domain_common: "Este \xE9 um provedor de dom\xEDnio de e-mail comum. Por favor, use um diferente.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Voc\xEA chegou ao seu limite de membros da organiza\xE7\xE3o, incluindo convites pendentes.",
    organization_minimum_permissions_needed: "\xC9 necess\xE1rio que haja pelo menos um membro da organiza\xE7\xE3o com as permiss\xF5es m\xEDnimas necess\xE1rias.",
    passkey_already_exists: "Uma chave de acesso j\xE1 est\xE1 registrada neste dispositivo.",
    passkey_not_supported: "Chaves de acesso n\xE3o s\xE3o suportadas neste dispositivo.",
    passkey_pa_not_supported: "Registro precisa de chave de acesso mas dispositivo n\xE3o a suporta.",
    passkey_registration_cancelled: "Registro de chave de acesso cancelado ou expirado.",
    passkey_retrieval_cancelled: "Verifica\xE7\xE3o de chave de acesso cancelada ou expirada.",
    passwordComplexity: {
      maximumLength: "menos de {{length}} caracteres",
      minimumLength: "{{length}} ou mais caracteres",
      requireLowercase: "uma letra min\xFAscula",
      requireNumbers: "um n\xFAmero",
      requireSpecialCharacter: "um caractere especial",
      requireUppercase: "uma letra mai\xFAscula",
      sentencePrefix: "Sua senha deve conter"
    },
    phone_number_exists: "Este n\xFAmero de telefone j\xE1 est\xE1 em uso. Por favor, tente outro.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Sua senha funciona, mas poderia ser mais forte. Tente adicionar mais caracteres.",
      goodPassword: "Sua senha atende a todos os requisitos necess\xE1rios.",
      notEnough: "Sua senha n\xE3o \xE9 forte o suficiente.",
      suggestions: {
        allUppercase: "Utilize apenas algumas letras mai\xFAsculas, n\xE3o todas.",
        anotherWord: "Adicione mais palavras que s\xE3o menos comuns.",
        associatedYears: "Evite anos associados a voc\xEA.",
        capitalization: "Utilize outras letras mai\xFAsculas, al\xE9m do que primeira.",
        dates: "Evite datas e anos associados a voc\xEA.",
        l33t: "Evite substitui\xE7\xF5es previs\xEDveis de letras, como '@' por 'a'.",
        longerKeyboardPattern: "Use padr\xF5es de teclado mais longos e mude a dire\xE7\xE3o da digita\xE7\xE3o v\xE1rias vezes.",
        noNeed: "Voc\xEA pode criar senhas fortes sem usar s\xEDmbolos, n\xFAmeros ou letras mai\xFAsculas.",
        pwned: "Se voc\xEA usar esta senha em outro lugar, voc\xEA deve mud\xE1-la.",
        recentYears: "Evite anos recentes.",
        repeated: "Evite palavras e caracteres repetidos.",
        reverseWords: 'Evite utilizar palavras comuns escritas de "tr\xE1s para frente".',
        sequences: "Evite sequ\xEAncias comuns de caracteres.",
        useWords: "Use v\xE1rias palavras, mas evite frases comuns."
      },
      warnings: {
        common: "Esta \xE9 uma senha comumente usada.",
        commonNames: "Nomes e sobrenomes comuns s\xE3o f\xE1ceis de adivinhar.",
        dates: "Datas s\xE3o f\xE1ceis de adivinhar.",
        extendedRepeat: 'Padr\xF5es de caracteres repetidos, como "abcabcabc" s\xE3o f\xE1ceis de adivinhar.',
        keyPattern: "Padr\xF5es curtos de teclado s\xE3o f\xE1ceis de adivinhar.",
        namesByThemselves: "Nomes ou sobrenomes s\xE3o f\xE1ceis de adivinhar.",
        pwned: "Sua senha foi exposta por uma viola\xE7\xE3o de dados na Internet.",
        recentYears: "Anos recentes s\xE3o f\xE1ceis de adivinhar.",
        sequences: 'Sequ\xEAncias comuns de caracteres, como "abc" s\xE3o f\xE1ceis de adivinhar.',
        similarToCommon: "Esta \xE9 semelhante a uma senha comumente usada.",
        simpleRepeat: 'Caracteres repetidos, como "aaa" s\xE3o f\xE1ceis de adivinhar.',
        straightRow: "Letras que v\xEAm em sequ\xEAncia teclado s\xE3o f\xE1ceis de adivinhar.",
        topHundred: "Esta \xE9 uma senha usada frequentemente.",
        topTen: "Esta \xE9 uma senha muito usada.",
        userInputs: "N\xE3o deve haver nenhum dado pessoal ou relacionado \xE0 p\xE1gina.",
        wordByItself: "Palavras simples s\xE3o f\xE1ceis de adivinhar."
      }
    }
  },
  userButton: {
    action__addAccount: "Adicionar conta",
    action__manageAccount: "Gerenciar conta",
    action__signOut: "Sair",
    action__signOutAll: "Sair de todas as contas"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copiado!",
      actionLabel__copy: "Copiar tudo",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Imprimir",
      infoText1: "C\xF3digos de backup ser\xE3o ativados para esta conta.",
      infoText2: "Guarde-os em seguran\xE7a e mantenha-os em sigilo. Voc\xEA pode gerar novos c\xF3digos de backup se suspeitar que eles tenham sido comprometidos.",
      subtitle__codelist: "Guarde-os em seguran\xE7a e mantenha-os em sigilo.",
      successMessage: "C\xF3digos de backup foram ativados para esta conta. Voc\xEA pode usar um deles para fazer login na sua conta caso perca o acesso ao seu dispositivo de autentica\xE7\xE3o. Cada c\xF3digo poder\xE1 ser utilizado apenas uma vez.",
      successSubtitle: "Voc\xEA pode usar um deles para fazer login na sua conta caso perca o acesso ao seu dispositivo de autentica\xE7\xE3o.",
      title: "Adicionar c\xF3digo de backup para verifica\xE7\xE3o",
      title__codelist: "C\xF3digos de backup"
    },
    connectedAccountPage: {
      formHint: "Selecione um provedor para conectar \xE0 sua conta.",
      formHint__noAccounts: "N\xE3o h\xE1 provedores de conta externos dispon\xEDveis.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "Voc\xEA n\xE3o conseguir\xE1 mais usar esta conta e quaisquer recursos dependentes dela deixar\xE3o de funcionar.",
        successMessage: "{{connectedAccount}} foi removido da sua conta.",
        title: "Remover conta conectada"
      },
      socialButtonsBlockButton: "Conectar conta {{provider|titleize}}",
      successMessage: "O provedor foi adicionado \xE0 sua conta",
      title: "Conecte uma conta"
    },
    deletePage: {
      actionDescription: "Digite Excluir conta abaixo para continuar.",
      confirm: "Excluir conta",
      messageLine1: "Tem certeza de que deseja excluir sua conta?",
      messageLine2: "Esta a\xE7\xE3o \xE9 permanente e irrevers\xEDvel.",
      title: "Excluir conta"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Um e-mail contendo um c\xF3digo de verifica\xE7\xE3o ser\xE1 enviado para este endere\xE7o de e-mail.",
        formSubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o enviado para {{identifier}}",
        formTitle: "C\xF3digo de verifica\xE7\xE3o",
        resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
        successMessage: "O e-mail {{identifier}} foi adicionado na sua conta."
      },
      emailLink: {
        formHint: "Um e-mail contendo um link de verifica\xE7\xE3o ser\xE1 enviado para este endere\xE7o de e-mail.",
        formSubtitle: "Clique no link de verifica\xE7\xE3o enviado para {{identifier}}",
        formTitle: "Link de verifica\xE7\xE3o",
        resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
        successMessage: "O e-mail {{identifier}} foi adicionado na sua conta."
      },
      enterpriseSSOLink: {
        formButton: "Clique para autenticar",
        formSubtitle: "Complete a autentica\xE7\xE3o com {{identifier}}"
      },
      formHint: "Voc\xEA precisar\xE1 verificar este endere\xE7o de email antes de poder adicion\xE1-lo \xE0 sua conta.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "Voc\xEA n\xE3o conseguir\xE1 fazer login novamente com este endere\xE7o de e-mail.",
        successMessage: "{{emailAddress}} foi removido da sua conta.",
        title: "Remover e-mail"
      },
      title: "Adicionar e-mail",
      verifyTitle: "Verificar endere\xE7o de e-mail"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Continuar",
    formButtonPrimary__finish: "Finalizar",
    formButtonPrimary__remove: "Excluir",
    formButtonPrimary__save: "Salvar",
    formButtonReset: "Cancelar",
    mfaPage: {
      formHint: "Selecione um m\xE9todo para adicionar.",
      title: "Adicione verifica\xE7\xE3o em duas etapas"
    },
    mfaPhoneCodePage: {
      backButton: "Usar n\xFAmero existente",
      primaryButton__addPhoneNumber: "Adicione um n\xFAmero de telefone",
      removeResource: {
        messageLine1: "{{identifier}} n\xE3o receber\xE1 mais c\xF3digos de verifica\xE7\xE3o ao realizar o login.",
        messageLine2: "Sua conta pode ficar menos segura. Tem certeza que deseja continuar?",
        successMessage: "C\xF3digo SMS de verifica\xE7\xE3o em duas etapas foi removido para {{mfaPhoneCode}}",
        title: "Remover verifica\xE7\xE3o em duas etapas"
      },
      subtitle__availablePhoneNumbers: "Selecione um n\xFAmero de telefone para registrar a verifica\xE7\xE3o em duas etapas por c\xF3digo SMS.",
      subtitle__unavailablePhoneNumbers: "N\xE3o h\xE1 n\xFAmeros de telefone dispon\xEDveis para registrar a verifica\xE7\xE3o em duas etapas por c\xF3digo SMS.",
      successMessage1: "Ao acessar, ser\xE1 necess\xE1rio o passo adicional de digitar o c\xF3digo de verifica\xE7\xE3o enviado a este telefone.",
      successMessage2: "Salve estes c\xF3digos de backup e os armazene em um lugar seguro. Se voc\xEA perder acesso ao seu dispositivo de autentica\xE7\xE3o, voc\xEA pode utiliz\xE1-los para acessar o sistema.",
      successTitle: "Verifica\xE7\xE3o por SMS habilitada",
      title: "Adicionar verifica\xE7\xE3o por SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Escanear c\xF3digo QR em vez disso",
        buttonUnableToScan__nonPrimary: "N\xE3o pode escanear o c\xF3digo QR?",
        infoText__ableToScan: "Configure um novo m\xE9todo de login no seu aplicativo autenticador e escaneie o seguinte c\xF3digo QR para vincul\xE1-lo \xE0 sua conta.",
        infoText__unableToScan: "Configure um novo m\xE9todo de login no seu aplicativo autenticador e insira a chave informada abaixo.",
        inputLabel__unableToScan1: "Certifique-se de que o 'One-time passwords' est\xE1 habilitado, em seguida, conclua a vincula\xE7\xE3o de sua conta.",
        inputLabel__unableToScan2: "Alternativamente, se seu autenticador suportar URIs TOTP, voc\xEA tamb\xE9m pode copiar a URI completa."
      },
      removeResource: {
        messageLine1: "Os c\xF3digos de verifica\xE7\xE3o deste aplicativo autenticador n\xE3o ser\xE3o mais necess\xE1rios ao fazer login.",
        messageLine2: "Sua conta pode ficar menos segura. Tem certeza que deseja continuar?",
        successMessage: "A verifica\xE7\xE3o em duas etapas via aplicativo autenticador foi removida.",
        title: "Remover verifica\xE7\xE3o em duas etapas"
      },
      successMessage: "A verifica\xE7\xE3o em duas etapas est\xE1 ativa agora. Ao fazer login, voc\xEA precisar\xE1 inserir um c\xF3digo de verifica\xE7\xE3o deste aplicativo autenticador como uma etapa adicional.",
      title: "Adicionar um aplicativo autenticador",
      verifySubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o gerado pelo seu aplicativo autenticador",
      verifyTitle: "C\xF3digo de verifica\xE7\xE3o"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Perfil",
      description: "Gerencie seus dados de perfil.",
      security: "Seguran\xE7a",
      title: "Conta"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} ser\xE1 removido desta conta.",
        title: "Remover chave de acesso"
      },
      subtitle__rename: "Voc\xEA pode renomear a chave de acesso para que seja mais f\xE1cil encontr\xE1-la.",
      title__rename: "Renomear chave de acesso"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\xC9 recomendado sair de todos os demais dispositivos que podem ter utilizado sua senha antiga.",
      readonly: "Sua senha atualmente n\xE3o pode ser editada porque voc\xEA s\xF3 pode fazer login por meio da conex\xE3o da empresa.",
      successMessage__set: "Sua senha foi salva.",
      successMessage__signOutOfOtherSessions: "Todos os outros dispositivos foram desconectados.",
      successMessage__update: "Sua senha foi atualizada.",
      title__set: "Defina a senha",
      title__update: "Trocar senha"
    },
    phoneNumberPage: {
      infoText: "Um SMS contendo um link de verifica\xE7\xE3o ser\xE1 enviado para este telefone.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "Voc\xEA n\xE3o conseguir\xE1 fazer login novamente utilizando este n\xFAmero de telefone.",
        successMessage: "{{phoneNumber}} foi removido da sua conta.",
        title: "Remover telefone"
      },
      successMessage: "{{identifier}} foi adicionado na sua conta.",
      title: "Adicionar telefone",
      verifySubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o enviado para {{identifier}}",
      verifyTitle: "Verificar n\xFAmero de telefone"
    },
    profilePage: {
      fileDropAreaHint: "Carregue uma imagem JPG, PNG, GIF ou WEBP menor que 10 MB",
      imageFormDestructiveActionSubtitle: "Remover imagem",
      imageFormSubtitle: "Carregar imagem",
      imageFormTitle: "Imagem do perfil",
      readonly: "As informa\xE7\xF5es do seu perfil foram fornecidas pela conex\xE3o corporativa e n\xE3o podem ser editadas.",
      successMessage: "Seu perfil foi atualizado.",
      title: "Atualizar perfil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Sair do dispositivo",
        title: "Dispositivos ativos"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Tentar novamente",
        actionLabel__reauthorize: "Reautorizar agora",
        destructiveActionTitle: "Remover",
        primaryButton: "Conectar conta",
        subtitle__disconnected: "Esta conta foi desconectada",
        subtitle__reauthorize: "Os escopos necess\xE1rios foram atualizados, e voc\xEA pode estar experimentado funcionalidades limitadas. Por favor, reautorize esta aplica\xE7\xE3o para evitar outros problemas",
        title: "Contas conectadas"
      },
      dangerSection: {
        deleteAccountButton: "Excluir Conta",
        title: "Perigo"
      },
      emailAddressesSection: {
        destructiveAction: "Remover e-mail",
        detailsAction__nonPrimary: "Definir como principal",
        detailsAction__primary: "Completar verifica\xE7\xE3o",
        detailsAction__unverified: "Completar verifica\xE7\xE3o",
        primaryButton: "Adicionar um e-mail",
        title: "Endere\xE7os de e-mail"
      },
      enterpriseAccountsSection: {
        title: "Contas corporativas"
      },
      headerTitle__account: "Conta",
      headerTitle__security: "Seguran\xE7a",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Gerar c\xF3digos novamente",
          headerTitle: "C\xF3digos de backup",
          subtitle__regenerate: "Obtenha um novo conjunto de c\xF3digos de backup seguros. Os c\xF3digos de backup anteriores ser\xE3o exclu\xEDdos e n\xE3o poder\xE3o ser usados.",
          title__regenerate: "Gerar c\xF3digos de backup novamente"
        },
        phoneCode: {
          actionLabel__setDefault: "Definir como principal",
          destructiveActionLabel: "Remover telefone"
        },
        primaryButton: "Adicione verifica\xE7\xE3o",
        title: "Verifica\xE7\xE3o em duas etapas",
        totp: {
          destructiveActionTitle: "Remover",
          headerTitle: "Aplicativo autenticador"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Remover",
        menuAction__rename: "Renomear",
        primaryButton: void 0,
        title: "Chaves de acesso"
      },
      passwordSection: {
        primaryButton__setPassword: "Defina a senha",
        primaryButton__updatePassword: "Trocar a senha",
        title: "Senha"
      },
      phoneNumbersSection: {
        destructiveAction: "Remover telefone",
        detailsAction__nonPrimary: "Definir como principal",
        detailsAction__primary: "Completar verifica\xE7\xE3o",
        detailsAction__unverified: "Completar verifica\xE7\xE3o",
        primaryButton: "Adicione um telefone",
        title: "N\xFAmeros de telefone"
      },
      profileSection: {
        primaryButton: "Atualizar perfil",
        title: "Perfil"
      },
      usernameSection: {
        primaryButton__setUsername: "Definir nome de usu\xE1rio",
        primaryButton__updateUsername: "Trocar nome de usu\xE1rio",
        title: "Nome de usu\xE1rio"
      },
      web3WalletsSection: {
        destructiveAction: "Remover carteira",
        primaryButton: "Carteiras Web3",
        title: "Carteiras Web3"
      }
    },
    usernamePage: {
      successMessage: "Seu nome de usu\xE1rio foi atualizado.",
      title__set: "Atualizar nome de usu\xE1rio",
      title__update: "Atualizar nome de usu\xE1rio"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "Voc\xEA n\xE3o poder\xE1 mais usar esta carteira Web3 para entrar na sua conta.",
        successMessage: "{{Web3Wallet}} foi removido da sua conta.",
        title: "Remover carteira Web3"
      },
      subtitle__availableWallets: "Selecione uma carteira Web3 para conectar \xE0 sua conta.",
      subtitle__unavailableWallets: "N\xE3o h\xE1 carteiras Web3 dispon\xEDveis.",
      successMessage: "A carteira foi adicionada \xE0 sua conta.",
      title: "Adicionar carteira Web3",
      web3WalletButtonsBlockButton: "Conectar carteira Web3"
    }
  },
  waitlist: {
    start: {
      actionLink: "Entrar",
      actionText: "J\xE1 possui acesso?",
      formButton: "Entrar na lista de espera",
      subtitle: "Entre com seu e-mail e entraremos em contato quando seu lugar estiver dispon\xEDvel",
      title: "Entre na lista de espera"
    },
    success: {
      message: "Te redirecionando em breve...",
      subtitle: "Entraremos em contato quando seu lugar estiver dispon\xEDvel",
      title: "Obrigado por entrar na lista de espera!"
    }
  }
};

// src/pt-PT.ts
var ptPT = {
  locale: "pt-PT",
  backButton: "Voltar",
  badge__default: "Padr\xE3o",
  badge__otherImpersonatorDevice: "Personificar outro dispositivo",
  badge__primary: "Principal",
  badge__requiresAction: "Requer a\xE7\xE3o",
  badge__thisDevice: "Este dispositivo",
  badge__unverified: "N\xE3o verificado",
  badge__userDevice: "Dispositivo do utilizador",
  badge__you: "O utilizador",
  createOrganization: {
    formButtonSubmit: "Criar organiza\xE7\xE3o",
    invitePage: {
      formButtonReset: "Ignorar"
    },
    title: "Criar organiza\xE7\xE3o"
  },
  dates: {
    lastDay: "Ontem \xE0s {{ date | timeString('pt-PT') }}",
    next6Days: "{{ date | weekday('pt-PT','long') }} \xE0s {{ date | timeString('pt-PT') }}",
    nextDay: "Amanh\xE3 \xE0s {{ date | timeString('pt-PT') }}",
    numeric: "{{ date | numeric('pt-PT') }}",
    previous6Days: "\xDAltimo {{ date | weekday('pt-PT','long') }} \xE0s {{ date | timeString('pt-PT') }}",
    sameDay: "Hoje \xE0s {{ date | timeString('pt-PT') }}"
  },
  dividerText: "ou",
  footerActionLink__useAnotherMethod: "Utilize outro m\xE9todo",
  footerPageLink__help: "Ajuda",
  footerPageLink__privacy: "Privacidade",
  footerPageLink__terms: "Termos de uso",
  formButtonPrimary: "Continuar",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Esqueceu a palavra-passe?",
  formFieldError__matchingPasswords: "Passwords match.",
  formFieldError__notMatchingPasswords: "Passwords don't match.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "Opcional",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: "Insira o c\xF3digo de backup",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Eliminar conta",
  formFieldInputPlaceholder__emailAddress: "Insira o seu endere\xE7o de e-mail",
  formFieldInputPlaceholder__emailAddress_username: "Insira o seu e-mail ou nome de utilizador",
  formFieldInputPlaceholder__emailAddresses: "Insira um ou mais endere\xE7os de e-mail separados por espa\xE7os ou v\xEDrgulas",
  formFieldInputPlaceholder__firstName: "Insira o seu primeiro nome",
  formFieldInputPlaceholder__lastName: "Insira o seu apelido",
  formFieldInputPlaceholder__organizationDomain: "Insira o dom\xEDnio da organiza\xE7\xE3o",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Insira o endere\xE7o de e-mail do dom\xEDnio da organiza\xE7\xE3o",
  formFieldInputPlaceholder__organizationName: "Insira o nome da organiza\xE7\xE3o",
  formFieldInputPlaceholder__organizationSlug: "Insira o identificador da organiza\xE7\xE3o (slug)",
  formFieldInputPlaceholder__password: "Insira a sua palavra-passe",
  formFieldInputPlaceholder__phoneNumber: "Insira o seu n\xFAmero de telefone",
  formFieldInputPlaceholder__username: "Insira o seu nome de utilizador",
  formFieldLabel__automaticInvitations: "Ativar convites autom\xE1ticos para este dom\xEDnio",
  formFieldLabel__backupCode: "C\xF3digo de backup",
  formFieldLabel__confirmDeletion: "Confirmar exclus\xE3o",
  formFieldLabel__confirmPassword: "Confirmar palavra-passe",
  formFieldLabel__currentPassword: "Palavra-passe atual",
  formFieldLabel__emailAddress: "Insira o seu e-mail",
  formFieldLabel__emailAddress_username: "E-mail ou nome de utilizador",
  formFieldLabel__emailAddresses: "Endere\xE7os de e-mail",
  formFieldLabel__firstName: "Nome",
  formFieldLabel__lastName: "Apelido",
  formFieldLabel__newPassword: "Nova palavra-passe",
  formFieldLabel__organizationDomain: "Dom\xEDnio",
  formFieldLabel__organizationDomainDeletePending: "Excluir convites e sugest\xF5es pendentes",
  formFieldLabel__organizationDomainEmailAddress: "Endere\xE7o de e-mail de verifica\xE7\xE3o",
  formFieldLabel__organizationDomainEmailAddressDescription: "Endere\xE7o de e-mail para receber um c\xF3digo e verificar este dom\xEDnio",
  formFieldLabel__organizationName: "Nome da organiza\xE7\xE3o",
  formFieldLabel__organizationSlug: "URL Slug",
  formFieldLabel__passkeyName: "Nome da Chave de Acesso",
  formFieldLabel__password: "Palavra-passe",
  formFieldLabel__phoneNumber: "Telem\xF3vel",
  formFieldLabel__role: "Fun\xE7\xE3o",
  formFieldLabel__signOutOfOtherSessions: "Desconectar de todos os outros dispositivos",
  formFieldLabel__username: "Nome de utilizador",
  impersonationFab: {
    action__signOut: "Terminar sess\xE3o",
    title: "Sess\xE3o iniciada como {{identifier}}"
  },
  maintenanceMode: "Modo de Manuten\xE7\xE3o",
  membershipRole__admin: "Administrador",
  membershipRole__basicMember: "Membro",
  membershipRole__guestMember: "Convidado",
  organizationList: {
    action__createOrganization: "Criar organiza\xE7\xE3o",
    action__invitationAccept: "Participar",
    action__suggestionsAccept: "Solicitar participa\xE7\xE3o",
    createOrganization: "Criar organiza\xE7\xE3o",
    invitationAcceptedLabel: "Participando",
    subtitle: "para continuar no {{applicationName}}",
    suggestionsAcceptedLabel: "Aprova\xE7\xE3o pendente",
    title: "Selecione uma conta",
    titleWithoutPersonal: "Selecione uma organiza\xE7\xE3o"
  },
  organizationProfile: {
    badge__automaticInvitation: "Convites autom\xE1ticos",
    badge__automaticSuggestion: "Sugest\xF5es autom\xE1ticas",
    badge__manualInvitation: "Sem inscri\xE7\xE3o autom\xE1tica",
    badge__unverified: "N\xE3o verificado",
    createDomainPage: {
      subtitle: "Adicione o dom\xEDnio para verificar. Utilizadores com endere\xE7os de e-mail neste dom\xEDnio podem entrar na organiza\xE7\xE3o automaticamente ou solicitar entrada.",
      title: "Adicionar dom\xEDnio"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Os convites n\xE3o puderam ser enviados. Corrija o seguinte e tente novamente:",
      formButtonPrimary__continue: "Enviar convites",
      selectDropdown__role: "Select role",
      subtitle: "Convidar novos membros para esta organiza\xE7\xE3o",
      successMessage: "Convites enviados com sucesso",
      title: "Convidar membros"
    },
    membersPage: {
      action__invite: "Convidar",
      action__search: "Pesquisar",
      activeMembersTab: {
        menuAction__remove: "Remover membro",
        tableHeader__actions: "A\xE7\xF5es",
        tableHeader__joined: "Entrou",
        tableHeader__role: "Fun\xE7\xE3o",
        tableHeader__user: "Utilizador"
      },
      detailsTitle__emptyRow: "Nenhum membro para mostrar",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Convide utilizadores conectando um dom\xEDnio de e-mail com a sua organiza\xE7\xE3o. Qualquer pessoa que se inscrever com um dom\xEDnio de e-mail correspondente poder\xE1 se entrar na organiza\xE7\xE3o a qualquer momento.",
          headerTitle: "Convites autom\xE1ticos",
          primaryButton: "Configurar dom\xEDnios verificados"
        },
        table__emptyRow: "Nenhum convite a mostrar"
      },
      invitedMembersTab: {
        menuAction__revoke: "Cancelar convite",
        tableHeader__invited: "Convidado"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Utilizadores que se inscrevem com um dom\xEDnio de e-mail correspondente podem ver uma sugest\xE3o para solicitar participa\xE7\xE3o na sua organiza\xE7\xE3o.",
          headerTitle: "Sugest\xF5es autom\xE1ticas",
          primaryButton: "Configurar dom\xEDnios verificados"
        },
        menuAction__approve: "Aprovar",
        menuAction__reject: "Rejeitar",
        tableHeader__requested: "Acesso solicitado",
        table__emptyRow: "Nenhuma solicita\xE7\xE3o a mostrar"
      },
      start: {
        headerTitle__invitations: "Convites",
        headerTitle__members: "Membros",
        headerTitle__requests: "Pedidos"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "Escreva {{organizationName}} abaixo para continuar.",
          messageLine1: "Tem certeza de que deseja excluir esta organiza\xE7\xE3o?",
          messageLine2: "Esta a\xE7\xE3o \xE9 permanente e irrevers\xEDvel.",
          successMessage: "Voc\xEA excluiu a organiza\xE7\xE3o.",
          title: "Excluir organiza\xE7\xE3o"
        },
        leaveOrganization: {
          actionDescription: "Escreva {{organizationName}} abaixo para continuar.",
          messageLine1: "Tem certeza de que deseja sair desta organiza\xE7\xE3o? Voc\xEA perder\xE1 o acesso a esta organiza\xE7\xE3o e \xE0s suas aplica\xE7\xF5es.",
          messageLine2: "Esta a\xE7\xE3o \xE9 permanente e n\xE3o pode ser desfeita.",
          successMessage: "Voc\xEA saiu da organiza\xE7\xE3o.",
          title: "Sair da organiza\xE7\xE3o"
        },
        title: "Perigo"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Adicionar dom\xEDnio",
        subtitle: "Permita que os utilizadores juntem-se \xE0 organiza\xE7\xE3o automaticamente ou solicitem participa\xE7\xE3o com base num dom\xEDnio de e-mail verificado.",
        title: "Dom\xEDnios verificados"
      },
      successMessage: "A organiza\xE7\xE3o foi atualizada.",
      title: "Perfil da organiza\xE7\xE3o"
    },
    removeDomainPage: {
      messageLine1: "O dom\xEDnio de e-mail {{domain}} ser\xE1 removido.",
      messageLine2: "Os utilizadores n\xE3o conseguir\xE3o entrar na organiza\xE7\xE3o ap\xF3s isso.",
      successMessage: "{{domain}} foi removido.",
      title: "Excluir dom\xEDnio"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Membros",
      profileSection: {
        primaryButton: "Guardar",
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "A exclus\xE3o deste dom\xEDnio afetar\xE1 os utilizadores convidados.",
        removeDomainActionLabel__remove: "Excluir dom\xEDnio",
        removeDomainSubtitle: "Remova este dom\xEDnio dos seus dom\xEDnios verificados",
        removeDomainTitle: "Excluir dom\xEDnio"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Os utilizadores s\xE3o automaticamente convidados a entrar na organiza\xE7\xE3o quando se inscrevem.",
        automaticInvitationOption__label: "Convites autom\xE1ticos",
        automaticSuggestionOption__description: "Os utilizadores recebem uma sugest\xE3o para solicitar participa\xE7\xE3o, mas devem ser aprovados por um administrador antes de poderem entrar na organiza\xE7\xE3o.",
        automaticSuggestionOption__label: "Sugest\xF5es autom\xE1ticas",
        calloutInfoLabel: "Alterar o modo de inscri\xE7\xE3o afetar\xE1 apenas os novos utilizadores.",
        calloutInvitationCountLabel: "Convites pendentes enviados aos utilizadores: {{count}}",
        calloutSuggestionCountLabel: "Sugest\xF5es pendentes enviadas aos utilizadores: {{count}}",
        manualInvitationOption__description: "Os utilizadores s\xF3 podem ser convidados manualmente para a organiza\xE7\xE3o.",
        manualInvitationOption__label: "Sem inscri\xE7\xE3o autom\xE1tica",
        subtitle: "Escolha como os utilizadores deste dom\xEDnio se podem entrar na organiza\xE7\xE3o."
      },
      start: {
        headerTitle__danger: "Perigo",
        headerTitle__enrollment: "Op\xE7\xF5es de inscri\xE7\xE3o"
      },
      subtitle: "O dom\xEDnio {{domain}} agora est\xE1 verificado. Continue por selecionar o modo de inscri\xE7\xE3o.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o enviado para o seu endere\xE7o de e-mail",
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
      subtitle: "O dom\xEDnio {{domainName}} precisa ser verificado por e-mail.",
      subtitleVerificationCodeScreen: "Um c\xF3digo de verifica\xE7\xE3o foi enviado para {{emailAddress}}. Insira-o para continuar.",
      title: "Verificar dom\xEDnio"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Criar organiza\xE7\xE3o",
    action__invitationAccept: "Participar",
    action__manageOrganization: "Configurar organiza\xE7\xE3o",
    action__suggestionsAccept: "Solicitar participa\xE7\xE3o",
    notSelected: "Nenhuma organiza\xE7\xE3o selecionada",
    personalWorkspace: "Conta pessoal",
    suggestionsAcceptedLabel: "Aprova\xE7\xE3o pendente"
  },
  paginationButton__next: "Pr\xF3ximo",
  paginationButton__previous: "Anterior",
  paginationRowText__displaying: "Apresentando",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Ajuda",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Utilize um c\xF3digo de backup",
      blockButton__emailCode: "Enviar c\xF3digo para {{identifier}}",
      blockButton__emailLink: "Enviar link para {{identifier}}",
      blockButton__passkey: "Utilizar chave de acesso",
      blockButton__password: "Fazer login com palavra-passe",
      blockButton__phoneCode: "Enviar c\xF3digo para {{identifier}}",
      blockButton__totp: "Utilize o seu autenticador",
      getHelp: {
        blockButton__emailSupport: "E-mail de suporte",
        content: "Se estiver com dificuldades para entrar na sua conta, envie-nos um e-mail e iremos ajudar-te a restaurar o acesso o mais r\xE1pido poss\xEDvel.",
        title: "Ajuda"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "Utilize outro m\xE9todo"
    },
    backupCodeMfa: {
      subtitle: "para continuar em {{applicationName}}",
      title: "Insira um c\xF3digo de backup"
    },
    emailCode: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique o seu e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "O cliente n\xE3o corresponde ao esperado. Tente novamente.",
        title: "Erro de cliente"
      },
      expired: {
        subtitle: "Retorne para a aba original para continuar",
        title: "Este link de verifica\xE7\xE3o expirou"
      },
      failed: {
        subtitle: "Retorne para a aba original para continuar",
        title: "Este link de verifica\xE7\xE3o \xE9 inv\xE1lido"
      },
      formSubtitle: "Utilize o link enviado no seu e-mail",
      formTitle: "Link de verifica\xE7\xE3o",
      loading: {
        subtitle: "Ser\xE1 redirecionado em breve",
        title: "Entrando..."
      },
      resendButton: "N\xE3o recebeu um link? Reenviar",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique o seu e-mail",
      unusedTab: {
        title: "J\xE1 pode fechar esta aba"
      },
      verified: {
        subtitle: "Ser\xE1 redirecionado em breve",
        title: "Login realizado com sucesso"
      },
      verifiedSwitchTab: {
        subtitle: "Retorne para a aba original para continuar",
        subtitleNewTab: "Retorne para a nova aba que foi aberta para continuar",
        titleNewTab: "Conectado em outra aba"
      }
    },
    forgotPassword: {
      formTitle: "C\xF3digo de redefini\xE7\xE3o de palavra-passe",
      resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Repor a palavra-passe",
      label__alternativeMethods: "Ou, fa\xE7a login com outro m\xE9todo.",
      title: "Esqueceu-se da palavra-passe?"
    },
    noAvailableMethods: {
      message: "N\xE3o foi poss\xEDvel fazer login. N\xE3o h\xE1 nenhum m\xE9todo de autentica\xE7\xE3o dispon\xEDvel.",
      subtitle: "Ocorreu um erro",
      title: "N\xE3o foi poss\xEDvel fazer login"
    },
    passkey: {
      subtitle: "Utilize a sua chave de acesso para autentica\xE7\xE3o.",
      title: "Autentica\xE7\xE3o com Chave de Acesso"
    },
    password: {
      actionLink: "Utilize outro m\xE9todo",
      subtitle: "para continuar em {{applicationName}}",
      title: "Insira a sua palavra-passe"
    },
    passwordPwned: {
      title: "Este password foi comprometido em uma viola\xE7\xE3o de dados. Escolha outro por motivos de seguran\xE7a."
    },
    phoneCode: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique o seu telem\xF3vel"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Insira o c\xF3digo enviado para o seu n\xFAmero de telefone",
      title: "Verifique o seu telem\xF3vel"
    },
    resetPassword: {
      formButtonPrimary: "Repor Palavra-passe",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "A sua palavra-passe foi alterada com sucesso. Entrando, por favor aguarde um momento.",
      title: "Repor Palavra-passe"
    },
    resetPasswordMfa: {
      detailsLabel: "Precisamos verificar a sua identidade antes de redefinir a palavra-passe."
    },
    start: {
      actionLink: "Registre-se",
      actionLink__join_waitlist: "Juntar-se \xE0 lista de espera",
      actionLink__use_email: "Usar e-mail",
      actionLink__use_email_username: "Usar e-mail ou nome de utilizador",
      actionLink__use_passkey: "Usar chave de acesso",
      actionLink__use_phone: "Usar telem\xF3vel",
      actionLink__use_username: "Usar nome de utilizador",
      actionText: "N\xE3o possui uma conta?",
      actionText__join_waitlist: "Ainda n\xE3o tem uma conta? Junte-se \xE0 lista de espera.",
      subtitle: "para continuar em {{applicationName}}",
      subtitleCombined: void 0,
      title: "Entrar",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      subtitle: "Insira o c\xF3digo de verifica\xE7\xE3o enviado para o seu dispositivo.",
      title: "Verifica\xE7\xE3o de duas etapas"
    }
  },
  signInEnterPasswordTitle: "Insira a sua palavra-passe",
  signUp: {
    continue: {
      actionLink: "Entrar",
      actionText: "J\xE1 possui uma conta?",
      subtitle: "para continuar em {{applicationName}}",
      title: "Preencha os campos ausentes"
    },
    emailCode: {
      formSubtitle: "Insira o c\xF3digo enviado para o seu e-mail",
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "N\xE3o recebeu o c\xF3digo? Reenviar",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique o seu e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Parece que houve um erro com a sua sess\xE3o. Tente novamente.",
        title: "Erro de sess\xE3o"
      },
      formSubtitle: "Utilize o link enviado no seu e-mail",
      formTitle: "Link de verifica\xE7\xE3o",
      loading: {
        title: "Entrando..."
      },
      resendButton: "Reenviar link",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique seu e-mail",
      verified: {
        title: "Registo realizado com sucesso"
      },
      verifiedSwitchTab: {
        subtitle: "Volte para a nova aba que foi aberta para continuar",
        subtitleNewTab: "Volte para a aba anterior para continuar",
        title: "E-mail verificado com sucesso"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "Aceito a Pol\xEDtica de Privacidade",
        label__onlyTermsOfService: "Aceito os Termos de Servi\xE7o",
        label__termsOfServiceAndPrivacyPolicy: "Aceito os Termos de Servi\xE7o e a Pol\xEDtica de Privacidade"
      },
      continue: {
        subtitle: "Ao continuar, voc\xEA concorda com os termos acima.",
        title: "Continuar"
      }
    },
    phoneCode: {
      formSubtitle: "Insira o c\xF3digo enviado para o seu telem\xF3vel",
      formTitle: "C\xF3digo de verifica\xE7\xE3o",
      resendButton: "N\xE3o recebeu o c\xF3digo? Reenviar",
      subtitle: "para continuar em {{applicationName}}",
      title: "Verifique o seu telem\xF3vel"
    },
    restrictedAccess: {
      actionLink: "Contactar suporte",
      actionText: "Precisa de ajuda?",
      blockButton__emailSupport: "Enviar e-mail para suporte",
      blockButton__joinWaitlist: "Junte-se \xE0 lista de espera",
      subtitle: "O seu acesso est\xE1 restrito. Para mais informa\xE7\xF5es, entre em contacto connosco.",
      subtitleWaitlist: "Estamos a aguardar a sua entrada na lista de espera. Agradecemos pela paci\xEAncia.",
      title: "Acesso Restrito"
    },
    start: {
      actionLink: "Entrar",
      actionLink__use_email: "Usar e-mail",
      actionLink__use_phone: "Usar telem\xF3vel",
      actionText: "J\xE1 tem uma conta?",
      subtitle: "para continuar em {{applicationName}}",
      subtitleCombined: "para continuar em {{applicationName}}",
      title: "Criar a sua conta",
      titleCombined: "Criar a sua conta"
    }
  },
  socialButtonsBlockButton: "Continuar com {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "J\xE1 \xE9 membro nesta organiza\xE7\xE3o.",
    captcha_invalid: "N\xE3o foi poss\xEDvel inscrever-se devido a falhas nas valida\xE7\xF5es de seguran\xE7a. Por favor, atualize a p\xE1gina para tentar novamente ou entre em contato com o suporte para obter mais ajuda.",
    captcha_unavailable: "Inscri\xE7\xE3o mal-sucedida devido a falha na valida\xE7\xE3o de bot. Por favor, atualize a p\xE1gina para tentar novamente ou entre em contato com o suporte para obter mais ajuda.",
    form_code_incorrect: "C\xF3digo incorreto.",
    form_identifier_exists__email_address: "O endere\xE7o de e-mail j\xE1 est\xE1 em uso.",
    form_identifier_exists__phone_number: "O n\xFAmero de telem\xF3vel j\xE1 est\xE1 em uso.",
    form_identifier_exists__username: "O nome de utilizador j\xE1 est\xE1 em uso.",
    form_identifier_not_found: "Identificador n\xE3o encontrado.",
    form_param_format_invalid: "Formato de par\xE2metro inv\xE1lido.",
    form_param_format_invalid__email_address: "O endere\xE7o de e-mail deve ser v\xE1lido.",
    form_param_format_invalid__phone_number: "O n\xFAmero de telem\xF3vel deve ser v\xE1lido.",
    form_param_max_length_exceeded__first_name: "O primeiro nome n\xE3o deve exceder 256 caracteres.",
    form_param_max_length_exceeded__last_name: "O apelido n\xE3o deve exceder 256 caracteres.",
    form_param_max_length_exceeded__name: "O nome n\xE3o deve exceder 256 caracteres.",
    form_param_nil: "Par\xE2metro n\xE3o pode ser nulo.",
    form_param_value_invalid: "Valor de par\xE2metro inv\xE1lido.",
    form_password_incorrect: "Palavra-passe incorreta.",
    form_password_length_too_short: "A palavra-passe \xE9 muito curta.",
    form_password_not_strong_enough: "A sua palavra-passe n\xE3o \xE9 forte o suficiente.",
    form_password_pwned: "Esta palavra-passe foi encontrada como parte de uma viola\xE7\xE3o e n\xE3o pode ser usada, por favor, tente outra palavra-passe.",
    form_password_pwned__sign_in: "Esta palavra-passe foi encontrada como parte de uma viola\xE7\xE3o e n\xE3o pode ser utilizada para login. Por favor, escolha outra.",
    form_password_size_in_bytes_exceeded: "A sua palavra-passe excedeu o n\xFAmero m\xE1ximo de bytes permitidos, por favor, encurte-a ou remova alguns caracteres especiais.",
    form_password_validation_failed: "Falha na valida\xE7\xE3o da palavra-passe.",
    form_username_invalid_character: "O nome de utilizador cont\xE9m caracteres inv\xE1lidos.",
    form_username_invalid_length: "O nome de utilizador deve ter entre 3 e 50 caracteres.",
    identification_deletion_failed: "Voc\xEA n\xE3o pode excluir a sua \xFAltima identifica\xE7\xE3o.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "menos de {{length}} caracteres",
      minimumLength: "{{length}} ou mais caracteres",
      requireLowercase: "uma letra min\xFAscula",
      requireNumbers: "um n\xFAmero",
      requireSpecialCharacter: "um caractere especial",
      requireUppercase: "uma letra mai\xFAscula",
      sentencePrefix: "A sua palavra-passe deve conter"
    },
    phone_number_exists: "Este n\xFAmero de telem\xF3vel j\xE1 est\xE1 em uso. Por favor, tente outro.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "A sua palavra-passe funciona, mas poderia ser mais forte. Tente adicionar mais caracteres.",
      goodPassword: "A sua palavra-passe atende a todos os requisitos necess\xE1rios.",
      notEnough: "A sua palavra-passe n\xE3o \xE9 forte o suficiente.",
      suggestions: {
        allUppercase: "Utilize apenas algumas letras mai\xFAsculas, n\xE3o todas.",
        anotherWord: "Adicione palavras menos comuns.",
        associatedYears: "Evite anos associados a voc\xEA.",
        capitalization: "Utilize outras letras mai\xFAsculas, al\xE9m do que primeira.",
        dates: "Evite datas e anos associados a voc\xEA.",
        l33t: "Evite substitui\xE7\xF5es previs\xEDveis de letras, como '@' por 'a'.",
        longerKeyboardPattern: "Use padr\xF5es de teclado mais longos e mude a dire\xE7\xE3o da digita\xE7\xE3o v\xE1rias vezes.",
        noNeed: "Voc\xEA pode criar palavras-passes fortes sem usar s\xEDmbolos, n\xFAmeros ou letras mai\xFAsculas.",
        pwned: "Se usar esta palavra-passe noutro lugar, deve mud\xE1-la.",
        recentYears: "Evite anos recentes.",
        repeated: "Evite palavras e caracteres repetidos.",
        reverseWords: 'Evite utilizar palavras comuns escritas de "tr\xE1s para frente".',
        sequences: "Evite sequ\xEAncias comuns de caracteres.",
        useWords: "Use v\xE1rias palavras, mas evite frases comuns."
      },
      warnings: {
        common: "Esta \xE9 uma palavra-passe comumente usada.",
        commonNames: "Nomes e apelidos comuns s\xE3o f\xE1ceis de adivinhar.",
        dates: "Datas s\xE3o f\xE1ceis de adivinhar.",
        extendedRepeat: 'Padr\xF5es de caracteres repetidos, como "abcabcabc" s\xE3o f\xE1ceis de adivinhar.',
        keyPattern: "Padr\xF5es curtos de teclado s\xE3o f\xE1ceis de adivinhar.",
        namesByThemselves: "Nomes ou apelidos s\xE3o f\xE1ceis de adivinhar.",
        pwned: "A sua palavra-passe foi exposta numa viola\xE7\xE3o de dados na Internet.",
        recentYears: "Anos recentes s\xE3o f\xE1ceis de adivinhar.",
        sequences: 'Sequ\xEAncias comuns de caracteres, como "abc" s\xE3o f\xE1ceis de adivinhar.',
        similarToCommon: "Esta \xE9 semelhante a uma palavra-passe comumente usada.",
        simpleRepeat: 'Caracteres repetidos, como "aaa" s\xE3o f\xE1ceis de adivinhar.',
        straightRow: "Letras que v\xEAm em sequ\xEAncia no teclado s\xE3o f\xE1ceis de adivinhar.",
        topHundred: "Esta \xE9 uma palavra-passe usada frequentemente.",
        topTen: "Esta \xE9 uma palavra-passe muito usada.",
        userInputs: "N\xE3o deve haver nenhum dado pessoal ou relacionado \xE0 p\xE1gina.",
        wordByItself: "Palavras simples s\xE3o f\xE1ceis de adivinhar."
      }
    }
  },
  userButton: {
    action__addAccount: "Adicionar conta",
    action__manageAccount: "Configurar conta",
    action__signOut: "Terminar sess\xE3o",
    action__signOutAll: "Terminar sess\xE3o de todas as contas"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copiado!",
      actionLabel__copy: "Copiar tudo",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Imprimir",
      infoText1: "C\xF3digos de backup ser\xE3o ativados para esta conta.",
      infoText2: "Guarde-os em seguran\xE7a e n\xE3o os partilhe. Voc\xEA pode gerar novos c\xF3digos de backup se suspeitar que eles tenham sido comprometidos.",
      subtitle__codelist: "Guarde-os em seguran\xE7a e n\xE3o os partilhe.",
      successMessage: "C\xF3digos de backup foram ativados para esta conta. Pode usar um deles para fazer login na sua conta caso perca o acesso ao seu dispositivo de autentica\xE7\xE3o. Cada c\xF3digo poder\xE1 ser utilizado apenas uma vez.",
      successSubtitle: "Pode usar um deles para fazer login na sua conta caso perca o acesso ao seu dispositivo de autentica\xE7\xE3o.",
      title: "Adicionar c\xF3digo de backup para verifica\xE7\xE3o",
      title__codelist: "C\xF3digos de backup"
    },
    connectedAccountPage: {
      formHint: "Selecione um provedor para conectar \xE0 sua conta.",
      formHint__noAccounts: "N\xE3o h\xE1 provedores de conta externos dispon\xEDveis.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "N\xE3o vai conseguir usar esta conta e, quaisquer recursos dependentes dela deixar\xE3o de funcionar.",
        successMessage: "{{connectedAccount}} foi removido da sua conta.",
        title: "Remover conta conectada"
      },
      socialButtonsBlockButton: "Conectar conta {{provider|titleize}}",
      successMessage: "O provedor foi adicionado \xE0 sua conta",
      title: "Conecte uma conta"
    },
    deletePage: {
      actionDescription: "Escreva Excluir conta abaixo para continuar.",
      confirm: "Excluir conta",
      messageLine1: "Tem certeza de que deseja excluir a sua conta?",
      messageLine2: "Esta a\xE7\xE3o \xE9 permanente e irrevers\xEDvel.",
      title: "Excluir conta"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Um e-mail contendo um c\xF3digo de verifica\xE7\xE3o ser\xE1 enviado para este endere\xE7o de e-mail.",
        formSubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o enviado para {{identifier}}",
        formTitle: "C\xF3digo de verifica\xE7\xE3o",
        resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
        successMessage: "O e-mail {{identifier}} foi adicionado \xE0 sua conta."
      },
      emailLink: {
        formHint: "Um e-mail contendo um link de verifica\xE7\xE3o ser\xE1 enviado para este endere\xE7o de e-mail.",
        formSubtitle: "Clique no link de verifica\xE7\xE3o enviado para {{identifier}}",
        formTitle: "Link de verifica\xE7\xE3o",
        resendButton: "N\xE3o recebeu um c\xF3digo? Reenviar",
        successMessage: "O e-mail {{identifier}} foi adicionado \xE0 sua conta."
      },
      enterpriseSSOLink: {
        formButton: "Clique para autenticar",
        formSubtitle: "Complete a autentica\xE7\xE3o com {{identifier}}"
      },
      formHint: "Voc\xEA precisar\xE1 verificar este endere\xE7o de email antes de poder adicion\xE1-lo \xE0 sua conta.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "N\xE3o vai conseguir fazer login novamente com este endere\xE7o de e-mail.",
        successMessage: "{{emailAddress}} foi removido da sua conta.",
        title: "Remover e-mail"
      },
      title: "Adicionar e-mail",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Continuar",
    formButtonPrimary__finish: "Finalizar",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "Cancelar",
    mfaPage: {
      formHint: "Selecione um m\xE9todo para adicionar.",
      title: "Adicione verifica\xE7\xE3o de duas etapas"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "Adicione um n\xFAmero de telem\xF3vel",
      removeResource: {
        messageLine1: "{{identifier}} n\xE3o receber\xE1 mais c\xF3digos de verifica\xE7\xE3o ao realizar o login.",
        messageLine2: "A sua conta pode ficar menos segura. Tem certeza que deseja continuar?",
        successMessage: "C\xF3digo SMS de verifica\xE7\xE3o de duas etapas foi removido para {{mfaPhoneCode}}",
        title: "Remover verifica\xE7\xE3o de duas etapas"
      },
      subtitle__availablePhoneNumbers: "Selecione um n\xFAmero de telem\xF3vel para registrar a verifica\xE7\xE3o de duas etapas por c\xF3digo SMS.",
      subtitle__unavailablePhoneNumbers: "N\xE3o h\xE1 n\xFAmeros de telem\xF3vel dispon\xEDveis para registrar a verifica\xE7\xE3o de duas etapas por c\xF3digo SMS.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "Adicionar verifica\xE7\xE3o por SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Ler c\xF3digo QR em vez disso",
        buttonUnableToScan__nonPrimary: "N\xE3o pode ler o c\xF3digo QR?",
        infoText__ableToScan: "Configure um novo m\xE9todo de login no seu autenticador e leia o seguinte c\xF3digo QR para vincul\xE1-lo \xE0 sua conta.",
        infoText__unableToScan: "Configure um novo m\xE9todo de login no seu autenticador e insira a chave informada abaixo.",
        inputLabel__unableToScan1: "Certifique-se de que o 'One-time passwords' est\xE1 ativo, de seguida, conclua a conex\xE3o da sua conta.",
        inputLabel__unableToScan2: "Alternativamente, se o seu autenticador suportar URIs TOTP, tamb\xE9m pode copiar a URI completa."
      },
      removeResource: {
        messageLine1: "Os c\xF3digos de verifica\xE7\xE3o deste autenticador n\xE3o ser\xE3o mais necess\xE1rios ao fazer login.",
        messageLine2: "A sua conta pode ficar menos segura. Tem certeza que deseja continuar?",
        successMessage: "A verifica\xE7\xE3o de duas etapas via autenticador foi removida.",
        title: "Remover verifica\xE7\xE3o de duas etapas"
      },
      successMessage: "A verifica\xE7\xE3o de duas etapas est\xE1 agora ativa. Ao fazer login, precisar\xE1 de inserir um c\xF3digo de verifica\xE7\xE3o deste autenticador como uma etapa adicional.",
      title: "Adicionar um autenticador",
      verifySubtitle: "Insira o c\xF3digo de verifica\xE7\xE3o gerado pelo seu autenticador",
      verifyTitle: "C\xF3digo de verifica\xE7\xE3o"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "Tem a certeza de que deseja remover este recurso?",
        title: "Remover Recurso"
      },
      subtitle__rename: "Altere o nome do recurso, se necess\xE1rio.",
      title__rename: "Renomear Recurso"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "A sua palavra-passe n\xE3o pode ser editada porque s\xF3 pode fazer login por meio da conex\xE3o da empresa.",
      successMessage__set: "A sua palavra-passe foi guardada.",
      successMessage__signOutOfOtherSessions: "Todos os outros dispositivos foram desconectados.",
      successMessage__update: "A sua palavra-passe foi atualizada.",
      title__set: "Defina a palavra-passe",
      title__update: "Trocar palavra-passe"
    },
    phoneNumberPage: {
      infoText: "Um SMS contendo um link de verifica\xE7\xE3o ser\xE1 enviado para este telem\xF3vel.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "N\xE3o vai conseguir fazer login novamente com este n\xFAmero de telem\xF3vel.",
        successMessage: "{{phoneNumber}} foi removido da sua conta.",
        title: "Remover telem\xF3vel"
      },
      successMessage: "{{identifier}} foi adicionado \xE0 sua conta.",
      title: "Adicionar telem\xF3vel",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "Carregue uma imagem JPG, PNG, GIF ou WEBP menor que 10MB",
      imageFormDestructiveActionSubtitle: "Remover imagem",
      imageFormSubtitle: "Carregar imagem",
      imageFormTitle: "Imagem de perfil",
      readonly: "As informa\xE7\xF5es do perfil foram fornecidas pela conex\xE3o corporativa e n\xE3o podem ser editadas.",
      successMessage: "O perfil foi atualizado.",
      title: "Atualizar perfil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Terminar sess\xE3o",
        title: "Dispositivos ativos"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Tentar novamente",
        actionLabel__reauthorize: "Reautorizar agora",
        destructiveActionTitle: "Remover",
        primaryButton: "Conectar conta",
        subtitle__disconnected: "A conta foi desconectada. Clique abaixo para conectar novamente.",
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "Contas conectadas"
      },
      dangerSection: {
        deleteAccountButton: "Excluir Conta",
        title: "Perigo"
      },
      emailAddressesSection: {
        destructiveAction: "Remover e-mail",
        detailsAction__nonPrimary: "Definir como principal",
        detailsAction__primary: "Completar verifica\xE7\xE3o",
        detailsAction__unverified: "Completar verifica\xE7\xE3o",
        primaryButton: "Adicionar um e-mail",
        title: "Endere\xE7os de e-mail"
      },
      enterpriseAccountsSection: {
        title: "Contas corporativas"
      },
      headerTitle__account: "Conta",
      headerTitle__security: "Seguran\xE7a",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Gerar novos c\xF3digos",
          headerTitle: "C\xF3digos de backup",
          subtitle__regenerate: "Obter um novo conjunto de c\xF3digos de backup seguros. Os c\xF3digos de backup anteriores ser\xE3o exclu\xEDdos e n\xE3o poder\xE3o ser utilizados novamente.",
          title__regenerate: "Gerar novos c\xF3digos de backup"
        },
        phoneCode: {
          actionLabel__setDefault: "Definir como principal",
          destructiveActionLabel: "Remover telem\xF3vel"
        },
        primaryButton: "Adicione verifica\xE7\xE3o",
        title: "Verifica\xE7\xE3o de duas etapas",
        totp: {
          destructiveActionTitle: "Remover",
          headerTitle: "Autenticador"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Remover chave de acesso",
        menuAction__rename: "Renomear chave de acesso",
        primaryButton: void 0,
        title: "Chaves de Acesso"
      },
      passwordSection: {
        primaryButton__setPassword: void 0,
        primaryButton__updatePassword: void 0,
        title: void 0
      },
      phoneNumbersSection: {
        destructiveAction: "Remover telem\xF3vel",
        detailsAction__nonPrimary: "Definir como principal",
        detailsAction__primary: "Completar verifica\xE7\xE3o",
        detailsAction__unverified: "Completar verifica\xE7\xE3o",
        primaryButton: "Adicione um telem\xF3vel",
        title: "N\xFAmeros de telem\xF3vel"
      },
      profileSection: {
        primaryButton: "Salvar altera\xE7\xF5es",
        title: "Perfil"
      },
      usernameSection: {
        primaryButton__setUsername: "Definir nome de utilizador",
        primaryButton__updateUsername: "Trocar nome de utilizador",
        title: "Nome de utilizador"
      },
      web3WalletsSection: {
        destructiveAction: "Remover carteira",
        primaryButton: "Carteiras Web3",
        title: "Carteiras Web3"
      }
    },
    usernamePage: {
      successMessage: "O nome de utilizador foi atualizado.",
      title__set: "Atualizar nome de utilizador",
      title__update: "Atualizar nome de utilizador"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 removido desta conta.",
        messageLine2: "N\xE3o vai conseguir usar esta carteira Web3 para entrar na sua conta.",
        successMessage: "{{Web3Wallet}} foi removido da sua conta.",
        title: "Remover carteira Web3"
      },
      subtitle__availableWallets: "Selecione uma carteira Web3 para conectar \xE0 sua conta.",
      subtitle__unavailableWallets: "N\xE3o h\xE1 carteiras Web3 dispon\xEDveis.",
      successMessage: "A carteira foi adicionada \xE0 sua conta.",
      title: "Adicionar carteira Web3",
      web3WalletButtonsBlockButton: "Conectar carteira Web3"
    }
  },
  waitlist: {
    start: {
      actionLink: "Junte-se \xE0 lista de espera",
      actionText: "Ainda n\xE3o tem uma conta? Junte-se \xE0 lista de espera.",
      formButton: "Submeter",
      subtitle: "Deixe os seus dados para se juntar \xE0 lista de espera.",
      title: "Juntar-se \xE0 lista de espera"
    },
    success: {
      message: "Obrigado por se inscrever! Voc\xEA ser\xE1 notificado assim que tiver acesso.",
      subtitle: "Aguarde enquanto processamos o seu pedido.",
      title: "Inscri\xE7\xE3o bem-sucedida na lista de espera"
    }
  }
};

// src/es-ES.ts
var esES = {
  locale: "es-ES",
  backButton: "Atr\xE1s",
  badge__default: "Por defecto",
  badge__otherImpersonatorDevice: "Otro dispositivo de imitaci\xF3n",
  badge__primary: "Primario",
  badge__requiresAction: "Requiere acci\xF3n",
  badge__thisDevice: "Este dispositivo",
  badge__unverified: "No confirmado",
  badge__userDevice: "Dispositivo de usuario",
  badge__you: "Usted",
  createOrganization: {
    formButtonSubmit: "Crear organizaci\xF3n",
    invitePage: {
      formButtonReset: "Saltar"
    },
    title: "Crear organizaci\xF3n"
  },
  dates: {
    lastDay: "Ayer a las {{ date | timeString('es-ES') }}",
    next6Days: "{{ date | weekday('es-ES','long') }} a las {{ date | timeString('es-ES') }}",
    nextDay: "Ma\xF1ana a las {{ date | timeString('es-ES') }}",
    numeric: "{{ date | numeric('es-ES') }}",
    previous6Days: "\xDAltimo {{ date | weekday('es-ES','long') }} en {{ date | timeString('es-ES') }}",
    sameDay: "Hoy a las {{ date | timeString('es-ES') }}"
  },
  dividerText: "o",
  footerActionLink__useAnotherMethod: "Usar otro m\xE9todo",
  footerPageLink__help: "Ayuda",
  footerPageLink__privacy: "Privacidad",
  footerPageLink__terms: "T\xE9rminos",
  formButtonPrimary: "Continuar",
  formButtonPrimary__verify: "Verificar",
  formFieldAction__forgotPassword: "Has olvidado tu contrase\xF1a?",
  formFieldError__matchingPasswords: "Las contrase\xF1as coinciden.",
  formFieldError__notMatchingPasswords: "Las contrase\xF1as no coinciden.",
  formFieldError__verificationLinkExpired: "El enlace de verificaci\xF3n ha expirado. Por favor solicite uno nuevo.",
  formFieldHintText__optional: "Opcional",
  formFieldHintText__slug: "Un slug es un ID legible que debe ser \xFAnico. Es com\xFAnmente usado en URLs.",
  formFieldInputPlaceholder__backupCode: "Ingrese su c\xF3digo de respaldo",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Eliminar cuenta",
  formFieldInputPlaceholder__emailAddress: "Ingrese su direcci\xF3n de correo electr\xF3nico",
  formFieldInputPlaceholder__emailAddress_username: "Ingrese su correo electr\xF3nico o nombre de usuario",
  formFieldInputPlaceholder__emailAddresses: "Ingrese o pegue una o m\xE1s direcciones de correo electr\xF3nico, separadas por espacios o comas",
  formFieldInputPlaceholder__firstName: "Ingrese su nombre",
  formFieldInputPlaceholder__lastName: "Ingrese su apellido",
  formFieldInputPlaceholder__organizationDomain: "Ingrese el dominio de la organizaci\xF3n",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Ingrese un correo electr\xF3nico del dominio",
  formFieldInputPlaceholder__organizationName: "Ingrese el nombre de la organizaci\xF3n",
  formFieldInputPlaceholder__organizationSlug: "Ingrese un slug \xFAnico para la organizaci\xF3n",
  formFieldInputPlaceholder__password: "Ingrese su contrase\xF1a",
  formFieldInputPlaceholder__phoneNumber: "Ingrese su n\xFAmero telef\xF3nico",
  formFieldInputPlaceholder__username: "Ingrese su nombre de usuario",
  formFieldLabel__automaticInvitations: "Activar invitaciones autom\xE1ticas para este dominio",
  formFieldLabel__backupCode: "C\xF3digo de respaldo",
  formFieldLabel__confirmDeletion: "Confirmaci\xF3n",
  formFieldLabel__confirmPassword: "Confirme la contrase\xF1a",
  formFieldLabel__currentPassword: "Contrase\xF1a actual",
  formFieldLabel__emailAddress: "Correo electr\xF3nico",
  formFieldLabel__emailAddress_username: "Correo electr\xF3nico o nombre de usuario",
  formFieldLabel__emailAddresses: "Direcciones de correo",
  formFieldLabel__firstName: "Nombre",
  formFieldLabel__lastName: "Apellido",
  formFieldLabel__newPassword: "Nueva contrase\xF1a",
  formFieldLabel__organizationDomain: "Dominio",
  formFieldLabel__organizationDomainDeletePending: "Borrar invitaciones y sugerencias pendientes",
  formFieldLabel__organizationDomainEmailAddress: "Correo de verificaci\xF3n",
  formFieldLabel__organizationDomainEmailAddressDescription: "Ingrese una direcci\xF3n de correo electr\xF3nico bajo este dominio para recibir un c\xF3digo y verificarlo.",
  formFieldLabel__organizationName: "Nombre de la Organizaci\xF3n",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Nombre de la clave de acceso",
  formFieldLabel__password: "Contrase\xF1a",
  formFieldLabel__phoneNumber: "N\xFAmero telef\xF3nico",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Cerrar sesi\xF3n en todos los dem\xE1s dispositivos",
  formFieldLabel__username: "Nombre de usuario",
  impersonationFab: {
    action__signOut: "Cerrar",
    title: "Registrado como {{identifier}}"
  },
  maintenanceMode: "Modo de mantenimiento",
  membershipRole__admin: "Administrador",
  membershipRole__basicMember: "Miembro",
  membershipRole__guestMember: "Invitado",
  organizationList: {
    action__createOrganization: "Crear organizaci\xF3n",
    action__invitationAccept: "Unirse",
    action__suggestionsAccept: "Solicitud a unirse",
    createOrganization: "Crear Organizaci\xF3n",
    invitationAcceptedLabel: "Unido",
    subtitle: "para continuar a {{applicationName}}",
    suggestionsAcceptedLabel: "Aprobaci\xF3n pendiente",
    title: "Choose an account",
    titleWithoutPersonal: "Escoja una organizaci\xF3n"
  },
  organizationProfile: {
    badge__automaticInvitation: "Invitaciones autom\xE1ticas",
    badge__automaticSuggestion: "Sugerencias autom\xE1ticas",
    badge__manualInvitation: "Sin inscripci\xF3n autom\xE1tica",
    badge__unverified: "No verificado",
    createDomainPage: {
      subtitle: "Agregue el dominio para verificar. Los usuarios con direcciones de correo electr\xF3nico en este dominio pueden unirse a la organizaci\xF3n autom\xE1ticamente o solicitar unirse.",
      title: "Agregar dominio"
    },
    invitePage: {
      detailsTitle__inviteFailed: "No se pudieron enviar las invitaciones. Solucione lo siguiente y vuelva a intentarlo:",
      formButtonPrimary__continue: "Enviar invitaciones",
      selectDropdown__role: "Seleccionar rol",
      subtitle: "Invitar nuevos miembros a esta organizaci\xF3n",
      successMessage: "Invitaciones enviadas con \xE9xito",
      title: "Invitar miembros"
    },
    membersPage: {
      action__invite: "Invitar",
      action__search: "Buscar",
      activeMembersTab: {
        menuAction__remove: "Quitar miembro",
        tableHeader__actions: "Acciones",
        tableHeader__joined: "Unido",
        tableHeader__role: "Rol",
        tableHeader__user: "Usuario"
      },
      detailsTitle__emptyRow: "No hay miembros para mostrar",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite a usuarios conectando un dominio de correo electr\xF3nico con su organizaci\xF3n. Cualquiera que se registre con un dominio de correo electr\xF3nico coincidente podr\xE1 unirse a la organizaci\xF3n en cualquier momento.",
          headerTitle: "Invitaciones autom\xE1ticas",
          primaryButton: "Gestionar dominios verificados"
        },
        table__emptyRow: "Sin invitaciones para mostrar"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revocar invitaci\xF3n",
        tableHeader__invited: "Invitado"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Los usuarios que se registren con un dominio de correo electr\xF3nico coincidente podr\xE1n ver una sugerencia para solicitar unirse a su organizaci\xF3n.",
          headerTitle: "Sugerencias autom\xE1ticas",
          primaryButton: "Gestionar dominios verificados"
        },
        menuAction__approve: "Aprobar",
        menuAction__reject: "Rechazar",
        tableHeader__requested: "Acceso solicitado",
        table__emptyRow: "Sin solicitudes para mostrar"
      },
      start: {
        headerTitle__invitations: "Invitaciones",
        headerTitle__members: "Miembros",
        headerTitle__requests: "Solicitudes"
      }
    },
    navbar: {
      description: "Gestione su organizaci\xF3n.",
      general: "General",
      members: "Miembros",
      title: "Organizaci\xF3n"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Escriba "{{organizationName}}" a continuaci\xF3n para continuar.',
          messageLine1: "\xBFEst\xE1 seguro de que desea eliminar esta organizaci\xF3n?",
          messageLine2: "Esta acci\xF3n es permanente e irreversible.",
          successMessage: "Ha eliminado la organizaci\xF3n.",
          title: "Borrar organizaci\xF3n"
        },
        leaveOrganization: {
          actionDescription: 'Escriba "{{organizationName}}" a continuaci\xF3n para continuar.',
          messageLine1: "\xBFEst\xE1 seguro de que desea abandonar esta organizaci\xF3n? Perder\xE1 el acceso a esta organizaci\xF3n y sus aplicaciones.",
          messageLine2: "Esta acci\xF3n es permanente e irreversible.",
          successMessage: "Has dejado la organizaci\xF3n.",
          title: "Abandonar la organizaci\xF3n"
        },
        title: "Peligro"
      },
      domainSection: {
        menuAction__manage: "Gestione",
        menuAction__remove: "Eliminar",
        menuAction__verify: "Verificar",
        primaryButton: "A\xF1adir dominio",
        subtitle: "Permita que los usuarios se unan a la organizaci\xF3n autom\xE1ticamente o soliciten unirse bas\xE1ndose en un dominio de correo electr\xF3nico verificado.",
        title: "Dominios verificados"
      },
      successMessage: "La organizaci\xF3n ha sido actualizada.",
      title: "Perfil de la organizaci\xF3n"
    },
    removeDomainPage: {
      messageLine1: "Se eliminar\xE1 el dominio de correo electr\xF3nico {{domain}}.",
      messageLine2: "Los usuarios no podr\xE1n unirse a la organizaci\xF3n autom\xE1ticamente despu\xE9s de esto.",
      successMessage: "{{dominio}} ha sido eliminado.",
      title: "Eliminar dominio"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Miembros",
      profileSection: {
        primaryButton: "Actualizar perfil",
        title: "Perfil de la Organizaci\xF3n",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "La eliminaci\xF3n de este dominio afectar\xE1 a los usuarios invitados.",
        removeDomainActionLabel__remove: "Eliminar dominio",
        removeDomainSubtitle: "Elimine este dominio de sus dominios verificados",
        removeDomainTitle: "Eliminar dominio"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Los usuarios son invitados autom\xE1ticamente a unirse a la organizaci\xF3n cuando se registran y pueden unirse en cualquier momento.",
        automaticInvitationOption__label: "Invitaciones autom\xE1ticas",
        automaticSuggestionOption__description: "Los usuarios reciben una sugerencia para solicitar unirse, pero deben ser aprobados por un administrador antes de poder unirse a la organizaci\xF3n.",
        automaticSuggestionOption__label: "Sugerencias autom\xE1ticas",
        calloutInfoLabel: "Cambiar el modo de inscripci\xF3n solo afectar\xE1 a nuevos usuarios.",
        calloutInvitationCountLabel: "Invitaciones pendientes enviadas a los usuarios: {{count}}",
        calloutSuggestionCountLabel: "Sugerencias pendientes enviadas a los usuarios: {{count}}",
        manualInvitationOption__description: "Los usuarios solo pueden ser invitados manualmente a la organizaci\xF3n.",
        manualInvitationOption__label: "Sin inscripci\xF3n autom\xE1tica",
        subtitle: "Elija c\xF3mo los usuarios de este dominio pueden unirse a la organizaci\xF3n."
      },
      start: {
        headerTitle__danger: "Peligro",
        headerTitle__enrollment: "Opciones de inscripci\xF3n"
      },
      subtitle: "El dominio {{domain}} est\xE1 ahora verificado. Contin\xFAe seleccionando el modo de inscripci\xF3n.",
      title: "Actualizar {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Ingrese el c\xF3digo de verificaci\xF3n enviado a su direcci\xF3n de correo electr\xF3nico",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibi\xF3 un c\xF3digo? Reenviar",
      subtitle: "El dominio {{domainName}} necesita ser verificado por correo electr\xF3nico.",
      subtitleVerificationCodeScreen: "Se envi\xF3 un c\xF3digo de verificaci\xF3n a {{emailAddress}}. Ingrese el c\xF3digo para continuar.",
      title: "Verificar dominio"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Crear Organizaci\xF3n",
    action__invitationAccept: "Unirse",
    action__manageOrganization: "Administrar Organizaci\xF3n",
    action__suggestionsAccept: "Solicitar unirse",
    notSelected: "Ninguna organizaci\xF3n seleccionada",
    personalWorkspace: "Espacio de trabajo personal",
    suggestionsAcceptedLabel: "Aprobaci\xF3n pendiente"
  },
  paginationButton__next: "Pr\xF3ximo",
  paginationButton__previous: "Previo",
  paginationRowText__displaying: "Mostrando",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: "Probar otro m\xE9todo",
      actionText: "\xBFNo tienes acceso a este m\xE9todo? Prueba otra opci\xF3n.",
      blockButton__backupCode: "Usar c\xF3digo de respaldo",
      blockButton__emailCode: "Usar c\xF3digo de correo electr\xF3nico",
      blockButton__password: "Usar contrase\xF1a",
      blockButton__phoneCode: "Usar c\xF3digo de tel\xE9fono",
      blockButton__totp: "Usar verificaci\xF3n TOTP",
      getHelp: {
        blockButton__emailSupport: "Contactar soporte por correo electr\xF3nico",
        content: "Si no puedes verificar tu identidad con los m\xE9todos anteriores, comun\xEDcate con nuestro equipo de soporte.",
        title: "Necesitas ayuda con la verificaci\xF3n?"
      },
      subtitle: "Selecciona uno de los m\xE9todos disponibles para verificar tu identidad.",
      title: "Reverificaci\xF3n de identidad"
    },
    backupCodeMfa: {
      subtitle: "Introduce tu c\xF3digo de respaldo para continuar con el acceso.",
      title: "Verificaci\xF3n por c\xF3digo de respaldo"
    },
    emailCode: {
      formTitle: "Ingresa el c\xF3digo que hemos enviado a tu correo electr\xF3nico.",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Revisa tu bandeja de entrada para el c\xF3digo de verificaci\xF3n.",
      title: "Verificaci\xF3n por correo electr\xF3nico"
    },
    noAvailableMethods: {
      message: "Lo sentimos, no tienes ning\xFAn m\xE9todo de verificaci\xF3n disponible. Contacta con soporte.",
      subtitle: "No se encontraron m\xE9todos alternativos disponibles.",
      title: "M\xE9todos de verificaci\xF3n no disponibles"
    },
    password: {
      actionLink: "\xBFOlvidaste tu contrase\xF1a? Recup\xE9rala aqu\xED.",
      subtitle: "Usa tu contrase\xF1a para verificar tu identidad.",
      title: "Verificaci\xF3n por contrase\xF1a"
    },
    phoneCode: {
      formTitle: "Introduce el c\xF3digo enviado a tu tel\xE9fono.",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Recibir\xE1s un c\xF3digo SMS para verificar tu identidad.",
      title: "Verificaci\xF3n por tel\xE9fono"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n de 2 pasos",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Introduce el c\xF3digo de verificaci\xF3n de dos factores enviado a tu tel\xE9fono.",
      title: "Verificaci\xF3n por tel\xE9fono (2FA)"
    },
    totpMfa: {
      formTitle: "C\xF3digo TOTP",
      subtitle: "Introduce el c\xF3digo de autenticaci\xF3n TOTP para completar la verificaci\xF3n.",
      title: "Verificaci\xF3n por TOTP (2FA)"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "A\xF1adir cuenta",
      action__signOutAll: "Cerrar sesi\xF3n de todas las cuentas",
      subtitle: "Seleccione la cuenta con la que desea continuar.",
      title: "Elija una cuenta"
    },
    alternativeMethods: {
      actionLink: "Consigue ayuda",
      actionText: "\xBFNo tienes ninguno de estos?",
      blockButton__backupCode: "Usa un c\xF3digo de respaldo",
      blockButton__emailCode: "Enviar c\xF3digo a {{identifier}}",
      blockButton__emailLink: "Enviar enlace a {{identifier}}",
      blockButton__passkey: "Usar llave de acceso",
      blockButton__password: "Entra con tu contrase\xF1a",
      blockButton__phoneCode: "Enviar c\xF3digo a {{identifier}}",
      blockButton__totp: "Usa tu aplicaci\xF3n de autenticaci\xF3n",
      getHelp: {
        blockButton__emailSupport: "Soporte de correo electr\xF3nico",
        content: "Si tiene dificultades para iniciar sesi\xF3n en su cuenta, env\xEDenos un correo electr\xF3nico y trabajaremos con usted para restablecer el acceso lo antes posible.",
        title: "Consigue ayuda"
      },
      subtitle: "\xBFTienes problemas? Puedes usar cualquiera de estos m\xE9todos para iniciar sesi\xF3n.",
      title: "Usa otro m\xE9todo"
    },
    backupCodeMfa: {
      subtitle: "para continuar a {{applicationName}}",
      title: "Introduce un c\xF3digo de seguridad"
    },
    emailCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revise su correo electr\xF3nico"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "El cliente no coincide con el solicitado. Por favor, intente de nuevo.",
        title: "Error de cliente no coincidente"
      },
      expired: {
        subtitle: "Regrese a la pesta\xF1a original para continuar.",
        title: "Este enlace de verificaci\xF3n ha expirado"
      },
      failed: {
        subtitle: "Regrese a la pesta\xF1a original para continuar.",
        title: "Este enlace de verificaci\xF3n es inv\xE1lido"
      },
      formSubtitle: "Utilice el enlace de verificaci\xF3n enviado a su correo electr\xF3nico",
      formTitle: "Enlace de verificaci\xF3n",
      loading: {
        subtitle: "Ser\xE1s redirigido pronto",
        title: "Iniciando sesi\xF3n..."
      },
      resendButton: "Reenviar enlace",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revise su correo electr\xF3nico",
      unusedTab: {
        title: "Puede cerrar esta pesta\xF1a"
      },
      verified: {
        subtitle: "Ser\xE1s redirigido pronto",
        title: "Inici\xF3 sesi\xF3n con \xE9xito"
      },
      verifiedSwitchTab: {
        subtitle: "Regrese a la pesta\xF1a original para continuar",
        subtitleNewTab: "Regrese a la pesta\xF1a reci\xE9n abierta para continuar",
        titleNewTab: "Inici\xF3 sesi\xF3n en otra pesta\xF1a"
      }
    },
    forgotPassword: {
      formTitle: "C\xF3digo de restablecimiento de contrase\xF1a",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "para restablecer tu contrase\xF1a",
      subtitle_email: "Primero, introduce el c\xF3digo enviado a tu correo electr\xF3nico",
      subtitle_phone: "Primero, introduce el c\xF3digo enviado a tu tel\xE9fono",
      title: "Restablecer contrase\xF1a"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Restablecer tu contrase\xF1a",
      label__alternativeMethods: "O, inicia sesi\xF3n con otro m\xE9todo",
      title: "\xBFOlvidaste tu contrase\xF1a?"
    },
    noAvailableMethods: {
      message: "No se puede continuar con el inicio de sesi\xF3n. No hay ning\xFAn factor de autenticaci\xF3n disponible.",
      subtitle: "Ocurri\xF3 un error",
      title: "No puedo iniciar sesi\xF3n"
    },
    passkey: {
      subtitle: "Use su clave de acceso para continuar con la autenticaci\xF3n.",
      title: "Clave de acceso"
    },
    password: {
      actionLink: "Usa otro m\xE9todo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Introduzca su contrase\xF1a"
    },
    passwordPwned: {
      title: "Tu contrase\xF1a ha sido comprometida"
    },
    phoneCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revisa tu tel\xE9fono"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "Introduce el c\xF3digo enviado a tu tel\xE9fono para continuar.",
      title: "Revisa tu tel\xE9fono"
    },
    resetPassword: {
      formButtonPrimary: "Restablecer Contrase\xF1a",
      requiredMessage: "Por razones de seguridad, se requiere restablecer su contrase\xF1a.",
      successMessage: "Tu contrase\xF1a ha sido cambiada exitosamente. Iniciando sesi\xF3n, por favor espera un momento.",
      title: "Establecer nueva contrase\xF1a"
    },
    resetPasswordMfa: {
      detailsLabel: "Necesitamos verificar tu identidad antes de restablecer tu contrase\xF1a."
    },
    start: {
      actionLink: "Reg\xEDstrese",
      actionLink__join_waitlist: "\xDAnase a la lista de espera",
      actionLink__use_email: "Usar correo electr\xF3nico",
      actionLink__use_email_username: "Usar correo electr\xF3nico o nombre de usuario",
      actionLink__use_passkey: "Usar una clave de acceso",
      actionLink__use_phone: "Usar tel\xE9fono",
      actionLink__use_username: "Usar nombre de usuario",
      actionText: "\xBFNo tienes cuenta?",
      actionText__join_waitlist: "\xBFTe gustar\xEDa unirte a la lista de espera?",
      subtitle: "para continuar a {{applicationName}}",
      subtitleCombined: void 0,
      title: "Entrar",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      subtitle: "Introduce el c\xF3digo que te enviamos a tu dispositivo",
      title: "Verificaci\xF3n de dos pasos"
    }
  },
  signInEnterPasswordTitle: "Ingresa tu contrase\xF1a",
  signUp: {
    continue: {
      actionLink: "Entrar",
      actionText: "\xBFTiene una cuenta?",
      subtitle: "para continuar a {{applicationName}}",
      title: "Rellene los campos que faltan"
    },
    emailCode: {
      formSubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a su correo electr\xF3nico",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Re-enviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verifique su correo electr\xF3nico"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Parece que no est\xE1s usando el dispositivo correcto para verificar tu cuenta.",
        title: "Error de dispositivo"
      },
      formSubtitle: "Utilice el enlace de verificaci\xF3n enviado a su direcci\xF3n de correo electr\xF3nico",
      formTitle: "Enlace de verificaci\xF3n",
      loading: {
        title: "Registrando..."
      },
      resendButton: "Reenviar enlace",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verifica tu correo electr\xF3nico",
      verified: {
        title: "Registrado con \xE9xito"
      },
      verifiedSwitchTab: {
        subtitle: "Regrese a la pesta\xF1a reci\xE9n abierta para continuar",
        subtitleNewTab: "Volver a la pesta\xF1a anterior para continuar",
        title: "Correo electr\xF3nico verificado con \xE9xito"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "He le\xEDdo y acepto la Pol\xEDtica de Privacidad",
        label__onlyTermsOfService: "He le\xEDdo y acepto los T\xE9rminos de Servicio",
        label__termsOfServiceAndPrivacyPolicy: "He le\xEDdo y acepto los T\xE9rminos de Servicio y la Pol\xEDtica de Privacidad"
      },
      continue: {
        subtitle: "Al continuar, aceptas las condiciones mencionadas.",
        title: "Por favor, acepta nuestros t\xE9rminos y pol\xEDticas para continuar"
      }
    },
    phoneCode: {
      formSubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a su n\xFAmero de tel\xE9fono",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Re-enviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verifique su tel\xE9fono"
    },
    restrictedAccess: {
      actionLink: "Cont\xE1ctanos para m\xE1s informaci\xF3n",
      actionText: "\xBFTienes problemas? Obt\xE9n ayuda",
      blockButton__emailSupport: "Soporte por correo electr\xF3nico",
      blockButton__joinWaitlist: "Unirte a la lista de espera",
      subtitle: "El acceso a esta funcionalidad est\xE1 restringido en este momento.",
      subtitleWaitlist: "Te has unido a la lista de espera. Nos pondremos en contacto contigo pronto.",
      title: "Acceso restringido"
    },
    start: {
      actionLink: "Iniciar sesi\xF3n",
      actionLink__use_email: "Usar correo electr\xF3nico",
      actionLink__use_phone: "Usar tel\xE9fono",
      actionText: "\xBFYa tienes una cuenta?",
      subtitle: "para continuar en {{applicationName}}",
      subtitleCombined: "para continuar en {{applicationName}}",
      title: "Crea tu cuenta",
      titleCombined: "Crea tu cuenta"
    }
  },
  socialButtonsBlockButton: "Continuar con {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "{{email}} ya es miembro de la organizaci\xF3n.",
    captcha_invalid: "Registro fallido debido a validaciones de seguridad fallidas. Por favor, actualice la p\xE1gina para intentarlo de nuevo o comun\xEDquese con el soporte para m\xE1s asistencia.",
    captcha_unavailable: "Registro fallido debido a una validaci\xF3n de bot fallida. Por favor, actualice la p\xE1gina para intentarlo de nuevo o comun\xEDquese con el soporte para m\xE1s asistencia.",
    form_code_incorrect: "El c\xF3digo ingresado es incorrecto.",
    form_identifier_exists__email_address: "Ya existe una cuenta con esta direcci\xF3n de correo electr\xF3nico.",
    form_identifier_exists__phone_number: "Ya existe una cuenta con este n\xFAmero de tel\xE9fono.",
    form_identifier_exists__username: "Ya existe una cuenta con este nombre de usuario.",
    form_identifier_not_found: "No se ha encontrado ninguna cuenta con este identificador.",
    form_param_format_invalid: "Formato de par\xE1metro inv\xE1lido.",
    form_param_format_invalid__email_address: "La direcci\xF3n de correo electr\xF3nico debe ser una direcci\xF3n de correo electr\xF3nico v\xE1lida.",
    form_param_format_invalid__phone_number: "El n\xFAmero de tel\xE9fono debe estar en un formato internacional v\xE1lido.",
    form_param_max_length_exceeded__first_name: "El nombre no debe exceder los 256 caracteres.",
    form_param_max_length_exceeded__last_name: "El apellido no debe exceder los 256 caracteres.",
    form_param_max_length_exceeded__name: "El nombre no debe exceder los 256 caracteres.",
    form_param_nil: "Este campo es obligatorio.",
    form_param_value_invalid: "Valor inv\xE1lido.",
    form_password_incorrect: "Contrase\xF1a incorrecta.",
    form_password_length_too_short: "La contrase\xF1a es demasiado corta.",
    form_password_not_strong_enough: "Tu contrase\xF1a no es lo suficientemente fuerte.",
    form_password_pwned: "Tu contrase\xF1a ha sido comprometida en una violaci\xF3n de seguridad.",
    form_password_pwned__sign_in: "La contrase\xF1a ya est\xE1 en uso en otro servicio.",
    form_password_size_in_bytes_exceeded: "Tu contrase\xF1a ha excedido el n\xFAmero m\xE1ximo de bytes permitidos, por favor ac\xF3rtala o elimina algunos caracteres especiales.",
    form_password_validation_failed: "La validaci\xF3n de la contrase\xF1a fall\xF3.",
    form_username_invalid_character: "El nombre de usuario contiene caracteres inv\xE1lidos.",
    form_username_invalid_length: "El nombre de usuario debe tener entre 3 y 20 caracteres.",
    identification_deletion_failed: "No puedes eliminar tu \xFAltima identificaci\xF3n.",
    not_allowed_access: "Acceso no permitido.",
    organization_domain_blocked: "Este es un dominio bloqueado, por favor usa otro.",
    organization_domain_common: "Este es un dominio com\xFAn, por favor usa otro.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Has alcanzado tu l\xEDmite de miembros de la organizaci\xF3n, incluyendo invitaciones pendientes.",
    organization_minimum_permissions_needed: "Es necesario que haya al menos un miembro de la organizaci\xF3n con los permisos m\xEDnimos necesarios.",
    passkey_already_exists: "Ya existe una clave de acceso.",
    passkey_not_supported: "Las claves de acceso no son compatibles.",
    passkey_pa_not_supported: "La clave de acceso no es compatible con la autenticaci\xF3n de dispositivos.",
    passkey_registration_cancelled: "El registro de la clave de acceso fue cancelado.",
    passkey_retrieval_cancelled: "La recuperaci\xF3n de la clave de acceso fue cancelada.",
    passwordComplexity: {
      maximumLength: "La contrase\xF1a no debe exceder los {{maxLength}} caracteres.",
      minimumLength: "La contrase\xF1a debe tener al menos {{minLength}} caracteres.",
      requireLowercase: "La contrase\xF1a debe contener al menos una letra min\xFAscula.",
      requireNumbers: "La contrase\xF1a debe contener al menos un n\xFAmero.",
      requireSpecialCharacter: "La contrase\xF1a debe contener al menos un car\xE1cter especial.",
      requireUppercase: "La contrase\xF1a debe contener al menos una letra may\xFAscula.",
      sentencePrefix: "Tu contrase\xF1a debe cumplir con los requisitos de complejidad."
    },
    phone_number_exists: void 0,
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: void 0,
      goodPassword: void 0,
      notEnough: void 0,
      suggestions: {
        allUppercase: void 0,
        anotherWord: void 0,
        associatedYears: void 0,
        capitalization: void 0,
        dates: void 0,
        l33t: void 0,
        longerKeyboardPattern: void 0,
        noNeed: void 0,
        pwned: void 0,
        recentYears: void 0,
        repeated: void 0,
        reverseWords: void 0,
        sequences: void 0,
        useWords: void 0
      },
      warnings: {
        common: void 0,
        commonNames: void 0,
        dates: void 0,
        extendedRepeat: void 0,
        keyPattern: void 0,
        namesByThemselves: void 0,
        pwned: void 0,
        recentYears: void 0,
        sequences: void 0,
        similarToCommon: void 0,
        simpleRepeat: void 0,
        straightRow: void 0,
        topHundred: void 0,
        topTen: void 0,
        userInputs: void 0,
        wordByItself: void 0
      }
    }
  },
  userButton: {
    action__addAccount: "A\xF1adir cuenta",
    action__manageAccount: "Administrar cuenta",
    action__signOut: "Cerrar sesi\xF3n",
    action__signOutAll: "Salir de todas las cuentas"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\xA1Copiado!",
      actionLabel__copy: "Copiar todo",
      actionLabel__download: "Descargar .txt",
      actionLabel__print: "Imprimir",
      infoText1: "Se habilitar\xE1n c\xF3digos de respaldo para esta cuenta.",
      infoText2: "Mantenga los c\xF3digos de respaldo en secreto y gu\xE1rdelos de forma segura. Puede regenerar c\xF3digos de respaldo si sospecha que se han visto comprometidos.",
      subtitle__codelist: "Gu\xE1rdelos de forma segura y mant\xE9ngalos en secreto.",
      successMessage: "Los c\xF3digos de respaldo ahora est\xE1n habilitados. Puede usar uno de estos para iniciar sesi\xF3n en su cuenta, si pierde el acceso a su dispositivo de autenticaci\xF3n. Cada c\xF3digo solo se puede utilizar una vez.",
      successSubtitle: "Puede usar uno de estos para iniciar sesi\xF3n en su cuenta, si pierde el acceso a su dispositivo de autenticaci\xF3n.",
      title: "Agregar verificaci\xF3n de c\xF3digo de respaldo",
      title__codelist: "C\xF3digos de respaldo"
    },
    connectedAccountPage: {
      formHint: "Seleccione un proveedor para conectar su cuenta.",
      formHint__noAccounts: "No hay proveedores de cuentas externas disponibles.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 usar esta cuenta activa y las funciones dependientes ya no funcionar\xE1n.",
        successMessage: "{{connectedAccount}} ha sido eliminado de su cuenta.",
        title: "Eliminar cuenta conectada"
      },
      socialButtonsBlockButton: "Conectar cuenta de {{provider | titleize}}",
      successMessage: "El proveedor ha sido agregado a su cuenta",
      title: "Agregar cuenta conectada"
    },
    deletePage: {
      actionDescription: 'Escribe "Eliminar cuenta" a continuaci\xF3n para continuar.',
      confirm: "Eliminar cuenta",
      messageLine1: "\xBFEst\xE1s seguro de que quieres eliminar tu cuenta?",
      messageLine2: "Esta acci\xF3n es permanente e irreversible.",
      title: "Eliminar cuenta"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "A esta direcci\xF3n de correo electr\xF3nico se le enviar\xE1 un correo electr\xF3nico con un C\xF3digo de verificaci\xF3n.",
        formSubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a {{identifier}}",
        formTitle: "C\xF3digo de verificaci\xF3n",
        resendButton: "Re-enviar c\xF3digo",
        successMessage: "El correo electr\xF3nico {{identifier}} se ha agregado a su cuenta."
      },
      emailLink: {
        formHint: "Se enviar\xE1 un correo electr\xF3nico con un enlace de verificaci\xF3n a esta direcci\xF3n de correo electr\xF3nico.",
        formSubtitle: "Haga clic en el enlace de verificaci\xF3n en el correo electr\xF3nico enviado a {{identifier}}",
        formTitle: "Enlace de verificaci\xF3n",
        resendButton: "Reenviar enlace",
        successMessage: "El correo electr\xF3nico {{identifier}} se ha agregado a su cuenta."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 iniciar sesi\xF3n con esta direcci\xF3n de correo electr\xF3nico.",
        successMessage: "{{emailAddress}} ha sido eliminado de su cuenta.",
        title: "Eliminar direcci\xF3n de correo electr\xF3nico"
      },
      title: "Agregar direcci\xF3n de correo electr\xF3nico",
      verifyTitle: "Verificar correo electr\xF3nico"
    },
    formButtonPrimary__add: "Agregar",
    formButtonPrimary__continue: "Continuar",
    formButtonPrimary__finish: "Terminar",
    formButtonPrimary__remove: "Eliminar",
    formButtonPrimary__save: "Guardar",
    formButtonReset: "Cancelar",
    mfaPage: {
      formHint: "Seleccione un m\xE9todo para agregar.",
      title: "Agregar verificaci\xF3n en dos pasos"
    },
    mfaPhoneCodePage: {
      backButton: "Usar n\xFAmero existente",
      primaryButton__addPhoneNumber: "Agregar un n\xFAmero de tel\xE9fono",
      removeResource: {
        messageLine1: "{{identifier}} dejar\xE1 de recibir el C\xF3digo de verificaci\xF3n al iniciar sesi\xF3n.",
        messageLine2: "Es posible que su cuenta no sea tan segura. \xBFEst\xE1s seguro de que quieres continuar?",
        successMessage: "Se elimin\xF3 la verificaci\xF3n de dos pasos del c\xF3digo SMS para {{mfaPhoneCode}}",
        title: "Eliminar la verificaci\xF3n en dos pasos"
      },
      subtitle__availablePhoneNumbers: "Seleccione un n\xFAmero de tel\xE9fono para registrarse para la verificaci\xF3n en dos pasos del c\xF3digo SMS.",
      subtitle__unavailablePhoneNumbers: "No hay n\xFAmeros de tel\xE9fono disponibles para registrarse para la verificaci\xF3n en dos pasos del c\xF3digo SMS.",
      successMessage1: "Al iniciar sesi\xF3n, deber\xE1 ingresar un c\xF3digo de verificaci\xF3n enviado a este n\xFAmero de tel\xE9fono como un paso adicional.",
      successMessage2: "Guarde estos c\xF3digos de respaldo y almac\xE9nelos en un lugar seguro. Si pierde el acceso a su dispositivo de autenticaci\xF3n, puede usar los c\xF3digos de respaldo para iniciar sesi\xF3n.",
      successTitle: "Verificaci\xF3n de c\xF3digo SMS habilitada",
      title: "Agregar verificaci\xF3n de c\xF3digo SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Escanea el c\xF3digo QR en su lugar",
        buttonUnableToScan__nonPrimary: "\xBFNo puedes escanear el c\xF3digo QR?",
        infoText__ableToScan: "Configure un nuevo m\xE9todo de inicio de sesi\xF3n en su aplicaci\xF3n de autenticaci\xF3n y escanee el siguiente c\xF3digo QR para vincularlo a su cuenta.",
        infoText__unableToScan: "Configure un nuevo m\xE9todo de inicio de sesi\xF3n en su autenticador e ingrese la clave que se proporciona a continuaci\xF3n.",
        inputLabel__unableToScan1: "Aseg\xFArese de que las contrase\xF1as basadas en el tiempo o de un solo uso est\xE9n habilitadas, luego termine de vincular su cuenta.",
        inputLabel__unableToScan2: "Alternativamente, si su autenticador admite TOTP URIs, tambi\xE9n puede copiar el URI completo."
      },
      removeResource: {
        messageLine1: "El c\xF3digo de verificaci\xF3n de este autenticador ya no ser\xE1 necesario al iniciar sesi\xF3n.",
        messageLine2: "Es posible que su cuenta no sea tan segura. \xBFEst\xE1s seguro de que quieres continuar?",
        successMessage: "Se elimin\xF3 la verificaci\xF3n en dos pasos a trav\xE9s de la aplicaci\xF3n de autenticaci\xF3n.",
        title: "Eliminar la verificaci\xF3n en dos pasos"
      },
      successMessage: "La verificaci\xF3n en dos pasos ahora est\xE1 habilitada. Al iniciar sesi\xF3n, deber\xE1 ingresar un c\xF3digo de verificaci\xF3n de este autenticador como un paso adicional.",
      title: "Agregar aplicaci\xF3n de autenticaci\xF3n",
      verifySubtitle: "Ingrese el c\xF3digo de verificaci\xF3n generado por su autenticador",
      verifyTitle: "C\xF3digo de verificaci\xF3n"
    },
    mobileButton__menu: "Men\xFA",
    navbar: {
      account: "Perfil",
      description: "Gestiona la informaci\xF3n de tu cuenta.",
      security: "Seguridad",
      title: "Cuenta"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "\xBFEst\xE1s seguro de que deseas eliminar este recurso?",
        title: "Eliminar Recurso"
      },
      subtitle__rename: "Ingresa el nuevo nombre para la clave de acceso.",
      title__rename: "Renombrar Clave de Acceso"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Se recomienda cerrar sesi\xF3n en todos los dem\xE1s dispositivos que puedan haber usado su contrase\xF1a anterior.",
      readonly: "Su contrase\xF1a actualmente no puede ser editada porque solo puede iniciar sesi\xF3n a trav\xE9s de la conexi\xF3n empresarial.",
      successMessage__set: "Su contrase\xF1a ha sido establecida.",
      successMessage__signOutOfOtherSessions: "Todos los dem\xE1s dispositivos han cerrado sesi\xF3n.",
      successMessage__update: "Tu contrase\xF1a ha sido actualizada.",
      title__set: "Configurar la clave",
      title__update: "Cambiar contrase\xF1a"
    },
    phoneNumberPage: {
      infoText: "Se enviar\xE1 un mensaje de texto con un enlace de verificaci\xF3n a este n\xFAmero de tel\xE9fono.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 iniciar sesi\xF3n con este n\xFAmero de tel\xE9fono.",
        successMessage: "{{phoneNumber}} ha sido eliminado de su cuenta.",
        title: "Eliminar n\xFAmero de tel\xE9fono"
      },
      successMessage: "{{identifier}} ha sido a\xF1adido a tu cuenta.",
      title: "Agregar el n\xFAmero de tel\xE9fono",
      verifySubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a {{identifier}}",
      verifyTitle: "Verificar n\xFAmero de tel\xE9fono"
    },
    profilePage: {
      fileDropAreaHint: "Cargue una imagen JPG, PNG, GIF o WEBP de menos de 10 MB",
      imageFormDestructiveActionSubtitle: "Eliminar la imagen",
      imageFormSubtitle: "Cargar imagen",
      imageFormTitle: "Imagen de perfil",
      readonly: "La informaci\xF3n de su perfil ha sido proporcionada por la conexi\xF3n empresarial y no puede ser editada.",
      successMessage: "Tu perfil ha sido actualizado.",
      title: "Actualizar Cuenta"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Cerrar sesi\xF3n en el dispositivo",
        title: "Dispositivos activos"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Int\xE9ntelo nuevamente",
        actionLabel__reauthorize: "Autorizar ahora",
        destructiveActionTitle: "Quitar",
        primaryButton: "Conectar cuenta",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "Los permisos necesarios han sido actualizados, y podr\xEDa estar experimentando funcionalidad limitada. Por favor, reautorice esta aplicaci\xF3n para evitar problemas.",
        title: "Cuentas conectadas"
      },
      dangerSection: {
        deleteAccountButton: "Eliminar cuenta",
        title: "Eliminar cuenta"
      },
      emailAddressesSection: {
        destructiveAction: "Eliminar direcci\xF3n de correo electr\xF3nico",
        detailsAction__nonPrimary: "Establecer como primario",
        detailsAction__primary: "Completar la verificaci\xF3n",
        detailsAction__unverified: "Completar la verificaci\xF3n",
        primaryButton: "Agregar una direcci\xF3n de correo electr\xF3nico",
        title: "Correos electr\xF3nicos"
      },
      enterpriseAccountsSection: {
        title: "Cuentas empresariales"
      },
      headerTitle__account: "Cuenta",
      headerTitle__security: "Seguridad",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenerar c\xF3digos",
          headerTitle: "C\xF3digos de respaldo",
          subtitle__regenerate: "Obtenga un nuevo conjunto de c\xF3digos de respaldo seguros. Los c\xF3digos de respaldo anteriores se eliminar\xE1n y no podr\xE1n ser usados.",
          title__regenerate: "Regenerar c\xF3digos de respaldo"
        },
        phoneCode: {
          actionLabel__setDefault: "Establecer por defecto",
          destructiveActionLabel: "Eliminar n\xFAmero telef\xF3nico"
        },
        primaryButton: "A\xF1adir verificaci\xF3n de dos pasos",
        title: "Verificaci\xF3n de dos pasos",
        totp: {
          destructiveActionTitle: "Eliminar",
          headerTitle: "Aplicaci\xF3n de autenticaci\xF3n"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Eliminar Clave de Acceso",
        menuAction__rename: "Renombrar Clave de Acceso",
        primaryButton: void 0,
        title: "Secci\xF3n de Claves de Acceso"
      },
      passwordSection: {
        primaryButton__setPassword: "Establecer contrase\xF1a",
        primaryButton__updatePassword: "Cambiar contrase\xF1a",
        title: "Contrase\xF1a"
      },
      phoneNumbersSection: {
        destructiveAction: "Quitar n\xFAmero de tel\xE9fono",
        detailsAction__nonPrimary: "Establecer como primario",
        detailsAction__primary: "Completar la verificaci\xF3n",
        detailsAction__unverified: "Completar la verificaci\xF3n",
        primaryButton: "Agregar un n\xFAmero de tel\xE9fono",
        title: "N\xFAmeros telef\xF3nicos"
      },
      profileSection: {
        primaryButton: "Actualizar perfil",
        title: "Perfil"
      },
      usernameSection: {
        primaryButton__setUsername: "Crear nombre de usuario",
        primaryButton__updateUsername: "Cambiar nombre de usuario",
        title: "Nombre de usuario"
      },
      web3WalletsSection: {
        destructiveAction: "Quitar cartera",
        primaryButton: "Agregar cartera Web3",
        title: "Cartera Web3"
      }
    },
    usernamePage: {
      successMessage: "Su nombre de usuario ha sido actualizado.",
      title__set: "Actualizar nombre de usuario",
      title__update: "Actualizar nombre de usuario"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 iniciar sesi\xF3n con esta billetera web3.",
        successMessage: "{{web3Wallet}} ha sido eliminado de su cuenta.",
        title: "Eliminar la billetera web3"
      },
      subtitle__availableWallets: "Seleccione una billetera web3 para conectarse a su cuenta.",
      subtitle__unavailableWallets: "No hay billeteras web3 disponibles.",
      successMessage: "La billetera ha sido agregada a su cuenta.",
      title: "A\xF1adir billetera Web3",
      web3WalletButtonsBlockButton: "Conectar billetera"
    }
  },
  waitlist: {
    start: {
      actionLink: "\xA1\xDAnete a la lista de espera!",
      actionText: "Si no tienes acceso, puedes unirte a nuestra lista de espera para recibir una invitaci\xF3n m\xE1s adelante.",
      formButton: "Unirse ahora",
      subtitle: "S\xE9 uno de los primeros en acceder a {{applicationName}}.",
      title: "\xDAnete a la lista de espera"
    },
    success: {
      message: "\xA1Felicidades! Te has unido exitosamente a la lista de espera.",
      subtitle: "Recibir\xE1s una invitaci\xF3n para unirte cuando haya espacio disponible.",
      title: "\xA1Te has unido a la lista de espera!"
    }
  }
};

// src/es-UY.ts
var esUY = {
  locale: "es-UY",
  backButton: "Atr\xE1s",
  badge__default: "Predeterminado",
  badge__otherImpersonatorDevice: "Otro dispositivo de suplantaci\xF3n",
  badge__primary: "Principal",
  badge__requiresAction: "Requiere acci\xF3n",
  badge__thisDevice: "Este dispositivo",
  badge__unverified: "No verificado",
  badge__userDevice: "Dispositivo del usuario",
  badge__you: "Vos",
  createOrganization: {
    formButtonSubmit: "Crear organizaci\xF3n",
    invitePage: {
      formButtonReset: "Omitir"
    },
    title: "Crear organizaci\xF3n"
  },
  dates: {
    lastDay: "Ayer a las {{ date | timeString('es-UY') }}",
    next6Days: "{{ date | weekday('es-UY','long') }} a las {{ date | timeString('es-UY') }}",
    nextDay: "Ma\xF1ana a las {{ date | timeString('es-UY') }}",
    numeric: "{{ date | numeric('es-UY') }}",
    previous6Days: "El pasado {{ date | weekday('es-UY','long') }} a las {{ date | timeString('es-UY') }}",
    sameDay: "Hoy a las {{ date | timeString('es-UY') }}"
  },
  dividerText: "o",
  footerActionLink__useAnotherMethod: "Usar otro m\xE9todo",
  footerPageLink__help: "Ayuda",
  footerPageLink__privacy: "Privacidad",
  footerPageLink__terms: "T\xE9rminos",
  formButtonPrimary: "Continuar",
  formButtonPrimary__verify: "Verificar",
  formFieldAction__forgotPassword: "\xBFOlvidaste tu contrase\xF1a?",
  formFieldError__matchingPasswords: "Las contrase\xF1as coinciden.",
  formFieldError__notMatchingPasswords: "Las contrase\xF1as no coinciden.",
  formFieldError__verificationLinkExpired: "El enlace de verificaci\xF3n ha expirado. Por favor, solicit\xE1 un nuevo enlace.",
  formFieldHintText__optional: "Opcional",
  formFieldHintText__slug: "Un slug es una identificaci\xF3n legible por humanos que debe ser \xFAnica. A menudo se utiliza en URLs.",
  formFieldInputPlaceholder__backupCode: "Ingres\xE1 el c\xF3digo de respaldo",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Eliminar cuenta",
  formFieldInputPlaceholder__emailAddress: "Ingres\xE1 tu direcci\xF3n de correo electr\xF3nico",
  formFieldInputPlaceholder__emailAddress_username: "Ingres\xE1 correo electr\xF3nico o nombre de usuario",
  formFieldInputPlaceholder__emailAddresses: "ejemplo@email.com, ejemplo2@email.com",
  formFieldInputPlaceholder__firstName: "Nombre",
  formFieldInputPlaceholder__lastName: "Apellido",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "vos@ejemplo.com",
  formFieldInputPlaceholder__organizationName: "Nombre de la organizaci\xF3n",
  formFieldInputPlaceholder__organizationSlug: "mi-org",
  formFieldInputPlaceholder__password: "Ingres\xE1 tu contrase\xF1a",
  formFieldInputPlaceholder__phoneNumber: "Ingres\xE1 tu n\xFAmero de tel\xE9fono",
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Habilitar invitaciones autom\xE1ticas para este dominio",
  formFieldLabel__backupCode: "C\xF3digo de respaldo",
  formFieldLabel__confirmDeletion: "Confirmaci\xF3n",
  formFieldLabel__confirmPassword: "Confirmar contrase\xF1a",
  formFieldLabel__currentPassword: "Contrase\xF1a actual",
  formFieldLabel__emailAddress: "Correo electr\xF3nico",
  formFieldLabel__emailAddress_username: "Correo electr\xF3nico o nombre de usuario",
  formFieldLabel__emailAddresses: "Correos electr\xF3nicos",
  formFieldLabel__firstName: "Nombre",
  formFieldLabel__lastName: "Apellido",
  formFieldLabel__newPassword: "Nueva contrase\xF1a",
  formFieldLabel__organizationDomain: "Dominio",
  formFieldLabel__organizationDomainDeletePending: "Eliminar invitaciones y sugerencias pendientes",
  formFieldLabel__organizationDomainEmailAddress: "Correo electr\xF3nico de verificaci\xF3n",
  formFieldLabel__organizationDomainEmailAddressDescription: "Ingres\xE1 un correo electr\xF3nico bajo este dominio para recibir un c\xF3digo y verificar el dominio.",
  formFieldLabel__organizationName: "Nombre",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Nombre de la clave de acceso",
  formFieldLabel__password: "Contrase\xF1a",
  formFieldLabel__phoneNumber: "N\xFAmero de tel\xE9fono",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Cerrar sesi\xF3n en todos los dem\xE1s dispositivos",
  formFieldLabel__username: "Nombre de usuario",
  impersonationFab: {
    action__signOut: "Cerrar sesi\xF3n",
    title: "Conectado como {{identifier}}"
  },
  maintenanceMode: "Actualmente estamos en mantenimiento, pero no te preocupes, no tomar\xE1 m\xE1s que unos minutos.",
  membershipRole__admin: "Administrador",
  membershipRole__basicMember: "Miembro",
  membershipRole__guestMember: "Invitado",
  organizationList: {
    action__createOrganization: "Crear organizaci\xF3n",
    action__invitationAccept: "Unirse",
    action__suggestionsAccept: "Solicitar unirse",
    createOrganization: "Crear organizaci\xF3n",
    invitationAcceptedLabel: "Unido",
    subtitle: "para continuar a {{applicationName}}",
    suggestionsAcceptedLabel: "Aprobaci\xF3n pendiente",
    title: "Eleg\xED una cuenta",
    titleWithoutPersonal: "Eleg\xED una organizaci\xF3n"
  },
  organizationProfile: {
    badge__automaticInvitation: "Invitaciones autom\xE1ticas",
    badge__automaticSuggestion: "Sugerencias autom\xE1ticas",
    badge__manualInvitation: "Sin inscripci\xF3n autom\xE1tica",
    badge__unverified: "No verificado",
    createDomainPage: {
      subtitle: "Agreg\xE1 el dominio para verificar. Los usuarios con correos electr\xF3nicos de este dominio pueden unirse autom\xE1ticamente a la organizaci\xF3n o solicitar unirse.",
      title: "Agregar dominio"
    },
    invitePage: {
      detailsTitle__inviteFailed: "No se pudieron enviar las invitaciones. Ya existen invitaciones pendientes para los siguientes correos electr\xF3nicos: {{email_addresses}}.",
      formButtonPrimary__continue: "Enviar invitaciones",
      selectDropdown__role: "Seleccionar rol",
      subtitle: "Ingres\xE1 o peg\xE1 uno o m\xE1s correos electr\xF3nicos, separados por espacios o comas.",
      successMessage: "Invitaciones enviadas con \xE9xito",
      title: "Invitar nuevos miembros"
    },
    membersPage: {
      action__invite: "Invitar",
      action__search: "Buscar",
      activeMembersTab: {
        menuAction__remove: "Eliminar miembro",
        tableHeader__actions: "Acciones",
        tableHeader__joined: "Se uni\xF3",
        tableHeader__role: "Rol",
        tableHeader__user: "Usuario"
      },
      detailsTitle__emptyRow: "No hay miembros para mostrar",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invit\xE1 a usuarios conectando un dominio de correo electr\xF3nico con tu organizaci\xF3n. Cualquiera que se registre con un correo que coincida podr\xE1 unirse a la organizaci\xF3n en cualquier momento.",
          headerTitle: "Invitaciones autom\xE1ticas",
          primaryButton: "Gestionar dominios verificados"
        },
        table__emptyRow: "No hay invitaciones para mostrar"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revocar invitaci\xF3n",
        tableHeader__invited: "Invitado"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Los usuarios que se registren con un correo que coincida podr\xE1n ver una sugerencia para solicitar unirse a tu organizaci\xF3n.",
          headerTitle: "Sugerencias autom\xE1ticas",
          primaryButton: "Gestionar dominios verificados"
        },
        menuAction__approve: "Aprobar",
        menuAction__reject: "Rechazar",
        tableHeader__requested: "Acceso solicitado",
        table__emptyRow: "No hay solicitudes para mostrar"
      },
      start: {
        headerTitle__invitations: "Invitaciones",
        headerTitle__members: "Miembros",
        headerTitle__requests: "Solicitudes"
      }
    },
    navbar: {
      description: "Gestion\xE1 tu organizaci\xF3n.",
      general: "General",
      members: "Miembros",
      title: "Organizaci\xF3n"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Escrib\xED "{{organizationName}}" abajo para continuar.',
          messageLine1: "\xBFEst\xE1s seguro de que quer\xE9s eliminar esta organizaci\xF3n?",
          messageLine2: "Esta acci\xF3n es permanente e irreversible.",
          successMessage: "Has eliminado la organizaci\xF3n.",
          title: "Eliminar organizaci\xF3n"
        },
        leaveOrganization: {
          actionDescription: 'Escrib\xED "{{organizationName}}" abajo para continuar.',
          messageLine1: "\xBFEst\xE1s seguro de que quer\xE9s abandonar esta organizaci\xF3n? Perder\xE1s el acceso a la organizaci\xF3n y a sus aplicaciones.",
          messageLine2: "Esta acci\xF3n es permanente e irreversible.",
          successMessage: "Has abandonado la organizaci\xF3n.",
          title: "Abandonar organizaci\xF3n"
        },
        title: "Peligro"
      },
      domainSection: {
        menuAction__manage: "Gestionar",
        menuAction__remove: "Eliminar",
        menuAction__verify: "Verificar",
        primaryButton: "Agregar dominio",
        subtitle: "Permit\xED que los usuarios se unan a la organizaci\xF3n autom\xE1ticamente o soliciten unirse en base a un dominio de correo verificado.",
        title: "Dominios verificados"
      },
      successMessage: "La organizaci\xF3n ha sido actualizada.",
      title: "Actualizar perfil"
    },
    removeDomainPage: {
      messageLine1: "El dominio de correo {{domain}} ser\xE1 eliminado.",
      messageLine2: "Los usuarios no podr\xE1n unirse autom\xE1ticamente a la organizaci\xF3n despu\xE9s de esto.",
      successMessage: "{{domain}} ha sido eliminado.",
      title: "Eliminar dominio"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Miembros",
      profileSection: {
        primaryButton: "Actualizar perfil",
        title: "Perfil de la organizaci\xF3n",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Eliminar este dominio afectar\xE1 a los usuarios invitados.",
        removeDomainActionLabel__remove: "Eliminar dominio",
        removeDomainSubtitle: "Eliminar este dominio de tus dominios verificados",
        removeDomainTitle: "Eliminar dominio"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Los usuarios son invitados autom\xE1ticamente a unirse a la organizaci\xF3n al registrarse y pueden unirse en cualquier momento.",
        automaticInvitationOption__label: "Invitaciones autom\xE1ticas",
        automaticSuggestionOption__description: "Los usuarios reciben una sugerencia para solicitar unirse, pero deben ser aprobados por un administrador antes de poder unirse a la organizaci\xF3n.",
        automaticSuggestionOption__label: "Sugerencias autom\xE1ticas",
        calloutInfoLabel: "Cambiar el modo de inscripci\xF3n solo afectar\xE1 a los nuevos usuarios.",
        calloutInvitationCountLabel: "Invitaciones pendientes enviadas a usuarios: {{count}}",
        calloutSuggestionCountLabel: "Sugerencias pendientes enviadas a usuarios: {{count}}",
        manualInvitationOption__description: "Los usuarios solo pueden ser invitados manualmente a la organizaci\xF3n.",
        manualInvitationOption__label: "Sin inscripci\xF3n autom\xE1tica",
        subtitle: "Eleg\xED c\xF3mo los usuarios de este dominio pueden unirse a la organizaci\xF3n."
      },
      start: {
        headerTitle__danger: "Peligro",
        headerTitle__enrollment: "Opciones de inscripci\xF3n"
      },
      subtitle: "El dominio {{domain}} est\xE1 verificado. Continu\xE1 seleccionando el modo de inscripci\xF3n.",
      title: "Actualizar {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n enviado a tu correo electr\xF3nico",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "El dominio {{domainName}} necesita ser verificado por correo electr\xF3nico.",
      subtitleVerificationCodeScreen: "Se envi\xF3 un c\xF3digo de verificaci\xF3n a {{emailAddress}}. Ingres\xE1 el c\xF3digo para continuar.",
      title: "Verificar dominio"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Crear organizaci\xF3n",
    action__invitationAccept: "Unirse",
    action__manageOrganization: "Gestionar",
    action__suggestionsAccept: "Solicitar unirse",
    notSelected: "Ninguna organizaci\xF3n seleccionada",
    personalWorkspace: "Cuenta personal",
    suggestionsAcceptedLabel: "Aprobaci\xF3n pendiente"
  },
  paginationButton__next: "Siguiente",
  paginationButton__previous: "Anterior",
  paginationRowText__displaying: "Mostrando",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: "Obtener ayuda",
      actionText: "\xBFNo ten\xE9s ninguno de estos?",
      blockButton__backupCode: "Usar un c\xF3digo de respaldo",
      blockButton__emailCode: "Enviar c\xF3digo por correo a {{identifier}}",
      blockButton__password: "Continuar con tu contrase\xF1a",
      blockButton__phoneCode: "Enviar c\xF3digo SMS a {{identifier}}",
      blockButton__totp: "Usar tu aplicaci\xF3n autenticadora",
      getHelp: {
        blockButton__emailSupport: "Soporte por correo",
        content: "Si ten\xE9s problemas para verificar tu cuenta, envi\xE1nos un correo y trabajaremos para restaurar el acceso lo antes posible.",
        title: "Obtener ayuda"
      },
      subtitle: "\xBFTen\xE9s problemas? Pod\xE9s usar cualquiera de estos m\xE9todos para la verificaci\xF3n.",
      title: "Usar otro m\xE9todo"
    },
    backupCodeMfa: {
      subtitle: "Ingres\xE1 el c\xF3digo de respaldo que recibiste al configurar la autenticaci\xF3n de dos pasos",
      title: "Ingres\xE1 un c\xF3digo de respaldo"
    },
    emailCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "Ingres\xE1 el c\xF3digo enviado a tu correo para continuar",
      title: "Verificaci\xF3n requerida"
    },
    noAvailableMethods: {
      message: "No se puede proceder con la verificaci\xF3n. No hay un factor de autenticaci\xF3n adecuado configurado",
      subtitle: "Ocurri\xF3 un error",
      title: "No se puede verificar tu cuenta"
    },
    password: {
      actionLink: "Usar otro m\xE9todo",
      subtitle: "Ingres\xE1 tu contrase\xF1a para continuar",
      title: "Verificaci\xF3n requerida"
    },
    phoneCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "Ingres\xE1 el c\xF3digo enviado a tu tel\xE9fono para continuar",
      title: "Verificaci\xF3n requerida"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "Ingres\xE1 el c\xF3digo enviado a tu tel\xE9fono para continuar",
      title: "Verificaci\xF3n requerida"
    },
    totpMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      subtitle: "Ingres\xE1 el c\xF3digo generado por tu aplicaci\xF3n autenticadora para continuar",
      title: "Verificaci\xF3n requerida"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Agregar cuenta",
      action__signOutAll: "Cerrar sesi\xF3n en todas las cuentas",
      subtitle: "Seleccion\xE1 la cuenta con la que deseas continuar.",
      title: "Eleg\xED una cuenta"
    },
    alternativeMethods: {
      actionLink: "Obtener ayuda",
      actionText: "\xBFNo ten\xE9s ninguno de estos?",
      blockButton__backupCode: "Usar un c\xF3digo de respaldo",
      blockButton__emailCode: "Enviar c\xF3digo por correo a {{identifier}}",
      blockButton__emailLink: "Enviar enlace por correo a {{identifier}}",
      blockButton__passkey: "Ingres\xE1 con tu clave de acceso",
      blockButton__password: "Ingres\xE1 con tu contrase\xF1a",
      blockButton__phoneCode: "Enviar c\xF3digo SMS a {{identifier}}",
      blockButton__totp: "Usar tu aplicaci\xF3n autenticadora",
      getHelp: {
        blockButton__emailSupport: "Soporte por correo",
        content: "Si ten\xE9s problemas para ingresar a tu cuenta, envi\xE1nos un correo y trabajaremos para restaurar el acceso lo antes posible.",
        title: "Obtener ayuda"
      },
      subtitle: "\xBFTen\xE9s problemas? Pod\xE9s usar cualquiera de estos m\xE9todos para ingresar.",
      title: "Usar otro m\xE9todo"
    },
    backupCodeMfa: {
      subtitle: "Tu c\xF3digo de respaldo es el que recibiste al configurar la autenticaci\xF3n de dos pasos.",
      title: "Ingres\xE1 un c\xF3digo de respaldo"
    },
    emailCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revis\xE1 tu correo"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Para continuar, abr\xED el enlace de verificaci\xF3n en el dispositivo y navegador desde el cual iniciaste sesi\xF3n",
        title: "El enlace de verificaci\xF3n no es v\xE1lido para este dispositivo"
      },
      expired: {
        subtitle: "Volv\xE9 a la pesta\xF1a original para continuar.",
        title: "Este enlace de verificaci\xF3n ha expirado"
      },
      failed: {
        subtitle: "Volv\xE9 a la pesta\xF1a original para continuar.",
        title: "Este enlace de verificaci\xF3n no es v\xE1lido"
      },
      formSubtitle: "Us\xE1 el enlace de verificaci\xF3n enviado a tu correo",
      formTitle: "Enlace de verificaci\xF3n",
      loading: {
        subtitle: "Ser\xE1s redirigido pronto",
        title: "Iniciando sesi\xF3n..."
      },
      resendButton: "\xBFNo recibiste un enlace? Reenviar",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revis\xE1 tu correo",
      unusedTab: {
        title: "Pod\xE9s cerrar esta pesta\xF1a"
      },
      verified: {
        subtitle: "Ser\xE1s redirigido pronto",
        title: "Sesi\xF3n iniciada con \xE9xito"
      },
      verifiedSwitchTab: {
        subtitle: "Volv\xE9 a la pesta\xF1a original para continuar",
        subtitleNewTab: "Volv\xE9 a la nueva pesta\xF1a para continuar",
        titleNewTab: "Sesi\xF3n iniciada en otra pesta\xF1a"
      }
    },
    forgotPassword: {
      formTitle: "C\xF3digo para restablecer la contrase\xF1a",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "para restablecer tu contrase\xF1a",
      subtitle_email: "Primero, ingres\xE1 el c\xF3digo enviado a tu correo electr\xF3nico",
      subtitle_phone: "Primero, ingres\xE1 el c\xF3digo enviado a tu tel\xE9fono",
      title: "Restablecer contrase\xF1a"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Restablecer tu contrase\xF1a",
      label__alternativeMethods: "O, ingres\xE1 con otro m\xE9todo",
      title: "\xBFOlvidaste tu contrase\xF1a?"
    },
    noAvailableMethods: {
      message: "No se puede continuar con el inicio de sesi\xF3n. No hay un factor de autenticaci\xF3n disponible.",
      subtitle: "Ocurri\xF3 un error",
      title: "No se puede iniciar sesi\xF3n"
    },
    passkey: {
      subtitle: "Usar tu clave de acceso confirma que sos vos. Tu dispositivo puede solicitar tu huella, rostro o bloqueo de pantalla.",
      title: "Usar tu clave de acceso"
    },
    password: {
      actionLink: "Usar otro m\xE9todo",
      subtitle: "Ingres\xE1 la contrase\xF1a asociada a tu cuenta",
      title: "Ingres\xE1 tu contrase\xF1a"
    },
    passwordPwned: {
      title: "Contrase\xF1a comprometida"
    },
    phoneCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revis\xE1 tu tel\xE9fono"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "Para continuar, ingres\xE1 el c\xF3digo enviado a tu tel\xE9fono",
      title: "Revis\xE1 tu tel\xE9fono"
    },
    resetPassword: {
      formButtonPrimary: "Restablecer contrase\xF1a",
      requiredMessage: "Por razones de seguridad, es necesario restablecer tu contrase\xF1a.",
      successMessage: "Tu contrase\xF1a se cambi\xF3 con \xE9xito. Iniciando sesi\xF3n, por favor, esper\xE1 un momento.",
      title: "Establecer nueva contrase\xF1a"
    },
    resetPasswordMfa: {
      detailsLabel: "Necesitamos verificar tu identidad antes de restablecer tu contrase\xF1a."
    },
    start: {
      actionLink: "Registrate",
      actionLink__join_waitlist: "Unirse a la lista de espera",
      actionLink__use_email: "Usar correo",
      actionLink__use_email_username: "Usar correo o nombre de usuario",
      actionLink__use_passkey: "Usar clave de acceso en su lugar",
      actionLink__use_phone: "Usar tel\xE9fono",
      actionLink__use_username: "Usar nombre de usuario",
      actionText: "\xBFNo ten\xE9s una cuenta?",
      actionText__join_waitlist: "\xBFQuer\xE9s acceso anticipado?",
      subtitle: "\xA1Bienvenido de nuevo! Por favor, ingres\xE1 para continuar",
      subtitleCombined: void 0,
      title: "Inici\xE1 sesi\xF3n en {{applicationName}}",
      titleCombined: "Continuar a {{applicationName}}"
    },
    totpMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      subtitle: "Para continuar, ingres\xE1 el c\xF3digo generado por tu aplicaci\xF3n autenticadora",
      title: "Verificaci\xF3n en dos pasos"
    }
  },
  signInEnterPasswordTitle: "Ingres\xE1 tu contrase\xF1a",
  signUp: {
    continue: {
      actionLink: "Iniciar sesi\xF3n",
      actionText: "\xBFYa ten\xE9s una cuenta?",
      subtitle: "Complet\xE1 los datos restantes para continuar.",
      title: "Complet\xE1 los campos faltantes"
    },
    emailCode: {
      formSubtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n enviado a tu correo electr\xF3nico",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n enviado a tu correo",
      title: "Verific\xE1 tu correo"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Para continuar, abr\xED el enlace de verificaci\xF3n en el dispositivo y navegador desde el cual te registraste",
        title: "El enlace de verificaci\xF3n no es v\xE1lido para este dispositivo"
      },
      formSubtitle: "Us\xE1 el enlace de verificaci\xF3n enviado a tu correo electr\xF3nico",
      formTitle: "Enlace de verificaci\xF3n",
      loading: {
        title: "Registr\xE1ndose..."
      },
      resendButton: "\xBFNo recibiste un enlace? Reenviar",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verific\xE1 tu correo",
      verified: {
        title: "Registro exitoso"
      },
      verifiedSwitchTab: {
        subtitle: "Volv\xE9 a la nueva pesta\xF1a para continuar",
        subtitleNewTab: "Volv\xE9 a la pesta\xF1a anterior para continuar",
        title: "Correo verificado con \xE9xito"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Acepto la {{ privacyPolicyLink || link("Pol\xEDtica de Privacidad") }}',
        label__onlyTermsOfService: 'Acepto los {{ termsOfServiceLink || link("T\xE9rminos de Servicio") }}',
        label__termsOfServiceAndPrivacyPolicy: 'Acepto los {{ termsOfServiceLink || link("T\xE9rminos de Servicio") }} y la {{ privacyPolicyLink || link("Pol\xEDtica de Privacidad") }}'
      },
      continue: {
        subtitle: "Por favor, le\xE9 y acept\xE1 los t\xE9rminos para continuar",
        title: "Consentimiento legal"
      }
    },
    phoneCode: {
      formSubtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n enviado a tu n\xFAmero de tel\xE9fono",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
      subtitle: "Ingres\xE1 el c\xF3digo enviado a tu tel\xE9fono",
      title: "Verific\xE1 tu tel\xE9fono"
    },
    restrictedAccess: {
      actionLink: "Iniciar sesi\xF3n",
      actionText: "\xBFYa ten\xE9s una cuenta?",
      blockButton__emailSupport: "Soporte por correo",
      blockButton__joinWaitlist: "Unirse a la lista de espera",
      subtitle: "Actualmente, los registros est\xE1n deshabilitados. Si cre\xE9s que deber\xEDas tener acceso, contact\xE1 al soporte.",
      subtitleWaitlist: "Actualmente, los registros est\xE1n deshabilitados. Para ser el primero en saber cuando lancemos, unite a la lista de espera.",
      title: "Acceso restringido"
    },
    start: {
      actionLink: "Iniciar sesi\xF3n",
      actionLink__use_email: "Usar correo en su lugar",
      actionLink__use_phone: "Usar tel\xE9fono en su lugar",
      actionText: "\xBFYa ten\xE9s una cuenta?",
      subtitle: "\xA1Bienvenido! Complet\xE1 los datos para comenzar.",
      subtitleCombined: "\xA1Bienvenido! Complet\xE1 los datos para comenzar.",
      title: "Cre\xE1 tu cuenta",
      titleCombined: "Cre\xE1 tu cuenta"
    }
  },
  socialButtonsBlockButton: "Continuar con {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} ya es miembro de la organizaci\xF3n.",
    captcha_invalid: "El registro no se pudo completar debido a validaciones de seguridad fallidas. Por favor, actualiz\xE1 la p\xE1gina para intentarlo de nuevo o contact\xE1 al soporte para m\xE1s asistencia.",
    captcha_unavailable: "El registro no se pudo completar debido a la validaci\xF3n fallida contra bots. Por favor, actualiz\xE1 la p\xE1gina para intentarlo de nuevo o contact\xE1 al soporte para m\xE1s asistencia.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "Este correo electr\xF3nico ya est\xE1 en uso. Por favor, prob\xE1 con otro.",
    form_identifier_exists__phone_number: "Este n\xFAmero de tel\xE9fono ya est\xE1 en uso. Por favor, prob\xE1 con otro.",
    form_identifier_exists__username: "Este nombre de usuario ya est\xE1 en uso. Por favor, prob\xE1 con otro.",
    form_identifier_not_found: "No se encontr\xF3 una cuenta con este identificador. Por favor, verific\xE1 e intent\xE1 de nuevo.",
    form_param_format_invalid: "El valor ingresado tiene un formato inv\xE1lido. Por favor, verific\xE1 y correg\xED.",
    form_param_format_invalid__email_address: "El correo electr\xF3nico debe ser v\xE1lido.",
    form_param_format_invalid__phone_number: "El n\xFAmero de tel\xE9fono debe estar en un formato internacional v\xE1lido.",
    form_param_max_length_exceeded__first_name: "El nombre no debe exceder los 256 caracteres.",
    form_param_max_length_exceeded__last_name: "El apellido no debe exceder los 256 caracteres.",
    form_param_max_length_exceeded__name: "El nombre no debe exceder los 256 caracteres.",
    form_param_nil: "Este campo es obligatorio y no puede estar vac\xEDo.",
    form_param_value_invalid: "El valor ingresado es inv\xE1lido. Por favor, corregilo.",
    form_password_incorrect: "La contrase\xF1a ingresada es incorrecta. Por favor, intent\xE1 de nuevo.",
    form_password_length_too_short: "Tu contrase\xF1a es demasiado corta. Debe tener al menos 8 caracteres.",
    form_password_not_strong_enough: "Tu contrase\xF1a no es lo suficientemente fuerte.",
    form_password_pwned: "Esta contrase\xF1a se encontr\xF3 en una filtraci\xF3n y no se puede usar. Por favor, prob\xE1 con otra contrase\xF1a.",
    form_password_pwned__sign_in: "Esta contrase\xF1a se encontr\xF3 en una filtraci\xF3n y no se puede usar. Por favor, restablec\xE9 tu contrase\xF1a.",
    form_password_size_in_bytes_exceeded: "Tu contrase\xF1a ha excedido el n\xFAmero m\xE1ximo de bytes permitidos. Por favor, acortala o elimin\xE1 algunos caracteres especiales.",
    form_password_validation_failed: "Contrase\xF1a incorrecta",
    form_username_invalid_character: "Tu nombre de usuario contiene caracteres inv\xE1lidos. Por favor, us\xE1 solo letras, n\xFAmeros y guiones bajos.",
    form_username_invalid_length: "Tu nombre de usuario debe tener entre {{min_length}} y {{max_length}} caracteres.",
    identification_deletion_failed: "No pod\xE9s eliminar tu \xFAltima identificaci\xF3n.",
    not_allowed_access: "No ten\xE9s permiso para acceder a esta p\xE1gina. Por favor, contact\xE1 al soporte si cre\xE9s que esto es un error.",
    organization_domain_blocked: "Este es un dominio de proveedor de correo bloqueado. Por favor, us\xE1 otro.",
    organization_domain_common: "Este es un dominio de proveedor de correo com\xFAn. Por favor, us\xE1 otro.",
    organization_domain_exists_for_enterprise_connection: "Este dominio ya se utiliza para el SSO de tu organizaci\xF3n.",
    organization_membership_quota_exceeded: "Has alcanzado el l\xEDmite de membres\xEDas en organizaciones, incluyendo invitaciones pendientes.",
    organization_minimum_permissions_needed: "Debe haber al menos un miembro de la organizaci\xF3n con los permisos m\xEDnimos requeridos.",
    passkey_already_exists: "Ya hay una clave de acceso registrada en este dispositivo.",
    passkey_not_supported: "Las claves de acceso no son compatibles con este dispositivo.",
    passkey_pa_not_supported: "El registro requiere un autenticador de plataforma, pero el dispositivo no lo soporta.",
    passkey_registration_cancelled: "El registro de la clave de acceso fue cancelado o agot\xF3 el tiempo de espera.",
    passkey_retrieval_cancelled: "La verificaci\xF3n de la clave de acceso fue cancelada o agot\xF3 el tiempo de espera.",
    passwordComplexity: {
      maximumLength: "menos de {{length}} caracteres",
      minimumLength: "{{length}} o m\xE1s caracteres",
      requireLowercase: "una letra min\xFAscula",
      requireNumbers: "un n\xFAmero",
      requireSpecialCharacter: "un car\xE1cter especial",
      requireUppercase: "una letra may\xFAscula",
      sentencePrefix: "Tu contrase\xF1a debe contener"
    },
    phone_number_exists: "Este n\xFAmero de tel\xE9fono ya est\xE1 en uso. Por favor, prob\xE1 con otro.",
    web3_missing_identifier: "No se encontr\xF3 una extensi\xF3n de cartera Web3. Por favor, instal\xE1 una para continuar.",
    zxcvbn: {
      couldBeStronger: "Tu contrase\xF1a funciona, pero podr\xEDa ser m\xE1s fuerte. Intent\xE1 agregar m\xE1s caracteres.",
      goodPassword: "Tu contrase\xF1a cumple con todos los requisitos necesarios.",
      notEnough: "Tu contrase\xF1a no es lo suficientemente fuerte.",
      suggestions: {
        allUppercase: "Us\xE1 may\xFAsculas en algunas letras, pero no en todas.",
        anotherWord: "Agreg\xE1 m\xE1s palabras que sean menos comunes.",
        associatedYears: "Evit\xE1 a\xF1os que est\xE9n asociados contigo.",
        capitalization: "Us\xE1 may\xFAsculas en m\xE1s de la primera letra.",
        dates: "Evit\xE1 fechas y a\xF1os que est\xE9n asociados contigo.",
        l33t: 'Evit\xE1 sustituciones de letras predecibles como "@" en lugar de "a".',
        longerKeyboardPattern: "Us\xE1 patrones de teclado m\xE1s largos y cambi\xE1 la direcci\xF3n de tecleo varias veces.",
        noNeed: "Pod\xE9s crear contrase\xF1as fuertes sin usar s\xEDmbolos, n\xFAmeros o letras may\xFAsculas.",
        pwned: "Si us\xE1s esta contrase\xF1a en otros sitios, deber\xEDas cambiarla.",
        recentYears: "Evit\xE1 a\xF1os recientes.",
        repeated: "Evit\xE1 palabras y caracteres repetidos.",
        reverseWords: "Evit\xE1 las versiones invertidas de palabras comunes.",
        sequences: "Evit\xE1 secuencias comunes de caracteres.",
        useWords: "Us\xE1 varias palabras, pero evit\xE1 frases comunes."
      },
      warnings: {
        common: "Esta es una contrase\xF1a com\xFAn.",
        commonNames: "Los nombres y apellidos comunes son f\xE1ciles de adivinar.",
        dates: "Las fechas son f\xE1ciles de adivinar.",
        extendedRepeat: 'Los patrones de caracteres repetidos como "abcabcabc" son f\xE1ciles de adivinar.',
        keyPattern: "Los patrones cortos de teclado son f\xE1ciles de adivinar.",
        namesByThemselves: "Los nombres o apellidos por s\xED solos son f\xE1ciles de adivinar.",
        pwned: "Tu contrase\xF1a se vio comprometida en una filtraci\xF3n de datos en Internet.",
        recentYears: "Los a\xF1os recientes son f\xE1ciles de adivinar.",
        sequences: 'Secuencias comunes de caracteres como "abc" son f\xE1ciles de adivinar.',
        similarToCommon: "Esto es similar a una contrase\xF1a com\xFAn.",
        simpleRepeat: 'Caracteres repetidos como "aaa" son f\xE1ciles de adivinar.',
        straightRow: "Filas rectas de teclas en tu teclado son f\xE1ciles de adivinar.",
        topHundred: "Esta es una contrase\xF1a frecuentemente usada.",
        topTen: "Esta es una contrase\xF1a muy usada.",
        userInputs: "No debe haber ning\xFAn dato personal o relacionado con la p\xE1gina.",
        wordByItself: "Palabras solas son f\xE1ciles de adivinar."
      }
    }
  },
  userButton: {
    action__addAccount: "Agregar cuenta",
    action__manageAccount: "Gestionar cuenta",
    action__signOut: "Cerrar sesi\xF3n",
    action__signOutAll: "Cerrar sesi\xF3n en todas las cuentas"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\xA1Copiado!",
      actionLabel__copy: "Copiar todo",
      actionLabel__download: "Descargar .txt",
      actionLabel__print: "Imprimir",
      infoText1: "Se habilitar\xE1n c\xF3digos de respaldo para esta cuenta.",
      infoText2: "Manten\xE9 los c\xF3digos de respaldo en secreto y guardalos de forma segura. Pod\xE9s regenerarlos si sospech\xE1s que han sido comprometidos.",
      subtitle__codelist: "Guardalos de forma segura y mantenelos en secreto.",
      successMessage: "Los c\xF3digos de respaldo est\xE1n habilitados. Pod\xE9s usar uno de ellos para ingresar a tu cuenta si perd\xE9s el acceso a tu dispositivo de autenticaci\xF3n. Cada c\xF3digo solo puede usarse una vez.",
      successSubtitle: "Pod\xE9s usar uno de ellos para ingresar a tu cuenta si perd\xE9s el acceso a tu dispositivo de autenticaci\xF3n.",
      title: "Agregar verificaci\xF3n con c\xF3digo de respaldo",
      title__codelist: "C\xF3digos de respaldo"
    },
    connectedAccountPage: {
      formHint: "Seleccion\xE1 un proveedor para conectar tu cuenta.",
      formHint__noAccounts: "No hay proveedores externos de cuenta disponibles.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1s usar esta cuenta conectada y las funciones dependientes dejar\xE1n de funcionar.",
        successMessage: "{{connectedAccount}} ha sido eliminado de tu cuenta.",
        title: "Eliminar cuenta conectada"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "El proveedor ha sido agregado a tu cuenta",
      title: "Agregar cuenta conectada"
    },
    deletePage: {
      actionDescription: 'Escrib\xED "Eliminar cuenta" abajo para continuar.',
      confirm: "Eliminar cuenta",
      messageLine1: "\xBFEst\xE1s seguro de que quer\xE9s eliminar tu cuenta?",
      messageLine2: "Esta acci\xF3n es permanente e irreversible.",
      title: "Eliminar cuenta"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Se enviar\xE1 un correo con un c\xF3digo de verificaci\xF3n a este correo electr\xF3nico.",
        formSubtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n enviado a {{identifier}}",
        formTitle: "C\xF3digo de verificaci\xF3n",
        resendButton: "\xBFNo recibiste un c\xF3digo? Reenviar",
        successMessage: "El correo {{identifier}} ha sido agregado a tu cuenta."
      },
      emailLink: {
        formHint: "Se enviar\xE1 un correo con un enlace de verificaci\xF3n a este correo electr\xF3nico.",
        formSubtitle: "Hac\xE9 clic en el enlace de verificaci\xF3n enviado a {{identifier}}",
        formTitle: "Enlace de verificaci\xF3n",
        resendButton: "\xBFNo recibiste un enlace? Reenviar",
        successMessage: "El correo {{identifier}} ha sido agregado a tu cuenta."
      },
      enterpriseSSOLink: {
        formButton: "Hac\xE9 clic para iniciar sesi\xF3n",
        formSubtitle: "Complet\xE1 el inicio de sesi\xF3n con {{identifier}}"
      },
      formHint: "Necesit\xE1s verificar este correo electr\xF3nico antes de poder agregarlo a tu cuenta.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1s iniciar sesi\xF3n usando este correo electr\xF3nico.",
        successMessage: "{{emailAddress}} ha sido eliminado de tu cuenta.",
        title: "Eliminar correo electr\xF3nico"
      },
      title: "Agregar correo electr\xF3nico",
      verifyTitle: "Verificar correo electr\xF3nico"
    },
    formButtonPrimary__add: "Agregar",
    formButtonPrimary__continue: "Continuar",
    formButtonPrimary__finish: "Finalizar",
    formButtonPrimary__remove: "Eliminar",
    formButtonPrimary__save: "Guardar",
    formButtonReset: "Cancelar",
    mfaPage: {
      formHint: "Seleccion\xE1 un m\xE9todo para agregar.",
      title: "Agregar verificaci\xF3n de dos pasos"
    },
    mfaPhoneCodePage: {
      backButton: "Usar n\xFAmero existente",
      primaryButton__addPhoneNumber: "Agregar n\xFAmero de tel\xE9fono",
      removeResource: {
        messageLine1: "{{identifier}} dejar\xE1 de recibir c\xF3digos de verificaci\xF3n al iniciar sesi\xF3n.",
        messageLine2: "Tu cuenta podr\xEDa no estar tan segura. \xBFEst\xE1s seguro de querer continuar?",
        successMessage: "La verificaci\xF3n de dos pasos mediante c\xF3digo SMS ha sido eliminada para {{mfaPhoneCode}}",
        title: "Eliminar verificaci\xF3n de dos pasos"
      },
      subtitle__availablePhoneNumbers: "Seleccion\xE1 un n\xFAmero de tel\xE9fono existente para registrar la verificaci\xF3n de dos pasos por c\xF3digo SMS o agreg\xE1 uno nuevo.",
      subtitle__unavailablePhoneNumbers: "No hay n\xFAmeros de tel\xE9fono disponibles para registrar la verificaci\xF3n de dos pasos por c\xF3digo SMS, por favor, agreg\xE1 uno nuevo.",
      successMessage1: "Al iniciar sesi\xF3n, deber\xE1s ingresar un c\xF3digo de verificaci\xF3n enviado a este n\xFAmero como un paso adicional.",
      successMessage2: "Guard\xE1 estos c\xF3digos de respaldo y almacenalos en un lugar seguro. Si perd\xE9s el acceso a tu dispositivo de autenticaci\xF3n, pod\xE9s usar los c\xF3digos de respaldo para ingresar.",
      successTitle: "Verificaci\xF3n por c\xF3digo SMS habilitada",
      title: "Agregar verificaci\xF3n por c\xF3digo SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Escane\xE1 el c\xF3digo QR en su lugar",
        buttonUnableToScan__nonPrimary: "\xBFNo pod\xE9s escanear el c\xF3digo QR?",
        infoText__ableToScan: "Configur\xE1 un nuevo m\xE9todo de ingreso en tu aplicaci\xF3n autenticadora y escane\xE1 el siguiente c\xF3digo QR para vincularlo a tu cuenta.",
        infoText__unableToScan: "Configur\xE1 un nuevo m\xE9todo de ingreso en tu autenticadora e ingres\xE1 la clave proporcionada abajo.",
        inputLabel__unableToScan1: "Asegurate de que las contrase\xF1as de un solo uso basadas en tiempo est\xE9n habilitadas, luego complet\xE1 la vinculaci\xF3n de tu cuenta.",
        inputLabel__unableToScan2: "Alternativamente, si tu autenticadora soporta URIs TOTP, tambi\xE9n pod\xE9s copiar la URI completa."
      },
      removeResource: {
        messageLine1: "Los c\xF3digos de verificaci\xF3n de esta autenticadora ya no ser\xE1n requeridos al iniciar sesi\xF3n.",
        messageLine2: "Tu cuenta podr\xEDa no estar tan segura. \xBFEst\xE1s seguro de querer continuar?",
        successMessage: "La verificaci\xF3n de dos pasos mediante aplicaci\xF3n autenticadora ha sido eliminada.",
        title: "Eliminar verificaci\xF3n de dos pasos"
      },
      successMessage: "La verificaci\xF3n de dos pasos est\xE1 habilitada. Al iniciar sesi\xF3n, deber\xE1s ingresar un c\xF3digo de verificaci\xF3n de esta autenticadora como paso adicional.",
      title: "Agregar aplicaci\xF3n autenticadora",
      verifySubtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n generado por tu autenticadora",
      verifyTitle: "C\xF3digo de verificaci\xF3n"
    },
    mobileButton__menu: "Men\xFA",
    navbar: {
      account: "Perfil",
      description: "Gestion\xE1 la informaci\xF3n de tu cuenta.",
      security: "Seguridad",
      title: "Cuenta"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} ser\xE1 eliminado de esta cuenta.",
        title: "Eliminar clave de acceso"
      },
      subtitle__rename: "Pod\xE9s cambiar el nombre de la clave de acceso para facilitar su identificaci\xF3n.",
      title__rename: "Renombrar clave de acceso"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Se recomienda cerrar sesi\xF3n en todos los dem\xE1s dispositivos que hayan usado tu antigua contrase\xF1a.",
      readonly: "Actualmente, tu contrase\xF1a no puede ser editada porque solo pod\xE9s ingresar mediante la conexi\xF3n empresarial.",
      successMessage__set: "Tu contrase\xF1a ha sido establecida.",
      successMessage__signOutOfOtherSessions: "Todos los dem\xE1s dispositivos han sido cerrados sesi\xF3n.",
      successMessage__update: "Tu contrase\xF1a ha sido actualizada.",
      title__set: "Establecer contrase\xF1a",
      title__update: "Actualizar contrase\xF1a"
    },
    phoneNumberPage: {
      infoText: "Se enviar\xE1 un mensaje de texto con un c\xF3digo de verificaci\xF3n a este n\xFAmero. Pueden aplicarse tarifas de mensaje y datos.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1s iniciar sesi\xF3n usando este n\xFAmero de tel\xE9fono.",
        successMessage: "{{phoneNumber}} ha sido eliminado de tu cuenta.",
        title: "Eliminar n\xFAmero de tel\xE9fono"
      },
      successMessage: "{{identifier}} ha sido agregado a tu cuenta.",
      title: "Agregar n\xFAmero de tel\xE9fono",
      verifySubtitle: "Ingres\xE1 el c\xF3digo de verificaci\xF3n enviado a {{identifier}}",
      verifyTitle: "Verificar n\xFAmero de tel\xE9fono"
    },
    profilePage: {
      fileDropAreaHint: "Tama\xF1o recomendado 1:1, hasta 10MB.",
      imageFormDestructiveActionSubtitle: "Eliminar",
      imageFormSubtitle: "Subir",
      imageFormTitle: "Imagen de perfil",
      readonly: "La informaci\xF3n de tu perfil fue proporcionada por la conexi\xF3n empresarial y no puede ser editada.",
      successMessage: "Tu perfil ha sido actualizado.",
      title: "Actualizar perfil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Cerrar sesi\xF3n en dispositivo",
        title: "Dispositivos activos"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Reconectar",
        actionLabel__reauthorize: "Autorizar ahora",
        destructiveActionTitle: "Eliminar",
        primaryButton: "Conectar cuenta",
        subtitle__disconnected: "Esta cuenta ha sido desconectada.",
        subtitle__reauthorize: "Los permisos requeridos han sido actualizados y podr\xEDas experimentar funcionalidad limitada. Por favor, reautoriza esta aplicaci\xF3n para evitar inconvenientes",
        title: "Cuentas conectadas"
      },
      dangerSection: {
        deleteAccountButton: "Eliminar cuenta",
        title: "Eliminar cuenta"
      },
      emailAddressesSection: {
        destructiveAction: "Eliminar correo",
        detailsAction__nonPrimary: "Establecer como principal",
        detailsAction__primary: "Completar verificaci\xF3n",
        detailsAction__unverified: "Verificar",
        primaryButton: "Agregar correo electr\xF3nico",
        title: "Correos electr\xF3nicos"
      },
      enterpriseAccountsSection: {
        title: "Cuentas empresariales"
      },
      headerTitle__account: "Detalles del perfil",
      headerTitle__security: "Seguridad",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenerar",
          headerTitle: "C\xF3digos de respaldo",
          subtitle__regenerate: "Obten\xE9 un nuevo conjunto de c\xF3digos de respaldo seguros. Los c\xF3digos anteriores ser\xE1n eliminados y no podr\xE1n usarse.",
          title__regenerate: "Regenerar c\xF3digos de respaldo"
        },
        phoneCode: {
          actionLabel__setDefault: "Establecer como predeterminado",
          destructiveActionLabel: "Eliminar"
        },
        primaryButton: "Agregar verificaci\xF3n de dos pasos",
        title: "Verificaci\xF3n de dos pasos",
        totp: {
          destructiveActionTitle: "Eliminar",
          headerTitle: "Aplicaci\xF3n autenticadora"
        }
      },
      passkeysSection: {
        primaryButton: "Agregar una clave de acceso",
        menuAction__destructive: "Eliminar",
        menuAction__rename: "Renombrar",
        title: "Claves de acceso"
      },
      passwordSection: {
        primaryButton__setPassword: "Establecer contrase\xF1a",
        primaryButton__updatePassword: "Actualizar contrase\xF1a",
        title: "Contrase\xF1a"
      },
      phoneNumbersSection: {
        destructiveAction: "Eliminar n\xFAmero de tel\xE9fono",
        detailsAction__nonPrimary: "Establecer como principal",
        detailsAction__primary: "Completar verificaci\xF3n",
        detailsAction__unverified: "Verificar n\xFAmero de tel\xE9fono",
        primaryButton: "Agregar n\xFAmero de tel\xE9fono",
        title: "N\xFAmeros de tel\xE9fono"
      },
      profileSection: {
        primaryButton: "Actualizar perfil",
        title: "Perfil"
      },
      usernameSection: {
        primaryButton__setUsername: "Establecer nombre de usuario",
        primaryButton__updateUsername: "Actualizar nombre de usuario",
        title: "Nombre de usuario"
      },
      web3WalletsSection: {
        destructiveAction: "Eliminar cartera",
        primaryButton: "Conectar cartera",
        title: "Carteras Web3"
      }
    },
    usernamePage: {
      successMessage: "Tu nombre de usuario ha sido actualizado.",
      title__set: "Establecer nombre de usuario",
      title__update: "Actualizar nombre de usuario"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1s iniciar sesi\xF3n usando esta cartera Web3.",
        successMessage: "{{web3Wallet}} ha sido eliminado de tu cuenta.",
        title: "Eliminar cartera Web3"
      },
      subtitle__availableWallets: "Seleccion\xE1 una cartera Web3 para conectar a tu cuenta.",
      subtitle__unavailableWallets: "No hay carteras Web3 disponibles.",
      successMessage: "La cartera ha sido agregada a tu cuenta.",
      title: "Agregar cartera Web3",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: "Iniciar sesi\xF3n",
      actionText: "\xBFYa ten\xE9s acceso?",
      formButton: "Unirse a la lista de espera",
      subtitle: "Ingres\xE1 tu correo electr\xF3nico y te avisaremos cuando tu lugar est\xE9 listo",
      title: "Unirse a la lista de espera"
    },
    success: {
      message: "Ser\xE1s redirigido pronto...",
      subtitle: "Nos pondremos en contacto cuando tu lugar est\xE9 listo",
      title: "\xA1Gracias por unirte a la lista de espera!"
    }
  }
};

// src/fi-FI.ts
var fiFI = {
  locale: "fi-FI",
  backButton: "Takaisin",
  badge__default: "Oletus",
  badge__otherImpersonatorDevice: "Toinen j\xE4ljitelty laite",
  badge__primary: "Ensisijainen",
  badge__requiresAction: "Vaaditaan toimia",
  badge__thisDevice: "T\xE4m\xE4 laite",
  badge__unverified: "Vahvistamaton",
  badge__userDevice: "K\xE4ytt\xE4j\xE4n laite",
  badge__you: "Sin\xE4",
  createOrganization: {
    formButtonSubmit: "Luo organisaatio",
    invitePage: {
      formButtonReset: "Ohita"
    },
    title: "Luo organisaatio"
  },
  dates: {
    lastDay: "Eilen klo {{ date | timeString('fi-FI') }}",
    next6Days: "{{ date | weekday('fi-FI','long') }} klo {{ date | timeString('fi-FI') }}",
    nextDay: "Huomenna klo {{ date | timeString('fi-FI') }}",
    numeric: "{{ date | numeric('fi-FI') }}",
    previous6Days: "Viime {{ date | weekday('fi-FI','long') }} klo {{ date | timeString('fi-FI') }}",
    sameDay: "T\xE4n\xE4\xE4n klo {{ date | timeString('fi-FI') }}"
  },
  dividerText: "tai",
  footerActionLink__useAnotherMethod: "K\xE4yt\xE4 toista tapaa",
  footerPageLink__help: "Apua",
  footerPageLink__privacy: "Tietosuoja",
  footerPageLink__terms: "K\xE4ytt\xF6ehdot",
  formButtonPrimary: "Jatka",
  formButtonPrimary__verify: "Vahvista",
  formFieldAction__forgotPassword: "Unohditko salasanasi?",
  formFieldError__matchingPasswords: "Salasanat t\xE4sm\xE4\xE4v\xE4t.",
  formFieldError__notMatchingPasswords: "Salasanat eiv\xE4t t\xE4sm\xE4\xE4.",
  formFieldError__verificationLinkExpired: "Vahvistuslinkki on vanhentunut. Pyyd\xE4 uusi linkki.",
  formFieldHintText__optional: "Valinnainen",
  formFieldHintText__slug: "Slug on luettava tunniste, joka on oltava yksil\xF6llinen. Sit\xE4 k\xE4ytet\xE4\xE4n usein URL-osoitteissa.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "esimerkki@domain.fi, esimerkki2@domain.fi",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "minun-org",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Ota automaattiset kutsut k\xE4ytt\xF6\xF6n t\xE4lle verkkotunnukselle",
  formFieldLabel__backupCode: "Varakoodi",
  formFieldLabel__confirmDeletion: "Vahvistus",
  formFieldLabel__confirmPassword: "Vahvista salasana",
  formFieldLabel__currentPassword: "Nykyinen salasana",
  formFieldLabel__emailAddress: "S\xE4hk\xF6postiosoite",
  formFieldLabel__emailAddress_username: "S\xE4hk\xF6postiosoite tai k\xE4ytt\xE4j\xE4nimi",
  formFieldLabel__emailAddresses: "S\xE4hk\xF6postiosoitteet",
  formFieldLabel__firstName: "Etunimi",
  formFieldLabel__lastName: "Sukunimi",
  formFieldLabel__newPassword: "Uusi salasana",
  formFieldLabel__organizationDomain: "Verkkotunnus",
  formFieldLabel__organizationDomainDeletePending: "Poista odottavat kutsut ja ehdotukset",
  formFieldLabel__organizationDomainEmailAddress: "Vahvistuss\xE4hk\xF6postiosoite",
  formFieldLabel__organizationDomainEmailAddressDescription: "Sy\xF6t\xE4 s\xE4hk\xF6postiosoite t\xE4lle verkkotunnukselle saadaksesi koodin ja vahvistaaksesi t\xE4m\xE4n verkkotunnuksen.",
  formFieldLabel__organizationName: "Nimi",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "P\xE4\xE4syavaimen nimi",
  formFieldLabel__password: "Salasana",
  formFieldLabel__phoneNumber: "Puhelinnumero",
  formFieldLabel__role: "Rooli",
  formFieldLabel__signOutOfOtherSessions: "Kirjaudu ulos kaikista muista laitteista",
  formFieldLabel__username: "K\xE4ytt\xE4j\xE4nimi",
  impersonationFab: {
    action__signOut: "Kirjaudu ulos",
    title: "Kirjautuneena k\xE4ytt\xE4j\xE4n\xE4 {{identifier}}"
  },
  maintenanceMode: "Olemme t\xE4ll\xE4 hetkell\xE4 huoltotilassa, mutta \xE4l\xE4 huoli, se ei kest\xE4 kauempaa kuin muutama minuutti.",
  membershipRole__admin: "Yll\xE4pit\xE4j\xE4",
  membershipRole__basicMember: "J\xE4sen",
  membershipRole__guestMember: "Vieras",
  organizationList: {
    action__createOrganization: "Luo organisaatio",
    action__invitationAccept: "Liity",
    action__suggestionsAccept: "Pyyd\xE4 liittymist\xE4",
    createOrganization: "Luo organisaatio",
    invitationAcceptedLabel: "Liittynyt",
    subtitle: "jatkaaksesi kohteeseen {{applicationName}}",
    suggestionsAcceptedLabel: "Odottaa hyv\xE4ksynt\xE4\xE4",
    title: "Valitse tili",
    titleWithoutPersonal: "Valitse organisaatio"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automaattiset kutsut",
    badge__automaticSuggestion: "Automaattiset ehdotukset",
    badge__manualInvitation: "Ei automaattista liittymist\xE4",
    badge__unverified: "Vahvistamaton",
    createDomainPage: {
      subtitle: "Lis\xE4\xE4 verkkotunnus vahvistaaksesi. T\xE4m\xE4n verkkotunnuksen s\xE4hk\xF6postiosoitteilla varustetut k\xE4ytt\xE4j\xE4t voivat liitty\xE4 organisaatioon automaattisesti tai pyyt\xE4\xE4 liittymist\xE4.",
      title: "Lis\xE4\xE4 verkkotunnus"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Kutsuja ei voitu l\xE4hett\xE4\xE4. Seuraaville s\xE4hk\xF6postiosoitteille on jo odottavia kutsuja: {{email_addresses}}.",
      formButtonPrimary__continue: "L\xE4het\xE4 kutsuja",
      selectDropdown__role: "Valitse rooli",
      subtitle: "Kirjoita tai liit\xE4 yksi tai useampi s\xE4hk\xF6postiosoite, erotettuna v\xE4lily\xF6nneill\xE4 tai pilkuilla.",
      successMessage: "Kutsut l\xE4hetetty onnistuneesti",
      title: "Kutsu uusia j\xE4seni\xE4"
    },
    membersPage: {
      action__invite: "Kutsu",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Poista j\xE4sen",
        tableHeader__actions: void 0,
        tableHeader__joined: "Liittynyt",
        tableHeader__role: "Rooli",
        tableHeader__user: "K\xE4ytt\xE4j\xE4"
      },
      detailsTitle__emptyRow: "Ei j\xE4seni\xE4 n\xE4ytett\xE4v\xE4ksi",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Kutsu k\xE4ytt\xE4ji\xE4 yhdist\xE4m\xE4ll\xE4 s\xE4hk\xF6postiverkkotunnus organisaatioosi. Kaikki, jotka rekister\xF6ityv\xE4t vastaavalla s\xE4hk\xF6postiverkkotunnuksella, voivat liitty\xE4 organisaatioon milloin tahansa.",
          headerTitle: "Automaattiset kutsut",
          primaryButton: "Hallitse vahvistettuja verkkotunnuksia"
        },
        table__emptyRow: "Ei kutsuja n\xE4ytett\xE4v\xE4ksi"
      },
      invitedMembersTab: {
        menuAction__revoke: "Peruuta kutsu",
        tableHeader__invited: "Kutsuttu"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "K\xE4ytt\xE4j\xE4t, jotka rekister\xF6ityv\xE4t vastaavalla s\xE4hk\xF6postiverkkotunnuksella, voivat n\xE4hd\xE4 ehdotuksen liittymisest\xE4 organisaatioosi.",
          headerTitle: "Automaattiset ehdotukset",
          primaryButton: "Hallitse vahvistettuja verkkotunnuksia"
        },
        menuAction__approve: "Hyv\xE4ksy",
        menuAction__reject: "Hylk\xE4\xE4",
        tableHeader__requested: "Pyydetty p\xE4\xE4sy",
        table__emptyRow: "Ei pyynt\xF6j\xE4 n\xE4ytett\xE4v\xE4ksi"
      },
      start: {
        headerTitle__invitations: "Kutsut",
        headerTitle__members: "J\xE4senet",
        headerTitle__requests: "Pyynt\xF6j\xE4"
      }
    },
    navbar: {
      description: "Hallitse organisaatiotasi.",
      general: "Yleinen",
      members: "J\xE4senet",
      title: "Organisaatio"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Kirjoita "{{organizationName}}" jatkaaksesi.',
          messageLine1: "Oletko varma, ett\xE4 haluat poistaa t\xE4m\xE4n organisaation?",
          messageLine2: "T\xE4m\xE4 toiminto on pysyv\xE4 ja peruuttamaton.",
          successMessage: "Olet poistanut organisaation.",
          title: "Poista organisaatio"
        },
        leaveOrganization: {
          actionDescription: 'Kirjoita "{{organizationName}}" jatkaaksesi.',
          messageLine1: "Oletko varma, ett\xE4 haluat poistua t\xE4st\xE4 organisaatiosta? Menet\xE4t p\xE4\xE4syn t\xE4h\xE4n organisaatioon ja sen sovelluksiin.",
          messageLine2: "T\xE4m\xE4 toiminto on pysyv\xE4 ja peruuttamaton.",
          successMessage: "Olet poistunut organisaatiosta.",
          title: "Poistu organisaatiosta"
        },
        title: "Vaara"
      },
      domainSection: {
        menuAction__manage: "Hallitse",
        menuAction__remove: "Poista",
        menuAction__verify: "Vahvista",
        primaryButton: "Lis\xE4\xE4 verkkotunnus",
        subtitle: "Salli k\xE4ytt\xE4jien liitty\xE4 organisaatioon automaattisesti tai pyyt\xE4\xE4 liittymist\xE4 vahvistetun s\xE4hk\xF6postiverkkotunnuksen perusteella.",
        title: "Vahvistetut verkkotunnukset"
      },
      successMessage: "Organisaatiota on p\xE4ivitetty.",
      title: "P\xE4ivit\xE4 profiili"
    },
    removeDomainPage: {
      messageLine1: "S\xE4hk\xF6postiverkkotunnus {{domain}} poistetaan.",
      messageLine2: "K\xE4ytt\xE4j\xE4t eiv\xE4t voi liitty\xE4 organisaatioon automaattisesti t\xE4m\xE4n j\xE4lkeen.",
      successMessage: "{{domain}} on poistettu.",
      title: "Poista verkkotunnus"
    },
    start: {
      headerTitle__general: "Yleinen",
      headerTitle__members: "J\xE4senet",
      profileSection: {
        primaryButton: "P\xE4ivit\xE4 profiili",
        title: "Organisaation profiili",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "T\xE4m\xE4n verkkotunnuksen poistaminen vaikuttaa kutsuttuihin k\xE4ytt\xE4jiin.",
        removeDomainActionLabel__remove: "Poista verkkotunnus",
        removeDomainSubtitle: "Poista t\xE4m\xE4 verkkotunnus vahvistetuista verkkotunnuksistasi",
        removeDomainTitle: "Poista verkkotunnus"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "K\xE4ytt\xE4j\xE4t kutsutaan automaattisesti liittym\xE4\xE4n organisaatioon rekister\xF6ityess\xE4\xE4n ja voivat liitty\xE4 milloin tahansa.",
        automaticInvitationOption__label: "Automaattiset kutsut",
        automaticSuggestionOption__description: "K\xE4ytt\xE4j\xE4t saavat ehdotuksen liittymisest\xE4, mutta heid\xE4n on saatava yll\xE4pit\xE4j\xE4n hyv\xE4ksynt\xE4 ennen kuin he voivat liitty\xE4 organisaatioon.",
        automaticSuggestionOption__label: "Automaattiset ehdotukset",
        calloutInfoLabel: "Enrollment-tilan muuttaminen vaikuttaa vain uusiin k\xE4ytt\xE4jiin.",
        calloutInvitationCountLabel: "K\xE4ytt\xE4jille l\xE4hetetyt odottavat kutsut: {{count}}",
        calloutSuggestionCountLabel: "K\xE4ytt\xE4jille l\xE4hetetyt odottavat ehdotukset: {{count}}",
        manualInvitationOption__description: "K\xE4ytt\xE4ji\xE4 voidaan kutsua vain manuaalisesti organisaatioon.",
        manualInvitationOption__label: "Ei automaattista liittymist\xE4",
        subtitle: "Valitse, miten t\xE4m\xE4n verkkotunnuksen k\xE4ytt\xE4j\xE4t voivat liitty\xE4 organisaatioon."
      },
      start: {
        headerTitle__danger: "Vaara",
        headerTitle__enrollment: "Liittymisvaihtoehdot"
      },
      subtitle: "Verkkotunnus {{domain}} on nyt vahvistettu. Jatka valitsemalla liittymistila.",
      title: "P\xE4ivit\xE4 {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Sy\xF6t\xE4 s\xE4hk\xF6postiosoitteeseesi l\xE4hetetty vahvistuskoodi",
      formTitle: "Vahvistuskoodi",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "Verkkotunnus {{domainName}} on vahvistettava s\xE4hk\xF6postitse.",
      subtitleVerificationCodeScreen: "Vahvistuskoodi l\xE4hetettiin osoitteeseen {{emailAddress}}. Sy\xF6t\xE4 koodi jatkaaksesi.",
      title: "Vahvista verkkotunnus"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Luo organisaatio",
    action__invitationAccept: "Liity",
    action__manageOrganization: "Hallitse",
    action__suggestionsAccept: "Pyyd\xE4 liittymist\xE4",
    notSelected: "Ei valittua organisaatiota",
    personalWorkspace: "Henkil\xF6kohtainen tili",
    suggestionsAcceptedLabel: "Odottaa hyv\xE4ksynt\xE4\xE4"
  },
  paginationButton__next: "Seuraava",
  paginationButton__previous: "Edellinen",
  paginationRowText__displaying: "N\xE4ytet\xE4\xE4n",
  paginationRowText__of: "yhteens\xE4",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Lis\xE4\xE4 tili",
      action__signOutAll: "Kirjaudu ulos kaikista tileist\xE4",
      subtitle: "Valitse tili, jolla haluat jatkaa.",
      title: "Valitse tili"
    },
    alternativeMethods: {
      actionLink: "Hanki apua",
      actionText: "Eik\xF6 sinulla ole n\xE4it\xE4?",
      blockButton__backupCode: "K\xE4yt\xE4 varakoodia",
      blockButton__emailCode: "L\xE4het\xE4 koodi s\xE4hk\xF6postitse {{identifier}}",
      blockButton__emailLink: "L\xE4het\xE4 linkki s\xE4hk\xF6postitse {{identifier}}",
      blockButton__passkey: "Kirjaudu sis\xE4\xE4n p\xE4\xE4syavaimellasi",
      blockButton__password: "Kirjaudu sis\xE4\xE4n salasanallasi",
      blockButton__phoneCode: "L\xE4het\xE4 SMS-koodi osoitteeseen {{identifier}}",
      blockButton__totp: "K\xE4yt\xE4 todennussovellustasi",
      getHelp: {
        blockButton__emailSupport: "S\xE4hk\xF6postituki",
        content: "Jos sinulla on vaikeuksia kirjautua tilillesi, l\xE4het\xE4 meille s\xE4hk\xF6postia, niin autamme sinua palauttamaan p\xE4\xE4syn tiliisi mahdollisimman pian.",
        title: "Hanki apua"
      },
      subtitle: "Ongelmia? Voit kirjautua sis\xE4\xE4n mill\xE4 tahansa n\xE4ist\xE4 tavoista.",
      title: "K\xE4yt\xE4 toista tapaa"
    },
    backupCodeMfa: {
      subtitle: "Varakoodi on se, jonka sait asettaessasi kaksivaiheisen todennuksen.",
      title: "Sy\xF6t\xE4 varakoodi"
    },
    emailCode: {
      formTitle: "Vahvistuskoodi",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "jatkaaksesi kohteeseen {{applicationName}}",
      title: "Tarkista s\xE4hk\xF6postisi"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Jatkaaksesi avaa vahvistuslinkki laitteella ja selaimella, josta aloitit kirjautumisen",
        title: "Vahvistuslinkki on virheellinen t\xE4lle laitteelle"
      },
      expired: {
        subtitle: "Palaa alkuper\xE4iseen v\xE4lilehteen jatkaaksesi.",
        title: "T\xE4m\xE4 vahvistuslinkki on vanhentunut"
      },
      failed: {
        subtitle: "Palaa alkuper\xE4iseen v\xE4lilehteen jatkaaksesi.",
        title: "T\xE4m\xE4 vahvistuslinkki on virheellinen"
      },
      formSubtitle: "K\xE4yt\xE4 s\xE4hk\xF6postiisi l\xE4hetetty\xE4 vahvistuslinkki\xE4",
      formTitle: "Vahvistuslinkki",
      loading: {
        subtitle: "Sinut ohjataan pian",
        title: "Kirjaudutaan sis\xE4\xE4n..."
      },
      resendButton: "Et saanut linkki\xE4? L\xE4het\xE4 uudelleen",
      subtitle: "jatkaaksesi kohteeseen {{applicationName}}",
      title: "Tarkista s\xE4hk\xF6postisi",
      unusedTab: {
        title: "Voit sulkea t\xE4m\xE4n v\xE4lilehden"
      },
      verified: {
        subtitle: "Sinut ohjataan pian",
        title: "Kirjautuminen onnistui"
      },
      verifiedSwitchTab: {
        subtitle: "Palaa alkuper\xE4iseen v\xE4lilehteen jatkaaksesi",
        subtitleNewTab: "Palaa uuteen v\xE4lilehteen jatkaaksesi",
        titleNewTab: "Kirjautunut toiseen v\xE4lilehteen"
      }
    },
    forgotPassword: {
      formTitle: "Nollaa salasana",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "nollataksesi salasanasi",
      subtitle_email: "Sy\xF6t\xE4 ensin s\xE4hk\xF6postiisi l\xE4hetetty koodi",
      subtitle_phone: "Sy\xF6t\xE4 ensin puhelimeesi l\xE4hetetty koodi",
      title: "Nollaa salasana"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Nollaa salasanasi",
      label__alternativeMethods: "tai kirjaudu sis\xE4\xE4n toisella tavalla",
      title: "Unohditko salasanasi?"
    },
    noAvailableMethods: {
      message: "Kirjautuminen ei onnistu. K\xE4ytett\xE4viss\xE4 ei ole yht\xE4\xE4n todennusmenetelm\xE4\xE4.",
      subtitle: "Tapahtui virhe",
      title: "Ei voi kirjautua"
    },
    passkey: {
      subtitle: "K\xE4ytt\xE4m\xE4ll\xE4 p\xE4\xE4syavaintasi vahvistat, ett\xE4 olet se joka v\xE4it\xE4t olevasi. Laite voi pyyt\xE4\xE4 sormenj\xE4lke\xE4si, kasvojasi tai n\xE4yt\xF6n lukitusta.",
      title: "K\xE4yt\xE4 p\xE4\xE4syavaintasi"
    },
    password: {
      actionLink: "K\xE4yt\xE4 toista tapaa",
      subtitle: "Sy\xF6t\xE4 tilisi salasana",
      title: "Sy\xF6t\xE4 salasanasi"
    },
    passwordPwned: {
      title: "Salasana kompromisoitu"
    },
    phoneCode: {
      formTitle: "Vahvistuskoodi",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "jatkaaksesi kohteeseen {{applicationName}}",
      title: "Tarkista puhelimesi"
    },
    phoneCodeMfa: {
      formTitle: "Vahvistuskoodi",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "Sy\xF6t\xE4 jatkaaksesi puhelimeesi l\xE4hetetty vahvistuskoodi",
      title: "Tarkista puhelimesi"
    },
    resetPassword: {
      formButtonPrimary: "Nollaa salasana",
      requiredMessage: "Turvallisuussyist\xE4 on tarpeen nollata salasanasi.",
      successMessage: "Salasanasi on vaihdettu onnistuneesti. Kirjaudutaan sis\xE4\xE4n, odota hetki.",
      title: "Aseta uusi salasana"
    },
    resetPasswordMfa: {
      detailsLabel: "Ennen salasanan nollaamista on varmistettava henkil\xF6llisyytesi."
    },
    start: {
      actionLink: "Rekister\xF6idy",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "K\xE4yt\xE4 s\xE4hk\xF6postia",
      actionLink__use_email_username: "K\xE4yt\xE4 s\xE4hk\xF6postia tai k\xE4ytt\xE4j\xE4nime\xE4",
      actionLink__use_passkey: "K\xE4yt\xE4 p\xE4\xE4syavainta",
      actionLink__use_phone: "K\xE4yt\xE4 puhelinta",
      actionLink__use_username: "K\xE4yt\xE4 k\xE4ytt\xE4j\xE4nime\xE4",
      actionText: "Eik\xF6 sinulla ole tili\xE4?",
      actionText__join_waitlist: void 0,
      subtitle: "jatkaaksesi kohteeseen {{applicationName}}",
      subtitleCombined: void 0,
      title: "Kirjaudu sis\xE4\xE4n",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Todennuskoodi",
      subtitle: "Sy\xF6t\xE4 todennuskoodi autentikointisovelluksestasi",
      title: "Kaksivaiheinen todennus"
    }
  },
  signInEnterPasswordTitle: "Sy\xF6t\xE4 salasanasi",
  signUp: {
    continue: {
      actionLink: "Kirjaudu sis\xE4\xE4n",
      actionText: "Onko sinulla jo tili?",
      subtitle: "T\xE4yt\xE4 loput tiedot jatkaaksesi.",
      title: "T\xE4yt\xE4 puuttuvat kent\xE4t."
    },
    emailCode: {
      formSubtitle: "Sy\xF6t\xE4 s\xE4hk\xF6postiisi l\xE4hetetty koodi",
      formTitle: "Vahvistuskoodi",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "Sy\xF6t\xE4 s\xE4hk\xF6postiisi l\xE4hetetty koodi jatkaaksesi.",
      title: "Tarkista s\xE4hk\xF6postisi"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Jatkaaksesi avaa vahvistuslinkki laitteella ja selaimella, josta aloitit rekister\xF6itymisen",
        title: "Vahvistuslinkki on virheellinen t\xE4lle laitteelle"
      },
      formSubtitle: "K\xE4yt\xE4 s\xE4hk\xF6postiisi l\xE4hetetty\xE4 vahvistuslinkki\xE4",
      formTitle: "Vahvistuslinkki",
      loading: {
        title: "Rekister\xF6idyt\xE4\xE4n..."
      },
      resendButton: "Etk\xF6 saanut linkki\xE4? L\xE4het\xE4 uudelleen",
      subtitle: "jatkaaksesi kohteeseen {{applicationName}}",
      title: "Vahvista s\xE4hk\xF6postisi",
      verified: {
        title: "Rekister\xF6ityminen onnistui"
      },
      verifiedSwitchTab: {
        subtitle: "Palaa alkuper\xE4iseen v\xE4lilehteen jatkaaksesi",
        subtitleNewTab: "Palaa uuteen v\xE4lilehteen jatkaaksesi",
        title: "Rekister\xF6itynyt toiseen v\xE4lilehteen"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Hyv\xE4ksyn {{ privacyPolicyLink || link("tietosuojaselosteen") }}',
        label__onlyTermsOfService: 'Hyv\xE4ksyn {{ termsOfServiceLink || link("k\xE4ytt\xF6ehdot") }}',
        label__termsOfServiceAndPrivacyPolicy: 'Hyv\xE4ksyn {{ termsOfServiceLink || link("k\xE4ytt\xF6ehdot") }} ja {{ privacyPolicyLink || link("tietosuojaselosteen") }}'
      },
      continue: {
        subtitle: "Lue ja hyv\xE4ksy ehdot jatkaaksesi",
        title: "K\xE4ytt\xF6ehdot ja tietosuojaseloste"
      }
    },
    phoneCode: {
      formSubtitle: "Sy\xF6t\xE4 puhelimeesi l\xE4hetetty koodi",
      formTitle: "Vahvistuskoodi",
      resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
      subtitle: "Sy\xF6t\xE4 puhelimeesi l\xE4hetetty koodi jatkaaksesi.",
      title: "Tarkista puhelimesi"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Kirjaudu sis\xE4\xE4n",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "Onko sinulla jo tili?",
      subtitle: "Tervetuloa! Luo tili jatkaaksesi.",
      subtitleCombined: "Tervetuloa! Luo tili jatkaaksesi.",
      title: "Luo tili",
      titleCombined: "Luo tili"
    }
  },
  socialButtonsBlockButton: "Jatka palvelun {{provider|titleize}} avulla",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Rekister\xF6ityminen ep\xE4onnistui ep\xE4onnistuneiden tietoturvatarkistusten vuoksi. P\xE4ivit\xE4 sivu ja yrit\xE4 uudelleen tai ota yhteytt\xE4 tukeen.",
    captcha_unavailable: "Rekister\xF6ityminen ep\xE4onnistui, koska botin vahvistus ep\xE4onnistui. P\xE4ivit\xE4 sivu ja yrit\xE4 uudelleen tai ota yhteytt\xE4 tukeen.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "T\xE4m\xE4 s\xE4hk\xF6postiosoite on jo k\xE4yt\xF6ss\xE4. Kokeile toista.",
    form_identifier_exists__phone_number: "T\xE4m\xE4 puhelinnumero on jo k\xE4yt\xF6ss\xE4. Kokeile toista.",
    form_identifier_exists__username: "T\xE4m\xE4 k\xE4ytt\xE4j\xE4nimi on jo k\xE4yt\xF6ss\xE4. Kokeile toista.",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "S\xE4hk\xF6postiosoiteen tulee olla kelvollinen.",
    form_param_format_invalid__phone_number: "Puhelinnumeron on oltava kelvollisessa kansainv\xE4lisess\xE4 muodossa",
    form_param_max_length_exceeded__first_name: "Etunimi saa olla enint\xE4\xE4n 256 merkki\xE4 pitk\xE4.",
    form_param_max_length_exceeded__last_name: "Sukunimi saa olla enint\xE4\xE4n 256 merkki\xE4 pitk\xE4.",
    form_param_max_length_exceeded__name: "Nimi saa olla enint\xE4\xE4n 256 merkki\xE4 pitk\xE4.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Salasana ei ole riitt\xE4v\xE4n vahva.",
    form_password_pwned: "Salasana on ollut osallisena tietovuodossa. Valitse toinen salasana.",
    form_password_pwned__sign_in: "Salasana on ollut osallisena tietovuodossa. Vaihdathan salasanasi.",
    form_password_size_in_bytes_exceeded: "Salasanasi on ylitt\xE4nyt sallitun tavum\xE4\xE4r\xE4n, lyhenn\xE4 sit\xE4 tai poista joitain erikoismerkkej\xE4.",
    form_password_validation_failed: "V\xE4\xE4r\xE4 salasana.",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "Et voi poistaa viimeist\xE4 henkil\xF6llisyytt\xE4si.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "P\xE4\xE4syavain on jo rekister\xF6ity t\xE4h\xE4n laitteeseen.",
    passkey_not_supported: "P\xE4\xE4syavain ei ole tuettu t\xE4ll\xE4 laitteella.",
    passkey_pa_not_supported: "Rekister\xF6inti vaatii alustan autentikaattorin, mutta laite ei tue sit\xE4.",
    passkey_registration_cancelled: "P\xE4\xE4syavaimen lis\xE4\xE4minen peruutettiin tai aikakatkaistiin.",
    passkey_retrieval_cancelled: "P\xE4\xE4syavaimella kirjautuminen peruutettiin tai aikakatkaistiin.",
    passwordComplexity: {
      maximumLength: "enint\xE4\xE4n {{length}} merkki\xE4",
      minimumLength: "v\xE4hint\xE4\xE4n {{length}} merkki\xE4",
      requireLowercase: "pieni kirjain",
      requireNumbers: "numero",
      requireSpecialCharacter: "erikoismerkki",
      requireUppercase: "iso kirjain",
      sentencePrefix: "Salasanan on sis\xE4llett\xE4v\xE4"
    },
    phone_number_exists: "T\xE4m\xE4 puhelinnumero on jo k\xE4yt\xF6ss\xE4. Kokeile toista.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Salasanasi toimii, mutta se voisi olla vahvempi. Kokeile lis\xE4t\xE4 erikoismerkkej\xE4 tai numeroita.",
      goodPassword: "Salasanasi t\xE4ytt\xE4\xE4 kaikki tarvittavat vaatimukset.",
      notEnough: "Salasanasi ei ole riitt\xE4v\xE4n vahva.",
      suggestions: {
        allUppercase: "K\xE4yt\xE4 isoja kirjaimia, mutta ei kaikkia kirjaimia.",
        anotherWord: "\xC4l\xE4 k\xE4yt\xE4 yleisi\xE4 sanoja.",
        associatedYears: "\xC4l\xE4 k\xE4yt\xE4 vuosilukuja, jotka liittyv\xE4t sinuun.",
        capitalization: "K\xE4yt\xE4 isoja ja pieni\xE4 kirjaimia.",
        dates: "\xC4l\xE4 k\xE4yt\xE4 p\xE4iv\xE4m\xE4\xE4ri\xE4.",
        l33t: "\xC4l\xE4 k\xE4yt\xE4 l33t-kielt\xE4.",
        longerKeyboardPattern: "V\xE4lt\xE4 pitki\xE4 n\xE4pp\xE4inkuvioita.",
        noNeed: "\xC4l\xE4 k\xE4yt\xE4 t\xE4t\xE4 sanaa.",
        pwned: "\xC4l\xE4 k\xE4yt\xE4 salasanaa, joka on ollut osallisena tietovuodossa.",
        recentYears: "\xC4l\xE4 k\xE4yt\xE4 viimeaikaisia vuosilukuja.",
        repeated: "\xC4l\xE4 k\xE4yt\xE4 toistuvia sanoja.",
        reverseWords: "\xC4l\xE4 k\xE4yt\xE4 sanoja takaperin.",
        sequences: "V\xE4lt\xE4 per\xE4kk\xE4isi\xE4 numeroita tai kirjaimia.",
        useWords: "\xC4l\xE4 k\xE4yt\xE4 yleisi\xE4 sanoja."
      },
      warnings: {
        common: "T\xE4m\xE4 on yleinen salasana.",
        commonNames: "Yleiset nimet ja sukunimet ovat helppo arvata.",
        dates: "P\xE4iv\xE4m\xE4\xE4r\xE4t ovat helppo arvata.",
        extendedRepeat: "Toistuvat merkit ovat helppo arvata.",
        keyPattern: "N\xE4pp\xE4inkuvioita on helppo arvata.",
        namesByThemselves: "Nimet ovat helppo arvata.",
        pwned: "T\xE4m\xE4 salasana on ollut osallisena tietovuodossa.",
        recentYears: "Viimeaikaiset vuodet ovat helppo arvata.",
        sequences: "Per\xE4kk\xE4iset numerot ja kirjaimet ovat helppo arvata.",
        similarToCommon: "T\xE4m\xE4 on samanlainen kuin yleinen salasana.",
        simpleRepeat: "Toistuvat merkit ovat helppo arvata.",
        straightRow: "Per\xE4kk\xE4iset merkit ovat helppo arvata.",
        topHundred: "T\xE4m\xE4 on yleinen salasana.",
        topTen: "T\xE4m\xE4 on yleinen salasana.",
        userInputs: "Salasana perustuu k\xE4ytt\xE4j\xE4n sy\xF6tteisiin.",
        wordByItself: "Yksitt\xE4inen sana on helppo arvata."
      }
    }
  },
  userButton: {
    action__addAccount: "Lis\xE4\xE4 tili",
    action__manageAccount: "Hallitse tili\xE4",
    action__signOut: "Kirjaudu ulos",
    action__signOutAll: "Kirjaudu ulos kaikista tileist\xE4"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopioitu",
      actionLabel__copy: "Kopioi",
      actionLabel__download: "Lataa .txt",
      actionLabel__print: "Tulosta",
      infoText1: "Varakoodit otetaan k\xE4ytt\xF6\xF6n t\xE4lle tilille.",
      infoText2: "Pid\xE4 varakoodit salassa ja s\xE4ilyt\xE4 ne turvallisesti. Voit luoda uudelleen varakoodit, jos ep\xE4ilet, ett\xE4 ne ovat vaarantuneet.",
      subtitle__codelist: "S\xE4ilyt\xE4 varakoodit turvallisessa paikassa ja pid\xE4 ne salassa.",
      successMessage: "Varakoodit ovat nyt k\xE4yt\xF6ss\xE4. Voit k\xE4ytt\xE4\xE4 jotakin n\xE4ist\xE4 kirjautuaksesi tilillesi, jos menet\xE4t k\xE4ytt\xF6oikeuden todennuslaitteeseesi. Jokaista koodia voi k\xE4ytt\xE4\xE4 vain kerran.",
      successSubtitle: "Voit k\xE4ytt\xE4\xE4 jotakin n\xE4ist\xE4 kirjautuaksesi tilillesi, jos menet\xE4t k\xE4ytt\xF6oikeuden todennuslaitteeseesi.",
      title: "Lis\xE4\xE4 varakoodin vahvistus",
      title__codelist: "Varakoodit"
    },
    connectedAccountPage: {
      formHint: "Valitse palveluntarjoaja yhdist\xE4\xE4ksesi tilisi.",
      formHint__noAccounts: "Ulkoisia tilintarjoajia ei ole saatavilla.",
      removeResource: {
        messageLine1: "{{identifier}} poistetaan tililt\xE4si.",
        messageLine2: "T\xE4m\xE4 ei poista tili\xE4si palveluntarjoajalta, mutta et voi en\xE4\xE4 k\xE4ytt\xE4\xE4 sit\xE4 kirjautumiseen tai muihin toimintoihin t\xE4m\xE4n tilin kautta.",
        successMessage: "{{connectedAccount}} on poistettu tililt\xE4si.",
        title: "Poista yhdistetty tili"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "Palveluntarjoaja on lis\xE4tty tilillesi",
      title: "Lis\xE4\xE4 yhdistetty tili"
    },
    deletePage: {
      actionDescription: 'Kirjoita "Delete account" poistaaksesi tilisi.',
      confirm: "Poista tili",
      messageLine1: "Oletko varma, ett\xE4 haluat poistaa tilisi?",
      messageLine2: "T\xE4m\xE4 toiminto on pysyv\xE4 ja peruuttamaton.",
      title: "Poista tili"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Vahvistuskoodin sis\xE4lt\xE4v\xE4 s\xE4hk\xF6posti l\xE4hetet\xE4\xE4n t\xE4h\xE4n s\xE4hk\xF6postiosoitteeseen.",
        formSubtitle: "Sy\xF6t\xE4 s\xE4hk\xF6postiisi {{identifier}} l\xE4hetetty koodi",
        formTitle: "Vahvistuskoodi",
        resendButton: "Etk\xF6 saanut koodia? L\xE4het\xE4 uudelleen",
        successMessage: "S\xE4hk\xF6postiosoitteesi {{identifier}} on nyt lis\xE4tty tilillesi."
      },
      emailLink: {
        formHint: "Vahvistuslinkki l\xE4hetet\xE4\xE4n t\xE4h\xE4n s\xE4hk\xF6postiosoitteeseen.",
        formSubtitle: "K\xE4yt\xE4 s\xE4hk\xF6postiisi l\xE4hetetty\xE4 vahvistuslinkki\xE4",
        formTitle: "Vahvistuslinkki",
        resendButton: "Et saanut linkki\xE4? L\xE4het\xE4 uudelleen",
        successMessage: "S\xE4hk\xF6postiosoitteesi {{identifier}} on nyt lis\xE4tty tilillesi."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} poistetaan tililt\xE4si.",
        messageLine2: "T\xE4m\xE4 ei poista s\xE4hk\xF6postiosoitettasi, mutta et voi en\xE4\xE4 k\xE4ytt\xE4\xE4 sit\xE4 kirjautumiseen tai muihin toimintoihin t\xE4m\xE4n tilin kautta.",
        successMessage: "{{emailAddress}} on poistettu tililt\xE4si.",
        title: "Poista s\xE4hk\xF6postiosoite"
      },
      title: "Lis\xE4\xE4 s\xE4hk\xF6postiosoite",
      verifyTitle: "Vahvista s\xE4hk\xF6postiosoite"
    },
    formButtonPrimary__add: "Lis\xE4\xE4",
    formButtonPrimary__continue: "Jatka",
    formButtonPrimary__finish: "Valmis",
    formButtonPrimary__remove: "Poista",
    formButtonPrimary__save: "Tallenna",
    formButtonReset: "Peruuta",
    mfaPage: {
      formHint: "Valitse todennusmenetelm\xE4.",
      title: "Lis\xE4\xE4 kaksivaiheinen todennus"
    },
    mfaPhoneCodePage: {
      backButton: "K\xE4yt\xE4 olemassa olevaa numeroa",
      primaryButton__addPhoneNumber: "Lis\xE4\xE4 puhelinnumero",
      removeResource: {
        messageLine1: "{{identifier}} ei en\xE4\xE4 vastaanota vahvistuskoodeja kirjautuessaan sis\xE4\xE4n.",
        messageLine2: "Tilisi ei ehk\xE4 ole yht\xE4 turvallinen. Haluatko varmasti jatkaa?",
        successMessage: "SMS-koodin kaksivaiheinen todennus on poistettu {{mfaPhoneCode}}",
        title: "Poista kaksivaiheinen todennus"
      },
      subtitle__availablePhoneNumbers: "Valitse olemassa oleva puhelinnumero rekister\xF6ity\xE4ksesi SMS-koodin kaksivaiheiseen todennukseen tai lis\xE4\xE4 uusi.",
      subtitle__unavailablePhoneNumbers: "Ei ole k\xE4ytett\xE4viss\xE4 olevia puhelinnumeroita rekister\xF6ity\xE4ksesi SMS-koodin kaksivaiheiseen todennukseen, lis\xE4\xE4 uusi.",
      successMessage1: "Kirjautuessasi sinun on annettava vahvistuskoodi, joka on l\xE4hetetty t\xE4h\xE4n puhelinnumeroon lis\xE4vaiheena.",
      successMessage2: "Tallenna n\xE4m\xE4 varakoodit ja s\xE4ilyt\xE4 ne jossain turvallisessa paikassa. Jos menet\xE4t p\xE4\xE4syn todennuslaitteeseesi, voit k\xE4ytt\xE4\xE4 varakoodeja kirjautuaksesi sis\xE4\xE4n.",
      successTitle: "SMS-koodin todennus on otettu k\xE4ytt\xF6\xF6n",
      title: "Lis\xE4\xE4 SMS-koodin todennus"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Skannaa sen sijaan QR-koodi",
        buttonUnableToScan__nonPrimary: "Et voi skannata QR-koodia?",
        infoText__ableToScan: "Aseta uusi kirjautumistapa todennussovellukseesi ja skannaa seuraava QR-koodi linkitt\xE4\xE4ksesi se tilillesi.",
        infoText__unableToScan: "Aseta uusi kirjautumistapa todennussovellukseesi ja sy\xF6t\xE4 alla annettu avain.",
        inputLabel__unableToScan1: "Varmista, ett\xE4 Aikaperusteiset tai Yksitt\xE4iset salasanat on k\xE4yt\xF6ss\xE4 ja viimeistele tilin linkitys.",
        inputLabel__unableToScan2: "Vaihtoehtoisesti, jos todennussovelluksesi tukee TOTP-URI:ta, voit my\xF6s kopioida koko URI:n."
      },
      removeResource: {
        messageLine1: "T\xE4m\xE4n todennussovelluksen avulla ei en\xE4\xE4 tarvita vahvistuskoodia kirjautuessasi sis\xE4\xE4n.",
        messageLine2: "Tilisi ei ehk\xE4 ole yht\xE4 turvallinen. Haluatko varmasti jatkaa?",
        successMessage: "Kaksivaiheinen todennus todennussovelluksen avulla on poistettu.",
        title: "Poista kaksivaiheinen todennus"
      },
      successMessage: "Kaksivaiheinen todennus on nyt otettu k\xE4ytt\xF6\xF6n. Kirjautuessasi sinun on annettava vahvistuskoodi t\xE4st\xE4 todennussovelluksesta lis\xE4vaiheena.",
      title: "Lis\xE4\xE4 todennussovellus",
      verifySubtitle: "Sy\xF6t\xE4 todennuskoodi, jonka todennussovelluksesi on luonut",
      verifyTitle: "Vahvistuskoodi"
    },
    mobileButton__menu: "Valikko",
    navbar: {
      account: "Profiili",
      description: "Hallitse tilisi tietoja",
      security: "Turvallisuus",
      title: "Tili"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} poistetaan tililt\xE4si.",
        title: "Poista p\xE4\xE4syavain"
      },
      subtitle__rename: "Voit muuttaa p\xE4\xE4syavaimen nime\xE4 helpottaaksesi sen l\xF6yt\xE4mist\xE4.",
      title__rename: "Nime\xE4 p\xE4\xE4syavain uudelleen"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Suositellaan kirjautumista ulos kaikista muista laitteista, jotka saattavat k\xE4ytt\xE4\xE4 vanhaa salasanaasi.",
      readonly: "Salasanaa ei voi muuttaa, koska kirjautuminen on mahdollista vain yrityksen yhteyden kautta.",
      successMessage__set: "Salasanasi on asetettu.",
      successMessage__signOutOfOtherSessions: "Kaikki muut laitteet on kirjattu ulos.",
      successMessage__update: "Salasanasi on p\xE4ivitetty.",
      title__set: "Aseta salasana",
      title__update: "P\xE4ivit\xE4 salasana"
    },
    phoneNumberPage: {
      infoText: "Vahvistuskoodin sis\xE4lt\xE4v\xE4 tekstiviesti l\xE4hetet\xE4\xE4n t\xE4h\xE4n puhelinnumeroon. Viesti- ja tiedonsiirtomaksuja saatetaan peri\xE4.",
      removeResource: {
        messageLine1: "{{identifier}} poistetaan tililt\xE4si.",
        messageLine2: "T\xE4m\xE4 ei poista puhelinnumeroasi, mutta et voi en\xE4\xE4 k\xE4ytt\xE4\xE4 sit\xE4 kirjautumiseen tai muihin toimintoihin t\xE4m\xE4n tilin kautta.",
        successMessage: "{{phoneNumber}} on poistettu tililt\xE4si.",
        title: "Poista puhelinnumero"
      },
      successMessage: "Puhelinnumerosi {{identifier}} on nyt lis\xE4tty tilillesi.",
      title: "Lis\xE4\xE4 puhelinnumero",
      verifySubtitle: "Sy\xF6t\xE4 puhelimeesi l\xE4hetetty vahvistuskoodi: {{identifier}}",
      verifyTitle: "Vahvista puhelinnumero"
    },
    profilePage: {
      fileDropAreaHint: "Suositeltu koko 1:1, enint\xE4\xE4n 10 Mt.",
      imageFormDestructiveActionSubtitle: "Poista kuva",
      imageFormSubtitle: "Lataa kuva",
      imageFormTitle: "Profiilikuva",
      readonly: "Profiilitietosi on annettu yrityksen yhteyden kautta eik\xE4 niit\xE4 voi muuttaa.",
      successMessage: "Profiilisi on p\xE4ivitetty.",
      title: "P\xE4ivit\xE4 profiili"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Kirjaudu ulos laitteesta",
        title: "Aktiiviset laitteet"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Yrit\xE4 uudelleen",
        actionLabel__reauthorize: "Valtuuta nyt",
        destructiveActionTitle: "Poista",
        primaryButton: "Yhdist\xE4 tili",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "Tarvittavat k\xE4ytt\xF6oikeudet on p\xE4ivitetty, ja saatat kokea rajoitettua toiminnallisuutta. Valtuuta t\xE4m\xE4 sovellus v\xE4ltt\xE4\xE4ksesi mahdolliset ongelmat.",
        title: "Yhdistetyt tilit"
      },
      dangerSection: {
        deleteAccountButton: "Poista tili",
        title: "Poista tili"
      },
      emailAddressesSection: {
        destructiveAction: "Poista s\xE4hk\xF6postiosoite",
        detailsAction__nonPrimary: "Aseta ensisijaiseksi",
        detailsAction__primary: "Viimeistele vahvistus",
        detailsAction__unverified: "Vahvista s\xE4hk\xF6postiosoite",
        primaryButton: "Lis\xE4\xE4 s\xE4hk\xF6postiosoite",
        title: "S\xE4hk\xF6postiosoitteet"
      },
      enterpriseAccountsSection: {
        title: "Yritystilit"
      },
      headerTitle__account: "Tili",
      headerTitle__security: "Turvallisuus",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Luo uudet",
          headerTitle: "Varakoodit",
          subtitle__regenerate: "Hanki uusi sarja turvallisia varakoodeja. Aiemmat varakoodit poistetaan eiv\xE4tk\xE4 ne ole en\xE4\xE4 k\xE4ytett\xE4viss\xE4.",
          title__regenerate: "Luo uudet varakoodit"
        },
        phoneCode: {
          actionLabel__setDefault: "Aseta oletukseksi",
          destructiveActionLabel: "Poista"
        },
        primaryButton: "Lis\xE4\xE4 kaksivaiheinen todennus",
        title: "Kaksivaiheinen todennus",
        totp: {
          destructiveActionTitle: "Poista",
          headerTitle: "Todennussovellus"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Poista",
        menuAction__rename: "Nime\xE4 uudelleen",
        primaryButton: void 0,
        title: "P\xE4\xE4syavaimet"
      },
      passwordSection: {
        primaryButton__setPassword: "Aseta salasana",
        primaryButton__updatePassword: "P\xE4ivit\xE4 salasana",
        title: "Salasana"
      },
      phoneNumbersSection: {
        destructiveAction: "Poista puhelinnumero",
        detailsAction__nonPrimary: "Aseta ensisijaiseksi",
        detailsAction__primary: "Viimeistele vahvistus",
        detailsAction__unverified: "Vahvista puhelinnumero",
        primaryButton: "Lis\xE4\xE4 puhelinnumero",
        title: "Puhelinnumerot"
      },
      profileSection: {
        primaryButton: "P\xE4ivit\xE4 profiili",
        title: "Profiili"
      },
      usernameSection: {
        primaryButton__setUsername: "Aseta k\xE4ytt\xE4j\xE4nimi",
        primaryButton__updateUsername: "P\xE4ivit\xE4 k\xE4ytt\xE4j\xE4nimi",
        title: "K\xE4ytt\xE4j\xE4nimi"
      },
      web3WalletsSection: {
        destructiveAction: "Poista lompakko",
        primaryButton: "Web3-lompakot",
        title: "Web3-lompakot"
      }
    },
    usernamePage: {
      successMessage: "K\xE4ytt\xE4j\xE4nimesi on p\xE4ivitetty.",
      title__set: "Aseta k\xE4ytt\xE4j\xE4nimi",
      title__update: "P\xE4ivit\xE4 k\xE4ytt\xE4j\xE4nimi"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} poistetaan tililt\xE4si.",
        messageLine2: "Et voi en\xE4\xE4 kirjautua sis\xE4\xE4n t\xE4ll\xE4 web3-lompakolla.",
        successMessage: "{{web3Wallet}} on poistettu tililt\xE4si.",
        title: "Poista web3-lompakko"
      },
      subtitle__availableWallets: "Valitse web3-lompakko yhdist\xE4\xE4ksesi tilisi.",
      subtitle__unavailableWallets: "Ei ole k\xE4ytett\xE4viss\xE4 olevia web3-lompakoita yhdist\xE4\xE4ksesi tilisi.",
      successMessage: "Web3-lompakko on lis\xE4tty tilillesi.",
      title: "Lis\xE4\xE4 web3-lompakko",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/ru-RU.ts
var ruRU = {
  locale: "ru-RU",
  backButton: "\u041D\u0430\u0437\u0430\u0434",
  badge__default: "\u041F\u043E-\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
  badge__otherImpersonatorDevice: "\u0414\u0440\u0443\u0433\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
  badge__primary: "\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0439",
  badge__requiresAction: "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
  badge__thisDevice: "\u042D\u0442\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
  badge__unverified: "\u041D\u0435\u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439",
  badge__userDevice: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
  badge__you: "\u0412\u044B",
  createOrganization: {
    formButtonSubmit: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E",
    invitePage: {
      formButtonReset: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C"
    },
    title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E"
  },
  dates: {
    lastDay: "\u0412\u0447\u0435\u0440\u0430 \u0432 {{ date | timeString('ru-RU') }}",
    next6Days: "{{ date | weekday('ru-RU','long') }} \u0432 {{ date | timeString('ru-RU') }}",
    nextDay: "\u0417\u0430\u0432\u0442\u0440\u0430 \u0432 {{ date | timeString('ru-RU') }}",
    numeric: "{{ date | numeric('ru-RU') }}",
    previous6Days: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 {{ date | weekday('ru-RU','long') }} \u0432 {{ date | timeString('ru-RU') }}",
    sameDay: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F \u0432 {{ date | timeString('ru-RU') }}"
  },
  dividerText: "\u0438\u043B\u0438",
  footerActionLink__useAnotherMethod: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043C\u0435\u0442\u043E\u0434",
  footerPageLink__help: "\u041F\u043E\u043C\u043E\u0449\u044C",
  footerPageLink__privacy: "\u041F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u044C",
  footerPageLink__terms: "\u0423\u0441\u043B\u043E\u0432\u0438\u044F",
  formButtonPrimary: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
  formButtonPrimary__verify: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
  formFieldAction__forgotPassword: "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
  formFieldError__matchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0438 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442.",
  formFieldError__notMatchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442.",
  formFieldError__verificationLinkExpired: "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441\u0441\u044B\u043B\u043A\u0438 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0438\u0441\u0442\u0435\u043A. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438 \u043D\u043E\u0432\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443.",
  formFieldHintText__optional: "\u041E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E",
  formFieldHintText__slug: "Slug - \u044D\u0442\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u0447\u0438\u0442\u0430\u0435\u043C\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u043C. \u041E\u043D \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0430\u0445.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043E\u0434\u0438\u043D \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0430\u0434\u0440\u0435\u0441\u043E\u0432 \u043F\u043E\u0447\u0442\u044B, \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0431\u0435\u043B\u0430\u043C\u0438 \u0438\u043B\u0438 \u0437\u0430\u043F\u044F\u0442\u044B\u043C\u0438",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "my-org",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "\u041A\u043E\u0434 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F",
  formFieldLabel__confirmDeletion: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
  formFieldLabel__confirmPassword: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
  formFieldLabel__currentPassword: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__emailAddress: "\u041F\u043E\u0447\u0442\u0430",
  formFieldLabel__emailAddress_username: "\u041F\u043E\u0447\u0442\u0430 \u0438\u043B\u0438 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
  formFieldLabel__emailAddresses: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0435 \u0430\u0434\u0440\u0435\u0441\u0430",
  formFieldLabel__firstName: "\u0418\u043C\u044F",
  formFieldLabel__lastName: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
  formFieldLabel__newPassword: "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__organizationDomain: "\u0414\u043E\u043C\u0435\u043D",
  formFieldLabel__organizationDomainDeletePending: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043E\u0436\u0438\u0434\u0430\u044E\u0449\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  formFieldLabel__organizationDomainEmailAddress: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0441 \u044D\u0442\u0438\u043C \u0434\u043E\u043C\u0435\u043D\u043E\u043C, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D.",
  formFieldLabel__organizationName: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u044E\u0447\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
  formFieldLabel__password: "\u041F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
  formFieldLabel__role: "\u0420\u043E\u043B\u044C",
  formFieldLabel__signOutOfOtherSessions: "\u0412\u044B\u0439\u0442\u0438 \u0441\u043E \u0432\u0441\u0435\u0445 \u0434\u0440\u0443\u0433\u0438\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432",
  formFieldLabel__username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
  impersonationFab: {
    action__signOut: "\u0412\u044B\u0439\u0442\u0438",
    title: "\u0412\u044B \u0432\u043E\u0448\u043B\u0438 \u043A\u0430\u043A {{identifier}}"
  },
  maintenanceMode: "\u0412 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043C\u044B \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043C \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043D\u043E \u043D\u0435 \u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0439\u0442\u0435\u0441\u044C, \u044D\u0442\u043E \u043D\u0435 \u0437\u0430\u0439\u043C\u0435\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043C\u0438\u043D\u0443\u0442.",
  membershipRole__admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
  membershipRole__basicMember: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A",
  membershipRole__guestMember: "\u0413\u043E\u0441\u0442\u044C",
  organizationList: {
    action__createOrganization: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E",
    action__invitationAccept: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F",
    action__suggestionsAccept: "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435",
    createOrganization: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E",
    invitationAcceptedLabel: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F",
    subtitle: "\u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0432 {{applicationName}}",
    suggestionsAcceptedLabel: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F",
    title: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    titleWithoutPersonal: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
    badge__automaticSuggestion: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
    badge__manualInvitation: "\u041D\u0435\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
    badge__unverified: "\u041D\u0435\u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439",
    createDomainPage: {
      subtitle: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0434\u043E\u043C\u0435\u043D. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438, \u0447\u044C\u044F \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u0434\u043E\u043C\u0435\u043D\u0435, \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0438\u043B\u0438 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0435 \u043C\u043E\u0433\u043B\u0438 \u0431\u044B\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B. \u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u043E\u0436\u0438\u0434\u0430\u044E\u0449\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0430\u0434\u0440\u0435\u0441\u043E\u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B: {{email_addresses}}.",
      formButtonPrimary__continue: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
      selectDropdown__role: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0440\u043E\u043B\u044C",
      subtitle: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0432 \u044D\u0442\u0443 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E",
      successMessage: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B",
      title: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432"
    },
    membersPage: {
      action__invite: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430",
        tableHeader__actions: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
        tableHeader__joined: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F",
        tableHeader__role: "\u0420\u043E\u043B\u044C",
        tableHeader__user: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C"
      },
      detailsTitle__emptyRow: "\u041D\u0435\u0442 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0432 \u0434\u043E\u043C\u0435\u043D \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043A \u0432\u0430\u0448\u0435\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438. \u041B\u044E\u0431\u043E\u0439, \u043A\u0442\u043E \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0434\u043E\u043C\u0435\u043D\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F.",
          headerTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
          primaryButton: "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C\u0438 \u0434\u043E\u043C\u0435\u043D\u0430\u043C\u0438"
        },
        table__emptyRow: "\u041D\u0435\u0442 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u041E\u0442\u043E\u0437\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435",
        tableHeader__invited: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043D\u044B\u0435"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0441 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0434\u043E\u043C\u0435\u043D\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0441\u043C\u043E\u0433\u0443\u0442 \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A \u0432\u0430\u0448\u0435\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
          headerTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
          primaryButton: "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C\u0438 \u0434\u043E\u043C\u0435\u043D\u0430\u043C\u0438"
        },
        menuAction__approve: "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C",
        menuAction__reject: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C",
        tableHeader__requested: "\u0417\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0435\u043C\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
        table__emptyRow: "\u041D\u0435\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"
      },
      start: {
        headerTitle__invitations: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
        headerTitle__members: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
        headerTitle__requests: "\u0417\u0430\u044F\u0432\u043A\u0438"
      }
    },
    navbar: {
      description: "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0432\u0430\u0448\u0435\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0435\u0439.",
      general: "\u041E\u0431\u0449\u0435\u0435",
      members: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
      title: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 {{organizationName}} \u0432 \u043F\u043E\u043B\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
          messageLine1: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E?",
          messageLine2: "\u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C.",
          successMessage: "\u0412\u044B \u0443\u0434\u0430\u043B\u0438\u043B\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E.",
          title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E"
        },
        leaveOrganization: {
          actionDescription: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 "{{organizationName}}" \u0432 \u043F\u043E\u043B\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.',
          messageLine1: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u044D\u0442\u0443 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E? \u0412\u044B \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u044D\u0442\u043E\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0438 \u0435\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C.",
          messageLine2: "\u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C.",
          successMessage: "\u0412\u044B \u043F\u043E\u043A\u0438\u043D\u0443\u043B\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E.",
          title: "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E"
        },
        title: "\u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C"
      },
      domainSection: {
        menuAction__manage: "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C",
        menuAction__remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        menuAction__verify: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D",
        subtitle: "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0438\u043B\u0438 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443, \u0435\u0441\u043B\u0438 \u0434\u043E\u043C\u0435\u043D \u0438\u0445 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D.",
        title: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0434\u043E\u043C\u0435\u043D\u044B"
      },
      successMessage: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0431\u044B\u043B\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
      title: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438"
    },
    removeDomainPage: {
      messageLine1: "\u0414\u043E\u043C\u0435\u043D \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B {{domain}} \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D.",
      messageLine2: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043D\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E",
      successMessage: "{{domain}} \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D.",
      title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D"
    },
    start: {
      headerTitle__general: "\u041E\u0431\u0449\u0435\u0435",
      headerTitle__members: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
      profileSection: {
        primaryButton: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
        title: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
        uploadAction__title: "\u041B\u043E\u0433\u043E\u0442\u0438\u043F"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043C\u0435\u043D\u0430 \u043F\u043E\u0432\u043B\u0438\u044F\u0435\u0442 \u043D\u0430 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.",
        removeDomainActionLabel__remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D",
        removeDomainSubtitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0434\u043E\u043C\u0435\u043D \u0438\u0437 \u0447\u0438\u0441\u043B\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445",
        removeDomainTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u043E\u043C\u0435\u043D"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u0441\u043B\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u0435\u0433\u043E \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0431\u0435\u0437 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
        automaticInvitationOption__label: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
        automaticSuggestionOption__description: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438. \u0427\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u043C\u043E\u0433 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438, \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0434\u043E\u043B\u0436\u0435\u043D \u043E\u0434\u043E\u0431\u0440\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443.",
        automaticSuggestionOption__label: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438",
        calloutInfoLabel: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0432\u043B\u0438\u044F\u0435\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u043D\u043E\u0432\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.",
        calloutInvitationCountLabel: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E: {{count}}",
        calloutSuggestionCountLabel: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0439 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E: {{count}}",
        manualInvitationOption__description: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043D\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E, \u0438\u0445 \u043C\u043E\u0436\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0440\u0443\u0447\u043D\u0443\u044E.",
        manualInvitationOption__label: "\u0422\u043E\u043B\u044C\u043A\u043E \u0440\u0443\u0447\u043D\u043E\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
        subtitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u043A\u0430\u043A\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0441 \u044D\u0442\u0438\u043C \u0434\u043E\u043C\u0435\u043D\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438."
      },
      start: {
        headerTitle__danger: "\u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
        headerTitle__enrollment: "\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F"
      },
      subtitle: "\u0414\u043E\u043C\u0435\u043D {{domain}} \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D. \u0422\u0435\u043F\u0435\u0440\u044C \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u043A\u0430\u043A \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0441 \u044D\u0442\u0438\u043C \u0434\u043E\u043C\u0435\u043D\u043E\u043C \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0442\u044C\u0441\u044F \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438.",
      title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443",
      formTitle: "\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430",
      subtitle: "\u0414\u043E\u043C\u0435\u043D {{domainName}} \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D \u0447\u0435\u0440\u0435\u0437 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443.",
      subtitleVerificationCodeScreen: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u043F\u043E\u0447\u0442\u0443 {{emailAddress}}. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0435\u0433\u043E, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
      title: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u043E\u043C\u0435\u043D\u0430"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E",
    action__invitationAccept: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F",
    action__manageOrganization: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
    action__suggestionsAccept: "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435",
    notSelected: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430",
    personalWorkspace: "\u041B\u0438\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
    suggestionsAcceptedLabel: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F"
  },
  paginationButton__next: "\u0412\u043F\u0435\u0440\u0435\u0434",
  paginationButton__previous: "\u041D\u0430\u0437\u0430\u0434",
  paginationRowText__displaying: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
  paginationRowText__of: "\u0438\u0437",
  reverification: {
    alternativeMethods: {
      actionLink: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u043C\u043E\u0449\u044C",
      actionText: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043D\u0438\u0447\u0435\u0433\u043E \u0438\u0437 \u044D\u0442\u043E\u0433\u043E?",
      blockButton__backupCode: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043A\u043E\u0434",
      blockButton__emailCode: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__password: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0441 \u0432\u0430\u0448\u0438\u043C \u043F\u0430\u0440\u043E\u043B\u0435\u043C",
      blockButton__phoneCode: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C SMS \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__totp: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438",
      getHelp: {
        blockButton__emailSupport: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443",
        content: "\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B \u0441 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C, \u0438 \u043C\u044B \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 \u0432\u0430\u043C\u0438 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u043C \u0434\u043E\u0441\u0442\u0443\u043F \u043A\u0430\u043A \u043C\u043E\u0436\u043D\u043E \u0441\u043A\u043E\u0440\u0435\u0435.",
        title: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u043C\u043E\u0449\u044C"
      },
      subtitle: "\u0421\u0442\u043E\u043B\u043A\u043D\u0443\u043B\u0438\u0441\u044C \u0441 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u043C\u0438? \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u0438\u0437 \u044D\u0442\u0438\u0445 \u043C\u0435\u0442\u043E\u0434\u043E\u0432 \u0434\u043B\u044F \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438",
      title: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043C\u0435\u0442\u043E\u0434"
    },
    backupCodeMfa: {
      subtitle: "\u0412\u0430\u0448 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043A\u043E\u0434 - \u044D\u0442\u043E \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043F\u0440\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0435 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438.",
      title: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043A\u043E\u0434"
    },
    emailCode: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
      subtitle: "\u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F {{applicationName}}",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448\u0443 \u043F\u043E\u0447\u0442\u0443"
    },
    noAvailableMethods: {
      message: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E. \u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0444\u0430\u043A\u0442\u043E\u0440\u0430 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438.",
      subtitle: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
      title: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C"
    },
    password: {
      actionLink: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u043C\u0435\u0442\u043E\u0434",
      subtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0439 \u0441 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E",
      title: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    phoneCode: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
      subtitle: "\u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F {{applicationName}}",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    phoneCodeMfa: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
      subtitle: "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    totpMfa: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      subtitle: "\u0427\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434, \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0448\u0438\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C-\u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043E\u043C",
      title: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
      action__signOutAll: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439",
      subtitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u0441 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
      title: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C"
    },
    alternativeMethods: {
      actionLink: "\u041F\u043E\u043C\u043E\u0449\u044C",
      actionText: "\u041D\u0438\u0447\u0435\u0433\u043E \u0438\u0437 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E?",
      blockButton__backupCode: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043A\u043E\u0434.",
      blockButton__emailCode: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__emailLink: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 {{identifier}}",
      blockButton__passkey: "\u0412\u043E\u0439\u0442\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u044E\u0447\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
      blockButton__password: "\u0412\u043E\u0439\u0442\u0438 \u0441 \u043F\u0430\u0440\u043E\u043B\u0435\u043C",
      blockButton__phoneCode: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__totp: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440",
      getHelp: {
        blockButton__emailSupport: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443",
        content: "\u0415\u0441\u043B\u0438 \u0432\u044B \u0438\u0441\u043F\u044B\u0442\u0432\u0430\u0435\u0442\u0435 \u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0441\u043E \u0432\u0445\u043E\u0434\u043E\u043C \u0432 \u0432\u0430\u0448\u0443 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C \u0438 \u043C\u044B \u043F\u043E\u0441\u0442\u0430\u0440\u0430\u0435\u043C\u0441\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0441\u0438\u0442\u044C \u0412\u0430\u0448 \u0434\u043E\u0441\u0442\u0443\u043F \u0432 \u043A\u0440\u0430\u0442\u0447\u0430\u0439\u0448\u0438\u0435 \u0441\u0440\u043E\u043A\u0438.",
        title: "\u041F\u043E\u043C\u043E\u0449\u044C"
      },
      subtitle: "\u0412\u043E\u0437\u043D\u0438\u043A\u0430\u044E\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B? \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u0438\u0437 \u044D\u0442\u0438\u0445 \u043C\u0435\u0442\u043E\u0434\u043E\u0432 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430.",
      title: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043C\u0435\u0442\u043E\u0434"
    },
    backupCodeMfa: {
      subtitle: '\u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0432 "{{applicationName}}"',
      title: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043A\u043E\u0434"
    },
    emailCode: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
      subtitle: '\u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0432 "{{applicationName}}"',
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0412\u0430\u0448\u0443 \u043F\u043E\u0447\u0442\u0443"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0427\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C, \u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443 \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u0438 \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435, \u0441 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0432\u044B \u043D\u0430\u0447\u0430\u043B\u0438 \u0432\u0445\u043E\u0434.",
        title: "\u0421\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430."
      },
      expired: {
        subtitle: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
        title: "\u042D\u0442\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u0438\u0441\u0442\u0435\u043A\u043B\u0430"
      },
      failed: {
        subtitle: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
        title: "\u042D\u0442\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430\u044F."
      },
      formSubtitle: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u0443\u044E \u043D\u0430 \u0412\u0430\u0448\u0443 \u043F\u043E\u0447\u0442\u0443",
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430",
      loading: {
        subtitle: "\u0412\u044B \u0441\u043A\u043E\u0440\u043E \u0431\u0443\u0434\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B",
        title: "\u0412\u0445\u043E\u0434\u0438\u043C..."
      },
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u0441\u0441\u044B\u043B\u043A\u0443? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0412\u0430\u0448\u0443 \u043F\u043E\u0447\u0442\u0443",
      unusedTab: {
        title: "\u0412\u043A\u043B\u0430\u0434\u043A\u0443 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u043A\u0440\u044B\u0442\u044C"
      },
      verified: {
        subtitle: "\u0412\u044B \u0441\u043A\u043E\u0440\u043E \u0431\u0443\u0434\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B",
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0439 \u0432\u0445\u043E\u0434"
      },
      verifiedSwitchTab: {
        subtitle: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
        subtitleNewTab: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
        titleNewTab: "\u0417\u0430\u043B\u043E\u0433\u0438\u043D\u044C\u0442\u0435\u0441\u044C \u043D\u0430 \u0434\u0440\u0443\u0433\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435"
      }
    },
    forgotPassword: {
      formTitle: "\u041A\u043E\u0434 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
      resendButton: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u0435\u0449\u0435 \u0440\u0430\u0437",
      subtitle: "\u0434\u043B\u044F \u0441\u0431\u0440\u043E\u0441\u0430 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0430\u0440\u043E\u043B\u044F",
      subtitle_email: "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
      subtitle_phone: "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D.",
      title: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      label__alternativeMethods: "\u0418\u043B\u0438, \u0432\u043E\u0439\u0442\u0438 \u0434\u0440\u0443\u0433\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C",
      title: "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"
    },
    noAvailableMethods: {
      message: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u043E\u0439\u0442\u0438. \u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0444\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438.",
      subtitle: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
      title: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u043E\u0439\u0442\u0438"
    },
    passkey: {
      subtitle: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u044E\u0447\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0432\u0430\u0448\u0443 \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u044C. \u0412\u0430\u0448\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0430\u0448 \u043E\u0442\u043F\u0435\u0447\u0430\u0442\u043E\u043A \u043F\u0430\u043B\u044C\u0446\u0430, \u043B\u0438\u0446\u043E \u0438\u043B\u0438 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443 \u044D\u043A\u0440\u0430\u043D\u0430.",
      title: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432\u0430\u0448 \u043A\u043B\u044E\u0447 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
    },
    password: {
      actionLink: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043C\u0435\u0442\u043E\u0434",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    passwordPwned: {
      title: "\u041F\u0430\u0440\u043E\u043B\u044C \u0441\u043A\u043E\u043C\u043F\u0440\u043E\u043C\u0435\u0442\u0438\u0440\u043E\u0432\u0430\u043D"
    },
    phoneCode: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    phoneCodeMfa: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
      subtitle: "\u0427\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D.",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    resetPassword: {
      formButtonPrimary: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      requiredMessage: "\u041F\u043E \u0441\u043E\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C.",
      successMessage: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u0432\u0445\u043E\u0434, \u043F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435.",
      title: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    resetPasswordMfa: {
      detailsLabel: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0443 \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u044C \u043F\u0435\u0440\u0435\u0434 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u043F\u0430\u0440\u043E\u043B\u044F"
    },
    start: {
      actionLink: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0447\u0442\u0443",
      actionLink__use_email_username: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0447\u0442\u0443 \u0438\u043B\u0438 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
      actionLink__use_passkey: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043A\u043B\u044E\u0447 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0432\u043C\u0435\u0441\u0442\u043E \u044D\u0442\u043E\u0433\u043E",
      actionLink__use_phone: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
      actionLink__use_username: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
      actionText: "\u041D\u0435\u0442 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438?",
      actionText__join_waitlist: void 0,
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      subtitleCombined: void 0,
      title: "\u0412\u043E\u0439\u0442\u0438",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      subtitle: "\u0427\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438, \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0448\u0438\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438.",
      title: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u0430\u044F \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
    }
  },
  signInEnterPasswordTitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
  signUp: {
    continue: {
      actionLink: "\u0412\u043E\u0439\u0442\u0438",
      actionText: "\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C?",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0432\u0441\u0435 \u043F\u043E\u043B\u044F"
    },
    emailCode: {
      formSubtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u0412\u0430\u043C \u043D\u0430 \u043F\u043E\u0447\u0442\u0443",
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u0412\u0430\u0448\u0443 \u043F\u043E\u0447\u0442\u0443"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0427\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C, \u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u0438 \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435, \u0441 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0432\u044B \u043D\u0430\u0447\u0430\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E.",
        title: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430."
      },
      formSubtitle: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443, \u043E\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u0443\u044E \u0412\u0430\u043C \u043D\u0430 \u043F\u043E\u0447\u0442\u0443",
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430",
      loading: {
        title: "\u0412\u0445\u043E\u0434\u0438\u043C..."
      },
      resendButton: "\u041F\u0435\u0440\u0435\u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u0412\u0430\u0448\u0443 \u043F\u043E\u0447\u0442\u0443",
      verified: {
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0439 \u0432\u0445\u043E\u0434"
      },
      verifiedSwitchTab: {
        subtitle: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u043D\u043E\u0432\u0443\u044E \u043E\u0442\u043A\u0440\u044B\u0442\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
        subtitleNewTab: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
        title: "\u041F\u043E\u0447\u0442\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u0430"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: '\u042F \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u0441 {{ privacyPolicyLink || link("\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438") }}',
        label__onlyTermsOfService: '\u042F \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u0441 {{ termsOfServiceLink || link("\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F") }}',
        label__termsOfServiceAndPrivacyPolicy: '\u042F \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u0441 {{ termsOfServiceLink || link("\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F") }} \u0438 {{ privacyPolicyLink || link("\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438") }}'
      },
      continue: {
        subtitle: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438 \u043F\u0440\u0438\u043C\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.",
        title: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435"
      }
    },
    phoneCode: {
      formSubtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0412\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
      resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043D\u043E\u0432\u0430.",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u0412\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
    },
    restrictedAccess: {
      actionLink: "\u0412\u043E\u0439\u0442\u0438",
      actionText: "\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C?",
      blockButton__emailSupport: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443",
      blockButton__joinWaitlist: void 0,
      subtitle: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0432 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0430. \u0415\u0441\u043B\u0438 \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u0443 \u0432\u0430\u0441 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u043E\u0439.",
      subtitleWaitlist: void 0,
      title: "\u0414\u043E\u0441\u0442\u0443\u043F \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D"
    },
    start: {
      actionLink: "\u0412\u043E\u0439\u0442\u0438",
      actionLink__use_email: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443 \u0432\u043C\u0435\u0441\u0442\u043E \u044D\u0442\u043E\u0433\u043E",
      actionLink__use_phone: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0432\u043C\u0435\u0441\u0442\u043E \u044D\u0442\u043E\u0433\u043E",
      actionText: "\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C?",
      subtitle: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      subtitleCombined: '\u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0412\u0430\u0448\u0443 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
      titleCombined: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0412\u0430\u0448\u0443 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C"
    }
  },
  socialButtonsBlockButton: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} \u0443\u0436\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u043B\u0435\u043D\u043E\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438.",
    captcha_invalid: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C \u0438\u0437-\u0437\u0430 \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u044B\u0445 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430, \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438.",
    captcha_unavailable: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C \u0438\u0437-\u0437\u0430 \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u043E\u0439 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u0431\u043E\u0442\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430, \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "\u042D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0443\u0436\u0435 \u0437\u0430\u043D\u044F\u0442. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439.",
    form_identifier_exists__phone_number: "\u042D\u0442\u043E\u0442 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0443\u0436\u0435 \u0437\u0430\u043D\u044F\u0442. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439.",
    form_identifier_exists__username: "\u042D\u0442\u043E \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0443\u0436\u0435 \u0437\u0430\u043D\u044F\u0442\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0435.",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C.",
    form_param_format_invalid__phone_number: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435.",
    form_param_max_length_exceeded__first_name: "\u0418\u043C\u044F \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 256 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.",
    form_param_max_length_exceeded__last_name: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 256 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.",
    form_param_max_length_exceeded__name: "\u0418\u043C\u044F \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 256 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043D\u0430\u0434\u0435\u0436\u043D\u044B\u0439.",
    form_password_pwned: "\u042D\u0442\u043E\u0442 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u043B \u0432\u0437\u043B\u043E\u043C\u0430\u043D \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
    form_password_pwned__sign_in: "\u042D\u0442\u043E\u0442 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u043B \u043D\u0430\u0439\u0434\u0435\u043D \u0432 \u0443\u0442\u0435\u0447\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0431\u0440\u043E\u0441\u044C\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C.",
    form_password_size_in_bytes_exceeded: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u0430\u0439\u0442\u043E\u0432, \u0441\u043E\u043A\u0440\u0430\u0442\u0438\u0442\u0435 \u0435\u0433\u043E \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B.",
    form_password_validation_failed: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E.",
    not_allowed_access: void 0,
    organization_domain_blocked: "\u042D\u0442\u043E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0434\u043E\u043C\u0435\u043D \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439.",
    organization_domain_common: "\u042D\u0442\u043E \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0434\u043E\u043C\u0435\u043D \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "\u0412\u044B \u0434\u043E\u0441\u0442\u0438\u0433\u043B\u0438 \u043F\u0440\u0435\u0434\u0435\u043B\u0430 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u0443\u0447\u0430\u0441\u0442\u0438\u0439 \u0432 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0445, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043E\u0436\u0438\u0434\u0430\u044E\u0449\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.",
    organization_minimum_permissions_needed: "\u0414\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043A\u0430\u043A \u043C\u0438\u043D\u0438\u043C\u0443\u043C \u043E\u0434\u0438\u043D \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u043C\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438.",
    passkey_already_exists: "\u041A\u043B\u044E\u0447 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u043D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435.",
    passkey_not_supported: "\u041A\u043B\u044E\u0447\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435.",
    passkey_pa_not_supported: "\u0414\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440, \u043D\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0435\u0433\u043E \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442.",
    passkey_registration_cancelled: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043A\u043B\u044E\u0447\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0431\u044B\u043B\u0430 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430 \u0438\u043B\u0438 \u0438\u0441\u0442\u0435\u043A\u043B\u043E \u0432\u0440\u0435\u043C\u044F \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F.",
    passkey_retrieval_cancelled: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043A\u043B\u044E\u0447\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0431\u044B\u043B\u0430 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430 \u0438\u043B\u0438 \u0438\u0441\u0442\u0435\u043A\u043B\u043E \u0432\u0440\u0435\u043C\u044F \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F.",
    passwordComplexity: {
      maximumLength: "\u043C\u0435\u043D\u0435\u0435 {{length}} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
      minimumLength: "{{length}} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
      requireLowercase: "\u0431\u0443\u043A\u0432\u0443 \u0432 \u043D\u0438\u0436\u043D\u0435\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0435",
      requireNumbers: "\u0446\u0438\u0444\u0440\u0443",
      requireSpecialCharacter: "\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
      requireUppercase: "\u0431\u0443\u043A\u0432\u0443 \u0432 \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0435",
      sentencePrefix: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C"
    },
    phone_number_exists: "\u042D\u0442\u043E\u0442 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0443\u0436\u0435 \u0437\u0430\u043D\u044F\u0442. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442, \u043D\u043E \u043C\u043E\u0433 \u0431\u044B \u0431\u044B\u0442\u044C \u043D\u0430\u0434\u0435\u0436\u043D\u0435\u0435. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.",
      goodPassword: "\u0425\u043E\u0440\u043E\u0448\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430. \u042D\u0442\u043E \u043E\u0442\u043B\u0438\u0447\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
      notEnough: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043D\u0430\u0434\u0435\u0436\u043D\u044B\u0439.",
      suggestions: {
        allUppercase: "\u0414\u0435\u043B\u0430\u0439\u0442\u0435 \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u043C\u0438 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435, \u043D\u043E \u043D\u0435 \u0432\u0441\u0435 \u0431\u0443\u043A\u0432\u044B.",
        anotherWord: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0441\u043B\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u0435\u043D\u0435\u0435 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u044B.",
        associatedYears: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u043B\u0435\u0442, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u0432\u044F\u0437\u0430\u043D\u044B \u0441 \u0432\u0430\u043C\u0438.",
        capitalization: "\u0414\u0435\u043B\u0430\u0439\u0442\u0435 \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u043C\u0438 \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0435\u0440\u0432\u0443\u044E \u0431\u0443\u043A\u0432\u0443",
        dates: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u0434\u0430\u0442 \u0438 \u043B\u0435\u0442, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u0432\u044F\u0437\u0430\u043D\u044B \u0441 \u0432\u0430\u043C\u0438.",
        l33t: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u043F\u0440\u0435\u0434\u0441\u043A\u0430\u0437\u0443\u0435\u043C\u044B\u0445 \u0437\u0430\u043C\u0435\u043D \u0431\u0443\u043A\u0432, \u0442\u0430\u043A\u0438\u0445 \u043A\u0430\u043A \xAB@\xBB \u0432\u043C\u0435\u0441\u0442\u043E \xABa\xBB.",
        longerKeyboardPattern: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0431\u043E\u043B\u0435\u0435 \u0434\u043B\u0438\u043D\u043D\u044B\u0435 \u0441\u043E\u0447\u0435\u0442\u0430\u043D\u0438\u044F \u043A\u043B\u0430\u0432\u0438\u0448 \u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u043C\u0435\u043D\u044F\u0439\u0442\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0432\u043E\u0434\u0430.",
        noNeed: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u0430\u0434\u0435\u0436\u043D\u044B\u0435 \u043F\u0430\u0440\u043E\u043B\u0438 \u0431\u0435\u0437 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432, \u0446\u0438\u0444\u0440 \u0438\u043B\u0438 \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u044B\u0445 \u0431\u0443\u043A\u0432.",
        pwned: "\u0415\u0441\u043B\u0438 \u0432\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0435 \u044D\u0442\u043E\u0442 \u043F\u0430\u0440\u043E\u043B\u044C \u0432 \u0434\u0440\u0443\u0433\u043E\u043C \u043C\u0435\u0441\u0442\u0435, \u0432\u0430\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0435\u0433\u043E.",
        recentYears: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0445 \u043B\u0435\u0442.",
        repeated: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0445\u0441\u044F \u0441\u043B\u043E\u0432 \u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.",
        reverseWords: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0433\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0445 \u0441\u043B\u043E\u0432.",
        sequences: "\u0418\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u0447\u0430\u0441\u0442\u044B\u0445 \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.",
        useWords: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043B\u043E\u0432, \u043D\u043E \u0438\u0437\u0431\u0435\u0433\u0430\u0439\u0442\u0435 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0445 \u0444\u0440\u0430\u0437."
      },
      warnings: {
        common: "\u042D\u0442\u043E \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        commonNames: "\u0420\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0435 \u0438\u043C\u0435\u043D\u0430 \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u0438 \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.",
        dates: "\u0414\u0430\u0442\u044B \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.",
        extendedRepeat: '\u041F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432, \u0442\u0430\u043A\u0438\u0435 \u043A\u0430\u043A "abcabcabc", \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.',
        keyPattern: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0435 \u0441\u043E\u0447\u0435\u0442\u0430\u043D\u0438\u044F \u043A\u043B\u0430\u0432\u0438\u0448 \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.",
        namesByThemselves: "\u041E\u0434\u043D\u0438 \u0438\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u0438 \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.",
        pwned: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u043B \u0440\u0430\u0441\u043A\u0440\u044B\u0442 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0443\u0442\u0435\u0447\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0435.",
        recentYears: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0433\u043E\u0434\u044B \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.",
        sequences: '\u0427\u0430\u0441\u0442\u044B\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432, \u0442\u0430\u043A\u0438\u0435 \u043A\u0430\u043A "abc", \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.',
        similarToCommon: "\u042D\u0442\u043E\u0442 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u0445\u043E\u0436 \u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        simpleRepeat: '\u041F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u044B, \u0442\u0430\u043A\u0438\u0435 \u043A\u0430\u043A "aaa", \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.',
        straightRow: "\u041F\u0440\u044F\u043C\u044B\u0435 \u0440\u044F\u0434\u044B \u043A\u043B\u0430\u0432\u0438\u0448 \u043D\u0430 \u043A\u043B\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u0435 \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C.",
        topHundred: "\u042D\u0442\u043E \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        topTen: "\u042D\u0442\u043E \u043E\u0447\u0435\u043D\u044C \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        userInputs: "\u041D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043B\u0438\u0447\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0434\u0430\u043D\u043D\u044B\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439.",
        wordByItself: "\u041E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0441\u043B\u043E\u0432\u0430 \u043B\u0435\u0433\u043A\u043E \u0443\u0433\u0430\u0434\u0430\u0442\u044C."
      }
    }
  },
  userButton: {
    action__addAccount: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    action__manageAccount: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E",
    action__signOut: "\u0412\u044B\u0439\u0442\u0438",
    action__signOutAll: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E!",
      actionLabel__copy: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435",
      actionLabel__download: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C .txt",
      actionLabel__print: "\u041F\u0435\u0447\u0430\u0442\u044C",
      infoText1: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
      infoText2: "\u0414\u0435\u0440\u0436\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0432 \u0441\u0435\u043A\u0440\u0435\u0442\u0435 \u0438 \u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0438\u0445 \u0432 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B, \u0435\u0441\u043B\u0438 \u043F\u043E\u0434\u043E\u0437\u0440\u0435\u0432\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u043E\u043D\u0438 \u0431\u044B\u043B\u0438 \u0441\u043A\u043E\u043C\u043F\u0440\u043E\u043C\u0435\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u044B.",
      subtitle__codelist: "\u0425\u0440\u0430\u043D\u0438\u0442\u0435 \u0438\u0445 \u0432 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0438 \u043D\u0435 \u0441\u043E\u043E\u0431\u0449\u0430\u0439\u0442\u0435 \u043D\u0438\u043A\u043E\u043C\u0443.",
      successMessage: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043E\u0434\u0438\u043D \u0438\u0437 \u044D\u0442\u0438\u0445 \u043A\u043E\u0434\u043E\u0432 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0432\u043E\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u0435\u0441\u043B\u0438 \u0432\u044B \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0443 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438. \u041A\u0430\u0436\u0434\u044B\u0439 \u043A\u043E\u0434 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0440\u0430\u0437.",
      successSubtitle: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043E\u0434\u0438\u043D \u0438\u0437 \u044D\u0442\u0438\u0445 \u043A\u043E\u0434\u043E\u0432 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0432\u043E\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u0435\u0441\u043B\u0438 \u0432\u044B \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0443 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
      title__codelist: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B"
    },
    connectedAccountPage: {
      formHint: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
      formHint__noAccounts: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u0432 \u0432\u043D\u0435\u0448\u043D\u0438\u0445 \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439.",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u0438 \u043B\u044E\u0431\u044B\u0435 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u044B\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C.",
        successMessage: "{{connectedAccount}} \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C"
      },
      socialButtonsBlockButton: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C {{provider|titleize}}",
      successMessage: "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0431\u044B\u043B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u0432\u0430\u0448\u0443 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C"
    },
    deletePage: {
      actionDescription: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C" \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.',
      confirm: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
      messageLine1: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0432\u043E\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C?",
      messageLine2: "\u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0438 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u044B\u043C.",
      title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u041D\u0430 \u044D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u0438\u0441\u044C\u043C\u043E \u0441 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u043C \u043A\u043E\u0434\u043E\u043C.",
        formSubtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 {{identifier}}",
        formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434",
        resendButton: "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
        successMessage: "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B {{identifier}} \u0431\u044B\u043B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u0432\u0430\u0448\u0443 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C."
      },
      emailLink: {
        formHint: "\u041D\u0430 \u044D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430.",
        formSubtitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u043F\u0438\u0441\u044C\u043C\u0435, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u043C \u043D\u0430 {{identifier}}",
        formTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430",
        resendButton: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
        successMessage: "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B {{identifier}} \u0431\u044B\u043B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u0432\u0430\u0448\u0443 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u044D\u0442\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0439\u0442\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u044D\u0442\u043E\u0433\u043E \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
        successMessage: "{{emailAddress}} \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B"
      },
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
      verifyTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B"
    },
    formButtonPrimary__add: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
    formButtonPrimary__continue: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
    formButtonPrimary__finish: "\u0413\u043E\u0442\u043E\u0432\u043E",
    formButtonPrimary__remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    formButtonPrimary__save: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
    formButtonReset: "\u041E\u0442\u043C\u0435\u043D\u0430",
    mfaPage: {
      formHint: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0435\u0442\u043E\u0434 \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443\u044E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E"
    },
    mfaPhoneCodePage: {
      backButton: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
      primaryButton__addPhoneNumber: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043A\u043E\u0434\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443.",
        messageLine2: "\u0412\u0430\u0448\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0431\u0443\u0434\u0435\u0442 \u043C\u0435\u043D\u0435\u0435 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0439. \u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?",
        successMessage: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F SMS-\u043A\u043E\u0434\u043E\u043C \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0434\u043B\u044F {{mfaPhoneCode}}",
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443\u044E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E"
      },
      subtitle__availablePhoneNumbers: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0438\u0446\u0438\u0438 SMS-\u043A\u043E\u0434\u043E\u043C.",
      subtitle__unavailablePhoneNumbers: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043D\u043E\u043C\u0435\u0440\u043E\u0432 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F SMS-\u043A\u043E\u0434\u043E\u043C. \u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043D\u043E\u043C\u0435\u0440.",
      successMessage1: "\u041F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u044D\u0442\u043E\u0442 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043A\u0430\u043A \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0448\u0430\u0433",
      successMessage2: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u044D\u0442\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0438 \u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0438\u0445 \u0432 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435. \u0415\u0441\u043B\u0438 \u0432\u044B \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0443 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438, \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430.",
      successTitle: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E SMS-\u043A\u043E\u0434\u0430 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u043A\u043E\u0434\u043E\u043C \u0438\u0437 SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u0412\u043C\u0435\u0441\u0442\u043E \u044D\u0442\u043E\u0433\u043E \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434",
        buttonUnableToScan__nonPrimary: "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C QR-\u043A\u043E\u0434?",
        infoText__ableToScan: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043C\u0435\u0442\u043E\u0434 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0432\u0430\u0448\u0435\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0438 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0441\u0432\u044F\u0437\u0430\u0442\u044C \u0435\u0433\u043E \u0441 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E.",
        infoText__unableToScan: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043C\u0435\u0442\u043E\u0434 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0432\u0430\u0448\u0435\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0438\u0436\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043A\u043B\u044E\u0447.",
        inputLabel__unableToScan1: "\u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C \u0447\u0442\u043E \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0435 \u0438\u043B\u0438 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u043A\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u0430\u0440\u043E\u043B\u0438 \u0437\u0430\u0442\u0435\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0443 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        inputLabel__unableToScan2: "\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0435\u0441\u043B\u0438 \u0432\u0430\u0448\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 URI TOTP, \u0432\u044B \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 URI."
      },
      removeResource: {
        messageLine1: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443.",
        messageLine2: "\u0412\u0430\u0448\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0431\u0443\u0434\u0435\u0442 \u043C\u0435\u043D\u0435\u0435 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0439. \u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?",
        successMessage: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430.",
        title: "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438"
      },
      successMessage: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430. \u041F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0432\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0448\u0430\u0433\u0430.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438",
      verifySubtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0448\u0438\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438",
      verifyTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434"
    },
    mobileButton__menu: "\u041C\u0435\u043D\u044E",
    navbar: {
      account: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
      description: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
      security: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
      title: "\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u044D\u0442\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043B\u044E\u0447 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
      },
      subtitle__rename: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u044E\u0447\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0447\u0442\u043E\u0431\u044B \u0435\u0433\u043E \u0431\u044B\u043B\u043E \u043B\u0435\u0433\u0447\u0435 \u043D\u0430\u0439\u0442\u0438.",
      title__rename: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043A\u043B\u044E\u0447 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u0432\u044B\u0439\u0442\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0434\u0440\u0443\u0433\u0438\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043B\u0441\u044F \u0432\u0430\u0448 \u0441\u0442\u0430\u0440\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
      readonly: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0441\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u043B\u044C\u0437\u044F \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C, \u0442\u0430\u043A \u043A\u0430\u043A \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0439\u0442\u0438 \u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435.",
      successMessage__set: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D.",
      successMessage__signOutOfOtherSessions: "\u0412\u0441\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u0431\u044B\u043B\u0438 \u0432\u044B\u0432\u0435\u0434\u0435\u043D\u044B \u0438\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u044B.",
      successMessage__update: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u044B\u043B \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.",
      title__set: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
      title__update: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    phoneNumberPage: {
      infoText: "\u041D\u0430 \u044D\u0442\u043E\u0442 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0441\u043E \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438. \u041C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u0442\u0430\u0440\u0438\u0444\u044B \u043D\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0434\u0430\u043D\u043D\u044B\u0445.",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u044D\u0442\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0439\u0442\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u044D\u0442\u043E\u0442 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430.",
        successMessage: "{{phoneNumber}} \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
      },
      successMessage: "{{identifier}} \u0431\u044B\u043B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u043A \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
      verifySubtitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 {{identifier}}",
      verifyTitle: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
    },
    profilePage: {
      fileDropAreaHint: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0430\u0445 JPG, PNG, GIF \u0438\u043B\u0438 WEBP \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u043C \u043C\u0435\u043D\u044C\u0448\u0435 10 \u041C\u0411",
      imageFormDestructiveActionSubtitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
      imageFormSubtitle: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
      imageFormTitle: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044F",
      readonly: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0431\u044B\u043B\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u043C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0430.",
      successMessage: "\u0412\u0430\u0448 \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0431\u044B\u043B \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.",
      title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430",
        title: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430",
        actionLabel__reauthorize: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441",
        destructiveActionTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        primaryButton: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
        subtitle__disconnected: "\u042D\u0442\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0430.",
        subtitle__reauthorize: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B, \u0438 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u043E\u043B\u043A\u043D\u0443\u0442\u044C\u0441\u044F \u0441 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0439 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C\u044E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0443\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435, \u0447\u0442\u043E\u0431\u044B \u0438\u0437\u0431\u0435\u0436\u0430\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C",
        title: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0435 \u0443\u0447\u0435\u0442\u043D\u044B\u0435 \u0437\u0430\u043F\u0438\u0441\u0438"
      },
      dangerSection: {
        deleteAccountButton: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
        title: "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438"
      },
      emailAddressesSection: {
        destructiveAction: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
        detailsAction__nonPrimary: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E",
        detailsAction__primary: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E",
        detailsAction__unverified: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
        title: "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B"
      },
      enterpriseAccountsSection: {
        title: "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0443\u0447\u0435\u0442\u043D\u044B\u0435 \u0437\u0430\u043F\u0438\u0441\u0438"
      },
      headerTitle__account: "\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
      headerTitle__security: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0434\u044B",
          headerTitle: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B",
          subtitle__regenerate: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0445 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0445 \u043A\u043E\u0434\u043E\u0432. \u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0431\u0443\u0434\u0443\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438 \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u044B.",
          title__regenerate: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0435 \u043A\u043E\u0434\u044B"
        },
        phoneCode: {
          actionLabel__setDefault: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
          destructiveActionLabel: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
        },
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443\u044E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E",
        title: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
        totp: {
          destructiveActionTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
          headerTitle: "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438"
        }
      },
      passkeysSection: {
        menuAction__destructive: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        menuAction__rename: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C",
        primaryButton: void 0,
        title: "\u041A\u043B\u044E\u0447\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
      },
      passwordSection: {
        primaryButton__setPassword: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
        primaryButton__updatePassword: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
        title: "\u041F\u0430\u0440\u043E\u043B\u044C"
      },
      phoneNumbersSection: {
        destructiveAction: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
        detailsAction__nonPrimary: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043A\u0430\u043A \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439",
        detailsAction__primary: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E",
        detailsAction__unverified: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E",
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
        title: "\u041D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432"
      },
      profileSection: {
        primaryButton: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
        title: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C"
      },
      usernameSection: {
        primaryButton__setUsername: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
        primaryButton__updateUsername: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
        title: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"
      },
      web3WalletsSection: {
        destructiveAction: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        primaryButton: "Web3 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0438",
        title: "Web3 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0438"
      }
    },
    usernamePage: {
      successMessage: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0431\u044B\u043B\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
      title__set: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
      title__update: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u044D\u0442\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        messageLine2: "\u0412\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0412\u043E\u0439\u0442\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u044D\u0442\u043E\u0433\u043E web3 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        successMessage: "{{web3Wallet}} \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C web3 \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      subtitle__availableWallets: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 web3 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
      subtitle__unavailableWallets: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 web3 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u043E\u0432.",
      successMessage: "\u041A\u043E\u0448\u0435\u043B\u0435\u043A \u0431\u044B\u043B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u043A \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C web3 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/sv-SE.ts
var svSE = {
  locale: "sv-SE",
  backButton: "Tillbaka",
  badge__default: "Standard",
  badge__otherImpersonatorDevice: "Annans imitat\xF6renhet",
  badge__primary: "Prim\xE4r",
  badge__requiresAction: "Kr\xE4ver \xE5tg\xE4rd",
  badge__thisDevice: "Den h\xE4r enheten",
  badge__unverified: "Overifierad",
  badge__userDevice: "Anv\xE4ndarens enhet",
  badge__you: "Du",
  createOrganization: {
    formButtonSubmit: "Skapa organisation",
    invitePage: {
      formButtonReset: "Hoppa \xF6ver"
    },
    title: "Skapa organisation"
  },
  dates: {
    lastDay: "Ig\xE5r klockan {{ date | timeString('sv-SE') }}",
    next6Days: "{{ date | weekday('sv-SE','long') }} klockan {{ date | timeString('sv-SE') }}",
    nextDay: "Imorgon klockan {{ date | timeString('sv-SE') }}",
    numeric: "{{ date | numeric('sv-SE') }}",
    previous6Days: "Senaste {{ date | weekday('sv-SE','long') }} klockan {{ date | timeString('sv-SE') }}",
    sameDay: "Idag klockan {{ date | timeString('sv-SE') }}"
  },
  dividerText: "eller",
  footerActionLink__useAnotherMethod: "Anv\xE4nd en annan metod",
  footerPageLink__help: "Hj\xE4lp",
  footerPageLink__privacy: "Integritet",
  footerPageLink__terms: "Villkor",
  formButtonPrimary: "Forts\xE4tt",
  formButtonPrimary__verify: "Verifiera",
  formFieldAction__forgotPassword: "Gl\xF6mt l\xF6senord?",
  formFieldError__matchingPasswords: "L\xF6senorden matchar.",
  formFieldError__notMatchingPasswords: "L\xF6senorden matchar inte.",
  formFieldError__verificationLinkExpired: "Verifieringsl\xE4nken har l\xF6pt ut. V\xE4nligen beg\xE4r en ny l\xE4nk.",
  formFieldHintText__optional: "Valfritt",
  formFieldHintText__slug: "En slug \xE4r ett l\xE4sbart ID som m\xE5ste vara unikt. Det anv\xE4nds ofta i URL:er.",
  formFieldInputPlaceholder__backupCode: "Ange din reservkod",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Radera konto",
  formFieldInputPlaceholder__emailAddress: "Ange din e-postadress",
  formFieldInputPlaceholder__emailAddress_username: "Ange din e-postadress eller ditt anv\xE4ndarnamn",
  formFieldInputPlaceholder__emailAddresses: "Ange eller klistra in en eller flera e-postadresser, separerade med mellanslag eller kommatecken",
  formFieldInputPlaceholder__firstName: "Ange ditt f\xF6rnamn",
  formFieldInputPlaceholder__lastName: "Ange ditt efternamn",
  formFieldInputPlaceholder__organizationDomain: "Ange organisationsdom\xE4n",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Ange e-postadress f\xF6r verifiering",
  formFieldInputPlaceholder__organizationName: "Ange organisationsnamn",
  formFieldInputPlaceholder__organizationSlug: "min-organisation",
  formFieldInputPlaceholder__password: "Ange ditt l\xF6senord",
  formFieldInputPlaceholder__phoneNumber: "Ange ditt telefonnummer",
  formFieldInputPlaceholder__username: "Ange ditt anv\xE4ndarnamn",
  formFieldLabel__automaticInvitations: "Aktivera automatiska inbjudningar f\xF6r denna dom\xE4n",
  formFieldLabel__backupCode: "Reserv-kod",
  formFieldLabel__confirmDeletion: "Radera konto",
  formFieldLabel__confirmPassword: "Bekr\xE4fta l\xF6senord",
  formFieldLabel__currentPassword: "Nuvarande l\xF6senord",
  formFieldLabel__emailAddress: "E-postadress",
  formFieldLabel__emailAddress_username: "E-postadress eller anv\xE4ndarnamn",
  formFieldLabel__emailAddresses: "E-postadresser",
  formFieldLabel__firstName: "F\xF6rnamn",
  formFieldLabel__lastName: "Efternamn",
  formFieldLabel__newPassword: "Nytt l\xF6senord",
  formFieldLabel__organizationDomain: "Dom\xE4n",
  formFieldLabel__organizationDomainDeletePending: "Ta bort v\xE4ntande inbjudningar och f\xF6rslag",
  formFieldLabel__organizationDomainEmailAddress: "Verifierings-e-postadress",
  formFieldLabel__organizationDomainEmailAddressDescription: "Ange en e-postadress under denna dom\xE4n f\xF6r att f\xE5 en kod och verifiera denna dom\xE4n.",
  formFieldLabel__organizationName: "Organisationsnamn",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Namn p\xE5 passkey",
  formFieldLabel__password: "L\xF6senord",
  formFieldLabel__phoneNumber: "Telefonnummer",
  formFieldLabel__role: "Roll",
  formFieldLabel__signOutOfOtherSessions: "Logga ut fr\xE5n alla andra enheter",
  formFieldLabel__username: "Anv\xE4ndarnamn",
  impersonationFab: {
    action__signOut: "Logga ut",
    title: "Inloggad som {{identifier}}"
  },
  maintenanceMode: "Vi genomf\xF6r f\xF6r n\xE4rvarande underh\xE5ll, men oroa dig inte, det b\xF6r inte ta mer \xE4n n\xE5gra minuter.",
  membershipRole__admin: "Admin",
  membershipRole__basicMember: "Medlem",
  membershipRole__guestMember: "G\xE4st",
  organizationList: {
    action__createOrganization: "Skapa organisation",
    action__invitationAccept: "G\xE5 med",
    action__suggestionsAccept: "Be om att g\xE5 med",
    createOrganization: "Skapa Organisation",
    invitationAcceptedLabel: "G\xE5tt med",
    subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
    suggestionsAcceptedLabel: "V\xE4ntar godk\xE4nnande",
    title: "V\xE4lj ett konto",
    titleWithoutPersonal: "V\xE4lj en organisation"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatiska inbjudningar",
    badge__automaticSuggestion: "Automatiska f\xF6rslag",
    badge__manualInvitation: "Ingen automatisk registrering",
    badge__unverified: "Overifierad",
    createDomainPage: {
      subtitle: "L\xE4gg till dom\xE4nen f\xF6r att verifiera. Anv\xE4ndare med e-postadresser i denna dom\xE4n kan g\xE5 med i organisationen automatiskt eller beg\xE4ra att f\xE5 g\xE5 med.",
      title: "L\xE4gg till dom\xE4n"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Inbjudningarna kunde inte skickas. \xC5tg\xE4rda f\xF6ljande och f\xF6rs\xF6k igen:",
      formButtonPrimary__continue: "Skicka inbjudningar",
      selectDropdown__role: "V\xE4lj roll",
      subtitle: "Bjud in nya medlemmar till denna organisation",
      successMessage: "Inbjudningar skickade",
      title: "Bjud in medlemmar"
    },
    membersPage: {
      action__invite: "Bjud in",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Ta bort medlem",
        tableHeader__actions: "\xC5tg\xE4rder",
        tableHeader__joined: "Gick med",
        tableHeader__role: "Roll",
        tableHeader__user: "Anv\xE4ndare"
      },
      detailsTitle__emptyRow: "Inga medlemmar att visa",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Bjud in anv\xE4ndare genom att koppla en e-postdom\xE4n till din organisation. Alla som registrerar sig med en matchande e-postdom\xE4n kommer att kunna g\xE5 med i organisationen n\xE4r som helst.",
          headerTitle: "Automatiska inbjudningar",
          primaryButton: "Hantera verifierade dom\xE4ner"
        },
        table__emptyRow: "Inga inbjudningar att visa"
      },
      invitedMembersTab: {
        menuAction__revoke: "\xC5terkalla inbjudan",
        tableHeader__invited: "Inbjudna"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Anv\xE4ndare som registrerar sig med en matchande e-postdom\xE4n kommer att kunna se ett f\xF6rslag om att beg\xE4ra att g\xE5 med i din organisation.",
          headerTitle: "Automatiska f\xF6rslag",
          primaryButton: "Hantera verifierade dom\xE4ner"
        },
        menuAction__approve: "Godk\xE4nn",
        menuAction__reject: "Avvisa",
        tableHeader__requested: "Beg\xE4rd \xE5tkomst",
        table__emptyRow: "Inga f\xF6rfr\xE5gningar att visa"
      },
      start: {
        headerTitle__invitations: "Inbjudningar",
        headerTitle__members: "Medlemmar",
        headerTitle__requests: "F\xF6rfr\xE5gningar"
      }
    },
    navbar: {
      description: "Hantera din organisation.",
      general: "Allm\xE4nna inst\xE4llningar",
      members: "Medlemar",
      title: "Organisation"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Skriv "{{organizationName}}" nedan f\xF6r att forts\xE4tta.',
          messageLine1: "\xC4r du s\xE4ker p\xE5 att du vill radera denna organisation?",
          messageLine2: "Denna \xE5tg\xE4rd \xE4r permanent och kan inte \xE5ngras.",
          successMessage: "Du har raderat organisationen.",
          title: "Radera organisation"
        },
        leaveOrganization: {
          actionDescription: 'Skriv "{{organizationName}}" nedan f\xF6r att forts\xE4tta.',
          messageLine1: "\xC4r du s\xE4ker p\xE5 att du vill l\xE4mna denna organisation? Du kommer att f\xF6rlora \xE5tkomst till organisationen och dess applikationer.",
          messageLine2: "Denna \xE5tg\xE4rd \xE4r permanent och o\xE5terkallelig.",
          successMessage: "Du har l\xE4mnat organisationen.",
          title: "L\xE4mna organisation"
        },
        title: "Farligt"
      },
      domainSection: {
        menuAction__manage: "Hantera",
        menuAction__remove: "Radera",
        menuAction__verify: "Verifiera",
        primaryButton: "L\xE4gg till dom\xE4n",
        subtitle: "Till\xE5t anv\xE4ndare att g\xE5 med i organisationen automatiskt eller beg\xE4ra att g\xE5 med baserat p\xE5 en verifierad e-postdom\xE4n.",
        title: "Verifierade dom\xE4ner"
      },
      successMessage: "Organisationen har uppdaterats.",
      title: "Organisationsprofil"
    },
    removeDomainPage: {
      messageLine1: "E-postdom\xE4nen {{domain}} kommer att tas bort.",
      messageLine2: "Anv\xE4ndare kommer inte att kunna g\xE5 med i organisationen automatiskt efter detta.",
      successMessage: "{{domain}} har tagits bort.",
      title: "Ta bort dom\xE4n"
    },
    start: {
      headerTitle__general: "Allm\xE4nna inst\xE4llningar",
      headerTitle__members: "Medlemmar",
      profileSection: {
        primaryButton: "Uppdatera profil",
        title: "Organisationsprofil",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Att ta bort denna dom\xE4n kommer att p\xE5verka inbjudna anv\xE4ndare.",
        removeDomainActionLabel__remove: "Ta bort dom\xE4n",
        removeDomainSubtitle: "Ta bort denna dom\xE4n fr\xE5n dina verifierade dom\xE4ner",
        removeDomainTitle: "Ta bort dom\xE4n"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Anv\xE4ndare bjuds automatiskt in att g\xE5 med i organisationen n\xE4r de registrerar sig och kan g\xE5 med n\xE4r som helst.",
        automaticInvitationOption__label: "Automatiska inbjudningar",
        automaticSuggestionOption__description: "Anv\xE4ndare f\xE5r ett f\xF6rslag om att beg\xE4ra att f\xE5 g\xE5 med, men m\xE5ste godk\xE4nnas av en administrat\xF6r innan de kan g\xE5 med i organisationen.",
        automaticSuggestionOption__label: "Automatiska f\xF6rslag",
        calloutInfoLabel: "Att \xE4ndra registreringsl\xE4get kommer endast att p\xE5verka nya anv\xE4ndare.",
        calloutInvitationCountLabel: "V\xE4ntande inbjudningar skickade till anv\xE4ndare: {{count}}",
        calloutSuggestionCountLabel: "V\xE4ntande f\xF6rslag skickade till anv\xE4ndare: {{count}}",
        manualInvitationOption__description: "Anv\xE4ndare kan endast bjudas in manuellt till organisationen.",
        manualInvitationOption__label: "Ingen automatisk registrering",
        subtitle: "V\xE4lj hur anv\xE4ndare fr\xE5n denna dom\xE4n kan g\xE5 med i organisationen."
      },
      start: {
        headerTitle__danger: "Fara",
        headerTitle__enrollment: "Registreringsalternativ"
      },
      subtitle: "Dom\xE4nen {{domain}} \xE4r nu verifierad. Forts\xE4tt genom att v\xE4lja registreringsl\xE4ge.",
      title: "Uppdatera {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Ange verifieringskoden som skickats till din e-postadress",
      formTitle: "Verifieringskod",
      resendButton: "Fick du inte koden? Skicka igen",
      subtitle: "Dom\xE4nen {{domainName}} beh\xF6ver verifieras via e-post.",
      subtitleVerificationCodeScreen: "En verifieringskod skickades till {{emailAddress}}. Ange koden f\xF6r att forts\xE4tta.",
      title: "Verifiera dom\xE4n"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Skapa organisation",
    action__invitationAccept: "Join",
    action__manageOrganization: "Hantera organisation",
    action__suggestionsAccept: "Request to join",
    notSelected: "Ingen organisation vald",
    personalWorkspace: "Personligt Arbetsomr\xE5de",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "N\xE4sta",
  paginationButton__previous: "F\xF6reg\xE5ende",
  paginationRowText__displaying: "Visar",
  paginationRowText__of: "av",
  reverification: {
    alternativeMethods: {
      actionLink: "F\xE5 hj\xE4lp",
      actionText: "Har du inget av dessa?",
      blockButton__backupCode: "Anv\xE4nd en reservkod",
      blockButton__emailCode: "Skicka kod via e-post till {{identifier}}",
      blockButton__password: "Forts\xE4tt med ditt l\xF6senord",
      blockButton__phoneCode: "Skicka SMS-kod till {{identifier}}",
      blockButton__totp: "Anv\xE4nd din autentiseringsapp",
      getHelp: {
        blockButton__emailSupport: "E-posta support",
        content: "Om du har problem med att verifiera ditt konto, maila oss s\xE5 hj\xE4lper vi dig att \xE5terst\xE4lla \xE5tkomsten s\xE5 snart som m\xF6jligt.",
        title: "F\xE5 hj\xE4lp"
      },
      subtitle: "Har du problem? Du kan anv\xE4nda n\xE5gon av dessa metoder f\xF6r verifiering.",
      title: "Anv\xE4nd en annan metod"
    },
    backupCodeMfa: {
      subtitle: "Din reservkod \xE4r den du fick n\xE4r du st\xE4llde in tv\xE5stegsverifiering.",
      title: "Ange en reservkod"
    },
    emailCode: {
      formTitle: "Verifieringskod",
      resendButton: "Fick du ingen kod? Skicka igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Kontrollera din e-post"
    },
    noAvailableMethods: {
      message: "Kan inte forts\xE4tta med verifieringen. Det finns ingen tillg\xE4nglig autentiseringsfaktor.",
      subtitle: "Ett fel intr\xE4ffade",
      title: "Kan inte verifiera ditt konto"
    },
    password: {
      actionLink: "Anv\xE4nd en annan metod",
      subtitle: "Ange l\xF6senordet som \xE4r kopplat till ditt konto",
      title: "Ange ditt l\xF6senord"
    },
    phoneCode: {
      formTitle: "Verifieringskod",
      resendButton: "Fick du ingen kod? Skicka igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Kontrollera din telefon"
    },
    phoneCodeMfa: {
      formTitle: "Verifieringskod",
      resendButton: "Fick du ingen kod? Skicka igen",
      subtitle: "F\xF6r att forts\xE4tta, v\xE4nligen ange verifieringskoden som skickats till din telefon",
      title: "Kontrollera din telefon"
    },
    totpMfa: {
      formTitle: "Verifieringskod",
      subtitle: "F\xF6r att forts\xE4tta, v\xE4nligen ange verifieringskoden som genererats av din autentiseringsapp",
      title: "Tv\xE5stegsverifiering"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "L\xE4gg till konto",
      action__signOutAll: "Logga ut fr\xE5n alla konton",
      subtitle: "V\xE4lj det konto du vill forts\xE4tta med",
      title: "V\xE4lj ett konto"
    },
    alternativeMethods: {
      actionLink: "F\xE5 hj\xE4lp",
      actionText: "Saknar du n\xE5gon av dessa?",
      blockButton__backupCode: "Anv\xE4nd en reservkod",
      blockButton__emailCode: "Skicka kod till {{identifier}}",
      blockButton__emailLink: "Skicka l\xE4nk till {{identifier}}",
      blockButton__passkey: "Anv\xE4nd din passkey",
      blockButton__password: "Logga in med ditt l\xF6senord",
      blockButton__phoneCode: "Skicka kod till {{identifier}}",
      blockButton__totp: "Anv\xE4nd din autentiseringsapp",
      getHelp: {
        blockButton__emailSupport: "E-post support",
        content: "Om du har problem med att logga in p\xE5 ditt konto, kontakta oss via e-post s\xE5 hj\xE4lper vi dig att \xE5terst\xE4lla \xE5tkomsten s\xE5 snabbt som m\xF6jligt.",
        title: "F\xE5 hj\xE4lp"
      },
      subtitle: "Har du problem? Du kan anv\xE4nda n\xE5gon av dessa metoder f\xF6r att logga in.",
      title: "Anv\xE4nd en annan metod"
    },
    backupCodeMfa: {
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Ange en reservkod"
    },
    emailCode: {
      formTitle: "Verifieringskod",
      resendButton: "Skicka koden igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Kontrollera din e-post"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "F\xF6r att forts\xE4tta, \xF6ppna verifieringsl\xE4nken p\xE5 enhet och webbl\xE4sare fr\xE5n vilken du startade inloggningen",
        title: "Verifieringsl\xE4nken \xE4r ogiltig f\xF6r denna enhet"
      },
      expired: {
        subtitle: "\xC5terg\xE5 till ursprungliga fliken f\xF6r att forts\xE4tta.",
        title: "Denna verifieringsl\xE4nk har upph\xF6rt att g\xE4lla"
      },
      failed: {
        subtitle: "\xC5terg\xE5 till ursprungliga fliken f\xF6r att forts\xE4tta.",
        title: "Denna verifieringsl\xE4nk \xE4r ogiltig"
      },
      formSubtitle: "Anv\xE4nd verifieringsl\xE4nken som skickades till din e-postadress",
      formTitle: "Verifieringsl\xE4nk",
      loading: {
        subtitle: "Du kommer att omdirigeras snart",
        title: "Loggar in..."
      },
      resendButton: "Skicka l\xE4nken igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Kontrollera din e-post",
      unusedTab: {
        title: "Du kan st\xE4nga den h\xE4r fliken"
      },
      verified: {
        subtitle: "Du kommer att omdirigeras snart",
        title: "Inloggningen lyckades"
      },
      verifiedSwitchTab: {
        subtitle: "\xC5terg\xE5 till ursprungliga fliken f\xF6r att forts\xE4tta",
        subtitleNewTab: "\xC5terg\xE5 till den nyligen \xF6ppnade fliken f\xF6r att forts\xE4tta",
        titleNewTab: "Loggade in p\xE5 annan flik"
      }
    },
    forgotPassword: {
      formTitle: "\xC5terst\xE4ll l\xF6senordskod",
      resendButton: "Fick du inte en kod? Skicka igen",
      subtitle: "f\xF6r att \xE5terst\xE4lla ditt l\xF6senord",
      subtitle_email: "F\xF6rst, ange koden som skickats till din e-postadress",
      subtitle_phone: "F\xF6rst, ange koden som skickats till din telefon",
      title: "\xC5terst\xE4ll l\xF6senord"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\xC5terst\xE4ll ditt l\xF6senord",
      label__alternativeMethods: "Eller, logga in med en annan metod",
      title: "Gl\xF6mt l\xF6senord?"
    },
    noAvailableMethods: {
      message: "Kan inte forts\xE4tta med inloggning. Det finns ingen tillg\xE4nglig autentiseringsfaktor.",
      subtitle: "Ett fel intr\xE4ffade",
      title: "Kan inte logga in"
    },
    passkey: {
      subtitle: "Att anv\xE4nda din passkey bekr\xE4ftar att det \xE4r du. Din enhet kan be om ditt fingeravtryck, ansikte eller sk\xE4rml\xE5s.",
      title: "Anv\xE4nd din passkey"
    },
    password: {
      actionLink: "Anv\xE4nd en annan metod",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Ange ditt l\xF6senord"
    },
    passwordPwned: {
      title: "L\xF6senord \xE4r f\xF6r os\xE4kert"
    },
    phoneCode: {
      formTitle: "Verifieringskod",
      resendButton: "Skicka koden igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Kolla din telefon"
    },
    phoneCodeMfa: {
      formTitle: "Verifieringskod",
      resendButton: "Skicka koden igen",
      subtitle: "F\xF6r att forts\xE4tta, v\xE4nligen ange verifieringskoden som skickats till din telefon",
      title: "Kolla din telefon"
    },
    resetPassword: {
      formButtonPrimary: "\xC5terst\xE4ll l\xF6senord",
      requiredMessage: "Av s\xE4kerhetssk\xE4l \xE4r det n\xF6dv\xE4ndigt att \xE5terst\xE4lla ditt l\xF6senord.",
      successMessage: "Ditt l\xF6senord har \xE4ndrats framg\xE5ngsrikt. Loggar in dig, var god v\xE4nta en stund.",
      title: "Ange nytt l\xF6senord"
    },
    resetPasswordMfa: {
      detailsLabel: "Vi beh\xF6ver verifiera din identitet innan vi \xE5terst\xE4ller ditt l\xF6senord."
    },
    start: {
      actionLink: "Skapa konto",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Use email",
      actionLink__use_email_username: "Use email or username",
      actionLink__use_passkey: "Anv\xE4nd passkey ist\xE4llet",
      actionLink__use_phone: "Anv\xE4nd telefon",
      actionLink__use_username: "Anv\xE4nd anv\xE4ndarnamn",
      actionText: "Har du inget konto?",
      actionText__join_waitlist: void 0,
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      subtitleCombined: void 0,
      title: "Logga in",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Verifieringskod",
      subtitle: "F\xF6r att forts\xE4tta, v\xE4nligen ange verifieringskoden som genereras av din autentiseringsapp",
      title: "Tv\xE5stegsverifiering"
    }
  },
  signInEnterPasswordTitle: "Ange ditt l\xF6senord",
  signUp: {
    continue: {
      actionLink: "Logga in",
      actionText: "Har du redan ett konto?",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Fyll i n\xF6dv\xE4ndiga f\xE4lt"
    },
    emailCode: {
      formSubtitle: "Ange verifieringskoden som skickades till din e-postadress",
      formTitle: "Verifieringskod",
      resendButton: "Skicka koden igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Verifiera din e-post"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "F\xF6r att forts\xE4tta, \xF6ppna verifieringsl\xE4nken p\xE5 enhet och webbl\xE4sare fr\xE5n vilken du startade inloggningen",
        title: "Verifieringsl\xE4nken \xE4r ogiltig f\xF6r denna enhet"
      },
      formSubtitle: "Anv\xE4nd verifieringsl\xE4nken som skickades till din e-postadress",
      formTitle: "Verifieringsl\xE4nk",
      loading: {
        title: "Registrerar..."
      },
      resendButton: "Skicka l\xE4nken igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Verifiera din e-post",
      verified: {
        title: "Registreringen lyckades"
      },
      verifiedSwitchTab: {
        subtitle: "\xC5terg\xE5 till den nyligen \xF6ppnade fliken f\xF6r att forts\xE4tta",
        subtitleNewTab: "\xC5terg\xE5 till f\xF6reg\xE5ende flik f\xF6r att forts\xE4tta",
        title: "E-posten har verifierats"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Jag godk\xE4nner {{ privacyPolicyLink || link("Integritetspolicyn") }}',
        label__onlyTermsOfService: 'Jag godk\xE4nner de {{ termsOfServiceLink || link("Allm\xE4nna villkoren") }}',
        label__termsOfServiceAndPrivacyPolicy: 'Jag godk\xE4nner de {{ termsOfServiceLink || link("Allm\xE4nna villkoren") }} och {{ privacyPolicyLink || link("Integritetspolicyn") }}'
      },
      continue: {
        subtitle: "V\xE4nligen l\xE4s och godk\xE4nn villkoren f\xF6r att forts\xE4tta",
        title: "Juridiskt samtycke"
      }
    },
    phoneCode: {
      formSubtitle: "Ange verifieringskoden som skickades till ditt telefonnummer",
      formTitle: "Verifieringskod",
      resendButton: "Skicka koden igen",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Verifiera din telefon"
    },
    restrictedAccess: {
      actionLink: "Tillbaka till inloggning",
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: "\xC5tkomst till denna app \xE4r begr\xE4nsad och en inbjudan kr\xE4vs f\xF6r att registrera sig.",
      subtitleWaitlist: void 0,
      title: "Begr\xE4nsad \xE5tkomst"
    },
    start: {
      actionLink: "Logga in",
      actionLink__use_email: "Anv\xE4nd e-post ist\xE4llet",
      actionLink__use_phone: "Anv\xE4nd telefon ist\xE4llet",
      actionText: "Har du redan ett konto?",
      subtitle: "f\xF6r att forts\xE4tta till {{applicationName}}",
      subtitleCombined: "f\xF6r att forts\xE4tta till {{applicationName}}",
      title: "Skapa ditt konto",
      titleCombined: "Skapa ditt konto"
    }
  },
  socialButtonsBlockButton: "Forts\xE4tt med {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} \xE4r redan medlem i organisationen.",
    captcha_invalid: "Registrering misslyckades p\xE5 grund av s\xE4kerhetskontroller. V\xE4nligen uppdatera sidan och f\xF6rs\xF6k igen eller kontakta supporten f\xF6r mer hj\xE4lp.",
    captcha_unavailable: "Registrering misslyckades p\xE5 grund av misslyckad bot-validering. V\xE4nligen uppdatera sidan och f\xF6rs\xF6k igen eller kontakta supporten f\xF6r mer hj\xE4lp.",
    form_code_incorrect: "Koden \xE4r felaktig",
    form_identifier_exists__email_address: "Denna e-postadress \xE4r taget. V\xE4nligen prova ett annat.",
    form_identifier_exists__phone_number: "Detta telefonnummer \xE4r taget. V\xE4nligen prova ett annat.",
    form_identifier_exists__username: "Detta anv\xE4ndarnamn \xE4r taget. V\xE4nligen prova ett annat.",
    form_identifier_not_found: "Identifieraren hittades inte.",
    form_param_format_invalid: "Formatet \xE4r ogiltigt.",
    form_param_format_invalid__email_address: "E-postadressen m\xE5ste vara en giltig e-postadress.",
    form_param_format_invalid__phone_number: "Telefonnumret m\xE5ste vara i ett giltigt internationellt format.",
    form_param_max_length_exceeded__first_name: "F\xF6rnamnet f\xE5r inte \xF6verskrida 256 tecken.",
    form_param_max_length_exceeded__last_name: "Efternamnet f\xE5r inte \xF6verskrida 256 tecken.",
    form_param_max_length_exceeded__name: "Namnet f\xE5r inte \xF6verskrida 256 tecken.",
    form_param_nil: "Parametern f\xE5r inte vara tom.",
    form_param_value_invalid: void 0,
    form_password_incorrect: "L\xF6senordet \xE4r felaktigt.",
    form_password_length_too_short: "L\xF6senordet \xE4r f\xF6r kort.",
    form_password_not_strong_enough: "Ditt l\xF6senord \xE4r inte tillr\xE4ckligt starkt.",
    form_password_pwned: "L\xF6senordet har l\xE4ckt i tidigare dataintr\xE5ng.",
    form_password_pwned__sign_in: "L\xF6senordet har l\xE4ckt, v\xE4nligen logga in f\xF6r att \xE4ndra det.",
    form_password_size_in_bytes_exceeded: "Ditt l\xF6senord har \xF6verskridit det maximala antalet till\xE5tna bytes, v\xE4nligen f\xF6rkorta det eller ta bort n\xE5gra specialtecken.",
    form_password_validation_failed: "Felaktigt l\xF6senord",
    form_username_invalid_character: "Anv\xE4ndarnamnet inneh\xE5ller ogiltiga tecken.",
    form_username_invalid_length: "Anv\xE4ndarnamnets l\xE4ngd \xE4r ogiltig.",
    identification_deletion_failed: "Du kan inte ta bort din sista identifiering.",
    not_allowed_access: "\xC5tkomst nekad.",
    organization_domain_blocked: "Dom\xE4nen \xE4r blockerad.",
    organization_domain_common: "Dom\xE4nen \xE4r vanlig.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Medlemskapet \xE4r fullt.",
    organization_minimum_permissions_needed: "Du m\xE5ste ha tillr\xE4ckligt med beh\xF6righeter.",
    passkey_already_exists: "Passnyckeln finns redan.",
    passkey_not_supported: "Passnyckel st\xF6ds inte.",
    passkey_pa_not_supported: "Passnyckel PA st\xF6ds inte.",
    passkey_registration_cancelled: "Registrering av passnyckel avbruten.",
    passkey_retrieval_cancelled: "H\xE4mtning av passnyckel avbruten.",
    passwordComplexity: {
      maximumLength: "Maximal l\xE4ngd",
      minimumLength: "Minimal l\xE4ngd",
      requireLowercase: "Kr\xE4ver sm\xE5 bokst\xE4ver",
      requireNumbers: "Kr\xE4ver siffror",
      requireSpecialCharacter: "Kr\xE4ver specialtecken",
      requireUppercase: "Kr\xE4ver stora bokst\xE4ver",
      sentencePrefix: "L\xF6senordet m\xE5ste inneh\xE5lla"
    },
    phone_number_exists: "Detta telefonnummer \xE4r taget. V\xE4nligen prova ett annat.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Ditt l\xF6senord fungerar, men kunde vara starkare. F\xF6rs\xF6k l\xE4gga till fler tecken.",
      goodPassword: "Ditt l\xF6senord uppfyller alla n\xF6dv\xE4ndiga krav.",
      notEnough: "Ditt l\xF6senord \xE4r inte tillr\xE4ckligt starkt.",
      suggestions: {
        allUppercase: "Anv\xE4nd stora bokst\xE4ver, men inte f\xF6r alla tecken.",
        anotherWord: "L\xE4gg till fler ord som \xE4r mindre vanliga.",
        associatedYears: "Undvik \xE5r som \xE4r associerade med dig.",
        capitalization: "Anv\xE4nd stor bokstav f\xF6r mer \xE4n det f\xF6rsta tecknet.",
        dates: "Undvik datum och \xE5r som \xE4r associerade med dig.",
        l33t: "Undvik f\xF6ruts\xE4gbara bokstavsers\xE4ttningar som '@' f\xF6r 'a'.",
        longerKeyboardPattern: "Anv\xE4nd l\xE4ngre tangentbordsm\xF6nster och \xE4ndra skrivr\xE4ttning flera g\xE5nger.",
        noNeed: "Du kan skapa starka l\xF6senord utan att anv\xE4nda symboler, siffror eller stora bokst\xE4ver.",
        pwned: "Om du anv\xE4nder detta l\xF6senord n\xE5gon annanstans b\xF6r du \xE4ndra det.",
        recentYears: "Undvik de senaste \xE5ren.",
        repeated: "Undvik upprepade ord och tecken.",
        reverseWords: "Undvik omv\xE4nd stavning av vanliga ord.",
        sequences: "Undvik vanliga teckenf\xF6ljder.",
        useWords: "Anv\xE4nd flera ord, men undvik vanliga fraser."
      },
      warnings: {
        common: "Detta \xE4r ett vanligt anv\xE4nt l\xF6senord.",
        commonNames: "Vanliga namn och efternamn \xE4r l\xE4tta att gissa.",
        dates: "Datum \xE4r l\xE4tta att gissa.",
        extendedRepeat: 'Upprepade teckenm\xF6nster som "abcabcabc" \xE4r l\xE4tta att gissa.',
        keyPattern: "Korta tangentbordsm\xF6nster \xE4r l\xE4tta att gissa.",
        namesByThemselves: "Enskilda namn eller efternamn \xE4r l\xE4tta att gissa.",
        pwned: "Ditt l\xF6senord har exponerats genom ett dataintr\xE5ng p\xE5 internet.",
        recentYears: "Senaste \xE5ren \xE4r l\xE4tta att gissa.",
        sequences: 'Vanliga teckenf\xF6ljder som "abc" \xE4r l\xE4tta att gissa.',
        similarToCommon: "Detta liknar ett vanligt anv\xE4nt l\xF6senord.",
        simpleRepeat: 'Upprepade tecken som "aaa" \xE4r l\xE4tta att gissa.',
        straightRow: "Raka rader av tangenter p\xE5 ditt tangentbord \xE4r l\xE4tta att gissa.",
        topHundred: "Detta \xE4r ett ofta anv\xE4nt l\xF6senord.",
        topTen: "Detta \xE4r ett mycket anv\xE4nt l\xF6senord.",
        userInputs: "Det b\xF6r inte finnas n\xE5gra personliga eller sidrelaterade data.",
        wordByItself: "Enskilda ord \xE4r l\xE4tta att gissa."
      }
    }
  },
  userButton: {
    action__addAccount: "L\xE4gg till konto",
    action__manageAccount: "Hantera konto",
    action__signOut: "Logga ut",
    action__signOutAll: "Logga ut fr\xE5n alla konton"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopierat!",
      actionLabel__copy: "Kopiera alla",
      actionLabel__download: "Ladda ner .txt",
      actionLabel__print: "Skriv ut",
      infoText1: "Backupkoder kommer att aktiveras f\xF6r detta konto.",
      infoText2: "H\xE5ll backupkoderna hemliga och f\xF6rvara dem s\xE4kert. Du kan generera nya backupkoder om du misst\xE4nker att de har komprometterats.",
      subtitle__codelist: "F\xF6rvara dem s\xE4kert och h\xE5ll dem hemliga.",
      successMessage: "Backupkoder \xE4r nu aktiverade. Du kan anv\xE4nda en av dessa f\xF6r att logga in p\xE5 ditt konto om du f\xF6rlorar \xE5tkomsten till din autentiseringsenhet. Varje kod kan endast anv\xE4ndas en g\xE5ng.",
      successSubtitle: "Du kan anv\xE4nda en av dessa f\xF6r att logga in p\xE5 ditt konto om du f\xF6rlorar \xE5tkomsten till din autentiseringsenhet.",
      title: "L\xE4gg till backupkodverifiering",
      title__codelist: "Backupkoder"
    },
    connectedAccountPage: {
      formHint: "V\xE4lj en leverant\xF6r f\xF6r att ansluta ditt konto.",
      formHint__noAccounts: "Det finns inga tillg\xE4ngliga externa kontoleverant\xF6rer.",
      removeResource: {
        messageLine1: "{{identifier}} kommer att tas bort fr\xE5n detta konto.",
        messageLine2: "Du kommer inte l\xE4ngre att kunna anv\xE4nda detta anslutna konto och alla beroende funktioner kommer att sluta fungera.",
        successMessage: "{{connectedAccount}} har tagits bort fr\xE5n ditt konto.",
        title: "Ta bort anslutet konto"
      },
      socialButtonsBlockButton: "Anslut {{provider|titleize}} konto",
      successMessage: "Leverant\xF6ren har lagts till i ditt konto.",
      title: "L\xE4gg till anslutet konto"
    },
    deletePage: {
      actionDescription: 'Skriv "Radera konto" nedan f\xF6r att forts\xE4tta.',
      confirm: "Radera konto",
      messageLine1: "\xC4r du s\xE4ker p\xE5 att du vill radera ditt konto?",
      messageLine2: "Denna \xE5tg\xE4rd \xE4r permanent och kan inte \xE5ngras.",
      title: "Radera konto"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Ett e-postmeddelande med en verifieringskod kommer att skickas till denna e-postadress.",
        formSubtitle: "Ange verifieringskoden som skickats till {{identifier}}",
        formTitle: "Verifieringskod",
        resendButton: "Skicka kod igen",
        successMessage: "E-postadressen {{identifier}} har lagts till i ditt konto."
      },
      emailLink: {
        formHint: "Ett e-postmeddelande med en verifieringsl\xE4nk kommer att skickas till denna e-postadress.",
        formSubtitle: "Klicka p\xE5 verifieringsl\xE4nken i e-postmeddelandet som skickats till {{identifier}}",
        formTitle: "Verifieringsl\xE4nk",
        resendButton: "Skicka l\xE4nken igen",
        successMessage: "E-postadressen {{identifier}} har lagts till i ditt konto."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} kommer att tas bort fr\xE5n detta konto.",
        messageLine2: "Du kommer inte l\xE4ngre att kunna logga in med denna e-postadress.",
        successMessage: "{{emailAddress}} har tagits bort fr\xE5n ditt konto.",
        title: "Ta bort e-postadress"
      },
      title: "L\xE4gg till e-postadress",
      verifyTitle: "Verifiera e-postadress"
    },
    formButtonPrimary__add: "L\xE4gg till",
    formButtonPrimary__continue: "Forts\xE4tt",
    formButtonPrimary__finish: "Slutf\xF6r",
    formButtonPrimary__remove: "Ta bort",
    formButtonPrimary__save: "Spara",
    formButtonReset: "Avbryt",
    mfaPage: {
      formHint: "V\xE4lj en metod att l\xE4gga till.",
      title: "L\xE4gg till tv\xE5stegsverifiering"
    },
    mfaPhoneCodePage: {
      backButton: "Anv\xE4nd befintligt telefonnummer",
      primaryButton__addPhoneNumber: "L\xE4gg till ett telefonnummer",
      removeResource: {
        messageLine1: "{{identifier}} kommer inte l\xE4ngre att ta emot verifieringskoder vid inloggning.",
        messageLine2: "Ditt konto kan vara mindre s\xE4kert. \xC4r du s\xE4ker p\xE5 att du vill forts\xE4tta?",
        successMessage: "SMS-kod tv\xE5stegsverifiering har tagits bort f\xF6r {{mfaPhoneCode}}",
        title: "Ta bort tv\xE5stegsverifiering"
      },
      subtitle__availablePhoneNumbers: "V\xE4lj ett telefonnummer att registrera f\xF6r SMS-kod tv\xE5stegsverifiering.",
      subtitle__unavailablePhoneNumbers: "Det finns inga tillg\xE4ngliga telefonnummer att registrera f\xF6r SMS-kod tv\xE5stegsverifiering.",
      successMessage1: "N\xE4r du loggar in kommer du att beh\xF6va ange en verifieringskod som skickats till detta telefonnummer som ett ytterligare steg.",
      successMessage2: "Spara dessa s\xE4kerhetskoder och f\xF6rvara dem p\xE5 ett s\xE4kert st\xE4lle. Om du f\xF6rlorar tillg\xE5ng till din autentiseringsenhet kan du anv\xE4nda s\xE4kerhetskoder f\xF6r att logga in.",
      successTitle: "SMS-kodsverifiering aktiverad",
      title: "L\xE4gg till SMS-kodverifiering"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Skanna QR-kod ist\xE4llet",
        buttonUnableToScan__nonPrimary: "Kan inte skanna QR-kod?",
        infoText__ableToScan: "Konfigurera en ny inloggningsmetod i din autentiseringsapp och skanna f\xF6ljande QR-kod f\xF6r att l\xE4nka den till ditt konto.",
        infoText__unableToScan: "Konfigurera en ny inloggningsmetod i din autentiseringsapp och ange nyckeln nedan.",
        inputLabel__unableToScan1: "Se till att tidsbaserade eller eng\xE5ngsl\xF6senord \xE4r aktiverade och slutf\xF6r sedan l\xE4nkningen till ditt konto.",
        inputLabel__unableToScan2: "Alternativt, om din autentiseringsapp st\xF6djer TOTP URI kan du ocks\xE5 kopiera hela URI."
      },
      removeResource: {
        messageLine1: "Verifieringskoder fr\xE5n denna autentiseringsapp kommer inte l\xE4ngre att kr\xE4vas vid inloggning.",
        messageLine2: "Ditt konto kan vara mindre s\xE4kert. \xC4r du s\xE4ker p\xE5 att du vill forts\xE4tta?",
        successMessage: "Tv\xE5stegsverifiering via autentiseringsapp har tagits bort.",
        title: "Ta bort tv\xE5stegsverifiering"
      },
      successMessage: "Tv\xE5stegsverifiering \xE4r nu aktiverat. Vid inloggning beh\xF6ver du ange en verifieringskod fr\xE5n denna autentiseringsapp som ett extra steg.",
      title: "L\xE4gg till autentiseringsapp",
      verifySubtitle: "Ange verifieringskoden genererad av din autentiseringsapp",
      verifyTitle: "Verifieringskod"
    },
    mobileButton__menu: "Meny",
    navbar: {
      account: "Profil",
      description: "Hantera din kontoinformation.",
      security: "S\xE4kerhet",
      title: "Konto"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} kommer att tas bort fr\xE5n detta konto.",
        title: "Ta bort passkey"
      },
      subtitle__rename: "Du kan \xE4ndra passkey-namnet f\xF6r att g\xF6ra det l\xE4ttare att hitta.",
      title__rename: "Byt namn p\xE5 Passkey"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Det rekommenderas att logga ut fr\xE5n alla andra enheter som kan ha anv\xE4nt ditt gamla l\xF6senord.",
      readonly: "Ditt l\xF6senord kan f\xF6r n\xE4rvarande inte redigeras eftersom du endast kan logga in via f\xF6retagsanslutningen.",
      successMessage__set: "Ditt l\xF6senord har angetts.",
      successMessage__signOutOfOtherSessions: "Alla andra enheter har loggats ut.",
      successMessage__update: "Ditt l\xF6senord har uppdaterats.",
      title__set: "Ange l\xF6senord",
      title__update: "Byt l\xF6senord"
    },
    phoneNumberPage: {
      infoText: "Ett textmeddelande med en verifieringsl\xE4nk kommer att skickas till detta telefonnummer.",
      removeResource: {
        messageLine1: "{{identifier}} kommer att tas bort fr\xE5n detta konto.",
        messageLine2: "Du kommer inte l\xE4ngre att kunna logga in med detta telefonnummer.",
        successMessage: "{{phoneNumber}} har tagits bort fr\xE5n ditt konto.",
        title: "Ta bort telefonnummer"
      },
      successMessage: "{{identifier}} har lagts till i ditt konto.",
      title: "L\xE4gg till telefonnummer",
      verifySubtitle: "Ange verifieringskoden som skickats till {{identifier}}",
      verifyTitle: "Verifiera telefonnummer"
    },
    profilePage: {
      fileDropAreaHint: "Ladda upp en JPG, PNG, GIF, eller WEBP bild som \xE4r mindre \xE4n 10 MB",
      imageFormDestructiveActionSubtitle: "Ta bort bild",
      imageFormSubtitle: "Ladda upp bild",
      imageFormTitle: "Profilbild",
      readonly: "Din profilinformation har tillhandah\xE5llits av f\xF6retagsanslutningen och kan inte redigeras.",
      successMessage: "Din profil har uppdaterats.",
      title: "Uppdatera profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Logga ut fr\xE5n enhet",
        title: "Aktiva enheter"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "F\xF6rs\xF6k igen",
        actionLabel__reauthorize: "Autentisera nu",
        destructiveActionTitle: "Ta bort",
        primaryButton: "Anslut konto",
        subtitle__disconnected: "Detta konto har kopplats bort.",
        subtitle__reauthorize: "De n\xF6dv\xE4ndiga beh\xF6righeterna har uppdaterats, och du kan uppleva begr\xE4nsad funktionalitet. V\xE4nligen ge ny auktorisering till denna applikation f\xF6r att undvika problem",
        title: "Anslutna konton"
      },
      dangerSection: {
        deleteAccountButton: "Radera konto",
        title: "Radera konto"
      },
      emailAddressesSection: {
        destructiveAction: "Ta bort e-postadress",
        detailsAction__nonPrimary: "S\xE4tt som prim\xE4r",
        detailsAction__primary: "Fullborda verifiering",
        detailsAction__unverified: "Fullborda verifiering",
        primaryButton: "L\xE4gg till en e-postadress",
        title: "E-postadresser"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "Konto",
      headerTitle__security: "S\xE4kerhet",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\xC5tergenerera koder",
          headerTitle: "S\xE4kerhetskopieringskoder",
          subtitle__regenerate: "F\xE5 en ny upps\xE4ttning s\xE4kra s\xE4kerhetskopieringskoder. Tidigare koder kommer att raderas och kan inte anv\xE4ndas.",
          title__regenerate: "\xC5tergenerera s\xE4kerhetskopieringskoder"
        },
        phoneCode: {
          actionLabel__setDefault: "Ange som standard",
          destructiveActionLabel: "Ta bort telefonnummer"
        },
        primaryButton: "L\xE4gg till tv\xE5stegsverifiering",
        title: "Tv\xE5stegsverifiering",
        totp: {
          destructiveActionTitle: "Ta bort",
          headerTitle: "Autentiseringsapp"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Ta bort",
        menuAction__rename: "Byt namn",
        primaryButton: void 0,
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "St\xE4ll in l\xF6senord",
        primaryButton__updatePassword: "Byt l\xF6senord",
        title: "L\xF6senord"
      },
      phoneNumbersSection: {
        destructiveAction: "Ta bort telefonnummer",
        detailsAction__nonPrimary: "S\xE4tt som prim\xE4r",
        detailsAction__primary: "Fullborda verifiering",
        detailsAction__unverified: "Fullborda verifiering",
        primaryButton: "L\xE4gg till ett telefonnummer",
        title: "Telefonnummer"
      },
      profileSection: {
        primaryButton: "Uppdatera profil",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "S\xE4tt anv\xE4ndarnamn",
        primaryButton__updateUsername: "\xC4ndra anv\xE4ndarnamn",
        title: "Anv\xE4ndarnamn"
      },
      web3WalletsSection: {
        destructiveAction: "Ta bort pl\xE5nbok",
        primaryButton: "Web3 pl\xE5nb\xF6cker",
        title: "Web3 pl\xE5nb\xF6cker"
      }
    },
    usernamePage: {
      successMessage: "Ditt anv\xE4ndarnamn har uppdaterats.",
      title__set: "Uppdatera anv\xE4ndarnamn",
      title__update: "Uppdatera anv\xE4ndarnamn"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} kommer att tas bort fr\xE5n detta konto.",
        messageLine2: "Du kommer inte l\xE4ngre att kunna logga in med denna web3-pl\xE5nbok.",
        successMessage: "{{web3Wallet}} har tagits bort fr\xE5n ditt konto.",
        title: "Ta bort web3-pl\xE5nbok"
      },
      subtitle__availableWallets: "V\xE4lj en web3-pl\xE5nbok att ansluta till ditt konto.",
      subtitle__unavailableWallets: "Det finns inga tillg\xE4ngliga web3-pl\xE5nb\xF6cker.",
      successMessage: "Pl\xE5nboken har lagts till i ditt konto.",
      title: "L\xE4gg till web3-pl\xE5nbok",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/tr-TR.ts
var trTR = {
  locale: "tr-TR",
  backButton: "Geri",
  badge__default: "Varsay\u0131lan",
  badge__otherImpersonatorDevice: "Di\u011Fer taklit eden cihaz",
  badge__primary: "Birincil",
  badge__requiresAction: "Eylem gerekli",
  badge__thisDevice: "Bu cihaz",
  badge__unverified: "Do\u011Frulanmam\u0131\u015F",
  badge__userDevice: "Kullan\u0131c\u0131 cihaz\u0131",
  badge__you: "Siz",
  createOrganization: {
    formButtonSubmit: "Olu\u015Ftur",
    invitePage: {
      formButtonReset: "Atla"
    },
    title: "Organizasyon olu\u015Ftur"
  },
  dates: {
    lastDay: "D\xFCn saat {{ date | timeString('tr-TR') }}",
    next6Days: "{{ date | weekday('tr-TR','long') }} saat {{ date | timeString('tr-TR') }}",
    nextDay: "Yar\u0131n saat {{ date | timeString('tr-TR') }}",
    numeric: "{{ date | numeric('tr-TR') }}",
    previous6Days: "Ge\xE7en hafta {{ date | weekday('tr-TR','long') }} saat {{ date | timeString('tr-TR') }}",
    sameDay: "Bug\xFCn saat {{ date | timeString('tr-TR') }}"
  },
  dividerText: "veya",
  footerActionLink__useAnotherMethod: "Ba\u015Fka bir y\xF6ntem kullan",
  footerPageLink__help: "Yard\u0131m",
  footerPageLink__privacy: "Gizlilik",
  footerPageLink__terms: "\u015Eartlar",
  formButtonPrimary: "\u0130leri",
  formButtonPrimary__verify: "Do\u011Frula",
  formFieldAction__forgotPassword: "\u015Eifremi unuttum",
  formFieldError__matchingPasswords: "\u015Eifreler e\u015Fle\u015Fmeli.",
  formFieldError__notMatchingPasswords: "\u015Eifreler e\u015Fle\u015Fmiyor.",
  formFieldError__verificationLinkExpired: "Do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131n s\xFCresi doldu. L\xFCtfen yeni bir ba\u011Flant\u0131 isteyin.",
  formFieldHintText__optional: "\u0130ste\u011Fe ba\u011Fl\u0131",
  formFieldHintText__slug: "Slug, okunabilir bir ID'dir ve benzersiz olmal\u0131d\u0131r. Genellikle URL'lerde kullan\u0131l\u0131r.",
  formFieldInputPlaceholder__backupCode: "Yedek kodu girin",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Hesab\u0131 sil",
  formFieldInputPlaceholder__emailAddress: "email@example.com",
  formFieldInputPlaceholder__emailAddress_username: "email veya kullan\u0131c\u0131 ad\u0131",
  formFieldInputPlaceholder__emailAddresses: "ornek@email.com, ornek2@email.com",
  formFieldInputPlaceholder__firstName: "Ad\u0131n\u0131z\u0131 girin",
  formFieldInputPlaceholder__lastName: "Soyad\u0131n\u0131z\u0131 girin",
  formFieldInputPlaceholder__organizationDomain: "Kurulu\u015F alan ad\u0131n\u0131 girin",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Kurulu\u015F e-posta adresini girin",
  formFieldInputPlaceholder__organizationName: "Kurulu\u015F ad\u0131n\u0131 girin",
  formFieldInputPlaceholder__organizationSlug: "kurulus-adi",
  formFieldInputPlaceholder__password: "\u015Eifrenizi girin",
  formFieldInputPlaceholder__phoneNumber: "Telefon numaran\u0131z\u0131 girin",
  formFieldInputPlaceholder__username: "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
  formFieldLabel__automaticInvitations: "Bu alan ad\u0131 i\xE7in otomatik davetleri etkinle\u015Ftir",
  formFieldLabel__backupCode: "Yedekleme kodu",
  formFieldLabel__confirmDeletion: "Onayla",
  formFieldLabel__confirmPassword: "\u015Eifreyi onayla",
  formFieldLabel__currentPassword: "Mevcut \u015Fifre",
  formFieldLabel__emailAddress: "E-posta adresi",
  formFieldLabel__emailAddress_username: "E-posta adresi veya kullan\u0131c\u0131 ad\u0131",
  formFieldLabel__emailAddresses: "E-posta adresleri",
  formFieldLabel__firstName: "Ad",
  formFieldLabel__lastName: "Soyad",
  formFieldLabel__newPassword: "Yeni \u015Fifre",
  formFieldLabel__organizationDomain: "Alan ad\u0131",
  formFieldLabel__organizationDomainDeletePending: "Bekleyen davetiyeleri ve \xF6nerileri sil",
  formFieldLabel__organizationDomainEmailAddress: "Do\u011Frulama e-posta adresi",
  formFieldLabel__organizationDomainEmailAddressDescription: "Bu alan ad\u0131 i\xE7in bir e-posta adresi girin, do\u011Frulama kodunu al\u0131n ve alan ad\u0131n\u0131 do\u011Frulay\u0131n.",
  formFieldLabel__organizationName: "Organizasyon ad\u0131",
  formFieldLabel__organizationSlug: "Organizasyon ba\u011Flant\u0131 metni",
  formFieldLabel__passkeyName: "Ge\xE7i\u015F anahtar\u0131n\u0131n ad\u0131",
  formFieldLabel__password: "\u015Eifre",
  formFieldLabel__phoneNumber: "Telefon numaras\u0131",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Di\u011Fer cihazlardaki oturumlardan \xE7\u0131k",
  formFieldLabel__username: "Kullan\u0131c\u0131 ad\u0131",
  impersonationFab: {
    action__signOut: "\xC7\u0131k\u0131\u015F yap",
    title: "{{identifier}} olarak giri\u015F yap\u0131ld\u0131"
  },
  maintenanceMode: "\u015Eu anda bak\u0131mday\u0131z, ancak endi\u015Felenmeyin, k\u0131sa bir s\xFCre i\xE7inde tamamlanacakt\u0131r.",
  membershipRole__admin: "Y\xF6netici",
  membershipRole__basicMember: "\xDCye",
  membershipRole__guestMember: "Misafir",
  organizationList: {
    action__createOrganization: "Organizasyon olu\u015Ftur",
    action__invitationAccept: "Kat\u0131l",
    action__suggestionsAccept: "Kat\u0131lmak i\xE7in talepte bulun",
    createOrganization: "Organizasyon Olu\u015Ftur",
    invitationAcceptedLabel: "Kat\u0131l\u0131m ba\u015Far\u0131l\u0131",
    subtitle: "{{applicationName}} ile devam edin",
    suggestionsAcceptedLabel: "Onay bekleniyor",
    title: "Bir hesap se\xE7in",
    titleWithoutPersonal: "Bir organizasyon se\xE7in"
  },
  organizationProfile: {
    badge__automaticInvitation: "Otomatik davetler",
    badge__automaticSuggestion: "Otomatik \xF6neriler",
    badge__manualInvitation: "Davetler",
    badge__unverified: "Do\u011Frulanmam\u0131\u015F",
    createDomainPage: {
      subtitle: "Alan ad\u0131n\u0131 ekleyerek do\u011Frulama yap\u0131n. Bu alana sahip e-posta adresleri ile kaydolan kullan\u0131c\u0131lar organizasyona otomatik olarak kat\u0131labilir veya kat\u0131lma talebi g\xF6nderebilir.",
      title: "Alan ad\u0131 ekle"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Davetiyeler g\xF6nderilemedi. A\u015Fa\u011F\u0131daki e-posta adresleri i\xE7in zaten bekleyen davetler var: {{email_addresses}}.",
      formButtonPrimary__continue: "Davetiye g\xF6nder",
      selectDropdown__role: "Rol se\xE7in",
      subtitle: "Bo\u015Fluk veya virg\xFClle ay\u0131rarak bir veya daha fazla e-posta adresi girin veya yap\u0131\u015Ft\u0131r\u0131n.",
      successMessage: "Davetler ba\u015Far\u0131yla g\xF6nderildi",
      title: "Yeni \xFCyeler davet edin"
    },
    membersPage: {
      action__invite: "Davet et",
      action__search: "Ara",
      activeMembersTab: {
        menuAction__remove: "\xDCyeyi kald\u0131r",
        tableHeader__actions: "\u0130\u015Flemler",
        tableHeader__joined: "Kat\u0131lma tarihi",
        tableHeader__role: "Rol",
        tableHeader__user: "Kullan\u0131c\u0131"
      },
      detailsTitle__emptyRow: "G\xF6r\xFCnt\xFClenecek \xFCye yok",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Organizasyonunuzla ili\u015Fkili bir alan ad\u0131 uzant\u0131s\u0131na sahip e-posta adresini girerek kullan\u0131c\u0131lar\u0131 otomatik olarak davet edin. Bu alana sahip e-posta ile kaydolan herkes, istedi\u011Fi zaman organizasyona kat\u0131labilir.",
          headerTitle: "Otomatik davetler",
          primaryButton: "Do\u011Frulanm\u0131\u015F alan adlar\u0131n\u0131 y\xF6net"
        },
        table__emptyRow: "G\xF6sterilecek davetiye yok"
      },
      invitedMembersTab: {
        menuAction__revoke: "Daveti iptal et",
        tableHeader__invited: "Davet Edilenler"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "E\u015Fle\u015Fen alan ad\u0131 uzant\u0131s\u0131na sahip e-posta ile kaydolan kullan\u0131c\u0131lar, kat\u0131lma talebi g\xF6nderebilmek i\xE7in otomatik \xF6neri alacaklar.",
          headerTitle: "Otomatik \xF6neriler",
          primaryButton: "Do\u011Frulanm\u0131\u015F alan adlar\u0131n\u0131 y\xF6net"
        },
        menuAction__approve: "Onayla",
        menuAction__reject: "Reddet",
        tableHeader__requested: "Kat\u0131lma iste\u011Fi",
        table__emptyRow: "G\xF6r\xFCnt\xFClenecek herhangi bir istek yok"
      },
      start: {
        headerTitle__invitations: "Davetler",
        headerTitle__members: "\xDCyeler",
        headerTitle__requests: "\u0130stekler"
      }
    },
    navbar: {
      description: "Organizasyonunuzu y\xF6netin.",
      general: "Genel",
      members: "\xDCyeler",
      title: "Organizasyon"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "Devam etmek i\xE7in a\u015Fa\u011F\u0131ya \u201C{{organizationName}}\u201D yaz\u0131n.",
          messageLine1: "Bu organizasyonu silmek istedi\u011Finizden emin misiniz?",
          messageLine2: "Bu i\u015Flem kal\u0131c\u0131d\u0131r ve geri al\u0131namaz.",
          successMessage: "Organizasyonu sildiniz.",
          title: "Organizasyonu sil"
        },
        leaveOrganization: {
          actionDescription: "Devam etmek i\xE7in a\u015Fa\u011F\u0131ya \u201C{{organizationName}}\u201D yaz\u0131n.",
          messageLine1: "Bu organizasyondan ayr\u0131lmak istedi\u011Finizden emin misiniz? Bu organizasyona ve uygulamalar\u0131na eri\u015Fiminizi kaybedeceksiniz.",
          messageLine2: "Bu i\u015Flem kal\u0131c\u0131d\u0131r ve geri al\u0131namaz.",
          successMessage: "Organizasyondan ayr\u0131ld\u0131n\u0131z.",
          title: "Organizasyondan ayr\u0131l"
        },
        title: "Tehlike"
      },
      domainSection: {
        menuAction__manage: "Y\xF6net",
        menuAction__remove: "Sil",
        menuAction__verify: "Do\u011Frula",
        primaryButton: "Alan ad\u0131 ekle",
        subtitle: "Kullan\u0131c\u0131lar\u0131n organizasyona otomatik olarak kat\u0131lmas\u0131na veya do\u011Frulanm\u0131\u015F bir alan ad\u0131 uzant\u0131l\u0131 e-posta ile kat\u0131lma iste\u011Finde bulunmas\u0131na izin verin.",
        title: "Do\u011Frulanm\u0131\u015F alan adlar\u0131"
      },
      successMessage: "Organizasyon g\xFCncellendi.",
      title: "Organizasyon profili"
    },
    removeDomainPage: {
      messageLine1: "{{domain}} Alan ad\u0131 kald\u0131r\u0131lacakt\u0131r.",
      messageLine2: "Kullan\u0131c\u0131lar bundan sonra organizasyona otomatik olarak kat\u0131lamayacaklar.",
      successMessage: "{{domain}} kald\u0131r\u0131ld\u0131.",
      title: "Alan ad\u0131n\u0131 kald\u0131r"
    },
    start: {
      headerTitle__general: "Genel",
      headerTitle__members: "\xDCyeler",
      profileSection: {
        primaryButton: "G\xFCncelle",
        title: "Organizasyon Profili",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Bu alan ad\u0131n\u0131 kald\u0131rmak, davet edilmi\u015F kullan\u0131c\u0131lar\u0131 etkileyecektir.",
        removeDomainActionLabel__remove: "Alan ad\u0131n\u0131 kald\u0131r",
        removeDomainSubtitle: "Bu alan ad\u0131n\u0131 do\u011Frulanm\u0131\u015F alan adlar\u0131n\u0131zdan kald\u0131r\u0131n",
        removeDomainTitle: "Alan ad\u0131n\u0131 kald\u0131r"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Kullan\u0131c\u0131lar, kay\u0131t olduklar\u0131nda otomatik olarak organizasyona davet edilir ve istedikleri zaman kat\u0131labilirler.",
        automaticInvitationOption__label: "Otomatik davetler",
        automaticSuggestionOption__description: "Kullan\u0131c\u0131lar, kat\u0131lma talebinde bulunmak i\xE7in otomatik \xF6neri al\u0131rlar; ancak organizasyona kat\u0131labilmeleri i\xE7in bir y\xF6netici onay\u0131 gereklidir.",
        automaticSuggestionOption__label: "Otomatik \xF6neriler",
        calloutInfoLabel: "Kay\u0131t t\xFCr\xFCn\xFCn de\u011Fi\u015Ftirilmesi yaln\u0131zca yeni kullan\u0131c\u0131lar\u0131 etkileyecektir.",
        calloutInvitationCountLabel: "Kullan\u0131c\u0131lara g\xF6nderilen ve bekleyen davetler: {{count}}",
        calloutSuggestionCountLabel: "Kullan\u0131c\u0131lara g\xF6nderilen ve bekleyen \xF6neriler: {{count}}",
        manualInvitationOption__description: "Kullan\u0131c\u0131lar organizasyona sadece manuel olarak davet edilebilir.",
        manualInvitationOption__label: "Manuel davet",
        subtitle: "Bu alan ad\u0131 alt\u0131ndaki kullan\u0131c\u0131lar\u0131n organizasyona nas\u0131l kat\u0131lacaklar\u0131n\u0131 se\xE7in."
      },
      start: {
        headerTitle__danger: "Tehlike",
        headerTitle__enrollment: "Kay\u0131t se\xE7enekleri"
      },
      subtitle: "Alan ad\u0131 {{domain}} \u015Fimdi do\u011Fruland\u0131. Devam etmek i\xE7in kay\u0131t modunu se\xE7in.",
      title: "{{domain}} adl\u0131 alan ad\u0131n\u0131 g\xFCncelle"
    },
    verifyDomainPage: {
      formSubtitle: "E-posta adresinize g\xF6nderilen do\u011Frulama kodunu girin",
      formTitle: "Do\u011Frulama kodu",
      resendButton: "Kod almad\u0131n\u0131z m\u0131? Tekrar g\xF6nderin",
      subtitle: "{{domainName}} Alan ad\u0131n\u0131n e-posta ile do\u011Frulanmas\u0131 gerekiyor.",
      subtitleVerificationCodeScreen: "{{emailAddress}} adresine bir do\u011Frulama kodu g\xF6nderildi. Devam etmek i\xE7in kodu giriniz.",
      title: "Alan ad\u0131n\u0131 do\u011Frula"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Organizasyon olu\u015Ftur",
    action__invitationAccept: "Kat\u0131l",
    action__manageOrganization: "Organizasyonu y\xF6net",
    action__suggestionsAccept: "Kat\u0131lmak i\xE7in talepte bulun",
    notSelected: "Organizasyon se\xE7ilmedi",
    personalWorkspace: "Ki\u015Fisel \xC7al\u0131\u015Fma Alan\u0131",
    suggestionsAcceptedLabel: "Onay bekleniyor"
  },
  paginationButton__next: "\u0130leri",
  paginationButton__previous: "Geri",
  paginationRowText__displaying: "Sayfa bilgisi:",
  paginationRowText__of: "-",
  reverification: {
    alternativeMethods: {
      actionLink: "Yard\u0131m almak i\xE7in buraya t\u0131klay\u0131n",
      actionText: "Alternatif do\u011Frulama y\xF6ntemlerini kullanmak ister misiniz?",
      blockButton__backupCode: "Yedek kodu kullan",
      blockButton__emailCode: "E-posta kodu g\xF6nder",
      blockButton__password: "\u015Eifreyi gir",
      blockButton__phoneCode: "Telefon kodu g\xF6nder",
      blockButton__totp: "TOTP kodu kullan",
      getHelp: {
        blockButton__emailSupport: "E-posta ile destek al\u0131n",
        content: "Hala yard\u0131ma ihtiyac\u0131n\u0131z varsa, destek ekibimizle ileti\u015Fime ge\xE7in.",
        title: "Yard\u0131m Al"
      },
      subtitle: "Do\u011Frulama i\u015Flemi i\xE7in alternatif y\xF6ntemler.",
      title: "Alternatif Do\u011Frulama Y\xF6ntemleri"
    },
    backupCodeMfa: {
      subtitle: "Yedek kodu girerek do\u011Frulaman\u0131z\u0131 tamamlayabilirsiniz.",
      title: "Yedek Kod ile Do\u011Frulama"
    },
    emailCode: {
      formTitle: "E-posta ile Do\u011Frulama",
      resendButton: "Tekrar g\xF6nder",
      subtitle: "E-posta adresinize g\xF6nderilen do\u011Frulama kodunu girin.",
      title: "E-posta Kodunu Girin"
    },
    noAvailableMethods: {
      message: "Alternatif do\u011Frulama y\xF6ntemleri mevcut de\u011Fil.",
      subtitle: "L\xFCtfen farkl\u0131 bir do\u011Frulama y\xF6ntemi deneyin.",
      title: "Do\u011Frulama Y\xF6ntemleri Yok"
    },
    password: {
      actionLink: "\u015Eifremi unuttum",
      subtitle: "\u015Eifrenizi girerek devam edebilirsiniz.",
      title: "\u015Eifre ile Giri\u015F Yap\u0131n"
    },
    phoneCode: {
      formTitle: "Telefon Kodu ile Do\u011Frulama",
      resendButton: "Telefon kodunu tekrar g\xF6nder",
      subtitle: "Telefonunuza g\xF6nderilen do\u011Frulama kodunu girin.",
      title: "Telefon Kodu Girin"
    },
    phoneCodeMfa: {
      formTitle: "Telefon Koduyla MFA Do\u011Frulamas\u0131",
      resendButton: "Telefon kodunu tekrar g\xF6nder",
      subtitle: "Telefonunuza g\xF6nderilen do\u011Frulama kodunu girin.",
      title: "Telefon Koduyla Do\u011Frulama"
    },
    totpMfa: {
      formTitle: "TOTP ile MFA Do\u011Frulamas\u0131",
      subtitle: "Mobil uygulaman\u0131zdan TOTP kodunu girin.",
      title: "TOTP Kodunu Girin"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Hesap ekle",
      action__signOutAll: "Mevcut t\xFCm oturumlar\u0131 kapat\u0131n",
      subtitle: "Devam etmek istedi\u011Finiz hesab\u0131 se\xE7in.",
      title: "Bir hesap se\xE7iniz"
    },
    alternativeMethods: {
      actionLink: "Yard\u0131m al",
      actionText: "Bunlardan hi\xE7biri yok mu?",
      blockButton__backupCode: "Yedekleme kodu kullan",
      blockButton__emailCode: "{{identifier}} adresine do\u011Frulama kodu g\xF6nder",
      blockButton__emailLink: "{{identifier}} adresine do\u011Frulama ba\u011Flant\u0131s\u0131 g\xF6nder",
      blockButton__passkey: "Ge\xE7i\u015F anahtar\u0131n\u0131zla oturum a\xE7\u0131n",
      blockButton__password: "\u015Eifreyle giri\u015F yap",
      blockButton__phoneCode: "{{identifier}} numaras\u0131na do\u011Frulama kodu g\xF6nder",
      blockButton__totp: "Authenticator uygulamas\u0131 kullan",
      getHelp: {
        blockButton__emailSupport: "E-posta deste\u011Fi",
        content: "E\u011Fer hesab\u0131n\u0131za giri\u015F yapmakta zorluk ya\u015F\u0131yorsan\u0131z, hesab\u0131n\u0131za eri\u015Fiminizi sa\u011Flayabilmemiz i\xE7in bize bir e-posta g\xF6nderin ve size yard\u0131mc\u0131 olal\u0131m.",
        title: "Yard\u0131m al"
      },
      subtitle: "Sorunlarla m\u0131 kar\u015F\u0131la\u015F\u0131yorsunuz? Oturum a\xE7mak i\xE7in bu y\xF6ntemlerden birini deneyebilirsiniz.",
      title: "Farkl\u0131 bir y\xF6ntem kullan"
    },
    backupCodeMfa: {
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "Yedekleme kodu giri\u015Fi"
    },
    emailCode: {
      formTitle: "Do\u011Frulama kodu",
      resendButton: "Kodu tekrar g\xF6nder",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "E-posta kutunuzu kontrol edin"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Devam etmek i\xE7in, oturum a\xE7ma i\u015Flemini ba\u015Flatt\u0131\u011F\u0131n\u0131z cihaz ve taray\u0131c\u0131daki do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131 a\xE7\u0131n",
        title: "Do\u011Frulama ba\u011Flant\u0131s\u0131 bu cihaz i\xE7in ge\xE7ersiz"
      },
      expired: {
        subtitle: "Devam etmek i\xE7in en ba\u015Ftaki sekmeye d\xF6n\xFCn",
        title: "Bu do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131n s\xFCresi dolmu\u015F"
      },
      failed: {
        subtitle: "Devam etmek i\xE7in en ba\u015Ftaki sekmeye d\xF6n\xFCn",
        title: "Bu do\u011Frulama ba\u011Flant\u0131s\u0131 ge\xE7ersiz"
      },
      formSubtitle: "E-posta adresinize g\xF6nderdi\u011Fimiz do\u011Frulama ba\u011Flant\u0131s\u0131na t\u0131klay\u0131n",
      formTitle: "Do\u011Frulama ba\u011Flant\u0131s\u0131",
      loading: {
        subtitle: "Birazdan yeniden y\xF6nlendirileceksiniz",
        title: "Giri\u015F yap\u0131l\u0131yor..."
      },
      resendButton: "Tekrar g\xF6nder",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "E-posta kutunuzu kontrol edin",
      unusedTab: {
        title: "Bu sekmeyi kapatabilirsiniz"
      },
      verified: {
        subtitle: "Birazdan yeniden y\xF6nlendirileceksiniz",
        title: "Ba\u015Far\u0131yla giri\u015F yap\u0131ld\u0131"
      },
      verifiedSwitchTab: {
        subtitle: "Devam etmek i\xE7in en ba\u015Ftaki sekmeye d\xF6n\xFCn",
        subtitleNewTab: "Devam etmek i\xE7in yeni a\xE7\u0131lm\u0131\u015F sekmeye d\xF6n\xFCn",
        titleNewTab: "Farkl\u0131 bir sekmede giri\u015F yap\u0131ld\u0131"
      }
    },
    forgotPassword: {
      formTitle: "\u015Eifre s\u0131f\u0131rlama kodu",
      resendButton: "Tekrar g\xF6nder",
      subtitle: "\u015Eifrenizi s\u0131f\u0131rlamak i\xE7in",
      subtitle_email: "\u0130lk olarak, e-posta kimli\u011Finize g\xF6nderilen kodu girin",
      subtitle_phone: "\u0130lk olarak, telefonunuza g\xF6nderilen kodu girin",
      title: "\u015Eifreyi s\u0131f\u0131rla"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u015Eifremi s\u0131f\u0131rla",
      label__alternativeMethods: "Veya ba\u015Fka bir y\xF6ntem kullan\u0131n:",
      title: "\u015Eifremi unuttum"
    },
    noAvailableMethods: {
      message: "Hesab\u0131n\u0131zda giri\u015F yapmak i\xE7in kullanabilece\u011Finiz bir y\xF6ntem bulunmuyor.",
      subtitle: "Bir hata olu\u015Ftu",
      title: "Giri\u015F yap\u0131lam\u0131yor"
    },
    passkey: {
      subtitle: "Ge\xE7i\u015F anahtar\u0131n\u0131z\u0131 kullanarak siz oldu\u011Funuzu onaylay\u0131n. Cihaz\u0131n\u0131z parmak izinizi, y\xFCz\xFCn\xFCz\xFC veya ekran kilidinizi isteyebilir.",
      title: "Ge\xE7i\u015F anahtar\u0131n\u0131z\u0131 kullan\u0131n"
    },
    password: {
      actionLink: "Ba\u015Fka bir y\xF6ntem kullan",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "\u015Eifrenizi girin"
    },
    passwordPwned: {
      title: "\u015Eifre ele ge\xE7irildi"
    },
    phoneCode: {
      formTitle: "Do\u011Frulama kodu",
      resendButton: "Kod almad\u0131n\u0131z m\u0131? Tekrar g\xF6nderin",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "Telefonuza g\xF6nderilen kodu girin"
    },
    phoneCodeMfa: {
      formTitle: "Do\u011Frulama kodu",
      resendButton: "Kod almad\u0131n\u0131z m\u0131? Tekrar g\xF6nderin",
      subtitle: "Devam etmek i\xE7in l\xFCtfen telefonunuza g\xF6nderilen do\u011Frulama kodunu girin",
      title: "Telefonuza g\xF6nderilen kodu girin"
    },
    resetPassword: {
      formButtonPrimary: "\u015Eifremi s\u0131f\u0131rla",
      requiredMessage: "G\xFCvenlik nedeniyle \u015Fifrenizi s\u0131f\u0131rlaman\u0131z gerekmektedir.",
      successMessage: "\u015Eifreniz ba\u015Far\u0131yla de\u011Fi\u015Ftirildi. Oturumunuz a\xE7\u0131l\u0131yor, l\xFCtfen biraz bekleyin.",
      title: "\u015Eifre s\u0131f\u0131rlama"
    },
    resetPasswordMfa: {
      detailsLabel: "\u015Eifrenizi s\u0131f\u0131rlamadan \xF6nce kimli\u011Finizi do\u011Frulamam\u0131z gerekiyor."
    },
    start: {
      actionLink: "Kay\u0131t ol",
      actionLink__join_waitlist: "Bekleme listesine kat\u0131l",
      actionLink__use_email: "E-posta kullan",
      actionLink__use_email_username: "E-posta veya kullan\u0131c\u0131 ad\u0131 kullan",
      actionLink__use_passkey: "Bunun yerine ge\xE7i\u015F anahtar\u0131n\u0131 kullan\u0131n",
      actionLink__use_phone: "Telefon kullan",
      actionLink__use_username: "Kullan\u0131c\u0131 ad\u0131 kullan",
      actionText: "Hesab\u0131n\u0131z yok mu?",
      actionText__join_waitlist: "Bekleme listesine kat\u0131l\u0131n",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      subtitleCombined: void 0,
      title: "Giri\u015F yap",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Do\u011Frulama kodu",
      subtitle: "Devam etmek i\xE7in l\xFCtfen kimlik do\u011Frulay\u0131c\u0131 uygulaman\u0131z taraf\u0131ndan olu\u015Fturulan do\u011Frulama kodunu girin",
      title: "\u0130ki a\u015Famal\u0131 do\u011Frulama"
    }
  },
  signInEnterPasswordTitle: "\u015Eifrenizi girin",
  signUp: {
    continue: {
      actionLink: "Giri\u015F yap",
      actionText: "Hesab\u0131n\u0131z var m\u0131?",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "Eksik bilgileri tamamlay\u0131n"
    },
    emailCode: {
      formSubtitle: "E-posta adresinize g\xF6nderdi\u011Fimiz do\u011Frulama kodunu giriniz",
      formTitle: "Do\u011Frulama kodu",
      resendButton: "Kodu tekrar g\xF6nder",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "E-posta adresinizi do\u011Frulay\u0131n"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Devam etmek i\xE7in, kay\u0131t i\u015Flemini ba\u015Flatt\u0131\u011F\u0131n\u0131z cihazda ve taray\u0131c\u0131da do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131 a\xE7\u0131n",
        title: "Do\u011Frulama ba\u011Flant\u0131s\u0131 bu cihaz i\xE7in ge\xE7ersiz"
      },
      formSubtitle: "E-posta adresinize g\xF6nderdi\u011Fimiz do\u011Frulama ba\u011Flant\u0131s\u0131na t\u0131klay\u0131n",
      formTitle: "Do\u011Frulama ba\u011Flant\u0131s\u0131",
      loading: {
        title: "Giri\u015F yap\u0131l\u0131yor..."
      },
      resendButton: "Ba\u011Flant\u0131 almad\u0131n\u0131z m\u0131? Tekrar g\xF6nder",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "E-posta adresinizi do\u011Frulay\u0131n",
      verified: {
        title: "Ba\u015Far\u0131yla do\u011Fruland\u0131"
      },
      verifiedSwitchTab: {
        subtitle: "Devam etmek i\xE7in yeni a\xE7\u0131lm\u0131\u015F sekmeye d\xF6n\xFCn",
        subtitleNewTab: "Devam etmek i\xE7in \xF6nceki sekmeye d\xF6n\xFCn",
        title: "E-posta adresiniz ba\u015Far\u0131yla do\u011Fruland\u0131"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "Gizlilik Politikas\u0131'n\u0131 kabul ediyorum",
        label__onlyTermsOfService: "Hizmet \u015Eartlar\u0131'n\u0131 kabul ediyorum",
        label__termsOfServiceAndPrivacyPolicy: "Hizmet \u015Eartlar\u0131 ve Gizlilik Politikas\u0131'n\u0131 kabul ediyorum"
      },
      continue: {
        subtitle: "Devam etmek i\xE7in l\xFCtfen gerekli ad\u0131mlar\u0131 takip edin.",
        title: "Devam Et"
      }
    },
    phoneCode: {
      formSubtitle: "Telefon numaran\u0131za g\xF6nderdi\u011Fimiz do\u011Frulama kodunu giriniz",
      formTitle: "Do\u011Frulama kodu",
      resendButton: "Kodu tekrar g\xF6nder",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      title: "Telefon numaran\u0131z\u0131 do\u011Frulay\u0131n"
    },
    restrictedAccess: {
      actionLink: "Yard\u0131m almak i\xE7in destekle ileti\u015Fime ge\xE7in",
      actionText: "Eri\u015Fiminiz k\u0131s\u0131tland\u0131 m\u0131?",
      blockButton__emailSupport: "E-posta ile destek al",
      blockButton__joinWaitlist: "Bekleme listesine kat\u0131l",
      subtitle: "Eri\u015Fim k\u0131s\u0131tlamas\u0131 nedeniyle bu sayfaya eri\u015Fim sa\u011Flanam\u0131yor.",
      subtitleWaitlist: "Eri\u015Fim i\xE7in bekleme listesine kayd\u0131n\u0131z al\u0131nd\u0131.",
      title: "K\u0131s\u0131tl\u0131 Eri\u015Fim"
    },
    start: {
      actionLink: "Giri\u015F yap",
      actionLink__use_email: "Bunun yerine e-posta kullan\u0131n",
      actionLink__use_phone: "Bunun yerine telefon kullan\u0131n",
      actionText: "Hesab\u0131n\u0131z var m\u0131?",
      subtitle: "{{applicationName}} ile devam etmek i\xE7in",
      subtitleCombined: "{{applicationName}} ile devam etmek i\xE7in",
      title: "Hesap olu\u015Ftur",
      titleCombined: "Hesap olu\u015Ftur"
    }
  },
  socialButtonsBlockButton: "{{provider|titleize}} ile giri\u015F yap\u0131n",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "Bu organizasyonda zaten \xFCyesiniz.",
    captcha_invalid: "G\xFCvenlik do\u011Frulamalar\u0131ndaki hatalar nedeniyle kay\u0131t yap\u0131lamad\u0131. L\xFCtfen tekrar denemek i\xE7in sayfay\u0131 yenileyin veya daha fazla yard\u0131m i\xE7in destek ekibi ile ileti\u015Fime ge\xE7in.",
    captcha_unavailable: "Bot do\u011Frulamas\u0131 ba\u015Far\u0131s\u0131z oldu\u011Fu i\xE7in kay\u0131t yap\u0131lamad\u0131. L\xFCtfen tekrar denemek i\xE7in sayfay\u0131 yenileyin veya daha fazla yard\u0131m i\xE7in destek ekibi ile ileti\u015Fime ge\xE7in.",
    form_code_incorrect: "Hatal\u0131 kod.",
    form_identifier_exists__email_address: "Bu e-posta adresi zaten kullan\u0131l\u0131yor.",
    form_identifier_exists__phone_number: "Bu telefon numaras\u0131 zaten kullan\u0131l\u0131yor.",
    form_identifier_exists__username: "Bu kullan\u0131c\u0131 ad\u0131 zaten kullan\u0131l\u0131yor.",
    form_identifier_not_found: "Tan\u0131mlay\u0131c\u0131 bulunamad\u0131.",
    form_param_format_invalid: "Parametre format\u0131 ge\xE7ersiz.",
    form_param_format_invalid__email_address: "E-posta adresi ge\xE7erli olmal\u0131d\u0131r.",
    form_param_format_invalid__phone_number: "Telefon numaras\u0131 ge\xE7erli olmal\u0131d\u0131r.",
    form_param_max_length_exceeded__first_name: "Ad 256 karakteri a\u015Fmamal\u0131d\u0131r.",
    form_param_max_length_exceeded__last_name: "Soyad 256 karakteri a\u015Fmamal\u0131d\u0131r.",
    form_param_max_length_exceeded__name: "\u0130sim 256 karakteri a\u015Fmamal\u0131d\u0131r.",
    form_param_nil: "Parametre bo\u015F olamaz.",
    form_param_value_invalid: "Parametre de\u011Feri ge\xE7ersiz.",
    form_password_incorrect: "\u015Eifre yanl\u0131\u015F.",
    form_password_length_too_short: "\u015Eifre \xE7ok k\u0131sa.",
    form_password_not_strong_enough: "\u015Eifreniz yeterince g\xFC\xE7l\xFC de\u011Fil.",
    form_password_pwned: "Bu \u015Fifre bir veri ihlalinde tespit edildi ve kullan\u0131lamaz. L\xFCtfen ba\u015Fka bir \u015Fifre deneyin.",
    form_password_pwned__sign_in: "Bu \u015Fifre bir veri ihlalinde tespit edildi ve oturum a\xE7mak i\xE7in kullan\u0131lamaz. L\xFCtfen ba\u015Fka bir \u015Fifre se\xE7in.",
    form_password_size_in_bytes_exceeded: "\u015Eifreniz izin verilen maksimum byte say\u0131s\u0131n\u0131 a\u015Ft\u0131, l\xFCtfen k\u0131salt\u0131n veya baz\u0131 \xF6zel karakterleri \xE7\u0131kar\u0131n.",
    form_password_validation_failed: "\u015Eifre do\u011Frulamas\u0131 ba\u015Far\u0131s\u0131z.",
    form_username_invalid_character: "Kullan\u0131c\u0131 ad\u0131 ge\xE7ersiz karakterler i\xE7eriyor.",
    form_username_invalid_length: "Kullan\u0131c\u0131 ad\u0131 3 ile 50 karakter aras\u0131nda olmal\u0131d\u0131r.",
    identification_deletion_failed: "Son kimli\u011Finizi silemezsiniz.",
    not_allowed_access: "Eri\u015Fime izin verilmiyor.",
    organization_domain_blocked: "Organizasyon alan ad\u0131 engellendi.",
    organization_domain_common: "Organizasyon alan ad\u0131 \xE7ok yayg\u0131n.",
    organization_domain_exists_for_enterprise_connection: "Kurumsal ba\u011Flant\u0131 i\xE7in bu alan ad\u0131 zaten mevcut.",
    organization_membership_quota_exceeded: "Organizasyon \xFCye kotas\u0131 a\u015F\u0131ld\u0131.",
    organization_minimum_permissions_needed: "Bu i\u015Flemi ger\xE7ekle\u015Ftirmek i\xE7in gerekli asgari izinlere sahip olmal\u0131s\u0131n\u0131z.",
    passkey_already_exists: "Bu hesaba zaten bir ge\xE7i\u015F anahtar\u0131 ba\u011Fl\u0131.",
    passkey_not_supported: "Ge\xE7i\u015F anahtarlar\u0131 \u015Fu anda desteklenmiyor.",
    passkey_pa_not_supported: "Bu platform i\xE7in ge\xE7i\u015F anahtarlar\u0131 desteklenmiyor.",
    passkey_registration_cancelled: "Ge\xE7i\u015F anahtar\u0131 kayd\u0131 iptal edildi.",
    passkey_retrieval_cancelled: "Ge\xE7i\u015F anahtar\u0131n\u0131 geri y\xFCkleme i\u015Flemi iptal edildi.",
    passwordComplexity: {
      maximumLength: "En fazla {{length}} karakter olmal\u0131",
      minimumLength: "En az {{length}} karakter olmal\u0131",
      requireLowercase: "bir k\xFC\xE7\xFCk harf i\xE7ermeli",
      requireNumbers: "bir say\u0131 i\xE7ermeli",
      requireSpecialCharacter: "bir \xF6zel karakter i\xE7ermeli",
      requireUppercase: "bir b\xFCy\xFCk harf i\xE7ermeli",
      sentencePrefix: "\u015Eifreniz;"
    },
    phone_number_exists: "Bu telefon numaras\u0131 zaten kullan\u0131l\u0131yor. L\xFCtfen ba\u015Fka bir numara deneyin.",
    web3_missing_identifier: "Web3 i\xE7in tan\u0131mlay\u0131c\u0131 eksik.",
    zxcvbn: {
      couldBeStronger: "\u015Eifreniz kriterleri kar\u015F\u0131l\u0131yor; fakat birka\xE7 karakter daha ekleyerek daha g\xFC\xE7l\xFC bir \u015Fifre olu\u015Fturabilirsiniz.",
      goodPassword: "Harika! Parolan\u0131z gerekli t\xFCm gereksinimleri kar\u015F\u0131l\u0131yor.",
      notEnough: "\u015Eifreniz yeterince g\xFC\xE7l\xFC de\u011Fil.",
      suggestions: {
        allUppercase: "T\xFCm harfleri b\xFCy\xFCk yazmak yerine rastgele b\xFCy\xFCk harfler kullan\u0131n.",
        anotherWord: "\u015Eifreniz daha az bilinen kelimeler i\xE7ermeli.",
        associatedYears: "Kendinizle alakas\u0131 olan y\u0131llar\u0131 kullanmay\u0131n.",
        capitalization: "Sadece ilk harfi b\xFCy\xFCk yazmak yerine rastgele b\xFCy\xFCk harfler kullan\u0131n.",
        dates: "Kendinizle alakas\u0131 olan tarihleri kullanmay\u0131n.",
        l33t: '"a" yerine "@" kullanmak gibi tahmin edilebilir harf ikamelerinden ka\xE7\u0131n\u0131n.',
        longerKeyboardPattern: "Daha uzun ve karma\u015F\u0131k klavye desenleri kullan\u0131n.",
        noNeed: "\xD6zel karakter, say\u0131 veya b\xFCy\xFCk harf kullanmadan da g\xFC\xE7l\xFC bir \u015Fifre olu\u015Fturabilirsiniz.",
        pwned: "Bu \u015Fifre bir veri ihlalinde tespit edildi. Ba\u015Fka bir yerde kullan\u0131yorsan\u0131z, de\u011Fi\u015Ftirmeniz \xF6nerilir.",
        recentYears: "G\xFCn\xFCm\xFCze yak\u0131n y\u0131llar\u0131 kullanmay\u0131n.",
        repeated: "Kelime veya karakter tekrarlar\u0131n\u0131 azalt\u0131n.",
        reverseWords: "Yayg\u0131n kelimelerin tersini kullanmaktan ka\xE7\u0131n\u0131n.",
        sequences: "Yayg\u0131n desenleri kullanmay\u0131n.",
        useWords: "Birden fazla s\xF6zc\xFCk kullan\u0131n ama yayg\u0131n deyi\u015Flerden ka\xE7\u0131n\u0131n."
      },
      warnings: {
        common: "Bu yayg\u0131n bir \u015Fifre.",
        commonNames: "Yayg\u0131n adlar ve soyadlar kolay tahmin edilir.",
        dates: "Tarihleri tahmin etmek kolayd\u0131r.",
        extendedRepeat: '"abcabcabc" gibi tekrarlanan desenler kolay tahmin edilir.',
        keyPattern: "K\u0131sa klavye desenleri kolay tahmin edilir.",
        namesByThemselves: "Adlar ya da soyadlar kolay tahmin edilir.",
        pwned: "Bu \u015Fifre bir veri ihlalinde tespit edilmi\u015F.",
        recentYears: "Yak\u0131n y\u0131llar kolay tahmin edilir.",
        sequences: '"abc" gibi yayg\u0131n desenlerin tahmini kolayd\u0131r.',
        similarToCommon: "Bu yayg\u0131n kullan\u0131lan \u015Fifrelere \xE7ok benziyor.",
        simpleRepeat: "Tekrarlanan karakterler kolay tahmin edilir.",
        straightRow: "Klavyede ard\u0131\u015F\u0131k karakterler kolay tahmin edilir.",
        topHundred: "Bu \xE7ok yayg\u0131n bir \u015Fifre.",
        topTen: "Bu epey yayg\u0131n bir \u015Fifre.",
        userInputs: "\u015Eifreniz ki\u015Fisel bilgiler i\xE7ermemeli.",
        wordByItself: "Tek s\xF6zc\xFCkler kolay tahmin edilir."
      }
    }
  },
  userButton: {
    action__addAccount: "Hesap ekle",
    action__manageAccount: "Hesab\u0131 y\xF6net",
    action__signOut: "\xC7\u0131k\u0131\u015F yap",
    action__signOutAll: "T\xFCm hesaplardan \xE7\u0131k\u0131\u015F yap"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopyaland\u0131!",
      actionLabel__copy: "Hepsini kopyala",
      actionLabel__download: ".txt olarak indir",
      actionLabel__print: "Yazd\u0131r",
      infoText1: "Yedekleme kodlar\u0131 bu hesap i\xE7in etkinle\u015Ftirilecektir.",
      infoText2: "Yedekleme kodlar\u0131n\u0131z\u0131 g\xFCvenli bir yerde saklay\u0131n. E\u011Fer bu kodlar\u0131n\u0131z\u0131n ba\u015Fkas\u0131n\u0131n eline ge\xE7ti\u011Fini d\xFC\u015F\xFCn\xFCrseniz, yenilerini olu\u015Fturabilirsiniz.",
      subtitle__codelist: "Yedekleme kodlar\u0131n\u0131z\u0131 g\xFCvenli bir yerde saklay\u0131n.",
      successMessage: "Yedekleme kodlar\u0131 ba\u015Far\u0131yla eklendi. E\u011Fer Authenticator uygulaman\u0131z\u0131n oldu\u011Fu cihaza eri\u015Fiminizi kaybettiyseniz, oturum a\xE7arken bu kodlardan birini girebilirsiniz. Her kod en fazla bir kez kullan\u0131labilir.",
      successSubtitle: "E\u011Fer Authenticator uygulaman\u0131z\u0131n oldu\u011Fu cihaz\u0131n\u0131za eri\u015Fiminizi kaybederseniz, bu kodlardan birini kullanarak hesab\u0131n\u0131za giri\u015F yapabilirsiniz.",
      title: "Yedekleme kodu do\u011Frulamas\u0131 ekle",
      title__codelist: "Yedekleme kodlar\u0131"
    },
    connectedAccountPage: {
      formHint: "Yeni bir hesap ba\u011Flamak i\xE7in bir sa\u011Flay\u0131c\u0131 se\xE7iniz.",
      formHint__noAccounts: "Kullan\u0131labilir bir sa\u011Flay\u0131c\u0131 yok.",
      removeResource: {
        messageLine1: "{{identifier}} hesab\u0131n\u0131zdan kald\u0131r\u0131lacakt\u0131r.",
        messageLine2: "Art\u0131k bu ba\u011Fl\u0131 hesab\u0131 kullanarak oturum a\xE7man\u0131z m\xFCmk\xFCn olmayacakt\u0131r ve buna ba\u011Fl\u0131 \xF6zellikler \xE7al\u0131\u015Fmayacakt\u0131r.",
        successMessage: "{{connectedAccount}} hesab\u0131n\u0131zdan kald\u0131r\u0131ld\u0131.",
        title: "Ba\u011Fl\u0131 hesab\u0131 kald\u0131r"
      },
      socialButtonsBlockButton: "{{provider|titleize}} hesab\u0131 ba\u011Fla",
      successMessage: "Sa\u011Flay\u0131c\u0131 hesab\u0131n\u0131za ba\u011Fland\u0131.",
      title: "Hesap ba\u011Fla"
    },
    deletePage: {
      actionDescription: "Devam etmek i\xE7in a\u015Fa\u011F\u0131ya \u201CHesab\u0131 sil\u201D yaz\u0131n.",
      confirm: "Hesab\u0131 sil",
      messageLine1: "Hesab\u0131n\u0131z\u0131 silmek istedi\u011Finizden emin misiniz?",
      messageLine2: "Bu i\u015Flem kal\u0131c\u0131d\u0131r ve geri al\u0131namaz.",
      title: "Hesab\u0131 sil"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Do\u011Frulama kodunu i\xE7eren bir e-posta belirtti\u011Finiz adrese g\xF6nderilecektir.",
        formSubtitle: "{{identifier}} adresine g\xF6nderilen do\u011Frulama kodunu giriniz",
        formTitle: "Do\u011Frulama kodu",
        resendButton: "Yeniden g\xF6nder",
        successMessage: "{{identifier}} adresi hesab\u0131n\u0131za eklendi."
      },
      emailLink: {
        formHint: "Do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131 i\xE7eren bir e-posta belirtti\u011Finiz adrese g\xF6nderilecektir.",
        formSubtitle: "{{identifier}} adresine g\xF6nderilen do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131 t\u0131klay\u0131n\u0131z",
        formTitle: "Do\u011Frulama ba\u011Flant\u0131s\u0131",
        resendButton: "Yeniden g\xF6nder",
        successMessage: "{{identifier}} adresi hesab\u0131n\u0131za eklendi."
      },
      enterpriseSSOLink: {
        formButton: "Ba\u011Flan",
        formSubtitle: "Kurumsal SSO kullan\u0131n"
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} adresi hesab\u0131n\u0131zdan kald\u0131r\u0131lacakt\u0131r.",
        messageLine2: "Art\u0131k bu e-posta adresini kullanarak oturum a\xE7man\u0131z m\xFCmk\xFCn olmayacakt\u0131r.",
        successMessage: "{{emailAddress}} adresi hesab\u0131n\u0131zdan kald\u0131r\u0131ld\u0131.",
        title: "E-posta adresini kald\u0131r"
      },
      title: "E-posta adresi ekle",
      verifyTitle: "E-posta adresini do\u011Frulay\u0131n"
    },
    formButtonPrimary__add: "Ekle",
    formButtonPrimary__continue: "\u0130lerle",
    formButtonPrimary__finish: "Bitir",
    formButtonPrimary__remove: "Kald\u0131r",
    formButtonPrimary__save: "Kaydet",
    formButtonReset: "\u0130ptal",
    mfaPage: {
      formHint: "Eklemek i\xE7in bir y\xF6ntem se\xE7iniz.",
      title: "\u0130ki a\u015Famal\u0131 do\u011Frulama y\xF6ntemi ekle"
    },
    mfaPhoneCodePage: {
      backButton: "Mevcut numaray\u0131 kullan",
      primaryButton__addPhoneNumber: "Telefon numaras\u0131 ekle",
      removeResource: {
        messageLine1: "Giri\u015F yaparken art\u0131k {{identifier}} numaras\u0131na SMS kodu g\xF6nderilmeyecektir.",
        messageLine2: "Hesab\u0131n\u0131z\u0131n g\xFCvenli\u011Fi azalabilir. Devam etmek istedi\u011Finizden emin misiniz?",
        successMessage: "\u0130ki a\u015Famal\u0131 SMS kodu do\u011Frulamas\u0131 {{mfaPhoneCode}} numaras\u0131ndan kald\u0131r\u0131ld\u0131.",
        title: "\u0130ki a\u015Famal\u0131 do\u011Frulamay\u0131 kald\u0131r"
      },
      subtitle__availablePhoneNumbers: "\u0130ki a\u015Famal\u0131 SMS kodu do\u011Frulamas\u0131 i\xE7in bir telefon numaras\u0131 se\xE7in.",
      subtitle__unavailablePhoneNumbers: "\u0130ki a\u015Famal\u0131 SMS kodu do\u011Frulamas\u0131 i\xE7in kullan\u0131labilir bir telefon numaras\u0131 yok.",
      successMessage1: "Oturum a\xE7arken, ek bir ad\u0131m olarak bu telefon numaras\u0131na g\xF6nderilen bir do\u011Frulama kodunu girmeniz gerekecektir.",
      successMessage2: "Bu yedek kodlar\u0131 kaydedin ve g\xFCvenli bir yerde saklay\u0131n. Kimlik do\u011Frulama cihaz\u0131n\u0131za eri\u015Fiminizi kaybederseniz oturum a\xE7mak i\xE7in yedek kodlar\u0131 kullanabilirsiniz.",
      successTitle: "SMS kodu do\u011Frulamas\u0131 etkin",
      title: "SMS kodu do\u011Frulamas\u0131 ekle"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Veya QR kodunu tara",
        buttonUnableToScan__nonPrimary: "QR kodunu tarayam\u0131yorum",
        infoText__ableToScan: "Authenticator uygulaman\u0131zda yeni bir giri\u015F y\xF6ntemi ayarlay\u0131n ve hesab\u0131n\u0131zla ba\u011Flamak i\xE7in a\u015Fa\u011F\u0131daki QR kodunu taray\u0131n.",
        infoText__unableToScan: "Authenticator uygulaman\u0131zda yeni bir giri\u015F y\xF6ntemi ekleme se\xE7ene\u011Fini bulun ve a\u015Fa\u011F\u0131da verilen de\u011Feri girin:",
        inputLabel__unableToScan1: "Zaman bazl\u0131 veya tek seferlik \u015Fifrelerin etkinle\u015Ftirildi\u011Finden emin olun, ard\u0131ndan hesab\u0131n\u0131z\u0131 ba\u011Flamay\u0131 tamamlay\u0131n.",
        inputLabel__unableToScan2: "Alternatif olarak do\u011Frulay\u0131c\u0131n\u0131z TOTP URI\u2019leri destekliyorsa, tam URI\u2019yi de kopyalayabilirsiniz."
      },
      removeResource: {
        messageLine1: "Art\u0131k giri\u015F yaparken authenticator'dan gelecek do\u011Frulama kodlar\u0131 gerekmeyecektir.",
        messageLine2: "Hesab\u0131n\u0131z\u0131n g\xFCvenli\u011Fi azalabilir. Devam etmek istedi\u011Finizden emin misiniz?",
        successMessage: "\u0130ki a\u015Famal\u0131 do\u011Frulama y\xF6ntemi kald\u0131r\u0131ld\u0131.",
        title: "\u0130ki a\u015Famal\u0131 do\u011Frulamay\u0131 kald\u0131r"
      },
      successMessage: "\u0130ki a\u015Famal\u0131 do\u011Frulama y\xF6ntemi ba\u015Far\u0131yla eklendi. Oturum a\xE7arken, ek bir ad\u0131m olarak bu do\u011Frulay\u0131c\u0131dan bir do\u011Frulama kodu girmeniz gerekecektir.",
      title: "Authenticator uygulamas\u0131 ekle",
      verifySubtitle: "Authenticator uygulaman\u0131zda olu\u015Fturulan do\u011Frulama kodunu giriniz",
      verifyTitle: "Do\u011Frulama kodu"
    },
    mobileButton__menu: "Men\xFC",
    navbar: {
      account: "Profil",
      description: "Hesap bilgilerinizi y\xF6netin.",
      security: "G\xFCvenlik",
      title: "Hesap"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} bu hesaptan kald\u0131r\u0131lacakt\u0131r.",
        title: "Ge\xE7i\u015F anahtar\u0131n\u0131 kald\u0131r"
      },
      subtitle__rename: "Bulmay\u0131 kolayla\u015Ft\u0131rmak i\xE7in ge\xE7i\u015F anahtar\u0131 ad\u0131n\u0131 de\u011Fi\u015Ftirebilirsiniz.",
      title__rename: "Ge\xE7i\u015F Anahtar\u0131n\u0131 Yeniden Adland\u0131r"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Eski \u015Fifrenizi kullanm\u0131\u015F olabilecek di\u011Fer t\xFCm cihazlardan \xE7\u0131k\u0131\u015F yapman\u0131z \xF6nerilir.",
      readonly: "Profil bilgileriniz kurumsal ba\u011Flant\u0131 \xFCzerinden sa\u011Fland\u0131\u011F\u0131 i\xE7in d\xFCzenlenemez.",
      successMessage__set: "\u015Eifreniz ba\u015Far\u0131yla de\u011Fi\u015Ftirildi.",
      successMessage__signOutOfOtherSessions: "Di\u011Fer t\xFCm cihazlardaki oturumlar\u0131n\u0131z sonland\u0131r\u0131ld\u0131.",
      successMessage__update: "\u015Eifreniz g\xFCncellendi.",
      title__set: "\u015Eifreyi de\u011Fi\u015Ftir",
      title__update: "Yeni \u015Fifre girin"
    },
    phoneNumberPage: {
      infoText: "Belirtilen numaraya do\u011Frulama kodunu i\xE7eren bir SMS g\xF6nderilecektir.",
      removeResource: {
        messageLine1: "{{identifier}} numaras\u0131 hesab\u0131n\u0131zdan kald\u0131r\u0131lacakt\u0131r.",
        messageLine2: "Art\u0131k bu telefon numaras\u0131n\u0131 kullanarak oturum a\xE7man\u0131z m\xFCmk\xFCn olmayacakt\u0131r.",
        successMessage: "{{phoneNumber}} numaras\u0131 hesab\u0131n\u0131zdan kald\u0131r\u0131ld\u0131.",
        title: "Telefon numaras\u0131n\u0131 kald\u0131r"
      },
      successMessage: "{{identifier}} numaras\u0131 hesab\u0131n\u0131za eklendi.",
      title: "Telefon numaras\u0131 ekle",
      verifySubtitle: "{{identifier}} numaras\u0131na g\xF6nderilen do\u011Frulama kodunu girin",
      verifyTitle: "Telefon numaras\u0131n\u0131 do\u011Frulay\u0131n"
    },
    profilePage: {
      fileDropAreaHint: "10 MB'tan k\xFC\xE7\xFCk boyutta bir JPG, PNG, GIF, veya WEBP dosyas\u0131 y\xFCkle",
      imageFormDestructiveActionSubtitle: "G\xF6rseli kald\u0131r",
      imageFormSubtitle: "G\xF6rsel y\xFCkle",
      imageFormTitle: "Profil g\xF6rseli",
      readonly: "Profil bilgileriniz kurumsal ba\u011Flant\u0131 \xFCzerinden sa\u011Fland\u0131\u011F\u0131 i\xE7in d\xFCzenlenemez.",
      successMessage: "Profiliniz g\xFCncellendi.",
      title: "Profili g\xFCncelle"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Cihaz oturumunu sonland\u0131r",
        title: "Aktif cihazlar"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Yeniden dene",
        actionLabel__reauthorize: "Yetkilendir",
        destructiveActionTitle: "Kald\u0131r",
        primaryButton: "Hesap ba\u011Fla",
        subtitle__disconnected: "Bu hesab\u0131n ba\u011Flant\u0131s\u0131 kesildi.",
        subtitle__reauthorize: "Gerekli kapsamlar g\xFCncellendi ve s\u0131n\u0131rl\u0131 i\u015Flevsellik ya\u015Fayabilirsiniz. Sorunlar\u0131 \xF6nlemek i\xE7in l\xFCtfen bu uygulamay\u0131 yeniden yetkilendirin",
        title: "Ba\u011Fl\u0131 hesaplar"
      },
      dangerSection: {
        deleteAccountButton: "Hesab\u0131 sil",
        title: "Tehlike"
      },
      emailAddressesSection: {
        destructiveAction: "E-posta adresini kald\u0131r",
        detailsAction__nonPrimary: "Birincil e-posta adresi yap",
        detailsAction__primary: "Do\u011Frulamay\u0131 tamamla",
        detailsAction__unverified: "Do\u011Frulamay\u0131 tamamla",
        primaryButton: "E-posta adresi ekle",
        title: "E-posta adresleri"
      },
      enterpriseAccountsSection: {
        title: "Kurumsal hesaplar"
      },
      headerTitle__account: "Hesap",
      headerTitle__security: "G\xFCvenlik",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Kodlar\u0131 yenile",
          headerTitle: "Yedekleme kodlar\u0131",
          subtitle__regenerate: "Yeni bir dizi g\xFCvenli yedekleme kodu al\u0131n. \xD6nceki yedekleme kodlar\u0131 silinecek ve kullan\u0131lamayacakt\u0131r.",
          title__regenerate: "Yedekleme kodlar\u0131n\u0131 yenile"
        },
        phoneCode: {
          actionLabel__setDefault: "Varsay\u0131lan olarak ayarla",
          destructiveActionLabel: "Telefon numaras\u0131n\u0131 kald\u0131r"
        },
        primaryButton: "\u0130ki a\u015Famal\u0131 do\u011Frulama ekle",
        title: "\u0130ki a\u015Famal\u0131 do\u011Frulama",
        totp: {
          destructiveActionTitle: "Kald\u0131r",
          headerTitle: "Authenticator uygulamas\u0131"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Kald\u0131r",
        menuAction__rename: "Yeniden Adland\u0131r",
        primaryButton: void 0,
        title: "Ge\xE7i\u015F Anahtarlar\u0131"
      },
      passwordSection: {
        primaryButton__setPassword: "\u015Eifreyi g\xFCncelle",
        primaryButton__updatePassword: "\u015Eifreyi de\u011Fi\u015Ftir",
        title: "\u015Eifre"
      },
      phoneNumbersSection: {
        destructiveAction: "Telefon numaras\u0131n\u0131 kald\u0131r",
        detailsAction__nonPrimary: "Birincil yap",
        detailsAction__primary: "Do\u011Frulamay\u0131 tamamla",
        detailsAction__unverified: "Do\u011Frulamay\u0131 tamamla",
        primaryButton: "Telefon numaras\u0131 ekle",
        title: "Telefon numaralar\u0131"
      },
      profileSection: {
        primaryButton: "Profili g\xFCncelle",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Kullan\u0131c\u0131 ad\u0131n\u0131 ayarla",
        primaryButton__updateUsername: "Kullan\u0131c\u0131 ad\u0131n\u0131 de\u011Fi\u015Ftir",
        title: "Kullan\u0131c\u0131 ad\u0131"
      },
      web3WalletsSection: {
        destructiveAction: "C\xFCzdan\u0131 kald\u0131r",
        primaryButton: "Web3 c\xFCzdanlar\u0131",
        title: "Web3 c\xFCzdanlar\u0131"
      }
    },
    usernamePage: {
      successMessage: "Kullan\u0131c\u0131 ad\u0131n\u0131z g\xFCncellendi.",
      title__set: "Kullan\u0131c\u0131 ad\u0131n\u0131 g\xFCncelle",
      title__update: "Kullan\u0131c\u0131 ad\u0131n\u0131 g\xFCncelle"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} c\xFCzdan\u0131 hesab\u0131n\u0131zdan kald\u0131r\u0131lacakt\u0131r.",
        messageLine2: "Art\u0131k bu c\xFCzdan\u0131 kullanarak oturum a\xE7man\u0131z m\xFCmk\xFCn olmayacakt\u0131r.",
        successMessage: "{{web3Wallet}} c\xFCzdan\u0131 hesab\u0131n\u0131zdan kald\u0131r\u0131ld\u0131.",
        title: "Web3 c\xFCzdan\u0131n\u0131 kald\u0131r"
      },
      subtitle__availableWallets: "Hesab\u0131n\u0131za eklemek i\xE7in bir web3 c\xFCzdan\u0131 se\xE7iniz.",
      subtitle__unavailableWallets: "Kullan\u0131labilir bir web3 c\xFCzdan\u0131 yok.",
      successMessage: "Web3 c\xFCzdan\u0131n\u0131z hesab\u0131n\u0131za eklendi.",
      title: "Web3 c\xFCzdan\u0131 ekle",
      web3WalletButtonsBlockButton: "Web3 c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in t\u0131klay\u0131n"
    }
  },
  waitlist: {
    start: {
      actionLink: "Bekleme listesine kat\u0131l",
      actionText: "Hala bir hesab\u0131n\u0131z yok mu?",
      formButton: "Kay\u0131t Ol",
      subtitle: "Kaydolduktan sonra erken eri\u015Fim kazanabilirsiniz.",
      title: "Bekleme Listesine Kat\u0131l\u0131n"
    },
    success: {
      message: "Ba\u015Far\u0131yla bekleme listesine eklendiniz. Erken eri\u015Fim i\xE7in sizi bilgilendirece\u011Fiz.",
      subtitle: "Bekleme listesinde oldu\u011Funuz i\xE7in te\u015Fekk\xFCr ederiz.",
      title: "Bekleme Listesine Kat\u0131ld\u0131n\u0131z"
    }
  }
};

// src/nl-NL.ts
var nlNL = {
  locale: "nl-NL",
  backButton: "Terug",
  badge__default: "Standaard",
  badge__otherImpersonatorDevice: "Ander impersonatie apparaat",
  badge__primary: "Primair",
  badge__requiresAction: "Actie vereist",
  badge__thisDevice: "Dit apparaat",
  badge__unverified: "Ongeverifieerd",
  badge__userDevice: "Gebruikersapparaat",
  badge__you: "Jij",
  createOrganization: {
    formButtonSubmit: "Cre\xEBer organisatie",
    invitePage: {
      formButtonReset: "Overslaan"
    },
    title: "Cre\xEBer organisatie"
  },
  dates: {
    lastDay: "Gisteren om {{ date | timeString('nl-NL') }}",
    next6Days: "{{ date | weekday('nl-NL','long') }} om {{ date | timeString('nl-NL') }}",
    nextDay: "Morgen om {{ date | timeString('nl-NL') }}",
    numeric: "{{ date | numeric('nl-NL') }}",
    previous6Days: "Vorige {{ date | weekday('nl-NL','long') }} om {{ date | timeString('nl-NL') }}",
    sameDay: "Vandaag om {{ date | timeString('nl-NL') }}"
  },
  dividerText: "of",
  footerActionLink__useAnotherMethod: "Een andere methode gebruiken",
  footerPageLink__help: "Helppagina",
  footerPageLink__privacy: "Privacybeleid",
  footerPageLink__terms: "Algemene voorwaarden",
  formButtonPrimary: "Doorgaan",
  formButtonPrimary__verify: "Verifieer",
  formFieldAction__forgotPassword: "Wachtwoord vergeten?",
  formFieldError__matchingPasswords: "Wachtwoorden matchen.",
  formFieldError__notMatchingPasswords: "Wachtwoorden komen niet overeen.",
  formFieldError__verificationLinkExpired: "De verificatielink is verlopen. Vraag een nieuwe link aan.",
  formFieldHintText__optional: "Optioneel",
  formFieldHintText__slug: "Een slug is een leesbare ID die uniek moet zijn. Het wordt vaak gebruikt in URL\u2019s.",
  formFieldInputPlaceholder__backupCode: "Voer een back-upcode in",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Verwijder account",
  formFieldInputPlaceholder__emailAddress: "jouw@email.com",
  formFieldInputPlaceholder__emailAddress_username: "gebruikersnaam@email.com",
  formFieldInputPlaceholder__emailAddresses: "voorbeeld@email.com, voorbeeld2@email.com",
  formFieldInputPlaceholder__firstName: "Voornaam",
  formFieldInputPlaceholder__lastName: "Achternaam",
  formFieldInputPlaceholder__organizationDomain: "voorbeeld.domein",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "contact@voorbeeld.domein",
  formFieldInputPlaceholder__organizationName: "Organisatienaam",
  formFieldInputPlaceholder__organizationSlug: "mijn-org",
  formFieldInputPlaceholder__password: "Wachtwoord",
  formFieldInputPlaceholder__phoneNumber: "Telefoonnummer",
  formFieldInputPlaceholder__username: "Gebruikersnaam",
  formFieldLabel__automaticInvitations: "Automatische uitnodigingen inschakelen voor dit domein",
  formFieldLabel__backupCode: "Backupcode",
  formFieldLabel__confirmDeletion: "Bevestiging",
  formFieldLabel__confirmPassword: "Wachtwoord bevestigen",
  formFieldLabel__currentPassword: "Huidig wachtwoord",
  formFieldLabel__emailAddress: "E-mailadres",
  formFieldLabel__emailAddress_username: "E-mailadres of gebruikersnaam",
  formFieldLabel__emailAddresses: "E-mailadressen",
  formFieldLabel__firstName: "Voornaam",
  formFieldLabel__lastName: "Achternaam",
  formFieldLabel__newPassword: "Nieuw wachtwoord",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Verwijder uitnodigingen en suggesties",
  formFieldLabel__organizationDomainEmailAddress: "Verificatie-e-mailadres",
  formFieldLabel__organizationDomainEmailAddressDescription: "Voer een e-mailadres onder dit domein in om een code te ontvangen en dit domein te verifi\xEBren.",
  formFieldLabel__organizationName: "Organisatienaam",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Naam",
  formFieldLabel__password: "Wachtwoord",
  formFieldLabel__phoneNumber: "Telefoonnummer",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Alle andere apparaten uitloggen",
  formFieldLabel__username: "Gebruikersnaam",
  impersonationFab: {
    action__signOut: "Uitloggen",
    title: "Ingelogd als {{identifier}}"
  },
  maintenanceMode: "Onderhoudsmodus",
  membershipRole__admin: "Beheerder",
  membershipRole__basicMember: "Lid",
  membershipRole__guestMember: "Gast",
  organizationList: {
    action__createOrganization: "Cre\xEBer organisatie",
    action__invitationAccept: "Toetreden",
    action__suggestionsAccept: "Verzoek om toetreden",
    createOrganization: "Cre\xEBer organisatie",
    invitationAcceptedLabel: "Toegetreden",
    subtitle: "om door te gaan naar {{applicationName}}",
    suggestionsAcceptedLabel: "In behandeling",
    title: "Kies een organisatie",
    titleWithoutPersonal: "Kies een organisatie"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatische Uitnodiging",
    badge__automaticSuggestion: "Automatische Suggesties",
    badge__manualInvitation: "Geen automatische inschrijving",
    badge__unverified: "Ongeverifieerd",
    createDomainPage: {
      subtitle: "Voeg het domein toe om te verifi\xEBren. Gebruikers met e-mailadressen in dit domein kunnen de organisatie automatisch toegang krijgen of een verzoek om toegang te maken.",
      title: "Domein toevoegen"
    },
    invitePage: {
      detailsTitle__inviteFailed: "De uitnodigingen konden niet verzonden worden. Los het volgende op en probeer het opnieuw:",
      formButtonPrimary__continue: "Uitnodigingen verzenden",
      selectDropdown__role: "Selecteer rol",
      subtitle: "Nodig nieuwe leden uit voor deze organisatie",
      successMessage: "Uitnodigingen succesvol verzonden",
      title: "Leden uitnodigen"
    },
    membersPage: {
      action__invite: "Uitnodigen",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Verwijder lid",
        tableHeader__actions: "Acties",
        tableHeader__joined: "Toegetreden",
        tableHeader__role: "Rol",
        tableHeader__user: "Gebruiker"
      },
      detailsTitle__emptyRow: "Geen leden gevonden",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Uitnodig gebruikers door een domein toe te voegen aan je organisatie. Iedereen die zich aanmeldt met een e-mailadres in dit domein kan de organisatie automatisch toegang krijgen of een verzoek om toegang te maken.",
          headerTitle: "Automatische uitnodigingen",
          primaryButton: "Beheer geverifieerde domeinen"
        },
        table__emptyRow: "Geen uitnodigingen gevonden"
      },
      invitedMembersTab: {
        menuAction__revoke: "Uitnodiging intrekken",
        tableHeader__invited: "Uitgenodigd"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Gebruikers die zich aanmelden met een e-mailadres in dit domein, kunnen een verzoek om toegang tot de organisatie zien.",
          headerTitle: "Automatische suggesties",
          primaryButton: "Beheer geverifieerde domeinen"
        },
        menuAction__approve: "Goedkeuren",
        menuAction__reject: "Weigeren",
        tableHeader__requested: "Verzoek om toegang",
        table__emptyRow: "Geen verzoeken om toegang"
      },
      start: {
        headerTitle__invitations: "Uitnodigingen",
        headerTitle__members: "Leden",
        headerTitle__requests: "Verzoeken"
      }
    },
    navbar: {
      description: "Beheer je organisatie.",
      general: "Algemeen",
      members: "Leden",
      title: "Organisatie"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Typ "{{organizationName}}" hieronder om door te gaan.',
          messageLine1: "Weet je zeker dat je deze organisatie wilt verwijderen?",
          messageLine2: "Deze actie is permanent en onomkeerbaar.",
          successMessage: "Je hebt deze organisatie verwijderd.",
          title: "Organisatie verwijderen"
        },
        leaveOrganization: {
          actionDescription: 'Typ "{{organizationName}}" hieronder om door te gaan.',
          messageLine1: "Weet je zeker dat je deze organisatie wilt verlaten? Je zult toegang verliezen tot deze organisatie en haar applicaties.",
          messageLine2: "Deze actie is permanent en onomkeerbaar.",
          successMessage: "Je hebt deze organisatie verlaten.",
          title: "Verlaat organisatie"
        },
        title: "Gevaar"
      },
      domainSection: {
        menuAction__manage: "Beheer",
        menuAction__remove: "Verwijder",
        menuAction__verify: "Verifieer",
        primaryButton: "Domein toevoegen",
        subtitle: "Laat gebruikers de organisatie automatisch toegang krijgen of een verzoek om toegang maken op basis van een geverifieerd e-maildomein.",
        title: "Geverifieerde domeinen"
      },
      successMessage: "De organisatie is bijgewerkt.",
      title: "Organisatieprofiel"
    },
    removeDomainPage: {
      messageLine1: "Het e-maildomein {{domain}} wordt verwijderd.",
      messageLine2: "Gebruikers kunnen de organisatie niet meer automatisch toegang krijgen na dit domein te verwijderen.",
      successMessage: "{{domain}} is verwijderd.",
      title: "Domein verwijderen"
    },
    start: {
      headerTitle__general: "Algemeen",
      headerTitle__members: "Leden",
      profileSection: {
        primaryButton: "",
        title: "Organisatieprofiel",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Verwijderen van dit domein zal uitnodigingen be\xEFnvloeden.",
        removeDomainActionLabel__remove: "Domein verwijderen",
        removeDomainSubtitle: "Verwijder dit domein van je geverifieerde domeinen",
        removeDomainTitle: "Domein verwijderen"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Gebruikers worden automatisch uitgenodigd om lid te worden van de organisatie wanneer ze zich aanmelden en kunnen lid worden wanneer ze dat willen.",
        automaticInvitationOption__label: "Automatische uitnodigingen",
        automaticSuggestionOption__description: "Gebruikers ontvangen een aanbeveling om lid te worden, maar moeten worden goedgekeurd door een beheerder voordat ze toegang kunnen krijgen tot de organisatie.",
        automaticSuggestionOption__label: "Automatische suggesties",
        calloutInfoLabel: "Wijziging van de inschrijfmodus heeft alleen invloed op nieuwe gebruikers.",
        calloutInvitationCountLabel: "Uitnodigingen verzonden aan gebruikers: {{count}}",
        calloutSuggestionCountLabel: "Aanbevelingen verzonden aan gebruikers: {{count}}",
        manualInvitationOption__description: "Gebruikers kunnen alleen handmatig worden uitgenodigd voor de organisatie.",
        manualInvitationOption__label: "Geen automatische inschrijving",
        subtitle: "Kies hoe gebruikers van dit domein toegang kunnen krijgen tot de organisatie."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Inschrijfopties"
      },
      subtitle: "Het domein {{domain}} is nu geverifieerd. Ga verder door de inschrijfmodus te selecteren.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Voer de verificatiecode in die verzonden is naar je e-mailadres",
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Verstuur opnieuw",
      subtitle: "Het domein {{domainName}} moet worden geverifieerd via e-mail.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verifieer domein"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Maak organisatie aan",
    action__invitationAccept: "Join",
    action__manageOrganization: "Beheer organisatie",
    action__suggestionsAccept: "Verzoek om lid te worden",
    notSelected: "Geen organisatie geselecteerd",
    personalWorkspace: "Persoonlijke werkruimte",
    suggestionsAcceptedLabel: "In behandeling"
  },
  paginationButton__next: "Volgende",
  paginationButton__previous: "Vorige",
  paginationRowText__displaying: "Weergeven",
  paginationRowText__of: "van",
  reverification: {
    alternativeMethods: {
      actionLink: "Krijg hulp",
      actionText: "Heb je geen van deze?",
      blockButton__backupCode: "Backupcode gebruiken",
      blockButton__emailCode: "Email code naar {{identifier}}",
      blockButton__password: "Doorgaan met je wachtwoord",
      blockButton__phoneCode: "Verzend SMS code naar {{identifier}}",
      blockButton__totp: "Use your authenticator app",
      getHelp: {
        blockButton__emailSupport: "Email ondersteuning",
        content: "Als je moeite hebt om je account te verifi\xEBren, email ons en we zullen met je werken om toegang te herstellen zo snel mogelijk.",
        title: "Krijg hulp"
      },
      subtitle: "Problemen? Je kunt een van deze methoden gebruiken voor verificatie.",
      title: "Gebruik een andere methode"
    },
    backupCodeMfa: {
      subtitle: "Je backupcode is de code die je kreeg bij het installeren van tweestapsverificatie.",
      title: "Backupcode invoeren"
    },
    emailCode: {
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Opnieuw verzenden",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Controleer je email"
    },
    noAvailableMethods: {
      message: "Kan niet verder gaan met verificatie. Er is geen beschikbare verificatiefactor.",
      subtitle: "Er is een fout opgetreden",
      title: "Kan je account niet verifi\xEBren"
    },
    password: {
      actionLink: "Gebruik een andere methode",
      subtitle: "Voer het wachtwoord in dat bij je account hoort",
      title: "Voer je wachtwoord in"
    },
    phoneCode: {
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Opnieuw verzenden",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Controleer je telefoon"
    },
    phoneCodeMfa: {
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Opnieuw verzenden",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Controleer je telefoon"
    },
    totpMfa: {
      formTitle: "Verificatiecode",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Tweestapsverificatie"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Account toevoegen",
      action__signOutAll: "Uitloggen van alle accounts",
      subtitle: "Selecteer het account met welk je door wilt gaan.",
      title: "Kies een account"
    },
    alternativeMethods: {
      actionLink: "Help",
      actionText: "Heb je geen van deze?",
      blockButton__backupCode: "Gebruik een backupcode",
      blockButton__emailCode: "Verzend code naar {{identifier}}",
      blockButton__emailLink: "Verzend link naar {{identifier}}",
      blockButton__passkey: "Gebruik toegangssleutel",
      blockButton__password: "Inloggen met je wachtwoord",
      blockButton__phoneCode: "Verzend code naar {{identifier}}",
      blockButton__totp: "Gebruik je authenticator app",
      getHelp: {
        blockButton__emailSupport: "E-mail {{applicationName}}",
        content: "Als je geen toegang hebt neem dan contact op met {{applicationName}} en we helpen je verder.",
        title: "Help"
      },
      subtitle: "Problemen? Je kan een van deze methoden gebruiken om in te loggen.",
      title: "Gebruik een andere methode"
    },
    backupCodeMfa: {
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Voer een backupcode in"
    },
    emailCode: {
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Check je e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "De client komt niet overeen met wat verwacht werd. Probeer het opnieuw.",
        title: "Clientfout"
      },
      expired: {
        subtitle: "Ga naar de oorspronkelijke tab om verder te gaan.",
        title: "Deze verificatielink is verlopen"
      },
      failed: {
        subtitle: "Ga naar de oorspronkelijke tab om verder te gaan.",
        title: "Deze verificatielink is niet geldig"
      },
      formSubtitle: "Gebruik de verificatielink die verzonden is naar je e-mailadres",
      formTitle: "Verificatielink",
      loading: {
        subtitle: "Je zal weldra doorgestuurd worden",
        title: "Inloggen ..."
      },
      resendButton: "Verstuur link opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Check je e-mail",
      unusedTab: {
        title: "Je kan deze tab sluiten."
      },
      verified: {
        subtitle: "Je zal weldra doorgestuurd worden",
        title: "Successvol ingelogd"
      },
      verifiedSwitchTab: {
        subtitle: "Ga naar de oorspronkelijke tab om verder te gaan",
        subtitleNewTab: "Ga naar de pasgeopende tab om verder te gaan",
        titleNewTab: "Ingelogd in andere tab"
      }
    },
    forgotPassword: {
      formTitle: "Wachtwoord resetcode",
      resendButton: "Niet ontvangen? Verstuur opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      subtitle_email: "Voer de code in die verzonden is naar je e-mailadres",
      subtitle_phone: "Voer de code in die verzonden is naar je telefoon",
      title: "Wachtwoord resetten"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Wachtwoord resetten",
      label__alternativeMethods: "Of log in met een andere methode",
      title: "Wachtwoord vergeten?"
    },
    noAvailableMethods: {
      message: "Het is niet mogelijk om door te gaan met inloggen. Er is geen beschikbare authenticatiefactor.",
      subtitle: "Er heeft zich een fout voorgedaan",
      title: "Inloggen niet mogelijk"
    },
    passkey: {
      subtitle: "Gebruik je toegangssleutel voor authenticatie.",
      title: "Authenticatie met toegangssleutel"
    },
    password: {
      actionLink: "Gebruik een andere methode",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Vul je wachtwoord in"
    },
    passwordPwned: {
      title: "Dit wachtwoord is gelekt bij een datalek. Kies een ander wachtwoord om veiligheidsredenen."
    },
    phoneCode: {
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om verder te gaan naar {{applicationName}}",
      title: "Check je telefoon"
    },
    phoneCodeMfa: {
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "",
      title: "Check je telefoon"
    },
    resetPassword: {
      formButtonPrimary: "Wachtwoord resetten",
      requiredMessage: "Voor veiligheidsredenen is het vereist om je wachtwoord te resetten.",
      successMessage: "Je wachtwoord is succesvol gewijzigd. We sturen je door naar de inlogpagina.",
      title: "Wachtwoord resetten"
    },
    resetPasswordMfa: {
      detailsLabel: "Voor veiligheidsredenen is het vereist om je wachtwoord te resetten."
    },
    start: {
      actionLink: "Registreren",
      actionLink__join_waitlist: "Meld je aan voor de wachtlijst",
      actionLink__use_email: "Gebruik e-mail",
      actionLink__use_email_username: "Gebruik e-mail of gebruikersnaam",
      actionLink__use_passkey: "Gebruik toegangssleutel",
      actionLink__use_phone: "Gebruik telefoon",
      actionLink__use_username: "Gebruik gebruikersnaam",
      actionText: "Geen account?",
      actionText__join_waitlist: "Nog geen account?",
      subtitle: "om door te gaan naar {{applicationName}}",
      subtitleCombined: void 0,
      title: "Inloggen",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Verificatiecode",
      subtitle: "",
      title: "Tweestapsverificatie"
    }
  },
  signInEnterPasswordTitle: "Vul je wachtwoord in",
  signUp: {
    continue: {
      actionLink: "Inloggen",
      actionText: "Heb je een account?",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Vul de ontbrekende velden in"
    },
    emailCode: {
      formSubtitle: "Voer de verificatiecode in die verzonden is naar je e-mailadres",
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Bevestig je e-mailadres"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "De client komt niet overeen met het verwachte. Probeer het opnieuw.",
        title: "Clientfout"
      },
      formSubtitle: "Gebruik de verificatielink die verzonden is naar je e-mailadres",
      formTitle: "Verificatielink",
      loading: {
        title: "Registreren ..."
      },
      resendButton: "Verstuur link opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Bevestig je e-mailadres",
      verified: {
        title: "Succesvol geregistreerd"
      },
      verifiedSwitchTab: {
        subtitle: "Ga naar de pas geopende tab om verder te gaan",
        subtitleNewTab: "Ga naar de vorige tab om verder te gaan",
        title: "E-mail bevestigd"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "Ik accepteer het Privacybeleid",
        label__onlyTermsOfService: "Ik accepteer de Algemene Voorwaarden",
        label__termsOfServiceAndPrivacyPolicy: "Ik accepteer de Algemene Voorwaarden en het Privacybeleid"
      },
      continue: {
        subtitle: "Door verder te gaan, ga je akkoord met de bovenstaande voorwaarden.",
        title: "Doorgaan"
      }
    },
    phoneCode: {
      formSubtitle: "Voer de verificatiecode in die verzonden is naar je telefoonnummer",
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Bevestig je telefoonnummer"
    },
    restrictedAccess: {
      actionLink: "Neem contact op met de ondersteuning",
      actionText: "Hulp nodig?",
      blockButton__emailSupport: "Stuur e-mail naar ondersteuning",
      blockButton__joinWaitlist: "Meld je aan voor de wachtlijst",
      subtitle: "Je toegang is beperkt. Neem contact met ons op voor meer informatie.",
      subtitleWaitlist: "We wachten op je toegang tot de wachtlijst. Bedankt voor je geduld.",
      title: "Beperkte toegang"
    },
    start: {
      actionLink: "Inloggen",
      actionLink__use_email: "Gebruik e-mail",
      actionLink__use_phone: "Gebruik telefoon",
      actionText: "Heb je al een account?",
      subtitle: "om door te gaan naar {{applicationName}}",
      subtitleCombined: "om door te gaan naar {{applicationName}}",
      title: "Maak je account aan",
      titleCombined: "Maak je account aan"
    }
  },
  socialButtonsBlockButton: "Ga verder met {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "Ga verder met {{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "Je bent al lid van de organisatie.",
    captcha_invalid: "Aanmelding mislukt vanwege mislukte beveiligingsvalidaties. Vernieuw de pagina om het opnieuw te proberen of neem contact op met de ondersteuning voor verdere hulp.",
    captcha_unavailable: "Aanmelding mislukt vanwege mislukte botvalidatie. Vernieuw de pagina om het opnieuw te proberen of neem contact op met de ondersteuning voor verdere hulp.",
    form_code_incorrect: "De ingevoerde code is incorrect.",
    form_identifier_exists__email_address: "Dit e-mailadres is al in gebruik.",
    form_identifier_exists__phone_number: "Dit telefoonnummer is al in gebruik.",
    form_identifier_exists__username: "Deze gebruikersnaam is al in gebruik.",
    form_identifier_not_found: "Dit identificerende gegeven kan niet worden gevonden.",
    form_param_format_invalid: "Het formaat van het ingevoerde gegeven is ongeldig.",
    form_param_format_invalid__email_address: "E-mailadres moet een geldig e-mailadres zijn.",
    form_param_format_invalid__phone_number: "Telefoonnummer moet een geldig internationaal nummer zijn.",
    form_param_max_length_exceeded__first_name: "Voornaam moet minder dan 256 tekens bevatten.",
    form_param_max_length_exceeded__last_name: "Achternaam moet minder dan 256 tekens bevatten.",
    form_param_max_length_exceeded__name: "Naam moet minder dan 256 tekens bevatten.",
    form_param_nil: "Dit veld mag niet leeg zijn.",
    form_param_value_invalid: "De waarde die je hebt ingevoerd is ongeldig.",
    form_password_incorrect: "Het wachtwoord is incorrect.",
    form_password_length_too_short: "Het wachtwoord is te kort.",
    form_password_not_strong_enough: "Je wachtwoord is niet sterk genoeg.",
    form_password_pwned: "Dit wachtwoord is in een datalek gevonden.",
    form_password_pwned__sign_in: "Als je dit wachtwoord elders gebruikt, moet je het wijzigen.",
    form_password_size_in_bytes_exceeded: "Je wachtwoord heeft het maximum aantal bytes overschreden, vermijd speciale tekens.",
    form_password_validation_failed: "Wachtwoord is incorrect.",
    form_username_invalid_character: "De gebruikersnaam bevat ongeldige tekens.",
    form_username_invalid_length: "De gebruikersnaam is te kort of te lang.",
    identification_deletion_failed: "Je kunt je laatste identificatie niet verwijderen.",
    not_allowed_access: "Toegang niet toegestaan.",
    organization_domain_blocked: "Het domein van de organisatie is geblokkeerd.",
    organization_domain_common: "Het domein van de organisatie is te algemeen.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Het lidmaatschapsquotum van de organisatie is overschreden.",
    organization_minimum_permissions_needed: "Minimale machtigingen vereist voor de organisatie.",
    passkey_already_exists: "Deze passkey bestaat al.",
    passkey_not_supported: "Passkeys worden niet ondersteund door deze browser.",
    passkey_pa_not_supported: "Passkeys worden niet ondersteund door deze browser.",
    passkey_registration_cancelled: "Passkey registratie is geannuleerd.",
    passkey_retrieval_cancelled: "Passkey ophalen is geannuleerd.",
    passwordComplexity: {
      maximumLength: "Wachtwoord moet minder dan 256 tekens bevatten.",
      minimumLength: "Wachtwoord moet minstens 8 tekens bevatten.",
      requireLowercase: "Wachtwoord moet minstens 1 kleine letter bevatten.",
      requireNumbers: "Wachtwoord moet minstens 1 cijfer bevatten.",
      requireSpecialCharacter: "Wachtwoord moet minstens 1 speciaal teken bevatten.",
      requireUppercase: "Wachtwoord moet minstens 1 hoofdletter bevatten.",
      sentencePrefix: "Wachtwoord moet minstens 1 speciaal teken bevatten."
    },
    phone_number_exists: "Dit telefoonnummer is al in gebruik. Probeer een ander nummer.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Je wachtwoord werkt, maar kan sterker zijn. Probeer meer tekens toe te voegen.",
      goodPassword: "Je wachtwoord voldoet aan alle vereisten.",
      notEnough: "Je wachtwoord is niet sterk genoeg.",
      suggestions: {
        allUppercase: "Zet een deel in hoofdletters, maar niet alle letters.",
        anotherWord: "Voeg meer woorden toe die minder vaak voorkomen.",
        associatedYears: "Vermijd jaartallen die met jou geassocieerd zijn.",
        capitalization: "Zet meer dan de eerste letter in hoofdletter.",
        dates: "Vermijd data en jaartallen die met jou geassocieerd zijn.",
        l33t: "Vermijd voorspelbare vervangingen, zoals '@' voor 'a'.",
        longerKeyboardPattern: "Gebruik langere toetsenbord patronen, en wissel meerdere keren van richting.",
        noNeed: "Je kan ook een sterk wachtwoord maken zonder speciale tekens, hoofdletters of nummers.",
        pwned: "Als u dit wachtwoord elders gebruikt, moet u het veranderen.",
        recentYears: "Vermijd recente jaartallen.",
        repeated: "Vermijd herhalende woorden en letters.",
        reverseWords: "Vermijd het omdraaien van veelvoorkomende woorden.",
        sequences: "Vermijd veelvoorkomende tekstreeksen.",
        useWords: "Gebruik meerdere woorden, maar vermijd veelvoorkomende zinnen."
      },
      warnings: {
        common: "Dit wachtwoord wordt veel gebruikt.",
        commonNames: "Veelvoorkomende voor- en achternamen zijn makkelijk te raden.",
        dates: "Datums zijn makkelijk te raden.",
        extendedRepeat: 'Herhalende patronen zoals "abcabcabc" zijn makkelijk te raden.',
        keyPattern: "Korte toetsenbord patronen zijn makkelijk te raden.",
        namesByThemselves: "Voor- en achternamen op zich zijn makkelijk te raden.",
        pwned: "Dit wachtwoord is in een datalek gevonden.",
        recentYears: "Recente jaartallen zijn makkelijk te raden.",
        sequences: 'Veelvoorkomende tekstreeksen zoals "abc" zijn makkelijk te raden.',
        similarToCommon: "Dit lijkt op een veelvoorkomend wachtwoord.",
        simpleRepeat: 'Herhalende letters zoals "aaa" zijn makkelijk te raden.',
        straightRow: "Opeenvolgende toetsen op jouw toetsenbord zijn makkelijk te raden.",
        topHundred: "Dit wachtwoord wordt erg veel gebruikt.",
        topTen: "Dit wachtwoord wordt heel erg veel gebruikt.",
        userInputs: "Vermijd persoonlijke of website gerelateerde woorden.",
        wordByItself: "Woorden op zich zijn makkelijk te raden."
      }
    }
  },
  userButton: {
    action__addAccount: "Account toevoegen",
    action__manageAccount: "Account beheren",
    action__signOut: "Uitloggen",
    action__signOutAll: "Uitloggen uit alle accounts"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Gekopieerd!",
      actionLabel__copy: "Kopieer",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Print",
      infoText1: "Backupcodes zullen voor dit account ingeschakeld zijn.",
      infoText2: "Houd de backupcodes geheim en bewaar ze veilig. U kunt backupcodes opnieuw genereren als u vermoedt dat ze zijn aangetast.",
      subtitle__codelist: "Sla ze veilig op en hou ze geheim.",
      successMessage: "Backupcodes zijn nu ingeschakeld. U kunt er een van gebruiken om in te loggen op uw account als u geen toegang meer heeft tot uw authenticatieapparaat. Elke code kan maar \xE9\xE9n keer gebruikt worden.",
      successSubtitle: "Je kunt \xE9\xE9n van deze gebruiken om in te loggen op je account als je geen toegang meer hebt tot je authenticatieapparaat.",
      title: "Voeg backup code verificatie toe",
      title__codelist: "Backup codes"
    },
    connectedAccountPage: {
      formHint: "Kies een provider om je account te verbinden.",
      formHint__noAccounts: "Er zijn geen beschikbare externe accountproviders.",
      removeResource: {
        messageLine1: "{{identifier}} zal verwijderd worden uit dit account.",
        messageLine2: "Je kunt deze verbonden account niet meer gebruiken en afhankelijke functies zullen niet meer werken.",
        successMessage: "{{connectedAccount}} is verwijderd uit je account.",
        title: "Verwijder externe account"
      },
      socialButtonsBlockButton: "Verbind {{provider|titleize}} account",
      successMessage: "Deze provider is toegevoegd aan je account.",
      title: "Verbind externe account"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "Delete account",
      messageLine1: "Are you sure you want to delete your account?",
      messageLine2: "This action is permanent and irreversible.",
      title: "Delete account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Een mail met daarin een verificatiecode is verstuurd naar dit adres.",
        formSubtitle: "Voer de verificatiecode in die verstuurd is naar {{identifier}}",
        formTitle: "Verificatiecode",
        resendButton: "Verstuur code opnieuw",
        successMessage: "Het e-mailadres {{identifier}} is toegevoegd aan je account."
      },
      emailLink: {
        formHint: "Een mail met daarin een verificatielink is verstuurd naar dit adres.",
        formSubtitle: "Klik op de verificatielink die verstuurd is naar {{identifier}}",
        formTitle: "Verificatielink",
        resendButton: "Verstuur link opnieuw",
        successMessage: "Het e-mailadres {{identifier}} is toegevoegd aan je account."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} zal verwijderd worden uit dit account.",
        messageLine2: "Je zal niet meer kunnen inloggen met dit e-mailadres.",
        successMessage: "{{emailAddress}} is verwijderd uit je account.",
        title: "Verwijder e-mailadres"
      },
      title: "E-mailadres toevoegen",
      verifyTitle: "E-mailadres bevestigen"
    },
    formButtonPrimary__add: "Toevoegen",
    formButtonPrimary__continue: "Doorgaan",
    formButtonPrimary__finish: "Afronden",
    formButtonPrimary__remove: "Verwijderen",
    formButtonPrimary__save: "Opslaan",
    formButtonReset: "Annuleren",
    mfaPage: {
      formHint: "Kies een methode om toe te voegen.",
      title: "Tweestapsverificatie toevoegen"
    },
    mfaPhoneCodePage: {
      backButton: "Gebruik bestaand nummer",
      primaryButton__addPhoneNumber: "Telefoonnummer toevoegen",
      removeResource: {
        messageLine1: "{{identifier}} zal niet langer verificatiecodes ontvangen bij het inloggen.",
        messageLine2: "Uw account is mogelijk niet zo veilig. Weet je zeker dat je door wilt gaan?",
        successMessage: "SMS-code tweestapsverificatie is verwijderd voor {{mfaPhoneCode}}",
        title: "Verwijder tweestapsverificatie"
      },
      subtitle__availablePhoneNumbers: "Selecteer een telefoonnummer om je te registreren voor SMS-code twee-stapsverificatie.",
      subtitle__unavailablePhoneNumbers: "Er zijn geen beschikbare telefoonnummers om te registreren voor SMS-code tweestapsverificatie.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Sla deze backup codes op en bewaar ze ergens veilig. Als je toegang kwijtraakt tot je authenticatieapparaat, kun je de backup codes gebruiken om in te loggen.",
      successTitle: "SMS-code verificatie ingeschakeld",
      title: "Voeg SMS-code verificatie toe"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Een tweede optie, scan de QR-code",
        buttonUnableToScan__nonPrimary: "Kan je de code niet scannen?",
        infoText__ableToScan: "Scan de QR-code met je authenticator app om de authenticator toe te voegen.",
        infoText__unableToScan: "Stel een nieuwe aanmeldmethode in op je authenticator en voer de onderstaande sleutel in.",
        inputLabel__unableToScan1: "Zorg ervoor dat tijdsgebaseerde of eenmalige wachtwoorden zijn ingeschakeld, en voltooi vervolgens het koppelen van uw account.",
        inputLabel__unableToScan2: "Als je authenticator TOTP-URI's ondersteunt, kun je ook de volledige URI kopi\xEBren."
      },
      removeResource: {
        messageLine1: "Verificatiecodes van deze authenticator zullen niet langer vereist zijn bij het inloggen.",
        messageLine2: "Uw account is mogelijk niet zo veilig. Weet je zeker dat je door wilt gaan?",
        successMessage: "Tweestapsverificatie via authenticator-applicatie is verwijderd.",
        title: "Verwijder tweestapsverificatie"
      },
      successMessage: "Tweestapsverificatie is nu ingesteld. Bij het inloggen zal je een verificatiecode van je authenticator app moeten invoeren.",
      title: "Voeg authenticator toe",
      verifySubtitle: "Voer de verificatiecode in die je authenticator app heeft gegenereerd.",
      verifyTitle: "Verificatiecode"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profiel",
      description: "Beheer je account informatie.",
      security: "Beveiliging",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} zal verwijderd worden uit dit account.",
        title: "Verwijder passkey"
      },
      subtitle__rename: "Je kunt de naam van de passkey wijzigen om deze gemakkelijker te vinden.",
      title__rename: "Passkey hernoemen"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Het is aanbevolen om uit te loggen van alle andere apparaten die mogelijk gebruik hebben gemaakt van je oude wachtwoord.",
      readonly: "Je wachtwoord kan momenteel niet worden gewijzigd omdat je alleen via de enterprise connectie kunt inloggen.",
      successMessage__set: "Je wachtwoord is ingesteld.",
      successMessage__signOutOfOtherSessions: "Alle andere apparaten zijn uitgelogd.",
      successMessage__update: "Je wachtwoord is bijgewerkt.",
      title__set: "Stel wachtwoord in",
      title__update: "Wachtwoord wijzigen"
    },
    phoneNumberPage: {
      infoText: "Een SMS met daarin een verificatiecode is verstuurd naar dit nummer.",
      removeResource: {
        messageLine1: "{{identifier}} zal van dit account verwijderd worden.",
        messageLine2: "Je zal niet meer kunnen inloggen met dit telefoonnummer.",
        successMessage: "{{phoneNumber}} is verwijderd uit je account.",
        title: "Verwijder telefoonnummer"
      },
      successMessage: "{{phoneNumber}} is toegevoegd aan je account.",
      title: "Telefoonnummer toevoegen",
      verifySubtitle: "Voer de verificatiecode in die verstuurd is naar {{phoneNumber}}",
      verifyTitle: "Verifieer telefoonnummer"
    },
    profilePage: {
      fileDropAreaHint: "Upload een JPG, PNG, GIF, of WEBP afbeelding kleiner dan 10 MB",
      imageFormDestructiveActionSubtitle: "Verwijder afbeelding",
      imageFormSubtitle: "Afbeelding uploaden",
      imageFormTitle: "Profielfoto",
      readonly: "Je profiel informatie is verstrekt door de enterprise connectie en kan niet worden bewerkt.",
      successMessage: "Je profiel is bijgewerkt.",
      title: "Profiel bijwerken"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Log uit op apparaat",
        title: "Actieve apparaten"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Probeer opnieuw",
        actionLabel__reauthorize: "Authoriseer nu",
        destructiveActionTitle: "Verwijderen",
        primaryButton: "Verbind een account",
        subtitle__disconnected: "Je account is losgekoppeld. Verbind het opnieuw om verder te gaan.",
        subtitle__reauthorize: "De vereiste scopes zijn bijgewerkt, en je kunt mogelijk beperkte functionaliteit ervaren. Autoriseer deze toepassing opnieuw om problemen te voorkomen.",
        title: "Aangesloten accounts"
      },
      dangerSection: {
        deleteAccountButton: "Verwijder account",
        title: "Account be\xEBindigen"
      },
      emailAddressesSection: {
        destructiveAction: "Verwijder e-mailadres",
        detailsAction__nonPrimary: "Stel in als hoofd",
        detailsAction__primary: "Rond verificatie af",
        detailsAction__unverified: "Rond verificatie af",
        primaryButton: "Voeg een e-mailadres toe",
        title: "E-mailadressen"
      },
      enterpriseAccountsSection: {
        title: "Bedrijfsaccounts"
      },
      headerTitle__account: "Account",
      headerTitle__security: "Beveiliging",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Codes hergenereren",
          headerTitle: "Backupcodes",
          subtitle__regenerate: "Genereer een nieuwe set backupcodes. De vorige kunnen niet meer gebruikt worden.",
          title__regenerate: "Backupcodes hergenereren"
        },
        phoneCode: {
          actionLabel__setDefault: "Stel in als standaard",
          destructiveActionLabel: "Verwijder tweestapsverificatie"
        },
        primaryButton: "Tweestapsverificatie instellen",
        title: "Tweestapsverificatie",
        totp: {
          destructiveActionTitle: "Verwijderen",
          headerTitle: "Authenticatorapplicatie"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Verwijderen",
        menuAction__rename: "Hernoemen",
        primaryButton: void 0,
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "Wachtwoord instellen",
        primaryButton__updatePassword: "Wachtwoord wijzigen",
        title: "Wachtwoord"
      },
      phoneNumbersSection: {
        destructiveAction: "Verwijder telefoonnummer",
        detailsAction__nonPrimary: "Stel in als hoofd",
        detailsAction__primary: "Rond verificatie af",
        detailsAction__unverified: "Rond verificatie af",
        primaryButton: "Voeg een telefoonnummer toe",
        title: "Telefoonnummers"
      },
      profileSection: {
        primaryButton: "Profiel bijwerken",
        title: "Profiel"
      },
      usernameSection: {
        primaryButton__setUsername: "Stel gebruikersnaam in",
        primaryButton__updateUsername: "Wijzig gebruikersnaam",
        title: "Gebruikersnaam"
      },
      web3WalletsSection: {
        destructiveAction: "Verwijder portefeuille",
        primaryButton: "Web3 portefeuilles",
        title: "Web3 portefeuilles"
      }
    },
    usernamePage: {
      successMessage: "Je gebruikersnaam is bijgewerkt.",
      title__set: "Gebruikersnaam bijwerken",
      title__update: "Gebruikersnaam bijwerken"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} zal verwijderd worden uit dit account.",
        messageLine2: "Je zal niet meer kunnen inloggen met deze web3 portefeuille.",
        successMessage: "{{web3Wallet}} is verwijderd uit je account.",
        title: "Verwijder web3 portefeuille"
      },
      subtitle__availableWallets: "Selecteer een web3 portefeuille om toe te voegen.",
      subtitle__unavailableWallets: "Er zijn geen beschikbare web3 portefeuilles.",
      successMessage: "De portefeuille is toegevoegd aan dit account.",
      title: "Web3 portefeuille toevoegen.",
      web3WalletButtonsBlockButton: "Voeg een Web3-portefeuille toe"
    }
  },
  waitlist: {
    start: {
      actionLink: "Inloggen",
      actionText: "Heb je al toegang?",
      formButton: "Verstuur",
      subtitle: "Je wordt toegevoegd aan de wachtlijst en op de hoogte gehouden.",
      title: "Wachtlijst aanmelding"
    },
    success: {
      message: "Je bent succesvol toegevoegd aan de wachtlijst!",
      subtitle: "Je ontvangt een bericht zodra er ruimte beschikbaar is.",
      title: "Succes!"
    }
  }
};

// src/nl-BE.ts
var nlBE = {
  locale: "nl-NL",
  backButton: "Terug",
  badge__default: "Standaard",
  badge__otherImpersonatorDevice: "Ander impersonatie apparaat",
  badge__primary: "Primair",
  badge__requiresAction: "Actie vereist",
  badge__thisDevice: "Dit apparaat",
  badge__unverified: "Ongeverifieerd",
  badge__userDevice: "Gebruikersapparaat",
  badge__you: "Jij",
  createOrganization: {
    formButtonSubmit: "Cre\xEBer organisatie",
    invitePage: {
      formButtonReset: "Overslaan"
    },
    title: "Cre\xEBer organisatie"
  },
  dates: {
    lastDay: "Gisteren om {{ date | timeString('nl-NL') }}",
    next6Days: "{{ date | weekday('nl-NL','long') }} om {{ date | timeString('nl-NL') }}",
    nextDay: "Morgen om {{ date | timeString('nl-NL') }}",
    numeric: "{{ date | numeric('nl-NL') }}",
    previous6Days: "Vorige {{ date | weekday('nl-NL','long') }} om {{ date | timeString('nl-NL') }}",
    sameDay: "Vandaag om {{ date | timeString('nl-NL') }}"
  },
  dividerText: "of",
  footerActionLink__useAnotherMethod: "Een andere methode gebruiken",
  footerPageLink__help: "Helppagina",
  footerPageLink__privacy: "Privacybeleid",
  footerPageLink__terms: "Algemene voorwaarden",
  formButtonPrimary: "Doorgaan",
  formButtonPrimary__verify: "Verifieer",
  formFieldAction__forgotPassword: "Wachtwoord vergeten?",
  formFieldError__matchingPasswords: "Wachtwoorden matchen.",
  formFieldError__notMatchingPasswords: "Wachtwoorden komen niet overeen.",
  formFieldError__verificationLinkExpired: "De verificatielink is verlopen. Vraag een nieuwe link aan.",
  formFieldHintText__optional: "Optioneel",
  formFieldHintText__slug: "Een slug is een leesbare ID die uniek moet zijn. Het wordt vaak gebruikt in URL\u2019s.",
  formFieldInputPlaceholder__backupCode: "Voer een back-upcode in",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Verwijder account",
  formFieldInputPlaceholder__emailAddress: "jouw@email.com",
  formFieldInputPlaceholder__emailAddress_username: "gebruikersnaam@email.com",
  formFieldInputPlaceholder__emailAddresses: "voorbeeld@email.com, voorbeeld2@email.com",
  formFieldInputPlaceholder__firstName: "Voornaam",
  formFieldInputPlaceholder__lastName: "Achternaam",
  formFieldInputPlaceholder__organizationDomain: "voorbeeld.domein",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "contact@voorbeeld.domein",
  formFieldInputPlaceholder__organizationName: "Organisatienaam",
  formFieldInputPlaceholder__organizationSlug: "mijn-org",
  formFieldInputPlaceholder__password: "Wachtwoord",
  formFieldInputPlaceholder__phoneNumber: "Telefoonnummer",
  formFieldInputPlaceholder__username: "Gebruikersnaam",
  formFieldLabel__automaticInvitations: "Automatische uitnodigingen inschakelen voor dit domein",
  formFieldLabel__backupCode: "Backupcode",
  formFieldLabel__confirmDeletion: "Bevestiging",
  formFieldLabel__confirmPassword: "Wachtwoord bevestigen",
  formFieldLabel__currentPassword: "Huidig wachtwoord",
  formFieldLabel__emailAddress: "E-mailadres",
  formFieldLabel__emailAddress_username: "E-mailadres of gebruikersnaam",
  formFieldLabel__emailAddresses: "E-mailadressen",
  formFieldLabel__firstName: "Voornaam",
  formFieldLabel__lastName: "Achternaam",
  formFieldLabel__newPassword: "Nieuw wachtwoord",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Verwijder uitnodigingen en suggesties",
  formFieldLabel__organizationDomainEmailAddress: "Verificatie-e-mailadres",
  formFieldLabel__organizationDomainEmailAddressDescription: "Voer een e-mailadres onder dit domein in om een code te ontvangen en dit domein te verifi\xEBren.",
  formFieldLabel__organizationName: "Organisatienaam",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Naam",
  formFieldLabel__password: "Wachtwoord",
  formFieldLabel__phoneNumber: "Telefoonnummer",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Alle andere apparaten uitloggen",
  formFieldLabel__username: "Gebruikersnaam",
  impersonationFab: {
    action__signOut: "Uitloggen",
    title: "Ingelogd als {{identifier}}"
  },
  maintenanceMode: "Onderhoudsmodus",
  membershipRole__admin: "Beheerder",
  membershipRole__basicMember: "Lid",
  membershipRole__guestMember: "Gast",
  organizationList: {
    action__createOrganization: "Cre\xEBer organisatie",
    action__invitationAccept: "Toetreden",
    action__suggestionsAccept: "Verzoek om toetreden",
    createOrganization: "Cre\xEBer organisatie",
    invitationAcceptedLabel: "Toegetreden",
    subtitle: "om door te gaan naar {{applicationName}}",
    suggestionsAcceptedLabel: "In behandeling",
    title: "Kies een organisatie",
    titleWithoutPersonal: "Kies een organisatie"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatische Uitnodiging",
    badge__automaticSuggestion: "Automatische Suggesties",
    badge__manualInvitation: "Geen automatische inschrijving",
    badge__unverified: "Ongeverifieerd",
    createDomainPage: {
      subtitle: "Voeg het domein toe om te verifi\xEBren. Gebruikers met e-mailadressen in dit domein kunnen de organisatie automatisch toegang krijgen of een verzoek om toegang te maken.",
      title: "Domein toevoegen"
    },
    invitePage: {
      detailsTitle__inviteFailed: "De uitnodigingen konden niet verzonden worden. Los het volgende op en probeer het opnieuw:",
      formButtonPrimary__continue: "Uitnodigingen verzenden",
      selectDropdown__role: "Selecteer rol",
      subtitle: "Nodig nieuwe leden uit voor deze organisatie",
      successMessage: "Uitnodigingen succesvol verzonden",
      title: "Leden uitnodigen"
    },
    membersPage: {
      action__invite: "Uitnodigen",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Verwijder lid",
        tableHeader__actions: "Acties",
        tableHeader__joined: "Toegetreden",
        tableHeader__role: "Rol",
        tableHeader__user: "Gebruiker"
      },
      detailsTitle__emptyRow: "Geen leden gevonden",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Uitnodig gebruikers door een domein toe te voegen aan je organisatie. Iedereen die zich aanmeldt met een e-mailadres in dit domein kan de organisatie automatisch toegang krijgen of een verzoek om toegang te maken.",
          headerTitle: "Automatische uitnodigingen",
          primaryButton: "Beheer geverifieerde domeinen"
        },
        table__emptyRow: "Geen uitnodigingen gevonden"
      },
      invitedMembersTab: {
        menuAction__revoke: "Uitnodiging intrekken",
        tableHeader__invited: "Uitgenodigd"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Gebruikers die zich aanmelden met een e-mailadres in dit domein, kunnen een verzoek om toegang tot de organisatie zien.",
          headerTitle: "Automatische suggesties",
          primaryButton: "Beheer geverifieerde domeinen"
        },
        menuAction__approve: "Goedkeuren",
        menuAction__reject: "Weigeren",
        tableHeader__requested: "Verzoek om toegang",
        table__emptyRow: "Geen verzoeken om toegang"
      },
      start: {
        headerTitle__invitations: "Uitnodigingen",
        headerTitle__members: "Leden",
        headerTitle__requests: "Verzoeken"
      }
    },
    navbar: {
      description: "Beheer je organisatie.",
      general: "Algemeen",
      members: "Leden",
      title: "Organisatie"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Typ "{{organizationName}}" hieronder om door te gaan.',
          messageLine1: "Weet je zeker dat je deze organisatie wilt verwijderen?",
          messageLine2: "Deze actie is permanent en onomkeerbaar.",
          successMessage: "Je hebt deze organisatie verwijderd.",
          title: "Organisatie verwijderen"
        },
        leaveOrganization: {
          actionDescription: 'Typ "{{organizationName}}" hieronder om door te gaan.',
          messageLine1: "Weet je zeker dat je deze organisatie wilt verlaten? Je zult toegang verliezen tot deze organisatie en haar applicaties.",
          messageLine2: "Deze actie is permanent en onomkeerbaar.",
          successMessage: "Je hebt deze organisatie verlaten.",
          title: "Verlaat organisatie"
        },
        title: "Gevaar"
      },
      domainSection: {
        menuAction__manage: "Beheer",
        menuAction__remove: "Verwijder",
        menuAction__verify: "Verifieer",
        primaryButton: "Domein toevoegen",
        subtitle: "Laat gebruikers de organisatie automatisch toegang krijgen of een verzoek om toegang maken op basis van een geverifieerd e-maildomein.",
        title: "Geverifieerde domeinen"
      },
      successMessage: "De organisatie is bijgewerkt.",
      title: "Organisatieprofiel"
    },
    removeDomainPage: {
      messageLine1: "Het e-maildomein {{domain}} wordt verwijderd.",
      messageLine2: "Gebruikers kunnen de organisatie niet meer automatisch toegang krijgen na dit domein te verwijderen.",
      successMessage: "{{domain}} is verwijderd.",
      title: "Domein verwijderen"
    },
    start: {
      headerTitle__general: "Algemeen",
      headerTitle__members: "Leden",
      profileSection: {
        primaryButton: "",
        title: "Organisatieprofiel",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Verwijderen van dit domein zal uitnodigingen be\xEFnvloeden.",
        removeDomainActionLabel__remove: "Domein verwijderen",
        removeDomainSubtitle: "Verwijder dit domein van je geverifieerde domeinen",
        removeDomainTitle: "Domein verwijderen"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Gebruikers worden automatisch uitgenodigd om lid te worden van de organisatie wanneer ze zich aanmelden en kunnen lid worden wanneer ze dat willen.",
        automaticInvitationOption__label: "Automatische uitnodigingen",
        automaticSuggestionOption__description: "Gebruikers ontvangen een aanbeveling om lid te worden, maar moeten worden goedgekeurd door een beheerder voordat ze toegang kunnen krijgen tot de organisatie.",
        automaticSuggestionOption__label: "Automatische suggesties",
        calloutInfoLabel: "Wijziging van de inschrijfmodus heeft alleen invloed op nieuwe gebruikers.",
        calloutInvitationCountLabel: "Uitnodigingen verzonden aan gebruikers: {{count}}",
        calloutSuggestionCountLabel: "Aanbevelingen verzonden aan gebruikers: {{count}}",
        manualInvitationOption__description: "Gebruikers kunnen alleen handmatig worden uitgenodigd voor de organisatie.",
        manualInvitationOption__label: "Geen automatische inschrijving",
        subtitle: "Kies hoe gebruikers van dit domein toegang kunnen krijgen tot de organisatie."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Inschrijfopties"
      },
      subtitle: "Het domein {{domain}} is nu geverifieerd. Ga verder door de inschrijfmodus te selecteren.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Voer de verificatiecode in die verzonden is naar je e-mailadres",
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Verstuur opnieuw",
      subtitle: "Het domein {{domainName}} moet worden geverifieerd via e-mail.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verifieer domein"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Maak organisatie aan",
    action__invitationAccept: "Join",
    action__manageOrganization: "Beheer organisatie",
    action__suggestionsAccept: "Verzoek om lid te worden",
    notSelected: "Geen organisatie geselecteerd",
    personalWorkspace: "Persoonlijke werkruimte",
    suggestionsAcceptedLabel: "In behandeling"
  },
  paginationButton__next: "Volgende",
  paginationButton__previous: "Vorige",
  paginationRowText__displaying: "Weergeven",
  paginationRowText__of: "van",
  reverification: {
    alternativeMethods: {
      actionLink: "Krijg hulp",
      actionText: "Heb je geen van deze?",
      blockButton__backupCode: "Backupcode gebruiken",
      blockButton__emailCode: "Email code naar {{identifier}}",
      blockButton__password: "Doorgaan met je wachtwoord",
      blockButton__phoneCode: "Verzend SMS code naar {{identifier}}",
      blockButton__totp: "Use your authenticator app",
      getHelp: {
        blockButton__emailSupport: "Email ondersteuning",
        content: "Als je moeite hebt om je account te verifi\xEBren, email ons en we zullen met je werken om toegang te herstellen zo snel mogelijk.",
        title: "Krijg hulp"
      },
      subtitle: "Problemen? Je kunt een van deze methoden gebruiken voor verificatie.",
      title: "Gebruik een andere methode"
    },
    backupCodeMfa: {
      subtitle: "Je backupcode is de code die je kreeg bij het installeren van tweestapsverificatie.",
      title: "Backupcode invoeren"
    },
    emailCode: {
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Opnieuw verzenden",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Controleer je email"
    },
    noAvailableMethods: {
      message: "Kan niet verder gaan met verificatie. Er is geen beschikbare verificatiefactor.",
      subtitle: "Er is een fout opgetreden",
      title: "Kan je account niet verifi\xEBren"
    },
    password: {
      actionLink: "Gebruik een andere methode",
      subtitle: "Voer het wachtwoord in dat bij je account hoort",
      title: "Voer je wachtwoord in"
    },
    phoneCode: {
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Opnieuw verzenden",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Controleer je telefoon"
    },
    phoneCodeMfa: {
      formTitle: "Verificatiecode",
      resendButton: "Niet ontvangen? Opnieuw verzenden",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Controleer je telefoon"
    },
    totpMfa: {
      formTitle: "Verificatiecode",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Tweestapsverificatie"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Account toevoegen",
      action__signOutAll: "Uitloggen van alle accounts",
      subtitle: "Selecteer het account met welk je door wilt gaan.",
      title: "Kies een account"
    },
    alternativeMethods: {
      actionLink: "Help",
      actionText: "Heb je geen van deze?",
      blockButton__backupCode: "Gebruik een backupcode",
      blockButton__emailCode: "Verzend code naar {{identifier}}",
      blockButton__emailLink: "Verzend link naar {{identifier}}",
      blockButton__passkey: "Gebruik toegangssleutel",
      blockButton__password: "Inloggen met je wachtwoord",
      blockButton__phoneCode: "Verzend code naar {{identifier}}",
      blockButton__totp: "Gebruik je authenticator app",
      getHelp: {
        blockButton__emailSupport: "E-mail {{applicationName}}",
        content: "Als je geen toegang hebt neem dan contact op met {{applicationName}} en we helpen je verder.",
        title: "Help"
      },
      subtitle: "Problemen? Je kan een van deze methoden gebruiken om in te loggen.",
      title: "Gebruik een andere methode"
    },
    backupCodeMfa: {
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Voer een backupcode in"
    },
    emailCode: {
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Check je e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "De client komt niet overeen met wat verwacht werd. Probeer het opnieuw.",
        title: "Clientfout"
      },
      expired: {
        subtitle: "Ga naar de oorspronkelijke tab om verder te gaan.",
        title: "Deze verificatielink is verlopen"
      },
      failed: {
        subtitle: "Ga naar de oorspronkelijke tab om verder te gaan.",
        title: "Deze verificatielink is niet geldig"
      },
      formSubtitle: "Gebruik de verificatielink die verzonden is naar je e-mailadres",
      formTitle: "Verificatielink",
      loading: {
        subtitle: "Je zal weldra doorgestuurd worden",
        title: "Inloggen ..."
      },
      resendButton: "Verstuur link opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Check je e-mail",
      unusedTab: {
        title: "Je kan deze tab sluiten."
      },
      verified: {
        subtitle: "Je zal weldra doorgestuurd worden",
        title: "Successvol ingelogd"
      },
      verifiedSwitchTab: {
        subtitle: "Ga naar de oorspronkelijke tab om verder te gaan",
        subtitleNewTab: "Ga naar de pasgeopende tab om verder te gaan",
        titleNewTab: "Ingelogd in andere tab"
      }
    },
    forgotPassword: {
      formTitle: "Wachtwoord resetcode",
      resendButton: "Niet ontvangen? Verstuur opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      subtitle_email: "Voer de code in die verzonden is naar je e-mailadres",
      subtitle_phone: "Voer de code in die verzonden is naar je telefoon",
      title: "Wachtwoord resetten"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Wachtwoord resetten",
      label__alternativeMethods: "Of log in met een andere methode",
      title: "Wachtwoord vergeten?"
    },
    noAvailableMethods: {
      message: "Het is niet mogelijk om door te gaan met inloggen. Er is geen beschikbare authenticatiefactor.",
      subtitle: "Er heeft zich een fout voorgedaan",
      title: "Inloggen niet mogelijk"
    },
    passkey: {
      subtitle: "Gebruik je toegangssleutel voor authenticatie.",
      title: "Authenticatie met toegangssleutel"
    },
    password: {
      actionLink: "Gebruik een andere methode",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Vul je wachtwoord in"
    },
    passwordPwned: {
      title: "Dit wachtwoord is gelekt bij een datalek. Kies een ander wachtwoord om veiligheidsredenen."
    },
    phoneCode: {
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om verder te gaan naar {{applicationName}}",
      title: "Check je telefoon"
    },
    phoneCodeMfa: {
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "",
      title: "Check je telefoon"
    },
    resetPassword: {
      formButtonPrimary: "Wachtwoord resetten",
      requiredMessage: "Voor veiligheidsredenen is het vereist om je wachtwoord te resetten.",
      successMessage: "Je wachtwoord is succesvol gewijzigd. We sturen je door naar de inlogpagina.",
      title: "Wachtwoord resetten"
    },
    resetPasswordMfa: {
      detailsLabel: "Voor veiligheidsredenen is het vereist om je wachtwoord te resetten."
    },
    start: {
      actionLink: "Registreren",
      actionLink__join_waitlist: "Meld je aan voor de wachtlijst",
      actionLink__use_email: "Gebruik e-mail",
      actionLink__use_email_username: "Gebruik e-mail of gebruikersnaam",
      actionLink__use_passkey: "Gebruik toegangssleutel",
      actionLink__use_phone: "Gebruik telefoon",
      actionLink__use_username: "Gebruik gebruikersnaam",
      actionText: "Geen account?",
      actionText__join_waitlist: "Nog geen account?",
      subtitle: "om door te gaan naar {{applicationName}}",
      subtitleCombined: void 0,
      title: "Inloggen",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Verificatiecode",
      subtitle: "",
      title: "Tweestapsverificatie"
    }
  },
  signInEnterPasswordTitle: "Vul je wachtwoord in",
  signUp: {
    continue: {
      actionLink: "Inloggen",
      actionText: "Heb je een account?",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Vul de ontbrekende velden in"
    },
    emailCode: {
      formSubtitle: "Voer de verificatiecode in die verzonden is naar je e-mailadres",
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Bevestig je e-mailadres"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "De client komt niet overeen met het verwachte. Probeer het opnieuw.",
        title: "Clientfout"
      },
      formSubtitle: "Gebruik de verificatielink die verzonden is naar je e-mailadres",
      formTitle: "Verificatielink",
      loading: {
        title: "Registreren ..."
      },
      resendButton: "Verstuur link opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Bevestig je e-mailadres",
      verified: {
        title: "Succesvol geregistreerd"
      },
      verifiedSwitchTab: {
        subtitle: "Ga naar de pas geopende tab om verder te gaan",
        subtitleNewTab: "Ga naar de vorige tab om verder te gaan",
        title: "E-mail bevestigd"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "Ik accepteer het Privacybeleid",
        label__onlyTermsOfService: "Ik accepteer de Algemene Voorwaarden",
        label__termsOfServiceAndPrivacyPolicy: "Ik accepteer de Algemene Voorwaarden en het Privacybeleid"
      },
      continue: {
        subtitle: "Door verder te gaan, ga je akkoord met de bovenstaande voorwaarden.",
        title: "Doorgaan"
      }
    },
    phoneCode: {
      formSubtitle: "Voer de verificatiecode in die verzonden is naar je telefoonnummer",
      formTitle: "Verificatiecode",
      resendButton: "Verstuur code opnieuw",
      subtitle: "om door te gaan naar {{applicationName}}",
      title: "Bevestig je telefoonnummer"
    },
    restrictedAccess: {
      actionLink: "Neem contact op met de ondersteuning",
      actionText: "Hulp nodig?",
      blockButton__emailSupport: "Stuur e-mail naar ondersteuning",
      blockButton__joinWaitlist: "Meld je aan voor de wachtlijst",
      subtitle: "Je toegang is beperkt. Neem contact met ons op voor meer informatie.",
      subtitleWaitlist: "We wachten op je toegang tot de wachtlijst. Bedankt voor je geduld.",
      title: "Beperkte toegang"
    },
    start: {
      actionLink: "Inloggen",
      actionLink__use_email: "Gebruik e-mail",
      actionLink__use_phone: "Gebruik telefoon",
      actionText: "Heb je al een account?",
      subtitle: "om door te gaan naar {{applicationName}}",
      subtitleCombined: "om door te gaan naar {{applicationName}}",
      title: "Maak je account aan",
      titleCombined: "Maak je account aan"
    }
  },
  socialButtonsBlockButton: "Ga verder met {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "Ga verder met {{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "Je bent al lid van de organisatie.",
    captcha_invalid: "Aanmelding mislukt vanwege mislukte beveiligingsvalidaties. Vernieuw de pagina om het opnieuw te proberen of neem contact op met de ondersteuning voor verdere hulp.",
    captcha_unavailable: "Aanmelding mislukt vanwege mislukte botvalidatie. Vernieuw de pagina om het opnieuw te proberen of neem contact op met de ondersteuning voor verdere hulp.",
    form_code_incorrect: "De ingevoerde code is incorrect.",
    form_identifier_exists__email_address: "Dit e-mailadres is al in gebruik.",
    form_identifier_exists__phone_number: "Dit telefoonnummer is al in gebruik.",
    form_identifier_exists__username: "Deze gebruikersnaam is al in gebruik.",
    form_identifier_not_found: "Dit identificerende gegeven kan niet worden gevonden.",
    form_param_format_invalid: "Het formaat van het ingevoerde gegeven is ongeldig.",
    form_param_format_invalid__email_address: "E-mailadres moet een geldig e-mailadres zijn.",
    form_param_format_invalid__phone_number: "Telefoonnummer moet een geldig internationaal nummer zijn.",
    form_param_max_length_exceeded__first_name: "Voornaam moet minder dan 256 tekens bevatten.",
    form_param_max_length_exceeded__last_name: "Achternaam moet minder dan 256 tekens bevatten.",
    form_param_max_length_exceeded__name: "Naam moet minder dan 256 tekens bevatten.",
    form_param_nil: "Dit veld mag niet leeg zijn.",
    form_param_value_invalid: "De waarde die je hebt ingevoerd is ongeldig.",
    form_password_incorrect: "Het wachtwoord is incorrect.",
    form_password_length_too_short: "Het wachtwoord is te kort.",
    form_password_not_strong_enough: "Je wachtwoord is niet sterk genoeg.",
    form_password_pwned: "Dit wachtwoord is in een datalek gevonden.",
    form_password_pwned__sign_in: "Als je dit wachtwoord elders gebruikt, moet je het wijzigen.",
    form_password_size_in_bytes_exceeded: "Je wachtwoord heeft het maximum aantal bytes overschreden, vermijd speciale tekens.",
    form_password_validation_failed: "Wachtwoord is incorrect.",
    form_username_invalid_character: "De gebruikersnaam bevat ongeldige tekens.",
    form_username_invalid_length: "De gebruikersnaam is te kort of te lang.",
    identification_deletion_failed: "Je kunt je laatste identificatie niet verwijderen.",
    not_allowed_access: "Toegang niet toegestaan.",
    organization_domain_blocked: "Het domein van de organisatie is geblokkeerd.",
    organization_domain_common: "Het domein van de organisatie is te algemeen.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Het lidmaatschapsquotum van de organisatie is overschreden.",
    organization_minimum_permissions_needed: "Minimale machtigingen vereist voor de organisatie.",
    passkey_already_exists: "Deze passkey bestaat al.",
    passkey_not_supported: "Passkeys worden niet ondersteund door deze browser.",
    passkey_pa_not_supported: "Passkeys worden niet ondersteund door deze browser.",
    passkey_registration_cancelled: "Passkey registratie is geannuleerd.",
    passkey_retrieval_cancelled: "Passkey ophalen is geannuleerd.",
    passwordComplexity: {
      maximumLength: "Wachtwoord moet minder dan 256 tekens bevatten.",
      minimumLength: "Wachtwoord moet minstens 8 tekens bevatten.",
      requireLowercase: "Wachtwoord moet minstens 1 kleine letter bevatten.",
      requireNumbers: "Wachtwoord moet minstens 1 cijfer bevatten.",
      requireSpecialCharacter: "Wachtwoord moet minstens 1 speciaal teken bevatten.",
      requireUppercase: "Wachtwoord moet minstens 1 hoofdletter bevatten.",
      sentencePrefix: "Wachtwoord moet minstens 1 speciaal teken bevatten."
    },
    phone_number_exists: "Dit telefoonnummer is al in gebruik. Probeer een ander nummer.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Je wachtwoord werkt, maar kan sterker zijn. Probeer meer tekens toe te voegen.",
      goodPassword: "Je wachtwoord voldoet aan alle vereisten.",
      notEnough: "Je wachtwoord is niet sterk genoeg.",
      suggestions: {
        allUppercase: "Zet een deel in hoofdletters, maar niet alle letters.",
        anotherWord: "Voeg meer woorden toe die minder vaak voorkomen.",
        associatedYears: "Vermijd jaartallen die met jou geassocieerd zijn.",
        capitalization: "Zet meer dan de eerste letter in hoofdletter.",
        dates: "Vermijd data en jaartallen die met jou geassocieerd zijn.",
        l33t: "Vermijd voorspelbare vervangingen, zoals '@' voor 'a'.",
        longerKeyboardPattern: "Gebruik langere toetsenbord patronen, en wissel meerdere keren van richting.",
        noNeed: "Je kan ook een sterk wachtwoord maken zonder speciale tekens, hoofdletters of nummers.",
        pwned: "Als u dit wachtwoord elders gebruikt, moet u het veranderen.",
        recentYears: "Vermijd recente jaartallen.",
        repeated: "Vermijd herhalende woorden en letters.",
        reverseWords: "Vermijd het omdraaien van veelvoorkomende woorden.",
        sequences: "Vermijd veelvoorkomende tekstreeksen.",
        useWords: "Gebruik meerdere woorden, maar vermijd veelvoorkomende zinnen."
      },
      warnings: {
        common: "Dit wachtwoord wordt veel gebruikt.",
        commonNames: "Veelvoorkomende voor- en achternamen zijn makkelijk te raden.",
        dates: "Datums zijn makkelijk te raden.",
        extendedRepeat: 'Herhalende patronen zoals "abcabcabc" zijn makkelijk te raden.',
        keyPattern: "Korte toetsenbord patronen zijn makkelijk te raden.",
        namesByThemselves: "Voor- en achternamen op zich zijn makkelijk te raden.",
        pwned: "Dit wachtwoord is in een datalek gevonden.",
        recentYears: "Recente jaartallen zijn makkelijk te raden.",
        sequences: 'Veelvoorkomende tekstreeksen zoals "abc" zijn makkelijk te raden.',
        similarToCommon: "Dit lijkt op een veelvoorkomend wachtwoord.",
        simpleRepeat: 'Herhalende letters zoals "aaa" zijn makkelijk te raden.',
        straightRow: "Opeenvolgende toetsen op jouw toetsenbord zijn makkelijk te raden.",
        topHundred: "Dit wachtwoord wordt erg veel gebruikt.",
        topTen: "Dit wachtwoord wordt heel erg veel gebruikt.",
        userInputs: "Vermijd persoonlijke of website gerelateerde woorden.",
        wordByItself: "Woorden op zich zijn makkelijk te raden."
      }
    }
  },
  userButton: {
    action__addAccount: "Account toevoegen",
    action__manageAccount: "Account beheren",
    action__signOut: "Uitloggen",
    action__signOutAll: "Uitloggen uit alle accounts"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Gekopieerd!",
      actionLabel__copy: "Kopieer",
      actionLabel__download: "Download .txt",
      actionLabel__print: "Print",
      infoText1: "Backupcodes zullen voor dit account ingeschakeld zijn.",
      infoText2: "Houd de backupcodes geheim en bewaar ze veilig. U kunt backupcodes opnieuw genereren als u vermoedt dat ze zijn aangetast.",
      subtitle__codelist: "Sla ze veilig op en hou ze geheim.",
      successMessage: "Backupcodes zijn nu ingeschakeld. U kunt er een van gebruiken om in te loggen op uw account als u geen toegang meer heeft tot uw authenticatieapparaat. Elke code kan maar \xE9\xE9n keer gebruikt worden.",
      successSubtitle: "Je kunt \xE9\xE9n van deze gebruiken om in te loggen op je account als je geen toegang meer hebt tot je authenticatieapparaat.",
      title: "Voeg backup code verificatie toe",
      title__codelist: "Backup codes"
    },
    connectedAccountPage: {
      formHint: "Kies een provider om je account te verbinden.",
      formHint__noAccounts: "Er zijn geen beschikbare externe accountproviders.",
      removeResource: {
        messageLine1: "{{identifier}} zal verwijderd worden uit dit account.",
        messageLine2: "Je kunt deze verbonden account niet meer gebruiken en afhankelijke functies zullen niet meer werken.",
        successMessage: "{{connectedAccount}} is verwijderd uit je account.",
        title: "Verwijder externe account"
      },
      socialButtonsBlockButton: "Verbind {{provider|titleize}} account",
      successMessage: "Deze provider is toegevoegd aan je account.",
      title: "Verbind externe account"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "Delete account",
      messageLine1: "Are you sure you want to delete your account?",
      messageLine2: "This action is permanent and irreversible.",
      title: "Delete account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Een mail met daarin een verificatiecode is verstuurd naar dit adres.",
        formSubtitle: "Voer de verificatiecode in die verstuurd is naar {{identifier}}",
        formTitle: "Verificatiecode",
        resendButton: "Verstuur code opnieuw",
        successMessage: "Het e-mailadres {{identifier}} is toegevoegd aan je account."
      },
      emailLink: {
        formHint: "Een mail met daarin een verificatielink is verstuurd naar dit adres.",
        formSubtitle: "Klik op de verificatielink die verstuurd is naar {{identifier}}",
        formTitle: "Verificatielink",
        resendButton: "Verstuur link opnieuw",
        successMessage: "Het e-mailadres {{identifier}} is toegevoegd aan je account."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} zal verwijderd worden uit dit account.",
        messageLine2: "Je zal niet meer kunnen inloggen met dit e-mailadres.",
        successMessage: "{{emailAddress}} is verwijderd uit je account.",
        title: "Verwijder e-mailadres"
      },
      title: "E-mailadres toevoegen",
      verifyTitle: "E-mailadres bevestigen"
    },
    formButtonPrimary__add: "Toevoegen",
    formButtonPrimary__continue: "Doorgaan",
    formButtonPrimary__finish: "Afronden",
    formButtonPrimary__remove: "Verwijderen",
    formButtonPrimary__save: "Opslaan",
    formButtonReset: "Annuleren",
    mfaPage: {
      formHint: "Kies een methode om toe te voegen.",
      title: "Tweestapsverificatie toevoegen"
    },
    mfaPhoneCodePage: {
      backButton: "Gebruik bestaand nummer",
      primaryButton__addPhoneNumber: "Telefoonnummer toevoegen",
      removeResource: {
        messageLine1: "{{identifier}} zal niet langer verificatiecodes ontvangen bij het inloggen.",
        messageLine2: "Uw account is mogelijk niet zo veilig. Weet je zeker dat je door wilt gaan?",
        successMessage: "SMS-code tweestapsverificatie is verwijderd voor {{mfaPhoneCode}}",
        title: "Verwijder tweestapsverificatie"
      },
      subtitle__availablePhoneNumbers: "Selecteer een telefoonnummer om je te registreren voor SMS-code twee-stapsverificatie.",
      subtitle__unavailablePhoneNumbers: "Er zijn geen beschikbare telefoonnummers om te registreren voor SMS-code tweestapsverificatie.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Sla deze backup codes op en bewaar ze ergens veilig. Als je toegang kwijtraakt tot je authenticatieapparaat, kun je de backup codes gebruiken om in te loggen.",
      successTitle: "SMS-code verificatie ingeschakeld",
      title: "Voeg SMS-code verificatie toe"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Een tweede optie, scan de QR-code",
        buttonUnableToScan__nonPrimary: "Kan je de code niet scannen?",
        infoText__ableToScan: "Scan de QR-code met je authenticator app om de authenticator toe te voegen.",
        infoText__unableToScan: "Stel een nieuwe aanmeldmethode in op je authenticator en voer de onderstaande sleutel in.",
        inputLabel__unableToScan1: "Zorg ervoor dat tijdsgebaseerde of eenmalige wachtwoorden zijn ingeschakeld, en voltooi vervolgens het koppelen van uw account.",
        inputLabel__unableToScan2: "Als je authenticator TOTP-URI's ondersteunt, kun je ook de volledige URI kopi\xEBren."
      },
      removeResource: {
        messageLine1: "Verificatiecodes van deze authenticator zullen niet langer vereist zijn bij het inloggen.",
        messageLine2: "Uw account is mogelijk niet zo veilig. Weet je zeker dat je door wilt gaan?",
        successMessage: "Tweestapsverificatie via authenticator-applicatie is verwijderd.",
        title: "Verwijder tweestapsverificatie"
      },
      successMessage: "Tweestapsverificatie is nu ingesteld. Bij het inloggen zal je een verificatiecode van je authenticator app moeten invoeren.",
      title: "Voeg authenticator toe",
      verifySubtitle: "Voer de verificatiecode in die je authenticator app heeft gegenereerd.",
      verifyTitle: "Verificatiecode"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profiel",
      description: "Beheer je account informatie.",
      security: "Beveiliging",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} zal verwijderd worden uit dit account.",
        title: "Verwijder passkey"
      },
      subtitle__rename: "Je kunt de naam van de passkey wijzigen om deze gemakkelijker te vinden.",
      title__rename: "Passkey hernoemen"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Het is aanbevolen om uit te loggen van alle andere apparaten die mogelijk gebruik hebben gemaakt van je oude wachtwoord.",
      readonly: "Je wachtwoord kan momenteel niet worden gewijzigd omdat je alleen via de enterprise connectie kunt inloggen.",
      successMessage__set: "Je wachtwoord is ingesteld.",
      successMessage__signOutOfOtherSessions: "Alle andere apparaten zijn uitgelogd.",
      successMessage__update: "Je wachtwoord is bijgewerkt.",
      title__set: "Stel wachtwoord in",
      title__update: "Wachtwoord wijzigen"
    },
    phoneNumberPage: {
      infoText: "Een SMS met daarin een verificatiecode is verstuurd naar dit nummer.",
      removeResource: {
        messageLine1: "{{identifier}} zal van dit account verwijderd worden.",
        messageLine2: "Je zal niet meer kunnen inloggen met dit telefoonnummer.",
        successMessage: "{{phoneNumber}} is verwijderd uit je account.",
        title: "Verwijder telefoonnummer"
      },
      successMessage: "{{phoneNumber}} is toegevoegd aan je account.",
      title: "Telefoonnummer toevoegen",
      verifySubtitle: "Voer de verificatiecode in die verstuurd is naar {{phoneNumber}}",
      verifyTitle: "Verifieer telefoonnummer"
    },
    profilePage: {
      fileDropAreaHint: "Upload een JPG, PNG, GIF, of WEBP afbeelding kleiner dan 10 MB",
      imageFormDestructiveActionSubtitle: "Verwijder afbeelding",
      imageFormSubtitle: "Afbeelding uploaden",
      imageFormTitle: "Profielfoto",
      readonly: "Je profiel informatie is verstrekt door de enterprise connectie en kan niet worden bewerkt.",
      successMessage: "Je profiel is bijgewerkt.",
      title: "Profiel bijwerken"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Log uit op apparaat",
        title: "Actieve apparaten"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Probeer opnieuw",
        actionLabel__reauthorize: "Authoriseer nu",
        destructiveActionTitle: "Verwijderen",
        primaryButton: "Verbind een account",
        subtitle__disconnected: "Je account is losgekoppeld. Verbind het opnieuw om verder te gaan.",
        subtitle__reauthorize: "De vereiste scopes zijn bijgewerkt, en je kunt mogelijk beperkte functionaliteit ervaren. Autoriseer deze toepassing opnieuw om problemen te voorkomen.",
        title: "Aangesloten accounts"
      },
      dangerSection: {
        deleteAccountButton: "Verwijder account",
        title: "Account be\xEBindigen"
      },
      emailAddressesSection: {
        destructiveAction: "Verwijder e-mailadres",
        detailsAction__nonPrimary: "Stel in als hoofd",
        detailsAction__primary: "Rond verificatie af",
        detailsAction__unverified: "Rond verificatie af",
        primaryButton: "Voeg een e-mailadres toe",
        title: "E-mailadressen"
      },
      enterpriseAccountsSection: {
        title: "Bedrijfsaccounts"
      },
      headerTitle__account: "Account",
      headerTitle__security: "Beveiliging",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Codes hergenereren",
          headerTitle: "Backupcodes",
          subtitle__regenerate: "Genereer een nieuwe set backupcodes. De vorige kunnen niet meer gebruikt worden.",
          title__regenerate: "Backupcodes hergenereren"
        },
        phoneCode: {
          actionLabel__setDefault: "Stel in als standaard",
          destructiveActionLabel: "Verwijder tweestapsverificatie"
        },
        primaryButton: "Tweestapsverificatie instellen",
        title: "Tweestapsverificatie",
        totp: {
          destructiveActionTitle: "Verwijderen",
          headerTitle: "Authenticatorapplicatie"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Verwijderen",
        menuAction__rename: "Hernoemen",
        primaryButton: void 0,
        title: "Passkeys"
      },
      passwordSection: {
        primaryButton__setPassword: "Wachtwoord instellen",
        primaryButton__updatePassword: "Wachtwoord wijzigen",
        title: "Wachtwoord"
      },
      phoneNumbersSection: {
        destructiveAction: "Verwijder telefoonnummer",
        detailsAction__nonPrimary: "Stel in als hoofd",
        detailsAction__primary: "Rond verificatie af",
        detailsAction__unverified: "Rond verificatie af",
        primaryButton: "Voeg een telefoonnummer toe",
        title: "Telefoonnummers"
      },
      profileSection: {
        primaryButton: "Profiel bijwerken",
        title: "Profiel"
      },
      usernameSection: {
        primaryButton__setUsername: "Stel gebruikersnaam in",
        primaryButton__updateUsername: "Wijzig gebruikersnaam",
        title: "Gebruikersnaam"
      },
      web3WalletsSection: {
        destructiveAction: "Verwijder portefeuille",
        primaryButton: "Web3 portefeuilles",
        title: "Web3 portefeuilles"
      }
    },
    usernamePage: {
      successMessage: "Je gebruikersnaam is bijgewerkt.",
      title__set: "Gebruikersnaam bijwerken",
      title__update: "Gebruikersnaam bijwerken"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} zal verwijderd worden uit dit account.",
        messageLine2: "Je zal niet meer kunnen inloggen met deze web3 portefeuille.",
        successMessage: "{{web3Wallet}} is verwijderd uit je account.",
        title: "Verwijder web3 portefeuille"
      },
      subtitle__availableWallets: "Selecteer een web3 portefeuille om toe te voegen.",
      subtitle__unavailableWallets: "Er zijn geen beschikbare web3 portefeuilles.",
      successMessage: "De portefeuille is toegevoegd aan dit account.",
      title: "Web3 portefeuille toevoegen.",
      web3WalletButtonsBlockButton: "Voeg een Web3-portefeuille toe"
    }
  },
  waitlist: {
    start: {
      actionLink: "Neem deel aan de wachtlijst",
      actionText: "Nog geen account?",
      formButton: "Verstuur",
      subtitle: "Je wordt toegevoegd aan de wachtlijst en op de hoogte gehouden.",
      title: "Wachtlijst aanmelding"
    },
    success: {
      message: "Je bent succesvol toegevoegd aan de wachtlijst!",
      subtitle: "Je ontvangt een bericht zodra er ruimte beschikbaar is.",
      title: "Succes!"
    }
  }
};

// src/ja-JP.ts
var jaJP = {
  locale: "ja-JP",
  backButton: "\u623B\u308B",
  badge__default: "\u30C7\u30D5\u30A9\u30EB\u30C8",
  badge__otherImpersonatorDevice: "\u4ED6\u306E\u6A21\u5023\u8005\u30C7\u30D0\u30A4\u30B9",
  badge__primary: "\u30D7\u30E9\u30A4\u30DE\u30EA",
  badge__requiresAction: "\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u5FC5\u8981",
  badge__thisDevice: "\u3053\u306E\u30C7\u30D0\u30A4\u30B9",
  badge__unverified: "\u672A\u78BA\u8A8D",
  badge__userDevice: "\u30E6\u30FC\u30B6\u30FC\u30C7\u30D0\u30A4\u30B9",
  badge__you: "\u3042\u306A\u305F",
  createOrganization: {
    formButtonSubmit: "\u7D44\u7E54\u3092\u4F5C\u6210\u3059\u308B",
    invitePage: {
      formButtonReset: "\u30B9\u30AD\u30C3\u30D7"
    },
    title: "\u7D44\u7E54\u306E\u4F5C\u6210"
  },
  dates: {
    lastDay: "\u6628\u65E5\u306E{{ date | timeString('ja-JP') }}\u306B",
    next6Days: "{{ date | weekday('ja-JP','long') }}\u306E{{ date | timeString('ja-JP') }}\u306B",
    nextDay: "\u660E\u65E5\u306E{{ date | timeString('ja-JP') }}\u306B",
    numeric: "{{ date | numeric('ja-JP') }}\u306B",
    previous6Days: "{{ date | weekday('ja-JP','long') }}\u306E{{ date | timeString('ja-JP') }}\u306B",
    sameDay: "\u4ECA\u65E5\u306E{{ date | timeString('ja-JP') }}\u306B"
  },
  dividerText: "\u307E\u305F\u306F",
  footerActionLink__useAnotherMethod: "\u5225\u306E\u65B9\u6CD5\u3092\u4F7F\u7528\u3059\u308B",
  footerPageLink__help: "\u30D8\u30EB\u30D7",
  footerPageLink__privacy: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC",
  footerPageLink__terms: "\u5229\u7528\u898F\u7D04",
  formButtonPrimary: "\u7D9A\u3051\u308B",
  formButtonPrimary__verify: "\u78BA\u8A8D\u3059\u308B",
  formFieldAction__forgotPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u3067\u3059\u304B\uFF1F",
  formFieldError__matchingPasswords: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u3059\u3002",
  formFieldError__notMatchingPasswords: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002",
  formFieldError__verificationLinkExpired: "\u691C\u8A3C\u30EA\u30F3\u30AF\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002\u65B0\u3057\u3044\u30EA\u30F3\u30AF\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  formFieldHintText__optional: "\u4EFB\u610F",
  formFieldHintText__slug: "\u30B9\u30E9\u30B0\u306F\u4EBA\u9593\u304C\u8AAD\u3081\u308B\u30E6\u30CB\u30FC\u30AF\u306AID\u3067\u3059\u3002URL\u3067\u826F\u304F\u4F7F\u308F\u308C\u307E\u3059\u3002",
  formFieldInputPlaceholder__backupCode: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664",
  formFieldInputPlaceholder__emailAddress: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  formFieldInputPlaceholder__emailAddress_username: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u30E6\u30FC\u30B6\u30FC\u540D",
  formFieldInputPlaceholder__emailAddresses: "\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30AB\u30F3\u30DE\u3067\u533A\u5207\u3063\u3066\u30011\u3064\u4EE5\u4E0A\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u307E\u305F\u306F\u8CBC\u308A\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044",
  formFieldInputPlaceholder__firstName: "\u540D",
  formFieldInputPlaceholder__lastName: "\u59D3",
  formFieldInputPlaceholder__organizationDomain: "\u7D44\u7E54\u30C9\u30E1\u30A4\u30F3",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "\u7D44\u7E54\u30C9\u30E1\u30A4\u30F3\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  formFieldInputPlaceholder__organizationName: "\u7D44\u7E54\u540D",
  formFieldInputPlaceholder__organizationSlug: "my-organization",
  formFieldInputPlaceholder__password: "\u30D1\u30B9\u30EF\u30FC\u30C9",
  formFieldInputPlaceholder__phoneNumber: "\u96FB\u8A71\u756A\u53F7",
  formFieldInputPlaceholder__username: "\u30E6\u30FC\u30B6\u30FC\u540D",
  formFieldLabel__automaticInvitations: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u306E\u81EA\u52D5\u62DB\u5F85\u3092\u6709\u52B9\u306B\u3059\u308B",
  formFieldLabel__backupCode: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9",
  formFieldLabel__confirmDeletion: "\u524A\u9664\u306E\u78BA\u8A8D",
  formFieldLabel__confirmPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
  formFieldLabel__currentPassword: "\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9",
  formFieldLabel__emailAddress: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  formFieldLabel__emailAddress_username: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u30E6\u30FC\u30B6\u30FC\u540D",
  formFieldLabel__emailAddresses: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  formFieldLabel__firstName: "\u540D",
  formFieldLabel__lastName: "\u59D3",
  formFieldLabel__newPassword: "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
  formFieldLabel__organizationDomain: "\u30C9\u30E1\u30A4\u30F3",
  formFieldLabel__organizationDomainDeletePending: "\u4FDD\u7559\u4E2D\u306E\u62DB\u5F85\u3068\u63D0\u6848\u3092\u524A\u9664",
  formFieldLabel__organizationDomainEmailAddress: "\u78BA\u8A8D\u7528\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u306E\u30B3\u30FC\u30C9\u3092\u53D7\u3051\u53D6\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  formFieldLabel__organizationName: "\u7D44\u7E54\u540D",
  formFieldLabel__organizationSlug: "\u30B9\u30E9\u30B0URL",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u30D1\u30B9\u30EF\u30FC\u30C9",
  formFieldLabel__phoneNumber: "\u96FB\u8A71\u756A\u53F7",
  formFieldLabel__role: "\u5F79\u5272",
  formFieldLabel__signOutOfOtherSessions: "\u4ED6\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8",
  formFieldLabel__username: "\u30E6\u30FC\u30B6\u30FC\u540D",
  impersonationFab: {
    action__signOut: "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8",
    title: "{{identifier}}\u3068\u3057\u3066\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\u7BA1\u7406\u8005",
  membershipRole__basicMember: "\u30E1\u30F3\u30D0\u30FC",
  membershipRole__guestMember: "\u30B2\u30B9\u30C8",
  organizationList: {
    action__createOrganization: "\u7D44\u7E54\u3092\u4F5C\u6210\u3059\u308B",
    action__invitationAccept: "\u53C2\u52A0\u3059\u308B",
    action__suggestionsAccept: "\u53C2\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B",
    createOrganization: "\u7D44\u7E54\u3092\u4F5C\u6210",
    invitationAcceptedLabel: "\u53C2\u52A0\u3057\u307E\u3057\u305F",
    subtitle: "{{applicationName}}",
    suggestionsAcceptedLabel: "\u627F\u8A8D\u5F85\u3061",
    title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9078\u629E",
    titleWithoutPersonal: "\u7D44\u7E54\u3092\u9078\u629E"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u81EA\u52D5\u62DB\u5F85",
    badge__automaticSuggestion: "\u81EA\u52D5\u30B5\u30B8\u30A7\u30B9\u30C8",
    badge__manualInvitation: "\u81EA\u52D5\u767B\u9332\u306A\u3057",
    badge__unverified: "\u672A\u627F\u8A8D",
    createDomainPage: {
      subtitle: "\u30C9\u30E1\u30A4\u30F3\u3092\u8FFD\u52A0\u3057\u3066\u691C\u8A3C\u3057\u307E\u3059\u3002\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u81EA\u52D5\u7684\u306B\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u304B\u3001\u53C2\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
      title: "\u30C9\u30E1\u30A4\u30F3\u3092\u8FFD\u52A0"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u62DB\u5F85\u72B6\u3092\u9001\u4FE1\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u4EE5\u4E0B\u3092\u4FEE\u6B63\u3057\u3066\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044:",
      formButtonPrimary__continue: "\u62DB\u5F85\u72B6\u3092\u9001\u4FE1\u3059\u308B",
      selectDropdown__role: "\u5F79\u5272\u3092\u9078\u629E",
      subtitle: "\u3053\u306E\u7D44\u7E54\u306B\u65B0\u3057\u3044\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3059\u308B",
      successMessage: "\u62DB\u5F85\u72B6\u304C\u6B63\u5E38\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
      title: "\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85"
    },
    membersPage: {
      action__invite: "\u62DB\u5F85",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u30E1\u30F3\u30D0\u30FC\u306E\u524A\u9664",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u53C2\u52A0\u65E5\u6642",
        tableHeader__role: "\u5F79\u5272",
        tableHeader__user: "\u30E6\u30FC\u30B6\u30FC"
      },
      detailsTitle__emptyRow: "\u8868\u793A\u3059\u308B\u30E1\u30F3\u30D0\u30FC\u306F\u3042\u308A\u307E\u305B\u3093",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u30E1\u30FC\u30EB\u30C9\u30E1\u30A4\u30F3\u3092\u7D44\u7E54\u306B\u63A5\u7D9A\u3059\u308B\u3053\u3068\u3067\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u307E\u3059\u3002\u4E00\u81F4\u3059\u308B\u30E1\u30FC\u30EB\u30C9\u30E1\u30A4\u30F3\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u3044\u3064\u3067\u3082\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
          headerTitle: "\u81EA\u52D5\u62DB\u5F85",
          primaryButton: "\u691C\u8A3C\u6E08\u307F\u30C9\u30E1\u30A4\u30F3\u3092\u7BA1\u7406"
        },
        table__emptyRow: "\u8868\u793A\u3059\u308B\u62DB\u5F85\u306F\u3042\u308A\u307E\u305B\u3093"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u62DB\u5F85\u3092\u53D6\u308A\u6D88\u3059",
        tableHeader__invited: "\u62DB\u5F85\u6E08\u307F"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u4E00\u81F4\u3059\u308B\u30E1\u30FC\u30EB\u30C9\u30E1\u30A4\u30F3\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u3078\u306E\u53C2\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u63D0\u6848\u3092\u53D7\u3051\u53D6\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
          headerTitle: "\u81EA\u52D5\u63D0\u6848",
          primaryButton: "\u691C\u8A3C\u6E08\u307F\u30C9\u30E1\u30A4\u30F3\u3092\u7BA1\u7406"
        },
        menuAction__approve: "\u627F\u8A8D",
        menuAction__reject: "\u62D2\u5426",
        tableHeader__requested: "\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u307E\u3057\u305F",
        table__emptyRow: "\u8868\u793A\u3059\u308B\u30EA\u30AF\u30A8\u30B9\u30C8\u306F\u3042\u308A\u307E\u305B\u3093"
      },
      start: {
        headerTitle__invitations: "\u62DB\u5F85",
        headerTitle__members: "\u30E1\u30F3\u30D0\u30FC",
        headerTitle__requests: "\u30EA\u30AF\u30A8\u30B9\u30C8"
      }
    },
    navbar: {
      description: "\u7D44\u7E54\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002",
      general: "\u4E00\u822C",
      members: "\u30E1\u30F3\u30D0\u30FC",
      title: "\u7D44\u7E54"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: '\u7D9A\u884C\u3059\u308B\u306B\u306F "{{organizationName}}" \u3068\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
          messageLine1: "\u3053\u306E\u7D44\u7E54\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
          messageLine2: "\u3053\u306E\u64CD\u4F5C\u306F\u6C38\u4E45\u7684\u3067\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
          successMessage: "\u7D44\u7E54\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
          title: "\u7D44\u7E54\u306E\u524A\u9664"
        },
        leaveOrganization: {
          actionDescription: '\u7D9A\u884C\u3059\u308B\u306B\u306F "{{organizationName}}" \u3068\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
          messageLine1: "\u3053\u306E\u7D44\u7E54\u304B\u3089\u8131\u9000\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u3053\u306E\u7D44\u7E54\u3068\u305D\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u5931\u308F\u308C\u307E\u3059\u3002",
          messageLine2: "\u3053\u306E\u64CD\u4F5C\u306F\u6C38\u4E45\u7684\u3067\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
          successMessage: "\u7D44\u7E54\u304B\u3089\u8131\u9000\u3057\u307E\u3057\u305F\u3002",
          title: "\u7D44\u7E54\u3092\u8131\u9000"
        },
        title: "\u6CE8\u610F"
      },
      domainSection: {
        menuAction__manage: "\u7BA1\u7406",
        menuAction__remove: "\u524A\u9664",
        menuAction__verify: "\u691C\u8A3C",
        primaryButton: "\u30C9\u30E1\u30A4\u30F3\u3092\u8FFD\u52A0",
        subtitle: "\u691C\u8A3C\u6E08\u307F\u306E\u30E1\u30FC\u30EB\u30C9\u30E1\u30A4\u30F3\u306B\u57FA\u3065\u3044\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u81EA\u52D5\u7684\u306B\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u304B\u3001\u53C2\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3053\u3068\u3092\u8A31\u53EF\u3057\u307E\u3059\u3002",
        title: "\u691C\u8A3C\u6E08\u307F\u30C9\u30E1\u30A4\u30F3"
      },
      successMessage: "\u7D44\u7E54\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002",
      title: "\u7D44\u7E54\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB"
    },
    removeDomainPage: {
      messageLine1: "\u30E1\u30FC\u30EB\u30C9\u30E1\u30A4\u30F3 {{domain}} \u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
      messageLine2: "\u3053\u306E\u5F8C\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u81EA\u52D5\u7684\u306B\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
      successMessage: "{{domain}} \u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
      title: "\u30C9\u30E1\u30A4\u30F3\u306E\u524A\u9664"
    },
    start: {
      headerTitle__general: "\u4E00\u822C",
      headerTitle__members: "\u30E1\u30F3\u30D0\u30FC",
      profileSection: {
        primaryButton: void 0,
        title: "\u7D44\u7E54\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
        uploadAction__title: "\u30ED\u30B4"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u62DB\u5F85\u3055\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u306B\u5F71\u97FF\u304C\u51FA\u307E\u3059\u3002",
        removeDomainActionLabel__remove: "\u30C9\u30E1\u30A4\u30F3\u3092\u524A\u9664",
        removeDomainSubtitle: "\u691C\u8A3C\u6E08\u307F\u30C9\u30E1\u30A4\u30F3\u304B\u3089\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u524A\u9664\u3057\u307E\u3059",
        removeDomainTitle: "\u30C9\u30E1\u30A4\u30F3\u306E\u524A\u9664"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u30B5\u30A4\u30F3\u30A2\u30C3\u30D7\u6642\u306B\u30E6\u30FC\u30B6\u30FC\u306F\u81EA\u52D5\u7684\u306B\u7D44\u7E54\u306B\u62DB\u5F85\u3055\u308C\u3001\u3044\u3064\u3067\u3082\u53C2\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
        automaticInvitationOption__label: "\u81EA\u52D5\u62DB\u5F85",
        automaticSuggestionOption__description: "\u30E6\u30FC\u30B6\u30FC\u306F\u7D44\u7E54\u3078\u306E\u53C2\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u63D0\u6848\u3092\u53D7\u3051\u53D6\u308A\u307E\u3059\u304C\u3001\u53C2\u52A0\u3059\u308B\u524D\u306B\u7BA1\u7406\u8005\u306E\u627F\u8A8D\u304C\u5FC5\u8981\u3067\u3059\u3002",
        automaticSuggestionOption__label: "\u81EA\u52D5\u63D0\u6848",
        calloutInfoLabel: "\u65B0\u3057\u3044\u30E6\u30FC\u30B6\u30FC\u306B\u306E\u307F\u767B\u9332\u30E2\u30FC\u30C9\u306E\u5909\u66F4\u304C\u5F71\u97FF\u3057\u307E\u3059\u3002",
        calloutInvitationCountLabel: "\u30E6\u30FC\u30B6\u30FC\u306B\u9001\u4FE1\u3055\u308C\u305F\u4FDD\u7559\u4E2D\u306E\u62DB\u5F85\u72B6: {{count}}",
        calloutSuggestionCountLabel: "\u30E6\u30FC\u30B6\u30FC\u306B\u9001\u4FE1\u3055\u308C\u305F\u4FDD\u7559\u4E2D\u306E\u63D0\u6848: {{count}}",
        manualInvitationOption__description: "\u30E6\u30FC\u30B6\u30FC\u306F\u7D44\u7E54\u306B\u624B\u52D5\u3067\u62DB\u5F85\u3055\u308C\u308B\u3053\u3068\u306E\u307F\u304C\u53EF\u80FD\u3067\u3059\u3002",
        manualInvitationOption__label: "\u81EA\u52D5\u767B\u9332\u306A\u3057",
        subtitle: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
      },
      start: {
        headerTitle__danger: "\u5371\u967A",
        headerTitle__enrollment: "\u767B\u9332\u30AA\u30D7\u30B7\u30E7\u30F3"
      },
      subtitle: "\u30C9\u30E1\u30A4\u30F3 {{domain}} \u304C\u691C\u8A3C\u3055\u308C\u307E\u3057\u305F\u3002\u767B\u9332\u30E2\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      title: "{{domain}} \u306E\u66F4\u65B0"
    },
    verifyDomainPage: {
      formSubtitle: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u9001\u4FE1\u3055\u308C\u305F\u691C\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      formTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: "\u30C9\u30E1\u30A4\u30F3 {{domainName}} \u306F\u30E1\u30FC\u30EB\u3067\u691C\u8A3C\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
      subtitleVerificationCodeScreen: "{{emailAddress}} \u306B\u691C\u8A3C\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      title: "\u30C9\u30E1\u30A4\u30F3\u3092\u691C\u8A3C"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u7D44\u7E54\u306E\u4F5C\u6210",
    action__invitationAccept: "\u53C2\u52A0\u3059\u308B",
    action__manageOrganization: "\u7D44\u7E54\u306E\u7BA1\u7406",
    action__suggestionsAccept: "\u53C2\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B",
    notSelected: "\u7D44\u7E54\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    personalWorkspace: "\u500B\u4EBA\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9",
    suggestionsAcceptedLabel: "\u627F\u8A8D\u5F85\u3061"
  },
  paginationButton__next: "\u6B21\u3078",
  paginationButton__previous: "\u524D\u3078",
  paginationRowText__displaying: "\u8868\u793A\u4E2D",
  paginationRowText__of: "\u5168",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u8FFD\u52A0",
      action__signOutAll: "\u5168\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8",
      subtitle: "\u7D9A\u884C\u3059\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9078\u629E"
    },
    alternativeMethods: {
      actionLink: "\u30D8\u30EB\u30D7\u3092\u53D6\u5F97",
      actionText: "\u3053\u308C\u3089\u306E\u3044\u305A\u308C\u3082\u6301\u3063\u3066\u3044\u307E\u305B\u3093\u304B\uFF1F",
      blockButton__backupCode: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u3092\u4F7F\u7528\u3059\u308B",
      blockButton__emailCode: "{{identifier}}\u306B\u30E1\u30FC\u30EB\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
      blockButton__emailLink: "{{identifier}}\u306B\u30E1\u30FC\u30EB\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
      blockButton__passkey: void 0,
      blockButton__password: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
      blockButton__phoneCode: "{{identifier}}\u306BSMS\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
      blockButton__totp: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3059\u308B",
      getHelp: {
        blockButton__emailSupport: "\u30E1\u30FC\u30EB\u30B5\u30DD\u30FC\u30C8",
        content: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3\u3067\u304D\u306A\u3044\u5834\u5408\u306F\u3001\u30E1\u30FC\u30EB\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u3044\u305F\u3060\u3051\u308C\u3070\u3001\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u30A2\u30AF\u30BB\u30B9\u3092\u56DE\u5FA9\u3059\u308B\u305F\u3081\u306B\u304A\u624B\u4F1D\u3044\u3044\u305F\u3057\u307E\u3059\u3002",
        title: "\u30D8\u30EB\u30D7\u3092\u53D6\u5F97"
      },
      subtitle: "\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u307E\u3059\u304B\uFF1F\u3053\u308C\u3089\u306E\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
      title: "\u5225\u306E\u65B9\u6CD5\u3092\u4F7F\u7528"
    },
    backupCodeMfa: {
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u3092\u5165\u529B"
    },
    emailCode: {
      formTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30E1\u30FC\u30EB\u3092\u78BA\u8A8D"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\u5143\u306E\u30BF\u30D6\u306B\u623B\u3063\u3066\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        title: "\u3053\u306E\u691C\u8A3C\u30EA\u30F3\u30AF\u306F\u671F\u9650\u5207\u308C\u3067\u3059"
      },
      failed: {
        subtitle: "\u5143\u306E\u30BF\u30D6\u306B\u623B\u3063\u3066\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        title: "\u3053\u306E\u691C\u8A3C\u30EA\u30F3\u30AF\u306F\u7121\u52B9\u3067\u3059"
      },
      formSubtitle: "\u30E1\u30FC\u30EB\u306B\u9001\u4FE1\u3055\u308C\u305F\u691C\u8A3C\u30EA\u30F3\u30AF\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044",
      formTitle: "\u691C\u8A3C\u30EA\u30F3\u30AF",
      loading: {
        subtitle: "\u307E\u3082\u306A\u304F\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3059",
        title: "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D..."
      },
      resendButton: "\u30EA\u30F3\u30AF\u3092\u518D\u9001\u4FE1",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30E1\u30FC\u30EB\u3092\u78BA\u8A8D",
      unusedTab: {
        title: "\u3053\u306E\u30BF\u30D6\u3092\u9589\u3058\u3066\u3082\u304B\u307E\u3044\u307E\u305B\u3093"
      },
      verified: {
        subtitle: "\u307E\u3082\u306A\u304F\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3059",
        title: "\u6B63\u5E38\u306B\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u307E\u3057\u305F"
      },
      verifiedSwitchTab: {
        subtitle: "\u7D9A\u884C\u3059\u308B\u306B\u306F\u5143\u306E\u30BF\u30D6\u306B\u623B\u3063\u3066\u304F\u3060\u3055\u3044",
        subtitleNewTab: "\u65B0\u3057\u304F\u958B\u3044\u305F\u30BF\u30D6\u306B\u623B\u3063\u3066\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044",
        titleNewTab: "\u4ED6\u306E\u30BF\u30D6\u3067\u30B5\u30A4\u30F3\u30A4\u30F3\u6E08\u307F"
      }
    },
    forgotPassword: {
      formTitle: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u305F\u3081\u306B",
      subtitle_email: "\u307E\u305A\u3001\u30E1\u30FC\u30EBID\u306B\u9001\u4FE1\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      subtitle_phone: "\u307E\u305A\u3001\u96FB\u8A71\u306B\u9001\u4FE1\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
      label__alternativeMethods: "\u307E\u305F\u306F\u3001\u5225\u306E\u65B9\u6CD5\u3067\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u3067\u3059\u304B\uFF1F"
    },
    noAvailableMethods: {
      message: "\u30B5\u30A4\u30F3\u30A4\u30F3\u3067\u304D\u307E\u305B\u3093\u3002\u5229\u7528\u53EF\u80FD\u306A\u8A8D\u8A3C\u65B9\u6CD5\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
      subtitle: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
      title: "\u30B5\u30A4\u30F3\u30A4\u30F3\u3067\u304D\u307E\u305B\u3093"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\u5225\u306E\u65B9\u6CD5\u3092\u4F7F\u7528",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: "{{applicationName}} \u3078\u306E\u7D9A\u884C\u306E\u305F\u3081",
      title: "\u96FB\u8A71\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044"
    },
    phoneCodeMfa: {
      formTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: void 0,
      title: "\u96FB\u8A71\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044"
    },
    resetPassword: {
      formButtonPrimary: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
      requiredMessage: "\u672A\u78BA\u8A8D\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u6301\u3064\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059\u3002\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u305F\u3081\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      successMessage: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u6B63\u5E38\u306B\u5909\u66F4\u3055\u308C\u307E\u3057\u305F\u3002\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3001\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u3002",
      title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8"
    },
    resetPasswordMfa: {
      detailsLabel: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u524D\u306B\u3001\u8EAB\u5143\u3092\u78BA\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"
    },
    start: {
      actionLink: "\u30B5\u30A4\u30F3\u30A2\u30C3\u30D7",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528",
      actionLink__use_email_username: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u4F7F\u7528",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "\u96FB\u8A71\u756A\u53F7\u3092\u4F7F\u7528",
      actionLink__use_username: "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u4F7F\u7528",
      actionText: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u3067\u3059\u304B\uFF1F",
      actionText__join_waitlist: void 0,
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      subtitleCombined: void 0,
      title: "\u30B5\u30A4\u30F3\u30A4\u30F3",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9",
      subtitle: void 0,
      title: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C"
    }
  },
  signInEnterPasswordTitle: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  signUp: {
    continue: {
      actionLink: "\u30B5\u30A4\u30F3\u30A4\u30F3",
      actionText: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u3059\u304B\uFF1F",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u672A\u5165\u529B\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u5165\u529B"
    },
    emailCode: {
      formSubtitle: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u9001\u4FE1\u3055\u308C\u305F\u78BA\u8A8D\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      formTitle: "\u78BA\u8A8D\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u9001\u4FE1\u3055\u308C\u305F\u78BA\u8A8D\u30EA\u30F3\u30AF\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044",
      formTitle: "\u78BA\u8A8D\u30EA\u30F3\u30AF",
      loading: {
        title: "\u767B\u9332\u4E2D..."
      },
      resendButton: "\u30EA\u30F3\u30AF\u3092\u518D\u9001\u4FE1",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D",
      verified: {
        title: "\u767B\u9332\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F"
      },
      verifiedSwitchTab: {
        subtitle: "\u7D9A\u884C\u3059\u308B\u305F\u3081\u306B\u65B0\u3057\u304F\u958B\u3044\u305F\u30BF\u30D6\u306B\u623B\u3063\u3066\u304F\u3060\u3055\u3044",
        subtitleNewTab: "\u7D9A\u884C\u3059\u308B\u305F\u3081\u306B\u524D\u306E\u30BF\u30D6\u306B\u623B\u3063\u3066\u304F\u3060\u3055\u3044",
        title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u6B63\u5E38\u306B\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\u96FB\u8A71\u756A\u53F7\u306B\u9001\u4FE1\u3055\u308C\u305F\u78BA\u8A8D\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      formTitle: "\u78BA\u8A8D\u30B3\u30FC\u30C9",
      resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u96FB\u8A71\u756A\u53F7\u3092\u78BA\u8A8D"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u30B5\u30A4\u30F3\u30A4\u30F3",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u3059\u304B\uFF1F",
      subtitle: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      subtitleCombined: "{{applicationName}}\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D9A\u3051\u308B",
      title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210",
      titleCombined: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210"
    }
  },
  socialButtonsBlockButton: "{{provider|titleize}}\u3067\u7D9A\u3051\u308B",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u691C\u8A3C\u306B\u5931\u6557\u3057\u305F\u305F\u3081\u3001\u30B5\u30A4\u30F3\u30A2\u30C3\u30D7\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u518D\u8A66\u884C\u3059\u308B\u304B\u3001\u30B5\u30DD\u30FC\u30C8\u30BB\u30F3\u30BF\u30FC\u306B\u9023\u7D61\u3057\u305F\u4E0A\u3067\u30B5\u30DD\u30FC\u30C8\u3092\u53D7\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
    captcha_unavailable: "\u30DC\u30C3\u30C8\u691C\u8A3C\u306B\u5931\u6557\u3057\u305F\u305F\u3081\u3001\u30B5\u30A4\u30F3\u30A2\u30C3\u30D7\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u518D\u8A66\u884C\u3059\u308B\u304B\u3001\u30B5\u30DD\u30FC\u30C8\u306B\u9023\u7D61\u3057\u3066\u3055\u3089\u306B\u652F\u63F4\u3092\u53D7\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
    form_code_incorrect: "\u30D5\u30A9\u30FC\u30E0\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: "\u8B58\u5225\u5B50\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    form_param_format_invalid: "\u30D1\u30E9\u30E1\u30FC\u30BF\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059\u3002",
    form_param_format_invalid__email_address: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    form_param_format_invalid__phone_number: "\u96FB\u8A71\u756A\u53F7\u306F\u6709\u52B9\u306A\u56FD\u969B\u5F62\u5F0F\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    form_param_max_length_exceeded__first_name: "\u6C0F\u540D\u306F256\u6587\u5B57\u3092\u8D85\u3048\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    form_param_max_length_exceeded__last_name: "\u59D3\u306F256\u6587\u5B57\u3092\u8D85\u3048\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    form_param_max_length_exceeded__name: "\u540D\u524D\u306F256\u6587\u5B57\u3092\u8D85\u3048\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    form_param_nil: "\u30D1\u30E9\u30E1\u30FC\u30BF\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    form_param_value_invalid: void 0,
    form_password_incorrect: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    form_password_length_too_short: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u9577\u3055\u304C\u77ED\u3059\u304E\u307E\u3059\u3002",
    form_password_not_strong_enough: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F37\u5EA6\u304C\u4E0D\u5341\u5206\u3067\u3059\u3002",
    form_password_pwned: "\u3053\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u4FB5\u5BB3\u306E\u4E00\u90E8\u3068\u3057\u3066\u898B\u3064\u304B\u3063\u305F\u305F\u3081\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u5225\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u30D0\u30A4\u30C8\u6570\u304C\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002\u77ED\u304F\u3059\u308B\u304B\u3001\u4E00\u90E8\u306E\u7279\u6B8A\u6587\u5B57\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    form_password_validation_failed: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059",
    form_username_invalid_character: "\u30E6\u30FC\u30B6\u30FC\u540D\u306B\u7121\u52B9\u306A\u6587\u5B57\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002",
    form_username_invalid_length: "\u30E6\u30FC\u30B6\u30FC\u540D\u306E\u9577\u3055\u304C\u7121\u52B9\u3067\u3059\u3002",
    identification_deletion_failed: "\u6700\u5F8C\u306E\u8B58\u5225\u60C5\u5831\u306F\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    not_allowed_access: "\u30A2\u30AF\u30BB\u30B9\u304C\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "{{length}}\u6587\u5B57\u672A\u6E80",
      minimumLength: "{{length}}\u6587\u5B57\u4EE5\u4E0A",
      requireLowercase: "\u5C0F\u6587\u5B57\u3092\u542B\u3080",
      requireNumbers: "\u6570\u5B57\u3092\u542B\u3080",
      requireSpecialCharacter: "\u7279\u6B8A\u6587\u5B57\u3092\u542B\u3080",
      requireUppercase: "\u5927\u6587\u5B57\u3092\u542B\u3080",
      sentencePrefix: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u6B21\u306E\u6761\u4EF6\u3092\u6E80\u305F\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\uFF1A"
    },
    phone_number_exists: "\u3053\u306E\u96FB\u8A71\u756A\u53F7\u306F\u65E2\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5225\u306E\u96FB\u8A71\u756A\u53F7\u3092\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u6709\u52B9\u3067\u3059\u304C\u3001\u3082\u3046\u5C11\u3057\u5F37\u5316\u3067\u304D\u307E\u3059\u3002\u6587\u5B57\u3092\u8FFD\u52A0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
      goodPassword: "\u7D20\u6674\u3089\u3057\u3044\u4ED5\u4E8B\u3067\u3059\u3002\u3053\u308C\u306F\u512A\u308C\u305F\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u3059\u3002",
      notEnough: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F37\u5EA6\u304C\u5341\u5206\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
      suggestions: {
        allUppercase: "\u5168\u3066\u306E\u6587\u5B57\u3092\u5927\u6587\u5B57\u306B\u3059\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u4E00\u90E8\u306E\u6587\u5B57\u3092\u5927\u6587\u5B57\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        anotherWord: "\u3088\u308A\u4E00\u822C\u7684\u3067\u306A\u3044\u5358\u8A9E\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        associatedYears: "\u81EA\u5206\u306B\u95A2\u9023\u3059\u308B\u5E74\u53F7\u306F\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        capitalization: "\u6700\u521D\u306E\u6587\u5B57\u4EE5\u5916\u3082\u5927\u6587\u5B57\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        dates: "\u81EA\u5206\u306B\u95A2\u9023\u3059\u308B\u65E5\u4ED8\u3084\u5E74\u53F7\u306F\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        l33t: "\u4E88\u6E2C\u53EF\u80FD\u306A\u6587\u5B57\u306E\u4EE3\u66FF\uFF08\u4F8B\uFF1A'@' \u3067 'a' \u3092\u7F6E\u304D\u63DB\u3048\u308B\uFF09\u3092\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        longerKeyboardPattern: "\u9577\u3044\u30AD\u30FC\u30DC\u30FC\u30C9\u30D1\u30BF\u30FC\u30F3\u3092\u4F7F\u7528\u3057\u3001\u30BF\u30A4\u30D4\u30F3\u30B0\u306E\u65B9\u5411\u3092\u8907\u6570\u56DE\u5909\u3048\u3066\u304F\u3060\u3055\u3044\u3002",
        noNeed: "\u30B7\u30F3\u30DC\u30EB\u3001\u6570\u5B57\u3001\u5927\u6587\u5B57\u306E\u4F7F\u7528\u306A\u3057\u3067\u3082\u5F37\u529B\u306A\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002",
        pwned: "\u4ED6\u306E\u5834\u6240\u3067\u3053\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u5909\u66F4\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
        recentYears: "\u6700\u8FD1\u306E\u5E74\u53F7\u306F\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        repeated: "\u7E70\u308A\u8FD4\u3055\u308C\u308B\u5358\u8A9E\u3084\u6587\u5B57\u3092\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        reverseWords: "\u4E00\u822C\u7684\u306A\u5358\u8A9E\u306E\u9006\u3055\u8AAD\u307F\u306F\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        sequences: "\u4E00\u822C\u7684\u306A\u6587\u5B57\u306E\u4E26\u3073\u3092\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
        useWords: "\u8907\u6570\u306E\u5358\u8A9E\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u304C\u3001\u4E00\u822C\u7684\u306A\u30D5\u30EC\u30FC\u30BA\u306F\u907F\u3051\u3066\u304F\u3060\u3055\u3044\u3002"
      },
      warnings: {
        common: "\u3053\u308C\u306F\u4E00\u822C\u7684\u306B\u4F7F\u308F\u308C\u308B\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u3059\u3002",
        commonNames: "\u4E00\u822C\u7684\u306A\u540D\u524D\u3084\u59D3\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        dates: "\u65E5\u4ED8\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        extendedRepeat: "\u300Cabcabcabc\u300D\u3068\u3044\u3063\u305F\u7E70\u308A\u8FD4\u3057\u30D1\u30BF\u30FC\u30F3\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        keyPattern: "\u77ED\u3044\u30AD\u30FC\u30DC\u30FC\u30C9\u30D1\u30BF\u30FC\u30F3\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        namesByThemselves: "\u5358\u4F53\u306E\u540D\u524D\u3084\u59D3\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        pwned: "\u3053\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u4E0A\u306E\u30C7\u30FC\u30BF\u4FB5\u5BB3\u306B\u3088\u3063\u3066\u516C\u958B\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
        recentYears: "\u6700\u8FD1\u306E\u5E74\u53F7\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        sequences: "\u300Cabc\u300D\u3068\u3044\u3063\u305F\u4E00\u822C\u7684\u306A\u6587\u5B57\u306E\u4E26\u3073\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        similarToCommon: "\u3053\u308C\u306F\u4E00\u822C\u7684\u306B\u4F7F\u308F\u308C\u308B\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u985E\u4F3C\u3057\u3066\u3044\u307E\u3059\u3002",
        simpleRepeat: "\u300Caaa\u300D\u3068\u3044\u3063\u305F\u7E70\u308A\u8FD4\u3057\u6587\u5B57\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        straightRow: "\u30AD\u30FC\u30DC\u30FC\u30C9\u4E0A\u306E\u9023\u7D9A\u3057\u305F\u884C\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002",
        topHundred: "\u3053\u308C\u306F\u983B\u7E41\u306B\u4F7F\u308F\u308C\u308B\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u3059\u3002",
        topTen: "\u3053\u308C\u306F\u3088\u304F\u4F7F\u308F\u308C\u308B\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u3059\u3002",
        userInputs: "\u500B\u4EBA\u60C5\u5831\u3084\u30DA\u30FC\u30B8\u306B\u95A2\u9023\u3059\u308B\u30C7\u30FC\u30BF\u306F\u542B\u307E\u308C\u3066\u3044\u306A\u3044\u306F\u305A\u3067\u3059\u3002",
        wordByItself: "\u5358\u8A9E\u5358\u4F53\u3067\u306F\u63A8\u6E2C\u3057\u3084\u3059\u3044\u3067\u3059\u3002"
      }
    }
  },
  userButton: {
    action__addAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u8FFD\u52A0",
    action__manageAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7BA1\u7406",
    action__signOut: "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8",
    action__signOutAll: "\u5168\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u30B3\u30D4\u30FC\u6E08\u307F\uFF01",
      actionLabel__copy: "\u3059\u3079\u3066\u30B3\u30D4\u30FC",
      actionLabel__download: ".txt\u3067\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
      actionLabel__print: "\u5370\u5237",
      infoText1: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u306F\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u304C\u6709\u52B9\u306B\u306A\u308A\u307E\u3059\u3002",
      infoText2: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u306F\u79D8\u5BC6\u306B\u4FDD\u7BA1\u3057\u3001\u5B89\u5168\u306B\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u7591\u308F\u3057\u3044\u5834\u5408\u306F\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u3092\u518D\u751F\u6210\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
      subtitle__codelist: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u3092\u5B89\u5168\u306B\u4FDD\u7BA1\u3057\u3001\u79D8\u5BC6\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      successMessage: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u304C\u6709\u52B9\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u8A8D\u8A3C\u30C7\u30D0\u30A4\u30B9\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u3044\u5834\u5408\u3001\u3053\u308C\u3089\u306E\u3044\u305A\u308C\u304B\u3092\u4F7F\u7528\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3\u3067\u304D\u307E\u3059\u3002\u5404\u30B3\u30FC\u30C9\u306F\u4E00\u5EA6\u3057\u304B\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
      successSubtitle: "\u8A8D\u8A3C\u30C7\u30D0\u30A4\u30B9\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u3044\u5834\u5408\u3001\u3053\u308C\u3089\u306E\u3044\u305A\u308C\u304B\u3092\u4F7F\u7528\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3\u3067\u304D\u307E\u3059\u3002",
      title: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u306E\u8FFD\u52A0",
      title__codelist: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9"
    },
    connectedAccountPage: {
      formHint: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9023\u643A\u3059\u308B\u30D7\u30ED\u30D0\u30A4\u30C0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      formHint__noAccounts: "\u5229\u7528\u53EF\u80FD\u306A\u5916\u90E8\u30A2\u30AB\u30A6\u30F3\u30C8\u30D7\u30ED\u30D0\u30A4\u30C0\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
      removeResource: {
        messageLine1: "{{identifier}}\u306F\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
        messageLine2: "\u3053\u306E\u9023\u643A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u3001\u95A2\u9023\u3059\u308B\u6A5F\u80FD\u3082\u4F7F\u7528\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        successMessage: "{{connectedAccount}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        title: "\u9023\u643A\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664"
      },
      socialButtonsBlockButton: "{{provider|titleize}}\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9023\u643A\u3059\u308B",
      successMessage: "\u30D7\u30ED\u30D0\u30A4\u30C0\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F",
      title: "\u9023\u643A\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u8FFD\u52A0"
    },
    deletePage: {
      actionDescription: "\u7D9A\u884C\u3059\u308B\u306B\u306F\u4E0B\u8A18\u306B\u300CDelete account\u300D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      confirm: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664",
      messageLine1: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
      messageLine2: "\u3053\u306E\u64CD\u4F5C\u306F\u6C38\u4E45\u7684\u3067\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
      title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u306F\u691C\u8A3C\u30B3\u30FC\u30C9\u304C\u542B\u307E\u308C\u305F\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002",
        formSubtitle: "{{identifier}}\u306B\u9001\u4FE1\u3055\u308C\u305F\u691C\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        formTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9",
        resendButton: "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
        successMessage: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9{{identifier}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002"
      },
      emailLink: {
        formHint: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u306F\u691C\u8A3C\u30EA\u30F3\u30AF\u304C\u542B\u307E\u308C\u305F\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002",
        formSubtitle: "{{identifier}}\u306B\u9001\u4FE1\u3055\u308C\u305F\u30E1\u30FC\u30EB\u306E\u691C\u8A3C\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        formTitle: "\u691C\u8A3C\u30EA\u30F3\u30AF",
        resendButton: "\u30EA\u30F3\u30AF\u3092\u518D\u9001\u4FE1",
        successMessage: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9{{identifier}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002"
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}}\u306F\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
        messageLine2: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u306E\u30B5\u30A4\u30F3\u30A4\u30F3\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        successMessage: "{{emailAddress}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u524A\u9664"
      },
      title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u8FFD\u52A0",
      verifyTitle: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u78BA\u8A8D"
    },
    formButtonPrimary__add: "\u8FFD\u52A0",
    formButtonPrimary__continue: "\u7D9A\u884C",
    formButtonPrimary__finish: "\u5B8C\u4E86",
    formButtonPrimary__remove: "\u524A\u9664",
    formButtonPrimary__save: "\u4FDD\u5B58",
    formButtonReset: "\u30AD\u30E3\u30F3\u30BB\u30EB",
    mfaPage: {
      formHint: "\u8FFD\u52A0\u3059\u308B\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      title: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u8FFD\u52A0"
    },
    mfaPhoneCodePage: {
      backButton: "\u65E2\u5B58\u306E\u756A\u53F7\u3092\u4F7F\u7528",
      primaryButton__addPhoneNumber: "\u96FB\u8A71\u756A\u53F7\u3092\u8FFD\u52A0",
      removeResource: {
        messageLine1: "{{identifier}}\u306F\u30B5\u30A4\u30F3\u30A4\u30F3\u6642\u306B\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u53D7\u3051\u53D6\u3089\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        messageLine2: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u4F4E\u4E0B\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u672C\u5F53\u306B\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
        successMessage: "{{mfaPhoneCode}}\u306ESMS\u30B3\u30FC\u30C9\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        title: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u524A\u9664"
      },
      subtitle__availablePhoneNumbers: "SMS\u30B3\u30FC\u30C9\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u305F\u3081\u306B\u767B\u9332\u3059\u308B\u96FB\u8A71\u756A\u53F7\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      subtitle__unavailablePhoneNumbers: "SMS\u30B3\u30FC\u30C9\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u305F\u3081\u306B\u5229\u7528\u53EF\u80FD\u306A\u96FB\u8A71\u756A\u53F7\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS\u30B3\u30FC\u30C9\u8A8D\u8A3C\u304C\u6709\u52B9\u306B\u306A\u308A\u307E\u3057\u305F",
      title: "SMS\u30B3\u30FC\u30C9\u8A8D\u8A3C\u306E\u8FFD\u52A0"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u4EE3\u308F\u308A\u306BQR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B",
        buttonUnableToScan__nonPrimary: "QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3067\u304D\u307E\u305B\u3093\u304B\uFF1F",
        infoText__ableToScan: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u3067\u65B0\u3057\u3044\u30B5\u30A4\u30F3\u30A4\u30F3\u65B9\u6CD5\u3092\u8A2D\u5B9A\u3057\u3001\u4EE5\u4E0B\u306EQR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u3068\u30EA\u30F3\u30AF\u3055\u305B\u307E\u3059\u3002",
        infoText__unableToScan: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u3067\u65B0\u3057\u3044\u30B5\u30A4\u30F3\u30A4\u30F3\u65B9\u6CD5\u3092\u8A2D\u5B9A\u3057\u3001\u4EE5\u4E0B\u306E\u30AD\u30FC\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        inputLabel__unableToScan1: "\u30BF\u30A4\u30E0\u30D9\u30FC\u30B9\u307E\u305F\u306F\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30EA\u30F3\u30AF\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        inputLabel__unableToScan2: "\u307E\u305F\u3001\u8A8D\u8A3C\u30A2\u30D7\u30EA\u304CTOTP URI\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u5B8C\u5168\u306AURI\u3092\u30B3\u30D4\u30FC\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"
      },
      removeResource: {
        messageLine1: "\u3053\u306E\u8A8D\u8A3C\u30A2\u30D7\u30EA\u304B\u3089\u306E\u691C\u8A3C\u30B3\u30FC\u30C9\u306F\u3001\u30B5\u30A4\u30F3\u30A4\u30F3\u6642\u306B\u306F\u4E0D\u8981\u306B\u306A\u308A\u307E\u3059\u3002",
        messageLine2: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u4F4E\u4E0B\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u672C\u5F53\u306B\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
        successMessage: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u305F\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        title: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u524A\u9664"
      },
      successMessage: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u304C\u6709\u52B9\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u30B5\u30A4\u30F3\u30A4\u30F3\u6642\u306B\u306F\u3001\u3053\u306E\u8A8D\u8A3C\u30A2\u30D7\u30EA\u304B\u3089\u306E\u691C\u8A3C\u30B3\u30FC\u30C9\u3092\u8FFD\u52A0\u306E\u30B9\u30C6\u30C3\u30D7\u3068\u3057\u3066\u5165\u529B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
      title: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u306E\u8FFD\u52A0",
      verifySubtitle: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u3067\u751F\u6210\u3055\u308C\u305F\u691C\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      verifyTitle: "\u691C\u8A3C\u30B3\u30FC\u30C9"
    },
    mobileButton__menu: "\u30E1\u30CB\u30E5\u30FC",
    navbar: {
      account: "\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB",
      description: "\u30A2\u30AB\u30A6\u30F3\u30C8\u60C5\u5831\u7BA1\u7406",
      security: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3",
      title: "\u30A2\u30AB\u30A6\u30F3\u30C8"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u53E4\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u3059\u3079\u3066\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
      readonly: "\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u60C5\u5831\u306F\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u63A5\u7D9A\u306B\u3088\u3063\u3066\u63D0\u4F9B\u3055\u308C\u3066\u304A\u308A\u3001\u7DE8\u96C6\u3067\u304D\u307E\u305B\u3093\u3002",
      successMessage__set: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u8A2D\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002",
      successMessage__signOutOfOtherSessions: "\u4ED6\u306E\u3059\u3079\u3066\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3057\u305F\u3002",
      successMessage__update: "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002",
      title__set: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u8A2D\u5B9A",
      title__update: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u66F4\u65B0"
    },
    phoneNumberPage: {
      infoText: "\u3053\u306E\u96FB\u8A71\u756A\u53F7\u306B\u306F\u691C\u8A3C\u30EA\u30F3\u30AF\u304C\u542B\u307E\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002",
      removeResource: {
        messageLine1: "{{identifier}}\u306F\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
        messageLine2: "\u3053\u306E\u96FB\u8A71\u756A\u53F7\u3092\u4F7F\u7528\u3057\u3066\u306E\u30B5\u30A4\u30F3\u30A4\u30F3\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        successMessage: "{{phoneNumber}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        title: "\u96FB\u8A71\u756A\u53F7\u306E\u524A\u9664"
      },
      successMessage: "{{identifier}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002",
      title: "\u96FB\u8A71\u756A\u53F7\u306E\u8FFD\u52A0",
      verifySubtitle: "{{identifier}}\u306B\u9001\u4FE1\u3055\u308C\u305F\u691C\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      verifyTitle: "\u96FB\u8A71\u756A\u53F7\u306E\u78BA\u8A8D"
    },
    profilePage: {
      fileDropAreaHint: "10MB\u672A\u6E80\u306EJPG\u3001PNG\u3001GIF\u3001\u307E\u305F\u306FWEBP\u753B\u50CF\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044",
      imageFormDestructiveActionSubtitle: "\u753B\u50CF\u306E\u524A\u9664",
      imageFormSubtitle: "\u753B\u50CF\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
      imageFormTitle: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF",
      readonly: "\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u60C5\u5831\u306F\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u63A5\u7D9A\u306B\u3088\u3063\u3066\u63D0\u4F9B\u3055\u308C\u3066\u304A\u308A\u3001\u7DE8\u96C6\u3067\u304D\u307E\u305B\u3093\u3002",
      successMessage: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002",
      title: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306E\u66F4\u65B0"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8",
        title: "\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30C7\u30D0\u30A4\u30B9"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u518D\u8A66\u884C",
        actionLabel__reauthorize: "\u4ECA\u3059\u3050\u8A8D\u8A3C",
        destructiveActionTitle: "\u524A\u9664",
        primaryButton: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9023\u643A\u3059\u308B",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "\u5FC5\u8981\u306A\u30B9\u30B3\u30FC\u30D7\u304C\u66F4\u65B0\u3055\u308C\u3001\u6A5F\u80FD\u304C\u5236\u9650\u3055\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u554F\u984C\u3092\u907F\u3051\u308B\u305F\u3081\u306B\u3001\u3053\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u518D\u8A8D\u8A3C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        title: "\u9023\u643A\u30A2\u30AB\u30A6\u30F3\u30C8"
      },
      dangerSection: {
        deleteAccountButton: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664",
        title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7D42\u4E86"
      },
      emailAddressesSection: {
        destructiveAction: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u524A\u9664",
        detailsAction__nonPrimary: "\u30D7\u30E9\u30A4\u30DE\u30EA\u306B\u8A2D\u5B9A\u3059\u308B",
        detailsAction__primary: "\u78BA\u8A8D\u3092\u5B8C\u4E86\u3059\u308B",
        detailsAction__unverified: "\u78BA\u8A8D\u3092\u5B8C\u4E86\u3059\u308B",
        primaryButton: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u8FFD\u52A0",
        title: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"
      },
      enterpriseAccountsSection: {
        title: "\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u30A2\u30AB\u30A6\u30F3\u30C8"
      },
      headerTitle__account: "\u30A2\u30AB\u30A6\u30F3\u30C8",
      headerTitle__security: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u30B3\u30FC\u30C9\u3092\u518D\u751F\u6210",
          headerTitle: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9",
          subtitle__regenerate: "\u5B89\u5168\u306A\u65B0\u3057\u3044\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002\u4EE5\u524D\u306E\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u306F\u524A\u9664\u3055\u308C\u3001\u4F7F\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
          title__regenerate: "\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u30B3\u30FC\u30C9\u306E\u518D\u751F\u6210"
        },
        phoneCode: {
          actionLabel__setDefault: "\u30C7\u30D5\u30A9\u30EB\u30C8\u306B\u8A2D\u5B9A",
          destructiveActionLabel: "\u96FB\u8A71\u756A\u53F7\u306E\u524A\u9664"
        },
        primaryButton: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u3092\u8FFD\u52A0\u3059\u308B",
        title: "\u4E8C\u6BB5\u968E\u8A8D\u8A3C",
        totp: {
          destructiveActionTitle: "\u524A\u9664",
          headerTitle: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3059\u308B",
        primaryButton__updatePassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3059\u308B",
        title: "\u30D1\u30B9\u30EF\u30FC\u30C9"
      },
      phoneNumbersSection: {
        destructiveAction: "\u96FB\u8A71\u756A\u53F7\u306E\u524A\u9664",
        detailsAction__nonPrimary: "\u30D7\u30E9\u30A4\u30DE\u30EA\u306B\u8A2D\u5B9A\u3059\u308B",
        detailsAction__primary: "\u78BA\u8A8D\u3092\u5B8C\u4E86\u3059\u308B",
        detailsAction__unverified: "\u78BA\u8A8D\u3092\u5B8C\u4E86\u3059\u308B",
        primaryButton: "\u96FB\u8A71\u756A\u53F7\u306E\u8FFD\u52A0",
        title: "\u96FB\u8A71\u756A\u53F7"
      },
      profileSection: {
        primaryButton: void 0,
        title: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB"
      },
      usernameSection: {
        primaryButton__setUsername: "\u30E6\u30FC\u30B6\u30FC\u540D\u306E\u8A2D\u5B9A",
        primaryButton__updateUsername: "\u30E6\u30FC\u30B6\u30FC\u540D\u306E\u5909\u66F4",
        title: "\u30E6\u30FC\u30B6\u30FC\u540D"
      },
      web3WalletsSection: {
        destructiveAction: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u524A\u9664",
        primaryButton: "Web3\u30A6\u30A9\u30EC\u30C3\u30C8",
        title: "Web3\u30A6\u30A9\u30EC\u30C3\u30C8"
      }
    },
    usernamePage: {
      successMessage: "\u30E6\u30FC\u30B6\u30FC\u540D\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002",
      title__set: "\u30E6\u30FC\u30B6\u30FC\u540D\u306E\u66F4\u65B0",
      title__update: "\u30E6\u30FC\u30B6\u30FC\u540D\u306E\u66F4\u65B0"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}}\u306F\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
        messageLine2: "\u3053\u306EWeb3\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u306E\u30B5\u30A4\u30F3\u30A4\u30F3\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        successMessage: "{{web3Wallet}}\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        title: "Web3\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u524A\u9664"
      },
      subtitle__availableWallets: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u63A5\u7D9A\u3059\u308BWeb3\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      subtitle__unavailableWallets: "\u5229\u7528\u53EF\u80FD\u306AWeb3\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
      successMessage: "\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002",
      title: "Web3\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8FFD\u52A0",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/he-IL.ts
var heIL = {
  locale: "he-IL",
  backButton: "\u05D7\u05D6\u05D5\u05E8",
  badge__default: "\u05D1\u05E8\u05D9\u05E8\u05EA \u05DE\u05D7\u05D3\u05DC",
  badge__otherImpersonatorDevice: "\u05DE\u05DB\u05E9\u05D9\u05E8 \u05DE\u05D7\u05E7\u05D4 \u05D0\u05D7\u05E8",
  badge__primary: "\u05E8\u05D0\u05E9\u05D9",
  badge__requiresAction: "\u05D3\u05D5\u05E8\u05E9 \u05E4\u05E2\u05D5\u05DC\u05D4",
  badge__thisDevice: "\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D6\u05D4",
  badge__unverified: "\u05DC\u05D0 \u05DE\u05D0\u05D5\u05DE\u05EA",
  badge__userDevice: "\u05DE\u05DB\u05E9\u05D9\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9",
  badge__you: "\u05D0\u05EA\u05D4",
  createOrganization: {
    formButtonSubmit: "\u05E6\u05D5\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF",
    invitePage: {
      formButtonReset: "\u05D3\u05DC\u05D2"
    },
    title: "\u05E6\u05D5\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF"
  },
  dates: {
    lastDay: "\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1-{{ date | timeString('iw') }}",
    next6Days: "{{ date | weekday('iw','long') }} \u05D1-{{ date | timeString('iw') }}",
    nextDay: "\u05DE\u05D7\u05E8 \u05D1-{{ date | timeString('iw') }}",
    numeric: "{{ date | numeric('iw') }}",
    previous6Days: "{{ date | weekday('iw','long') }} \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05D1-{{ date | timeString('iw') }}",
    sameDay: "\u05D4\u05D9\u05D5\u05DD \u05D1-{{ date | timeString('iw') }}"
  },
  dividerText: "\u05D0\u05D5",
  footerActionLink__useAnotherMethod: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E9\u05D9\u05D8\u05D4 \u05D0\u05D7\u05E8\u05EA",
  footerPageLink__help: "\u05E2\u05D6\u05E8\u05D4",
  footerPageLink__privacy: "\u05E4\u05E8\u05D8\u05D9\u05D5\u05EA",
  footerPageLink__terms: "\u05EA\u05E0\u05D0\u05D9\u05DD",
  formButtonPrimary: "\u05D4\u05DE\u05E9\u05DA",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "\u05E9\u05DB\u05D7\u05EA \u05E1\u05D9\u05E1\u05DE\u05D4?",
  formFieldError__matchingPasswords: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D0\u05D5\u05EA \u05EA\u05D5\u05D0\u05DE\u05D5\u05EA.",
  formFieldError__notMatchingPasswords: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D0\u05D5\u05EA \u05D0\u05D9\u05E0\u05DF \u05EA\u05D5\u05D0\u05DE\u05D5\u05EA.",
  formFieldError__verificationLinkExpired: "\u05D4\u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA \u05E4\u05D2 \u05EA\u05D5\u05E7\u05E3. \u05D0\u05E0\u05D0 \u05D1\u05E7\u05E9/\u05D9 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05D7\u05D3\u05E9.",
  formFieldHintText__optional: "\u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05E0\u05DC\u05D9",
  formFieldHintText__slug: "(slug) \u05D4\u05D5\u05D0 \u05DE\u05D6\u05D4\u05D4 \u05E7\u05E8\u05D9\u05D0 \u05E9\u05DE\u05D9\u05D5\u05E2\u05D3 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D9\u05D9\u05D7\u05D5\u05D3\u05D9. \u05D4\u05D5\u05D0 \u05DE\u05E9\u05DE\u05E9 \u05DC\u05E2\u05D9\u05EA\u05D9\u05DD \u05E7\u05E8\u05D5\u05D1\u05D5\u05EA \u05D1\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA URL.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u05DE\u05D7\u05D9\u05E7\u05EA \u05D7\u05E9\u05D1\u05D5\u05DF",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "example@email.com, example2@email.com",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "\u05D4\u05D0\u05E8\u05D2\u05D5\u05DF-\u05E9\u05DC\u05D9",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "\u05D4\u05E4\u05E2\u05DC \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA \u05DC\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D4\u05D6\u05D4",
  formFieldLabel__backupCode: "\u05E7\u05D5\u05D3 \u05D2\u05D9\u05D1\u05D5\u05D9",
  formFieldLabel__confirmDeletion: "\u05D0\u05D9\u05E9\u05D5\u05E8",
  formFieldLabel__confirmPassword: "\u05D0\u05DE\u05EA \u05E1\u05D9\u05E1\u05DE\u05D4",
  formFieldLabel__currentPassword: "\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E0\u05D5\u05DB\u05D7\u05D9\u05EA",
  formFieldLabel__emailAddress: '\u05DB\u05EA\u05D5\u05D1\u05EA \u05D3\u05D5\u05D0"\u05DC',
  formFieldLabel__emailAddress_username: '\u05DB\u05EA\u05D5\u05D1\u05EA \u05D3\u05D5\u05D0"\u05DC \u05D0\u05D5 \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9',
  formFieldLabel__emailAddresses: '\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05D3\u05D5\u05D0"\u05DC',
  formFieldLabel__firstName: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9",
  formFieldLabel__lastName: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4",
  formFieldLabel__newPassword: "\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D7\u05D3\u05E9\u05D4",
  formFieldLabel__organizationDomain: "\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF",
  formFieldLabel__organizationDomainDeletePending: "\u05DE\u05D7\u05E7 \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05D5\u05D4\u05E6\u05E2\u05D5\u05EA \u05DE\u05DE\u05EA\u05D9\u05E0\u05D5\u05EA",
  formFieldLabel__organizationDomainEmailAddress: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u05D4\u05D6\u05DF \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05EA\u05D7\u05EA \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D6\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05E7\u05D1\u05DC \u05E7\u05D5\u05D3 \u05D5\u05DC\u05D0\u05DE\u05EA \u05D0\u05EA \u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF.",
  formFieldLabel__organizationName: "\u05E9\u05DD \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF",
  formFieldLabel__organizationSlug: "\u05DB\u05EA\u05D5\u05D1\u05EA URL \u05E9\u05DC \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF",
  formFieldLabel__passkeyName: "\u05E9\u05DD \u05D0\u05D5 \u05DE\u05E4\u05EA\u05D7 \u05E1\u05D9\u05E1\u05DE\u05D4",
  formFieldLabel__password: "\u05E1\u05D9\u05E1\u05DE\u05D4",
  formFieldLabel__phoneNumber: "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
  formFieldLabel__role: "\u05EA\u05E4\u05E7\u05D9\u05D3",
  formFieldLabel__signOutOfOtherSessions: "\u05D4\u05EA\u05E0\u05EA\u05E7 \u05DE\u05DB\u05DC \u05D4\u05DE\u05DB\u05E9\u05D9\u05E8\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D9\u05DD",
  formFieldLabel__username: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
  impersonationFab: {
    action__signOut: "\u05D4\u05EA\u05E0\u05EA\u05E7",
    title: "\u05DE\u05D7\u05D5\u05D1\u05E8 \u05DB{{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\u05DE\u05E0\u05D4\u05DC",
  membershipRole__basicMember: "\u05D7\u05D1\u05E8",
  membershipRole__guestMember: "\u05D0\u05D5\u05E8\u05D7",
  organizationList: {
    action__createOrganization: "\u05E6\u05D5\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF",
    action__invitationAccept: "\u05D4\u05E6\u05D8\u05E8\u05E3",
    action__suggestionsAccept: "\u05D1\u05E7\u05E9\u05D4 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E4\u05D5\u05EA",
    createOrganization: "\u05E6\u05D5\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF",
    invitationAcceptedLabel: "\u05D4\u05E6\u05D8\u05E8\u05E3",
    subtitle: "\u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05DC{{applicationName}}",
    suggestionsAcceptedLabel: "\u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D0\u05D9\u05E9\u05D5\u05E8",
    title: "\u05D1\u05D7\u05E8 \u05D7\u05E9\u05D1\u05D5\u05DF",
    titleWithoutPersonal: "\u05D1\u05D7\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA",
    badge__automaticSuggestion: "\u05D4\u05E6\u05E2\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA",
    badge__manualInvitation: "\u05DC\u05DC\u05D0 \u05D4\u05E8\u05E9\u05DE\u05D4 \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05EA",
    badge__unverified: "\u05DC\u05D0 \u05DE\u05D0\u05D5\u05DE\u05EA",
    createDomainPage: {
      subtitle: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05EA \u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA. \u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05E2\u05DD \u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05EA\u05D7\u05EA \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D6\u05D4 \u05D9\u05DB\u05D5\u05DC\u05D9\u05DD \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05D1\u05D0\u05D5\u05E4\u05DF \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9 \u05D0\u05D5 \u05DC\u05D1\u05E7\u05E9 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3.",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u05DC\u05D0 \u05D4\u05D9\u05D4 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DC\u05D5\u05D7 \u05D0\u05EA \u05D4\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA. \u05EA\u05E7\u05DF \u05D0\u05EA \u05D4\u05D1\u05E2\u05D9\u05D5\u05EA \u05D4\u05D1\u05D0\u05D5\u05EA \u05D5\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1:",
      formButtonPrimary__continue: "\u05E9\u05DC\u05D7 \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA",
      selectDropdown__role: "\u05D1\u05D7\u05E8 \u05EA\u05E4\u05E7\u05D9\u05D3",
      subtitle: "\u05D4\u05D6\u05DE\u05DF \u05D7\u05D1\u05E8\u05D9\u05DD \u05D7\u05D3\u05E9\u05D9\u05DD \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05D6\u05D4",
      successMessage: "\u05D4\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05E0\u05E9\u05DC\u05D7\u05D5 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4",
      title: "\u05D4\u05D6\u05DE\u05DF \u05D7\u05D1\u05E8\u05D9\u05DD"
    },
    membersPage: {
      action__invite: "\u05D4\u05D6\u05DE\u05DF",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u05D4\u05E1\u05E8 \u05D7\u05D1\u05E8",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u05D4\u05E6\u05D8\u05E8\u05E3",
        tableHeader__role: "\u05EA\u05E4\u05E7\u05D9\u05D3",
        tableHeader__user: "\u05DE\u05E9\u05EA\u05DE\u05E9"
      },
      detailsTitle__emptyRow: "\u05D0\u05D9\u05DF \u05D7\u05D1\u05E8\u05D9\u05DD \u05DC\u05D4\u05E6\u05D2\u05D4",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u05D4\u05D6\u05DE\u05DF \u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05E2\u05DC \u05D9\u05D3\u05D9 \u05D7\u05D9\u05D1\u05D5\u05E8 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05E9\u05DC\u05DA. \u05DB\u05DC \u05DE\u05D9 \u05E9\u05E0\u05E8\u05E9\u05DD \u05E2\u05DD \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05EA\u05D5\u05D0\u05DD \u05D9\u05D5\u05DB\u05DC \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05D1\u05DB\u05DC \u05E2\u05EA.",
          headerTitle: "\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA",
          primaryButton: "\u05E0\u05D4\u05DC \u05D3\u05D5\u05DE\u05D9\u05D9\u05E0\u05D9\u05DD \u05DE\u05D0\u05D5\u05DE\u05EA\u05D9\u05DD"
        },
        table__emptyRow: "\u05D0\u05D9\u05DF \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05DC\u05D4\u05E6\u05D2\u05D4"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u05D1\u05D8\u05DC \u05D4\u05D6\u05DE\u05E0\u05D4",
        tableHeader__invited: "\u05D4\u05D5\u05D6\u05DE\u05DF"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05E9\u05E0\u05E8\u05E9\u05DE\u05D9\u05DD \u05E2\u05DD \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05EA\u05D5\u05D0\u05DD \u05D9\u05D5\u05DB\u05DC\u05D5 \u05DC\u05E8\u05D0\u05D5\u05EA \u05D4\u05E6\u05E2\u05D4 \u05DC\u05D1\u05E7\u05E9 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05E9\u05DC\u05DA.",
          headerTitle: "\u05D4\u05E6\u05E2\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA",
          primaryButton: "\u05E0\u05D4\u05DC \u05D3\u05D5\u05DE\u05D9\u05D9\u05E0\u05D9\u05DD \u05DE\u05D0\u05D5\u05DE\u05EA\u05D9\u05DD"
        },
        menuAction__approve: "\u05D0\u05E9\u05E8",
        menuAction__reject: "\u05D3\u05D7\u05D4",
        tableHeader__requested: "\u05D1\u05E7\u05E9\u05EA \u05D2\u05D9\u05E9\u05D4",
        table__emptyRow: "\u05D0\u05D9\u05DF \u05D1\u05E7\u05E9\u05D5\u05EA \u05DC\u05D4\u05E6\u05D2\u05D4"
      },
      start: {
        headerTitle__invitations: "\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA",
        headerTitle__members: "\u05D7\u05D1\u05E8\u05D9\u05DD",
        headerTitle__requests: "\u05D1\u05E7\u05E9\u05D5\u05EA"
      }
    },
    navbar: {
      description: "\u05E0\u05D4\u05DC \u05D0\u05EA \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF \u05E9\u05DC\u05DA.",
      general: "\u05DB\u05DC\u05DC\u05D9",
      members: "\u05D7\u05D1\u05E8\u05D9\u05DD",
      title: "\u05D0\u05E8\u05D2\u05D5\u05DF"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: '\u05D4\u05E7\u05DC\u05D3 "{{organizationName}}" \u05DC\u05DE\u05D8\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.',
          messageLine1: "\u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7 \u05E9\u05D0\u05EA\u05D4 \u05E8\u05D5\u05E6\u05D4 \u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF \u05D4\u05D6\u05D4?",
          messageLine2: "\u05E4\u05E2\u05D5\u05DC\u05D4 \u05D6\u05D5 \u05D4\u05D9\u05D0 \u05E1\u05D5\u05E4\u05D9\u05EA \u05D5\u05D1\u05DC\u05EA\u05D9 \u05D4\u05E4\u05D9\u05DB\u05D4.",
          successMessage: "\u05DE\u05D7\u05E7\u05EA \u05D0\u05EA \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF.",
          title: "\u05DE\u05D7\u05E7 \u05D0\u05E8\u05D2\u05D5\u05DF"
        },
        leaveOrganization: {
          actionDescription: '\u05D4\u05E7\u05DC\u05D3 "{{organizationName}}" \u05DC\u05DE\u05D8\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.',
          messageLine1: "\u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7 \u05E9\u05D0\u05EA\u05D4 \u05E8\u05D5\u05E6\u05D4 \u05DC\u05E2\u05D6\u05D5\u05D1 \u05D0\u05EA \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF \u05D4\u05D6\u05D4? \u05EA\u05D0\u05D1\u05D3 \u05D2\u05D9\u05E9\u05D4 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05D6\u05D4 \u05D5\u05DC\u05D9\u05D9\u05E9\u05D5\u05DE\u05D9\u05DD \u05E9\u05DC\u05D5.",
          messageLine2: "\u05E4\u05E2\u05D5\u05DC\u05D4 \u05D6\u05D5 \u05D4\u05D9\u05D0 \u05E1\u05D5\u05E4\u05D9\u05EA \u05D5\u05D1\u05DC\u05EA\u05D9 \u05D4\u05E4\u05D9\u05DB\u05D4.",
          successMessage: "\u05E2\u05D6\u05D1\u05EA \u05D0\u05EA \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF.",
          title: "\u05E2\u05D6\u05D5\u05D1 \u05D0\u05EA \u05D4\u05D0\u05E8\u05D2\u05D5\u05DF"
        },
        title: "\u05E1\u05D9\u05DB\u05D5\u05DF"
      },
      domainSection: {
        menuAction__manage: "\u05E0\u05D4\u05DC",
        menuAction__remove: "\u05DE\u05D7\u05E7",
        menuAction__verify: "\u05D0\u05DE\u05EA",
        primaryButton: "\u05D4\u05D5\u05E1\u05E3 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF",
        subtitle: "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05D1\u05D0\u05D5\u05E4\u05DF \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9 \u05D0\u05D5 \u05DC\u05D1\u05E7\u05E9 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05E2\u05DC \u05D1\u05E1\u05D9\u05E1 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DE\u05D0\u05D5\u05DE\u05EA.",
        title: "\u05D3\u05D5\u05DE\u05D9\u05D9\u05E0\u05D9\u05DD \u05DE\u05D0\u05D5\u05DE\u05EA\u05D9\u05DD"
      },
      successMessage: "\u05D4\u05D0\u05E8\u05D2\u05D5\u05DF \u05E2\u05D5\u05D3\u05DB\u05DF.",
      title: "\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC \u05D0\u05E8\u05D2\u05D5\u05DF"
    },
    removeDomainPage: {
      messageLine1: "\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC {{domain}} \u05D9\u05D5\u05E1\u05E8.",
      messageLine2: "\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05DC\u05D0 \u05D9\u05D5\u05DB\u05DC\u05D5 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05D1\u05D0\u05D5\u05E4\u05DF \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9 \u05DC\u05D0\u05D7\u05E8 \u05E4\u05E2\u05D5\u05DC\u05D4 \u05D6\u05D5.",
      successMessage: "{{domain}} \u05D4\u05D5\u05E1\u05E8.",
      title: "\u05D4\u05E1\u05E8 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF"
    },
    start: {
      headerTitle__general: "\u05DB\u05DC\u05DC\u05D9",
      headerTitle__members: "\u05D7\u05D1\u05E8\u05D9\u05DD",
      profileSection: {
        primaryButton: "\u05E2\u05D3\u05DB\u05DF \u05E4\u05E8\u05D5\u05E4\u05D9\u05DC",
        title: "\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC \u05D0\u05E8\u05D2\u05D5\u05DF",
        uploadAction__title: "\u05DC\u05D5\u05D2\u05D5"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u05D4\u05E1\u05E8\u05EA \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D6\u05D4 \u05EA\u05E9\u05E4\u05D9\u05E2 \u05E2\u05DC \u05D4\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05D4\u05DE\u05D5\u05D6\u05DE\u05E0\u05D9\u05DD.",
        removeDomainActionLabel__remove: "\u05D4\u05E1\u05E8 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF",
        removeDomainSubtitle: "\u05D4\u05E1\u05E8 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D6\u05D4 \u05DE\u05E8\u05E9\u05D9\u05DE\u05EA \u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05E0\u05D9\u05DD \u05D4\u05DE\u05D0\u05D5\u05DE\u05EA\u05D9\u05DD \u05E9\u05DC\u05DA",
        removeDomainTitle: "\u05D4\u05E1\u05E8 \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05DE\u05D5\u05D6\u05DE\u05E0\u05D9\u05DD \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05EA \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05DB\u05E9\u05D4\u05DD \u05E0\u05E8\u05E9\u05DE\u05D9\u05DD \u05D5\u05D9\u05DB\u05D5\u05DC\u05D9\u05DD \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05D1\u05DB\u05DC \u05E2\u05EA.",
        automaticInvitationOption__label: "\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA",
        automaticSuggestionOption__description: "\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05DE\u05E7\u05D1\u05DC\u05D9\u05DD \u05D4\u05E6\u05E2\u05D4 \u05DC\u05D1\u05E7\u05E9 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3, \u05D0\u05DA \u05D7\u05D9\u05D9\u05D1\u05D9\u05DD \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05D0\u05D5\u05E9\u05E8\u05D9\u05DD \u05E2\u05DC \u05D9\u05D3\u05D9 \u05DE\u05E0\u05D4\u05DC \u05DC\u05E4\u05E0\u05D9 \u05E9\u05D9\u05D5\u05DB\u05DC\u05D5 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF.",
        automaticSuggestionOption__label: "\u05D4\u05E6\u05E2\u05D5\u05EA \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05D5\u05EA",
        calloutInfoLabel: "\u05E9\u05D9\u05E0\u05D5\u05D9 \u05DE\u05E6\u05D1 \u05D4\u05D4\u05E8\u05E9\u05DE\u05D4 \u05D9\u05E9\u05E4\u05D9\u05E2 \u05E8\u05E7 \u05E2\u05DC \u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05D7\u05D3\u05E9\u05D9\u05DD.",
        calloutInvitationCountLabel: "\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05DE\u05DE\u05EA\u05D9\u05E0\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7\u05D5 \u05DC\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD: {{count}}",
        calloutSuggestionCountLabel: "\u05D4\u05E6\u05E2\u05D5\u05EA \u05DE\u05DE\u05EA\u05D9\u05E0\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7\u05D5 \u05DC\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD: {{count}}",
        manualInvitationOption__description: "\u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05D9\u05DB\u05D5\u05DC\u05D9\u05DD \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF \u05E8\u05E7 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D6\u05DE\u05E0\u05D4 \u05D9\u05D3\u05E0\u05D9\u05EA.",
        manualInvitationOption__label: "\u05DC\u05DC\u05D0 \u05D4\u05E8\u05E9\u05DE\u05D4 \u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05EA",
        subtitle: "\u05D1\u05D7\u05E8 \u05DB\u05D9\u05E6\u05D3 \u05DE\u05E9\u05EA\u05DE\u05E9\u05D9\u05DD \u05DE\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05D6\u05D4 \u05D9\u05DB\u05D5\u05DC\u05D9\u05DD \u05DC\u05D4\u05E6\u05D8\u05E8\u05E3 \u05DC\u05D0\u05E8\u05D2\u05D5\u05DF."
      },
      start: {
        headerTitle__danger: "\u05E1\u05D9\u05DB\u05D5\u05DF",
        headerTitle__enrollment: "\u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA \u05D4\u05E8\u05E9\u05DE\u05D4"
      },
      subtitle: "\u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF {{domain}} \u05D0\u05D5\u05DE\u05EA \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4. \u05D4\u05DE\u05E9\u05DA \u05D1\u05D1\u05D7\u05D9\u05E8\u05EA \u05DE\u05E6\u05D1 \u05D4\u05E8\u05E9\u05DE\u05D4.",
      title: "\u05E2\u05D3\u05DB\u05DF {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u05D4\u05D6\u05DF \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA",
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05DC\u05D0 \u05E7\u05D9\u05D1\u05DC\u05EA \u05E7\u05D5\u05D3? \u05E9\u05DC\u05D7 \u05E9\u05D5\u05D1",
      subtitle: "\u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF {{domainName}} \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05D0\u05D5\u05DE\u05EA \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC.",
      subtitleVerificationCodeScreen: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05E0\u05E9\u05DC\u05D7 \u05DC{{emailAddress}}. \u05D4\u05D6\u05DF \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.",
      title: "\u05D0\u05DE\u05EA \u05D3\u05D5\u05DE\u05D9\u05D9\u05DF"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u05E6\u05D5\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF",
    action__invitationAccept: "\u05D4\u05E6\u05D8\u05E8\u05E3",
    action__manageOrganization: "\u05E0\u05D4\u05DC \u05D0\u05E8\u05D2\u05D5\u05DF",
    action__suggestionsAccept: "\u05D1\u05E7\u05E9\u05D4 \u05DC\u05D4\u05E6\u05D8\u05E8\u05E4\u05D5\u05EA",
    notSelected: "\u05DC\u05D0 \u05E0\u05D1\u05D7\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF",
    personalWorkspace: "\u05D0\u05D6\u05D5\u05E8 \u05D0\u05D9\u05E9\u05D9",
    suggestionsAcceptedLabel: "\u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D0\u05D9\u05E9\u05D5\u05E8"
  },
  paginationButton__next: "\u05D4\u05D1\u05D0",
  paginationButton__previous: "\u05D4\u05E7\u05D5\u05D3\u05DD",
  paginationRowText__displaying: "\u05DE\u05E6\u05D9\u05D2",
  paginationRowText__of: "\u05DE\u05EA\u05D5\u05DA",
  reverification: {
    alternativeMethods: {
      actionLink: "\u05D4\u05E9\u05D2 \u05E2\u05D6\u05E8\u05D4",
      actionText: "\u05D0\u05D9\u05DF \u05DC\u05DA \u05D0\u05E3 \u05D0\u05D7\u05D3 \u05DE\u05D0\u05DC\u05D4?",
      blockButton__backupCode: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E7\u05D5\u05D3 \u05D2\u05D9\u05D1\u05D5\u05D9",
      blockButton__emailCode: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DC {{identifier}}",
      blockButton__password: "\u05D4\u05DE\u05E9\u05DA \u05E2\u05DD \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA",
      blockButton__phoneCode: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 SMS \u05DC {{identifier}}",
      blockButton__totp: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA",
      getHelp: {
        blockButton__emailSupport: "\u05EA\u05DE\u05D9\u05DB\u05D4 \u05D1\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
        content: "\u05D0\u05DD \u05D9\u05E9 \u05DC\u05DA \u05D1\u05E2\u05D9\u05D4 \u05D1\u05D0\u05D9\u05DE\u05D5\u05EA \u05D7\u05E9\u05D1\u05D5\u05E0\u05DA, \u05E9\u05DC\u05D7 \u05DC\u05E0\u05D5 \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D5\u05D0\u05E0\u05D7\u05E0\u05D5 \u05E0\u05D9\u05E6\u05D5\u05E8 \u05D0\u05D9\u05EA\u05DA \u05E7\u05E9\u05E8 \u05E2\u05DC \u05DE\u05E0\u05EA \u05DC\u05E9\u05D7\u05D6\u05E8 \u05D0\u05EA \u05D4\u05D2\u05D9\u05E9\u05D4 \u05D1\u05D4\u05E7\u05D3\u05DD \u05D4\u05D0\u05E4\u05E9\u05E8\u05D9",
        title: "\u05D4\u05E9\u05D2 \u05E2\u05D6\u05E8\u05D4"
      },
      subtitle: "\u05E0\u05EA\u05E7\u05DC\u05EA \u05D1\u05D1\u05E2\u05D9\u05D5\u05EA? \u05D0\u05EA\u05D4 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05DB\u05DC \u05D0\u05D7\u05EA \u05DE\u05D4\u05E9\u05D9\u05D8\u05D5\u05EA \u05D4\u05DC\u05DC\u05D5 \u05E2\u05D1\u05D5\u05E8 \u05D0\u05D9\u05DE\u05D5\u05EA",
      title: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E9\u05D9\u05D8\u05D4 \u05D0\u05D7\u05E8\u05EA"
    },
    backupCodeMfa: {
      subtitle: "\u05E7\u05D5\u05D3 \u05D4\u05D2\u05D9\u05D1\u05D5\u05D9 \u05E9\u05DC\u05DA \u05D4\u05D5\u05D0 \u05D4\u05E7\u05D5\u05D3 \u05E9\u05E7\u05D9\u05D1\u05DC\u05EA \u05DB\u05D0\u05E9\u05E8 \u05D4\u05D2\u05D3\u05E8\u05EA \u05D0\u05EA \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9",
      title: "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D2\u05D9\u05D1\u05D5\u05D9"
    },
    emailCode: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05DC\u05D0 \u05E7\u05D9\u05D1\u05DC\u05EA \u05E7\u05D5\u05D3? \u05E9\u05DC\u05D7 \u05E9\u05D5\u05D1",
      subtitle: "\u05D4\u05DE\u05E9\u05DA \u05DC {{applicationName}}",
      title: "\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA"
    },
    noAvailableMethods: {
      message: "\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05E2\u05DD \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA. \u05D0\u05D9\u05DF \u05D2\u05D5\u05E8\u05DD \u05D0\u05D9\u05DE\u05D5\u05EA \u05D6\u05DE\u05D9\u05DF",
      subtitle: "\u05E7\u05E8\u05EA\u05D4 \u05EA\u05E7\u05DC\u05D4",
      title: "\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D0\u05DE\u05EA \u05D0\u05EA \u05D7\u05E9\u05D1\u05D5\u05E0\u05DA"
    },
    password: {
      actionLink: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E9\u05D9\u05D8\u05D4 \u05D0\u05D7\u05E8\u05EA",
      subtitle: "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E9\u05E8\u05EA \u05E2\u05DD \u05D7\u05E9\u05D1\u05D5\u05E0\u05DA",
      title: "\u05D4\u05DB\u05E0\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D4"
    },
    phoneCode: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05DC\u05D0 \u05E7\u05D9\u05D1\u05DC\u05EA \u05E7\u05D5\u05D3? \u05E9\u05DC\u05D7 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05DA \u05DC {{applicationName}}",
      title: "\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA"
    },
    phoneCodeMfa: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05DC\u05D0 \u05E7\u05D9\u05D1\u05DC\u05EA \u05E7\u05D5\u05D3? \u05E9\u05DC\u05D7 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05DA, \u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
      title: "\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA"
    },
    totpMfa: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05DA, \u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05D5\u05E6\u05E8 \u05E2\u05DC \u05D9\u05D3\u05D9 \u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA",
      title: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u05D4\u05D5\u05E1\u05E3 \u05D7\u05E9\u05D1\u05D5\u05DF",
      action__signOutAll: "\u05D4\u05EA\u05E0\u05EA\u05E7 \u05DE\u05DB\u05DC \u05D4\u05D7\u05E9\u05D1\u05D5\u05E0\u05D5\u05EA",
      subtitle: "\u05D1\u05D7\u05E8 \u05D0\u05EA \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05D0\u05D9\u05EA\u05D5 \u05EA\u05E8\u05E6\u05D4 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.",
      title: "\u05D1\u05D7\u05E8 \u05D7\u05E9\u05D1\u05D5\u05DF"
    },
    alternativeMethods: {
      actionLink: "\u05E7\u05D1\u05DC \u05E2\u05D6\u05E8\u05D4",
      actionText: "\u05D0\u05D9\u05DF \u05DC\u05DA \u05D0\u05E3 \u05D0\u05D7\u05EA \u05DE\u05D4\u05E9\u05D9\u05D8\u05D5\u05EA \u05D4\u05D0\u05DC\u05D4?",
      blockButton__backupCode: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E7\u05D5\u05D3 \u05D2\u05D9\u05D1\u05D5\u05D9",
      blockButton__emailCode: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05D1\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DC-{{identifier}}",
      blockButton__emailLink: "\u05E9\u05DC\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05D1\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DC-{{identifier}}",
      blockButton__passkey: "\u05D4\u05D9\u05DB\u05E0\u05E1 \u05E2\u05DD \u05D4\u05DE\u05E4\u05EA\u05D7 \u05E9\u05DC\u05DA",
      blockButton__password: "\u05D4\u05EA\u05D7\u05D1\u05E8 \u05E2\u05DD \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA",
      blockButton__phoneCode: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 SMS \u05DC-{{identifier}}",
      blockButton__totp: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA",
      getHelp: {
        blockButton__emailSupport: "\u05DE\u05D9\u05D9\u05DC \u05DC\u05EA\u05DE\u05D9\u05DB\u05D4",
        content: "\u05D0\u05DD \u05D0\u05EA\u05D4 \u05E0\u05EA\u05E7\u05DC \u05D1\u05E7\u05E9\u05D9\u05D9\u05DD \u05D1\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA \u05DC\u05D7\u05E9\u05D1\u05D5\u05E0\u05DA, \u05E9\u05DC\u05D7 \u05DC\u05E0\u05D5 \u05DE\u05D9\u05D9\u05DC \u05D5\u05E0\u05E2\u05D1\u05D5\u05D3 \u05D0\u05D9\u05EA\u05DA \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05D6\u05E8 \u05D0\u05EA \u05D4\u05D2\u05D9\u05E9\u05D4 \u05D1\u05D4\u05E7\u05D3\u05DD \u05D4\u05D0\u05E4\u05E9\u05E8\u05D9.",
        title: "\u05E7\u05D1\u05DC \u05E2\u05D6\u05E8\u05D4"
      },
      subtitle: "\u05E0\u05EA\u05E7\u05DC\u05EA \u05D1\u05D1\u05E2\u05D9\u05D4? \u05EA\u05D5\u05DB\u05DC \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05D7\u05EA \u05DE\u05D4\u05E9\u05D9\u05D8\u05D5\u05EA \u05D4\u05D0\u05DC\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8.",
      title: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E9\u05D9\u05D8\u05D4 \u05D0\u05D7\u05E8\u05EA"
    },
    backupCodeMfa: {
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D5\u05D3 \u05D2\u05D9\u05D1\u05D5\u05D9"
    },
    emailCode: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: '\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA'
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u05DC\u05D4\u05DE\u05E9\u05DA, \u05E4\u05EA\u05D7 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05DE\u05D4\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D5\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05DE\u05DE\u05E0\u05D5 \u05D0\u05EA\u05D4 \u05DE\u05EA\u05DB\u05D5\u05D5\u05DF \u05DC\u05D1\u05E6\u05E2 \u05DB\u05E0\u05D9\u05E1\u05D4",
        title: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D6\u05D4 \u05DC\u05D0 \u05D7\u05D5\u05E7\u05D9 \u05E2\u05D1\u05D5\u05E8 \u05DE\u05DB\u05E9\u05D9\u05E8 \u05D6\u05D4"
      },
      expired: {
        subtitle: "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8\u05D9\u05EA \u05DC\u05D4\u05DE\u05E9\u05DA.",
        title: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D6\u05D4 \u05E4\u05D2 \u05EA\u05D5\u05E7\u05E3"
      },
      failed: {
        subtitle: "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8\u05D9\u05EA \u05DC\u05D4\u05DE\u05E9\u05DA.",
        title: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D6\u05D4 \u05DC\u05D0 \u05D7\u05D5\u05E7\u05D9"
      },
      formSubtitle: '\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA',
      formTitle: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D0\u05D9\u05DE\u05D5\u05EA",
      loading: {
        subtitle: "\u05EA\u05D5\u05E2\u05D1\u05E8 \u05D1\u05E7\u05E8\u05D5\u05D1",
        title: "\u05DE\u05EA\u05D7\u05D1\u05E8..."
      },
      resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: '\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA',
      unusedTab: {
        title: "\u05D0\u05EA\u05D4 \u05D9\u05DB\u05D5\u05DC \u05DC\u05E1\u05D2\u05D5\u05E8 \u05D0\u05EA \u05D4\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05D4\u05D6\u05D5"
      },
      verified: {
        subtitle: "\u05EA\u05D5\u05E2\u05D1\u05E8 \u05D1\u05E7\u05E8\u05D5\u05D1",
        title: "\u05E0\u05DB\u05E0\u05E1\u05EA \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4"
      },
      verifiedSwitchTab: {
        subtitle: "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8\u05D9\u05EA \u05DC\u05D4\u05DE\u05E9\u05DA",
        subtitleNewTab: "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05E9\u05E0\u05E4\u05EA\u05D7\u05D4 \u05D7\u05D3\u05E9\u05D4 \u05DC\u05D4\u05DE\u05E9\u05DA",
        titleNewTab: "\u05E0\u05DB\u05E0\u05E1 \u05D1\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05D0\u05D7\u05E8\u05EA"
      }
    },
    forgotPassword: {
      formTitle: "\u05D0\u05E4\u05E1 \u05E7\u05D5\u05D3 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4",
      resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
      subtitle: "\u05DB\u05D3\u05D9 \u05DC\u05D0\u05E4\u05E1 \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA",
      subtitle_email: "\u05E8\u05D0\u05E9\u05D9\u05EA, \u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA",
      subtitle_phone: "\u05E8\u05D0\u05E9\u05D9\u05EA, \u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
      title: "\u05D0\u05D9\u05E4\u05D5\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D4"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u05D0\u05E4\u05E1 \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA",
      label__alternativeMethods: "\u05D0\u05D5, \u05D4\u05EA\u05D7\u05D1\u05E8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05E9\u05D9\u05D8\u05D4 \u05D0\u05D7\u05E8\u05EA.",
      title: "\u05E9\u05DB\u05D7\u05EA \u05E1\u05D9\u05E1\u05DE\u05D4?"
    },
    noAvailableMethods: {
      message: "\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D1\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA. \u05D0\u05D9\u05DF \u05D2\u05D5\u05E8\u05DD \u05D0\u05D9\u05DE\u05D5\u05EA \u05D6\u05DE\u05D9\u05DF.",
      subtitle: "\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4",
      title: "\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E9\u05D9\u05D8\u05D4 \u05D0\u05D7\u05E8\u05EA",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E1\u05D9\u05E1\u05DE\u05EA\u05DA"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05E9\u05DC\u05D7 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: "\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA"
    },
    phoneCodeMfa: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05E9\u05DC\u05D7 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
      subtitle: void 0,
      title: "\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA"
    },
    resetPassword: {
      formButtonPrimary: "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D4",
      requiredMessage: "\u05DE\u05D8\u05E2\u05DE\u05D9 \u05D0\u05D1\u05D8\u05D7\u05D4, \u05D9\u05E9 \u05DC\u05D0\u05E4\u05E1 \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA.",
      successMessage: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05E9\u05D5\u05E0\u05EA\u05D4 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4. \u05DE\u05D7\u05D1\u05E8 \u05D0\u05D5\u05EA\u05DA, \u05D0\u05E0\u05D0 \u05D4\u05DE\u05EA\u05DF \u05E8\u05D2\u05E2.",
      title: "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D4"
    },
    resetPasswordMfa: {
      detailsLabel: "\u05D0\u05E0\u05D7\u05E0\u05D5 \u05E6\u05E8\u05D9\u05DB\u05D9\u05DD \u05DC\u05D0\u05DE\u05EA \u05D0\u05EA \u05D6\u05D4\u05D5\u05EA\u05DA \u05DC\u05E4\u05E0\u05D9 \u05E9\u05E0\u05D0\u05E4\u05E1 \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA."
    },
    start: {
      actionLink: "\u05D4\u05E8\u05E9\u05DE\u05D4",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: '\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D3\u05D5\u05D0"\u05DC',
      actionLink__use_email_username: '\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D3\u05D5\u05D0"\u05DC \u05D0\u05D5 \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9',
      actionLink__use_passkey: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05DE\u05E4\u05EA\u05D7 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05D1\u05DE\u05E7\u05D5\u05DD",
      actionLink__use_phone: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF",
      actionLink__use_username: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
      actionText: "\u05D0\u05D9\u05DF \u05DC\u05DA \u05D7\u05E9\u05D1\u05D5\u05DF?",
      actionText__join_waitlist: void 0,
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      subtitleCombined: void 0,
      title: "\u05D4\u05EA\u05D7\u05D1\u05E8",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05DA, \u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05D5\u05E6\u05E8 \u05E2\u05DC \u05D9\u05D3\u05D9 \u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA",
      title: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05D9 \u05E9\u05DC\u05D1\u05D9\u05DD"
    }
  },
  signInEnterPasswordTitle: "\u05D4\u05D6\u05DF \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA",
  signUp: {
    continue: {
      actionLink: "\u05D4\u05EA\u05D7\u05D1\u05E8",
      actionText: "\u05D9\u05E9 \u05DC\u05DA \u05D7\u05E9\u05D1\u05D5\u05DF?",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: "\u05DE\u05DC\u05D0 \u05E9\u05D3\u05D5\u05EA \u05D7\u05E1\u05E8\u05D9\u05DD"
    },
    emailCode: {
      formSubtitle: '\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA',
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: '\u05D0\u05DE\u05EA \u05D0\u05EA \u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA'
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u05DC\u05D4\u05DE\u05E9\u05DA, \u05E4\u05EA\u05D7 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05DE\u05D4\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D5\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05DE\u05DE\u05E0\u05D5 \u05D0\u05EA\u05D4 \u05DE\u05EA\u05DB\u05D5\u05D5\u05DF \u05DC\u05D1\u05E6\u05E2 \u05D0\u05EA \u05D4\u05E8\u05D9\u05E9\u05D5\u05DD",
        title: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D0\u05D9\u05E0\u05D5 \u05D7\u05D5\u05E7\u05D9 \u05E2\u05D1\u05D5\u05E8 \u05DE\u05DB\u05E9\u05D9\u05E8 \u05D6\u05D4"
      },
      formSubtitle: '\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA',
      formTitle: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA",
      loading: {
        title: "\u05DE\u05EA\u05D7\u05D9\u05DC \u05DC\u05D4\u05D9\u05E8\u05E9\u05DD..."
      },
      resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: '\u05D0\u05DE\u05EA \u05D0\u05EA \u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D3\u05D5\u05D0"\u05DC \u05E9\u05DC\u05DA',
      verified: {
        title: "\u05E0\u05E8\u05E9\u05DE\u05EA \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4"
      },
      verifiedSwitchTab: {
        subtitle: "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05E9\u05E0\u05E4\u05EA\u05D7\u05D4 \u05DC\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA",
        subtitleNewTab: "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D9\u05D4 \u05D4\u05E7\u05D5\u05D3\u05DE\u05EA \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA",
        title: '\u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5\u05D0"\u05DC \u05D4\u05E6\u05DC\u05D9\u05D7'
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
      formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
      resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: "\u05D0\u05DE\u05EA \u05D0\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u05D4\u05EA\u05D7\u05D1\u05E8",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u05D9\u05E9 \u05DC\u05DA \u05D7\u05E9\u05D1\u05D5\u05DF?",
      subtitle: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      subtitleCombined: "\u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05D0\u05DC {{applicationName}}",
      title: "\u05E6\u05D5\u05E8 \u05D0\u05EA \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA",
      titleCombined: "\u05E6\u05D5\u05E8 \u05D0\u05EA \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA"
    }
  },
  socialButtonsBlockButton: "\u05D4\u05DE\u05E9\u05DA \u05E2\u05DD {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} \u05DB\u05D1\u05E8 \u05D7\u05D1\u05E8 \u05D1\u05D0\u05E8\u05D2\u05D5\u05DF",
    captcha_invalid: "\u05D4\u05D4\u05E8\u05E9\u05DE\u05D4 \u05E0\u05DB\u05E9\u05DC\u05D4 \u05E2\u05E7\u05D1 \u05DB\u05E9\u05DC \u05D1\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D0\u05D1\u05D8\u05D7\u05D4. \u05D0\u05E0\u05D0 \u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05D3\u05E3 \u05D5\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1, \u05D0\u05D5 \u05E4\u05E0\u05D4 \u05DC\u05EA\u05DE\u05D9\u05DB\u05D4 \u05DC\u05E2\u05D6\u05E8\u05D4 \u05E0\u05D5\u05E1\u05E4\u05EA.",
    captcha_unavailable: "\u05D4\u05D4\u05E8\u05E9\u05DE\u05D4 \u05E0\u05DB\u05E9\u05DC\u05D4 \u05E2\u05E7\u05D1 \u05DB\u05E9\u05DC \u05D1\u05D0\u05D9\u05DE\u05D5\u05EA \u05E0\u05D2\u05D3 \u05D1\u05D5\u05D8\u05D9\u05DD. \u05D0\u05E0\u05D0 \u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05D3\u05E3 \u05D5\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1, \u05D0\u05D5 \u05E4\u05E0\u05D4 \u05DC\u05EA\u05DE\u05D9\u05DB\u05D4 \u05DC\u05E2\u05D6\u05E8\u05D4 \u05E0\u05D5\u05E1\u05E4\u05EA.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05DE\u05D9\u05D9\u05DC \u05D4\u05D6\u05D0\u05EA \u05DB\u05D1\u05E8 \u05EA\u05E4\u05D5\u05E1\u05D4. \u05D0\u05E0\u05D0 \u05E0\u05E1\u05D4 \u05D0\u05D7\u05E8\u05EA.",
    form_identifier_exists__phone_number: "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05D4\u05D6\u05D4 \u05DB\u05D1\u05E8 \u05EA\u05E4\u05D5\u05E1. \u05D0\u05E0\u05D0 \u05E0\u05E1\u05D4 \u05DE\u05E1\u05E4\u05E8 \u05D0\u05D7\u05E8.",
    form_identifier_exists__username: "\u05E9\u05DD \u05D4\u05DE\u05E9\u05EA\u05DE\u05E9 \u05D4\u05D6\u05D4 \u05DB\u05D1\u05E8 \u05EA\u05E4\u05D5\u05E1. \u05D0\u05E0\u05D0 \u05E0\u05E1\u05D4 \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D0\u05D7\u05E8",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05D9\u05D5\u05EA \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05EA\u05E7\u05D9\u05E0\u05D4.",
    form_param_format_invalid__phone_number: "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D1\u05E4\u05D5\u05E8\u05DE\u05D8 \u05D1\u05D9\u05E0\u05DC\u05D0\u05D5\u05DE\u05D9 \u05EA\u05E7\u05D9\u05DF.",
    form_param_max_length_exceeded__first_name: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9 \u05DC\u05D0 \u05E6\u05E8\u05D9\u05DA \u05DC\u05E2\u05DC\u05D5\u05EA \u05E2\u05DC 256 \u05EA\u05D5\u05D5\u05D9\u05DD.",
    form_param_max_length_exceeded__last_name: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4 \u05DC\u05D0 \u05E6\u05E8\u05D9\u05DA \u05DC\u05E2\u05DC\u05D5\u05EA \u05E2\u05DC 256 \u05EA\u05D5\u05D5\u05D9\u05DD.",
    form_param_max_length_exceeded__name: "\u05E9\u05DD \u05DC\u05D0 \u05E6\u05E8\u05D9\u05DA \u05DC\u05E2\u05DC\u05D5\u05EA \u05E2\u05DC 256 \u05EA\u05D5\u05D5\u05D9\u05DD.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05D0\u05D9\u05E0\u05D4 \u05DE\u05E1\u05E4\u05D9\u05E7 \u05D7\u05D6\u05E7\u05D4.",
    form_password_pwned: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D4\u05D6\u05D5 \u05E0\u05DE\u05E6\u05D0\u05D4 \u05DB\u05D7\u05DC\u05E7 \u05DE\u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05E9\u05E0\u05D7\u05E9\u05E4\u05D5 \u05D1\u05D4\u05E4\u05E8\u05EA \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD \u05D5\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D4, \u05E0\u05E1\u05D4 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05D0\u05D7\u05E8\u05EA \u05D1\u05DE\u05E7\u05D5\u05DD.",
    form_password_pwned__sign_in: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D4\u05D6\u05D5 \u05E0\u05DE\u05E6\u05D0\u05D4 \u05DB\u05D7\u05DC\u05E7 \u05DE\u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05E9\u05E0\u05D7\u05E9\u05E4\u05D5 \u05D1\u05D4\u05E4\u05E8\u05EA \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD \u05D5\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D4, \u05D0\u05E0\u05D0 \u05D1\u05E6\u05E2 \u05D0\u05D9\u05EA\u05D7\u05D5\u05DC \u05DC\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA.",
    form_password_size_in_bytes_exceeded: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05D7\u05D5\u05E8\u05D2\u05EA \u05DE\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D1\u05D9\u05D9\u05D8\u05D9\u05DD \u05D4\u05DE\u05E8\u05D1\u05D9 \u05D4\u05DE\u05D5\u05EA\u05E8, \u05E0\u05E1\u05D4 \u05DC\u05E7\u05E6\u05E8 \u05D0\u05D5\u05EA\u05D4 \u05D0\u05D5 \u05DC\u05D4\u05E1\u05D9\u05E8 \u05DB\u05DE\u05D4 \u05EA\u05D5\u05D5\u05D9\u05DD \u05DE\u05D9\u05D5\u05D7\u05D3\u05D9\u05DD.",
    form_password_validation_failed: "\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D4",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D6\u05D9\u05D4\u05D5\u05D9 \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05E9\u05DC\u05DA.",
    not_allowed_access: void 0,
    organization_domain_blocked: "\u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05E9\u05DC \u05E1\u05E4\u05E7 \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D4\u05D6\u05D4 \u05D7\u05E1\u05D5\u05DD. \u05D0\u05E0\u05D0 \u05E0\u05E1\u05D4 \u05D0\u05D7\u05D3 \u05E9\u05D5\u05E0\u05D4.",
    organization_domain_common: "\u05D4\u05D3\u05D5\u05DE\u05D9\u05D9\u05DF \u05E9\u05DC \u05E1\u05E4\u05E7 \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D4\u05D6\u05D4 \u05E0\u05E4\u05D5\u05E5. \u05D0\u05E0\u05D0 \u05E0\u05E1\u05D4 \u05D0\u05D7\u05D3 \u05E9\u05D5\u05E0\u05D4.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "\u05D4\u05D2\u05E2\u05EA \u05DC\u05DE\u05D2\u05D1\u05DC\u05EA \u05D4\u05D7\u05D1\u05E8\u05D5\u05EA \u05D1\u05D0\u05E8\u05D2\u05D5\u05DF, \u05DB\u05D5\u05DC\u05DC \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05D9\u05D5\u05E6\u05D0\u05D5\u05EA \u05D3\u05D5\u05E4\u05DF.",
    organization_minimum_permissions_needed: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D7\u05D1\u05E8 \u05D0\u05E8\u05D2\u05D5\u05DF \u05D0\u05D7\u05D3 \u05DC\u05E4\u05D7\u05D5\u05EA \u05E2\u05DD \u05D4\u05D4\u05E8\u05E9\u05D0\u05D5\u05EA \u05D4\u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9\u05D5\u05EA \u05D4\u05E0\u05D3\u05E8\u05E9\u05D5\u05EA.",
    passkey_already_exists: "\u05DE\u05E4\u05EA\u05D7 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05DB\u05D1\u05E8 \u05E8\u05E9\u05D5\u05DD \u05D1\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D6\u05D4.",
    passkey_not_supported: "\u05DE\u05E4\u05EA\u05D7\u05D5\u05EA \u05E1\u05D9\u05E1\u05DE\u05D4 \u05D0\u05D9\u05E0\u05DD \u05E0\u05EA\u05DE\u05DB\u05D9\u05DD \u05D1\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D6\u05D4.",
    passkey_pa_not_supported: "\u05D4\u05D4\u05E8\u05E9\u05DE\u05D4 \u05D3\u05D5\u05E8\u05E9\u05EA \u05DE\u05D0\u05DE\u05EA \u05E4\u05DC\u05D8\u05E4\u05D5\u05E8\u05DE\u05D4 \u05D0\u05DA \u05D4\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D0\u05D9\u05E0\u05D5 \u05EA\u05D5\u05DE\u05DA \u05D1\u05DB\u05DA.",
    passkey_registration_cancelled: "\u05E8\u05D9\u05E9\u05D5\u05DD \u05DE\u05E4\u05EA\u05D7 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D1\u05D5\u05D8\u05DC \u05D0\u05D5 \u05E4\u05D2 \u05D4\u05D6\u05DE\u05DF \u05D4\u05E7\u05E6\u05D5\u05D1.",
    passkey_retrieval_cancelled: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05DE\u05E4\u05EA\u05D7 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D1\u05D5\u05D8\u05DC \u05D0\u05D5 \u05E4\u05D2 \u05D4\u05D6\u05DE\u05DF \u05D4\u05E7\u05E6\u05D5\u05D1.",
    passwordComplexity: {
      maximumLength: "\u05E4\u05D7\u05D5\u05EA \u05DE-{{length}} \u05EA\u05D5\u05D5\u05D9\u05DD",
      minimumLength: "{{length}} \u05EA\u05D5\u05D5\u05D9\u05DD \u05D0\u05D5 \u05D9\u05D5\u05EA\u05E8",
      requireLowercase: "\u05D0\u05D5\u05EA \u05E7\u05D8\u05E0\u05D4",
      requireNumbers: "\u05DE\u05E1\u05E4\u05E8",
      requireSpecialCharacter: "\u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3",
      requireUppercase: "\u05D0\u05D5\u05EA \u05D2\u05D3\u05D5\u05DC\u05D4",
      sentencePrefix: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05DB\u05D9\u05DC"
    },
    phone_number_exists: "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05D4\u05D6\u05D4 \u05DB\u05D1\u05E8 \u05D1\u05E9\u05D9\u05DE\u05D5\u05E9. \u05D0\u05E0\u05D0 \u05E0\u05E1\u05D4 \u05DE\u05E1\u05E4\u05E8 \u05D0\u05D7\u05E8.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05EA\u05E7\u05E4\u05D4, \u05D0\u05DA \u05D9\u05DB\u05D5\u05DC\u05D4 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D7\u05D6\u05E7\u05D4 \u05D9\u05D5\u05EA\u05E8. \u05E0\u05E1\u05D4 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D9\u05D5\u05EA\u05E8 \u05EA\u05D5\u05D5\u05D9\u05DD.",
      goodPassword: "\u05E2\u05D1\u05D5\u05D3\u05D4 \u05D8\u05D5\u05D1\u05D4. \u05D6\u05D5 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05DE\u05E6\u05D5\u05D9\u05E0\u05EA.",
      notEnough: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05D0\u05D9\u05E0\u05D4 \u05DE\u05E1\u05E4\u05D9\u05E7 \u05D7\u05D6\u05E7\u05D4.",
      suggestions: {
        allUppercase: "\u05D4\u05D2\u05D3\u05DC \u05DB\u05DE\u05D4, \u05D0\u05DA \u05DC\u05D0 \u05D0\u05EA \u05DB\u05DC \u05D4\u05D0\u05D5\u05EA\u05D9\u05D5\u05EA.",
        anotherWord: "\u05D4\u05D5\u05E1\u05E3 \u05E2\u05D5\u05D3 \u05DE\u05D9\u05DC\u05D9\u05DD \u05E9\u05D4\u05DF \u05E4\u05D7\u05D5\u05EA \u05E0\u05E4\u05D5\u05E6\u05D5\u05EA.",
        associatedYears: "\u05D4\u05D9\u05DE\u05E0\u05E2 \u05DE\u05E9\u05E0\u05D9\u05DD \u05E9\u05E7\u05E9\u05D5\u05E8\u05D5\u05EA \u05D0\u05DC\u05D9\u05DA.",
        capitalization: "\u05D4\u05D2\u05D3\u05DC \u05D9\u05D5\u05EA\u05E8 \u05DE\u05D0\u05D5\u05EA \u05D0\u05D7\u05EA.",
        dates: "\u05D4\u05DE\u05E0\u05E2 \u05DE\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD \u05D5\u05E9\u05E0\u05D9\u05DD \u05E9\u05E7\u05E9\u05D5\u05E8\u05D9\u05DD \u05D0\u05DC\u05D9\u05DA.",
        l33t: "\u05D4\u05DE\u05E0\u05E2 \u05DE\u05D4\u05D7\u05DC\u05E4\u05D5\u05EA \u05EA\u05D5\u05D5\u05D9\u05DD \u05E6\u05E4\u05D5\u05D9\u05D5\u05EA \u05DB\u05DE\u05D5 '@' \u05D1\u05DE\u05E7\u05D5\u05DD 'a'.",
        longerKeyboardPattern: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D3\u05E4\u05D5\u05E1\u05D9 \u05DE\u05E7\u05DC\u05D3\u05EA \u05D0\u05E8\u05D5\u05DB\u05D9\u05DD \u05D9\u05D5\u05EA\u05E8 \u05D5\u05E9\u05E0\u05D4 \u05D0\u05EA \u05DB\u05D9\u05D5\u05D5\u05DF \u05D4\u05D4\u05E7\u05DC\u05D3\u05D4 \u05DE\u05E1\u05E4\u05E8 \u05E4\u05E2\u05DE\u05D9\u05DD.",
        noNeed: "\u05D0\u05EA\u05D4 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D9\u05E6\u05D5\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0\u05D5\u05EA \u05D7\u05D6\u05E7\u05D5\u05EA \u05DC\u05DC\u05D0 \u05E9\u05D9\u05DE\u05D5\u05E9 \u05D1\u05E1\u05DE\u05DC\u05D9\u05DD, \u05DE\u05E1\u05E4\u05E8\u05D9\u05DD, \u05D0\u05D5 \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D2\u05D3\u05D5\u05DC\u05D5\u05EA.",
        pwned: "\u05D0\u05DD \u05D0\u05EA\u05D4 \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D6\u05D5 \u05D1\u05DE\u05E7\u05D5\u05DE\u05D5\u05EA \u05D0\u05D7\u05E8\u05D9\u05DD, \u05E2\u05DC\u05D9\u05DA \u05DC\u05E9\u05E0\u05D5\u05EA\u05D4.",
        recentYears: "\u05D4\u05D9\u05DE\u05E0\u05E2 \u05DE\u05E9\u05E0\u05D9\u05DD \u05D0\u05D7\u05E8\u05D5\u05E0\u05D5\u05EA.",
        repeated: "\u05D4\u05D9\u05DE\u05E0\u05E2 \u05DE\u05DE\u05D9\u05DC\u05D9\u05DD \u05D5\u05EA\u05D5\u05D5\u05D9\u05DD \u05DE\u05D5\u05D7\u05D6\u05E8\u05D9\u05DD.",
        reverseWords: "\u05D4\u05D9\u05DE\u05E0\u05E2 \u05DE\u05DB\u05EA\u05D9\u05D1\u05D4 \u05D4\u05E4\u05D5\u05DB\u05D4 \u05E9\u05DC \u05DE\u05D9\u05DC\u05D9\u05DD \u05E0\u05E4\u05D5\u05E6\u05D5\u05EA.",
        sequences: "\u05D4\u05DE\u05E0\u05E2 \u05DE\u05E8\u05E6\u05E4\u05D5\u05EA \u05EA\u05D5\u05D5\u05D9\u05DD \u05E0\u05E4\u05D5\u05E6\u05D5\u05EA.",
        useWords: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05DE\u05D9\u05DC\u05D9\u05DD \u05DE\u05E8\u05D5\u05D1\u05D5\u05EA, \u05D0\u05DA \u05D4\u05D9\u05DE\u05E0\u05E2 \u05DE\u05D1\u05D9\u05D8\u05D5\u05D9\u05D9\u05DD \u05E0\u05E4\u05D5\u05E6\u05D9\u05DD."
      },
      warnings: {
        common: "\u05D6\u05D5 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05E0\u05DE\u05E6\u05D0\u05EA \u05D1\u05E9\u05D9\u05DE\u05D5\u05E9 \u05E0\u05E4\u05D5\u05E5.",
        commonNames: "\u05E9\u05DE\u05D5\u05EA \u05E0\u05E4\u05D5\u05E6\u05D9\u05DD \u05D5\u05E9\u05DE\u05D5\u05EA \u05DE\u05E9\u05E4\u05D7\u05D4 \u05E7\u05DC\u05D9\u05DD \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.",
        dates: "\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD \u05E7\u05DC\u05D9\u05DD \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.",
        extendedRepeat: '\u05D3\u05E4\u05D5\u05E1\u05D9\u05DD \u05DE\u05D5\u05D7\u05D6\u05E8\u05D9\u05DD \u05E9\u05DC \u05EA\u05D5\u05D5\u05D9\u05DD \u05DB\u05DE\u05D5 "abcabcabc" \u05E7\u05DC\u05D9\u05DD \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.',
        keyPattern: "\u05D3\u05E4\u05D5\u05E1\u05D9\u05DD \u05E7\u05E6\u05E8\u05D9\u05DD \u05E9\u05DC \u05DE\u05E7\u05DC\u05D3\u05EA \u05E7\u05DC\u05D9\u05DD \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.",
        namesByThemselves: "\u05E9\u05DE\u05D5\u05EA \u05D1\u05D5\u05D3\u05D3\u05D9\u05DD \u05D0\u05D5 \u05E9\u05DE\u05D5\u05EA \u05DE\u05E9\u05E4\u05D7\u05D4 \u05E7\u05DC\u05D9\u05DD \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.",
        pwned: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05D4\u05D5\u05D7\u05E9\u05E4\u05D4 \u05D1\u05DE\u05D4\u05DC\u05DA \u05D4\u05E4\u05E8\u05EA \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD \u05D1\u05D0\u05D9\u05E0\u05D8\u05E8\u05E0\u05D8.",
        recentYears: "\u05E9\u05E0\u05D9\u05DD \u05D0\u05D7\u05E8\u05D5\u05E0\u05D5\u05EA \u05E7\u05DC\u05D5\u05EA \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.",
        sequences: '\u05E8\u05E6\u05E4\u05D5\u05EA \u05EA\u05D5\u05D5\u05D9\u05DD \u05E0\u05E4\u05D5\u05E6\u05D5\u05EA \u05DB\u05DE\u05D5 "abc" \u05E7\u05DC\u05D5\u05EA \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.',
        similarToCommon: "\u05D6\u05D5 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05D3\u05D5\u05DE\u05D4 \u05DC\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05E0\u05DE\u05E6\u05D0\u05EA \u05D1\u05E9\u05D9\u05DE\u05D5\u05E9 \u05E0\u05E4\u05D5\u05E5.",
        simpleRepeat: '\u05EA\u05D5\u05D5\u05D9\u05DD \u05DE\u05D5\u05D7\u05D6\u05E8\u05D9\u05DD \u05DB\u05DE\u05D5 "aaa" \u05E7\u05DC\u05D9\u05DD \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.',
        straightRow: "\u05E9\u05D5\u05E8\u05D5\u05EA \u05D9\u05E9\u05E8\u05D5\u05EA \u05E9\u05DC \u05DE\u05E7\u05E9\u05D9\u05DD \u05D1\u05DE\u05E7\u05DC\u05D3\u05EA \u05E9\u05DC\u05DA \u05E7\u05DC\u05D5\u05EA \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9.",
        topHundred: "\u05D6\u05D5 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05E0\u05DE\u05E6\u05D0\u05EA \u05D1\u05E9\u05D9\u05DE\u05D5\u05E9 \u05EA\u05DB\u05D5\u05E3.",
        topTen: "\u05D6\u05D5 \u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05E0\u05DE\u05E6\u05D0\u05EA \u05D1\u05E9\u05D9\u05DE\u05D5\u05E9 \u05DB\u05D1\u05D3.",
        userInputs: "\u05D0\u05D9\u05DF \u05DC\u05D4\u05D6\u05D9\u05DF \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD \u05D0\u05D9\u05E9\u05D9\u05D9\u05DD \u05D0\u05D5 \u05E7\u05E9\u05D5\u05E8\u05D9\u05DD \u05DC\u05D3\u05E3.",
        wordByItself: "\u05DE\u05D9\u05DC\u05D9\u05DD \u05D1\u05D5\u05D3\u05D3\u05D5\u05EA \u05E7\u05DC\u05D5\u05EA \u05DC\u05E0\u05D9\u05D7\u05D5\u05E9."
      }
    }
  },
  userButton: {
    action__addAccount: "\u05D4\u05D5\u05E1\u05E3 \u05D7\u05E9\u05D1\u05D5\u05DF",
    action__manageAccount: "\u05E0\u05D4\u05DC \u05D7\u05E9\u05D1\u05D5\u05DF",
    action__signOut: "\u05D4\u05EA\u05E0\u05EA\u05E7",
    action__signOutAll: "\u05D4\u05EA\u05E0\u05EA\u05E7 \u05DE\u05DB\u05DC \u05D4\u05D7\u05E9\u05D1\u05D5\u05E0\u05D5\u05EA"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u05D4\u05D5\u05E2\u05EA\u05E7!",
      actionLabel__copy: "\u05D4\u05E2\u05EA\u05E7 \u05D4\u05DB\u05DC",
      actionLabel__download: "\u05D4\u05D5\u05E8\u05D3 .txt",
      actionLabel__print: "\u05D4\u05D3\u05E4\u05E1",
      infoText1: "\u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9 \u05D9\u05D4\u05D9\u05D5 \u05DE\u05D5\u05E4\u05E2\u05DC\u05D9\u05DD \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05D6\u05D4.",
      infoText2: "\u05E9\u05DE\u05D5\u05E8 \u05D0\u05EA \u05E7\u05D5\u05D3\u05D9 \u05D4\u05D2\u05D9\u05D1\u05D5\u05D9 \u05D1\u05E1\u05D5\u05D3 \u05D5\u05D0\u05D7\u05E1\u05DF \u05D0\u05D5\u05EA\u05DD \u05D1\u05D1\u05D8\u05D7\u05D4. \u05EA\u05D5\u05DB\u05DC \u05DC\u05D7\u05D5\u05DC\u05DC \u05DE\u05D7\u05D3\u05E9 \u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9 \u05D0\u05DD \u05D0\u05EA\u05D4 \u05D7\u05D5\u05E9\u05D3 \u05E9\u05D4\u05DD \u05E0\u05E4\u05D2\u05E2\u05D5.",
      subtitle__codelist: "\u05D0\u05D7\u05E1\u05DF \u05D0\u05D5\u05EA\u05DD \u05D1\u05D1\u05D8\u05D7\u05D4 \u05D5\u05E9\u05DE\u05D5\u05E8 \u05E2\u05DC\u05D9\u05D4\u05DD \u05D1\u05E1\u05D5\u05D3.",
      successMessage: "\u05E7\u05D5\u05D3\u05D9 \u05D4\u05D2\u05D9\u05D1\u05D5\u05D9 \u05DE\u05D5\u05E4\u05E2\u05DC\u05D9\u05DD \u05DB\u05E2\u05EA. \u05EA\u05D5\u05DB\u05DC \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05D7\u05D3 \u05DE\u05D0\u05DC\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA, \u05D0\u05DD \u05D0\u05EA\u05D4 \u05DE\u05D0\u05D1\u05D3 \u05D2\u05D9\u05E9\u05D4 \u05DC\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA. \u05DB\u05DC \u05E7\u05D5\u05D3 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D5 \u05E8\u05E7 \u05E4\u05E2\u05DD \u05D0\u05D7\u05EA.",
      successSubtitle: "\u05EA\u05D5\u05DB\u05DC \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05D7\u05D3 \u05DE\u05D0\u05DC\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA, \u05D0\u05DD \u05D0\u05EA\u05D4 \u05DE\u05D0\u05D1\u05D3 \u05D2\u05D9\u05E9\u05D4 \u05DC\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA.",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05E7\u05D5\u05D3 \u05D2\u05D9\u05D1\u05D5\u05D9",
      title__codelist: "\u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9"
    },
    connectedAccountPage: {
      formHint: "\u05D1\u05D7\u05E8 \u05E1\u05E4\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05D7\u05D1\u05E8 \u05D0\u05EA \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
      formHint__noAccounts: "\u05D0\u05D9\u05DF \u05E1\u05E4\u05E7\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DC\u05D7\u05E9\u05D1\u05D5\u05E0\u05D5\u05EA \u05D7\u05D9\u05E6\u05D5\u05E0\u05D9\u05D9\u05DD.",
      removeResource: {
        messageLine1: "{{identifier}} \u05D9\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05D4\u05D6\u05D4.",
        messageLine2: "\u05DC\u05D0 \u05EA\u05D5\u05DB\u05DC \u05D9\u05D5\u05EA\u05E8 \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D7\u05E9\u05D1\u05D5\u05DF \u05DE\u05D7\u05D5\u05D1\u05E8 \u05D6\u05D4 \u05D5\u05DB\u05DC \u05D4\u05EA\u05DB\u05D5\u05E0\u05D5\u05EA \u05D4\u05EA\u05DC\u05D5\u05D9\u05D5\u05EA \u05DC\u05D0 \u05D9\u05E2\u05D1\u05D3\u05D5.",
        successMessage: "{{connectedAccount}} \u05D4\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
        title: "\u05D4\u05E1\u05E8 \u05D7\u05E9\u05D1\u05D5\u05DF \u05DE\u05D7\u05D5\u05D1\u05E8"
      },
      socialButtonsBlockButton: "\u05D7\u05D1\u05E8 \u05D7\u05E9\u05D1\u05D5\u05DF {{provider|titleize}}",
      successMessage: "\u05D4\u05E1\u05E4\u05E7 \u05D4\u05EA\u05D5\u05D5\u05E1\u05E3 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D7\u05E9\u05D1\u05D5\u05DF \u05DE\u05D7\u05D5\u05D1\u05E8"
    },
    deletePage: {
      actionDescription: '\u05D4\u05E7\u05DC\u05D3 "\u05DE\u05D7\u05E7 \u05D7\u05E9\u05D1\u05D5\u05DF" \u05DC\u05DE\u05D8\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.',
      confirm: "\u05DE\u05D7\u05E7 \u05D7\u05E9\u05D1\u05D5\u05DF",
      messageLine1: "\u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7 \u05E9\u05D0\u05EA\u05D4 \u05E8\u05D5\u05E6\u05D4 \u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA?",
      messageLine2: "\u05E4\u05E2\u05D5\u05DC\u05D4 \u05D6\u05D5 \u05D4\u05D9\u05D0 \u05E1\u05D5\u05E4\u05D9\u05EA \u05D5\u05D1\u05DC\u05EA\u05D9 \u05D4\u05E4\u05D9\u05DB\u05D4.",
      title: "\u05DE\u05D7\u05E7 \u05D7\u05E9\u05D1\u05D5\u05DF"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05E9\u05DE\u05DB\u05D9\u05DC \u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D9\u05E9\u05DC\u05D7 \u05DC\u05DB\u05EA\u05D5\u05D1\u05EA \u05D6\u05D5.",
        formSubtitle: "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC-{{identifier}}",
        formTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA",
        resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05DE\u05D7\u05D3\u05E9",
        successMessage: "\u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC {{identifier}} \u05D4\u05EA\u05D5\u05D5\u05E1\u05E3 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA."
      },
      emailLink: {
        formHint: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05E9\u05DE\u05DB\u05D9\u05DC \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA \u05D9\u05E9\u05DC\u05D7 \u05DC\u05DB\u05EA\u05D5\u05D1\u05EA \u05D6\u05D5.",
        formSubtitle: "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05E7\u05D9\u05E9\u05D5\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D1\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC-{{identifier}}",
        formTitle: "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA",
        resendButton: "\u05E9\u05DC\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DE\u05D7\u05D3\u05E9",
        successMessage: "\u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC {{identifier}} \u05D4\u05EA\u05D5\u05D5\u05E1\u05E3 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u05D9\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05D4\u05D6\u05D4.",
        messageLine2: "\u05DC\u05D0 \u05EA\u05D5\u05DB\u05DC \u05D9\u05D5\u05EA\u05E8 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D6\u05D5.",
        successMessage: "\u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC {{emailAddress}} \u05D4\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
        title: "\u05D4\u05E1\u05E8 \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC"
      },
      title: "\u05D4\u05D5\u05E1\u05E3 \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
      verifyTitle: "\u05D0\u05DE\u05EA \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC"
    },
    formButtonPrimary__add: "\u05D4\u05D5\u05E1\u05E3",
    formButtonPrimary__continue: "\u05D4\u05DE\u05E9\u05DA",
    formButtonPrimary__finish: "\u05E1\u05D9\u05D9\u05DD",
    formButtonPrimary__remove: "\u05DE\u05D7\u05E7",
    formButtonPrimary__save: "\u05E9\u05DE\u05D5\u05E8",
    formButtonReset: "\u05D1\u05D8\u05DC",
    mfaPage: {
      formHint: "\u05D1\u05D7\u05E8 \u05E9\u05D9\u05D8\u05D4 \u05DC\u05D4\u05D5\u05E1\u05E4\u05D4.",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9"
    },
    mfaPhoneCodePage: {
      backButton: "\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05DE\u05E1\u05E4\u05E8 \u05E7\u05D9\u05D9\u05DD",
      primaryButton__addPhoneNumber: "\u05D4\u05D5\u05E1\u05E3 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
      removeResource: {
        messageLine1: "{{identifier}} \u05DC\u05D0 \u05D9\u05E7\u05D1\u05DC \u05D9\u05D5\u05EA\u05E8 \u05E7\u05D5\u05D3\u05D9\u05DD \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA \u05D1\u05E2\u05EA \u05D4\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA.",
        messageLine2: "\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA \u05E2\u05E9\u05D5\u05D9 \u05DC\u05D0 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D1\u05D8\u05D5\u05D7 \u05DB\u05DE\u05D5 \u05E9\u05D4\u05D5\u05D0. \u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7 \u05E9\u05D0\u05EA\u05D4 \u05E8\u05D5\u05E6\u05D4 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA?",
        successMessage: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05E7\u05D5\u05D3 SMS \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9 \u05D4\u05D5\u05E1\u05E8 \u05DC{{mfaPhoneCode}}",
        title: "\u05D4\u05E1\u05E8 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9"
      },
      subtitle__availablePhoneNumbers: "\u05D1\u05D7\u05E8 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA \u05E7\u05D5\u05D3 SMS \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9.",
      subtitle__unavailablePhoneNumbers: "\u05D0\u05D9\u05DF \u05DE\u05E1\u05E4\u05E8\u05D9 \u05D8\u05DC\u05E4\u05D5\u05DF \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA \u05E7\u05D5\u05D3 SMS \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9.",
      successMessage1: "\u05D1\u05E2\u05EA \u05D4\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA, \u05EA\u05E6\u05D8\u05E8\u05DA \u05DC\u05D4\u05D6\u05D9\u05DF \u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF \u05D6\u05D4 \u05DB\u05E9\u05DC\u05D1 \u05E0\u05D5\u05E1\u05E3.",
      successMessage2: "\u05E9\u05DE\u05D5\u05E8 \u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9 \u05D0\u05DC\u05D5 \u05D1\u05DE\u05E7\u05D5\u05DD \u05D1\u05D8\u05D5\u05D7. \u05D0\u05DD \u05EA\u05D0\u05D1\u05D3 \u05D2\u05D9\u05E9\u05D4 \u05DC\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05DC\u05DA, \u05EA\u05D5\u05DB\u05DC \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8.",
      successTitle: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05E7\u05D5\u05D3 SMS \u05D4\u05D5\u05E4\u05E2\u05DC",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05E7\u05D5\u05D3 SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u05E1\u05E8\u05D5\u05E7 \u05E7\u05D5\u05D3 QR \u05D1\u05DE\u05E7\u05D5\u05DD",
        buttonUnableToScan__nonPrimary: "\u05DC\u05D0 \u05D9\u05DB\u05D5\u05DC \u05DC\u05E1\u05E8\u05D5\u05E7 \u05E7\u05D5\u05D3 QR?",
        infoText__ableToScan: "\u05D4\u05D2\u05D3\u05E8 \u05E9\u05D9\u05D8\u05EA \u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA \u05D7\u05D3\u05E9\u05D4 \u05D1\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D4\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05E9\u05DC\u05DA \u05D5\u05E1\u05E8\u05D5\u05E7 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4-QR \u05D4\u05D1\u05D0 \u05DB\u05D3\u05D9 \u05DC\u05D7\u05D1\u05E8\u05D5 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
        infoText__unableToScan: "\u05D4\u05D2\u05D3\u05E8 \u05E9\u05D9\u05D8\u05EA \u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA \u05D7\u05D3\u05E9\u05D4 \u05D1\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05E9\u05DC\u05DA \u05D5\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05DE\u05E4\u05EA\u05D7 \u05E9\u05E1\u05D5\u05E4\u05E7 \u05DC\u05DE\u05D8\u05D4.",
        inputLabel__unableToScan1: "\u05D5\u05D5\u05D3\u05D0 \u05E9\u05E1\u05D9\u05E1\u05DE\u05D0\u05D5\u05EA \u05DE\u05D1\u05D5\u05E1\u05E1\u05D5\u05EA-\u05D6\u05DE\u05DF \u05D0\u05D5 \u05D7\u05D3-\u05E4\u05E2\u05DE\u05D9\u05D5\u05EA \u05DE\u05D5\u05E4\u05E2\u05DC\u05D5\u05EA, \u05D5\u05D0\u05D6 \u05E1\u05D9\u05D9\u05DD \u05DC\u05D7\u05D1\u05E8 \u05D0\u05EA \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
        inputLabel__unableToScan2: "\u05DC\u05D7\u05DC\u05D5\u05E4\u05D9\u05DF, \u05D0\u05DD \u05D4\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05E9\u05DC\u05DA \u05EA\u05D5\u05DE\u05DA \u05D1\u05DB\u05EA\u05D5\u05D1\u05EA URI \u05E9\u05DC TOTP, \u05EA\u05D5\u05DB\u05DC \u05D2\u05DD \u05DC\u05D4\u05E2\u05EA\u05D9\u05E7 \u05D0\u05EA \u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05DE\u05DC\u05D0\u05D4."
      },
      removeResource: {
        messageLine1: "\u05E7\u05D5\u05D3\u05D9 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05DE\u05D4\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05D4\u05D6\u05D4 \u05DC\u05D0 \u05D9\u05D4\u05D9\u05D5 \u05E0\u05D3\u05E8\u05E9\u05D9\u05DD \u05D9\u05D5\u05EA\u05E8 \u05D1\u05E2\u05EA \u05D4\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA.",
        messageLine2: "\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA \u05E2\u05E9\u05D5\u05D9 \u05DC\u05D0 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D1\u05D8\u05D5\u05D7 \u05DB\u05DE\u05D5 \u05E9\u05D4\u05D5\u05D0. \u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7 \u05E9\u05D0\u05EA\u05D4 \u05E8\u05D5\u05E6\u05D4 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA?",
        successMessage: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05EA \u05D4\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05D4\u05D5\u05E1\u05E8.",
        title: "\u05D4\u05E1\u05E8 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9"
      },
      successMessage: "\u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9 \u05DE\u05D5\u05E4\u05E2\u05DC \u05DB\u05E2\u05EA. \u05D1\u05E2\u05EA \u05D4\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA, \u05EA\u05D9\u05D3\u05E8\u05E9 \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05DE\u05D4\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05D6\u05D4 \u05DB\u05E9\u05DC\u05D1 \u05E0\u05D5\u05E1\u05E3.",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D0\u05D9\u05DE\u05D5\u05EA",
      verifySubtitle: "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05D5\u05E6\u05E8 \u05E2\u05DC \u05D9\u05D3\u05D9 \u05D4\u05D0\u05D5\u05EA\u05E0\u05D8\u05D9\u05E7\u05D8\u05D5\u05E8 \u05E9\u05DC\u05DA",
      verifyTitle: "\u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D5\u05EA"
    },
    mobileButton__menu: "\u05EA\u05E4\u05E8\u05D9\u05D8",
    navbar: {
      account: "\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC",
      description: "\u05E0\u05D4\u05DC \u05D0\u05EA \u05E4\u05E8\u05D8\u05D9 \u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
      security: "\u05D0\u05D1\u05D8\u05D7\u05D4",
      title: "\u05D7\u05E9\u05D1\u05D5\u05DF"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} \u05D9\u05D5\u05E1\u05E8 \u05DE\u05D7\u05E9\u05D1\u05D5\u05DF \u05D6\u05D4",
        title: "\u05D4\u05E1\u05E8 \u05DE\u05E4\u05EA\u05D7 \u05E1\u05D9\u05E1\u05DE\u05D4"
      },
      subtitle__rename: "\u05D0\u05EA\u05D4 \u05D9\u05DB\u05D5\u05DC \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05E9\u05DD \u05DE\u05E4\u05EA\u05D7 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E2\u05DC \u05DE\u05E0\u05EA \u05DC\u05DE\u05E6\u05D5\u05D0 \u05D0\u05D5\u05EA\u05D5 \u05D1\u05E7\u05DC\u05D5\u05EA \u05D9\u05D5\u05EA\u05E8",
      title__rename: "\u05E9\u05E0\u05D4 \u05E9\u05DD \u05DC\u05DE\u05E4\u05EA\u05D7 \u05E1\u05D9\u05E1\u05DE\u05D4"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u05DE\u05D5\u05DE\u05DC\u05E5 \u05DC\u05D4\u05EA\u05E0\u05EA\u05E7 \u05DE\u05DB\u05DC \u05D4\u05DE\u05DB\u05E9\u05D9\u05E8\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D9\u05DD \u05E9\u05E2\u05DC\u05D5\u05DC\u05D9\u05DD \u05D4\u05D9\u05D5 \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D4\u05D9\u05E9\u05E0\u05D4 \u05E9\u05DC\u05DA.",
      readonly: "\u05DB\u05E8\u05D2\u05E2 \u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E2\u05E8\u05D5\u05DA \u05D0\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05DE\u05DB\u05D9\u05D5\u05D5\u05DF \u05E9\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05E8\u05E7 \u05D3\u05E8\u05DA \u05D7\u05D9\u05D1\u05D5\u05E8 \u05D0\u05E8\u05D2\u05D5\u05E0\u05D9.",
      successMessage__set: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05D4\u05D5\u05D2\u05D3\u05E8\u05D4.",
      successMessage__signOutOfOtherSessions: "\u05DB\u05DC \u05D4\u05DE\u05DB\u05E9\u05D9\u05E8\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D9\u05DD \u05D4\u05EA\u05E0\u05EA\u05E7\u05D5.",
      successMessage__update: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05DC\u05DA \u05E2\u05D5\u05D3\u05DB\u05E0\u05D4.",
      title__set: "\u05D4\u05D2\u05D3\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D4",
      title__update: "\u05E9\u05E0\u05D4 \u05E1\u05D9\u05E1\u05DE\u05D4"
    },
    phoneNumberPage: {
      infoText: "\u05D4\u05D5\u05D3\u05E2\u05EA \u05D8\u05E7\u05E1\u05D8 \u05E9\u05DE\u05DB\u05D9\u05DC\u05D4 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05D0\u05D9\u05DE\u05D5\u05EA \u05EA\u05D9\u05E9\u05DC\u05D7 \u05DC\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF \u05D6\u05D4.",
      removeResource: {
        messageLine1: "{{identifier}} \u05D9\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05D4\u05D6\u05D4.",
        messageLine2: "\u05DC\u05D0 \u05EA\u05D5\u05DB\u05DC \u05D9\u05D5\u05EA\u05E8 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF \u05D6\u05D4.",
        successMessage: "{{phoneNumber}} \u05D4\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
        title: "\u05D4\u05E1\u05E8 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF"
      },
      successMessage: "{{identifier}} \u05D4\u05EA\u05D5\u05D5\u05E1\u05E3 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
      verifySubtitle: "\u05D4\u05D6\u05DF \u05D0\u05EA \u05E7\u05D5\u05D3 \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA \u05E9\u05E0\u05E9\u05DC\u05D7 \u05DC{{identifier}}",
      verifyTitle: "\u05D0\u05DE\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF"
    },
    profilePage: {
      fileDropAreaHint: '\u05D4\u05E2\u05DC\u05D4 \u05EA\u05DE\u05D5\u05E0\u05D4 \u05D1\u05E4\u05D5\u05E8\u05DE\u05D8 JPG, PNG, GIF, \u05D0\u05D5 WEBP \u05D4\u05E7\u05D8\u05E0\u05D4 \u05DE-10 \u05DE"\u05D1',
      imageFormDestructiveActionSubtitle: "\u05D4\u05E1\u05E8 \u05EA\u05DE\u05D5\u05E0\u05D4",
      imageFormSubtitle: "\u05D4\u05E2\u05DC\u05D4 \u05EA\u05DE\u05D5\u05E0\u05D4",
      imageFormTitle: "\u05EA\u05DE\u05D5\u05E0\u05EA \u05E4\u05E8\u05D5\u05E4\u05D9\u05DC",
      readonly: "\u05E4\u05E8\u05D8\u05D9 \u05D4\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC \u05E9\u05DC\u05DA \u05E0\u05D9\u05EA\u05E0\u05D9\u05DD \u05E2\u05DC \u05D9\u05D3\u05D9 \u05D4\u05D7\u05D9\u05D1\u05D5\u05E8 \u05D4\u05D0\u05E8\u05D2\u05D5\u05E0\u05D9 \u05D5\u05D0\u05D9\u05E0\u05DD \u05E0\u05D9\u05EA\u05E0\u05D9\u05DD \u05DC\u05E2\u05E8\u05D9\u05DB\u05D4.",
      successMessage: "\u05D4\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC \u05E9\u05DC\u05DA \u05E2\u05D5\u05D3\u05DB\u05DF.",
      title: "\u05E2\u05D3\u05DB\u05DF \u05E4\u05E8\u05D5\u05E4\u05D9\u05DC"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u05D4\u05EA\u05E0\u05EA\u05E7 \u05DE\u05D4\u05DE\u05DB\u05E9\u05D9\u05E8",
        title: "\u05DE\u05DB\u05E9\u05D9\u05E8\u05D9\u05DD \u05E4\u05E2\u05D9\u05DC\u05D9\u05DD"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1",
        actionLabel__reauthorize: "\u05D0\u05E9\u05E8 \u05E2\u05DB\u05E9\u05D9\u05D5",
        destructiveActionTitle: "\u05D4\u05E1\u05E8",
        primaryButton: "\u05D7\u05D1\u05E8 \u05D7\u05E9\u05D1\u05D5\u05DF",
        subtitle__disconnected: "\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05D4\u05D6\u05D4 \u05E0\u05D5\u05EA\u05E7",
        subtitle__reauthorize: "\u05D4\u05D4\u05E8\u05E9\u05D0\u05D5\u05EA \u05D4\u05E0\u05D3\u05E8\u05E9\u05D5\u05EA \u05E2\u05D5\u05D3\u05DB\u05E0\u05D5, \u05D9\u05D9\u05EA\u05DB\u05DF \u05E9\u05D0\u05EA\u05D4 \u05D7\u05D5\u05D5\u05D4 \u05E4\u05D5\u05E0\u05E7\u05E6\u05D9\u05D5\u05E0\u05DC\u05D9\u05D5\u05EA \u05DE\u05D5\u05D2\u05D1\u05DC\u05EA. \u05D0\u05E0\u05D0 \u05D0\u05E9\u05E8 \u05DE\u05D7\u05D3\u05E9 \u05D0\u05EA \u05D4\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05D9\u05DE\u05E0\u05E2 \u05DE\u05D1\u05E2\u05D9\u05D5\u05EA.",
        title: "\u05D7\u05E9\u05D1\u05D5\u05E0\u05D5\u05EA \u05DE\u05D7\u05D5\u05D1\u05E8\u05D9\u05DD"
      },
      dangerSection: {
        deleteAccountButton: "\u05DE\u05D7\u05E7 \u05D7\u05E9\u05D1\u05D5\u05DF",
        title: "\u05DE\u05E1\u05D5\u05DB\u05DF"
      },
      emailAddressesSection: {
        destructiveAction: "\u05D4\u05E1\u05E8 \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
        detailsAction__nonPrimary: "\u05D4\u05D2\u05D3\u05E8 \u05DB\u05E2\u05D9\u05E7\u05E8\u05D9\u05EA",
        detailsAction__primary: "\u05D4\u05E9\u05DC\u05DD \u05D0\u05D9\u05DE\u05D5\u05EA",
        detailsAction__unverified: "\u05D4\u05E9\u05DC\u05DD \u05D0\u05D9\u05DE\u05D5\u05EA",
        primaryButton: "\u05D4\u05D5\u05E1\u05E3 \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
        title: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC"
      },
      enterpriseAccountsSection: {
        title: "\u05D7\u05E9\u05D1\u05D5\u05E0\u05D5\u05EA \u05D0\u05E8\u05D2\u05D5\u05E0\u05D9\u05D9\u05DD"
      },
      headerTitle__account: "\u05D7\u05E9\u05D1\u05D5\u05DF",
      headerTitle__security: "\u05D0\u05D1\u05D8\u05D7\u05D4",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u05E6\u05D5\u05E8 \u05E7\u05D5\u05D3\u05D9\u05DD \u05DE\u05D7\u05D3\u05E9",
          headerTitle: "\u05E7\u05D5\u05D3 \u05D2\u05D9\u05D1\u05D5\u05D9",
          subtitle__regenerate: "\u05E7\u05D1\u05DC \u05E7\u05D1\u05D5\u05E6\u05D4 \u05D7\u05D3\u05E9\u05D4 \u05E9\u05DC \u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9 \u05DE\u05D0\u05D5\u05D1\u05D8\u05D7\u05D9\u05DD. \u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9 \u05E7\u05D5\u05D3\u05DE\u05D9\u05DD \u05D9\u05D9\u05DE\u05D7\u05E7\u05D5 \u05D5\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D4\u05DD.",
          title__regenerate: "\u05E6\u05D5\u05E8 \u05DE\u05D7\u05D3\u05E9 \u05E7\u05D5\u05D3\u05D9 \u05D2\u05D9\u05D1\u05D5\u05D9"
        },
        phoneCode: {
          actionLabel__setDefault: "\u05D4\u05D2\u05D3\u05E8 \u05DB\u05D1\u05E8\u05D9\u05E8\u05EA \u05DE\u05D7\u05D3\u05DC",
          destructiveActionLabel: "\u05D4\u05E1\u05E8 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF"
        },
        primaryButton: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9",
        title: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05D3\u05D5-\u05E9\u05DC\u05D1\u05D9",
        totp: {
          destructiveActionTitle: "\u05D4\u05E1\u05E8",
          headerTitle: "\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05DE\u05D0\u05DE\u05EA"
        }
      },
      passkeysSection: {
        menuAction__destructive: "\u05D4\u05D2\u05D3\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D4",
        menuAction__rename: "\u05E2\u05D3\u05DB\u05DF \u05E1\u05D9\u05E1\u05DE\u05D4",
        primaryButton: void 0,
        title: "\u05E1\u05D9\u05E1\u05DE\u05D4"
      },
      passwordSection: {
        primaryButton__setPassword: "\u05D4\u05D2\u05D3\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D4",
        primaryButton__updatePassword: "\u05E9\u05E0\u05D4 \u05E1\u05D9\u05E1\u05DE\u05D4",
        title: "\u05E1\u05D9\u05E1\u05DE\u05D4"
      },
      phoneNumbersSection: {
        destructiveAction: "\u05D4\u05E1\u05E8 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
        detailsAction__nonPrimary: "\u05D4\u05D2\u05D3\u05E8 \u05DB\u05E8\u05D0\u05E9\u05D9",
        detailsAction__primary: "\u05D4\u05E9\u05DC\u05DD \u05D0\u05D9\u05DE\u05D5\u05EA",
        detailsAction__unverified: "\u05D4\u05E9\u05DC\u05DD \u05D0\u05D9\u05DE\u05D5\u05EA",
        primaryButton: "\u05D4\u05D5\u05E1\u05E3 \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
        title: "\u05DE\u05E1\u05E4\u05E8\u05D9 \u05D8\u05DC\u05E4\u05D5\u05DF"
      },
      profileSection: {
        primaryButton: "\u05E2\u05D3\u05DB\u05DF \u05E4\u05E8\u05D5\u05E4\u05D9\u05DC",
        title: "\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC"
      },
      usernameSection: {
        primaryButton__setUsername: "\u05D4\u05D2\u05D3\u05E8 \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
        primaryButton__updateUsername: "\u05E9\u05E0\u05D4 \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
        title: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9"
      },
      web3WalletsSection: {
        destructiveAction: "\u05D4\u05E1\u05E8 \u05D0\u05E8\u05E0\u05E7",
        primaryButton: "\u05D0\u05E8\u05E0\u05E7\u05D9 Web3",
        title: "\u05D0\u05E8\u05E0\u05E7\u05D9 Web3"
      }
    },
    usernamePage: {
      successMessage: "\u05E9\u05DD \u05D4\u05DE\u05E9\u05EA\u05DE\u05E9 \u05E9\u05DC\u05DA \u05E2\u05D5\u05D3\u05DB\u05DF.",
      title__set: "\u05E2\u05D3\u05DB\u05DF \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
      title__update: "\u05E2\u05D3\u05DB\u05DF \u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u05D9\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05D4\u05D6\u05D4.",
        messageLine2: "\u05DC\u05D0 \u05EA\u05D5\u05DB\u05DC \u05D9\u05D5\u05EA\u05E8 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D0\u05E8\u05E0\u05E7 web3 \u05D6\u05D4.",
        successMessage: "{{web3Wallet}} \u05D4\u05D5\u05E1\u05E8 \u05DE\u05D4\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
        title: "\u05D4\u05E1\u05E8 \u05D0\u05E8\u05E0\u05E7 web3"
      },
      subtitle__availableWallets: "\u05D1\u05D7\u05E8 \u05D0\u05E8\u05E0\u05E7 web3 \u05DC\u05D7\u05D9\u05D1\u05D5\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
      subtitle__unavailableWallets: "\u05D0\u05D9\u05DF \u05D0\u05E8\u05E0\u05E7\u05D9 web3 \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD.",
      successMessage: "\u05D4\u05D0\u05E8\u05E0\u05E7 \u05D4\u05EA\u05D5\u05D5\u05E1\u05E3 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA.",
      title: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05E8\u05E0\u05E7 web3",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/cs-CZ.ts
var csCZ = {
  locale: "cs-CZ",
  backButton: "Zp\u011Bt",
  badge__default: "V\xFDchoz\xED",
  badge__otherImpersonatorDevice: "Jin\xE9 za\u0159\xEDzen\xED p\u0159edstavitele",
  badge__primary: "Hlavn\xED",
  badge__requiresAction: "Vy\u017Eaduje akci",
  badge__thisDevice: "Toto za\u0159\xEDzen\xED",
  badge__unverified: "Nepotvrzen\xE9",
  badge__userDevice: "Za\u0159\xEDzen\xED u\u017Eivatele",
  badge__you: "Vy",
  createOrganization: {
    formButtonSubmit: "Vytvo\u0159it organizaci",
    invitePage: {
      formButtonReset: "P\u0159esko\u010Dit"
    },
    title: "Vytvo\u0159it organizaci"
  },
  dates: {
    lastDay: "V\u010Dera v {{ date | timeString('cs-CZ') }}",
    next6Days: "P\u0159\xED\u0161t\xED  {{ date | weekday('cs-CZ','long') }} v {{ date | timeString('cs-CZ') }}",
    nextDay: "Z\xEDtra v {{ date | timeString('cs-CZ') }}",
    numeric: "{{ date | numeric('cs-CZ') }}",
    previous6Days: "Minul\xFD {{ date | weekday('cs-CZ','long') }} v {{ date | timeString('cs-CZ') }}",
    sameDay: "Dnes v  {{ date | timeString('cs-CZ') }}"
  },
  dividerText: "nebo",
  footerActionLink__useAnotherMethod: "Pou\u017E\xEDt jinou metodu",
  footerPageLink__help: "N\xE1pov\u011Bda",
  footerPageLink__privacy: "Ochrana soukrom\xED",
  footerPageLink__terms: "Podm\xEDnky",
  formButtonPrimary: "Pokra\u010Dovat",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Zapomn\u011Bli jste heslo?",
  formFieldError__matchingPasswords: "Hesla se shoduj\xED.",
  formFieldError__notMatchingPasswords: "Hesla se neshoduj\xED.",
  formFieldError__verificationLinkExpired: "Odkaz pro ov\u011B\u0159en\xED ji\u017E expiroval. Pros\xEDm, po\u017E\xE1dejte o nov\xFD.",
  formFieldHintText__optional: "Voliteln\xE9",
  formFieldHintText__slug: "Slug je \u010Dlov\u011Bkem \u010Diteln\xFD identifik\xE1tor, kter\xFD mus\xED b\xFDt unik\xE1tn\xED. \u010Casto pou\u017Eit v URL adres\xE1ch.",
  formFieldInputPlaceholder__backupCode: "Zadejte z\xE1lo\u017En\xED k\xF3d",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Potvr\u010Fte smaz\xE1n\xED \xFA\u010Dtu",
  formFieldInputPlaceholder__emailAddress: "Zadejte va\u0161i emailovou adresu",
  formFieldInputPlaceholder__emailAddress_username: "Zadejte sv\u016Fj email nebo u\u017Eivatelsk\xE9 jm\xE9no",
  formFieldInputPlaceholder__emailAddresses: "Zadejte nebo vlo\u017Ete jednu nebo v\xEDce emailov\xFDch adres odd\u011Blen\xFDch mezerou nebo \u010D\xE1rkou",
  formFieldInputPlaceholder__firstName: "Zadejte sv\xE9 jm\xE9no",
  formFieldInputPlaceholder__lastName: "Zadejte sv\xE9 p\u0159\xEDjmen\xED",
  formFieldInputPlaceholder__organizationDomain: "Zadejte dom\xE9nu va\u0161\xED organizace",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "Zadejte emailovou adresu va\u0161\xED organizace",
  formFieldInputPlaceholder__organizationName: "Zadejte n\xE1zev va\u0161\xED organizace",
  formFieldInputPlaceholder__organizationSlug: "Zadejte slug pro va\u0161i organizaci",
  formFieldInputPlaceholder__password: "Zadejte sv\xE9 heslo",
  formFieldInputPlaceholder__phoneNumber: "Zadejte sv\xE9 telefonn\xED \u010D\xEDslo",
  formFieldInputPlaceholder__username: "Zadejte sv\xE9 u\u017Eivatelsk\xE9 jm\xE9no",
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "Z\xE1lo\u017En\xED k\xF3d",
  formFieldLabel__confirmDeletion: "Potvrzen\xED",
  formFieldLabel__confirmPassword: "Potvrdit heslo",
  formFieldLabel__currentPassword: "St\xE1vaj\xEDc\xED heslo",
  formFieldLabel__emailAddress: "Emailov\xE1 adresa",
  formFieldLabel__emailAddress_username: "Emailov\xE1 adresa nebo u\u017Eivatelsk\xE9 jm\xE9no",
  formFieldLabel__emailAddresses: "Emailov\xE9 adresy",
  formFieldLabel__firstName: "Jm\xE9no",
  formFieldLabel__lastName: "P\u0159\xEDjmen\xED",
  formFieldLabel__newPassword: "Nov\xE9 heslo",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "N\xE1zev organizace",
  formFieldLabel__organizationSlug: "URL adresa",
  formFieldLabel__passkeyName: "N\xE1zev kl\xED\u010De",
  formFieldLabel__password: "Heslo",
  formFieldLabel__phoneNumber: "Telefonn\xED \u010D\xEDslo",
  formFieldLabel__role: "Role",
  formFieldLabel__signOutOfOtherSessions: "Odhl\xE1sit se ze v\u0161ech ostatn\xEDch za\u0159\xEDzen\xED",
  formFieldLabel__username: "U\u017Eivatelsk\xE9 jm\xE9no",
  impersonationFab: {
    action__signOut: "Odhl\xE1sit se",
    title: "P\u0159ihl\xE1\u0161en(a) jako {{identifier}}"
  },
  maintenanceMode: "\xDAdr\u017Eba",
  membershipRole__admin: "Spr\xE1vce",
  membershipRole__basicMember: "\u010Clen",
  membershipRole__guestMember: "Host",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Pozv\xE1nky se nepoda\u0159ilo odeslat. Opravte n\xE1sleduj\xEDc\xED a zkuste to znovu:",
      formButtonPrimary__continue: "Odeslat pozv\xE1nky",
      selectDropdown__role: "Select role",
      subtitle: "Pozvat nov\xE9 \u010Dleny do t\xE9to organizace",
      successMessage: "Pozv\xE1nky byly \xFAsp\u011B\u0161n\u011B odesl\xE1ny",
      title: "Pozvat \u010Dleny"
    },
    membersPage: {
      action__invite: "Pozvat",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Odstranit \u010Dlena",
        tableHeader__actions: "Akce",
        tableHeader__joined: "P\u0159ipojil se",
        tableHeader__role: "Role",
        tableHeader__user: "U\u017Eivatel"
      },
      detailsTitle__emptyRow: "\u017D\xE1dn\xED \u010Dlenov\xE9 k zobrazen\xED",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "Zru\u0161it pozv\xE1n\xED",
        tableHeader__invited: "Pozv\xE1ni"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to delete this organization?",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have deleted the organization.",
          title: "Delete organization"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Opravdu chcete opustit tuto organizaci? Ztrat\xEDte p\u0159\xEDstup k t\xE9to organizaci a jej\xEDm aplikac\xEDm.",
          messageLine2: "Tato akce je trval\xE1 a nevratn\xE1.",
          successMessage: "Opustili jste organizaci.",
          title: "Opustit organizaci"
        },
        title: "Upozorn\u011Bn\xED"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "Organizace byla aktualizov\xE1na.",
      title: "Profil organizace"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\u010Clenov\xE9",
      profileSection: {
        primaryButton: "Pokra\u010Dovat",
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Vytvo\u0159it organizaci",
    action__invitationAccept: "Join",
    action__manageOrganization: "Spravovat organizaci",
    action__suggestionsAccept: "Request to join",
    notSelected: "Nen\xED vybr\xE1na \u017E\xE1dn\xE1 organizace",
    personalWorkspace: "Osobn\xED pracovn\xED prostor",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "Dal\u0161\xED",
  paginationButton__previous: "P\u0159edchoz\xED",
  paginationRowText__displaying: "Zobrazuje se",
  paginationRowText__of: "z",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Z\xEDskat pomoc",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Pou\u017E\xEDt z\xE1lo\u017En\xED k\xF3d",
      blockButton__emailCode: "Odeslat ov\u011B\u0159ovac\xED k\xF3d na email {{identifier}}",
      blockButton__emailLink: "Odeslat odkaz na email {{identifier}}",
      blockButton__passkey: "Pou\u017E\xEDt Passkey",
      blockButton__password: "P\u0159ihl\xE1sit se pomoc\xED hesla",
      blockButton__phoneCode: "Poslat SMS k\xF3d na telefonn\xED \u010D\xEDslo {{identifier}}",
      blockButton__totp: "Pou\u017E\xEDt autentiza\u010Dn\xED aplikaci",
      getHelp: {
        blockButton__emailSupport: "Podpora p\u0159es email",
        content: "Pokud m\xE1te pot\xED\u017Ee s p\u0159ihl\xE1\u0161en\xEDm do sv\xE9ho \xFA\u010Dtu, kontaktujte n\xE1s emailem a pokus\xEDme se v\xE1m co nejd\u0159\xEDve obnovit p\u0159\xEDstup.",
        title: "Z\xEDskat pomoc"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "Pou\u017E\xEDt jinou metodu"
    },
    backupCodeMfa: {
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Zadejte z\xE1lo\u017En\xED k\xF3d"
    },
    emailCode: {
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
      resendButton: "Znovu poslat k\xF3d",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Zkontrolujte sv\u016Fj email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Zkontrolujte, \u017Ee pou\u017E\xEDv\xE1te spr\xE1vn\xE9ho klienta.",
        title: "Chyba klienta"
      },
      expired: {
        subtitle: "Vra\u0165te se do p\u016Fvodn\xEDho okna pro pokra\u010Dov\xE1n\xED.",
        title: "Tento ov\u011B\u0159ovac\xED odkaz vypr\u0161el"
      },
      failed: {
        subtitle: "Vra\u0165te se do p\u016Fvodn\xEDho okna pro pokra\u010Dov\xE1n\xED.",
        title: "Tento ov\u011B\u0159ovac\xED odkaz je neplatn\xFD"
      },
      formSubtitle: "Pou\u017Eijte ov\u011B\u0159ovac\xED odkaz zaslan\xFD na v\xE1\u0161 email",
      formTitle: "Ov\u011B\u0159ovac\xED odkaz",
      loading: {
        subtitle: "Brzy budete p\u0159esm\u011Brov\xE1ni",
        title: "P\u0159ihla\u0161uji..."
      },
      resendButton: "Znovu poslat odkaz",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Zkontrolujte sv\u016Fj email",
      unusedTab: {
        title: "M\u016F\u017Eete zav\u0159\xEDt toto okno"
      },
      verified: {
        subtitle: "Brzy budete p\u0159esm\u011Brov\xE1ni",
        title: "\xDAsp\u011B\u0161n\u011B p\u0159ihl\xE1\u0161eno"
      },
      verifiedSwitchTab: {
        subtitle: "Vra\u0165te se do p\u016Fvodn\xEDho okna pro pokra\u010Dov\xE1n\xED",
        subtitleNewTab: "Vra\u0165te se do nov\u011B otev\u0159en\xE9ho okna pro pokra\u010Dov\xE1n\xED",
        titleNewTab: "P\u0159ihl\xE1\u0161eno v jin\xE9m okn\u011B"
      }
    },
    forgotPassword: {
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d pro obnoven\xED hesla",
      resendButton: "Znovu poslat k\xF3d",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Obnovit heslo",
      label__alternativeMethods: "Nebo se p\u0159ihlaste pomoc\xED jin\xE9 metody.",
      title: "Zapomn\u011Bli jste heslo?"
    },
    noAvailableMethods: {
      message: "Nelze pokra\u010Dovat v p\u0159ihl\xE1\u0161en\xED. Nen\xED k dispozici \u017E\xE1dn\xE1 dostupn\xE1 autentifika\u010Dn\xED metoda.",
      subtitle: "Do\u0161lo k chyb\u011B",
      title: "Nelze se p\u0159ihl\xE1sit"
    },
    passkey: {
      subtitle: "Pou\u017Eijte v\xE1\u0161 Passkey pro ov\u011B\u0159en\xED.",
      title: "Ov\u011B\u0159en\xED pomoc\xED Passkey"
    },
    password: {
      actionLink: "Pou\u017E\xEDt jinou metodu",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Zadejte sv\xE9 heslo"
    },
    passwordPwned: {
      title: "Zadejte sv\xE9 heslo"
    },
    phoneCode: {
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
      resendButton: "Znovu odeslat k\xF3d",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Zkontrolujte sv\u016Fj telefon"
    },
    phoneCodeMfa: {
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
      resendButton: "Znovu odeslat k\xF3d",
      subtitle: "Zadejte ov\u011B\u0159ovac\xED k\xF3d z aplikace pro dvoufaktorov\xE9 ov\u011B\u0159en\xED.",
      title: "Zkontrolujte sv\u016Fj telefon"
    },
    resetPassword: {
      formButtonPrimary: "Obnovit heslo",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "Va\u0161e heslo bylo \xFAsp\u011B\u0161n\u011B zm\u011Bn\u011Bno. P\u0159ihla\u0161uji v\xE1s, pros\xEDm po\u010Dkejte okam\u017Eik.",
      title: "Obnovit heslo"
    },
    resetPasswordMfa: {
      detailsLabel: "P\u0159ed obnoven\xEDm hesla je t\u0159eba ov\u011B\u0159it va\u0161i toto\u017Enost."
    },
    start: {
      actionLink: "Registrovat se",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Pou\u017E\xEDt email",
      actionLink__use_email_username: "Pou\u017E\xEDt email nebo u\u017Eivatelsk\xE9 jm\xE9no",
      actionLink__use_passkey: "Pou\u017E\xEDt Passkey",
      actionLink__use_phone: "Pou\u017E\xEDt telefon",
      actionLink__use_username: "Pou\u017E\xEDt u\u017Eivatelsk\xE9 jm\xE9no",
      actionText: "Nem\xE1te \xFA\u010Det?",
      actionText__join_waitlist: "P\u0159ipojit se k \u010Dekac\xED listin\u011B",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      subtitleCombined: void 0,
      title: "P\u0159ihl\xE1sit se",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
      subtitle: "Zadejte ov\u011B\u0159ovac\xED k\xF3d z aplikace pro dvoufaktorov\xE9 ov\u011B\u0159en\xED.",
      title: "Dvoufaktorov\xE9 ov\u011B\u0159en\xED"
    }
  },
  signInEnterPasswordTitle: "Zadejte sv\xE9 heslo",
  signUp: {
    continue: {
      actionLink: "P\u0159ihl\xE1sit se",
      actionText: "M\xE1te \xFA\u010Det?",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Vypl\u0148te chyb\u011Bj\xEDc\xED pole"
    },
    emailCode: {
      formSubtitle: "Zadejte ov\u011B\u0159ovac\xED k\xF3d poslan\xFD na va\u0161i emailovou adresu",
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
      resendButton: "Znovu poslat k\xF3d",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Ov\u011B\u0159te sv\u016Fj email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Zkontrolujte, \u017Ee pou\u017E\xEDv\xE1te spr\xE1vn\xE9ho klienta.",
        title: "Chyba klienta"
      },
      formSubtitle: "Pou\u017Eijte ov\u011B\u0159ovac\xED odkaz poslan\xFD na va\u0161i emailovou adresu",
      formTitle: "Ov\u011B\u0159ovac\xED odkaz",
      loading: {
        title: "Prob\xEDh\xE1 registrace..."
      },
      resendButton: "Znovu poslat odkaz",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Ov\u011B\u0159te sv\u016Fj email",
      verified: {
        title: "\xDAsp\u011B\u0161n\u011B zaregistrov\xE1no"
      },
      verifiedSwitchTab: {
        subtitle: "Vra\u0165te se do nov\u011B otev\u0159en\xE9ho okna pro pokra\u010Dov\xE1n\xED",
        subtitleNewTab: "Vra\u0165te se do p\u0159edchoz\xEDho okna pro pokra\u010Dov\xE1n\xED",
        title: "Email \xFAsp\u011B\u0161n\u011B ov\u011B\u0159en"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "Souhlas\xEDm s politikou ochrany osobn\xEDch \xFAdaj\u016F",
        label__onlyTermsOfService: "Souhlas\xEDm s podm\xEDnkami slu\u017Eby",
        label__termsOfServiceAndPrivacyPolicy: "Souhlas\xEDm s podm\xEDnkami slu\u017Eby a politikou ochrany osobn\xEDch \xFAdaj\u016F"
      },
      continue: {
        subtitle: "Pokra\u010Dujte pro dokon\u010Den\xED registrace.",
        title: "Pokra\u010Dovat"
      }
    },
    phoneCode: {
      formSubtitle: "Zadejte ov\u011B\u0159ovac\xED k\xF3d poslan\xFD na va\u0161e telefonn\xED \u010D\xEDslo",
      formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
      resendButton: "Znovu poslat k\xF3d",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Ov\u011B\u0159te sv\u016Fj telefon"
    },
    restrictedAccess: {
      actionLink: "Po\u017E\xE1dat o p\u0159\xEDstup",
      actionText: "Nem\xE1te p\u0159\xEDstup k t\xE9to oblasti.",
      blockButton__emailSupport: "Kontaktujte podporu",
      blockButton__joinWaitlist: "P\u0159ipojit se k \u010Dekac\xED listin\u011B",
      subtitle: "Tento obsah nen\xED k dispozici.",
      subtitleWaitlist: "P\u0159ipojte se k \u010Dekac\xED listin\u011B pro p\u0159\xEDstup.",
      title: "Omezen\xFD p\u0159\xEDstup"
    },
    start: {
      actionLink: "P\u0159ihl\xE1sit se",
      actionLink__use_email: void 0,
      actionLink__use_phone: "Pou\u017E\xEDt telefon",
      actionText: "M\xE1te \xFA\u010Det?",
      subtitle: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      subtitleCombined: "pro pokra\u010Dov\xE1n\xED do {{applicationName}}",
      title: "Vytvo\u0159te si \xFA\u010Det",
      titleCombined: "Vytvo\u0159te si \xFA\u010Det"
    }
  },
  socialButtonsBlockButton: "Pokra\u010Dovat s {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "Ji\u017E jste \u010Dlenem organizace.",
    captcha_invalid: "Registrace ne\xFAsp\u011B\u0161n\xE1 kv\u016Fli ne\xFAsp\u011B\u0161n\xFDm bezpe\u010Dnostn\xEDm validac\xEDm. Pros\xEDm, obnovte str\xE1nku a zkuste to znovu nebo kontaktujte podporu.",
    captcha_unavailable: "Registrace ne\xFAsp\u011B\u0161n\xE1 kv\u016Fli selh\xE1n\xED ov\u011B\u0159en\xED botu. Pros\xEDm, obnovte str\xE1nku a zkuste to znovu nebo kontaktujte podporu.",
    form_code_incorrect: "K\xF3d je nespr\xE1vn\xFD.",
    form_identifier_exists__email_address: "Tato emailov\xE1 adresa ji\u017E byla pou\u017Eita.",
    form_identifier_exists__phone_number: "Toto telefonn\xED \u010D\xEDslo ji\u017E bylo pou\u017Eito.",
    form_identifier_exists__username: "Toto u\u017Eivatelsk\xE9 jm\xE9no ji\u017E bylo pou\u017Eito.",
    form_identifier_not_found: "Identifik\xE1tor nebyl nalezen.",
    form_param_format_invalid: "Form\xE1t parametru je neplatn\xFD.",
    form_param_format_invalid__email_address: "Emailov\xE1 adresa mus\xED b\xFDt platn\xE1.",
    form_param_format_invalid__phone_number: "Telefonn\xED \u010D\xEDslo mus\xED b\xFDt ve validn\xEDm mezin\xE1rodn\xEDm form\xE1tu.",
    form_param_max_length_exceeded__first_name: "Jm\xE9no nesm\xED p\u0159es\xE1hnout 256 znak\u016F.",
    form_param_max_length_exceeded__last_name: "P\u0159\xEDjmen\xED nesm\xED p\u0159es\xE1hnout 256 znak\u016F.",
    form_param_max_length_exceeded__name: "Jm\xE9no nesm\xED p\u0159es\xE1hnout 256 znak\u016F.",
    form_param_nil: "Tento parametr je povinn\xFD.",
    form_param_value_invalid: "Tento parametr m\xE1 neplatnou hodnotu.",
    form_password_incorrect: "Heslo je nespr\xE1vn\xE9.",
    form_password_length_too_short: "Heslo je p\u0159\xEDli\u0161 kr\xE1tk\xE9.",
    form_password_not_strong_enough: "Va\u0161e heslo nen\xED dostate\u010Dn\u011B siln\xE9.",
    form_password_pwned: "Toto heslo bylo nalezeno v \xFAniku dat a nem\u016F\u017Ee b\xFDt pou\u017Eito. Zvolte pros\xEDm jin\xE9 heslo.",
    form_password_pwned__sign_in: "Zvolte siln\xE9 heslo pro p\u0159ihl\xE1\u0161en\xED.",
    form_password_size_in_bytes_exceeded: "Va\u0161e heslo p\u0159ekro\u010Dilo maxim\xE1ln\xED povolen\xFD po\u010Det byt\u016F, pros\xEDm zkr\xE1tit ho nebo odstranit n\u011Bkter\xE9 speci\xE1ln\xED znaky.",
    form_password_validation_failed: "Nespr\xE1vn\xE9 heslo",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "m\xE9n\u011B ne\u017E {{length}} znak\u016F",
      minimumLength: "{{length}} nebo v\xEDce znak\u016F",
      requireLowercase: "mal\xE9 p\xEDsmeno",
      requireNumbers: "\u010D\xEDslici",
      requireSpecialCharacter: "speci\xE1ln\xED znak",
      requireUppercase: "velk\xE9 p\xEDsmeno",
      sentencePrefix: "Va\u0161e heslo mus\xED obsahovat"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Va\u0161e heslo funguje, ale mohlo by b\xFDt siln\u011Bj\u0161\xED. Zkuste p\u0159idat v\xEDce znak\u016F.",
      goodPassword: "Dobr\xE1 pr\xE1ce. Toto je vynikaj\xEDc\xED heslo.",
      notEnough: "Va\u0161e heslo nen\xED dostate\u010Dn\u011B siln\xE9.",
      suggestions: {
        allUppercase: "Pou\u017Eijte velk\xE1 p\xEDsmena pouze u n\u011Bkter\xFDch, ne v\u0161ech p\xEDsmen.",
        anotherWord: "P\u0159idejte v\xEDce slov, kter\xE1 nejsou tak b\u011B\u017En\xE1.",
        associatedYears: "Vyhn\u011Bte se letopo\u010Dt\u016Fm, kter\xE9 jsou s v\xE1mi spojen\xE9.",
        capitalization: "P\xEDsmena pi\u0161te s velk\xFDm po\u010D\xE1te\u010Dn\xEDm p\xEDsmenem a v\xEDce ne\u017E jen prvn\xED p\xEDsmeno.",
        dates: "Vyhn\u011Bte se dat\u016Fm a letopo\u010Dt\u016Fm, kter\xE9 jsou s v\xE1mi spojen\xE9.",
        l33t: "Vyhn\u011Bte se p\u0159edv\xEDdateln\xFDm n\xE1hrad\xE1m p\xEDsmen, nap\u0159\xEDklad '@' m\xEDsto 'a'.",
        longerKeyboardPattern: "Pou\u017Eijte del\u0161\xED vzory na kl\xE1vesnici a m\u011B\u0148te sm\u011Br psan\xED v\xEDcekr\xE1t.",
        noNeed: "M\u016F\u017Eete vytv\xE1\u0159et siln\xE1 hesla i bez pou\u017Eit\xED symbol\u016F, \u010D\xEDsel nebo velk\xFDch p\xEDsmen.",
        pwned: "Pokud pou\u017E\xEDv\xE1te toto heslo i jinde, m\u011Bli byste ho zm\u011Bnit.",
        recentYears: "Vyhn\u011Bte se ned\xE1vn\xFDm rok\u016Fm.",
        repeated: "Vyhn\u011Bte se opakuj\xEDc\xEDm se slov\u016Fm a znak\u016Fm.",
        reverseWords: "Vyhn\u011Bte se obr\xE1cen\xFDm pravopis\u016Fm b\u011B\u017En\xFDch slov.",
        sequences: "Vyhn\u011Bte se b\u011B\u017En\xFDm sekvenc\xEDm znak\u016F.",
        useWords: "Pou\u017Eijte v\xEDce slov, ale vyhn\u011Bte se b\u011B\u017En\xFDm fr\xE1z\xEDm."
      },
      warnings: {
        common: "Toto je b\u011B\u017En\u011B pou\u017E\xEDvan\xE9 heslo.",
        commonNames: "B\u011B\u017En\xE1 jm\xE9na a p\u0159\xEDjmen\xED jsou snadno uh\xE1dnuteln\xE1.",
        dates: "Datum je snadno uh\xE1dnuteln\xE9.",
        extendedRepeat: 'Opakuj\xEDc\xED se vzory znak\u016F jako "abcabcabc" jsou snadno uh\xE1dnuteln\xE9.',
        keyPattern: "Kr\xE1tk\xE9 vzory na kl\xE1vesnici jsou snadno uh\xE1dnuteln\xE9.",
        namesByThemselves: "Samostatn\xE1 jm\xE9na nebo p\u0159\xEDjmen\xED jsou snadno uh\xE1dnuteln\xE1.",
        pwned: "Va\u0161e heslo bylo odhaleno p\u0159i \xFAniku dat na internetu.",
        recentYears: "Ned\xE1vn\xE9 roky jsou snadno uh\xE1dnuteln\xE9.",
        sequences: 'B\u011B\u017En\xE9 sekvence znak\u016F jako "abc" jsou snadno uh\xE1dnuteln\xE9.',
        similarToCommon: "Toto je podobn\xE9 b\u011B\u017En\u011B pou\u017E\xEDvan\xE9mu heslu.",
        simpleRepeat: 'Opakuj\xEDc\xED se znaky jako "aaa" jsou snadno uh\xE1dnuteln\xE9.',
        straightRow: "\u0158ady kl\xE1ves na kl\xE1vesnici jsou snadno uh\xE1dnuteln\xE9.",
        topHundred: "Toto je \u010Dasto pou\u017E\xEDvan\xE9 heslo.",
        topTen: "Toto je \u010Dasto pou\u017E\xEDvan\xE9 heslo.",
        userInputs: "Heslo by nem\u011Blo obsahovat osobn\xED nebo str\xE1nkou souvisej\xEDc\xED \xFAdaje.",
        wordByItself: "Samostatn\xE1 slova jsou snadno uh\xE1dnuteln\xE1."
      }
    }
  },
  userButton: {
    action__addAccount: "P\u0159idat \xFA\u010Det",
    action__manageAccount: "Spravovat \xFA\u010Det",
    action__signOut: "Odhl\xE1sit se",
    action__signOutAll: "Odhl\xE1sit se ze v\u0161ech \xFA\u010Dt\u016F"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Zkop\xEDrov\xE1no!",
      actionLabel__copy: "Zkop\xEDrovat v\u0161e",
      actionLabel__download: "St\xE1hnout .txt",
      actionLabel__print: "Vytisknout",
      infoText1: "Pro tento \xFA\u010Det budou povoleny z\xE1lo\u017En\xED k\xF3dy.",
      infoText2: "Z\xE1lo\u017En\xED k\xF3dy uchov\xE1vejte tajn\u011B a bezpe\u010Dn\u011B. M\u016F\u017Eete vygenerovat nov\xE9 z\xE1lo\u017En\xED k\xF3dy, pokud m\xE1te podez\u0159en\xED, \u017Ee byly kompromitov\xE1ny.",
      subtitle__codelist: "Uchov\xE1vejte je bezpe\u010Dn\u011B a tajn\u011B.",
      successMessage: "Z\xE1lo\u017En\xED k\xF3dy jsou nyn\xED povoleny. Pokud ztrat\xEDte p\u0159\xEDstup k va\u0161emu ov\u011B\u0159ovac\xEDmu za\u0159\xEDzen\xED, m\u016F\u017Eete pou\u017E\xEDt jeden z t\u011Bchto k\xF3d\u016F k p\u0159ihl\xE1\u0161en\xED do sv\xE9ho \xFA\u010Dtu. Ka\u017Ed\xFD k\xF3d lze pou\u017E\xEDt pouze jednou.",
      successSubtitle: "Pou\u017Eijte jeden z t\u011Bchto k\xF3d\u016F k p\u0159ihl\xE1\u0161en\xED do sv\xE9ho \xFA\u010Dtu, pokud ztrat\xEDte p\u0159\xEDstup k va\u0161emu ov\u011B\u0159ovac\xEDmu za\u0159\xEDzen\xED.",
      title: "P\u0159idat ov\u011B\u0159ov\xE1n\xED pomoc\xED z\xE1lo\u017En\xEDch k\xF3d\u016F",
      title__codelist: "Z\xE1lo\u017En\xED k\xF3dy"
    },
    connectedAccountPage: {
      formHint: "Vyberte poskytovatele pro p\u0159ipojen\xED va\u0161eho \xFA\u010Dtu.",
      formHint__noAccounts: "Nejsou k dispozici \u017E\xE1dn\xED dostupn\xED extern\xED poskytovatel\xE9 \xFA\u010Dt\u016F.",
      removeResource: {
        messageLine1: "{{identifier}} bude odebr\xE1n z tohoto \xFA\u010Dtu.",
        messageLine2: "Nebudete ji\u017E moci pou\u017E\xEDvat tento p\u0159ipojen\xFD \xFA\u010Det a jak\xE9koli z\xE1visl\xE9 funkce p\u0159estanou fungovat.",
        successMessage: "{{connectedAccount}} byl odebr\xE1n z va\u0161eho \xFA\u010Dtu.",
        title: "Odstranit p\u0159ipojen\xFD \xFA\u010Det"
      },
      socialButtonsBlockButton: "P\u0159ipojit \xFA\u010Det {{provider|titleize}}",
      successMessage: "Poskytovatel byl p\u0159id\xE1n k va\u0161emu \xFA\u010Dtu.",
      title: "P\u0159idat p\u0159ipojen\xFD \xFA\u010Det"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "Delete account",
      messageLine1: "Are you sure you want to delete your account?",
      messageLine2: "This action is permanent and irreversible.",
      title: "Delete account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Na tuto e-mailovou adresu bude odesl\xE1n ov\u011B\u0159ovac\xED k\xF3d.",
        formSubtitle: "Zadejte ov\u011B\u0159ovac\xED k\xF3d zaslan\xFD na adresu {{identifier}}",
        formTitle: "Ov\u011B\u0159ovac\xED k\xF3d",
        resendButton: "Znovu odeslat k\xF3d",
        successMessage: "E-mailov\xE1 adresa {{identifier}} byla p\u0159id\xE1na k va\u0161emu \xFA\u010Dtu."
      },
      emailLink: {
        formHint: "Na tuto e-mailovou adresu bude odesl\xE1n ov\u011B\u0159ovac\xED odkaz.",
        formSubtitle: "Klikn\u011Bte na ov\u011B\u0159ovac\xED odkaz v e-mailu zaslan\xE9m na adresu {{identifier}}",
        formTitle: "Ov\u011B\u0159ovac\xED odkaz",
        resendButton: "Znovu odeslat odkaz",
        successMessage: "E-mailov\xE1 adresa {{identifier}} byla p\u0159id\xE1na k va\u0161emu \xFA\u010Dtu."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} bude odstran\u011Bna z tohoto \xFA\u010Dtu.",
        messageLine2: "Nebudete se moci p\u0159ihl\xE1sit pomoc\xED t\xE9to e-mailov\xE9 adresy.",
        successMessage: "{{emailAddress}} byla odebr\xE1na z va\u0161eho \xFA\u010Dtu.",
        title: "Odstranit e-mailovou adresu"
      },
      title: "P\u0159idat e-mailovou adresu",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "P\u0159idat",
    formButtonPrimary__continue: "Pokra\u010Dovat",
    formButtonPrimary__finish: "Dokon\u010Dit",
    formButtonPrimary__remove: "Odstranit",
    formButtonPrimary__save: "Ulo\u017Eit",
    formButtonReset: "Zru\u0161it",
    mfaPage: {
      formHint: "Vyberte zp\u016Fsob p\u0159id\xE1n\xED.",
      title: "P\u0159idat dvoufaktorov\xE9 ov\u011B\u0159ov\xE1n\xED"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "P\u0159idat telefonn\xED \u010D\xEDslo",
      removeResource: {
        messageLine1: "{{identifier}} ji\u017E nebude dost\xE1vat ov\u011B\u0159ovac\xED k\xF3dy p\u0159i p\u0159ihla\u0161ov\xE1n\xED.",
        messageLine2: "V\xE1\u0161 \xFA\u010Det nemus\xED b\xFDt tak bezpe\u010Dn\xFD. Opravdu chcete pokra\u010Dovat?",
        successMessage: "Dvoufaktorov\xE9 ov\u011B\u0159ov\xE1n\xED pomoc\xED SMS k\xF3du bylo odebr\xE1no pro {{mfaPhoneCode}}",
        title: "Odstranit dvoufaktorov\xE9 ov\u011B\u0159ov\xE1n\xED"
      },
      subtitle__availablePhoneNumbers: "Vyberte telefonn\xED \u010D\xEDslo pro registraci dvoufaktorov\xE9ho ov\u011B\u0159ov\xE1n\xED pomoc\xED SMS k\xF3du.",
      subtitle__unavailablePhoneNumbers: "Nejsou k dispozici \u017E\xE1dn\xE1 dostupn\xE1 telefonn\xED \u010D\xEDsla pro registraci dvoufaktorov\xE9ho ov\u011B\u0159ov\xE1n\xED pomoc\xED SMS k\xF3du.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "P\u0159idat ov\u011B\u0159ov\xE1n\xED pomoc\xED SMS k\xF3du"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Nam\xEDsto toho naskenujte QR k\xF3d",
        buttonUnableToScan__nonPrimary: "Nem\u016F\u017Eete naskenovat QR k\xF3d?",
        infoText__ableToScan: "Nastavte novou metodu p\u0159ihl\xE1\u0161en\xED ve va\u0161\xED aplikaci pro ov\u011B\u0159ov\xE1n\xED a naskenujte n\xE1sleduj\xEDc\xED QR k\xF3d, abyste jej propojili se sv\xFDm \xFA\u010Dtem.",
        infoText__unableToScan: "Nastavte novou metodu p\u0159ihl\xE1\u0161en\xED ve sv\xE9 aplikaci pro ov\u011B\u0159ov\xE1n\xED a zadejte n\xED\u017Ee poskytnut\xFD kl\xED\u010D.",
        inputLabel__unableToScan1: "Ujist\u011Bte se, \u017Ee je povoleno \u010Dasov\u011B z\xE1visl\xE9 nebo jednor\xE1zov\xE9 heslo, a dokon\u010Dete propojen\xED va\u0161eho \xFA\u010Dtu.",
        inputLabel__unableToScan2: "Alternativn\u011B, pokud va\u0161e aplikace pro ov\u011B\u0159ov\xE1n\xED podporuje TOTP URI, m\u016F\u017Eete tak\xE9 zkop\xEDrovat cel\xFD URI."
      },
      removeResource: {
        messageLine1: "P\u0159i p\u0159ihla\u0161ov\xE1n\xED ji\u017E nebudou vy\u017Eadov\xE1ny ov\u011B\u0159ovac\xED k\xF3dy z t\xE9to aplikace pro ov\u011B\u0159ov\xE1n\xED.",
        messageLine2: "V\xE1\u0161 \xFA\u010Det nemus\xED b\xFDt tak bezpe\u010Dn\xFD. Opravdu chcete pokra\u010Dovat?",
        successMessage: "Dvoufaktorov\xE9 ov\u011B\u0159ov\xE1n\xED pomoc\xED aplikace pro ov\u011B\u0159ov\xE1n\xED bylo odebr\xE1no.",
        title: "Odstranit dvoufaktorov\xE9 ov\u011B\u0159ov\xE1n\xED"
      },
      successMessage: "Dvoufaktorov\xE9 ov\u011B\u0159ov\xE1n\xED je nyn\xED povoleno. P\u0159i p\u0159ihl\xE1\u0161en\xED budete muset zadat ov\u011B\u0159ovac\xED k\xF3d z t\xE9to aplikace pro ov\u011B\u0159ov\xE1n\xED jako dal\u0161\xED krok.",
      title: "P\u0159idat aplikaci pro ov\u011B\u0159ov\xE1n\xED",
      verifySubtitle: "Zadejte ov\u011B\u0159ovac\xED k\xF3d generovan\xFD va\u0161\xED aplikac\xED pro ov\u011B\u0159ov\xE1n\xED",
      verifyTitle: "Ov\u011B\u0159ovac\xED k\xF3d"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profil",
      description: "Spravujte sv\xE9 \xFAdaje.",
      security: "Zabezpe\u010Den\xED",
      title: "\xDA\u010Det"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Je doporu\u010Deno se odhl\xE1sit ze v\u0161ech ostatn\xEDch za\u0159\xEDzen\xEDch, kter\xE1 mohla pou\u017E\xEDt va\u0161e star\xE9 heslo.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "Va\u0161e heslo bylo nastaveno.",
      successMessage__signOutOfOtherSessions: "V\u0161echna ostatn\xED za\u0159\xEDzen\xED byla odhl\xE1\u0161ena.",
      successMessage__update: "Va\u0161e heslo bylo aktualizov\xE1no.",
      title__set: "Nastavit heslo",
      title__update: "Zm\u011Bnit heslo"
    },
    phoneNumberPage: {
      infoText: "Na toto telefonn\xED \u010D\xEDslo bude odesl\xE1na textov\xE1 zpr\xE1va obsahuj\xEDc\xED ov\u011B\u0159ovac\xED odkaz.",
      removeResource: {
        messageLine1: "{{identifier}} bude odebr\xE1no z tohoto \xFA\u010Dtu.",
        messageLine2: "Nebudete ji\u017E moci p\u0159ihl\xE1sit se pomoc\xED tohoto telefonn\xEDho \u010D\xEDsla.",
        successMessage: "{{phoneNumber}} bylo odebr\xE1no z va\u0161eho \xFA\u010Dtu.",
        title: "Odstranit telefonn\xED \u010D\xEDslo"
      },
      successMessage: "{{identifier}} bylo p\u0159id\xE1no k va\u0161emu \xFA\u010Dtu.",
      title: "P\u0159idat telefonn\xED \u010D\xEDslo",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "Nahrajte obr\xE1zek ve form\xE1tech JPG, PNG, GIF nebo WEBP s velikost\xED men\u0161\xED ne\u017E 10 MB",
      imageFormDestructiveActionSubtitle: "Odstranit obr\xE1zek",
      imageFormSubtitle: "Nahr\xE1t obr\xE1zek",
      imageFormTitle: "Profilov\xFD obr\xE1zek",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "V\xE1\u0161 profil byl aktualizov\xE1n.",
      title: "Aktualizovat profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Odhl\xE1sit se z za\u0159\xEDzen\xED",
        title: "Aktivn\xED za\u0159\xEDzen\xED"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Zkusit znovu",
        actionLabel__reauthorize: "Autorizovat nyn\xED",
        destructiveActionTitle: "Odstranit",
        primaryButton: "P\u0159ipojit \xFA\u010Det",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "P\u0159ipojen\xE9 \xFA\u010Dty"
      },
      dangerSection: {
        deleteAccountButton: "Smazat \xFA\u010Det",
        title: "Zru\u0161en\xED \xFA\u010Dtu"
      },
      emailAddressesSection: {
        destructiveAction: "Odstranit emailovou adresu",
        detailsAction__nonPrimary: "Nastavit jako hlavn\xED",
        detailsAction__primary: "Dokon\u010Dit ov\u011B\u0159en\xED",
        detailsAction__unverified: "Dokon\u010Dit ov\u011B\u0159en\xED",
        primaryButton: "P\u0159idat emailovou adresu",
        title: "Emailov\xE9 adresy"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "\xDA\u010Det",
      headerTitle__security: "Bezpe\u010Dnost",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Obnovit k\xF3dy",
          headerTitle: "Z\xE1lo\u017En\xED k\xF3dy",
          subtitle__regenerate: "Z\xEDskejte novou sadu zabezpe\u010Den\xFDch z\xE1lo\u017En\xEDch k\xF3d\u016F. P\u0159edchoz\xED z\xE1lo\u017En\xED k\xF3dy budou smaz\xE1ny a nelze je pou\u017E\xEDt.",
          title__regenerate: "Obnovit z\xE1lo\u017En\xED k\xF3dy"
        },
        phoneCode: {
          actionLabel__setDefault: "Nastavit jako v\xFDchoz\xED",
          destructiveActionLabel: "Odstranit telefonn\xED \u010D\xEDslo"
        },
        primaryButton: "P\u0159idat dvoufaktorov\xE9 ov\u011B\u0159en\xED",
        title: "Dvoufaktorov\xE9 ov\u011B\u0159en\xED",
        totp: {
          destructiveActionTitle: "Odstranit",
          headerTitle: "Aplikace Authenticator"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Odstranit",
        menuAction__rename: "P\u0159ejmenovat",
        primaryButton: void 0,
        title: "Spr\xE1va kl\xED\u010D\u016F"
      },
      passwordSection: {
        primaryButton__setPassword: "Nastavit heslo",
        primaryButton__updatePassword: "Zm\u011Bnit heslo",
        title: "Heslo"
      },
      phoneNumbersSection: {
        destructiveAction: "Odstranit telefonn\xED \u010D\xEDslo",
        detailsAction__nonPrimary: "Nastavit jako hlavn\xED",
        detailsAction__primary: "Dokon\u010Dit ov\u011B\u0159en\xED",
        detailsAction__unverified: "Dokon\u010Dit ov\u011B\u0159en\xED",
        primaryButton: "P\u0159idat telefonn\xED \u010D\xEDslo",
        title: "Telefonn\xED \u010D\xEDsla"
      },
      profileSection: {
        primaryButton: void 0,
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Nastavit u\u017Eivatelsk\xE9 jm\xE9no",
        primaryButton__updateUsername: "Zm\u011Bnit u\u017Eivatelsk\xE9 jm\xE9no",
        title: "U\u017Eivatelsk\xE9 jm\xE9no"
      },
      web3WalletsSection: {
        destructiveAction: "Odstranit pen\u011B\u017Eenku",
        primaryButton: "Web3 pen\u011B\u017Eenky",
        title: "Web3 pen\u011B\u017Eenky"
      }
    },
    usernamePage: {
      successMessage: "Va\u0161e u\u017Eivatelsk\xE9 jm\xE9no bylo aktualizov\xE1no.",
      title__set: "Aktualizovat u\u017Eivatelsk\xE9 jm\xE9no",
      title__update: "Aktualizovat u\u017Eivatelsk\xE9 jm\xE9no"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} bude odebr\xE1na z tohoto \xFA\u010Dtu.",
        messageLine2: "Nebudete se ji\u017E moci p\u0159ihl\xE1sit pomoc\xED t\xE9to web3 pen\u011B\u017Eenky.",
        successMessage: "{{web3Wallet}} byla odebr\xE1na z va\u0161eho \xFA\u010Dtu.",
        title: "Odstranit web3 pen\u011B\u017Eenku"
      },
      subtitle__availableWallets: "Vyberte web3 pen\u011B\u017Eenku k p\u0159ipojen\xED k va\u0161emu \xFA\u010Dtu.",
      subtitle__unavailableWallets: "Nejsou k dispozici \u017E\xE1dn\xE9 dostupn\xE9 web3 pen\u011B\u017Eenky.",
      successMessage: "Pen\u011B\u017Eenka byla p\u0159id\xE1na k va\u0161emu \xFA\u010Dtu.",
      title: "P\u0159idat web3 pen\u011B\u017Eenku",
      web3WalletButtonsBlockButton: "Pokra\u010Dovat s Web3 pen\u011B\u017Eenkou"
    }
  },
  waitlist: {
    start: {
      actionLink: "P\u0159ihl\xE1sit se na \u010Dekac\xED listinu",
      actionText: "Chcete-li b\xFDt informov\xE1ni, p\u0159ihlaste se na \u010Dekac\xED listinu.",
      formButton: "P\u0159ihl\xE1sit se",
      subtitle: "P\u0159idejte se na \u010Dekac\xED listinu pro p\u0159\xEDstup k {{applicationName}}.",
      title: "P\u0159ihl\xE1\u0161en\xED na \u010Dekac\xED listinu"
    },
    success: {
      message: "Byli jste \xFAsp\u011B\u0161n\u011B p\u0159id\xE1ni na \u010Dekac\xED listinu!",
      subtitle: "Po\u010Dkejte na dal\u0161\xED instrukce, kter\xE9 v\xE1m po\u0161leme na email.",
      title: "\xDAsp\u011Bch"
    }
  }
};

// src/zh-CN.ts
var zhCN = {
  locale: "zh-CN",
  backButton: "\u8FD4\u56DE",
  badge__default: "\u9ED8\u8BA4",
  badge__otherImpersonatorDevice: "\u5176\u4ED6\u6A21\u62DF\u5668\u8BBE\u5907",
  badge__primary: "\u4E3B\u8981",
  badge__requiresAction: "\u9700\u8981\u64CD\u4F5C",
  badge__thisDevice: "\u6B64\u8BBE\u5907",
  badge__unverified: "\u672A\u9A8C\u8BC1",
  badge__userDevice: "\u7528\u6237\u8BBE\u5907",
  badge__you: "\u60A8",
  createOrganization: {
    formButtonSubmit: "\u521B\u5EFA\u7EC4\u7EC7",
    invitePage: {
      formButtonReset: "\u8DF3\u8FC7"
    },
    title: "\u521B\u5EFA\u7EC4\u7EC7"
  },
  dates: {
    lastDay: "\u6628\u5929{{ date | timeString('zh-CN') }}",
    next6Days: "{{ date | weekday('zh-CN','long') }} {{ date | timeString('zh-CN') }}",
    nextDay: "\u660E\u5929{{ date | timeString('zh-CN') }}",
    numeric: "{{ date | numeric('zh-CN') }}",
    previous6Days: "\u4E0A\u5468{{ date | weekday('zh-CN','long') }} {{ date | timeString('zh-CN') }}",
    sameDay: "\u4ECA\u5929{{ date | timeString('zh-CN') }}"
  },
  dividerText: "\u6216\u8005",
  footerActionLink__useAnotherMethod: "\u4F7F\u7528\u53E6\u4E00\u79CD\u65B9\u6CD5",
  footerPageLink__help: "\u5E2E\u52A9",
  footerPageLink__privacy: "\u9690\u79C1",
  footerPageLink__terms: "\u6761\u6B3E",
  formButtonPrimary: "\u7EE7\u7EED",
  formButtonPrimary__verify: "\u9A8C\u8BC1",
  formFieldAction__forgotPassword: "\u5FD8\u8BB0\u5BC6\u7801\uFF1F",
  formFieldError__matchingPasswords: "\u5BC6\u7801\u5339\u914D\u3002",
  formFieldError__notMatchingPasswords: "\u5BC6\u7801\u4E0D\u5339\u914D\u3002",
  formFieldError__verificationLinkExpired: "\u9A8C\u8BC1\u94FE\u63A5\u5DF2\u8FC7\u671F\u3002\u8BF7\u7533\u8BF7\u65B0\u7684\u94FE\u63A5\u3002",
  formFieldHintText__optional: "\u9009\u586B",
  formFieldHintText__slug: "Slug \u662F\u4E00\u4E2A\u4EBA\u7C7B\u53EF\u8BFB\u7684 ID\uFF0C\u5B83\u5FC5\u987B\u662F\u552F\u4E00\u7684\u3002\u5B83\u901A\u5E38\u7528\u4E8E URL \u4E2D\u3002",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u5220\u9664\u5E10\u6237",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "\u8F93\u5165\u6216\u7C98\u8D34\u4E00\u4E2A\u6216\u591A\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u7528\u7A7A\u683C\u6216\u9017\u53F7\u5206\u9694",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "\u6211\u7684\u7EC4\u7EC7",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "\u4E3A\u6B64\u57DF\u540D\u542F\u7528\u81EA\u52A8\u9080\u8BF7",
  formFieldLabel__backupCode: "\u5907\u7528\u4EE3\u7801",
  formFieldLabel__confirmDeletion: "\u786E\u8BA4",
  formFieldLabel__confirmPassword: "\u786E\u8BA4\u5BC6\u7801",
  formFieldLabel__currentPassword: "\u5F53\u524D\u5BC6\u7801",
  formFieldLabel__emailAddress: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
  formFieldLabel__emailAddress_username: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u6216\u7528\u6237\u540D",
  formFieldLabel__emailAddresses: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
  formFieldLabel__firstName: "\u540D\u5B57",
  formFieldLabel__lastName: "\u59D3\u6C0F",
  formFieldLabel__newPassword: "\u65B0\u5BC6\u7801",
  formFieldLabel__organizationDomain: "\u57DF\u540D",
  formFieldLabel__organizationDomainDeletePending: "\u5220\u9664\u5F85\u5904\u7406\u7684\u9080\u8BF7\u548C\u5EFA\u8BAE",
  formFieldLabel__organizationDomainEmailAddress: "\u9A8C\u8BC1\u90AE\u7BB1\u5730\u5740",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u8F93\u5165\u6B64\u57DF\u540D\u4E0B\u7684\u4E00\u4E2A\u90AE\u7BB1\u5730\u5740\u4EE5\u63A5\u6536\u9A8C\u8BC1\u7801\u5E76\u9A8C\u8BC1\u6B64\u57DF\u540D\u3002",
  formFieldLabel__organizationName: "\u7EC4\u7EC7\u540D\u79F0",
  formFieldLabel__organizationSlug: "URL \u7B80\u79F0",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u5BC6\u7801",
  formFieldLabel__phoneNumber: "\u7535\u8BDD\u53F7\u7801",
  formFieldLabel__role: "\u89D2\u8272",
  formFieldLabel__signOutOfOtherSessions: "\u767B\u51FA\u6240\u6709\u5176\u4ED6\u8BBE\u5907",
  formFieldLabel__username: "\u7528\u6237\u540D",
  impersonationFab: {
    action__signOut: "\u9000\u51FA\u767B\u5F55",
    title: "\u4EE5 {{identifier}} \u767B\u5F55"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\u7BA1\u7406\u5458",
  membershipRole__basicMember: "\u6210\u5458",
  membershipRole__guestMember: "\u8BBF\u5BA2",
  organizationList: {
    action__createOrganization: "\u521B\u5EFA\u7EC4\u7EC7",
    action__invitationAccept: "\u52A0\u5165",
    action__suggestionsAccept: "\u8BF7\u6C42\u52A0\u5165",
    createOrganization: "\u521B\u5EFA\u7EC4\u7EC7",
    invitationAcceptedLabel: "\u5DF2\u52A0\u5165",
    subtitle: "\u4EE5\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
    suggestionsAcceptedLabel: "\u7B49\u5F85\u6279\u51C6",
    title: "\u9009\u62E9\u4E00\u4E2A\u8D26\u6237",
    titleWithoutPersonal: "\u9009\u62E9\u4E00\u4E2A\u7EC4\u7EC7"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u81EA\u52A8\u9080\u8BF7",
    badge__automaticSuggestion: "\u81EA\u52A8\u5EFA\u8BAE",
    badge__manualInvitation: "\u65E0\u81EA\u52A8\u6CE8\u518C",
    badge__unverified: "\u672A\u9A8C\u8BC1",
    createDomainPage: {
      subtitle: "\u6DFB\u52A0\u57DF\u540D\u4EE5\u8FDB\u884C\u9A8C\u8BC1\u3002\u5177\u6709\u6B64\u57DF\u540D\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u7684\u7528\u6237\u53EF\u4EE5\u81EA\u52A8\u52A0\u5165\u7EC4\u7EC7\u6216\u8BF7\u6C42\u52A0\u5165\u3002",
      title: "\u6DFB\u52A0\u57DF\u540D"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u9080\u8BF7\u65E0\u6CD5\u53D1\u9001\u3002\u4FEE\u590D\u4EE5\u4E0B\u95EE\u9898\u7136\u540E\u91CD\u8BD5\uFF1A",
      formButtonPrimary__continue: "\u53D1\u9001\u9080\u8BF7",
      selectDropdown__role: "\u9009\u62E9\u89D2\u8272",
      subtitle: "\u9080\u8BF7\u65B0\u6210\u5458\u52A0\u5165\u6B64\u7EC4\u7EC7",
      successMessage: "\u9080\u8BF7\u6210\u529F\u53D1\u9001",
      title: "\u9080\u8BF7\u6210\u5458"
    },
    membersPage: {
      action__invite: "\u9080\u8BF7",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u79FB\u9664\u6210\u5458",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u52A0\u5165",
        tableHeader__role: "\u89D2\u8272",
        tableHeader__user: "\u7528\u6237"
      },
      detailsTitle__emptyRow: "\u6CA1\u6709\u53EF\u663E\u793A\u7684\u6210\u5458",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u901A\u8FC7\u5C06\u7535\u5B50\u90AE\u4EF6\u57DF\u540D\u4E0E\u60A8\u7684\u7EC4\u7EC7\u8FDE\u63A5\u6765\u9080\u8BF7\u7528\u6237\u3002\u4EFB\u4F55\u4F7F\u7528\u5339\u914D\u7535\u5B50\u90AE\u4EF6\u57DF\u540D\u6CE8\u518C\u7684\u4EBA\u90FD\u53EF\u4EE5\u968F\u65F6\u52A0\u5165\u7EC4\u7EC7\u3002",
          headerTitle: "\u81EA\u52A8\u9080\u8BF7",
          primaryButton: "\u7BA1\u7406\u5DF2\u9A8C\u8BC1\u57DF\u540D"
        },
        table__emptyRow: "\u6CA1\u6709\u53EF\u663E\u793A\u7684\u9080\u8BF7"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u64A4\u9500\u9080\u8BF7",
        tableHeader__invited: "\u5DF2\u9080\u8BF7"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u4F7F\u7528\u5339\u914D\u7535\u5B50\u90AE\u4EF6\u57DF\u540D\u6CE8\u518C\u7684\u7528\u6237\u5C06\u80FD\u591F\u770B\u5230\u8BF7\u6C42\u52A0\u5165\u60A8\u7EC4\u7EC7\u7684\u5EFA\u8BAE\u3002",
          headerTitle: "\u81EA\u52A8\u5EFA\u8BAE",
          primaryButton: "\u7BA1\u7406\u5DF2\u9A8C\u8BC1\u57DF\u540D"
        },
        menuAction__approve: "\u6279\u51C6",
        menuAction__reject: "\u62D2\u7EDD",
        tableHeader__requested: "\u5DF2\u8BF7\u6C42\u8BBF\u95EE",
        table__emptyRow: "\u6CA1\u6709\u53EF\u663E\u793A\u7684\u8BF7\u6C42"
      },
      start: {
        headerTitle__invitations: "\u9080\u8BF7",
        headerTitle__members: "\u6210\u5458",
        headerTitle__requests: "\u8BF7\u6C42"
      }
    },
    navbar: {
      description: "\u7BA1\u7406\u60A8\u7684\u7EC4\u7EC7\u3002",
      general: "\u5E38\u89C4",
      members: "\u6210\u5458",
      title: "\u7EC4\u7EC7"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: '\u5728\u4E0B\u65B9\u8F93\u5165 "{{organizationName}}" \u4EE5\u7EE7\u7EED\u3002',
          messageLine1: "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u6B64\u7EC4\u7EC7\u5417\uFF1F",
          messageLine2: "\u6B64\u64CD\u4F5C\u662F\u6C38\u4E45\u6027\u7684\u4E14\u65E0\u6CD5\u64A4\u9500\u3002",
          successMessage: "\u60A8\u5DF2\u5220\u9664\u8BE5\u7EC4\u7EC7\u3002",
          title: "\u5220\u9664\u7EC4\u7EC7"
        },
        leaveOrganization: {
          actionDescription: '\u5728\u4E0B\u65B9\u8F93\u5165 "{{organizationName}}" \u4EE5\u7EE7\u7EED\u3002',
          messageLine1: "\u60A8\u786E\u5B9A\u8981\u79BB\u5F00\u6B64\u7EC4\u7EC7\u5417\uFF1F\u60A8\u5C06\u5931\u53BB\u5BF9\u6B64\u7EC4\u7EC7\u53CA\u5176\u5E94\u7528\u7A0B\u5E8F\u7684\u8BBF\u95EE\u6743\u9650\u3002",
          messageLine2: "\u6B64\u64CD\u4F5C\u662F\u6C38\u4E45\u6027\u7684\u4E14\u65E0\u6CD5\u64A4\u9500\u3002",
          successMessage: "\u60A8\u5DF2\u79BB\u5F00\u4E86\u7EC4\u7EC7\u3002",
          title: "\u79BB\u5F00\u7EC4\u7EC7"
        },
        title: "\u5371\u9669"
      },
      domainSection: {
        menuAction__manage: "\u7BA1\u7406",
        menuAction__remove: "\u5220\u9664",
        menuAction__verify: "\u9A8C\u8BC1",
        primaryButton: "\u6DFB\u52A0\u57DF\u540D",
        subtitle: "\u5141\u8BB8\u7528\u6237\u6839\u636E\u5DF2\u9A8C\u8BC1\u7684\u7535\u5B50\u90AE\u4EF6\u57DF\u540D\u81EA\u52A8\u52A0\u5165\u7EC4\u7EC7\u6216\u8BF7\u6C42\u52A0\u5165\u3002",
        title: "\u5DF2\u9A8C\u8BC1\u57DF\u540D"
      },
      successMessage: "\u7EC4\u7EC7\u4FE1\u606F\u5DF2\u66F4\u65B0\u3002",
      title: "\u7EC4\u7EC7\u7B80\u4ECB"
    },
    removeDomainPage: {
      messageLine1: "\u7535\u5B50\u90AE\u4EF6\u57DF\u540D {{domain}} \u5C06\u88AB\u5220\u9664\u3002",
      messageLine2: "\u6B64\u540E\uFF0C\u7528\u6237\u5C06\u65E0\u6CD5\u81EA\u52A8\u52A0\u5165\u7EC4\u7EC7\u3002",
      successMessage: "{{domain}} \u5DF2\u88AB\u5220\u9664\u3002",
      title: "\u5220\u9664\u57DF\u540D"
    },
    start: {
      headerTitle__general: "\u5E38\u89C4",
      headerTitle__members: "\u6210\u5458",
      profileSection: {
        primaryButton: "\u66F4\u65B0\u7EC4\u7EC7\u7B80\u4ECB",
        title: "\u7EC4\u7EC7\u7B80\u4ECB",
        uploadAction__title: "\u6807\u5FD7"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u5220\u9664\u6B64\u57DF\u540D\u5C06\u5F71\u54CD\u53D7\u9080\u7528\u6237\u3002",
        removeDomainActionLabel__remove: "\u5220\u9664\u57DF\u540D",
        removeDomainSubtitle: "\u4ECE\u60A8\u7684\u5DF2\u9A8C\u8BC1\u57DF\u540D\u4E2D\u5220\u9664\u6B64\u57DF\u540D",
        removeDomainTitle: "\u5220\u9664\u57DF\u540D"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u7528\u6237\u5728\u6CE8\u518C\u65F6\u4F1A\u81EA\u52A8\u6536\u5230\u52A0\u5165\u7EC4\u7EC7\u7684\u9080\u8BF7\uFF0C\u5E76\u4E14\u53EF\u4EE5\u968F\u65F6\u52A0\u5165\u3002",
        automaticInvitationOption__label: "\u81EA\u52A8\u9080\u8BF7",
        automaticSuggestionOption__description: "\u7528\u6237\u4F1A\u6536\u5230\u8BF7\u6C42\u52A0\u5165\u7684\u5EFA\u8BAE\uFF0C\u4F46\u5728\u52A0\u5165\u7EC4\u7EC7\u4E4B\u524D\u5FC5\u987B\u5F97\u5230\u7BA1\u7406\u5458\u7684\u6279\u51C6\u3002",
        automaticSuggestionOption__label: "\u81EA\u52A8\u5EFA\u8BAE",
        calloutInfoLabel: "\u66F4\u6539\u6CE8\u518C\u6A21\u5F0F\u53EA\u4F1A\u5F71\u54CD\u65B0\u7528\u6237\u3002",
        calloutInvitationCountLabel: "\u5DF2\u53D1\u9001\u7ED9\u7528\u6237\u7684\u5F85\u5904\u7406\u9080\u8BF7\uFF1A{{count}}",
        calloutSuggestionCountLabel: "\u5DF2\u53D1\u9001\u7ED9\u7528\u6237\u7684\u5F85\u5904\u7406\u5EFA\u8BAE\uFF1A{{count}}",
        manualInvitationOption__description: "\u7528\u6237\u53EA\u80FD\u88AB\u624B\u52A8\u9080\u8BF7\u52A0\u5165\u7EC4\u7EC7\u3002",
        manualInvitationOption__label: "\u65E0\u81EA\u52A8\u6CE8\u518C",
        subtitle: "\u9009\u62E9\u6B64\u57DF\u540D\u7684\u7528\u6237\u5982\u4F55\u52A0\u5165\u7EC4\u7EC7\u3002"
      },
      start: {
        headerTitle__danger: "\u5371\u9669",
        headerTitle__enrollment: "\u6CE8\u518C\u9009\u9879"
      },
      subtitle: "\u57DF\u540D {{domain}} \u73B0\u5DF2\u9A8C\u8BC1\u3002\u7EE7\u7EED\u9009\u62E9\u6CE8\u518C\u6A21\u5F0F\u3002",
      title: "\u66F4\u65B0 {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u8F93\u5165\u53D1\u9001\u5230\u60A8\u90AE\u7BB1\u5730\u5740\u7684\u9A8C\u8BC1\u7801",
      formTitle: "\u9A8C\u8BC1\u7801",
      resendButton: "\u672A\u6536\u5230\u9A8C\u8BC1\u7801\uFF1F\u91CD\u65B0\u53D1\u9001",
      subtitle: "\u57DF\u540D {{domainName}} \u9700\u8981\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u8FDB\u884C\u9A8C\u8BC1\u3002",
      subtitleVerificationCodeScreen: "\u9A8C\u8BC1\u7801\u5DF2\u53D1\u9001\u5230 {{emailAddress}}\u3002\u8F93\u5165\u9A8C\u8BC1\u7801\u4EE5\u7EE7\u7EED\u3002",
      title: "\u9A8C\u8BC1\u57DF\u540D"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u521B\u5EFA\u7EC4\u7EC7",
    action__invitationAccept: "\u52A0\u5165",
    action__manageOrganization: "\u7BA1\u7406\u7EC4\u7EC7",
    action__suggestionsAccept: "\u8BF7\u6C42\u52A0\u5165",
    notSelected: "\u672A\u9009\u62E9\u7EC4\u7EC7",
    personalWorkspace: "\u4E2A\u4EBA\u5DE5\u4F5C\u533A",
    suggestionsAcceptedLabel: "\u7B49\u5F85\u6279\u51C6"
  },
  paginationButton__next: "\u4E0B\u4E00\u9875",
  paginationButton__previous: "\u4E0A\u4E00\u9875",
  paginationRowText__displaying: "\u663E\u793A",
  paginationRowText__of: "\u7684",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u6DFB\u52A0\u8D26\u6237",
      action__signOutAll: "\u9000\u51FA\u6240\u6709\u8D26\u6237",
      subtitle: "\u9009\u62E9\u60A8\u8981\u7EE7\u7EED\u4F7F\u7528\u7684\u8D26\u6237\u3002",
      title: "\u9009\u62E9\u4E00\u4E2A\u8D26\u6237"
    },
    alternativeMethods: {
      actionLink: "\u83B7\u53D6\u5E2E\u52A9",
      actionText: "\u6CA1\u6709\u8FD9\u4E9B\uFF1F",
      blockButton__backupCode: "\u4F7F\u7528\u5907\u7528\u4EE3\u7801",
      blockButton__emailCode: "\u7535\u5B50\u90AE\u4EF6\u9A8C\u8BC1\u7801\u5230 {{identifier}}",
      blockButton__emailLink: "\u7535\u5B50\u90AE\u4EF6\u94FE\u63A5\u5230 {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "\u4F7F\u7528\u60A8\u7684\u5BC6\u7801\u767B\u5F55",
      blockButton__phoneCode: "\u53D1\u9001\u77ED\u4FE1\u4EE3\u7801\u5230 {{identifier}}",
      blockButton__totp: "\u4F7F\u7528\u60A8\u7684\u9A8C\u8BC1\u5E94\u7528\u7A0B\u5E8F",
      getHelp: {
        blockButton__emailSupport: "\u90AE\u4EF6\u652F\u6301",
        content: "\u5982\u679C\u60A8\u5728\u767B\u5F55\u8D26\u6237\u65F6\u9047\u5230\u56F0\u96BE\uFF0C\u8BF7\u7ED9\u6211\u4EEC\u53D1\u9001\u7535\u5B50\u90AE\u4EF6\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5FEB\u8BA9\u60A8\u6062\u590D\u8BBF\u95EE\u3002",
        title: "\u83B7\u53D6\u5E2E\u52A9"
      },
      subtitle: "\u9047\u5230\u95EE\u9898\uFF1F\u60A8\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0B\u4EFB\u4F55\u65B9\u6CD5\u767B\u5F55\u3002",
      title: "\u4F7F\u7528\u5176\u4ED6\u65B9\u6CD5"
    },
    backupCodeMfa: {
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u8F93\u5165\u5907\u7528\u4EE3\u7801"
    },
    emailCode: {
      formTitle: "\u9A8C\u8BC1\u7801",
      resendButton: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1\u7801",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u67E5\u770B\u60A8\u7684\u7535\u5B50\u90AE\u4EF6"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\u8FD4\u56DE\u539F\u59CB\u6807\u7B7E\u9875\u7EE7\u7EED\u3002",
        title: "\u6B64\u9A8C\u8BC1\u94FE\u63A5\u5DF2\u8FC7\u671F"
      },
      failed: {
        subtitle: "\u8FD4\u56DE\u539F\u59CB\u6807\u7B7E\u9875\u7EE7\u7EED\u3002",
        title: "\u6B64\u9A8C\u8BC1\u94FE\u63A5\u65E0\u6548"
      },
      formSubtitle: "\u4F7F\u7528\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u7684\u9A8C\u8BC1\u94FE\u63A5",
      formTitle: "\u9A8C\u8BC1\u94FE\u63A5",
      loading: {
        subtitle: "\u5373\u5C06\u4E3A\u60A8\u91CD\u5B9A\u5411",
        title: "\u6B63\u5728\u767B\u5F55..."
      },
      resendButton: "\u91CD\u65B0\u53D1\u9001\u94FE\u63A5",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u67E5\u770B\u60A8\u7684\u7535\u5B50\u90AE\u4EF6",
      unusedTab: {
        title: "\u60A8\u53EF\u4EE5\u5173\u95ED\u6B64\u6807\u7B7E\u9875"
      },
      verified: {
        subtitle: "\u5373\u5C06\u4E3A\u60A8\u91CD\u5B9A\u5411",
        title: "\u6210\u529F\u767B\u5F55"
      },
      verifiedSwitchTab: {
        subtitle: "\u8FD4\u56DE\u539F\u59CB\u6807\u7B7E\u9875\u7EE7\u7EED",
        subtitleNewTab: "\u8FD4\u56DE\u65B0\u6253\u5F00\u7684\u6807\u7B7E\u9875\u7EE7\u7EED",
        titleNewTab: "\u5728\u5176\u4ED6\u6807\u7B7E\u9875\u4E0A\u767B\u5F55"
      }
    },
    forgotPassword: {
      formTitle: "\u91CD\u7F6E\u5BC6\u7801\u4EE3\u7801",
      resendButton: "\u91CD\u65B0\u53D1\u9001\u4EE3\u7801",
      subtitle: "\u4EE5\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801",
      subtitle_email: "\u9996\u5148\uFF0C\u8F93\u5165\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u4EF6 ID \u7684\u4EE3\u7801",
      subtitle_phone: "\u9996\u5148\uFF0C\u8F93\u5165\u53D1\u9001\u5230\u60A8\u624B\u673A\u7684\u4EE3\u7801",
      title: "\u91CD\u7F6E\u5BC6\u7801"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u91CD\u7F6E\u5BC6\u7801",
      label__alternativeMethods: "\u6216\u8005\uFF0C\u4F7F\u7528\u5176\u4ED6\u65B9\u5F0F\u767B\u5F55\u3002",
      title: "\u5FD8\u8BB0\u5BC6\u7801\uFF1F"
    },
    noAvailableMethods: {
      message: "\u65E0\u6CD5\u7EE7\u7EED\u767B\u5F55\u3002\u6CA1\u6709\u53EF\u7528\u7684\u8EAB\u4EFD\u9A8C\u8BC1\u56E0\u7D20\u3002",
      subtitle: "\u51FA\u73B0\u9519\u8BEF",
      title: "\u65E0\u6CD5\u767B\u5F55"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\u4F7F\u7528\u5176\u4ED6\u65B9\u6CD5",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u8F93\u5165\u60A8\u7684\u5BC6\u7801"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\u9A8C\u8BC1\u7801",
      resendButton: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1\u7801",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u68C0\u67E5\u624B\u673A\u77ED\u4FE1"
    },
    phoneCodeMfa: {
      formTitle: "\u9A8C\u8BC1\u7801",
      resendButton: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1\u7801",
      subtitle: "\u8BF7\u7EE7\u7EED\u8F93\u5165\u53D1\u9001\u5230\u60A8\u624B\u673A\u7684\u9A8C\u8BC1\u7801\u3002",
      title: "\u68C0\u67E5\u624B\u673A\u77ED\u4FE1"
    },
    resetPassword: {
      formButtonPrimary: "\u91CD\u7F6E\u5BC6\u7801",
      requiredMessage: "\u51FA\u4E8E\u5B89\u5168\u539F\u56E0\uFF0C\u9700\u8981\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801\u3002",
      successMessage: "\u60A8\u7684\u5BC6\u7801\u5DF2\u6210\u529F\u66F4\u6539\u3002\u6B63\u5728\u4E3A\u60A8\u767B\u5F55\uFF0C\u8BF7\u7A0D\u7B49\u3002",
      title: "\u91CD\u7F6E\u5BC6\u7801"
    },
    resetPasswordMfa: {
      detailsLabel: "\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u624D\u80FD\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801\u3002"
    },
    start: {
      actionLink: "\u6CE8\u518C",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\u4F7F\u7528\u7535\u5B50\u90AE\u4EF6",
      actionLink__use_email_username: "\u4F7F\u7528\u7535\u5B50\u90AE\u4EF6\u6216\u7528\u6237\u540D",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "\u4F7F\u7528\u7535\u8BDD",
      actionLink__use_username: "\u4F7F\u7528\u7528\u6237\u540D",
      actionText: "\u8FD8\u6CA1\u6709\u8D26\u6237\uFF1F",
      actionText__join_waitlist: void 0,
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      subtitleCombined: void 0,
      title: "\u767B\u5F55",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u9A8C\u8BC1\u7801",
      subtitle: "\u8BF7\u7EE7\u7EED\u8F93\u5165\u7531\u60A8\u7684\u8EAB\u4EFD\u9A8C\u8BC1\u5E94\u7528\u751F\u6210\u7684\u9A8C\u8BC1\u7801\u3002",
      title: "\u4E24\u6B65\u9A8C\u8BC1"
    }
  },
  signInEnterPasswordTitle: "\u8F93\u5165\u60A8\u7684\u5BC6\u7801",
  signUp: {
    continue: {
      actionLink: "\u767B\u5F55",
      actionText: "\u5DF2\u7ECF\u6709\u8D26\u6237\u4E86\uFF1F",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u586B\u5199\u7F3A\u5C11\u7684\u5B57\u6BB5"
    },
    emailCode: {
      formSubtitle: "\u8F93\u5165\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u7684\u9A8C\u8BC1\u7801",
      formTitle: "\u9A8C\u8BC1\u7801",
      resendButton: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1\u7801",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u9A8C\u8BC1\u60A8\u7684\u7535\u5B50\u90AE\u4EF6"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\u4F7F\u7528\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u7684\u9A8C\u8BC1\u94FE\u63A5",
      formTitle: "\u9A8C\u8BC1\u94FE\u63A5",
      loading: {
        title: "\u6B63\u5728\u6CE8\u518C..."
      },
      resendButton: "\u91CD\u65B0\u53D1\u9001\u94FE\u63A5",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u9A8C\u8BC1\u60A8\u7684\u7535\u5B50\u90AE\u4EF6",
      verified: {
        title: "\u6210\u529F\u6CE8\u518C"
      },
      verifiedSwitchTab: {
        subtitle: "\u8FD4\u56DE\u65B0\u6253\u5F00\u7684\u6807\u7B7E\u9875\u7EE7\u7EED",
        subtitleNewTab: "\u8FD4\u56DE\u4E0A\u4E00\u4E2A\u6807\u7B7E\u9875\u7EE7\u7EED",
        title: "\u6210\u529F\u9A8C\u8BC1\u7535\u5B50\u90AE\u4EF6"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\u8F93\u5165\u53D1\u9001\u5230\u60A8\u7684\u7535\u8BDD\u53F7\u7801\u7684\u9A8C\u8BC1\u7801",
      formTitle: "\u9A8C\u8BC1\u7801",
      resendButton: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1\u7801",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u9A8C\u8BC1\u60A8\u7684\u7535\u8BDD"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u767B\u5F55",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u5DF2\u7ECF\u6709\u8D26\u6237\u4E86\uFF1F",
      subtitle: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      subtitleCombined: "\u7EE7\u7EED\u4F7F\u7528 {{applicationName}}",
      title: "\u521B\u5EFA\u60A8\u7684\u8D26\u6237",
      titleCombined: "\u521B\u5EFA\u60A8\u7684\u8D26\u6237"
    }
  },
  socialButtonsBlockButton: "\u4F7F\u7528 {{provider|titleize}} \u767B\u5F55",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\u7531\u4E8E\u5B89\u5168\u9A8C\u8BC1\u5931\u8D25\uFF0C\u6CE8\u518C\u672A\u6210\u529F\u3002\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5\u6216\u8054\u7CFB\u652F\u6301\u83B7\u53D6\u66F4\u591A\u5E2E\u52A9\u3002",
    captcha_unavailable: "\u6CE8\u518C\u5931\u8D25\uFF0C\u539F\u56E0\u662F\u672A\u901A\u8FC7\u673A\u5668\u4EBA\u9A8C\u8BC1\u3002\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5\u6216\u8054\u7CFB\u652F\u6301\u56E2\u961F\u4EE5\u83B7\u53D6\u66F4\u591A\u5E2E\u52A9\u3002",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u90AE\u7BB1\u5730\u5740\u5FC5\u987B\u662F\u6709\u6548\u7684\u90AE\u7BB1\u683C\u5F0F\u3002",
    form_param_format_invalid__phone_number: "\u7535\u8BDD\u53F7\u7801\u5FC5\u987B\u7B26\u5408\u6709\u6548\u7684\u56FD\u9645\u683C\u5F0F\u3002",
    form_param_max_length_exceeded__first_name: "\u540D\u5B57\u957F\u5EA6\u4E0D\u5F97\u8D85\u8FC7256\u4E2A\u5B57\u7B26\u3002",
    form_param_max_length_exceeded__last_name: "\u59D3\u6C0F\u957F\u5EA6\u4E0D\u5F97\u8D85\u8FC7256\u4E2A\u5B57\u7B26\u3002",
    form_param_max_length_exceeded__name: "\u59D3\u540D\u957F\u5EA6\u4E0D\u5F97\u8D85\u8FC7256\u4E2A\u5B57\u7B26\u3002",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u60A8\u7684\u5BC6\u7801\u5F3A\u5EA6\u4E0D\u591F\u3002",
    form_password_pwned: "\u8FD9\u4E2A\u5BC6\u7801\u5728\u6570\u636E\u6CC4\u9732\u4E2D\u88AB\u53D1\u73B0\uFF0C\u4E0D\u80FD\u4F7F\u7528\uFF0C\u8BF7\u6362\u4E00\u4E2A\u5BC6\u7801\u8BD5\u8BD5\u3002",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\u60A8\u7684\u5BC6\u7801\u8D85\u8FC7\u4E86\u5141\u8BB8\u7684\u6700\u5927\u5B57\u8282\u6570\uFF0C\u8BF7\u7F29\u77ED\u5B83\u6216\u53BB\u6389\u4E00\u4E9B\u7279\u6B8A\u5B57\u7B26\u3002",
    form_password_validation_failed: "\u5BC6\u7801\u9519\u8BEF",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "\u60A8\u65E0\u6CD5\u5220\u9664\u6700\u540E\u4E00\u4E2A\u8EAB\u4EFD\u6807\u8BC6\u3002",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "\u5C11\u4E8E{{length}}\u4E2A\u5B57\u7B26",
      minimumLength: "{{length}}\u4E2A\u6216\u66F4\u591A\u5B57\u7B26",
      requireLowercase: "\u4E00\u4E2A\u5C0F\u5199\u5B57\u6BCD",
      requireNumbers: "\u4E00\u4E2A\u6570\u5B57",
      requireSpecialCharacter: "\u4E00\u4E2A\u7279\u6B8A\u5B57\u7B26",
      requireUppercase: "\u4E00\u4E2A\u5927\u5199\u5B57\u6BCD",
      sentencePrefix: "\u60A8\u7684\u5BC6\u7801\u5FC5\u987B\u5305\u542B"
    },
    phone_number_exists: "\u8BE5\u7535\u8BDD\u53F7\u7801\u5DF2\u88AB\u4F7F\u7528\uFF0C\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u53F7\u7801\u3002",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u60A8\u7684\u5BC6\u7801\u53EF\u4EE5\u7528\uFF0C\u4F46\u53EF\u4EE5\u66F4\u5F3A\u3002\u8BD5\u7740\u6DFB\u52A0\u66F4\u591A\u5B57\u7B26\u3002",
      goodPassword: "\u505A\u5F97\u597D\u3002\u8FD9\u662F\u4E00\u4E2A\u4F18\u79C0\u7684\u5BC6\u7801\u3002",
      notEnough: "\u60A8\u7684\u5BC6\u7801\u5F3A\u5EA6\u4E0D\u591F\u3002",
      suggestions: {
        allUppercase: "\u5927\u5199\u4E00\u4E9B\uFF0C\u4F46\u4E0D\u662F\u6240\u6709\u7684\u5B57\u6BCD\u3002",
        anotherWord: "\u6DFB\u52A0\u66F4\u4E0D\u5E38\u89C1\u7684\u66F4\u591A\u5355\u8BCD\u3002",
        associatedYears: "\u907F\u514D\u4E0E\u4F60\u6709\u5173\u7684\u5E74\u4EFD\u3002",
        capitalization: "\u5927\u5199\u4E0D\u4EC5\u4EC5\u662F\u7B2C\u4E00\u4E2A\u5B57\u6BCD\u3002",
        dates: "\u907F\u514D\u4E0E\u4F60\u6709\u5173\u7684\u65E5\u671F\u548C\u5E74\u4EFD\u3002",
        l33t: '\u907F\u514D\u9884\u6D4B\u7684\u5B57\u6BCD\u66FF\u6362\uFF0C\u5982"@"\u4EE3\u66FF"a"\u3002',
        longerKeyboardPattern: "\u4F7F\u7528\u66F4\u957F\u7684\u952E\u76D8\u6A21\u5F0F\uFF0C\u5E76\u591A\u6B21\u6539\u53D8\u6253\u5B57\u65B9\u5411\u3002",
        noNeed: "\u4F60\u53EF\u4EE5\u521B\u5EFA\u5F3A\u5BC6\u7801\uFF0C\u800C\u65E0\u9700\u4F7F\u7528\u7B26\u53F7\uFF0C\u6570\u5B57\u6216\u5927\u5199\u5B57\u6BCD\u3002",
        pwned: "\u5982\u679C\u60A8\u5728\u5176\u4ED6\u5730\u65B9\u4F7F\u7528\u6B64\u5BC6\u7801\uFF0C\u60A8\u5E94\u8BE5\u66F4\u6539\u5B83\u3002",
        recentYears: "\u907F\u514D\u8FD1\u5E74\u6765\u3002",
        repeated: "\u907F\u514D\u91CD\u590D\u7684\u5355\u8BCD\u548C\u5B57\u7B26\u3002",
        reverseWords: "\u907F\u514D\u5E38\u7528\u8BCD\u7684\u53CD\u5411\u62FC\u5199\u3002",
        sequences: "\u907F\u514D\u5E38\u89C1\u5B57\u7B26\u5E8F\u5217\u3002",
        useWords: "\u4F7F\u7528\u591A\u4E2A\u5355\u8BCD\uFF0C\u4F46\u907F\u514D\u5E38\u89C1\u77ED\u8BED\u3002"
      },
      warnings: {
        common: "\u8FD9\u662F\u4E00\u4E2A\u5E38\u7528\u7684\u5BC6\u7801\u3002",
        commonNames: "\u5E38\u89C1\u7684\u540D\u5B57\u548C\u59D3\u6C0F\u6613\u88AB\u731C\u5230\u3002",
        dates: "\u65E5\u671F\u6613\u88AB\u731C\u5230\u3002",
        extendedRepeat: '\u50CF"abcabcabc"\u8FD9\u6837\u7684\u91CD\u590D\u5B57\u7B26\u6A21\u5F0F\u6613\u88AB\u731C\u5230\u3002',
        keyPattern: "\u77ED\u952E\u76D8\u6A21\u5F0F\u6613\u88AB\u731C\u5230\u3002",
        namesByThemselves: "\u5355\u4E2A\u540D\u5B57\u6216\u59D3\u6C0F\u6613\u88AB\u731C\u5230\u3002",
        pwned: "\u60A8\u7684\u5BC6\u7801\u5728\u4E92\u8054\u7F51\u4E0A\u7684\u6570\u636E\u6CC4\u9732\u4E2D\u88AB\u66B4\u9732\u3002",
        recentYears: "\u8FD1\u5E74\u6765\u6613\u88AB\u731C\u5230\u3002",
        sequences: '\u50CF"abc"\u8FD9\u6837\u7684\u5E38\u89C1\u5B57\u7B26\u5E8F\u5217\u6613\u88AB\u731C\u5230\u3002',
        similarToCommon: "\u8FD9\u4E2A\u5BC6\u7801\u548C\u5E38\u7528\u5BC6\u7801\u76F8\u4F3C\u3002",
        simpleRepeat: '\u50CF"aaa"\u8FD9\u6837\u7684\u91CD\u590D\u5B57\u7B26\u6613\u88AB\u731C\u5230\u3002',
        straightRow: "\u952E\u76D8\u4E0A\u7684\u76F4\u884C\u952E\u6613\u88AB\u731C\u5230\u3002",
        topHundred: "\u8FD9\u662F\u4E00\u4E2A\u9891\u7E41\u4F7F\u7528\u7684\u5BC6\u7801\u3002",
        topTen: "\u8FD9\u662F\u4E00\u4E2A\u5927\u91CF\u4F7F\u7528\u7684\u5BC6\u7801\u3002",
        userInputs: "\u4E0D\u5E94\u8BE5\u6709\u4EFB\u4F55\u4E2A\u4EBA\u6216\u9875\u9762\u76F8\u5173\u7684\u6570\u636E\u3002",
        wordByItself: "\u5355\u4E2A\u5355\u8BCD\u6613\u88AB\u731C\u5230\u3002"
      }
    }
  },
  userButton: {
    action__addAccount: "\u6DFB\u52A0\u8D26\u6237",
    action__manageAccount: "\u7BA1\u7406\u8D26\u6237",
    action__signOut: "\u9000\u51FA\u767B\u5F55",
    action__signOutAll: "\u9000\u51FA\u6240\u6709\u8D26\u6237"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u5DF2\u590D\u5236\uFF01",
      actionLabel__copy: "\u590D\u5236\u5168\u90E8",
      actionLabel__download: "\u4E0B\u8F7D .txt",
      actionLabel__print: "\u6253\u5370",
      infoText1: "\u5C06\u4E3A\u6B64\u8D26\u6237\u542F\u7528\u5907\u4EFD\u4EE3\u7801\u3002",
      infoText2: "\u4FDD\u5BC6\u5E76\u5B89\u5168\u5B58\u50A8\u5907\u4EFD\u4EE3\u7801\u3002\u5982\u679C\u60A8\u6000\u7591\u5B83\u4EEC\u5DF2\u7ECF\u6CC4\u9732\uFF0C\u60A8\u53EF\u4EE5\u91CD\u65B0\u751F\u6210\u5907\u4EFD\u4EE3\u7801\u3002",
      subtitle__codelist: "\u5B89\u5168\u5B58\u50A8\u5E76\u4FDD\u5B88\u79D8\u5BC6\u3002",
      successMessage: "\u73B0\u5728\u5DF2\u542F\u7528\u5907\u4EFD\u4EE3\u7801\u3002\u5982\u679C\u60A8\u5931\u53BB\u4E86\u9A8C\u8BC1\u8BBE\u5907\u7684\u8BBF\u95EE\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u5176\u4E2D\u4E4B\u4E00\u767B\u5F55\u60A8\u7684\u8D26\u6237\u3002\u6BCF\u4E2A\u4EE3\u7801\u53EA\u80FD\u4F7F\u7528\u4E00\u6B21\u3002",
      successSubtitle: "\u5982\u679C\u60A8\u5931\u53BB\u4E86\u9A8C\u8BC1\u8BBE\u5907\u7684\u8BBF\u95EE\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u5176\u4E2D\u4E4B\u4E00\u767B\u5F55\u60A8\u7684\u8D26\u6237\u3002",
      title: "\u6DFB\u52A0\u5907\u4EFD\u4EE3\u7801\u9A8C\u8BC1",
      title__codelist: "\u5907\u4EFD\u4EE3\u7801"
    },
    connectedAccountPage: {
      formHint: "\u9009\u62E9\u4E00\u4E2A\u4F9B\u5E94\u5546\u6765\u8FDE\u63A5\u60A8\u7684\u8D26\u6237\u3002",
      formHint__noAccounts: "\u6CA1\u6709\u53EF\u7528\u7684\u5916\u90E8\u8D26\u6237\u4F9B\u5E94\u5546\u3002",
      removeResource: {
        messageLine1: "{{identifier}} \u5C06\u4ECE\u6B64\u8D26\u6237\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C06\u65E0\u6CD5\u518D\u4F7F\u7528\u8FD9\u4E2A\u5DF2\u8FDE\u63A5\u7684\u8D26\u6237\uFF0C\u4EFB\u4F55\u4F9D\u8D56\u7684\u529F\u80FD\u5C06\u4E0D\u518D\u5DE5\u4F5C\u3002",
        successMessage: "{{connectedAccount}} \u5DF2\u4ECE\u60A8\u7684\u8D26\u6237\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664\u5DF2\u8FDE\u63A5\u7684\u8D26\u6237"
      },
      socialButtonsBlockButton: "\u8FDE\u63A5 {{provider|titleize}} \u8D26\u6237",
      successMessage: "\u4F9B\u5E94\u5546\u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237",
      title: "\u6DFB\u52A0\u5DF2\u8FDE\u63A5\u7684\u8D26\u6237"
    },
    deletePage: {
      actionDescription: '\u5728\u4E0B\u65B9\u8F93\u5165 "Delete account" \u4EE5\u7EE7\u7EED\u3002',
      confirm: "Delete account",
      messageLine1: "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u60A8\u7684\u8D26\u6237\u5417\uFF1F",
      messageLine2: "\u6B64\u64CD\u4F5C\u662F\u6C38\u4E45\u4E14\u4E0D\u53EF\u9006\u7684\u3002",
      title: "\u5220\u9664\u8D26\u6237"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u4E00\u5C01\u542B\u6709\u9A8C\u8BC1\u7801\u7684\u90AE\u4EF6\u5C06\u4F1A\u88AB\u53D1\u9001\u5230\u8FD9\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002",
        formSubtitle: "\u8F93\u5165\u53D1\u9001\u5230 {{identifier}} \u7684\u9A8C\u8BC1\u7801",
        formTitle: "\u9A8C\u8BC1\u7801",
        resendButton: "\u91CD\u53D1\u9A8C\u8BC1\u7801",
        successMessage: "\u7535\u5B50\u90AE\u4EF6 {{identifier}} \u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u3002"
      },
      emailLink: {
        formHint: "\u4E00\u5C01\u542B\u6709\u9A8C\u8BC1\u94FE\u63A5\u7684\u90AE\u4EF6\u5C06\u4F1A\u88AB\u53D1\u9001\u5230\u8FD9\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002",
        formSubtitle: "\u70B9\u51FB\u53D1\u9001\u5230 {{identifier}} \u7684\u90AE\u4EF6\u4E2D\u7684\u9A8C\u8BC1\u94FE\u63A5",
        formTitle: "\u9A8C\u8BC1\u94FE\u63A5",
        resendButton: "\u91CD\u53D1\u94FE\u63A5",
        successMessage: "\u7535\u5B50\u90AE\u4EF6 {{identifier}} \u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u3002"
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u5C06\u4ECE\u6B64\u8D26\u6237\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C06\u65E0\u6CD5\u4F7F\u7528\u8FD9\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u767B\u5F55\u3002",
        successMessage: "\u7535\u5B50\u90AE\u4EF6 {{emailAddress}} \u5DF2\u4ECE\u60A8\u7684\u8D26\u6237\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664\u7535\u5B50\u90AE\u4EF6\u5730\u5740"
      },
      title: "\u6DFB\u52A0\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "\u6DFB\u52A0",
    formButtonPrimary__continue: "\u7EE7\u7EED",
    formButtonPrimary__finish: "\u5B8C\u6210",
    formButtonPrimary__remove: "\u79FB\u9664",
    formButtonPrimary__save: "\u4FDD\u5B58",
    formButtonReset: "\u53D6\u6D88",
    mfaPage: {
      formHint: "\u9009\u62E9\u4E00\u4E2A\u6DFB\u52A0\u7684\u65B9\u6CD5\u3002",
      title: "\u6DFB\u52A0\u4E24\u6B65\u9A8C\u8BC1"
    },
    mfaPhoneCodePage: {
      backButton: "\u4F7F\u7528\u73B0\u6709\u53F7\u7801",
      primaryButton__addPhoneNumber: "\u6DFB\u52A0\u7535\u8BDD\u53F7\u7801",
      removeResource: {
        messageLine1: "{{identifier}} \u5C06\u4E0D\u518D\u5728\u767B\u5F55\u65F6\u63A5\u6536\u9A8C\u8BC1\u4EE3\u7801\u3002",
        messageLine2: "\u60A8\u7684\u8D26\u6237\u53EF\u80FD\u4E0D\u518D\u5B89\u5168\u3002\u60A8\u786E\u5B9A\u8981\u7EE7\u7EED\u5417\uFF1F",
        successMessage: "\u5DF2\u79FB\u9664{{mfaPhoneCode}}\u7684\u77ED\u4FE1\u9A8C\u8BC1\u7801\u4E24\u6B65\u9A8C\u8BC1",
        title: "\u79FB\u9664\u4E24\u6B65\u9A8C\u8BC1"
      },
      subtitle__availablePhoneNumbers: "\u9009\u62E9\u4E00\u4E2A\u7535\u8BDD\u53F7\u7801\u6765\u6CE8\u518C\u77ED\u4FE1\u9A8C\u8BC1\u7801\u4E24\u6B65\u9A8C\u8BC1\u3002",
      subtitle__unavailablePhoneNumbers: "\u6CA1\u6709\u53EF\u7528\u7684\u7535\u8BDD\u53F7\u7801\u6765\u6CE8\u518C\u77ED\u4FE1\u9A8C\u8BC1\u7801\u4E24\u6B65\u9A8C\u8BC1\u3002",
      successMessage1: "\u767B\u5F55\u65F6\uFF0C\u60A8\u9700\u8981\u8F93\u5165\u53D1\u9001\u5230\u6B64\u7535\u8BDD\u53F7\u7801\u7684\u9A8C\u8BC1\u7801\u4F5C\u4E3A\u989D\u5916\u7684\u6B65\u9AA4\u3002",
      successMessage2: "\u8BF7\u4FDD\u5B58\u8FD9\u4E9B\u5907\u4EFD\u4EE3\u7801\u5E76\u5C06\u5176\u59A5\u5584\u5B58\u653E\u3002\u5982\u679C\u60A8\u65E0\u6CD5\u8BBF\u95EE\u8EAB\u4EFD\u9A8C\u8BC1\u8BBE\u5907\uFF0C\u53EF\u4EE5\u4F7F\u7528\u5907\u4EFD\u4EE3\u7801\u8FDB\u884C\u767B\u5F55\u3002",
      successTitle: "\u77ED\u4FE1\u9A8C\u8BC1\u7801\u9A8C\u8BC1\u5DF2\u542F\u7528",
      title: "\u6DFB\u52A0\u77ED\u4FE1\u9A8C\u8BC1\u7801\u9A8C\u8BC1"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u626B\u63CF\u4E8C\u7EF4\u7801",
        buttonUnableToScan__nonPrimary: "\u4E0D\u80FD\u626B\u63CF\u4E8C\u7EF4\u7801\uFF1F",
        infoText__ableToScan: "\u5728\u60A8\u7684\u9A8C\u8BC1\u5668\u5E94\u7528\u4E2D\u8BBE\u7F6E\u4E00\u4E2A\u65B0\u7684\u767B\u5F55\u65B9\u6CD5\uFF0C\u5E76\u626B\u63CF\u4E0B\u9762\u7684\u4E8C\u7EF4\u7801\u5C06\u5176\u94FE\u63A5\u5230\u60A8\u7684\u8D26\u6237\u3002",
        infoText__unableToScan: "\u5728\u9A8C\u8BC1\u5668\u4E2D\u8BBE\u7F6E\u4E00\u4E2A\u65B0\u7684\u767B\u5F55\u65B9\u6CD5\uFF0C\u5E76\u8F93\u5165\u4E0B\u9762\u63D0\u4F9B\u7684 Key\u3002",
        inputLabel__unableToScan1: "\u786E\u4FDD\u542F\u7528\u4E86\u57FA\u4E8E\u65F6\u95F4\u6216\u4E00\u6B21\u6027\u5BC6\u7801\uFF0C\u7136\u540E\u5B8C\u6210\u94FE\u63A5\u60A8\u7684\u8D26\u6237\u3002",
        inputLabel__unableToScan2: "\u6216\u8005\uFF0C\u5982\u679C\u60A8\u7684\u9A8C\u8BC1\u5668\u652F\u6301 TOTP URIs\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u590D\u5236\u5B8C\u6574\u7684 URI\u3002"
      },
      removeResource: {
        messageLine1: "\u767B\u5F55\u65F6\uFF0C\u5C06\u4E0D\u518D\u9700\u8981\u6765\u81EA\u6B64\u9A8C\u8BC1\u5668\u7684\u9A8C\u8BC1\u7801\u3002",
        messageLine2: "\u60A8\u7684\u8D26\u6237\u53EF\u80FD\u4E0D\u518D\u5B89\u5168\u3002\u60A8\u786E\u5B9A\u8981\u7EE7\u7EED\u5417\uFF1F",
        successMessage: "\u5DF2\u79FB\u9664\u901A\u8FC7\u9A8C\u8BC1\u5668\u5E94\u7528\u7A0B\u5E8F\u7684\u4E24\u6B65\u9A8C\u8BC1\u3002",
        title: "\u79FB\u9664\u4E24\u6B65\u9A8C\u8BC1"
      },
      successMessage: "\u73B0\u5728\u5DF2\u542F\u7528\u4E24\u6B65\u9A8C\u8BC1\u3002\u5728\u767B\u5F55\u65F6\uFF0C\u60A8\u9700\u8981\u8F93\u5165\u6765\u81EA\u6B64\u9A8C\u8BC1\u5668\u7684\u9A8C\u8BC1\u7801\u4F5C\u4E3A\u989D\u5916\u6B65\u9AA4\u3002",
      title: "\u6DFB\u52A0\u9A8C\u8BC1\u5668\u5E94\u7528\u7A0B\u5E8F",
      verifySubtitle: "\u8F93\u5165\u60A8\u7684\u9A8C\u8BC1\u5668\u751F\u6210\u7684\u9A8C\u8BC1\u7801",
      verifyTitle: "\u9A8C\u8BC1\u4EE3\u7801"
    },
    mobileButton__menu: "\u83DC\u5355",
    navbar: {
      account: "\u8D26\u6237",
      description: "\u7BA1\u7406\u60A8\u7684\u8D26\u6237\u3002",
      security: "\u5B89\u5168",
      title: "\u8D26\u6237"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u5EFA\u8BAE\u60A8\u4ECE\u6240\u6709\u53EF\u80FD\u4F7F\u7528\u8FC7\u65E7\u5BC6\u7801\u7684\u5176\u4ED6\u8BBE\u5907\u4E0A\u9000\u51FA\u767B\u5F55\u3002",
      readonly: "\u7531\u4E8E\u60A8\u53EA\u80FD\u901A\u8FC7\u4F01\u4E1A\u8FDE\u63A5\u767B\u5F55\uFF0C\u5F53\u524D\u65E0\u6CD5\u7F16\u8F91\u60A8\u7684\u5BC6\u7801\u3002",
      successMessage__set: "\u60A8\u7684\u5BC6\u7801\u5DF2\u8BBE\u7F6E\u3002",
      successMessage__signOutOfOtherSessions: "\u6240\u6709\u5176\u4ED6\u8BBE\u5907\u5DF2\u9000\u51FA\u3002",
      successMessage__update: "\u60A8\u7684\u5BC6\u7801\u5DF2\u66F4\u65B0\u3002",
      title__set: "\u8BBE\u7F6E\u5BC6\u7801",
      title__update: "\u66F4\u6539\u5BC6\u7801"
    },
    phoneNumberPage: {
      infoText: "\u4E00\u6761\u5305\u542B\u9A8C\u8BC1\u94FE\u63A5\u7684\u77ED\u4FE1\u5C06\u4F1A\u53D1\u9001\u5230\u8FD9\u4E2A\u7535\u8BDD\u53F7\u7801\u3002",
      removeResource: {
        messageLine1: "{{identifier}} \u5C06\u4ECE\u6B64\u8D26\u6237\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C06\u65E0\u6CD5\u4F7F\u7528\u8FD9\u4E2A\u7535\u8BDD\u53F7\u7801\u767B\u5F55\u3002",
        successMessage: "\u7535\u8BDD\u53F7\u7801 {{phoneNumber}} \u5DF2\u4ECE\u60A8\u7684\u8D26\u6237\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664\u7535\u8BDD\u53F7\u7801"
      },
      successMessage: "{{identifier}} \u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u3002",
      title: "\u6DFB\u52A0\u7535\u8BDD\u53F7\u7801",
      verifySubtitle: "\u8BF7\u8F93\u5165\u53D1\u9001\u81F3 {{identifier}} \u7684\u9A8C\u8BC1\u7801",
      verifyTitle: "\u9A8C\u8BC1\u7535\u8BDD\u53F7\u7801"
    },
    profilePage: {
      fileDropAreaHint: "\u4E0A\u4F20\u5C0F\u4E8E10MB\u7684JPG, PNG, GIF, \u6216WEBP\u683C\u5F0F\u7684\u56FE\u7247",
      imageFormDestructiveActionSubtitle: "\u79FB\u9664\u56FE\u7247",
      imageFormSubtitle: "\u4E0A\u4F20\u56FE\u7247",
      imageFormTitle: "\u4E2A\u4EBA\u8D44\u6599\u56FE\u7247",
      readonly: "\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7531\u4F01\u4E1A\u8FDE\u63A5\u63D0\u4F9B\uFF0C\u65E0\u6CD5\u8FDB\u884C\u7F16\u8F91\u3002",
      successMessage: "\u60A8\u7684\u4E2A\u4EBA\u8D44\u6599\u5DF2\u66F4\u65B0\u3002",
      title: "\u66F4\u65B0\u4E2A\u4EBA\u8D44\u6599"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u9000\u51FA\u8BBE\u5907",
        title: "\u6D3B\u52A8\u8BBE\u5907"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u518D\u8BD5\u4E00\u6B21",
        actionLabel__reauthorize: "\u7ACB\u5373\u6388\u6743",
        destructiveActionTitle: "\u79FB\u9664",
        primaryButton: "\u8FDE\u63A5\u8D26\u6237",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "\u201C\u6240\u9700\u7684\u6743\u9650\u8303\u56F4\u5DF2\u66F4\u65B0\uFF0C\u60A8\u53EF\u80FD\u4F1A\u9047\u5230\u529F\u80FD\u53D7\u9650\u7684\u95EE\u9898\u3002\u8BF7\u91CD\u65B0\u6388\u6743\u6B64\u5E94\u7528\u7A0B\u5E8F\uFF0C\u4EE5\u907F\u514D\u51FA\u73B0\u4EFB\u4F55\u95EE\u9898\u3002\u201D",
        title: "\u5DF2\u8FDE\u63A5\u7684\u8D26\u6237"
      },
      dangerSection: {
        deleteAccountButton: "\u5220\u9664\u8D26\u6237",
        title: "\u7EC8\u6B62\u8D26\u6237"
      },
      emailAddressesSection: {
        destructiveAction: "\u79FB\u9664\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
        detailsAction__nonPrimary: "\u8BBE\u4E3A\u4E3B\u8981",
        detailsAction__primary: "\u5B8C\u6210\u9A8C\u8BC1",
        detailsAction__unverified: "\u5B8C\u6210\u9A8C\u8BC1",
        primaryButton: "\u6DFB\u52A0\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
        title: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740"
      },
      enterpriseAccountsSection: {
        title: "\u4F01\u4E1A\u8D26\u6237"
      },
      headerTitle__account: "\u8D26\u6237",
      headerTitle__security: "\u5B89\u5168",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u91CD\u65B0\u751F\u6210\u4EE3\u7801",
          headerTitle: "\u5907\u4EFD\u4EE3\u7801",
          subtitle__regenerate: "\u83B7\u53D6\u4E00\u5957\u65B0\u7684\u5B89\u5168\u5907\u4EFD\u4EE3\u7801\u3002\u4E4B\u524D\u7684\u5907\u4EFD\u4EE3\u7801\u5C06\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u4F7F\u7528\u3002",
          title__regenerate: "\u91CD\u65B0\u751F\u6210\u5907\u4EFD\u4EE3\u7801"
        },
        phoneCode: {
          actionLabel__setDefault: "\u8BBE\u4E3A\u9ED8\u8BA4",
          destructiveActionLabel: "\u79FB\u9664\u7535\u8BDD\u53F7\u7801"
        },
        primaryButton: "\u6DFB\u52A0\u4E24\u6B65\u9A8C\u8BC1",
        title: "\u4E24\u6B65\u9A8C\u8BC1",
        totp: {
          destructiveActionTitle: "\u79FB\u9664",
          headerTitle: "\u9A8C\u8BC1\u5668\u5E94\u7528\u7A0B\u5E8F"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u8BBE\u7F6E\u5BC6\u7801",
        primaryButton__updatePassword: "\u66F4\u6539\u5BC6\u7801",
        title: "\u5BC6\u7801"
      },
      phoneNumbersSection: {
        destructiveAction: "\u79FB\u9664\u7535\u8BDD\u53F7\u7801",
        detailsAction__nonPrimary: "\u8BBE\u4E3A\u4E3B\u8981",
        detailsAction__primary: "\u5B8C\u6210\u9A8C\u8BC1",
        detailsAction__unverified: "\u5B8C\u6210\u9A8C\u8BC1",
        primaryButton: "\u6DFB\u52A0\u7535\u8BDD\u53F7\u7801",
        title: "\u7535\u8BDD\u53F7\u7801"
      },
      profileSection: {
        primaryButton: "\u66F4\u65B0\u4E2A\u4EBA\u8D44\u6599",
        title: "\u4E2A\u4EBA\u8D44\u6599"
      },
      usernameSection: {
        primaryButton__setUsername: "\u8BBE\u7F6E\u7528\u6237\u540D",
        primaryButton__updateUsername: "\u66F4\u6539\u7528\u6237\u540D",
        title: "\u7528\u6237\u540D"
      },
      web3WalletsSection: {
        destructiveAction: "\u79FB\u9664\u94B1\u5305",
        primaryButton: "Web3 \u94B1\u5305",
        title: "Web3 \u94B1\u5305"
      }
    },
    usernamePage: {
      successMessage: "\u60A8\u7684\u7528\u6237\u540D\u5DF2\u66F4\u65B0\u3002",
      title__set: "\u66F4\u65B0\u7528\u6237\u540D",
      title__update: "\u66F4\u65B0\u7528\u6237\u540D"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u5C06\u4ECE\u6B64\u8D26\u6237\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C06\u65E0\u6CD5\u4F7F\u7528\u8FD9\u4E2A web3 \u94B1\u5305\u767B\u5F55\u3002",
        successMessage: "{{web3Wallet}} \u5DF2\u4ECE\u60A8\u7684\u8D26\u6237\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664 web3 \u94B1\u5305"
      },
      subtitle__availableWallets: "\u9009\u62E9\u4E00\u4E2A web3 \u94B1\u5305\u8FDE\u63A5\u5230\u60A8\u7684\u8D26\u6237\u3002",
      subtitle__unavailableWallets: "\u6CA1\u6709\u53EF\u7528\u7684 web3 \u94B1\u5305\u3002",
      successMessage: "\u94B1\u5305\u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u3002",
      title: "\u6DFB\u52A0web3\u94B1\u5305",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/zh-TW.ts
var zhTW = {
  locale: "zh-TW",
  backButton: "\u8FD4\u56DE",
  badge__default: "\u9ED8\u8A8D",
  badge__otherImpersonatorDevice: "\u5176\u4ED6\u6A21\u64EC\u5668\u8A2D\u5099",
  badge__primary: "\u4E3B\u8981",
  badge__requiresAction: "\u9700\u8981\u64CD\u4F5C",
  badge__thisDevice: "\u6B64\u8A2D\u5099",
  badge__unverified: "\u672A\u9A57\u8B49",
  badge__userDevice: "\u7528\u6236\u8A2D\u5099",
  badge__you: "\u60A8",
  createOrganization: {
    formButtonSubmit: "\u5275\u5EFA\u7D44\u7E54",
    invitePage: {
      formButtonReset: "\u8DF3\u904E"
    },
    title: "\u5275\u5EFA\u7D44\u7E54"
  },
  dates: {
    lastDay: "\u6628\u5929{{ date | timeString('zh-TW') }}",
    next6Days: "{{ date | weekday('zh-TW','long') }} {{ date | timeString('zh-TW') }}",
    nextDay: "\u660E\u5929{{ date | timeString('zh-TW') }}",
    numeric: "{{ date | numeric('zh-TW') }}",
    previous6Days: "\u4E0A\u9031{{ date | weekday('zh-TW','long') }} {{ date | timeString('zh-TW') }}",
    sameDay: "\u4ECA\u5929{{ date | timeString('zh-TW') }}"
  },
  dividerText: "\u6216\u8005",
  footerActionLink__useAnotherMethod: "\u4F7F\u7528\u53E6\u4E00\u7A2E\u65B9\u6CD5",
  footerPageLink__help: "\u5E6B\u52A9",
  footerPageLink__privacy: "\u96B1\u79C1",
  footerPageLink__terms: "\u689D\u6B3E",
  formButtonPrimary: "\u7E7C\u7E8C",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "\u5FD8\u8A18\u5BC6\u78BC\uFF1F",
  formFieldError__matchingPasswords: "\u5BC6\u78BC\u5339\u914D\u3002",
  formFieldError__notMatchingPasswords: "\u5BC6\u78BC\u4E0D\u5339\u914D\u3002",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "\u9078\u586B",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "\u8F38\u5165\u6216\u9ECF\u8CBC\u4E00\u500B\u6216\u591A\u500B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF0C\u7528\u7A7A\u683C\u6216\u9017\u865F\u5206\u9694",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "\u5099\u7528\u4EE3\u78BC",
  formFieldLabel__confirmDeletion: "\u78BA\u5B9A",
  formFieldLabel__confirmPassword: "\u78BA\u8A8D\u5BC6\u78BC",
  formFieldLabel__currentPassword: "\u7576\u524D\u5BC6\u78BC",
  formFieldLabel__emailAddress: "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
  formFieldLabel__emailAddress_username: "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u6216\u4F7F\u7528\u8005\u540D\u7A31",
  formFieldLabel__emailAddresses: "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
  formFieldLabel__firstName: "\u540D\u5B57",
  formFieldLabel__lastName: "\u59D3\u6C0F",
  formFieldLabel__newPassword: "\u65B0\u5BC6\u78BC",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "\u7D44\u7E54\u540D\u7A31",
  formFieldLabel__organizationSlug: "URL \u7C21\u7A31",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u5BC6\u78BC",
  formFieldLabel__phoneNumber: "\u96FB\u8A71\u865F\u78BC",
  formFieldLabel__role: "\u89D2\u8272",
  formFieldLabel__signOutOfOtherSessions: "\u767B\u51FA\u6240\u6709\u5176\u4ED6\u8A2D\u5099",
  formFieldLabel__username: "\u4F7F\u7528\u8005\u540D\u7A31",
  impersonationFab: {
    action__signOut: "\u9000\u51FA\u767B\u9304",
    title: "\u4EE5 {{identifier}} \u767B\u9304"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\u7BA1\u7406\u54E1",
  membershipRole__basicMember: "\u6210\u54E1",
  membershipRole__guestMember: "\u8A2A\u5BA2",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u9080\u8ACB\u7121\u6CD5\u767C\u9001\u3002\u4FEE\u8986\u4EE5\u4E0B\u554F\u984C\u7136\u5F8C\u91CD\u8A66\uFF1A",
      formButtonPrimary__continue: "\u767C\u9001\u9080\u8ACB",
      selectDropdown__role: "Select role",
      subtitle: "\u9080\u8ACB\u65B0\u6210\u54E1\u52A0\u5165\u6B64\u7D44\u7E54",
      successMessage: "\u9080\u8ACB\u6210\u529F\u767C\u9001",
      title: "\u9080\u8ACB\u6210\u54E1"
    },
    membersPage: {
      action__invite: "\u9080\u8ACB",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u79FB\u9664\u6210\u54E1",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u52A0\u5165",
        tableHeader__role: "\u89D2\u8272",
        tableHeader__user: "\u7528\u6236"
      },
      detailsTitle__emptyRow: "\u6C92\u6709\u53EF\u986F\u793A\u7684\u6210\u54E1",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u64A4\u92B7\u9080\u8ACB",
        tableHeader__invited: "\u5DF2\u9080\u8ACB"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to delete this organization?",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have deleted the organization.",
          title: "Delete organization"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "\u60A8\u78BA\u5B9A\u8981\u96E2\u958B\u6B64\u7D44\u7E54\u55CE\uFF1F\u60A8\u5C07\u5931\u53BB\u5C0D\u6B64\u7D44\u7E54\u53CA\u5176\u61C9\u7528\u7A0B\u5F0F\u7684\u8A2A\u554F\u6B0A\u9650\u3002",
          messageLine2: "\u6B64\u64CD\u4F5C\u662F\u6C38\u4E45\u6027\u7684\u4E14\u7121\u6CD5\u64A4\u92B7\u3002",
          successMessage: "\u60A8\u5DF2\u96E2\u958B\u4E86\u7D44\u7E54\u3002",
          title: "\u96E2\u958B\u7D44\u7E54"
        },
        title: "\u5371\u96AA"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "\u7D44\u7E54\u5DF2\u66F4\u65B0\u3002",
      title: "\u7D44\u7E54\u7C21\u4ECB"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\u6210\u54E1",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u5275\u5EFA\u7D44\u7E54",
    action__invitationAccept: "Join",
    action__manageOrganization: "\u7BA1\u7406\u7D44\u7E54",
    action__suggestionsAccept: "Request to join",
    notSelected: "\u672A\u9078\u64C7\u7D44\u7E54",
    personalWorkspace: "\u500B\u4EBA\u5DE5\u4F5C\u5340",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "\u4E0B\u4E00\u9801",
  paginationButton__previous: "\u4E0A\u4E00\u9801",
  paginationRowText__displaying: "\u986F\u793A",
  paginationRowText__of: "\u7684",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "\u7372\u53D6\u5E6B\u52A9",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "\u4F7F\u7528\u5099\u7528\u4EE3\u78BC",
      blockButton__emailCode: "\u96FB\u5B50\u90F5\u4EF6\u9A57\u8B49\u78BC\u5230 {{identifier}}",
      blockButton__emailLink: "\u96FB\u5B50\u90F5\u4EF6\u9023\u7D50\u5230 {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "\u4F7F\u7528\u60A8\u7684\u5BC6\u78BC\u767B\u9304",
      blockButton__phoneCode: "\u767C\u9001\u7C21\u8A0A\u4EE3\u78BC\u5230 {{identifier}}",
      blockButton__totp: "\u4F7F\u7528\u60A8\u7684\u9A57\u8B49\u61C9\u7528\u7A0B\u5F0F",
      getHelp: {
        blockButton__emailSupport: "\u90F5\u4EF6\u652F\u6301",
        content: "\u5982\u679C\u60A8\u5728\u767B\u5165\u5E33\u6236\u6642\u9047\u5230\u56F0\u96E3\uFF0C\u8ACB\u7D66\u6211\u5011\u767C\u9001\u96FB\u5B50\u90F5\u4EF6\uFF0C\u6211\u5011\u5C07\u76E1\u5FEB\u8B93\u60A8\u6062\u8986\u8A2A\u554F\u3002",
        title: "\u7372\u53D6\u5E6B\u52A9"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "\u4F7F\u7528\u5176\u4ED6\u65B9\u6CD5"
    },
    backupCodeMfa: {
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u8F38\u5165\u5099\u7528\u4EE3\u78BC"
    },
    emailCode: {
      formTitle: "\u9A57\u8B49\u78BC",
      resendButton: "\u91CD\u65B0\u767C\u9001\u9A57\u8B49\u78BC",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u67E5\u770B\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\u8FD4\u56DE\u539F\u59CB\u6A19\u7C64\u9801\u7E7C\u7E8C\u3002",
        title: "\u6B64\u9A57\u8B49\u9023\u7D50\u5DF2\u904E\u671F"
      },
      failed: {
        subtitle: "\u8FD4\u56DE\u539F\u59CB\u6A19\u7C64\u9801\u7E7C\u7E8C\u3002",
        title: "\u6B64\u9A57\u8B49\u9023\u7D50\u7121\u6548"
      },
      formSubtitle: "\u4F7F\u7528\u767C\u9001\u5230\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u7684\u9A57\u8B49\u9023\u7D50",
      formTitle: "\u9A57\u8B49\u9023\u7D50",
      loading: {
        subtitle: "\u5373\u5C07\u70BA\u60A8\u91CD\u5B9A\u5411",
        title: "\u6B63\u5728\u767B\u9304..."
      },
      resendButton: "\u91CD\u65B0\u767C\u9001\u9023\u7D50",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u67E5\u770B\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6",
      unusedTab: {
        title: "\u60A8\u53EF\u4EE5\u95DC\u9589\u6B64\u6A19\u7C64\u9801"
      },
      verified: {
        subtitle: "\u5373\u5C07\u70BA\u60A8\u91CD\u5B9A\u5411",
        title: "\u6210\u529F\u767B\u9304"
      },
      verifiedSwitchTab: {
        subtitle: "\u8FD4\u56DE\u539F\u59CB\u6A19\u7C64\u9801\u7E7C\u7E8C",
        subtitleNewTab: "\u8FD4\u56DE\u65B0\u6253\u958B\u7684\u6A19\u7C64\u9801\u7E7C\u7E8C",
        titleNewTab: "\u5728\u5176\u4ED6\u6A19\u7C64\u9801\u4E0A\u767B\u5165"
      }
    },
    forgotPassword: {
      formTitle: "\u91CD\u8A2D\u5BC6\u78BC\u4EE3\u78BC",
      resendButton: "\u91CD\u65B0\u767C\u9001\u4EE3\u78BC",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u91CD\u8A2D\u5BC6\u78BC",
      label__alternativeMethods: "\u6216\u8005\uFF0C\u4F7F\u7528\u5176\u4ED6\u65B9\u5F0F\u767B\u9304\u3002",
      title: "\u5FD8\u8A18\u5BC6\u78BC\uFF1F"
    },
    noAvailableMethods: {
      message: "\u7121\u6CD5\u7E7C\u7E8C\u767B\u9304\u3002\u6C92\u6709\u53EF\u7528\u7684\u8EAB\u4EFD\u9A57\u8B49\u56E0\u7D20\u3002",
      subtitle: "\u51FA\u73FE\u932F\u8AA4",
      title: "\u7121\u6CD5\u767B\u9304"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\u4F7F\u7528\u5176\u4ED6\u65B9\u6CD5",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u8F38\u5165\u60A8\u7684\u5BC6\u78BC"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\u9A57\u8B49\u78BC",
      resendButton: "\u91CD\u65B0\u767C\u9001\u9A57\u8B49\u78BC",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u6AA2\u67E5\u624B\u6A5F\u7C21\u8A0A"
    },
    phoneCodeMfa: {
      formTitle: "\u9A57\u8B49\u78BC",
      resendButton: "\u91CD\u65B0\u767C\u9001\u9A57\u8B49\u78BC",
      subtitle: void 0,
      title: "\u6AA2\u67E5\u624B\u6A5F\u7C21\u8A0A"
    },
    resetPassword: {
      formButtonPrimary: "\u91CD\u8A2D\u5BC6\u78BC",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "\u60A8\u7684\u5BC6\u78BC\u5DF2\u6210\u529F\u66F4\u6539\u3002\u6B63\u5728\u70BA\u60A8\u767B\u9304\uFF0C\u8ACB\u7A0D\u7B49\u3002",
      title: "\u91CD\u8A2D\u5BC6\u78BC"
    },
    resetPasswordMfa: {
      detailsLabel: "\u6211\u5011\u9700\u8981\u9A57\u8B49\u60A8\u7684\u8EAB\u4EFD\u624D\u80FD\u91CD\u8A2D\u60A8\u7684\u5BC6\u78BC\u3002"
    },
    start: {
      actionLink: "\u8A3B\u518A",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6",
      actionLink__use_email_username: "\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u6216\u4F7F\u7528\u8005\u540D\u7A31",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "\u4F7F\u7528\u96FB\u8A71",
      actionLink__use_username: "\u4F7F\u7528\u4F7F\u7528\u8005\u540D\u7A31",
      actionText: "\u9084\u6C92\u6709\u5E33\u6236\uFF1F",
      actionText__join_waitlist: void 0,
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      subtitleCombined: void 0,
      title: "\u767B\u9304",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u9A57\u8B49\u78BC",
      subtitle: void 0,
      title: "\u5169\u6B65\u9A57\u8B49"
    }
  },
  signInEnterPasswordTitle: "\u8F38\u5165\u60A8\u7684\u5BC6\u78BC",
  signUp: {
    continue: {
      actionLink: "\u767B\u9304",
      actionText: "\u5DF2\u7D93\u6709\u5E33\u6236\u4E86\uFF1F",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u586B\u5BEB\u7F3A\u5C11\u7684\u6B04\u4F4D"
    },
    emailCode: {
      formSubtitle: "\u8F38\u5165\u767C\u9001\u5230\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7684\u9A57\u8B49\u78BC",
      formTitle: "\u9A57\u8B49\u78BC",
      resendButton: "\u91CD\u65B0\u767C\u9001\u9A57\u8B49\u78BC",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u9A57\u8B49\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\u4F7F\u7528\u767C\u9001\u5230\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7684\u9A57\u8B49\u9023\u7D50",
      formTitle: "\u9A57\u8B49\u9023\u7D50",
      loading: {
        title: "\u6B63\u5728\u8A3B\u518A..."
      },
      resendButton: "\u91CD\u65B0\u767C\u9001\u9023\u7D50",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u9A57\u8B49\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6",
      verified: {
        title: "\u6210\u529F\u8A3B\u518A"
      },
      verifiedSwitchTab: {
        subtitle: "\u8FD4\u56DE\u65B0\u6253\u958B\u7684\u6A19\u7C64\u9801\u7E7C\u7E8C",
        subtitleNewTab: "\u8FD4\u56DE\u4E0A\u4E00\u500B\u6A19\u7C64\u9801\u7E7C\u7E8C",
        title: "\u6210\u529F\u9A57\u8B49\u96FB\u5B50\u90F5\u4EF6"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: '\u6211\u540C\u610F {{ privacyPolicyLink || link("\u96B1\u79C1\u689D\u6B3E") }}',
        label__onlyTermsOfService: '\u6211\u540C\u610F {{ termsOfServiceLink || link("\u4F7F\u7528\u689D\u6B3E") }}',
        label__termsOfServiceAndPrivacyPolicy: '\u6211\u540C\u610F {{ termsOfServiceLink || link("\u4F7F\u7528\u689D\u6B3E") }} and {{ privacyPolicyLink || link("\u96B1\u79C1\u689D\u6B3E") }}'
      },
      continue: {
        subtitle: "\u8ACB\u95B1\u8B80\u4E26\u63A5\u53D7\u689D\u6B3E\u4EE5\u7E7C\u7E8C",
        title: "\u540C\u610F\u689D\u6B3E"
      }
    },
    phoneCode: {
      formSubtitle: "\u8F38\u5165\u767C\u9001\u5230\u60A8\u7684\u96FB\u8A71\u865F\u78BC\u7684\u9A57\u8B49\u78BC",
      formTitle: "\u9A57\u8B49\u78BC",
      resendButton: "\u91CD\u65B0\u767C\u9001\u9A57\u8B49\u78BC",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u9A57\u8B49\u60A8\u7684\u96FB\u8A71"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u767B\u9304",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u5DF2\u7D93\u6709\u5E33\u6236\u4E86\uFF1F",
      subtitle: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      subtitleCombined: "\u7E7C\u7E8C\u4F7F\u7528 {{applicationName}}",
      title: "\u5275\u5EFA\u60A8\u7684\u5E33\u6236",
      titleCombined: "\u5275\u5EFA\u60A8\u7684\u5E33\u6236"
    }
  },
  socialButtonsBlockButton: "\u4F7F\u7528 {{provider|titleize}} \u767B\u9304",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\u7531\u65BC\u5B89\u5168\u9A57\u8B49\u5931\u6557\uFF0C\u8A3B\u518A\u672A\u6210\u529F\u3002\u8ACB\u5237\u65B0\u9801\u9762\u91CD\u8A66\u6216\u806F\u7D61\u652F\u6301\u7372\u53D6\u66F4\u591A\u5E6B\u52A9\u3002",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Email address must be a valid email address.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u60A8\u7684\u5BC6\u78BC\u5F37\u5EA6\u4E0D\u5920\u3002",
    form_password_pwned: "\u9019\u500B\u5BC6\u78BC\u5728\u6578\u64DA\u6D29\u9732\u4E2D\u88AB\u767C\u73FE\uFF0C\u4E0D\u80FD\u4F7F\u7528\uFF0C\u8ACB\u63DB\u4E00\u500B\u5BC6\u78BC\u8A66\u8A66\u3002",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\u60A8\u7684\u5BC6\u78BC\u8D85\u904E\u4E86\u5141\u8A31\u7684\u6700\u5927\u4F4D\u5143\u7D44\u6578\uFF0C\u8ACB\u7E2E\u77ED\u5B83\u6216\u53BB\u6389\u4E00\u4E9B\u7279\u6B8A\u5B57\u5143\u3002",
    form_password_validation_failed: "\u5BC6\u78BC\u932F\u8AA4",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "\u5C11\u65BC{{length}}\u500B\u5B57\u5143",
      minimumLength: "{{length}}\u500B\u6216\u66F4\u591A\u5B57\u5143",
      requireLowercase: "\u4E00\u500B\u5C0F\u5BEB\u5B57\u6BCD",
      requireNumbers: "\u4E00\u500B\u6578\u5B57",
      requireSpecialCharacter: "\u4E00\u500B\u7279\u6B8A\u5B57\u5143",
      requireUppercase: "\u4E00\u500B\u5927\u5BEB\u5B57\u6BCD",
      sentencePrefix: "\u60A8\u7684\u5BC6\u78BC\u5FC5\u9808\u5305\u542B"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u60A8\u7684\u5BC6\u78BC\u53EF\u4EE5\u7528\uFF0C\u4F46\u53EF\u4EE5\u66F4\u5F37\u3002\u8A66\u8457\u6DFB\u52A0\u66F4\u591A\u5B57\u5143\u3002",
      goodPassword: "\u505A\u5F97\u597D\u3002\u9019\u662F\u4E00\u500B\u512A\u79C0\u7684\u5BC6\u78BC\u3002",
      notEnough: "\u60A8\u7684\u5BC6\u78BC\u5F37\u5EA6\u4E0D\u5920\u3002",
      suggestions: {
        allUppercase: "\u5927\u5BEB\u4E00\u4E9B\uFF0C\u4F46\u4E0D\u662F\u6240\u6709\u7684\u5B57\u6BCD\u3002",
        anotherWord: "\u6DFB\u52A0\u66F4\u4E0D\u5E38\u898B\u7684\u66F4\u591A\u55AE\u5B57\u3002",
        associatedYears: "\u907F\u514D\u8207\u4F60\u6709\u95DC\u7684\u5E74\u4EFD\u3002",
        capitalization: "\u5927\u5BEB\u4E0D\u50C5\u50C5\u662F\u7B2C\u4E00\u500B\u5B57\u6BCD\u3002",
        dates: "\u907F\u514D\u8207\u4F60\u6709\u95DC\u7684\u65E5\u671F\u548C\u5E74\u4EFD\u3002",
        l33t: '\u907F\u514D\u9810\u6E2C\u7684\u5B57\u6BCD\u66FF\u63DB\uFF0C\u5982"@"\u4EE3\u66FF"a"\u3002',
        longerKeyboardPattern: "\u4F7F\u7528\u66F4\u9577\u7684\u9375\u76E4\u6A21\u5F0F\uFF0C\u4E26\u591A\u6B21\u6539\u8B8A\u6253\u5B57\u65B9\u5411\u3002",
        noNeed: "\u4F60\u53EF\u4EE5\u5275\u5EFA\u5F37\u5BC6\u78BC\uFF0C\u800C\u7121\u9700\u4F7F\u7528\u7B26\u865F\uFF0C\u6578\u5B57\u6216\u5927\u5BEB\u5B57\u6BCD\u3002",
        pwned: "\u5982\u679C\u60A8\u5728\u5176\u4ED6\u5730\u65B9\u4F7F\u7528\u6B64\u5BC6\u78BC\uFF0C\u60A8\u61C9\u8A72\u66F4\u6539\u5B83\u3002",
        recentYears: "\u907F\u514D\u8FD1\u5E74\u4F86\u3002",
        repeated: "\u907F\u514D\u91CD\u8907\u7684\u55AE\u5B57\u548C\u5B57\u5143\u3002",
        reverseWords: "\u907F\u514D\u5E38\u7528\u8A5E\u7684\u53CD\u5411\u62FC\u5BEB\u3002",
        sequences: "\u907F\u514D\u5E38\u898B\u5B57\u5143\u5E8F\u5217\u3002",
        useWords: "\u4F7F\u7528\u591A\u500B\u55AE\u5B57\uFF0C\u4F46\u907F\u514D\u5E38\u898B\u77ED\u8A9E\u3002"
      },
      warnings: {
        common: "\u9019\u662F\u4E00\u500B\u5E38\u7528\u7684\u5BC6\u78BC\u3002",
        commonNames: "\u5E38\u898B\u7684\u540D\u5B57\u548C\u59D3\u6C0F\u6613\u88AB\u731C\u5230\u3002",
        dates: "\u65E5\u671F\u6613\u88AB\u731C\u5230\u3002",
        extendedRepeat: '\u50CF"abcabcabc"\u9019\u6A23\u7684\u91CD\u8907\u5B57\u5143\u6A21\u5F0F\u6613\u88AB\u731C\u5230\u3002',
        keyPattern: "\u77ED\u9375\u76E4\u6A21\u5F0F\u6613\u88AB\u731C\u5230\u3002",
        namesByThemselves: "\u55AE\u500B\u540D\u5B57\u6216\u59D3\u6C0F\u6613\u88AB\u731C\u5230\u3002",
        pwned: "\u60A8\u7684\u5BC6\u78BC\u5728\u7DB2\u8DEF\u4E0A\u7684\u6578\u64DA\u6D29\u9732\u4E2D\u88AB\u66B4\u9732\u3002",
        recentYears: "\u8FD1\u5E74\u4F86\u6613\u88AB\u731C\u5230\u3002",
        sequences: '\u50CF"abc"\u9019\u6A23\u7684\u5E38\u898B\u5B57\u5143\u5E8F\u5217\u6613\u88AB\u731C\u5230\u3002',
        similarToCommon: "\u9019\u500B\u5BC6\u78BC\u548C\u5E38\u7528\u5BC6\u78BC\u76F8\u4F3C\u3002",
        simpleRepeat: '\u50CF"aaa"\u9019\u6A23\u7684\u91CD\u8907\u5B57\u5143\u6613\u88AB\u731C\u5230\u3002',
        straightRow: "\u9375\u76E4\u4E0A\u7684\u76F4\u884C\u9375\u6613\u88AB\u731C\u5230\u3002",
        topHundred: "\u9019\u662F\u4E00\u500B\u983B\u7E41\u4F7F\u7528\u7684\u5BC6\u78BC\u3002",
        topTen: "\u9019\u662F\u4E00\u500B\u5927\u91CF\u4F7F\u7528\u7684\u5BC6\u78BC\u3002",
        userInputs: "\u4E0D\u61C9\u8A72\u6709\u4EFB\u4F55\u500B\u4EBA\u6216\u9801\u9762\u76F8\u95DC\u7684\u6578\u64DA\u3002",
        wordByItself: "\u55AE\u500B\u55AE\u5B57\u6613\u88AB\u731C\u5230\u3002"
      }
    }
  },
  userButton: {
    action__addAccount: "\u6DFB\u52A0\u5E33\u6236",
    action__manageAccount: "\u7BA1\u7406\u5E33\u6236",
    action__signOut: "\u9000\u51FA\u767B\u9304",
    action__signOutAll: "\u9000\u51FA\u6240\u6709\u5E33\u6236"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u5DF2\u8907\u88FD\uFF01",
      actionLabel__copy: "\u8907\u88FD\u5168\u90E8",
      actionLabel__download: "\u4E0B\u8F09 .txt",
      actionLabel__print: "\u5217\u5370",
      infoText1: "\u5C07\u70BA\u6B64\u5E33\u6236\u555F\u7528\u5099\u4EFD\u4EE3\u78BC\u3002",
      infoText2: "\u4FDD\u5BC6\u4E26\u5B89\u5168\u5132\u5B58\u5099\u4EFD\u4EE3\u78BC\u3002\u5982\u679C\u60A8\u61F7\u7591\u5B83\u5011\u5DF2\u7D93\u6D29\u9732\uFF0C\u60A8\u53EF\u4EE5\u91CD\u65B0\u751F\u6210\u5099\u4EFD\u4EE3\u78BC\u3002",
      subtitle__codelist: "\u5B89\u5168\u5132\u5B58\u4E26\u4FDD\u5B88\u79D8\u5BC6\u3002",
      successMessage: "\u73FE\u5728\u5DF2\u555F\u7528\u5099\u4EFD\u4EE3\u78BC\u3002\u5982\u679C\u60A8\u5931\u53BB\u4E86\u9A57\u8B49\u8A2D\u5099\u7684\u8A2A\u554F\u6B0A\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u5176\u4E2D\u4E4B\u4E00\u767B\u5165\u60A8\u7684\u5E33\u6236\u3002\u6BCF\u500B\u4EE3\u78BC\u53EA\u80FD\u4F7F\u7528\u4E00\u6B21\u3002",
      successSubtitle: "\u5982\u679C\u60A8\u5931\u53BB\u4E86\u9A57\u8B49\u8A2D\u5099\u7684\u8A2A\u554F\u6B0A\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u5176\u4E2D\u4E4B\u4E00\u767B\u5165\u60A8\u7684\u5E33\u6236\u3002",
      title: "\u6DFB\u52A0\u5099\u4EFD\u4EE3\u78BC\u9A57\u8B49",
      title__codelist: "\u5099\u4EFD\u4EE3\u78BC"
    },
    connectedAccountPage: {
      formHint: "\u9078\u64C7\u4E00\u500B\u4F9B\u61C9\u5546\u4F86\u9023\u63A5\u60A8\u7684\u5E33\u6236\u3002",
      formHint__noAccounts: "\u6C92\u6709\u53EF\u7528\u7684\u5916\u90E8\u5E33\u6236\u4F9B\u61C9\u5546\u3002",
      removeResource: {
        messageLine1: "{{identifier}} \u5C07\u5F9E\u6B64\u5E33\u6236\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C07\u7121\u6CD5\u518D\u4F7F\u7528\u9019\u500B\u5DF2\u9023\u63A5\u7684\u5E33\u6236\uFF0C\u4EFB\u4F55\u4F9D\u8CF4\u7684\u529F\u80FD\u5C07\u4E0D\u518D\u5DE5\u4F5C\u3002",
        successMessage: "{{connectedAccount}} \u5DF2\u5F9E\u60A8\u7684\u5E33\u6236\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664\u5DF2\u9023\u63A5\u7684\u5E33\u6236"
      },
      socialButtonsBlockButton: "\u9023\u63A5 {{provider|titleize}} \u5E33\u6236",
      successMessage: "\u4F9B\u61C9\u5546\u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u5E33\u6236",
      title: "\u6DFB\u52A0\u5DF2\u9023\u63A5\u7684\u5E33\u6236"
    },
    deletePage: {
      actionDescription: "\u8ACB\u5728\u4E0B\u65B9\u8F38\u5165\u201CDelete account\u201D\u4EE5\u7E7C\u7E8C\u3002",
      confirm: "\u79FB\u9664\u5E33\u6236",
      messageLine1: "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u60A8\u7684\u5E33\u6236\u55CE\uFF1F",
      messageLine2: "\u9019\u500B\u52D5\u4F5C\u662F\u6C38\u4E45\u6027\u4E14\u7121\u6CD5\u9084\u539F\u7684\u3002",
      title: "\u79FB\u9664\u5E33\u6236"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u4E00\u5C01\u542B\u6709\u9A57\u8B49\u78BC\u7684\u90F5\u4EF6\u5C07\u6703\u88AB\u767C\u9001\u5230\u9019\u500B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002",
        formSubtitle: "\u8F38\u5165\u767C\u9001\u5230 {{identifier}} \u7684\u9A57\u8B49\u78BC",
        formTitle: "\u9A57\u8B49\u78BC",
        resendButton: "\u91CD\u767C\u9A57\u8B49\u78BC",
        successMessage: "\u96FB\u5B50\u90F5\u4EF6 {{identifier}} \u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u5E33\u6236\u3002"
      },
      emailLink: {
        formHint: "\u4E00\u5C01\u542B\u6709\u9A57\u8B49\u9023\u7D50\u7684\u90F5\u4EF6\u5C07\u6703\u88AB\u767C\u9001\u5230\u9019\u500B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002",
        formSubtitle: "\u9EDE\u64CA\u767C\u9001\u5230 {{identifier}} \u7684\u90F5\u4EF6\u4E2D\u7684\u9A57\u8B49\u9023\u7D50",
        formTitle: "\u9A57\u8B49\u9023\u7D50",
        resendButton: "\u91CD\u767C\u9023\u7D50",
        successMessage: "\u96FB\u5B50\u90F5\u4EF6 {{identifier}} \u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u5E33\u6236\u3002"
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u5C07\u5F9E\u6B64\u5E33\u6236\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C07\u7121\u6CD5\u4F7F\u7528\u9019\u500B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u767B\u9304\u3002",
        successMessage: "\u96FB\u5B50\u90F5\u4EF6 {{emailAddress}} \u5DF2\u5F9E\u60A8\u7684\u5E33\u6236\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664\u96FB\u5B50\u90F5\u4EF6\u5730\u5740"
      },
      title: "\u6DFB\u52A0\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "\u7E7C\u7E8C",
    formButtonPrimary__finish: "\u5B8C\u6210",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "\u53D6\u6D88",
    mfaPage: {
      formHint: "\u9078\u64C7\u4E00\u500B\u6DFB\u52A0\u7684\u65B9\u6CD5\u3002",
      title: "\u6DFB\u52A0\u5169\u6B65\u9A57\u8B49"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "\u6DFB\u52A0\u96FB\u8A71\u865F\u78BC",
      removeResource: {
        messageLine1: "{{identifier}} \u5C07\u4E0D\u518D\u5728\u767B\u9304\u6642\u63A5\u6536\u9A57\u8B49\u4EE3\u78BC\u3002",
        messageLine2: "\u60A8\u7684\u5E33\u6236\u53EF\u80FD\u4E0D\u518D\u5B89\u5168\u3002\u60A8\u78BA\u5B9A\u8981\u7E7C\u7E8C\u55CE\uFF1F",
        successMessage: "\u5DF2\u79FB\u9664{{mfaPhoneCode}}\u7684\u7C21\u8A0A\u9A57\u8B49\u78BC\u5169\u6B65\u9A57\u8B49",
        title: "\u79FB\u9664\u5169\u6B65\u9A57\u8B49"
      },
      subtitle__availablePhoneNumbers: "\u9078\u64C7\u4E00\u500B\u96FB\u8A71\u865F\u78BC\u4F86\u8A3B\u518A\u7C21\u8A0A\u9A57\u8B49\u78BC\u5169\u6B65\u9A57\u8B49\u3002",
      subtitle__unavailablePhoneNumbers: "\u6C92\u6709\u53EF\u7528\u7684\u96FB\u8A71\u865F\u78BC\u4F86\u8A3B\u518A\u7C21\u8A0A\u9A57\u8B49\u78BC\u5169\u6B65\u9A57\u8B49\u3002",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "\u6DFB\u52A0\u7C21\u8A0A\u9A57\u8B49\u78BC\u9A57\u8B49"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u6383\u63CF\u4E8C\u7DAD\u78BC",
        buttonUnableToScan__nonPrimary: "\u4E0D\u80FD\u6383\u63CF\u4E8C\u7DAD\u78BC\uFF1F",
        infoText__ableToScan: "\u5728\u60A8\u7684\u9A57\u8B49\u5668\u61C9\u7528\u4E2D\u8A2D\u7F6E\u4E00\u500B\u65B0\u7684\u767B\u9304\u65B9\u6CD5\uFF0C\u4E26\u6383\u63CF\u4E0B\u9762\u7684\u4E8C\u7DAD\u78BC\u5C07\u5176\u9023\u7D50\u5230\u60A8\u7684\u5E33\u6236\u3002",
        infoText__unableToScan: "\u5728\u9A57\u8B49\u5668\u4E2D\u8A2D\u7F6E\u4E00\u500B\u65B0\u7684\u767B\u9304\u65B9\u6CD5\uFF0C\u4E26\u8F38\u5165\u4E0B\u9762\u63D0\u4F9B\u7684 Key\u3002",
        inputLabel__unableToScan1: "\u78BA\u4FDD\u555F\u7528\u4E86\u57FA\u65BC\u6642\u9593\u6216\u4E00\u6B21\u6027\u5BC6\u78BC\uFF0C\u7136\u5F8C\u5B8C\u6210\u9023\u7D50\u60A8\u7684\u5E33\u6236\u3002",
        inputLabel__unableToScan2: "\u6216\u8005\uFF0C\u5982\u679C\u60A8\u7684\u9A57\u8B49\u5668\u652F\u6301 TOTP URIs\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u8907\u88FD\u5B8C\u6574\u7684 URI\u3002"
      },
      removeResource: {
        messageLine1: "\u767B\u9304\u6642\uFF0C\u5C07\u4E0D\u518D\u9700\u8981\u4F86\u81EA\u6B64\u9A57\u8B49\u5668\u7684\u9A57\u8B49\u78BC\u3002",
        messageLine2: "\u60A8\u7684\u5E33\u6236\u53EF\u80FD\u4E0D\u518D\u5B89\u5168\u3002\u60A8\u78BA\u5B9A\u8981\u7E7C\u7E8C\u55CE\uFF1F",
        successMessage: "\u5DF2\u79FB\u9664\u901A\u904E\u9A57\u8B49\u5668\u61C9\u7528\u7A0B\u5F0F\u7684\u5169\u6B65\u9A57\u8B49\u3002",
        title: "\u79FB\u9664\u5169\u6B65\u9A57\u8B49"
      },
      successMessage: "\u73FE\u5728\u5DF2\u555F\u7528\u5169\u6B65\u9A57\u8B49\u3002\u5728\u767B\u9304\u6642\uFF0C\u60A8\u9700\u8981\u8F38\u5165\u4F86\u81EA\u6B64\u9A57\u8B49\u5668\u7684\u9A57\u8B49\u78BC\u4F5C\u70BA\u984D\u5916\u6B65\u9A5F\u3002",
      title: "\u6DFB\u52A0\u9A57\u8B49\u5668\u61C9\u7528\u7A0B\u5F0F",
      verifySubtitle: "\u8F38\u5165\u60A8\u7684\u9A57\u8B49\u5668\u751F\u6210\u7684\u9A57\u8B49\u78BC",
      verifyTitle: "\u9A57\u8B49\u4EE3\u78BC"
    },
    mobileButton__menu: "\u83DC\u55AE",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "\u60A8\u7684\u5BC6\u78BC\u5DF2\u8A2D\u7F6E\u3002",
      successMessage__signOutOfOtherSessions: "\u6240\u6709\u5176\u4ED6\u8A2D\u5099\u5DF2\u9000\u51FA\u3002",
      successMessage__update: "\u60A8\u7684\u5BC6\u78BC\u5DF2\u66F4\u65B0\u3002",
      title__set: "\u8A2D\u7F6E\u5BC6\u78BC",
      title__update: "\u66F4\u6539\u5BC6\u78BC"
    },
    phoneNumberPage: {
      infoText: "\u4E00\u689D\u5305\u542B\u9A57\u8B49\u9023\u7D50\u7684\u7C21\u8A0A\u5C07\u6703\u767C\u9001\u5230\u9019\u500B\u96FB\u8A71\u865F\u78BC\u3002",
      removeResource: {
        messageLine1: "{{identifier}} \u5C07\u5F9E\u6B64\u5E33\u6236\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C07\u7121\u6CD5\u4F7F\u7528\u9019\u500B\u96FB\u8A71\u865F\u78BC\u767B\u9304\u3002",
        successMessage: "\u96FB\u8A71\u865F\u78BC {{phoneNumber}} \u5DF2\u5F9E\u60A8\u7684\u5E33\u6236\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664\u96FB\u8A71\u865F\u78BC"
      },
      successMessage: "{{identifier}} \u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u5E33\u6236\u3002",
      title: "\u6DFB\u52A0\u96FB\u8A71\u865F\u78BC",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "\u4E0A\u50B3\u5C0F\u65BC10MB\u7684JPG, PNG, GIF, \u6216WEBP\u683C\u5F0F\u7684\u5716\u7247",
      imageFormDestructiveActionSubtitle: "\u79FB\u9664\u5716\u7247",
      imageFormSubtitle: "\u4E0A\u50B3\u5716\u7247",
      imageFormTitle: "\u500B\u4EBA\u8CC7\u6599\u5716\u7247",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "\u60A8\u7684\u500B\u4EBA\u8CC7\u6599\u5DF2\u66F4\u65B0\u3002",
      title: "\u66F4\u65B0\u500B\u4EBA\u8CC7\u6599"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u9000\u51FA\u8A2D\u5099",
        title: "\u6D3B\u52D5\u8A2D\u5099"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u518D\u8A66\u4E00\u6B21",
        actionLabel__reauthorize: "\u7ACB\u5373\u6388\u6B0A",
        destructiveActionTitle: "\u79FB\u9664",
        primaryButton: "\u9023\u63A5\u5E33\u6236",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "\u5DF2\u9023\u63A5\u7684\u5E33\u6236"
      },
      dangerSection: {
        deleteAccountButton: "\u79FB\u9664\u5E33\u6236",
        title: "\u5371\u96AA"
      },
      emailAddressesSection: {
        destructiveAction: "\u79FB\u9664\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
        detailsAction__nonPrimary: "\u8A2D\u70BA\u4E3B\u8981",
        detailsAction__primary: "\u5B8C\u6210\u9A57\u8B49",
        detailsAction__unverified: "\u5B8C\u6210\u9A57\u8B49",
        primaryButton: "\u6DFB\u52A0\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
        title: "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740"
      },
      enterpriseAccountsSection: {
        title: "\u4F01\u696D\u5E33\u6236"
      },
      headerTitle__account: "\u5E33\u6236",
      headerTitle__security: "\u5B89\u5168",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u91CD\u65B0\u751F\u6210\u4EE3\u78BC",
          headerTitle: "\u5099\u4EFD\u4EE3\u78BC",
          subtitle__regenerate: "\u7372\u53D6\u4E00\u5957\u65B0\u7684\u5B89\u5168\u5099\u4EFD\u4EE3\u78BC\u3002\u4E4B\u524D\u7684\u5099\u4EFD\u4EE3\u78BC\u5C07\u88AB\u522A\u9664\uFF0C\u7121\u6CD5\u4F7F\u7528\u3002",
          title__regenerate: "\u91CD\u65B0\u751F\u6210\u5099\u4EFD\u4EE3\u78BC"
        },
        phoneCode: {
          actionLabel__setDefault: "\u8A2D\u70BA\u9ED8\u8A8D",
          destructiveActionLabel: "\u79FB\u9664\u96FB\u8A71\u865F\u78BC"
        },
        primaryButton: "\u6DFB\u52A0\u5169\u6B65\u9A57\u8B49",
        title: "\u5169\u6B65\u9A57\u8B49",
        totp: {
          destructiveActionTitle: "\u79FB\u9664",
          headerTitle: "\u9A57\u8B49\u5668\u61C9\u7528\u7A0B\u5F0F"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u8A2D\u7F6E\u5BC6\u78BC",
        primaryButton__updatePassword: "\u66F4\u6539\u5BC6\u78BC",
        title: "\u5BC6\u78BC"
      },
      phoneNumbersSection: {
        destructiveAction: "\u79FB\u9664\u96FB\u8A71\u865F\u78BC",
        detailsAction__nonPrimary: "\u8A2D\u70BA\u4E3B\u8981",
        detailsAction__primary: "\u5B8C\u6210\u9A57\u8B49",
        detailsAction__unverified: "\u5B8C\u6210\u9A57\u8B49",
        primaryButton: "\u6DFB\u52A0\u96FB\u8A71\u865F\u78BC",
        title: "\u96FB\u8A71\u865F\u78BC"
      },
      profileSection: {
        primaryButton: "\u66F4\u65B0\u500B\u4EBA\u8CC7\u6599",
        title: "\u500B\u4EBA\u8CC7\u6599"
      },
      usernameSection: {
        primaryButton__setUsername: "\u8A2D\u7F6E\u4F7F\u7528\u8005\u540D\u7A31",
        primaryButton__updateUsername: "\u66F4\u6539\u4F7F\u7528\u8005\u540D\u7A31",
        title: "\u4F7F\u7528\u8005\u540D\u7A31"
      },
      web3WalletsSection: {
        destructiveAction: "\u79FB\u9664\u9322\u5305",
        primaryButton: "Web3 \u9322\u5305",
        title: "Web3 \u9322\u5305"
      }
    },
    usernamePage: {
      successMessage: "\u60A8\u7684\u4F7F\u7528\u8005\u540D\u7A31\u5DF2\u66F4\u65B0\u3002",
      title__set: "\u66F4\u65B0\u4F7F\u7528\u8005\u540D\u7A31",
      title__update: "\u66F4\u65B0\u4F7F\u7528\u8005\u540D\u7A31"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u5C07\u5F9E\u6B64\u5E33\u6236\u4E2D\u88AB\u79FB\u9664\u3002",
        messageLine2: "\u60A8\u5C07\u7121\u6CD5\u4F7F\u7528\u9019\u500B web3 \u9322\u5305\u767B\u9304\u3002",
        successMessage: "{{web3Wallet}} \u5DF2\u5F9E\u60A8\u7684\u5E33\u6236\u4E2D\u79FB\u9664\u3002",
        title: "\u79FB\u9664 web3 \u9322\u5305"
      },
      subtitle__availableWallets: "\u9078\u64C7\u4E00\u500B web3 \u9322\u5305\u9023\u63A5\u5230\u60A8\u7684\u5E33\u6236\u3002",
      subtitle__unavailableWallets: "\u6C92\u6709\u53EF\u7528\u7684 web3 \u9322\u5305\u3002",
      successMessage: "\u9322\u5305\u5DF2\u88AB\u6DFB\u52A0\u5230\u60A8\u7684\u5E33\u6236\u3002",
      title: "\u6DFB\u52A0web3\u9322\u5305",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/ko-KR.ts
var koKR = {
  locale: "ko-KR",
  backButton: "\uB3CC\uC544\uAC00\uAE30",
  badge__default: "\uAE30\uBCF8\uAC12",
  badge__otherImpersonatorDevice: "\uAE30\uD0C0 \uC0AC\uCE6D \uC7A5\uCE58",
  badge__primary: "\uAE30\uBCF8",
  badge__requiresAction: "\uC870\uCE58 \uD544\uC694",
  badge__thisDevice: "\uC774 \uC7A5\uCE58",
  badge__unverified: "\uBBF8\uD655\uC778",
  badge__userDevice: "\uC0AC\uC6A9\uC790 \uC7A5\uCE58",
  badge__you: "\uB2F9\uC2E0",
  createOrganization: {
    formButtonSubmit: "\uC870\uC9C1 \uB9CC\uB4E4\uAE30",
    invitePage: {
      formButtonReset: "\uB118\uAE30\uAE30"
    },
    title: "\uC870\uC9C1 \uB9CC\uB4E4\uAE30"
  },
  dates: {
    lastDay: "\uC5B4\uC81C {{ date | timeString('ko-KR') }}",
    next6Days: "\uB2E4\uC74C {{ date | weekday('ko-KR','long') }} {{ date | timeString('ko-KR') }}",
    nextDay: "\uB0B4\uC77C {{ date | timeString('ko-KR') }}",
    numeric: "{{ date | numeric('ko-KR') }}",
    previous6Days: "\uC9C0\uB09C {{ date | weekday('ko-KR','long') }} {{ date | timeString('ko-KR') }}",
    sameDay: "\uC624\uB298 {{ date | timeString('ko-KR') }}"
  },
  dividerText: "\uB610\uB294",
  footerActionLink__useAnotherMethod: "\uB2E4\uB978 \uBC29\uBC95 \uC0AC\uC6A9\uD558\uAE30",
  footerPageLink__help: "\uB3C4\uC6C0",
  footerPageLink__privacy: "\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68",
  footerPageLink__terms: "\uC57D\uAD00",
  formButtonPrimary: "\uACC4\uC18D",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
  formFieldError__matchingPasswords: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD569\uB2C8\uB2E4.",
  formFieldError__notMatchingPasswords: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "\uC120\uD0DD\uC0AC\uD56D",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\uACC4\uC815 \uC0AD\uC81C",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "\uD558\uB098 \uC774\uC0C1\uC758 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uACF5\uBC31 \uB610\uB294 \uC27C\uD45C\uB85C \uAD6C\uBD84\uD558\uC5EC \uC785\uB825\uD558\uAC70\uB098 \uBD99\uC5EC\uB123\uC2B5\uB2C8\uB2E4",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "\uBC31\uC5C5 \uCF54\uB4DC",
  formFieldLabel__confirmDeletion: "\uD655\uC778",
  formFieldLabel__confirmPassword: "\uBE44\uBC00\uBC88\uD638 \uD655\uC778",
  formFieldLabel__currentPassword: "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638",
  formFieldLabel__emailAddress: "\uC774\uBA54\uC77C \uC8FC\uC18C",
  formFieldLabel__emailAddress_username: "\uC774\uBA54\uC77C \uC8FC\uC18C \uD639\uC740 \uC0AC\uC6A9\uC790 \uC774\uB984",
  formFieldLabel__emailAddresses: "\uC774\uBA54\uC77C \uC8FC\uC18C",
  formFieldLabel__firstName: "\uC774\uB984",
  formFieldLabel__lastName: "\uC131",
  formFieldLabel__newPassword: "\uC0C8 \uBE44\uBC00\uBC88\uD638",
  formFieldLabel__organizationDomain: "\uB3C4\uBA54\uC778",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "\uC774\uB984",
  formFieldLabel__organizationSlug: "\uC2AC\uB7EC\uADF8",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\uBE44\uBC00\uBC88\uD638",
  formFieldLabel__phoneNumber: "\uD734\uB300\uD3F0 \uBC88\uD638",
  formFieldLabel__role: "\uC5ED\uD560",
  formFieldLabel__signOutOfOtherSessions: "\uB2E4\uB978 \uBAA8\uB4E0 \uAE30\uAE30\uC5D0\uC11C \uB85C\uADF8\uC544\uC6C3",
  formFieldLabel__username: "\uC0AC\uC6A9\uC790 \uC774\uB984",
  impersonationFab: {
    action__signOut: "\uB85C\uADF8\uC544\uC6C3",
    title: "{{identifier}}\uB85C \uB85C\uADF8\uC778\uD588\uC2B5\uB2C8\uB2E4"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\uAD00\uB9AC\uC790",
  membershipRole__basicMember: "\uBA64\uBC84",
  membershipRole__guestMember: "\uAC8C\uC2A4\uD2B8",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\uCD08\uB300\uB97C \uBCF4\uB0BC \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uB2E4\uC74C\uC744 \uC218\uC815\uD558\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694:",
      formButtonPrimary__continue: "\uCD08\uB300 \uBCF4\uB0B4\uAE30",
      selectDropdown__role: "Select role",
      subtitle: "\uC774 \uC870\uC9C1\uC5D0 \uC0C8 \uBA64\uBC84 \uCD08\uB300",
      successMessage: "\uCD08\uB300\uAC00 \uC131\uACF5\uC801\uC73C\uB85C \uC804\uC1A1\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      title: "\uD68C\uC6D0 \uCD08\uB300"
    },
    membersPage: {
      action__invite: "\uCD08\uB300",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\uD68C\uC6D0 \uC81C\uAC70",
        tableHeader__actions: void 0,
        tableHeader__joined: "\uAC00\uC785\uB428",
        tableHeader__role: "\uC5ED\uD560",
        tableHeader__user: "\uC0AC\uC6A9\uC790"
      },
      detailsTitle__emptyRow: "\uD45C\uC2DC\uD560 \uBA64\uBC84 \uC5C6\uC74C",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "\uCD08\uB300 \uCDE8\uC18C",
        tableHeader__invited: "\uCD08\uB300\uB428"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "\uACC4\uC18D\uD558\uB824\uBA74 \uC544\uB798\uC5D0 {{organizationName}}\uC744(\uB97C) \uC785\uB825\uD558\uC138\uC694.",
          messageLine1: "\uC774 \uC870\uC9C1\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
          messageLine2: "\uC774 \uC791\uC5C5\uC740 \uC601\uAD6C\uC801\uC774\uBA70 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
          successMessage: "\uC870\uC9C1\uC744 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.",
          title: "\uC870\uC9C1 \uC0AD\uC81C"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "\uC774 \uC870\uC9C1\uC744 \uD0C8\uD1F4\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? \uC774 \uC870\uC9C1 \uBC0F \uD574\uB2F9 \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC783\uAC8C\uB429\uB2C8\uB2E4.",
          messageLine2: "\uC774 \uC791\uC5C5\uC740 \uC601\uAD6C\uC801\uC774\uBA70 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
          successMessage: "\uC870\uC9C1\uC744 \uD0C8\uD1F4\uD588\uC2B5\uB2C8\uB2E4.",
          title: "\uC870\uC9C1 \uB5A0\uB098\uAE30"
        },
        title: "\uC704\uD5D8"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "\uB3C4\uBA54\uC778 \uCD94\uAC00",
        subtitle: "\uC778\uC99D\uB41C \uC774\uBA54\uC77C \uB3C4\uBA54\uC778\uC744 \uAE30\uBC18\uC73C\uB85C \uC0AC\uC6A9\uC790\uAC00 \uC870\uC9C1\uC5D0 \uC790\uB3D9\uC73C\uB85C \uAC00\uC785\uD558\uAC70\uB098 \uAC00\uC785 \uC694\uCCAD\uC744 \uD560 \uC218 \uC788\uAC8C \uD569\uB2C8\uB2E4.",
        title: "\uC778\uC99D\uB41C \uB3C4\uBA54\uC778"
      },
      successMessage: "\uC870\uC9C1\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      title: "\uC870\uC9C1 \uD504\uB85C\uD544"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\uBA64\uBC84",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\uC870\uC9C1 \uB9CC\uB4E4\uAE30",
    action__invitationAccept: "Join",
    action__manageOrganization: "\uC870\uC9C1 \uAD00\uB9AC",
    action__suggestionsAccept: "Request to join",
    notSelected: "\uC120\uD0DD\uD55C \uC870\uC9C1 \uC5C6\uC74C",
    personalWorkspace: "\uAC1C\uC778 \uC6CC\uD06C\uC2A4\uD398\uC774\uC2A4",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "\uB2E4\uC74C",
  paginationButton__previous: "\uC774\uC804",
  paginationRowText__displaying: "\uD45C\uC2DC\uC911",
  paginationRowText__of: "\uC758",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "\uB3C4\uC6C0 \uC694\uCCAD\uD558\uAE30",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "\uBC31\uC5C5 \uCF54\uB4DC \uC0AC\uC6A9\uD558\uAE30",
      blockButton__emailCode: "{{identifier}}\uB85C \uC774\uBA54\uC77C \uCF54\uB4DC \uBCF4\uB0B4\uAE30",
      blockButton__emailLink: "{{identifier}}\uB85C \uC774\uBA54\uC77C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
      blockButton__passkey: void 0,
      blockButton__password: "\uBE44\uBC00\uBC88\uD638\uB85C \uB85C\uADF8\uC778",
      blockButton__phoneCode: "{{identifier}}\uB85C SMS \uCF54\uB4DC \uBCF4\uB0B4\uAE30",
      blockButton__totp: "\uC778\uC99D \uC571 \uC0AC\uC6A9\uD558\uAE30",
      getHelp: {
        blockButton__emailSupport: "\uC774\uBA54\uC77C \uC9C0\uC6D0",
        content: "\uACC4\uC815\uC5D0 \uB85C\uADF8\uC778\uD558\uB294 \uB370 \uBB38\uC81C\uAC00 \uC788\uB294 \uACBD\uC6B0 \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uC8FC\uC2DC\uBA74 \uCD5C\uB300\uD55C \uBE68\uB9AC \uC561\uC138\uC2A4\uB97C \uBCF5\uAD6C\uD574 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",
        title: "\uB3C4\uC6C0 \uC694\uCCAD\uD558\uAE30"
      },
      subtitle: "\uBB38\uC81C\uAC00 \uC788\uB098\uC694? \uB2E4\uB978 \uBC29\uBC95\uC73C\uB85C \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
      title: "\uB2E4\uB978 \uBC29\uBC95 \uC0AC\uC6A9\uD558\uAE30"
    },
    backupCodeMfa: {
      subtitle: "\uBC31\uC5C5\uCF54\uB4DC\uB294 2\uB2E8\uACC4 \uC778\uC99D\uC744 \uC124\uC815\uD560 \uB54C \uC5BB\uC740 \uCF54\uB4DC\uC785\uB2C8\uB2E4",
      title: "\uBC31\uC5C5 \uCF54\uB4DC \uC785\uB825"
    },
    emailCode: {
      formTitle: "\uC778\uC99D \uCF54\uB4DC",
      resendButton: "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
      subtitle: "{{applicationName}}\uB85C \uACC4\uC18D\uD558\uB824\uBA74",
      title: "\uC774\uBA54\uC77C\uC744 \uD655\uC778\uD558\uC138\uC694"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uC6D0\uB798 \uD0ED\uC73C\uB85C \uB3CC\uC544\uAC00\uC138\uC694.",
        title: "\uC774 \uC778\uC99D \uB9C1\uD06C\uB294 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4"
      },
      failed: {
        subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uC6D0\uB798 \uD0ED\uC73C\uB85C \uB3CC\uC544\uAC00\uC138\uC694.",
        title: "\uC774 \uC778\uC99D \uB9C1\uD06C\uB294 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4"
      },
      formSubtitle: "\uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uB9C1\uD06C\uB97C \uC0AC\uC6A9\uD558\uC138\uC694",
      formTitle: "\uC778\uC99D \uB9C1\uD06C",
      loading: {
        subtitle: "\uACE7 \uB9AC\uB2E4\uC774\uB809\uC158 \uB429\uB2C8\uB2E4",
        title: "\uB85C\uADF8\uC778 \uC911..."
      },
      resendButton: "\uB9C1\uD06C \uC7AC\uC804\uC1A1",
      subtitle: "{{applicationName}}\uB85C \uACC4\uC18D\uD558\uB824\uBA74",
      title: "\uC774\uBA54\uC77C\uC744 \uD655\uC778\uD558\uC138\uC694",
      unusedTab: {
        title: "\uC774 \uD0ED\uC744 \uB2EB\uC73C\uC154\uB3C4 \uB429\uB2C8\uB2E4"
      },
      verified: {
        subtitle: "\uACE7 \uB9AC\uB2E4\uC774\uB809\uC158 \uB420 \uC608\uC815\uC785\uB2C8\uB2E4",
        title: "\uB85C\uADF8\uC778\uC5D0 \uC131\uACF5\uD588\uC2B5\uB2C8\uB2E4"
      },
      verifiedSwitchTab: {
        subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uC6D0\uB798 \uD0ED\uC73C\uB85C \uB3CC\uC544\uAC00\uC138\uC694",
        subtitleNewTab: "\uACC4\uC18D\uD558\uB824\uBA74 \uC0C8\uB85C \uC5F0 \uD0ED\uC73C\uB85C \uB3CC\uC544\uAC00\uC138\uC694",
        titleNewTab: "\uB2E4\uB978 \uD0ED\uC5D0\uC11C \uB85C\uADF8\uC778"
      }
    },
    forgotPassword: {
      formTitle: "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uCF54\uB4DC",
      resendButton: "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
      subtitle: "to reset your password",
      subtitle_email: "\uBA3C\uC800 \uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uB41C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      subtitle_phone: "\uBA3C\uC800 \uD734\uB300\uD3F0\uC73C\uB85C \uC804\uC1A1\uB41C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      title: "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
      label__alternativeMethods: "\uB610\uB294 \uB2E4\uB978 \uBC29\uBC95\uC73C\uB85C \uB85C\uADF8\uC778",
      title: "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?"
    },
    noAvailableMethods: {
      message: "\uB85C\uADF8\uC778\uC744 \uACC4\uC18D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC778\uC99D \uBC29\uBC95\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
      subtitle: "\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
      title: "\uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\uB2E4\uB978 \uBC29\uBC95 \uC0AC\uC6A9\uD558\uAE30",
      subtitle: "\uACC4\uC815\uC5D0 \uB4F1\uB85D\uB41C \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694",
      title: "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\uC778\uC99D \uCF54\uB4DC",
      resendButton: "\uCF54\uB4DC \uB2E4\uC2DC \uBCF4\uB0B4\uAE30",
      subtitle: "{{applicationName}}\uB85C \uACC4\uC18D\uD558\uB824\uBA74",
      title: "\uD734\uB300\uD3F0 \uD655\uC778"
    },
    phoneCodeMfa: {
      formTitle: "\uC778\uC99D \uCF54\uB4DC",
      resendButton: "\uCF54\uB4DC \uB2E4\uC2DC \uBCF4\uB0B4\uAE30",
      subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uD734\uB300\uD3F0\uC73C\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      title: "\uD734\uB300\uD3F0 \uD655\uC778"
    },
    resetPassword: {
      formButtonPrimary: "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC131\uACF5\uC801\uC73C\uB85C \uBCC0\uACBD\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB294 \uC911\uC785\uB2C8\uB2E4. \uC7A0\uC2DC\uB9CC \uAE30\uB2E4\uB824\uC8FC\uC138\uC694.",
      title: "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815"
    },
    resetPasswordMfa: {
      detailsLabel: "\uBE44\uBC00\uBC88\uD638\uB97C \uC7AC\uC124\uC815\uD558\uAE30 \uC804\uC5D0 \uC2E0\uC6D0\uC744 \uD655\uC778\uD574\uC57C \uD569\uB2C8\uB2E4."
    },
    start: {
      actionLink: "\uD68C\uC6D0\uAC00\uC785",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\uC774\uBA54\uC77C \uC0AC\uC6A9\uD558\uAE30",
      actionLink__use_email_username: "\uC774\uBA54\uC77C \uB610\uB294 \uC0AC\uC6A9\uC790 \uC774\uB984 \uC0AC\uC6A9\uD558\uAE30",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "\uD734\uB300\uD3F0 \uBC88\uD638 \uC0AC\uC6A9\uD558\uAE30",
      actionLink__use_username: "\uC0AC\uC6A9\uC790 \uC774\uB984 \uC0AC\uC6A9\uD558\uAE30",
      actionText: "\uACC4\uC815\uC774 \uC5C6\uC73C\uC2E0\uAC00\uC694?",
      actionText__join_waitlist: void 0,
      subtitle: "\uD658\uC601\uD569\uB2C8\uB2E4! \uACC4\uC18D\uD558\uB824\uBA74 \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694",
      subtitleCombined: void 0,
      title: "{{applicationName}}\uC5D0 \uB85C\uADF8\uC778",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\uC778\uC99D \uCF54\uB4DC",
      subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uC778\uC99D \uC571\uC5D0\uC11C \uC0DD\uC131\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      title: "2\uB2E8\uACC4 \uC778\uC99D"
    }
  },
  signInEnterPasswordTitle: "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694",
  signUp: {
    continue: {
      actionLink: "\uB85C\uADF8\uC778",
      actionText: "\uACC4\uC815\uC774 \uC788\uC73C\uC2E0\uAC00\uC694?",
      subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uB204\uB77D\uB41C \uD544\uB4DC\uC5D0 \uAC12\uC744 \uC785\uB825\uD558\uC138\uC694",
      title: "\uB204\uB77D\uB41C \uD544\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694"
    },
    emailCode: {
      formSubtitle: "\uC774\uBA54\uC77C \uC8FC\uC18C\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      formTitle: "\uC778\uC99D \uCF54\uB4DC",
      resendButton: "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
      subtitle: "\uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      title: "\uC774\uBA54\uC77C \uC778\uC99D"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\uC774\uBA54\uC77C \uC8FC\uC18C\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uB9C1\uD06C\uB97C \uC0AC\uC6A9\uD569\uB2C8\uB2E4.",
      formTitle: "\uC778\uC99D \uB9C1\uD06C",
      loading: {
        title: "\uAC00\uC785 \uC911..."
      },
      resendButton: "\uB9C1\uD06C \uC7AC\uC804\uC1A1",
      subtitle: "{{applicationName}}\uB85C \uACC4\uC18D\uD558\uB824\uBA74",
      title: "\uC774\uBA54\uC77C \uC778\uC99D\uD558\uAE30",
      verified: {
        title: "\uC131\uACF5\uC801\uC73C\uB85C \uAC00\uC785\uC5D0 \uC131\uACF5\uD588\uC2B5\uB2C8\uB2E4"
      },
      verifiedSwitchTab: {
        subtitle: "\uACC4\uC18D\uD558\uB824\uBA74 \uC0C8\uB85C \uC5F0 \uD0ED\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
        subtitleNewTab: "\uACC4\uC18D\uD558\uB824\uBA74 \uC774\uC804 \uD0ED\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
        title: "\uC774\uBA54\uC77C \uC778\uC99D \uC131\uACF5"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\uD734\uB300\uD3F0 \uBC88\uD638\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694.",
      formTitle: "\uC778\uC99D \uCF54\uB4DC",
      resendButton: "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
      subtitle: "\uD734\uB300\uD3F0\uC73C\uB85C \uC804\uC1A1\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
      title: "\uD734\uB300\uD3F0 \uBC88\uD638 \uC778\uC99D"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\uB85C\uADF8\uC778\uD558\uAE30",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\uACC4\uC815\uC774 \uC788\uC73C\uC2E0\uAC00\uC694?",
      subtitle: "\uD658\uC601\uD569\uB2C8\uB2E4! \uC544\uB798 \uC815\uBCF4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
      subtitleCombined: "\uD658\uC601\uD569\uB2C8\uB2E4! \uC544\uB798 \uC815\uBCF4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
      title: "\uACC4\uC815 \uB9CC\uB4E4\uAE30",
      titleCombined: "\uACC4\uC815 \uB9CC\uB4E4\uAE30"
    }
  },
  socialButtonsBlockButton: "{{provider|titleize}}\uB85C \uACC4\uC18D\uD558\uAE30",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Sign up unsuccessful due to failed security validations. Please refresh the page to try again or reach out to support for more assistance.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Email address must be a valid email address.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\uBE44\uBC00\uBC88\uD638\uAC00 \uCDA9\uBD84\uD788 \uC548\uC804\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    form_password_pwned: "\uC774 \uBE44\uBC00\uBC88\uD638\uB294 \uC720\uCD9C\uC0AC\uD56D\uC774 \uBC1C\uACAC\uB418\uC5B4 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC73C\uBBC0\uB85C \uB300\uC2E0 \uB2E4\uB978 \uBE44\uBC00\uBC88\uD638\uB97C \uC0AC\uC6A9\uD574 \uBCF4\uC138\uC694.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\uBE44\uBC00\uBC88\uD638\uAC00 \uD5C8\uC6A9\uB418\uB294 \uCD5C\uB300 \uBC14\uC774\uD2B8 \uC218\uB97C \uCD08\uACFC\uD588\uC2B5\uB2C8\uB2E4. \uBE44\uBC00\uBC88\uD638\uB97C \uC904\uC774\uAC70\uB098 \uC77C\uBD80 \uD2B9\uC218 \uBB38\uC790\uB97C \uC81C\uAC70\uD574 \uC8FC\uC138\uC694.",
    form_password_validation_failed: "\uC798\uBABB\uB41C \uBE44\uBC00\uBC88\uD638",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "{{length}} \uBCF4\uB2E4 \uC9E7\uC740 \uBB38\uC790\uC5F4",
      minimumLength: "{{length}} \uB610\uB294 \uADF8 \uC774\uC0C1\uC758 \uBB38\uC790\uC5F4",
      requireLowercase: "\uC18C\uBB38\uC790",
      requireNumbers: "\uC22B\uC790",
      requireSpecialCharacter: "\uD2B9\uC218\uBB38\uC790",
      requireUppercase: "\uB300\uBB38\uC790",
      sentencePrefix: "\uB2F9\uC2E0\uC758 \uBE44\uBC00\uBC88\uD638\uB294 \uBC18\uB4DC\uC2DC \uD3EC\uD568\uD574\uC57C\uD569\uB2C8\uB2E4"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\uBE44\uBC00\uBC88\uD638\uB294 \uC791\uB3D9\uD558\uC9C0\uB9CC \uB354 \uAC15\uB825\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uBB38\uC790\uB97C \uB354 \uCD94\uAC00\uD574 \uBCF4\uC138\uC694.",
      goodPassword: "\uC218\uACE0\uD558\uC168\uC2B5\uB2C8\uB2E4. \uD6CC\uB96D\uD55C \uBE44\uBC00\uBC88\uD638\uC785\uB2C8\uB2E4.",
      notEnough: "\uBE44\uBC00\uBC88\uD638\uAC00 \uCDA9\uBD84\uD788 \uC548\uC804\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
      suggestions: {
        allUppercase: "\uBAA8\uB4E0 \uBB38\uC790\uAC00 \uC544\uB2CC \uC77C\uBD80 \uBB38\uC790\uB97C \uB300\uBB38\uC790\uB85C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
        anotherWord: "\uB35C \uC77C\uBC18\uC801\uC778 \uB2E8\uC5B4\uB97C \uB354 \uCD94\uAC00\uD569\uB2C8\uB2E4.",
        associatedYears: "\uADC0\uD558\uC640 \uC5F0\uAD00\uB41C \uC5F0\uB3C4\uB294 \uD53C\uD558\uC138\uC694.",
        capitalization: "\uD55C \uAE00\uC790 \uC774\uC0C1\uC744 \uB300\uBB38\uC790\uB85C \uD45C\uAE30\uD558\uC138\uC694.",
        dates: "\uC790\uC2E0\uACFC \uAD00\uB828\uB41C \uB0A0\uC9DC\uC640 \uC5F0\uB3C4\uB294 \uD53C\uD558\uC138\uC694.",
        l33t: "'a'\uC5D0\uC11C '@'\uC640 \uAC19\uC774 \uC608\uCE21 \uAC00\uB2A5\uD55C \uBB38\uC790 \uB300\uCCB4\uB97C \uD53C\uD558\uC138\uC694.",
        longerKeyboardPattern: "\uB354 \uAE34 \uD0A4\uBCF4\uB4DC \uD328\uD134\uC744 \uC0AC\uC6A9\uD558\uACE0 \uD0C0\uC774\uD551 \uBC29\uD5A5\uC744 \uC5EC\uB7EC \uBC88 \uBCC0\uACBD\uD569\uB2C8\uB2E4.",
        noNeed: "\uAE30\uD638, \uC22B\uC790 \uB610\uB294 \uB300\uBB38\uC790\uB97C \uC0AC\uC6A9\uD558\uC9C0 \uC54A\uACE0\uB3C4 \uAC15\uB825\uD55C \uBE44\uBC00\uBC88\uD638\uB97C \uB9CC\uB4E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        pwned: "\uC774 \uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uB978 \uACF3\uC5D0\uC11C \uC0AC\uC6A9\uD558\uB294 \uACBD\uC6B0 \uBCC0\uACBD\uD574\uC57C \uD569\uB2C8\uB2E4.",
        recentYears: "\uCD5C\uADFC \uC5F0\uB3C4\uB294 \uD53C\uD558\uC138\uC694.",
        repeated: "\uBC18\uBCF5\uB418\uB294 \uB2E8\uC5B4\uC640 \uBB38\uC790\uB97C \uD53C\uD558\uC138\uC694.",
        reverseWords: "\uC77C\uBC18\uC801\uC778 \uB2E8\uC5B4\uC758 \uCCA0\uC790\uB97C \uAC70\uAFB8\uB85C \uC4F0\uC9C0 \uB9C8\uC138\uC694.",
        sequences: "\uC77C\uBC18\uC801\uC778 \uBB38\uC790 \uC2DC\uD000\uC2A4\uB97C \uD53C\uD558\uC138\uC694.",
        useWords: "\uC5EC\uB7EC \uB2E8\uC5B4\uB97C \uC0AC\uC6A9\uD558\uB418 \uC77C\uBC18\uC801\uC778 \uBB38\uAD6C\uB294 \uD53C\uD558\uC138\uC694."
      },
      warnings: {
        common: "\uC77C\uBC18\uC801\uC73C\uB85C \uC0AC\uC6A9\uB418\uB294 \uBE44\uBC00\uBC88\uD638\uC785\uB2C8\uB2E4.",
        commonNames: "\uC77C\uBC18\uC801\uC778 \uC774\uB984\uACFC \uC131\uC740 \uCD94\uCE21\uD558\uAE30 \uC27D\uC2B5\uB2C8\uB2E4.",
        dates: "\uB0A0\uC9DC\uB294 \uC27D\uAC8C \uCD94\uCE21\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        extendedRepeat: '"abcabcabc"\uC640 \uAC19\uC774 \uBC18\uBCF5\uB418\uB294 \uBB38\uC790 \uD328\uD134\uC740 \uC27D\uAC8C \uCD94\uCE21\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        keyPattern: "\uC9E7\uC740 \uD328\uD134\uC740 \uCD94\uCE21\uD558\uAE30 \uC27D\uC2B5\uB2C8\uB2E4.",
        namesByThemselves: "\uB2E8\uC77C \uC774\uB984\uC774\uB098 \uC131\uC740 \uCD94\uCE21\uD558\uAE30 \uC27D\uC2B5\uB2C8\uB2E4.",
        pwned: "\uC778\uD130\uB137\uC5D0\uC11C \uB370\uC774\uD130 \uC720\uCD9C\uB85C \uC778\uD574 \uBE44\uBC00\uBC88\uD638\uAC00 \uB178\uCD9C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
        recentYears: "\uCD5C\uADFC\uC5F0\uB3C4\uB294 \uC27D\uAC8C \uCD94\uCE21\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        sequences: '"abc"\uC640 \uAC19\uC740 \uC77C\uBC18\uC801\uC778 \uBB38\uC790 \uC2DC\uD000\uC2A4\uB294 \uC27D\uAC8C \uCD94\uCE21\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        similarToCommon: "\uC77C\uBC18\uC801\uC73C\uB85C \uC0AC\uC6A9\uB418\uB294 \uBE44\uBC00\uBC88\uD638\uC640 \uC720\uC0AC\uD569\uB2C8\uB2E4.",
        simpleRepeat: '"aaa"\uC640 \uAC19\uC774 \uBC18\uBCF5\uB418\uB294 \uBB38\uC790\uB294 \uC27D\uAC8C \uCD94\uCE21\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        straightRow: "\uAC19\uC740 \uC904\uC5D0 \uC704\uCE58\uD55C \uD0A4\uBCF4\uB4DC\uB97C \uC0AC\uC6A9\uD558\uB294 \uAC83\uC740 \uCD94\uCE21\uD558\uAE30 \uC27D\uC2B5\uB2C8\uB2E4.",
        topHundred: "\uC790\uC8FC \uC0AC\uC6A9\uB418\uB294 \uBE44\uBC00\uBC88\uD638\uC785\uB2C8\uB2E4.",
        topTen: "\uC544\uC8FC \uB9CE\uC774 \uC0AC\uC6A9\uB418\uB294 \uBE44\uBC00\uBC88\uD638\uC785\uB2C8\uB2E4.",
        userInputs: "\uAC1C\uC778 \uC815\uBCF4\uB098 \uD398\uC774\uC9C0 \uAD00\uB828 \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC57C \uD569\uB2C8\uB2E4.",
        wordByItself: "\uD55C \uB2E8\uC5B4\uB294 \uC27D\uAC8C \uCD94\uCE21\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
      }
    }
  },
  userButton: {
    action__addAccount: "\uACC4\uC815 \uCD94\uAC00",
    action__manageAccount: "\uACC4\uC815 \uAD00\uB9AC",
    action__signOut: "\uB85C\uADF8\uC544\uC6C3",
    action__signOutAll: "\uBAA8\uB4E0 \uACC4\uC815\uC5D0\uC11C \uB85C\uADF8\uC544\uC6C3"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\uBCF5\uC0AC \uC644\uB8CC!",
      actionLabel__copy: "\uC804\uCCB4 \uBCF5\uC0AC",
      actionLabel__download: ".txt \uB2E4\uC6B4\uB85C\uB4DC",
      actionLabel__print: "\uC778\uC1C4",
      infoText1: "\uC774 \uACC4\uC815\uC5D0 \uB300\uD574 \uBC31\uC5C5 \uCF54\uB4DC\uAC00 \uD65C\uC131\uD654\uB429\uB2C8\uB2E4.",
      infoText2: "\uBC31\uC5C5 \uCF54\uB4DC\uB97C \uBE44\uBC00\uB85C \uC720\uC9C0\uD558\uACE0 \uC548\uC804\uD558\uAC8C \uBCF4\uAD00\uD558\uC138\uC694. \uBC31\uC5C5 \uCF54\uB4DC\uAC00 \uC190\uC0C1\uB41C \uAC83\uC73C\uB85C \uC758\uC2EC\uB418\uB294 \uACBD\uC6B0 \uBC31\uC5C5 \uCF54\uB4DC\uB97C \uB2E4\uC2DC \uC0DD\uC131\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
      subtitle__codelist: "\uC548\uC804\uD558\uAC8C \uC800\uC7A5\uD558\uACE0 \uBE44\uBC00\uB85C \uC720\uC9C0\uD558\uC138\uC694.",
      successMessage: "\uC774\uC81C \uBC31\uC5C5 \uCF54\uB4DC\uAC00 \uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC778\uC99D \uC7A5\uCE58\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC5C6\uB294 \uACBD\uC6B0 \uC774 \uC911 \uD558\uB098\uB97C \uC0AC\uC6A9\uD558\uC5EC \uACC4\uC815\uC5D0 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uAC01 \uCF54\uB4DC\uB294 \uD55C \uBC88\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
      successSubtitle: "\uC778\uC99D \uC7A5\uCE58\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC5C6\uB294 \uACBD\uC6B0 \uC774 \uC911 \uD558\uB098\uB97C \uC0AC\uC6A9\uD558\uC5EC \uACC4\uC815\uC5D0 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
      title: "\uBC31\uC5C5 \uCF54\uB4DC \uC778\uC99D \uCD94\uAC00",
      title__codelist: "\uBC31\uC5C5 \uCF54\uB4DC"
    },
    connectedAccountPage: {
      formHint: "\uACC4\uC815\uC744 \uC5F0\uACB0\uD560 \uC81C\uACF5\uC790\uB97C \uC120\uD0DD\uD558\uC138\uC694",
      formHint__noAccounts: "\uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC678\uBD80 \uACC4\uC815 \uC81C\uACF5\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      removeResource: {
        messageLine1: "{{identifier}}\uAC00 \uC774 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70 \uB420 \uC608\uC815\uC785\uB2C8\uB2E4.",
        messageLine2: "\uC774 \uC5F0\uACB0\uB41C \uACC4\uC815\uC744 \uB354 \uC774\uC0C1 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC73C\uBA70 \uC885\uC18D\uB41C \uBAA8\uB4E0 \uAE30\uB2A5\uC774 \uB354 \uC774\uC0C1 \uC791\uB3D9\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        successMessage: "{{connectedAccount}}\uAC00 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
        title: "\uC5F0\uACB0\uB41C \uACC4\uC815 \uC81C\uAC70"
      },
      socialButtonsBlockButton: "{{provider|titleize}} \uACC4\uC815 \uC5F0\uACB0",
      successMessage: "\uC774 \uC81C\uACF5\uC790\uAC00 \uACC4\uC815\uC5D0 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      title: "\uC5F0\uACB0\uB41C \uACC4\uC815 \uCD94\uAC00\uD558\uAE30"
    },
    deletePage: {
      actionDescription: "\uACC4\uC18D\uD558\uB824\uBA74 \uC544\uB798\uC5D0 \uACC4\uC815 \uC0AD\uC81C\uB97C \uC785\uB825\uD558\uC138\uC694.",
      confirm: "\uACC4\uC815 \uC0AD\uC81C",
      messageLine1: "\uC815\uB9D0\uB85C \uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
      messageLine2: "\uC774 \uC791\uC5C5\uC740 \uC601\uAD6C\uC801\uC774\uBA70 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
      title: "\uACC4\uC815 \uC0AD\uC81C"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\uC774 \uC774\uBA54\uC77C \uC8FC\uC18C\uB85C \uC778\uC99D \uCF54\uB4DC\uAC00 \uD3EC\uD568\uB41C \uC774\uBA54\uC77C\uC774 \uC804\uC1A1\uB429\uB2C8\uB2E4.",
        formSubtitle: "{{identifier}}\uC5D0\uAC8C \uC804\uC1A1\uB41C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD569\uB2C8\uB2E4",
        formTitle: "\uC778\uC99D \uCF54\uB4DC",
        resendButton: "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
        successMessage: "{{identifier}} \uC774\uBA54\uC77C\uC774 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      },
      emailLink: {
        formHint: "\uC778\uC99D \uB9C1\uD06C\uAC00 \uD3EC\uD568\uB41C \uC774\uBA54\uC77C\uC774 \uC774 \uC774\uBA54\uC77C \uC8FC\uC18C\uB85C \uC804\uC1A1\uB429\uB2C8\uB2E4.",
        formSubtitle: "{{identifier}}\uC5D0\uAC8C \uC804\uC1A1\uB41C \uC774\uBA54\uC77C\uC758 \uB9C1\uD06C\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4.",
        formTitle: "\uC778\uC99D \uB9C1\uD06C",
        resendButton: "\uB9C1\uD06C \uC7AC\uC804\uC1A1",
        successMessage: "{{identifier}} \uC774\uBA54\uC77C\uC774 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \uC774\uBA54\uC77C\uC774 \uC774 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70 \uB420 \uC5D0\uC815\uC785\uB2C8\uB2E4.",
        messageLine2: "\uB354 \uC774\uC0C1 \uC774 \uC774\uBA54\uC77C \uC8FC\uC18C\uB85C \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
        successMessage: "{{emailAddress}} \uC774\uBA54\uC77C\uC774 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0\uC11C \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
        title: "\uC774\uBA54\uC77C \uC81C\uAC70"
      },
      title: "\uC774\uBA54\uC77C \uC8FC\uC18C \uCD94\uAC00",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "\uACC4\uC18D",
    formButtonPrimary__finish: "\uC644\uB8CC",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "\uCDE8\uC18C",
    mfaPage: {
      formHint: "\uCD94\uAC00\uD560 \uBC29\uBC95\uC744 \uC120\uD0DD\uD569\uB2C8\uB2E4.",
      title: "2\uB2E8\uACC4 \uC778\uC99D \uCD94\uAC00"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "\uD734\uB300\uD3F0 \uBC88\uD638 \uCD94\uAC00",
      removeResource: {
        messageLine1: "{{identifier}}\uB294 \uB85C\uADF8\uC778\uD560 \uB54C \uB354 \uC774\uC0C1 \uC778\uC99D \uCF54\uB4DC\uB97C \uBC1B\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        messageLine2: "\uACC4\uC815\uC774 \uC548\uC804\uD558\uC9C0 \uC54A\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uACC4\uC18D\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
        successMessage: "{{mfaPhoneCode}}\uC5D0 \uB300\uD55C SMS \uCF54\uB4DC 2\uB2E8\uACC4 \uC778\uC99D\uC774 \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
        title: "2\uB2E8\uACC4 \uC778\uC99D \uC81C\uAC70"
      },
      subtitle__availablePhoneNumbers: "SMS \uCF54\uB4DC 2\uB2E8\uACC4 \uC778\uC99D\uC744 \uC704\uD574 \uB4F1\uB85D\uD560 \uD734\uB300\uD3F0 \uBC88\uD638\uB97C \uC120\uD0DD\uD558\uC138\uC694.",
      subtitle__unavailablePhoneNumbers: "SMS \uCF54\uB4DC 2\uB2E8\uACC4 \uC778\uC99D\uC5D0 \uB4F1\uB85D\uD560 \uC218 \uC788\uB294 \uD734\uB300\uD3F0 \uBC88\uD638\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "SMS \uCF54\uB4DC \uC778\uC99D \uCD94\uAC00"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\uB300\uC2E0 QR \uCF54\uB4DC \uC2A4\uCE94 \uD558\uC138\uC694",
        buttonUnableToScan__nonPrimary: "QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD560 \uC218 \uC5C6\uB098\uC694?",
        infoText__ableToScan: "\uC778\uC99D \uC571\uC5D0\uC11C \uC0C8 \uB85C\uADF8\uC778 \uBC29\uBC95\uC744 \uC124\uC815\uD558\uACE0 \uB2E4\uC74C QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uACC4\uC815\uC5D0 \uC5F0\uACB0\uD569\uB2C8\uB2E4.",
        infoText__unableToScan: "\uC778\uC99D \uC7A5\uCE58\uC5D0\uC11C \uC0C8 \uB85C\uADF8\uC778 \uBC29\uBC95\uC744 \uC124\uC815\uD558\uACE0 \uC544\uB798\uC5D0 \uC81C\uACF5\uB41C \uD0A4\uB97C \uC785\uB825\uD569\uB2C8\uB2E4.",
        inputLabel__unableToScan1: "\uC2DC\uAC04 \uAE30\uBC18 \uB610\uB294 \uC77C\uD68C\uC6A9 \uBE44\uBC00\uBC88\uD638\uAC00 \uC0AC\uC6A9 \uC124\uC815\uB418\uC5B4 \uC788\uB294\uC9C0 \uD655\uC778\uD55C \uB2E4\uC74C \uACC4\uC815 \uC5F0\uACB0\uC744 \uC644\uB8CC\uD569\uB2C8\uB2E4.",
        inputLabel__unableToScan2: "\uB610\uB294 \uC778\uC99D\uC790\uAC00 TOTP URI\uB97C \uC9C0\uC6D0\uD558\uB294 \uACBD\uC6B0 \uC804\uCCB4 URI\uB97C \uBCF5\uC0AC\uD560 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4."
      },
      removeResource: {
        messageLine1: "\uB85C\uADF8\uC778\uD560 \uB54C \uB354 \uC774\uC0C1 \uC774 \uC778\uC99D\uC790\uC758 \uC778\uC99D \uCF54\uB4DC\uAC00 \uD544\uC694\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        messageLine2: "\uACC4\uC815\uC774 \uC548\uC804\uD558\uC9C0 \uC54A\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uACC4\uC18D \uC9C4\uD589\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
        successMessage: "\uC778\uC99D\uC790 \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC744 \uD1B5\uD55C 2\uB2E8\uACC4 \uC778\uC99D\uC774 \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
        title: "2\uB2E8\uACC4 \uC778\uC99D \uC81C\uAC70"
      },
      successMessage: "\uC774\uC81C 2\uB2E8\uACC4 \uC778\uC99D\uC774 \uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD560 \uB54C \uCD94\uAC00 \uB2E8\uACC4\uB85C \uC774 \uC778\uC99D\uC790\uC758 \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD574\uC57C \uD569\uB2C8\uB2E4.",
      title: "\uC778\uC99D \uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uCD94\uAC00",
      verifySubtitle: "\uC778\uC99D\uC790\uAC00 \uC0DD\uC131\uD55C \uC778\uC99D \uCF54\uB4DC\uB97C \uC785\uB825\uD569\uB2C8\uB2E4",
      verifyTitle: "\uC778\uC99D \uCF54\uB4DC"
    },
    mobileButton__menu: "\uBA54\uB274",
    navbar: {
      account: "\uD504\uB85C\uD544",
      description: "\uACC4\uC815 \uC815\uBCF4\uB97C \uAD00\uB9AC\uD558\uC138\uC694.",
      security: "\uBCF4\uC548",
      title: "\uACC4\uC815"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC124\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      successMessage__signOutOfOtherSessions: "\uB2E4\uB978 \uBAA8\uB4E0 \uAE30\uAE30\uB294 \uB85C\uADF8\uC544\uC6C3\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      successMessage__update: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      title__set: "\uBE44\uBC00\uBC88\uD638 \uC124\uC815",
      title__update: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD"
    },
    phoneNumberPage: {
      infoText: "\uC778\uC99D \uB9C1\uD06C\uAC00 \uD3EC\uD568\uB41C \uBB38\uC790 \uBA54\uC2DC\uC9C0\uAC00 \uC774 \uD734\uB300\uD3F0 \uBC88\uD638\uB85C \uC804\uC1A1\uB429\uB2C8\uB2E4.",
      removeResource: {
        messageLine1: "{{identifier}}\uAC00 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70 \uB420 \uC608\uC815\uC785\uB2C8\uB2E4.",
        messageLine2: "\uB354 \uC774\uC0C1 \uC774 \uD734\uB300\uD3F0 \uBC88\uD638\uB85C \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
        successMessage: "{{phoneNumber}}\uAC00 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
        title: "\uD734\uB300\uD3F0 \uBC88\uD638 \uC81C\uAC70"
      },
      successMessage: "{{identifier}}\uAC00 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      title: "\uD734\uB300\uD3F0 \uBC88\uD638 \uCD94\uAC00",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "10MB\uBCF4\uB2E4 \uC791\uC740 JPG, PNG, GIF \uB610\uB294 WEBP \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD569\uB2C8\uB2E4",
      imageFormDestructiveActionSubtitle: "\uC774\uBBF8\uC9C0 \uC81C\uAC70",
      imageFormSubtitle: "\uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC",
      imageFormTitle: "\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "\uD504\uB85C\uD544\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      title: "\uD504\uB85C\uD544 \uC5C5\uB370\uC774\uD2B8"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\uC774 \uC7A5\uCE58\uC5D0\uC11C \uB85C\uADF8\uC544\uC6C3",
        title: "\uD65C\uC131\uD654\uB41C \uC7A5\uCE58"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\uC7AC\uC2DC\uB3C4",
        actionLabel__reauthorize: "\uC9C0\uAE08 \uC778\uC99D\uD558\uAE30",
        destructiveActionTitle: "\uC81C\uAC70",
        primaryButton: "\uACC4\uC815 \uC5F0\uACB0\uD558\uAE30",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "\uC5F0\uACB0\uB41C \uACC4\uC815"
      },
      dangerSection: {
        deleteAccountButton: "\uACC4\uC815 \uC0AD\uC81C",
        title: "\uC704\uD5D8"
      },
      emailAddressesSection: {
        destructiveAction: "\uC774\uBA54\uC77C \uC8FC\uC18C \uC81C\uAC70",
        detailsAction__nonPrimary: "\uAE30\uBCF8\uC73C\uB85C \uC124\uC815",
        detailsAction__primary: "\uC778\uC99D \uC644\uB8CC",
        detailsAction__unverified: "\uC778\uC99D \uC644\uB8CC",
        primaryButton: "\uC774\uBA54\uC77C \uC8FC\uC18C \uCD94\uAC00",
        title: "\uC774\uBA54\uC77C \uC8FC\uC18C"
      },
      enterpriseAccountsSection: {
        title: "\uAE30\uC5C5 \uACC4\uC815"
      },
      headerTitle__account: "\uD504\uB85C\uD544",
      headerTitle__security: "\uBCF4\uC548",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\uCF54\uB4DC \uC7AC\uC0DD\uC131",
          headerTitle: "\uBC31\uC5C5 \uCF54\uB4DC",
          subtitle__regenerate: "\uC0C8\uB85C\uC6B4 \uBCF4\uC548 \uBC31\uC5C5 \uCF54\uB4DC \uC138\uD2B8\uB97C \uBC1B\uC73C\uC138\uC694. \uC774\uC804 \uBC31\uC5C5 \uCF54\uB4DC\uB294 \uC0AD\uC81C\uB418\uBA70 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
          title__regenerate: "\uBC31\uC5C5 \uCF54\uB4DC \uC7AC\uC0DD\uC131"
        },
        phoneCode: {
          actionLabel__setDefault: "\uAE30\uBCF8\uC73C\uB85C \uC124\uC815",
          destructiveActionLabel: "\uD734\uB300\uD3F0 \uBC88\uD638 \uC81C\uAC70"
        },
        primaryButton: "2\uB2E8\uACC4 \uC778\uC99D \uCD94\uAC00",
        title: "2\uB2E8\uACC4 \uC778\uC99D",
        totp: {
          destructiveActionTitle: "\uC81C\uAC70",
          headerTitle: "\uC778\uC99D \uC560\uD50C\uB9AC\uCF00\uC774\uC158"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\uBE44\uBC00\uBC88\uD638 \uC124\uC815",
        primaryButton__updatePassword: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD",
        title: "\uBE44\uBC00\uBC88\uD638"
      },
      phoneNumbersSection: {
        destructiveAction: "\uD734\uB300\uD3F0 \uBC88\uD638 \uC81C\uAC70",
        detailsAction__nonPrimary: "\uAE30\uBCF8\uC73C\uB85C \uC124\uC815",
        detailsAction__primary: "\uC778\uC99D \uC644\uB8CC",
        detailsAction__unverified: "\uC778\uC99D \uC644\uB8CC",
        primaryButton: "\uD734\uB300\uD3F0 \uBC88\uD638 \uCD94\uAC00",
        title: "\uD734\uB300\uD3F0 \uBC88\uD638"
      },
      profileSection: {
        primaryButton: "\uD504\uB85C\uD544 \uC218\uC815",
        title: "\uD504\uB85C\uD544"
      },
      usernameSection: {
        primaryButton__setUsername: "\uC0AC\uC6A9\uC790 \uC774\uB984 \uC124\uC815",
        primaryButton__updateUsername: "\uC0AC\uC6A9\uC790 \uC774\uB984 \uBCC0\uACBD",
        title: "\uC0AC\uC6A9\uC790 \uC774\uB984"
      },
      web3WalletsSection: {
        destructiveAction: "\uC9C0\uAC11 \uC81C\uAC70",
        primaryButton: "Web3 \uC9C0\uAC11",
        title: "Web3 \uC9C0\uAC11"
      }
    },
    usernamePage: {
      successMessage: "\uB2F9\uC2E0\uC76D \uC0AC\uC6A9\uC790 \uC774\uB984\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      title__set: "\uC0AC\uC6A9\uC790 \uC774\uB984 \uC5C5\uB370\uC774\uD2B8",
      title__update: "\uC0AC\uC6A9\uC790 \uC774\uB984 \uC5C5\uB370\uC774\uD2B8"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}}\uAC00 \uC774 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70 \uB420 \uC608\uC815\uC785\uB2C8\uB2E4.",
        messageLine2: "\uB354 \uC774\uC0C1 \uC774 web3 \uC9C0\uAC11\uC744 \uC0AC\uC6A9\uD558\uC5EC \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
        successMessage: "{{web3Wallet}}\uAC00 \uB2F9\uC2E0\uC758 \uACC4\uC815\uC5D0\uC11C \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
        title: "web3 \uC9C0\uAC11 \uC81C\uAC70"
      },
      subtitle__availableWallets: "\uACC4\uC815\uC5D0 \uC5F0\uACB0\uD560 web3 \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uC138\uC694.",
      subtitle__unavailableWallets: "\uC0AC\uC6A9 \uAC00\uB2A5\uD55C web3 \uC9C0\uAC11\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
      successMessage: "\uC9C0\uAC11\uC774 \uACC4\uC815\uC5D0 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4\xDF.",
      title: "web3 \uC9C0\uAC11 \uCD94\uAC00",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/nb-NO.ts
var nbNO = {
  locale: "nb-NO",
  backButton: "Tilbake",
  badge__default: "Standard",
  badge__otherImpersonatorDevice: "Annen imitators enhet",
  badge__primary: "Prim\xE6r",
  badge__requiresAction: "Krever handling",
  badge__thisDevice: "Denne enheten",
  badge__unverified: "Ikke verifisert",
  badge__userDevice: "Brukerens enhet",
  badge__you: "Du",
  createOrganization: {
    formButtonSubmit: "Opprett organisasjon",
    invitePage: {
      formButtonReset: "Hopp over"
    },
    title: "Opprett organisasjon"
  },
  dates: {
    lastDay: "I g\xE5r kl. {{ date | timeString('nb-NO') }}",
    next6Days: "{{ date | weekday('nb-NO','long') }} kl. {{ date | timeString('nb-NO') }}",
    nextDay: "I morgen kl. {{ date | timeString('nb-NO') }}",
    numeric: "{{ date | numeric('nb-NO') }}",
    previous6Days: "Sist {{ date | weekday('nb-NO','long') }} kl. {{ date | timeString('nb-NO') }}",
    sameDay: "I dag kl. {{ date | timeString('nb-NO') }}"
  },
  dividerText: "eller",
  footerActionLink__useAnotherMethod: "Bruk en annen metode",
  footerPageLink__help: "Hjelp",
  footerPageLink__privacy: "Personvern",
  footerPageLink__terms: "Vilk\xE5r",
  formButtonPrimary: "Fortsett",
  formButtonPrimary__verify: "Verifiser",
  formFieldAction__forgotPassword: "Glemt passord?",
  formFieldError__matchingPasswords: "Passordene stemmer overens.",
  formFieldError__notMatchingPasswords: "Passordene stemmer ikke overens.",
  formFieldError__verificationLinkExpired: "Verifikasjonslenken har utl\xF8pt. Vennligst be om en ny lenke.",
  formFieldHintText__optional: "Valgfritt",
  formFieldHintText__slug: "En slug er en menneskelesbar ID som m\xE5 v\xE6re unik. Den brukes ofte i URL-er.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Slett konto",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "Skriv inn eller lim inn \xE9n eller flere e-postadresser, separert med mellomrom eller komma",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Skru p\xE5 automatiske invitasjoner for dette domenet",
  formFieldLabel__backupCode: "Sikkerhetskode",
  formFieldLabel__confirmDeletion: "Bekreftelse",
  formFieldLabel__confirmPassword: "Bekreft passord",
  formFieldLabel__currentPassword: "N\xE5v\xE6rende passord",
  formFieldLabel__emailAddress: "E-postadresse",
  formFieldLabel__emailAddress_username: "E-postadresse eller brukernavn",
  formFieldLabel__emailAddresses: "E-postadresser",
  formFieldLabel__firstName: "Fornavn",
  formFieldLabel__lastName: "Etternavn",
  formFieldLabel__newPassword: "Nytt passord",
  formFieldLabel__organizationDomain: "Domene",
  formFieldLabel__organizationDomainDeletePending: "Slett ventende invitasjoner og forslag",
  formFieldLabel__organizationDomainEmailAddress: "Verifikasjon e-postadresse",
  formFieldLabel__organizationDomainEmailAddressDescription: "Oppgi en e-postadresse under dette domenet for \xE5 motta en kode og verifisere domenet.",
  formFieldLabel__organizationName: "Organisasjonsnavn",
  formFieldLabel__organizationSlug: "Slug URL",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "Passord",
  formFieldLabel__phoneNumber: "Telefonnummer",
  formFieldLabel__role: "Rolle",
  formFieldLabel__signOutOfOtherSessions: "Logg ut fra alle andre enheter",
  formFieldLabel__username: "Brukernavn",
  impersonationFab: {
    action__signOut: "Logg ut",
    title: "Logget inn som {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "Administrator",
  membershipRole__basicMember: "Medlem",
  membershipRole__guestMember: "Gjest",
  organizationList: {
    action__createOrganization: "Lag organisasjon",
    action__invitationAccept: "Bli med",
    action__suggestionsAccept: "Sp\xF8r om \xE5 bli med",
    createOrganization: "Lag Organisasjon",
    invitationAcceptedLabel: "Blitt med",
    subtitle: "for \xE5 fortsette til {{applicationName}}",
    suggestionsAcceptedLabel: "Venter p\xE5 godkjenning",
    title: "Velg en bruker",
    titleWithoutPersonal: "Velg en organiasjon"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatisk invitasjon",
    badge__automaticSuggestion: "Automatisk forslag",
    badge__manualInvitation: "Ingen automatisk registrering",
    badge__unverified: "Uverifisert",
    createDomainPage: {
      subtitle: "Legg til domenet som skal verifiseres. Brukere med e-postadresser p\xE5 dette domenet kan automatisk bli med i organisasjonen eller be om \xE5 f\xE5 bli med.",
      title: "Legg til domene"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Invitasjonene kunne ikke sendes. Fiks f\xF8lgende og pr\xF8v igjen:",
      formButtonPrimary__continue: "Send invitasjoner",
      selectDropdown__role: "Velg rolle",
      subtitle: "Inviter nye medlemmer til denne organisasjonen",
      successMessage: "Invitasjoner er sendt",
      title: "Inviter medlemmer"
    },
    membersPage: {
      action__invite: "Inviter",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Fjern medlem",
        tableHeader__actions: void 0,
        tableHeader__joined: "Ble med",
        tableHeader__role: "Rolle",
        tableHeader__user: "Bruker"
      },
      detailsTitle__emptyRow: "Ingen medlemmer \xE5 vise",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Inviter brukere ved \xE5 koble et e-postdomene til organisasjonen din. Alle som registrerer seg med et matchende e-postdomene vil kunne bli med i organisasjonen n\xE5r som helst.",
          headerTitle: "Automatiske invitasjoner",
          primaryButton: "Administrer verifiserte domener"
        },
        table__emptyRow: "Ingen invitasjoner \xE5 vise"
      },
      invitedMembersTab: {
        menuAction__revoke: "Tilbakekall invitasjon",
        tableHeader__invited: "Invitert"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Brukere som registrerer seg med et matchende e-postdomene, vil kunne se et forslag om \xE5 be om \xE5 bli med i organisasjonen din.",
          headerTitle: "Automatiske forslag",
          primaryButton: "Administrer verifiserte domener"
        },
        menuAction__approve: "Godta",
        menuAction__reject: "Avsl\xE5",
        tableHeader__requested: "Tilgangsforesp\xF8sler",
        table__emptyRow: "Ingen forsesp\xF8rsler \xE5 vise"
      },
      start: {
        headerTitle__invitations: "Invitasjoner",
        headerTitle__members: "Medlemmer",
        headerTitle__requests: "Foresp\xF8rsler"
      }
    },
    navbar: {
      description: "Administrer organisasjonen din.",
      general: "Generelt",
      members: "Medlemmer",
      title: "Organisasjon"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Skriv "{{organizationName}}" under for \xE5 bekrefte.',
          messageLine1: "Er du sikker p\xE5 at du vil slette denne organisasjonen?",
          messageLine2: "Denne handlingen er permanent og kan ikke reverseres.",
          successMessage: "Du har slettet organisasjonen.",
          title: "Slett organisasjonen"
        },
        leaveOrganization: {
          actionDescription: 'Skriv "{{organizationName}}" under for \xE5 fortsette.',
          messageLine1: "Er du sikker p\xE5 at du vil forlate denne organisasjonen? Du vil miste tilgangen til denne organisasjonen og dens applikasjoner.",
          messageLine2: "Denne handlingen er permanent og kan ikke reverseres.",
          successMessage: "Du har forlatt organisasjonen.",
          title: "Forlat organisasjonen"
        },
        title: "Fare"
      },
      domainSection: {
        menuAction__manage: "Administrer",
        menuAction__remove: "Slett",
        menuAction__verify: "Verifiser",
        primaryButton: "Legg til domene",
        subtitle: "Tillat brukere \xE5 bli med i organisasjonen automatisk eller be om \xE5 bli med basert p\xE5 et verifisert e-postdomene.",
        title: "Verifiserte domener"
      },
      successMessage: "Organisasjonen er oppdatert.",
      title: "Organisasjonsprofil"
    },
    removeDomainPage: {
      messageLine1: "E-postdomenet {{domain}} vil bli fjernet.",
      messageLine2: "Brukere vil ikke kunne bli med i organisasjonen automatisk etter dette.",
      successMessage: "{{domain}} har blitt fjernet.",
      title: "Fjern domene"
    },
    start: {
      headerTitle__general: "Generelt",
      headerTitle__members: "Medlemmer",
      profileSection: {
        primaryButton: void 0,
        title: "Organisasjonsprofil",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\xC5 fjerne dette domenet vil p\xE5virke inviterte brukere.",
        removeDomainActionLabel__remove: "Fjern domene",
        removeDomainSubtitle: "Fjern domenet fra dine verifiserte domener",
        removeDomainTitle: "Fjern domene"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Brukere blir automatisk invitert til \xE5 bli med i organisasjonen n\xE5r de registrerer seg og kan bli med n\xE5r som helst.",
        automaticInvitationOption__label: "Automatiske invitasjoner",
        automaticSuggestionOption__description: "Brukere mottar et forslag om \xE5 be om \xE5 bli med, men m\xE5 godkjennes av en administrator f\xF8r de kan bli med i organisasjonen.",
        automaticSuggestionOption__label: "Automatiske forslag",
        calloutInfoLabel: "\xC5 endre p\xE5meldingsmodus vil kun p\xE5virke nye brukere.",
        calloutInvitationCountLabel: "Ventende invitasjoner sendt til brukere: {{count}}",
        calloutSuggestionCountLabel: "Ventende forslag sendt til brukere: {{count}}",
        manualInvitationOption__description: "Brukere kan kun bli invitert manuelt til organisasjonen.",
        manualInvitationOption__label: "Ingen automatisk registrering",
        subtitle: "Velg hvordan brukere fra dette domenet kan bli med i organisasjonen."
      },
      start: {
        headerTitle__danger: "Fare",
        headerTitle__enrollment: "Registreringsalternativer"
      },
      subtitle: "Domenet {{domain}} har blitt verifisert. Fortsett ved \xE5 velge registreringsmodus.",
      title: "Oppdater {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Skriv inn verifiseringskoden som ble sendt til e-postadressen din",
      formTitle: "Verifiseringskode",
      resendButton: "Ikke mottatt kode? Send p\xE5 nytt",
      subtitle: "Domenet {{domainName}} m\xE5 verifiseres gjennom e-post.",
      subtitleVerificationCodeScreen: "En verifiseringskode har blitt sendt til {{emailAddress}}. Skriv inn koden for \xE5 fortsette.",
      title: "Verifiser domene"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Opprett organisasjon",
    action__invitationAccept: "Bli med",
    action__manageOrganization: "Administrer organisasjon",
    action__suggestionsAccept: "Sp\xF8r om \xE5 bli med",
    notSelected: "Ingen organisasjon valgt",
    personalWorkspace: "Personlig arbeidsomr\xE5de",
    suggestionsAcceptedLabel: "Venter p\xE5 godkjenning"
  },
  paginationButton__next: "Neste",
  paginationButton__previous: "Forrige",
  paginationRowText__displaying: "Viser",
  paginationRowText__of: "av",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Legg til konto",
      action__signOutAll: "Logg ut av alle kontoer",
      subtitle: "Velg kontoen du \xF8nsker \xE5 fortsette med.",
      title: "Velg konto"
    },
    alternativeMethods: {
      actionLink: "F\xE5 hjelp",
      actionText: "Har du ingen av disse?",
      blockButton__backupCode: "Bruk en sikkerhetskopi-kode",
      blockButton__emailCode: "Send e-postkode til {{identifier}}",
      blockButton__emailLink: "Send lenke til {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "Logg inn med passordet ditt",
      blockButton__phoneCode: "Send SMS-kode til {{identifier}}",
      blockButton__totp: "Bruk autentiseringsappen din",
      getHelp: {
        blockButton__emailSupport: "Kontakt kundest\xF8tte via e-post",
        content: "Hvis du har problemer med \xE5 logge inn p\xE5 kontoen din, kan du sende oss en e-post, og vi vil jobbe med deg for \xE5 gjenopprette tilgangen s\xE5 snart som mulig.",
        title: "F\xE5 hjelp"
      },
      subtitle: "Opplever du problemer? Du kan bruke hvilken som helst av disse metodene for \xE5 logge inn.",
      title: "Bruk en annen metode"
    },
    backupCodeMfa: {
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Skriv inn en sikkerhetskopi-kode"
    },
    emailCode: {
      formTitle: "Verifiseringskode",
      resendButton: "Send kode p\xE5 nytt",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Sjekk e-posten din"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "G\xE5 tilbake til den opprinnelige fanen for \xE5 fortsette.",
        title: "Denne verifiseringslenken er utl\xF8pt"
      },
      failed: {
        subtitle: "G\xE5 tilbake til den opprinnelige fanen for \xE5 fortsette.",
        title: "Denne verifiseringslenken er ugyldig"
      },
      formSubtitle: "Bruk verifiseringslenken som er sendt til e-postadressen din",
      formTitle: "Verifiseringslenke",
      loading: {
        subtitle: "Du blir omdirigert snart",
        title: "Logger inn..."
      },
      resendButton: "Send lenke p\xE5 nytt",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Sjekk e-posten din",
      unusedTab: {
        title: "Du kan lukke denne fanen"
      },
      verified: {
        subtitle: "Du blir omdirigert snart",
        title: "Innloggingen var vellykket"
      },
      verifiedSwitchTab: {
        subtitle: "G\xE5 tilbake til den opprinnelige fanen for \xE5 fortsette",
        subtitleNewTab: "G\xE5 tilbake til den ny\xE5pnede fanen for \xE5 fortsette",
        titleNewTab: "Logget inn p\xE5 en annen fane"
      }
    },
    forgotPassword: {
      formTitle: "Tilbakestill passord-kode",
      resendButton: "Send kode p\xE5 nytt",
      subtitle: "for \xE5 tilbakestille passordet ditt",
      subtitle_email: "F\xF8rst, skriv inn koden som ble sendt til e-posten din",
      subtitle_phone: "F\xF8rst, skriv inn koden som ble sendt til telefonen din",
      title: "Tilbakestill passord"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Tilbakestill passordet ditt",
      label__alternativeMethods: "Eller logg inn med en annen metode.",
      title: "Glemt passord?"
    },
    noAvailableMethods: {
      message: "Kan ikke fortsette med innloggingen. Det er ingen tilgjengelige autentiseringsfaktorer.",
      subtitle: "En feil oppstod",
      title: "Kan ikke logge inn"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "Bruk en annen metode",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Skriv inn passordet ditt"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "Verifiseringskode",
      resendButton: "Send kode p\xE5 nytt",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Sjekk telefonen din"
    },
    phoneCodeMfa: {
      formTitle: "Verifiseringskode",
      resendButton: "Send kode p\xE5 nytt",
      subtitle: void 0,
      title: "Sjekk telefonen din"
    },
    resetPassword: {
      formButtonPrimary: "Tilbakestill passordet",
      requiredMessage: "En konto eksisterer allerede med en uverifisert e-postadresse. Vennligst tilbakestill passordet ditt av sikkerhetshensyn.",
      successMessage: "Passordet ditt er blitt tilbakestilt. Logger deg inn, vennligst vent et \xF8yeblikk.",
      title: "Tilbakestill passordet"
    },
    resetPasswordMfa: {
      detailsLabel: "Vi m\xE5 bekrefte identiteten din f\xF8r vi tilbakestiller passordet ditt."
    },
    start: {
      actionLink: "Opprett konto",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Bruk e-post",
      actionLink__use_email_username: "Bruk e-post eller brukernavn",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "Bruk telefon",
      actionLink__use_username: "Bruk brukernavn",
      actionText: "Ingen konto?",
      actionText__join_waitlist: void 0,
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      subtitleCombined: void 0,
      title: "Logg inn",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Verifiseringskode",
      subtitle: void 0,
      title: "To-trinns verifisering"
    }
  },
  signInEnterPasswordTitle: "Skriv inn passordet ditt",
  signUp: {
    continue: {
      actionLink: "Logg inn",
      actionText: "Har du allerede en konto?",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Fyll ut manglende felt"
    },
    emailCode: {
      formSubtitle: "Skriv inn verifiseringskoden som er sendt til e-postadressen din",
      formTitle: "Verifiseringskode",
      resendButton: "Send kode p\xE5 nytt",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Verifiser e-posten din"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "Bruk verifiseringslenken som er sendt til e-postadressen din",
      formTitle: "Verifiseringslenke",
      loading: {
        title: "Registrerer deg..."
      },
      resendButton: "Send lenke p\xE5 nytt",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Verifiser e-posten din",
      verified: {
        title: "Registreringen var vellykket"
      },
      verifiedSwitchTab: {
        subtitle: "G\xE5 tilbake til den nylig \xE5pnede fanen for \xE5 fortsette",
        subtitleNewTab: "G\xE5 tilbake til forrige fane for \xE5 fortsette",
        title: "E-posten ble verifisert"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Skriv inn verifiseringskoden som er sendt til telefonnummeret ditt",
      formTitle: "Verifiseringskode",
      resendButton: "Send kode p\xE5 nytt",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      title: "Verifiser telefonen din"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Logg inn",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "Har du allerede en konto?",
      subtitle: "for \xE5 fortsette til {{applicationName}}",
      subtitleCombined: "for \xE5 fortsette til {{applicationName}}",
      title: "Opprett kontoen din",
      titleCombined: "Opprett kontoen din"
    }
  },
  socialButtonsBlockButton: "Fortsett med {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Registreringen mislyktes p\xE5 grunn av mislykkede sikkerhetsvalideringer. Vennligst oppdater siden og pr\xF8v igjen, eller ta kontakt med brukerst\xF8tte for mer hjelp.",
    captcha_unavailable: "Registreringen mislyktes p\xE5 grunn av mislykkede bot-valideringer. Vennligst oppdater siden og pr\xF8v igjen, eller ta kontakt med brukerst\xF8tte for mer hjelp.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "E-postadressen m\xE5 v\xE6re en gyldig e-postadresse",
    form_param_format_invalid__phone_number: "Telefonnummeret m\xE5 v\xE6re i et gyldig internasjonalt format",
    form_param_max_length_exceeded__first_name: "Fornavn kan ikke v\xE6re lengre enn 256 bokstaver.",
    form_param_max_length_exceeded__last_name: "Etternavn kan ikke v\xE6re lengre enn 256 bokstaver.",
    form_param_max_length_exceeded__name: "Navn kan ikke v\xE6re lengre enn 256 bokstaver.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Passordet ditt er ikke sterkt nok.",
    form_password_pwned: "Dette passordet er funnet som en del av et datainnbrudd og kan ikke brukes. Vennligst pr\xF8v et annet passord.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "Passordet ditt har overskredet maksimalt antall byte tillatt. Vennligst forkort det eller fjern noen spesialtegn.",
    form_password_validation_failed: "Feil passord",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "mindre enn {{length}} tegn",
      minimumLength: "{{length}} eller flere tegn",
      requireLowercase: "en liten bokstav",
      requireNumbers: "et tall",
      requireSpecialCharacter: "et spesialtegn",
      requireUppercase: "en stor bokstav",
      sentencePrefix: "Passordet ditt m\xE5 inneholde"
    },
    phone_number_exists: "Dette telefonnummeret er allerede i bruk. Vennligst bruk et annet telefonnummer.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Passordet ditt fungerer, men det kan v\xE6re sterkere. Pr\xF8v \xE5 legge til flere tegn.",
      goodPassword: "Godt jobbet. Dette er et utmerket passord.",
      notEnough: "Passordet ditt er ikke sterkt nok.",
      suggestions: {
        allUppercase: "Stor bokstav p\xE5 noen, men ikke alle bokstaver.",
        anotherWord: "Legg til flere ord som er mindre vanlige.",
        associatedYears: "Unng\xE5 \xE5r som er knyttet til deg.",
        capitalization: "Sett stor bokstav p\xE5 mer enn den f\xF8rste bokstaven.",
        dates: "Unng\xE5 datoer og \xE5r som er knyttet til deg.",
        l33t: "Unng\xE5 forutsigbare bokstavbytter som '@' for 'a'.",
        longerKeyboardPattern: "Bruk lengre tastaturm\xF8nstre og endre skrivretning flere ganger.",
        noNeed: "Du kan lage sterke passord uten \xE5 bruke symboler, tall eller store bokstaver.",
        pwned: "Hvis du bruker dette passordet andre steder, b\xF8r du endre det.",
        recentYears: "Unng\xE5 nylige \xE5r.",
        repeated: "Unng\xE5 gjentatte ord og tegn.",
        reverseWords: "Unng\xE5 omvendte stavelser av vanlige ord.",
        sequences: "Unng\xE5 vanlige tegnsekvenser.",
        useWords: "Bruk flere ord, men unng\xE5 vanlige fraser."
      },
      warnings: {
        common: "Dette er et vanlig brukt passord.",
        commonNames: "Vanlige navn og etternavn er lett \xE5 gjette.",
        dates: "Datoer er lett \xE5 gjette.",
        extendedRepeat: 'Gjentatte tegnm\xF8nstre som "abcabcabc" er lett \xE5 gjette.',
        keyPattern: "Korte tastaturm\xF8nstre er lett \xE5 gjette.",
        namesByThemselves: "Enkelt navn eller etternavn er lett \xE5 gjette.",
        pwned: "Passordet ditt ble eksponert i et datainnbrudd p\xE5 internett.",
        recentYears: "Nylige \xE5r er lett \xE5 gjette.",
        sequences: 'Vanlige tegnsekvenser som "abc" er lett \xE5 gjette.',
        similarToCommon: "Dette ligner p\xE5 et vanlig brukt passord.",
        simpleRepeat: 'Gjentatte tegn som "aaa" er lett \xE5 gjette.',
        straightRow: "Rette rader med tastene p\xE5 tastaturet ditt er lett \xE5 gjette.",
        topHundred: "Dette er et ofte brukt passord.",
        topTen: "Dette er et mye brukt passord.",
        userInputs: "Det b\xF8r ikke v\xE6re personlige eller sidetilknyttede data.",
        wordByItself: "Enkeltord er lett \xE5 gjette."
      }
    }
  },
  userButton: {
    action__addAccount: "Legg til konto",
    action__manageAccount: "Administrer konto",
    action__signOut: "Logg ut",
    action__signOutAll: "Logg ut av alle kontoer"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopiert!",
      actionLabel__copy: "Kopier alle",
      actionLabel__download: "Last ned .txt",
      actionLabel__print: "Skriv ut",
      infoText1: "Sikkerhetskoder vil bli aktivert for denne kontoen.",
      infoText2: "Hold sikkerhetskodene hemmelige og oppbevar dem sikkert. Du kan generere nye sikkerhetskoder hvis du mistenker at de er kompromittert.",
      subtitle__codelist: "Oppbevar dem sikkert og hold dem hemmelige.",
      successMessage: "Sikkerhetskoder er n\xE5 aktivert. Du kan bruke en av disse til \xE5 logge inn p\xE5 kontoen din hvis du mister tilgangen til autentiseringsenheten. Hver kode kan bare brukes \xE9n gang.",
      successSubtitle: "Du kan bruke en av disse til \xE5 logge inn p\xE5 kontoen din hvis du mister tilgangen til autentiseringsenheten.",
      title: "Legg til sikkerhetskopieringskodeverifisering",
      title__codelist: "Sikkerhetskoder"
    },
    connectedAccountPage: {
      formHint: "Velg en tilbyder for \xE5 koble til kontoen din.",
      formHint__noAccounts: "Det er ingen tilgjengelige eksterne konto-tilbydere.",
      removeResource: {
        messageLine1: "{{identifier}} vil bli fjernet fra denne kontoen.",
        messageLine2: "Du vil ikke lenger kunne bruke denne tilknyttede kontoen, og eventuelle avhengige funksjoner vil ikke lenger fungere.",
        successMessage: "{{connectedAccount}} har blitt fjernet fra kontoen din.",
        title: "Fjern tilknyttet konto"
      },
      socialButtonsBlockButton: "Koble til {{provider|titleize}}-konto",
      successMessage: "Tilbyderen har blitt lagt til kontoen din.",
      title: "Legg til tilknyttet konto"
    },
    deletePage: {
      actionDescription: 'Skriv inn "Slett konto" under for \xE5 fortsette.',
      confirm: "Slett konto",
      messageLine1: "Er du sikker p\xE5 at du vil slette kontoen din?",
      messageLine2: "Denne handlingen er permanent og kan ikke reverseres.",
      title: "Slett konto"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "En e-post med en verifiseringskode vil bli sendt til denne e-postadressen.",
        formSubtitle: "Skriv inn verifiseringskoden som er sendt til {{identifier}}",
        formTitle: "Verifiseringskode",
        resendButton: "Send kode p\xE5 nytt",
        successMessage: "E-posten {{identifier}} har blitt lagt til kontoen din."
      },
      emailLink: {
        formHint: "En e-post med en verifiseringslenke vil bli sendt til denne e-postadressen.",
        formSubtitle: "Klikk p\xE5 verifiseringslenken i e-posten sendt til {{identifier}}",
        formTitle: "Verifiseringslenke",
        resendButton: "Send lenke p\xE5 nytt",
        successMessage: "E-posten {{identifier}} har blitt lagt til kontoen din."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} vil bli fjernet fra denne kontoen.",
        messageLine2: "Du vil ikke lenger kunne logge inn med denne e-postadressen.",
        successMessage: "{{emailAddress}} har blitt fjernet fra kontoen din.",
        title: "Fjern e-postadresse"
      },
      title: "Legg til e-postadresse",
      verifyTitle: "Verifiser e-postadresse"
    },
    formButtonPrimary__add: "Legg til",
    formButtonPrimary__continue: "Fortsett",
    formButtonPrimary__finish: "Fullf\xF8r",
    formButtonPrimary__remove: "Fjern",
    formButtonPrimary__save: "Lagre",
    formButtonReset: "Avbryt",
    mfaPage: {
      formHint: "Velg en metode for \xE5 legge til.",
      title: "Legg til to-trinns verifisering"
    },
    mfaPhoneCodePage: {
      backButton: "Bruk eksisterende nummer",
      primaryButton__addPhoneNumber: "Legg til et telefonnummer",
      removeResource: {
        messageLine1: "{{identifier}} vil ikke lenger motta verifiseringskoder ved p\xE5logging.",
        messageLine2: "Kontoen din kan bli mindre sikker. Er du sikker p\xE5 at du vil fortsette?",
        successMessage: "SMS-kode to-trinns verifisering er fjernet for {{mfaPhoneCode}}",
        title: "Fjern to-trinns verifisering"
      },
      subtitle__availablePhoneNumbers: "Velg et telefonnummer for \xE5 registrere deg for SMS-kode to-trinns verifisering.",
      subtitle__unavailablePhoneNumbers: "Det er ingen tilgjengelige telefonnummer \xE5 registrere seg for SMS-kode to-trinns verifisering.",
      successMessage1: "Ved innlogging vil du m\xE5tte skrive inn en verifiseringskode sendt til dette telfonnummeret som et tilleggssteg.",
      successMessage2: "Ta vare p\xE5 disse reservekodene og oppbevar dem p\xE5 et trygt sted. Hvis du mister tilgang til autentiseringsenheten din kan du bruke reservekodene for \xE5 logge inn.",
      successTitle: "SMS-kodeverifisering lagt til",
      title: "Legg til SMS-kodeverifisering"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Skan QR-kode i stedet",
        buttonUnableToScan__nonPrimary: "Kan ikke skanne QR-kode?",
        infoText__ableToScan: "Sett opp en ny innloggingsmetode i autentiseringsappen din og skann f\xF8lgende QR-kode for \xE5 koble den til kontoen din.",
        infoText__unableToScan: "Sett opp en ny innloggingsmetode i autentiseringsappen og skriv inn n\xF8kkelen som er oppgitt nedenfor.",
        inputLabel__unableToScan1: "S\xF8rg for at tidsbaserte eller engangspassord er aktivert, og fullf\xF8r deretter koblingen av kontoen din.",
        inputLabel__unableToScan2: "Alternativt, hvis autentiseringsappen din st\xF8tter TOTP URI-er, kan du ogs\xE5 kopiere hele URI-en."
      },
      removeResource: {
        messageLine1: "Verifiseringskoder fra denne autentiseringsappen vil ikke lenger v\xE6re p\xE5krevd ved p\xE5logging.",
        messageLine2: "Kontoen din kan bli mindre sikker. Er du sikker p\xE5 at du vil fortsette?",
        successMessage: "To-trinns verifisering via autentiseringsappen er fjernet.",
        title: "Fjern to-trinns verifisering"
      },
      successMessage: "To-trinns verifisering er n\xE5 aktivert. N\xE5r du logger inn, m\xE5 du angi en verifiseringskode fra denne autentiseringsappen som et ekstra trinn.",
      title: "Legg til autentiseringsapp",
      verifySubtitle: "Skriv inn verifiseringskoden generert av autentiseringsappen din",
      verifyTitle: "Verifiseringskode"
    },
    mobileButton__menu: "Meny",
    navbar: {
      account: "Profil",
      description: "Administrer kontoinformasjonen din.",
      security: "Sikkerhet",
      title: "Konto"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Det er anbefalt \xE5 logge ut av alle de andre enhetene dine som kan ha brukt ditt gamle passord.",
      readonly: "Passordet ditt kan for \xF8yeblikket ikke endres fordi du kun kan logge inn via bedriftstilkoblingen.",
      successMessage__set: "Passordet ditt er satt.",
      successMessage__signOutOfOtherSessions: "Alle andre enheter har blitt logget ut.",
      successMessage__update: "Passordet ditt har blitt oppdatert.",
      title__set: "Sett passord",
      title__update: "Endre passord"
    },
    phoneNumberPage: {
      infoText: "En tekstmelding med en verifiseringslenke vil bli sendt til dette telefonnummeret.",
      removeResource: {
        messageLine1: "{{identifier}} vil bli fjernet fra denne kontoen.",
        messageLine2: "Du vil ikke lenger kunne logge inn med dette telefonnummeret.",
        successMessage: "{{phoneNumber}} har blitt fjernet fra kontoen din.",
        title: "Fjern telefonnummer"
      },
      successMessage: "{{identifier}} har blitt lagt til kontoen din.",
      title: "Legg til telefonnummer",
      verifySubtitle: "Skriv inn verifiseringskoden som ble sendt til {{identifier}}",
      verifyTitle: "Verifiser telefonnummer"
    },
    profilePage: {
      fileDropAreaHint: "Last opp et JPG, PNG, GIF eller WEBP-bilde som er mindre enn 10 MB",
      imageFormDestructiveActionSubtitle: "Fjern bilde",
      imageFormSubtitle: "Last opp bilde",
      imageFormTitle: "Profilbilde",
      readonly: "Informasjonen om profilen din er levert av bedriftstilkoblingen og kan ikke redigeres.",
      successMessage: "Profilen din har blitt oppdatert.",
      title: "Oppdater profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Logg ut fra enhet",
        title: "Aktive enheter"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Pr\xF8v p\xE5 nytt",
        actionLabel__reauthorize: "Autoriser n\xE5",
        destructiveActionTitle: "Fjern",
        primaryButton: "Koble til konto",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "Tilkoblede kontoer"
      },
      dangerSection: {
        deleteAccountButton: "Slett konto",
        title: "Fare"
      },
      emailAddressesSection: {
        destructiveAction: "Fjern e-postadresse",
        detailsAction__nonPrimary: "Angi som prim\xE6r",
        detailsAction__primary: "Fullf\xF8r verifisering",
        detailsAction__unverified: "Fullf\xF8r verifisering",
        primaryButton: "Legg til en e-postadresse",
        title: "E-postadresser"
      },
      enterpriseAccountsSection: {
        title: "Bedriftskontoer"
      },
      headerTitle__account: "Konto",
      headerTitle__security: "Sikkerhet",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Generer koder p\xE5 nytt",
          headerTitle: "Sikkerhetskoder",
          subtitle__regenerate: "F\xE5 en ny serie med sikre sikkerhetskoder. Tidligere sikkerhetskoder vil bli slettet og kan ikke brukes.",
          title__regenerate: "Generer nye sikkerhetskoder"
        },
        phoneCode: {
          actionLabel__setDefault: "Angi som standard",
          destructiveActionLabel: "Fjern telefonnummer"
        },
        primaryButton: "Legg til to-trinns verifisering",
        title: "To-trinns verifisering",
        totp: {
          destructiveActionTitle: "Fjern",
          headerTitle: "Autentiseringsapplikasjon"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "Opprett passord",
        primaryButton__updatePassword: "Endre passord",
        title: "Passord"
      },
      phoneNumbersSection: {
        destructiveAction: "Fjern telefonnummer",
        detailsAction__nonPrimary: "Angi som prim\xE6r",
        detailsAction__primary: "Fullf\xF8r verifisering",
        detailsAction__unverified: "Fullf\xF8r verifisering",
        primaryButton: "Legg til et telefonnummer",
        title: "Telefonnumre"
      },
      profileSection: {
        primaryButton: void 0,
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Angi brukernavn",
        primaryButton__updateUsername: "Endre brukernavn",
        title: "Brukernavn"
      },
      web3WalletsSection: {
        destructiveAction: "Fjern lommebok",
        primaryButton: "Web3-lommeb\xF8ker",
        title: "Web3-lommeb\xF8ker"
      }
    },
    usernamePage: {
      successMessage: "Brukernavnet ditt har blitt oppdatert.",
      title__set: "Oppdater brukernavn",
      title__update: "Oppdater brukernavn"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} vil bli fjernet fra denne kontoen.",
        messageLine2: "Du vil ikke lenger kunne logge inn med denne web3-lommeboken.",
        successMessage: "{{web3Wallet}} har blitt fjernet fra kontoen din.",
        title: "Fjern web3-lommebok"
      },
      subtitle__availableWallets: "Velg en web3-lommebok for \xE5 koble til kontoen din.",
      subtitle__unavailableWallets: "Det er ingen tilgjengelige web3-lommeb\xF8ker.",
      successMessage: "Lommeboken har blitt lagt til kontoen din.",
      title: "Legg til web3-lommebok",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/vi-VN.ts
var viVN = {
  locale: "vi-VN",
  backButton: "Quay l\u1EA1i",
  badge__default: "M\u1EB7c \u0111\u1ECBnh",
  badge__otherImpersonatorDevice: "Thi\u1EBFt b\u1ECB nh\xE2n danh kh\xE1c",
  badge__primary: "Ch\xEDnh",
  badge__requiresAction: "Y\xEAu c\u1EA7u h\xE0nh \u0111\u1ED9ng",
  badge__thisDevice: "Thi\u1EBFt b\u1ECB n\xE0y",
  badge__unverified: "Ch\u01B0a x\xE1c minh",
  badge__userDevice: "Thi\u1EBFt b\u1ECB ng\u01B0\u1EDDi d\xF9ng",
  badge__you: "B\u1EA1n",
  createOrganization: {
    formButtonSubmit: "T\u1EA1o t\u1ED5 ch\u1EE9c",
    invitePage: {
      formButtonReset: "B\u1ECF qua"
    },
    title: "T\u1EA1o T\u1ED5 ch\u1EE9c"
  },
  dates: {
    lastDay: "H\xF4m qua l\xFAc {{ date | timeString('vi-VN') }}",
    next6Days: "V\xE0o {{ date | weekday('vi-VN','long') }} t\u1EDBi l\xFAc {{ date | timeString('vi-VN') }}",
    nextDay: "Ng\xE0y mai l\xFAc {{ date | timeString('vi-VN') }}",
    numeric: "{{ date | numeric('vi-VN') }}",
    previous6Days: "V\xE0o {{ date | weekday('vi-VN','long') }} tr\u01B0\u1EDBc \u0111\xF3 l\xFAc {{ date | timeString('vi-VN') }}",
    sameDay: "H\xF4m nay l\xFAc {{ date | timeString('vi-VN') }}"
  },
  dividerText: "ho\u1EB7c",
  footerActionLink__useAnotherMethod: "S\u1EED d\u1EE5ng ph\u01B0\u01A1ng ph\xE1p kh\xE1c",
  footerPageLink__help: "Tr\u1EE3 gi\xFAp",
  footerPageLink__privacy: "Quy\u1EC1n ri\xEAng t\u01B0",
  footerPageLink__terms: "\u0110i\u1EC1u kho\u1EA3n",
  formButtonPrimary: "Ti\u1EBFp t\u1EE5c",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Qu\xEAn m\u1EADt kh\u1EA9u?",
  formFieldError__matchingPasswords: "M\u1EADt kh\u1EA9u kh\u1EDBp.",
  formFieldError__notMatchingPasswords: "M\u1EADt kh\u1EA9u kh\xF4ng kh\u1EDBp.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "T\xF9y ch\u1ECDn",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "Nh\u1EADp ho\u1EB7c d\xE1n m\u1ED9t ho\u1EB7c nhi\u1EC1u \u0111\u1ECBa ch\u1EC9 email, c\xE1ch nhau b\u1EB1ng kho\u1EA3ng tr\u1EAFng ho\u1EB7c d\u1EA5u ph\u1EA9y",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "M\xE3 sao l\u01B0u",
  formFieldLabel__confirmDeletion: "Confirmation",
  formFieldLabel__confirmPassword: "X\xE1c nh\u1EADn m\u1EADt kh\u1EA9u",
  formFieldLabel__currentPassword: "M\u1EADt kh\u1EA9u hi\u1EC7n t\u1EA1i",
  formFieldLabel__emailAddress: "\u0110\u1ECBa ch\u1EC9 email",
  formFieldLabel__emailAddress_username: "\u0110\u1ECBa ch\u1EC9 email ho\u1EB7c t\xEAn ng\u01B0\u1EDDi d\xF9ng",
  formFieldLabel__emailAddresses: "C\xE1c \u0111\u1ECBa ch\u1EC9 email",
  formFieldLabel__firstName: "T\xEAn",
  formFieldLabel__lastName: "H\u1ECD",
  formFieldLabel__newPassword: "M\u1EADt kh\u1EA9u m\u1EDBi",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "T\xEAn t\u1ED5 ch\u1EE9c",
  formFieldLabel__organizationSlug: "\u0110\u01B0\u1EDDng d\u1EABn r\xFAt g\u1ECDn",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "M\u1EADt kh\u1EA9u",
  formFieldLabel__phoneNumber: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
  formFieldLabel__role: "Vai tr\xF2",
  formFieldLabel__signOutOfOtherSessions: "\u0110\u0103ng xu\u1EA5t kh\u1ECFi t\u1EA5t c\u1EA3 c\xE1c thi\u1EBFt b\u1ECB kh\xE1c",
  formFieldLabel__username: "T\xEAn ng\u01B0\u1EDDi d\xF9ng",
  impersonationFab: {
    action__signOut: "\u0110\u0103ng xu\u1EA5t",
    title: "\u0110\u0103ng nh\u1EADp v\u1EDBi t\u01B0 c\xE1ch {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "Qu\u1EA3n tr\u1ECB vi\xEAn",
  membershipRole__basicMember: "Th\xE0nh vi\xEAn",
  membershipRole__guestMember: "Kh\xE1ch",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Kh\xF4ng th\u1EC3 g\u1EEDi l\u1EDDi m\u1EDDi. S\u1EEDa c\xE1c l\u1ED7i sau v\xE0 th\u1EED l\u1EA1i:",
      formButtonPrimary__continue: "G\u1EEDi l\u1EDDi m\u1EDDi",
      selectDropdown__role: "Select role",
      subtitle: "M\u1EDDi th\xE0nh vi\xEAn m\u1EDBi v\xE0o t\u1ED5 ch\u1EE9c n\xE0y",
      successMessage: "M\u1EDDi \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi th\xE0nh c\xF4ng",
      title: "M\u1EDDi th\xE0nh vi\xEAn"
    },
    membersPage: {
      action__invite: "M\u1EDDi",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "G\u1EE1 b\u1ECF th\xE0nh vi\xEAn",
        tableHeader__actions: void 0,
        tableHeader__joined: "Tham gia",
        tableHeader__role: "Vai tr\xF2",
        tableHeader__user: "Ng\u01B0\u1EDDi d\xF9ng"
      },
      detailsTitle__emptyRow: "Kh\xF4ng c\xF3 th\xE0nh vi\xEAn \u0111\u1EC3 hi\u1EC3n th\u1ECB",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "Thu h\u1ED3i l\u1EDDi m\u1EDDi",
        tableHeader__invited: "\u0110\xE3 m\u1EDDi"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a t\u1ED5 ch\u1EE9c n\xE0y kh\xF4ng?",
          messageLine2: "H\xE0nh \u0111\u1ED9ng n\xE0y l\xE0 v\u0129nh vi\u1EC5n v\xE0 kh\xF4ng th\u1EC3 ho\xE0n t\xE1c.",
          successMessage: "B\u1EA1n \u0111\xE3 x\xF3a t\u1ED5 ch\u1EE9c.",
          title: "X\xF3a t\u1ED5 ch\u1EE9c"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n r\u1EDDi kh\u1ECFi t\u1ED5 ch\u1EE9c n\xE0y? B\u1EA1n s\u1EBD m\u1EA5t quy\u1EC1n truy c\u1EADp v\xE0o t\u1ED5 ch\u1EE9c n\xE0y v\xE0 c\xE1c \u1EE9ng d\u1EE5ng c\u1EE7a n\xF3.",
          messageLine2: "H\xE0nh \u0111\u1ED9ng n\xE0y l\xE0 v\u0129nh vi\u1EC5n v\xE0 kh\xF4ng th\u1EC3 ho\xE0n t\xE1c.",
          successMessage: "B\u1EA1n \u0111\xE3 r\u1EDDi kh\u1ECFi t\u1ED5 ch\u1EE9c.",
          title: "R\u1EDDi kh\u1ECFi t\u1ED5 ch\u1EE9c"
        },
        title: "Nguy hi\u1EC3m"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "T\u1ED5 ch\u1EE9c \u0111\xE3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.",
      title: "H\u1ED3 s\u01A1 T\u1ED5 ch\u1EE9c"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Th\xE0nh vi\xEAn",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "T\u1EA1o T\u1ED5 ch\u1EE9c",
    action__invitationAccept: "Join",
    action__manageOrganization: "Qu\u1EA3n l\xFD T\u1ED5 ch\u1EE9c",
    action__suggestionsAccept: "Request to join",
    notSelected: "Ch\u01B0a ch\u1ECDn t\u1ED5 ch\u1EE9c",
    personalWorkspace: "Kh\xF4ng gian C\xE1 nh\xE2n",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "Ti\u1EBFp",
  paginationButton__previous: "Tr\u01B0\u1EDBc",
  paginationRowText__displaying: "Hi\u1EC3n th\u1ECB",
  paginationRowText__of: "c\u1EE7a",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Nh\u1EADn tr\u1EE3 gi\xFAp",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "S\u1EED d\u1EE5ng m\xE3 sao l\u01B0u",
      blockButton__emailCode: "G\u1EEDi m\xE3 qua email cho {{identifier}}",
      blockButton__emailLink: "G\u1EEDi li\xEAn k\u1EBFt qua email cho {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "\u0110\u0103ng nh\u1EADp b\u1EB1ng m\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n",
      blockButton__phoneCode: "G\u1EEDi m\xE3 SMS cho {{identifier}}",
      blockButton__totp: "S\u1EED d\u1EE5ng \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c c\u1EE7a b\u1EA1n",
      getHelp: {
        blockButton__emailSupport: "H\u1ED7 tr\u1EE3 qua email",
        content: "N\u1EBFu b\u1EA1n g\u1EB7p kh\xF3 kh\u0103n khi \u0111\u0103ng nh\u1EADp v\xE0o t\xE0i kho\u1EA3n c\u1EE7a m\xECnh, h\xE3y g\u1EEDi email cho ch\xFAng t\xF4i v\xE0 ch\xFAng t\xF4i s\u1EBD c\xF9ng b\u1EA1n kh\xF4i ph\u1EE5c quy\u1EC1n truy c\u1EADp trong th\u1EDDi gian ng\u1EAFn nh\u1EA5t.",
        title: "Nh\u1EADn tr\u1EE3 gi\xFAp"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "S\u1EED d\u1EE5ng ph\u01B0\u01A1ng ph\xE1p kh\xE1c"
    },
    backupCodeMfa: {
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "Nh\u1EADp m\xE3 sao l\u01B0u"
    },
    emailCode: {
      formTitle: "M\xE3 x\xE1c minh",
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "Ki\u1EC3m tra email c\u1EE7a b\u1EA1n"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "Quay tr\u1EDF l\u1EA1i c\u1EEDa s\u1ED5 g\u1ED1c \u0111\u1EC3 ti\u1EBFp t\u1EE5c.",
        title: "Li\xEAn k\u1EBFt x\xE1c minh n\xE0y \u0111\xE3 h\u1EBFt h\u1EA1n"
      },
      failed: {
        subtitle: "Quay tr\u1EDF l\u1EA1i c\u1EEDa s\u1ED5 g\u1ED1c \u0111\u1EC3 ti\u1EBFp t\u1EE5c.",
        title: "Li\xEAn k\u1EBFt x\xE1c minh n\xE0y kh\xF4ng h\u1EE3p l\u1EC7"
      },
      formSubtitle: "S\u1EED d\u1EE5ng li\xEAn k\u1EBFt x\xE1c minh \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn email c\u1EE7a b\u1EA1n",
      formTitle: "Li\xEAn k\u1EBFt x\xE1c minh",
      loading: {
        subtitle: "B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng s\u1EDBm",
        title: "\u0110ang \u0111\u0103ng nh\u1EADp..."
      },
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c li\xEAn k\u1EBFt? G\u1EEDi l\u1EA1i",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "Ki\u1EC3m tra email c\u1EE7a b\u1EA1n",
      unusedTab: {
        title: "B\u1EA1n c\xF3 th\u1EC3 \u0111\xF3ng c\u1EEDa s\u1ED5 n\xE0y"
      },
      verified: {
        subtitle: "B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng s\u1EDBm",
        title: "\u0110\u0103ng nh\u1EADp th\xE0nh c\xF4ng"
      },
      verifiedSwitchTab: {
        subtitle: "Quay tr\u1EDF l\u1EA1i c\u1EEDa s\u1ED5 g\u1ED1c \u0111\u1EC3 ti\u1EBFp t\u1EE5c",
        subtitleNewTab: "Quay tr\u1EDF l\u1EA1i c\u1EEDa s\u1ED5 m\u1EDBi m\u1EDF \u0111\u1EC3 ti\u1EBFp t\u1EE5c",
        titleNewTab: "\u0110\u0103ng nh\u1EADp tr\xEAn c\u1EEDa s\u1ED5 kh\xE1c"
      }
    },
    forgotPassword: {
      formTitle: "M\xE3 \u0111\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u",
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0110\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u",
      label__alternativeMethods: "Ho\u1EB7c, \u0111\u0103ng nh\u1EADp b\u1EB1ng ph\u01B0\u01A1ng ph\xE1p kh\xE1c.",
      title: "Qu\xEAn m\u1EADt kh\u1EA9u?"
    },
    noAvailableMethods: {
      message: "Kh\xF4ng th\u1EC3 ti\u1EBFp t\u1EE5c \u0111\u0103ng nh\u1EADp. Kh\xF4ng c\xF3 ph\u01B0\u01A1ng th\u1EE9c x\xE1c th\u1EF1c n\xE0o kh\u1EA3 d\u1EE5ng.",
      subtitle: "\u0110\xE3 x\u1EA3y ra l\u1ED7i",
      title: "Kh\xF4ng th\u1EC3 \u0111\u0103ng nh\u1EADp"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "S\u1EED d\u1EE5ng ph\u01B0\u01A1ng ph\xE1p kh\xE1c",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "Nh\u1EADp m\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "M\xE3 x\xE1c nh\u1EADn",
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "Ki\u1EC3m tra \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n"
    },
    phoneCodeMfa: {
      formTitle: "M\xE3 x\xE1c nh\u1EADn",
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
      subtitle: void 0,
      title: "Ki\u1EC3m tra \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n"
    },
    resetPassword: {
      formButtonPrimary: "\u0110\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\xE3 \u0111\u01B0\u1EE3c thay \u0111\u1ED5i th\xE0nh c\xF4ng. \u0110ang \u0111\u0103ng nh\u1EADp, vui l\xF2ng ch\u1EDD m\u1ED9t ch\xFAt.",
      title: "\u0110\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u"
    },
    resetPasswordMfa: {
      detailsLabel: "Ch\xFAng t\xF4i c\u1EA7n x\xE1c minh danh t\xEDnh c\u1EE7a b\u1EA1n tr\u01B0\u1EDBc khi \u0111\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u."
    },
    start: {
      actionLink: "\u0110\u0103ng k\xFD",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "S\u1EED d\u1EE5ng email",
      actionLink__use_email_username: "S\u1EED d\u1EE5ng email ho\u1EB7c t\xEAn \u0111\u0103ng nh\u1EADp",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "S\u1EED d\u1EE5ng s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
      actionLink__use_username: "S\u1EED d\u1EE5ng t\xEAn \u0111\u0103ng nh\u1EADp",
      actionText: "Ch\u01B0a c\xF3 t\xE0i kho\u1EA3n?",
      actionText__join_waitlist: void 0,
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      subtitleCombined: void 0,
      title: "\u0110\u0103ng nh\u1EADp",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "M\xE3 x\xE1c minh",
      subtitle: void 0,
      title: "X\xE1c minh hai b\u01B0\u1EDBc"
    }
  },
  signInEnterPasswordTitle: "Nh\u1EADp m\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n",
  signUp: {
    continue: {
      actionLink: "\u0110\u0103ng nh\u1EADp",
      actionText: "\u0110\xE3 c\xF3 t\xE0i kho\u1EA3n?",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "\u0110i\u1EC1n c\xE1c tr\u01B0\u1EDDng b\u1ECB thi\u1EBFu"
    },
    emailCode: {
      formSubtitle: "Nh\u1EADp m\xE3 x\xE1c minh \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 email c\u1EE7a b\u1EA1n",
      formTitle: "M\xE3 x\xE1c minh",
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "X\xE1c minh email c\u1EE7a b\u1EA1n"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "S\u1EED d\u1EE5ng li\xEAn k\u1EBFt x\xE1c minh \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 email c\u1EE7a b\u1EA1n",
      formTitle: "Li\xEAn k\u1EBFt x\xE1c minh",
      loading: {
        title: "\u0110ang \u0111\u0103ng k\xFD..."
      },
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c li\xEAn k\u1EBFt? G\u1EEDi l\u1EA1i",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "X\xE1c minh email c\u1EE7a b\u1EA1n",
      verified: {
        title: "\u0110\u0103ng k\xFD th\xE0nh c\xF4ng"
      },
      verifiedSwitchTab: {
        subtitle: "Quay l\u1EA1i c\u1EEDa s\u1ED5 m\u1EDBi \u0111\u01B0\u1EE3c m\u1EDF \u0111\u1EC3 ti\u1EBFp t\u1EE5c",
        subtitleNewTab: "Quay l\u1EA1i c\u1EEDa s\u1ED5 tr\u01B0\u1EDBc \u0111\u1EC3 ti\u1EBFp t\u1EE5c",
        title: "X\xE1c minh email th\xE0nh c\xF4ng"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Nh\u1EADp m\xE3 x\xE1c minh \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn s\u1ED1 \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n",
      formTitle: "M\xE3 x\xE1c minh",
      resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "X\xE1c minh s\u1ED1 \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u0110\u0103ng nh\u1EADp",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u0110\xE3 c\xF3 t\xE0i kho\u1EA3n?",
      subtitle: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      subtitleCombined: "\u0111\u1EC3 ti\u1EBFp t\u1EE5c v\u1EDBi {{applicationName}}",
      title: "T\u1EA1o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n",
      titleCombined: "T\u1EA1o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n"
    }
  },
  socialButtonsBlockButton: "Ti\u1EBFp t\u1EE5c v\u1EDBi {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\u0110\u0103ng k\xFD kh\xF4ng th\xE0nh c\xF4ng do kh\xF4ng v\u01B0\u1EE3t qua c\xE1c x\xE1c th\u1EF1c b\u1EA3o m\u1EADt. Vui l\xF2ng l\xE0m m\u1EDBi trang v\xE0 th\u1EED l\u1EA1i ho\u1EB7c li\xEAn h\u1EC7 h\u1ED7 tr\u1EE3 \u0111\u1EC3 \u0111\u01B0\u1EE3c tr\u1EE3 gi\xFAp th\xEAm.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u0110\u1ECBa ch\u1EC9 email ph\u1EA3i l\xE0 m\u1ED9t \u0111\u1ECBa ch\u1EC9 email h\u1EE3p l\u1EC7",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n kh\xF4ng \u0111\u1EE7 m\u1EA1nh.",
    form_password_pwned: "M\u1EADt kh\u1EA9u n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c ph\xE1t hi\u1EC7n trong m\u1ED9t cu\u1ED9c t\u1EA5n c\xF4ng v\xE0 kh\xF4ng th\u1EC3 s\u1EED d\u1EE5ng, vui l\xF2ng th\u1EED m\u1EADt kh\u1EA9u kh\xE1c.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\xE3 v\u01B0\u1EE3t qu\xE1 s\u1ED1 byte t\u1ED1i \u0111a cho ph\xE9p, vui l\xF2ng r\xFAt ng\u1EAFn ho\u1EB7c lo\u1EA1i b\u1ECF m\u1ED9t s\u1ED1 k\xFD t\u1EF1 \u0111\u1EB7c bi\u1EC7t.",
    form_password_validation_failed: "M\u1EADt kh\u1EA9u kh\xF4ng \u0111\xFAng",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "B\u1EA1n kh\xF4ng th\u1EC3 x\xF3a th\xF4ng tin nh\u1EADn d\u1EA1ng cu\u1ED1i c\xF9ng c\u1EE7a b\u1EA1n.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "\xEDt h\u01A1n {{length}} k\xFD t\u1EF1",
      minimumLength: "{{length}} ho\u1EB7c nhi\u1EC1u k\xFD t\u1EF1",
      requireLowercase: "m\u1ED9t ch\u1EEF c\xE1i vi\u1EBFt th\u01B0\u1EDDng",
      requireNumbers: "m\u1ED9t s\u1ED1",
      requireSpecialCharacter: "m\u1ED9t k\xFD t\u1EF1 \u0111\u1EB7c bi\u1EC7t",
      requireUppercase: "m\u1ED9t ch\u1EEF c\xE1i vi\u1EBFt hoa",
      sentencePrefix: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n ph\u1EA3i ch\u1EE9a"
    },
    phone_number_exists: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng. Vui l\xF2ng th\u1EED s\u1ED1 kh\xE1c.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\u1EE7 m\u1EA1nh, nh\u01B0ng c\xF3 th\u1EC3 m\u1EA1nh h\u01A1n. H\xE3y th\xEAm nhi\u1EC1u k\xFD t\u1EF1 h\u01A1n.",
      goodPassword: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\xE1p \u1EE9ng t\u1EA5t c\u1EA3 c\xE1c y\xEAu c\u1EA7u c\u1EA7n thi\u1EBFt.",
      notEnough: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n kh\xF4ng \u0111\u1EE7 m\u1EA1nh.",
      suggestions: {
        allUppercase: "Vi\u1EBFt hoa m\u1ED9t s\u1ED1 k\xFD t\u1EF1, nh\u01B0ng kh\xF4ng ph\u1EA3i t\u1EA5t c\u1EA3.",
        anotherWord: "Th\xEAm nhi\u1EC1u t\u1EEB \xEDt ph\u1ED5 bi\u1EBFn h\u01A1n.",
        associatedYears: "Tr\xE1nh c\xE1c n\u0103m li\xEAn quan \u0111\u1EBFn b\u1EA1n.",
        capitalization: "Vi\u1EBFt hoa nhi\u1EC1u h\u01A1n ch\u1EC9 ch\u1EEF c\xE1i \u0111\u1EA7u ti\xEAn.",
        dates: "Tr\xE1nh s\u1EED d\u1EE5ng ng\xE0y th\xE1ng n\u0103m li\xEAn quan \u0111\u1EBFn b\u1EA1n.",
        l33t: "Tr\xE1nh vi\u1EC7c thay th\u1EBF ch\u1EEF c\xE1i d\u1EC5 \u0111o\xE1n b\u1EB1ng c\xE1c k\xFD t\u1EF1 nh\u01B0 '@' thay cho 'a'.",
        longerKeyboardPattern: "S\u1EED d\u1EE5ng c\xE1c m\u1EABu b\xE0n ph\xEDm d\xE0i h\u01A1n v\xE0 thay \u0111\u1ED5i h\u01B0\u1EDBng g\xF5 nhi\u1EC1u l\u1EA7n.",
        noNeed: "B\u1EA1n c\xF3 th\u1EC3 t\u1EA1o m\u1EADt kh\u1EA9u m\u1EA1nh m\xE0 kh\xF4ng c\u1EA7n s\u1EED d\u1EE5ng k\xFD t\u1EF1 \u0111\u1EB7c bi\u1EC7t, s\u1ED1 ho\u1EB7c ch\u1EEF c\xE1i vi\u1EBFt hoa.",
        pwned: "N\u1EBFu b\u1EA1n s\u1EED d\u1EE5ng m\u1EADt kh\u1EA9u n\xE0y \u1EDF nh\u1EEFng n\u01A1i kh\xE1c, b\u1EA1n n\xEAn thay \u0111\u1ED5i n\xF3.",
        recentYears: "Tr\xE1nh c\xE1c n\u0103m g\u1EA7n \u0111\xE2y.",
        repeated: "Tr\xE1nh vi\u1EC7c l\u1EB7p l\u1EA1i t\u1EEB v\xE0 k\xFD t\u1EF1.",
        reverseWords: "Tr\xE1nh vi\u1EC7c vi\u1EBFt ng\u01B0\u1EE3c c\xE1c t\u1EEB th\xF4ng th\u01B0\u1EDDng.",
        sequences: "Tr\xE1nh c\xE1c chu\u1ED7i k\xFD t\u1EF1 th\xF4ng th\u01B0\u1EDDng.",
        useWords: "S\u1EED d\u1EE5ng nhi\u1EC1u t\u1EEB, nh\u01B0ng tr\xE1nh c\xE1c c\u1EE5m t\u1EEB th\xF4ng th\u01B0\u1EDDng."
      },
      warnings: {
        common: "\u0110\xE2y l\xE0 m\u1ED9t m\u1EADt kh\u1EA9u ph\u1ED5 bi\u1EBFn.",
        commonNames: "C\xE1c t\xEAn ri\xEAng v\xE0 h\u1ECD ph\u1ED5 bi\u1EBFn d\u1EC5 \u0111o\xE1n.",
        dates: "Ng\xE0y th\xE1ng d\u1EC5 \u0111o\xE1n.",
        extendedRepeat: 'C\xE1c m\u1EABu k\xFD t\u1EF1 l\u1EB7p l\u1EA1i nh\u01B0 "abcabcabc" d\u1EC5 \u0111o\xE1n.',
        keyPattern: "M\u1EABu b\xE0n ph\xEDm ng\u1EAFn d\u1EC5 \u0111o\xE1n.",
        namesByThemselves: "C\xE1c t\xEAn ri\xEAng ho\u1EB7c h\u1ECD ri\xEAng d\u1EC5 \u0111o\xE1n.",
        pwned: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\xE3 b\u1ECB r\xF2 r\u1EC9 qua m\u1ED9t cu\u1ED9c t\u1EA5n c\xF4ng d\u1EEF li\u1EC7u tr\xEAn Internet.",
        recentYears: "C\xE1c n\u0103m g\u1EA7n \u0111\xE2y d\u1EC5 \u0111o\xE1n.",
        sequences: 'C\xE1c chu\u1ED7i k\xFD t\u1EF1 ph\u1ED5 bi\u1EBFn nh\u01B0 "abc" d\u1EC5 \u0111o\xE1n.',
        similarToCommon: "\u0110\xE2y gi\u1ED1ng v\u1EDBi m\u1ED9t m\u1EADt kh\u1EA9u ph\u1ED5 bi\u1EBFn.",
        simpleRepeat: 'C\xE1c k\xFD t\u1EF1 l\u1EB7p l\u1EA1i nh\u01B0 "aaa" d\u1EC5 \u0111o\xE1n.',
        straightRow: "C\xE1c h\xE0ng ph\xEDm tr\xEAn b\xE0n ph\xEDm c\u1EE7a b\u1EA1n d\u1EC5 \u0111o\xE1n.",
        topHundred: "\u0110\xE2y l\xE0 m\u1ED9t m\u1EADt kh\u1EA9u \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng th\u01B0\u1EDDng xuy\xEAn.",
        topTen: "\u0110\xE2y l\xE0 m\u1ED9t m\u1EADt kh\u1EA9u \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng r\u1EA5t nhi\u1EC1u.",
        userInputs: "Kh\xF4ng n\xEAn c\xF3 b\u1EA5t k\u1EF3 d\u1EEF li\u1EC7u c\xE1 nh\xE2n ho\u1EB7c li\xEAn quan \u0111\u1EBFn trang web.",
        wordByItself: "M\u1ED9t t\u1EEB \u0111\u01A1n d\u1EC5 \u0111o\xE1n."
      }
    }
  },
  userButton: {
    action__addAccount: "Th\xEAm t\xE0i kho\u1EA3n",
    action__manageAccount: "Qu\u1EA3n l\xFD t\xE0i kho\u1EA3n",
    action__signOut: "\u0110\u0103ng xu\u1EA5t",
    action__signOutAll: "\u0110\u0103ng xu\u1EA5t kh\u1ECFi t\u1EA5t c\u1EA3 c\xE1c t\xE0i kho\u1EA3n"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u0110\xE3 sao ch\xE9p!",
      actionLabel__copy: "Sao ch\xE9p t\u1EA5t c\u1EA3",
      actionLabel__download: "T\u1EA3i xu\u1ED1ng .txt",
      actionLabel__print: "In",
      infoText1: "C\xE1c m\xE3 sao l\u01B0u s\u1EBD \u0111\u01B0\u1EE3c k\xEDch ho\u1EA1t cho t\xE0i kho\u1EA3n n\xE0y.",
      infoText2: "Gi\u1EEF c\xE1c m\xE3 sao l\u01B0u b\xED m\u1EADt v\xE0 l\u01B0u ch\xFAng m\u1ED9t c\xE1ch an to\xE0n. B\u1EA1n c\xF3 th\u1EC3 t\u1EA1o l\u1EA1i c\xE1c m\xE3 sao l\u01B0u n\u1EBFu b\u1EA1n nghi ng\u1EDD ch\xFAng \u0111\xE3 b\u1ECB x\xE2m ph\u1EA1m.",
      subtitle__codelist: "L\u01B0u ch\xFAng m\u1ED9t c\xE1ch an to\xE0n v\xE0 gi\u1EEF ch\xFAng b\xED m\u1EADt.",
      successMessage: "M\xE3 sao l\u01B0u \u0111\xE3 \u0111\u01B0\u1EE3c k\xEDch ho\u1EA1t. B\u1EA1n c\xF3 th\u1EC3 s\u1EED d\u1EE5ng m\u1ED9t trong c\xE1c m\xE3 n\xE0y \u0111\u1EC3 \u0111\u0103ng nh\u1EADp v\xE0o t\xE0i kho\u1EA3n c\u1EE7a m\xECnh, n\u1EBFu b\u1EA1n m\u1EA5t quy\u1EC1n truy c\u1EADp v\xE0o thi\u1EBFt b\u1ECB x\xE1c th\u1EF1c c\u1EE7a m\xECnh. M\u1ED7i m\xE3 ch\u1EC9 c\xF3 th\u1EC3 s\u1EED d\u1EE5ng m\u1ED9t l\u1EA7n.",
      successSubtitle: "B\u1EA1n c\xF3 th\u1EC3 s\u1EED d\u1EE5ng m\u1ED9t trong c\xE1c m\xE3 n\xE0y \u0111\u1EC3 \u0111\u0103ng nh\u1EADp v\xE0o t\xE0i kho\u1EA3n c\u1EE7a m\xECnh, n\u1EBFu b\u1EA1n m\u1EA5t quy\u1EC1n truy c\u1EADp v\xE0o thi\u1EBFt b\u1ECB x\xE1c th\u1EF1c c\u1EE7a m\xECnh.",
      title: "Th\xEAm m\xE3 x\xE1c th\u1EF1c sao l\u01B0u",
      title__codelist: "C\xE1c m\xE3 sao l\u01B0u"
    },
    connectedAccountPage: {
      formHint: "Ch\u1ECDn m\u1ED9t nh\xE0 cung c\u1EA5p \u0111\u1EC3 k\u1EBFt n\u1ED1i t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
      formHint__noAccounts: "Kh\xF4ng c\xF3 nh\xE0 cung c\u1EA5p t\xE0i kho\u1EA3n b\xEAn ngo\xE0i kh\u1EA3 d\u1EE5ng.",
      removeResource: {
        messageLine1: "{{identifier}} s\u1EBD b\u1ECB x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n n\xE0y.",
        messageLine2: "B\u1EA1n s\u1EBD kh\xF4ng th\u1EC3 s\u1EED d\u1EE5ng t\xE0i kho\u1EA3n li\xEAn k\u1EBFt n\xE0y v\xE0 b\u1EA5t k\u1EF3 t\xEDnh n\u0103ng ph\u1EE5 thu\u1ED9c n\xE0o s\u1EBD kh\xF4ng c\xF2n ho\u1EA1t \u0111\u1ED9ng.",
        successMessage: "{{connectedAccount}} \u0111\xE3 \u0111\u01B0\u1EE3c x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
        title: "X\xF3a t\xE0i kho\u1EA3n li\xEAn k\u1EBFt"
      },
      socialButtonsBlockButton: "K\u1EBFt n\u1ED1i t\xE0i kho\u1EA3n {{provider|titleize}}",
      successMessage: "Nh\xE0 cung c\u1EA5p \u0111\xE3 \u0111\u01B0\u1EE3c th\xEAm v\xE0o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n",
      title: "Th\xEAm t\xE0i kho\u1EA3n li\xEAn k\u1EBFt"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "X\xF3a t\xE0i kho\u1EA3n",
      messageLine1: "B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a t\xE0i kho\u1EA3n c\u1EE7a m\xECnh kh\xF4ng?",
      messageLine2: "H\xE0nh \u0111\u1ED9ng n\xE0y l\xE0 v\u0129nh vi\u1EC5n v\xE0 kh\xF4ng th\u1EC3 ho\xE0n t\xE1c.",
      title: "X\xF3a t\xE0i kho\u1EA3n"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "M\u1ED9t email ch\u1EE9a m\xE3 x\xE1c minh s\u1EBD \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 email n\xE0y.",
        formSubtitle: "Nh\u1EADp m\xE3 x\xE1c minh \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn {{identifier}}",
        formTitle: "M\xE3 x\xE1c minh",
        resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c m\xE3? G\u1EEDi l\u1EA1i",
        successMessage: "Email {{identifier}} \u0111\xE3 \u0111\u01B0\u1EE3c th\xEAm v\xE0o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n."
      },
      emailLink: {
        formHint: "M\u1ED9t email ch\u1EE9a li\xEAn k\u1EBFt x\xE1c minh s\u1EBD \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 email n\xE0y.",
        formSubtitle: "Nh\u1EA5p v\xE0o li\xEAn k\u1EBFt x\xE1c minh trong email \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn {{identifier}}",
        formTitle: "Li\xEAn k\u1EBFt x\xE1c minh",
        resendButton: "Kh\xF4ng nh\u1EADn \u0111\u01B0\u1EE3c li\xEAn k\u1EBFt? G\u1EEDi l\u1EA1i",
        successMessage: "Email {{identifier}} \u0111\xE3 \u0111\u01B0\u1EE3c th\xEAm v\xE0o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} s\u1EBD b\u1ECB x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n n\xE0y.",
        messageLine2: "B\u1EA1n s\u1EBD kh\xF4ng th\u1EC3 \u0111\u0103ng nh\u1EADp b\u1EB1ng \u0111\u1ECBa ch\u1EC9 email n\xE0y n\u1EEFa.",
        successMessage: "{{emailAddress}} \u0111\xE3 \u0111\u01B0\u1EE3c x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
        title: "X\xF3a \u0111\u1ECBa ch\u1EC9 email"
      },
      title: "Th\xEAm \u0111\u1ECBa ch\u1EC9 email",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Ti\u1EBFp t\u1EE5c",
    formButtonPrimary__finish: "Ho\xE0n th\xE0nh",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "H\u1EE7y",
    mfaPage: {
      formHint: "Ch\u1ECDn m\u1ED9t ph\u01B0\u01A1ng ph\xE1p \u0111\u1EC3 th\xEAm.",
      title: "Th\xEAm x\xE1c minh hai b\u01B0\u1EDBc"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "Th\xEAm s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
      removeResource: {
        messageLine1: "{{identifier}} s\u1EBD kh\xF4ng c\xF2n nh\u1EADn \u0111\u01B0\u1EE3c m\xE3 x\xE1c th\u1EF1c khi \u0111\u0103ng nh\u1EADp.",
        messageLine2: "T\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n c\xF3 th\u1EC3 kh\xF4ng an to\xE0n. B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n ti\u1EBFp t\u1EE5c kh\xF4ng?",
        successMessage: "X\xE1c th\u1EF1c hai b\u01B0\u1EDBc b\u1EB1ng m\xE3 SMS \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EE1 b\u1ECF cho {{mfaPhoneCode}}",
        title: "G\u1EE1 b\u1ECF x\xE1c th\u1EF1c hai b\u01B0\u1EDBc"
      },
      subtitle__availablePhoneNumbers: "Ch\u1ECDn m\u1ED9t s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EC3 \u0111\u0103ng k\xFD x\xE1c th\u1EF1c hai b\u01B0\u1EDBc b\u1EB1ng m\xE3 SMS.",
      subtitle__unavailablePhoneNumbers: "Kh\xF4ng c\xF3 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i n\xE0o kh\u1EA3 d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD x\xE1c th\u1EF1c hai b\u01B0\u1EDBc b\u1EB1ng m\xE3 SMS.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "Th\xEAm m\xE3 x\xE1c th\u1EF1c SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Qu\xE9t m\xE3 QR thay v\xEC \u0111\xF3",
        buttonUnableToScan__nonPrimary: "Kh\xF4ng th\u1EC3 qu\xE9t m\xE3 QR?",
        infoText__ableToScan: "Thi\u1EBFt l\u1EADp m\u1ED9t ph\u01B0\u01A1ng th\u1EE9c \u0111\u0103ng nh\u1EADp m\u1EDBi trong \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c c\u1EE7a b\u1EA1n v\xE0 qu\xE9t m\xE3 QR d\u01B0\u1EDBi \u0111\xE2y \u0111\u1EC3 li\xEAn k\u1EBFt n\xF3 v\u1EDBi t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
        infoText__unableToScan: "Thi\u1EBFt l\u1EADp m\u1ED9t ph\u01B0\u01A1ng th\u1EE9c \u0111\u0103ng nh\u1EADp m\u1EDBi trong \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c v\xE0 nh\u1EADp Kh\xF3a \u0111\u01B0\u1EE3c cung c\u1EA5p b\xEAn d\u01B0\u1EDBi.",
        inputLabel__unableToScan1: "\u0110\u1EA3m b\u1EA3o \u0111\xE3 k\xEDch ho\u1EA1t m\u1EADt kh\u1EA9u d\u1EF1a tr\xEAn th\u1EDDi gian ho\u1EB7c m\u1EADt kh\u1EA9u m\u1ED9t l\u1EA7n, sau \u0111\xF3 ho\xE0n th\xE0nh vi\u1EC7c li\xEAn k\u1EBFt t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
        inputLabel__unableToScan2: "Ho\u1EB7c n\u1EBFu \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c c\u1EE7a b\u1EA1n h\u1ED7 tr\u1EE3 TOTP URIs, b\u1EA1n c\u0169ng c\xF3 th\u1EC3 sao ch\xE9p to\xE0n b\u1ED9 URI."
      },
      removeResource: {
        messageLine1: "M\xE3 x\xE1c th\u1EF1c t\u1EEB \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c n\xE0y s\u1EBD kh\xF4ng c\xF2n \u0111\u01B0\u1EE3c y\xEAu c\u1EA7u khi \u0111\u0103ng nh\u1EADp.",
        messageLine2: "T\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n c\xF3 th\u1EC3 kh\xF4ng an to\xE0n. B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n ti\u1EBFp t\u1EE5c kh\xF4ng?",
        successMessage: "X\xE1c th\u1EF1c hai b\u01B0\u1EDBc qua \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EE1 b\u1ECF.",
        title: "G\u1EE1 b\u1ECF x\xE1c th\u1EF1c hai b\u01B0\u1EDBc"
      },
      successMessage: "X\xE1c th\u1EF1c hai b\u01B0\u1EDBc \u0111\xE3 \u0111\u01B0\u1EE3c k\xEDch ho\u1EA1t. Khi \u0111\u0103ng nh\u1EADp, b\u1EA1n s\u1EBD c\u1EA7n nh\u1EADp m\xE3 x\xE1c th\u1EF1c t\u1EEB \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c n\xE0y nh\u01B0 m\u1ED9t b\u01B0\u1EDBc b\u1ED5 sung.",
      title: "Th\xEAm \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c",
      verifySubtitle: "Nh\u1EADp m\xE3 x\xE1c th\u1EF1c \u0111\u01B0\u1EE3c t\u1EA1o b\u1EDFi \u1EE9ng d\u1EE5ng x\xE1c th\u1EF1c c\u1EE7a b\u1EA1n",
      verifyTitle: "M\xE3 x\xE1c th\u1EF1c"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Hi\u1EC7n t\u1EA1i b\u1EA1n kh\xF4ng th\u1EC3 ch\u1EC9nh s\u1EEDa m\u1EADt kh\u1EA9u v\xEC b\u1EA1n ch\u1EC9 c\xF3 th\u1EC3 \u0111\u0103ng nh\u1EADp qua k\u1EBFt n\u1ED1i doanh nghi\u1EC7p.",
      successMessage__set: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\xE3 \u0111\u01B0\u1EE3c thi\u1EBFt l\u1EADp.",
      successMessage__signOutOfOtherSessions: "T\u1EA5t c\u1EA3 c\xE1c thi\u1EBFt b\u1ECB kh\xE1c \u0111\xE3 \u0111\u01B0\u1EE3c \u0111\u0103ng xu\u1EA5t.",
      successMessage__update: "M\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n \u0111\xE3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.",
      title__set: "Thi\u1EBFt l\u1EADp m\u1EADt kh\u1EA9u",
      title__update: "Thay \u0111\u1ED5i m\u1EADt kh\u1EA9u"
    },
    phoneNumberPage: {
      infoText: "M\u1ED9t tin nh\u1EAFn ch\u1EE9a li\xEAn k\u1EBFt x\xE1c minh s\u1EBD \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn s\u1ED1 \u0111i\u1EC7n tho\u1EA1i n\xE0y.",
      removeResource: {
        messageLine1: "{{identifier}} s\u1EBD b\u1ECB x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n n\xE0y.",
        messageLine2: "B\u1EA1n s\u1EBD kh\xF4ng th\u1EC3 \u0111\u0103ng nh\u1EADp b\u1EB1ng s\u1ED1 \u0111i\u1EC7n tho\u1EA1i n\xE0y n\u1EEFa.",
        successMessage: "{{phoneNumber}} \u0111\xE3 \u0111\u01B0\u1EE3c x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
        title: "X\xF3a s\u1ED1 \u0111i\u1EC7n tho\u1EA1i"
      },
      successMessage: "{{identifier}} \u0111\xE3 \u0111\u01B0\u1EE3c th\xEAm v\xE0o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
      title: "Th\xEAm s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "T\u1EA3i l\xEAn \u1EA3nh JPG, PNG, GIF, ho\u1EB7c WEBP c\xF3 dung l\u01B0\u1EE3ng nh\u1ECF h\u01A1n 10 MB",
      imageFormDestructiveActionSubtitle: "X\xF3a \u1EA3nh",
      imageFormSubtitle: "T\u1EA3i \u1EA3nh l\xEAn",
      imageFormTitle: "H\xECnh \u1EA3nh h\u1ED3 s\u01A1",
      readonly: "Th\xF4ng tin h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n \u0111\xE3 \u0111\u01B0\u1EE3c cung c\u1EA5p b\u1EDFi k\u1EBFt n\u1ED1i doanh nghi\u1EC7p v\xE0 kh\xF4ng th\u1EC3 ch\u1EC9nh s\u1EEDa.",
      successMessage: "H\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n \u0111\xE3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.",
      title: "C\u1EADp nh\u1EADt h\u1ED3 s\u01A1"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0110\u0103ng xu\u1EA5t kh\u1ECFi thi\u1EBFt b\u1ECB",
        title: "Thi\u1EBFt b\u1ECB ho\u1EA1t \u0111\u1ED9ng"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Th\u1EED l\u1EA1i",
        actionLabel__reauthorize: "X\xE1c th\u1EF1c ngay",
        destructiveActionTitle: "X\xF3a",
        primaryButton: "K\u1EBFt n\u1ED1i t\xE0i kho\u1EA3n",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "T\xE0i kho\u1EA3n \u0111\xE3 k\u1EBFt n\u1ED1i"
      },
      dangerSection: {
        deleteAccountButton: "X\xF3a T\xE0i kho\u1EA3n",
        title: "Nguy hi\u1EC3m"
      },
      emailAddressesSection: {
        destructiveAction: "X\xF3a \u0111\u1ECBa ch\u1EC9 email",
        detailsAction__nonPrimary: "\u0110\u1EB7t l\xE0m ch\xEDnh",
        detailsAction__primary: "Ho\xE0n t\u1EA5t x\xE1c minh",
        detailsAction__unverified: "Ho\xE0n t\u1EA5t x\xE1c minh",
        primaryButton: "Th\xEAm \u0111\u1ECBa ch\u1EC9 email",
        title: "\u0110\u1ECBa ch\u1EC9 email"
      },
      enterpriseAccountsSection: {
        title: "T\xE0i kho\u1EA3n doanh nghi\u1EC7p"
      },
      headerTitle__account: "T\xE0i kho\u1EA3n",
      headerTitle__security: "B\u1EA3o m\u1EADt",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "T\u1EA1o l\u1EA1i m\xE3",
          headerTitle: "M\xE3 sao l\u01B0u",
          subtitle__regenerate: "Nh\u1EADn m\u1ED9t b\u1ED9 m\xE3 sao l\u01B0u an to\xE0n m\u1EDBi. C\xE1c m\xE3 sao l\u01B0u tr\u01B0\u1EDBc \u0111\xF3 s\u1EBD b\u1ECB x\xF3a v\xE0 kh\xF4ng th\u1EC3 s\u1EED d\u1EE5ng \u0111\u01B0\u1EE3c.",
          title__regenerate: "T\u1EA1o l\u1EA1i m\xE3 sao l\u01B0u"
        },
        phoneCode: {
          actionLabel__setDefault: "\u0110\u1EB7t l\xE0m m\u1EB7c \u0111\u1ECBnh",
          destructiveActionLabel: "X\xF3a s\u1ED1 \u0111i\u1EC7n tho\u1EA1i"
        },
        primaryButton: "Th\xEAm x\xE1c th\u1EF1c hai b\u01B0\u1EDBc",
        title: "X\xE1c th\u1EF1c hai b\u01B0\u1EDBc",
        totp: {
          destructiveActionTitle: "X\xF3a",
          headerTitle: "\u1EE8ng d\u1EE5ng x\xE1c th\u1EF1c"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u0110\u1EB7t m\u1EADt kh\u1EA9u",
        primaryButton__updatePassword: "Thay \u0111\u1ED5i m\u1EADt kh\u1EA9u",
        title: "M\u1EADt kh\u1EA9u"
      },
      phoneNumbersSection: {
        destructiveAction: "X\xF3a s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
        detailsAction__nonPrimary: "\u0110\u1EB7t l\xE0m ch\xEDnh",
        detailsAction__primary: "Ho\xE0n t\u1EA5t x\xE1c minh",
        detailsAction__unverified: "Ho\xE0n t\u1EA5t x\xE1c minh",
        primaryButton: "Th\xEAm s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
        title: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"
      },
      profileSection: {
        primaryButton: void 0,
        title: "H\u1ED3 s\u01A1"
      },
      usernameSection: {
        primaryButton__setUsername: "\u0110\u1EB7t t\xEAn ng\u01B0\u1EDDi d\xF9ng",
        primaryButton__updateUsername: "Thay \u0111\u1ED5i t\xEAn ng\u01B0\u1EDDi d\xF9ng",
        title: "T\xEAn ng\u01B0\u1EDDi d\xF9ng"
      },
      web3WalletsSection: {
        destructiveAction: "X\xF3a v\xED",
        primaryButton: "V\xED Web3",
        title: "V\xED Web3"
      }
    },
    usernamePage: {
      successMessage: "T\xEAn ng\u01B0\u1EDDi d\xF9ng c\u1EE7a b\u1EA1n \u0111\xE3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.",
      title__set: "C\u1EADp nh\u1EADt t\xEAn ng\u01B0\u1EDDi d\xF9ng",
      title__update: "C\u1EADp nh\u1EADt t\xEAn ng\u01B0\u1EDDi d\xF9ng"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} s\u1EBD b\u1ECB x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n n\xE0y.",
        messageLine2: "B\u1EA1n s\u1EBD kh\xF4ng th\u1EC3 \u0111\u0103ng nh\u1EADp b\u1EB1ng v\xED web3 n\xE0y n\u1EEFa.",
        successMessage: "{{web3Wallet}} \u0111\xE3 \u0111\u01B0\u1EE3c x\xF3a kh\u1ECFi t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
        title: "X\xF3a v\xED web3"
      },
      subtitle__availableWallets: "Ch\u1ECDn m\u1ED9t v\xED web3 \u0111\u1EC3 k\u1EBFt n\u1ED1i v\u1EDBi t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
      subtitle__unavailableWallets: "Kh\xF4ng c\xF3 v\xED web3 kh\u1EA3 d\u1EE5ng.",
      successMessage: "V\xED \u0111\xE3 \u0111\u01B0\u1EE3c th\xEAm v\xE0o t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
      title: "Th\xEAm v\xED web3",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/pl-PL.ts
var plPL = {
  locale: "pl-PL",
  backButton: "Powr\xF3t",
  badge__default: "Domy\u015Blny",
  badge__otherImpersonatorDevice: "Inne urz\u0105dzenie osobiste",
  badge__primary: "Podstawowy",
  badge__requiresAction: "Wymaga dzia\u0142ania",
  badge__thisDevice: "To urz\u0105dzenie",
  badge__unverified: "Niezweryfikowany",
  badge__userDevice: "Urz\u0105dzenie u\u017Cytkownika",
  badge__you: "Ty",
  createOrganization: {
    formButtonSubmit: "Utw\xF3rz organizacj\u0119",
    invitePage: {
      formButtonReset: "Pomi\u0144"
    },
    title: "Utw\xF3rz organizacj\u0119"
  },
  dates: {
    lastDay: "Wczoraj o godzinie {{ date | timeString('pl-PL') }}",
    next6Days: "{{ date | weekday('pl-PL','long') }} o godzinie {{ date | timeString('pl-PL') }}",
    nextDay: "Jutro o godzinie {{ date | timeString('pl-PL') }}",
    numeric: "{{ date | numeric('pl-PL') }}",
    previous6Days: "Ostatni(a) {{ date | weekday('pl-PL','long') }} o godzinie {{ date | timeString('pl-PL') }}",
    sameDay: "Dzisiaj o godzinie {{ date | timeString('pl-PL') }}"
  },
  dividerText: "lub",
  footerActionLink__useAnotherMethod: "U\u017Cyj innej metody",
  footerPageLink__help: "Pomoc",
  footerPageLink__privacy: "Prywatno\u015B\u0107",
  footerPageLink__terms: "Warunki",
  formButtonPrimary: "Kontynuuj",
  formButtonPrimary__verify: "Zweryfikuj",
  formFieldAction__forgotPassword: "Zapomnia\u0142em/am has\u0142a",
  formFieldError__matchingPasswords: "Has\u0142a si\u0119 zgadzaj\u0105.",
  formFieldError__notMatchingPasswords: "Has\u0142a si\u0119 nie zgadzaj\u0105.",
  formFieldError__verificationLinkExpired: "Link weryfikacyjny wygas\u0142. Spr\xF3buj ponownie.",
  formFieldHintText__optional: "Opcjonalne",
  formFieldHintText__slug: "Jest to unikalne ID, kt\xF3re jest czytelne dla cz\u0142owieka, cz\u0119sto u\u017Cywane w adresach URL.",
  formFieldInputPlaceholder__backupCode: "Wprowad\u017A kod zapasowy",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Usu\u0144 konto",
  formFieldInputPlaceholder__emailAddress: "Wprowad\u017A adres email",
  formFieldInputPlaceholder__emailAddress_username: "Adres e-mail lub nazwa u\u017Cytkownika",
  formFieldInputPlaceholder__emailAddresses: "Wprowad\u017A lub wklej jeden lub wi\u0119cej adres\xF3w e-mail, oddzielonych spacjami lub przecinkami",
  formFieldInputPlaceholder__firstName: "Imi\u0119",
  formFieldInputPlaceholder__lastName: "Nazwisko",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "jan.kowalski@example.com",
  formFieldInputPlaceholder__organizationName: "Nazwa organizacji",
  formFieldInputPlaceholder__organizationSlug: "moja-organizacja",
  formFieldInputPlaceholder__password: "Wprowad\u017A swoje has\u0142o",
  formFieldInputPlaceholder__phoneNumber: "Wprowad\u017A numer telefonu",
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "W\u0142\u0105cz automatyczne zaproszenia dla tej domeny",
  formFieldLabel__backupCode: "Kod zapasowy",
  formFieldLabel__confirmDeletion: "Potwierdzenie",
  formFieldLabel__confirmPassword: "Potwierd\u017A has\u0142o",
  formFieldLabel__currentPassword: "Obecne has\u0142o",
  formFieldLabel__emailAddress: "Adres e-mail",
  formFieldLabel__emailAddress_username: "Adres e-mail lub nazwa u\u017Cytkownika",
  formFieldLabel__emailAddresses: "Adresy e-mail",
  formFieldLabel__firstName: "Imi\u0119",
  formFieldLabel__lastName: "Nazwisko",
  formFieldLabel__newPassword: "Nowe has\u0142o",
  formFieldLabel__organizationDomain: "Domena",
  formFieldLabel__organizationDomainDeletePending: "Usu\u0144 oczekuj\u0105ce zaproszenia i propozycje",
  formFieldLabel__organizationDomainEmailAddress: "Weryfikacyjny adres e-mail",
  formFieldLabel__organizationDomainEmailAddressDescription: "Wprowad\u017A adres e-mail w tej domenie, aby otrzyma\u0107 kod i zweryfikowa\u0107 t\u0119 domen\u0119.",
  formFieldLabel__organizationName: "Nazwa organizacji",
  formFieldLabel__organizationSlug: "Slug URL",
  formFieldLabel__passkeyName: "Nazwa klucza dost\u0119pu",
  formFieldLabel__password: "Has\u0142o",
  formFieldLabel__phoneNumber: "Numer telefonu",
  formFieldLabel__role: "Rola",
  formFieldLabel__signOutOfOtherSessions: "Wyloguj si\u0119 ze wszystkich innych urz\u0105dze\u0144",
  formFieldLabel__username: "Nazwa u\u017Cytkownika",
  impersonationFab: {
    action__signOut: "Wyloguj",
    title: "Zalogowano jako {{identifier}}"
  },
  maintenanceMode: "Aktualnie trwaj\u0105 prace konserwacyjne, ale nie powinno to zaj\u0105\u0107 d\u0142u\u017Cej ni\u017C kilka minut.",
  membershipRole__admin: "Administrator",
  membershipRole__basicMember: "U\u017Cytkownik",
  membershipRole__guestMember: "Go\u015B\u0107",
  organizationList: {
    action__createOrganization: "Stw\xF3rz organizacj\u0119",
    action__invitationAccept: "Do\u0142\u0105cz",
    action__suggestionsAccept: "Popro\u015B o do\u0142\u0105czenie",
    createOrganization: "Stw\xF3rz organizacj\u0119",
    invitationAcceptedLabel: "Do\u0142\u0105czono",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Wybierz konto",
    titleWithoutPersonal: "Wybierz organizacj\u0119"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatyczne zaproszenia",
    badge__automaticSuggestion: "Automatyczne sugestie",
    badge__manualInvitation: "Brak automatycznej rejestracji",
    badge__unverified: "Niezweryfikowany",
    createDomainPage: {
      subtitle: "Dodaj domen\u0119 do weryfikacji. U\u017Cytkownicy z adresami e-mail w tej domenie mog\u0105 do\u0142\u0105czy\u0107 do organizacji automatycznie lub poprosi\u0107 o do\u0142\u0105czenie.",
      title: "Dodaj domen\u0119"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Nie uda\u0142o si\u0119 wys\u0142a\u0107 zaprosze\u0144. Napraw poni\u017Csze problemy i spr\xF3buj ponownie:",
      formButtonPrimary__continue: "Wy\u015Blij zaproszenia",
      selectDropdown__role: "Wybierz rol\u0119",
      subtitle: "Zapro\u015B nowych u\u017Cytkownik\xF3w do tej organizacji",
      successMessage: "Zaproszenia zosta\u0142y pomy\u015Blnie wys\u0142ane",
      title: "Zapro\u015B u\u017Cytkownik\xF3w"
    },
    membersPage: {
      action__invite: "Zapro\u015B",
      action__search: "Wyszukaj",
      activeMembersTab: {
        menuAction__remove: "Usu\u0144 u\u017Cytkownika",
        tableHeader__actions: "Akcje",
        tableHeader__joined: "Do\u0142\u0105czy\u0142",
        tableHeader__role: "Rola",
        tableHeader__user: "U\u017Cytkownik"
      },
      detailsTitle__emptyRow: "Brak u\u017Cytkownik\xF3w do wy\u015Bwietlenia",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Zapro\u015B u\u017Cytkownik\xF3w, \u0142\u0105cz\u0105c domen\u0119 e-mail ze swoj\u0105 organizacj\u0105. Ka\u017Cdy, kto zarejestruje si\u0119 za pomoc\u0105 pasuj\u0105cej domeny e-mail, b\u0119dzie m\xF3g\u0142 do\u0142\u0105czy\u0107 do organizacji w dowolnym momencie.",
          headerTitle: "Automatyczne zaproszenia",
          primaryButton: "Zarz\u0105dzanie zweryfikowanymi domenami"
        },
        table__emptyRow: "Brak zaprosze\u0144 do wy\u015Bwietlenia"
      },
      invitedMembersTab: {
        menuAction__revoke: "Anuluj zaproszenie",
        tableHeader__invited: "Zaproszony"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "U\u017Cytkownicy, kt\xF3rzy zarejestruj\u0105 si\u0119 za pomoc\u0105 pasuj\u0105cej domeny e-mail, b\u0119d\u0105 mogli zobaczy\u0107 propozycj\u0119, aby poprosi\u0107 o do\u0142\u0105czenie do Twojej organizacji.",
          headerTitle: "Automatyczne propozycje",
          primaryButton: "Zarz\u0105dzanie zweryfikowanymi domenami"
        },
        menuAction__approve: "Zatwierd\u017A",
        menuAction__reject: "Odrzu\u0107",
        tableHeader__requested: "Pro\u015Bby o dost\u0119p",
        table__emptyRow: "Brak pr\xF3\u015Bb do wy\u015Bwietlenia"
      },
      start: {
        headerTitle__invitations: "Zaproszenia",
        headerTitle__members: "Cz\u0142onkowie",
        headerTitle__requests: "Pro\u015Bby"
      }
    },
    navbar: {
      description: "Zarz\u0105dzaj organizacj\u0105.",
      general: "G\u0142\xF3wne",
      members: "Cz\u0142onkowie",
      title: "Organizacja"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Wpisz "{{organizationName}}" poni\u017Cej aby kontynuowa\u0107.',
          messageLine1: "Czy na pewno chcesz usun\u0105\u0107 t\u0119 organizacj\u0119?",
          messageLine2: "To dzia\u0142anie jest trwa\u0142e i nieodwracalne.",
          successMessage: "Organizacja zosta\u0142a usuni\u0119ta.",
          title: "Usu\u0144 organizacj\u0119"
        },
        leaveOrganization: {
          actionDescription: 'Wpisz "{{organizationName}}" poni\u017Cej aby kontynuowa\u0107.',
          messageLine1: "Czy na pewno chcesz opu\u015Bci\u0107 t\u0119 organizacj\u0119? Stracisz dost\u0119p do tej organizacji i jej aplikacji.",
          messageLine2: "Ta akcja jest trwa\u0142a i nieodwracalna.",
          successMessage: "Opu\u015Bci\u0142e\u015B organizacj\u0119.",
          title: "Opu\u015B\u0107 organizacj\u0119"
        },
        title: "Zagro\u017Cenie"
      },
      domainSection: {
        menuAction__manage: "Zarz\u0105dzaj",
        menuAction__remove: "Usu\u0144",
        menuAction__verify: "Zweryfikuj",
        primaryButton: "Dodaj domen\u0119",
        subtitle: "Zezwalaj u\u017Cytkownikom na automatyczne do\u0142\u0105czanie do organizacji lub \u017C\u0105daj do\u0142\u0105czenia na podstawie zweryfikowanej domeny e-mail.",
        title: "Zweryfikowane domeny"
      },
      successMessage: "Organizacja zosta\u0142a zaktualizowana.",
      title: "Profil organizacji"
    },
    removeDomainPage: {
      messageLine1: "Domena e-mail {{domain}} zostanie usuni\u0119ta.",
      messageLine2: "Po wykonaniu tej czynno\u015Bci u\u017Cytkownicy nie b\u0119d\u0105 mogli automatycznie do\u0142\u0105czy\u0107 do organizacji.",
      successMessage: "Domena {{domain}} zosta\u0142a usuni\u0119ta.",
      title: "Usu\u0144 domen\u0119"
    },
    start: {
      headerTitle__general: "Og\xF3lne",
      headerTitle__members: "Cz\u0142onkowie",
      profileSection: {
        primaryButton: void 0,
        title: "Profil organizacji",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Usuni\u0119cie tej domeny wp\u0142ynie na zaproszonych u\u017Cytkownik\xF3w.",
        removeDomainActionLabel__remove: "Usu\u0144 domen\u0119",
        removeDomainSubtitle: "Usu\u0144 t\u0105 domen\u0119 ze zweryfikowanych domen",
        removeDomainTitle: "Usu\u0144 domen\u0119"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "U\u017Cytkownicy s\u0105 automatycznie zapraszani do do\u0142\u0105czenia do organizacji podczas rejestracji i mog\u0105 do\u0142\u0105czy\u0107 w dowolnym momencie.",
        automaticInvitationOption__label: "Automatyczne zaproszenia",
        automaticSuggestionOption__description: "U\u017Cytkownicy otrzymuj\u0105 propozycj\u0119, aby poprosi\u0107 o do\u0142\u0105czenie, ale musz\u0105 zosta\u0107 zatwierdzeni przez administratora, zanim b\u0119d\u0105 mogli do\u0142\u0105czy\u0107 do organizacji.",
        automaticSuggestionOption__label: "Automatyczne propozycje",
        calloutInfoLabel: "Zmiana trybu rejestracji b\u0119dzie mia\u0142a wp\u0142yw tylko na nowych u\u017Cytkownik\xF3w.",
        calloutInvitationCountLabel: "Oczekuj\u0105ce zaproszenia wys\u0142ane do u\u017Cytkownik\xF3w: {{count}}",
        calloutSuggestionCountLabel: "Oczekuj\u0105ce propozycje wys\u0142ane do u\u017Cytkownik\xF3w: {{count}}",
        manualInvitationOption__description: "U\u017Cytkownik\xF3w mo\u017Cna zaprasza\u0107 do organizacji wy\u0142\u0105cznie r\u0119cznie.",
        manualInvitationOption__label: "Brak automatycznej rejestracji",
        subtitle: "Wybierz spos\xF3b, w jaki u\u017Cytkownicy z tej domeny mog\u0105 do\u0142\u0105czy\u0107 do organizacji."
      },
      start: {
        headerTitle__danger: "Zagro\u017Cenie",
        headerTitle__enrollment: "Opcje rejestracji"
      },
      subtitle: "Domena {{domain}} zosta\u0142a zweryfikowana. Kontynuuj, wybieraj\u0105c opcje rejestracji",
      title: "Zaktualizuj {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Wprowad\u017A kod weryfikacyjny wys\u0142any na Tw\xF3j adres e-mail",
      formTitle: "Kod weryfikacyjny",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "Domena {{domainName}} musi zosta\u0107 zweryfikowana przez e-mail.",
      subtitleVerificationCodeScreen: "Kod weryfikacyjny zosta\u0142 wys\u0142any na adres {{emailAddress}}. Wprowad\u017A kod, aby kontynuowa\u0107.",
      title: "Zweryfikuj domen\u0119"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Utw\xF3rz organizacj\u0119",
    action__invitationAccept: "Do\u0142\u0105cz",
    action__manageOrganization: "Zarz\u0105dzaj organizacj\u0105",
    action__suggestionsAccept: "Pro\u015Bba o do\u0142\u0105czenie",
    notSelected: "Nie wybrano organizacji",
    personalWorkspace: "Przestrze\u0144 osobista",
    suggestionsAcceptedLabel: "Oczekiwanie na zatwierdzenie"
  },
  paginationButton__next: "Nast\u0119pny",
  paginationButton__previous: "Poprzedni",
  paginationRowText__displaying: "Wy\u015Bwietlanie",
  paginationRowText__of: "z",
  reverification: {
    alternativeMethods: {
      actionLink: "Uzyskaj pomoc",
      actionText: "Nie u\u017Cywasz \u017Cadnej z tych metod?",
      blockButton__backupCode: "U\u017Cyj kodu zapasowego",
      blockButton__emailCode: "Wy\u015Blij kod e-mailem do {{identifier}}",
      blockButton__password: "Zaloguj si\u0119 za pomoc\u0105 has\u0142a",
      blockButton__phoneCode: "Wy\u015Blij kod SMS-em do {{identifier}}",
      blockButton__totp: "U\u017Cyj aplikacji uwierzytelniaj\u0105cej",
      getHelp: {
        blockButton__emailSupport: "Skontaktuj si\u0119 z pomoc\u0105",
        content: "Je\u015Bli masz problem z weryfikacj\u0105 konta, wy\u015Blij do nas e-mail, a postaramy si\u0119 jak najszybciej przywr\xF3ci\u0107 dost\u0119p.",
        title: "Uzyskaj wsparcie"
      },
      subtitle: "Masz problem? Mo\u017Cesz u\u017Cy\u0107 dowolnej z tych metod weryfikacji.",
      title: "U\u017Cyj innej metody"
    },
    backupCodeMfa: {
      subtitle: "Tw\xF3j kod zapasowy to ten, kt\xF3ry otrzyma\u0142e\u015B podczas konfigurowania uwierzytelniania dwuetapowego.",
      title: "Wprowad\u017A kod zapasowy"
    },
    emailCode: {
      formTitle: "Kod weryfikacyjny",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "Wprowad\u017A kod wys\u0142any na Tw\xF3j adres e-mail, aby kontynuowa\u0107",
      title: "Wymagana weryfikacja"
    },
    noAvailableMethods: {
      message: "Nie mo\u017Cna kontynuowa\u0107 weryfikacji. Brak dost\u0119pnych czynnik\xF3w uwierzytelniania.",
      subtitle: "Wyst\u0105pi\u0142 b\u0142\u0105d",
      title: "Nie mo\u017Cemy zweryfikowa\u0107 twojego konta"
    },
    password: {
      actionLink: "U\u017Cyj innej metody",
      subtitle: "Wprowad\u017A has\u0142o, aby kontynuowa\u0107",
      title: "Wymagana weryfikacja"
    },
    phoneCode: {
      formTitle: "Kod weryfikacyjny",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "Wprowad\u017A kod wys\u0142any na Tw\xF3j telefon, aby kontynuowa\u0107",
      title: "Wymagana weryfikacja"
    },
    phoneCodeMfa: {
      formTitle: "Kod weryfikacyjny",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "Aby kontynuowa\u0107, wprowad\u017A kod weryfikacyjny wys\u0142any na tw\xF3j telefon",
      title: "Wymagana weryfikacja"
    },
    totpMfa: {
      formTitle: "Kod weryfikacyjny",
      subtitle: "Aby kontynuowa\u0107, wprowad\u017A kod weryfikacyjny wygenerowany przez swoj\u0105 aplikacj\u0119 uwierzytelniaj\u0105c\u0105",
      title: "Wymagana weryfikacja"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Dodaj konto",
      action__signOutAll: "Wyloguj si\u0119 ze wszystkich kont",
      subtitle: "Wybierz konto, na kt\xF3rym chcesz kontynuowa\u0107.",
      title: "Wybierz konto"
    },
    alternativeMethods: {
      actionLink: "Uzyskaj pomoc",
      actionText: "Nie u\u017Cywasz \u017Cadnej z tych metod?",
      blockButton__backupCode: "U\u017Cyj kodu zapasowego",
      blockButton__emailCode: "Wy\u015Blij kod do {{identifier}}",
      blockButton__emailLink: "Wy\u015Blij link do {{identifier}}",
      blockButton__passkey: "Zaloguj si\u0119 za pomoc\u0105 klucza dost\u0119powego",
      blockButton__password: "Zaloguj si\u0119 za pomoc\u0105 has\u0142a",
      blockButton__phoneCode: "Wy\u015Blij kod do {{identifier}}",
      blockButton__totp: "U\u017Cyj aplikacji uwierzytelniaj\u0105cej",
      getHelp: {
        blockButton__emailSupport: "Wy\u015Blij e-mail do pomocy technicznej",
        content: "Je\u015Bli masz problem z zalogowaniem si\u0119 do swojego konta, wy\u015Blij do nas e-mail, a postaramy si\u0119 jak najszybciej przywr\xF3ci\u0107 dost\u0119p.",
        title: "Uzyskaj pomoc"
      },
      subtitle: "Masz problem? Mo\u017Cesz u\u017Cy\u0107 dowolnej z tych metod weryfikacji.",
      title: "U\u017Cyj innego sposobu"
    },
    backupCodeMfa: {
      subtitle: "aby przej\u015B\u0107 do {{applicationName}}",
      title: "Wprowad\u017A kod zapasowy"
    },
    emailCode: {
      formTitle: "Kod weryfikacyjny",
      resendButton: "Wy\u015Blij kod ponownie",
      subtitle: "aby kontynuowa\u0107 w {{applicationName}}",
      title: "Sprawd\u017A swoj\u0105 poczt\u0119 e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Aby kontynuowa\u0107, otw\xF3rz link weryfikacyjny na urz\u0105dzeniu i w przegl\u0105darce, w kt\xF3rej rozpocz\u0105\u0142e\u015B logowanie",
        title: "Link weryfikacyjny jest nieprawid\u0142owy dla tego urz\u0105dzenia"
      },
      expired: {
        subtitle: "Powr\xF3\u0107 do oryginalnej karty, aby kontynuowa\u0107.",
        title: "Ten link weryfikacyjny wygas\u0142"
      },
      failed: {
        subtitle: "Powr\xF3\u0107 do oryginalnej karty, aby kontynuowa\u0107.",
        title: "Ten link weryfikacyjny jest nieprawid\u0142owy"
      },
      formSubtitle: "U\u017Cyj linku weryfikacyjnego wys\u0142anego na Tw\xF3j adres e-mail",
      formTitle: "Link weryfikacyjny",
      loading: {
        subtitle: "Zostaniesz przekierowany wkr\xF3tce",
        title: "Logowanie..."
      },
      resendButton: "Wy\u015Blij link ponownie",
      subtitle: "aby kontynuowa\u0107 w {{applicationName}}",
      title: "Sprawd\u017A swoj\u0105 poczt\u0119 e-mail",
      unusedTab: {
        title: "Mo\u017Cesz zamkn\u0105\u0107 t\u0119 kart\u0119"
      },
      verified: {
        subtitle: "Zostaniesz przekierowany wkr\xF3tce",
        title: "Pomy\u015Blnie zalogowano"
      },
      verifiedSwitchTab: {
        subtitle: "Powr\xF3\u0107 do oryginalnej karty, aby kontynuowa\u0107",
        subtitleNewTab: "Powr\xF3\u0107 do nowo otwartej karty, aby kontynuowa\u0107",
        titleNewTab: "Zalogowano na innej karcie"
      }
    },
    forgotPassword: {
      formTitle: "Kod werfikacyjny resetowania has\u0142a",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "aby zresetowa\u0107 has\u0142o",
      subtitle_email: "Najpierw wprowad\u017A kod wys\u0142any na Tw\xF3j adres e-mail",
      subtitle_phone: "Najpierw wprowad\u017A kod wys\u0142any na Tw\xF3j numer telefonu",
      title: "Zmie\u0144 has\u0142o"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Zresetuj has\u0142o",
      label__alternativeMethods: "Lub zaloguj si\u0119 za pomoc\u0105 innej metody",
      title: "Zapomnia\u0142e\u015B has\u0142a?"
    },
    noAvailableMethods: {
      message: "Nie mo\u017Cna kontynuowa\u0107 logowania. Brak dost\u0119pnych czynnik\xF3w uwierzytelniaj\u0105cych.",
      subtitle: "Wyst\u0105pi\u0142 b\u0142\u0105d",
      title: "Nie mo\u017Cna si\u0119 zalogowa\u0107"
    },
    passkey: {
      subtitle: "U\u017Cycie klucza dost\u0119pu potwierdza, \u017Ce to Ty. Urz\u0105dzenie mo\u017Ce poprosi\u0107 o tw\xF3j odcisk palca, twarz lub blokad\u0119 ekranu.",
      title: "U\u017Cyj swojego klucza dost\u0119powego"
    },
    password: {
      actionLink: "U\u017Cyj innego sposobu",
      subtitle: "aby kontynuowa\u0107 w {{applicationName}}",
      title: "Wprowad\u017A swoje has\u0142o"
    },
    passwordPwned: {
      title: "Has\u0142o skompromitowane"
    },
    phoneCode: {
      formTitle: "Kod weryfikacyjny",
      resendButton: "Wy\u015Blij kod ponownie",
      subtitle: "aby przej\u015B\u0107 do {{applicationName}}",
      title: "Sprawd\u017A sw\xF3j telefon"
    },
    phoneCodeMfa: {
      formTitle: "Kod weryfikacyjny",
      resendButton: "Wy\u015Blij kod ponownie",
      subtitle: "Aby kontynuowa\u0107, wprowad\u017A kod weryfikacyjny wys\u0142any na Tw\xF3j telefon",
      title: "Sprawd\u017A sw\xF3j telefon"
    },
    resetPassword: {
      formButtonPrimary: "Zmie\u0144 has\u0142o",
      requiredMessage: "Z powod\xF3w bezpiecze\u0144stwa konieczne jest zresetowanie has\u0142a.",
      successMessage: "Twoje has\u0142o zosta\u0142o pomy\u015Blnie zresetowane. Logujemy Ci\u0119, prosz\u0119 czeka\u0107...",
      title: "Ustaw nowe has\u0142o"
    },
    resetPasswordMfa: {
      detailsLabel: "Przed zresetowaniem has\u0142a musimy zweryfikowa\u0107 to\u017Csamo\u015B\u0107 u\u017Cytkownika."
    },
    start: {
      actionLink: "Zarejestruj si\u0119",
      actionLink__join_waitlist: "Do\u0142\u0105cz do listy oczekuj\u0105cych",
      actionLink__use_email: "U\u017Cyj adresu e-mail",
      actionLink__use_email_username: "U\u017Cyj adresu e-mail lub nazwy u\u017Cytkownika",
      actionLink__use_passkey: "U\u017Cyj klucza dost\u0119powego",
      actionLink__use_phone: "U\u017Cyj numeru telefonu",
      actionLink__use_username: "U\u017Cyj nazwy u\u017Cytkownika",
      actionText: "Nie masz konta?",
      actionText__join_waitlist: "Chcesz otrzyma\u0107 wczesny dost\u0119p?",
      subtitle: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      subtitleCombined: void 0,
      title: "Zaloguj si\u0119",
      titleCombined: "Kontynuuj do {{applicationName}}"
    },
    totpMfa: {
      formTitle: "Kod weryfikacyjny",
      subtitle: "Aby kontynuowa\u0107, wprowad\u017A kod weryfikacyjny wygenerowany przez aplikacj\u0119 uwierzytelniaj\u0105c\u0105",
      title: "Weryfikacja dwustopniowa"
    }
  },
  signInEnterPasswordTitle: "Wprowad\u017A swoje has\u0142o",
  signUp: {
    continue: {
      actionLink: "Zaloguj si\u0119",
      actionText: "Masz ju\u017C konto?",
      subtitle: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      title: "Uzupe\u0142nij brakuj\u0105ce pola"
    },
    emailCode: {
      formSubtitle: "Wprowad\u017A kod weryfikacyjny wys\u0142any na Tw\xF3j adres e-mail",
      formTitle: "Kod weryfikacyjny",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      title: "Zweryfikuj sw\xF3j adres e-mail"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Aby kontynuowa\u0107, otw\xF3rz link weryfikacyjny na urz\u0105dzeniu i w przegl\u0105darce, w kt\xF3rej rozpocz\u0105\u0142e\u015B rejestracj\u0119",
        title: "Link weryfikacyjny jest nieprawid\u0142owy dla tego urz\u0105dzenia"
      },
      formSubtitle: "U\u017Cyj linku weryfikacyjnego wys\u0142anego na Tw\xF3j adres e-mail",
      formTitle: "Link weryfikacyjny",
      loading: {
        title: "Rejestrowanie..."
      },
      resendButton: "Nie otrzyma\u0142e\u015B linku? Wy\u015Blij ponownie",
      subtitle: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      title: "Zweryfikuj sw\xF3j adres e-mail",
      verified: {
        title: "Pomy\u015Blnie zarejestrowano"
      },
      verifiedSwitchTab: {
        subtitle: "Powr\xF3\u0107 do nowo otwartej karty, aby kontynuowa\u0107",
        subtitleNewTab: "Powr\xF3\u0107 do poprzedniej karty, aby kontynuowa\u0107",
        title: "Adres e-mail zosta\u0142 pomy\u015Blnie zweryfikowany"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Akceptuj\u0119 {{ privacyPolicyLink || link("Polityk\u0119 prywatno\u015Bci") }}',
        label__onlyTermsOfService: 'Akceptuj\u0119 {{ termsOfServiceLink || link("Warunki \u015Bwiadczenia us\u0142ugi") }}"',
        label__termsOfServiceAndPrivacyPolicy: 'Akceptuj\u0119 {{ termsOfServiceLink || link("Warunki \u015Bwiadczenia us\u0142ugi") }} i {{ privacyPolicyLink || link("Polityk\u0119 prywatno\u015Bci") }}'
      },
      continue: {
        subtitle: "Przeczytaj i zaakceptuj warunki, aby kontynuowa\u0107",
        title: "Zgoda prawna"
      }
    },
    phoneCode: {
      formSubtitle: "Wprowad\u017A kod weryfikacyjny wys\u0142any na Tw\xF3j numer telefonu",
      formTitle: "Kod weryfikacyjny",
      resendButton: "Nie otrzyma\u0142e\u015B kodu? Wy\u015Blij ponownie",
      subtitle: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      title: "Zweryfikuj sw\xF3j numer telefonu"
    },
    restrictedAccess: {
      actionLink: "Zaloguj si\u0119",
      actionText: "Masz ju\u017C konto?",
      blockButton__emailSupport: "Skontaktuj si\u0119 z pomoc\u0105",
      blockButton__joinWaitlist: "Do\u0142\u0105cz do listy oczekuj\u0105cych",
      subtitle: "Rejestracja jest obecnie wy\u0142\u0105czona. Je\u015Bli uwa\u017Casz, \u017Ce powiniene\u015B mie\u0107 dost\u0119p, skontaktuj si\u0119 z pomoc\u0105.",
      subtitleWaitlist: "Rejestracja jest obecnie wy\u0142\u0105czona. Aby dowiedzie\u0107 si\u0119 jako pierwszy o naszym starcie, do\u0142\u0105cz do listy oczekuj\u0105cych.",
      title: "Dost\u0119p ograniczony"
    },
    start: {
      actionLink: "Zaloguj si\u0119",
      actionLink__use_email: "U\u017Cyj adresu e-mail",
      actionLink__use_phone: "U\u017Cyj numeru telefonu",
      actionText: "Masz ju\u017C konto?",
      subtitle: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      subtitleCombined: "by przej\u015B\u0107 do aplikacji {{applicationName}}",
      title: "Utw\xF3rz swoje konto",
      titleCombined: "Utw\xF3rz swoje konto"
    }
  },
  socialButtonsBlockButton: "Kontynuuj z {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} jest ju\u017C cz\u0142onkiem organizacji.",
    captcha_invalid: "Rejestracja nie powiod\u0142a si\u0119 z powodu niepowodzenia weryfikacji zabezpiecze\u0144. Od\u015Bwie\u017C stron\u0119, aby spr\xF3bowa\u0107 ponownie lub skontaktuj si\u0119 z pomoc\u0105, aby uzyska\u0107 wsparcie.",
    captcha_unavailable: "Rejestracja nie powiod\u0142a si\u0119 z powodu niedost\u0119pno\u015Bci weryfikacji bot\xF3w. Od\u015Bwie\u017C stron\u0119, aby spr\xF3bowa\u0107 ponownie lub skontaktuj si\u0119 z pomoc\u0105, aby uzyska\u0107 wsparcie.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "Adres e-mail jest ju\u017C zaj\u0119ty. Prosz\u0119 spr\xF3bowa\u0107 innego.",
    form_identifier_exists__phone_number: "Ten numer telefonu jest zaj\u0119ty. Spr\xF3buj u\u017Cy\u0107 innego.",
    form_identifier_exists__username: "Ta nazwa u\u017Cytkownika jest zaj\u0119ta. Spr\xF3buj u\u017Cy\u0107 innej.",
    form_identifier_not_found: "Nie znaleziono konta o tym identyfikatorze. Sprawd\u017A i spr\xF3buj ponownie.",
    form_param_format_invalid: "Wprowadzona warto\u015B\u0107 ma nieprawid\u0142owy format. Sprawd\u017A i popraw j\u0105.",
    form_param_format_invalid__email_address: "Adres e-mail powinien by\u0107 poprawnym adresem e-mail.",
    form_param_format_invalid__phone_number: "Numer telefonu powinien mie\u0107 prawid\u0142owy format mi\u0119dzynarodowy",
    form_param_max_length_exceeded__first_name: "Imi\u0119 nie powinno przekracza\u0107 256 znak\xF3w.",
    form_param_max_length_exceeded__last_name: "Nazwisko nie powinno przekracza\u0107 256 znak\xF3w.",
    form_param_max_length_exceeded__name: "Nazwa nie powinna przekracza\u0107 256 znak\xF3w.",
    form_param_nil: "To pole jest wymagane i nie mo\u017Ce by\u0107 puste.",
    form_param_value_invalid: "Wprowadzona warto\u015B\u0107 jest nieprawid\u0142owa. Popraw j\u0105.",
    form_password_incorrect: "Wprowadzone has\u0142o jest nieprawid\u0142owe. Spr\xF3buj ponownie.",
    form_password_length_too_short: "Twoje has\u0142o jest zbyt kr\xF3tkie. Musi mie\u0107 co najmniej 8 znak\xF3w.",
    form_password_not_strong_enough: "Twoje has\u0142o nie jest wystarczaj\u0105co silne",
    form_password_pwned: "To has\u0142o zosta\u0142o znalezione w wyniku w\u0142amania i nie mo\u017Cna go u\u017Cy\u0107. Zamiast tego spr\xF3buj u\u017Cy\u0107 innego has\u0142a.",
    form_password_pwned__sign_in: "To has\u0142o zosta\u0142o znalezione w wyniku w\u0142amania i nie mo\u017Cna go u\u017Cy\u0107. Zresetuj has\u0142o.",
    form_password_size_in_bytes_exceeded: "Twoje has\u0142o przekroczy\u0142o maksymaln\u0105 dozwolon\u0105 liczb\u0119 bajt\xF3w, skr\xF3\u0107 je lub usu\u0144 niekt\xF3re znaki specjalne.",
    form_password_validation_failed: "Podane has\u0142o jest nieprawid\u0142owe",
    form_username_invalid_character: "Twoja nazwa u\u017Cytkownika zawiera nieprawid\u0142owe znaki. Prosimy o u\u017Cywanie wy\u0142\u0105cznie liter, cyfr i podkre\u015Ble\u0144.",
    form_username_invalid_length: "Nazwa u\u017Cytkownika musi zawiera\u0107 od {{min_length}} do {{max_length}} znak\xF3w.",
    identification_deletion_failed: "Nie mo\u017Cna usun\u0105\u0107 ostatniego identyfikatora.",
    not_allowed_access: "Nie masz uprawnie\u0144 dost\u0119pu do tej strony. Je\u015Bli uwa\u017Casz, \u017Ce jest to b\u0142\u0105d, skontaktuj si\u0119 z pomoc\u0105.",
    organization_domain_blocked: "To jest zablokowana domena dostawcy poczty e-mail. U\u017Cyj innej domeny.",
    organization_domain_common: "To jest popularna domena dostawcy poczty e-mail. U\u017Cyj innej domeny.",
    organization_domain_exists_for_enterprise_connection: "Ta domena jest ju\u017C u\u017Cywana do logowania jednokrotnego w organizacji.",
    organization_membership_quota_exceeded: "Osi\u0105gni\u0119to limit cz\u0142onkostwa w organizacji, w tym zaleg\u0142ych zaprosze\u0144.",
    organization_minimum_permissions_needed: "Musi istnie\u0107 co najmniej jeden cz\u0142onek organizacji z minimalnymi wymaganymi uprawnieniami.",
    passkey_already_exists: "Klucz dost\u0119pu jest ju\u017C zarejestrowany w tym urz\u0105dzeniu.",
    passkey_not_supported: "Klucze dost\u0119pu nie s\u0105 obs\u0142ugiwane przez to urz\u0105dzenie.",
    passkey_pa_not_supported: "Rejestracja wymaga platformy uwierzytelniaj\u0105cej, ale urz\u0105dzenie jej nie obs\u0142uguje.",
    passkey_registration_cancelled: "Rejestracja klucza dost\u0119pu zosta\u0142a anulowana lub up\u0142yn\u0105\u0142 jej limit czasu.",
    passkey_retrieval_cancelled: "Weryfikacja klucza dost\u0119pu zosta\u0142a anulowana lub up\u0142yn\u0105\u0142 limit czasu.",
    passwordComplexity: {
      maximumLength: "mniej ni\u017C {{length}} znak\xF3w",
      minimumLength: "{{length}} lub wi\u0119cej znak\xF3w",
      requireLowercase: "ma\u0142\u0105 liter\u0119",
      requireNumbers: "cyfr\u0119",
      requireSpecialCharacter: "znak specjalny",
      requireUppercase: "wielk\u0105 liter\u0119",
      sentencePrefix: "Twoje has\u0142o musi zawiera\u0107"
    },
    phone_number_exists: "Numer telefonu jest ju\u017C zaj\u0119ty. Prosz\u0119 spr\xF3bowa\u0107 innego.",
    web3_missing_identifier: "Nie mo\u017Cna znale\u017A\u0107 rozszerzenia Web3 Wallet. Zainstaluj je, aby kontynuowa\u0107.",
    zxcvbn: {
      couldBeStronger: "Twoje has\u0142o jest odpowiednie, ale mog\u0142oby by\u0107 silniejsze. Spr\xF3buj doda\u0107 wi\u0119cej znak\xF3w.",
      goodPassword: "Twoje has\u0142o jest wystarczaj\u0105co silne.",
      notEnough: "Twoje has\u0142o jest zbyt s\u0142abe. Spr\xF3buj doda\u0107 wi\u0119cej znak\xF3w.",
      suggestions: {
        allUppercase: "Unikaj u\u017Cywania samych wielkich liter.",
        anotherWord: "Dodaj wi\u0119cej s\u0142\xF3w, kt\xF3re s\u0105 rzadsze.",
        associatedYears: "Unikaj lat zwi\u0105zanych z Tob\u0105.",
        capitalization: "U\u017Cywaj wielkich liter cz\u0119sciej.",
        dates: "Unikaj dat zwi\u0105zanych z Tob\u0105.",
        l33t: "Unikaj przewidywalnego zamieniania liter, takich jak '@' za 'a'.",
        longerKeyboardPattern: "U\u017Cywaj d\u0142ugich wzor\xF3w na klawiaturze, zmieniaj\u0105c kierunek pisania wielokrotnie.",
        noNeed: "Mo\u017Cesz tworzy\u0107 silne has\u0142a bez u\u017Cywania symboli, cyfr lub wielkich liter.",
        pwned: "Je\u017Celi u\u017Cywasz tego has\u0142a gdzie indziej, zmie\u0144 je jak najszybciej.",
        recentYears: "Unikaj ostatnich lat.",
        repeated: "Unikaj powtarzanych s\u0142\xF3w i znak\xF3w.",
        reverseWords: "Unikaj wpisywania popularnych s\u0142\xF3w od ty\u0142u.",
        sequences: "Unikaj popularnych kombinacji znak\xF3w.",
        useWords: "U\u017Cywaj wielu s\u0142\xF3w, ale unikaj popularnych fraz."
      },
      warnings: {
        common: "Jest to cz\u0119sto u\u017Cywane has\u0142o.",
        commonNames: "Imiona i nazwiska s\u0105 \u0142atwe do odgadni\u0119cia.",
        dates: "Daty s\u0105 \u0142atwe do odgadni\u0119cia.",
        extendedRepeat: 'Powtarzaj\u0105ce si\u0119 wzorce znak\xF3w, takie jak "abcabcabc", s\u0105 \u0142atwe do odgadni\u0119cia.',
        keyPattern: "Kr\xF3tkie wzory klawiatury s\u0105 \u0142atwe do odgadni\u0119cia.",
        namesByThemselves: "Pojedyncze imiona lub nazwiska s\u0105 \u0142atwe do odgadni\u0119cia.",
        pwned: "Twoje has\u0142o zosta\u0142o ujawnione w wyniku wycieku danych w Internecie.",
        recentYears: "Ostatnie lata s\u0105 \u0142atwe do odgadni\u0119cia.",
        sequences: 'Typowe sekwencje znak\xF3w, takie jak "abc", s\u0105 \u0142atwe do odgadni\u0119cia.',
        similarToCommon: "Jest to podobne do powszechnie u\u017Cywanego has\u0142a.",
        simpleRepeat: 'Powtarzaj\u0105ce si\u0119 znaki, takie jak "aaa", s\u0105 \u0142atwe do odgadni\u0119cia.',
        straightRow: "Proste rz\u0119dy klawiszy na klawiaturze s\u0105 \u0142atwe do odgadni\u0119cia.",
        topHundred: "To jest cz\u0119sto u\u017Cywane has\u0142o.",
        topTen: "To jest bardzo cz\u0119sto u\u017Cywane has\u0142o.",
        userInputs: "Nie powinno by\u0107 \u017Cadnych danych osobowych ani danych zwi\u0105zanych ze stron\u0105.",
        wordByItself: "Pojedyncze s\u0142owa s\u0105 \u0142atwe do odgadni\u0119cia."
      }
    }
  },
  userButton: {
    action__addAccount: "Dodaj konto",
    action__manageAccount: "Zarz\u0105dzaj kontem",
    action__signOut: "Wyloguj",
    action__signOutAll: "Wyloguj ze wszystkich kont"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Skopiowane!",
      actionLabel__copy: "Skopiuj wszystkie",
      actionLabel__download: "Pobierz .txt",
      actionLabel__print: "Drukuj",
      infoText1: "Kody zapasowe zostan\u0105 w\u0142\u0105czone dla tego konta.",
      infoText2: "Przechowuj kody zapasowe w tajemnicy i bezpiecznie. Mo\u017Cesz wygenerowa\u0107 nowe kody, je\u015Bli podejrzewasz, \u017Ce zosta\u0142y skompromitowane.",
      subtitle__codelist: "Przechowuj je bezpiecznie i zachowaj w tajemnicy.",
      successMessage: "Kody zapasowe s\u0105 teraz w\u0142\u0105czone. Mo\u017Cesz u\u017Cy\u0107 jednego z tych kod\xF3w do zalogowania si\u0119 na swoje konto, je\u015Bli utracisz dost\u0119p do urz\u0105dzenia uwierzytelniaj\u0105cego. Ka\u017Cdy kod mo\u017Cna u\u017Cy\u0107 tylko raz.",
      successSubtitle: "Mo\u017Cesz u\u017Cy\u0107 jednego z tych kod\xF3w do zalogowania si\u0119 na swoje konto, je\u015Bli utracisz dost\u0119p do urz\u0105dzenia uwierzytelniaj\u0105cego.",
      title: "Dodaj weryfikacj\u0119 kodem zapasowym",
      title__codelist: "Kody zapasowe"
    },
    connectedAccountPage: {
      formHint: "Wybierz dostawc\u0119, aby po\u0142\u0105czy\u0107 konto.",
      formHint__noAccounts: "Nie ma dost\u0119pnych zewn\u0119trznych dostawc\xF3w kont.",
      removeResource: {
        messageLine1: "{{identifier}} zostanie usuni\u0119te z tego konta.",
        messageLine2: "Nie b\u0119dziesz ju\u017C m\xF3g\u0142 korzysta\u0107 z tego po\u0142\u0105czonego konta i wszystkie zale\u017Cne funkcje przestan\u0105 dzia\u0142a\u0107.",
        successMessage: "{{connectedAccount}} zosta\u0142o usuni\u0119te z Twojego konta.",
        title: "Usu\u0144 po\u0142\u0105czone konto"
      },
      socialButtonsBlockButton: "Po\u0142\u0105cz konto {{provider|titleize}}",
      successMessage: "Dostawca zosta\u0142 dodany do Twojego konta.",
      title: "Dodaj po\u0142\u0105czone konto"
    },
    deletePage: {
      actionDescription: 'Wpisz "Usu\u0144 konto" poni\u017Cej aby kontynuowa\u0107.',
      confirm: "Usu\u0144 konto",
      messageLine1: "Czy na pewno chcesz usun\u0105\u0107 to konto?",
      messageLine2: "Ta operacja jest nieodwracalna i nie mo\u017Cna jej cofn\u0105\u0107.",
      title: "Usu\u0144 konto"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "E-mail zawieraj\u0105cy kod weryfikacyjny zostanie wys\u0142any na ten adres e-mail.",
        formSubtitle: "Wprowad\u017A kod weryfikacyjny wys\u0142any na adres {{identifier}}",
        formTitle: "Kod weryfikacyjny",
        resendButton: "Wy\u015Blij ponownie kod",
        successMessage: "Adres e-mail {{identifier}} zosta\u0142 dodany do twojego konta."
      },
      emailLink: {
        formHint: "E-mail zawieraj\u0105cy link weryfikacyjny zostanie wys\u0142any na ten adres e-mail.",
        formSubtitle: "Kliknij w link weryfikacyjny w e-mailu wys\u0142anym na adres {{identifier}}",
        formTitle: "Link weryfikacyjny",
        resendButton: "Wy\u015Blij ponownie link",
        successMessage: "Adres e-mail {{identifier}} zosta\u0142 dodany do twojego konta."
      },
      enterpriseSSOLink: {
        formButton: "Kliknij, aby si\u0119 zalogowa\u0107",
        formSubtitle: "Uko\u0144cz logowanie za pomoc\u0105 {{identifier}}"
      },
      formHint: "Przed dodaniem adresu e-mail do konta nale\u017Cy go zweryfikowa\u0107.",
      removeResource: {
        messageLine1: "{{identifier}} zostanie usuni\u0119ty z tego konta.",
        messageLine2: "Nie b\u0119dzie ju\u017C mo\u017Cliwe zalogowanie si\u0119 za pomoc\u0105 tego adresu e-mail.",
        successMessage: "{{emailAddress}} zosta\u0142 usuni\u0119ty z twojego konta.",
        title: "Usu\u0144 adres e-mail"
      },
      title: "Dodaj adres e-mail",
      verifyTitle: "Zweryfikuj adres e-mail"
    },
    formButtonPrimary__add: "Dodaj",
    formButtonPrimary__continue: "Kontynuuj",
    formButtonPrimary__finish: "Zako\u0144cz",
    formButtonPrimary__remove: "Usu\u0144",
    formButtonPrimary__save: "Zapisz",
    formButtonReset: "Anuluj",
    mfaPage: {
      formHint: "Wybierz metod\u0119 dodania.",
      title: "Dodaj weryfikacj\u0119 dwuetapow\u0105"
    },
    mfaPhoneCodePage: {
      backButton: "U\u017Cyj istniej\u0105cego numeru",
      primaryButton__addPhoneNumber: "Dodaj numer telefonu",
      removeResource: {
        messageLine1: "{{identifier}} nie b\u0119dzie ju\u017C otrzymywa\u0142 kod\xF3w weryfikacyjnych podczas logowania.",
        messageLine2: "Twoje konto mo\u017Ce by\u0107 mniej bezpieczne. Czy na pewno chcesz kontynuowa\u0107?",
        successMessage: "Weryfikacja kodem SMS w dwustopniowym procesie uwierzytelniania zosta\u0142a usuni\u0119ta dla {{mfaPhoneCode}}",
        title: "Usu\u0144 dwustopniow\u0105 weryfikacj\u0119"
      },
      subtitle__availablePhoneNumbers: "Wybierz numer telefonu, aby zarejestrowa\u0107 weryfikacj\u0119 kodem SMS w dwustopniowym procesie uwierzytelniania.",
      subtitle__unavailablePhoneNumbers: "Brak dost\u0119pnych numer\xF3w telefon\xF3w do zarejestrowania weryfikacji kodem SMS w dwustopniowym procesie uwierzytelniania.",
      successMessage1: "Podczas logowania nale\u017Cy dodatkowo wprowadzi\u0107 kod weryfikacyjny wys\u0142any na ten numer telefonu.",
      successMessage2: "Zapisz te kody zapasowe i przechowuj je w bezpiecznym miejscu. Je\u015Bli utracisz dost\u0119p do urz\u0105dzenia uwierzytelniaj\u0105cego, mo\u017Cesz u\u017Cy\u0107 kod\xF3w zapasowych, aby si\u0119 zalogowa\u0107.",
      successTitle: "Weryfikacja kodem SMS w\u0142\u0105czona",
      title: "Dodaj weryfikacj\u0119 kodem SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Zamiast tego zeskanuj kod QR",
        buttonUnableToScan__nonPrimary: "Nie mo\u017Cna zeskanowa\u0107 kodu QR?",
        infoText__ableToScan: "Ustaw now\u0105 metod\u0119 logowania w swojej aplikacji autentykacyjnej i zeskanuj nast\u0119puj\u0105cy kod QR, aby po\u0142\u0105czy\u0107 go z Twoim kontem.",
        infoText__unableToScan: "Ustaw now\u0105 metod\u0119 logowania w swojej aplikacji autentykacyjnej i wprowad\u017A poni\u017Cszy klucz.",
        inputLabel__unableToScan1: "Upewnij si\u0119, \u017Ce w\u0142\u0105czona jest opcja jednorazowe has\u0142a lub has\u0142a oparte na czasie, a nast\u0119pnie zako\u0144cz \u0142\u0105czenie konta.",
        inputLabel__unableToScan2: "Alternatywnie, je\u015Bli Twoja aplikacja autentykacyjna obs\u0142uguje URI TOTP, mo\u017Cesz r\xF3wnie\u017C skopiowa\u0107 pe\u0142ny URI."
      },
      removeResource: {
        messageLine1: "Kody weryfikacyjne z tej aplikacji autentykacyjnej nie b\u0119d\u0105 ju\u017C wymagane podczas logowania.",
        messageLine2: "Twoje konto mo\u017Ce by\u0107 mniej bezpieczne. Czy na pewno chcesz kontynuowa\u0107?",
        successMessage: "Weryfikacja dwuetapowa za pomoc\u0105 aplikacji autentykacyjnej zosta\u0142a usuni\u0119ta.",
        title: "Usu\u0144 weryfikacj\u0119 dwuetapow\u0105"
      },
      successMessage: "Weryfikacja dwuetapowa jest teraz w\u0142\u0105czona. Przy logowaniu b\u0119dziesz musia\u0142 wprowadzi\u0107 kod weryfikacyjny z tej aplikacji jako dodatkowy krok.",
      title: "Dodaj aplikacj\u0119 autentykacyjn\u0105",
      verifySubtitle: "Wprowad\u017A kod weryfikacyjny wygenerowany przez Twoj\u0105 aplikacj\u0119 autentykacyjn\u0105",
      verifyTitle: "Kod weryfikacyjny"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profil",
      description: "Zarz\u0105dzaj danymi konta.",
      security: "Bezpiecze\u0144stwo",
      title: "Konto"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} zostanie usuni\u0119ty z tego konta.",
        title: "Usu\u0144 klucz dost\u0119pu"
      },
      subtitle__rename: "Mo\u017Cesz zmieni\u0107 nazw\u0119 klucza dost\u0119pu aby go \u0142atwiej znale\u017A\u0107.",
      title__rename: "Zmie\u0144 nazw\u0119 klucza dost\u0119pu"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Zaleca si\u0119 wylogowanie z innych urz\u0105dze\u0144, kt\xF3re mog\u0142y u\u017Cywa\u0107 starego has\u0142a.",
      readonly: "Obecnie nie mo\u017Cna edytowa\u0107 has\u0142a, poniewa\u017C mo\u017Cesz zalogowa\u0107 si\u0119 tylko za po\u015Brednictwem po\u0142\u0105czenia firmowego.",
      successMessage__set: "Twoje has\u0142o zosta\u0142o ustawione.",
      successMessage__signOutOfOtherSessions: "Wylogowano z wszystkich innych urz\u0105dze\u0144.",
      successMessage__update: "Twoje has\u0142o zosta\u0142o zaktualizowane.",
      title__set: "Ustaw has\u0142o",
      title__update: "Zmie\u0144 has\u0142o"
    },
    phoneNumberPage: {
      infoText: "Wiadomo\u015B\u0107 tekstowa zawieraj\u0105ca link weryfikacyjny zostanie wys\u0142ana na ten numer telefonu.",
      removeResource: {
        messageLine1: "{{identifier}} zostanie usuni\u0119ty z tego konta.",
        messageLine2: "Nie b\u0119dzie ju\u017C mo\u017Cliwe zalogowanie si\u0119 za pomoc\u0105 tego numeru telefonu.",
        successMessage: "{{phoneNumber}} zosta\u0142 usuni\u0119ty z twojego konta.",
        title: "Usu\u0144 numer telefonu"
      },
      successMessage: "{{identifier}} zosta\u0142 dodany do twojego konta.",
      title: "Dodaj numer telefonu",
      verifySubtitle: "Wpisz kod weryfikacyjny wys\u0142any na {{identifier}}",
      verifyTitle: "Zweryfikuj numer telefonu"
    },
    profilePage: {
      fileDropAreaHint: "Prze\u015Blij zdj\u0119cie w formacie JPG, PNG, GIF lub WEBP mniejsze ni\u017C 10 MB",
      imageFormDestructiveActionSubtitle: "Usu\u0144 zdj\u0119cie",
      imageFormSubtitle: "Prze\u015Blij zdj\u0119cie",
      imageFormTitle: "Zdj\u0119cie profilowe",
      readonly: "Informacje o Twoim profilu zosta\u0142y udost\u0119pnione przez po\u0142\u0105czenie firmowe i nie mo\u017Cna ich edytowa\u0107.",
      successMessage: "Tw\xF3j profil zosta\u0142 zaktualizowany.",
      title: "Edytuj profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Wyloguj z urz\u0105dzenia",
        title: "Aktywne urz\u0105dzenia"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Spr\xF3buj ponownie",
        actionLabel__reauthorize: "Autoryzuj teraz",
        destructiveActionTitle: "Od\u0142\u0105cz",
        primaryButton: "Po\u0142\u0105cz konto",
        subtitle__disconnected: "To konto zosta\u0142o od\u0142\u0105czone",
        subtitle__reauthorize: "Wymagane zakresy zosta\u0142y zaktualizowane i funkcjonalno\u015B\u0107 aplikacji mo\u017Ce by\u0107 ograniczona. Aby unikn\u0105\u0107 problem\xF3w, nale\u017Cy ponownie autoryzowa\u0107 aplikacj\u0119",
        title: "Po\u0142\u0105czone konta"
      },
      dangerSection: {
        deleteAccountButton: "Usu\u0144 konto",
        title: "Niebezpiecze\u0144stwo"
      },
      emailAddressesSection: {
        destructiveAction: "Usu\u0144 adres email",
        detailsAction__nonPrimary: "Ustaw jako g\u0142\xF3wny",
        detailsAction__primary: "Zako\u0144cz weryfikacj\u0119",
        detailsAction__unverified: "Zako\u0144cz weryfikacj\u0119",
        primaryButton: "Dodaj adres email",
        title: "Adresy email"
      },
      enterpriseAccountsSection: {
        title: "Konta firmowe"
      },
      headerTitle__account: "Konto",
      headerTitle__security: "Bezpiecze\u0144stwo",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Wygeneruj kody",
          headerTitle: "Kody zapasowe",
          subtitle__regenerate: "Otrzymaj nowy zestaw bezpiecznych kod\xF3w zapasowych. Poprzednie kody zapasowe zostan\u0105 usuni\u0119te i nie b\u0119d\u0105 dzia\u0142a\u0107.",
          title__regenerate: "Wygeneruj nowe kody zapasowe"
        },
        phoneCode: {
          actionLabel__setDefault: "Ustaw jako domy\u015Blny",
          destructiveActionLabel: "Usu\u0144 numer telefonu"
        },
        primaryButton: "Dodaj weryfikacj\u0119 dwuetapow\u0105",
        title: "Weryfikacja dwuetapowa",
        totp: {
          destructiveActionTitle: "Usu\u0144",
          headerTitle: "Aplikacja autoryzacyjna"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Usu\u0144",
        menuAction__rename: "Zmie\u0144 nazw\u0119",
        primaryButton: void 0,
        title: "Klucze dost\u0119pu"
      },
      passwordSection: {
        primaryButton__setPassword: "Ustaw has\u0142o",
        primaryButton__updatePassword: "Zmie\u0144 has\u0142o",
        title: "Has\u0142o"
      },
      phoneNumbersSection: {
        destructiveAction: "Usu\u0144 numer telefonu",
        detailsAction__nonPrimary: "Ustaw jako g\u0142\xF3wny",
        detailsAction__primary: "Zako\u0144cz weryfikacj\u0119",
        detailsAction__unverified: "Zako\u0144cz weryfikacj\u0119",
        primaryButton: "Dodaj numer telefonu",
        title: "Numery telefon\xF3w"
      },
      profileSection: {
        primaryButton: "Zaaktualizuj profil",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Ustaw nazw\u0119 u\u017Cytkownika",
        primaryButton__updateUsername: "Zmie\u0144 nazw\u0119 u\u017Cytkownika",
        title: "Nazwa u\u017Cytkownika"
      },
      web3WalletsSection: {
        destructiveAction: "Usu\u0144 portfel",
        primaryButton: "Portfele Web3",
        title: "Portfele Web3"
      }
    },
    usernamePage: {
      successMessage: "Twoja nazwa u\u017Cytkownika zosta\u0142a zaktualizowana.",
      title__set: "Zmie\u0144 nazw\u0119 u\u017Cytkownika",
      title__update: "Zmie\u0144 nazw\u0119 u\u017Cytkownika"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} zostanie usuni\u0119ty z tego konta.",
        messageLine2: "Nie b\u0119dziesz ju\u017C m\xF3g\u0142 si\u0119 zalogowa\u0107 za pomoc\u0105 tego portfela web3.",
        successMessage: "{{web3Wallet}} zosta\u0142 usuni\u0119ty z Twojego konta.",
        title: "Usu\u0144 portfel web3"
      },
      subtitle__availableWallets: "Wybierz portfel web3 do po\u0142\u0105czenia z Twoim kontem.",
      subtitle__unavailableWallets: "Nie ma dost\u0119pnych portfeli web3.",
      successMessage: "Portfel zosta\u0142 dodany do Twojego konta.",
      title: "Dodaj portfel web3",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: "Zaloguj si\u0119",
      actionText: "Masz ju\u017C konto?",
      formButton: "Do\u0142\u0105cz do listy oczekuj\u0105cych",
      subtitle: "Wpisz sw\xF3j adres e-mail, a my powiadomimy Ci\u0119, gdy miejsce dla Ciebie b\u0119dzie gotowe.",
      title: "Do\u0142\u0105cz do listy oczekuj\u0105cych"
    },
    success: {
      message: "Wkr\xF3tce nast\u0105pi przekierowanie...",
      subtitle: "Skontaktujemy si\u0119 z Tob\u0105, gdy miejsce dla Ciebie b\u0119dzie gotowe",
      title: "Dzi\u0119kujemy za do\u0142\u0105czenie do listy oczekuj\u0105cych!"
    }
  }
};

// src/el-GR.ts
var elGR = {
  locale: "el-GR",
  backButton: "\u03A0\u03AF\u03C3\u03C9",
  badge__default: "\u03A0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE",
  badge__otherImpersonatorDevice: "\u0386\u03BB\u03BB\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03C5\u03C0\u03BF\u03B4\u03C5\u03CC\u03BC\u03B5\u03BD\u03BF\u03C5",
  badge__primary: "\u039A\u03CD\u03C1\u03B9\u03BF",
  badge__requiresAction: "\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1",
  badge__thisDevice: "\u0391\u03C5\u03C4\u03AE \u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE",
  badge__unverified: "\u039C\u03B7 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF",
  badge__userDevice: "\u03A3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
  badge__you: "\u0395\u03C3\u03B5\u03AF\u03C2",
  createOrganization: {
    formButtonSubmit: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
    invitePage: {
      formButtonReset: "\u03A0\u03B1\u03C1\u03AC\u03BB\u03B5\u03B9\u03C8\u03B7"
    },
    title: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u039F\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD"
  },
  dates: {
    lastDay: "\u03A7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2 {{ date | timeString('el') }}",
    next6Days: "{{ date | weekday('el','long') }} \u03C3\u03C4\u03B9\u03C2 {{ date | timeString('el') }}",
    nextDay: "\u0391\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2 {{ date | timeString('el') }}",
    numeric: "{{ date | numeric('el') }}",
    previous6Days: "\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 {{ date | weekday('el','long') }} \u03C3\u03C4\u03B9\u03C2 {{ date | timeString('el') }}",
    sameDay: "\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2 {{ date | timeString('el') }}"
  },
  dividerText: "\u03AE",
  footerActionLink__useAnotherMethod: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03AC\u03BB\u03BB\u03B7 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF",
  footerPageLink__help: "\u0392\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1",
  footerPageLink__privacy: "\u03A0\u03C1\u03BF\u03C3\u03C4\u03B1\u03C3\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CE\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD",
  footerPageLink__terms: "\u038C\u03C1\u03BF\u03B9",
  formButtonPrimary: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "\u039E\u03B5\u03C7\u03AC\u03C3\u03B1\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC;",
  formFieldError__matchingPasswords: "\u039F\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD.",
  formFieldError__notMatchingPasswords: "\u039F\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B4\u03B5\u03BD \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: "\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C3\u03B1\u03C2",
  formFieldInputPlaceholder__emailAddress_username: "\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 email \u03AE \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
  formFieldInputPlaceholder__emailAddresses: "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AE \u03B5\u03C0\u03B9\u03BA\u03BF\u03BB\u03BB\u03AE\u03C3\u03C4\u03B5 \u03BC\u03AF\u03B1 \u03AE \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B4\u03B9\u03B5\u03C5\u03B8\u03CD\u03BD\u03C3\u03B5\u03B9\u03C2 email, \u03C7\u03C9\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BC\u03B5 \u03BA\u03B5\u03BD\u03AC \u03AE \u03BA\u03CC\u03BC\u03BC\u03B1\u03C4\u03B1",
  formFieldInputPlaceholder__firstName: "\u038C\u03BD\u03BF\u03BC\u03B1",
  formFieldInputPlaceholder__lastName: "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "you@example.com",
  formFieldInputPlaceholder__organizationName: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
  formFieldInputPlaceholder__organizationSlug: "my-org",
  formFieldInputPlaceholder__password: "\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2",
  formFieldInputPlaceholder__phoneNumber: "\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03C3\u03B1\u03C2",
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03C9\u03BD \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1",
  formFieldLabel__backupCode: "\u0391\u03BD\u03C4\u03AF\u03B3\u03C1\u03B1\u03C6\u03BF \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD",
  formFieldLabel__confirmDeletion: "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7",
  formFieldLabel__confirmPassword: "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
  formFieldLabel__currentPassword: "\u03A4\u03C1\u03AD\u03C7\u03C9\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
  formFieldLabel__emailAddress: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email",
  formFieldLabel__emailAddress_username: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03AE \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
  formFieldLabel__emailAddresses: "\u0394\u03B9\u03B5\u03C5\u03B8\u03CD\u03BD\u03C3\u03B5\u03B9\u03C2 email",
  formFieldLabel__firstName: "\u038C\u03BD\u03BF\u03BC\u03B1",
  formFieldLabel__lastName: "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF",
  formFieldLabel__newPassword: "\u039D\u03AD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CE\u03BD \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD",
  formFieldLabel__organizationDomainEmailAddress: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1.",
  formFieldLabel__organizationName: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
  formFieldLabel__organizationSlug: "\u03A3\u03C5\u03BD\u03C4\u03CC\u03BC\u03B5\u03C5\u03C3\u03B7 URL",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
  formFieldLabel__phoneNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
  formFieldLabel__role: "\u03A1\u03CC\u03BB\u03BF\u03C2",
  formFieldLabel__signOutOfOtherSessions: "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03AC\u03BB\u03BB\u03B5\u03C2 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AD\u03C2",
  formFieldLabel__username: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
  impersonationFab: {
    action__signOut: "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
    title: "\u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C9\u03C2 {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\u0394\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE\u03C2",
  membershipRole__basicMember: "\u039C\u03AD\u03BB\u03BF\u03C2",
  membershipRole__guestMember: "\u0395\u03C0\u03B9\u03C3\u03BA\u03AD\u03C0\u03C4\u03B7\u03C2",
  organizationList: {
    action__createOrganization: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
    action__invitationAccept: "\u03A3\u03C5\u03BC\u03BC\u03B5\u03C4\u03BF\u03C7\u03AE",
    action__suggestionsAccept: "\u0391\u03AF\u03C4\u03B7\u03C3\u03B7 \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03BF\u03C7\u03AE\u03C2",
    createOrganization: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u039F\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
    invitationAcceptedLabel: "\u03A3\u03C5\u03BC\u03BC\u03B5\u03C4\u03AD\u03C7\u03B5\u03C4\u03B5",
    subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
    suggestionsAcceptedLabel: "\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7",
    title: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC",
    titleWithoutPersonal: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u0391\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03B9\u03C2",
    badge__automaticSuggestion: "\u0391\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2",
    badge__manualInvitation: "\u03A7\u03C9\u03C1\u03AF\u03C2 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B7 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE",
    badge__unverified: "\u039C\u03B7 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF",
    createDomainPage: {
      subtitle: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7. \u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2 \u03BC\u03B5 \u03B4\u03B9\u03B5\u03C5\u03B8\u03CD\u03BD\u03C3\u03B5\u03B9\u03C2 email \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1 \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03AC\u03C3\u03C7\u03BF\u03C5\u03BD \u03C3\u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03AE \u03BD\u03B1 \u03B1\u03B9\u03C4\u03B7\u03B8\u03BF\u03CD\u03BD \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03BF\u03C7\u03AE.",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C4\u03BF\u03BC\u03AD\u03B1"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u039F\u03B9 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03C3\u03B1\u03BD \u03BD\u03B1 \u03C3\u03C4\u03B1\u03BB\u03BF\u03CD\u03BD. \u0394\u03B9\u03BF\u03C1\u03B8\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC:",
      formButtonPrimary__continue: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD",
      selectDropdown__role: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03C1\u03CC\u03BB\u03BF\u03C5",
      subtitle: "\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03BD\u03AD\u03B1 \u03BC\u03AD\u03BB\u03B7 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC",
      successMessage: "\u039F\u03B9 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C3\u03C4\u03AC\u03BB\u03B7\u03C3\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1",
      title: "\u03A0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7 \u03BC\u03B5\u03BB\u03CE\u03BD"
    },
    membersPage: {
      action__invite: "\u03A0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03BC\u03AD\u03BB\u03BF\u03C5\u03C2",
        tableHeader__actions: "\u0395\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B5\u03C2",
        tableHeader__joined: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\u03BA\u03B1\u03C4\u03B5",
        tableHeader__role: "\u03A1\u03CC\u03BB\u03BF\u03C2",
        tableHeader__user: "\u03A7\u03C1\u03AE\u03C3\u03C4\u03B7\u03C2"
      },
      detailsTitle__emptyRow: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03BC\u03AD\u03BB\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u0391\u03BD\u03AC\u03BA\u03BB\u03B7\u03C3\u03B7 \u03C0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7\u03C2",
        tableHeader__invited: "\u03A0\u03C1\u03BF\u03C3\u03BA\u03B5\u03BA\u03BB\u03B7\u03BC\u03AD\u03BD\u03BF"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF {{organizationName}} \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.",
          messageLine1: "\u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03C2 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC;",
          messageLine2: "\u0391\u03C5\u03C4\u03AE \u03B7 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03CC\u03BD\u03B9\u03BC\u03B7 \u03BA\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03BC\u03B7 \u03B1\u03BD\u03B1\u03C3\u03C4\u03C1\u03AD\u03C8\u03B9\u03BC\u03B7.",
          successMessage: "\u0388\u03C7\u03B5\u03C4\u03B5 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03B9 \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC.",
          title: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD"
        },
        leaveOrganization: {
          actionDescription: "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF {{organizationName}} \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.",
          messageLine1: "\u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03C2 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C7\u03C9\u03C1\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC; \u0398\u03B1 \u03C7\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2 \u03C4\u03BF\u03C5.",
          messageLine2: "\u0391\u03C5\u03C4\u03AE \u03B7 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03CC\u03BD\u03B9\u03BC\u03B7 \u03BA\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03BC\u03B7 \u03B1\u03BD\u03B1\u03C3\u03C4\u03C1\u03AD\u03C8\u03B9\u03BC\u03B7.",
          successMessage: "\u0388\u03C7\u03B5\u03C4\u03B5 \u03B1\u03C0\u03BF\u03C7\u03C9\u03C1\u03AE\u03C3\u03B5\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC.",
          title: "\u0391\u03C0\u03BF\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC"
        },
        title: "\u039A\u03AF\u03BD\u03B4\u03C5\u03BD\u03BF\u03C2"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "\u039F \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.",
      title: "\u03A0\u03C1\u03BF\u03C6\u03AF\u03BB \u039F\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\u039C\u03AD\u03BB\u03B7",
      profileSection: {
        primaryButton: "\u0395\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB",
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u039F\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
    action__invitationAccept: "Join",
    action__manageOrganization: "\u0394\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7 \u039F\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD",
    action__suggestionsAccept: "Request to join",
    notSelected: "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03B5\u03AF \u03BF\u03C1\u03B3\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC\u03C2",
    personalWorkspace: "\u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC\u03C2 \u03A7\u03CE\u03C1\u03BF\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF",
  paginationButton__previous: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF",
  paginationRowText__displaying: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7",
  paginationRowText__of: "\u03B1\u03C0\u03CC",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "\u039B\u03AE\u03C8\u03B7 \u03B2\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1\u03C2",
      actionText: "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03BA\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AC;",
      blockButton__backupCode: "\u03A7\u03C1\u03AE\u03C3\u03B7 \u03B5\u03BD\u03CC\u03C2 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03CD \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD",
      blockButton__emailCode: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03BC\u03B5 email \u03C3\u03C4\u03BF {{identifier}}",
      blockButton__emailLink: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03BC\u03BF\u03C5 \u03C3\u03C4\u03BF {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2",
      blockButton__phoneCode: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD SMS \u03C3\u03C4\u03BF {{identifier}}",
      blockButton__totp: "\u03A7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2 \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2",
      getHelp: {
        blockButton__emailSupport: "\u03A5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7 \u03BC\u03AD\u03C3\u03C9 email",
        content: "\u0395\u03AC\u03BD \u03B1\u03BD\u03C4\u03B9\u03BC\u03B5\u03C4\u03C9\u03C0\u03AF\u03B6\u03B5\u03C4\u03B5 \u03B4\u03C5\u03C3\u03BA\u03BF\u03BB\u03AF\u03B1 \u03C3\u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2, \u03C3\u03C4\u03B5\u03AF\u03BB\u03C4\u03B5 \u03BC\u03B1\u03C2 email \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03BD.",
        title: "\u039B\u03AE\u03C8\u03B7 \u03B2\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1\u03C2"
      },
      subtitle: "\u0391\u03BD\u03C4\u03B9\u03BC\u03B5\u03C4\u03C9\u03C0\u03AF\u03B6\u03B5\u03C4\u03B5 \u03B4\u03C5\u03C3\u03BA\u03BF\u03BB\u03AF\u03B5\u03C2; \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BF\u03C0\u03BF\u03B9\u03B1\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AD\u03C2 \u03C4\u03B9\u03C2 \u03BC\u03B5\u03B8\u03CC\u03B4\u03BF\u03C5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5.",
      title: "\u03A7\u03C1\u03AE\u03C3\u03B7 \u03BC\u03B9\u03B1\u03C2 \u03AC\u03BB\u03BB\u03B7\u03C2 \u03BC\u03B5\u03B8\u03CC\u03B4\u03BF\u03C5"
    },
    backupCodeMfa: {
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03B5\u03BD\u03CC\u03C2 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03CD \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD"
    },
    emailCode: {
      formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.",
        title: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03AE\u03BE\u03B5\u03B9"
      },
      failed: {
        subtitle: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.",
        title: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2"
      },
      formSubtitle: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03C3\u03C4\u03BF email \u03C3\u03B1\u03C2",
      formTitle: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      loading: {
        subtitle: "\u0398\u03B1 \u03B1\u03BD\u03B1\u03BA\u03B1\u03C4\u03B5\u03C5\u03B8\u03C5\u03BD\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1",
        title: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7..."
      },
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2",
      unusedTab: {
        title: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1"
      },
      verified: {
        subtitle: "\u0398\u03B1 \u03B1\u03BD\u03B1\u03BA\u03B1\u03C4\u03B5\u03C5\u03B8\u03C5\u03BD\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1",
        title: "\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7"
      },
      verifiedSwitchTab: {
        subtitle: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
        subtitleNewTab: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7 \u03BD\u03AD\u03B1 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03C0\u03BF\u03C5 \u03AC\u03BD\u03BF\u03B9\u03BE\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
        titleNewTab: "\u0388\u03C7\u03B5\u03C4\u03B5 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF \u03C3\u03B5 \u03AC\u03BB\u03BB\u03B7 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1"
      }
    },
    forgotPassword: {
      formTitle: "\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2",
      subtitle_email: "\u03A0\u03C1\u03CE\u03C4\u03B1, \u03B5\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03BF\u03C5 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C3\u03B1\u03C2",
      subtitle_phone: "\u03A0\u03C1\u03CE\u03C4\u03B1, \u03B5\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03BF\u03C5 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03CC \u03C3\u03B1\u03C2",
      title: "\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
      label__alternativeMethods: "\u0389, \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B5 \u03BC\u03B9\u03B1 \u03AC\u03BB\u03BB\u03B7 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF.",
      title: "\u039E\u03B5\u03C7\u03AC\u03C3\u03B1\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2;"
    },
    noAvailableMethods: {
      message: "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7. \u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C2 \u03C0\u03B1\u03C1\u03AC\u03B3\u03BF\u03BD\u03C4\u03B1\u03C2 \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2.",
      subtitle: "\u03A0\u03C1\u03BF\u03AD\u03BA\u03C5\u03C8\u03B5 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1",
      title: "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7"
    },
    passkey: {
      subtitle: "\u0397 \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03BF\u03C5 passkey \u03C3\u03B1\u03C2 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03BD\u03B5\u03B9 \u03C4\u03B7\u03BD \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03AC \u03C3\u03B1\u03C2. \u0397 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03C3\u03B1\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B6\u03B7\u03C4\u03AE\u03C3\u03B5\u03B9 \u03B4\u03B1\u03BA\u03C4\u03C5\u03BB\u03B9\u03BA\u03CC \u03B1\u03C0\u03BF\u03C4\u03CD\u03C0\u03C9\u03BC\u03B1, \u03B1\u03BD\u03B1\u03B3\u03BD\u03CE\u03C1\u03B9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C3\u03CE\u03C0\u03BF\u03C5 \u03AE \u03BA\u03BB\u03B5\u03AF\u03B4\u03C9\u03BC\u03B1 \u03BF\u03B8\u03CC\u03BD\u03B7\u03C2.",
      title: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF passkey \u03C3\u03B1\u03C2"
    },
    password: {
      actionLink: "\u03A7\u03C1\u03AE\u03C3\u03B7 \u03AC\u03BB\u03BB\u03B7\u03C2 \u03BC\u03B5\u03B8\u03CC\u03B4\u03BF\u03C5",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2"
    },
    passwordPwned: {
      title: "\u03A0\u03B1\u03C1\u03B1\u03B2\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2"
    },
    phoneCode: {
      formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03CC \u03C3\u03B1\u03C2"
    },
    phoneCodeMfa: {
      formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: void 0,
      title: "\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03CC \u03C3\u03B1\u03C2"
    },
    resetPassword: {
      formButtonPrimary: "\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
      requiredMessage: "\u03A5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03BC\u03B5 \u03BC\u03B7 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03C5\u03BC\u03AD\u03BD\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BB\u03CC\u03B3\u03BF\u03C5\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2.",
      successMessage: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03B9 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1. \u03A3\u03B1\u03C2 \u03C3\u03C5\u03BD\u03B4\u03AD\u03BF\u03C5\u03BC\u03B5, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5.",
      title: "\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2"
    },
    resetPasswordMfa: {
      detailsLabel: "\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03BF\u03C5\u03BC\u03B5 \u03C4\u03B7\u03BD \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03AC \u03C3\u03B1\u03C2 \u03C0\u03C1\u03B9\u03BD \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2."
    },
    start: {
      actionLink: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE",
      actionLink__join_waitlist: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03B1\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE\u03C2",
      actionLink__use_email: "\u03A7\u03C1\u03AE\u03C3\u03B7 email",
      actionLink__use_email_username: "\u03A7\u03C1\u03AE\u03C3\u03B7 email \u03AE \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
      actionLink__use_passkey: "\u03A7\u03C1\u03AE\u03C3\u03B7 passkey",
      actionLink__use_phone: "\u03A7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
      actionLink__use_username: "\u03A7\u03C1\u03AE\u03C3\u03B7 \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
      actionText: "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC;",
      actionText__join_waitlist: "\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03C0\u03C1\u03CE\u03B9\u03BC\u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7;",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      subtitleCombined: void 0,
      title: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
      titleCombined: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03C3\u03C4\u03BF {{applicationName}}"
    },
    totpMfa: {
      formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      subtitle: void 0,
      title: "A\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03B4\u03CD\u03BF \u03B2\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD"
    }
  },
  signInEnterPasswordTitle: "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
  signUp: {
    continue: {
      actionLink: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
      actionText: "\u0388\u03C7\u03B5\u03C4\u03B5 \u03AE\u03B4\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC;",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03B1 \u03C0\u03B5\u03B4\u03AF\u03B1"
    },
    emailCode: {
      formSubtitle: "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03C3\u03C4\u03BF email \u03C3\u03B1\u03C2",
      formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C3\u03B1\u03C2",
      formTitle: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      loading: {
        title: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7..."
      },
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2",
      verified: {
        title: "\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE"
      },
      verifiedSwitchTab: {
        subtitle: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7 \u03BD\u03AD\u03B1 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
        subtitleNewTab: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
        title: "\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 email"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: '\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE \u03BC\u03B5 \u03C4\u03B7\u03BD {{ privacyPolicyLink || link("\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5") }}',
        label__onlyTermsOfService: '\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 {{ termsOfServiceLink || link("\u038C\u03C1\u03BF\u03C5\u03C2 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2") }}',
        label__termsOfServiceAndPrivacyPolicy: '\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 {{ termsOfServiceLink || link("\u038C\u03C1\u03BF\u03C5\u03C2 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2") }} \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD {{ privacyPolicyLink || link("\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5") }}'
      },
      continue: {
        subtitle: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03B9\u03B1\u03B2\u03AC\u03C3\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03B1\u03C0\u03BF\u03B4\u03B5\u03C7\u03C4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03CC\u03C1\u03BF\u03C5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
        title: "\u039D\u03BF\u03BC\u03B9\u03BA\u03AE \u03C3\u03C5\u03BD\u03B1\u03AF\u03BD\u03B5\u03C3\u03B7"
      }
    },
    phoneCode: {
      formSubtitle: "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03C3\u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03C3\u03B1\u03C2",
      formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
      resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BE\u03B1\u03BD\u03AC",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0395\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03CC \u03C3\u03B1\u03C2"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u0388\u03C7\u03B5\u03C4\u03B5 \u03AE\u03B4\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC;",
      subtitle: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      subtitleCombined: "\u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF {{applicationName}}",
      title: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2",
      titleCombined: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2"
    }
  },
  socialButtonsBlockButton: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03BC\u03B5 {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\u0397 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5 \u03BB\u03CC\u03B3\u03C9 \u03B1\u03C0\u03BF\u03C4\u03C5\u03C7\u03B7\u03BC\u03AD\u03BD\u03C9\u03BD \u03B5\u03BB\u03AD\u03B3\u03C7\u03C9\u03BD \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2. \u0391\u03BD\u03B1\u03BD\u03B5\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF \u03BA\u03AD\u03BD\u03C4\u03C1\u03BF \u03C5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B7 \u03B2\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B9\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03BA\u03B5\u03C4\u03AC \u03B9\u03C3\u03C7\u03C5\u03C1\u03CC\u03C2.",
    form_password_pwned: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B4\u03B9\u03B1\u03C1\u03C1\u03B5\u03CD\u03C3\u03B5\u03B9 online \u03C3\u03C4\u03BF \u03C0\u03B1\u03C1\u03B5\u03BB\u03B8\u03CC\u03BD \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF. \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03AC\u03BB\u03BB\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03B1\u03BD\u03C4\u03AF \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC\u03BD.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C5\u03C0\u03B5\u03C1\u03B2\u03B5\u03AF \u03C4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC bytes \u03C0\u03BF\u03C5 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03C4\u03B1\u03B9. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5, \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03AE \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03C4\u03B5 \u03BC\u03B5\u03C1\u03B9\u03BA\u03BF\u03CD\u03C2 \u03B5\u03B9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.",
    form_password_validation_failed: "\u039B\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "\u0394\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03C4\u03B1\u03C5\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 \u03B1\u03C0\u03CC {{length}} \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2",
      minimumLength: "{{length}} \u03AE \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2",
      requireLowercase: "\u03AD\u03BD\u03B1 \u03C0\u03B5\u03B6\u03CC \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1",
      requireNumbers: "\u03AD\u03BD\u03B1\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC",
      requireSpecialCharacter: "\u03AD\u03BD\u03B1 \u03B5\u03B9\u03B4\u03B9\u03BA\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B1",
      requireUppercase: "\u03AD\u03BD\u03B1 \u03BA\u03B5\u03C6\u03B1\u03BB\u03B1\u03AF\u03BF \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1",
      sentencePrefix: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9"
    },
    phone_number_exists: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B1\u03B9 \u03AE\u03B4\u03B7. \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03AC\u03BB\u03BB\u03BF.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03BA\u03B5\u03C4\u03CC\u03C2, \u03B1\u03BB\u03BB\u03AC \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03C3\u03B5 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03B9\u03BF \u03B9\u03C3\u03C7\u03C5\u03C1\u03CC\u03C2. \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.",
      goodPassword: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03AF \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B5\u03C2 \u03C0\u03C1\u03BF\u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AD\u03C2.",
      notEnough: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03BA\u03B5\u03C4\u03AC \u03B9\u03C3\u03C7\u03C5\u03C1\u03CC\u03C2.",
      suggestions: {
        allUppercase: "\u0388\u03C7\u03B5\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03BC\u03B5\u03C1\u03B9\u03BA\u03AC \u03BA\u03B5\u03C6\u03B1\u03BB\u03B1\u03AF\u03B1 \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03B1.",
        anotherWord: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03BB\u03AD\u03BE\u03B5\u03B9\u03C2 \u03C0\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03C3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2.",
        associatedYears: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03AD\u03C4\u03B7 \u03C0\u03BF\u03C5 \u03C3\u03B1\u03C2 \u03B1\u03C6\u03BF\u03C1\u03BF\u03CD\u03BD.",
        capitalization: "\u039C\u03B7\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03BA\u03B5\u03C6\u03B1\u03BB\u03B1\u03AF\u03BF \u03BC\u03CC\u03BD\u03BF \u03C4\u03BF \u03C0\u03C1\u03CE\u03C4\u03BF \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1.",
        dates: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03AD\u03C4\u03B7 \u03C0\u03BF\u03C5 \u03C3\u03B1\u03C2 \u03B1\u03C6\u03BF\u03C1\u03BF\u03CD\u03BD.",
        l33t: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AD\u03C8\u03B9\u03BC\u03B5\u03C2 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AC\u03C4\u03C9\u03BD \u03CC\u03C0\u03C9\u03C2 '@' \u03B3\u03B9\u03B1 'a'.",
        longerKeyboardPattern: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B1 \u03BC\u03BF\u03C4\u03AF\u03B2\u03B1 \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5 \u03BA\u03B1\u03B9 \u03B1\u03BB\u03BB\u03AC\u03BE\u03C4\u03B5 \u03C0\u03BF\u03BB\u03BB\u03AD\u03C2 \u03C6\u03BF\u03C1\u03AD\u03C2 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2.",
        noNeed: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B9\u03C3\u03C7\u03C5\u03C1\u03BF\u03CD\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C7\u03C9\u03C1\u03AF\u03C2 \u03C4\u03B7 \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C3\u03C5\u03BC\u03B2\u03CC\u03BB\u03C9\u03BD, \u03B1\u03C1\u03B9\u03B8\u03BC\u03CE\u03BD \u03AE \u03BA\u03B5\u03C6\u03B1\u03BB\u03B1\u03AF\u03C9\u03BD \u03B3\u03C1\u03B1\u03BC\u03BC\u03AC\u03C4\u03C9\u03BD.",
        pwned: "\u0391\u03BD \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03B1\u03BB\u03BB\u03BF\u03CD, \u03B8\u03B1 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C4\u03BF\u03BD \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5.",
        recentYears: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03C0\u03C1\u03CC\u03C3\u03C6\u03B1\u03C4\u03B1 \u03AD\u03C4\u03B7.",
        repeated: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B1\u03BD\u03B1\u03BB\u03B1\u03BC\u03B2\u03B1\u03BD\u03CC\u03BC\u03B5\u03BD\u03B5\u03C2 \u03BB\u03AD\u03BE\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.",
        reverseWords: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03B1\u03BD\u03C4\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AD\u03C2 \u03C3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03C9\u03BD \u03BB\u03AD\u03BE\u03B5\u03C9\u03BD.",
        sequences: "\u0391\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03BA\u03BF\u03B9\u03BD\u03AD\u03C2 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B5\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD.",
        useWords: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C0\u03BF\u03BB\u03BB\u03AD\u03C2 \u03BB\u03AD\u03BE\u03B5\u03B9\u03C2, \u03B1\u03BB\u03BB\u03AC \u03B1\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03BA\u03BF\u03B9\u03BD\u03AD\u03C2 \u03C6\u03C1\u03AC\u03C3\u03B5\u03B9\u03C2."
      },
      warnings: {
        common: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03BA\u03BF\u03B9\u03BD\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2.",
        commonNames: "\u03A3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03B1 \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03C0\u03CE\u03BD\u03C5\u03BC\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.",
        dates: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B5\u03C2 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.",
        extendedRepeat: '\u0395\u03C0\u03B1\u03BD\u03B1\u03BB\u03B1\u03BC\u03B2\u03B1\u03BD\u03CC\u03BC\u03B5\u03BD\u03B1 \u03BC\u03BF\u03C4\u03AF\u03B2\u03B1 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD \u03CC\u03C0\u03C9\u03C2 "abcabcabc" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.',
        keyPattern: "\u03A3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1 \u03BC\u03BF\u03C4\u03AF\u03B2\u03B1 \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.",
        namesByThemselves: "\u039C\u03B5\u03BC\u03BF\u03BD\u03C9\u03BC\u03AD\u03BD\u03B1 \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03B1 \u03AE \u03B5\u03C0\u03CE\u03BD\u03C5\u03BC\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.",
        pwned: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B1\u03C0\u03BF\u03BA\u03B1\u03BB\u03CD\u03C6\u03B8\u03B7\u03BA\u03B5 \u03B1\u03C0\u03CC \u03C0\u03B1\u03C1\u03B1\u03B2\u03AF\u03B1\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C3\u03C4\u03BF \u03B4\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF.",
        recentYears: "\u03A0\u03C1\u03CC\u03C3\u03C6\u03B1\u03C4\u03B1 \u03AD\u03C4\u03B7 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.",
        sequences: '\u03A3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B5\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD \u03CC\u03C0\u03C9\u03C2 "abc" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.',
        similarToCommon: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03B1\u03C1\u03CC\u03BC\u03BF\u03B9\u03BF\u03C2 \u03BC\u03B5 \u03AD\u03BD\u03B1\u03BD \u03BA\u03BF\u03B9\u03BD\u03CC \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2.",
        simpleRepeat: '\u0395\u03C0\u03B1\u03BD\u03B1\u03BB\u03B1\u03BC\u03B2\u03B1\u03BD\u03CC\u03BC\u03B5\u03BD\u03BF\u03B9 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2 \u03CC\u03C0\u03C9\u03C2 "aaa" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03BF \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.',
        straightRow: "\u03A3\u03B5\u03B9\u03C1\u03AD\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AC\u03C4\u03C9\u03BD \u03C3\u03C4\u03BF \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD.",
        topHundred: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03C3\u03C5\u03C7\u03BD\u03AC \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2.",
        topTen: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03C0\u03BF\u03BB\u03CD \u03B4\u03B9\u03B1\u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2.",
        userInputs: "\u0394\u03B5\u03BD \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03AC \u03AE \u03C3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1.",
        wordByItself: "\u039F\u03B9 \u03BC\u03B5\u03BC\u03BF\u03BD\u03C9\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BB\u03AD\u03BE\u03B5\u03B9\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B5\u03C2 \u03BD\u03B1 \u03BC\u03B1\u03BD\u03C4\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD."
      }
    }
  },
  userButton: {
    action__addAccount: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
    action__manageAccount: "\u0394\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
    action__signOut: "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
    action__signOutAll: "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B1\u03C0\u03CC \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD\u03C2"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD!",
      actionLabel__copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03CC\u03BB\u03C9\u03BD",
      actionLabel__download: "\u039B\u03AE\u03C8\u03B7 .txt",
      actionLabel__print: "\u0395\u03BA\u03C4\u03CD\u03C0\u03C9\u03C3\u03B7",
      infoText1: "\u039F\u03B9 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03AF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B8\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF\u03B9 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
      infoText2: "\u03A6\u03C5\u03BB\u03AC\u03BE\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03CD\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03BC\u03C5\u03C3\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03BA\u03B1\u03B9 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03BC\u03B5 \u03B1\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BD\u03AD\u03BF\u03C5\u03C2 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03CD\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03B5\u03AC\u03BD \u03C5\u03C0\u03BF\u03C8\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03AD\u03C7\u03BF\u03C5\u03BD \u03B4\u03B9\u03B1\u03C1\u03C1\u03B5\u03CD\u03C3\u03B5\u03B9.",
      subtitle__codelist: "\u03A6\u03C5\u03BB\u03AC\u03BE\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03BC\u03B5 \u03B1\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1 \u03BA\u03B1\u03B9 \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03BC\u03C5\u03C3\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2.",
      successMessage: "\u039F\u03B9 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03AF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BB\u03AD\u03BF\u03BD \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF\u03B9. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03BF\u03CD\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2, \u03B5\u03AC\u03BD \u03C7\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2. \u039A\u03AC\u03B8\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF \u03BC\u03CC\u03BD\u03BF \u03BC\u03AF\u03B1 \u03C6\u03BF\u03C1\u03AC.",
      successSubtitle: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03BF\u03CD\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2, \u03B5\u03AC\u03BD \u03C7\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2.",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03BC\u03B5 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03CD\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2",
      title__codelist: "\u0395\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03AF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF"
    },
    connectedAccountPage: {
      formHint: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03C0\u03AC\u03C1\u03BF\u03C7\u03BF \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
      formHint__noAccounts: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03B9 \u03C0\u03AC\u03C1\u03BF\u03C7\u03BF\u03B9 \u03B5\u03BE\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03CE\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CE\u03BD.",
      removeResource: {
        messageLine1: "\u039F {{identifier}} \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
        messageLine2: "\u0394\u03B5\u03BD \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BA\u03B1\u03B9 \u03BF\u03C0\u03BF\u03B9\u03B5\u03C3\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03B5\u03BE\u03B1\u03C1\u03C4\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B5\u03C2 \u03B4\u03B5\u03BD \u03B8\u03B1 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03BF\u03CD\u03BD \u03C0\u03BB\u03AD\u03BF\u03BD.",
        successMessage: "\u039F {{connectedAccount}} \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
        title: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD"
      },
      socialButtonsBlockButton: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC {{provider|titleize}}",
      successMessage: "\u039F \u03C0\u03AC\u03C1\u03BF\u03C7\u03BF\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD"
    },
    deletePage: {
      actionDescription: '\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD" \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.',
      confirm: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
      messageLine1: "\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03C2 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2;",
      messageLine2: "\u0391\u03C5\u03C4\u03AE \u03B7 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03CC\u03BD\u03B9\u03BC\u03B7 \u03BA\u03B1\u03B9 \u03BC\u03B7 \u03B1\u03BD\u03B1\u03C3\u03C4\u03C1\u03AD\u03C8\u03B9\u03BC\u03B7.",
      title: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u0398\u03B1 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03AD\u03BD\u03B1 email \u03C0\u03BF\u03C5 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03AD\u03BD\u03B1\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email.",
        formSubtitle: "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03C3\u03C4\u03B7\u03BD {{identifier}}",
        formTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
        resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC; \u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2",
        successMessage: "\u03A4\u03BF email {{identifier}} \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2."
      },
      emailLink: {
        formHint: "\u0398\u03B1 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03AD\u03BD\u03B1 email \u03C0\u03BF\u03C5 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03AD\u03BD\u03B1\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email.",
        formSubtitle: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C3\u03C4\u03BF email \u03C0\u03BF\u03C5 \u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03C3\u03C4\u03B7\u03BD {{identifier}}",
        formTitle: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
        resendButton: "\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF; \u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2",
        successMessage: "\u03A4\u03BF email {{identifier}} \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 {{identifier}} \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
        messageLine2: "\u0394\u03B5\u03BD \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email.",
        successMessage: "\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 {{emailAddress}} \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
        title: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 email"
      },
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 email",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7",
    formButtonPrimary__continue: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
    formButtonPrimary__finish: "\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7",
    formButtonPrimary__remove: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
    formButtonPrimary__save: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7",
    formButtonReset: "\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7",
    mfaPage: {
      formHint: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03B3\u03B9\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7.",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B4\u03B9\u03C0\u03BB\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
      removeResource: {
        messageLine1: "\u039F {{identifier}} \u03B4\u03B5\u03BD \u03B8\u03B1 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03B9 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7.",
        messageLine2: "\u039F \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03BD\u03B4\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03BC\u03B7\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03CC\u03C3\u03BF \u03B1\u03C3\u03C6\u03B1\u03BB\u03AE\u03C2. \u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5;",
        successMessage: "\u0397 \u03B4\u03B9\u03C0\u03BB\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03BC\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 SMS \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 {{mfaPhoneCode}}",
        title: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B4\u03B9\u03C0\u03BB\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2"
      },
      subtitle__availablePhoneNumbers: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03B5\u03AF\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03B4\u03B9\u03C0\u03BB\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03BC\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 SMS.",
      subtitle__unavailablePhoneNumbers: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03B9 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03AF \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03B3\u03B9\u03B1 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03B4\u03B9\u03C0\u03BB\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03BC\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2 SMS.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u03A3\u03AC\u03C1\u03C9\u03C3\u03B7 QR \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03B1\u03BD\u03C4\u03AF \u03B1\u03C5\u03C4\u03BF\u03CD",
        buttonUnableToScan__nonPrimary: "\u0394\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03B1\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD QR \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC;",
        infoText__ableToScan: "\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BD\u03AD\u03B1 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2 \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03C3\u03B1\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 QR \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C4\u03BF\u03BD \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
        infoText__unableToScan: "\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BD\u03AD\u03B1 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B7\u03BD \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03BB\u03B5\u03B9\u03B4\u03AF \u03C0\u03BF\u03C5 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9.",
        inputLabel__unableToScan1: "\u0392\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03BF\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03C0\u03BF\u03C5 \u03B2\u03B1\u03C3\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF\u03BD \u03C7\u03C1\u03CC\u03BD\u03BF \u03AE \u03BC\u03AF\u03B1\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF\u03B9 \u03BA\u03B1\u03B9 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03C3\u03B1\u03C2.",
        inputLabel__unableToScan2: "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03BA\u03C4\u03B9\u03BA\u03AC, \u03B5\u03AC\u03BD \u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03B9 TOTP URIs, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 URI."
      },
      removeResource: {
        messageLine1: "\u0394\u03B5\u03BD \u03B8\u03B1 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7.",
        messageLine2: "\u039F \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03BD\u03B4\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03BC\u03B7\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03CC\u03C3\u03BF \u03B1\u03C3\u03C6\u03B1\u03BB\u03AE\u03C2. \u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5;",
        successMessage: "\u0397 \u03B4\u03B9\u03C0\u03BB\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03BC\u03AD\u03C3\u03C9 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2 \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF.",
        title: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B4\u03B9\u03C0\u03BB\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2"
      },
      successMessage: "\u0397 \u03B4\u03B9\u03C0\u03BB\u03AE \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BB\u03AD\u03BF\u03BD \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03B7. \u039A\u03B1\u03C4\u03AC \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7, \u03B8\u03B1 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2 \u03C9\u03C2 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03B2\u03AE\u03BC\u03B1.",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2 \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2",
      verifySubtitle: "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2",
      verifyTitle: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2"
    },
    mobileButton__menu: "\u039C\u03B5\u03BD\u03BF\u03CD",
    navbar: {
      account: "\u03A0\u03C1\u03BF\u03C6\u03AF\u03BB",
      description: "\u0394\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C4\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03C3\u03B1\u03C2.",
      security: "\u0391\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1",
      title: "\u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C3\u03C4\u03B9\u03B3\u03BC\u03AE \u03B5\u03C0\u03B5\u03B9\u03B4\u03AE \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03BC\u03AD\u03C3\u03C9 \u03C4\u03B7\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7.",
      successMessage__set: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BF\u03C1\u03B9\u03C3\u03C4\u03B5\u03AF.",
      successMessage__signOutOfOtherSessions: "\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03AC\u03BB\u03BB\u03B5\u03C2 \u03C3\u03C5\u03BD\u03B5\u03B4\u03C1\u03AF\u03B5\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BD \u03B1\u03C0\u03BF\u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF.",
      successMessage__update: "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.",
      title__set: "\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
      title__update: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2"
    },
    phoneNumberPage: {
      infoText: "\u0398\u03B1 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03AD\u03BD\u03B1 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03BA\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C0\u03BF\u03C5 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03AD\u03BD\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5.",
      removeResource: {
        messageLine1: "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 {{identifier}} \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
        messageLine2: "\u0394\u03B5\u03BD \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5.",
        successMessage: "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 {{phoneNumber}} \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
        title: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5"
      },
      successMessage: "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 {{identifier}} \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03B5 \u03BC\u03BF\u03C1\u03C6\u03AE JPG, PNG, GIF \u03AE WEBP \u03BC\u03B9\u03BA\u03C1\u03CC\u03C4\u03B5\u03C1\u03B7 \u03C4\u03C9\u03BD 10 MB",
      imageFormDestructiveActionSubtitle: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
      imageFormSubtitle: "\u0391\u03BD\u03AD\u03B2\u03B1\u03C3\u03BC\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
      imageFormTitle: "\u0395\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB",
      readonly: "\u039F\u03B9 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C3\u03B1\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C0\u03B1\u03C1\u03B1\u03C3\u03C7\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03BF\u03CD\u03BD.",
      successMessage: "\u03A4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.",
      title: "\u0395\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE",
        title: "\u0395\u03BD\u03B5\u03C1\u03B3\u03AD\u03C2 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AD\u03C2"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u03A0\u03C1\u03BF\u03C3\u03C0\u03AC\u03B8\u03B5\u03B9\u03B1 \u03BE\u03B1\u03BD\u03AC",
        actionLabel__reauthorize: "\u0395\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C4\u03CE\u03C1\u03B1",
        destructiveActionTitle: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
        primaryButton: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "\u03A3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF\u03B9 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03AF"
      },
      dangerSection: {
        deleteAccountButton: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
        title: "\u039A\u03AF\u03BD\u03B4\u03C5\u03BD\u03BF\u03C2"
      },
      emailAddressesSection: {
        destructiveAction: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 email",
        detailsAction__nonPrimary: "\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C9\u03C2 \u03BA\u03CD\u03C1\u03B9\u03B1",
        detailsAction__primary: "\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
        detailsAction__unverified: "\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
        primaryButton: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 email",
        title: "\u0394\u03B9\u03B5\u03C5\u03B8\u03CD\u03BD\u03C3\u03B5\u03B9\u03C2 email"
      },
      enterpriseAccountsSection: {
        title: "\u0395\u03C0\u03B9\u03C7\u03B5\u03B9\u03C1\u03B7\u03C3\u03B9\u03B1\u03BA\u03BF\u03AF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03AF"
      },
      headerTitle__account: "\u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2",
      headerTitle__security: "\u0391\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u0395\u03C0\u03B1\u03BD\u03B1\u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CE\u03BD",
          headerTitle: "\u0395\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03AF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF",
          subtitle__regenerate: "\u039B\u03AC\u03B2\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03BD\u03AD\u03BF \u03C3\u03B5\u03C4 \u03B1\u03C3\u03C6\u03B1\u03BB\u03CE\u03BD \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03CE\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CE\u03BD. \u039F\u03B9 \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF\u03B9 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03BF\u03AF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B8\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03BF\u03CD\u03BD \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03BF\u03CD\u03BD.",
          title__regenerate: "\u0395\u03C0\u03B1\u03BD\u03B1\u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03B5\u03C6\u03B5\u03B4\u03C1\u03B9\u03BA\u03CE\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CE\u03BD"
        },
        phoneCode: {
          actionLabel__setDefault: "\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C9\u03C2 \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF\u03C2",
          destructiveActionLabel: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5"
        },
        primaryButton: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2 \u03B4\u03CD\u03BF \u03B2\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD",
        title: "\u0391\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03B4\u03CD\u03BF \u03B2\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD",
        totp: {
          destructiveActionTitle: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
          headerTitle: "\u0395\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B1\u03C5\u03B8\u03B5\u03BD\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
        primaryButton__updatePassword: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
        title: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2"
      },
      phoneNumbersSection: {
        destructiveAction: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
        detailsAction__nonPrimary: "\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C9\u03C2 \u03BA\u03CD\u03C1\u03B9\u03BF\u03C2",
        detailsAction__primary: "\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
        detailsAction__unverified: "\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
        primaryButton: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
        title: "\u0391\u03C1\u03B9\u03B8\u03BC\u03BF\u03AF \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5"
      },
      profileSection: {
        primaryButton: "\u0395\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB",
        title: "\u03A0\u03C1\u03BF\u03C6\u03AF\u03BB"
      },
      usernameSection: {
        primaryButton__setUsername: "\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
        primaryButton__updateUsername: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
        title: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7"
      },
      web3WalletsSection: {
        destructiveAction: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD",
        primaryButton: "\u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9\u03B1 Web3",
        title: "\u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9\u03B1 Web3"
      }
    },
    usernamePage: {
      successMessage: "\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.",
      title__set: "\u0395\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7",
      title__update: "\u0395\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03BF\u03BD\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "\u03A4\u03BF {{identifier}} \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
        messageLine2: "\u0394\u03B5\u03BD \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF web3 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9.",
        successMessage: "\u03A4\u03BF {{web3Wallet}} \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
        title: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 web3 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD"
      },
      subtitle__availableWallets: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1 web3 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C4\u03BF \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
      subtitle__unavailableWallets: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 web3 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9\u03B1.",
      successMessage: "\u03A4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.",
      title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 web3 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/sk-SK.ts
var skSK = {
  locale: "sk-SK",
  backButton: "Sp\xE4\u0165",
  badge__default: "Predvolen\xE9",
  badge__otherImpersonatorDevice: "In\xE9 zariadenie z\xE1stupcu",
  badge__primary: "Hlavn\xFD",
  badge__requiresAction: "Vy\u017Eaduje akciu",
  badge__thisDevice: "Toto zariadenie",
  badge__unverified: "Nepotvrden\xE9",
  badge__userDevice: "Zariadenie pou\u017E\xEDvate\u013Ea",
  badge__you: "Vy",
  createOrganization: {
    formButtonSubmit: "Vytvori\u0165 organiz\xE1ciu",
    invitePage: {
      formButtonReset: "Presko\u010Di\u0165"
    },
    title: "Vytvori\u0165 organiz\xE1ciu"
  },
  dates: {
    lastDay: "V\u010Dera o {{ date | timeString('sk-SK') }}",
    next6Days: "P\u0159\xED\u0161t\xED {{ date | weekday('sk-SK','long') }} o {{ date | timeString('sk-SK') }}",
    nextDay: "Zajtra o {{ date | timeString('sk-SK') }}",
    numeric: "{{ date | numeric('sk-SK') }}",
    previous6Days: "Minul\xFD {{ date | weekday('sk-SK','long') }} o {{ date | timeString('sk-SK') }}",
    sameDay: "Dnes o {{ date | timeString('sk-SK') }}"
  },
  dividerText: "alebo",
  footerActionLink__useAnotherMethod: "Pou\u017Ei\u0165 in\xFA met\xF3du",
  footerPageLink__help: "Pomoc",
  footerPageLink__privacy: "Ochrana s\xFAkromia",
  footerPageLink__terms: "Podmienky",
  formButtonPrimary: "Pokra\u010Dova\u0165",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "Zabudli ste heslo?",
  formFieldError__matchingPasswords: "Hesl\xE1 sa zhoduj\xFA.",
  formFieldError__notMatchingPasswords: "Hesl\xE1 sa nezhoduj\xFA.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "Volite\u013En\xE9",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "Zadajte alebo vlo\u017Ete jednu alebo viac emailov\xFDch adries oddelen\xFDch medzerou alebo \u010Diarkou",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "Z\xE1lo\u017En\xFD k\xF3d",
  formFieldLabel__confirmDeletion: "Confirmation",
  formFieldLabel__confirmPassword: "Potvrdi\u0165 heslo",
  formFieldLabel__currentPassword: "S\xFA\u010Dasn\xE9 heslo",
  formFieldLabel__emailAddress: "Emailov\xE1 adresa",
  formFieldLabel__emailAddress_username: "Emailov\xE1 adresa alebo u\u017E\xEDvate\u013Esk\xE9 meno",
  formFieldLabel__emailAddresses: "Emailov\xE9 adresy",
  formFieldLabel__firstName: "Meno",
  formFieldLabel__lastName: "Priezvisko",
  formFieldLabel__newPassword: "Nov\xE9 heslo",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "N\xE1zov organiz\xE1cie",
  formFieldLabel__organizationSlug: "URL adresa",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "Heslo",
  formFieldLabel__phoneNumber: "Telef\xF3nne \u010D\xEDslo",
  formFieldLabel__role: "Rola",
  formFieldLabel__signOutOfOtherSessions: "Odhl\xE1si\u0165 sa zo v\u0161etk\xFDch ostatn\xFDch zariaden\xED",
  formFieldLabel__username: "U\u017E\xEDvate\u013Esk\xE9 meno",
  impersonationFab: {
    action__signOut: "Odhl\xE1si\u0165 sa",
    title: "Prihl\xE1sen\xFD(\xE1) ako {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "Spr\xE1vca",
  membershipRole__basicMember: "\u010Clen",
  membershipRole__guestMember: "Host",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Pozv\xE1nky sa nepodarilo odosla\u0165. Opravte nasleduj\xFAce a sk\xFAste to znovu:",
      formButtonPrimary__continue: "Odosla\u0165 pozv\xE1nky",
      selectDropdown__role: "Select role",
      subtitle: "Pozva\u0165 nov\xFDch \u010Dlenov do tejto organiz\xE1cie",
      successMessage: "Pozv\xE1nky boli \xFAspe\u0161ne odoslan\xE9.",
      title: "Pozva\u0165 \u010Dlenov"
    },
    membersPage: {
      action__invite: "Pozva\u0165",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Odstr\xE1ni\u0165 \u010Dlena",
        tableHeader__actions: void 0,
        tableHeader__joined: "Pripojil sa",
        tableHeader__role: "Rola",
        tableHeader__user: "U\u017E\xEDvate\u013E"
      },
      detailsTitle__emptyRow: "\u017Diadni \u010Dlenovia na zobrazenie",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "Zru\u0161i\u0165 pozvanie",
        tableHeader__invited: "Pozvan\xED"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to delete this organization?",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have deleted the organization.",
          title: "Delete organization"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Naozaj chcete opusti\u0165 t\xFAto organiz\xE1ciu? Strat\xEDte pr\xEDstup k tejto organiz\xE1cii a jej aplik\xE1ci\xE1m.",
          messageLine2: "T\xE1to akcia je trval\xE1 a nezvratn\xE1.",
          successMessage: "Opustili ste organiz\xE1ciu.",
          title: "Opusti\u0165 organiz\xE1ciu"
        },
        title: "Upozornenie"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "Organiz\xE1cia bola aktualizovan\xE1.",
      title: "Profil organiz\xE1cie"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\u010Clenovia",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Vytvori\u0165 organiz\xE1ciu",
    action__invitationAccept: "Join",
    action__manageOrganization: "Spravova\u0165 organiz\xE1ciu",
    action__suggestionsAccept: "Request to join",
    notSelected: "Nie je vybran\xE1 \u017Eiadna organiz\xE1cia",
    personalWorkspace: "Osobn\xFD pracovn\xFD priestor",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "\u010Eal\u0161ie",
  paginationButton__previous: "Predch\xE1dzaj\xFAce",
  paginationRowText__displaying: "Zobrazuje sa",
  paginationRowText__of: "z",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Z\xEDska\u0165 pomoc",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Pou\u017Ei\u0165 z\xE1lo\u017En\xFD k\xF3d",
      blockButton__emailCode: "Odosla\u0165 overovac\xED k\xF3d na email {{identifier}}",
      blockButton__emailLink: "Odosla\u0165 odkaz na email {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "Prihl\xE1si\u0165 sa pomocou hesla",
      blockButton__phoneCode: "Posla\u0165 SMS k\xF3d na telef\xF3nne \u010D\xEDslo {{identifier}}",
      blockButton__totp: "Pou\u017Ei\u0165 autentifika\u010Dn\xFA aplik\xE1ciu",
      getHelp: {
        blockButton__emailSupport: "Podpora cez email",
        content: "Ak m\xE1te probl\xE9my s prihl\xE1sen\xEDm do svojho \xFA\u010Dtu, kontaktujte n\xE1s emailom a pok\xFAsime sa v\xE1m \u010Do najsk\xF4r obnovi\u0165 pr\xEDstup.",
        title: "Z\xEDska\u0165 pomoc"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "Pou\u017Ei\u0165 in\xFA met\xF3du"
    },
    backupCodeMfa: {
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Zadajte z\xE1lo\u017En\xFD k\xF3d"
    },
    emailCode: {
      formTitle: "Overovac\xED k\xF3d",
      resendButton: "Znovu posla\u0165 k\xF3d",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Skontrolujte svoj email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "Vr\xE1\u0165te sa do p\xF4vodn\xE9ho okna pre pokra\u010Dovanie.",
        title: "Tento overovac\xED odkaz vypr\u0161al"
      },
      failed: {
        subtitle: "Vr\xE1\u0165te sa do p\xF4vodn\xE9ho okna pre pokra\u010Dovanie.",
        title: "Tento overovac\xED odkaz je neplatn\xFD"
      },
      formSubtitle: "Pou\u017Eite overovac\xED odkaz zaslan\xFD na v\xE1\u0161 email",
      formTitle: "Overovac\xED odkaz",
      loading: {
        subtitle: "\u010Coskoro budete presmerovan\xED",
        title: "Prihlasujem..."
      },
      resendButton: "Znovu posla\u0165 odkaz",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Skontrolujte svoj email",
      unusedTab: {
        title: "M\xF4\u017Eete zatvori\u0165 toto okno"
      },
      verified: {
        subtitle: "\u010Coskoro budete presmerovan\xED",
        title: "\xDAspe\u0161ne prihl\xE1sen\xE9"
      },
      verifiedSwitchTab: {
        subtitle: "Vr\xE1\u0165te sa do p\xF4vodn\xE9ho okna pre pokra\u010Dovanie",
        subtitleNewTab: "Vr\xE1\u0165te sa do novootvoren\xE9ho okna pre pokra\u010Dovanie",
        titleNewTab: "Prihl\xE1sen\xE9 v inom okne"
      }
    },
    forgotPassword: {
      formTitle: "Overovac\xED k\xF3d pre obnovenie hesla",
      resendButton: "Znovu posla\u0165 k\xF3d",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Obnovi\u0165 heslo",
      label__alternativeMethods: "Alebo sa prihl\xE1ste pomocou inej met\xF3dy.",
      title: "Zabudli ste heslo?"
    },
    noAvailableMethods: {
      message: "Nemo\u017Eno pokra\u010Dova\u0165 v prihl\xE1sen\xED. Nie je k dispoz\xEDcii \u017Eiadna dostupn\xE1 autentifika\u010Dn\xE1 met\xF3da.",
      subtitle: "Do\u0161lo k chybe",
      title: "Nie je mo\u017En\xE9 sa prihl\xE1si\u0165"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "Pou\u017Ei\u0165 in\xFA met\xF3du",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Zadajte svoje heslo"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "Overovac\xED k\xF3d",
      resendButton: "Znova odosla\u0165 k\xF3d",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Skontrolujte v\xE1\u0161 telef\xF3n"
    },
    phoneCodeMfa: {
      formTitle: "Overovac\xED k\xF3d",
      resendButton: "Znova odosla\u0165 k\xF3d",
      subtitle: void 0,
      title: "Skontrolujte v\xE1\u0161 telef\xF3n"
    },
    resetPassword: {
      formButtonPrimary: "Obnovi\u0165 heslo",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "Va\u0161e heslo bolo \xFAspe\u0161ne zmenen\xE9. Prihlasujem v\xE1s, pros\xEDm po\u010Dkajte okam\u017Eite.",
      title: "Obnovi\u0165 heslo"
    },
    resetPasswordMfa: {
      detailsLabel: "Pred obnoven\xEDm hesla je potrebn\xE9 overi\u0165 va\u0161u toto\u017Enos\u0165."
    },
    start: {
      actionLink: "Registrova\u0165 sa",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Pou\u017Ei\u0165 email",
      actionLink__use_email_username: "Pou\u017Ei\u0165 email alebo u\u017E\xEDvate\u013Esk\xE9 meno",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "Pou\u017Ei\u0165 telef\xF3n",
      actionLink__use_username: "Pou\u017Ei\u0165 u\u017E\xEDvate\u013Esk\xE9 meno",
      actionText: "Nem\xE1te \xFA\u010Det?",
      actionText__join_waitlist: void 0,
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      subtitleCombined: void 0,
      title: "Prihl\xE1si\u0165 sa",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Overovac\xED k\xF3d",
      subtitle: void 0,
      title: "Dvojfaktorov\xE9 overenie"
    }
  },
  signInEnterPasswordTitle: "Zadajte svoje heslo",
  signUp: {
    continue: {
      actionLink: "Prihl\xE1si\u0165 sa",
      actionText: "M\xE1te \xFA\u010Det?",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Vypl\u0148te ch\xFDbaj\xFAce polia"
    },
    emailCode: {
      formSubtitle: "Zadajte overovac\xED k\xF3d poslan\xFD na va\u0161u emailov\xFA adresu",
      formTitle: "Overovac\xED k\xF3d",
      resendButton: "Znovu posla\u0165 k\xF3d",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Overte svoj email"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "Pou\u017Eite overovac\xED odkaz poslan\xFD na va\u0161u emailov\xFA adresu",
      formTitle: "Overovac\xED odkaz",
      loading: {
        title: "Prebieha registr\xE1cia..."
      },
      resendButton: "Znovu posla\u0165 odkaz",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Overte svoj email",
      verified: {
        title: "\xDAspe\u0161ne zaregistrovan\xE9"
      },
      verifiedSwitchTab: {
        subtitle: "Vr\xE1\u0165te sa do novootvoren\xE9ho okna pre pokra\u010Dovanie",
        subtitleNewTab: "Vr\xE1\u0165te sa do predch\xE1dzaj\xFAceho okna pre pokra\u010Dovanie",
        title: "Email \xFAspe\u0161ne overen\xFD"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Zadajte overovac\xED k\xF3d poslan\xFD na va\u0161e telef\xF3nne \u010D\xEDslo",
      formTitle: "Overovac\xED k\xF3d",
      resendButton: "Znovu posla\u0165 k\xF3d",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Overte svoj telef\xF3n"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Prihl\xE1si\u0165 sa",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "M\xE1te \xFA\u010Det?",
      subtitle: "pre pokra\u010Dovanie do {{applicationName}}",
      subtitleCombined: "pre pokra\u010Dovanie do {{applicationName}}",
      title: "Vytvorte si \xFA\u010Det",
      titleCombined: "Vytvorte si \xFA\u010Det"
    }
  },
  socialButtonsBlockButton: "Pokra\u010Dova\u0165 s {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Sign up unsuccessful due to failed security validations. Please refresh the page to try again or reach out to support for more assistance.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Email address must be a valid email address.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Va\u0161e heslo nie je dostato\u010Dne siln\xE9.",
    form_password_pwned: "Toto heslo bolo n\xE1jden\xE9 v r\xE1mci \xFAniku d\xE1t a nem\xF4\u017Ee by\u0165 pou\u017Eit\xE9, pros\xEDm zvo\u013Ete in\xE9 heslo.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "Va\u0161e heslo prekro\u010Dilo maxim\xE1lny povolen\xFD po\u010Det bytov, pros\xEDm skr\xE1\u0165te ho alebo odstr\xE1\u0148te niektor\xE9 \u0161peci\xE1lne znaky.",
    form_password_validation_failed: "Nespr\xE1vne heslo",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "menej ako {{length}} znakov",
      minimumLength: "{{length}} alebo viac znakov",
      requireLowercase: "mal\xE9 p\xEDsmeno",
      requireNumbers: "\u010D\xEDslicu",
      requireSpecialCharacter: "\u0161peci\xE1lny znak",
      requireUppercase: "ve\u013Ek\xE9 p\xEDsmeno",
      sentencePrefix: "Va\u0161e heslo mus\xED obsahova\u0165"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Va\u0161e heslo funguje, ale mohlo by by\u0165 silnej\u0161ie. Sk\xFAste prida\u0165 viac znakov.",
      goodPassword: "Dobr\xE1 pr\xE1ca. Toto je vynikaj\xFAce heslo.",
      notEnough: "Va\u0161e heslo nen\xED dostato\u010Dne siln\xE9.",
      suggestions: {
        allUppercase: "Pou\u017Eite ve\u013Ek\xE9 p\xEDsmena len u niektor\xFDch, nie v\u0161etk\xFDch p\xEDsmen.",
        anotherWord: "Pridajte viac slov, ktor\xE9 nie s\xFA tak be\u017En\xE9.",
        associatedYears: "Vyhnite sa rokom, ktor\xE9 s\xFA s vami spojen\xE9.",
        capitalization: "P\xEDsmen\xE1 p\xED\u0161te s ve\u013Ek\xFDm po\u010Diato\u010Dn\xFDm p\xEDsmenom a viac ako len prv\xFDm p\xEDsmenom.",
        dates: "Vyhnite sa d\xE1tumom a rokom, ktor\xE9 s\xFA s vami spojen\xE9.",
        l33t: "Vyhnite sa predv\xEDdate\u013En\xFDm n\xE1hrad\xE1m p\xEDsmen, napr\xEDklad '@' miesto 'a'.",
        longerKeyboardPattern: "Pou\u017Eite dlh\u0161ie vzory na kl\xE1vesnici a menite smer p\xEDsania viackr\xE1t.",
        noNeed: "M\xF4\u017Eete vytv\xE1ra\u0165 siln\xE9 hesl\xE1 aj bez pou\u017Eitia symbolov, \u010D\xEDsel alebo ve\u013Ek\xFDch p\xEDsmen.",
        pwned: "Ak pou\u017E\xEDvate toto heslo aj niekde inde, mali by ste ho zmeni\u0165.",
        recentYears: "Vyhnite sa ned\xE1vnym rokom.",
        repeated: "Vyhnite sa opakuj\xFAcim sa slov\xE1m a znakom.",
        reverseWords: "Vyhnite sa obr\xE1ten\xFDm pravopisom be\u017En\xFDch slov.",
        sequences: "Vyhnite sa be\u017En\xFDm sekvenci\xE1m znakov.",
        useWords: "Pou\u017Eite viac slov, ale vyhnite sa be\u017En\xFDm fr\xE1zam."
      },
      warnings: {
        common: "Toto je be\u017Ene pou\u017E\xEDvan\xE9 heslo.",
        commonNames: "Be\u017En\xE9 men\xE1 a priezvisk\xE1 s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.",
        dates: "D\xE1tum je \u013Eahko uh\xE1dnute\u013En\xFD.",
        extendedRepeat: 'Opakuj\xFAce sa vzory znakov ako "abcabcabc" s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.',
        keyPattern: "Kr\xE1tke vzory na kl\xE1vesnici s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.",
        namesByThemselves: "Samostatn\xE9 men\xE1 alebo priezvisk\xE1 s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.",
        pwned: "Va\u0161e heslo bolo odhalen\xE9 pri \xFAniku \xFAdajov na internete.",
        recentYears: "Ned\xE1vne roky s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.",
        sequences: 'Be\u017En\xE9 sekvencie znakov ako "abc" s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.',
        similarToCommon: "Toto je podobn\xE9 be\u017Ene pou\u017E\xEDvan\xE9mu heslu.",
        simpleRepeat: 'Opakuj\xFAce sa znaky ako "aaa" s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.',
        straightRow: "Rady kl\xE1vesnice s\xFA \u013Eahko uh\xE1dnute\u013En\xE9.",
        topHundred: "Toto je \u010Dasto pou\u017E\xEDvan\xE9 heslo.",
        topTen: "Toto je \u010Dasto pou\u017E\xEDvan\xE9 heslo.",
        userInputs: "Heslo by nemalo obsahova\u0165 osobn\xE9 alebo str\xE1nkou s\xFAvisiace \xFAdaje.",
        wordByItself: "Samostatn\xE9 slov\xE1 s\xFA \u013Eahko uh\xE1dnute\u013En\xE9."
      }
    }
  },
  userButton: {
    action__addAccount: "Prida\u0165 \xFA\u010Det",
    action__manageAccount: "Spravova\u0165 \xFA\u010Det",
    action__signOut: "Odhl\xE1si\u0165 sa",
    action__signOutAll: "Odhl\xE1si\u0165 sa zo v\u0161etk\xFDch \xFA\u010Dtov"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Skop\xEDrovan\xE9!",
      actionLabel__copy: "Kop\xEDrova\u0165 v\u0161etko",
      actionLabel__download: "Stiahnu\u0165 .txt",
      actionLabel__print: "Vytla\u010Di\u0165",
      infoText1: "Pre tento \xFA\u010Det bud\xFA povolen\xE9 z\xE1lo\u017En\xE9 k\xF3dy.",
      infoText2: "Z\xE1lo\u017En\xE9 k\xF3dy uchov\xE1vajte tajne a bezpe\u010Dne. M\xF4\u017Eete vygenerova\u0165 nov\xE9 z\xE1lo\u017En\xE9 k\xF3dy, ak m\xE1te podozrenie, \u017Ee boli skompromitovan\xE9.",
      subtitle__codelist: "Uchov\xE1vajte ich bezpe\u010Dne a tajne.",
      successMessage: "Z\xE1lo\u017En\xE9 k\xF3dy s\xFA teraz povolen\xE9. Ak strat\xEDte pr\xEDstup k v\xE1\u0161mu overovaciemu zariadeniu, m\xF4\u017Eete pou\u017Ei\u0165 jeden z t\xFDchto k\xF3dov na prihl\xE1senie do v\xE1\u0161ho \xFA\u010Dtu. Ka\u017Ed\xFD k\xF3d mo\u017Eno pou\u017Ei\u0165 iba raz.",
      successSubtitle: "Pou\u017Eite jeden z t\xFDchto k\xF3dov na prihl\xE1senie do v\xE1\u0161ho \xFA\u010Dtu, ak strat\xEDte pr\xEDstup k v\xE1\u0161mu overovaciemu zariadeniu.",
      title: "Prida\u0165 overovanie pomocou z\xE1lo\u017En\xFDch k\xF3dov",
      title__codelist: "Z\xE1lo\u017En\xE9 k\xF3dy"
    },
    connectedAccountPage: {
      formHint: "Vyberte poskytovate\u013Ea pre pripojenie v\xE1\u0161ho \xFA\u010Dtu.",
      formHint__noAccounts: "Nie s\xFA k dispoz\xEDcii \u017Eiadni dostupn\xED extern\xED poskytovatelia \xFA\u010Dtov.",
      removeResource: {
        messageLine1: "{{identifier}} bude odobran\xFD z tohto \xFA\u010Dtu.",
        messageLine2: "Nebudete u\u017E m\xF4c\u0165 pou\u017E\xEDva\u0165 tento pripojen\xFD \xFA\u010Det a ak\xE9ko\u013Evek z\xE1visl\xE9 funkcie prestan\xFA fungova\u0165.",
        successMessage: "{{connectedAccount}} bol odstr\xE1nen\xFD z v\xE1\u0161ho \xFA\u010Dtu.",
        title: "Odstr\xE1ni\u0165 pripojen\xFD \xFA\u010Det"
      },
      socialButtonsBlockButton: "Pripoji\u0165 \xFA\u010Det {{provider|titleize}}",
      successMessage: "Poskytovate\u013E bol pridan\xFD k v\xE1\u0161mu \xFA\u010Dtu.",
      title: "Prida\u0165 pripojen\xFD \xFA\u010Det"
    },
    deletePage: {
      actionDescription: 'Type "Delete account" below to continue.',
      confirm: "Delete account",
      messageLine1: "Are you sure you want to delete your account?",
      messageLine2: "This action is permanent and irreversible.",
      title: "Delete account"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Na t\xFAto e-mailov\xFA adresu bude odoslan\xFD overovac\xED k\xF3d.",
        formSubtitle: "Zadajte overovac\xED k\xF3d zaslan\xFD na adresu {{identifier}}",
        formTitle: "Overovac\xED k\xF3d",
        resendButton: "Znovu odosla\u0165 k\xF3d",
        successMessage: "E-mailov\xE1 adresa {{identifier}} bola pridan\xE1 k v\xE1\u0161mu \xFA\u010Dtu."
      },
      emailLink: {
        formHint: "Na t\xFAto e-mailov\xFA adresu bude odoslan\xFD overovac\xED odkaz.",
        formSubtitle: "Kliknite na overovac\xED odkaz v e-maile zaslanom na adresu {{identifier}}",
        formTitle: "Overovac\xED odkaz",
        resendButton: "Znovu odosla\u0165 odkaz",
        successMessage: "E-mailov\xE1 adresa {{identifier}} bola pridan\xE1 k v\xE1\u0161mu \xFA\u010Dtu."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} bude odstr\xE1nen\xE1 z tohto \xFA\u010Dtu.",
        messageLine2: "Nebudete sa m\xF4c\u0165 prihl\xE1si\u0165 pomocou tejto e-mailovej adresy.",
        successMessage: "{{emailAddress}} bola odobran\xE1 z v\xE1\u0161ho \xFA\u010Dtu.",
        title: "Odstr\xE1ni\u0165 e-mailov\xFA adresu"
      },
      title: "Prida\u0165 e-mailov\xFA adresu",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Pokra\u010Dova\u0165",
    formButtonPrimary__finish: "Dokon\u010Di\u0165",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "Zru\u0161i\u0165",
    mfaPage: {
      formHint: "Vyberte sp\xF4sob pridania.",
      title: "Prida\u0165 dvojfaktorov\xE9 overenie"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "Prida\u0165 telef\xF3nne \u010D\xEDslo",
      removeResource: {
        messageLine1: "{{identifier}} u\u017E nebude dost\xE1va\u0165 overovacie k\xF3dy pri prihlasovan\xED.",
        messageLine2: "V\xE1\u0161 \xFA\u010Det nemus\xED by\u0165 tak bezpe\u010Dn\xFD. Naozaj chcete pokra\u010Dova\u0165?",
        successMessage: "Dvojfaktorov\xE9 overovanie pomocou SMS k\xF3du bolo odstr\xE1nen\xE9 pre {{mfaPhoneCode}}",
        title: "Odstr\xE1ni\u0165 dvojfaktorov\xE9 overovanie"
      },
      subtitle__availablePhoneNumbers: "Vyberte telef\xF3nne \u010D\xEDslo pre registr\xE1ciu dvojfaktorov\xE9ho overovania pomocou SMS k\xF3du.",
      subtitle__unavailablePhoneNumbers: "Nie s\xFA k dispoz\xEDcii \u017Eiadne dostupn\xE9 telef\xF3nne \u010D\xEDsla pre registr\xE1ciu dvojfaktorov\xE9ho overovania pomocou SMS k\xF3du.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "Prida\u0165 overovanie pomocou SMS k\xF3du"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Namiesto toho naskenujte QR k\xF3d",
        buttonUnableToScan__nonPrimary: "Nem\xF4\u017Eete naskenova\u0165 QR k\xF3d?",
        infoText__ableToScan: "Nastavte nov\xFA met\xF3du prihl\xE1senia vo va\u0161ej aplik\xE1cii pre overovanie a naskenujte nasleduj\xFAci QR k\xF3d, aby ste ju spojili so svoj\xEDm \xFA\u010Dtom.",
        infoText__unableToScan: "Nastavte nov\xFA met\xF3du prihl\xE1senia vo va\u0161ej aplik\xE1cii pre overovanie a zadajte ni\u017E\u0161ie uveden\xFD k\u013E\xFA\u010D.",
        inputLabel__unableToScan1: "Uistite sa, \u017Ee je povolen\xE9 \u010Dasovo z\xE1visl\xE9 alebo jednor\xE1zov\xE9 heslo a dokon\u010Dite spojenie v\xE1\u0161ho \xFA\u010Dtu.",
        inputLabel__unableToScan2: "Alternat\xEDvne, ak va\u0161a aplik\xE1cia pre overovanie podporuje TOTP URI, m\xF4\u017Eete tie\u017E skop\xEDrova\u0165 cel\xFD URI."
      },
      removeResource: {
        messageLine1: "Pri prihlasovan\xED u\u017E nebud\xFA vy\u017Eadovan\xE9 overovacie k\xF3dy z tejto aplik\xE1cie pre overovanie.",
        messageLine2: "V\xE1\u0161 \xFA\u010Det nemus\xED by\u0165 tak bezpe\u010Dn\xFD. Naozaj chcete pokra\u010Dova\u0165?",
        successMessage: "Dvojfaktorov\xE9 overovanie pomocou aplik\xE1cie pre overovanie bolo odstr\xE1nen\xE9.",
        title: "Odstr\xE1ni\u0165 dvojfaktorov\xE9 overovanie"
      },
      successMessage: "Dvojfaktorov\xE9 overovanie je teraz povolen\xE9. Pri prihl\xE1sen\xED budete musie\u0165 zada\u0165 overovac\xED k\xF3d z tejto aplik\xE1cie pre overovanie ako \u010Fal\u0161\xED krok.",
      title: "Prida\u0165 aplik\xE1ciu pre overovanie",
      verifySubtitle: "Zadajte overovac\xED k\xF3d generovan\xFD va\u0161ou aplik\xE1ciou pre overovanie.",
      verifyTitle: "Overovac\xED k\xF3d"
    },
    mobileButton__menu: "Menu",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "Va\u0161e heslo bolo nastaven\xE9.",
      successMessage__signOutOfOtherSessions: "V\u0161etky ostatn\xE9 zariadenia boli odhl\xE1sen\xE9.",
      successMessage__update: "Va\u0161e heslo bolo aktualizovan\xE9.",
      title__set: "Nastavi\u0165 heslo",
      title__update: "Zmeni\u0165 heslo"
    },
    phoneNumberPage: {
      infoText: "Na toto telef\xF3nne \u010D\xEDslo bude odoslan\xE1 textov\xE1 spr\xE1va obsahuj\xFAca overovac\xED odkaz.",
      removeResource: {
        messageLine1: "{{identifier}} bude odobran\xE9 z tohto \xFA\u010Dtu.",
        messageLine2: "Nebudete sa m\xF4c\u0165 prihl\xE1si\u0165 pomocou tohto telef\xF3nneho \u010D\xEDsla.",
        successMessage: "{{phoneNumber}} bolo odstr\xE1nen\xE9 z v\xE1\u0161ho \xFA\u010Dtu.",
        title: "Odstr\xE1ni\u0165 telef\xF3nne \u010D\xEDslo"
      },
      successMessage: "{{identifier}} bolo pridan\xE9 k v\xE1\u0161mu \xFA\u010Dtu.",
      title: "Prida\u0165 telef\xF3nne \u010D\xEDslo",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "Nahrajte obr\xE1zok vo form\xE1toch JPG, PNG, GIF alebo WEBP s ve\u013Ekos\u0165ou men\u0161ou ne\u017E 10 MB",
      imageFormDestructiveActionSubtitle: "Odstr\xE1ni\u0165 obr\xE1zok",
      imageFormSubtitle: "Nahra\u0165 obr\xE1zok",
      imageFormTitle: "Profilov\xFD obr\xE1zok",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "V\xE1\u0161 profil bol aktualizovan\xFD.",
      title: "Aktualizova\u0165 profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Odhl\xE1si\u0165 sa zo zariadenia",
        title: "Akt\xEDvne zariadenia"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Sk\xFAsi\u0165 znovu",
        actionLabel__reauthorize: "Autorizova\u0165 teraz",
        destructiveActionTitle: "Odstr\xE1ni\u0165",
        primaryButton: "Pripoji\u0165 \xFA\u010Det",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "Pripojen\xE9 \xFA\u010Dty"
      },
      dangerSection: {
        deleteAccountButton: "Delete Account",
        title: "Account termination"
      },
      emailAddressesSection: {
        destructiveAction: "Odstr\xE1ni\u0165 emailov\xFA adresu",
        detailsAction__nonPrimary: "Nastavi\u0165 ako hlavn\xFA",
        detailsAction__primary: "Dokon\u010Di\u0165 overenie",
        detailsAction__unverified: "Dokon\u010Di\u0165 overenie",
        primaryButton: "Prida\u0165 emailov\xFA adresu",
        title: "Emailov\xE9 adresy"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "\xDA\u010Det",
      headerTitle__security: "Bezpe\u010Dnos\u0165",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Obnovi\u0165 k\xF3dy",
          headerTitle: "Z\xE1lo\u017En\xE9 k\xF3dy",
          subtitle__regenerate: "Z\xEDskajte nov\xFA sadu zabezpe\u010Den\xFDch z\xE1lo\u017En\xFDch k\xF3dov. Predch\xE1dzaj\xFAce z\xE1lo\u017En\xE9 k\xF3dy bud\xFA zmazan\xE9 a nebud\xFA pou\u017Eite\u013En\xE9.",
          title__regenerate: "Obnovi\u0165 z\xE1lo\u017En\xE9 k\xF3dy"
        },
        phoneCode: {
          actionLabel__setDefault: "Nastavi\u0165 ako predvolen\xE9",
          destructiveActionLabel: "Odstr\xE1ni\u0165 telef\xF3nne \u010D\xEDslo"
        },
        primaryButton: "Prida\u0165 dvojfaktorov\xFA autentifik\xE1ciu",
        title: "Dvojfaktorov\xE1 autentifik\xE1cia",
        totp: {
          destructiveActionTitle: "Odstr\xE1ni\u0165",
          headerTitle: "Aplik\xE1cia Authenticator"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "Nastavi\u0165 heslo",
        primaryButton__updatePassword: "Zmeni\u0165 heslo",
        title: "Heslo"
      },
      phoneNumbersSection: {
        destructiveAction: "Odstr\xE1ni\u0165 telef\xF3nne \u010D\xEDslo",
        detailsAction__nonPrimary: "Nastavi\u0165 ako hlavn\xE9",
        detailsAction__primary: "Dokon\u010Di\u0165 overenie",
        detailsAction__unverified: "Dokon\u010Di\u0165 overenie",
        primaryButton: "Prida\u0165 telef\xF3nne \u010D\xEDslo",
        title: "Telef\xF3nne \u010D\xEDsla"
      },
      profileSection: {
        primaryButton: void 0,
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Nastavi\u0165 u\u017E\xEDvate\u013Esk\xE9 meno",
        primaryButton__updateUsername: "Zmeni\u0165 u\u017E\xEDvate\u013Esk\xE9 meno",
        title: "U\u017E\xEDvate\u013Esk\xE9 meno"
      },
      web3WalletsSection: {
        destructiveAction: "Odstr\xE1ni\u0165 pe\u0148a\u017Eenku",
        primaryButton: "Web3 pe\u0148a\u017Eenky",
        title: "Web3 pe\u0148a\u017Eenky"
      }
    },
    usernamePage: {
      successMessage: "Va\u0161e u\u017E\xEDvate\u013Esk\xE9 meno bolo aktualizovan\xE9.",
      title__set: "Aktualizova\u0165 u\u017E\xEDvate\u013Esk\xE9 meno",
      title__update: "Aktualizova\u0165 u\u017E\xEDvate\u013Esk\xE9 meno"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} bude odobran\xE1 z tohto \xFA\u010Dtu.",
        messageLine2: "Nebudete sa u\u017E m\xF4c\u0165 prihl\xE1si\u0165 pomocou tejto web3 pe\u0148a\u017Eenky.",
        successMessage: "{{web3Wallet}} bola odstr\xE1nen\xE1 z v\xE1\u0161ho \xFA\u010Dtu.",
        title: "Odstr\xE1ni\u0165 web3 pe\u0148a\u017Eenku"
      },
      subtitle__availableWallets: "Vyberte web3 pe\u0148a\u017Eenku na pripojenie k v\xE1\u0161mu \xFA\u010Dtu.",
      subtitle__unavailableWallets: "Nie s\xFA k dispoz\xEDcii \u017Eiadne dostupn\xE9 web3 pe\u0148a\u017Eenky.",
      successMessage: "Pe\u0148a\u017Eenka bola pridan\xE1 k v\xE1\u0161mu \xFA\u010Dtu.",
      title: "Prida\u0165 web3 pe\u0148a\u017Eenku",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/uk-UA.ts
var ukUA = {
  locale: "uk-UA",
  backButton: "\u041D\u0430\u0437\u0430\u0434",
  badge__default: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
  badge__otherImpersonatorDevice: "\u0406\u043D\u0448\u0438\u0439 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439-\u0434\u0432\u0456\u0439\u043D\u0438\u043A",
  badge__primary: "\u041E\u0441\u043D\u043E\u0432\u043D\u0438\u0439",
  badge__requiresAction: "\u041F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0434\u0456\u0457",
  badge__thisDevice: "\u0426\u0435\u0439 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439",
  badge__unverified: "\u041D\u0435\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0439",
  badge__userDevice: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
  badge__you: "\u0412\u0438",
  createOrganization: {
    formButtonSubmit: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E",
    invitePage: {
      formButtonReset: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438"
    },
    title: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E"
  },
  dates: {
    lastDay: "\u0412\u0447\u043E\u0440\u0430 \u0432 {{ date | timeString('uk-UA') }}",
    next6Days: "{{ date | weekday('uk-UA','long') }} \u0432 {{ date | timeString('uk-UA') }}",
    nextDay: "\u0417\u0430\u0432\u0442\u0440\u0430 \u0432 {{ date | timeString('uk-UA') }}",
    numeric: "{{ date | numeric('uk-UA') }}",
    previous6Days: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 {{ date | weekday('uk-UA','long') }} \u0432 {{ date | timeString('uk-UA') }}",
    sameDay: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u0432 {{ date | timeString('uk-UA') }}"
  },
  dividerText: "\u0430\u0431\u043E",
  footerActionLink__useAnotherMethod: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0456\u043D\u0448\u0438\u0439 \u043C\u0435\u0442\u043E\u0434",
  footerPageLink__help: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
  footerPageLink__privacy: "\u041F\u0440\u0438\u0432\u0430\u0442\u043D\u0456\u0441\u0442\u044C",
  footerPageLink__terms: "\u0423\u043C\u043E\u0432\u0438",
  formButtonPrimary: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
  formFieldError__matchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0456 \u0437\u0431\u0456\u0433\u0430\u044E\u0442\u044C\u0441\u044F.",
  formFieldError__notMatchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0456 \u043D\u0435 \u0437\u0431\u0456\u0433\u0430\u044E\u0442\u044C\u0441\u044F.",
  formFieldError__verificationLinkExpired: "The verification link expired. Please request a new link.",
  formFieldHintText__optional: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
  formFieldHintText__slug: "A slug is a human-readable ID that must be unique. It\u2019s often used in URLs.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0430\u0431\u043E \u0432\u0441\u0442\u0430\u0432\u0442\u0435 \u043E\u0434\u043D\u0443 \u0430\u0431\u043E \u0431\u0456\u043B\u044C\u0448\u0435 \u0430\u0434\u0440\u0435\u0441 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438, \u0440\u043E\u0437\u0434\u0456\u043B\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0431\u0456\u043B\u0430\u043C\u0438 \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043C\u0438",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Enable automatic invitations for this domain",
  formFieldLabel__backupCode: "\u041A\u043E\u0434 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
  formFieldLabel__confirmDeletion: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
  formFieldLabel__confirmPassword: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
  formFieldLabel__currentPassword: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__emailAddress: "\u041F\u043E\u0448\u0442\u0430",
  formFieldLabel__emailAddress_username: "\u041F\u043E\u0448\u0442\u0430 \u0430\u0431\u043E \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
  formFieldLabel__emailAddresses: "\u041F\u043E\u0448\u0442\u043E\u0432\u0456 \u0430\u0434\u0440\u0435\u0441\u0438",
  formFieldLabel__firstName: "\u0406\u043C'\u044F",
  formFieldLabel__lastName: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
  formFieldLabel__newPassword: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Delete pending invitations and suggestions",
  formFieldLabel__organizationDomainEmailAddress: "Verification email address",
  formFieldLabel__organizationDomainEmailAddressDescription: "Enter an email address under this domain to receive a code and verify this domain.",
  formFieldLabel__organizationName: "\u041D\u0430\u0437\u0432\u0430 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457",
  formFieldLabel__organizationSlug: "URL \u0430\u0434\u0440\u0435\u0441\u0430",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u041F\u0430\u0440\u043E\u043B\u044C",
  formFieldLabel__phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
  formFieldLabel__role: "\u0420\u043E\u043B\u044C",
  formFieldLabel__signOutOfOtherSessions: "\u0412\u0438\u0439\u0442\u0438 \u0437 \u0443\u0441\u0456\u0445 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432",
  formFieldLabel__username: "\u0406\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
  impersonationFab: {
    action__signOut: "\u0412\u0438\u0439\u0442\u0438",
    title: "\u0412\u0438 \u0443\u0432\u0456\u0439\u0448\u043B\u0438 \u044F\u043A {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
  membershipRole__basicMember: "\u0427\u043B\u0435\u043D",
  membershipRole__guestMember: "\u0413\u0456\u0441\u0442\u044C",
  organizationList: {
    action__createOrganization: "Create organization",
    action__invitationAccept: "Join",
    action__suggestionsAccept: "Request to join",
    createOrganization: "Create Organization",
    invitationAcceptedLabel: "Joined",
    subtitle: "to continue to {{applicationName}}",
    suggestionsAcceptedLabel: "Pending approval",
    title: "Choose an account",
    titleWithoutPersonal: "Choose an organization"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatic invitations",
    badge__automaticSuggestion: "Automatic suggestions",
    badge__manualInvitation: "No automatic enrollment",
    badge__unverified: "Unverified",
    createDomainPage: {
      subtitle: "Add the domain to verify. Users with email addresses at this domain can join the organization automatically or request to join.",
      title: "Add domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u0417\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438. \u0412\u0438\u043F\u0440\u0430\u0432\u0442\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0456 \u043F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443:",
      formButtonPrimary__continue: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u044F",
      selectDropdown__role: "Select role",
      subtitle: "\u0417\u0430\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u043D\u043E\u0432\u0438\u0445 \u0443\u0447\u0430\u0441\u043D\u0438\u043A\u0456\u0432 \u0434\u043E \u0446\u0456\u0454\u0457 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457",
      successMessage: "\u0417\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      title: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438 \u0443\u0447\u0430\u0441\u043D\u0438\u043A\u0456\u0432"
    },
    membersPage: {
      action__invite: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0443\u0447\u0430\u0441\u043D\u0438\u043A\u0430",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0432\u0441\u044F",
        tableHeader__role: "\u0420\u043E\u043B\u044C",
        tableHeader__user: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447"
      },
      detailsTitle__emptyRow: "\u041D\u0435\u043C\u0430\u0454 \u0443\u0447\u0430\u0441\u043D\u0438\u043A\u0456\u0432 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invite users by connecting an email domain with your organization. Anyone who signs up with a matching email domain will be able to join the organization anytime.",
          headerTitle: "Automatic invitations",
          primaryButton: "Manage verified domains"
        },
        table__emptyRow: "No invitations to display"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u0412\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u0442\u0438 \u0437\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u044F",
        tableHeader__invited: "\u0417\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u0456"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Users who sign up with a matching email domain, will be able to see a suggestion to request to join your organization.",
          headerTitle: "Automatic suggestions",
          primaryButton: "Manage verified domains"
        },
        menuAction__approve: "Approve",
        menuAction__reject: "Reject",
        tableHeader__requested: "Requested access",
        table__emptyRow: "No requests to display"
      },
      start: {
        headerTitle__invitations: "Invitations",
        headerTitle__members: "Members",
        headerTitle__requests: "Requests"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "Are you sure you want to delete this organization?",
          messageLine2: "This action is permanent and irreversible.",
          successMessage: "You have deleted the organization.",
          title: "Delete organization"
        },
        leaveOrganization: {
          actionDescription: 'Type "{{organizationName}}" below to continue.',
          messageLine1: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u0446\u044E \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E? \u0412\u0438 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0446\u0456\u0454\u0457 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457 \u0442\u0430 \u0457\u0457 \u0434\u043E\u0434\u0430\u0442\u043A\u0456\u0432.",
          messageLine2: "\u0426\u044F \u0434\u0456\u044F \u0454 \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u043E\u044E \u0456 \u043D\u0435\u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u044E.",
          successMessage: "\u0412\u0438 \u043F\u043E\u043A\u0438\u043D\u0443\u043B\u0438 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E.",
          title: "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E"
        },
        title: "\u041D\u0435\u0431\u0435\u0437\u043F\u0435\u043A\u0430"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Add domain",
        subtitle: "Allow users to join the organization automatically or request to join based on a verified email domain.",
        title: "Verified domains"
      },
      successMessage: "\u041E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E \u0431\u0443\u043B\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
      title: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457"
    },
    removeDomainPage: {
      messageLine1: "The email domain {{domain}} will be removed.",
      messageLine2: "Users won\u2019t be able to join the organization automatically after this.",
      successMessage: "{{domain}} has been removed.",
      title: "Remove domain"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Removing this domain will affect invited users.",
        removeDomainActionLabel__remove: "Remove domain",
        removeDomainSubtitle: "Remove this domain from your verified domains",
        removeDomainTitle: "Remove domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Users are automatically invited to join the organization when they sign-up and can join anytime.",
        automaticInvitationOption__label: "Automatic invitations",
        automaticSuggestionOption__description: "Users receive a suggestion to request to join, but must be approved by an admin before they are able to join the organization.",
        automaticSuggestionOption__label: "Automatic suggestions",
        calloutInfoLabel: "Changing the enrollment mode will only affect new users.",
        calloutInvitationCountLabel: "Pending invitations sent to users: {{count}}",
        calloutSuggestionCountLabel: "Pending suggestions sent to users: {{count}}",
        manualInvitationOption__description: "Users can only be invited manually to the organization.",
        manualInvitationOption__label: "No automatic enrollment",
        subtitle: "Choose how users from this domain can join the organization."
      },
      start: {
        headerTitle__danger: "Danger",
        headerTitle__enrollment: "Enrollment options"
      },
      subtitle: "The domain {{domain}} is now verified. Continue by selecting enrollment mode.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Enter the verification code sent to your email address",
      formTitle: "Verification code",
      resendButton: "Didn't receive a code? Resend",
      subtitle: "The domain {{domainName}} needs to be verified via email.",
      subtitleVerificationCodeScreen: "A verification code was sent to {{emailAddress}}. Enter the code to continue.",
      title: "Verify domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044E",
    action__invitationAccept: "Join",
    action__manageOrganization: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0454\u044E",
    action__suggestionsAccept: "Request to join",
    notSelected: "\u041E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u043D\u0435 \u043E\u0431\u0440\u0430\u043D\u0430",
    personalWorkspace: "\u041E\u0441\u043E\u0431\u0438\u0441\u0442\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043F\u0440\u043E\u0441\u0442\u0456\u0440",
    suggestionsAcceptedLabel: "Pending approval"
  },
  paginationButton__next: "\u0412\u043F\u0435\u0440\u0435\u0434",
  paginationButton__previous: "\u041D\u0430\u0437\u0430\u0434",
  paginationRowText__displaying: "\u0412\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
  paginationRowText__of: "\u0437",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043A\u043E\u0434 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      blockButton__emailCode: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__emailLink: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 \u043F\u0430\u0440\u043E\u043B\u0435\u043C",
      blockButton__phoneCode: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043A\u043E\u0434 \u043D\u0430 {{identifier}}",
      blockButton__totp: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440",
      getHelp: {
        blockButton__emailSupport: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0432 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0443",
        content: "\u042F\u043A\u0449\u043E \u0443 \u0432\u0430\u0441 \u0432\u0438\u043D\u0438\u043A\u043B\u0438 \u0442\u0440\u0443\u0434\u043D\u043E\u0449\u0456 \u0437 \u0432\u0445\u043E\u0434\u043E\u043C \u0443 \u0412\u0430\u0448 \u0430\u043A\u0430\u0443\u043D\u0442, \u043D\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u043D\u0430\u043C, \u0456 \u043C\u0438 \u043F\u043E\u043F\u0440\u0430\u0446\u044E\u0454\u043C\u043E \u0437 \u0412\u0430\u043C\u0438, \u0449\u043E\u0431 \u0432\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u044F\u043A\u043D\u0430\u0439\u0448\u0432\u0438\u0434\u0448\u0435.",
        title: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0456\u043D\u0448\u0438\u0439 \u043C\u0435\u0442\u043E\u0434"
    },
    backupCodeMfa: {
      subtitle: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F"
    },
    emailCode: {
      formTitle: "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      resendButton: "\u041D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043A\u043E\u0434? \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
      subtitle: "\u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0434\u043E {{applicationName}}",
      title: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0432\u043E\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.",
        title: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u0456\u0457 \u0446\u044C\u043E\u0433\u043E \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F"
      },
      failed: {
        subtitle: "\u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
        title: "\u0426\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0454 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u043C"
      },
      formSubtitle: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F, \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u0435 \u043D\u0430 \u0412\u0430\u0448\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443",
      formTitle: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      loading: {
        subtitle: "\u0412\u0430\u0441 \u0431\u0443\u0434\u0435 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430\u0439\u0431\u043B\u0438\u0436\u0447\u0438\u043C \u0447\u0430\u0441\u043E\u043C",
        title: "\u0412\u0445\u0456\u0434 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443..."
      },
      resendButton: "\u041F\u0435\u0440\u0435\u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
      subtitle: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0412\u0430\u0448\u0443 \u043F\u043E\u0448\u0442\u0443",
      unusedTab: {
        title: "\u0412\u043A\u043B\u0430\u0434\u043A\u0443 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0438"
      },
      verified: {
        subtitle: "\u0412\u0438 \u0441\u043A\u043E\u0440\u043E \u0431\u0443\u0434\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0456",
        title: "\u0423\u0441\u043F\u0456\u0448\u043D\u0438\u0439 \u0432\u0445\u0456\u0434"
      },
      verifiedSwitchTab: {
        subtitle: "\u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
        subtitleNewTab: "\u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0449\u043E\u0439\u043D\u043E \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E\u0457 \u0432\u043A\u043B\u0430\u0434\u043A\u0438, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
        titleNewTab: "\u0412\u0438 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u043D\u0430 \u0456\u043D\u0448\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456"
      }
    },
    forgotPassword: {
      formTitle: "\u041A\u043E\u0434 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
      resendButton: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043A\u043E\u0434 \u0449\u0435 \u0440\u0430\u0437",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0412\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
      label__alternativeMethods: "\u0410\u0431\u043E, \u0443\u0432\u0456\u0439\u0442\u0438 \u0456\u043D\u0448\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C",
      title: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"
    },
    noAvailableMethods: {
      message: "\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0432\u0445\u0456\u0434. \u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0444\u0430\u043A\u0442\u043E\u0440\u0443 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457.",
      subtitle: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      title: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0443\u0432\u0456\u0439\u0442\u0438"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u0456\u043D\u0448\u0438\u0439 \u043C\u0435\u0442\u043E\u0434",
      subtitle: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      resendButton: "\u041D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043A\u043E\u0434? \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
      subtitle: "\u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0432 {{applicationName}}",
      title: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0432\u0456\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    phoneCodeMfa: {
      formTitle: "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      resendButton: "\u041D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043A\u043E\u0434? \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
      subtitle: void 0,
      title: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0432\u0456\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    resetPassword: {
      formButtonPrimary: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
      requiredMessage: "For security reasons, it is required to reset your password.",
      successMessage: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u043C\u0456\u043D\u0435\u043D\u043E. \u0412\u0438\u043A\u043E\u043D\u0443\u0454\u0442\u044C\u0441\u044F \u0432\u0445\u0456\u0434, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435.",
      title: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    resetPasswordMfa: {
      detailsLabel: "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0443\u0432\u0430\u0442\u0438 \u0432\u0430\u0448\u0443 \u043E\u0441\u043E\u0431\u0443 \u043F\u0435\u0440\u0435\u0434 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F\u043C \u043F\u0430\u0440\u043E\u043B\u044F"
    },
    start: {
      actionLink: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0442\u0443",
      actionLink__use_email_username: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0442\u0443 \u0430\u0431\u043E \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      actionLink__use_username: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      actionText: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0430\u0443\u043D\u0442\u0430?",
      actionText__join_waitlist: void 0,
      subtitle: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      subtitleCombined: void 0,
      title: "\u0423\u0432\u0456\u0439\u0442\u0438",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434",
      subtitle: void 0,
      title: "\u0414\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430"
    }
  },
  signInEnterPasswordTitle: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
  signUp: {
    continue: {
      actionLink: "\u0423\u0432\u0456\u0439\u0442\u0438",
      actionText: "\u0423\u0436\u0435 \u0454 \u0430\u043A\u0430\u0443\u043D\u0442?",
      subtitle: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043F\u043E\u043B\u044F"
    },
    emailCode: {
      formSubtitle: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F, \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u0438\u0439 \u043D\u0430 \u0432\u0430\u0448\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443",
      formTitle: "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      resendButton: "\u041D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043A\u043E\u0434? \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
      subtitle: "\u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0434\u043E {{applicationName}}",
      title: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0441\u0432\u043E\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F, \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u0435 \u043D\u0430 \u0432\u0430\u0448\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443",
      formTitle: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      loading: {
        title: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F..."
      },
      resendButton: "\u041D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F? \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
      subtitle: "\u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0434\u043E {{applicationName}}",
      title: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0441\u0432\u043E\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443",
      verified: {
        title: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u043E"
      },
      verifiedSwitchTab: {
        subtitle: "\u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u043D\u043E\u0432\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
        subtitleNewTab: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E\u0457 \u0432\u043A\u043B\u0430\u0434\u043A\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F",
        title: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E email"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F, \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u0438\u0439 \u043D\u0430 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      formTitle: "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      resendButton: "\u041D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043A\u043E\u0434? \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
      subtitle: "\u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0437 {{applicationName}}",
      title: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0441\u0432\u0456\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "\u0423\u0432\u0456\u0439\u0442\u0438",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\u0423\u0436\u0435 \u0454 \u0430\u043A\u0430\u0443\u043D\u0442?",
      subtitle: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      subtitleCombined: '\u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 "{{applicationName}}"',
      title: "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0412\u0430\u0448 \u0430\u043A\u0430\u0443\u043D\u0442",
      titleCombined: "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0412\u0430\u0448 \u0430\u043A\u0430\u0443\u043D\u0442"
    }
  },
  socialButtonsBlockButton: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Sign up unsuccessful due to failed security validations. Please refresh the page to try again or reach out to support for more assistance.",
    captcha_unavailable: "Sign up unsuccessful due to failed bot validation. Please refresh the page to try again or reach out to support for more assistance.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Email address must be a valid email address.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "First name should not exceed 256 characters.",
    form_param_max_length_exceeded__last_name: "Last name should not exceed 256 characters.",
    form_param_max_length_exceeded__name: "Name should not exceed 256 characters.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u043D\u0430\u0434\u0456\u0439\u043D\u0438\u0439.",
    form_password_pwned: "\u0426\u0435\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u0443\u043B\u043E \u0437\u043B\u0430\u043C\u0430\u043D\u043E \u0456 \u0439\u043E\u0433\u043E \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0456\u043D\u0448\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0443 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0431\u0430\u0439\u0442\u0456\u0432, \u0441\u043A\u043E\u0440\u043E\u0442\u0456\u0442\u044C \u0439\u043E\u0433\u043E \u0430\u0431\u043E \u0432\u0438\u0434\u0430\u043B\u0456\u0442\u044C \u0434\u0435\u044F\u043A\u0456 \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0438.",
    form_password_validation_failed: "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "You cannot delete your last identification.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "\u043C\u0435\u043D\u0448\u0435 {{length}} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
      minimumLength: "{{length}} \u0430\u0431\u043E \u0431\u0456\u043B\u044C\u0448\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
      requireLowercase: "\u0431\u0443\u043A\u0432\u0443 \u0432 \u043D\u0438\u0436\u043D\u044C\u043E\u043C\u0443 \u0440\u0435\u0433\u0456\u0441\u0442\u0440\u0456",
      requireNumbers: "\u0446\u0438\u0444\u0440\u0443",
      requireSpecialCharacter: "\u0441\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
      requireUppercase: "\u0431\u0443\u043A\u0432\u0443 \u0443 \u0432\u0435\u0440\u0445\u043D\u044C\u043E\u043C\u0443 \u0440\u0435\u0433\u0456\u0441\u0442\u0440\u0456",
      sentencePrefix: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u043C\u0456\u0441\u0442\u0438\u0442\u0438"
    },
    phone_number_exists: "This phone number is taken. Please try another.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0456\u0434\u0445\u043E\u0434\u0438\u0442\u044C, \u0430\u043B\u0435 \u043C\u0456\u0433 \u0431\u0438 \u0431\u0443\u0442\u0438 \u043D\u0430\u0434\u0456\u0439\u043D\u0456\u0448\u0438\u043C. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432.",
      goodPassword: "\u0425\u043E\u0440\u043E\u0448\u0430 \u0440\u043E\u0431\u043E\u0442\u0430. \u0426\u0435 \u0432\u0456\u0434\u043C\u0456\u043D\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
      notEnough: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u043D\u0430\u0434\u0456\u0439\u043D\u0438\u0439.",
      suggestions: {
        allUppercase: "\u0420\u043E\u0431\u0456\u0442\u044C \u0432\u0435\u043B\u0438\u043A\u0438\u043C\u0438 \u0434\u0435\u044F\u043A\u0456, \u0430\u043B\u0435 \u043D\u0435 \u0432\u0441\u0456 \u0431\u0443\u043A\u0432\u0438.",
        anotherWord: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 \u0441\u043B\u0456\u0432, \u044F\u043A\u0456 \u043C\u0435\u043D\u0448 \u043F\u043E\u0448\u0438\u0440\u0435\u043D\u0456.",
        associatedYears: "\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u0440\u043E\u043A\u0456\u0432, \u044F\u043A\u0456 \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u0437 \u0432\u0430\u043C\u0438.",
        capitalization: "\u0420\u043E\u0431\u0456\u0442\u044C \u0432\u0435\u043B\u0438\u043A\u0438\u043C\u0438 \u043D\u0435 \u0442\u0456\u043B\u044C\u043A\u0438 \u043F\u0435\u0440\u0448\u0443 \u0431\u0443\u043A\u0432\u0443",
        dates: "\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u0434\u0430\u0442 \u0456 \u0440\u043E\u043A\u0456\u0432, \u044F\u043A\u0456 \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u0437 \u0432\u0430\u043C\u0438.",
        l33t: '\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0434\u0431\u0430\u0447\u0443\u0432\u0430\u043D\u0438\u0445 \u0437\u0430\u043C\u0456\u043D \u0431\u0443\u043A\u0432, \u0442\u0430\u043A\u0438\u0445 \u044F\u043A "@" \u0437\u0430\u043C\u0456\u0441\u0442\u044C "a".',
        longerKeyboardPattern: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0434\u043E\u0432\u0448\u0456 \u043F\u043E\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u043A\u043B\u0430\u0432\u0456\u0448 \u0456 \u043A\u0456\u043B\u044C\u043A\u0430 \u0440\u0430\u0437\u0456\u0432 \u0437\u043C\u0456\u043D\u044E\u0439\u0442\u0435 \u043D\u0430\u043F\u0440\u044F\u043C\u043E\u043A \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F.",
        noNeed: "\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u044E\u0432\u0430\u0442\u0438 \u043D\u0430\u0434\u0456\u0439\u043D\u0456 \u043F\u0430\u0440\u043E\u043B\u0456 \u0431\u0435\u0437 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432, \u0446\u0438\u0444\u0440 \u0430\u0431\u043E \u0432\u0435\u043B\u0438\u043A\u0438\u0445 \u043B\u0456\u0442\u0435\u0440.",
        pwned: "\u042F\u043A\u0449\u043E \u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u0446\u0435\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0432 \u0456\u043D\u0448\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456, \u0432\u0430\u043C \u0441\u043B\u0456\u0434 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u0439\u043E\u0433\u043E.",
        recentYears: "\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u043E\u0441\u0442\u0430\u043D\u043D\u0456\u0445 \u0440\u043E\u043A\u0456\u0432.",
        repeated: "\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u044E\u0432\u0430\u043D\u0438\u0445 \u0441\u043B\u0456\u0432 \u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432.",
        reverseWords: "\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u0433\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0447\u0430\u0441\u0442\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u043D\u0438\u0445 \u0441\u043B\u0456\u0432.",
        sequences: "\u0423\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u0447\u0430\u0441\u0442\u0438\u0445 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0435\u0439 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432.",
        useWords: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043A\u0456\u043B\u044C\u043A\u0430 \u0441\u043B\u0456\u0432, \u0430\u043B\u0435 \u0443\u043D\u0438\u043A\u0430\u0439\u0442\u0435 \u043F\u043E\u0448\u0438\u0440\u0435\u043D\u0438\u0445 \u0444\u0440\u0430\u0437."
      },
      warnings: {
        common: "\u0426\u0435 \u043F\u043E\u0448\u0438\u0440\u0435\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        commonNames: "\u041F\u043E\u0448\u0438\u0440\u0435\u043D\u0456 \u0456\u043C\u0435\u043D\u0430 \u0442\u0430 \u043F\u0440\u0456\u0437\u0432\u0438\u0449\u0430 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.",
        dates: "\u0414\u0430\u0442\u0438 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.",
        extendedRepeat: '\u0428\u0430\u0431\u043B\u043E\u043D\u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432, \u0449\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u044E\u044E\u0442\u044C\u0441\u044F, \u0442\u0430\u043A\u0456 \u044F\u043A "abcabcabcabc", \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.',
        keyPattern: "\u041A\u043E\u0440\u043E\u0442\u043A\u0456 \u043F\u043E\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u043A\u043B\u0430\u0432\u0456\u0448 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.",
        namesByThemselves: "\u041E\u0434\u043D\u0456 \u0456\u043C\u0435\u043D\u0430 \u0430\u0431\u043E \u043F\u0440\u0456\u0437\u0432\u0438\u0449\u0430 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.",
        pwned: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u0443\u043B\u043E \u0440\u043E\u0437\u043A\u0440\u0438\u0442\u043E \u0432\u043D\u0430\u0441\u043B\u0456\u0434\u043E\u043A \u0432\u0438\u0442\u043E\u043A\u0443 \u0434\u0430\u043D\u0438\u0445 \u0432 \u0406\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0456.",
        recentYears: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0440\u043E\u043A\u0438 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.",
        sequences: '\u0427\u0430\u0441\u0442\u0456 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432, \u0442\u0430\u043A\u0456 \u044F\u043A "abc", \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.',
        similarToCommon: "\u0426\u0435\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0441\u0445\u043E\u0436\u0438\u0439 \u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        simpleRepeat: '\u0421\u0438\u043C\u0432\u043E\u043B\u0438, \u0449\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u044E\u044E\u0442\u044C\u0441\u044F, \u0442\u0430\u043A\u0456 \u044F\u043A "aaa", \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.',
        straightRow: "\u041F\u0440\u044F\u043C\u0456 \u0440\u044F\u0434\u0438 \u043A\u043B\u0430\u0432\u0456\u0448 \u043D\u0430 \u043A\u043B\u0430\u0432\u0456\u0430\u0442\u0443\u0440\u0456 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438.",
        topHundred: "\u0426\u0435 \u0447\u0430\u0441\u0442\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        topTen: "\u0426\u0435 \u0434\u0443\u0436\u0435 \u0447\u0430\u0441\u0442\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C.",
        userInputs: "\u041D\u0435 \u043F\u043E\u0432\u0438\u043D\u043D\u043E \u0431\u0443\u0442\u0438 \u043D\u0456\u044F\u043A\u0438\u0445 \u043E\u0441\u043E\u0431\u0438\u0441\u0442\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0430\u0431\u043E \u0434\u0430\u043D\u0438\u0445, \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0438\u0445 \u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u043E\u044E.",
        wordByItself: "\u041E\u043A\u0440\u0435\u043C\u0456 \u0441\u043B\u043E\u0432\u0430 \u043B\u0435\u0433\u043A\u043E \u0432\u0433\u0430\u0434\u0430\u0442\u0438."
      }
    }
  },
  userButton: {
    action__addAccount: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442",
    action__manageAccount: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0430\u043A\u0430\u0443\u043D\u0442\u043E\u043C",
    action__signOut: "\u0412\u0438\u0439\u0442\u0438",
    action__signOutAll: "\u0412\u0438\u0439\u0442\u0438 \u0437 \u0443\u0441\u0456\u0445 \u0430\u043A\u0430\u0443\u043D\u0442\u0456\u0432"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E!",
      actionLabel__copy: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0432\u0441\u0435",
      actionLabel__download: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 .txt",
      actionLabel__print: "\u0414\u0440\u0443\u043A",
      infoText1: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0456 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
      infoText2: "\u0417\u0431\u0435\u0440\u0456\u0433\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438 \u0432 \u0442\u0430\u0454\u043C\u043D\u0438\u0446\u0456 \u0442\u0430 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0439\u0442\u0435 \u0457\u0445 \u0443 \u0431\u0435\u0437\u043F\u0435\u0446\u0456. \u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u0456 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438, \u044F\u043A\u0449\u043E \u043F\u0456\u0434\u043E\u0437\u0440\u044E\u0454\u0442\u0435, \u0449\u043E \u0432\u043E\u043D\u0438 \u0431\u0443\u043B\u0438 \u0441\u043A\u043E\u043C\u043F\u0440\u043E\u043C\u0435\u0442\u043E\u0432\u0430\u043D\u0456.",
      subtitle__codelist: "\u0417\u0431\u0435\u0440\u0456\u0433\u0430\u0439\u0442\u0435 \u0457\u0445 \u0443 \u0431\u0435\u0437\u043F\u0435\u0446\u0456 \u0442\u0430 \u043D\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u044F\u0439\u0442\u0435 \u043D\u0456\u043A\u043E\u043C\u0443.",
      successMessage: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438 \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E. \u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u043E\u0434\u0438\u043D \u0456\u0437 \u0446\u0438\u0445 \u043A\u043E\u0434\u0456\u0432 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0434\u043E \u0441\u0432\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0432\u043E\u0433\u043E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E. \u041A\u043E\u0436\u0435\u043D \u043A\u043E\u0434 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u0438\u0439 \u0442\u0456\u043B\u044C\u043A\u0438 \u043E\u0434\u0438\u043D \u0440\u0430\u0437.",
      successSubtitle: "\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u043E\u0434\u0438\u043D \u0456\u0437 \u0446\u0438\u0445 \u043A\u043E\u0434\u0456\u0432 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0443 \u0441\u0432\u0456\u0439 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0432\u043E\u0433\u043E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E.",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438\u0439 \u043A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      title__codelist: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438"
    },
    connectedAccountPage: {
      formHint: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0434\u043B\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u0430\u043A\u0430\u0443\u043D\u0442\u0430.",
      formHint__noAccounts: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0456\u0432 \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u0456\u0445 \u0430\u043A\u0430\u0443\u043D\u0442\u0456\u0432.",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        messageLine2: "\u0412\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0437\u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439 \u0430\u043A\u0430\u0443\u043D\u0442, \u0456 \u0431\u0443\u0434\u044C-\u044F\u043A\u0456 \u0437\u0430\u043B\u0435\u0436\u043D\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C.",
        successMessage: "{{connectedAccount}} \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        title: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439 \u0430\u043A\u0430\u0443\u043D\u0442"
      },
      socialButtonsBlockButton: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442 {{provider|titleize}}",
      successMessage: "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0431\u0443\u043B\u043E \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0430\u043A\u0430\u0443\u043D\u0442\u0430",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439 \u0430\u043A\u0430\u0443\u043D\u0442"
    },
    deletePage: {
      actionDescription: '\u0412\u0432\u0435\u0434\u0456\u0442\u044C "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442" \u043D\u0438\u0436\u0447\u0435, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.',
      confirm: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442",
      messageLine1: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0441\u0432\u0456\u0439 \u0430\u043A\u0430\u0443\u043D\u0442?",
      messageLine2: "\u0426\u044F \u0434\u0456\u044F \u0454 \u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u044E \u0442\u0430 \u043D\u0435\u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u044E.",
      title: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u041D\u0430 \u0446\u044E \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438 \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u043B\u0438\u0441\u0442 \u0456\u0437 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u043C \u043A\u043E\u0434\u043E\u043C.",
        formSubtitle: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434, \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 {{identifier}}",
        formTitle: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434",
        resendButton: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
        successMessage: "\u0410\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438 {{identifier}} \u0431\u0443\u043B\u043E \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443."
      },
      emailLink: {
        formHint: "\u041D\u0430 \u0446\u044E \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438 \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F.",
        formSubtitle: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u043B\u0438\u0441\u0442\u0456, \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E\u043C\u0443 \u043D\u0430 {{identifier}}",
        formTitle: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        resendButton: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
        successMessage: "\u0410\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438 {{identifier}} \u0431\u0443\u043B\u043E \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0446\u044C\u043E\u0433\u043E \u0430\u043A\u0430\u0443\u043D\u0442\u0430.",
        messageLine2: "\u0412\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0437\u043C\u043E\u0436\u0435\u0442\u0435 \u0443\u0432\u0456\u0439\u0442\u0438 \u0437 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F\u043C \u0446\u0456\u0454\u0457 \u0430\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438.",
        successMessage: "{{emailAddress}} \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        title: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438"
      },
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
    formButtonPrimary__finish: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    mfaPage: {
      formHint: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u0435\u0442\u043E\u0434 \u0434\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F.",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u0432\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044E"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435 \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0442\u0438 \u043A\u043E\u0434\u0438 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u0438 \u0432\u0445\u043E\u0434\u0456 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443.",
        messageLine2: "\u0412\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0431\u0443\u0434\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430\u0445\u0438\u0449\u0435\u043D\u0438\u043C. \u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?",
        successMessage: "\u0414\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0437 \u043A\u043E\u0434\u043E\u043C \u0437 SMS \u0431\u0443\u043B\u0430 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0430 \u0434\u043B\u044F {{mfaPhoneCode}}",
        title: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0443 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0443"
      },
      subtitle__availablePhoneNumbers: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0434\u043B\u044F \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457 \u0443 \u0434\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456 \u0437 \u043A\u043E\u0434\u043E\u043C \u0437 SMS.",
      subtitle__unavailablePhoneNumbers: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043D\u043E\u043C\u0435\u0440\u0456\u0432 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0434\u043B\u044F \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457 \u0432 \u0434\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456 \u0437 \u043A\u043E\u0434\u043E\u043C \u0437 SMS.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0443 \u043A\u043E\u0434\u043E\u043C \u0437 SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u0417\u0430\u043C\u0456\u0441\u0442\u044C \u0446\u044C\u043E\u0433\u043E \u0432\u0456\u0434\u0441\u043A\u0430\u043D\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434",
        buttonUnableToScan__nonPrimary: "\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0432\u0456\u0434\u0441\u043A\u0430\u043D\u0443\u0432\u0430\u0442\u0438 QR-\u043A\u043E\u0434?",
        infoText__ableToScan: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435 \u043D\u043E\u0432\u0438\u0439 \u043C\u0435\u0442\u043E\u0434 \u0432\u0445\u043E\u0434\u0443 \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 \u0442\u0430 \u0432\u0456\u0434\u0441\u043A\u0430\u043D\u0443\u0439\u0442\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 QR-\u043A\u043E\u0434, \u0449\u043E\u0431 \u043F\u043E\u0432'\u044F\u0437\u0430\u0442\u0438 \u0439\u043E\u0433\u043E \u0437 \u0432\u0430\u0448\u0438\u043C \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u043C \u0437\u0430\u043F\u0438\u0441\u043E\u043C.",
        infoText__unableToScan: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435 \u043D\u043E\u0432\u0438\u0439 \u043C\u0435\u0442\u043E\u0434 \u0432\u0445\u043E\u0434\u0443 \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 \u0442\u0430 \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0438\u0436\u0447\u0435 \u043D\u0430\u0434\u0430\u043D\u0438\u0439 \u043A\u043B\u044E\u0447.",
        inputLabel__unableToScan1: "\u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0456 \u043F\u0430\u0440\u043E\u043B\u0456 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u0447\u0430\u0441\u0443, \u043F\u043E\u0442\u0456\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0456\u0442\u044C \u0437\u0432'\u044F\u0437\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0432\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        inputLabel__unableToScan2: "\u041A\u0440\u0456\u043C \u0442\u043E\u0433\u043E, \u044F\u043A\u0449\u043E \u0432\u0430\u0448 \u0434\u043E\u0434\u0430\u0442\u043E\u043A \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 URI TOTP, \u0432\u0438 \u0442\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 URI."
      },
      removeResource: {
        messageLine1: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434 \u0456\u0437 \u0446\u044C\u043E\u0433\u043E \u0434\u043E\u0434\u0430\u0442\u043A\u0430 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043F\u0456\u0434 \u0447\u0430\u0441 \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443.",
        messageLine2: "\u0412\u0430\u0448 \u0430\u043A\u0430\u0443\u043D\u0442 \u0431\u0443\u0434\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430\u0445\u0438\u0449\u0435\u043D\u0438\u043C. \u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?",
        successMessage: "\u0414\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0443 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044E \u0447\u0435\u0440\u0435\u0437 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043E\u043A \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E.",
        title: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0434\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u043E\u0457 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457"
      },
      successMessage: "\u0414\u0432\u043E\u0435\u0442\u0430\u043F\u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0430. \u041F\u0456\u0434 \u0447\u0430\u0441 \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0431\u0443\u0434\u0435 \u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434 \u0456\u0437 \u0446\u044C\u043E\u0433\u043E \u0434\u043E\u0434\u0430\u0442\u043A\u0430 \u044F\u043A \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043A\u0440\u043E\u043A.",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043E\u043A \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457",
      verifySubtitle: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0439 \u0432\u0430\u0448\u0438\u043C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u043C \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457",
      verifyTitle: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434"
    },
    mobileButton__menu: "\u041C\u0435\u043D\u044E",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "Your password can currently not be edited because you can sign in only via the enterprise connection.",
      successMessage__set: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
      successMessage__signOutOfOtherSessions: "\u0423\u0441\u0456 \u0456\u043D\u0448\u0456 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457 \u0431\u0443\u043B\u0438 \u0432\u0438\u0432\u0435\u0434\u0435\u043D\u0456 \u0456\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u0438.",
      successMessage__update: "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u0443\u043B\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
      title__set: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
      title__update: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C"
    },
    phoneNumberPage: {
      infoText: "\u041D\u0430 \u0446\u0435\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0437 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u043C \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C.",
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        messageLine2: "\u0412\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0437\u043C\u043E\u0436\u0435\u0442\u0435 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0447\u0438 \u0446\u0435\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443.",
        successMessage: "{{phoneNumber}} \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        title: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443"
      },
      successMessage: "{{identifier}} \u0431\u0443\u043B\u043E \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0443 \u0444\u043E\u0440\u043C\u0430\u0442\u0430\u0445 JPG, PNG, GIF \u0430\u0431\u043E WEBP \u0440\u043E\u0437\u043C\u0456\u0440\u043E\u043C \u043C\u0435\u043D\u0448\u0435 10 \u041C\u0411",
      imageFormDestructiveActionSubtitle: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
      imageFormSubtitle: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
      imageFormTitle: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0444\u0456\u043B\u044E",
      readonly: "Your profile information has been provided by the enterprise connection and cannot be edited.",
      successMessage: "\u0412\u0430\u0448 \u043F\u0440\u043E\u0444\u0456\u043B\u044C \u0431\u0443\u043B\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
      title: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0412\u0438\u0439\u0442\u0438 \u0437 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E",
        title: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
        actionLabel__reauthorize: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0440\u0430\u0437",
        destructiveActionTitle: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        primaryButton: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0456 \u0430\u043A\u0430\u0443\u043D\u0442\u0438"
      },
      dangerSection: {
        deleteAccountButton: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0430\u043A\u0430\u0443\u043D\u0442",
        title: "\u041D\u0435\u0431\u0435\u0437\u043F\u0435\u043A\u0430"
      },
      emailAddressesSection: {
        destructiveAction: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        detailsAction__nonPrimary: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u044F\u043A \u043E\u0441\u043D\u043E\u0432\u043D\u0443",
        detailsAction__primary: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0443",
        detailsAction__unverified: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0443",
        primaryButton: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        title: "\u0410\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438"
      },
      enterpriseAccountsSection: {
        title: "Enterprise accounts"
      },
      headerTitle__account: "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
      headerTitle__security: "\u0411\u0435\u0437\u043F\u0435\u043A\u0430",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043A\u043E\u0434\u0438",
          headerTitle: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438",
          subtitle__regenerate: "\u041E\u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u0438\u0439 \u043D\u0430\u0431\u0456\u0440 \u0431\u0435\u0437\u043F\u0435\u0447\u043D\u0438\u0445 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438\u0445 \u043A\u043E\u0434\u0456\u0432. \u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442\u044C \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0456 \u0456 \u043D\u0435 \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u0456.",
          title__regenerate: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043D\u043E\u0432\u0456 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0456 \u043A\u043E\u0434\u0438"
        },
        phoneCode: {
          actionLabel__setDefault: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
          destructiveActionLabel: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443"
        },
        primaryButton: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u0432\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044E",
        title: "\u0414\u0432\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F",
        totp: {
          destructiveActionTitle: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
          headerTitle: "\u0414\u043E\u0434\u0430\u0442\u043E\u043A \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        primaryButton__updatePassword: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        title: "\u041F\u0430\u0440\u043E\u043B\u044C"
      },
      phoneNumbersSection: {
        destructiveAction: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
        detailsAction__nonPrimary: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u044F\u043A \u043E\u0441\u043D\u043E\u0432\u043D\u0438\u0439",
        detailsAction__primary: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044E",
        detailsAction__unverified: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044E",
        primaryButton: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
        title: "\u041D\u043E\u043C\u0435\u0440\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0456\u0432"
      },
      profileSection: {
        primaryButton: void 0,
        title: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C"
      },
      usernameSection: {
        primaryButton__setUsername: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
        primaryButton__updateUsername: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
        title: "\u0406\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
      },
      web3WalletsSection: {
        destructiveAction: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C",
        primaryButton: "Web3 \u0433\u0430\u043C\u0430\u043D\u0446\u0456",
        title: "Web3 \u0433\u0430\u043C\u0430\u043D\u0446\u0456"
      }
    },
    usernamePage: {
      successMessage: "\u0406\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0431\u0443\u043B\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
      title__set: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      title__update: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0456\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        messageLine2: "\u0412\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0437\u043C\u043E\u0436\u0435\u0442\u0435 \u0423\u0432\u0456\u0439\u0442\u0438 \u0437 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F\u043C \u0446\u044C\u043E\u0433\u043E web3 \u0433\u0430\u043C\u0430\u043D\u0446\u044F.",
        successMessage: "{{web3Wallet}} \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
        title: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 web3 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C"
      },
      subtitle__availableWallets: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C web3 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u0434\u043B\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
      subtitle__unavailableWallets: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 web3 \u0433\u0430\u043C\u0430\u043D\u0446\u0456\u0432.",
      successMessage: "\u0413\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u0431\u0443\u043B\u043E \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
      title: "\u0414\u043E\u0434\u0430\u0442\u0438 web3 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/ro-RO.ts
var roRO = {
  locale: "ro-RO",
  backButton: "\xCEnapoi",
  badge__default: "Implicit",
  badge__otherImpersonatorDevice: "Alt dispozitiv de imita\u021Bie",
  badge__primary: "Principal\u0103",
  badge__requiresAction: "Necesit\u0103 ac\u021Biune",
  badge__thisDevice: "Acest dispozitiv",
  badge__unverified: "Nedeclarat",
  badge__userDevice: "Dispozitiv de utilizator",
  badge__you: "Tu",
  createOrganization: {
    formButtonSubmit: "Crea\u021Bi o organiza\u021Bie",
    invitePage: {
      formButtonReset: "Skip"
    },
    title: "Crea\u021Bi o organiza\u021Bie"
  },
  dates: {
    lastDay: "Ieri la {{ date | timeString('en-US') }}",
    next6Days: "{{ date | weekday('en-US','long') }} la {{ date | timeString('en-US') }}",
    nextDay: "M\xE2ine la {{ date | timeString('en-US') }}",
    numeric: "{{ date | numeric('en-US') }}}",
    previous6Days: "Ultimul {{ date | weekday('en-US','long') }} la {{ date | timeString('en-US') }}",
    sameDay: "Ast\u0103zi la {{ date | timeString('en-US') }}"
  },
  dividerText: "sau",
  footerActionLink__useAnotherMethod: "Utiliza\u021Bi o alt\u0103 metod\u0103",
  footerPageLink__help: "Ajutor",
  footerPageLink__privacy: "Confiden\u021Bialitate",
  footerPageLink__terms: "Termeni",
  formButtonPrimary: "Continua\u021Bi",
  formButtonPrimary__verify: "Verify",
  formFieldAction__forgotPassword: "A\u021Bi uitat parola?",
  formFieldError__matchingPasswords: "Parolele se potrivesc.",
  formFieldError__notMatchingPasswords: "Parolele nu se potrivesc.",
  formFieldError__verificationLinkExpired: "Linkul de verificare a expirat. V\u0103 rug\u0103m s\u0103 solicita\u021Bi un nou link.",
  formFieldHintText__optional: "Op\u021Bional",
  formFieldHintText__slug: "Un slug este un ID lizibil de c\u0103tre om, care trebuie s\u0103 fie unic. Este adesea utilizat \xEEn URL-uri.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Delete account",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "Introduce\u021Bi sau lipi\u021Bi una sau mai multe adrese de e-mail, separate prin spa\u021Bii sau virgule",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Activa\u021Bi invita\u021Biile automate pentru acest domeniu",
  formFieldLabel__backupCode: "Cod de rezerv\u0103",
  formFieldLabel__confirmDeletion: "Confirmare",
  formFieldLabel__confirmPassword: "Confirma\u021Bi parola",
  formFieldLabel__currentPassword: "Parola curent\u0103",
  formFieldLabel__emailAddress: "Adresa de e-mail",
  formFieldLabel__emailAddress_username: "Adresa de e-mail sau numele de utilizator",
  formFieldLabel__emailAddresses: "Adrese de e-mail",
  formFieldLabel__firstName: "Prenume",
  formFieldLabel__lastName: "Nume",
  formFieldLabel__newPassword: "Parol\u0103 nou\u0103",
  formFieldLabel__organizationDomain: "Domeniu",
  formFieldLabel__organizationDomainDeletePending: "\u0218terge\u021Bi invita\u021Biile \u0219i sugestiile \xEEn a\u0219teptare",
  formFieldLabel__organizationDomainEmailAddress: "Adresa de e-mail de verificare",
  formFieldLabel__organizationDomainEmailAddressDescription: "Introduce\u021Bi o adres\u0103 de e-mail sub acest domeniu pentru a primi un cod \u0219i pentru a verifica acest domeniu.",
  formFieldLabel__organizationName: "Numele organiza\u021Biei",
  formFieldLabel__organizationSlug: "Slug URL",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "Parola",
  formFieldLabel__phoneNumber: "Num\u0103r de telefon",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Deconecta\u021Bi-v\u0103 de pe toate celelalte dispozitive",
  formFieldLabel__username: "Nume utilizator",
  impersonationFab: {
    action__signOut: "Deconecta\u021Bi-v\u0103",
    title: "Conectat ca {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "Admin",
  membershipRole__basicMember: "Membru",
  membershipRole__guestMember: "Invitat",
  organizationList: {
    action__createOrganization: "Crea\u021Bi o organiza\u021Bie",
    action__invitationAccept: "Al\u0103tura\u021Bi-v\u0103",
    action__suggestionsAccept: "Cerere de aderare",
    createOrganization: "Crea\u021Bi o organiza\u021Bie",
    invitationAcceptedLabel: "S-a al\u0103turat",
    subtitle: "pentru a continua la {{applicationName}}",
    suggestionsAcceptedLabel: "\xCEn curs de aprobare",
    title: "Selecta\u021Bi un cont",
    titleWithoutPersonal: "Selecta\u021Bi o organiza\u021Bie"
  },
  organizationProfile: {
    badge__automaticInvitation: "Invita\u021Bii automate",
    badge__automaticSuggestion: "Sugestii automate",
    badge__manualInvitation: "F\u0103r\u0103 \xEEnscriere automat\u0103",
    badge__unverified: "Nedeclarat",
    createDomainPage: {
      subtitle: "Ad\u0103uga\u021Bi domeniul de verificat. Utilizatorii cu adrese de e-mail la acest domeniu se pot al\u0103tura organiza\u021Biei \xEEn mod automat sau pot solicita s\u0103 se al\u0103ture.",
      title: "Ad\u0103uga\u021Bi domeniul"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Invita\u021Biile nu au putut fi trimise. Exist\u0103 deja invita\u021Bii \xEEn a\u0219teptare pentru urm\u0103toarele adrese de e-mail: {{email_addresses}}.",
      formButtonPrimary__continue: "Trimite\u021Bi invita\u021Bii",
      selectDropdown__role: "Select role",
      subtitle: "Invita\u021Bi noi membri \xEEn aceast\u0103 organiza\u021Bie",
      successMessage: "Invita\u021Bii trimise cu succes",
      title: "Invita\u021Bi membri"
    },
    membersPage: {
      action__invite: "Invita\u021Bi",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\xCEndep\u0103rta\u021Bi membrul",
        tableHeader__actions: void 0,
        tableHeader__joined: "S-a al\u0103turat",
        tableHeader__role: "Rol",
        tableHeader__user: "Utilizator"
      },
      detailsTitle__emptyRow: "Nu exist\u0103 membri de afi\u0219at",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invita\u021Bi utilizatorii prin conectarea unui domeniu de e-mail cu organiza\u021Bia dvs. Oricine se \xEEnscrie cu un domeniu de e-mail corespunz\u0103tor va putea s\u0103 se al\u0103ture organiza\u021Biei oric\xE2nd.",
          headerTitle: "Invita\u021Bii automate",
          primaryButton: "Gestiona\u021Bi domeniile verificate"
        },
        table__emptyRow: "Nu exist\u0103 invita\u021Bii de afi\u0219are"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revocarea invita\u021Biei",
        tableHeader__invited: "Invitat"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Utilizatorii care se \xEEnscriu cu un domeniu de e-mail corespunz\u0103tor vor putea vedea o sugestie de a solicita s\u0103 se al\u0103ture organiza\u021Biei dvs.",
          headerTitle: "Sugestii automate",
          primaryButton: "Gestiona\u021Bi domeniile verificate"
        },
        menuAction__approve: "Aprobarea",
        menuAction__reject: "Respinge\u021Bi",
        tableHeader__requested: "Accesul solicitat",
        table__emptyRow: "Nu exist\u0103 cereri de afi\u0219are"
      },
      start: {
        headerTitle__invitations: "Invita\u021Bii",
        headerTitle__members: "Membri",
        headerTitle__requests: "Cereri"
      }
    },
    navbar: {
      description: "Manage your organization.",
      general: "General",
      members: "Members",
      title: "Organization"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: "Introduce\u021Bi {{organizationName}} mai jos pentru a continua.",
          messageLine1: "Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 \u0219terge\u021Bi aceast\u0103 organiza\u021Bie?",
          messageLine2: "Aceast\u0103 ac\u021Biune este permanent\u0103 \u0219i ireversibil\u0103.",
          successMessage: "A\u021Bi \u0219ters organiza\u021Bia.",
          title: "\u0218terge\u021Bi organiza\u021Bia"
        },
        leaveOrganization: {
          actionDescription: "Introduce\u021Bi {{organizationName}} mai jos pentru a continua.",
          messageLine1: "E\u0219ti sigur c\u0103 vrei s\u0103 p\u0103r\u0103se\u0219ti aceast\u0103 organiza\u021Bie? Ve\u021Bi pierde accesul la aceast\u0103 organiza\u021Bie \u0219i la aplica\u021Biile sale.",
          messageLine2: "Aceast\u0103 ac\u021Biune este permanent\u0103 \u0219i ireversibil\u0103.",
          successMessage: "A\u021Bi p\u0103r\u0103sit organiza\u021Bia.",
          title: "Organizarea concediului"
        },
        title: "Pericol"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "Ad\u0103uga\u021Bi domeniul",
        subtitle: "Permite\u021Bi utilizatorilor s\u0103 se al\u0103ture automat organiza\u021Biei sau s\u0103 solicite aderarea pe baza unui domeniu de e-mail verificat.",
        title: "Domenii verificate"
      },
      successMessage: "Organiza\u021Bia a fost actualizat\u0103.",
      title: "Profilul organiza\u021Biei"
    },
    removeDomainPage: {
      messageLine1: "Domeniul de e-mail {{domain}} va fi eliminat.",
      messageLine2: "Dup\u0103 aceasta, utilizatorii nu vor mai putea s\u0103 se al\u0103ture automat organiza\u021Biei.",
      successMessage: "{{domain}} a fost eliminat.",
      title: "\xCEnl\u0103tura\u021Bi domeniul"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Membri",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Eliminarea acestui domeniu va afecta utilizatorii invita\u021Bi.",
        removeDomainActionLabel__remove: "\xCEnl\u0103tura\u021Bi domeniul",
        removeDomainSubtitle: "Elimina\u021Bi acest domeniu din domeniile verificate",
        removeDomainTitle: "\xCEnl\u0103tura\u021Bi domeniul"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Utilizatorii sunt invita\u021Bi automat s\u0103 se al\u0103ture organiza\u021Biei atunci c\xE2nd se \xEEnscriu \u0219i se pot al\u0103tura oric\xE2nd.",
        automaticInvitationOption__label: "Invita\u021Bii automate",
        automaticSuggestionOption__description: "Utilizatorii primesc o sugestie de a solicita aderarea, dar trebuie s\u0103 fie aproba\u021Bi de un administrator \xEEnainte de a se putea al\u0103tura organiza\u021Biei.",
        automaticSuggestionOption__label: "Sugestii automate",
        calloutInfoLabel: "Schimbarea modului de \xEEnscriere va afecta doar utilizatorii noi.",
        calloutInvitationCountLabel: "Invita\u021Bii \xEEn a\u0219teptare trimise utilizatorilor: {{count}}",
        calloutSuggestionCountLabel: "Sugestii \xEEn a\u0219teptare trimise utilizatorilor: {{count}}",
        manualInvitationOption__description: "Utilizatorii pot fi invita\u021Bi doar manual \xEEn organiza\u021Bie.",
        manualInvitationOption__label: "F\u0103r\u0103 \xEEnscriere automat\u0103",
        subtitle: "Alege\u021Bi modul \xEEn care utilizatorii din acest domeniu se pot al\u0103tura organiza\u021Biei."
      },
      start: {
        headerTitle__danger: "Pericol",
        headerTitle__enrollment: "Op\u021Biuni de \xEEnscriere"
      },
      subtitle: "Domeniul {{domain}} este acum verificat. Continua\u021Bi prin selectarea modului de \xEEnscriere.",
      title: "Update {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Introduce\u021Bi codul de verificare trimis la adresa dvs. de e-mail",
      formTitle: "Cod de verificare",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: "Domeniul {{domainName}} trebuie s\u0103 fie verificat prin e-mail.",
      subtitleVerificationCodeScreen: "Un cod de verificare a fost trimis la {{emailAddress}}. Introduce\u021Bi codul pentru a continua.",
      title: "Verific\u0103 domeniul"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Crea\u021Bi o organiza\u021Bie",
    action__invitationAccept: "Al\u0103tura\u021Bi-v\u0103",
    action__manageOrganization: "Gestiona\u021Bi organiza\u021Bia",
    action__suggestionsAccept: "Cerere de aderare",
    notSelected: "Nici o organiza\u021Bie selectat\u0103",
    personalWorkspace: "Cont personal",
    suggestionsAcceptedLabel: "\xCEn curs de aprobare"
  },
  paginationButton__next: "Urm\u0103torul",
  paginationButton__previous: "Anterior",
  paginationRowText__displaying: "Afi\u0219area",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "Ob\u021Bine\u021Bi ajutor",
      actionText: "Don\u2019t have any of these?",
      blockButton__backupCode: "Utiliza\u021Bi un cod de rezerv\u0103",
      blockButton__emailCode: "Codul de e-mail c\u0103tre {{identifier}}",
      blockButton__emailLink: "Trimite\u021Bi un link prin e-mail c\u0103tre {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "Conecta\u021Bi-v\u0103 cu parola dvs",
      blockButton__phoneCode: "Trimite\u021Bi codul SMS la {{identifier}}",
      blockButton__totp: "Utiliza\u021Bi aplica\u021Bia de autentificare",
      getHelp: {
        blockButton__emailSupport: "Suport prin e-mail",
        content: "Dac\u0103 \xEEnt\xE2mpina\u021Bi dificult\u0103\u021Bi la conectarea \xEEn contul dvs., trimite\u021Bi-ne un e-mail \u0219i vom lucra cu dvs. pentru a restabili accesul c\xE2t mai cur\xE2nd posibil.",
        title: "Ob\u021Bine\u021Bi ajutor"
      },
      subtitle: "Facing issues? You can use any of these methods to sign in.",
      title: "Utiliza\u021Bi o alt\u0103 metod\u0103"
    },
    backupCodeMfa: {
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Introduce\u021Bi un cod de rezerv\u0103"
    },
    emailCode: {
      formTitle: "Cod de verificare",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Verific\u0103-\u021Bi e-mailul"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "Reveni\u021Bi la tab-ul ini\u021Bial pentru a continua.",
        title: "Acest link de verificare a expirat"
      },
      failed: {
        subtitle: "Reveni\u021Bi la tab-ul ini\u021Bial pentru a continua.",
        title: "Acest link de verificare nu este valid"
      },
      formSubtitle: "Folosi\u021Bi link-ul de verificare trimis pe e-mailul dvs",
      formTitle: "Link de verificare",
      loading: {
        subtitle: "Ve\u021Bi fi redirec\u021Bionat \xEEn cur\xE2nd",
        title: "Conectarea..."
      },
      resendButton: "Nu a\u021Bi primit un link? Trimite\u021Bi din nou",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Verific\u0103-\u021Bi e-mailul",
      unusedTab: {
        title: "Pute\u021Bi \xEEnchide aceast\u0103 fil\u0103"
      },
      verified: {
        subtitle: "Ve\u021Bi fi redirec\u021Bionat \xEEn cur\xE2nd",
        title: "Conectat cu succes"
      },
      verifiedSwitchTab: {
        subtitle: "Reveni\u021Bi la tab-ul ini\u021Bial pentru a continua",
        subtitleNewTab: "Reveni\u021Bi la tab-ul nou deschis pentru a continua",
        titleNewTab: "Conectat pe alt\u0103 fil\u0103"
      }
    },
    forgotPassword: {
      formTitle: "Resetarea codului de parol\u0103",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: "to reset your password",
      subtitle_email: "First, enter the code sent to your email ID",
      subtitle_phone: "First, enter the code sent to your phone",
      title: "Reset password"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Reseta\u021Bi-v\u0103 parola",
      label__alternativeMethods: "Sau, conecta\u021Bi-v\u0103 cu o alt\u0103 metod\u0103.",
      title: "A\u021Bi uitat parola?"
    },
    noAvailableMethods: {
      message: "Nu se poate continua autentificarea. Nu exist\u0103 niciun factor de autentificare disponibil.",
      subtitle: "S-a produs o eroare",
      title: "Nu se poate autentifica"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "Utiliza\u021Bi o alt\u0103 metod\u0103",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Introduce\u021Bi parola dvs"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "Cod de verificare",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Verificarea telefonului dvs"
    },
    phoneCodeMfa: {
      formTitle: "Cod de verificare",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: void 0,
      title: "Verificarea telefonului dvs"
    },
    resetPassword: {
      formButtonPrimary: "Resetare parol\u0103",
      requiredMessage: "Exist\u0103 deja un cont cu o adres\u0103 de e-mail neverificat\u0103. V\u0103 rug\u0103m s\u0103 v\u0103 reseta\u021Bi parola pentru securitate.",
      successMessage: "Parola dvs. a fost schimbat\u0103 cu succes. V\u0103 rug\u0103m s\u0103 a\u0219tepta\u021Bi un moment.",
      title: "Resetare parol\u0103"
    },
    resetPasswordMfa: {
      detailsLabel: "Trebuie s\u0103 v\u0103 verific\u0103m identitatea \xEEnainte de a v\u0103 reseta parola."
    },
    start: {
      actionLink: "\xCEnscrie\u021Bi-v\u0103",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Utiliza\u021Bi e-mailul",
      actionLink__use_email_username: "Utiliza\u021Bi e-mail sau nume de utilizator",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "Utiliza\u021Bi telefonul",
      actionLink__use_username: "Utiliza\u021Bi numele de utilizator",
      actionText: "Nu ave\u021Bi cont?",
      actionText__join_waitlist: void 0,
      subtitle: "pentru a continua la {{applicationName}}",
      subtitleCombined: void 0,
      title: "Conecta\u021Bi-v\u0103",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Cod de verificare",
      subtitle: void 0,
      title: "Verificare \xEEn dou\u0103 etape"
    }
  },
  signInEnterPasswordTitle: "Introduce\u021Bi parola dvs",
  signUp: {
    continue: {
      actionLink: "Conecta\u021Bi-v\u0103",
      actionText: "Ave\u021Bi un cont?",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Completa\u021Bi c\xE2mpurile lips\u0103"
    },
    emailCode: {
      formSubtitle: "Introduce\u021Bi codul de verificare trimis la adresa dvs. de e-mail",
      formTitle: "Cod de verificare",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Verifica\u021Bi-v\u0103 e-mailul"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "Utiliza\u021Bi link-ul de verificare trimis la adresa dvs. de e-mail",
      formTitle: "Link de verificare",
      loading: {
        title: "Se creaz\u0103 contul..."
      },
      resendButton: "Nu a\u021Bi primit un link? Trimite\u021Bi din nou",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Verifica\u021Bi-v\u0103 e-mailul",
      verified: {
        title: "\xCEnregistrat cu succes"
      },
      verifiedSwitchTab: {
        subtitle: "Reveni\u021Bi la tab-ul nou deschis pentru a continua",
        subtitleNewTab: "Reveni\u021Bi la tab-ul anterior pentru a continua",
        title: "E-mail verificat cu succes"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Introduce\u021Bi codul de verificare trimis la num\u0103rul dvs. de telefon",
      formTitle: "Cod de verificare",
      resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
      subtitle: "pentru a continua la {{applicationName}}",
      title: "Verificarea telefonului dvs"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Conecta\u021Bi-v\u0103",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "Ave\u021Bi un cont?",
      subtitle: "pentru a continua la {{applicationName}}",
      subtitleCombined: "pentru a continua la {{applicationName}}",
      title: "Crea\u021Bi-v\u0103 un cont",
      titleCombined: "Crea\u021Bi-v\u0103 un cont"
    }
  },
  socialButtonsBlockButton: "Continua\u021Bi cu {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "\xCEnscrierea a e\u0219uat din cauza unor valid\u0103ri de securitate nereu\u0219ite. V\u0103 rug\u0103m s\u0103 re\xEEmprosp\u0103ta\u021Bi pagina pentru a \xEEncerca din nou sau contacta\u021Bi serviciul de asisten\u021B\u0103 pentru mai mult\u0103 asisten\u021B\u0103.",
    captcha_unavailable: "\xCEnscrierea a e\u0219uat din cauza unei valid\u0103ri nereu\u0219ite a robotului. V\u0103 rug\u0103m s\u0103 re\xEEmprosp\u0103ta\u021Bi pagina pentru a \xEEncerca din nou sau contacta\u021Bi serviciul de asisten\u021B\u0103 pentru mai mult\u0103 asisten\u021B\u0103.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Adresa de e-mail trebuie s\u0103 fie o adres\u0103 de e-mail valid\u0103.",
    form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
    form_param_max_length_exceeded__first_name: "Prenumele nu trebuie s\u0103 dep\u0103\u0219easc\u0103 256 de caractere.",
    form_param_max_length_exceeded__last_name: "Numele de familie nu trebuie s\u0103 dep\u0103\u0219easc\u0103 256 de caractere.",
    form_param_max_length_exceeded__name: "Numele nu trebuie s\u0103 dep\u0103\u0219easc\u0103 256 de caractere.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Parola dvs. nu este suficient de puternic\u0103.",
    form_password_pwned: "Aceast\u0103 parol\u0103 a fost descoperit\u0103 ca parte a unei \xEEnc\u0103lc\u0103ri \u0219i nu poate fi utilizat\u0103, v\u0103 rug\u0103m s\u0103 \xEEncerca\u021Bi o alt\u0103 parol\u0103.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "Parola dvs. a dep\u0103\u0219it num\u0103rul maxim de octe\u021Bi permis, v\u0103 rug\u0103m s\u0103 o scurta\u021Bi sau s\u0103 elimina\u021Bi unele caractere speciale.",
    form_password_validation_failed: "Parol\u0103 incorect\u0103",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "Nu v\u0103 pute\u021Bi \u0219terge ultima identificare.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "mai pu\u021Bin de {{length}} caractere",
      minimumLength: "{{length}} sau mai multe caractere",
      requireLowercase: "o liter\u0103 minuscul\u0103",
      requireNumbers: "un num\u0103r",
      requireSpecialCharacter: "un caracter special",
      requireUppercase: "o liter\u0103 majuscul\u0103",
      sentencePrefix: "Parola dvs. trebuie s\u0103 con\u021Bin\u0103"
    },
    phone_number_exists: "Acest num\u0103r de telefon este ocupat. V\u0103 rug\u0103m s\u0103 \xEEncerca\u021Bi altul.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Parola dvs. func\u021Bioneaz\u0103, dar ar putea fi mai puternic\u0103. \xCEncerca\u021Bi s\u0103 ad\u0103uga\u021Bi mai multe caractere.",
      goodPassword: "Parola dvs. \xEEndepline\u0219te toate cerin\u021Bele necesare.",
      notEnough: "Parola dvs. nu este suficient de puternic\u0103.",
      suggestions: {
        allUppercase: "Scrie\u021Bi cu majuscule unele litere, dar nu toate literele.",
        anotherWord: "Ad\u0103uga\u021Bi mai multe cuvinte care sunt mai pu\u021Bin frecvente.",
        associatedYears: "Evita\u021Bi anii care v\u0103 sunt asocia\u021Bi.",
        capitalization: "Scrie\u021Bi cu majuscul\u0103 mai mult dec\xE2t prima liter\u0103.",
        dates: "Evita\u021Bi datele \u0219i anii care v\u0103 sunt asociate.",
        l33t: 'Evita\u021Bi \xEEnlocuirile previzibile de litere, cum ar fi "@" pentru "a".',
        longerKeyboardPattern: "Utiliza\u021Bi modele de tastatur\u0103 mai lungi \u0219i schimba\u021Bi direc\u021Bia de tastare de mai multe ori.",
        noNeed: "Pute\u021Bi crea parole puternice f\u0103r\u0103 a folosi simboluri, numere sau litere majuscule.",
        pwned: "Dac\u0103 folosi\u021Bi aceast\u0103 parol\u0103 \xEEn alt\u0103 parte, ar trebui s\u0103 o schimba\u021Bi.",
        recentYears: "Evita\u021Bi ultimii ani.",
        repeated: "Evita\u021Bi cuvintele \u0219i caracterele repetate.",
        reverseWords: "Evita\u021Bi ortografia invers\u0103 a cuvintelor uzuale.",
        sequences: "Evita\u021Bi secven\u021Bele de caractere comune.",
        useWords: "Folosi\u021Bi mai multe cuvinte, dar evita\u021Bi frazele comune."
      },
      warnings: {
        common: "Aceasta este o parol\u0103 folosit\u0103 \xEEn mod obi\u0219nuit.",
        commonNames: "Numele comune \u0219i numele de familie sunt u\u0219or de ghicit.",
        dates: "Datele sunt u\u0219or de ghicit.",
        extendedRepeat: 'Modelele de caractere repetate, cum ar fi "abcabcabc", sunt u\u0219or de ghicit.',
        keyPattern: "Modelele scurte de tastatur\u0103 sunt u\u0219or de ghicit.",
        namesByThemselves: "Numele sau prenumele simple sunt u\u0219or de ghicit.",
        pwned: "Parola dvs. a fost expus\u0103 \xEEn urma unei \xEEnc\u0103lc\u0103ri a securit\u0103\u021Bii datelor pe internet.",
        recentYears: "Ultimii ani sunt u\u0219or de ghicit.",
        sequences: 'Secven\u021Bele de caractere comune, cum ar fi "abc", sunt u\u0219or de ghicit.',
        similarToCommon: "Acest lucru este similar cu o parol\u0103 folosit\u0103 \xEEn mod obi\u0219nuit.",
        simpleRepeat: 'Caracterele repetate, cum ar fi "aaa", sunt u\u0219or de ghicit.',
        straightRow: "R\xE2ndurile drepte de taste de pe tastatur\u0103 sunt u\u0219or de ghicit.",
        topHundred: "Aceasta este o parol\u0103 utilizat\u0103 frecvent.",
        topTen: "Aceasta este o parol\u0103 foarte utilizat\u0103.",
        userInputs: "Nu trebuie s\u0103 existe date personale sau legate de pagini.",
        wordByItself: "Cuvintele simple sunt u\u0219or de ghicit."
      }
    }
  },
  userButton: {
    action__addAccount: "Ad\u0103uga\u021Bi un cont",
    action__manageAccount: "Gestiona\u021Bi contul",
    action__signOut: "Deconecta\u021Bi-v\u0103",
    action__signOutAll: "Deconecta\u021Bi-v\u0103 din toate conturile"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copiat!",
      actionLabel__copy: "Copia\u021Bi toate",
      actionLabel__download: "Descarc\u0103 .txt",
      actionLabel__print: "Imprimare",
      infoText1: "Codurile de rezerv\u0103 vor fi activate pentru acest cont.",
      infoText2: "P\u0103stra\u021Bi codurile de rezerv\u0103 \xEEn secret \u0219i p\u0103stra\u021Bi-le \xEEn siguran\u021B\u0103. Pute\u021Bi regenera codurile de rezerv\u0103 dac\u0103 b\u0103nui\u021Bi c\u0103 acestea au fost compromise.",
      subtitle__codelist: "P\u0103stra\u021Bi-le \xEEn siguran\u021B\u0103 \u0219i p\u0103stra\u021Bi-le \xEEn secret.",
      successMessage: "Codurile de rezerv\u0103 sunt acum activate. Pute\u021Bi utiliza unul dintre acestea pentru a v\u0103 conecta la contul dvs., dac\u0103 pierde\u021Bi accesul la dispozitivul de autentificare. Fiecare cod poate fi utilizat o singur\u0103 dat\u0103.",
      successSubtitle: "Pute\u021Bi utiliza unul dintre acestea pentru a v\u0103 conecta la contul dvs., dac\u0103 pierde\u021Bi accesul la dispozitivul de autentificare.",
      title: "Ad\u0103uga\u021Bi verificarea codului de rezerv\u0103",
      title__codelist: "Coduri de rezerv\u0103"
    },
    connectedAccountPage: {
      formHint: "Selecta\u021Bi un furnizor pentru a v\u0103 conecta contul.",
      formHint__noAccounts: "Nu exist\u0103 furnizori de conturi externe disponibili.",
      removeResource: {
        messageLine1: "{{identifier}} va fi eliminat din acest cont.",
        messageLine2: "Nu ve\u021Bi mai putea utiliza acest cont conectat, iar toate func\u021Biile dependente nu vor mai func\u021Biona.",
        successMessage: "{{connectedAccount}} a fost eliminat din contul dumneavoastr\u0103.",
        title: "\xCEnl\u0103tura\u021Bi contul conectat"
      },
      socialButtonsBlockButton: "Conecteaz\u0103 contul {{provider|titleize}}",
      successMessage: "Furnizorul a fost ad\u0103ugat \xEEn contul dvs",
      title: "Ad\u0103uga\u021Bi un cont conectat"
    },
    deletePage: {
      actionDescription: "Introduce\u021Bi Delete account (\u0218terge\u021Bi contul) mai jos pentru a continua.",
      confirm: "\u0218terge\u021Bi contul",
      messageLine1: "Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 v\u0103 \u0219terge\u021Bi contul?",
      messageLine2: "Aceast\u0103 ac\u021Biune este permanent\u0103 \u0219i ireversibil\u0103.",
      title: "\u0218terge\u021Bi contul"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Un e-mail con\u021Bin\xE2nd un cod de verificare va fi trimis la aceast\u0103 adres\u0103 de e-mail.",
        formSubtitle: "Introduce\u021Bi codul de verificare trimis la {{identifier}}",
        formTitle: "Cod de verificare",
        resendButton: "Nu a\u021Bi primit un cod? Trimite\u021Bi din nou",
        successMessage: "E-mailul {{identifier}} a fost ad\u0103ugat \xEEn contul dvs."
      },
      emailLink: {
        formHint: "La aceast\u0103 adres\u0103 de e-mail va fi trimis un e-mail con\u021Bin\xE2nd un link de verificare.",
        formSubtitle: "Face\u021Bi clic pe link-ul de verificare din e-mailul trimis c\u0103tre {{identifier}}",
        formTitle: "Link de verificare",
        resendButton: "Nu a\u021Bi primit un link? Trimite\u021Bi din nou",
        successMessage: "E-mailul {{identifier}} a fost ad\u0103ugat \xEEn contul dvs."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} va fi eliminat din acest cont.",
        messageLine2: "Nu ve\u021Bi mai putea s\u0103 v\u0103 conecta\u021Bi folosind aceast\u0103 adres\u0103 de e-mail.",
        successMessage: "{{emailAddress}} a fost eliminat din contul dvs.",
        title: "Elimina\u021Bi adresa de e-mail"
      },
      title: "Ad\u0103uga\u021Bi adresa de e-mail",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "Continua\u021Bi",
    formButtonPrimary__finish: "Finalizare",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "Anuleaz\u0103",
    mfaPage: {
      formHint: "Selecta\u021Bi o metod\u0103 de ad\u0103ugat.",
      title: "Ad\u0103uga\u021Bi verificarea \xEEn doi pa\u0219i"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "Ad\u0103uga\u021Bi un num\u0103r de telefon",
      removeResource: {
        messageLine1: "{{identifier}} nu va mai primi coduri de verificare atunci c\xE2nd se conecteaz\u0103.",
        messageLine2: "Este posibil ca contul dumneavoastr\u0103 s\u0103 nu fie la fel de sigur. Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 continua\u021Bi?",
        successMessage: "Verificarea \xEEn doi pa\u0219i a codului SMS a fost eliminat\u0103 pentru {{mfaPhoneCode}}",
        title: "Eliminarea verific\u0103rii \xEEn dou\u0103 etape"
      },
      subtitle__availablePhoneNumbers: "Selecta\u021Bi un num\u0103r de telefon pentru a v\u0103 \xEEnregistra pentru verificarea \xEEn doi pa\u0219i a codului SMS.",
      subtitle__unavailablePhoneNumbers: "Nu exist\u0103 numere de telefon disponibile pentru a v\u0103 \xEEnregistra pentru verificarea \xEEn doi pa\u0219i prin cod SMS.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "Ad\u0103uga\u021Bi verificarea codului SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scana\u021Bi \xEEn schimb codul QR",
        buttonUnableToScan__nonPrimary: "Nu pute\u021Bi scana codul QR?",
        infoText__ableToScan: "Configura\u021Bi o nou\u0103 metod\u0103 de conectare \xEEn aplica\u021Bia de autentificare \u0219i scana\u021Bi urm\u0103torul cod QR pentru a o lega de contul dvs.",
        infoText__unableToScan: "Configura\u021Bi o nou\u0103 metod\u0103 de conectare \xEEn autentificatorul dvs. \u0219i introduce\u021Bi cheia furnizat\u0103 mai jos.",
        inputLabel__unableToScan1: "Asigura\u021Bi-v\u0103 c\u0103 este activat\u0103 op\u021Biunea Parole pe baz\u0103 de timp sau Parole unice, apoi finaliza\u021Bi conectarea contului dvs.",
        inputLabel__unableToScan2: "Alternativ, dac\u0103 autentificatorul dvs. accept\u0103 URI-urile TOTP, pute\u021Bi copia \u0219i URI-ul complet."
      },
      removeResource: {
        messageLine1: "Codurile de verificare de la acest autentificator nu vor mai fi necesare la autentificare.",
        messageLine2: "Este posibil ca contul dumneavoastr\u0103 s\u0103 nu fie la fel de sigur. Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 continua\u021Bi?",
        successMessage: "Verificarea \xEEn doi pa\u0219i prin intermediul aplica\u021Biei Authenticator a fost eliminat\u0103.",
        title: "Eliminarea verific\u0103rii \xEEn dou\u0103 etape"
      },
      successMessage: "Verificarea \xEEn doi pa\u0219i este acum activat\u0103. C\xE2nd v\u0103 conecta\u021Bi, va trebui s\u0103 introduce\u021Bi un cod de verificare de la acest autentificator ca pas suplimentar.",
      title: "Ad\u0103uga\u021Bi aplica\u021Bia de autentificare",
      verifySubtitle: "Introduce\u021Bi codul de verificare generat de autentificatorul dvs",
      verifyTitle: "Cod de verificare"
    },
    mobileButton__menu: "Meniu",
    navbar: {
      account: "Profile",
      description: "Manage your account info.",
      security: "Security",
      title: "Account"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "\xCEn prezent, parola dvs. nu poate fi modificat\u0103, deoarece v\u0103 pute\u021Bi conecta numai prin intermediul conexiunii \xEEntreprinderii.",
      successMessage__set: "Parola dvs. a fost setat\u0103.",
      successMessage__signOutOfOtherSessions: "Toate celelalte dispozitive au fost deconectate.",
      successMessage__update: "Parola dvs. a fost actualizat\u0103.",
      title__set: "Seta\u021Bi parola",
      title__update: "Modifica\u021Bi parola"
    },
    phoneNumberPage: {
      infoText: "La acest num\u0103r de telefon va fi trimis un mesaj text con\u021Bin\xE2nd un link de verificare.",
      removeResource: {
        messageLine1: "{{identifier}} va fi eliminat din acest cont.",
        messageLine2: "Nu ve\u021Bi mai putea s\u0103 v\u0103 conecta\u021Bi folosind acest num\u0103r de telefon.",
        successMessage: "{{phoneNumber}} a fost eliminat din contul dvs.",
        title: "Elimina\u021Bi num\u0103rul de telefon"
      },
      successMessage: "{{identifier}} a fost ad\u0103ugat \xEEn contul dumneavoastr\u0103.",
      title: "Ad\u0103uga\u021Bi num\u0103rul de telefon",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "\xCEnc\u0103rca\u021Bi o imagine JPG, PNG, GIF sau WEBP mai mic\u0103 de 10 MB",
      imageFormDestructiveActionSubtitle: "Elimina\u021Bi imaginea",
      imageFormSubtitle: "\xCEnc\u0103rca\u021Bi imaginea",
      imageFormTitle: "Imagine de profil",
      readonly: "Informa\u021Biile din profilul dvs. au fost furnizate de c\u0103tre conexiunea cu compania \u0219i nu pot fi modificate.",
      successMessage: "Profilul dvs. a fost actualizat.",
      title: "Actualizarea profilului"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Deconecta\u021Bi-v\u0103 de la dispozitiv",
        title: "Dispozitive active"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\xCEncearc\u0103 din nou",
        actionLabel__reauthorize: "Autoriza\u021Bi acum",
        destructiveActionTitle: "Elimina\u021Bi",
        primaryButton: "Conecta\u021Bi-v\u0103 contul",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "Conturi conectate"
      },
      dangerSection: {
        deleteAccountButton: "\u0218terge\u021Bi contul",
        title: "Pericol"
      },
      emailAddressesSection: {
        destructiveAction: "Elimina\u021Bi adresa de e-mail",
        detailsAction__nonPrimary: "Seta\u021Bi ca principal\u0103",
        detailsAction__primary: "Verificare complet\u0103",
        detailsAction__unverified: "Verific\u0103 adresa de e-mail",
        primaryButton: "Ad\u0103uga\u021Bi o adres\u0103 de e-mail",
        title: "Adrese de e-mail"
      },
      enterpriseAccountsSection: {
        title: "Conturi de companie"
      },
      headerTitle__account: "Cont",
      headerTitle__security: "Securitate",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenerarea codurilor",
          headerTitle: "Coduri de rezerv\u0103",
          subtitle__regenerate: "Ob\u021Bine\u021Bi un set nou de coduri de rezerv\u0103 securizate. Codurile de rezerv\u0103 anterioare vor fi \u0219terse \u0219i nu vor mai putea fi utilizate.",
          title__regenerate: "Regenerarea codurilor de rezerv\u0103"
        },
        phoneCode: {
          actionLabel__setDefault: "Setat ca implicit",
          destructiveActionLabel: "Elimina\u021Bi num\u0103rul de telefon"
        },
        primaryButton: "Ad\u0103uga\u021Bi verificarea \xEEn doi pa\u0219i",
        title: "Verificare \xEEn dou\u0103 etape",
        totp: {
          destructiveActionTitle: "Elimina\u021Bi",
          headerTitle: "Aplica\u021Bia Authenticator"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "Seta\u021Bi parola",
        primaryButton__updatePassword: "Modifica\u021Bi parola",
        title: "Parola"
      },
      phoneNumbersSection: {
        destructiveAction: "Elimina\u021Bi num\u0103rul de telefon",
        detailsAction__nonPrimary: "Seta\u021Bi ca principal",
        detailsAction__primary: "Verificare complet\u0103",
        detailsAction__unverified: "Verifica\u021Bi num\u0103rul de telefon",
        primaryButton: "Ad\u0103uga\u021Bi un num\u0103r de telefon",
        title: "Numere de telefon"
      },
      profileSection: {
        primaryButton: void 0,
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Seta\u021Bi numele de utilizator",
        primaryButton__updateUsername: "Schimb\u0103 numele de utilizator",
        title: "Nume utilizator"
      },
      web3WalletsSection: {
        destructiveAction: "Scoate\u021Bi portofelul",
        primaryButton: "Portofele Web3",
        title: "Portofele Web3"
      }
    },
    usernamePage: {
      successMessage: "Numele dvs. de utilizator a fost actualizat.",
      title__set: "Actualiza\u021Bi numele de utilizator",
      title__update: "Actualiza\u021Bi numele de utilizator"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} va fi eliminat din acest cont.",
        messageLine2: "Nu ve\u021Bi mai putea s\u0103 v\u0103 conecta\u021Bi folosind acest portofel web3.",
        successMessage: "{{web3Wallet}} a fost eliminat din contul dumneavoastr\u0103.",
        title: "\xCEndep\u0103rta\u021Bi portofelul web3"
      },
      subtitle__availableWallets: "Selecta\u021Bi un portofel web3 pentru a v\u0103 conecta la cont.",
      subtitle__unavailableWallets: "Nu exist\u0103 portofele web3 disponibile.",
      successMessage: "Portofelul a fost ad\u0103ugat \xEEn contul dumneavoastr\u0103.",
      title: "Ad\u0103uga\u021Bi portofelul web3",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/es-MX.ts
var esMX = {
  locale: "es-MX",
  backButton: "Atr\xE1s",
  badge__default: "Por defecto",
  badge__otherImpersonatorDevice: "Otro dispositivo de imitaci\xF3n",
  badge__primary: "Primario",
  badge__requiresAction: "Requiere acci\xF3n",
  badge__thisDevice: "Este dispositivo",
  badge__unverified: "No confirmado",
  badge__userDevice: "Dispositivo de usuario",
  badge__you: "Usted",
  createOrganization: {
    formButtonSubmit: "Crear organizaci\xF3n",
    invitePage: {
      formButtonReset: "Saltar"
    },
    title: "Crear organizaci\xF3n"
  },
  dates: {
    lastDay: "Ayer a las {{ date | timeString('es-ES') }}",
    next6Days: "{{ date | weekday('es-ES','long') }} a las {{ date | timeString('es-ES') }}",
    nextDay: "Ma\xF1ana a las {{ date | timeString('es-ES') }}",
    numeric: "{{ date | numeric('es-ES') }}",
    previous6Days: "\xDAltimo {{ date | weekday('es-ES','long') }} en {{ date | timeString('es-ES') }}",
    sameDay: "Hoy a las {{ date | timeString('es-ES') }}"
  },
  dividerText: "o",
  footerActionLink__useAnotherMethod: "Usar otro m\xE9todo",
  footerPageLink__help: "Ayuda",
  footerPageLink__privacy: "Privacidad",
  footerPageLink__terms: "T\xE9rminos",
  formButtonPrimary: "Continuar",
  formButtonPrimary__verify: "Verificar",
  formFieldAction__forgotPassword: "Has olvidado tu contrase\xF1a?",
  formFieldError__matchingPasswords: "Las contrase\xF1as coinciden.",
  formFieldError__notMatchingPasswords: "Las no contrase\xF1as coinciden.",
  formFieldError__verificationLinkExpired: "El link de verificaci\xF3n expiro. Porfavor vuelva a solicitarlo.",
  formFieldHintText__optional: "Opcional",
  formFieldHintText__slug: "Un slug es una identificaci\xF3n legible por humanos que debe ser \xFAnica. Se utiliza a menudo en URL.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Eliminar cuenta",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "Ingrese o pegue una o m\xE1s direcciones de correo electr\xF3nico, separadas por espacios o comas",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: void 0,
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Activar invitaciones automaticas para este dominio",
  formFieldLabel__backupCode: "C\xF3digo de respaldo",
  formFieldLabel__confirmDeletion: "Confirmarci\xF3n",
  formFieldLabel__confirmPassword: "Confirme la contrase\xF1a",
  formFieldLabel__currentPassword: "Contrase\xF1a actual",
  formFieldLabel__emailAddress: "Correo electr\xF3nico",
  formFieldLabel__emailAddress_username: "Correo electr\xF3nico o nombre de usuario",
  formFieldLabel__emailAddresses: "Direcciones de correo",
  formFieldLabel__firstName: "Nombre",
  formFieldLabel__lastName: "Apellido",
  formFieldLabel__newPassword: "Nueva contrase\xF1a",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Eliminar invitaciones y sugerencias pendientes",
  formFieldLabel__organizationDomainEmailAddress: "Verificaci\xF3n de correo",
  formFieldLabel__organizationDomainEmailAddressDescription: "Entrar una direcci\xF3n de correo electr\xF3nico bajo este dominio para recibir un c\xF3digo y verificarlo.",
  formFieldLabel__organizationName: "Nombre de la Organizaci\xF3n",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Nombre de llave de acceso",
  formFieldLabel__password: "Contrase\xF1a",
  formFieldLabel__phoneNumber: "N\xFAmero telef\xF3nico",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Cerrar sesi\xF3n en todos los dem\xE1s dispositivos",
  formFieldLabel__username: "Nombre de usuario",
  impersonationFab: {
    action__signOut: "Cerrar",
    title: "Registrado como {{identifier}}"
  },
  maintenanceMode: "Actualmente estamos en mantenimiento, pero no te preocupes, no deber\xEDa llevar m\xE1s de unos minutos.",
  membershipRole__admin: "Administrador",
  membershipRole__basicMember: "Miembro",
  membershipRole__guestMember: "Invitado",
  organizationList: {
    action__createOrganization: "Crear organizaci\xF3n",
    action__invitationAccept: "Unirse",
    action__suggestionsAccept: "Pedir unirse",
    createOrganization: "Crear Organizaci\xF3n",
    invitationAcceptedLabel: "Unido",
    subtitle: "Para continuar con {{applicationName}}",
    suggestionsAcceptedLabel: "Aprobaci\xF3n pendiente",
    title: "Elige una cuenta",
    titleWithoutPersonal: "Elige una organizaci\xF3n"
  },
  organizationProfile: {
    badge__automaticInvitation: "Invitaciones automaticas",
    badge__automaticSuggestion: "Sugerencias automaticas",
    badge__manualInvitation: "Sin inscripci\xF3nes automaticas",
    badge__unverified: "No verificado",
    createDomainPage: {
      subtitle: "A\xF1ada el email para verificar. Los usuarios con direcciones de correo electr\xF3nico en este dominio pueden unirse a la organizaci\xF3n aqu\xED o pedir unirse.",
      title: "Anadir dominio"
    },
    invitePage: {
      detailsTitle__inviteFailed: "No se pudieron enviar las invitaciones. Solucione lo siguiente y vuelva a intentarlo:",
      formButtonPrimary__continue: "Enviar invitaciones",
      selectDropdown__role: "Select role",
      subtitle: "Invitar nuevos miembros a esta organizaci\xF3n",
      successMessage: "Invitaciones enviadas con \xE9xito",
      title: "Invitar miembros"
    },
    membersPage: {
      action__invite: "Invitar",
      action__search: "Buscar",
      activeMembersTab: {
        menuAction__remove: "Eliminar miembro",
        tableHeader__actions: void 0,
        tableHeader__joined: "Se uni\xF3",
        tableHeader__role: "Rol",
        tableHeader__user: "Usuario"
      },
      detailsTitle__emptyRow: "No hay miembros para mostrar",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Invita usuarios conectando un dominio de correo electr\xF3nico con su organizaci\xF3n. Cualquiera que se registre con un dominio de correo electr\xF3nico coincidente podr\xE1 unirse a la organizaci\xF3n en cualquier momento.",
          headerTitle: "Invitaciones automaticas",
          primaryButton: "Gestionar dominios verificados"
        },
        table__emptyRow: "No hay invitaciones para mostrar"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revocar invitaci\xF3n",
        tableHeader__invited: "Invitado"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Los usuarios que inicien sesi\xF3n con un dominio de correo electr\xF3nico coincidente podr\xE1n ver una sugerencia para solicitar unirse a su organizaci\xF3n.",
          headerTitle: "Sugerencias automaticas",
          primaryButton: "Gestionar dominios verificados"
        },
        menuAction__approve: "Aprobado",
        menuAction__reject: "Rechazado",
        tableHeader__requested: "Acceso solicitado",
        table__emptyRow: "No hay solicitudes para mostrar"
      },
      start: {
        headerTitle__invitations: "Invitaciones",
        headerTitle__members: "Miembros",
        headerTitle__requests: "Solicitudes"
      }
    },
    navbar: {
      description: "Gestiona tu organizaci\xF3n.",
      general: "General",
      members: "Miembros",
      title: "Organizaci\xF3n"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Escribe "{{organizationName}}" a continuaci\xF3n para continuar.',
          messageLine1: "\xBFEstas seguro que quieres eliminar esta organizaci\xF3n?",
          messageLine2: "Esta acci\xF3n es permanente e irreversible.",
          successMessage: "Haz eliminado la organizaci\xF3n.",
          title: "Eliminar la organizaci\xF3n"
        },
        leaveOrganization: {
          actionDescription: 'Escribe "{{organizationName}}" a continuaci\xF3n para continuar.',
          messageLine1: "\xBFEst\xE1 seguro de que desea abandonar esta organizaci\xF3n? Perder\xE1 el acceso a esta organizaci\xF3n y sus aplicaciones.",
          messageLine2: "Esta acci\xF3n es permanente e irreversible.",
          successMessage: "Has dejado la organizaci\xF3n.",
          title: "Abandonar la organizaci\xF3n"
        },
        title: "Peligro"
      },
      domainSection: {
        menuAction__manage: "Gestionar",
        menuAction__remove: "Eliminar",
        menuAction__verify: "Verificar",
        primaryButton: "A\xF1adir dominio",
        subtitle: "Permite a los usuarios conectarse automaticamente o solicitar unirse a la organizaci\xF3n basado en un dominio de correo electr\xF3nico verificado.",
        title: "Verified domains"
      },
      successMessage: "La organizaci\xF3n ha sido actualizada.",
      title: "Perfil de la organizaci\xF3n"
    },
    removeDomainPage: {
      messageLine1: "Se eliminar\xE1 el dominio de correo electr\xF3nico {{domain}}.",
      messageLine2: "Los usuarios no podr\xE1n unirse a la organizaci\xF3n de manera autom\xE1tica una vez que se haya eliminado.",
      successMessage: "{{domain}} se ha eliminado.",
      title: "Eliminar dominio"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Miembros",
      profileSection: {
        primaryButton: "Actualizar perfil",
        title: "Perfil de la organizaci\xF3n",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Eliminar este dominio afectar\xE1 a los usuarios invitados.",
        removeDomainActionLabel__remove: "Eliminar dominio",
        removeDomainSubtitle: "Eliminar este dominio de los dominios verificados",
        removeDomainTitle: "Eliminar dominio"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Los usuarios se unen autom\xE1ticamente a la organizaci\xF3n cuando se registran y pueden unirse en cualquier momento.",
        automaticInvitationOption__label: "Invitaciones autom\xE1ticas",
        automaticSuggestionOption__description: "Los usuarios reciben una sugerencia para solicitar unirse, pero deben ser aprobados por un administrador antes de poder unirse a la organizaci\xF3n.",
        automaticSuggestionOption__label: "Sugerencias autom\xE1ticas",
        calloutInfoLabel: "Cambiar el modo de inscripci\xF3n solo afectar\xE1 a los nuevos usuarios.",
        calloutInvitationCountLabel: "Invitaciones pendientes enviadas a usuarios: {{count}}",
        calloutSuggestionCountLabel: "Sugerencias pendientes enviadas a usuarios: {{count}}",
        manualInvitationOption__description: "Los usuarios solo pueden ser invitados manualmente a la organizaci\xF3n.",
        manualInvitationOption__label: "Sin inscripci\xF3n autom\xE1tica",
        subtitle: "Seleccione c\xF3mo los usuarios de este dominio pueden unirse a la organizaci\xF3n."
      },
      start: {
        headerTitle__danger: "Peligro",
        headerTitle__enrollment: "Opciones de inscripci\xF3n"
      },
      subtitle: "El dominio {{domain}} ahora est\xE1 verificado. Contin\xFAa seleccionando el modo de inscripci\xF3n.",
      title: "Actualizar {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Introduce el c\xF3digo de verificaci\xF3n enviado a su direcci\xF3n de correo electr\xF3nico",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "No recibiste un c\xF3digo? Reenviar",
      subtitle: "El dominio {{domainName}} necesita ser verificado v\xEDa correo electr\xF3nico.",
      subtitleVerificationCodeScreen: "Se envi\xF3 un c\xF3digo de verificaci\xF3n a {{emailAddress}}. Introduzca el c\xF3digo para continuar.",
      title: "Verificar dominio"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Crear Organizaci\xF3n",
    action__invitationAccept: "Unirse",
    action__manageOrganization: "Administrar Organizaci\xF3n",
    action__suggestionsAccept: "Solicitar unirse",
    notSelected: "Ninguna organizaci\xF3n seleccionada",
    personalWorkspace: "Espacio personal",
    suggestionsAcceptedLabel: "Pendiente de aprobaci\xF3n"
  },
  paginationButton__next: "Siguiente",
  paginationButton__previous: "Anterior",
  paginationRowText__displaying: "Mostrando",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Agregar cuenta",
      action__signOutAll: "Cerrar sesi\xF3n de todas las cuentas",
      subtitle: "Seleccione la cuenta con la que desea continuar.",
      title: "Elija una cuenta"
    },
    alternativeMethods: {
      actionLink: "Obtener ayuda",
      actionText: "\xBFNo tienes ninguno de estos?",
      blockButton__backupCode: "Usa un c\xF3digo de respaldo",
      blockButton__emailCode: "Enviar c\xF3digo a{{identifier}}",
      blockButton__emailLink: "Enviar enlace a{{identifier}}",
      blockButton__passkey: "Inicia sesi\xF3n con tu llave de acceso",
      blockButton__password: "Inicia sesi\xF3n con tu contrase\xF1a",
      blockButton__phoneCode: "Enviar c\xF3digo a{{identifier}}",
      blockButton__totp: "Usa tu aplicaci\xF3n de autenticaci\xF3n",
      getHelp: {
        blockButton__emailSupport: "Soporte de correo electr\xF3nico",
        content: "Si tiene problemas para ingresar a su cuenta, env\xEDenos un correo electr\xF3nico y trabajaremos con usted para restablecer el acceso lo antes posible.",
        title: "Obtener ayuda"
      },
      subtitle: "Si est\xE1 experimentando problemas, puede utilizar uno de estos m\xE9todos para ingresar.",
      title: "Utiliza otro m\xE9todo"
    },
    backupCodeMfa: {
      subtitle: "para continuar a {{applicationName}}",
      title: "Introduce un c\xF3digo de seguridad"
    },
    emailCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Re-enviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revise su correo electr\xF3nico"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "Regresa a la pesta\xF1a original para continuar.",
        title: "Este enlace de verificaci\xF3n ha expirado"
      },
      failed: {
        subtitle: "Regresa a la pesta\xF1a original para continuar.",
        title: "Este enlace de verificaci\xF3n es invalido"
      },
      formSubtitle: "Utilice el enlace de verificaci\xF3n enviado a su correo electr\xF3nico",
      formTitle: "Enlace de verificaci\xF3n",
      loading: {
        subtitle: "Ser\xE1s redirigido pronto",
        title: "Iniciando sesi\xF3n..."
      },
      resendButton: "Reenviar enlace",
      subtitle: "para continuar a {{applicationName}}",
      title: "Revise su correo electr\xF3nico",
      unusedTab: {
        title: "Puede cerrar esta pesta\xF1a"
      },
      verified: {
        subtitle: "Ser\xE1s redirigido pronto",
        title: "Inici\xF3 sesi\xF3n con \xE9xito"
      },
      verifiedSwitchTab: {
        subtitle: "Regrese a la pesta\xF1a original para continuar",
        subtitleNewTab: "Regrese a la pesta\xF1a reci\xE9n abierta para continuar",
        titleNewTab: "Inici\xF3 sesi\xF3n en otra pesta\xF1a"
      }
    },
    forgotPassword: {
      formTitle: "C\xF3digo para restablecer la contrase\xF1a",
      resendButton: "No recibiste un c\xF3digo? Reenviar",
      subtitle: "para restablecer tu contrase\xF1a",
      subtitle_email: "Primero, introduce el c\xF3digo enviado a tu {{email}}",
      subtitle_phone: "Primero, introduce el c\xF3digo enviado a tu {{phone}}",
      title: "Restablecer contrase\xF1a"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Restablecer tu contrase\xF1a",
      label__alternativeMethods: "O, inicia sesi\xF3n con otro m\xE9todo",
      title: "\xBFOlvidaste tu contrase\xF1a?"
    },
    noAvailableMethods: {
      message: "No se puede continuar con el inicio de sesi\xF3n. No hay ning\xFAn factor de autenticaci\xF3n disponible.",
      subtitle: "Ocurri\xF3 un error",
      title: "No puedo iniciar sesi\xF3n"
    },
    passkey: {
      subtitle: "Usando tu llave de acceso confirmas que eres t\xFA. Tu dispositivo puede pedirte la huella dactilar, el rostro o el bloqueo de pantalla.",
      title: "Usa tu llave de acceso"
    },
    password: {
      actionLink: "Use otro m\xE9todo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Introduzca su contrase\xF1a"
    },
    passwordPwned: {
      title: "Contrase\xF1a en peligro"
    },
    phoneCode: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar con {{applicationName}}",
      title: "Revisa tu tel\xE9fono"
    },
    phoneCodeMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar con {{applicationName}}",
      title: "Revisa tu tel\xE9fono"
    },
    resetPassword: {
      formButtonPrimary: "Restablecer contrase\xF1a",
      requiredMessage: "Por razones de seguridad, es necesario restablecer su contrase\xF1a.",
      successMessage: "Tu contrase\xF1a se ha cambiado correctamente. Te estamos redirigiendo, por favor espera un momento.",
      title: "Establecer nueva contrase\xF1a"
    },
    resetPasswordMfa: {
      detailsLabel: "Es necesario verificar su identidad para restablecer su contrase\xF1a."
    },
    start: {
      actionLink: "Registrarse",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Utilizar correo electr\xF3nico",
      actionLink__use_email_username: "Utilizar correo electr\xF3nico o nombre de usuario",
      actionLink__use_passkey: "Usar llave de acceso",
      actionLink__use_phone: "Utilizar tel\xE9fono",
      actionLink__use_username: "Utilizar nombre de usuario",
      actionText: "\xBFNo tiene cuenta?",
      actionText__join_waitlist: void 0,
      subtitle: "para continuar con {{applicationName}}",
      subtitleCombined: void 0,
      title: "Iniciar sesi\xF3n",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "C\xF3digo de verificaci\xF3n",
      subtitle: "Para continuar, por favor introduce el c\xF3digo generado por tu aplicaci\xF3n de autenticaci\xF3n",
      title: "Verificaci\xF3n de dos factores"
    }
  },
  signInEnterPasswordTitle: "Ingresa tu contrase\xF1a",
  signUp: {
    continue: {
      actionLink: "Entrar",
      actionText: "\xBFTiene una cuenta?",
      subtitle: "para continuar a {{applicationName}}",
      title: "Rellene los campos que faltan"
    },
    emailCode: {
      formSubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a su correo electr\xF3nico",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verifique su correo electr\xF3nico"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "Utilice el enlace de verificaci\xF3n enviado a su direcci\xF3n de correo electr\xF3nico",
      formTitle: "Enlace de verificaci\xF3n",
      loading: {
        title: "Registrando..."
      },
      resendButton: "Reenviar enlace",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verifica tu correo electr\xF3nico",
      verified: {
        title: "Registrado con \xE9xito"
      },
      verifiedSwitchTab: {
        subtitle: "Regrese a la pesta\xF1a reci\xE9n abierta para continuar",
        subtitleNewTab: "Volver a la pesta\xF1a anterior para continuar",
        title: "Correo electr\xF3nico verificado con \xE9xito"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a su n\xFAmero de tel\xE9fono.",
      formTitle: "C\xF3digo de verificaci\xF3n",
      resendButton: "Reenviar c\xF3digo",
      subtitle: "para continuar a {{applicationName}}",
      title: "Verifique su tel\xE9fono"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Acceder",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "\xBFTienes una cuenta?",
      subtitle: "para continuar con {{applicationName}}",
      subtitleCombined: "para continuar con {{applicationName}}",
      title: "Crea tu cuenta",
      titleCombined: "Crea tu cuenta"
    }
  },
  socialButtonsBlockButton: "Continuar con {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "El registro fall\xF3 debido a fallos en la validaci\xF3n de seguridad. Por favor, recargue la p\xE1gina o cont\xE1ctenos para obtener m\xE1s asistencia.",
    captcha_unavailable: "El registro fall\xF3 debido a fallos en la validaci\xF3n de bot. Por favor, recargue la p\xE1gina o cont\xE1ctenos para obtener m\xE1s asistencia.",
    form_code_incorrect: "C\xF3digo incorrecto.",
    form_identifier_exists__email_address: "La direcci\xF3n de correo ya existe.",
    form_identifier_exists__phone_number: "El n\xFAmero de tel\xE9fono ya existe.",
    form_identifier_exists__username: "El nombre de usuario ya existe.",
    form_identifier_not_found: "No se encontr\xF3, puede estar mal escrito.",
    form_param_format_invalid: "Formato inv\xE1lido.",
    form_param_format_invalid__email_address: "La direcci\xF3n de correo debe ser v\xE1lida.",
    form_param_format_invalid__phone_number: "El n\xFAmero de tel\xE9fono debe ser en un formato v\xE1lido internacional.",
    form_param_max_length_exceeded__first_name: "El nombre debe tener menos de 256 caracteres.",
    form_param_max_length_exceeded__last_name: "El apellido debe tener menos de 256 caracteres.",
    form_param_max_length_exceeded__name: "El nombre debe tener menos de 256 caracteres.",
    form_param_nil: "Campo vac\xEDo.",
    form_param_value_invalid: void 0,
    form_password_incorrect: "Contrase\xF1a incorrecta.",
    form_password_length_too_short: "La contrase\xF1a es muy corta.",
    form_password_not_strong_enough: "La contrase\xF1a no es suficientemente segura.",
    form_password_pwned: "Esta contrase\xF1a se encontr\xF3 como parte de una infracci\xF3n y no se puede usar; pruebe con otra contrase\xF1a.",
    form_password_pwned__sign_in: "La contrase\xF1a es muy insegura.",
    form_password_size_in_bytes_exceeded: "La contrase\xF1a excede el n\xFAmero m\xE1ximo de bytes permitidos. Por favor, elimine algunos caracteres especiales o reduzca la longitud de la contrase\xF1a.",
    form_password_validation_failed: "Contrase\xF1a incorrecta",
    form_username_invalid_character: "Car\xE1cter inv\xE1lido.",
    form_username_invalid_length: "La longitud del nombre de usuario es demasiado corta.",
    identification_deletion_failed: "No se puede eliminar la \xFAltima identificaci\xF3n.",
    not_allowed_access: "No tienes permiso para acceder a este recurso.",
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "Ya se ha registrado una llave de acceso en este dispositivo.",
    passkey_not_supported: "Las llaves de acceso no son compatibles con este dispositivo.",
    passkey_pa_not_supported: "El registro requiere un autenticador de plataforma, pero el dispositivo no lo admite.",
    passkey_registration_cancelled: "El registro de la llave de acceso se ha cancelado o ha expirado.",
    passkey_retrieval_cancelled: "La verificaci\xF3n de la llave de acceso se ha cancelado o ha expirado.",
    passwordComplexity: {
      maximumLength: "menos de {{length}} caracteres",
      minimumLength: "{{length}} o m\xE1s caracteres",
      requireLowercase: "al menos una letra min\xFAscula",
      requireNumbers: "al menos un n\xFAmero",
      requireSpecialCharacter: "al menos un caracter especial",
      requireUppercase: "al menos una letra may\xFAscula",
      sentencePrefix: "Tu contrase\xF1a debe contener"
    },
    phone_number_exists: "Este n\xFAmero de tel\xE9fono ya est\xE1 en uso. Por favor, trata con otro.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Tu contrase\xF1a funciona, pero puede ser m\xE1s segura. Prueba a\xF1adiendo m\xE1s caracteres.",
      goodPassword: "Tu contrase\xF1a cumple con todos los requisitos necesarios.",
      notEnough: "Tu contrase\xF1a no es lo suficientemente segura.",
      suggestions: {
        allUppercase: "Escribe algunas letras en may\xFAsculas, pero no todas.",
        anotherWord: "A\xF1ade palabras menos comunes.",
        associatedYears: "Evita a\xF1os asociados contigo.",
        capitalization: "Escribe algunas letras en may\xFAsculas adem\xE1s de la primera.",
        dates: "Evita fechas asociadas contigo.",
        l33t: "Evita sustituciones predecibles como '@' por 'a'",
        longerKeyboardPattern: "Usa patrones de teclado m\xE1s largos y cambia la direcci\xF3n de escritura varias veces.",
        noNeed: "Puedes crear contrase\xF1as seguras sin usar s\xEDmbolos, n\xFAmeros o may\xFAsculas.",
        pwned: "Si utiliza esta contrase\xF1a en otro lugar, deber\xEDa cambiarla.",
        recentYears: "Evita a\xF1os recientes.",
        repeated: "Evita palabras y letras repetidas.",
        reverseWords: "Evita palabras comunes escritas al rev\xE9s",
        sequences: "Evita secuencias de letras comunes.",
        useWords: "Usa varias palabras, pero evita frases comunes."
      },
      warnings: {
        common: "Es una contrase\xF1a usada com\xFAnmente.",
        commonNames: "Nombres y apellidos comunes son f\xE1ciles de adivinar.",
        dates: "Las fechas son f\xE1ciles de adivinar.",
        extendedRepeat: 'Patrones repetidos como "abcabcabc" son f\xE1ciles de adivinar.',
        keyPattern: "Patrones cortos son f\xE1ciles de adivinar.",
        namesByThemselves: "Nombres y apellidos a solas son f\xE1ciles de adivinar.",
        pwned: "Su contrase\xF1a fue expuesta por una violaci\xF3n de datos en Internet.",
        recentYears: "Los a\xF1os recientes son f\xE1ciles de adivinar.",
        sequences: 'Patrones comunes como "abc" son f\xE1ciles de adivinar',
        similarToCommon: "Es similar a una contrase\xF1a usada habitualmente.",
        simpleRepeat: 'Caracteres repetidos como "aaa" son f\xE1ciles de adivinar',
        straightRow: "Teclas consecutivas en tu teclado son f\xE1ciles de adivinar.",
        topHundred: "Es una contrase\xF1a usada con mucha frecuencia.",
        topTen: "Es de las contrase\xF1as m\xE1s usadas.",
        userInputs: "No deber\xEDa haber datos personales o relacionados con esta p\xE1gina.",
        wordByItself: "Palabras \xFAnicas son f\xE1ciles de adivinar."
      }
    }
  },
  userButton: {
    action__addAccount: "A\xF1adir cuenta",
    action__manageAccount: "Administrar cuenta",
    action__signOut: "Cerrar sesi\xF3n",
    action__signOutAll: "Salir de todas las cuentas"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copiado!",
      actionLabel__copy: "Copiar todo",
      actionLabel__download: "Descargar .txt",
      actionLabel__print: "Imprimir",
      infoText1: "Se habilitar\xE1n c\xF3digos de respaldo para esta cuenta.",
      infoText2: "Mantenga los c\xF3digos de respaldo en secreto y gu\xE1rdelos de forma segura. Puede regenerar c\xF3digos de respaldo si sospecha que se han visto comprometidos.",
      subtitle__codelist: "Guardelos de forma segura y mant\xE9ngalos en secreto.",
      successMessage: "Los c\xF3digos de respaldo ahora est\xE1n habilitados. Puede usar uno de estos para iniciar sesi\xF3n en su cuenta, si pierde el acceso a su dispositivo de autenticaci\xF3n. Cada c\xF3digo solo se puede utilizar una vez.",
      successSubtitle: "Puede usar uno de estos para iniciar sesi\xF3n en su cuenta, si pierde el acceso a su dispositivo de autenticaci\xF3n.",
      title: "Agregar verificaci\xF3n de c\xF3digo de respaldo",
      title__codelist: "C\xF3digos de respaldo"
    },
    connectedAccountPage: {
      formHint: "Seleccione un proveedor para conectar su cuenta.",
      formHint__noAccounts: "No hay proveedores de cuentas externas disponibles.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 usar esta cuenta activa y las funciones dependientes ya no funcionar\xE1n.",
        successMessage: "{{connectedAccount}} ha sido eliminado de su cuenta.",
        title: "Eliminar cuenta conectada"
      },
      socialButtonsBlockButton: "Conectar cuenta de {{provider|titleize}}",
      successMessage: "El proveedor ha sido agregado a su cuenta",
      title: "Agregar cuenta conectada"
    },
    deletePage: {
      actionDescription: 'Escribe "Eliminar cuenta" a continuaci\xF3n para continuar',
      confirm: "Eliminar cuenta",
      messageLine1: "\xBFEstas seguro que quieres eliminar tu cuenta?",
      messageLine2: "Esta acci\xF3n es permanente e irreversible.",
      title: "Eliminar cuenta"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "A esta direcci\xF3n de correo electr\xF3nico se le enviar\xE1 un correo electr\xF3nico con un C\xF3digo de verificaci\xF3n.",
        formSubtitle: "Introduzca el c\xF3digo de verificaci\xF3n enviado a {{identifier}}",
        formTitle: "C\xF3digo de verificaci\xF3n",
        resendButton: "Re-enviar c\xF3digo",
        successMessage: "El correo electr\xF3nico {{identifier}} se ha agregado a su cuenta."
      },
      emailLink: {
        formHint: "Se enviar\xE1 un correo electr\xF3nico con un enlace de verificaci\xF3n a esta direcci\xF3n de correo electr\xF3nico.",
        formSubtitle: "Haga clic en el enlace de verificaci\xF3n en el correo electr\xF3nico enviado a {{identifier}}",
        formTitle: "Enlace de verificaci\xF3n",
        resendButton: "Reenviar enlace",
        successMessage: "El correo electr\xF3nico {{identifier}} se ha agregado a su cuenta."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 iniciar sesi\xF3n con esta direcci\xF3n de correo electr\xF3nico.",
        successMessage: "{{emailAddress}} ha sido eliminado de su cuenta.",
        title: "Eliminar direcci\xF3n de correo electr\xF3nico"
      },
      title: "Agregar direcci\xF3n de correo electr\xF3nico",
      verifyTitle: "Verificar direcci\xF3n de correo electr\xF3nico"
    },
    formButtonPrimary__add: "Agregar",
    formButtonPrimary__continue: "Continuar",
    formButtonPrimary__finish: "Terminar",
    formButtonPrimary__remove: "Eliminar",
    formButtonPrimary__save: "Guardar",
    formButtonReset: "Cancelar",
    mfaPage: {
      formHint: "Seleccione un m\xE9todo para agregar.",
      title: "Agregar verificaci\xF3n en dos pasos"
    },
    mfaPhoneCodePage: {
      backButton: "Usar n\xFAmero existente",
      primaryButton__addPhoneNumber: "Agregar n\xFAmero de tel\xE9fono",
      removeResource: {
        messageLine1: "{{identifier}} dejar\xE1 de recibir el C\xF3digo de verificaci\xF3n al iniciar sesi\xF3n.",
        messageLine2: "Es posible que su cuenta no sea tan segura. \xBFEst\xE1s seguro de que quieres continuar?",
        successMessage: "Se elimin\xF3 la verificaci\xF3n de dos pasos del c\xF3digo SMS para {{mfaPhoneCode}}",
        title: "Eliminar la verificaci\xF3n en dos pasos"
      },
      subtitle__availablePhoneNumbers: "Seleccione un n\xFAmero de tel\xE9fono para registrarse para la verificaci\xF3n en dos pasos del c\xF3digo SMS.",
      subtitle__unavailablePhoneNumbers: "No hay n\xFAmeros de tel\xE9fono disponibles para registrarse para la verificaci\xF3n en dos pasos del c\xF3digo SMS.",
      successMessage1: "Al iniciar sesi\xF3n, se le pedir\xE1 un c\xF3digo de verificaci\xF3n enviado a este n\xFAmero de tel\xE9fono como un paso adicional.",
      successMessage2: "Guarde estos c\xF3digos de respaldo y almac\xE9nelos en un lugar seguro. Si pierde el acceso a su dispositivo de autenticaci\xF3n, puede utilizar los c\xF3digos de respaldo para iniciar sesi\xF3n.",
      successTitle: "Verificaci\xF3n de c\xF3digo SMS habilitada",
      title: "Agregar verificaci\xF3n de c\xF3digo SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Escanea el c\xF3digo QR en su lugar",
        buttonUnableToScan__nonPrimary: "\xBFNo puedes escanear el c\xF3digo QR?",
        infoText__ableToScan: "Configure un nuevo m\xE9todo de inicio de sesi\xF3n en su aplicaci\xF3n de autenticaci\xF3n y escanee el siguiente c\xF3digo QR para vincularlo a su cuenta.",
        infoText__unableToScan: "Configure un nuevo m\xE9todo de inicio de sesi\xF3n en su autenticador e ingrese la clave que se proporciona a continuaci\xF3n.",
        inputLabel__unableToScan1: "Aseg\xFArese de que las contrase\xF1as basadas en el tiempo o de un solo uso est\xE9n habilitadas, luego finalice de vincular su cuenta.",
        inputLabel__unableToScan2: "Alternativamente, si su autenticador admite URIs TOTP, tambi\xE9n puede copiar la URI completa."
      },
      removeResource: {
        messageLine1: "El c\xF3digo de verificaci\xF3n de este autenticador ya no ser\xE1 necesario al iniciar sesi\xF3n.",
        messageLine2: "Es posible que su cuenta no sea tan segura. \xBFEst\xE1s seguro de que quieres continuar?",
        successMessage: "Se elimin\xF3 la verificaci\xF3n en dos pasos a trav\xE9s de la aplicaci\xF3n de autenticaci\xF3n.",
        title: "Eliminar la verificaci\xF3n en dos pasos"
      },
      successMessage: "La verificaci\xF3n en dos pasos ahora est\xE1 habilitada. Al iniciar sesi\xF3n, deber\xE1 ingresar un C\xF3digo de verificaci\xF3n de este autenticador como un paso adicional.",
      title: "Agregar aplicaci\xF3n de autenticaci\xF3n",
      verifySubtitle: "Ingrese el C\xF3digo de verificaci\xF3n generado por su autenticador",
      verifyTitle: "C\xF3digo de verificaci\xF3n"
    },
    mobileButton__menu: "Men\xFA",
    navbar: {
      account: "Perfil",
      description: "Administra tu informaci\xF3n de cuenta.",
      security: "Seguridad",
      title: "Cuenta"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} ser\xE1 eliminada de esta cuenta.",
        title: "Eliminar llave de acceso"
      },
      subtitle__rename: "Puedes cambiar el nombre de la llave de acceso para que sea m\xE1s f\xE1cil de encontrar.",
      title__rename: "Renombrar llave de acceso"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Se recomienda cerrar la sesi\xF3n de todos los otros dispositivos que hayan utilizado su antigua contrase\xF1a.",
      readonly: "Tu contrase\xF1a no se puede editar actualmente porque solo se puede acceder a trav\xE9s de la conexi\xF3n de empresa.",
      successMessage__set: "Se ha establecido tu contrase\xF1a.",
      successMessage__signOutOfOtherSessions: "Se cerr\xF3 la sesi\xF3n de todos los dem\xE1s dispositivos.",
      successMessage__update: "Tu contrase\xF1a ha sido actualizada.",
      title__set: "Configurar la clave",
      title__update: "Cambiar contrase\xF1a"
    },
    phoneNumberPage: {
      infoText: "Se enviar\xE1 un mensaje de texto con un enlace de verificaci\xF3n a este n\xFAmero de tel\xE9fono.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 iniciar sesi\xF3n con este n\xFAmero de tel\xE9fono.",
        successMessage: "{{phoneNumber}} ha sido eliminado de su cuenta.",
        title: "Eliminar n\xFAmero de tel\xE9fono"
      },
      successMessage: "{{identifier}} ha sido a\xF1adido a tu cuenta.",
      title: "Agregar el n\xFAmero de tel\xE9fono",
      verifySubtitle: "Ingrese el c\xF3digo de verificaci\xF3n enviado a {{identifier}}",
      verifyTitle: "Verificar n\xFAmero de tel\xE9fono"
    },
    profilePage: {
      fileDropAreaHint: "Cargue una imagen JPG, PNG, GIF o WEBP de menos de 10 MB",
      imageFormDestructiveActionSubtitle: "Eliminar la imagen",
      imageFormSubtitle: "Cargar imagen",
      imageFormTitle: "Imagen de perfil",
      readonly: "Tu informaci\xF3n de perfil ha sido proporcionada por la conexi\xF3n de empresa y no se puede editar.",
      successMessage: "Tu perfil ha sido actualizado.",
      title: "Actualizar perfil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Cerrar sesi\xF3n en el dispositivo",
        title: "Dispositivos activos"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Int\xE9ntelo nuevamente",
        actionLabel__reauthorize: "Autorizar ahora",
        destructiveActionTitle: "Quitar",
        primaryButton: "Conectar cuenta",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "Los permisos requeridos han sido actualizados, y podr\xEDa experimentar limitaciones. Por favor, autorice de nuevo esta aplicaci\xF3n para evitar cualquier problema",
        title: "Cuentas conectadas"
      },
      dangerSection: {
        deleteAccountButton: "Eliminar cuenta",
        title: "Peligro"
      },
      emailAddressesSection: {
        destructiveAction: "Eliminar direcci\xF3n de correo electr\xF3nico",
        detailsAction__nonPrimary: "Establecer como primario",
        detailsAction__primary: "Completar la verificaci\xF3n",
        detailsAction__unverified: "Completar la verificaci\xF3n",
        primaryButton: "Agregar una direcci\xF3n de correo electr\xF3nico",
        title: "Correos electr\xF3nicos"
      },
      enterpriseAccountsSection: {
        title: "Cuentas de empresa"
      },
      headerTitle__account: "Cuenta",
      headerTitle__security: "Seguridad",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenerar c\xF3digos",
          headerTitle: "C\xF3digos de respaldo",
          subtitle__regenerate: "Obtenga un nuevo conjunto de c\xF3digos de respaldo seguros. Los c\xF3digos de respaldo anteriores se eliminar\xE1n y no podr\xE1n ser usados.",
          title__regenerate: "Regenerar c\xF3digos de respaldo"
        },
        phoneCode: {
          actionLabel__setDefault: "Establecer por defecto",
          destructiveActionLabel: "Eliminar n\xFAmero telef\xF3nico"
        },
        primaryButton: "A\xF1adir verificaci\xF3n de dos pasos",
        title: "Verificaci\xF3n de dos pasos",
        totp: {
          destructiveActionTitle: "Eliminar",
          headerTitle: "Aplicaci\xF3n de autenticaci\xF3n"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Eliminar",
        menuAction__rename: "Renombrar",
        primaryButton: void 0,
        title: "Llaves de acceso"
      },
      passwordSection: {
        primaryButton__setPassword: "Establecer contrase\xF1a ",
        primaryButton__updatePassword: "Cambiar contrase\xF1a",
        title: "Contrase\xF1a"
      },
      phoneNumbersSection: {
        destructiveAction: "Quitar n\xFAmero de tel\xE9fono",
        detailsAction__nonPrimary: "Establecer como primario",
        detailsAction__primary: "Completar la verificaci\xF3n",
        detailsAction__unverified: "Completar la verificaci\xF3n",
        primaryButton: "Agregar un n\xFAmero de tel\xE9fono",
        title: "N\xFAmeros telef\xF3nicos"
      },
      profileSection: {
        primaryButton: "Actualizar perfil",
        title: "Perfil"
      },
      usernameSection: {
        primaryButton__setUsername: "Crear nombre de usuario",
        primaryButton__updateUsername: "Cambiar nombre de usuario",
        title: "Nombre de usuario"
      },
      web3WalletsSection: {
        destructiveAction: "Quitar cartera",
        primaryButton: "Web3 cartera",
        title: "Web3 cartera"
      }
    },
    usernamePage: {
      successMessage: "Su nombre de usuario ha sido actualizado.",
      title__set: "Actualizar nombre de usuario",
      title__update: "Actualizar nombre de usuario"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ser\xE1 eliminado de esta cuenta.",
        messageLine2: "Ya no podr\xE1 iniciar sesi\xF3n con esta billetera web3.",
        successMessage: "{{web3Wallet}} ha sido eliminado de su cuenta.",
        title: "Eliminar la billetera web3"
      },
      subtitle__availableWallets: "Seleccione una billetera web3 para conectarse a su cuenta.",
      subtitle__unavailableWallets: "No hay billetera web3 disponibles.",
      successMessage: "La billetera ha sido agregada a su cuenta.",
      title: "A\xF1adir web3 billetera",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/bg-BG.ts
var bgBG = {
  locale: "bg-BG",
  backButton: "\u041D\u0430\u0437\u0430\u0434",
  badge__default: "\u041F\u043E \u043F\u043E\u0434\u0440\u0430\u0437\u0431\u0438\u0440\u0430\u043D\u0435",
  badge__otherImpersonatorDevice: "\u0414\u0440\u0443\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0437\u0430 \u0438\u043C\u0438\u0442\u0430\u0446\u0438\u044F",
  badge__primary: "\u041E\u0441\u043D\u043E\u0432\u0435\u043D",
  badge__requiresAction: "\u0418\u0437\u0438\u0441\u043A\u0432\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
  badge__thisDevice: "\u0422\u043E\u0432\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
  badge__unverified: "\u041D\u0435\u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u043D",
  badge__userDevice: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
  badge__you: "\u0412\u0438\u0435",
  createOrganization: {
    formButtonSubmit: "\u0421\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
    invitePage: {
      formButtonReset: "\u041F\u0440\u043E\u043F\u0443\u0441\u043D\u0438"
    },
    title: "\u0421\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F"
  },
  dates: {
    lastDay: "\u0412\u0447\u0435\u0440\u0430 \u0432 {{ date | timeString('bg-BG') }}",
    next6Days: "{{ date | weekday('bg-BG','long') }} \u0432 {{ date | timeString('bg-BG') }}",
    nextDay: "\u0423\u0442\u0440\u0435 \u0432 {{ date | timeString('bg-BG') }}",
    numeric: "{{ date | numeric('bg-BG') }}",
    previous6Days: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u0432 {{ date | weekday('bg-BG','long') }} \u0432 {{ date | timeString('bg-BG') }}",
    sameDay: "\u0414\u043D\u0435\u0441 \u0432 {{ date | timeString('bg-BG') }}"
  },
  dividerText: "\u0438\u043B\u0438",
  footerActionLink__useAnotherMethod: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0434\u0440\u0443\u0433 \u043C\u0435\u0442\u043E\u0434",
  footerPageLink__help: "\u041F\u043E\u043C\u043E\u0449",
  footerPageLink__privacy: "\u041F\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442",
  footerPageLink__terms: "\u0423\u0441\u043B\u043E\u0432\u0438\u044F",
  formButtonPrimary: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438",
  formButtonPrimary__verify: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438",
  formFieldAction__forgotPassword: "\u0417\u0430\u0431\u0440\u0430\u0432\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430?",
  formFieldError__matchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0438\u0442\u0435 \u0441\u044A\u0432\u043F\u0430\u0434\u0430\u0442.",
  formFieldError__notMatchingPasswords: "\u041F\u0430\u0440\u043E\u043B\u0438\u0442\u0435 \u043D\u0435 \u0441\u044A\u0432\u043F\u0430\u0434\u0430\u0442.",
  formFieldError__verificationLinkExpired: "\u041B\u0438\u043D\u043A\u044A\u0442 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0435 \u0438\u0437\u0442\u0435\u043A\u044A\u043B. \u041C\u043E\u043B\u044F, \u0437\u0430\u044F\u0432\u0435\u0442\u0435 \u043D\u043E\u0432 \u043B\u0438\u043D\u043A.",
  formFieldHintText__optional: "\u041F\u043E \u0438\u0437\u0431\u043E\u0440",
  formFieldHintText__slug: "Slug \u0435 \u0447\u0435\u0442\u0438\u043C \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440, \u043A\u043E\u0439\u0442\u043E \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u0435\u043D. \u0427\u0435\u0441\u0442\u043E \u0441\u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u0432 URL \u0430\u0434\u0440\u0435\u0441\u0438.",
  formFieldInputPlaceholder__backupCode: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u043A\u043E\u0434",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u0418\u0437\u0442\u0440\u0438\u0439 \u0430\u043A\u0430\u0443\u043D\u0442\u0430",
  formFieldInputPlaceholder__emailAddress: "example@email.com",
  formFieldInputPlaceholder__emailAddress_username: "example@email.com \u0438\u043B\u0438 \u0438\u043C\u0435_\u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B",
  formFieldInputPlaceholder__emailAddresses: "example@email.com, example2@email.com",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: "\u0412\u0430\u0448\u0435\u0442\u043E \u0444\u0430\u043C\u0438\u043B\u043D\u043E \u0438\u043C\u0435",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "example@yourdomain.com",
  formFieldInputPlaceholder__organizationName: "\u0418\u043C\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  formFieldInputPlaceholder__organizationSlug: "slug-\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  formFieldInputPlaceholder__password: "\u041F\u0430\u0440\u043E\u043B\u0430",
  formFieldInputPlaceholder__phoneNumber: "+359 123 456 789",
  formFieldInputPlaceholder__username: "\u0418\u043C\u0435 \u043D\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B",
  formFieldLabel__automaticInvitations: "\u0412\u043A\u043B\u044E\u0447\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u043E\u043A\u0430\u043D\u0438 \u0437\u0430 \u0442\u043E\u0437\u0438 \u0434\u043E\u043C\u0435\u0439\u043D",
  formFieldLabel__backupCode: "\u0420\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u043A\u043E\u0434",
  formFieldLabel__confirmDeletion: "\u041F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
  formFieldLabel__confirmPassword: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430",
  formFieldLabel__currentPassword: "\u0422\u0435\u043A\u0443\u0449\u0430 \u043F\u0430\u0440\u043E\u043B\u0430",
  formFieldLabel__emailAddress: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
  formFieldLabel__emailAddress_username: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441 \u0438\u043B\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435",
  formFieldLabel__emailAddresses: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u0438",
  formFieldLabel__firstName: "\u0418\u043C\u0435",
  formFieldLabel__lastName: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
  formFieldLabel__newPassword: "\u041D\u043E\u0432\u0430 \u043F\u0430\u0440\u043E\u043B\u0430",
  formFieldLabel__organizationDomain: "\u0414\u043E\u043C\u0435\u0439\u043D",
  formFieldLabel__organizationDomainDeletePending: "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u0447\u0430\u043A\u0432\u0430\u0449\u0438 \u043F\u043E\u043A\u0430\u043D\u0438 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  formFieldLabel__organizationDomainEmailAddress: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441 \u043F\u043E\u0434 \u0442\u043E\u0437\u0438 \u0434\u043E\u043C\u0435\u0439\u043D, \u0437\u0430 \u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438 \u0434\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0438\u0442\u0435 \u0434\u043E\u043C\u0435\u0439\u043D\u0430.",
  formFieldLabel__organizationName: "\u0418\u043C\u0435",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "\u041F\u0430\u0440\u043E\u043B\u0430",
  formFieldLabel__phoneNumber: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440",
  formFieldLabel__role: "\u0420\u043E\u043B\u044F",
  formFieldLabel__signOutOfOtherSessions: "\u0418\u0437\u0445\u043E\u0434 \u043E\u0442 \u0432\u0441\u0438\u0447\u043A\u0438 \u0434\u0440\u0443\u0433\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430",
  formFieldLabel__username: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435",
  impersonationFab: {
    action__signOut: "\u0418\u0437\u0445\u043E\u0434",
    title: "\u0412\u043B\u0435\u0437\u043B\u0438 \u0441\u0442\u0435 \u043A\u0430\u0442\u043E {{identifier}}"
  },
  maintenanceMode: "\u0420\u0435\u0436\u0438\u043C \u043D\u0430 \u043F\u043E\u0434\u0434\u0440\u044A\u0436\u043A\u0430",
  membershipRole__admin: "\u0410\u0434\u043C\u0438\u043D",
  membershipRole__basicMember: "\u0427\u043B\u0435\u043D",
  membershipRole__guestMember: "\u0413\u043E\u0441\u0442",
  organizationList: {
    action__createOrganization: "\u0421\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
    action__invitationAccept: "\u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u043D\u0435",
    action__suggestionsAccept: "\u0417\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u043D\u0435",
    createOrganization: "\u0421\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
    invitationAcceptedLabel: "\u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0435\u043D",
    subtitle: "\u0437\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 \u043A\u044A\u043C {{applicationName}}",
    suggestionsAcceptedLabel: "\u0427\u0430\u043A\u0430\u0449\u043E \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435",
    title: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442",
    titleWithoutPersonal: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u043E\u043A\u0430\u043D\u0438",
    badge__automaticSuggestion: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
    badge__manualInvitation: "\u041D\u044F\u043C\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0432\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435",
    badge__unverified: "\u041D\u0435\u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D",
    createDomainPage: {
      subtitle: "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0434\u043E\u043C\u0435\u0439\u043D \u0437\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F. \u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u0441 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u0438 \u043D\u0430 \u0442\u043E\u0437\u0438 \u0434\u043E\u043C\u0435\u0439\u043D \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442 \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0438\u043B\u0438 \u0434\u0430 \u0437\u0430\u044F\u0432\u044F\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442.",
      title: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0434\u043E\u043C\u0435\u0439\u043D"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u041F\u043E\u043A\u0430\u043D\u0438\u0442\u0435 \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438. \u0412\u0435\u0447\u0435 \u0438\u043C\u0430 \u0447\u0430\u043A\u0430\u0449\u0438 \u043F\u043E\u043A\u0430\u043D\u0438 \u0437\u0430 \u0441\u043B\u0435\u0434\u043D\u0438\u0442\u0435 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u0438: {{email_addresses}}.",
      formButtonPrimary__continue: "\u0418\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u043A\u0430\u043D\u0438",
      selectDropdown__role: "Select role",
      subtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0438\u043B\u0438 \u043F\u043E\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u0435\u0434\u0438\u043D \u0438\u043B\u0438 \u043F\u043E\u0432\u0435\u0447\u0435 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u0438, \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438 \u0441 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0438 \u0438\u043B\u0438 \u0437\u0430\u043F\u0435\u0442\u0430\u044F.",
      successMessage: "\u041F\u043E\u043A\u0430\u043D\u0438\u0442\u0435 \u0431\u044F\u0445\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438",
      title: "\u041F\u043E\u043A\u0430\u043D\u0430 \u0437\u0430 \u043D\u043E\u0432\u0438 \u0447\u043B\u0435\u043D\u043E\u0432\u0435"
    },
    membersPage: {
      action__invite: "\u041F\u043E\u043A\u0430\u043D\u0438",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0447\u043B\u0435\u043D",
        tableHeader__actions: void 0,
        tableHeader__joined: "\u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0438\u043B \u0441\u0435",
        tableHeader__role: "\u0420\u043E\u043B\u044F",
        tableHeader__user: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B"
      },
      detailsTitle__emptyRow: "\u041D\u044F\u043C\u0430 \u0447\u043B\u0435\u043D\u043E\u0432\u0435 \u0437\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u041F\u043E\u043A\u0430\u043D\u0435\u0442\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438, \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u0449\u0438 \u0438\u043C\u0435\u0439\u043B \u0434\u043E\u043C\u0435\u0439\u043D \u0441 \u0432\u0430\u0448\u0430\u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F. \u0412\u0441\u0435\u043A\u0438, \u043A\u043E\u0439\u0442\u043E \u0441\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430 \u0441\u044A\u0441 \u0441\u044A\u043E\u0442\u0432\u0435\u0442\u043D\u0438\u044F \u0438\u043C\u0435\u0439\u043B \u0434\u043E\u043C\u0435\u0439\u043D, \u0449\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0438 \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u043F\u043E \u0432\u0441\u044F\u043A\u043E \u0432\u0440\u0435\u043C\u0435.",
          headerTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u043E\u043A\u0430\u043D\u0438",
          primaryButton: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D\u0438\u0442\u0435 \u0434\u043E\u043C\u0435\u0439\u043D\u0438"
        },
        table__emptyRow: "\u041D\u044F\u043C\u0430 \u043F\u043E\u043A\u0430\u043D\u0438 \u0437\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u041E\u0442\u043C\u044F\u043D\u0430 \u043D\u0430 \u043F\u043E\u043A\u0430\u043D\u0430\u0442\u0430",
        tableHeader__invited: "\u041F\u043E\u043A\u0430\u043D\u0435\u043D\u0438"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438, \u043A\u043E\u0438\u0442\u043E \u0441\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u0442 \u0441\u044A\u0441 \u0441\u044A\u043E\u0442\u0432\u0435\u0442\u043D\u0438\u044F \u0438\u043C\u0435\u0439\u043B \u0434\u043E\u043C\u0435\u0439\u043D, \u0449\u0435 \u0432\u0438\u0434\u044F\u0442 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u043D\u0435 \u043A\u044A\u043C \u0432\u0430\u0448\u0430\u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F.",
          headerTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
          primaryButton: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D\u0438\u0442\u0435 \u0434\u043E\u043C\u0435\u0439\u043D\u0438"
        },
        menuAction__approve: "\u041E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435",
        menuAction__reject: "\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435",
        tableHeader__requested: "\u0417\u0430\u044F\u0432\u0435\u043D \u0434\u043E\u0441\u0442\u044A\u043F",
        table__emptyRow: "\u041D\u044F\u043C\u0430 \u0437\u0430\u044F\u0432\u043A\u0438 \u0437\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435"
      },
      start: {
        headerTitle__invitations: "\u041F\u043E\u043A\u0430\u043D\u0438",
        headerTitle__members: "\u0427\u043B\u0435\u043D\u043E\u0432\u0435",
        headerTitle__requests: "\u0417\u0430\u044F\u0432\u043A\u0438"
      }
    },
    navbar: {
      description: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F.",
      general: "\u041E\u0431\u0449\u0438",
      members: "\u0427\u043B\u0435\u043D\u043E\u0432\u0435",
      title: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: '\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 "{{organizationName}}" \u043F\u043E-\u0434\u043E\u043B\u0443, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.',
          messageLine1: "\u0421\u0438\u0433\u0443\u0440\u043D\u0438 \u043B\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0442\u0430\u0437\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F?",
          messageLine2: "\u0422\u043E\u0432\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0435 \u043F\u0435\u0440\u043C\u0430\u043D\u0435\u043D\u0442\u043D\u043E \u0438 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E.",
          successMessage: "\u0418\u0437\u0442\u0440\u0438\u0445\u0442\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430.",
          title: "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430"
        },
        leaveOrganization: {
          actionDescription: '\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 "{{organizationName}}" \u043F\u043E-\u0434\u043E\u043B\u0443, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.',
          messageLine1: "\u0421\u0438\u0433\u0443\u0440\u043D\u0438 \u043B\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u043D\u0430\u043F\u0443\u0441\u043D\u0435\u0442\u0435 \u0442\u0430\u0437\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F? \u0429\u0435 \u0437\u0430\u0433\u0443\u0431\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u044A\u043F \u0434\u043E \u0442\u0430\u0437\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0438 \u043D\u0435\u0439\u043D\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F.",
          messageLine2: "\u0422\u043E\u0432\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0435 \u043F\u0435\u0440\u043C\u0430\u043D\u0435\u043D\u0442\u043D\u043E \u0438 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E.",
          successMessage: "\u0418\u0437\u043B\u044F\u0437\u043E\u0445\u0442\u0435 \u043E\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430.",
          title: "\u041D\u0430\u043F\u0443\u0441\u043A\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430"
        },
        title: "\u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442"
      },
      domainSection: {
        menuAction__manage: "Manage",
        menuAction__remove: "Delete",
        menuAction__verify: "Verify",
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0434\u043E\u043C\u0435\u0439\u043D",
        subtitle: "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0432\u0430 \u043D\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u0442 \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0438\u043B\u0438 \u0434\u0430 \u0437\u0430\u044F\u0432\u044F\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442 \u043D\u0430 \u0431\u0430\u0437\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D \u0438\u043C\u0435\u0439\u043B \u0434\u043E\u043C\u0435\u0439\u043D.",
        title: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D\u0438 \u0434\u043E\u043C\u0435\u0439\u043D\u0438"
      },
      successMessage: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0430.",
      title: "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430"
    },
    removeDomainPage: {
      messageLine1: "\u0418\u043C\u0435\u0439\u043B \u0434\u043E\u043C\u0435\u0439\u043D\u044A\u0442 {{domain}} \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442.",
      messageLine2: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u043D\u044F\u043C\u0430 \u0434\u0430 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0441\u043B\u0435\u0434 \u0442\u043E\u0432\u0430.",
      successMessage: "{{domain}} \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442.",
      title: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043C\u0435\u0439\u043D"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "\u0427\u043B\u0435\u043D\u043E\u0432\u0435",
      profileSection: {
        primaryButton: void 0,
        title: "Organization Profile",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0442\u043E\u0437\u0438 \u0434\u043E\u043C\u0435\u0439\u043D \u0449\u0435 \u0437\u0430\u0441\u0435\u0433\u043D\u0435 \u043F\u043E\u043A\u0430\u043D\u0435\u043D\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438.",
        removeDomainActionLabel__remove: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043C\u0435\u0439\u043D",
        removeDomainSubtitle: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0442\u0435 \u0442\u043E\u0437\u0438 \u0434\u043E\u043C\u0435\u0439\u043D \u043E\u0442 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D\u0438\u0442\u0435 \u0441\u0438 \u0434\u043E\u043C\u0435\u0439\u043D\u0438",
        removeDomainTitle: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043C\u0435\u0439\u043D"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u0441\u0435 \u043F\u043E\u043A\u0430\u043D\u0432\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442 \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430, \u043A\u043E\u0433\u0430\u0442\u043E \u0441\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u0442 \u0438 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442 \u043F\u043E \u0432\u0441\u044F\u043A\u043E \u0432\u0440\u0435\u043C\u0435.",
        automaticInvitationOption__label: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u043E\u043A\u0430\u043D\u0438",
        automaticSuggestionOption__description: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u0442 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u0430 \u0437\u0430\u044F\u0432\u044F\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442, \u043D\u043E \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438 \u043E\u0442 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440, \u043F\u0440\u0435\u0434\u0438 \u0434\u0430 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442 \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430.",
        automaticSuggestionOption__label: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
        calloutInfoLabel: "\u041F\u0440\u043E\u043C\u044F\u043D\u0430\u0442\u0430 \u043D\u0430 \u0440\u0435\u0436\u0438\u043C\u0430 \u043D\u0430 \u0437\u0430\u043F\u0438\u0441\u0432\u0430\u043D\u0435 \u0449\u0435 \u0437\u0430\u0441\u0435\u0433\u043D\u0435 \u0441\u0430\u043C\u043E \u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438.",
        calloutInvitationCountLabel: "\u0427\u0430\u043A\u0430\u0449\u0438 \u043F\u043E\u043A\u0430\u043D\u0438, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438 \u043D\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438: {{count}}",
        calloutSuggestionCountLabel: "\u0427\u0430\u043A\u0430\u0449\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438 \u043D\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438: {{count}}",
        manualInvitationOption__description: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u043F\u043E\u043A\u0430\u043D\u0435\u043D\u0438 \u0441\u0430\u043C\u043E \u0440\u044A\u0447\u043D\u043E \u0432 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430.",
        manualInvitationOption__label: "\u0411\u0435\u0437 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0437\u0430\u043F\u0438\u0441\u0432\u0430\u043D\u0435",
        subtitle: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u0430\u043A \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438\u0442\u0435 \u043E\u0442 \u0442\u043E\u0437\u0438 \u0434\u043E\u043C\u0435\u0439\u043D \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0442 \u043A\u044A\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430."
      },
      start: {
        headerTitle__danger: "\u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442",
        headerTitle__enrollment: "\u041E\u043F\u0446\u0438\u0438 \u0437\u0430 \u0437\u0430\u043F\u0438\u0441\u0432\u0430\u043D\u0435"
      },
      subtitle: "\u0414\u043E\u043C\u0435\u0439\u043D\u044A\u0442 {{domain}} \u0432\u0435\u0447\u0435 \u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D. \u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0435\u0442\u0435, \u043A\u0430\u0442\u043E \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0440\u0435\u0436\u0438\u043C \u043D\u0430 \u0437\u0430\u043F\u0438\u0441\u0432\u0430\u043D\u0435.",
      title: "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0414\u043E\u043C\u0435\u0439\u043D\u044A\u0442 {{domainName}} \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0430\u043D \u0447\u0440\u0435\u0437 \u0438\u043C\u0435\u0439\u043B.",
      subtitleVerificationCodeScreen: "\u0411\u0435\u0448\u0435 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043A\u043E\u0434 \u0437\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0430 {{emailAddress}}. \u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.",
      title: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0430 \u0434\u043E\u043C\u0435\u0439\u043D"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0421\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
    action__invitationAccept: "\u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u043D\u0435",
    action__manageOrganization: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
    action__suggestionsAccept: "\u0417\u0430\u044F\u0432\u043A\u0430 \u0437\u0430 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u044F\u0432\u0430\u043D\u0435",
    notSelected: "\u041D\u044F\u043C\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
    personalWorkspace: "\u041B\u0438\u0447\u0435\u043D \u0430\u043A\u0430\u0443\u043D\u0442",
    suggestionsAcceptedLabel: "\u0427\u0430\u043A\u0430\u0449\u043E \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435"
  },
  paginationButton__next: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449",
  paginationButton__previous: "\u041F\u0440\u0435\u0434\u0438\u0448\u0435\u043D",
  paginationRowText__displaying: "\u041F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435 \u043D\u0430",
  paginationRowText__of: "\u043E\u0442",
  reverification: {
    alternativeMethods: {
      actionLink: "Get help",
      actionText: "Don't have one of these?",
      blockButton__backupCode: "Use backup code",
      blockButton__emailCode: "Send code to email",
      blockButton__password: "Login with password",
      blockButton__phoneCode: "Send code to phone",
      blockButton__totp: "Use authenticator app",
      getHelp: {
        blockButton__emailSupport: "Contact support via email",
        content: "If you need assistance, please contact support.",
        title: "Need help?"
      },
      subtitle: "Choose an alternative method to verify your identity.",
      title: "Alternative methods"
    },
    backupCodeMfa: {
      subtitle: "Enter the backup code sent to your email.",
      title: "Backup code verification"
    },
    emailCode: {
      formTitle: "Enter the verification code sent to your email address.",
      resendButton: "Didn't receive the code? Send it again.",
      subtitle: "We've sent a code to your email.",
      title: "Email verification"
    },
    noAvailableMethods: {
      message: "Unable to proceed. No available authentication methods.",
      subtitle: "Something went wrong.",
      title: "Authentication failed"
    },
    password: {
      actionLink: "Use another method",
      subtitle: 'Enter your password to continue using "{{applicationName}}"',
      title: "Enter your password"
    },
    phoneCode: {
      formTitle: "Enter the verification code sent to your phone number.",
      resendButton: "Didn't receive the code? Resend it.",
      subtitle: "We've sent a code to your phone.",
      title: "Phone verification"
    },
    phoneCodeMfa: {
      formTitle: "Enter the verification code sent to your phone number.",
      resendButton: "Didn't receive the code? Resend it.",
      subtitle: "Verify using the code sent to your phone.",
      title: "Phone number MFA"
    },
    totpMfa: {
      formTitle: "Enter the verification code from your authenticator app.",
      subtitle: "Use your authenticator app to get the code.",
      title: "Authenticator App MFA"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Add account",
      action__signOutAll: "Sign out of all accounts",
      subtitle: "Select the account with which you wish to continue.",
      title: "Choose an account"
    },
    alternativeMethods: {
      actionLink: "\u041F\u043E\u043B\u0443\u0447\u0435\u0442\u0435 \u043F\u043E\u043C\u043E\u0449",
      actionText: "\u041D\u044F\u043C\u0430\u0442\u0435 \u043D\u0438\u0442\u043E \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u044F\u0445?",
      blockButton__backupCode: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439 \u0440\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u043A\u043E\u0434",
      blockButton__emailCode: "\u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E \u0438\u043C\u0435\u0439\u043B \u0434\u043E {{identifier}}",
      blockButton__emailLink: "\u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043B\u0438\u043D\u043A \u043F\u043E \u0438\u043C\u0435\u0439\u043B \u0434\u043E {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "\u0412\u043B\u0435\u0437 \u0441 \u043F\u0430\u0440\u043E\u043B\u0430",
      blockButton__phoneCode: "\u0418\u0437\u043F\u0440\u0430\u0442\u0438 SMS \u043A\u043E\u0434 \u0434\u043E {{identifier}}",
      blockButton__totp: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435",
      getHelp: {
        blockButton__emailSupport: "\u0418\u043C\u0435\u0439\u043B \u043F\u043E\u0434\u0434\u0440\u044A\u0436\u043A\u0430",
        content: "\u0410\u043A\u043E \u0438\u043C\u0430\u0442\u0435 \u0437\u0430\u0442\u0440\u0443\u0434\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u0438 \u0432\u043B\u0438\u0437\u0430\u043D\u0435 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0441\u0438, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u0442\u0435 \u043D\u0438 \u0438\u043C\u0435\u0439\u043B \u0438 \u0449\u0435 \u0440\u0430\u0431\u043E\u0442\u0438\u043C \u0441 \u0432\u0430\u0441, \u0437\u0430 \u0434\u0430 \u0432\u044A\u0437\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u043C \u0434\u043E\u0441\u0442\u044A\u043F\u0430 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0441\u043A\u043E\u0440\u043E.",
        title: "\u041F\u043E\u043B\u0443\u0447\u0438 \u043F\u043E\u043C\u043E\u0449"
      },
      subtitle: "\u0418\u043C\u0430\u0442\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u043D\u044F\u043A\u043E\u0439 \u043E\u0442 \u0442\u0435\u0437\u0438 \u043C\u0435\u0442\u043E\u0434\u0438 \u0437\u0430 \u0432\u043B\u0438\u0437\u0430\u043D\u0435.",
      title: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0434\u0440\u0443\u0433 \u043C\u0435\u0442\u043E\u0434"
    },
    backupCodeMfa: {
      subtitle: "\u0412\u0430\u0448\u0438\u044F\u0442 \u0440\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u043A\u043E\u0434 \u0435 \u0442\u043E\u0437\u0438, \u043A\u043E\u0439\u0442\u043E \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043F\u0440\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u0430\u0442\u0430 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u043A\u0430\u0446\u0438\u044F.",
      title: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u043A\u043E\u0434"
    },
    emailCode: {
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435 \u043A\u044A\u043C {{applicationName}}",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "\u0412\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u0432 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u043D\u0438\u044F \u0442\u0430\u0431, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.",
        title: "\u0422\u043E\u0437\u0438 \u043B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0435 \u0438\u0437\u0442\u0435\u043A\u044A\u043B"
      },
      failed: {
        subtitle: "\u0412\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u0432 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u043D\u0438\u044F \u0442\u0430\u0431, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.",
        title: "\u0422\u043E\u0437\u0438 \u043B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0435 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D"
      },
      formSubtitle: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043B\u0438\u043D\u043A\u044A\u0442 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
      formTitle: "\u041B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      loading: {
        subtitle: "\u0429\u0435 \u0431\u044A\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0438 \u0441\u043A\u043E\u0440\u043E",
        title: "\u0412\u043B\u0438\u0437\u0430\u043D\u0435..."
      },
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043B\u0438\u043D\u043A? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435 \u043A\u044A\u043C {{applicationName}}",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B",
      unusedTab: {
        title: "\u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0437\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u0442\u043E\u0437\u0438 \u0442\u0430\u0431"
      },
      verified: {
        subtitle: "\u0429\u0435 \u0431\u044A\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0438 \u0441\u043A\u043E\u0440\u043E",
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0432\u043B\u0435\u0437\u043B\u0438"
      },
      verifiedSwitchTab: {
        subtitle: "\u0412\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u0432 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u043D\u0438\u044F \u0442\u0430\u0431, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435",
        subtitleNewTab: "\u0412\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u0432 \u043D\u043E\u0432\u043E\u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u044F \u0442\u0430\u0431, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435",
        titleNewTab: "\u0412\u043B\u0435\u0437\u043D\u0430\u043B\u0438 \u0441\u0442\u0435 \u0432 \u0434\u0440\u0443\u0433 \u0442\u0430\u0431"
      }
    },
    forgotPassword: {
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043D\u0443\u043B\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0437\u0430 \u0434\u0430 \u043D\u0443\u043B\u0438\u0440\u0430\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0441\u0438",
      subtitle_email: "\u041F\u044A\u0440\u0432\u043E, \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B",
      subtitle_phone: "\u041F\u044A\u0440\u0432\u043E, \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      title: "\u041D\u0443\u043B\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u041D\u0443\u043B\u0438\u0440\u0430\u0439\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430",
      label__alternativeMethods: "\u0418\u043B\u0438, \u0432\u043B\u0435\u0437\u0442\u0435 \u0441 \u0434\u0440\u0443\u0433 \u043C\u0435\u0442\u043E\u0434",
      title: "\u0417\u0430\u0431\u0440\u0430\u0432\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430?"
    },
    noAvailableMethods: {
      message: "\u041D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u0441 \u0432\u043B\u0438\u0437\u0430\u043D\u0435\u0442\u043E. \u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u043C\u0435\u0442\u043E\u0434 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435.",
      subtitle: "\u0412\u044A\u0437\u043D\u0438\u043A\u043D\u0430 \u0433\u0440\u0435\u0448\u043A\u0430",
      title: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0432\u043B\u0438\u0437\u0430\u043D\u0435"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0434\u0440\u0443\u0433 \u043C\u0435\u0442\u043E\u0434",
      subtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0430 \u0441 \u0432\u0430\u0448\u0438\u044F \u0430\u043A\u0430\u0443\u043D\u0442",
      title: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435 \u043A\u044A\u043C {{applicationName}}",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    phoneCodeMfa: {
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0417\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435, \u043C\u043E\u043B\u044F \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      title: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    resetPassword: {
      formButtonPrimary: "\u041D\u0443\u043B\u0438\u0440\u0430\u0439 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430",
      requiredMessage: "\u0412\u0435\u0447\u0435 \u0441\u044A\u0449\u0435\u0441\u0442\u0432\u0443\u0432\u0430 \u0430\u043A\u0430\u0443\u043D\u0442 \u0441 \u043D\u0435\u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u043D \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441. \u041C\u043E\u043B\u044F, \u043D\u0443\u043B\u0438\u0440\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0441\u0438 \u0437\u0430 \u0441\u0438\u0433\u0443\u0440\u043D\u043E\u0441\u0442.",
      successMessage: "\u041F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0432\u0438 \u0431\u0435\u0448\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0440\u043E\u043C\u0435\u043D\u0435\u043D\u0430. \u0412\u043B\u0438\u0437\u0430\u043D\u0435, \u043C\u043E\u043B\u044F \u0438\u0437\u0447\u0430\u043A\u0430\u0439\u0442\u0435 \u043C\u043E\u043C\u0435\u043D\u0442.",
      title: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u0430 \u043F\u0430\u0440\u043E\u043B\u0430"
    },
    resetPasswordMfa: {
      detailsLabel: "\u0422\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0438\u043C \u0432\u0430\u0448\u0430\u0442\u0430 \u0441\u0430\u043C\u043E\u043B\u0438\u0447\u043D\u043E\u0441\u0442, \u043F\u0440\u0435\u0434\u0438 \u0434\u0430 \u043D\u0443\u043B\u0438\u0440\u0430\u043C\u0435 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0432\u0438."
    },
    start: {
      actionLink: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u0439\u0442\u0435 \u0441\u0435",
      actionLink__join_waitlist: "\u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0435\u0442\u0435 \u0441\u0435 \u043A\u044A\u043C \u043B\u0438\u0441\u0442\u0430\u0442\u0430 \u0437\u0430 \u0438\u0437\u0447\u0430\u043A\u0432\u0430\u043D\u0435",
      actionLink__use_email: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0438\u043C\u0435\u0439\u043B",
      actionLink__use_email_username: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0438\u043C\u0435\u0439\u043B \u0438\u043B\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      actionLink__use_username: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435",
      actionText: "\u041D\u044F\u043C\u0430\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442?",
      actionText__join_waitlist: "\u0412\u0441\u0435 \u043E\u0449\u0435 \u043D\u044F\u043C\u0430\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442? \u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0435\u0442\u0435 \u0441\u0435 \u043A\u044A\u043C \u043B\u0438\u0441\u0442\u0430\u0442\u0430 \u0437\u0430 \u0438\u0437\u0447\u0430\u043A\u0432\u0430\u043D\u0435.",
      subtitle: "\u0414\u043E\u0431\u0440\u0435 \u0434\u043E\u0448\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u043D\u043E! \u041C\u043E\u043B\u044F, \u0432\u043B\u0435\u0437\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435",
      subtitleCombined: void 0,
      title: "\u0412\u043B\u0435\u0437\u0442\u0435 \u0432 {{applicationName}}",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      subtitle: "\u0417\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435, \u043C\u043E\u043B\u044F \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D \u043E\u0442 \u0432\u0430\u0448\u0435\u0442\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435",
      title: "\u0414\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
    }
  },
  signInEnterPasswordTitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430",
  signUp: {
    continue: {
      actionLink: "\u0412\u043B\u0435\u0437\u0442\u0435",
      actionText: "\u0412\u0435\u0447\u0435 \u0438\u043C\u0430\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442?",
      subtitle: "\u041C\u043E\u043B\u044F, \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043E\u0441\u0442\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.",
      title: "\u041F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043B\u0438\u043F\u0441\u0432\u0430\u0449\u0438\u0442\u0435 \u043F\u043E\u043B\u0435\u0442\u0430"
    },
    emailCode: {
      formSubtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B",
      title: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043B\u0438\u043D\u043A\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
      formTitle: "\u041B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      loading: {
        title: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u043D\u0435..."
      },
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043B\u0438\u043D\u043A? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435 \u043A\u044A\u043C {{applicationName}}",
      title: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0438\u043C\u0435\u0439\u043B",
      verified: {
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u043D"
      },
      verifiedSwitchTab: {
        subtitle: "\u0412\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u043A\u044A\u043C \u043D\u043E\u0432\u043E\u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u044F \u0442\u0430\u0431, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435",
        subtitleNewTab: "\u0412\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u043A\u044A\u043C \u043F\u0440\u0435\u0434\u0445\u043E\u0434\u043D\u0438\u044F \u0442\u0430\u0431, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435",
        title: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u043D \u0438\u043C\u0435\u0439\u043B"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: "\u0421\u044A\u0433\u043B\u0430\u0441\u0435\u043D \u0441\u044A\u043C \u0441\u0430\u043C\u043E \u0441 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430\u0442\u0430 \u0437\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u043D\u043E\u0441\u0442",
        label__onlyTermsOfService: "\u0421\u044A\u0433\u043B\u0430\u0441\u0435\u043D \u0441\u044A\u043C \u0441\u0430\u043C\u043E \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435",
        label__termsOfServiceAndPrivacyPolicy: "\u0421\u044A\u0433\u043B\u0430\u0441\u0435\u043D \u0441\u044A\u043C \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435 \u0438 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430\u0442\u0430 \u0437\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u043D\u043E\u0441\u0442"
      },
      continue: {
        subtitle: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0437\u0430\u0432\u044A\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0430",
        title: "\u041F\u0440\u043E\u0447\u0435\u0442\u0435\u0442\u0435 \u0438 \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u0435\u0442\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0442\u0430"
      }
    },
    phoneCode: {
      formSubtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440",
      formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
      subtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      title: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
    },
    restrictedAccess: {
      actionLink: "\u041F\u043E\u043B\u0443\u0447\u0435\u0442\u0435 \u043F\u043E\u043C\u043E\u0449",
      actionText: "\u041D\u044F\u043C\u0430\u0442\u0435 \u043D\u0438\u0442\u043E \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u044F\u0445?",
      blockButton__emailSupport: "\u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441\u0435 \u0441 \u043F\u043E\u0434\u0434\u0440\u044A\u0436\u043A\u0430\u0442\u0430 \u043F\u043E \u0438\u043C\u0435\u0439\u043B",
      blockButton__joinWaitlist: "\u041F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0435\u0442\u0435 \u0441\u0435 \u043A\u044A\u043C \u0447\u0430\u043A\u0430\u0449\u0438\u044F \u0441\u043F\u0438\u0441\u044A\u043A",
      subtitle: "\u0412\u044A\u0437\u043D\u0438\u043A\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C \u0441 \u0434\u043E\u0441\u0442\u044A\u043F\u0430 \u0432\u0438.",
      subtitleWaitlist: "\u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0441\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u0435 \u043A\u044A\u043C \u0447\u0430\u043A\u0430\u0449\u0438\u044F \u0441\u043F\u0438\u0441\u044A\u043A \u0437\u0430 \u0431\u044A\u0434\u0435\u0449\u0438 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438.",
      title: "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0434\u043E\u0441\u0442\u044A\u043F"
    },
    start: {
      actionLink: "\u0412\u043B\u0435\u0437\u0442\u0435",
      actionLink__use_email: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0438\u043C\u0435\u0439\u043B",
      actionLink__use_phone: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
      actionText: "\u0412\u0435\u0447\u0435 \u0438\u043C\u0430\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442?",
      subtitle: "\u0414\u043E\u0431\u0440\u0435 \u0434\u043E\u0448\u043B\u0438! \u041C\u043E\u043B\u044F, \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u0434\u0430\u043D\u043D\u0438\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435.",
      subtitleCombined: "\u0414\u043E\u0431\u0440\u0435 \u0434\u043E\u0448\u043B\u0438! \u041C\u043E\u043B\u044F, \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u0434\u0430\u043D\u043D\u0438\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435.",
      title: "\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u044F \u0430\u043A\u0430\u0443\u043D\u0442",
      titleCombined: "\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u044F \u0430\u043A\u0430\u0443\u043D\u0442"
    }
  },
  socialButtonsBlockButton: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u0441 {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: "\u0412\u0438\u0435 \u0432\u0435\u0447\u0435 \u0441\u0442\u0435 \u0447\u043B\u0435\u043D \u043D\u0430 \u0442\u0430\u0437\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F.",
    captcha_invalid: void 0,
    captcha_unavailable: void 0,
    form_code_incorrect: "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D \u043A\u043E\u0434. \u041C\u043E\u043B\u044F, \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E.",
    form_identifier_exists__email_address: "\u0422\u043E\u0437\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441 \u0432\u0435\u0447\u0435 \u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u043D.",
    form_identifier_exists__phone_number: "\u0422\u043E\u0437\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440 \u0432\u0435\u0447\u0435 \u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D.",
    form_identifier_exists__username: "\u0422\u043E\u0432\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435 \u0432\u0435\u0447\u0435 \u0441\u044A\u0449\u0435\u0441\u0442\u0432\u0443\u0432\u0430.",
    form_identifier_not_found: "\u041D\u0435 \u043C\u043E\u0436\u0435\u043C \u0434\u0430 \u043D\u0430\u043C\u0435\u0440\u0438\u043C \u0442\u043E\u0437\u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440.",
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u044A\u0442 \u043D\u0435 \u0435 \u0432\u044A\u0432 \u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0444\u043E\u0440\u043C\u0430\u0442.",
    form_param_format_invalid__phone_number: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u0438\u044F\u0442 \u043D\u043E\u043C\u0435\u0440 \u043D\u0435 \u0435 \u0432\u044A\u0432 \u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0444\u043E\u0440\u043C\u0430\u0442.",
    form_param_max_length_exceeded__first_name: "\u041F\u044A\u0440\u0432\u043E\u0442\u043E \u0438\u043C\u0435 \u043D\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u043F\u043E-\u0434\u044A\u043B\u0433\u043E \u043E\u0442 256 \u0441\u0438\u043C\u0432\u043E\u043B\u0430.",
    form_param_max_length_exceeded__last_name: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F\u0442\u0430 \u043D\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u043F\u043E-\u0434\u044A\u043B\u0433\u0430 \u043E\u0442 256 \u0441\u0438\u043C\u0432\u043E\u043B\u0430.",
    form_param_max_length_exceeded__name: "\u0418\u043C\u0435\u0442\u043E \u043D\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u043D\u0430\u0434\u0432\u0438\u0448\u0430\u0432\u0430 256 \u0441\u0438\u043C\u0432\u043E\u043B\u0430.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430. \u041C\u043E\u043B\u044F, \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E.",
    form_password_length_too_short: "\u041F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0435 \u0442\u0432\u044A\u0440\u0434\u0435 \u043A\u0440\u0430\u0442\u043A\u0430. \u041C\u043E\u043B\u044F, \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043F\u043E\u043D\u0435 8 \u0441\u0438\u043C\u0432\u043E\u043B\u0430.",
    form_password_not_strong_enough: "\u041F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430 \u043F\u043E\u043D\u0435 \u0435\u0434\u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0430 \u0431\u0443\u043A\u0432\u0430, \u0435\u0434\u043D\u0430 \u0446\u0438\u0444\u0440\u0430 \u0438 \u0435\u0434\u0438\u043D \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0435\u043D \u0441\u0438\u043C\u0432\u043E\u043B.",
    form_password_pwned: "\u0422\u0430\u0437\u0438 \u043F\u0430\u0440\u043E\u043B\u0430 \u0435 \u043A\u043E\u043C\u043F\u0440\u043E\u043C\u0435\u0442\u0438\u0440\u0430\u043D\u0430 \u0432 \u0438\u0437\u0442\u0435\u043A\u043B\u0438 \u0434\u0430\u043D\u043D\u0438. \u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u0440\u0443\u0433\u0430.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "\u041F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0432\u0438 \u0435 \u0442\u0432\u044A\u0440\u0434\u0435 \u0434\u044A\u043B\u0433\u0430. \u041C\u043E\u043B\u044F, \u0441\u044A\u043A\u0440\u0430\u0442\u0435\u0442\u0435 \u044F.",
    form_password_validation_failed: "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430.",
    form_username_invalid_character: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E\u0442\u043E \u0438\u043C\u0435 \u0441\u044A\u0434\u044A\u0440\u0436\u0430 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u0438.",
    form_username_invalid_length: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E\u0442\u043E \u0438\u043C\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043C\u0435\u0436\u0434\u0443 3 \u0438 256 \u0441\u0438\u043C\u0432\u043E\u043B\u0430.",
    identification_deletion_failed: "\u041D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 \u0441\u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F.",
    not_allowed_access: "\u041D\u044F\u043C\u0430\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0438\u0442\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0437\u0430 \u0434\u043E\u0441\u0442\u044A\u043F.",
    organization_domain_blocked: "\u0414\u043E\u043C\u0435\u043D\u044A\u0442 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u0430\u043D.",
    organization_domain_common: "\u0414\u043E\u043C\u0435\u043D\u044A\u0442 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u0442\u0432\u044A\u0440\u0434\u0435 \u043E\u0431\u0449.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "\u041A\u0432\u043E\u0442\u0430\u0442\u0430 \u0437\u0430 \u0447\u043B\u0435\u043D\u043E\u0432\u0435 \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u0438\u0437\u0447\u0435\u0440\u043F\u0430\u043D\u0430.",
    organization_minimum_permissions_needed: "\u0422\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0438\u043C\u0430\u0442\u0435 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u043D\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0437\u0430 \u0434\u043E\u0441\u0442\u044A\u043F.",
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{length}} \u0441\u0438\u043C\u0432\u043E\u043B\u0430",
      minimumLength: "{{length}} \u0438\u043B\u0438 \u043F\u043E\u0432\u0435\u0447\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u0430",
      requireLowercase: "\u043C\u0430\u043B\u043A\u0430 \u0431\u0443\u043A\u0432\u0430",
      requireNumbers: "\u0447\u0438\u0441\u043B\u043E",
      requireSpecialCharacter: "\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0435\u043D \u0441\u0438\u043C\u0432\u043E\u043B",
      requireUppercase: "\u0433\u043B\u0430\u0432\u043D\u0430 \u0431\u0443\u043A\u0432\u0430",
      sentencePrefix: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
    },
    phone_number_exists: "\u0422\u043E\u0437\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440 \u0435 \u0437\u0430\u0435\u0442. \u041C\u043E\u043B\u044F, \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0441 \u0434\u0440\u0443\u0433.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u0440\u0430\u0431\u043E\u0442\u0438, \u043D\u043E \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043F\u043E-\u0441\u0438\u0433\u0443\u0440\u043D\u0430. \u041E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0434\u0430 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u0435 \u043F\u043E\u0432\u0435\u0447\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u0438.",
      goodPassword: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u043E\u0442\u0433\u043E\u0432\u0430\u0440\u044F \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0438 \u0438\u0437\u0438\u0441\u043A\u0432\u0430\u043D\u0438\u044F.",
      notEnough: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u0430\u0442\u044A\u0447\u043D\u043E \u0441\u0438\u0433\u0443\u0440\u043D\u0430.",
      suggestions: {
        allUppercase: "\u041D\u0430\u043F\u0440\u0430\u0432\u0435\u0442\u0435 \u0433\u043B\u0430\u0432\u043D\u0438 \u043D\u044F\u043A\u043E\u0438, \u043D\u043E \u043D\u0435 \u0432\u0441\u0438\u0447\u043A\u0438 \u0431\u0443\u043A\u0432\u0438.",
        anotherWord: "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043E\u0449\u0435 \u0434\u0443\u043C\u0438, \u043A\u043E\u0438\u0442\u043E \u0441\u0430 \u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0431\u0438\u0447\u0430\u0439\u043D\u0438.",
        associatedYears: "\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u0433\u043E\u0434\u0438\u043D\u0438, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u0432\u0430\u0441.",
        capitalization: "\u041D\u0430\u043F\u0440\u0435\u0432\u0435\u0442\u0435 \u0433\u043B\u0430\u0432\u043D\u0438 \u043F\u043E\u0432\u0435\u0447\u0435 \u043E\u0442 \u043F\u044A\u0440\u0432\u0430\u0442\u0430 \u0431\u0443\u043A\u0432\u0430.",
        dates: "\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u0434\u0430\u0442\u0438 \u0438 \u0433\u043E\u0434\u0438\u043D\u0438, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u0432\u0430\u0441.",
        l33t: '\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0438\u043C\u0438 \u0437\u0430\u043C\u0435\u0441\u0442\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0431\u0443\u043A\u0432\u0438 \u043A\u0430\u0442\u043E "@" \u0437\u0430 "a".',
        longerKeyboardPattern: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u043E-\u0434\u044A\u043B\u0433\u0438 \u043A\u043B\u0430\u0432\u0438\u0448\u043D\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u044F\u0439\u0442\u0435 \u043F\u043E\u0441\u043E\u043A\u0430\u0442\u0430 \u043D\u0430 \u043D\u0430\u0431\u0438\u0440\u0430\u043D\u0435 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u043F\u044A\u0442\u0438.",
        noNeed: "\u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0441\u044A\u0437\u0434\u0430\u0434\u0435\u0442\u0435 \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u043F\u0430\u0440\u043E\u043B\u0438 \u0438 \u0431\u0435\u0437 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u0438, \u0447\u0438\u0441\u043B\u0430 \u0438\u043B\u0438 \u0433\u043B\u0430\u0432\u043D\u0438 \u0431\u0443\u043A\u0432\u0438.",
        pwned: "\u0410\u043A\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0442\u0430\u0437\u0438 \u043F\u0430\u0440\u043E\u043B\u0430 \u043D\u0430 \u0434\u0440\u0443\u0433\u043E \u043C\u044F\u0441\u0442\u043E, \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u044F \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435.",
        recentYears: "\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u0441\u043A\u043E\u0440\u043E\u0448\u043D\u0438 \u0433\u043E\u0434\u0438\u043D\u0438.",
        repeated: "\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u0430\u0440\u044F\u0449\u0438 \u0441\u0435 \u0434\u0443\u043C\u0438 \u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u0438.",
        reverseWords: "\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u043E\u0431\u044A\u0440\u043D\u0430\u0442\u0438 \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043D\u0430 \u043E\u0431\u0438\u0447\u0430\u0439\u043D\u0438 \u0434\u0443\u043C\u0438.",
        sequences: "\u0418\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u043E\u0431\u0438\u0447\u0430\u0439\u043D\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u043D\u043E\u0441\u0442\u0438 \u043E\u0442 \u0441\u0438\u043C\u0432\u043E\u043B\u0438.",
        useWords: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u0443\u043C\u0438, \u043D\u043E \u0438\u0437\u0431\u044F\u0433\u0432\u0430\u0439\u0442\u0435 \u043E\u0431\u0438\u0447\u0430\u0439\u043D\u0438 \u0444\u0440\u0430\u0437\u0438."
      },
      warnings: {
        common: "\u0422\u043E\u0432\u0430 \u0435 \u0447\u0435\u0441\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430.",
        commonNames: "\u041E\u0431\u0438\u0447\u0430\u0439\u043D\u0438 \u0438\u043C\u0435\u043D\u0430 \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u0438 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.",
        dates: "\u0414\u0430\u0442\u0438\u0442\u0435 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.",
        extendedRepeat: '\u041F\u043E\u0432\u0442\u0430\u0440\u044F\u0449\u0438 \u0441\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u043D\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u043A\u0430\u0442\u043E "abcabcabc" \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.',
        keyPattern: "\u041A\u0440\u0430\u0442\u043A\u0438 \u043A\u043B\u0430\u0432\u0438\u0448\u043D\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.",
        namesByThemselves: "\u0415\u0434\u0438\u043D\u0438\u0447\u043D\u0438 \u0438\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u0438 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.",
        pwned: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u0435 \u0431\u0438\u043B\u0430 \u043A\u043E\u043C\u043F\u0440\u043E\u043C\u0435\u043D\u0442\u0438\u0440\u0430\u043D\u0430 \u043E\u0442 \u0438\u0437\u0442\u0435\u043A\u043B\u0438 \u0434\u0430\u043D\u043D\u0438 \u0432 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442.",
        recentYears: "\u0421\u043A\u043E\u0440\u043E\u0448\u043D\u0438 \u0433\u043E\u0434\u0438\u043D\u0438 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.",
        sequences: '\u041E\u0431\u0438\u0447\u0430\u0439\u043D\u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u043D\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u043D\u043E\u0441\u0442\u0438 \u043A\u0430\u0442\u043E "abc" \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.',
        similarToCommon: "\u0422\u043E\u0432\u0430 \u0435 \u043F\u043E\u0434\u043E\u0431\u043D\u043E \u043D\u0430 \u0447\u0435\u0441\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430.",
        simpleRepeat: '\u041F\u043E\u0432\u0442\u0430\u0440\u044F\u0449\u0438 \u0441\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u0438 \u043A\u0430\u0442\u043E "aaa" \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.',
        straightRow: "\u0420\u0435\u0434\u043E\u0432\u0435 \u043E\u0442 \u043A\u043B\u0430\u0432\u0438\u0448\u0438 \u043D\u0430 \u043A\u043B\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u0430\u0442\u0430 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435.",
        topHundred: "\u0422\u043E\u0432\u0430 \u0435 \u0447\u0435\u0441\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430.",
        topTen: "\u0422\u043E\u0432\u0430 \u0435 \u0447\u0435\u0441\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u0430.",
        userInputs: "\u041D\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0438\u043C\u0430 \u043B\u0438\u0447\u043D\u0438 \u0438\u043B\u0438 \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441\u044A\u0441 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430 \u0434\u0430\u043D\u043D\u0438.",
        wordByItself: "\u0415\u0434\u0438\u043D\u0438\u0447\u043D\u0438 \u0434\u0443\u043C\u0438 \u0441\u0430 \u043B\u0435\u0441\u043D\u0438 \u0437\u0430 \u043E\u0442\u0433\u0430\u0434\u0432\u0430\u043D\u0435."
      }
    }
  },
  userButton: {
    action__addAccount: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0430\u043A\u0430\u0443\u043D\u0442",
    action__manageAccount: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0430\u043A\u0430\u0443\u043D\u0442\u0430",
    action__signOut: "\u0418\u0437\u0445\u043E\u0434",
    action__signOutAll: "\u0418\u0437\u0445\u043E\u0434 \u043E\u0442 \u0432\u0441\u0438\u0447\u043A\u0438 \u0430\u043A\u0430\u0443\u043D\u0442\u0438"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E!",
      actionLabel__copy: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438",
      actionLabel__download: "\u0418\u0437\u0442\u0435\u0433\u043B\u044F\u043D\u0435 \u043D\u0430 .txt",
      actionLabel__print: "\u041E\u0442\u043F\u0435\u0447\u0430\u0442\u0432\u0430\u043D\u0435",
      infoText1: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0438\u0442\u0435 \u043A\u043E\u0434\u043E\u0432\u0435 \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u0438 \u0437\u0430 \u0442\u043E\u0437\u0438 \u0430\u043A\u0430\u0443\u043D\u0442.",
      infoText2: "\u0414\u0440\u044A\u0436\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438\u0442\u0435 \u043A\u043E\u0434\u043E\u0432\u0435 \u0432 \u0442\u0430\u0439\u043D\u0430 \u0438 \u0433\u0438 \u0441\u044A\u0445\u0440\u0430\u043D\u044F\u0432\u0430\u0439\u0442\u0435 \u0441\u0438\u0433\u0443\u0440\u043D\u043E. \u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u0442\u0435 \u043D\u043E\u0432\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438 \u043A\u043E\u0434\u043E\u0432\u0435, \u0430\u043A\u043E \u043F\u043E\u0434\u043E\u0437\u0438\u0440\u0430\u0442\u0435, \u0447\u0435 \u0442\u0435 \u0441\u0430 \u0431\u0438\u043B\u0438 \u043A\u043E\u043C\u043F\u0440\u043E\u043C\u0435\u0442\u0438\u0440\u0430\u043D\u0438.",
      subtitle__codelist: "\u0417\u0430\u043F\u0430\u0437\u0435\u0442\u0435 \u0433\u0438 \u0441\u0438\u0433\u0443\u0440\u043D\u043E \u0438 \u0433\u0438 \u0434\u044A\u0440\u0436\u0435\u0442\u0435 \u0432 \u0442\u0430\u0439\u043D\u0430.",
      successMessage: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0438\u0442\u0435 \u043A\u043E\u0434\u043E\u0432\u0435 \u0441\u0430 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u0438. \u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u044F\u0445, \u0437\u0430 \u0434\u0430 \u0432\u043B\u0435\u0437\u0435\u0442\u0435 \u0432 \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438, \u0430\u043A\u043E \u0437\u0430\u0433\u0443\u0431\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u0430 \u0434\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u0442\u043E \u0441\u0438 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435. \u0412\u0441\u0435\u043A\u0438 \u043A\u043E\u0434 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u0441\u0430\u043C\u043E \u0432\u0435\u0434\u043D\u044A\u0436.",
      successSubtitle: "\u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u044F\u0445, \u0437\u0430 \u0434\u0430 \u0432\u043B\u0435\u0437\u0435\u0442\u0435 \u0432 \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438, \u0430\u043A\u043E \u0437\u0430\u0433\u0443\u0431\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u0430 \u0434\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u0442\u043E \u0441\u0438 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435.",
      title: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u043A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
      title__codelist: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0438 \u043A\u043E\u0434\u043E\u0432\u0435"
    },
    connectedAccountPage: {
      formHint: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A, \u0437\u0430 \u0434\u0430 \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
      formHint__noAccounts: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u0432\u044A\u043D\u0448\u043D\u0438 \u0430\u043A\u0430\u0443\u043D\u0442 \u0434\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u0446\u0438.",
      removeResource: {
        messageLine1: "{{identifier}} \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0442\u043E\u0437\u0438 \u043F\u0440\u043E\u0444\u0438\u043B.",
        messageLine2: "\u041D\u044F\u043C\u0430 \u0434\u0430 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0442\u043E\u0437\u0438 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u0430\u043A\u0430\u0443\u043D\u0442, \u0438 \u0432\u0441\u044F\u043A\u0430\u043A\u0432\u0438 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u043D\u044F\u043C\u0430 \u0434\u0430 \u0440\u0430\u0431\u043E\u0442\u044F\u0442 \u043F\u043E\u0432\u0435\u0447\u0435.",
        successMessage: "{{connectedAccount}} \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
        title: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u0430\u043A\u0430\u0443\u043D\u0442"
      },
      socialButtonsBlockButton: "\u0421\u0432\u044A\u0440\u0436\u0438 \u0430\u043A\u0430\u0443\u043D\u0442 {{provider|titleize}}",
      successMessage: "\u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u0431\u0435\u0448\u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u043A\u044A\u043C \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u0430\u043A\u0430\u0443\u043D\u0442"
    },
    deletePage: {
      actionDescription: '\u041D\u0430\u043F\u0438\u0448\u0435\u0442\u0435 "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0430\u043A\u0430\u0443\u043D\u0442\u0430" \u043F\u043E-\u0434\u043E\u043B\u0443, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.',
      confirm: "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0430\u043A\u0430\u0443\u043D\u0442\u0430",
      messageLine1: "\u0421\u0438\u0433\u0443\u0440\u043D\u0438 \u043B\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438?",
      messageLine2: "\u0422\u043E\u0432\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0435 \u043F\u0435\u0440\u043C\u0430\u043D\u0435\u043D\u0442\u043D\u043E \u0438 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E.",
      title: "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0430\u043A\u0430\u0443\u043D\u0442\u0430"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u041D\u0430 \u0442\u043E\u0437\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u0438\u043C\u0435\u0439\u043B \u0441 \u043A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435.",
        formSubtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 {{identifier}}",
        formTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
        resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043A\u043E\u0434? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
        successMessage: "\u0418\u043C\u0435\u0439\u043B\u044A\u0442 {{identifier}} \u0431\u0435\u0448\u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u043A\u044A\u043C \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B."
      },
      emailLink: {
        formHint: "\u041D\u0430 \u0442\u043E\u0437\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u0438\u043C\u0435\u0439\u043B \u0441 \u043B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435.",
        formSubtitle: "\u041A\u043B\u0438\u043A\u043D\u0435\u0442\u0435 \u0432\u044A\u0440\u0445\u0443 \u043B\u0438\u043D\u043A\u0430 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0432 \u0438\u043C\u0435\u0439\u043B\u0430, \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043D\u0430 {{identifier}}",
        formTitle: "\u041B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
        resendButton: "\u041D\u0435 \u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043B\u0438\u043D\u043A? \u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E",
        successMessage: "\u0418\u043C\u0435\u0439\u043B\u044A\u0442 {{identifier}} \u0431\u0435\u0448\u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u043A\u044A\u043C \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0442\u043E\u0437\u0438 \u043F\u0440\u043E\u0444\u0438\u043B.",
        messageLine2: "\u041D\u044F\u043C\u0430 \u0434\u0430 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0432\u043B\u0435\u0437\u0435\u0442\u0435 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0441\u0438, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u043A\u0438 \u0442\u043E\u0437\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441.",
        successMessage: "{{emailAddress}} \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
        title: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441"
      },
      title: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
      verifyTitle: "Verify email address"
    },
    formButtonPrimary__add: "Add",
    formButtonPrimary__continue: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438",
    formButtonPrimary__finish: "\u0417\u0430\u0432\u044A\u0440\u0448\u0438",
    formButtonPrimary__remove: "Remove",
    formButtonPrimary__save: "Save",
    formButtonReset: "\u041E\u0442\u043A\u0430\u0436\u0438",
    mfaPage: {
      formHint: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043C\u0435\u0442\u043E\u0434, \u043A\u043E\u0439\u0442\u043E \u0434\u0430 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u0435.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
    },
    mfaPhoneCodePage: {
      backButton: "Use existing number",
      primaryButton__addPhoneNumber: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440",
      removeResource: {
        messageLine1: "{{identifier}} \u043D\u044F\u043C\u0430 \u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430 \u043F\u043E\u0432\u0435\u0447\u0435 \u043A\u043E\u0434\u043E\u0432\u0435 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0440\u0438 \u0432\u043B\u0438\u0437\u0430\u043D\u0435.",
        messageLine2: "\u0412\u0430\u0448\u0438\u044F\u0442 \u0430\u043A\u0430\u0443\u043D\u0442 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043D\u0435 \u0435 \u0442\u043E\u043B\u043A\u043E\u0432\u0430 \u0441\u0438\u0433\u0443\u0440\u0435\u043D. \u0421\u0438\u0433\u0443\u0440\u043D\u0438 \u043B\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435?",
        successMessage: "\u0414\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435 \u0441 SMS \u043A\u043E\u0434 \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442\u043E \u0437\u0430 {{mfaPhoneCode}}",
        title: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435"
      },
      subtitle__availablePhoneNumbers: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440, \u0437\u0430 \u0434\u0430 \u0441\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u0442\u0435 \u0437\u0430 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435 \u0441 SMS \u043A\u043E\u0434.",
      subtitle__unavailablePhoneNumbers: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u0438 \u043D\u043E\u043C\u0435\u0440\u0430 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0437\u0430 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435 \u0441 SMS \u043A\u043E\u0434.",
      successMessage1: "When signing in, you will need to enter a verification code sent to this phone number as an additional step.",
      successMessage2: "Save these backup codes and store them somewhere safe. If you lose access to your authentication device, you can use backup codes to sign in.",
      successTitle: "SMS code verification enabled",
      title: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 SMS \u043A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439 QR \u043A\u043E\u0434\u0430 \u0432\u043C\u0435\u0441\u0442\u043E \u0442\u043E\u0432\u0430",
        buttonUnableToScan__nonPrimary: "\u041D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u0430 QR \u043A\u043E\u0434\u0430?",
        infoText__ableToScan: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043D\u043E\u0432 \u043C\u0435\u0442\u043E\u0434 \u0437\u0430 \u0432\u043B\u0438\u0437\u0430\u043D\u0435 \u0432\u044A\u0432 \u0432\u0430\u0448\u0438\u044F \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B\u0435\u043D \u0430\u043F\u043B\u0438\u043A\u0430\u0442\u043E\u0440 \u0438 \u0441\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F QR \u043A\u043E\u0434, \u0437\u0430 \u0434\u0430 \u0433\u043E \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441 \u0432\u0430\u0448\u0438\u044F \u0430\u043A\u0430\u0443\u043D\u0442.",
        infoText__unableToScan: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043D\u043E\u0432 \u043C\u0435\u0442\u043E\u0434 \u0437\u0430 \u0432\u043B\u0438\u0437\u0430\u043D\u0435 \u0432\u044A\u0432 \u0432\u0430\u0448\u0438\u044F \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B \u0438 \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0438\u044F \u043F\u043E-\u0434\u043E\u043B\u0443 \u043A\u043B\u044E\u0447.",
        inputLabel__unableToScan1: "\u0423\u0432\u0435\u0440\u0435\u0442\u0435 \u0441\u0435, \u0447\u0435 \u0432\u0440\u0435\u043C\u0435\u0432\u0438\u0442\u0435 \u0438\u043B\u0438 \u0435\u0434\u043D\u043E\u043A\u0440\u0430\u0442\u043D\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u0438 \u0441\u0430 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u0438, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u0437\u0430\u0432\u044A\u0440\u0448\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0430\u043A\u0430\u0443\u043D\u0442.",
        inputLabel__unableToScan2: "\u0410\u043B\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u043E, \u0430\u043A\u043E \u0432\u0430\u0448\u0438\u044F\u0442 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430 TOTP URI, \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u044A\u0449\u043E \u0434\u0430 \u043A\u043E\u043F\u0438\u0440\u0430\u0442\u0435 \u043F\u044A\u043B\u043D\u0438\u044F URI."
      },
      removeResource: {
        messageLine1: "\u041A\u043E\u0434\u043E\u0432\u0435\u0442\u0435 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u0442 \u0442\u043E\u0437\u0438 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B \u0432\u0435\u0447\u0435 \u043D\u044F\u043C\u0430 \u0434\u0430 \u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0438 \u043F\u0440\u0438 \u0432\u043B\u0438\u0437\u0430\u043D\u0435.",
        messageLine2: "\u0412\u0430\u0448\u0438\u044F\u0442 \u0430\u043A\u0430\u0443\u043D\u0442 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043D\u0435 \u0435 \u0442\u043E\u043B\u043A\u043E\u0432\u0430 \u0441\u0438\u0433\u0443\u0440\u0435\u043D. \u0421\u0438\u0433\u0443\u0440\u043D\u0438 \u043B\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435?",
        successMessage: "\u0414\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435 \u0447\u0440\u0435\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435 \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442\u043E.",
        title: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435"
      },
      successMessage: "\u0414\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435 \u0435 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u043E. \u041F\u0440\u0438 \u0432\u043B\u0438\u0437\u0430\u043D\u0435, \u0449\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u0442 \u0442\u043E\u0432\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B\u043D\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043A\u0430\u0442\u043E \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u0441\u0442\u044A\u043F\u043A\u0430.",
      title: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435",
      verifySubtitle: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D \u043E\u0442 \u0432\u0430\u0448\u0435\u0442\u043E \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B\u043D\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
      verifyTitle: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435"
    },
    mobileButton__menu: "\u041C\u0435\u043D\u044E",
    navbar: {
      account: "Profile",
      description: "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0432\u0430\u0439\u0442\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0442\u0430 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0441\u0438.",
      security: "Security",
      title: "\u041F\u0440\u043E\u0444\u0438\u043B"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "It is recommended to sign out of all other devices which may have used your old password.",
      readonly: "\u0412\u0430\u0448\u0430\u0442\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u0432 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u043D\u0430, \u0442\u044A\u0439 \u043A\u0430\u0442\u043E \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0432\u043B\u0438\u0437\u0430\u0442\u0435 \u0441\u0430\u043C\u043E \u0447\u0440\u0435\u0437 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430 \u0432\u0440\u044A\u0437\u043A\u0430.",
      successMessage__set: "\u041F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0432\u0438 \u0431\u0435\u0448\u0435 \u0437\u0430\u0434\u0430\u0434\u0435\u043D\u0430.",
      successMessage__signOutOfOtherSessions: "\u0412\u0441\u0438\u0447\u043A\u0438 \u0434\u0440\u0443\u0433\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u0431\u044F\u0445\u0430 \u0438\u0437\u043B\u0435\u0437\u043B\u0438.",
      successMessage__update: "\u041F\u0430\u0440\u043E\u043B\u0430\u0442\u0430 \u0432\u0438 \u0431\u0435\u0448\u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D\u0430.",
      title__set: "\u0417\u0430\u0434\u0430\u0439 \u043F\u0430\u0440\u043E\u043B\u0430",
      title__update: "\u041F\u0440\u043E\u043C\u0435\u043D\u0438 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430"
    },
    phoneNumberPage: {
      infoText: "\u0421\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u0435, \u0441\u044A\u0434\u044A\u0440\u0436\u0430\u0449\u043E \u043B\u0438\u043D\u043A \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435, \u0449\u0435 \u0431\u044A\u0434\u0435 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u043E \u043D\u0430 \u0442\u043E\u0437\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440.",
      removeResource: {
        messageLine1: "{{identifier}} \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0442\u043E\u0437\u0438 \u043F\u0440\u043E\u0444\u0438\u043B.",
        messageLine2: "\u041D\u044F\u043C\u0430 \u0434\u0430 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0432\u043B\u0435\u0437\u0435\u0442\u0435 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0441\u0438, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u043A\u0438 \u0442\u043E\u0437\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440.",
        successMessage: "{{phoneNumber}} \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
        title: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440"
      },
      successMessage: "{{identifier}} \u0431\u0435\u0448\u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u043A\u044A\u043C \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440",
      verifySubtitle: "Enter the verification code sent to {{identifier}}",
      verifyTitle: "Verify phone number"
    },
    profilePage: {
      fileDropAreaHint: "\u041F\u0440\u0435\u043F\u043E\u0440\u044A\u0447\u0438\u0442\u0435\u043B\u0435\u043D \u0440\u0430\u0437\u043C\u0435\u0440 1:1, \u0434\u043E 10MB.",
      imageFormDestructiveActionSubtitle: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438",
      imageFormSubtitle: "\u041A\u0430\u0447\u0438",
      imageFormTitle: "\u041F\u0440\u043E\u0444\u0438\u043B\u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430",
      readonly: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0442\u0430 \u0432\u0438 \u0437\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u043E\u0442 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u0442\u0430 \u0432\u0440\u044A\u0437\u043A\u0430 \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u043D\u0430.",
      successMessage: "\u0412\u0430\u0448\u0438\u044F\u0442 \u043F\u0440\u043E\u0444\u0438\u043B \u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D.",
      title: "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0418\u0437\u043B\u0435\u0437 \u043E\u0442 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u0442\u043E",
        title: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u041E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E",
        actionLabel__reauthorize: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0438\u0440\u0430\u0439\u0442\u0435 \u0441\u0435\u0433\u0430",
        destructiveActionTitle: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438",
        primaryButton: "\u0421\u0432\u044A\u0440\u0436\u0438 \u0430\u043A\u0430\u0443\u043D\u0442",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "The required scopes have been updated, and you may be experiencing limited functionality. Please re-authorize this application to avoid any issues",
        title: "\u0421\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0430\u043A\u0430\u0443\u043D\u0442\u0438"
      },
      dangerSection: {
        deleteAccountButton: "\u0418\u0437\u0442\u0440\u0438\u0439 \u043F\u0440\u043E\u0444\u0438\u043B\u0430",
        title: "\u041F\u0440\u0435\u043A\u0440\u0430\u0442\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430"
      },
      emailAddressesSection: {
        destructiveAction: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0438\u043C\u0435\u0439\u043B",
        detailsAction__nonPrimary: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u043A\u0430\u0442\u043E \u043E\u0441\u043D\u043E\u0432\u0435\u043D",
        detailsAction__primary: "\u0417\u0430\u0432\u044A\u0440\u0448\u0438 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
        detailsAction__unverified: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435",
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
        title: "\u0418\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441\u0438"
      },
      enterpriseAccountsSection: {
        title: "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0438 \u0430\u043A\u0430\u0443\u043D\u0442\u0438"
      },
      headerTitle__account: "\u041F\u0440\u043E\u0444\u0438\u043B",
      headerTitle__security: "\u0421\u0438\u0433\u0443\u0440\u043D\u043E\u0441\u0442",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u041F\u0440\u0435\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u0439",
          headerTitle: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0438 \u043A\u043E\u0434\u043E\u0432\u0435",
          subtitle__regenerate: "\u0412\u0437\u0435\u043C\u0435\u0442\u0435 \u043D\u043E\u0432 \u043D\u0430\u0431\u043E\u0440 \u043E\u0442 \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438 \u043A\u043E\u0434\u043E\u0432\u0435. \u041F\u0440\u0435\u0434\u0445\u043E\u0434\u043D\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438 \u043A\u043E\u0434\u043E\u0432\u0435 \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u0438\u0437\u0442\u0440\u0438\u0442\u0438 \u0438 \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0438.",
          title__regenerate: "\u041F\u0440\u0435\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u0439 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0438 \u043A\u043E\u0434\u043E\u0432\u0435"
        },
        phoneCode: {
          actionLabel__setDefault: "\u0417\u0430\u0434\u0430\u0439 \u043A\u0430\u0442\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0435\u043D",
          destructiveActionLabel: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438"
        },
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0434\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
        title: "\u0414\u0432\u0443\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u0430 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
        totp: {
          destructiveActionTitle: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438",
          headerTitle: "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043D\u0435"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "\u0417\u0430\u0434\u0430\u0439 \u043F\u0430\u0440\u043E\u043B\u0430",
        primaryButton__updatePassword: "\u041F\u0440\u043E\u043C\u0435\u043D\u0438 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430",
        title: "\u041F\u0430\u0440\u043E\u043B\u0430"
      },
      phoneNumbersSection: {
        destructiveAction: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440",
        detailsAction__nonPrimary: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u043A\u0430\u0442\u043E \u043E\u0441\u043D\u043E\u0432\u0435\u043D",
        detailsAction__primary: "\u0417\u0430\u0432\u044A\u0440\u0448\u0438 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
        detailsAction__unverified: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u0438\u044F \u043D\u043E\u043C\u0435\u0440",
        primaryButton: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440",
        title: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u0438 \u043D\u043E\u043C\u0435\u0440\u0430"
      },
      profileSection: {
        primaryButton: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u0430",
        title: "\u041F\u0440\u043E\u0444\u0438\u043B"
      },
      usernameSection: {
        primaryButton__setUsername: "\u0417\u0430\u0434\u0430\u0439 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435",
        primaryButton__updateUsername: "\u041F\u0440\u043E\u043C\u0435\u043D\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E\u0442\u043E \u0438\u043C\u0435",
        title: "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435"
      },
      web3WalletsSection: {
        destructiveAction: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
        primaryButton: "Web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0438",
        title: "Web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0438"
      }
    },
    usernamePage: {
      successMessage: "\u0412\u0430\u0448\u0435\u0442\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435 \u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u043E.",
      title__set: "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E\u0442\u043E \u0438\u043C\u0435",
      title__update: "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E\u0442\u043E \u0438\u043C\u0435"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u0449\u0435 \u0431\u044A\u0434\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0442\u043E\u0437\u0438 \u043F\u0440\u043E\u0444\u0438\u043B.",
        messageLine2: "\u041D\u044F\u043C\u0430 \u0434\u0430 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0432\u043B\u0435\u0437\u0435\u0442\u0435 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0441\u0438, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u043A\u0438 \u0442\u043E\u0437\u0438 web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B.",
        successMessage: "{{web3Wallet}} \u0431\u0435\u0448\u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442 \u043E\u0442 \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
        title: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B"
      },
      subtitle__availableWallets: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B, \u0437\u0430 \u0434\u0430 \u0433\u043E \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441 \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
      subtitle__unavailableWallets: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0438.",
      successMessage: "\u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u044A\u0442 \u0431\u0435\u0448\u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u043A\u044A\u043C \u0432\u0430\u0448\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B.",
      title: "\u0414\u043E\u0431\u0430\u0432\u0438 web3 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: "Sign up",
      actionText: "Don't have an account?",
      formButton: "Join waitlist",
      subtitle: "Join our waitlist and we'll notify you once we are ready.",
      title: "Join our waitlist"
    },
    success: {
      message: "You have successfully joined the waitlist. We will notify you when access is available.",
      subtitle: "Thank you for your patience.",
      title: "Waitlist successful"
    }
  }
};

// src/th-TH.ts
var thTH = {
  locale: "th-TH",
  backButton: "\u0E01\u0E25\u0E31\u0E1A",
  badge__default: "\u0E04\u0E48\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
  badge__otherImpersonatorDevice: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E1B\u0E25\u0E2D\u0E21\u0E15\u0E31\u0E27\u0E2D\u0E37\u0E48\u0E19",
  badge__primary: "\u0E2B\u0E25\u0E31\u0E01",
  badge__requiresAction: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
  badge__thisDevice: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49",
  badge__unverified: "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
  badge__userDevice: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
  badge__you: "\u0E04\u0E38\u0E13",
  createOrganization: {
    formButtonSubmit: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23",
    invitePage: {
      formButtonReset: "\u0E02\u0E49\u0E32\u0E21"
    },
    title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23"
  },
  dates: {
    lastDay: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32 {{ date | timeString('th-TH') }} \u0E19.",
    next6Days: "{{ date | weekday('th-TH','long') }} \u0E40\u0E27\u0E25\u0E32 {{ date | timeString('th-TH') }} \u0E19.",
    nextDay: "\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32 {{ date | timeString('th-TH') }}",
    numeric: "{{ date | numeric('th-TH') }}",
    previous6Days: "{{ date | weekday('th-TH','long') }}\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32 \u0E40\u0E27\u0E25\u0E32 {{ date | timeString('th-TH') }} \u0E19.",
    sameDay: "\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32 {{ date | timeString('th-TH') }} \u0E19."
  },
  dividerText: "\u0E2B\u0E23\u0E37\u0E2D",
  footerActionLink__useAnotherMethod: "\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19",
  footerPageLink__help: "\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D",
  footerPageLink__privacy: "\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
  footerPageLink__terms: "\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14",
  formButtonPrimary: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
  formButtonPrimary__verify: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
  formFieldAction__forgotPassword: "\u0E25\u0E37\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19?",
  formFieldError__matchingPasswords: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
  formFieldError__notMatchingPasswords: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
  formFieldError__verificationLinkExpired: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E02\u0E2D\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E2B\u0E21\u0E48",
  formFieldHintText__optional: "\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19",
  formFieldHintText__slug: "Slug \u0E40\u0E1B\u0E47\u0E19 ID \u0E17\u0E35\u0E48\u0E2D\u0E48\u0E32\u0E19\u0E44\u0E14\u0E49\u0E41\u0E25\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E19 \u0E21\u0E31\u0E01\u0E43\u0E0A\u0E49\u0E43\u0E19 URLs",
  formFieldInputPlaceholder__backupCode: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
  formFieldInputPlaceholder__emailAddress: "\u0E43\u0E2A\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
  formFieldInputPlaceholder__emailAddress_username: "\u0E43\u0E2A\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
  formFieldInputPlaceholder__emailAddresses: "example@email.com, example2@email.com",
  formFieldInputPlaceholder__firstName: "\u0E0A\u0E37\u0E48\u0E2D",
  formFieldInputPlaceholder__lastName: "\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25",
  formFieldInputPlaceholder__organizationDomain: "example.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "you@example.com",
  formFieldInputPlaceholder__organizationName: "\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23",
  formFieldInputPlaceholder__organizationSlug: "my-org",
  formFieldInputPlaceholder__password: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
  formFieldInputPlaceholder__phoneNumber: "\u0E43\u0E2A\u0E48\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
  formFieldInputPlaceholder__username: "\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
  formFieldLabel__automaticInvitations: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49",
  formFieldLabel__backupCode: "\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07",
  formFieldLabel__confirmDeletion: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
  formFieldLabel__confirmPassword: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
  formFieldLabel__currentPassword: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19",
  formFieldLabel__emailAddress: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
  formFieldLabel__emailAddress_username: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
  formFieldLabel__emailAddresses: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
  formFieldLabel__firstName: "\u0E0A\u0E37\u0E48\u0E2D",
  formFieldLabel__lastName: "\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25",
  formFieldLabel__newPassword: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
  formFieldLabel__organizationDomain: "\u0E42\u0E14\u0E40\u0E21\u0E19",
  formFieldLabel__organizationDomainDeletePending: "\u0E25\u0E1A\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
  formFieldLabel__organizationDomainEmailAddress: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
  formFieldLabel__organizationDomainEmailAddressDescription: "\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E25\u0E30\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19",
  formFieldLabel__organizationName: "\u0E0A\u0E37\u0E48\u0E2D",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C",
  formFieldLabel__password: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
  formFieldLabel__phoneNumber: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
  formFieldLabel__role: "\u0E1A\u0E17\u0E1A\u0E32\u0E17",
  formFieldLabel__signOutOfOtherSessions: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C",
  formFieldLabel__username: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
  impersonationFab: {
    action__signOut: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
    title: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E43\u0E19\u0E10\u0E32\u0E19\u0E30 {{identifier}}"
  },
  maintenanceMode: "\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E40\u0E23\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E23\u0E30\u0E1A\u0E1A \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E07\u0E27\u0E25\u0E44\u0E1B \u0E40\u0E1E\u0E23\u0E32\u0E30\u0E44\u0E21\u0E48\u0E19\u0E48\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E19\u0E32\u0E19\u0E40\u0E01\u0E34\u0E19\u0E01\u0E27\u0E48\u0E32\u0E2A\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E19\u0E32\u0E17\u0E35",
  membershipRole__admin: "\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A",
  membershipRole__basicMember: "\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
  membershipRole__guestMember: "\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21",
  organizationList: {
    action__createOrganization: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23",
    action__invitationAccept: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
    action__suggestionsAccept: "\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
    createOrganization: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23",
    invitationAcceptedLabel: "\u0E44\u0E14\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E25\u0E49\u0E27",
    subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07 {{applicationName}}",
    suggestionsAcceptedLabel: "\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34",
    title: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    titleWithoutPersonal: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23"
  },
  organizationProfile: {
    badge__automaticInvitation: "\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
    badge__automaticSuggestion: "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
    badge__manualInvitation: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
    badge__unverified: "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
    createDomainPage: {
      subtitle: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E14\u0E40\u0E21\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E21\u0E35\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E43\u0E19\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E44\u0E14\u0E49",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E14\u0E40\u0E21\u0E19"
    },
    invitePage: {
      detailsTitle__inviteFailed: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E44\u0E14\u0E49 \u0E21\u0E35\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49: {{email_addresses}}",
      formButtonPrimary__continue: "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D",
      selectDropdown__role: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E17\u0E1A\u0E32\u0E17",
      subtitle: "\u0E43\u0E2A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E32\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 \u0E41\u0E22\u0E01\u0E14\u0E49\u0E27\u0E22\u0E0A\u0E48\u0E2D\u0E07\u0E27\u0E48\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E08\u0E38\u0E25\u0E20\u0E32\u0E04",
      successMessage: "\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
      title: "\u0E40\u0E0A\u0E34\u0E0D\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E43\u0E2B\u0E21\u0E48"
    },
    membersPage: {
      action__invite: "\u0E40\u0E0A\u0E34\u0E0D",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "\u0E25\u0E1A\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
        tableHeader__actions: "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
        tableHeader__joined: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
        tableHeader__role: "\u0E1A\u0E17\u0E1A\u0E32\u0E17",
        tableHeader__user: "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49"
      },
      detailsTitle__emptyRow: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "\u0E40\u0E0A\u0E34\u0E0D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E01\u0E31\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E17\u0E38\u0E01\u0E04\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E14\u0E49\u0E27\u0E22\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D",
          headerTitle: "\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
          primaryButton: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E42\u0E14\u0E40\u0E21\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
        },
        table__emptyRow: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07"
      },
      invitedMembersTab: {
        menuAction__revoke: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D",
        tableHeader__invited: "\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E0A\u0E34\u0E0D"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E14\u0E49\u0E27\u0E22\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19 \u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E2B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E43\u0E19\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
          headerTitle: "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
          primaryButton: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E42\u0E14\u0E40\u0E21\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
        },
        menuAction__approve: "\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34",
        menuAction__reject: "\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18",
        tableHeader__requested: "\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
        table__emptyRow: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E33\u0E02\u0E2D\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07"
      },
      start: {
        headerTitle__invitations: "\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D",
        headerTitle__members: "\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
        headerTitle__requests: "\u0E04\u0E33\u0E02\u0E2D"
      }
    },
    navbar: {
      description: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      general: "\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
      members: "\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
      title: "\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: '\u0E1E\u0E34\u0E21\u0E1E\u0E4C "{{organizationName}}" \u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D',
          messageLine1: "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E19\u0E35\u0E49",
          messageLine2: "\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E17\u0E33\u0E19\u0E35\u0E49\u0E16\u0E32\u0E27\u0E23\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E14\u0E49",
          successMessage: "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E25\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E41\u0E25\u0E49\u0E27",
          title: "\u0E25\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23"
        },
        leaveOrganization: {
          actionDescription: '\u0E1E\u0E34\u0E21\u0E1E\u0E4C "{{organizationName}}" \u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D',
          messageLine1: "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E41\u0E25\u0E30\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E21\u0E31\u0E19",
          messageLine2: "\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E17\u0E33\u0E19\u0E35\u0E49\u0E16\u0E32\u0E27\u0E23\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E14\u0E49",
          successMessage: "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E41\u0E25\u0E49\u0E27",
          title: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23"
        },
        title: "\u0E04\u0E33\u0E40\u0E15\u0E37\u0E2D\u0E19"
      },
      domainSection: {
        menuAction__manage: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23",
        menuAction__remove: "\u0E25\u0E1A",
        menuAction__verify: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
        primaryButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E14\u0E40\u0E21\u0E19",
        subtitle: "\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E15\u0E32\u0E21\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27",
        title: "\u0E42\u0E14\u0E40\u0E21\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A"
      },
      successMessage: "\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27",
      title: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C"
    },
    removeDomainPage: {
      messageLine1: "\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25 {{domain}} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01",
      messageLine2: "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49",
      successMessage: "{{domain}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27",
      title: "\u0E25\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19"
    },
    start: {
      headerTitle__general: "\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
      headerTitle__members: "\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
      profileSection: {
        primaryButton: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
        title: "\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23",
        uploadAction__title: "\u0E42\u0E25\u0E42\u0E01\u0E49"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E0A\u0E34\u0E0D",
        removeDomainActionLabel__remove: "\u0E25\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19",
        removeDomainSubtitle: "\u0E25\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E42\u0E14\u0E40\u0E21\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        removeDomainTitle: "\u0E25\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E0A\u0E34\u0E0D\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E41\u0E25\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D",
        automaticInvitationOption__label: "\u0E40\u0E0A\u0E34\u0E0D\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        automaticSuggestionOption__description: "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E43\u0E2B\u0E49\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 \u0E41\u0E15\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E01\u0E48\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E44\u0E14\u0E49",
        automaticSuggestionOption__label: "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        calloutInfoLabel: "\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E42\u0E2B\u0E21\u0E14\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E43\u0E2B\u0E21\u0E48\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        calloutInvitationCountLabel: "\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49: {{count}}",
        calloutSuggestionCountLabel: "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49: {{count}}",
        manualInvitationOption__description: "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E0A\u0E34\u0E0D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E15\u0E49\u0E2D\u0E07\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E34\u0E0D\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        manualInvitationOption__label: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        subtitle: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E08\u0E32\u0E01\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E44\u0E14\u0E49"
      },
      start: {
        headerTitle__danger: "\u0E2D\u0E31\u0E19\u0E15\u0E23\u0E32\u0E22",
        headerTitle__enrollment: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21"
      },
      subtitle: "\u0E42\u0E14\u0E40\u0E21\u0E19 {{domain}} \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E2B\u0E21\u0E14\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
      title: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15 {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
      subtitle: "\u0E42\u0E14\u0E40\u0E21\u0E19 {{domainName}} \u0E15\u0E49\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
      subtitleVerificationCodeScreen: "\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 {{emailAddress}} \u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E42\u0E14\u0E40\u0E21\u0E19"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23",
    action__invitationAccept: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
    action__manageOrganization: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23",
    action__suggestionsAccept: "\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
    notSelected: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
    personalWorkspace: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25",
    suggestionsAcceptedLabel: "\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34"
  },
  paginationButton__next: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
  paginationButton__previous: "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
  paginationRowText__displaying: "\u0E41\u0E2A\u0E14\u0E07",
  paginationRowText__of: "\u0E08\u0E32\u0E01",
  reverification: {
    alternativeMethods: {
      actionLink: "\u0E02\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D",
      actionText: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E27\u0E34\u0E18\u0E35\u0E43\u0E14\u0E17\u0E35\u0E48\u0E01\u0E25\u0E48\u0E32\u0E27\u0E21\u0E32\u0E2B\u0E23\u0E37\u0E2D?",
      blockButton__backupCode: "\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07",
      blockButton__emailCode: "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25 {{identifier}}",
      blockButton__password: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      blockButton__phoneCode: "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A SMS \u0E44\u0E1B\u0E22\u0E31\u0E07 {{identifier}}",
      blockButton__totp: "\u0E43\u0E0A\u0E49\u0E41\u0E2D\u0E1B\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      getHelp: {
        blockButton__emailSupport: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
        content: "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E16\u0E36\u0E07\u0E40\u0E23\u0E32\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E0A\u0E48\u0E27\u0E22\u0E04\u0E38\u0E13\u0E40\u0E23\u0E35\u0E22\u0E01\u0E04\u0E37\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E42\u0E14\u0E22\u0E40\u0E23\u0E47\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
        title: "\u0E02\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D"
      },
      subtitle: "\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E2B\u0E23\u0E37\u0E2D? \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E43\u0E14\u0E27\u0E34\u0E18\u0E35\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E19\u0E35\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      title: "\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19"
    },
    backupCodeMfa: {
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19",
      title: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07"
    },
    emailCode: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48? \u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    },
    noAvailableMethods: {
      message: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E44\u0E14\u0E49 \u0E44\u0E21\u0E48\u0E21\u0E35\u0E1B\u0E31\u0E08\u0E08\u0E31\u0E22\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E04\u0E48\u0E32",
      subtitle: "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
      title: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49"
    },
    password: {
      actionLink: "\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    },
    phoneCode: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48? \u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    },
    phoneCodeMfa: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48? \u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    },
    totpMfa: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E42\u0E14\u0E22\u0E41\u0E2D\u0E1B\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
      action__signOutAll: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
      subtitle: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35"
    },
    alternativeMethods: {
      actionLink: "\u0E02\u0E2D\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D",
      actionText: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E27\u0E34\u0E18\u0E35\u0E43\u0E14\u0E17\u0E35\u0E48\u0E01\u0E25\u0E48\u0E32\u0E27\u0E21\u0E32\u0E2B\u0E23\u0E37\u0E2D?",
      blockButton__backupCode: "\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07",
      blockButton__emailCode: "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25 {{identifier}}",
      blockButton__emailLink: "\u0E2A\u0E48\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25 {{identifier}}",
      blockButton__passkey: "\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E14\u0E49\u0E27\u0E22\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      blockButton__password: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      blockButton__phoneCode: "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A SMS \u0E44\u0E1B\u0E22\u0E31\u0E07 {{identifier}}",
      blockButton__totp: "\u0E43\u0E0A\u0E49\u0E41\u0E2D\u0E1B\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19",
      getHelp: {
        blockButton__emailSupport: "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
        content: "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E1E\u0E1A\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E16\u0E36\u0E07\u0E40\u0E23\u0E32\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E0A\u0E48\u0E27\u0E22\u0E04\u0E38\u0E13\u0E40\u0E23\u0E35\u0E22\u0E01\u0E04\u0E37\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E42\u0E14\u0E22\u0E40\u0E23\u0E47\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
        title: "\u0E02\u0E2D\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D"
      },
      subtitle: "\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E2B\u0E23\u0E37\u0E2D? \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E43\u0E14\u0E27\u0E34\u0E18\u0E35\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E14\u0E49",
      title: "\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19"
    },
    backupCodeMfa: {
      subtitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E04\u0E37\u0E2D\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19",
      title: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07"
    },
    emailCode: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07 {{applicationName}}",
      title: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D \u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E41\u0E25\u0E30\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49",
        title: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49"
      },
      expired: {
        subtitle: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E14\u0E34\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        title: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E19\u0E35\u0E49\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38"
      },
      failed: {
        subtitle: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E14\u0E34\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        title: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07"
      },
      formSubtitle: "\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      formTitle: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      loading: {
        subtitle: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E40\u0E23\u0E47\u0E27 \u0E46 \u0E19\u0E35\u0E49",
        title: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A..."
      },
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07 {{applicationName}}",
      title: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      unusedTab: {
        title: "\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E1B\u0E34\u0E14\u0E41\u0E17\u0E47\u0E1A\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49"
      },
      verified: {
        subtitle: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E40\u0E23\u0E47\u0E27 \u0E46 \u0E19\u0E35\u0E49",
        title: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
      },
      verifiedSwitchTab: {
        subtitle: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E14\u0E34\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        subtitleNewTab: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E41\u0E17\u0E47\u0E1A\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E2B\u0E21\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        titleNewTab: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E43\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E2D\u0E37\u0E48\u0E19"
      }
    },
    forgotPassword: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      subtitle_email: "\u0E02\u0E31\u0E49\u0E19\u0E41\u0E23\u0E01 \u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 ID \u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      subtitle_phone: "\u0E02\u0E31\u0E49\u0E19\u0E41\u0E23\u0E01 \u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      label__alternativeMethods: "\u0E2B\u0E23\u0E37\u0E2D \u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19",
      title: "\u0E25\u0E37\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19?"
    },
    noAvailableMethods: {
      message: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E14\u0E49 \u0E44\u0E21\u0E48\u0E21\u0E35\u0E1B\u0E31\u0E08\u0E08\u0E31\u0E22\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49",
      subtitle: "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
      title: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E14\u0E49"
    },
    passkey: {
      subtitle: "\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E38\u0E13 \u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E02\u0E2D\u0E25\u0E32\u0E22\u0E19\u0E34\u0E49\u0E27\u0E21\u0E37\u0E2D \u0E43\u0E1A\u0E2B\u0E19\u0E49\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E25\u0E47\u0E2D\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D",
      title: "\u0E43\u0E0A\u0E49\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    password: {
      actionLink: "\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    passwordPwned: {
      title: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E04\u0E22\u0E16\u0E39\u0E01\u0E42\u0E08\u0E23\u0E01\u0E23\u0E23\u0E21"
    },
    phoneCode: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07 {{applicationName}}",
      title: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    phoneCodeMfa: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    resetPassword: {
      formButtonPrimary: "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
      requiredMessage: "\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
      successMessage: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27 \u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48",
      title: "\u0E15\u0E31\u0E49\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48"
    },
    resetPasswordMfa: {
      detailsLabel: "\u0E40\u0E23\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E48\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E08\u0E30\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19"
    },
    start: {
      actionLink: "\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
      actionLink__join_waitlist: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E23\u0E2D",
      actionLink__use_email: "\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25",
      actionLink__use_email_username: "\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
      actionLink__use_passkey: "\u0E43\u0E0A\u0E49\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E41\u0E17\u0E19",
      actionLink__use_phone: "\u0E43\u0E0A\u0E49\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
      actionLink__use_username: "\u0E43\u0E0A\u0E49\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
      actionText: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2B\u0E23\u0E37\u0E2D?",
      actionText__join_waitlist: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E48\u0E2D\u0E19\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
      subtitle: "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E01\u0E25\u0E31\u0E1A! \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      subtitleCombined: void 0,
      title: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A {{applicationName}}",
      titleCombined: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07 {{applicationName}}"
    },
    totpMfa: {
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E42\u0E14\u0E22\u0E41\u0E2D\u0E1B\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19"
    }
  },
  signInEnterPasswordTitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
  signUp: {
    continue: {
      actionLink: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
      actionText: "\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
      subtitle: "\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
      title: "\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E02\u0E32\u0E14\u0E2B\u0E32\u0E22"
    },
    emailCode: {
      formSubtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A? \u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D \u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E41\u0E25\u0E30\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23",
        title: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49"
      },
      formSubtitle: "\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      formTitle: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      loading: {
        title: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01..."
      },
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E25\u0E34\u0E07\u0E01\u0E4C? \u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48",
      subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07 {{applicationName}}",
      title: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      verified: {
        title: "\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
      },
      verifiedSwitchTab: {
        subtitle: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E41\u0E17\u0E47\u0E1A\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E2B\u0E21\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        subtitleNewTab: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E41\u0E17\u0E47\u0E1A\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        title: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: '\u0E09\u0E31\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A {{ privacyPolicyLink || link("\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27") }}',
        label__onlyTermsOfService: '\u0E09\u0E31\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A {{ termsOfServiceLink || link("\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19") }}',
        label__termsOfServiceAndPrivacyPolicy: '\u0E09\u0E31\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A {{ termsOfServiceLink || link("\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19") }} \u0E41\u0E25\u0E30 {{ privacyPolicyLink || link("\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27") }}'
      },
      continue: {
        subtitle: "\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E48\u0E32\u0E19\u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        title: "\u0E01\u0E32\u0E23\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E17\u0E32\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22"
      }
    },
    phoneCode: {
      formSubtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A? \u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48",
      subtitle: "\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    },
    restrictedAccess: {
      actionLink: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
      actionText: "\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
      blockButton__emailSupport: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
      blockButton__joinWaitlist: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E23\u0E2D",
      subtitle: "\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E16\u0E39\u0E01\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E04\u0E27\u0E23\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
      subtitleWaitlist: "\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E16\u0E39\u0E01\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49 \u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E19\u0E41\u0E23\u0E01\u0E17\u0E35\u0E48\u0E23\u0E39\u0E49\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E15\u0E31\u0E27 \u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E23\u0E2D",
      title: "\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E16\u0E39\u0E01\u0E08\u0E33\u0E01\u0E31\u0E14"
    },
    start: {
      actionLink: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
      actionLink__use_email: "\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E41\u0E17\u0E19",
      actionLink__use_phone: "\u0E43\u0E0A\u0E49\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E41\u0E17\u0E19",
      actionText: "\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
      subtitle: "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A! \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
      subtitleCombined: "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A! \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
      title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      titleCombined: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
    }
  },
  socialButtonsBlockButton: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E14\u0E49\u0E27\u0E22 {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} \u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E02\u0E2D\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
    captcha_invalid: "\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E44\u0E21\u0E48\u0E1C\u0E48\u0E32\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    captcha_unavailable: "\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1A\u0E2D\u0E17\u0E44\u0E21\u0E48\u0E1C\u0E48\u0E32\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    form_code_incorrect: "\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    form_identifier_exists__email_address: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E31\u0E19\u0E2D\u0E37\u0E48\u0E19",
    form_identifier_exists__phone_number: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E31\u0E19\u0E2D\u0E37\u0E48\u0E19",
    form_identifier_exists__username: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E31\u0E19\u0E2D\u0E37\u0E48\u0E19",
    form_identifier_not_found: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E21\u0E35\u0E15\u0E31\u0E27\u0E23\u0E30\u0E1A\u0E38\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E30\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    form_param_format_invalid: "\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E30\u0E41\u0E01\u0E49\u0E44\u0E02",
    form_param_format_invalid__email_address: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    form_param_format_invalid__phone_number: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2A\u0E32\u0E01\u0E25\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    form_param_max_length_exceeded__first_name: "\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E19\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E40\u0E01\u0E34\u0E19 256 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
    form_param_max_length_exceeded__last_name: "\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E40\u0E01\u0E34\u0E19 256 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
    form_param_max_length_exceeded__name: "\u0E0A\u0E37\u0E48\u0E2D\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E40\u0E01\u0E34\u0E19 256 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
    form_param_nil: "\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E27\u0E49\u0E19\u0E27\u0E48\u0E32\u0E07\u0E44\u0E14\u0E49",
    form_param_value_invalid: "\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    form_password_incorrect: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E1B\u0E49\u0E2D\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    form_password_length_too_short: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E31\u0E49\u0E19\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 8 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
    form_password_not_strong_enough: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
    form_password_pwned: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E1E\u0E1A\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E31\u0E48\u0E27\u0E44\u0E2B\u0E25\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E2D\u0E37\u0E48\u0E19\u0E41\u0E17\u0E19",
    form_password_pwned__sign_in: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E1E\u0E1A\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E31\u0E48\u0E27\u0E44\u0E2B\u0E25\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    form_password_size_in_bytes_exceeded: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E01\u0E34\u0E19\u0E08\u0E33\u0E19\u0E27\u0E19\u0E44\u0E1A\u0E15\u0E4C\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E14\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E1A\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E1E\u0E34\u0E40\u0E28\u0E29\u0E1A\u0E32\u0E07\u0E15\u0E31\u0E27",
    form_password_validation_failed: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    form_username_invalid_character: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E21\u0E35\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 \u0E41\u0E25\u0E30\u0E02\u0E35\u0E14\u0E25\u0E48\u0E32\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
    form_username_invalid_length: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 {{min_length}} \u0E16\u0E36\u0E07 {{max_length}} \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
    identification_deletion_failed: "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
    not_allowed_access: "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E27\u0E48\u0E32\u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
    organization_domain_blocked: "\u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E14\u0E40\u0E21\u0E19\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E37\u0E48\u0E19",
    organization_domain_common: "\u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E14\u0E40\u0E21\u0E19\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2D\u0E37\u0E48\u0E19",
    organization_domain_exists_for_enterprise_connection: "\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A SSO \u0E02\u0E2D\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    organization_membership_quota_exceeded: "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E16\u0E36\u0E07\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E41\u0E25\u0E49\u0E27 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
    organization_minimum_permissions_needed: "\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E04\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19",
    passkey_already_exists: "\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E16\u0E39\u0E01\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E01\u0E31\u0E1A\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49\u0E41\u0E25\u0E49\u0E27",
    passkey_not_supported: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C",
    passkey_pa_not_supported: "\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E23\u0E30\u0E1A\u0E1A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21 \u0E41\u0E15\u0E48\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A",
    passkey_registration_cancelled: "\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E16\u0E39\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E21\u0E14\u0E40\u0E27\u0E25\u0E32",
    passkey_retrieval_cancelled: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E16\u0E39\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E21\u0E14\u0E40\u0E27\u0E25\u0E32",
    passwordComplexity: {
      maximumLength: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{length}} \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
      minimumLength: "{{length}} \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32",
      requireLowercase: "\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E40\u0E25\u0E47\u0E01",
      requireNumbers: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02",
      requireSpecialCharacter: "\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E1E\u0E34\u0E40\u0E28\u0E29",
      requireUppercase: "\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E2B\u0E0D\u0E48",
      sentencePrefix: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35"
    },
    phone_number_exists: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E2D\u0E37\u0E48\u0E19",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49 \u0E41\u0E15\u0E48\u0E04\u0E27\u0E23\u0E08\u0E30\u0E41\u0E02\u0E47\u0E07\u0E41\u0E01\u0E23\u0E48\u0E07\u0E01\u0E27\u0E48\u0E32\u0E19\u0E35\u0E49 \u0E25\u0E2D\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
      goodPassword: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E15\u0E23\u0E07\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
      notEnough: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
      suggestions: {
        allUppercase: "\u0E43\u0E0A\u0E49\u0E15\u0E31\u0E27\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E2B\u0E0D\u0E48\u0E1A\u0E32\u0E07\u0E15\u0E31\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
        anotherWord: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E33\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E04\u0E48\u0E2D\u0E22\u0E21\u0E35\u0E04\u0E19\u0E43\u0E0A\u0E49\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19",
        associatedYears: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E1B\u0E35\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13",
        capitalization: "\u0E43\u0E0A\u0E49\u0E15\u0E31\u0E27\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E2B\u0E0D\u0E48\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E15\u0E31\u0E27\u0E41\u0E23\u0E01",
        dates: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E30\u0E1B\u0E35\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13",
        l33t: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E17\u0E35\u0E48\u0E04\u0E32\u0E14\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22 \u0E40\u0E0A\u0E48\u0E19 '@' \u0E41\u0E17\u0E19 'a'",
        longerKeyboardPattern: "\u0E43\u0E0A\u0E49\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E01\u0E14\u0E04\u0E35\u0E22\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E17\u0E35\u0E48\u0E22\u0E32\u0E27\u0E02\u0E36\u0E49\u0E19\u0E41\u0E25\u0E30\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E2B\u0E25\u0E32\u0E22\u0E04\u0E23\u0E31\u0E49\u0E07",
        noNeed: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E41\u0E02\u0E47\u0E07\u0E41\u0E01\u0E23\u0E48\u0E07\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E1E\u0E34\u0E40\u0E28\u0E29 \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 \u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E27\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E2B\u0E0D\u0E48",
        pwned: "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E19\u0E35\u0E49\u0E17\u0E35\u0E48\u0E2D\u0E37\u0E48\u0E19 \u0E04\u0E38\u0E13\u0E04\u0E27\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E21\u0E31\u0E19",
        recentYears: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E1B\u0E35\u0E17\u0E35\u0E48\u0E43\u0E01\u0E25\u0E49\u0E40\u0E04\u0E35\u0E22\u0E07",
        repeated: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E04\u0E33\u0E41\u0E25\u0E30\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E17\u0E35\u0E48\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E19",
        reverseWords: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E30\u0E01\u0E14\u0E04\u0E33\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E43\u0E19\u0E17\u0E32\u0E07\u0E01\u0E25\u0E31\u0E1A\u0E01\u0E31\u0E19",
        sequences: "\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
        useWords: "\u0E43\u0E0A\u0E49\u0E2B\u0E25\u0E32\u0E22\u0E04\u0E33 \u0E41\u0E15\u0E48\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E27\u0E25\u0E35\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B"
      },
      warnings: {
        common: "\u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E1E\u0E23\u0E48\u0E2B\u0E25\u0E32\u0E22",
        commonNames: "\u0E0A\u0E37\u0E48\u0E2D\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E41\u0E25\u0E30\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        dates: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        extendedRepeat: '\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E0B\u0E49\u0E33\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E40\u0E0A\u0E48\u0E19 "abcabcabc" \u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22',
        keyPattern: "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E01\u0E14\u0E04\u0E35\u0E22\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E2A\u0E31\u0E49\u0E19 \u0E46 \u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        namesByThemselves: "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E14\u0E35\u0E48\u0E22\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        pwned: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E23\u0E31\u0E48\u0E27\u0E44\u0E2B\u0E25\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E19\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15",
        recentYears: "\u0E1B\u0E35\u0E17\u0E35\u0E48\u0E43\u0E01\u0E25\u0E49\u0E40\u0E04\u0E35\u0E22\u0E07\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        sequences: '\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E40\u0E0A\u0E48\u0E19 "abc" \u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22',
        similarToCommon: "\u0E19\u0E35\u0E49\u0E04\u0E25\u0E49\u0E32\u0E22\u0E01\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E1E\u0E23\u0E48\u0E2B\u0E25\u0E32\u0E22",
        simpleRepeat: '\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E17\u0E35\u0E48\u0E0B\u0E49\u0E33\u0E40\u0E0A\u0E48\u0E19 "aaa" \u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22',
        straightRow: "\u0E41\u0E16\u0E27\u0E15\u0E23\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E35\u0E22\u0E4C\u0E1A\u0E19\u0E04\u0E35\u0E22\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        topHundred: "\u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E1A\u0E48\u0E2D\u0E22",
        topTen: "\u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E21\u0E32\u0E01",
        userInputs: "\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32",
        wordByItself: "\u0E04\u0E33\u0E40\u0E14\u0E35\u0E22\u0E27\u0E40\u0E14\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22"
      }
    }
  },
  userButton: {
    action__addAccount: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    action__manageAccount: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    action__signOut: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
    action__signOutAll: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E17\u0E38\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27!",
      actionLabel__copy: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
      actionLabel__download: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 .txt",
      actionLabel__print: "\u0E1E\u0E34\u0E21\u0E1E\u0E4C",
      infoText1: "\u0E08\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49",
      infoText2: "\u0E40\u0E01\u0E47\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E44\u0E27\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E41\u0E25\u0E30\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E07\u0E2A\u0E31\u0E22\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22",
      subtitle__codelist: "\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E41\u0E25\u0E30\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A",
      successMessage: "\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E44\u0E14\u0E49 \u0E41\u0E15\u0E48\u0E25\u0E30\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27",
      successSubtitle: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E44\u0E14\u0E49",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07",
      title__codelist: "\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07"
    },
    connectedAccountPage: {
      formHint: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      formHint__noAccounts: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E20\u0E32\u0E22\u0E19\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49",
      removeResource: {
        messageLine1: "{{identifier}} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49",
        messageLine2: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E19\u0E35\u0E49\u0E41\u0E25\u0E30\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49",
        successMessage: "{{connectedAccount}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E19\u0E33\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2D\u0E2D\u0E01"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E44\u0E1B\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
    },
    deletePage: {
      actionDescription: '\u0E1E\u0E34\u0E21\u0E1E\u0E4C "Delete account" \u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D',
      confirm: "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
      messageLine1: "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13?",
      messageLine2: "\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E17\u0E33\u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E16\u0E32\u0E27\u0E23\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E14\u0E49",
      title: "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E21\u0E35\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E19\u0E35\u0E49",
        formSubtitle: "\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 {{identifier}}",
        formTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        successMessage: "\u0E2D\u0E35\u0E40\u0E21\u0E25 {{identifier}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27"
      },
      emailLink: {
        formHint: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E21\u0E35\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E19\u0E35\u0E49",
        formSubtitle: "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E43\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 {{identifier}}",
        formTitle: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        resendButton: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E2A\u0E48\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        successMessage: "\u0E2D\u0E35\u0E40\u0E21\u0E25 {{identifier}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27"
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49",
        messageLine2: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        successMessage: "\u0E2D\u0E35\u0E40\u0E21\u0E25 {{emailAddress}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
        title: "\u0E19\u0E33\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E2D\u0E01"
      },
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
      verifyTitle: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25"
    },
    formButtonPrimary__add: "\u0E40\u0E1E\u0E34\u0E48\u0E21",
    formButtonPrimary__continue: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
    formButtonPrimary__finish: "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19",
    formButtonPrimary__remove: "\u0E19\u0E33\u0E2D\u0E2D\u0E01",
    formButtonPrimary__save: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
    formButtonReset: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    mfaPage: {
      formHint: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E34\u0E18\u0E35\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19"
    },
    mfaPhoneCodePage: {
      backButton: "\u0E43\u0E0A\u0E49\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48",
      primaryButton__addPhoneNumber: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
      removeResource: {
        messageLine1: "{{identifier}} \u0E08\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        messageLine2: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E44\u0E21\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E40\u0E17\u0E48\u0E32\u0E17\u0E35\u0E48\u0E04\u0E27\u0E23 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        successMessage: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A SMS \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A {{mfaPhoneCode}}",
        title: "\u0E19\u0E33\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E2D\u0E2D\u0E01"
      },
      subtitle__availablePhoneNumbers: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A SMS \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E43\u0E2B\u0E21\u0E48",
      subtitle__unavailablePhoneNumbers: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A SMS \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E43\u0E2B\u0E21\u0E48",
      successMessage1: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
      successMessage2: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E43\u0E19\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E14\u0E49",
      successTitle: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A SMS",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E14\u0E49\u0E27\u0E22\u0E23\u0E2B\u0E31\u0E2A SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "\u0E2A\u0E41\u0E01\u0E19\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14\u0E41\u0E17\u0E19",
        buttonUnableToScan__nonPrimary: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E41\u0E01\u0E19\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        infoText__ableToScan: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E41\u0E2D\u0E1B\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E2A\u0E41\u0E01\u0E19\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        infoText__unableToScan: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E15\u0E31\u0E27\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E1B\u0E49\u0E2D\u0E19\u0E04\u0E35\u0E22\u0E4C\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E44\u0E27\u0E49\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07",
        inputLabel__unableToScan1: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E15\u0E32\u0E21\u0E40\u0E27\u0E25\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27 \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E08\u0E36\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        inputLabel__unableToScan2: "\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E32\u0E01\u0E15\u0E31\u0E27\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A TOTP URIs \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 URI \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E44\u0E14\u0E49"
      },
      removeResource: {
        messageLine1: "\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E19\u0E35\u0E49\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        messageLine2: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E44\u0E21\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E40\u0E17\u0E48\u0E32\u0E17\u0E35\u0E48\u0E04\u0E27\u0E23 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        successMessage: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E1C\u0E48\u0E32\u0E19\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01",
        title: "\u0E19\u0E33\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E2D\u0E2D\u0E01"
      },
      successMessage: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19",
      verifySubtitle: "\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E42\u0E14\u0E22\u0E23\u0E30\u0E1A\u0E1A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      verifyTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    },
    mobileButton__menu: "\u0E40\u0E21\u0E19\u0E39",
    navbar: {
      account: "\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
      description: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      security: "\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
      title: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49",
        title: "\u0E25\u0E1A\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C"
      },
      subtitle__rename: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19",
      title__rename: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E01\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      readonly: "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
      successMessage__set: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
      successMessage__signOutOfOtherSessions: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E44\u0E14\u0E49\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E2D\u0E01",
      successMessage__update: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15",
      title__set: "\u0E15\u0E31\u0E49\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
      title__update: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19"
    },
    phoneNumberPage: {
      infoText: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E19\u0E35\u0E49 \u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E04\u0E48\u0E32\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      removeResource: {
        messageLine1: "{{identifier}} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49",
        messageLine2: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        successMessage: "{{phoneNumber}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E19\u0E33\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E19\u0E33\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E2D\u0E2D\u0E01"
      },
      successMessage: "{{identifier}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
      verifySubtitle: "\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 {{identifier}}",
      verifyTitle: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C"
    },
    profilePage: {
      fileDropAreaHint: "\u0E41\u0E19\u0E30\u0E19\u0E33\u0E2A\u0E31\u0E14\u0E2A\u0E48\u0E27\u0E19 1:1 \u0E41\u0E25\u0E30 \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 10MB",
      imageFormDestructiveActionSubtitle: "\u0E25\u0E1A",
      imageFormSubtitle: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14",
      imageFormTitle: "\u0E23\u0E39\u0E1B\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
      readonly: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E44\u0E14\u0E49",
      successMessage: "\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27",
      title: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C",
        title: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        actionLabel__reauthorize: "\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49",
        destructiveActionTitle: "\u0E25\u0E1A",
        primaryButton: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
        subtitle__disconnected: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E15\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27",
        subtitle__reauthorize: "\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E30\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E08\u0E33\u0E01\u0E31\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        title: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
      },
      dangerSection: {
        deleteAccountButton: "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
        title: "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35"
      },
      emailAddressesSection: {
        destructiveAction: "\u0E25\u0E1A\u0E2D\u0E35\u0E40\u0E21\u0E25",
        detailsAction__nonPrimary: "\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E31\u0E01",
        detailsAction__primary: "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        detailsAction__unverified: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        primaryButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
        title: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25"
      },
      enterpriseAccountsSection: {
        title: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23"
      },
      headerTitle__account: "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
      headerTitle__security: "\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E21\u0E48",
          headerTitle: "\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07",
          subtitle__regenerate: "\u0E23\u0E31\u0E1A\u0E0A\u0E38\u0E14\u0E43\u0E2B\u0E21\u0E48\u0E02\u0E2D\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49",
          title__regenerate: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48"
        },
        phoneCode: {
          actionLabel__setDefault: "\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E48\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
          destructiveActionLabel: "\u0E25\u0E1A"
        },
        primaryButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19",
        title: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2A\u0E2D\u0E07\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19",
        totp: {
          destructiveActionTitle: "\u0E25\u0E1A",
          headerTitle: "\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19"
        }
      },
      passkeysSection: {
        menuAction__destructive: "\u0E25\u0E1A",
        menuAction__rename: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D",
        primaryButton: void 0,
        title: "\u0E1E\u0E32\u0E2A\u0E04\u0E35\u0E22\u0E4C"
      },
      passwordSection: {
        primaryButton__setPassword: "\u0E15\u0E31\u0E49\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
        primaryButton__updatePassword: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
        title: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19"
      },
      phoneNumbersSection: {
        destructiveAction: "\u0E25\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        detailsAction__nonPrimary: "\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E31\u0E01",
        detailsAction__primary: "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        detailsAction__unverified: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        primaryButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        title: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C"
      },
      profileSection: {
        primaryButton: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
        title: "\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C"
      },
      usernameSection: {
        primaryButton__setUsername: "\u0E15\u0E31\u0E49\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
        primaryButton__updateUsername: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
        title: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49"
      },
      web3WalletsSection: {
        destructiveAction: "\u0E25\u0E1A\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15",
        primaryButton: "\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3",
        title: "\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3"
      }
    },
    usernamePage: {
      successMessage: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27",
      title__set: "\u0E15\u0E31\u0E49\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
      title__update: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E19\u0E35\u0E49",
        messageLine2: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3 \u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E2D\u0E35\u0E01",
        successMessage: "{{web3Wallet}} \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
        title: "\u0E25\u0E1A\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3"
      },
      subtitle__availableWallets: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      subtitle__unavailableWallets: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3 \u0E17\u0E35\u0E48\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
      successMessage: "\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E44\u0E1B\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15 Web3",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
      actionText: "\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
      formButton: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E23\u0E2D",
      subtitle: "\u0E43\u0E2A\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E41\u0E08\u0E49\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E17\u0E23\u0E32\u0E1A\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1E\u0E23\u0E49\u0E2D\u0E21",
      title: "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E23\u0E2D"
    },
    success: {
      message: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E43\u0E19\u0E44\u0E21\u0E48\u0E0A\u0E49\u0E32...",
      subtitle: "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1E\u0E23\u0E49\u0E2D\u0E21",
      title: "\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E23\u0E2D!"
    }
  }
};

// src/ca-ES.ts
var caES = {
  locale: "ca-ES",
  backButton: "Enrere",
  badge__default: "Per defecte",
  badge__otherImpersonatorDevice: "Un altre dispositiu impostor",
  badge__primary: "Principal",
  badge__requiresAction: "Requereix acci\xF3",
  badge__thisDevice: "Aquest dispositiu",
  badge__unverified: "No verificat",
  badge__userDevice: "Dispositiu de l'usuari",
  badge__you: "Tu",
  createOrganization: {
    formButtonSubmit: "Crea organitzaci\xF3",
    invitePage: {
      formButtonReset: "Omet"
    },
    title: "Crea organitzaci\xF3"
  },
  dates: {
    lastDay: "Ahir a les {{ date | timeString('en-US') }}",
    next6Days: "{{ date | weekday('en-US','long') }} a les {{ date | timeString('en-US') }}",
    nextDay: "Dem\xE0 a les {{ date | timeString('en-US') }}",
    numeric: "{{ date | numeric('en-US') }}",
    previous6Days: "El darrer {{ date | weekday('en-US','long') }} a les {{ date | timeString('en-US') }}",
    sameDay: "Avui a les {{ date | timeString('en-US') }}"
  },
  dividerText: "o",
  footerActionLink__useAnotherMethod: "Utilitza un altre m\xE8tode",
  footerPageLink__help: "Ajuda",
  footerPageLink__privacy: "Privacitat",
  footerPageLink__terms: "Termes",
  formButtonPrimary: "Continua",
  formButtonPrimary__verify: "Verifica",
  formFieldAction__forgotPassword: "Has oblidat la contrasenya?",
  formFieldError__matchingPasswords: "Les contrasenyes coincideixen.",
  formFieldError__notMatchingPasswords: "Les contrasenyes no coincideixen.",
  formFieldError__verificationLinkExpired: "L'enlla\xE7 de verificaci\xF3 ha caducat. Si us plau, sol\xB7licita un nou enlla\xE7.",
  formFieldHintText__optional: "Opcional",
  formFieldHintText__slug: "Un slug \xE9s un ID llegible per humans que ha de ser \xFAnic. Sovint s'utilitza en URL.",
  formFieldInputPlaceholder__backupCode: "Codi de seguretat",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Eliminar compte",
  formFieldInputPlaceholder__emailAddress: "exemple@correu.com",
  formFieldInputPlaceholder__emailAddress_username: "exemple@correu.com o nom d'usuari",
  formFieldInputPlaceholder__emailAddresses: "exemple@correu.com, exemple2@correu.com",
  formFieldInputPlaceholder__firstName: "Nom",
  formFieldInputPlaceholder__lastName: "Cognoms",
  formFieldInputPlaceholder__organizationDomain: "exemple.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress: "contacte@exemple.com",
  formFieldInputPlaceholder__organizationName: "Nom de l'organitzaci\xF3",
  formFieldInputPlaceholder__organizationSlug: "la-meva-org",
  formFieldInputPlaceholder__password: "Contrasenya",
  formFieldInputPlaceholder__phoneNumber: "N\xFAmero de tel\xE8fon",
  formFieldInputPlaceholder__username: "Nom d'usuari",
  formFieldLabel__automaticInvitations: "Activa invitacions autom\xE0tiques per a aquest domini",
  formFieldLabel__backupCode: "Codi de seguretat",
  formFieldLabel__confirmDeletion: "Confirmaci\xF3",
  formFieldLabel__confirmPassword: "Confirma la contrasenya",
  formFieldLabel__currentPassword: "Contrasenya actual",
  formFieldLabel__emailAddress: "Adre\xE7a de correu electr\xF2nic",
  formFieldLabel__emailAddress_username: "Adre\xE7a de correu electr\xF2nic o nom d'usuari",
  formFieldLabel__emailAddresses: "Adreces de correu electr\xF2nic",
  formFieldLabel__firstName: "Nom",
  formFieldLabel__lastName: "Cognoms",
  formFieldLabel__newPassword: "Nova contrasenya",
  formFieldLabel__organizationDomain: "Domini",
  formFieldLabel__organizationDomainDeletePending: "Elimina invitacions pendents i suggeriments",
  formFieldLabel__organizationDomainEmailAddress: "Adre\xE7a de correu electr\xF2nic de verificaci\xF3",
  formFieldLabel__organizationDomainEmailAddressDescription: "Introdueix una adre\xE7a de correu electr\xF2nic sota aquest domini per rebre un codi i verificar aquest domini.",
  formFieldLabel__organizationName: "Nom",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: void 0,
  formFieldLabel__password: "Contrasenya",
  formFieldLabel__phoneNumber: "N\xFAmero de tel\xE8fon",
  formFieldLabel__role: "Rol",
  formFieldLabel__signOutOfOtherSessions: "Tanca la sessi\xF3 de tots els altres dispositius",
  formFieldLabel__username: "Nom d'usuari",
  impersonationFab: {
    action__signOut: "Tanca la sessi\xF3",
    title: "Connectat com a {{identifier}}"
  },
  maintenanceMode: void 0,
  membershipRole__admin: "Administrador",
  membershipRole__basicMember: "Membre",
  membershipRole__guestMember: "Convidat",
  organizationList: {
    action__createOrganization: "Crea organitzaci\xF3",
    action__invitationAccept: "Uneix-te",
    action__suggestionsAccept: "Sol\xB7licita unir-te",
    createOrganization: "Crea Organitzaci\xF3",
    invitationAcceptedLabel: "Unit",
    subtitle: "per continuar a {{applicationName}}",
    suggestionsAcceptedLabel: "Aprovaci\xF3 pendent",
    title: "Trieu un compte",
    titleWithoutPersonal: "Trieu una organitzaci\xF3"
  },
  organizationProfile: {
    badge__automaticInvitation: "Invitacions autom\xE0tiques",
    badge__automaticSuggestion: "Suggeriments autom\xE0tics",
    badge__manualInvitation: "Sense inscripci\xF3 autom\xE0tica",
    badge__unverified: "No verificat",
    createDomainPage: {
      subtitle: "Afegeix el domini per verificar. Els usuaris amb adreces de correu electr\xF2nic en aquest domini poden unir-se a l'organitzaci\xF3 autom\xE0ticament o sol\xB7licitar unir-se.",
      title: "Afegeix domini"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Les invitacions no s'han pogut enviar. Ja hi ha invitacions pendents per a les seg\xFCents adreces de correu electr\xF2nic: {{email_addresses}}.",
      formButtonPrimary__continue: "Envia invitacions",
      selectDropdown__role: "Selecciona rol",
      subtitle: "Introdueix o enganxa una o m\xE9s adreces de correu electr\xF2nic, separades per espais o comes.",
      successMessage: "Les invitacions s'han enviat correctament",
      title: "Convida nous membres"
    },
    membersPage: {
      action__invite: "Convida",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Elimina membre",
        tableHeader__actions: void 0,
        tableHeader__joined: "Unit",
        tableHeader__role: "Rol",
        tableHeader__user: "Usuari"
      },
      detailsTitle__emptyRow: "No hi ha membres per mostrar",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Convida usuaris connectant un domini de correu electr\xF2nic amb la teva organitzaci\xF3. Qualsevol que es registri amb un domini de correu electr\xF2nic coincident podr\xE0 unir-se a l'organitzaci\xF3 en qualsevol moment.",
          headerTitle: "Invitacions autom\xE0tiques",
          primaryButton: "Gestiona dominis verificats"
        },
        table__emptyRow: "No hi ha invitacions per mostrar"
      },
      invitedMembersTab: {
        menuAction__revoke: "Revoca invitaci\xF3",
        tableHeader__invited: "Convidat"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Els usuaris que es registren amb un domini de correu electr\xF2nic coincident, podran veure una sugger\xE8ncia per sol\xB7licitar unir-se a la teva organitzaci\xF3.",
          headerTitle: "Suggeriments autom\xE0tics",
          primaryButton: "Gestiona dominis verificats"
        },
        menuAction__approve: "Aprova",
        menuAction__reject: "Rebutja",
        tableHeader__requested: "Acc\xE9s sol\xB7licitat",
        table__emptyRow: "No hi ha sol\xB7licituds per mostrar"
      },
      start: {
        headerTitle__invitations: "Invitacions",
        headerTitle__members: "Membres",
        headerTitle__requests: "Sol\xB7licituds"
      }
    },
    navbar: {
      description: "Gestiona la teva organitzaci\xF3.",
      general: "General",
      members: "Membres",
      title: "Organitzaci\xF3"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Escriu "{{organizationName}}" a continuaci\xF3 per continuar.',
          messageLine1: "Est\xE0s segur que vols eliminar aquesta organitzaci\xF3?",
          messageLine2: "Aquesta acci\xF3 \xE9s permanent i irreversible.",
          successMessage: "Has eliminat l'organitzaci\xF3.",
          title: "Elimina organitzaci\xF3"
        },
        leaveOrganization: {
          actionDescription: 'Escriu "{{organizationName}}" a continuaci\xF3 per continuar.',
          messageLine1: "Est\xE0s segur que vols deixar aquesta organitzaci\xF3? Perdr\xE0s l'acc\xE9s a aquesta organitzaci\xF3 i les seves aplicacions.",
          messageLine2: "Aquesta acci\xF3 \xE9s permanent i irreversible.",
          successMessage: "Has deixat l'organitzaci\xF3.",
          title: "Deixa organitzaci\xF3"
        },
        title: "Perill"
      },
      domainSection: {
        menuAction__manage: "Gestiona",
        menuAction__remove: "Elimina",
        menuAction__verify: "Verifica",
        primaryButton: "Afegeix domini",
        subtitle: "Permet als usuaris unir-se a l'organitzaci\xF3 autom\xE0ticament o sol\xB7licitar unir-se basant-se en un domini de correu electr\xF2nic verificat.",
        title: "Dominis verificats"
      },
      successMessage: "L'organitzaci\xF3 s'ha actualitzat.",
      title: "Actualitza perfil"
    },
    removeDomainPage: {
      messageLine1: "El domini de correu electr\xF2nic {{domain}} ser\xE0 eliminat.",
      messageLine2: "Els usuaris ja no podran unir-se a l'organitzaci\xF3 autom\xE0ticament despr\xE9s d'aix\xF2.",
      successMessage: "{{domain}} ha estat eliminat.",
      title: "Elimina domini"
    },
    start: {
      headerTitle__general: "General",
      headerTitle__members: "Membres",
      profileSection: {
        primaryButton: "Actualitza perfil",
        title: "Perfil de l'Organitzaci\xF3",
        uploadAction__title: "Logotip"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Eliminar aquest domini afectar\xE0 els usuaris convidats.",
        removeDomainActionLabel__remove: "Elimina domini",
        removeDomainSubtitle: "Elimina aquest domini dels teus dominis verificats",
        removeDomainTitle: "Elimina domini"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Els usuaris s\xF3n convidats autom\xE0ticament a unir-se a l'organitzaci\xF3 quan es registren i poden unir-se en qualsevol moment.",
        automaticInvitationOption__label: "Invitacions autom\xE0tiques",
        automaticSuggestionOption__description: "Els usuaris reben una sugger\xE8ncia per sol\xB7licitar unir-se, per\xF2 ha de ser aprovat per un administrador abans de poder-se unir a l'organitzaci\xF3.",
        automaticSuggestionOption__label: "Suggeriments autom\xE0tics",
        calloutInfoLabel: "Canviar el mode d'inscripci\xF3 nom\xE9s afectar\xE0 els nous usuaris.",
        calloutInvitationCountLabel: "Invitacions pendents enviades a usuaris: {{count}}",
        calloutSuggestionCountLabel: "Suggeriments pendents enviats a usuaris: {{count}}",
        manualInvitationOption__description: "Els usuaris nom\xE9s poden ser convidats manualment a l'organitzaci\xF3.",
        manualInvitationOption__label: "Sense inscripci\xF3 autom\xE0tica",
        subtitle: "Trieu com els usuaris d'aquest domini poden unir-se a l'organitzaci\xF3."
      },
      start: {
        headerTitle__danger: "Perill",
        headerTitle__enrollment: "Opcions d'inscripci\xF3"
      },
      subtitle: "El domini {{domain}} ara est\xE0 verificat. Continua seleccionant el mode d'inscripci\xF3.",
      title: "Actualitza {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Introdueix el codi de verificaci\xF3 enviat al teu correu electr\xF2nic",
      formTitle: "Codi de verificaci\xF3",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "El domini {{domainName}} necessita ser verificat via correu electr\xF2nic.",
      subtitleVerificationCodeScreen: "S'ha enviat un codi de verificaci\xF3 a {{emailAddress}}. Introdueix el codi per continuar.",
      title: "Verifica domini"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Crea organitzaci\xF3",
    action__invitationAccept: "Uneix-te",
    action__manageOrganization: "Gestiona",
    action__suggestionsAccept: "Sol\xB7licita unir-te",
    notSelected: "No s'ha seleccionat cap organitzaci\xF3",
    personalWorkspace: "Compte personal",
    suggestionsAcceptedLabel: "Aprovaci\xF3 pendent"
  },
  paginationButton__next: "Seg\xFCent",
  paginationButton__previous: "Anterior",
  paginationRowText__displaying: "Mostrant",
  paginationRowText__of: "de",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Afegeix compte",
      action__signOutAll: "Tanca la sessi\xF3 de tots els comptes",
      subtitle: "Selecciona el compte amb el qual vols continuar.",
      title: "Trieu un compte"
    },
    alternativeMethods: {
      actionLink: "Obt\xE9n ajuda",
      actionText: "No tens cap d'aquests?",
      blockButton__backupCode: "Utilitza un codi de seguretat",
      blockButton__emailCode: "Envia codi per correu electr\xF2nic a {{identifier}}",
      blockButton__emailLink: "Envia enlla\xE7 per correu electr\xF2nic a {{identifier}}",
      blockButton__passkey: void 0,
      blockButton__password: "Inicia sessi\xF3 amb la teva contrasenya",
      blockButton__phoneCode: "Envia codi SMS a {{identifier}}",
      blockButton__totp: "Utilitza la teva aplicaci\xF3 d'autenticaci\xF3",
      getHelp: {
        blockButton__emailSupport: "Suport per correu electr\xF2nic",
        content: "Si tens dificultats per iniciar sessi\xF3 al teu compte, envia'ns un correu electr\xF2nic i treballarem amb tu per restaurar l'acc\xE9s tan aviat com sigui possible.",
        title: "Obt\xE9n ajuda"
      },
      subtitle: "Tens problemes? Pots utilitzar qualsevol d'aquests m\xE8todes per iniciar sessi\xF3.",
      title: "Utilitza un altre m\xE8tode"
    },
    backupCodeMfa: {
      subtitle: "El teu codi de seguretat \xE9s el que vas obtenir quan vas configurar l'autenticaci\xF3 de dos passos.",
      title: "Introdueix un codi de seguretat"
    },
    emailCode: {
      formTitle: "Codi de verificaci\xF3",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "per continuar a {{applicationName}}",
      title: "Comprova el teu correu electr\xF2nic"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "Torna a la pestanya original per continuar.",
        title: "Aquest enlla\xE7 de verificaci\xF3 ha caducat"
      },
      failed: {
        subtitle: "Torna a la pestanya original per continuar.",
        title: "Aquest enlla\xE7 de verificaci\xF3 no \xE9s v\xE0lid"
      },
      formSubtitle: "Utilitza l'enlla\xE7 de verificaci\xF3 enviat al teu correu electr\xF2nic",
      formTitle: "Enlla\xE7 de verificaci\xF3",
      loading: {
        subtitle: "Ser\xE0s redirigit aviat",
        title: "Iniciant sessi\xF3..."
      },
      resendButton: "No has rebut l'enlla\xE7? Reenvia",
      subtitle: "per continuar a {{applicationName}}",
      title: "Comprova el teu correu electr\xF2nic",
      unusedTab: {
        title: "Pots tancar aquesta pestanya"
      },
      verified: {
        subtitle: "Ser\xE0s redirigit aviat",
        title: "Has iniciat sessi\xF3 amb \xE8xit"
      },
      verifiedSwitchTab: {
        subtitle: "Torna a la pestanya original per continuar",
        subtitleNewTab: "Torna a la pestanya recentment oberta per continuar",
        titleNewTab: "S'ha iniciat sessi\xF3 en una altra pestanya"
      }
    },
    forgotPassword: {
      formTitle: "Codi de restabliment de contrasenya",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "per restablir la teva contrasenya",
      subtitle_email: "Primer, introdueix el codi enviat al teu ID de correu electr\xF2nic",
      subtitle_phone: "Primer, introdueix el codi enviat al teu tel\xE8fon",
      title: "Restableix la contrasenya"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Restableix la teva contrasenya",
      label__alternativeMethods: "O b\xE9, inicia sessi\xF3 amb un altre m\xE8tode",
      title: "Has oblidat la contrasenya?"
    },
    noAvailableMethods: {
      message: "No es pot procedir amb l'inici de sessi\xF3. No hi ha cap factor d'autenticaci\xF3 disponible.",
      subtitle: "S'ha produ\xEFt un error",
      title: "No es pot iniciar sessi\xF3"
    },
    passkey: {
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: "Utilitza un altre m\xE8tode",
      subtitle: "Introdueix la contrasenya associada al teu compte",
      title: "Introdueix la teva contrasenya"
    },
    passwordPwned: {
      title: void 0
    },
    phoneCode: {
      formTitle: "Codi de verificaci\xF3",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "per continuar a {{applicationName}}",
      title: "Comprova el teu tel\xE8fon"
    },
    phoneCodeMfa: {
      formTitle: "Codi de verificaci\xF3",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "Per continuar, introdueix el codi de verificaci\xF3 enviat al teu tel\xE8fon",
      title: "Comprova el teu tel\xE8fon"
    },
    resetPassword: {
      formButtonPrimary: "Restableix la contrasenya",
      requiredMessage: "Ja existeix un compte amb una adre\xE7a de correu electr\xF2nic no verificada. Si us plau, restableix la teva contrasenya per seguretat.",
      successMessage: "La teva contrasenya s'ha canviat amb \xE8xit. Iniciant sessi\xF3, espera un moment.",
      title: "Estableix una nova contrasenya"
    },
    resetPasswordMfa: {
      detailsLabel: "Necessitem verificar la teva identitat abans de restablir la teva contrasenya."
    },
    start: {
      actionLink: "Registra't",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Utilitza correu electr\xF2nic",
      actionLink__use_email_username: "Utilitza correu electr\xF2nic o nom d'usuari",
      actionLink__use_passkey: void 0,
      actionLink__use_phone: "Utilitza tel\xE8fon",
      actionLink__use_username: "Utilitza nom d'usuari",
      actionText: "No tens un compte?",
      actionText__join_waitlist: void 0,
      subtitle: "Benvingut de nou! Si us plau, inicia sessi\xF3 per continuar",
      subtitleCombined: void 0,
      title: "Inicia sessi\xF3 a {{applicationName}}",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Codi de verificaci\xF3",
      subtitle: "Per continuar, introdueix el codi de verificaci\xF3 generat per la teva aplicaci\xF3 d'autenticaci\xF3",
      title: "Verificaci\xF3 de dos passos"
    }
  },
  signInEnterPasswordTitle: "Introdueix la teva contrasenya",
  signUp: {
    continue: {
      actionLink: "Inicia sessi\xF3",
      actionText: "Ja tens un compte?",
      subtitle: "Si us plau, completa els detalls restants per continuar.",
      title: "Completa els camps que falten"
    },
    emailCode: {
      formSubtitle: "Introdueix el codi de verificaci\xF3 enviat a la teva adre\xE7a de correu electr\xF2nic",
      formTitle: "Codi de verificaci\xF3",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "Introdueix el codi de verificaci\xF3 enviat al teu correu",
      title: "Verifica el teu correu electr\xF2nic"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "Utilitza l'enlla\xE7 de verificaci\xF3 enviat a la teva adre\xE7a de correu electr\xF2nic",
      formTitle: "Enlla\xE7 de verificaci\xF3",
      loading: {
        title: "Registrant..."
      },
      resendButton: "No has rebut l'enlla\xE7? Reenvia",
      subtitle: "per continuar a {{applicationName}}",
      title: "Verifica el teu correu electr\xF2nic",
      verified: {
        title: "Registre completat amb \xE8xit"
      },
      verifiedSwitchTab: {
        subtitle: "Torna a la pestanya recentment oberta per continuar",
        subtitleNewTab: "Torna a la pestanya anterior per continuar",
        title: "Correu electr\xF2nic verificat amb \xE8xit"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Introdueix el codi de verificaci\xF3 enviat al teu n\xFAmero de tel\xE8fon",
      formTitle: "Codi de verificaci\xF3",
      resendButton: "No has rebut el codi? Reenvia",
      subtitle: "Introdueix el codi de verificaci\xF3 enviat al teu tel\xE8fon",
      title: "Verifica el teu tel\xE8fon"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Inicia sessi\xF3",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "Ja tens un compte?",
      subtitle: "Benvingut! Si us plau, completa els detalls per comen\xE7ar.",
      subtitleCombined: "Benvingut! Si us plau, completa els detalls per comen\xE7ar.",
      title: "Crea el teu compte",
      titleCombined: "Crea el teu compte"
    }
  },
  socialButtonsBlockButton: "Continua amb {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "El registre no ha estat exit\xF3s a causa de validacions de seguretat fallides. Si us plau, actualitza la p\xE0gina per tornar-ho a intentar o posa't en contacte amb el suport per obtenir m\xE9s assist\xE8ncia.",
    captcha_unavailable: "El registre no ha estat exit\xF3s a causa de la validaci\xF3 fallida de bot. Si us plau, actualitza la p\xE0gina per tornar-ho a intentar o posa't en contacte amb el suport per obtenir m\xE9s assist\xE8ncia.",
    form_code_incorrect: "El codi introdu\xEFt no \xE9s v\xE0lid. Si us plau, comprova el codi i torna-ho a intentar.",
    form_identifier_exists__email_address: void 0,
    form_identifier_exists__phone_number: void 0,
    form_identifier_exists__username: void 0,
    form_identifier_not_found: "No s'ha trobat cap identificador coincident. Si us plau, comprova el valor introdu\xEFt.",
    form_param_format_invalid: "Format de par\xE0metre no v\xE0lid.",
    form_param_format_invalid__email_address: "L'adre\xE7a de correu electr\xF2nic ha de ser una adre\xE7a v\xE0lida.",
    form_param_format_invalid__phone_number: "El n\xFAmero de tel\xE8fon ha de tenir un format internacional v\xE0lid.",
    form_param_max_length_exceeded__first_name: "El nom no ha de superar els 256 car\xE0cters.",
    form_param_max_length_exceeded__last_name: "Els cognoms no han de superar els 256 car\xE0cters.",
    form_param_max_length_exceeded__name: "El nom no ha de superar els 256 car\xE0cters.",
    form_param_nil: "El valor del camp no pot ser nul. Si us plau, completa aquest camp.",
    form_param_value_invalid: void 0,
    form_password_incorrect: "La contrasenya introdu\xEFda \xE9s incorrecta.",
    form_password_length_too_short: "La teva contrasenya ha de tenir almenys 8 car\xE0cters.",
    form_password_not_strong_enough: "La teva contrasenya no \xE9s prou forta.",
    form_password_pwned: "Aquesta contrasenya ha aparegut en una filtraci\xF3 i no es pot utilitzar, si us plau, prova una altra contrasenya.",
    form_password_pwned__sign_in: void 0,
    form_password_size_in_bytes_exceeded: "La teva contrasenya ha superat el nombre m\xE0xim de bytes permesos, si us plau, redueix-la o elimina alguns car\xE0cters especials.",
    form_password_validation_failed: "Contrasenya incorrecta",
    form_username_invalid_character: "El nom d'usuari cont\xE9 car\xE0cters no v\xE0lids.",
    form_username_invalid_length: "El nom d'usuari ha de tenir entre 3 i 50 car\xE0cters.",
    identification_deletion_failed: "No pots eliminar la teva \xFAltima identificaci\xF3.",
    not_allowed_access: "No tens perm\xEDs per accedir a aquesta p\xE0gina. Si us plau, posa't en contacte amb el suport.",
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: void 0,
    passkey_not_supported: void 0,
    passkey_pa_not_supported: void 0,
    passkey_registration_cancelled: void 0,
    passkey_retrieval_cancelled: void 0,
    passwordComplexity: {
      maximumLength: "menys de {{length}} car\xE0cters",
      minimumLength: "{{length}} o m\xE9s car\xE0cters",
      requireLowercase: "una lletra min\xFAscula",
      requireNumbers: "un n\xFAmero",
      requireSpecialCharacter: "un car\xE0cter especial",
      requireUppercase: "una lletra maj\xFAscula",
      sentencePrefix: "La teva contrasenya ha de contenir"
    },
    phone_number_exists: "Aquest n\xFAmero de tel\xE8fon ja est\xE0 en \xFAs. Si us plau, prova'n un altre.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "La teva contrasenya funciona, per\xF2 podria ser m\xE9s forta. Prova afegint m\xE9s car\xE0cters.",
      goodPassword: "La teva contrasenya compleix tots els requisits necessaris.",
      notEnough: "La teva contrasenya no \xE9s prou forta.",
      suggestions: {
        allUppercase: "Capitalitza algunes, per\xF2 no totes les lletres.",
        anotherWord: "Afegeix m\xE9s paraules que siguin menys comunes.",
        associatedYears: "Evita anys que estiguin associats amb tu.",
        capitalization: "Capitalitza m\xE9s que la primera lletra.",
        dates: "Evita dates i anys que estiguin associats amb tu.",
        l33t: "Evita substitucions de lletres previsibles com '@' per 'a'.",
        longerKeyboardPattern: "Utilitza patrons de teclat m\xE9s llargs i canvia la direcci\xF3 de la tipografia diverses vegades.",
        noNeed: "Pots crear contrasenyes fortes sense utilitzar s\xEDmbols, n\xFAmeros o lletres maj\xFAscules.",
        pwned: "Si utilitzes aquesta contrasenya en un altre lloc, hauries de canviar-la.",
        recentYears: "Evita anys recents.",
        repeated: "Evita paraules i car\xE0cters repetits.",
        reverseWords: "Evita ortografies invertides de paraules comunes.",
        sequences: "Evita seq\xFC\xE8ncies de car\xE0cters comuns.",
        useWords: "Utilitza diverses paraules, per\xF2 evita frases comunes."
      },
      warnings: {
        common: "Aquesta \xE9s una contrasenya molt utilitzada.",
        commonNames: "Els noms i cognoms comuns s\xF3n f\xE0cils d'endevinar.",
        dates: "Les dates s\xF3n f\xE0cils d'endevinar.",
        extendedRepeat: `Els patrons de car\xE0cters repetits com "abcabcabc" s\xF3n f\xE0cils d'endevinar.`,
        keyPattern: "Els patrons curts de teclat s\xF3n f\xE0cils d'endevinar.",
        namesByThemselves: "Els noms o cognoms sols s\xF3n f\xE0cils d'endevinar.",
        pwned: "La teva contrasenya va ser exposada per una violaci\xF3 de dades a Internet.",
        recentYears: "Els anys recents s\xF3n f\xE0cils d'endevinar.",
        sequences: `Les seq\xFC\xE8ncies de car\xE0cters comuns com "abc" s\xF3n f\xE0cils d'endevinar.`,
        similarToCommon: "Aix\xF2 \xE9s similar a una contrasenya molt utilitzada.",
        simpleRepeat: `Els car\xE0cters repetits com "aaa" s\xF3n f\xE0cils d'endevinar.`,
        straightRow: "Les files rectes de tecles del teclat s\xF3n f\xE0cils d'endevinar.",
        topHundred: "Aquesta \xE9s una contrasenya molt utilitzada.",
        topTen: "Aquesta \xE9s una contrasenya altament utilitzada.",
        userInputs: "No hi hauria de tenir cap dada personal ni relacionada amb la p\xE0gina.",
        wordByItself: "Les paraules soles s\xF3n f\xE0cils d'endevinar."
      }
    }
  },
  userButton: {
    action__addAccount: "Afegeix compte",
    action__manageAccount: "Gestiona compte",
    action__signOut: "Tanca sessi\xF3",
    action__signOutAll: "Tanca sessi\xF3 de tots els comptes"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Copiat!",
      actionLabel__copy: "Copia tot",
      actionLabel__download: "Descarrega .txt",
      actionLabel__print: "Imprimeix",
      infoText1: "Els codis de seguretat s'activaran per a aquest compte.",
      infoText2: "Guarda els codis de seguretat en secret i emmagatzema'ls de manera segura. Pots regenerar els codis de seguretat si sospites que han estat compromesos.",
      subtitle__codelist: "Emmagatzema'ls de manera segura i mantingues-los en secret.",
      successMessage: "Ara els codis de seguretat estan activats. Pots utilitzar un d'aquests per iniciar sessi\xF3 al teu compte, si perds l'acc\xE9s al teu dispositiu d'autenticaci\xF3. Cada codi nom\xE9s es pot utilitzar una vegada.",
      successSubtitle: "Pots utilitzar un d'aquests per iniciar sessi\xF3 al teu compte, si perds l'acc\xE9s al teu dispositiu d'autenticaci\xF3.",
      title: "Afegeix verificaci\xF3 amb codi de seguretat",
      title__codelist: "Codis de seguretat"
    },
    connectedAccountPage: {
      formHint: "Selecciona un prove\xEFdor per connectar el teu compte.",
      formHint__noAccounts: "No hi ha prove\xEFdors de comptes externs disponibles.",
      removeResource: {
        messageLine1: "{{identifier}} ser\xE0 eliminat d'aquest compte.",
        messageLine2: "Ja no podr\xE0s utilitzar aquest compte connectat i qualsevol funcionalitat dependent deixar\xE0 de funcionar.",
        successMessage: "{{connectedAccount}} ha estat eliminat del teu compte.",
        title: "Elimina compte connectat"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "El prove\xEFdor s'ha afegit al teu compte",
      title: "Afegeix compte connectat"
    },
    deletePage: {
      actionDescription: 'Escriu "Elimina compte" a continuaci\xF3 per continuar.',
      confirm: "Elimina compte",
      messageLine1: "Est\xE0s segur que vols eliminar el teu compte?",
      messageLine2: "Aquesta acci\xF3 \xE9s permanent i irreversible.",
      title: "Elimina compte"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "S'enviar\xE0 un correu electr\xF2nic que cont\xE9 un codi de verificaci\xF3 a aquesta adre\xE7a de correu electr\xF2nic.",
        formSubtitle: "Introdueix el codi de verificaci\xF3 enviat a {{identifier}}",
        formTitle: "Codi de verificaci\xF3",
        resendButton: "No has rebut el codi? Reenvia",
        successMessage: "El correu electr\xF2nic {{identifier}} s'ha afegit al teu compte."
      },
      emailLink: {
        formHint: "S'enviar\xE0 un correu electr\xF2nic que cont\xE9 un enlla\xE7 de verificaci\xF3 a aquesta adre\xE7a de correu electr\xF2nic.",
        formSubtitle: "Fes clic a l'enlla\xE7 de verificaci\xF3 al correu enviat a {{identifier}}",
        formTitle: "Enlla\xE7 de verificaci\xF3",
        resendButton: "No has rebut l'enlla\xE7? Reenvia",
        successMessage: "El correu electr\xF2nic {{identifier}} s'ha afegit al teu compte."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} ser\xE0 eliminat d'aquest compte.",
        messageLine2: "Ja no podr\xE0s iniciar sessi\xF3 utilitzant aquesta adre\xE7a de correu electr\xF2nic.",
        successMessage: "{{emailAddress}} ha estat eliminat del teu compte.",
        title: "Elimina adre\xE7a de correu electr\xF2nic"
      },
      title: "Afegeix adre\xE7a de correu electr\xF2nic",
      verifyTitle: "Verifica adre\xE7a de correu electr\xF2nic"
    },
    formButtonPrimary__add: "Afegeix",
    formButtonPrimary__continue: "Continua",
    formButtonPrimary__finish: "Finalitza",
    formButtonPrimary__remove: "Elimina",
    formButtonPrimary__save: "Guarda",
    formButtonReset: "Cancel\xB7la",
    mfaPage: {
      formHint: "Selecciona un m\xE8tode per afegir.",
      title: "Afegeix verificaci\xF3 en dos passos"
    },
    mfaPhoneCodePage: {
      backButton: "Utilitza el n\xFAmero existent",
      primaryButton__addPhoneNumber: "Afegeix n\xFAmero de tel\xE8fon",
      removeResource: {
        messageLine1: "{{ identifier }} ja no rebr\xE0 codis de verificaci\xF3 quan inici\xEF sessi\xF3.",
        messageLine2: "El teu compte podria no ser tan segur.Est\xE0s segur que vols continuar ? ",
        successMessage: "La verificaci\xF3 en dos passos per SMS ha estat eliminada per { { mfaPhoneCode } } ",
        title: "Elimina la verificaci\xF3 en dos passos"
      },
      subtitle__availablePhoneNumbers: "Selecciona un n\xFAmero de tel\xE8fon existent per registrar - lo per la verificaci\xF3 en dos passos per SMS o afegeix - ne un de nou.",
      subtitle__unavailablePhoneNumbers: "No hi ha n\xFAmeros de tel\xE8fon disponibles per registrar - los per la verificaci\xF3 en dos passos per SMS, si us plau, afegeix - ne un de nou.",
      successMessage1: "Quan inici\xEFs sessi\xF3, necessitar\xE0s introduir un codi de verificaci\xF3 enviat a aquest n\xFAmero de tel\xE8fon com un pas addicional.",
      successMessage2: "Guarda aquests codis de seguretat i emmagatzema'ls en un lloc segur. Si perds l'acc\xE9s al teu dispositiu d'autenticaci\xF3, pots utilitzar els codis de seguretat per iniciar sessi\xF3.",
      successTitle: "La verificaci\xF3 per codi SMS activada",
      title: "Afegeix verificaci\xF3 per codi SMS"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Escaneja el codi QR en lloc",
        buttonUnableToScan__nonPrimary: "No pots escanejar el codi QR? ",
        infoText__ableToScan: "Configura un nou m\xE8tode d'inici de sessi\xF3 a la teva aplicaci\xF3 d'autenticador i escaneja el seg\xFCent codi QR per vincular - lo al teu compte.",
        infoText__unableToScan: "Configura un nou m\xE8tode d'inici de sessi\xF3 al teu autenticador i introdueix la clau proporcionada a continuaci\xF3.",
        inputLabel__unableToScan1: "Assegura't que els contrasenyes basades en temps o d'\xFAs \xFAnic estan habilitats, despr\xE9s finalitza la vinculaci\xF3 del teu compte.",
        inputLabel__unableToScan2: "Alternativament, si el teu autenticador suporta URI de TOTP, tamb\xE9 pots copiar l'URI completa."
      },
      removeResource: {
        messageLine1: "Els codis de verificaci\xF3 d'aquest autenticador ja no seran necessaris quan inici\xEFs sessi\xF3.",
        messageLine2: "El teu compte podria no ser tan segur.Est\xE0s segur que vols continuar? ",
        successMessage: "La verificaci\xF3 en dos passos mitjan\xE7ant l'aplicaci\xF3 d'autenticaci\xF3 ha estat eliminada.",
        title: "Elimina la verificaci\xF3 en dos passos"
      },
      successMessage: "La verificaci\xF3 en dos passos ara est\xE0 habilitada.Quan inici\xEFs sessi\xF3, necessitar\xE0s introduir un codi de verificaci\xF3 d'aquest autenticador com un pas addicional.",
      title: "Afegeix aplicaci\xF3 d'autenticaci\xF3",
      verifySubtitle: "Introdueix el codi de verificaci\xF3 generat pel teu autenticador",
      verifyTitle: "Codi de verificaci\xF3"
    },
    mobileButton__menu: "Men\xFA",
    navbar: {
      account: "Perfil",
      description: "Gestiona la informaci\xF3 del teu compte.",
      security: "Seguretat",
      title: "Compte"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Es recomana tancar sessi\xF3 en tots els altres dispositius que hagin utilitzat la teva contrasenya antiga.",
      readonly: "Actualment no pots editar la teva contrasenya perqu\xE8 pots iniciar sessi\xF3 nom\xE9s a trav\xE9s de la connexi\xF3 d'empresa.",
      successMessage__set: "La teva contrasenya ha estat establerta.",
      successMessage__signOutOfOtherSessions: "S'ha tancat sessi\xF3 en tots els altres dispositius.",
      successMessage__update: "La teva contrasenya ha estat actualitzada.",
      title__set: "Estableix contrasenya",
      title__update: "Actualitza contrasenya"
    },
    phoneNumberPage: {
      infoText: "S'enviar\xE0 un missatge de text que cont\xE9 un codi de verificaci\xF3 a aquest n\xFAmero de tel\xE8fon. Poden aplicar-se tarifes de missatges i dades.",
      removeResource: {
        messageLine1: "{ { identifier } } ser\xE0 eliminat d'aquest compte.",
        messageLine2: "Ja no podr\xE0s iniciar sessi\xF3 utilitzant aquest n\xFAmero de tel\xE8fon.",
        successMessage: "{ { phoneNumber } } ha estat eliminat del teu compte.",
        title: "Elimina n\xFAmero de tel\xE8fon"
      },
      successMessage: "{ { identifier } } s'ha afegit al teu compte.",
      title: "Afegeix n\xFAmero de tel\xE8fon",
      verifySubtitle: "Introdueix el codi de verificaci\xF3 enviat a { { identifier } } ",
      verifyTitle: "Verifica n\xFAmero de tel\xE8fon"
    },
    profilePage: {
      fileDropAreaHint: "Mida recomanada 1:1, fins a 10MB.",
      imageFormDestructiveActionSubtitle: "Elimina",
      imageFormSubtitle: "Puja",
      imageFormTitle: "Imatge de perfil",
      readonly: "La informaci\xF3 del teu perfil ha estat proporcionada per la connexi\xF3 d'empresa i no pot ser editada.",
      successMessage: "El teu perfil ha estat actualitzat.",
      title: "Actualitza perfil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Tanca sessi\xF3 del dispositiu",
        title: "Dispositius actius"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Torna-ho a intentar",
        actionLabel__reauthorize: "Autoritza ara",
        destructiveActionTitle: "Elimina",
        primaryButton: "Connecta compte",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "Els \xE0mbits requerits han estat actualitzats, i podr\xE0s estar experimentant funcionalitat limitada. Si us plau, reautoritza aquesta aplicaci\xF3 per evitar qualsevol problema",
        title: "Comptes connectats"
      },
      dangerSection: {
        deleteAccountButton: "Elimina compte",
        title: "Elimina compte"
      },
      emailAddressesSection: {
        destructiveAction: "Elimina correu electr\xF2nic",
        detailsAction__nonPrimary: "Estableix com a principal",
        detailsAction__primary: "Completa la verificaci\xF3",
        detailsAction__unverified: "Verifica",
        primaryButton: "Afegeix adre\xE7a de correu electr\xF2nic",
        title: "Adreces de correu electr\xF2nic"
      },
      enterpriseAccountsSection: {
        title: "Comptes d'empresa"
      },
      headerTitle__account: "Detalls del perfil",
      headerTitle__security: "Seguretat",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regenera",
          headerTitle: "Codis de seguretat",
          subtitle__regenerate: "Obt\xE9n un nou conjunt de codis de seguretat segurs. Els codis de seguretat anteriors seran eliminats i no podran ser utilitzats.",
          title__regenerate: "Regenera codis de seguretat"
        },
        phoneCode: {
          actionLabel__setDefault: "Estableix com a predeterminat",
          destructiveActionLabel: "Elimina"
        },
        primaryButton: "Afegeix verificaci\xF3 en dos passos",
        title: "Verificaci\xF3 en dos passos",
        totp: {
          destructiveActionTitle: "Elimina",
          headerTitle: "Aplicaci\xF3 d'autenticaci\xF3"
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: "Estableix contrasenya",
        primaryButton__updatePassword: "Actualitza contrasenya",
        title: "Contrasenya"
      },
      phoneNumbersSection: {
        destructiveAction: "Elimina n\xFAmero de tel\xE8fon",
        detailsAction__nonPrimary: "Estableix com a principal",
        detailsAction__primary: "Completa la verificaci\xF3",
        detailsAction__unverified: "Verifica n\xFAmero de tel\xE8fon",
        primaryButton: "Afegeix n\xFAmero de tel\xE8fon",
        title: "N\xFAmeros de tel\xE8fon"
      },
      profileSection: {
        primaryButton: "Actualitza perfil",
        title: "Perfil"
      },
      usernameSection: {
        primaryButton__setUsername: "Estableix nom d'usuari",
        primaryButton__updateUsername: "Actualitza nom d'usuari",
        title: "Nom d'usuari"
      },
      web3WalletsSection: {
        destructiveAction: "Elimina cartera",
        primaryButton: "Carteres Web3",
        title: "Carteres Web3"
      }
    },
    usernamePage: {
      successMessage: "El teu nom d'usuari ha estat actualitzat.",
      title__set: "Estableix nom d'usuari",
      title__update: "Actualitza nom d'usuari"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ser\xE0 eliminat d'aquest compte.",
        messageLine2: "Ja no podr\xE0s iniciar sessi\xF3 utilitzant aquesta cartera Web3.",
        successMessage: "{{web3Wallet}} ha estat eliminada del teu compte.",
        title: "Elimina cartera Web3"
      },
      subtitle__availableWallets: "Selecciona una cartera Web3 per connectar al teu compte.",
      subtitle__unavailableWallets: "No hi ha carteres Web3 disponibles.",
      successMessage: "La cartera ha estat afegida al teu compte.",
      title: "Afegeix cartera Web3",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/hu-HU.ts
var huHU = {
  locale: "hu-HU",
  backButton: "Vissza",
  badge__default: "Alap\xE9rtelmezett",
  badge__otherImpersonatorDevice: "M\xE1sik megszem\xE9lyes\xEDt\u0151 eszk\xF6z",
  badge__primary: "Els\u0151dleges",
  badge__requiresAction: "Beavatkoz\xE1s sz\xFCks\xE9ges",
  badge__thisDevice: "Ez az eszk\xF6z",
  badge__unverified: "Nem ellen\u0151rz\xF6tt",
  badge__userDevice: "Felhaszn\xE1l\xF3i eszk\xF6z",
  badge__you: "Te",
  createOrganization: {
    formButtonSubmit: "Szervezet l\xE9trehoz\xE1sa",
    invitePage: {
      formButtonReset: "Kihagy\xE1s"
    },
    title: "Szervezet l\xE9trehoz\xE1sa"
  },
  dates: {
    lastDay: "Tegnap {{ date | timeString('hu-HU') }}-kor",
    next6Days: "{{ date | weekday('hu-HU','long') }} {{ date | timeString('hu-HU') }}-kor",
    nextDay: "Holnap {{ date | timeString('hu-HU') }}-kor",
    numeric: "{{ date | timeString('hu-HU') }}",
    previous6Days: "Elm\xFAlt {{ date | weekday('hu-HU','long') }} {{ date | timeString('hu-HU') }}-kor",
    sameDay: "Ma {{ date | timeString('hu-HU') }}-kor"
  },
  dividerText: "vagy",
  footerActionLink__useAnotherMethod: "M\xE1sik m\xF3dszer haszn\xE1lata",
  footerPageLink__help: "S\xFAg\xF3",
  footerPageLink__privacy: "Adatv\xE9delem",
  footerPageLink__terms: "Felhaszn\xE1l\xE1si felt\xE9telek",
  formButtonPrimary: "Tov\xE1bb",
  formButtonPrimary__verify: "Ellen\u0151rz\xE9s",
  formFieldAction__forgotPassword: "Elfelejtetted a jelszavad?",
  formFieldError__matchingPasswords: "A jelszavak megegyeznek",
  formFieldError__notMatchingPasswords: "A jelszavak nem egyeznek",
  formFieldError__verificationLinkExpired: "A meger\u0151s\xEDt\u0151 link lej\xE1rt. K\xE9rlek k\xE9rj egy \xFAjat.",
  formFieldHintText__optional: "Nem k\xF6telez\u0151",
  formFieldHintText__slug: "A slug egy egyedi azonos\xEDt\xF3, amelyet \xE1ltal\xE1ban URL-ben haszn\xE1lunk.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Fi\xF3k t\xF6rl\xE9se",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "pelda@email.hu, pelda2@email.hu",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "my-org",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Automatikus megh\xEDv\xE1sok enged\xE9lyez\xE9se ezen a domainen",
  formFieldLabel__backupCode: "Tartal\xE9k k\xF3d",
  formFieldLabel__confirmDeletion: "Meger\u0151s\xEDt\xE9s",
  formFieldLabel__confirmPassword: "Jelsz\xF3 meger\u0151s\xEDt\xE9se",
  formFieldLabel__currentPassword: "Jelenlegi jelsz\xF3",
  formFieldLabel__emailAddress: "Email c\xEDm",
  formFieldLabel__emailAddress_username: "Email c\xEDm vagy felhaszn\xE1l\xF3n\xE9v",
  formFieldLabel__emailAddresses: "Email c\xEDmek",
  formFieldLabel__firstName: "Keresztn\xE9v",
  formFieldLabel__lastName: "Vezet\xE9kn\xE9v",
  formFieldLabel__newPassword: "\xDAj jelsz\xF3",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "F\xFCgg\u0151ben l\xE9v\u0151 megh\xEDv\xE1sok \xE9s javaslatok t\xF6rl\xE9se",
  formFieldLabel__organizationDomainEmailAddress: "Visszaigazol\xF3 email c\xEDm",
  formFieldLabel__organizationDomainEmailAddressDescription: "\xCDrj be egy email c\xEDmet ez alatt a domain alatt, hogy visszaigazold a domaint.",
  formFieldLabel__organizationName: "Szervezet neve",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Passkey neve",
  formFieldLabel__password: "Jelsz\xF3",
  formFieldLabel__phoneNumber: "Telefonsz\xE1m",
  formFieldLabel__role: "Beoszt\xE1s",
  formFieldLabel__signOutOfOtherSessions: "Kijelentkeztet\xE9s minden m\xE1s eszk\xF6z\xF6kr\u0151l",
  formFieldLabel__username: "Felhaszn\xE1l\xF3n\xE9v",
  impersonationFab: {
    action__signOut: "Kijelentkez\xE9s",
    title: "Bejelntkezve mint {{identifier}}"
  },
  maintenanceMode: "Jelenleg karbantart\xE1s alatt \xE1llunk, de ne agg\xF3dj, ez nem tart tov\xE1bb p\xE1r percn\xE9l!",
  membershipRole__admin: "Adminisztr\xE1tor",
  membershipRole__basicMember: "Tag",
  membershipRole__guestMember: "Vend\xE9g",
  organizationList: {
    action__createOrganization: "Szervezet l\xE9trehoz\xE1sa",
    action__invitationAccept: "Csatlakoz\xE1s",
    action__suggestionsAccept: "Csatlakoz\xE1s k\xE9r\xE9se",
    createOrganization: "Szervezet l\xE9trehoz\xE1sa",
    invitationAcceptedLabel: "Megh\xEDv\xE1s elfogadva",
    subtitle: "Amivel folytathatod a(z) {{applicationName}}",
    suggestionsAcceptedLabel: "Elfogad\xE1sra v\xE1r",
    title: "V\xE1lassz egy fi\xF3kot",
    titleWithoutPersonal: "V\xE1lassz egy szervezetet"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatikus megh\xEDv\xE1sok",
    badge__automaticSuggestion: "Automatikus javaslatok",
    badge__manualInvitation: "Nincs automatikus felv\xE9tel",
    badge__unverified: "Nincs visszaigazolva",
    createDomainPage: {
      subtitle: "Add meg a visszaigazoland\xF3 domain nev\xE9t. Minden email c\xEDm err\u0151l a tartom\xE1nyj\xF3l automatikusan tud csatlakozni a szervezethez.",
      title: "Domain hozz\xE1ad\xE1sa"
    },
    invitePage: {
      detailsTitle__inviteFailed: "A megh\xEDvok k\xFCld\xE9se sikertelen. M\xE1r vannak f\xFCgg\u0151ben l\xE9v\u0151 megh\xEDv\xF3k a k\xF6vetkez\u0151 c\xEDmekre: {{email_addresses}}",
      formButtonPrimary__continue: "Megh\xEDv\xF3k k\xFCld\xE9se",
      selectDropdown__role: "V\xE1lassz beoszt\xE1st",
      subtitle: "\xCDrj be vagy illessz be egy vagy t\xF6bb email c\xEDmet, vessz\u0151vel, vagy sz\xF3k\xF6zzel elv\xE1lasztva.",
      successMessage: "A megh\xEDv\xF3k sikeresen elk\xFCldve",
      title: "\xDAj tagok megh\xEDv\xE1sa"
    },
    membersPage: {
      action__invite: "Megh\xEDv\xE1s",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Tag elt\xE1vol\xEDt\xE1sa",
        tableHeader__actions: void 0,
        tableHeader__joined: "Csatlakozott",
        tableHeader__role: "Beoszt\xE1s",
        tableHeader__user: "Felhaszn\xE1l\xF3"
      },
      detailsTitle__emptyRow: "Nincsenek list\xE1zhat\xF3 tagok",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Adj meg egy email domaint, hogy megh\xEDvhass tagokat. B\xE1rki aki err\u0151l a tartom\xE1nyr\xF3l regisztr\xE1l, b\xE1rmikor, csatlakozhat a szervezethez b\xE1rmikor",
          headerTitle: "Automatikus megh\xEDv\xE1sok",
          primaryButton: "Visszaigazolt domainek kezel\xE9se"
        },
        table__emptyRow: "Nincsenek list\xE1zhat\xF3 megh\xEDv\xE1sok"
      },
      invitedMembersTab: {
        menuAction__revoke: "Megh\xEDv\xF3 visszavon\xE1sa",
        tableHeader__invited: "Megh\xEDvva"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Azok a felhaszn\xE1l\xF3k, akik, egyez\u0151 email domainnel regisztr\xE1lnak, l\xE1tni fognak egy javaslatot, hogy csatlakozzanak a szervezetedhez.",
          headerTitle: "Automatikus javaslat",
          primaryButton: "Visszaigazolt domainek kezel\xE9se"
        },
        menuAction__approve: "Elfogad\xE1s",
        menuAction__reject: "Elutas\xEDt\xE1s",
        tableHeader__requested: "Hozz\xE1f\xE9r\xE9s k\xE9r\xE9se",
        table__emptyRow: "Nincsenek list\xE1zhat\xF3 k\xE9r\xE9sek"
      },
      start: {
        headerTitle__invitations: "Megh\xEDv\xF3k",
        headerTitle__members: "Tagok",
        headerTitle__requests: "K\xE9r\xE9sek"
      }
    },
    navbar: {
      description: "A szervezeted kezel\xE9se",
      general: "\xC1ltal\xE1nos",
      members: "Tagok",
      title: "Szervezet"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: '\xCDrd be, hogy: "{{organizationName}}" a folytat\xE1shoz',
          messageLine1: "Biztosan t\xF6r\xF6lni szeretn\xE9d ez a szervezetet?",
          messageLine2: "Ez a m\u0171velet v\xE9gleges \xE9s visszaford\xEDthatatlan.",
          successMessage: "Kit\xF6r\xF6lted a szervezetet.",
          title: "Szervezet t\xF6rl\xE9se"
        },
        leaveOrganization: {
          actionDescription: '\xCDrd be, hogy: "{{organizationName}}" a folytat\xE1shoz',
          messageLine1: "Biztos vagy benne, hogy el szeretn\xE9d hagyni a szervezetet? Elvesz\xEDted a hozz\xE1f\xE9r\xE9st a szervezethez, \xE9s alkamaz\xE1saihoz.",
          messageLine2: "Ez a m\u0171velet v\xE9gleges \xE9s visszaford\xEDthatatlan.",
          successMessage: "Elhagytad a szervezetet.",
          title: "Szervezet elhagy\xE1sa"
        },
        title: "Vesz\xE9ly"
      },
      domainSection: {
        menuAction__manage: "Kezel\xE9s",
        menuAction__remove: "T\xF6rl\xE9s",
        menuAction__verify: "Visszaigazol\xE1s",
        primaryButton: "Domain hozz\xE1ad\xE1sa",
        subtitle: "Endeg\xE9lyezd, hogy a felhaszn\xE1l\xF3k automatikusan csatlakozhassanak a szervezetedhez, vagy hozz\xE1f\xE9r\xE9st k\xE9rjenek, az email domainj\xFCk alapj\xE1n.",
        title: "Visszaigazolt domainek"
      },
      successMessage: "A szervezet friss\xEDtve",
      title: "Profil friss\xEDt\xE9se"
    },
    removeDomainPage: {
      messageLine1: "Az email domain {{domain}} el lesz t\xE1vol\xEDtva",
      messageLine2: "Ez ut\xE1n a felhaszn\xE1l\xF3k nem tudnak automatikusan csatlakozni",
      successMessage: "{{domain}} t\xF6r\xF6lve lett",
      title: "Domain t\xF6rl\xE9se"
    },
    start: {
      headerTitle__general: "\xC1ltal\xE1nos",
      headerTitle__members: "Tagok",
      profileSection: {
        primaryButton: "Profil friss\xEDt\xE9se",
        title: "Szervezet Profil",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "A domain t\xF6rl\xE9se befoly\xE1solja a megh\xEDvott felhaszn\xE1l\xF3kat",
        removeDomainActionLabel__remove: "Domain t\xF6rl\xE9se",
        removeDomainSubtitle: "Domain t\xF6rl\xE9se a visszaigazolt domainek list\xE1j\xE1r\xF3l",
        removeDomainTitle: "Domain t\xF6rl\xE9se"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "A felhaszn\xE1l\xF3k automatikusan meg lesznek h\xEDvva a szervezetbe, amikor regisztr\xE1lnak, \xE9s b\xE1rmikor csatlakozhatnak.",
        automaticInvitationOption__label: "Automatikus megh\xEDv\xE1sok",
        automaticSuggestionOption__description: "A felaszn\xE1l\xF3k kapnak egy javaslatot, hogy k\xE9rjenek hozz\xE1f\xE9r\xE9st, de el\u0151bb egy adminisztr\xE1tornak j\xF3v\xE1 kell hagynia, miel\u0151tt csatlakozhatnak.",
        automaticSuggestionOption__label: "Automatikus javaslatok",
        calloutInfoLabel: "A felv\xE9teli m\xF3d megv\xE1ltoztat\xE1sa csak az \xFAj felhaszn\xE1l\xF3kra lesz hat\xE1ssal",
        calloutInvitationCountLabel: "F\xFCgg\u0151ben l\xE9v\u0151 megh\xEDv\xF3k: {{count}}",
        calloutSuggestionCountLabel: "F\xFCgg\u0151ben l\xE9v\u0151 javaslatok: {{count}}",
        manualInvitationOption__description: "Felhaszn\xE1l\xF3kat csak manu\xE1lisan lehet megh\xEDvni a szervezetbe.",
        manualInvitationOption__label: "Nincs automatikus felv\xE9tel",
        subtitle: "V\xE1laszd ki, hogy a felhaszn\xE1l\xF3k, hogyan csatlakozhatnak szervezethez."
      },
      start: {
        headerTitle__danger: "Vesz\xE9ly",
        headerTitle__enrollment: "Felv\xE9teli opci\xF3k"
      },
      subtitle: "A domain {{domain}} visszaigazolva. A folytat\xE1shoz v\xE1lassz felv\xE9teli m\xF3dot",
      title: "{{domain}} friss\xEDt\xE9se"
    },
    verifyDomainPage: {
      formSubtitle: "\xCDrd be a meger\u0151s\xEDt\u0151 k\xF3dot, amit elk\xFCldt\xFCnk az email c\xEDmedre",
      formTitle: "Meger\u0151s\xEDt\u0151 k\xF3d",
      resendButton: "Nem kapt\xE1l k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "A domain {{domainName}}-t emaillel j\xF3v\xE1 kell hagyni.",
      subtitleVerificationCodeScreen: "Elk\xFCldt\xFCk a meger\u0151s\xEDt\u0151 k\xF3dot a(z) {{emailAddress}} c\xEDmre. A folytat\xE1shoz \xEDrd be a k\xF3dot",
      title: "Domain visszaigazol\xE1sa"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Szervezet l\xE9trehoz\xE1sa",
    action__invitationAccept: "Csatlakoz\xE1s",
    action__manageOrganization: "Kezel\xE9s",
    action__suggestionsAccept: "Csatlakoz\xE1s k\xE9r\xE9se",
    notSelected: "Nincs szervezet kiv\xE1lasztva",
    personalWorkspace: "Szem\xE9lyes fi\xF3k",
    suggestionsAcceptedLabel: "Elfogad\xE1sra v\xE1r"
  },
  paginationButton__next: "K\xF6vetkez\u0151",
  paginationButton__previous: "El\u0151z\u0151",
  paginationRowText__displaying: "Mutat",
  paginationRowText__of: "-b\xF3l/-b\u0151l",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Fi\xF3k hozz\xE1ad\xE1sa",
      action__signOutAll: "Kijelentkez\xE9s minden fi\xF3kb\xF3l",
      subtitle: "V\xE1laszd ki a fi\xF3kot amivel folytatni szeretn\xE9d",
      title: "V\xE1lassz egy fi\xF3kot"
    },
    alternativeMethods: {
      actionLink: "Seg\xEDts\xE9g k\xE9r\xE9se",
      actionText: "Nincs ezekb\u0151l egyik sem ?",
      blockButton__backupCode: "Tartal\xE9k k\xF3d haszn\xE1lata",
      blockButton__emailCode: "Email k\xF3d a {{identifier}}-nak/nek",
      blockButton__emailLink: "Email link a {{identifier}}-nak/nek",
      blockButton__passkey: "Bejelentkez\xE9s passkey-vel",
      blockButton__password: "Bejelentkez\xE9s jelsz\xF3val",
      blockButton__phoneCode: "SMS k\xF3d {{identifier}}-nak/nek",
      blockButton__totp: "Hiteles\xEDt\u0151 app haszn\xE1lata",
      getHelp: {
        blockButton__emailSupport: "Seg\xEDts\xE9g k\xE9r\xE9se emailben",
        content: "Ha b\xE1rmilyen probl\xE9m\xE1d van a bejelentkez\xE9ssel a fi\xF3kodba, k\xFCldj nek\xFCnk egy emailt, \xE9s vissza\xE1ll\xEDtjuk a fi\xF3kodat, amint lehets\xE9ges.",
        title: "Seg\xEDts\xE9g k\xE9r\xE9s"
      },
      subtitle: "Probl\xE9m\xE1d akadt? Ezek k\xF6z\xFCl b\xE1rmelyik bejelentkez\xE9si m\xF3dot v\xE1laszthatod.",
      title: "Bejelentkez\xE9s m\xE1s m\xF3don"
    },
    backupCodeMfa: {
      subtitle: "A tartal\xE9k k\xF3d az, amit akkor kapt\xE1l, amikor be\xE1ll\xEDtottad a k\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1st",
      title: "\xCDrd be a tartal\xE9k k\xF3dot"
    },
    emailCode: {
      formTitle: "Visszaigazol\xF3 k\xF3d",
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "hogy folytathasd a(z) {{applicationName}}",
      title: "Ellen\u0151rizd az emailed"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      expired: {
        subtitle: "Menj vissza az eredeti lapra a folytat\xE1shoz.",
        title: "Ez a meger\u0151s\xEDt\u0151 link lej\xE1rt"
      },
      failed: {
        subtitle: "Menj vissza az eredeti lapra a folytat\xE1shoz.",
        title: "Ez a meger\u0151s\xEDt\u0151 link \xE9rv\xE9nytelen"
      },
      formSubtitle: "Haszn\xE1ld a meger\u0151s\xEDt\u0151 linket, amit a emailben kapt\xE1l",
      formTitle: "Meger\u0151s\xEDt\u0151 link",
      loading: {
        subtitle: "Hamarosan \xE1tir\xE1ny\xEDtunk",
        title: "Bejelentkez\xE9s folyamatban..."
      },
      resendButton: "Nem kapt\xE1l linket? \xDAjrak\xFCld\xE9s",
      subtitle: "hogy folytathasd a(z) {{applicationName}}",
      title: "Ellen\u0151rizd az emailed",
      unusedTab: {
        title: "Ezt a lapot bez\xE1rhatod"
      },
      verified: {
        subtitle: "Hamarosan \xE1tir\xE1ny\xEDtunk",
        title: "Sikeres bejelentkez\xE9s"
      },
      verifiedSwitchTab: {
        subtitle: "Menj vissza az eredeti lapra a folyat\xE1shoz",
        subtitleNewTab: "Menj \xE1t az \xFAjonan megnyitott lapra a folytat\xE1shoz",
        titleNewTab: "Egy m\xE1sik lapon bejelezkezt\xE9l be"
      }
    },
    forgotPassword: {
      formTitle: "Jelsz\xF3 vissza\xE1ll\xEDt\xF3 k\xF3d",
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "hogy vissza\xE1ll\xEDthasd a jelszavad",
      subtitle_email: "El\u0151sz\xF6r, \xEDrd be a k\xF3dot amit emailben kapt\xE1l",
      subtitle_phone: "El\u0151sz\xF6r, \xEDrd be a k\xF3dot amit a telefonodra kapt\xE1l",
      title: "Jelsz\xF3 vissza\xE1ll\xEDt\xE1s"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "\xC1ll\xEDtsd vissza a jelszavad",
      label__alternativeMethods: "Vagy jelentkezz be m\xE1s m\xF3don",
      title: "Efelejtetted a jelszavad?"
    },
    noAvailableMethods: {
      message: "Nem lehet bejelentkezni. Nincs el\xE9rhet\u0151 hiteles\xEDt\u0151 t\xE9nyez\u0151.",
      subtitle: "Hiba t\xF6rt\xE9nt",
      title: "Nem lehetett bejelentkezni"
    },
    passkey: {
      subtitle: "A Passkey-d haszn\xE1lata meger\u0151s\xEDti, hogy te vagy az. Az eszk\xF6z\xF6d k\xE9rheti az ujjlenyomatod, arcod vagy a k\xE9perny\u0151z\xE1rad.",
      title: "Haszn\xE1ld a passkeydet"
    },
    password: {
      actionLink: "M\xE1sik m\xF3d haszn\xE1lata",
      subtitle: "\xCDrd be a fi\xF3khoz tartoz\xF3 jelszavad",
      title: "\xCDrd be a jelszavad"
    },
    passwordPwned: {
      title: "Jelsz\xF3 kompromit\xE1l\xF3dott"
    },
    phoneCode: {
      formTitle: "Visszaigazol\xF3 k\xF3d",
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "hogy folytathasd a(z) {{applicationName}}",
      title: "Ellen\u0151rizd a telefonod"
    },
    phoneCodeMfa: {
      formTitle: "Visszaigazol\xF3 k\xF3d",
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "A folytat\xE1shoz, k\xE9rlek \xEDrd be a visszaigazol\xF3 k\xF3dot, amit a telefonodra k\xFCldt\xFCnk.",
      title: "Ellen\u0151rizd a telefonod"
    },
    resetPassword: {
      formButtonPrimary: "Jelsz\xF3 vissza\xE1ll\xEDt\xE1sa",
      requiredMessage: "Biztons\xE1gi okokb\xF3l, musz\xE1j megv\xE1ltoztatnod a jelszavadat.",
      successMessage: "A jelszavad sikeresen megv\xE1ltozott. A bejelentkez\xE9s folyamatban, k\xE9rlek v\xE1rj.",
      title: "\xDAj jelsz\xF3 be\xE1ll\xEDt\xE1sa"
    },
    resetPasswordMfa: {
      detailsLabel: "Vissza kell igazolnod az identit\xE1sod, miel\u0151tt vissza\xE1ll\xEDtod a jelszavad"
    },
    start: {
      actionLink: "Regisztr\xE1ci\xF3",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Email haszn\xE1lata",
      actionLink__use_email_username: "Haszn\xE1ld az emailded vagy a felhaszn\xE1l\xF3neved",
      actionLink__use_passkey: "Passkey haszn\xE1lata",
      actionLink__use_phone: "Telefon haszn\xE1lata",
      actionLink__use_username: "Felhaszn\xE1l\xF3n\xE9v haszn\xE1lata",
      actionText: "Nincs fi\xF3kod?",
      actionText__join_waitlist: void 0,
      subtitle: "\xDCdv \xFAjra! A folytat\xE1shoz k\xE9rlek jelentkezz be.",
      subtitleCombined: void 0,
      title: "Bejelentkez\xE9s a(z) {{applicationName}} fi\xF3kba",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Visszaigazol\xF3 k\xF3d",
      subtitle: "A folytat\xE1shoz, k\xE9rlek \xEDrd be a visszaigazol\xF3 k\xF3dot, amit a hiteles\xEDt\u0151 app k\xE9sz\xEDtett.",
      title: "K\xE9t l\xE9p\xE9cs\u0151s azonos\xEDt\xE1s"
    }
  },
  signInEnterPasswordTitle: "\xCDrd be a jelszavad",
  signUp: {
    continue: {
      actionLink: "Bejelentkez\xE9s",
      actionText: "Van m\xE1r fi\xF3kod?",
      subtitle: "K\xE9rlek t\xF6ltsd ki a h\xE1tral\xE9v\u0151 mez\u0151ket a folytat\xE1shoz",
      title: "T\xF6ltsd ki a hi\xE1nyz\xF3 mez\u0151ket"
    },
    emailCode: {
      formSubtitle: "\xCDrd be a visszaigazol\xF3 k\xF3dot, amit emailben kapt\xE1l",
      formTitle: "Viszaigazol\xF3 k\xF3d",
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "\xCDrd be a visszaigazol\xF3 k\xF3dot, amit emailben kapt\xE1l",
      title: "Email meger\u0151s\xEDt\xE9se"
    },
    emailLink: {
      clientMismatch: {
        subtitle: void 0,
        title: void 0
      },
      formSubtitle: "Haszn\xE1ld a  visszaigazol\xF3 linket, amit a emailben kapt\xE1l",
      formTitle: "Visszaigazol\xF3 link",
      loading: {
        title: "Regisztr\xE1l\xE1s..."
      },
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "hogy folytasd a(z) {{applicationName}}",
      title: "Er\u0151s\xEDtsd meg az email c\xEDmed",
      verified: {
        title: "Sikeres regisztr\xE1ci\xF3"
      },
      verifiedSwitchTab: {
        subtitle: "Menj az \xFAjonan nyitott lapra, a folytat\xE1shoz",
        subtitleNewTab: "Menj vissza az el\u0151z\u0151 lapra a folytat\xE1shoz",
        title: "Sikeresen meger\u0151s\xEDtetted az email c\xEDmed"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "\xCDrd be a visszaigazol\xF3 k\xF3dot, amit a telefondra kapt\xE1l",
      formTitle: "Visszaigazol\xF3 k\xF3d",
      resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
      subtitle: "\xCDrd be a visszaigazol\xF3 k\xF3dot, amit a telefonodra kapt\xE1l",
      title: "Er\u0151s\xEDtsd meg a telefonsz\xE1mod"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Bejelentkez\xE9s",
      actionLink__use_email: void 0,
      actionLink__use_phone: void 0,
      actionText: "Van m\xE1r fi\xF3kod?",
      subtitle: "\xDCdv! K\xE9rlek add meg az adatokat, hogy elkezdhesd.",
      subtitleCombined: "\xDCdv! K\xE9rlek add meg az adatokat, hogy elkezdhesd.",
      title: "Fi\xF3k l\xE9trehoz\xE1sa",
      titleCombined: "Fi\xF3k l\xE9trehoz\xE1sa"
    }
  },
  socialButtonsBlockButton: "Folytat\xE1s {{provider|titleize}} seg\xEDts\xE9g\xE9vel",
  socialButtonsBlockButtonManyInView: void 0,
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Biztons\xE1gi okokb\xF3l a regisztr\xE1ci\xF3 sikertelen volt. K\xE9rlek friss\xEDtsd az oldalt, hogy \xFAjra pr\xF3b\xE1lhasd, vagy k\xE9rj t\xE1mogat\xE1st.",
    captcha_unavailable: "Bot \xE9rv\xE9nyes\xEDt\xE9se miatt, a regisztr\xE1ci\xF3 sikertelen volt. K\xE9rlek friss\xEDtsd az oldalt, hogy \xFAjra pr\xF3b\xE1lhasd, vagy k\xE9rj t\xE1mogat\xE1st.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "Ez az email c\xEDm m\xE1r foglalt. K\xE9rlek pr\xF3b\xE1lj egy m\xE1sikat.",
    form_identifier_exists__phone_number: "Ez a telefonsz\xE1m m\xE1r foglalt. K\xE9rlek pr\xF3b\xE1lj egy m\xE1sikat.",
    form_identifier_exists__username: "Ez a felhaszn\xE1l\xF3n\xE9v m\xE1r foglalt. K\xE9rlek pr\xF3b\xE1lj egy m\xE1sikat.",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Az email c\xEDmnek \xE9rv\xE9nyes email c\xEDmnek kell lennie.",
    form_param_format_invalid__phone_number: "A telefonsz\xE1mnak \xE9rv\xE9nyes telefonsz\xE1mnak kell lennie.",
    form_param_max_length_exceeded__first_name: "A keresztn\xE9v nem lehet hosszabb, mint 256 karakter.",
    form_param_max_length_exceeded__last_name: "A vezet\xE9kn\xE9v nem lehet hosszabb, mint 256 karakter.",
    form_param_max_length_exceeded__name: "A n\xE9v nem lehet hosszabb mint 256 karakter.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "A jelsz\xF3 nem el\xE9g er\u0151s",
    form_password_pwned: "\xDAgy l\xE1tjuk, hogy ez a jelsz\xF3 kisziv\xE1rgott, ez\xE9rt ezt nem haszn\xE1lhatod, k\xE9rlek pr\xF3b\xE1lj egy m\xE1sik jelsz\xF3t.",
    form_password_pwned__sign_in: "\xDAgy l\xE1tjuk, hogy ez a jelsz\xF3 kisziv\xE1rgott, ez\xE9rt ezt nem haszn\xE1lhatod, k\xE9rlek \xE1ll\xEDtsd \xE1t a jelszavad.",
    form_password_size_in_bytes_exceeded: "A jelszavad t\xF6bb b\xE1jtot tartalmaz mint a megadott maximum, k\xE9rlek r\xF6vid\xEDtsd vagy t\xF6r\xF6lj ki n\xE9h\xE1ny speci\xE1lis karaktert.",
    form_password_validation_failed: "Helytelen jelsz\xF3",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "Nem t\xF6r\xF6lheted ki az utols\xF3 azonos\xEDt\xF3d.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "Egy passkey m\xE1r regisztr\xE1lva van ehhez az eszk\xF6zh\xF6z.",
    passkey_not_supported: "Passkeyk nem t\xE1mogatottak ezen az eszk\xF6z\xF6n.",
    passkey_pa_not_supported: "A regisztr\xE1ci\xF3hoz egy platform hiteles\xEDt\u0151 kell, de ez az eszk\xF6z ezt nem t\xE1mogatja.",
    passkey_registration_cancelled: "Passkey regisztr\xE1ci\xF3 megszakadt vagy lej\xE1rt.",
    passkey_retrieval_cancelled: "Passkey visszaigazol\xE1s megszakadt vagy lej\xE1rt.",
    passwordComplexity: {
      maximumLength: "kevesebb mint {{length}} karaktert",
      minimumLength: "{{length}} vagy t\xF6bb karaktert",
      requireLowercase: "egy kisbet\u0171t",
      requireNumbers: "egy sz\xE1mot",
      requireSpecialCharacter: "egy speci\xE1lis karaktert",
      requireUppercase: "egy nagybet\u0171",
      sentencePrefix: "A jelszavadnak tartalmaznia kell"
    },
    phone_number_exists: "Ez a telefonsz\xE1m m\xE1r foglalt. K\xE9rlek pr\xF3b\xE1lj meg egy m\xE1sikat.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "A jelszavad, j\xF3, de lehetne er\u0151sebb. Adj hozz\xE1 t\xF6bb karaktert.",
      goodPassword: "A jelszavad megfelel az elv\xE1r\xE1soknak.",
      notEnough: "Nem el\xE9g er\u0151s a jelszavad.",
      suggestions: {
        allUppercase: "V\xE1ltoztass meg n\xE9h\xE1ny bet\u0171t nagybet\u0171re, de ne mindet.",
        anotherWord: "Adj hozz\xE1 kev\xE9sb\xE9 gyakori szavakat.",
        associatedYears: "Ker\xFCld el a hozz\xE1d kapcsolhat\xF3 \xE9vek haszn\xE1lat\xE1t",
        capitalization: "Ne csak az els\u0151 bet\u0171 legyen nagy bet\u0171.",
        dates: "Ker\xFCld el a hozz\xE1d k\xF6thet\u0151 d\xE1tumok \xE9s \xE9vek haszn\xE1lat\xE1t.",
        l33t: "Ker\xFCld el a kisz\xE1m\xEDthat\xF3 bet\u0171 behelyettes\xEDt\xE9seket, mint a '@' az 'a' helyett.",
        longerKeyboardPattern: "Haszn\xE1lj hosszabb billenty\u0171zet mint\xE1kat, \xE9s v\xE1ltoztasd meg a g\xE9pel\xE9s ir\xE1ny\xE1t t\xF6bbsz\xF6r.",
        noNeed: "\xDAgy is l\xE9trehozhatsz er\u0151s jelsz\xF3t, hogy nem haszn\xE1lsz speci\xE1lis karaktereket, sz\xE1mokat, vagy nagybet\u0171ket.",
        pwned: "Ha m\xE1shol is haszn\xE1lod ezt a jelsz\xF3t, akkor v\xE1ltoztasd meg.",
        recentYears: "Ker\xFCld el a k\xF6zelm\xFAlt \xE9vek haszn\xE1lat\xE1t.",
        repeated: "Ker\xFCld el a sz\xF3- vagy karakterism\xE9tl\xE9st",
        reverseWords: "Ker\xFCld el a szavak visszafel\xE9 \xEDr\xE1s\xE1t.",
        sequences: "Ker\xFCld el a gyakori karakter sorozatokat.",
        useWords: "Haszn\xE1lj t\xF6bb sz\xF3t, de ker\xFCld el a gyakori kifejez\xE9seket."
      },
      warnings: {
        common: "Ez egy gyakran haszn\xE1lt jelsz\xF3",
        commonNames: "A gyakori nevek k\xF6nnyen kital\xE1lhat\xF3ak.",
        dates: "A d\xE1tumokat k\xF6nny\u0171 kital\xE1lni.",
        extendedRepeat: 'Ism\xE9tl\u0151d\u0151 karakter sorozatok, mint "abcabcabc" k\xF6nnyen kital\xE1lhat\xF3ak.',
        keyPattern: "A r\xF6vid billenty\u0171zetmint\xE1k k\xF6nnyen kital\xE1lhat\xF3ak.",
        namesByThemselves: "A nevek k\xF6nnyen kital\xE1lhat\xF3ak.",
        pwned: "A jelszavad kisziv\xE1rgott egy adatsziv\xE1rg\xE1s sor\xE1n az Interneten. V\xE1lassz egy m\xE1sikat.",
        recentYears: "Az elm\xFAlt \xE9vek k\xF6nnyen kital\xE1lhat\xF3ak.",
        sequences: 'Gyakori karakter sorozatok, mint "abc" k\xF6nnyen kital\xE1lhat\xF3ak.',
        similarToCommon: "Ez hasonl\xEDt egy gyakran haszn\xE1lt jelsz\xF3hoz.",
        simpleRepeat: 'Ism\xE9tl\u0151d\u0151 karakterek, mint az "aaa" k\xF6nnyen kital\xE1lhat\xF3ak.',
        straightRow: 'Egyenes sor a billenty\u0171zeten, mint az "asdf" k\xF6nnyen kital\xE1lhat\xF3ak.',
        topHundred: "Ez egy gyakran haszn\xE1lt jelsz\xF3",
        topTen: "Ez egy nagyon gyakori jelsz\xF3",
        userInputs: "Ne tartalmazzon, szem\xE9lyes, vagy az oldalhoz k\xF6thet\u0151 inform\xE1ci\xF3t.",
        wordByItself: "Egyszavas jelszavak k\xF6nnyen kital\xE1lhat\xF3ak."
      }
    }
  },
  userButton: {
    action__addAccount: "Fi\xF3k hozz\xE1ad\xE1sa",
    action__manageAccount: "Fi\xF3k kezel\xE9se",
    action__signOut: "Kijelentkez\xE9s",
    action__signOutAll: "Kijelentkez\xE9s minden fi\xF3kb\xF3l"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kim\xE1solva!",
      actionLabel__copy: "Az \xF6sszes kim\xE1sol\xE1sa",
      actionLabel__download: ".txt let\xF6lt\xE9se",
      actionLabel__print: "Nyomtat\xE1s",
      infoText1: "A tartal\xE9k k\xF3dok be lesznek kapcsolva ehhez a fi\xF3khoz.",
      infoText2: "A tartal\xE9k k\xF3dokat tartsd titokban, \xE9s t\xE1rold biztons\xE1gos helyen. \xDAjragener\xE1lhatod a tartal\xE9k k\xF3dokat, ha azt gondolod, hogy kisziv\xE1rogtak.",
      subtitle__codelist: "T\xE1rold \u0151ket biztons\xE1gos helyen, \xE9s tartsd titokban.",
      successMessage: "A tartal\xE9k k\xF3dok bekapcsolva. Haszn\xE1lhatod ezeket, hogy bel\xE9pj a fi\xF3kodba, ha nem f\xE9rsz hozz\xE1 a hiteles\xEDt\u0151 eszk\xF6zh\xF6z. Mindegyik k\xF3dot egyszer tudod haszn\xE1lni.",
      successSubtitle: "Haszn\xE1lhatod ezeket is, hogy bel\xE9pj a fi\xF3kodba, ha nem f\xE9rsz hozz\xE1 a hiteles\xEDt\u0151 eszk\xF6z\xF6dh\xF6z.",
      title: "Tartal\xE9k k\xF3d meger\u0151s\xEDt\xE9s hozz\xE1ad\xE1sa",
      title__codelist: "Tartal\xE9k k\xF3dok"
    },
    connectedAccountPage: {
      formHint: "V\xE1lassz egy szolg\xE1ltat\xF3t, amit \xF6sszek\xF6tsz a fi\xF3koddal.",
      formHint__noAccounts: "Nincs el\xE9rhet\u0151 k\xFCls\u0151 fi\xF3k szolg\xE1ltat\xF3.",
      removeResource: {
        messageLine1: "{{identifier}} el lesz t\xE1vol\xEDtva ebb\u0151l a fi\xF3kb\xF3l.",
        messageLine2: "Nem fogod tudni haszn\xE1lni ezt a kapcsolt fi\xF3kot. B\xE1rmilyen ett\u0151l f\xFCgg\u0151 szolg\xE1ltat\xE1s nem fog m\u0171k\xF6dni.",
        successMessage: "{{connectedAccount}} elt\xE1vol\xEDtva a fi\xF3kdb\xF3l.",
        title: "Kapcsolt fi\xF3k elt\xE1vol\xEDt\xE1sa"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "A szolg\xE1tat\xF3 hozz\xE1 lett adva a fi\xF3kodhoz.",
      title: "Kapcsolt fi\xF3k hozz\xE1ad\xE1sa"
    },
    deletePage: {
      actionDescription: '\xCDrd be, hogy "Delete account" a folytat\xE1shoz.',
      confirm: "Fi\xF3k t\xF6rl\xE9se",
      messageLine1: "Biztos vagy benne, hogy t\xF6r\xF6lni szeretn\xE9d a fi\xF3kod?",
      messageLine2: "Ez a m\u0171velet v\xE9gleges \xE9s visszaford\xEDthatatlan.",
      title: "Fi\xF3k t\xF6rl\xE9se"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Egy visszaigazol\xF3 k\xF3dot tartalmaz\xF3 emailt fogunk k\xFCldeni erre az email c\xEDmre.",
        formSubtitle: "\xCDrd be a visszaigazol\xF3 k\xF3dot, amit a(z) {{identifier}} c\xEDmre k\xFCldt\xFCnk.",
        formTitle: "Visszaigazol\xF3 k\xF3d",
        resendButton: "Nem kaptad meg a k\xF3dot? \xDAjrak\xFCld\xE9s",
        successMessage: "Az email: {{identifier}} hozz\xE1 lett adva a fi\xF3kodhoz."
      },
      emailLink: {
        formHint: "Egy visszaigazol\xF3 linket tartalmaz\xF3 emailt fogunk k\xFCldeni erre az email c\xEDmre.",
        formSubtitle: "Kattints a visszaigazol\xF3 linkre az emailben, amit ide k\xFCldt\xFCnk: {{identifier}}",
        formTitle: "Visszaigazol\xF3 link",
        resendButton: "Nem kaptad meg a linket? \xDAjrak\xFCld\xE9s",
        successMessage: "Az email: {{identifier}} hozz\xE1 lett adva a fi\xF3kodhoz."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} el lesz t\xE1vol\xEDtva ebb\u0151l a fi\xF3kb\xF3l.",
        messageLine2: "Nem fogsz tudni t\xF6bbet bejelentkezni ezzel az email c\xEDmmel.",
        successMessage: "{{emailAddress}} el lett t\xE1vol\xEDtva a fi\xF3kodb\xF3l.",
        title: "Email c\xEDm t\xF6rl\xE9se"
      },
      title: "Email c\xEDm hozz\xE1ad\xE1sa",
      verifyTitle: "Email c\xEDm visszaigazol\xE1sa"
    },
    formButtonPrimary__add: "Hozz\xE1ad\xE1s",
    formButtonPrimary__continue: "Folytat\xE1s",
    formButtonPrimary__finish: "Befejez\xE9s",
    formButtonPrimary__remove: "Elt\xE1vol\xEDt\xE1s",
    formButtonPrimary__save: "Ment\xE9s",
    formButtonReset: "M\xE9gsem",
    mfaPage: {
      formHint: "V\xE1lassz egy hiteles\xEDt\u0151 m\xF3dszert, amit hozz\xE1 szeretn\xE9l adni.",
      title: "K\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1s bekapcsol\xE1sa"
    },
    mfaPhoneCodePage: {
      backButton: "L\xE9tez\u0151 sz\xE1m haszn\xE1lata",
      primaryButton__addPhoneNumber: "Telefonsz\xE1m hozz\xE1ad\xE1sa",
      removeResource: {
        messageLine1: "{{identifier}} nem fog t\xF6bbet visszaigazol\xF3 k\xF3dot kapni, amikor bel\xE9psz.",
        messageLine2: "A fi\xF3k\xF3d nem biztos, hogy olyan biztons\xE1gos lesz. Biztosan folytatod?",
        successMessage: "K\xE9tl\xE9pcs\u0151s SMS k\xF3d elt\xE1vol\xEDtva a {{mfaPhoneCode}} sz\xE1mhoz",
        title: "K\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1s elt\xE1vol\xEDt\xE1sa"
      },
      subtitle__availablePhoneNumbers: "V\xE1lassz egy telefonsz\xE1mot, hogy regisztr\xE1ld az SMS k\xF3d k\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1st, vagy adj hozz\xE1 egy \xFAjat.",
      subtitle__unavailablePhoneNumbers: "Nincs el\xE9rhet\u0151 telefonsz\xE1m, az SMS k\xF3d k\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1shoz. K\xE9rlek adj hozz\xE1 egyet.",
      successMessage1: "Amikor bel\xE9psz, extra l\xE9p\xE9sk\xE9nt meg kell adnod a visszaigazol\xF3 k\xF3dot, amit elk\xFCld\xFCnk erre a telefonsz\xE1mra.",
      successMessage2: "T\xE1rold ezeket a tartal\xE9k k\xF3dokat, egy biztons\xE1gos helyen. Ha nem f\xE9rsz hozz\xE1 a hiteles\xEDt\u0151 eszk\xF6z\xF6dh\xF6z, ezekkel tudsz bel\xE9pni.",
      successTitle: "SMS visszaigazol\xF3 k\xF3d hozz\xE1adva",
      title: "SMS visszaigazol\xF3 k\xF3d hozz\xE1ad\xE1sa"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Ink\xE1bb olvasd be a QR k\xF3dot",
        buttonUnableToScan__nonPrimary: "Nem tudod beolvasni a QR k\xF3dot?",
        infoText__ableToScan: "\xC1ll\xEDts be egy \xFAj bel\xE9p\xE9si m\xF3dot, a hiteles\xEDt\u0151 alkalmaz\xE1sodban \xE9s olvasd a QR k\xF3dot, hogy \xF6sszek\xF6sd a fi\xF3koddal.",
        infoText__unableToScan: "\xC1ll\xEDts be egy \xFAj bejelentkez\xE9s m\xF3dot a hiteles\xEDt\u0151 alkalmaz\xE1sodban, \xEDrd be a kulcsot, amit lejjebb tal\xE1lsz.",
        inputLabel__unableToScan1: "Bizonyosodj meg, hogy a Time-based vagy a One-time passwords be van kapcsolva, majd fejezd be a fi\xF3k \xF6sszek\xF6t\xE9s\xE9t a k\xF6vetkez\u0151 kulccsal:",
        inputLabel__unableToScan2: "Alternat\xEDvak\xE9nt, ha az hiteles\xEDt\u0151 alkalmaz\xE1sod t\xE1mogatja a TOTP URI-kat, a teljes URI-t is be lehet m\xE1solni."
      },
      removeResource: {
        messageLine1: "Visszaigazol\xF3 k\xF3dok ebb\u0151l a hiteles\xEDt\u0151 alkalmaz\xE1sb\xF3l, m\xE1r nem fognak kelleni a bejelenetkez\xE9shez.",
        messageLine2: "El\u0151fordulhat, hogy a fi\xF3kod nem lesz olyan biztons\xE1gos. Biztonsan folytatni szeretn\xE9d?",
        successMessage: "K\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1s hiteles\xEDt\u0151 alkalmaz\xE1ssal elt\xE1vol\xEDtva.",
        title: "K\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1s elt\xE1vol\xEDt\xE1sa"
      },
      successMessage: "K\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1st bekapcsolva. Extra l\xE9p\xE9sk\xE9nt, amikor bel\xE9psz, meg kell adnod a visszaigazol\xF3 k\xF3dot a hiteles\xEDt\u0151 alkalmaz\xE1sodb\xF3l.",
      title: "Hiteles\xEDt\u0151 alkalmaz\xE1s hozz\xE1ad\xE1sa",
      verifySubtitle: "\xCDrd be a visszaigazol\xF3 k\xF3dot, amit a hiteles\xEDt\u0151 alkalmaz\xE1sodb\xF3l.",
      verifyTitle: "Visszaigazol\xF3 k\xF3d"
    },
    mobileButton__menu: "Men\xFC",
    navbar: {
      account: "Profil",
      description: "Fi\xF3k inform\xE1ci\xF3k kezel\xE9se",
      security: "Biztons\xE1g",
      title: "Fi\xF3k"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} el lesz t\xE1vol\xEDtva ebb\u0151l a fi\xF3kb\xF3l.",
        title: "Passkey t\xF6rl\xE9se"
      },
      subtitle__rename: "Megv\xE1ltoztathatod a passkey nev\xE9t, hogy k\xF6nnyebb legyen megtal\xE1lni.",
      title__rename: "Passkey \xE1tnevez\xE9se"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Aj\xE1nlott kijelentkeztetni az \xF6sszes olyan eszk\xF6zt, ami a r\xE9gi jelszavadat haszn\xE1lja.",
      readonly: "A jelszavad jelenleg nem m\xF3dos\xEDthat\xF3, mert csak v\xE1llalati kapcsolattal tudsz bel\xE9pni.",
      successMessage__set: "A jelszavad be\xE1ll\xEDtottuk.",
      successMessage__signOutOfOtherSessions: "Minden m\xE1s eszk\xF6z kijelentkeztetve.",
      successMessage__update: "A jelszavad friss\xEDt\xE9sre ker\xFClt.",
      title__set: "Jelsz\xF3 be\xE1ll\xEDt\xE1sa",
      title__update: "Jelsz\xF3 friss\xEDt\xE9se"
    },
    phoneNumberPage: {
      infoText: "Egy sz\xF6veges \xFCzenetet k\xFCld\xFCnk a visszaigazol\xF3 k\xF3ddal erre a sz\xE1mra. Az \xFCzenet \xE9s az adatforgalom d\xEDjai \xE9rv\xE9nyesek lehetnek.",
      removeResource: {
        messageLine1: "{{identifier}} el lesz t\xE1vol\xEDtva ebb\u0151l a fi\xF3kb\xF3l.",
        messageLine2: "Nem fogsz tudni t\xF6bbet bejelentkezni ezzel a telefonsz\xE1mmal.",
        successMessage: "{{phoneNumber}} el lett t\xE1vol\xEDtva a fi\xF3kodb\xF3l.",
        title: "Telefonsz\xE1m elt\xE1vol\xEDt\xE1sa"
      },
      successMessage: "{{identifier}} hozz\xE1 lett adva a fi\xF3kodhoz.",
      title: "Telefonsz\xE1m hozz\xE1ad\xE1sa",
      verifySubtitle: "\xCDrd be a visszaigaz\xF3l\xF3 k\xF3dot, amit a(z) {{identifier}} sz\xE1mra k\xFCldt\xFCnk.",
      verifyTitle: "Telefonsz\xE1m visszaigazol\xE1sa"
    },
    profilePage: {
      fileDropAreaHint: "Aj\xE1nlott m\xE9ret 1:1, 10MB-ig.",
      imageFormDestructiveActionSubtitle: "Elt\xE1vol\xEDt\xE1s",
      imageFormSubtitle: "Felt\xF6lt\xE9s",
      imageFormTitle: "Profil k\xE9p",
      readonly: "A profilod adatai, v\xE1llalati kapcsolatb\xF3l sz\xE1rmaznak, \xEDgy nem m\xF3dos\xEDthat\xF3ak.",
      successMessage: "A profilod friss\xEDtve.",
      title: "Profil friss\xEDt\xE9se"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Kijelentkez\xE9s az eszk\xF6zr\u0151l",
        title: "Akt\xEDv eszk\xF6z\xF6k"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Pr\xF3b\xE1ld \xFAjra",
        actionLabel__reauthorize: "Enged\xE9lyezd most",
        destructiveActionTitle: "Elt\xE1vol\xEDt\xE1s",
        primaryButton: "Fi\xF3k \xF6sszek\xF6t\xE9se",
        subtitle__disconnected: void 0,
        subtitle__reauthorize: "A sz\xFCks\xE9ges hat\xE1sk\xF6r\xF6k megv\xE1ltozt\xE1k, el\u0151fordulhat, hogy limit\xE1lt funkcionalit\xE1st tapasztalhatsz. K\xE9rlek, \xFAjra enged\xE9lyezd az alkalmaz\xE1st, hogy elker\xFCld a hib\xE1kat.",
        title: "Kapcsolt fi\xF3kok"
      },
      dangerSection: {
        deleteAccountButton: "Fi\xF3k t\xF6rl\xE9se",
        title: "Fi\xF3k t\xF6rl\xE9se"
      },
      emailAddressesSection: {
        destructiveAction: "Email elt\xE1vol\xEDt\xE1sa",
        detailsAction__nonPrimary: "Be\xE1ll\xEDt\xE1s els\u0151dlegesk\xE9nt",
        detailsAction__primary: "Visszaigazol\xE1s befejez\xE9se",
        detailsAction__unverified: "Visszaigazol\xE1s",
        primaryButton: "Email c\xEDm hozz\xE1ad\xE1sa",
        title: "Email c\xEDmek"
      },
      enterpriseAccountsSection: {
        title: "V\xE1llalati fi\xF3kok"
      },
      headerTitle__account: "Profil adatok",
      headerTitle__security: "Biztons\xE1g",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "\xDAjra gener\xE1l\xE1s",
          headerTitle: "Tartal\xE9k k\xF3dok",
          subtitle__regenerate: "K\xE9rj egy \xFAj biztons\xE1gos tartal\xE9k k\xF3dokat. Az el\u0151z\u0151 k\xF3dok t\xF6rl\xE9sre ker\xFClnek, \xE9s nem lesznek haszn\xE1lhat\xF3k.",
          title__regenerate: "Tartal\xE9k k\xF3dok \xFAjragener\xE1l\xE1sa"
        },
        phoneCode: {
          actionLabel__setDefault: "Be\xE1ll\xEDt\xE1s alap\xE9rtelmezettk\xE9nt",
          destructiveActionLabel: "Elt\xE1vol\xEDt\xE1s"
        },
        primaryButton: "K\xE9tl\xE9pcs\u0151s azonos\xEDt\xE1s hozz\xE1ad\xE1sa",
        title: "K\xE9t l\xE9pcs\u0151s azonos\xEDt\xE1s",
        totp: {
          destructiveActionTitle: "Elt\xE1vol\xEDt\xE1s",
          headerTitle: "Hiteles\xEDt\u0151 alkalmaz\xE1s"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Elt\xE1vol\xEDt\xE1s",
        menuAction__rename: "\xC1tnevez\xE9s",
        primaryButton: void 0,
        title: "Passkey-k"
      },
      passwordSection: {
        primaryButton__setPassword: "Jelsz\xF3 be\xE1ll\xEDt\xE1sa",
        primaryButton__updatePassword: "Jelsz\xF3 friss\xEDt\xE9se",
        title: "Jelsz\xF3"
      },
      phoneNumbersSection: {
        destructiveAction: "Teleofnsz\xE1m elt\xE1vol\xEDt\xE1sa",
        detailsAction__nonPrimary: "Be\xE1ll\xEDt\xE1s els\u0151dlegesk\xE9nt",
        detailsAction__primary: "Visszaigazol\xE1s befejez\xE9se",
        detailsAction__unverified: "Teleofnsz\xE1m visszaigazol\xE1sa",
        primaryButton: "Telefonsz\xE1m hozz\xE1ad\xE1sa",
        title: "Telefonsz\xE1mok"
      },
      profileSection: {
        primaryButton: "Profil friss\xEDt\xE9se",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Felhaszn\xE1l\xF3n\xE9v be\xE1ll\xEDt\xE1sa",
        primaryButton__updateUsername: "Felhaszn\xE1l\xF3n\xE9v friss\xEDt\xE9se",
        title: "Felhaszn\xE1l\xF3n\xE9v"
      },
      web3WalletsSection: {
        destructiveAction: "T\xE1rca elt\xE1vol\xEDt\xE1sa",
        primaryButton: "Web3 t\xE1rc\xE1k",
        title: "Web3 t\xE1rc\xE1k"
      }
    },
    usernamePage: {
      successMessage: "A felhaszn\xE1l\xF3neved friss\xEDtve.",
      title__set: "Felhaszn\xE1l\xF3n\xE9v be\xE1ll\xEDt\xE1sa",
      title__update: "Felaszn\xE1l\xF3n\xE9v friss\xEDt\xE9se"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} el lesz t\xE1vol\xEDtva ebb\u0151l a fi\xF3kb\xF3l.",
        messageLine2: "Nem fogod tudni haszn\xE1lni a bejelentkez\xE9shez, ezt a web3 t\xE1rc\xE1t.",
        successMessage: "{{web3Wallet}} elt\xE1vol\xEDtva a fi\xF3kodb\xF3l.",
        title: "Web3 t\xE1rca elt\xE1vol\xEDt\xE1sa"
      },
      subtitle__availableWallets: "V\xE1laszd ki a web3 t\xE1rc\xE1t, amit hozz\xE1 szeretn\xE9l adni a fi\xF3kodhoz.",
      subtitle__unavailableWallets: "Nincs el\xE9rhet\u0151 web3 t\xE1rca.",
      successMessage: "A t\xE1rca sikeresen hozz\xE1adva a fi\xF3kodhoz.",
      title: "Web3 t\xE1rca hozz\xE1ad\xE1sa",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/is-IS.ts
var isIS = {
  locale: "is-IS",
  backButton: "Til baka",
  badge__default: "Sj\xE1lfgefi\xF0",
  badge__otherImpersonatorDevice: "\xD6nnur t\xE6ki sem herma eftir",
  badge__primary: "A\xF0al",
  badge__requiresAction: "Krefst a\xF0ger\xF0a",
  badge__thisDevice: "\xDEetta t\xE6ki",
  badge__unverified: "\xD3sta\xF0fest",
  badge__userDevice: "Notendat\xE6ki",
  badge__you: "\xDE\xFA",
  createOrganization: {
    formButtonSubmit: "Stofna samt\xF6k",
    invitePage: {
      formButtonReset: "Sleppa"
    },
    title: "Stofna samt\xF6k"
  },
  dates: {
    lastDay: "\xCD g\xE6r kl {{ date | timeString('is-IS') }}",
    next6Days: "{{ date | weekday('is-IS','long') }} kl {{ date | timeString('is-IS') }}",
    nextDay: "\xC1 morgun kl {{ date | timeString('is-IS') }}",
    numeric: "{{ date | numeric('is-IS') }}",
    previous6Days: "S\xED\xF0asta {{ date | weekday('is-IS','long') }} kl {{ date | timeString('is-IS') }}",
    sameDay: "\xCD dag kl {{ date | timeString('is-IS') }}"
  },
  dividerText: "e\xF0a",
  footerActionLink__useAnotherMethod: "Nota a\xF0ra a\xF0fer\xF0",
  footerPageLink__help: "Hj\xE1lp",
  footerPageLink__privacy: "Pers\xF3nuvernd",
  footerPageLink__terms: "Skilm\xE1lar",
  formButtonPrimary: "Halda \xE1fram",
  formButtonPrimary__verify: "Sta\xF0festa",
  formFieldAction__forgotPassword: "Gleymt lykilor\xF0?",
  formFieldError__matchingPasswords: "Lykilor\xF0 passa saman.",
  formFieldError__notMatchingPasswords: "Lykilor\xF0 passa ekki saman.",
  formFieldError__verificationLinkExpired: "Sta\xF0festingartengillinn er \xFAtrunninn. Vinsamlegast bi\xF0ji\xF0 um n\xFDjan tengil.",
  formFieldHintText__optional: "Valfrj\xE1lst",
  formFieldHintText__slug: "Stubbur (e. slug) er au\xF0lesanlegt au\xF0kenni sem ver\xF0ur a\xF0 vera einstakt. \xDEa\xF0 er oft nota\xF0 \xED vefsl\xF3\xF0um.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Ey\xF0a a\xF0gangi",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "d\xE6mi@netfang.is, d\xE6mi2@netfang.is",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "min-samtok",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Virkja sj\xE1lfvirk bo\xF0 fyrir \xFEetta l\xE9n",
  formFieldLabel__backupCode: "\xD6ryggisk\xF3\xF0i",
  formFieldLabel__confirmDeletion: "Sta\xF0festing",
  formFieldLabel__confirmPassword: "Sta\xF0festa lykilor\xF0",
  formFieldLabel__currentPassword: "N\xFAverandi lykilor\xF0",
  formFieldLabel__emailAddress: "Netfang",
  formFieldLabel__emailAddress_username: "Netfang e\xF0a notendanafn",
  formFieldLabel__emailAddresses: "Netf\xF6ng",
  formFieldLabel__firstName: "Fornafn",
  formFieldLabel__lastName: "Eftirnafn",
  formFieldLabel__newPassword: "N\xFDtt lykilor\xF0",
  formFieldLabel__organizationDomain: "L\xE9n",
  formFieldLabel__organizationDomainDeletePending: "Ey\xF0a bo\xF0um \xED bi\xF0 og till\xF6gum",
  formFieldLabel__organizationDomainEmailAddress: "Sta\xF0festingarnetfang",
  formFieldLabel__organizationDomainEmailAddressDescription: "Sl\xE1\xF0u inn netfang undir \xFEessu l\xE9ni til a\xF0 f\xE1 k\xF3\xF0a og sta\xF0festa \xFEetta l\xE9n.",
  formFieldLabel__organizationName: "Nafn",
  formFieldLabel__organizationSlug: "Stubbur (e. slug)",
  formFieldLabel__passkeyName: "Nafn lykils",
  formFieldLabel__password: "Lykilor\xF0",
  formFieldLabel__phoneNumber: "S\xEDman\xFAmer",
  formFieldLabel__role: "Hlutverk",
  formFieldLabel__signOutOfOtherSessions: "Skr\xE1 \xFAt af \xF6llum \xF6\xF0rum t\xE6kjum",
  formFieldLabel__username: "Notendanafn",
  impersonationFab: {
    action__signOut: "Skr\xE1 \xFAt",
    title: "Skr\xE1\xF0ur inn sem {{identifier}}"
  },
  maintenanceMode: "Vi\xF0 erum n\xFA \xED vi\xF0haldi, en ekki hafa \xE1hyggjur, \xFEa\xF0 \xE6tti ekki a\xF0 taka meira en nokkrar m\xEDn\xFAtur.",
  membershipRole__admin: "Stj\xF3rnandi",
  membershipRole__basicMember: "Me\xF0limur",
  membershipRole__guestMember: "Gestur",
  organizationList: {
    action__createOrganization: "Stofna samt\xF6k",
    action__invitationAccept: "Ganga \xED",
    action__suggestionsAccept: "Bi\xF0ja um a\xF0 ganga \xED",
    createOrganization: "Stofna samt\xF6k",
    invitationAcceptedLabel: "Gengi\xF0 \xED",
    subtitle: "til a\xF0 halda \xE1fram \xED {{applicationName}}",
    suggestionsAcceptedLabel: "B\xED\xF0ur sam\xFEykkis",
    title: "Veldu reikning",
    titleWithoutPersonal: "Veldu samt\xF6k"
  },
  organizationProfile: {
    badge__automaticInvitation: "Sj\xE1lfvirk bo\xF0",
    badge__automaticSuggestion: "Sj\xE1lfvirkar till\xF6gur",
    badge__manualInvitation: "Engin sj\xE1lfvirk skr\xE1ning",
    badge__unverified: "\xD3sta\xF0fest",
    createDomainPage: {
      subtitle: "B\xE6ttu vi\xF0 l\xE9ni til a\xF0 sta\xF0festa. Notendur me\xF0 netf\xF6ng undir \xFEessu l\xE9ni geta gengi\xF0 \xED samt\xF6kin sj\xE1lfkrafa e\xF0a be\xF0i\xF0 um a\xF0 ganga \xED.",
      title: "B\xE6ta vi\xF0 l\xE9ni"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Ekki t\xF3kst a\xF0 senda bo\xF0in. \xDEa\xF0 eru \xFEegar bi\xF0bo\xF0 fyrir eftirfarandi netf\xF6ng: {{email_addresses}}.",
      formButtonPrimary__continue: "Senda bo\xF0",
      selectDropdown__role: "Veldu hlutverk",
      subtitle: "Sl\xE1\xF0u inn e\xF0a l\xEDmdu eitt e\xF0a fleiri netf\xF6ng, a\xF0skilin me\xF0 bilum e\xF0a kommum.",
      successMessage: "Bo\xF0 send me\xF0 g\xF3\xF0um \xE1rangri",
      title: "Bj\xF3\xF0a n\xFDja me\xF0limi"
    },
    membersPage: {
      action__invite: "Bj\xF3\xF0a",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Fjarl\xE6gja me\xF0lim",
        tableHeader__actions: void 0,
        tableHeader__joined: "Gengi\xF0 \xED",
        tableHeader__role: "Hlutverk",
        tableHeader__user: "Notandi"
      },
      detailsTitle__emptyRow: "Engir me\xF0limir til a\xF0 s\xFDna",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Bj\xF3\xF0a notendum me\xF0 \xFEv\xED a\xF0 tengja netfangal\xE9n vi\xF0 samt\xF6kin \xFE\xEDn. Allir sem skr\xE1 sig me\xF0 samsvarandi netfangal\xE9n geta gengi\xF0 \xED samt\xF6kin hven\xE6r sem er.",
          headerTitle: "Sj\xE1lfvirk bo\xF0",
          primaryButton: "Stj\xF3rna sta\xF0festum l\xE9num"
        },
        table__emptyRow: "Engin bo\xF0 til a\xF0 s\xFDna"
      },
      invitedMembersTab: {
        menuAction__revoke: "Afturkalla bo\xF0",
        tableHeader__invited: "Bo\xF0i\xF0"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Notendur sem skr\xE1 sig me\xF0 samsvarandi netfangal\xE9n, munu sj\xE1 till\xF6gu um a\xF0 bi\xF0ja um a\xF0 ganga \xED samt\xF6kin \xFE\xEDn.",
          headerTitle: "Sj\xE1lfvirkar till\xF6gur",
          primaryButton: "Stj\xF3rna sta\xF0festum l\xE9num"
        },
        menuAction__approve: "Sam\xFEykkja",
        menuAction__reject: "Hafna",
        tableHeader__requested: "Be\xF0i\xF0 um a\xF0gang",
        table__emptyRow: "Engar bei\xF0nir til a\xF0 s\xFDna"
      },
      start: {
        headerTitle__invitations: "Bo\xF0",
        headerTitle__members: "Me\xF0limir",
        headerTitle__requests: "Bei\xF0nir"
      }
    },
    navbar: {
      description: "Stj\xF3rna samt\xF6kunum \xFE\xEDnum.",
      general: "Almennt",
      members: "Me\xF0limir",
      title: "Samt\xF6k"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Sl\xE1\xF0u inn "{{organizationName}}" h\xE9r a\xF0 ne\xF0an til a\xF0 halda \xE1fram.',
          messageLine1: "Ertu viss um a\xF0 \xFE\xFA viljir ey\xF0a \xFEessum samt\xF6kum?",
          messageLine2: "\xDEessi a\xF0ger\xF0 er varanleg og \xF3afturkr\xE6f.",
          successMessage: "\xDE\xFA hefur eytt samt\xF6kunum.",
          title: "Ey\xF0a samt\xF6kum"
        },
        leaveOrganization: {
          actionDescription: 'Sl\xE1\xF0u inn "{{organizationName}}" h\xE9r a\xF0 ne\xF0an til a\xF0 halda \xE1fram.',
          messageLine1: "Ertu viss um a\xF0 \xFE\xFA viljir yfirgefa \xFEessi samt\xF6k? \xDE\xFA munt missa a\xF0gang a\xF0 \xFEessum samt\xF6kum og forritum \xFEeirra.",
          messageLine2: "\xDEessi a\xF0ger\xF0 er varanleg og \xF3afturkr\xE6f.",
          successMessage: "\xDE\xFA hefur yfirgefi\xF0 samt\xF6kin.",
          title: "Yfirgefa samt\xF6k"
        },
        title: "H\xE6tta"
      },
      domainSection: {
        menuAction__manage: "Stj\xF3rna",
        menuAction__remove: "Ey\xF0a",
        menuAction__verify: "Sta\xF0festa",
        primaryButton: "B\xE6ta vi\xF0 l\xE9ni",
        subtitle: "Leyfa notendum a\xF0 ganga \xED samt\xF6kin sj\xE1lfkrafa e\xF0a bi\xF0ja um a\xF0 ganga \xED byggt \xE1 sta\xF0festu netfangal\xE9ni.",
        title: "Sta\xF0fest l\xE9n"
      },
      successMessage: "Samt\xF6kin hafa veri\xF0 uppf\xE6r\xF0.",
      title: "Uppf\xE6ra pr\xF3f\xEDl"
    },
    removeDomainPage: {
      messageLine1: "Netfangal\xE9n {{domain}} ver\xF0ur fjarl\xE6gt.",
      messageLine2: "Notendur munu ekki geta gengi\xF0 \xED samt\xF6kin sj\xE1lfkrafa eftir \xFEetta.",
      successMessage: "{{domain}} hefur veri\xF0 fjarl\xE6gt.",
      title: "Fjarl\xE6gja l\xE9n"
    },
    start: {
      headerTitle__general: "Almennt",
      headerTitle__members: "Me\xF0limir",
      profileSection: {
        primaryButton: "Uppf\xE6ra pr\xF3f\xEDl",
        title: "Pr\xF3f\xEDll samtaka",
        uploadAction__title: "Merki"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "A\xF0 fjarl\xE6gja \xFEetta l\xE9n mun hafa \xE1hrif \xE1 bo\xF0na notendur.",
        removeDomainActionLabel__remove: "Fjarl\xE6gja l\xE9n",
        removeDomainSubtitle: "Fjarl\xE6gja \xFEetta l\xE9n \xFAr sta\xF0festum l\xE9num \xFE\xEDnum",
        removeDomainTitle: "Fjarl\xE6gja l\xE9n"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Notendur eru sj\xE1lfkrafa bo\xF0nir a\xF0 ganga \xED samt\xF6kin \xFEegar \xFEeir skr\xE1 sig og geta gengi\xF0 \xED hven\xE6r sem er.",
        automaticInvitationOption__label: "Sj\xE1lfvirk bo\xF0",
        automaticSuggestionOption__description: "Notendur f\xE1 till\xF6gu um a\xF0 bi\xF0ja um a\xF0 ganga \xED, en ver\xF0a a\xF0 vera sam\xFEykktir af stj\xF3rnanda \xE1\xF0ur en \xFEeir geta gengi\xF0 \xED samt\xF6kin.",
        automaticSuggestionOption__label: "Sj\xE1lfvirkar till\xF6gur",
        calloutInfoLabel: "A\xF0 breyta skr\xE1ningara\xF0fer\xF0 mun a\xF0eins hafa \xE1hrif \xE1 n\xFDja notendur.",
        calloutInvitationCountLabel: "Bi\xF0bo\xF0 send til notenda: {{count}}",
        calloutSuggestionCountLabel: "Bi\xF0till\xF6gur sendar til notenda: {{count}}",
        manualInvitationOption__description: "Notendur geta a\xF0eins veri\xF0 bo\xF0nir handvirkt \xED samt\xF6kin.",
        manualInvitationOption__label: "Engin sj\xE1lfvirk skr\xE1ning",
        subtitle: "Veldu hvernig notendur fr\xE1 \xFEessu l\xE9ni geta gengi\xF0 \xED samt\xF6kin."
      },
      start: {
        headerTitle__danger: "H\xE6tta",
        headerTitle__enrollment: "Skr\xE1ningarm\xF6guleikar"
      },
      subtitle: "L\xE9ni\xF0 {{domain}} er n\xFA sta\xF0fest. Haltu \xE1fram me\xF0 \xFEv\xED a\xF0 velja skr\xE1ningarm\xE1ta.",
      title: "Uppf\xE6ra {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 netfangi\xF0 \xFEitt",
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "L\xE9ni\xF0 {{domainName}} \xFEarf a\xF0 vera sta\xF0fest me\xF0 t\xF6lvup\xF3sti.",
      subtitleVerificationCodeScreen: "Sta\xF0festingark\xF3\xF0i var sendur \xE1 {{emailAddress}}. Sl\xE1\xF0u inn k\xF3\xF0ann til a\xF0 halda \xE1fram.",
      title: "Sta\xF0festa l\xE9n"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Stofna samt\xF6k",
    action__invitationAccept: "Ganga \xED",
    action__manageOrganization: "Stj\xF3rna",
    action__suggestionsAccept: "Bi\xF0ja um a\xF0 ganga \xED",
    notSelected: "Engin samt\xF6k valin",
    personalWorkspace: "Pers\xF3nulegur reikningur",
    suggestionsAcceptedLabel: "B\xED\xF0ur sam\xFEykkis"
  },
  paginationButton__next: "N\xE6sta",
  paginationButton__previous: "Fyrri",
  paginationRowText__displaying: "S\xFDnir",
  paginationRowText__of: "af",
  reverification: {
    alternativeMethods: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__backupCode: void 0,
      blockButton__emailCode: void 0,
      blockButton__password: void 0,
      blockButton__phoneCode: void 0,
      blockButton__totp: void 0,
      getHelp: {
        blockButton__emailSupport: void 0,
        content: void 0,
        title: void 0
      },
      subtitle: void 0,
      title: void 0
    },
    backupCodeMfa: {
      subtitle: void 0,
      title: void 0
    },
    emailCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    noAvailableMethods: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    },
    password: {
      actionLink: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCode: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    phoneCodeMfa: {
      formTitle: void 0,
      resendButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    totpMfa: {
      formTitle: void 0,
      subtitle: void 0,
      title: void 0
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "B\xE6ta vi\xF0 reikningi",
      action__signOutAll: "Skr\xE1 \xFAt af \xF6llum reikningum",
      subtitle: "Veldu reikninginn sem \xFE\xFA vilt halda \xE1fram me\xF0.",
      title: "Veldu reikning"
    },
    alternativeMethods: {
      actionLink: "F\xE1 hj\xE1lp",
      actionText: "Ertu ekki me\xF0 neitt af \xFEessu?",
      blockButton__backupCode: "Nota \xF6ryggisk\xF3\xF0a",
      blockButton__emailCode: "Senda k\xF3\xF0a \xE1 {{identifier}}",
      blockButton__emailLink: "Senda tengil \xE1 {{identifier}}",
      blockButton__passkey: "Skr\xE1 inn me\xF0 lykli",
      blockButton__password: "Skr\xE1 inn me\xF0 lykilor\xF0i",
      blockButton__phoneCode: "Senda SMS k\xF3\xF0a \xE1 {{identifier}}",
      blockButton__totp: "Nota au\xF0kennisforriti\xF0 \xFEitt",
      getHelp: {
        blockButton__emailSupport: "Senda t\xF6lvup\xF3st \xE1 stu\xF0ning",
        content: "Ef \xFE\xFA \xE1tt \xED erfi\xF0leikum me\xF0 a\xF0 skr\xE1 \xFEig inn \xE1 reikninginn \xFEinn, sendu okkur t\xF6lvup\xF3st og vi\xF0 munum vinna me\xF0 \xFE\xE9r til a\xF0 endurheimta a\xF0gang eins flj\xF3tt og au\xF0i\xF0 er.",
        title: "F\xE1 hj\xE1lp"
      },
      subtitle: "\xC1ttu \xED vandr\xE6\xF0um? \xDE\xFA getur nota\xF0 einhverja af \xFEessum a\xF0fer\xF0um til a\xF0 skr\xE1 \xFEig inn.",
      title: "Nota a\xF0ra a\xF0fer\xF0"
    },
    backupCodeMfa: {
      subtitle: "\xD6ryggisk\xF3\xF0inn \xFEinn er s\xE1 sem \xFE\xFA f\xE9kkst \xFEegar \xFE\xFA stilltir tveggja \xFErepa au\xF0kenningu.",
      title: "Sl\xE1\xF0u inn \xF6ryggisk\xF3\xF0a"
    },
    emailCode: {
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "til a\xF0 halda \xE1fram \xED {{applicationName}}",
      title: "Athuga\xF0u t\xF6lvup\xF3stinn \xFEinn"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Til a\xF0 halda \xE1fram, opna\xF0u sta\xF0festingartengilinn \xE1 t\xE6kinu og vafranum sem \xFE\xFA byrja\xF0ir innskr\xE1ninguna me\xF0",
        title: "Sta\xF0festingartengill er \xF3gildur fyrir \xFEetta t\xE6ki"
      },
      expired: {
        subtitle: "Far\xF0u aftur \xED upprunalega flipann til a\xF0 halda \xE1fram.",
        title: "\xDEessi sta\xF0festingartengill er \xFAtrunninn"
      },
      failed: {
        subtitle: "Far\xF0u aftur \xED upprunalega flipann til a\xF0 halda \xE1fram.",
        title: "\xDEessi sta\xF0festingartengill er \xF3gildur"
      },
      formSubtitle: "Nota sta\xF0festingartengilinn sem sendur var \xE1 t\xF6lvup\xF3stinn \xFEinn",
      formTitle: "Sta\xF0festingartengill",
      loading: {
        subtitle: "\xDE\xFA ver\xF0ur flj\xF3tlega v\xEDsa\xF0 \xE1fram",
        title: "Skr\xE1 inn..."
      },
      resendButton: "F\xE9kkstu ekki tengil? Senda aftur",
      subtitle: "til a\xF0 halda \xE1fram \xED {{applicationName}}",
      title: "Athuga\xF0u t\xF6lvup\xF3stinn \xFEinn",
      unusedTab: {
        title: "\xDE\xFA getur loka\xF0 \xFEessum flipa"
      },
      verified: {
        subtitle: "\xDE\xFA ver\xF0ur flj\xF3tlega v\xEDsa\xF0 \xE1fram",
        title: "T\xF3kst a\xF0 skr\xE1 inn"
      },
      verifiedSwitchTab: {
        subtitle: "Far\xF0u aftur \xED upprunalega flipann til a\xF0 halda \xE1fram",
        subtitleNewTab: "Far\xF0u aftur \xED n\xFDopna\xF0a flipann til a\xF0 halda \xE1fram",
        titleNewTab: "Skr\xE1\xF0ur inn \xE1 \xF6\xF0rum flipa"
      }
    },
    forgotPassword: {
      formTitle: "Endurstilla lykilor\xF0 k\xF3\xF0a",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "til a\xF0 endurstilla lykilor\xF0i\xF0 \xFEitt",
      subtitle_email: "Fyrst, sl\xE1\xF0u inn k\xF3\xF0ann sem sendur var \xE1 netfangi\xF0 \xFEitt",
      subtitle_phone: "Fyrst, sl\xE1\xF0u inn k\xF3\xF0ann sem sendur var \xE1 s\xEDmann \xFEinn",
      title: "Endurstilla lykilor\xF0"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Endurstilla lykilor\xF0i\xF0 \xFEitt",
      label__alternativeMethods: "E\xF0a, skr\xE1\xF0u \xFEig inn me\xF0 annarri a\xF0fer\xF0",
      title: "Gleymt lykilor\xF0?"
    },
    noAvailableMethods: {
      message: "Ekki er h\xE6gt a\xF0 halda \xE1fram me\xF0 innskr\xE1ningu. Engin tilt\xE6k au\xF0kenningara\xF0fer\xF0.",
      subtitle: "Villa kom upp",
      title: "Ekki h\xE6gt a\xF0 skr\xE1 inn"
    },
    passkey: {
      subtitle: "A\xF0 nota lykilinn \xFEinn sta\xF0festir a\xF0 \xFE\xFA ert \xFEa\xF0. T\xE6ki\xF0 \xFEitt g\xE6ti be\xF0i\xF0 um fingrafar, andlit e\xF0a skj\xE1l\xE1s.",
      title: "Nota lykilinn \xFEinn"
    },
    password: {
      actionLink: "Nota a\xF0ra a\xF0fer\xF0",
      subtitle: "Sl\xE1\xF0u inn lykilor\xF0i\xF0 sem tengist reikningnum \xFE\xEDnum",
      title: "Sl\xE1\xF0u inn lykilor\xF0i\xF0 \xFEitt"
    },
    passwordPwned: {
      title: "Lykilor\xF0 broti\xF0"
    },
    phoneCode: {
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "til a\xF0 halda \xE1fram \xED {{applicationName}}",
      title: "Athuga\xF0u s\xEDmann \xFEinn"
    },
    phoneCodeMfa: {
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "Til a\xF0 halda \xE1fram, vinsamlegast sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 s\xEDmann \xFEinn",
      title: "Athuga\xF0u s\xEDmann \xFEinn"
    },
    resetPassword: {
      formButtonPrimary: "Endurstilla lykilor\xF0",
      requiredMessage: "Af \xF6ryggis\xE1st\xE6\xF0um er nau\xF0synlegt a\xF0 endurstilla lykilor\xF0i\xF0 \xFEitt.",
      successMessage: "Lykilor\xF0i\xF0 \xFEitt var endurstillt me\xF0 g\xF3\xF0um \xE1rangri. Skr\xE1 \xFEig inn, vinsamlegast b\xEDddu augnablik.",
      title: "Setja n\xFDtt lykilor\xF0"
    },
    resetPasswordMfa: {
      detailsLabel: "Vi\xF0 \xFEurfum a\xF0 sta\xF0festa au\xF0kenni \xFEitt \xE1\xF0ur en vi\xF0 endurstillum lykilor\xF0i\xF0 \xFEitt."
    },
    start: {
      actionLink: "Skr\xE1 sig",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Nota netfang",
      actionLink__use_email_username: "Nota netfang e\xF0a notendanafn",
      actionLink__use_passkey: "Nota lykil \xED sta\xF0inn",
      actionLink__use_phone: "Nota s\xEDma",
      actionLink__use_username: "Nota notendanafn",
      actionText: "Ertu ekki me\xF0 reikning?",
      actionText__join_waitlist: void 0,
      subtitle: "Velkomin aftur! Vinsamlegast skr\xE1\xF0u \xFEig inn til a\xF0 halda \xE1fram",
      subtitleCombined: void 0,
      title: "Skr\xE1 inn \xED {{applicationName}}",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      subtitle: "Til a\xF0 halda \xE1fram, vinsamlegast sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem au\xF0kennisforriti\xF0 \xFEitt bj\xF3 til",
      title: "Tveggja \xFErepa au\xF0kenning"
    }
  },
  signInEnterPasswordTitle: "Sl\xE1\xF0u inn lykilor\xF0i\xF0 \xFEitt",
  signUp: {
    continue: {
      actionLink: "Skr\xE1 inn",
      actionText: "Ertu me\xF0 reikning?",
      subtitle: "Vinsamlegast fylltu \xFAt eftirfarandi uppl\xFDsingar til a\xF0 halda \xE1fram.",
      title: "Fylltu \xFAt vantar reiti"
    },
    emailCode: {
      formSubtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 netfangi\xF0 \xFEitt",
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 netfangi\xF0 \xFEitt",
      title: "Sta\xF0festa netfang"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Til a\xF0 halda \xE1fram, opna\xF0u sta\xF0festingartengilinn \xE1 t\xE6kinu og vafranum sem \xFE\xFA byrja\xF0ir skr\xE1ninguna me\xF0",
        title: "Sta\xF0festingartengill er \xF3gildur fyrir \xFEetta t\xE6ki"
      },
      formSubtitle: "Nota sta\xF0festingartengilinn sem sendur var \xE1 netfangi\xF0 \xFEitt",
      formTitle: "Sta\xF0festingartengill",
      loading: {
        title: "Skr\xE1 sig..."
      },
      resendButton: "F\xE9kkstu ekki tengil? Senda aftur",
      subtitle: "til a\xF0 halda \xE1fram \xED {{applicationName}}",
      title: "Sta\xF0festa netfang",
      verified: {
        title: "T\xF3kst a\xF0 skr\xE1 sig"
      },
      verifiedSwitchTab: {
        subtitle: "Far\xF0u aftur \xED n\xFDopna\xF0a flipann til a\xF0 halda \xE1fram",
        subtitleNewTab: "Far\xF0u aftur \xED fyrri flipann til a\xF0 halda \xE1fram",
        title: "T\xF3kst a\xF0 sta\xF0festa netfang"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: void 0,
        label__onlyTermsOfService: void 0,
        label__termsOfServiceAndPrivacyPolicy: void 0
      },
      continue: {
        subtitle: void 0,
        title: void 0
      }
    },
    phoneCode: {
      formSubtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 s\xEDman\xFAmeri\xF0 \xFEitt",
      formTitle: "Sta\xF0festingark\xF3\xF0i",
      resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
      subtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 s\xEDman\xFAmeri\xF0 \xFEitt",
      title: "Sta\xF0festa s\xEDman\xFAmer"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Skr\xE1 inn",
      actionLink__use_email: "Nota netfang \xED sta\xF0inn",
      actionLink__use_phone: "Nota s\xEDma \xED sta\xF0inn",
      actionText: "Ertu me\xF0 reikning?",
      subtitle: "Velkomin! Vinsamlegast fylltu \xFAt uppl\xFDsingar til a\xF0 byrja.",
      subtitleCombined: "Velkomin! Vinsamlegast fylltu \xFAt uppl\xFDsingar til a\xF0 byrja.",
      title: "Stofna reikning",
      titleCombined: "Stofna reikning"
    }
  },
  socialButtonsBlockButton: "Halda \xE1fram me\xF0 {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: void 0,
    captcha_invalid: "Skr\xE1ning mist\xF3kst vegna misheppna\xF0ra \xF6ryggissta\xF0festinga. Vinsamlegast endurhla\xF0i\xF0 s\xED\xF0una til a\xF0 reyna aftur e\xF0a hafi\xF0 samband vi\xF0 stu\xF0ning til a\xF0 f\xE1 frekari a\xF0sto\xF0.",
    captcha_unavailable: "Skr\xE1ning mist\xF3kst vegna misheppna\xF0rar v\xE9lmenna sta\xF0festingar. Vinsamlegast endurhla\xF0i\xF0 s\xED\xF0una til a\xF0 reyna aftur e\xF0a hafi\xF0 samband vi\xF0 stu\xF0ning til a\xF0 f\xE1 frekari a\xF0sto\xF0.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "\xDEetta netfang er \xFEegar \xED notkun. Vinsamlegast reyndu anna\xF0.",
    form_identifier_exists__phone_number: "\xDEetta s\xEDman\xFAmer er \xFEegar \xED notkun. Vinsamlegast reyndu anna\xF0.",
    form_identifier_exists__username: "\xDEetta notendanafn er \xFEegar \xED notkun. Vinsamlegast reyndu anna\xF0.",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Netfang ver\xF0ur a\xF0 vera gilt netfang.",
    form_param_format_invalid__phone_number: "S\xEDman\xFAmer ver\xF0ur a\xF0 vera \xE1 giltu al\xFEj\xF3\xF0legu formi",
    form_param_max_length_exceeded__first_name: "Fornafn m\xE1 ekki vera lengra en 256 stafir.",
    form_param_max_length_exceeded__last_name: "Eftirnafn m\xE1 ekki vera lengra en 256 stafir.",
    form_param_max_length_exceeded__name: "Nafn m\xE1 ekki vera lengra en 256 stafir.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Lykilor\xF0i\xF0 \xFEitt er ekki n\xF3gu sterkt.",
    form_password_pwned: "\xDEetta lykilor\xF0 hefur fundist sem hluti af \xF6ryggisbresti og m\xE1 ekki nota, vinsamlegast reyndu anna\xF0 lykilor\xF0.",
    form_password_pwned__sign_in: "\xDEetta lykilor\xF0 hefur fundist sem hluti af \xF6ryggisbresti og m\xE1 ekki nota, vinsamlegast endurstilltu lykilor\xF0i\xF0 \xFEitt.",
    form_password_size_in_bytes_exceeded: "Lykilor\xF0i\xF0 \xFEitt hefur fari\xF0 yfir h\xE1marksfj\xF6lda b\xE6ta sem leyf\xF0ir eru, vinsamlegast styttu \xFEa\xF0 e\xF0a fjarl\xE6g\xF0u nokkra s\xE9rstafi.",
    form_password_validation_failed: "Rangt lykilor\xF0",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "\xDE\xFA getur ekki eytt s\xED\xF0asta au\xF0kenni \xFE\xEDnu.",
    not_allowed_access: void 0,
    organization_domain_blocked: void 0,
    organization_domain_common: void 0,
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: void 0,
    organization_minimum_permissions_needed: void 0,
    passkey_already_exists: "Lykill er \xFEegar skr\xE1\xF0ur me\xF0 \xFEessu t\xE6ki.",
    passkey_not_supported: "Lyklar eru ekki studdir \xE1 \xFEessu t\xE6ki.",
    passkey_pa_not_supported: "Skr\xE1ning krefst vettvangs au\xF0kennis en t\xE6ki\xF0 sty\xF0ur \xFEa\xF0 ekki.",
    passkey_registration_cancelled: "Skr\xE1ning lykils var h\xE6tt e\xF0a rann \xFAt.",
    passkey_retrieval_cancelled: "Sta\xF0festing lykils var h\xE6tt e\xF0a rann \xFAt.",
    passwordComplexity: {
      maximumLength: "minna en {{length}} stafir",
      minimumLength: "{{length}} e\xF0a fleiri stafir",
      requireLowercase: "l\xE1gstaf",
      requireNumbers: "t\xF6lu",
      requireSpecialCharacter: "s\xE9rstaf",
      requireUppercase: "h\xE1staf",
      sentencePrefix: "Lykilor\xF0i\xF0 \xFEitt ver\xF0ur a\xF0 innihalda"
    },
    phone_number_exists: "\xDEetta s\xEDman\xFAmer er \xFEegar \xED notkun. Vinsamlegast reyndu anna\xF0.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Lykilor\xF0i\xF0 \xFEitt virkar, en g\xE6ti veri\xF0 sterkara. Reyndu a\xF0 b\xE6ta vi\xF0 fleiri st\xF6fum.",
      goodPassword: "Lykilor\xF0i\xF0 \xFEitt uppfyllir allar nau\xF0synlegar kr\xF6fur.",
      notEnough: "Lykilor\xF0i\xF0 \xFEitt er ekki n\xF3gu sterkt.",
      suggestions: {
        allUppercase: "St\xF3rstafa sum, en ekki alla stafi.",
        anotherWord: "B\xE6ttu vi\xF0 fleiri or\xF0um sem eru minna algeng.",
        associatedYears: "For\xF0astu \xE1r sem tengjast \xFE\xE9r.",
        capitalization: "St\xF3rstafa fleiri en fyrsta staf.",
        dates: "For\xF0astu dagsetningar og \xE1r sem tengjast \xFE\xE9r.",
        l33t: "For\xF0astu fyrirsj\xE1anlegar stafaskiptingar eins og '@' fyrir 'a'.",
        longerKeyboardPattern: "Nota\xF0u lengri lyklabor\xF0smynstur og breyttu sl\xE1ttarstefnu nokkrum sinnum.",
        noNeed: "\xDE\xFA getur b\xFAi\xF0 til sterk lykilor\xF0 \xE1n \xFEess a\xF0 nota t\xE1kn, t\xF6lur e\xF0a h\xE1stafi.",
        pwned: "Ef \xFE\xFA notar \xFEetta lykilor\xF0 annars sta\xF0ar, \xE6ttir \xFE\xFA a\xF0 breyta \xFEv\xED.",
        recentYears: "For\xF0astu n\xFDleg \xE1r.",
        repeated: "For\xF0astu endurtekin or\xF0 og stafi.",
        reverseWords: "For\xF0astu \xF6fug stafsetning algengra or\xF0a.",
        sequences: "For\xF0astu algengar stafara\xF0ir.",
        useWords: "Nota\xF0u m\xF6rg or\xF0, en for\xF0astu algengar setningar."
      },
      warnings: {
        common: "\xDEetta er algengt lykilor\xF0.",
        commonNames: "Algeng n\xF6fn og eftirn\xF6fn eru au\xF0velt a\xF0 giska \xE1.",
        dates: "Dagsetningar eru au\xF0velt a\xF0 giska \xE1.",
        extendedRepeat: 'Endurtekin stafamynstur eins og "abcabcabc" eru au\xF0velt a\xF0 giska \xE1.',
        keyPattern: "Stutt lyklabor\xF0smynstur eru au\xF0velt a\xF0 giska \xE1.",
        namesByThemselves: "Einst\xF6k n\xF6fn e\xF0a eftirn\xF6fn eru au\xF0velt a\xF0 giska \xE1.",
        pwned: "Lykilor\xF0i\xF0 \xFEitt var afhj\xFApa\xF0 \xED \xF6ryggisbresti \xE1 netinu.",
        recentYears: "N\xFDleg \xE1r eru au\xF0velt a\xF0 giska \xE1.",
        sequences: 'Algengar stafara\xF0ir eins og "abc" eru au\xF0velt a\xF0 giska \xE1.',
        similarToCommon: "\xDEetta er svipa\xF0 og algengt lykilor\xF0.",
        simpleRepeat: 'Endurteknir stafir eins og "aaa" eru au\xF0velt a\xF0 giska \xE1.',
        straightRow: "Beinar ra\xF0ir af lyklum \xE1 lyklabor\xF0inu eru au\xF0velt a\xF0 giska \xE1.",
        topHundred: "\xDEetta er oft nota\xF0 lykilor\xF0.",
        topTen: "\xDEetta er mj\xF6g oft nota\xF0 lykilor\xF0.",
        userInputs: "\xDEa\xF0 \xE6tti ekki a\xF0 vera neinar pers\xF3nulegar e\xF0a s\xED\xF0u tengdar uppl\xFDsingar.",
        wordByItself: "Einst\xF6k or\xF0 eru au\xF0velt a\xF0 giska \xE1."
      }
    }
  },
  userButton: {
    action__addAccount: "B\xE6ta vi\xF0 reikningi",
    action__manageAccount: "Stj\xF3rna reikningi",
    action__signOut: "Skr\xE1 \xFAt",
    action__signOutAll: "Skr\xE1 \xFAt af \xF6llum reikningum"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Afrita\xF0!",
      actionLabel__copy: "Afrita allt",
      actionLabel__download: "S\xE6kja .txt",
      actionLabel__print: "Prenta",
      infoText1: "\xD6ryggisk\xF3\xF0ar ver\xF0a virkja\xF0ir fyrir \xFEennan reikning.",
      infoText2: "Geymdu \xF6ryggisk\xF3\xF0ana leynilega og geymdu \xFE\xE1 \xE1 \xF6ruggum sta\xF0. \xDE\xFA getur endurmynda\xF0 \xF6ryggisk\xF3\xF0a ef \xFE\xFA grunar a\xF0 \xFEeir hafi veri\xF0 afhj\xFApa\xF0ir.",
      subtitle__codelist: "Geymdu \xFE\xE1 \xE1 \xF6ruggum sta\xF0 og haltu \xFEeim leynilegum.",
      successMessage: "\xD6ryggisk\xF3\xF0ar eru n\xFA virkja\xF0ir. \xDE\xFA getur nota\xF0 einn af \xFEessum til a\xF0 skr\xE1 \xFEig inn \xE1 reikninginn \xFEinn, ef \xFE\xFA missir a\xF0gang a\xF0 au\xF0kennis t\xE6kinu \xFE\xEDnu. Hver k\xF3\xF0i getur a\xF0eins veri\xF0 nota\xF0ur einu sinni.",
      successSubtitle: "\xDE\xFA getur nota\xF0 einn af \xFEessum til a\xF0 skr\xE1 \xFEig inn \xE1 reikninginn \xFEinn, ef \xFE\xFA missir a\xF0gang a\xF0 au\xF0kennis t\xE6kinu \xFE\xEDnu.",
      title: "B\xE6ta vi\xF0 \xF6ryggisk\xF3\xF0a sta\xF0festingu",
      title__codelist: "\xD6ryggisk\xF3\xF0ar"
    },
    connectedAccountPage: {
      formHint: "Veldu \xFEj\xF3nustua\xF0ila til a\xF0 tengja reikninginn \xFEinn.",
      formHint__noAccounts: "Engir tilt\xE6kir ytri reiknings\xFEj\xF3nustua\xF0ilar.",
      removeResource: {
        messageLine1: "{{identifier}} ver\xF0ur fjarl\xE6gt \xFAr \xFEessum reikningi.",
        messageLine2: "\xDE\xFA munt ekki lengur geta nota\xF0 \xFEennan tengda reikning og \xF6ll h\xE1\xF0 eiginleikar munu ekki lengur virka.",
        successMessage: "{{connectedAccount}} hefur veri\xF0 fjarl\xE6gt \xFAr reikningnum \xFE\xEDnum.",
        title: "Fjarl\xE6gja tengdan reikning"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "\xDEj\xF3nustua\xF0ilinn hefur veri\xF0 b\xE6tt vi\xF0 reikninginn \xFEinn",
      title: "B\xE6ta vi\xF0 tengdum reikningi"
    },
    deletePage: {
      actionDescription: 'Sl\xE1\xF0u inn "Ey\xF0a reikningi" h\xE9r a\xF0 ne\xF0an til a\xF0 halda \xE1fram.',
      confirm: "Ey\xF0a reikningi",
      messageLine1: "Ertu viss um a\xF0 \xFE\xFA viljir ey\xF0a reikningnum \xFE\xEDnum?",
      messageLine2: "\xDEessi a\xF0ger\xF0 er varanleg og \xF3afturkr\xE6f.",
      title: "Ey\xF0a reikningi"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "T\xF6lvup\xF3stur sem inniheldur sta\xF0festingark\xF3\xF0a ver\xF0ur sendur \xE1 \xFEetta netfang.",
        formSubtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 {{identifier}}",
        formTitle: "Sta\xF0festingark\xF3\xF0i",
        resendButton: "F\xE9kkstu ekki k\xF3\xF0a? Senda aftur",
        successMessage: "Netfangi\xF0 {{identifier}} hefur veri\xF0 b\xE6tt vi\xF0 reikninginn \xFEinn."
      },
      emailLink: {
        formHint: "T\xF6lvup\xF3stur sem inniheldur sta\xF0festingartengil ver\xF0ur sendur \xE1 \xFEetta netfang.",
        formSubtitle: "Smelltu \xE1 sta\xF0festingartengilinn \xED t\xF6lvup\xF3stinum sem sendur var \xE1 {{identifier}}",
        formTitle: "Sta\xF0festingartengill",
        resendButton: "F\xE9kkstu ekki tengil? Senda aftur",
        successMessage: "Netfangi\xF0 {{identifier}} hefur veri\xF0 b\xE6tt vi\xF0 reikninginn \xFEinn."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} ver\xF0ur fjarl\xE6gt \xFAr \xFEessum reikningi.",
        messageLine2: "\xDE\xFA munt ekki lengur geta skr\xE1\xF0 \xFEig inn me\xF0 \xFEessu netfangi.",
        successMessage: "{{emailAddress}} hefur veri\xF0 fjarl\xE6gt \xFAr reikningnum \xFE\xEDnum.",
        title: "Fjarl\xE6gja netfang"
      },
      title: "B\xE6ta vi\xF0 netfangi",
      verifyTitle: "Sta\xF0festa netfang"
    },
    formButtonPrimary__add: "B\xE6ta vi\xF0",
    formButtonPrimary__continue: "Halda \xE1fram",
    formButtonPrimary__finish: "Lj\xFAka",
    formButtonPrimary__remove: "Fjarl\xE6gja",
    formButtonPrimary__save: "Vista",
    formButtonReset: "H\xE6tta vi\xF0",
    mfaPage: {
      formHint: "Veldu a\xF0fer\xF0 til a\xF0 b\xE6ta vi\xF0.",
      title: "B\xE6ta vi\xF0 tveggja \xFErepa au\xF0kenningu"
    },
    mfaPhoneCodePage: {
      backButton: "Nota n\xFAverandi n\xFAmer",
      primaryButton__addPhoneNumber: "B\xE6ta vi\xF0 s\xEDman\xFAmeri",
      removeResource: {
        messageLine1: "{{identifier}} mun ekki lengur f\xE1 sta\xF0festingark\xF3\xF0a vi\xF0 innskr\xE1ningu.",
        messageLine2: "Reikningurinn \xFEinn g\xE6ti ekki veri\xF0 eins \xF6ruggur. Ertu viss um a\xF0 \xFE\xFA viljir halda \xE1fram?",
        successMessage: "SMS k\xF3\xF0a tveggja \xFErepa au\xF0kenning hefur veri\xF0 fjarl\xE6g\xF0 fyrir {{mfaPhoneCode}}",
        title: "Fjarl\xE6gja tveggja \xFErepa au\xF0kenningu"
      },
      subtitle__availablePhoneNumbers: "Veldu n\xFAverandi s\xEDman\xFAmer til a\xF0 skr\xE1 fyrir SMS k\xF3\xF0a tveggja \xFErepa au\xF0kenningu e\xF0a b\xE6ttu vi\xF0 n\xFDju.",
      subtitle__unavailablePhoneNumbers: "Engin tilt\xE6k s\xEDman\xFAmer til a\xF0 skr\xE1 fyrir SMS k\xF3\xF0a tveggja \xFErepa au\xF0kenningu, vinsamlegast b\xE6ttu vi\xF0 n\xFDju.",
      successMessage1: "Vi\xF0 innskr\xE1ningu \xFEarftu a\xF0 sl\xE1 inn sta\xF0festingark\xF3\xF0a sem sendur er \xE1 \xFEetta s\xEDman\xFAmer sem vi\xF0b\xF3tar skref.",
      successMessage2: "Vista\xF0u \xFEessa \xF6ryggisk\xF3\xF0a og geymdu \xFE\xE1 \xE1 \xF6ruggum sta\xF0. Ef \xFE\xFA missir a\xF0gang a\xF0 au\xF0kennis t\xE6kinu \xFE\xEDnu, getur \xFE\xFA nota\xF0 \xF6ryggisk\xF3\xF0a til a\xF0 skr\xE1 \xFEig inn.",
      successTitle: "SMS k\xF3\xF0a sta\xF0festing virkja\xF0",
      title: "B\xE6ta vi\xF0 SMS k\xF3\xF0a sta\xF0festingu"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Skanna QR k\xF3\xF0a \xED sta\xF0inn",
        buttonUnableToScan__nonPrimary: "Getur ekki skanna\xF0 QR k\xF3\xF0a?",
        infoText__ableToScan: "Settu upp n\xFDja innskr\xE1ningara\xF0fer\xF0 \xED au\xF0kennisforritinu \xFE\xEDnu og skanna\xF0u eftirfarandi QR k\xF3\xF0a til a\xF0 tengja \xFEa\xF0 vi\xF0 reikninginn \xFEinn.",
        infoText__unableToScan: "Settu upp n\xFDja innskr\xE1ningara\xF0fer\xF0 \xED au\xF0kennisforritinu \xFE\xEDnu og sl\xE1\xF0u inn lykilinn h\xE9r a\xF0 ne\xF0an.",
        inputLabel__unableToScan1: "Gakktu \xFAr skugga um a\xF0 T\xEDmatengdir e\xF0a Einnota lykilor\xF0 s\xE9u virkja\xF0, og lj\xFAktu s\xED\xF0an vi\xF0 a\xF0 tengja reikninginn \xFEinn.",
        inputLabel__unableToScan2: "A\xF0 \xF6\xF0rum kosti, ef au\xF0kennisforriti\xF0 \xFEitt sty\xF0ur TOTP URI, getur\xF0u einnig afrita\xF0 fullan URI."
      },
      removeResource: {
        messageLine1: "Sta\xF0festingark\xF3\xF0ar fr\xE1 \xFEessu au\xF0kennisforriti ver\xF0a ekki lengur nau\xF0synlegir vi\xF0 innskr\xE1ningu.",
        messageLine2: "Reikningurinn \xFEinn g\xE6ti ekki veri\xF0 eins \xF6ruggur. Ertu viss um a\xF0 \xFE\xFA viljir halda \xE1fram?",
        successMessage: "Tveggja \xFErepa au\xF0kenning me\xF0 au\xF0kennisforriti hefur veri\xF0 fjarl\xE6g\xF0.",
        title: "Fjarl\xE6gja tveggja \xFErepa au\xF0kenningu"
      },
      successMessage: "Tveggja \xFErepa au\xF0kenning er n\xFA virkja\xF0. Vi\xF0 innskr\xE1ningu \xFEarftu a\xF0 sl\xE1 inn sta\xF0festingark\xF3\xF0a fr\xE1 \xFEessu au\xF0kennisforriti sem vi\xF0b\xF3tar skref.",
      title: "B\xE6ta vi\xF0 au\xF0kennisforriti",
      verifySubtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem au\xF0kennisforriti\xF0 \xFEitt bj\xF3 til",
      verifyTitle: "Sta\xF0festingark\xF3\xF0i"
    },
    mobileButton__menu: "Valmynd",
    navbar: {
      account: "Pr\xF3f\xEDll",
      description: "Stj\xF3rna reikningsuppl\xFDsingum \xFE\xEDnum.",
      security: "\xD6ryggi",
      title: "Reikningur"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} ver\xF0ur fjarl\xE6gt \xFAr \xFEessum reikningi.",
        title: "Fjarl\xE6gja lykil"
      },
      subtitle__rename: "\xDE\xFA getur breytt nafni lykilsins til a\xF0 au\xF0velda a\xF0 finna hann.",
      title__rename: "Endurnefna lykil"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "M\xE6lt er me\xF0 a\xF0 skr\xE1 \xFEig \xFAt af \xF6llum \xF6\xF0rum t\xE6kjum sem g\xE6tu hafa nota\xF0 gamla lykilor\xF0i\xF0 \xFEitt.",
      readonly: "Lykilor\xF0i\xF0 \xFEitt er ekki h\xE6gt a\xF0 breyta n\xFAna vegna \xFEess a\xF0 \xFE\xFA getur a\xF0eins skr\xE1\xF0 \xFEig inn \xED gegnum fyrirt\xE6kjatengingu.",
      successMessage__set: "Lykilor\xF0i\xF0 \xFEitt hefur veri\xF0 sett.",
      successMessage__signOutOfOtherSessions: "\xD6ll \xF6nnur t\xE6ki hafa veri\xF0 skr\xE1\xF0 \xFAt.",
      successMessage__update: "Lykilor\xF0i\xF0 \xFEitt hefur veri\xF0 uppf\xE6rt.",
      title__set: "Setja lykilor\xF0",
      title__update: "Uppf\xE6ra lykilor\xF0"
    },
    phoneNumberPage: {
      infoText: "SMS sem inniheldur sta\xF0festingark\xF3\xF0a ver\xF0ur sent \xE1 \xFEetta s\xEDman\xFAmer. Skilabo\xF0 og gagnagj\xF6ld geta \xE1tt vi\xF0.",
      removeResource: {
        messageLine1: "{{identifier}} ver\xF0ur fjarl\xE6gt \xFAr \xFEessum reikningi.",
        messageLine2: "\xDE\xFA munt ekki lengur geta skr\xE1\xF0 \xFEig inn me\xF0 \xFEessu s\xEDman\xFAmeri.",
        successMessage: "{{phoneNumber}} hefur veri\xF0 fjarl\xE6gt \xFAr reikningnum \xFE\xEDnum.",
        title: "Fjarl\xE6gja s\xEDman\xFAmer"
      },
      successMessage: "{{identifier}} hefur veri\xF0 b\xE6tt vi\xF0 reikninginn \xFEinn.",
      title: "B\xE6ta vi\xF0 s\xEDman\xFAmeri",
      verifySubtitle: "Sl\xE1\xF0u inn sta\xF0festingark\xF3\xF0ann sem sendur var \xE1 {{identifier}}",
      verifyTitle: "Sta\xF0festa s\xEDman\xFAmer"
    },
    profilePage: {
      fileDropAreaHint: "M\xE6lt st\xE6r\xF0 1:1, allt a\xF0 10MB.",
      imageFormDestructiveActionSubtitle: "Fjarl\xE6gja",
      imageFormSubtitle: "Hla\xF0a upp",
      imageFormTitle: "Pr\xF3f\xEDlmynd",
      readonly: "Pr\xF3f\xEDluppl\xFDsingar \xFE\xEDnar hafa veri\xF0 veittar af fyrirt\xE6kjatengingu og er ekki h\xE6gt a\xF0 breyta.",
      successMessage: "Pr\xF3f\xEDllinn \xFEinn hefur veri\xF0 uppf\xE6r\xF0ur.",
      title: "Uppf\xE6ra pr\xF3f\xEDl"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Skr\xE1 \xFAt af t\xE6ki",
        title: "Virk t\xE6ki"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Endurtengja",
        actionLabel__reauthorize: "Heimila n\xFAna",
        destructiveActionTitle: "Fjarl\xE6gja",
        primaryButton: "Tengja reikning",
        subtitle__disconnected: "\xDEessi reikningur hefur veri\xF0 aftengdur.",
        subtitle__reauthorize: "Nau\xF0synlegar heimildir hafa veri\xF0 uppf\xE6r\xF0ar, og \xFE\xFA g\xE6tir veri\xF0 a\xF0 upplifa takmarka\xF0a virkni. Vinsamlegast endurheimila\xF0u \xFEetta forrit til a\xF0 for\xF0ast vandam\xE1l",
        title: "Tengdir reikningar"
      },
      dangerSection: {
        deleteAccountButton: "Ey\xF0a reikningi",
        title: "Ey\xF0a reikningi"
      },
      emailAddressesSection: {
        destructiveAction: "Fjarl\xE6gja netfang",
        detailsAction__nonPrimary: "Setja sem a\xF0al",
        detailsAction__primary: "Lj\xFAka sta\xF0festingu",
        detailsAction__unverified: "Sta\xF0festa",
        primaryButton: "B\xE6ta vi\xF0 netfangi",
        title: "Netf\xF6ng"
      },
      enterpriseAccountsSection: {
        title: "Fyrirt\xE6kjareikningar"
      },
      headerTitle__account: "Pr\xF3f\xEDluppl\xFDsingar",
      headerTitle__security: "\xD6ryggi",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Endurmynda",
          headerTitle: "\xD6ryggisk\xF3\xF0ar",
          subtitle__regenerate: "F\xE1\xF0u n\xFDtt sett af \xF6ruggum \xF6ryggisk\xF3\xF0um. Fyrri \xF6ryggisk\xF3\xF0ar ver\xF0a eyttir og ekki h\xE6gt a\xF0 nota.",
          title__regenerate: "Endurmynda \xF6ryggisk\xF3\xF0a"
        },
        phoneCode: {
          actionLabel__setDefault: "Setja sem sj\xE1lfgefi\xF0",
          destructiveActionLabel: "Fjarl\xE6gja"
        },
        primaryButton: "B\xE6ta vi\xF0 tveggja \xFErepa au\xF0kenningu",
        title: "Tveggja \xFErepa au\xF0kenning",
        totp: {
          destructiveActionTitle: "Fjarl\xE6gja",
          headerTitle: "Au\xF0kennisforrit"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Fjarl\xE6gja",
        menuAction__rename: "Endurnefna",
        primaryButton: void 0,
        title: "Lyklar"
      },
      passwordSection: {
        primaryButton__setPassword: "Setja lykilor\xF0",
        primaryButton__updatePassword: "Uppf\xE6ra lykilor\xF0",
        title: "Lykilor\xF0"
      },
      phoneNumbersSection: {
        destructiveAction: "Fjarl\xE6gja s\xEDman\xFAmer",
        detailsAction__nonPrimary: "Setja sem a\xF0al",
        detailsAction__primary: "Lj\xFAka sta\xF0festingu",
        detailsAction__unverified: "Sta\xF0festa s\xEDman\xFAmer",
        primaryButton: "B\xE6ta vi\xF0 s\xEDman\xFAmeri",
        title: "S\xEDman\xFAmer"
      },
      profileSection: {
        primaryButton: "Uppf\xE6ra pr\xF3f\xEDl",
        title: "Pr\xF3f\xEDll"
      },
      usernameSection: {
        primaryButton__setUsername: "Setja notendanafn",
        primaryButton__updateUsername: "Uppf\xE6ra notendanafn",
        title: "Notendanafn"
      },
      web3WalletsSection: {
        destructiveAction: "Fjarl\xE6gja veski",
        primaryButton: "Web3 veski",
        title: "Web3 veski"
      }
    },
    usernamePage: {
      successMessage: "Notendanafni\xF0 \xFEitt hefur veri\xF0 uppf\xE6rt.",
      title__set: "Setja notendanafn",
      title__update: "Uppf\xE6ra notendanafn"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} ver\xF0ur fjarl\xE6gt \xFAr \xFEessum reikningi.",
        messageLine2: "\xDE\xFA munt ekki lengur geta skr\xE1\xF0 \xFEig inn me\xF0 \xFEessu web3 veski.",
        successMessage: "{{web3Wallet}} hefur veri\xF0 fjarl\xE6gt \xFAr reikningnum \xFE\xEDnum.",
        title: "Fjarl\xE6gja web3 veski"
      },
      subtitle__availableWallets: "Veldu web3 veski til a\xF0 tengja vi\xF0 reikninginn \xFEinn.",
      subtitle__unavailableWallets: "Engin tilt\xE6k web3 veski.",
      successMessage: "Veski\xF0 hefur veri\xF0 b\xE6tt vi\xF0 reikninginn \xFEinn.",
      title: "B\xE6ta vi\xF0 web3 veski",
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/hr-HR.ts
var hrHR = {
  locale: "hr-HR",
  backButton: "Natrag",
  badge__default: "Zadano",
  badge__otherImpersonatorDevice: "Drugi ure\u0111aj za opona\u0161anje",
  badge__primary: "Primarno",
  badge__requiresAction: "Zahtijeva akciju",
  badge__thisDevice: "Ovaj ure\u0111aj",
  badge__unverified: "Nepotvr\u0111eno",
  badge__userDevice: "Korisni\u010Dki ure\u0111aj",
  badge__you: "Vi",
  createOrganization: {
    formButtonSubmit: "kreiraj organizaciju",
    invitePage: {
      formButtonReset: "Presko\u010Di"
    },
    title: "Kreiraj organizaciju"
  },
  dates: {
    lastDay: "Ju\u010Der u {{ date | timeString('hr-HR') }}",
    next6Days: "{{ date | weekday('hr-HR','long') }} u {{ date | timeString('hr-HR') }}",
    nextDay: "Sutra u {{ date | timeString('hr-HR') }}",
    numeric: "{{ date | numeric('hr-HR') }}",
    previous6Days: "Pro\u0161li {{ date | weekday('hr-HR','long') }} u {{ date | timeString('hr-HR') }}",
    sameDay: "Danas u {{ date | timeString('hr-HR') }}"
  },
  dividerText: "ili",
  footerActionLink__useAnotherMethod: "Koristite drugu metodu",
  footerPageLink__help: "Pomo\u0107",
  footerPageLink__privacy: "Privatnost",
  footerPageLink__terms: "Uvjeti",
  formButtonPrimary: "Nastavi",
  formButtonPrimary__verify: "Potvrdi",
  formFieldAction__forgotPassword: "Zaboravili ste lozinku?",
  formFieldError__matchingPasswords: "Lozinke se podudaraju.",
  formFieldError__notMatchingPasswords: "Lozinke se ne podudaraju.",
  formFieldError__verificationLinkExpired: "Verifikacijska poveznica je istekla. Molimo zatra\u017Eite novu poveznicu.",
  formFieldHintText__optional: "Neobavezno",
  formFieldHintText__slug: "Slug je \u010Ditljiv ID koji mora biti jedinstven. \u010Cesto se koristi u URL-ovima.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Izbri\u0161i ra\u010Dun",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "primjer@email.com, primjer2@email.com",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "moja-organizacija",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Omogu\u0107i automatske pozivnice za ovu domenu",
  formFieldLabel__backupCode: "Rezervni kod",
  formFieldLabel__confirmDeletion: "Potvrda",
  formFieldLabel__confirmPassword: "Potvrdi lozinku",
  formFieldLabel__currentPassword: "Trenutna lozinka",
  formFieldLabel__emailAddress: "E-mail adresa",
  formFieldLabel__emailAddress_username: "E-mail adresa ili korisni\u010Dko ime",
  formFieldLabel__emailAddresses: "E-mail adrese",
  formFieldLabel__firstName: "Ime",
  formFieldLabel__lastName: "Prezime",
  formFieldLabel__newPassword: "Nova lozinka",
  formFieldLabel__organizationDomain: "Domena",
  formFieldLabel__organizationDomainDeletePending: "Izbri\u0161i prijedloge i pozivnice na \u010Dekanju",
  formFieldLabel__organizationDomainEmailAddress: "E-mail adresa za verifikaciju",
  formFieldLabel__organizationDomainEmailAddressDescription: "Unesite e-mail adresu pod ovom domenom kako biste primili kod i potvrdili ovu domenu.",
  formFieldLabel__organizationName: "Naziv",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Naziv pristupnog klju\u010Da",
  formFieldLabel__password: "Lozinka",
  formFieldLabel__phoneNumber: "Telefonski broj",
  formFieldLabel__role: "Uloga",
  formFieldLabel__signOutOfOtherSessions: "Odjavi se sa svih ostalih ure\u0111aja",
  formFieldLabel__username: "Korisni\u010Dko ime",
  impersonationFab: {
    action__signOut: "Odjava",
    title: "Prijavljeni ste kao {{identifier}}"
  },
  maintenanceMode: "Trenutno provodimo odr\u017Eavanje, ali ne brinite, ne bi trebalo trajati du\u017Ee od nekoliko minuta.",
  membershipRole__admin: "Administrator",
  membershipRole__basicMember: "\u010Clan",
  membershipRole__guestMember: "Gost",
  organizationList: {
    action__createOrganization: "Kreiraj organizaciju",
    action__invitationAccept: "Pridru\u017Ei se",
    action__suggestionsAccept: "Zatra\u017Ei pridru\u017Eivanje",
    createOrganization: "Kreiraj organizaciju",
    invitationAcceptedLabel: "Pridru\u017Een",
    subtitle: "za nastavak na {{applicationName}}",
    suggestionsAcceptedLabel: "\u010Ceka odobrenje",
    title: "Odaberite ra\u010Dun",
    titleWithoutPersonal: "Odaberite organizaciju"
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatske pozivnice",
    badge__automaticSuggestion: "Automatski prijedlozi",
    badge__manualInvitation: "Bez automatskog u\u010Dlanjenja",
    badge__unverified: "Nepotvr\u0111eno",
    createDomainPage: {
      subtitle: "Dodajte domenu za provjeru. Korisnici s e-mail adresama na ovoj domeni mogu se automatski pridru\u017Eiti organizaciji ili zatra\u017Eiti pridru\u017Eivanje.",
      title: "Dodaj domenu"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Pozivnice se nisu mogle poslati. Ve\u0107 postoje pozivnice na \u010Dekanju za sljede\u0107e e-mail adrese: {{email_addresses}}.",
      formButtonPrimary__continue: "Po\u0161alji pozivnice",
      selectDropdown__role: "Odaberi ulogu",
      subtitle: "Unesite ili zalijepite jednu ili vi\u0161e e-mail adresa, odvojenih razmakom ili zarezom.",
      successMessage: "Pozivnice uspje\u0161no poslane",
      title: "Pozovi nove \u010Dlanove"
    },
    membersPage: {
      action__invite: "Pozovi",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Ukloni \u010Dlana",
        tableHeader__actions: void 0,
        tableHeader__joined: "Pridru\u017Een",
        tableHeader__role: "Uloga",
        tableHeader__user: "Korisnik"
      },
      detailsTitle__emptyRow: "Nema \u010Dlanova za prikaz",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Pozovite korisnike povezivanjem e-mail domene s va\u0161om organizacijom. Svatko tko se prijavi s odgovaraju\u0107om e-mail domenom mo\u0107i \u0107e se pridru\u017Eiti organizaciji u bilo kojem trenutku.",
          headerTitle: "Automatske pozivnice",
          primaryButton: "Upravljaj potvr\u0111enim domenama"
        },
        table__emptyRow: "Nema pozivnica za prikaz"
      },
      invitedMembersTab: {
        menuAction__revoke: "Opozovi pozivnicu",
        tableHeader__invited: "Pozvan"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Korisnici koji se prijave s odgovaraju\u0107om e-mail domenom mo\u0107i \u0107e vidjeti prijedlog za zahtjev za pridru\u017Eivanje va\u0161oj organizaciji.",
          headerTitle: "Automatski prijedlozi",
          primaryButton: "Upravljaj potvr\u0111enim domenama"
        },
        menuAction__approve: "Odobri",
        menuAction__reject: "Odbij",
        tableHeader__requested: "Zatra\u017Een pristup",
        table__emptyRow: "Nema zahtjeva za prikaz"
      },
      start: {
        headerTitle__invitations: "Pozivnice",
        headerTitle__members: "\u010Clanovi",
        headerTitle__requests: "Zahtjevi"
      }
    },
    navbar: {
      description: "Upravljajte svojom organizacijom.",
      general: "Op\u0107enito",
      members: "\u010Clanovi",
      title: "Organizacija"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Upi\u0161ite "{{organizationName}}" ispod za nastavak.',
          messageLine1: "Jeste li sigurni da \u017Eelite izbrisati ovu organizaciju?",
          messageLine2: "Ova radnja je trajna i nepovratna.",
          successMessage: "Izbrisali ste organizaciju.",
          title: "Izbri\u0161i organizaciju"
        },
        leaveOrganization: {
          actionDescription: 'Upi\u0161ite "{{organizationName}}" ispod za nastavak.',
          messageLine1: "Jeste li sigurni da \u017Eelite napustiti ovu organizaciju? Izgubit \u0107ete pristup ovoj organizaciji i njezinim aplikacijama.",
          messageLine2: "Ova radnja je trajna i nepovratna.",
          successMessage: "Napustili ste organizaciju.",
          title: "Napusti organizaciju"
        },
        title: "Opasnost"
      },
      domainSection: {
        menuAction__manage: "Upravljaj",
        menuAction__remove: "Izbri\u0161i",
        menuAction__verify: "Potvrdi",
        primaryButton: "Dodaj domenu",
        subtitle: "Dopustite korisnicima da se automatski pridru\u017Ee organizaciji ili zatra\u017Ee pridru\u017Eivanje na temelju potvr\u0111ene e-mail domene.",
        title: "Potvr\u0111ene domene"
      },
      successMessage: "Organizacija je a\u017Eurirana.",
      title: "A\u017Euriraj profil"
    },
    removeDomainPage: {
      messageLine1: "E-mail domena {{domain}} bit \u0107e uklonjena.",
      messageLine2: "Korisnici se nakon ovoga ne\u0107e mo\u0107i automatski pridru\u017Eiti organizaciji.",
      successMessage: "{{domain}} je uklonjena.",
      title: "Ukloni domenu"
    },
    start: {
      headerTitle__general: "Op\u0107enito",
      headerTitle__members: "\u010Clanovi",
      profileSection: {
        primaryButton: "A\u017Euriraj profil",
        title: "Profil organizacije",
        uploadAction__title: "Logotip"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Uklanjanje ove domene utjecat \u0107e na pozvane korisnike.",
        removeDomainActionLabel__remove: "Ukloni domenu",
        removeDomainSubtitle: "Ukloni ovu domenu iz va\u0161ih potvr\u0111enih domena",
        removeDomainTitle: "Ukloni domenu"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Korisnici su automatski pozvani da se pridru\u017Ee organizaciji kada se prijave i mogu se pridru\u017Eiti u bilo kojem trenutku.",
        automaticInvitationOption__label: "Automatske pozivnice",
        automaticSuggestionOption__description: "Korisnici primaju prijedlog za zahtjev za pridru\u017Eivanje, ali moraju biti odobreni od strane administratora prije nego \u0161to se mogu pridru\u017Eiti organizaciji.",
        automaticSuggestionOption__label: "Automatski prijedlozi",
        calloutInfoLabel: "Promjena na\u010Dina upisa utjecat \u0107e samo na nove korisnike.",
        calloutInvitationCountLabel: "Pozivnice na \u010Dekanju poslane korisnicima: {{count}}",
        calloutSuggestionCountLabel: "Prijedlozi na \u010Dekanju poslani korisnicima: {{count}}",
        manualInvitationOption__description: "Korisnici mogu biti pozvani u organizaciju samo ru\u010Dno.",
        manualInvitationOption__label: "Bez automatskog upisa",
        subtitle: "Odaberite kako se korisnici s ove domene mogu pridru\u017Eiti organizaciji."
      },
      start: {
        headerTitle__danger: "Opasnost",
        headerTitle__enrollment: "Opcije upisa"
      },
      subtitle: "Domena {{domain}} je sada potvr\u0111ena. Nastavite odabirom na\u010Dina upisa.",
      title: "A\u017Euriraj {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Unesite verifikacijski kod poslan na va\u0161u e-mail adresu",
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "Domena {{domainName}} mora biti potvr\u0111ena putem e-maila.",
      subtitleVerificationCodeScreen: "Verifikacijski kod poslan je na {{emailAddress}}. Unesite kod za nastavak.",
      title: "Potvrdi domenu"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Kreiraj organizaciju",
    action__invitationAccept: "Pridru\u017Ei se",
    action__manageOrganization: "Upravljaj",
    action__suggestionsAccept: "Zatra\u017Ei pridru\u017Eivanje",
    notSelected: "Nije odabrana organizacija",
    personalWorkspace: "Osobni ra\u010Dun",
    suggestionsAcceptedLabel: "\u010Ceka odobrenje"
  },
  paginationButton__next: "Sljede\u0107e",
  paginationButton__previous: "Prethodno",
  paginationRowText__displaying: "Prikazuje se",
  paginationRowText__of: "od",
  reverification: {
    alternativeMethods: {
      actionLink: "Zatra\u017Eite pomo\u0107",
      actionText: "Nemate ni\u0161ta od ovoga?",
      blockButton__backupCode: "Koristite rezervni kod",
      blockButton__emailCode: "Po\u0161alji kod e-po\u0161tom na {{identifier}}",
      blockButton__password: "Nastavite s va\u0161om lozinkom",
      blockButton__phoneCode: "Po\u0161alji SMS kod na {{identifier}}",
      blockButton__totp: "Koristite va\u0161u aplikaciju za autentifikaciju",
      getHelp: {
        blockButton__emailSupport: "Po\u0161alji e-po\u0161tu podr\u0161ci",
        content: "Ako imate problema s verifikacijom va\u0161eg ra\u010Duna, po\u0161aljite nam e-po\u0161tu i radit \u0107emo s vama na vra\u0107anju pristupa \u0161to je prije mogu\u0107e.",
        title: "Zatra\u017Eite pomo\u0107"
      },
      subtitle: "Imate problema? Mo\u017Eete koristiti bilo koju od ovih metoda za verifikaciju.",
      title: "Koristite drugu metodu"
    },
    backupCodeMfa: {
      subtitle: "Va\u0161 rezervni kod je onaj koji ste dobili prilikom postavljanja dvostupanjske autentifikacije.",
      title: "Unesite rezervni kod"
    },
    emailCode: {
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "za nastavak na {{applicationName}}",
      title: "Provjerite svoju e-po\u0161tu"
    },
    noAvailableMethods: {
      message: "Ne mo\u017Ee se nastaviti s verifikacijom. Nema dostupnog faktora autentifikacije.",
      subtitle: "Do\u0161lo je do pogre\u0161ke",
      title: "Ne mo\u017Ee se verificirati va\u0161 ra\u010Dun"
    },
    password: {
      actionLink: "Koristite drugu metodu",
      subtitle: "Unesite lozinku povezanu s va\u0161im ra\u010Dunom",
      title: "Unesite va\u0161u lozinku"
    },
    phoneCode: {
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "za nastavak na {{applicationName}}",
      title: "Provjerite svoj telefon"
    },
    phoneCodeMfa: {
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "Za nastavak, molimo unesite verifikacijski kod poslan na va\u0161 telefon",
      title: "Provjerite svoj telefon"
    },
    totpMfa: {
      formTitle: "Verifikacijski kod",
      subtitle: "Za nastavak, molimo unesite verifikacijski kod generiran va\u0161om aplikacijom za autentifikaciju",
      title: "Dvostupanjska verifikacija"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Dodaj ra\u010Dun",
      action__signOutAll: "Odjavi se sa svih ra\u010Duna",
      subtitle: "Odaberite ra\u010Dun s kojim \u017Eelite nastaviti.",
      title: "Odaberite ra\u010Dun"
    },
    alternativeMethods: {
      actionLink: "Zatra\u017Eite pomo\u0107",
      actionText: "Nemate ni\u0161ta od ovoga?",
      blockButton__backupCode: "Koristite rezervni kod",
      blockButton__emailCode: "Po\u0161alji kod e-po\u0161tom na {{identifier}}",
      blockButton__emailLink: "Po\u0161alji poveznicu e-po\u0161tom na {{identifier}}",
      blockButton__passkey: "Prijavite se svojim pristupnim klju\u010Dem",
      blockButton__password: "Prijavite se svojom lozinkom",
      blockButton__phoneCode: "Po\u0161alji SMS kod na {{identifier}}",
      blockButton__totp: "Koristite svoju aplikaciju za autentifikaciju",
      getHelp: {
        blockButton__emailSupport: "Po\u0161aljite e-po\u0161tu podr\u0161ci",
        content: "Ako imate problema s prijavom na svoj ra\u010Dun, po\u0161aljite nam e-po\u0161tu i radit \u0107emo s vama na vra\u0107anju pristupa \u0161to je prije mogu\u0107e.",
        title: "Zatra\u017Eite pomo\u0107"
      },
      subtitle: "Imate problema? Mo\u017Eete koristiti bilo koju od ovih metoda za prijavu.",
      title: "Koristite drugu metodu"
    },
    backupCodeMfa: {
      subtitle: "Va\u0161 rezervni kod je onaj koji ste dobili prilikom postavljanja dvostupanjske autentifikacije.",
      title: "Unesite rezervni kod"
    },
    emailCode: {
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "za nastavak na {{applicationName}}",
      title: "Provjerite svoju e-po\u0161tu"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Za nastavak, otvorite verifikacijsku poveznicu na ure\u0111aju i pregledniku s kojeg ste zapo\u010Deli prijavu",
        title: "Verifikacijska poveznica nije valjana za ovaj ure\u0111aj"
      },
      expired: {
        subtitle: "Vratite se na izvornu karticu za nastavak.",
        title: "Ova verifikacijska poveznica je istekla"
      },
      failed: {
        subtitle: "Vratite se na izvornu karticu za nastavak.",
        title: "Ova verifikacijska poveznica nije valjana"
      },
      formSubtitle: "Koristite verifikacijsku poveznicu poslanu na va\u0161u e-po\u0161tu",
      formTitle: "Verifikacijska poveznica",
      loading: {
        subtitle: "Uskoro \u0107ete biti preusmjereni",
        title: "Prijava..."
      },
      resendButton: "Niste primili poveznicu? Po\u0161alji ponovno",
      subtitle: "za nastavak na {{applicationName}}",
      title: "Provjerite svoju e-po\u0161tu",
      unusedTab: {
        title: "Mo\u017Eete zatvoriti ovu karticu"
      },
      verified: {
        subtitle: "Uskoro \u0107ete biti preusmjereni",
        title: "Uspje\u0161no prijavljeni"
      },
      verifiedSwitchTab: {
        subtitle: "Vratite se na izvornu karticu za nastavak",
        subtitleNewTab: "Vratite se na novootvorenu karticu za nastavak",
        titleNewTab: "Prijavljeni na drugoj kartici"
      }
    },
    forgotPassword: {
      formTitle: "Kod za resetiranje lozinke",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "za resetiranje va\u0161e lozinke",
      subtitle_email: "Prvo unesite kod poslan na va\u0161u e-mail adresu",
      subtitle_phone: "Prvo unesite kod poslan na va\u0161 telefon",
      title: "Resetiraj lozinku"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Resetirajte svoju lozinku",
      label__alternativeMethods: "Ili se prijavite na drugi na\u010Din",
      title: "Zaboravili ste lozinku?"
    },
    noAvailableMethods: {
      message: "Nije mogu\u0107e nastaviti s prijavom. Nema dostupnog faktora autentifikacije.",
      subtitle: "Do\u0161lo je do pogre\u0161ke",
      title: "Nije mogu\u0107e prijaviti se"
    },
    passkey: {
      subtitle: "Kori\u0161tenje va\u0161eg pristupnog klju\u010Da potvr\u0111uje da ste to vi. Va\u0161 ure\u0111aj mo\u017Ee tra\u017Eiti otisak prsta, prepoznavanje lica ili zaklju\u010Davanje zaslona.",
      title: "Koristite svoj pristupni klju\u010D"
    },
    password: {
      actionLink: "Koristite drugu metodu",
      subtitle: "Unesite lozinku povezanu s va\u0161im ra\u010Dunom",
      title: "Unesite svoju lozinku"
    },
    passwordPwned: {
      title: "Lozinka je kompromitirana"
    },
    phoneCode: {
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "za nastavak na {{applicationName}}",
      title: "Provjerite svoj telefon"
    },
    phoneCodeMfa: {
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "Za nastavak, unesite verifikacijski kod poslan na va\u0161 telefon",
      title: "Provjerite svoj telefon"
    },
    resetPassword: {
      formButtonPrimary: "Resetiraj lozinku",
      requiredMessage: "Iz sigurnosnih razloga, potrebno je resetirati va\u0161u lozinku.",
      successMessage: "Va\u0161a lozinka je uspje\u0161no promijenjena. Prijavljujemo vas, molimo pri\u010Dekajte trenutak.",
      title: "Postavite novu lozinku"
    },
    resetPasswordMfa: {
      detailsLabel: "Moramo potvrditi va\u0161 identitet prije resetiranja lozinke."
    },
    start: {
      actionLink: "Registrirajte se",
      actionLink__join_waitlist: void 0,
      actionLink__use_email: "Koristite e-po\u0161tu",
      actionLink__use_email_username: "Koristite e-po\u0161tu ili korisni\u010Dko ime",
      actionLink__use_passkey: "Koristite pristupni klju\u010D umjesto toga",
      actionLink__use_phone: "Koristite telefon",
      actionLink__use_username: "Koristite korisni\u010Dko ime",
      actionText: "Nemate ra\u010Dun?",
      actionText__join_waitlist: void 0,
      subtitle: "Dobrodo\u0161li natrag! Molimo prijavite se za nastavak",
      subtitleCombined: void 0,
      title: "Prijavite se na {{applicationName}}",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Verifikacijski kod",
      subtitle: "Za nastavak, unesite verifikacijski kod generiran va\u0161om aplikacijom za autentifikaciju",
      title: "Dvostupanjska verifikacija"
    }
  },
  signInEnterPasswordTitle: "Unesite svoju lozinku",
  signUp: {
    continue: {
      actionLink: "Prijavi se",
      actionText: "Ve\u0107 imate ra\u010Dun?",
      subtitle: "Molimo ispunite preostale detalje za nastavak.",
      title: "Ispunite preostala polja"
    },
    emailCode: {
      formSubtitle: "Unesite verifikacijski kod poslan na va\u0161u e-mail adresu",
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "Unesite verifikacijski kod poslan na va\u0161u e-po\u0161tu",
      title: "Potvrdite svoju e-po\u0161tu"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Za nastavak, otvorite verifikacijsku poveznicu na ure\u0111aju i pregledniku s kojeg ste zapo\u010Deli registraciju",
        title: "Verifikacijska poveznica nije valjana za ovaj ure\u0111aj"
      },
      formSubtitle: "Koristite verifikacijsku poveznicu poslanu na va\u0161u e-mail adresu",
      formTitle: "Verifikacijska poveznica",
      loading: {
        title: "Registracija..."
      },
      resendButton: "Niste primili poveznicu? Po\u0161alji ponovno",
      subtitle: "za nastavak na {{applicationName}}",
      title: "Potvrdite svoju e-po\u0161tu",
      verified: {
        title: "Uspje\u0161no registrirani"
      },
      verifiedSwitchTab: {
        subtitle: "Vratite se na novootvorenu karticu za nastavak",
        subtitleNewTab: "Vratite se na prethodnu karticu za nastavak",
        title: "Uspje\u0161no potvr\u0111ena e-po\u0161ta"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Sla\u017Eem se s {{ privacyPolicyLink || link("Politikom privatnosti") }}',
        label__onlyTermsOfService: 'Sla\u017Eem se s {{ termsOfServiceLink || link("Uvjetima kori\u0161tenja") }}',
        label__termsOfServiceAndPrivacyPolicy: 'Sla\u017Eem se s {{ termsOfServiceLink || link("Uvjetima kori\u0161tenja") }} i {{ privacyPolicyLink || link("Politikom privatnosti") }}'
      },
      continue: {
        subtitle: "Molimo pro\u010Ditajte i prihvatite uvjete kako biste nastavili",
        title: "Pravni pristanak"
      }
    },
    phoneCode: {
      formSubtitle: "Unesite verifikacijski kod poslan na va\u0161 broj telefona",
      formTitle: "Verifikacijski kod",
      resendButton: "Niste primili kod? Po\u0161alji ponovno",
      subtitle: "Unesite verifikacijski kod poslan na va\u0161 telefon",
      title: "Potvrdite svoj telefon"
    },
    restrictedAccess: {
      actionLink: void 0,
      actionText: void 0,
      blockButton__emailSupport: void 0,
      blockButton__joinWaitlist: void 0,
      subtitle: void 0,
      subtitleWaitlist: void 0,
      title: void 0
    },
    start: {
      actionLink: "Prijavi se",
      actionLink__use_email: "Koristite e-po\u0161tu",
      actionLink__use_phone: "Koristite telefon",
      actionText: "Ve\u0107 imate ra\u010Dun?",
      subtitle: "Dobrodo\u0161li! Molimo ispunite detalje za po\u010Detak.",
      subtitleCombined: "Dobrodo\u0161li! Molimo ispunite detalje za po\u010Detak.",
      title: "Kreirajte svoj ra\u010Dun",
      titleCombined: "Kreirajte svoj ra\u010Dun"
    }
  },
  socialButtonsBlockButton: "Nastavite s {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} je ve\u0107 \u010Dlan organizacije.",
    captcha_invalid: "Registracija neuspje\u0161na zbog neuspjelih sigurnosnih provjera. Molimo osvje\u017Eite stranicu i poku\u0161ajte ponovno ili se obratite podr\u0161ci za dodatnu pomo\u0107.",
    captcha_unavailable: "Registracija neuspje\u0161na zbog neuspjele provjere bota. Molimo osvje\u017Eite stranicu i poku\u0161ajte ponovno ili se obratite podr\u0161ci za dodatnu pomo\u0107.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "Ova e-mail adresa je zauzeta. Molimo poku\u0161ajte s drugom.",
    form_identifier_exists__phone_number: "Ovaj telefonski broj je zauzet. Molimo poku\u0161ajte s drugim.",
    form_identifier_exists__username: "Ovo korisni\u010Dko ime je zauzeto. Molimo poku\u0161ajte s drugim.",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "E-mail adresa mora biti valjana e-mail adresa.",
    form_param_format_invalid__phone_number: "Telefonski broj mora biti u valjanom me\u0111unarodnom formatu",
    form_param_max_length_exceeded__first_name: "Ime ne smije biti du\u017Ee od 256 znakova.",
    form_param_max_length_exceeded__last_name: "Prezime ne smije biti du\u017Ee od 256 znakova.",
    form_param_max_length_exceeded__name: "Ime ne smije biti du\u017Ee od 256 znakova.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Va\u0161a lozinka nije dovoljno jaka.",
    form_password_pwned: "Ova lozinka je prona\u0111ena kao dio curenja podataka i ne mo\u017Ee se koristiti, molimo poku\u0161ajte s drugom lozinkom.",
    form_password_pwned__sign_in: "Ova lozinka je prona\u0111ena kao dio curenja podataka i ne mo\u017Ee se koristiti, molimo resetirajte svoju lozinku.",
    form_password_size_in_bytes_exceeded: "Va\u0161a lozinka je prema\u0161ila maksimalni dopu\u0161teni broj bajtova, molimo skratite je ili uklonite neke posebne znakove.",
    form_password_validation_failed: "Neto\u010Dna lozinka",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "Ne mo\u017Eete izbrisati svoju posljednju identifikaciju.",
    not_allowed_access: void 0,
    organization_domain_blocked: "Ovo je blokirana domena pru\u017Eatelja e-po\u0161te. Molimo koristite drugu.",
    organization_domain_common: "Ovo je uobi\u010Dajena domena pru\u017Eatelja e-po\u0161te. Molimo koristite drugu.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Dostigli ste ograni\u010Denje \u010Dlanstava u organizacijama, uklju\u010Duju\u0107i otvorene pozivnice.",
    organization_minimum_permissions_needed: "Mora postojati barem jedan \u010Dlan organizacije s minimalnim potrebnim dozvolama.",
    passkey_already_exists: "Pristupni klju\u010D je ve\u0107 registriran na ovom ure\u0111aju.",
    passkey_not_supported: "Pristupni klju\u010Devi nisu podr\u017Eani na ovom ure\u0111aju.",
    passkey_pa_not_supported: "Registracija zahtijeva platformski autentifikator, ali ure\u0111aj ga ne podr\u017Eava.",
    passkey_registration_cancelled: "Registracija pristupnog klju\u010Da je otkazana ili je isteklo vrijeme.",
    passkey_retrieval_cancelled: "Provjera pristupnog klju\u010Da je otkazana ili je isteklo vrijeme.",
    passwordComplexity: {
      maximumLength: "manje od {{length}} znakova",
      minimumLength: "{{length}} ili vi\u0161e znakova",
      requireLowercase: "malo slovo",
      requireNumbers: "broj",
      requireSpecialCharacter: "poseban znak",
      requireUppercase: "veliko slovo",
      sentencePrefix: "Va\u0161a lozinka mora sadr\u017Eavati"
    },
    phone_number_exists: "Ovaj telefonski broj je zauzet. Molimo poku\u0161ajte s drugim.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Va\u0161a lozinka funkcionira, ali mogla bi biti ja\u010Da. Poku\u0161ajte dodati vi\u0161e znakova.",
      goodPassword: "Va\u0161a lozinka zadovoljava sve potrebne zahtjeve.",
      notEnough: "Va\u0161a lozinka nije dovoljno jaka.",
      suggestions: {
        allUppercase: "Napi\u0161ite velika samo neka, a ne sva slova.",
        anotherWord: "Dodajte vi\u0161e rije\u010Di koje su manje uobi\u010Dajene.",
        associatedYears: "Izbjegavajte godine koje su povezane s vama.",
        capitalization: "Napi\u0161ite velikim slovima vi\u0161e od prvog slova.",
        dates: "Izbjegavajte datume i godine koje su povezane s vama.",
        l33t: "Izbjegavajte predvidljive zamjene slova poput '@' za 'a'.",
        longerKeyboardPattern: "Koristite du\u017Ee obrasce tipkovnice i vi\u0161e puta promijenite smjer tipkanja.",
        noNeed: "Mo\u017Eete stvoriti jake lozinke bez kori\u0161tenja simbola, brojeva ili velikih slova.",
        pwned: "Ako ovu lozinku koristite negdje drugdje, trebali biste je promijeniti.",
        recentYears: "Izbjegavajte nedavne godine.",
        repeated: "Izbjegavajte ponavljanje rije\u010Di i znakova.",
        reverseWords: "Izbjegavajte obrnuta spelovanja uobi\u010Dajenih rije\u010Di.",
        sequences: "Izbjegavajte uobi\u010Dajene nizove znakova.",
        useWords: "Koristite vi\u0161e rije\u010Di, ali izbjegavajte uobi\u010Dajene fraze."
      },
      warnings: {
        common: "Ovo je \u010Desto kori\u0161tena lozinka.",
        commonNames: "Uobi\u010Dajena imena i prezimena lako je pogoditi.",
        dates: "Datume je lako pogoditi.",
        extendedRepeat: 'Ponavljaju\u0107e uzorke znakova poput "abcabcabc" lako je pogoditi.',
        keyPattern: "Kratke obrasce tipkovnice lako je pogoditi.",
        namesByThemselves: "Pojedina\u010Dna imena ili prezimena lako je pogoditi.",
        pwned: "Va\u0161a lozinka je otkrivena u curenju podataka na internetu.",
        recentYears: "Nedavne godine lako je pogoditi.",
        sequences: 'Uobi\u010Dajene nizove znakova poput "abc" lako je pogoditi.',
        similarToCommon: "Ovo je sli\u010Dno \u010Desto kori\u0161tenoj lozinci.",
        simpleRepeat: 'Ponavljaju\u0107e znakove poput "aaa" lako je pogoditi.',
        straightRow: "Ravne redove tipki na va\u0161oj tipkovnici lako je pogoditi.",
        topHundred: "Ovo je \u010Desto kori\u0161tena lozinka.",
        topTen: "Ovo je vrlo \u010Desto kori\u0161tena lozinka.",
        userInputs: "Ne bi trebalo biti osobnih podataka ili podataka vezanih uz stranicu.",
        wordByItself: "Pojedina\u010Dne rije\u010Di lako je pogoditi."
      }
    }
  },
  userButton: {
    action__addAccount: "Dodaj ra\u010Dun",
    action__manageAccount: "Upravljaj ra\u010Dunom",
    action__signOut: "Odjavi se",
    action__signOutAll: "Odjavi se sa svih ra\u010Duna"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopirano!",
      actionLabel__copy: "Kopiraj sve",
      actionLabel__download: "Preuzmi .txt",
      actionLabel__print: "Ispi\u0161i",
      infoText1: "Rezervni kodovi bit \u0107e omogu\u0107eni za ovaj ra\u010Dun.",
      infoText2: "\u010Cuvajte rezervne kodove u tajnosti i pohranite ih na sigurno. Mo\u017Eete regenerirati rezervne kodove ako sumnjate da su kompromitirani.",
      subtitle__codelist: "Pohranite ih na sigurno i \u010Duvajte u tajnosti.",
      successMessage: "Rezervni kodovi su sada omogu\u0107eni. Mo\u017Eete koristiti jedan od njih za prijavu na svoj ra\u010Dun ako izgubite pristup svom ure\u0111aju za autentifikaciju. Svaki kod se mo\u017Ee koristiti samo jednom.",
      successSubtitle: "Mo\u017Eete koristiti jedan od ovih za prijavu na svoj ra\u010Dun ako izgubite pristup svom ure\u0111aju za autentifikaciju.",
      title: "Dodaj verifikaciju rezervnim kodom",
      title__codelist: "Rezervni kodovi"
    },
    connectedAccountPage: {
      formHint: "Odaberite pru\u017Eatelja usluge za povezivanje va\u0161eg ra\u010Duna.",
      formHint__noAccounts: "Nema dostupnih vanjskih pru\u017Eatelja ra\u010Duna.",
      removeResource: {
        messageLine1: "{{identifier}} \u0107e biti uklonjen s ovog ra\u010Duna.",
        messageLine2: "Vi\u0161e ne\u0107ete mo\u0107i koristiti ovaj povezani ra\u010Dun i sve ovisne zna\u010Dajke vi\u0161e ne\u0107e raditi.",
        successMessage: "{{connectedAccount}} je uklonjen s va\u0161eg ra\u010Duna.",
        title: "Ukloni povezani ra\u010Dun"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "Pru\u017Eatelj usluge je dodan va\u0161em ra\u010Dunu",
      title: "Dodaj povezani ra\u010Dun"
    },
    deletePage: {
      actionDescription: 'Upi\u0161ite "Izbri\u0161i ra\u010Dun" ispod za nastavak.',
      confirm: "Izbri\u0161i ra\u010Dun",
      messageLine1: "Jeste li sigurni da \u017Eelite izbrisati svoj ra\u010Dun?",
      messageLine2: "Ova radnja je trajna i nepovratna.",
      title: "Izbri\u0161i ra\u010Dun"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Poruka s verifikacijskim kodom bit \u0107e poslana na ovu adresu e-po\u0161te.",
        formSubtitle: "Unesite verifikacijski kod poslan na {{identifier}}",
        formTitle: "Verifikacijski kod",
        resendButton: "Niste primili kod? Po\u0161alji ponovno",
        successMessage: "E-po\u0161ta {{identifier}} je dodana va\u0161em ra\u010Dunu."
      },
      emailLink: {
        formHint: "Poruka s verifikacijskom poveznicom bit \u0107e poslana na ovu adresu e-po\u0161te.",
        formSubtitle: "Kliknite na verifikacijsku poveznicu u e-po\u0161ti poslanoj na {{identifier}}",
        formTitle: "Verifikacijska poveznica",
        resendButton: "Niste primili poveznicu? Po\u0161alji ponovno",
        successMessage: "E-po\u0161ta {{identifier}} je dodana va\u0161em ra\u010Dunu."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} \u0107e biti uklonjen s ovog ra\u010Duna.",
        messageLine2: "Vi\u0161e se ne\u0107ete mo\u0107i prijaviti koriste\u0107i ovu adresu e-po\u0161te.",
        successMessage: "{{emailAddress}} je uklonjena s va\u0161eg ra\u010Duna.",
        title: "Ukloni adresu e-po\u0161te"
      },
      title: "Dodaj adresu e-po\u0161te",
      verifyTitle: "Potvrdi adresu e-po\u0161te"
    },
    formButtonPrimary__add: "Dodaj",
    formButtonPrimary__continue: "Nastavi",
    formButtonPrimary__finish: "Zavr\u0161i",
    formButtonPrimary__remove: "Ukloni",
    formButtonPrimary__save: "Spremi",
    formButtonReset: "Odustani",
    mfaPage: {
      formHint: "Odaberite metodu za dodavanje.",
      title: "Dodaj dvostupanjsku provjeru"
    },
    mfaPhoneCodePage: {
      backButton: "Koristi postoje\u0107i broj",
      primaryButton__addPhoneNumber: "Dodaj telefonski broj",
      removeResource: {
        messageLine1: "{{identifier}} vi\u0161e ne\u0107e primati verifikacijske kodove prilikom prijave.",
        messageLine2: "Va\u0161 ra\u010Dun mo\u017Eda ne\u0107e biti toliko siguran. Jeste li sigurni da \u017Eelite nastaviti?",
        successMessage: "SMS kod dvostupanjske provjere je uklonjen za {{mfaPhoneCode}}",
        title: "Ukloni dvostupanjsku provjeru"
      },
      subtitle__availablePhoneNumbers: "Odaberite postoje\u0107i telefonski broj za registraciju SMS koda dvostupanjske provjere ili dodajte novi.",
      subtitle__unavailablePhoneNumbers: "Nema dostupnih telefonskih brojeva za registraciju SMS koda dvostupanjske provjere, molimo dodajte novi.",
      successMessage1: "Prilikom prijave, morat \u0107ete unijeti verifikacijski kod poslan na ovaj telefonski broj kao dodatni korak.",
      successMessage2: "Spremite ove rezervne kodove i pohranite ih na sigurno mjesto. Ako izgubite pristup svom ure\u0111aju za autentifikaciju, mo\u017Eete koristiti rezervne kodove za prijavu.",
      successTitle: "SMS kod verifikacije omogu\u0107en",
      title: "Dodaj SMS kod verifikacije"
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Umjesto toga, skeniraj QR kod",
        buttonUnableToScan__nonPrimary: "Ne mo\u017Eete skenirati QR kod?",
        infoText__ableToScan: "Postavite novu metodu prijave u va\u0161oj aplikaciji za autentifikaciju i skenirajte sljede\u0107i QR kod da biste je povezali s va\u0161im ra\u010Dunom.",
        infoText__unableToScan: "Postavite novu metodu prijave u va\u0161em autentifikatoru i unesite Klju\u010D naveden ispod.",
        inputLabel__unableToScan1: "Provjerite jesu li omogu\u0107ene vremenski temeljene ili jednokratne lozinke, zatim zavr\u0161ite povezivanje va\u0161eg ra\u010Duna.",
        inputLabel__unableToScan2: "Alternativno, ako va\u0161 autentifikator podr\u017Eava TOTP URI-je, mo\u017Eete tako\u0111er kopirati cijeli URI."
      },
      removeResource: {
        messageLine1: "Verifikacijski kodovi iz ovog autentifikatora vi\u0161e ne\u0107e biti potrebni prilikom prijave.",
        messageLine2: "Va\u0161 ra\u010Dun mo\u017Eda ne\u0107e biti toliko siguran. Jeste li sigurni da \u017Eelite nastaviti?",
        successMessage: "Dvostupanjska provjera putem aplikacije za autentifikaciju je uklonjena.",
        title: "Ukloni dvostupanjsku provjeru"
      },
      successMessage: "Dvostupanjska provjera je sada omogu\u0107ena. Prilikom prijave, morat \u0107ete unijeti verifikacijski kod iz ovog autentifikatora kao dodatni korak.",
      title: "Dodaj aplikaciju za autentifikaciju",
      verifySubtitle: "Unesite verifikacijski kod generiran va\u0161im autentifikatorom",
      verifyTitle: "Verifikacijski kod"
    },
    mobileButton__menu: "Izbornik",
    navbar: {
      account: "Profil",
      description: "Upravljajte informacijama va\u0161eg ra\u010Duna.",
      security: "Sigurnost",
      title: "Ra\u010Dun"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} \u0107e biti uklonjen s ovog ra\u010Duna.",
        title: "Ukloni pristupni klju\u010D"
      },
      subtitle__rename: "Mo\u017Eete promijeniti naziv pristupnog klju\u010Da kako biste ga lak\u0161e prona\u0161li.",
      title__rename: "Preimenuj pristupni klju\u010D"
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Preporu\u010Duje se odjava sa svih drugih ure\u0111aja koji su mo\u017Eda koristili va\u0161u staru lozinku.",
      readonly: "Va\u0161a lozinka trenutno se ne mo\u017Ee ure\u0111ivati jer se mo\u017Eete prijaviti samo putem poslovne veze.",
      successMessage__set: "Va\u0161a lozinka je postavljena.",
      successMessage__signOutOfOtherSessions: "Svi ostali ure\u0111aji su odjavljeni.",
      successMessage__update: "Va\u0161a lozinka je a\u017Eurirana.",
      title__set: "Postavi lozinku",
      title__update: "A\u017Euriraj lozinku"
    },
    phoneNumberPage: {
      infoText: "Tekstualna poruka s verifikacijskim kodom bit \u0107e poslana na ovaj telefonski broj. Mogu se primijeniti naknade za poruke i podatke.",
      removeResource: {
        messageLine1: "{{identifier}} \u0107e biti uklonjen s ovog ra\u010Duna.",
        messageLine2: "Vi\u0161e se ne\u0107ete mo\u0107i prijaviti koriste\u0107i ovaj telefonski broj.",
        successMessage: "{{phoneNumber}} je uklonjen s va\u0161eg ra\u010Duna.",
        title: "Ukloni telefonski broj"
      },
      successMessage: "{{identifier}} je dodan va\u0161em ra\u010Dunu.",
      title: "Dodaj telefonski broj",
      verifySubtitle: "Unesite verifikacijski kod poslan na {{identifier}}",
      verifyTitle: "Potvrdi telefonski broj"
    },
    profilePage: {
      fileDropAreaHint: "Preporu\u010Dena veli\u010Dina 1:1, do 10MB.",
      imageFormDestructiveActionSubtitle: "Ukloni",
      imageFormSubtitle: "U\u010Ditaj",
      imageFormTitle: "Profilna slika",
      readonly: "Va\u0161e profilne informacije su pru\u017Eene putem poslovne veze i ne mogu se ure\u0111ivati.",
      successMessage: "Va\u0161 profil je a\u017Euriran.",
      title: "A\u017Euriraj profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Odjavi se s ure\u0111aja",
        title: "Aktivni ure\u0111aji"
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Ponovno pove\u017Ei",
        actionLabel__reauthorize: "Autoriziraj sada",
        destructiveActionTitle: "Ukloni",
        primaryButton: "Pove\u017Ei ra\u010Dun",
        subtitle__disconnected: "Ovaj ra\u010Dun je isklju\u010Den.",
        subtitle__reauthorize: "Potrebna ovla\u0161tenja su a\u017Eurirana i mo\u017Eda do\u017Eivljavate ograni\u010Denu funkcionalnost. Molimo vas da ponovno autorizirate ovu aplikaciju kako biste izbjegli probleme",
        title: "Povezani ra\u010Duni"
      },
      dangerSection: {
        deleteAccountButton: "Izbri\u0161i ra\u010Dun",
        title: "Izbri\u0161i ra\u010Dun"
      },
      emailAddressesSection: {
        destructiveAction: "Ukloni e-po\u0161tu",
        detailsAction__nonPrimary: "Postavi kao primarnu",
        detailsAction__primary: "Dovr\u0161i verifikaciju",
        detailsAction__unverified: "Potvrdi",
        primaryButton: "Dodaj adresu e-po\u0161te",
        title: "Adrese e-po\u0161te"
      },
      enterpriseAccountsSection: {
        title: "Poslovni ra\u010Duni"
      },
      headerTitle__account: "Detalji profila",
      headerTitle__security: "Sigurnost",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Regeneriraj",
          headerTitle: "Rezervni kodovi",
          subtitle__regenerate: "Dobijte novi set sigurnosnih rezervnih kodova. Prethodni rezervni kodovi bit \u0107e izbrisani i ne mogu se koristiti.",
          title__regenerate: "Regeneriraj rezervne kodove"
        },
        phoneCode: {
          actionLabel__setDefault: "Postavi kao zadano",
          destructiveActionLabel: "Ukloni"
        },
        primaryButton: "Dodaj dvostupanjsku provjeru",
        title: "Dvostupanjska provjera",
        totp: {
          destructiveActionTitle: "Ukloni",
          headerTitle: "Aplikacija za autentifikaciju"
        }
      },
      passkeysSection: {
        menuAction__destructive: "Ukloni",
        menuAction__rename: "Preimenuj",
        primaryButton: void 0,
        title: "Pristupni klju\u010Devi"
      },
      passwordSection: {
        primaryButton__setPassword: "Postavi lozinku",
        primaryButton__updatePassword: "A\u017Euriraj lozinku",
        title: "Lozinka"
      },
      phoneNumbersSection: {
        destructiveAction: "Ukloni telefonski broj",
        detailsAction__nonPrimary: "Postavi kao primarni",
        detailsAction__primary: "Dovr\u0161i verifikaciju",
        detailsAction__unverified: "Potvrdi telefonski broj",
        primaryButton: "Dodaj telefonski broj",
        title: "Telefonski brojevi"
      },
      profileSection: {
        primaryButton: "A\u017Euriraj profil",
        title: "Profil"
      },
      usernameSection: {
        primaryButton__setUsername: "Postavi korisni\u010Dko ime",
        primaryButton__updateUsername: "A\u017Euriraj korisni\u010Dko ime",
        title: "Korisni\u010Dko ime"
      },
      web3WalletsSection: {
        destructiveAction: "Ukloni nov\u010Danik",
        primaryButton: "Pove\u017Ei nov\u010Danik",
        title: "Web3 nov\u010Danici"
      }
    },
    usernamePage: {
      successMessage: "Va\u0161e korisni\u010Dko ime je a\u017Eurirano.",
      title__set: "Postavi korisni\u010Dko ime",
      title__update: "A\u017Euriraj korisni\u010Dko ime"
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} \u0107e biti uklonjen s ovog ra\u010Duna.",
        messageLine2: "Vi\u0161e se ne\u0107ete mo\u0107i prijaviti koriste\u0107i ovaj web3 nov\u010Danik.",
        successMessage: "{{web3Wallet}} je uklonjen s va\u0161eg ra\u010Duna.",
        title: "Ukloni web3 nov\u010Danik"
      },
      subtitle__availableWallets: "Odaberite web3 nov\u010Danik za povezivanje s va\u0161im ra\u010Dunom.",
      subtitle__unavailableWallets: "Nema dostupnih web3 nov\u010Danika.",
      successMessage: "Nov\u010Danik je dodan va\u0161em ra\u010Dunu.",
      title: "Dodaj web3 nov\u010Danik",
      web3WalletButtonsBlockButton: "{{provider|titleize}}"
    }
  },
  waitlist: {
    start: {
      actionLink: void 0,
      actionText: void 0,
      formButton: void 0,
      subtitle: void 0,
      title: void 0
    },
    success: {
      message: void 0,
      subtitle: void 0,
      title: void 0
    }
  }
};

// src/id-ID.ts
var idID = {
  locale: "id-ID",
  backButton: "Kembali",
  badge__default: "Default",
  badge__otherImpersonatorDevice: "Perangkat impersonator lain",
  badge__primary: "Utama",
  badge__requiresAction: "Memerlukan tindakan",
  badge__thisDevice: "Perangkat ini",
  badge__unverified: "Belum diverifikasi",
  badge__userDevice: "Perangkat pengguna",
  badge__you: "Anda",
  createOrganization: {
    formButtonSubmit: "Buat organisasi",
    invitePage: {
      formButtonReset: "Lewati"
    },
    title: "Buat organisasi"
  },
  dates: {
    lastDay: "Kemarin pada {{ date | timeString('id-ID') }}",
    next6Days: "{{ date | weekday('id-ID','long') }} pada {{ date | timeString('id-ID') }}",
    nextDay: "Besok pada {{ date | timeString('id-ID') }}",
    numeric: "{{ date | numeric('id-ID') }}",
    previous6Days: "{{ date | weekday('id-ID','long') }} lalu pada {{ date | timeString('id-ID') }}",
    sameDay: "Hari ini pada {{ date | timeString('id-ID') }}"
  },
  dividerText: "atau",
  footerActionLink__useAnotherMethod: "Gunakan metode lain",
  footerPageLink__help: "Bantuan",
  footerPageLink__privacy: "Privasi",
  footerPageLink__terms: "Ketentuan",
  formButtonPrimary: "Lanjutkan",
  formButtonPrimary__verify: "Verifikasi",
  formFieldAction__forgotPassword: "Lupa kata sandi?",
  formFieldError__matchingPasswords: "Kata sandi cocok.",
  formFieldError__notMatchingPasswords: "Kata sandi tidak cocok.",
  formFieldError__verificationLinkExpired: "Tautan verifikasi telah kedaluwarsa. Silakan minta tautan baru.",
  formFieldHintText__optional: "Opsional",
  formFieldHintText__slug: "Slug adalah ID yang mudah dibaca dan harus unik. Biasanya digunakan dalam URL.",
  formFieldInputPlaceholder__backupCode: void 0,
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Hapus akun",
  formFieldInputPlaceholder__emailAddress: void 0,
  formFieldInputPlaceholder__emailAddress_username: void 0,
  formFieldInputPlaceholder__emailAddresses: "contoh@email.com, contoh2@email.com",
  formFieldInputPlaceholder__firstName: void 0,
  formFieldInputPlaceholder__lastName: void 0,
  formFieldInputPlaceholder__organizationDomain: void 0,
  formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
  formFieldInputPlaceholder__organizationName: void 0,
  formFieldInputPlaceholder__organizationSlug: "organisasi-saya",
  formFieldInputPlaceholder__password: void 0,
  formFieldInputPlaceholder__phoneNumber: void 0,
  formFieldInputPlaceholder__username: void 0,
  formFieldLabel__automaticInvitations: "Aktifkan undangan otomatis untuk domain ini",
  formFieldLabel__backupCode: "Kode cadangan",
  formFieldLabel__confirmDeletion: "Konfirmasi",
  formFieldLabel__confirmPassword: "Konfirmasi kata sandi",
  formFieldLabel__currentPassword: "Kata sandi saat ini",
  formFieldLabel__emailAddress: "Alamat email",
  formFieldLabel__emailAddress_username: "Alamat email atau nama pengguna",
  formFieldLabel__emailAddresses: "Alamat email",
  formFieldLabel__firstName: "Nama depan",
  formFieldLabel__lastName: "Nama belakang",
  formFieldLabel__newPassword: "Kata sandi baru",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending: "Hapus undangan dan saran yang tertunda",
  formFieldLabel__organizationDomainEmailAddress: "Alamat email verifikasi",
  formFieldLabel__organizationDomainEmailAddressDescription: "Masukkan alamat email dengan domain ini untuk menerima kode dan memverifikasi domain ini.",
  formFieldLabel__organizationName: "Nama",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Nama passkey",
  formFieldLabel__password: "Kata sandi",
  formFieldLabel__phoneNumber: "Nomor telepon",
  formFieldLabel__role: "Peran",
  formFieldLabel__signOutOfOtherSessions: "Keluar dari semua perangkat lain",
  formFieldLabel__username: "Nama pengguna",
  impersonationFab: {
    action__signOut: "Keluar",
    title: "Masuk sebagai {{identifier}}"
  },
  maintenanceMode: "Kami sedang dalam pemeliharaan sistem, tapi jangan khawatir, ini tidak akan memakan waktu lebih dari beberapa menit.",
  membershipRole__admin: "Admin",
  membershipRole__basicMember: "Anggota",
  membershipRole__guestMember: "Tamu",
  organizationList: {
    action__createOrganization: "Buat organisasi",
    action__invitationAccept: "Gabung",
    action__suggestionsAccept: "Minta bergabung",
    createOrganization: "Buat Organisasi",
    invitationAcceptedLabel: "Bergabung",
    subtitle: "untuk melanjutkan ke {{applicationName}}",
    suggestionsAcceptedLabel: "Menunggu persetujuan",
    title: "Pilih akun",
    titleWithoutPersonal: "Pilih organisasi"
  },
  organizationProfile: {
    badge__automaticInvitation: "Undangan otomatis",
    badge__automaticSuggestion: "Saran otomatis",
    badge__manualInvitation: "Tanpa pendaftaran otomatis",
    badge__unverified: "Belum diverifikasi",
    createDomainPage: {
      subtitle: "Tambahkan domain untuk verifikasi. Pengguna dengan alamat email di domain ini dapat bergabung dengan organisasi secara otomatis atau meminta untuk bergabung.",
      title: "Tambah domain"
    },
    invitePage: {
      detailsTitle__inviteFailed: "Undangan tidak dapat dikirim. Sudah ada undangan tertunda untuk alamat email berikut: {{email_addresses}}.",
      formButtonPrimary__continue: "Kirim undangan",
      selectDropdown__role: "Pilih peran",
      subtitle: "Masukkan atau tempel satu atau lebih alamat email, dipisahkan dengan spasi atau koma.",
      successMessage: "Undangan berhasil dikirim",
      title: "Undang anggota baru"
    },
    membersPage: {
      action__invite: "Undang",
      action__search: void 0,
      activeMembersTab: {
        menuAction__remove: "Hapus anggota",
        tableHeader__actions: void 0,
        tableHeader__joined: "Bergabung",
        tableHeader__role: "Peran",
        tableHeader__user: "Pengguna"
      },
      detailsTitle__emptyRow: "Tidak ada anggota untuk ditampilkan",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: "Undang pengguna dengan menghubungkan domain email ke organisasi Anda. Siapa pun yang mendaftar dengan domain email yang cocok akan dapat bergabung dengan organisasi kapan saja.",
          headerTitle: "Undangan otomatis",
          primaryButton: "Kelola domain terverifikasi"
        },
        table__emptyRow: "Tidak ada undangan untuk ditampilkan"
      },
      invitedMembersTab: {
        menuAction__revoke: "Batalkan undangan",
        tableHeader__invited: "Diundang"
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: "Pengguna yang mendaftar dengan domain email yang cocok akan dapat melihat saran untuk meminta bergabung dengan organisasi Anda.",
          headerTitle: "Saran otomatis",
          primaryButton: "Kelola domain terverifikasi"
        },
        menuAction__approve: "Setujui",
        menuAction__reject: "Tolak",
        tableHeader__requested: "Meminta akses",
        table__emptyRow: "Tidak ada permintaan untuk ditampilkan"
      },
      start: {
        headerTitle__invitations: "Undangan",
        headerTitle__members: "Anggota",
        headerTitle__requests: "Permintaan"
      }
    },
    navbar: {
      description: "Kelola organisasi Anda.",
      general: "Umum",
      members: "Anggota",
      title: "Organisasi"
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Ketik "{{organizationName}}" di bawah untuk melanjutkan.',
          messageLine1: "Anda yakin ingin menghapus organisasi ini?",
          messageLine2: "Tindakan ini permanen dan tidak dapat dibatalkan.",
          successMessage: "Anda telah menghapus organisasi.",
          title: "Hapus organisasi"
        },
        leaveOrganization: {
          actionDescription: 'Ketik "{{organizationName}}" di bawah untuk melanjutkan.',
          messageLine1: "Anda yakin ingin meninggalkan organisasi ini? Anda akan kehilangan akses ke organisasi ini dan aplikasinya.",
          messageLine2: "Tindakan ini permanen dan tidak dapat dibatalkan.",
          successMessage: "Anda telah meninggalkan organisasi.",
          title: "Tinggalkan organisasi"
        },
        title: "Bahaya"
      },
      domainSection: {
        menuAction__manage: "Kelola",
        menuAction__remove: "Hapus",
        menuAction__verify: "Verifikasi",
        primaryButton: "Tambah domain",
        subtitle: "Izinkan pengguna untuk bergabung dengan organisasi secara otomatis atau meminta bergabung berdasarkan domain email terverifikasi.",
        title: "Domain terverifikasi"
      },
      successMessage: "Organisasi telah diperbarui.",
      title: "Perbarui profil"
    },
    removeDomainPage: {
      messageLine1: "Domain email {{domain}} akan dihapus.",
      messageLine2: "Pengguna tidak akan dapat bergabung dengan organisasi secara otomatis setelah ini.",
      successMessage: "{{domain}} telah dihapus.",
      title: "Hapus domain"
    },
    start: {
      headerTitle__general: "Umum",
      headerTitle__members: "Anggota",
      profileSection: {
        primaryButton: "Perbarui profil",
        title: "Profil Organisasi",
        uploadAction__title: "Logo"
      }
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: "Menghapus domain ini akan mempengaruhi pengguna yang diundang.",
        removeDomainActionLabel__remove: "Hapus domain",
        removeDomainSubtitle: "Hapus domain ini dari domain terverifikasi Anda",
        removeDomainTitle: "Hapus domain"
      },
      enrollmentTab: {
        automaticInvitationOption__description: "Pengguna otomatis diundang untuk bergabung dengan organisasi saat mereka mendaftar dan dapat bergabung kapan saja.",
        automaticInvitationOption__label: "Undangan otomatis",
        automaticSuggestionOption__description: "Pengguna menerima saran untuk meminta bergabung, tetapi harus disetujui oleh admin sebelum mereka dapat bergabung dengan organisasi.",
        automaticSuggestionOption__label: "Saran otomatis",
        calloutInfoLabel: "Mengubah mode pendaftaran hanya akan mempengaruhi pengguna baru.",
        calloutInvitationCountLabel: "Undangan tertunda yang dikirim ke pengguna: {{count}}",
        calloutSuggestionCountLabel: "Saran tertunda yang dikirim ke pengguna: {{count}}",
        manualInvitationOption__description: "Pengguna hanya dapat diundang secara manual ke organisasi.",
        manualInvitationOption__label: "Tanpa pendaftaran otomatis",
        subtitle: "Pilih bagaimana pengguna dari domain ini dapat bergabung dengan organisasi."
      },
      start: {
        headerTitle__danger: "Bahaya",
        headerTitle__enrollment: "Opsi pendaftaran"
      },
      subtitle: "Domain {{domain}} sekarang terverifikasi. Lanjutkan dengan memilih mode pendaftaran.",
      title: "Perbarui {{domain}}"
    },
    verifyDomainPage: {
      formSubtitle: "Masukkan kode verifikasi yang dikirim ke alamat email Anda",
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Domain {{domainName}} perlu diverifikasi melalui email.",
      subtitleVerificationCodeScreen: "Kode verifikasi telah dikirim ke {{emailAddress}}. Masukkan kode untuk melanjutkan.",
      title: "Verifikasi domain"
    }
  },
  organizationSwitcher: {
    action__createOrganization: "Buat organisasi",
    action__invitationAccept: "Gabung",
    action__manageOrganization: "Kelola",
    action__suggestionsAccept: "Minta bergabung",
    notSelected: "Tidak ada organisasi dipilih",
    personalWorkspace: "Akun pribadi",
    suggestionsAcceptedLabel: "Menunggu persetujuan"
  },
  paginationButton__next: "Berikutnya",
  paginationButton__previous: "Sebelumnya",
  paginationRowText__displaying: "Menampilkan",
  paginationRowText__of: "dari",
  reverification: {
    alternativeMethods: {
      actionLink: "Dapatkan bantuan",
      actionText: "Tidak memiliki salah satu dari ini?",
      blockButton__backupCode: "Gunakan kode cadangan",
      blockButton__emailCode: "Kirim kode ke {{identifier}}",
      blockButton__password: "Lanjutkan dengan kata sandi Anda",
      blockButton__phoneCode: "Kirim kode SMS ke {{identifier}}",
      blockButton__totp: "Gunakan aplikasi autentikator Anda",
      getHelp: {
        blockButton__emailSupport: "Email dukungan",
        content: "Jika Anda kesulitan memverifikasi akun, email kami dan kami akan membantu memulihkan akses secepat mungkin.",
        title: "Dapatkan bantuan"
      },
      subtitle: "Mengalami masalah? Anda dapat menggunakan salah satu metode ini untuk verifikasi.",
      title: "Gunakan metode lain"
    },
    backupCodeMfa: {
      subtitle: "Masukkan kode cadangan yang Anda terima saat menyiapkan autentikasi dua langkah",
      title: "Masukkan kode cadangan"
    },
    emailCode: {
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Masukkan kode yang dikirim ke email Anda untuk melanjutkan",
      title: "Verifikasi diperlukan"
    },
    noAvailableMethods: {
      message: "Tidak dapat melanjutkan verifikasi. Tidak ada faktor autentikasi yang sesuai dikonfigurasi",
      subtitle: "Terjadi kesalahan",
      title: "Tidak dapat memverifikasi akun Anda"
    },
    password: {
      actionLink: "Gunakan metode lain",
      subtitle: "Masukkan kata sandi Anda untuk melanjutkan",
      title: "Verifikasi diperlukan"
    },
    phoneCode: {
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Masukkan kode yang dikirim ke telepon Anda untuk melanjutkan",
      title: "Verifikasi diperlukan"
    },
    phoneCodeMfa: {
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Masukkan kode yang dikirim ke telepon Anda untuk melanjutkan",
      title: "Verifikasi diperlukan"
    },
    totpMfa: {
      formTitle: "Kode verifikasi",
      subtitle: "Masukkan kode yang dihasilkan oleh aplikasi autentikator Anda untuk melanjutkan",
      title: "Verifikasi diperlukan"
    }
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: "Tambah akun",
      action__signOutAll: "Keluar dari semua akun",
      subtitle: "Pilih akun yang ingin Anda gunakan untuk melanjutkan.",
      title: "Pilih akun"
    },
    alternativeMethods: {
      actionLink: "Dapatkan bantuan",
      actionText: "Tidak memiliki metode ini?",
      blockButton__backupCode: "Gunakan kode cadangan",
      blockButton__emailCode: "Kirim kode ke {{identifier}}",
      blockButton__emailLink: "Kirim tautan ke {{identifier}}",
      blockButton__passkey: "Masuk dengan passkey Anda",
      blockButton__password: "Masuk dengan kata sandi",
      blockButton__phoneCode: "Kirim kode SMS ke {{identifier}}",
      blockButton__totp: "Gunakan aplikasi autentikator",
      getHelp: {
        blockButton__emailSupport: "Email dukungan",
        content: "Jika Anda kesulitan masuk ke akun, email kami dan kami akan membantu memulihkan akses secepat mungkin.",
        title: "Dapatkan bantuan"
      },
      subtitle: "Mengalami masalah? Anda dapat menggunakan salah satu metode ini untuk masuk.",
      title: "Gunakan metode lain"
    },
    backupCodeMfa: {
      subtitle: "Kode cadangan Anda adalah yang Anda dapatkan saat menyiapkan verifikasi dua langkah.",
      title: "Masukkan kode cadangan"
    },
    emailCode: {
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "untuk melanjutkan ke {{applicationName}}",
      title: "Periksa email Anda"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Untuk melanjutkan, buka tautan verifikasi di perangkat dan browser yang Anda gunakan untuk memulai masuk",
        title: "Tautan verifikasi tidak valid untuk perangkat ini"
      },
      expired: {
        subtitle: "Kembali ke tab asal untuk melanjutkan.",
        title: "Tautan verifikasi ini telah kedaluwarsa"
      },
      failed: {
        subtitle: "Kembali ke tab asal untuk melanjutkan.",
        title: "Tautan verifikasi ini tidak valid"
      },
      formSubtitle: "Gunakan tautan verifikasi yang dikirim ke email Anda",
      formTitle: "Tautan verifikasi",
      loading: {
        subtitle: "Anda akan segera dialihkan",
        title: "Sedang masuk..."
      },
      resendButton: "Tidak menerima tautan? Kirim ulang",
      subtitle: "untuk melanjutkan ke {{applicationName}}",
      title: "Periksa email Anda",
      unusedTab: {
        title: "Anda dapat menutup tab ini"
      },
      verified: {
        subtitle: "Anda akan segera dialihkan",
        title: "Berhasil masuk"
      },
      verifiedSwitchTab: {
        subtitle: "Kembali ke tab asal untuk melanjutkan",
        subtitleNewTab: "Kembali ke tab yang baru dibuka untuk melanjutkan",
        titleNewTab: "Masuk di tab lain"
      }
    },
    forgotPassword: {
      formTitle: "Kode reset kata sandi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "untuk mereset kata sandi Anda",
      subtitle_email: "Pertama, masukkan kode yang dikirim ke alamat email Anda",
      subtitle_phone: "Pertama, masukkan kode yang dikirim ke telepon Anda",
      title: "Reset kata sandi"
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Reset kata sandi Anda",
      label__alternativeMethods: "Atau, masuk dengan metode lain",
      title: "Lupa Kata Sandi?"
    },
    noAvailableMethods: {
      message: "Tidak dapat melanjutkan masuk. Tidak ada faktor autentikasi yang tersedia.",
      subtitle: "Terjadi kesalahan",
      title: "Tidak dapat masuk"
    },
    passkey: {
      subtitle: "Menggunakan passkey mengonfirmasi bahwa ini adalah Anda. Perangkat Anda mungkin meminta sidik jari, wajah, atau kunci layar.",
      title: "Gunakan passkey Anda"
    },
    password: {
      actionLink: "Gunakan metode lain",
      subtitle: "Masukkan kata sandi yang terkait dengan akun Anda",
      title: "Masukkan kata sandi Anda"
    },
    passwordPwned: {
      title: "Kata sandi terkompromi"
    },
    phoneCode: {
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "untuk melanjutkan ke {{applicationName}}",
      title: "Periksa telepon Anda"
    },
    phoneCodeMfa: {
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Untuk melanjutkan, masukkan kode verifikasi yang dikirim ke telepon Anda",
      title: "Periksa telepon Anda"
    },
    resetPassword: {
      formButtonPrimary: "Reset Kata Sandi",
      requiredMessage: "Untuk alasan keamanan, Anda harus mereset kata sandi.",
      successMessage: "Kata sandi Anda berhasil diubah. Sedang memasukkan Anda, mohon tunggu sebentar.",
      title: "Atur kata sandi baru"
    },
    resetPasswordMfa: {
      detailsLabel: "Kami perlu memverifikasi identitas Anda sebelum mereset kata sandi."
    },
    start: {
      actionLink: "Daftar",
      actionLink__join_waitlist: "Gabung daftar tunggu",
      actionLink__use_email: "Gunakan email",
      actionLink__use_email_username: "Gunakan email atau nama pengguna",
      actionLink__use_passkey: "Gunakan passkey sebagai gantinya",
      actionLink__use_phone: "Gunakan telepon",
      actionLink__use_username: "Gunakan nama pengguna",
      actionText: "Belum punya akun?",
      actionText__join_waitlist: "Ingin akses awal?",
      subtitle: "Selamat datang kembali! Silakan masuk untuk melanjutkan",
      subtitleCombined: void 0,
      title: "Masuk ke {{applicationName}}",
      titleCombined: void 0
    },
    totpMfa: {
      formTitle: "Kode verifikasi",
      subtitle: "Untuk melanjutkan, masukkan kode verifikasi yang dihasilkan oleh aplikasi autentikator Anda",
      title: "Verifikasi dua langkah"
    }
  },
  signInEnterPasswordTitle: "Masukkan kata sandi Anda",
  signUp: {
    continue: {
      actionLink: "Masuk",
      actionText: "Sudah punya akun?",
      subtitle: "Silakan isi detail yang tersisa untuk melanjutkan.",
      title: "Isi kolom yang kosong"
    },
    emailCode: {
      formSubtitle: "Masukkan kode verifikasi yang dikirim ke alamat email Anda",
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Masukkan kode verifikasi yang dikirim ke email Anda",
      title: "Verifikasi email Anda"
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Untuk melanjutkan, buka tautan verifikasi di perangkat dan browser yang Anda gunakan untuk memulai pendaftaran",
        title: "Tautan verifikasi tidak valid untuk perangkat ini"
      },
      formSubtitle: "Gunakan tautan verifikasi yang dikirim ke alamat email Anda",
      formTitle: "Tautan verifikasi",
      loading: {
        title: "Sedang mendaftar..."
      },
      resendButton: "Tidak menerima tautan? Kirim ulang",
      subtitle: "untuk melanjutkan ke {{applicationName}}",
      title: "Verifikasi email Anda",
      verified: {
        title: "Berhasil mendaftar"
      },
      verifiedSwitchTab: {
        subtitle: "Kembali ke tab yang baru dibuka untuk melanjutkan",
        subtitleNewTab: "Kembali ke tab sebelumnya untuk melanjutkan",
        title: "Berhasil memverifikasi email"
      }
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Saya menyetujui {{ privacyPolicyLink || link("Kebijakan Privasi") }}',
        label__onlyTermsOfService: 'Saya menyetujui {{ termsOfServiceLink || link("Ketentuan Layanan") }}',
        label__termsOfServiceAndPrivacyPolicy: 'Saya menyetujui {{ termsOfServiceLink || link("Ketentuan Layanan") }} dan {{ privacyPolicyLink || link("Kebijakan Privasi") }}'
      },
      continue: {
        subtitle: "Silakan baca dan setujui ketentuan untuk melanjutkan",
        title: "Persetujuan hukum"
      }
    },
    phoneCode: {
      formSubtitle: "Masukkan kode verifikasi yang dikirim ke nomor telepon Anda",
      formTitle: "Kode verifikasi",
      resendButton: "Tidak menerima kode? Kirim ulang",
      subtitle: "Masukkan kode verifikasi yang dikirim ke telepon Anda",
      title: "Verifikasi telepon Anda"
    },
    restrictedAccess: {
      actionLink: "Masuk",
      actionText: "Sudah punya akun?",
      blockButton__emailSupport: "Email dukungan",
      blockButton__joinWaitlist: "Gabung daftar tunggu",
      subtitle: "Pendaftaran saat ini dinonaktifkan. Jika Anda yakin seharusnya memiliki akses, silakan hubungi dukungan.",
      subtitleWaitlist: "Pendaftaran saat ini dinonaktifkan. Untuk menjadi yang pertama tahu saat kami meluncur, bergabunglah dengan daftar tunggu.",
      title: "Akses dibatasi"
    },
    start: {
      actionLink: "Masuk",
      actionLink__use_email: "Gunakan email sebagai gantinya",
      actionLink__use_phone: "Gunakan telepon sebagai gantinya",
      actionText: "Sudah punya akun?",
      subtitle: "Selamat datang! Silakan isi detail untuk memulai.",
      subtitleCombined: "Selamat datang! Silakan isi detail untuk memulai.",
      title: "Buat akun Anda",
      titleCombined: "Buat akun Anda"
    }
  },
  socialButtonsBlockButton: "Lanjutkan dengan {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization: "{{email}} sudah menjadi anggota organisasi.",
    captcha_invalid: "Pendaftaran gagal karena validasi keamanan gagal. Silakan muat ulang halaman untuk mencoba lagi atau hubungi dukungan untuk bantuan lebih lanjut.",
    captcha_unavailable: "Pendaftaran gagal karena validasi bot gagal. Silakan muat ulang halaman untuk mencoba lagi atau hubungi dukungan untuk bantuan lebih lanjut.",
    form_code_incorrect: void 0,
    form_identifier_exists__email_address: "Alamat email ini sudah digunakan. Silakan coba yang lain.",
    form_identifier_exists__phone_number: "Nomor telepon ini sudah digunakan. Silakan coba yang lain.",
    form_identifier_exists__username: "Nama pengguna ini sudah digunakan. Silakan coba yang lain.",
    form_identifier_not_found: void 0,
    form_param_format_invalid: void 0,
    form_param_format_invalid__email_address: "Alamat email harus berupa alamat email yang valid.",
    form_param_format_invalid__phone_number: "Nomor telepon harus dalam format internasional yang valid",
    form_param_max_length_exceeded__first_name: "Nama depan tidak boleh lebih dari 256 karakter.",
    form_param_max_length_exceeded__last_name: "Nama belakang tidak boleh lebih dari 256 karakter.",
    form_param_max_length_exceeded__name: "Nama tidak boleh lebih dari 256 karakter.",
    form_param_nil: void 0,
    form_param_value_invalid: void 0,
    form_password_incorrect: void 0,
    form_password_length_too_short: void 0,
    form_password_not_strong_enough: "Kata sandi Anda tidak cukup kuat.",
    form_password_pwned: "Kata sandi ini telah ditemukan sebagai bagian dari kebocoran data dan tidak dapat digunakan, silakan coba kata sandi lain.",
    form_password_pwned__sign_in: "Kata sandi ini telah ditemukan sebagai bagian dari kebocoran data dan tidak dapat digunakan, silakan reset kata sandi Anda.",
    form_password_size_in_bytes_exceeded: "Kata sandi Anda telah melebihi jumlah byte maksimum yang diizinkan, silakan persingkat atau hapus beberapa karakter khusus.",
    form_password_validation_failed: "Kata Sandi Salah",
    form_username_invalid_character: void 0,
    form_username_invalid_length: void 0,
    identification_deletion_failed: "Anda tidak dapat menghapus identifikasi terakhir Anda.",
    not_allowed_access: void 0,
    organization_domain_blocked: "Ini adalah domain penyedia email yang diblokir. Silakan gunakan yang lain.",
    organization_domain_common: "Ini adalah domain penyedia email umum. Silakan gunakan yang lain.",
    organization_domain_exists_for_enterprise_connection: void 0,
    organization_membership_quota_exceeded: "Anda telah mencapai batas keanggotaan organisasi, termasuk undangan yang belum selesai.",
    organization_minimum_permissions_needed: "Harus ada setidaknya satu anggota organisasi dengan izin minimum yang diperlukan.",
    passkey_already_exists: "Passkey sudah terdaftar di perangkat ini.",
    passkey_not_supported: "Passkey tidak didukung di perangkat ini.",
    passkey_pa_not_supported: "Pendaftaran memerlukan platform autentikator tetapi perangkat tidak mendukungnya.",
    passkey_registration_cancelled: "Pendaftaran passkey dibatalkan atau waktu habis.",
    passkey_retrieval_cancelled: "Verifikasi passkey dibatalkan atau waktu habis.",
    passwordComplexity: {
      maximumLength: "kurang dari {{length}} karakter",
      minimumLength: "{{length}} karakter atau lebih",
      requireLowercase: "huruf kecil",
      requireNumbers: "angka",
      requireSpecialCharacter: "karakter khusus",
      requireUppercase: "huruf besar",
      sentencePrefix: "Kata sandi Anda harus mengandung"
    },
    phone_number_exists: "Nomor telepon ini sudah digunakan. Silakan coba yang lain.",
    web3_missing_identifier: void 0,
    zxcvbn: {
      couldBeStronger: "Kata sandi Anda berfungsi, tapi bisa lebih kuat. Coba tambahkan lebih banyak karakter.",
      goodPassword: "Kata sandi Anda memenuhi semua persyaratan yang diperlukan.",
      notEnough: "Kata sandi Anda tidak cukup kuat.",
      suggestions: {
        allUppercase: "Kapitalisasi beberapa, tapi tidak semua huruf.",
        anotherWord: "Tambahkan lebih banyak kata yang kurang umum.",
        associatedYears: "Hindari tahun yang terkait dengan Anda.",
        capitalization: "Kapitalisasi lebih dari huruf pertama.",
        dates: "Hindari tanggal dan tahun yang terkait dengan Anda.",
        l33t: "Hindari penggantian huruf yang dapat diprediksi seperti '@' untuk 'a'.",
        longerKeyboardPattern: "Gunakan pola keyboard yang lebih panjang dan ubah arah pengetikan beberapa kali.",
        noNeed: "Anda dapat membuat kata sandi yang kuat tanpa menggunakan simbol, angka, atau huruf besar.",
        pwned: "Jika Anda menggunakan kata sandi ini di tempat lain, Anda harus mengubahnya.",
        recentYears: "Hindari tahun-tahun terakhir.",
        repeated: "Hindari kata dan karakter yang berulang.",
        reverseWords: "Hindari ejaan terbalik dari kata-kata umum.",
        sequences: "Hindari urutan karakter umum.",
        useWords: "Gunakan beberapa kata, tapi hindari frasa umum."
      },
      warnings: {
        common: "Ini adalah kata sandi yang umum digunakan.",
        commonNames: "Nama dan nama keluarga yang umum mudah ditebak.",
        dates: "Tanggal mudah ditebak.",
        extendedRepeat: 'Pola karakter berulang seperti "abcabcabc" mudah ditebak.',
        keyPattern: "Pola keyboard pendek mudah ditebak.",
        namesByThemselves: "Nama tunggal atau nama keluarga mudah ditebak.",
        pwned: "Kata sandi Anda telah terekspos oleh kebocoran data di Internet.",
        recentYears: "Tahun-tahun terakhir mudah ditebak.",
        sequences: 'Urutan karakter umum seperti "abc" mudah ditebak.',
        similarToCommon: "Ini mirip dengan kata sandi yang umum digunakan.",
        simpleRepeat: 'Karakter berulang seperti "aaa" mudah ditebak.',
        straightRow: "Baris lurus tombol di keyboard Anda mudah ditebak.",
        topHundred: "Ini adalah kata sandi yang sering digunakan.",
        topTen: "Ini adalah kata sandi yang sangat sering digunakan.",
        userInputs: "Seharusnya tidak ada data pribadi atau terkait halaman.",
        wordByItself: "Kata tunggal mudah ditebak."
      }
    }
  },
  userButton: {
    action__addAccount: "Tambah akun",
    action__manageAccount: "Kelola akun",
    action__signOut: "Keluar",
    action__signOutAll: "Keluar dari semua akun"
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Disalin!",
      actionLabel__copy: "Salin semua",
      actionLabel__download: "Unduh .txt",
      actionLabel__print: "Cetak",
      infoText1: "Kode cadangan akan diaktifkan untuk akun ini.",
      infoText2: "Jaga kerahasiaan kode cadangan dan simpan dengan aman. Anda dapat membuat ulang kode cadangan jika mencurigai telah disusupi.",
      subtitle__codelist: "Simpan dengan aman dan jaga kerahasiaannya.",
      successMessage: "Kode cadangan sekarang diaktifkan. Anda dapat menggunakan salah satu dari ini untuk masuk ke akun Anda, jika kehilangan akses ke perangkat autentikasi. Setiap kode hanya dapat digunakan sekali.",
      successSubtitle: "Anda dapat menggunakan salah satu dari ini untuk masuk ke akun Anda, jika kehilangan akses ke perangkat autentikasi.",
      title: "Tambah verifikasi kode cadangan",
      title__codelist: "Kode cadangan"
    },
    connectedAccountPage: {
      formHint: "Pilih penyedia untuk menghubungkan akun Anda.",
      formHint__noAccounts: "Tidak ada penyedia akun eksternal yang tersedia.",
      removeResource: {
        messageLine1: "{{identifier}} akan dihapus dari akun ini.",
        messageLine2: "Anda tidak akan dapat menggunakan akun terhubung ini dan fitur terkait tidak akan berfungsi lagi.",
        successMessage: "{{connectedAccount}} telah dihapus dari akun Anda.",
        title: "Hapus akun terhubung"
      },
      socialButtonsBlockButton: "{{provider|titleize}}",
      successMessage: "Penyedia telah ditambahkan ke akun Anda",
      title: "Tambah akun terhubung"
    },
    deletePage: {
      actionDescription: 'Ketik "Delete account" di bawah untuk melanjutkan.',
      confirm: "Hapus akun",
      messageLine1: "Anda yakin ingin menghapus akun Anda?",
      messageLine2: "Tindakan ini permanen dan tidak dapat dibatalkan.",
      title: "Hapus akun"
    },
    emailAddressPage: {
      emailCode: {
        formHint: "Email berisi kode verifikasi akan dikirim ke alamat email ini.",
        formSubtitle: "Masukkan kode verifikasi yang dikirim ke {{identifier}}",
        formTitle: "Kode verifikasi",
        resendButton: "Tidak menerima kode? Kirim ulang",
        successMessage: "Email {{identifier}} telah ditambahkan ke akun Anda."
      },
      emailLink: {
        formHint: "Email berisi tautan verifikasi akan dikirim ke alamat email ini.",
        formSubtitle: "Klik tautan verifikasi di email yang dikirim ke {{identifier}}",
        formTitle: "Tautan verifikasi",
        resendButton: "Tidak menerima tautan? Kirim ulang",
        successMessage: "Email {{identifier}} telah ditambahkan ke akun Anda."
      },
      enterpriseSSOLink: {
        formButton: void 0,
        formSubtitle: void 0
      },
      formHint: void 0,
      removeResource: {
        messageLine1: "{{identifier}} akan dihapus dari akun ini.",
        messageLine2: "Anda tidak akan dapat masuk menggunakan alamat email ini.",
        successMessage: "{{emailAddress}} telah dihapus dari akun Anda.",
        title: "Hapus alamat email"
      },
      title: "Tambah alamat email",
      verifyTitle: "Verifikasi alamat email"
    },
    formButtonPrimary__add: "Tambah",
    formButtonPrimary__continue: "Lanjutkan",
    formButtonPrimary__finish: "Selesai",
    formButtonPrimary__remove: "Hapus",
    formButtonPrimary__save: "Simpan",
    formButtonReset: "Batal",
    mfaPage: {
      formHint: "Pilih metode untuk ditambahkan.",
      title: "Tambah verifikasi dua langkah"
    },
    mfaPhoneCodePage: {
      backButton: void 0,
      primaryButton__addPhoneNumber: void 0,
      removeResource: {
        messageLine1: void 0,
        messageLine2: void 0,
        successMessage: void 0,
        title: void 0
      },
      subtitle__availablePhoneNumbers: void 0,
      subtitle__unavailablePhoneNumbers: void 0,
      successMessage1: void 0,
      successMessage2: void 0,
      successTitle: void 0,
      title: void 0
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: void 0,
        buttonUnableToScan__nonPrimary: void 0,
        infoText__ableToScan: void 0,
        infoText__unableToScan: void 0,
        inputLabel__unableToScan1: void 0,
        inputLabel__unableToScan2: void 0
      },
      removeResource: {
        messageLine1: void 0,
        messageLine2: void 0,
        successMessage: void 0,
        title: void 0
      },
      successMessage: void 0,
      title: void 0,
      verifySubtitle: void 0,
      verifyTitle: void 0
    },
    mobileButton__menu: void 0,
    navbar: {
      account: "Profil",
      description: "Kelola info akun Anda.",
      security: "Keamanan",
      title: "Akun"
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: void 0,
        title: void 0
      },
      subtitle__rename: void 0,
      title__rename: void 0
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: "Disarankan untuk keluar dari semua perangkat lain yang mungkin menggunakan kata sandi lama Anda.",
      readonly: "Kata sandi Anda saat ini tidak dapat diedit karena Anda hanya dapat masuk melalui koneksi enterprise.",
      successMessage__set: "Kata sandi Anda telah diatur.",
      successMessage__signOutOfOtherSessions: "Semua perangkat lain telah dikeluarkan.",
      successMessage__update: "Kata sandi Anda telah diperbarui.",
      title__set: "Atur kata sandi",
      title__update: "Perbarui kata sandi"
    },
    phoneNumberPage: {
      infoText: "Pesan teks berisi kode verifikasi akan dikirim ke nomor telepon ini. Biaya pesan dan data mungkin berlaku.",
      removeResource: {
        messageLine1: "{{identifier}} akan dihapus dari akun ini.",
        messageLine2: "Anda tidak akan dapat masuk menggunakan nomor telepon ini.",
        successMessage: "{{phoneNumber}} telah dihapus dari akun Anda.",
        title: "Hapus nomor telepon"
      },
      successMessage: "{{identifier}} telah ditambahkan ke akun Anda.",
      title: "Tambah nomor telepon",
      verifySubtitle: "Masukkan kode verifikasi yang dikirim ke {{identifier}}",
      verifyTitle: "Verifikasi nomor telepon"
    },
    profilePage: {
      fileDropAreaHint: "Ukuran yang disarankan 1:1, hingga 10MB.",
      imageFormDestructiveActionSubtitle: "Hapus",
      imageFormSubtitle: "Unggah",
      imageFormTitle: "Gambar profil",
      readonly: "Informasi profil Anda telah disediakan oleh koneksi enterprise dan tidak dapat diedit.",
      successMessage: "Profil Anda telah diperbarui.",
      title: "Perbarui profil"
    },
    start: {
      activeDevicesSection: {
        destructiveAction: void 0,
        title: void 0
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: void 0,
        actionLabel__reauthorize: void 0,
        destructiveActionTitle: void 0,
        primaryButton: void 0,
        subtitle__disconnected: void 0,
        subtitle__reauthorize: void 0,
        title: void 0
      },
      dangerSection: {
        deleteAccountButton: void 0,
        title: void 0
      },
      emailAddressesSection: {
        destructiveAction: void 0,
        detailsAction__nonPrimary: void 0,
        detailsAction__primary: void 0,
        detailsAction__unverified: void 0,
        primaryButton: void 0,
        title: void 0
      },
      enterpriseAccountsSection: {
        title: void 0
      },
      headerTitle__account: void 0,
      headerTitle__security: void 0,
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: void 0,
          headerTitle: void 0,
          subtitle__regenerate: void 0,
          title__regenerate: void 0
        },
        phoneCode: {
          actionLabel__setDefault: void 0,
          destructiveActionLabel: void 0
        },
        primaryButton: void 0,
        title: void 0,
        totp: {
          destructiveActionTitle: void 0,
          headerTitle: void 0
        }
      },
      passkeysSection: {
        menuAction__destructive: void 0,
        menuAction__rename: void 0,
        primaryButton: void 0,
        title: void 0
      },
      passwordSection: {
        primaryButton__setPassword: void 0,
        primaryButton__updatePassword: void 0,
        title: void 0
      },
      phoneNumbersSection: {
        destructiveAction: void 0,
        detailsAction__nonPrimary: void 0,
        detailsAction__primary: void 0,
        detailsAction__unverified: void 0,
        primaryButton: void 0,
        title: void 0
      },
      profileSection: {
        primaryButton: void 0,
        title: void 0
      },
      usernameSection: {
        primaryButton__setUsername: void 0,
        primaryButton__updateUsername: void 0,
        title: void 0
      },
      web3WalletsSection: {
        destructiveAction: void 0,
        primaryButton: void 0,
        title: void 0
      }
    },
    usernamePage: {
      successMessage: void 0,
      title__set: void 0,
      title__update: void 0
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: void 0,
        messageLine2: void 0,
        successMessage: void 0,
        title: void 0
      },
      subtitle__availableWallets: void 0,
      subtitle__unavailableWallets: void 0,
      successMessage: void 0,
      title: void 0,
      web3WalletButtonsBlockButton: void 0
    }
  },
  waitlist: {
    start: {
      actionLink: "Masuk",
      actionText: "Sudah punya akses?",
      formButton: "Gabung daftar tunggu",
      subtitle: "Masukkan alamat email Anda dan kami akan memberi tahu ketika tempat Anda siap",
      title: "Gabung daftar tunggu"
    },
    success: {
      message: "Anda akan segera dialihkan...",
      subtitle: "Kami akan menghubungi ketika tempat Anda siap",
      title: "Terima kasih telah bergabung dengan daftar tunggu!"
    }
  }
};
export {
  arSA,
  beBY,
  bgBG,
  caES,
  csCZ,
  daDK,
  deDE,
  elGR,
  enGB,
  enUS,
  esES,
  esMX,
  esUY,
  fiFI,
  frFR,
  heIL,
  hrHR,
  huHU,
  idID,
  isIS,
  itIT,
  jaJP,
  koKR,
  nbNO,
  nlBE,
  nlNL,
  plPL,
  ptBR,
  ptPT,
  roRO,
  ruRU,
  skSK,
  svSE,
  thTH,
  trTR,
  ukUA,
  viVN,
  zhCN,
  zhTW
};
//# sourceMappingURL=index.mjs.map